(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire00b0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire00b0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("arQ7u", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dboSl"));

});
parcelRegister("dboSl", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $998f993730a607e7$export$dca3b0875bd9a954; }, function (v) { return $998f993730a607e7$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $998f993730a607e7$export$16fa2f45be04daa8; }, function (v) { return $998f993730a607e7$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $998f993730a607e7$export$ffb0004e005737fa; }, function (v) { return $998f993730a607e7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $998f993730a607e7$export$e2c29f18771995cb; }, function (v) { return $998f993730a607e7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $998f993730a607e7$export$221d75b3f55bb0bd; }, function (v) { return $998f993730a607e7$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $998f993730a607e7$export$5f8d39834fd61797; }, function (v) { return $998f993730a607e7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $998f993730a607e7$export$74bf444e3cd11ea5; }, function (v) { return $998f993730a607e7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $998f993730a607e7$export$ae55be85d98224ed; }, function (v) { return $998f993730a607e7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $998f993730a607e7$export$e530037191fcd5d7; }, function (v) { return $998f993730a607e7$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $998f993730a607e7$export$fd42f52fd3ae1109; }, function (v) { return $998f993730a607e7$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $998f993730a607e7$export$c8a8987d4410bf2d; }, function (v) { return $998f993730a607e7$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $998f993730a607e7$export$d38cd72104c1f0e9; }, function (v) { return $998f993730a607e7$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $998f993730a607e7$export$7d1e3a5e95ceca43; }, function (v) { return $998f993730a607e7$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $998f993730a607e7$export$257a8862b851cb5b; }, function (v) { return $998f993730a607e7$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $998f993730a607e7$export$a8257692ac88316c; }, function (v) { return $998f993730a607e7$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $998f993730a607e7$export$488013bae63b21da; }, function (v) { return $998f993730a607e7$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $998f993730a607e7$export$7c73462e0d25e514; }, function (v) { return $998f993730a607e7$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $998f993730a607e7$export$35808ee640e87ca7; }, function (v) { return $998f993730a607e7$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $998f993730a607e7$export$fae74005e78b1a27; }, function (v) { return $998f993730a607e7$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $998f993730a607e7$export$dc8fbce3eb94dc1e; }, function (v) { return $998f993730a607e7$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $998f993730a607e7$export$6d9c69b0de29b591; }, function (v) { return $998f993730a607e7$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $998f993730a607e7$export$d5a552a76deda3c2; }, function (v) { return $998f993730a607e7$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $998f993730a607e7$export$e5c5a5f917a5871c; }, function (v) { return $998f993730a607e7$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $998f993730a607e7$export$1538c33de8887b59; }, function (v) { return $998f993730a607e7$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $998f993730a607e7$export$13e3392192263954; }, function (v) { return $998f993730a607e7$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $998f993730a607e7$export$b8f5890fc79d6aca; }, function (v) { return $998f993730a607e7$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $998f993730a607e7$export$60241385465d0a34; }, function (v) { return $998f993730a607e7$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $998f993730a607e7$export$83d89fbfd8236492; }, function (v) { return $998f993730a607e7$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $998f993730a607e7$export$dca3b0875bd9a954;
var $998f993730a607e7$export$16fa2f45be04daa8;
var $998f993730a607e7$export$ffb0004e005737fa;
var $998f993730a607e7$export$e2c29f18771995cb;
var $998f993730a607e7$export$221d75b3f55bb0bd;
var $998f993730a607e7$export$5f8d39834fd61797;
var $998f993730a607e7$export$74bf444e3cd11ea5;
var $998f993730a607e7$export$ae55be85d98224ed;
var $998f993730a607e7$export$e530037191fcd5d7;
var $998f993730a607e7$export$fd42f52fd3ae1109;
var $998f993730a607e7$export$c8a8987d4410bf2d;
var $998f993730a607e7$export$d38cd72104c1f0e9;
var $998f993730a607e7$export$7d1e3a5e95ceca43;
var $998f993730a607e7$export$257a8862b851cb5b;
var $998f993730a607e7$export$a8257692ac88316c;
var $998f993730a607e7$export$488013bae63b21da;
var $998f993730a607e7$export$7c73462e0d25e514;
var $998f993730a607e7$export$35808ee640e87ca7;
var $998f993730a607e7$export$fae74005e78b1a27;
var $998f993730a607e7$export$dc8fbce3eb94dc1e;
var $998f993730a607e7$export$6d9c69b0de29b591;
var $998f993730a607e7$export$d5a552a76deda3c2;
var $998f993730a607e7$export$e5c5a5f917a5871c;
var $998f993730a607e7$export$1538c33de8887b59;
var $998f993730a607e7$export$13e3392192263954;
var $998f993730a607e7$export$b8f5890fc79d6aca;
var $998f993730a607e7$export$60241385465d0a34;
var $998f993730a607e7$export$83d89fbfd8236492;
"use strict";

var $dAVlL = parcelRequire("dAVlL");
var $998f993730a607e7$var$n = "function" === typeof Symbol && Symbol.for, $998f993730a607e7$var$p = $998f993730a607e7$var$n ? Symbol.for("react.element") : 60103, $998f993730a607e7$var$q = $998f993730a607e7$var$n ? Symbol.for("react.portal") : 60106, $998f993730a607e7$var$r = $998f993730a607e7$var$n ? Symbol.for("react.fragment") : 60107, $998f993730a607e7$var$t = $998f993730a607e7$var$n ? Symbol.for("react.strict_mode") : 60108, $998f993730a607e7$var$u = $998f993730a607e7$var$n ? Symbol.for("react.profiler") : 60114, $998f993730a607e7$var$v = $998f993730a607e7$var$n ? Symbol.for("react.provider") : 60109, $998f993730a607e7$var$w = $998f993730a607e7$var$n ? Symbol.for("react.context") : 60110, $998f993730a607e7$var$x = $998f993730a607e7$var$n ? Symbol.for("react.forward_ref") : 60112, $998f993730a607e7$var$y = $998f993730a607e7$var$n ? Symbol.for("react.suspense") : 60113, $998f993730a607e7$var$z = $998f993730a607e7$var$n ? Symbol.for("react.memo") : 60115, $998f993730a607e7$var$A = $998f993730a607e7$var$n ? Symbol.for("react.lazy") : 60116, $998f993730a607e7$var$B = "function" === typeof Symbol && Symbol.iterator;
function $998f993730a607e7$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $998f993730a607e7$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $998f993730a607e7$var$E = {};
function $998f993730a607e7$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $998f993730a607e7$var$E;
    this.updater = c || $998f993730a607e7$var$D;
}
$998f993730a607e7$var$F.prototype.isReactComponent = {};
$998f993730a607e7$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($998f993730a607e7$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$998f993730a607e7$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $998f993730a607e7$var$G() {}
$998f993730a607e7$var$G.prototype = $998f993730a607e7$var$F.prototype;
function $998f993730a607e7$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $998f993730a607e7$var$E;
    this.updater = c || $998f993730a607e7$var$D;
}
var $998f993730a607e7$var$I = $998f993730a607e7$var$H.prototype = new $998f993730a607e7$var$G;
$998f993730a607e7$var$I.constructor = $998f993730a607e7$var$H;
$dAVlL($998f993730a607e7$var$I, $998f993730a607e7$var$F.prototype);
$998f993730a607e7$var$I.isPureReactComponent = !0;
var $998f993730a607e7$var$J = {
    current: null
}, $998f993730a607e7$var$K = Object.prototype.hasOwnProperty, $998f993730a607e7$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $998f993730a607e7$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$998f993730a607e7$var$K.call(b, e) && !$998f993730a607e7$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $998f993730a607e7$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $998f993730a607e7$var$J.current
    };
}
function $998f993730a607e7$var$N(a, b) {
    return {
        $$typeof: $998f993730a607e7$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $998f993730a607e7$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $998f993730a607e7$var$p;
}
function $998f993730a607e7$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $998f993730a607e7$var$P = /\/+/g, $998f993730a607e7$var$Q = [];
function $998f993730a607e7$var$R(a, b, c, e) {
    if ($998f993730a607e7$var$Q.length) {
        var d = $998f993730a607e7$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $998f993730a607e7$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $998f993730a607e7$var$Q.length && $998f993730a607e7$var$Q.push(a);
}
function $998f993730a607e7$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $998f993730a607e7$var$p:
                case $998f993730a607e7$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $998f993730a607e7$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $998f993730a607e7$var$U(d, k);
        g += $998f993730a607e7$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $998f993730a607e7$var$B && a[$998f993730a607e7$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $998f993730a607e7$var$U(d, k++), g += $998f993730a607e7$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($998f993730a607e7$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $998f993730a607e7$var$V(a, b, c) {
    return null == a ? 0 : $998f993730a607e7$var$T(a, "", b, c);
}
function $998f993730a607e7$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $998f993730a607e7$var$escape(a.key) : b.toString(36);
}
function $998f993730a607e7$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $998f993730a607e7$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $998f993730a607e7$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($998f993730a607e7$var$O(a) && (a = $998f993730a607e7$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($998f993730a607e7$var$P, "$&/") + "/") + c)), e.push(a));
}
function $998f993730a607e7$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($998f993730a607e7$var$P, "$&/") + "/");
    b = $998f993730a607e7$var$R(b, g, e, d);
    $998f993730a607e7$var$V(a, $998f993730a607e7$var$aa, b);
    $998f993730a607e7$var$S(b);
}
var $998f993730a607e7$var$Y = {
    current: null
};
function $998f993730a607e7$var$Z() {
    var a = $998f993730a607e7$var$Y.current;
    if (null === a) throw Error($998f993730a607e7$var$C(321));
    return a;
}
var $998f993730a607e7$var$ba = {
    ReactCurrentDispatcher: $998f993730a607e7$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $998f993730a607e7$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $dAVlL
};
$998f993730a607e7$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $998f993730a607e7$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $998f993730a607e7$var$R(null, null, b, c);
        $998f993730a607e7$var$V(a, $998f993730a607e7$var$W, b);
        $998f993730a607e7$var$S(b);
    },
    count: function(a) {
        return $998f993730a607e7$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $998f993730a607e7$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$998f993730a607e7$var$O(a)) throw Error($998f993730a607e7$var$C(143));
        return a;
    }
};
$998f993730a607e7$export$16fa2f45be04daa8 = $998f993730a607e7$var$F;
$998f993730a607e7$export$ffb0004e005737fa = $998f993730a607e7$var$r;
$998f993730a607e7$export$e2c29f18771995cb = $998f993730a607e7$var$u;
$998f993730a607e7$export$221d75b3f55bb0bd = $998f993730a607e7$var$H;
$998f993730a607e7$export$5f8d39834fd61797 = $998f993730a607e7$var$t;
$998f993730a607e7$export$74bf444e3cd11ea5 = $998f993730a607e7$var$y;
$998f993730a607e7$export$ae55be85d98224ed = $998f993730a607e7$var$ba;
$998f993730a607e7$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($998f993730a607e7$var$C(267, a));
    var e = $dAVlL({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $998f993730a607e7$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$998f993730a607e7$var$K.call(b, h) && !$998f993730a607e7$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $998f993730a607e7$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$998f993730a607e7$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $998f993730a607e7$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $998f993730a607e7$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$998f993730a607e7$export$c8a8987d4410bf2d = $998f993730a607e7$var$M;
$998f993730a607e7$export$d38cd72104c1f0e9 = function(a) {
    var b = $998f993730a607e7$var$M.bind(null, a);
    b.type = a;
    return b;
};
$998f993730a607e7$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$998f993730a607e7$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $998f993730a607e7$var$x,
        render: a
    };
};
$998f993730a607e7$export$a8257692ac88316c = $998f993730a607e7$var$O;
$998f993730a607e7$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $998f993730a607e7$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$998f993730a607e7$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $998f993730a607e7$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$998f993730a607e7$export$35808ee640e87ca7 = function(a, b) {
    return $998f993730a607e7$var$Z().useCallback(a, b);
};
$998f993730a607e7$export$fae74005e78b1a27 = function(a, b) {
    return $998f993730a607e7$var$Z().useContext(a, b);
};
$998f993730a607e7$export$dc8fbce3eb94dc1e = function() {};
$998f993730a607e7$export$6d9c69b0de29b591 = function(a, b) {
    return $998f993730a607e7$var$Z().useEffect(a, b);
};
$998f993730a607e7$export$d5a552a76deda3c2 = function(a, b, c) {
    return $998f993730a607e7$var$Z().useImperativeHandle(a, b, c);
};
$998f993730a607e7$export$e5c5a5f917a5871c = function(a, b) {
    return $998f993730a607e7$var$Z().useLayoutEffect(a, b);
};
$998f993730a607e7$export$1538c33de8887b59 = function(a, b) {
    return $998f993730a607e7$var$Z().useMemo(a, b);
};
$998f993730a607e7$export$13e3392192263954 = function(a, b, c) {
    return $998f993730a607e7$var$Z().useReducer(a, b, c);
};
$998f993730a607e7$export$b8f5890fc79d6aca = function(a) {
    return $998f993730a607e7$var$Z().useRef(a);
};
$998f993730a607e7$export$60241385465d0a34 = function(a) {
    return $998f993730a607e7$var$Z().useState(a);
};
$998f993730a607e7$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("dAVlL", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $9e5b1fb26a06aa19$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $9e5b1fb26a06aa19$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $9e5b1fb26a06aa19$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $9e5b1fb26a06aa19$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $9e5b1fb26a06aa19$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $9e5b1fb26a06aa19$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $9e5b1fb26a06aa19$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($9e5b1fb26a06aa19$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($9e5b1fb26a06aa19$var$getOwnPropertySymbols) {
            symbols = $9e5b1fb26a06aa19$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($9e5b1fb26a06aa19$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("9sDDw", function(module, exports) {
"use strict";
function $6e35798def21f5d9$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6e35798def21f5d9$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6e35798def21f5d9$var$checkDCE();

module.exports = (parcelRequire("hrffU"));

});
parcelRegister("hrffU", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $arQ7u = parcelRequire("arQ7u");

var $dAVlL = parcelRequire("dAVlL");

var $bgCxj = parcelRequire("bgCxj");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$arQ7u) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $arQ7u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $dAVlL({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $arQ7u.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $dAVlL({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $dAVlL({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $bgCxj.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $bgCxj.unstable_scheduleCallback($bgCxj.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $bgCxj.unstable_UserBlockingPriority, ed = $bgCxj.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $dAVlL({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$dAVlL(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $dAVlL(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $dAVlL({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $dAVlL({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $bgCxj.unstable_runWithPriority, Jf = $bgCxj.unstable_scheduleCallback, Kf = $bgCxj.unstable_cancelCallback, Lf = $bgCxj.unstable_requestPaint, Mf = $bgCxj.unstable_now, Nf = $bgCxj.unstable_getCurrentPriorityLevel, Of = $bgCxj.unstable_ImmediatePriority, Pf = $bgCxj.unstable_UserBlockingPriority, Qf = $bgCxj.unstable_NormalPriority, Rf = $bgCxj.unstable_LowPriority, Sf = $bgCxj.unstable_IdlePriority, Tf = {}, Uf = $bgCxj.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $dAVlL({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $dAVlL({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $arQ7u.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $dAVlL({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $dAVlL({}, f, {
                    value: void 0
                });
                d = $dAVlL({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $dAVlL({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($dAVlL({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("bgCxj", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fm9Nk"));

});
parcelRegister("fm9Nk", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $b2e0821792122e20$export$c4744153514ff05d; }, function (v) { return $b2e0821792122e20$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $b2e0821792122e20$export$d66a1c1c77bd778b; }, function (v) { return $b2e0821792122e20$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $b2e0821792122e20$export$3e506c1ccc9cc1a7; }, function (v) { return $b2e0821792122e20$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $b2e0821792122e20$export$e26fe2ed2fa76875; }, function (v) { return $b2e0821792122e20$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $b2e0821792122e20$export$502329bbf4b505b1; }, function (v) { return $b2e0821792122e20$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $b2e0821792122e20$export$6e3807111c4874c4; }, function (v) { return $b2e0821792122e20$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $b2e0821792122e20$export$c27134553091fb3a; }, function (v) { return $b2e0821792122e20$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $b2e0821792122e20$export$33ee1acdc04fd2a2; }, function (v) { return $b2e0821792122e20$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $b2e0821792122e20$export$b00a404bbd5edef2; }, function (v) { return $b2e0821792122e20$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $b2e0821792122e20$export$8352ce38b91d0c62; }, function (v) { return $b2e0821792122e20$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $b2e0821792122e20$export$d3dfb8e4810cb555; }, function (v) { return $b2e0821792122e20$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $b2e0821792122e20$export$839f9183b0465a69; }, function (v) { return $b2e0821792122e20$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $b2e0821792122e20$export$72fdf0e06517287b; }, function (v) { return $b2e0821792122e20$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $b2e0821792122e20$export$4b844e58a3e414b4; }, function (v) { return $b2e0821792122e20$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $b2e0821792122e20$export$816d2913ae6b83b1; }, function (v) { return $b2e0821792122e20$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $b2e0821792122e20$export$61bcfe829111a1d0; }, function (v) { return $b2e0821792122e20$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $b2e0821792122e20$export$7ee8c9beb337bc3f; }, function (v) { return $b2e0821792122e20$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $b2e0821792122e20$export$b5836b71941fa3ed; }, function (v) { return $b2e0821792122e20$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $b2e0821792122e20$export$cf845f2c119da08a; }, function (v) { return $b2e0821792122e20$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b2e0821792122e20$export$c4744153514ff05d;
var $b2e0821792122e20$export$d66a1c1c77bd778b;
var $b2e0821792122e20$export$3e506c1ccc9cc1a7;
var $b2e0821792122e20$export$e26fe2ed2fa76875;
var $b2e0821792122e20$export$502329bbf4b505b1;
var $b2e0821792122e20$export$6e3807111c4874c4;
var $b2e0821792122e20$export$c27134553091fb3a;
var $b2e0821792122e20$export$33ee1acdc04fd2a2;
var $b2e0821792122e20$export$b00a404bbd5edef2;
var $b2e0821792122e20$export$8352ce38b91d0c62;
var $b2e0821792122e20$export$d3dfb8e4810cb555;
var $b2e0821792122e20$export$839f9183b0465a69;
var $b2e0821792122e20$export$72fdf0e06517287b;
var $b2e0821792122e20$export$4b844e58a3e414b4;
var $b2e0821792122e20$export$816d2913ae6b83b1;
var $b2e0821792122e20$export$61bcfe829111a1d0;
var $b2e0821792122e20$export$7ee8c9beb337bc3f;
var $b2e0821792122e20$export$b5836b71941fa3ed;
var $b2e0821792122e20$export$cf845f2c119da08a;
"use strict";
var $b2e0821792122e20$var$f, $b2e0821792122e20$var$g, $b2e0821792122e20$var$h, $b2e0821792122e20$var$k, $b2e0821792122e20$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $b2e0821792122e20$var$p = null, $b2e0821792122e20$var$q = null, $b2e0821792122e20$var$t = function() {
        if (null !== $b2e0821792122e20$var$p) try {
            var a = $b2e0821792122e20$export$c4744153514ff05d();
            $b2e0821792122e20$var$p(!0, a);
            $b2e0821792122e20$var$p = null;
        } catch (b) {
            throw setTimeout($b2e0821792122e20$var$t, 0), b;
        }
    }, $b2e0821792122e20$var$u = Date.now();
    $b2e0821792122e20$export$c4744153514ff05d = function() {
        return Date.now() - $b2e0821792122e20$var$u;
    };
    $b2e0821792122e20$var$f = function(a) {
        null !== $b2e0821792122e20$var$p ? setTimeout($b2e0821792122e20$var$f, 0, a) : ($b2e0821792122e20$var$p = a, setTimeout($b2e0821792122e20$var$t, 0));
    };
    $b2e0821792122e20$var$g = function(a, b) {
        $b2e0821792122e20$var$q = setTimeout(a, b);
    };
    $b2e0821792122e20$var$h = function() {
        clearTimeout($b2e0821792122e20$var$q);
    };
    $b2e0821792122e20$var$k = function() {
        return !1;
    };
    $b2e0821792122e20$var$l = $b2e0821792122e20$export$d66a1c1c77bd778b = function() {};
} else {
    var $b2e0821792122e20$var$w = window.performance, $b2e0821792122e20$var$x = window.Date, $b2e0821792122e20$var$y = window.setTimeout, $b2e0821792122e20$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $b2e0821792122e20$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $b2e0821792122e20$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $b2e0821792122e20$var$w && "function" === typeof $b2e0821792122e20$var$w.now) $b2e0821792122e20$export$c4744153514ff05d = function() {
        return $b2e0821792122e20$var$w.now();
    };
    else {
        var $b2e0821792122e20$var$B = $b2e0821792122e20$var$x.now();
        $b2e0821792122e20$export$c4744153514ff05d = function() {
            return $b2e0821792122e20$var$x.now() - $b2e0821792122e20$var$B;
        };
    }
    var $b2e0821792122e20$var$C = !1, $b2e0821792122e20$var$D = null, $b2e0821792122e20$var$E = -1, $b2e0821792122e20$var$F = 5, $b2e0821792122e20$var$G = 0;
    $b2e0821792122e20$var$k = function() {
        return $b2e0821792122e20$export$c4744153514ff05d() >= $b2e0821792122e20$var$G;
    };
    $b2e0821792122e20$var$l = function() {};
    $b2e0821792122e20$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $b2e0821792122e20$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $b2e0821792122e20$var$H = new MessageChannel, $b2e0821792122e20$var$I = $b2e0821792122e20$var$H.port2;
    $b2e0821792122e20$var$H.port1.onmessage = function() {
        if (null !== $b2e0821792122e20$var$D) {
            var a = $b2e0821792122e20$export$c4744153514ff05d();
            $b2e0821792122e20$var$G = a + $b2e0821792122e20$var$F;
            try {
                $b2e0821792122e20$var$D(!0, a) ? $b2e0821792122e20$var$I.postMessage(null) : ($b2e0821792122e20$var$C = !1, $b2e0821792122e20$var$D = null);
            } catch (b) {
                throw $b2e0821792122e20$var$I.postMessage(null), b;
            }
        } else $b2e0821792122e20$var$C = !1;
    };
    $b2e0821792122e20$var$f = function(a) {
        $b2e0821792122e20$var$D = a;
        $b2e0821792122e20$var$C || ($b2e0821792122e20$var$C = !0, $b2e0821792122e20$var$I.postMessage(null));
    };
    $b2e0821792122e20$var$g = function(a, b) {
        $b2e0821792122e20$var$E = $b2e0821792122e20$var$y(function() {
            a($b2e0821792122e20$export$c4744153514ff05d());
        }, b);
    };
    $b2e0821792122e20$var$h = function() {
        $b2e0821792122e20$var$z($b2e0821792122e20$var$E);
        $b2e0821792122e20$var$E = -1;
    };
}
function $b2e0821792122e20$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $b2e0821792122e20$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $b2e0821792122e20$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $b2e0821792122e20$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $b2e0821792122e20$var$K(n, c)) void 0 !== r && 0 > $b2e0821792122e20$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $b2e0821792122e20$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $b2e0821792122e20$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $b2e0821792122e20$var$N = [], $b2e0821792122e20$var$O = [], $b2e0821792122e20$var$P = 1, $b2e0821792122e20$var$Q = null, $b2e0821792122e20$var$R = 3, $b2e0821792122e20$var$S = !1, $b2e0821792122e20$var$T = !1, $b2e0821792122e20$var$U = !1;
function $b2e0821792122e20$var$V(a) {
    for(var b = $b2e0821792122e20$var$L($b2e0821792122e20$var$O); null !== b;){
        if (null === b.callback) $b2e0821792122e20$var$M($b2e0821792122e20$var$O);
        else if (b.startTime <= a) $b2e0821792122e20$var$M($b2e0821792122e20$var$O), b.sortIndex = b.expirationTime, $b2e0821792122e20$var$J($b2e0821792122e20$var$N, b);
        else break;
        b = $b2e0821792122e20$var$L($b2e0821792122e20$var$O);
    }
}
function $b2e0821792122e20$var$W(a) {
    $b2e0821792122e20$var$U = !1;
    $b2e0821792122e20$var$V(a);
    if (!$b2e0821792122e20$var$T) {
        if (null !== $b2e0821792122e20$var$L($b2e0821792122e20$var$N)) $b2e0821792122e20$var$T = !0, $b2e0821792122e20$var$f($b2e0821792122e20$var$X);
        else {
            var b = $b2e0821792122e20$var$L($b2e0821792122e20$var$O);
            null !== b && $b2e0821792122e20$var$g($b2e0821792122e20$var$W, b.startTime - a);
        }
    }
}
function $b2e0821792122e20$var$X(a, b) {
    $b2e0821792122e20$var$T = !1;
    $b2e0821792122e20$var$U && ($b2e0821792122e20$var$U = !1, $b2e0821792122e20$var$h());
    $b2e0821792122e20$var$S = !0;
    var c = $b2e0821792122e20$var$R;
    try {
        $b2e0821792122e20$var$V(b);
        for($b2e0821792122e20$var$Q = $b2e0821792122e20$var$L($b2e0821792122e20$var$N); null !== $b2e0821792122e20$var$Q && (!($b2e0821792122e20$var$Q.expirationTime > b) || a && !$b2e0821792122e20$var$k());){
            var d = $b2e0821792122e20$var$Q.callback;
            if (null !== d) {
                $b2e0821792122e20$var$Q.callback = null;
                $b2e0821792122e20$var$R = $b2e0821792122e20$var$Q.priorityLevel;
                var e = d($b2e0821792122e20$var$Q.expirationTime <= b);
                b = $b2e0821792122e20$export$c4744153514ff05d();
                "function" === typeof e ? $b2e0821792122e20$var$Q.callback = e : $b2e0821792122e20$var$Q === $b2e0821792122e20$var$L($b2e0821792122e20$var$N) && $b2e0821792122e20$var$M($b2e0821792122e20$var$N);
                $b2e0821792122e20$var$V(b);
            } else $b2e0821792122e20$var$M($b2e0821792122e20$var$N);
            $b2e0821792122e20$var$Q = $b2e0821792122e20$var$L($b2e0821792122e20$var$N);
        }
        if (null !== $b2e0821792122e20$var$Q) var m = !0;
        else {
            var n = $b2e0821792122e20$var$L($b2e0821792122e20$var$O);
            null !== n && $b2e0821792122e20$var$g($b2e0821792122e20$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $b2e0821792122e20$var$Q = null, $b2e0821792122e20$var$R = c, $b2e0821792122e20$var$S = !1;
    }
}
function $b2e0821792122e20$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $b2e0821792122e20$var$Z = $b2e0821792122e20$var$l;
$b2e0821792122e20$export$3e506c1ccc9cc1a7 = 5;
$b2e0821792122e20$export$e26fe2ed2fa76875 = 1;
$b2e0821792122e20$export$502329bbf4b505b1 = 4;
$b2e0821792122e20$export$6e3807111c4874c4 = 3;
$b2e0821792122e20$export$c27134553091fb3a = null;
$b2e0821792122e20$export$33ee1acdc04fd2a2 = 2;
$b2e0821792122e20$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$b2e0821792122e20$export$8352ce38b91d0c62 = function() {
    $b2e0821792122e20$var$T || $b2e0821792122e20$var$S || ($b2e0821792122e20$var$T = !0, $b2e0821792122e20$var$f($b2e0821792122e20$var$X));
};
$b2e0821792122e20$export$d3dfb8e4810cb555 = function() {
    return $b2e0821792122e20$var$R;
};
$b2e0821792122e20$export$839f9183b0465a69 = function() {
    return $b2e0821792122e20$var$L($b2e0821792122e20$var$N);
};
$b2e0821792122e20$export$72fdf0e06517287b = function(a) {
    switch($b2e0821792122e20$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $b2e0821792122e20$var$R;
    }
    var c = $b2e0821792122e20$var$R;
    $b2e0821792122e20$var$R = b;
    try {
        return a();
    } finally{
        $b2e0821792122e20$var$R = c;
    }
};
$b2e0821792122e20$export$4b844e58a3e414b4 = function() {};
$b2e0821792122e20$export$816d2913ae6b83b1 = $b2e0821792122e20$var$Z;
$b2e0821792122e20$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $b2e0821792122e20$var$R;
    $b2e0821792122e20$var$R = a;
    try {
        return b();
    } finally{
        $b2e0821792122e20$var$R = c;
    }
};
$b2e0821792122e20$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $b2e0821792122e20$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $b2e0821792122e20$var$Y(a);
    } else c = $b2e0821792122e20$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $b2e0821792122e20$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $b2e0821792122e20$var$J($b2e0821792122e20$var$O, a), null === $b2e0821792122e20$var$L($b2e0821792122e20$var$N) && a === $b2e0821792122e20$var$L($b2e0821792122e20$var$O) && ($b2e0821792122e20$var$U ? $b2e0821792122e20$var$h() : $b2e0821792122e20$var$U = !0, $b2e0821792122e20$var$g($b2e0821792122e20$var$W, e - d))) : (a.sortIndex = c, $b2e0821792122e20$var$J($b2e0821792122e20$var$N, a), $b2e0821792122e20$var$T || $b2e0821792122e20$var$S || ($b2e0821792122e20$var$T = !0, $b2e0821792122e20$var$f($b2e0821792122e20$var$X)));
    return a;
};
$b2e0821792122e20$export$b5836b71941fa3ed = function() {
    var a = $b2e0821792122e20$export$c4744153514ff05d();
    $b2e0821792122e20$var$V(a);
    var b = $b2e0821792122e20$var$L($b2e0821792122e20$var$N);
    return b !== $b2e0821792122e20$var$Q && null !== $b2e0821792122e20$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $b2e0821792122e20$var$Q.expirationTime || $b2e0821792122e20$var$k();
};
$b2e0821792122e20$export$cf845f2c119da08a = function(a) {
    var b = $b2e0821792122e20$var$R;
    return function() {
        var c = $b2e0821792122e20$var$R;
        $b2e0821792122e20$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $b2e0821792122e20$var$R = c;
        }
    };
};

});




parcelRegister("9dO3T", function(module, exports) {
$parcel$export(module.exports, "connect", function () { return (parcelRequire("fbonu")).default; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("iEjUn")).default; });
parcelRequire("5Rx5w");
parcelRequire("dNIRY");
var $9sDDw = parcelRequire("9sDDw");

var $8yoxr = parcelRequire("8yoxr");
// with standard React renderers (ReactDOM, React Native)
(0, $8yoxr.setBatch)((0, $9sDDw.unstable_batchedUpdates));

});
parcelRegister("5Rx5w", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("iEjUn")).default; });
$parcel$export(module.exports, "connect", function () { return (parcelRequire("fbonu")).default; });

var $iEjUn = parcelRequire("iEjUn");

var $inppm = parcelRequire("inppm");

var $lXqWn = parcelRequire("lXqWn");

var $fbonu = parcelRequire("fbonu");

var $lrgBk = parcelRequire("lrgBk");

var $b7CSV = parcelRequire("b7CSV");

var $1tyRm = parcelRequire("1tyRm");

var $dZ2ut = parcelRequire("dZ2ut");

});
parcelRegister("iEjUn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d93b67c6eaaa0ee7$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");


var $lXqWn = parcelRequire("lXqWn");

var $7xCP5 = parcelRequire("7xCP5");

var $aueyN = parcelRequire("aueyN");
function $d93b67c6eaaa0ee7$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $arQ7u.useMemo)(function() {
        var subscription = (0, $7xCP5.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $arQ7u.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $aueyN.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $lXqWn.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $d93b67c6eaaa0ee7$export$2e2bcd8739ae039 = $d93b67c6eaaa0ee7$var$Provider;

});
parcelRegister("lXqWn", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $ffc40184dce63634$export$cc80c08dc91f1c00; });

var $arQ7u = parcelRequire("arQ7u");
var $ffc40184dce63634$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createContext(null);
var $ffc40184dce63634$export$2e2bcd8739ae039 = $ffc40184dce63634$export$cc80c08dc91f1c00;

});

parcelRegister("7xCP5", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $57d9bae8399533f7$export$d567d2b9af322f8f; });

var $8yoxr = parcelRequire("8yoxr");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $57d9bae8399533f7$var$createListenerCollection() {
    var batch = (0, $8yoxr.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $57d9bae8399533f7$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $57d9bae8399533f7$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $57d9bae8399533f7$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $57d9bae8399533f7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $57d9bae8399533f7$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("8yoxr", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $63a48889353efef2$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $63a48889353efef2$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $63a48889353efef2$var$defaultNoopBatch(callback) {
    callback();
}
var $63a48889353efef2$var$batch = $63a48889353efef2$var$defaultNoopBatch; // Allow injecting another batching function later
var $63a48889353efef2$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $63a48889353efef2$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $63a48889353efef2$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $63a48889353efef2$var$batch;
};

});


parcelRegister("aueyN", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $7a2800125edcf37f$export$700979bc83e7db82; });

var $arQ7u = parcelRequire("arQ7u");
var $7a2800125edcf37f$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $arQ7u.useLayoutEffect) : (0, $arQ7u.useEffect);

});


parcelRegister("inppm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d60e158032870d6b$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $fJZol = parcelRequire("fJZol");

var $2XZwC = parcelRequire("2XZwC");

var $arQ7u = parcelRequire("arQ7u");

var $legPH = parcelRequire("legPH");

var $7xCP5 = parcelRequire("7xCP5");

var $aueyN = parcelRequire("aueyN");

var $lXqWn = parcelRequire("lXqWn");
var $d60e158032870d6b$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $d60e158032870d6b$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $d60e158032870d6b$var$EMPTY_ARRAY = [];
var $d60e158032870d6b$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $d60e158032870d6b$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $d60e158032870d6b$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $d60e158032870d6b$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $aueyN.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $d60e158032870d6b$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $d60e158032870d6b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $d60e158032870d6b$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $d60e158032870d6b$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $lXqWn.ReactReduxContext) : _ref2$context, connectOptions = (0, $fJZol.default)(_ref2, $d60e158032870d6b$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $abElG.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $arQ7u.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $arQ7u.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $fJZol.default)(props, $d60e158032870d6b$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $arQ7u.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $legPH.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $arQ7u.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $arQ7u.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $arQ7u.useMemo)(function() {
                if (!shouldHandleStateChanges) return $d60e158032870d6b$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $7xCP5.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $arQ7u.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $abElG.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $arQ7u.useReducer)($d60e158032870d6b$var$storeStateUpdatesReducer, $d60e158032870d6b$var$EMPTY_ARRAY, $d60e158032870d6b$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $arQ7u.useRef)();
            var lastWrapperProps = (0, $arQ7u.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $arQ7u.useRef)();
            var renderIsScheduled = (0, $arQ7u.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $d60e158032870d6b$var$useIsomorphicLayoutEffectWithArgs($d60e158032870d6b$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $d60e158032870d6b$var$useIsomorphicLayoutEffectWithArgs($d60e158032870d6b$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $arQ7u.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(WrappedComponent, (0, $abElG.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $arQ7u.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(Connect, (0, $abElG.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($2XZwC)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($2XZwC)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("abElG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76aa3adcef9f652a$export$2e2bcd8739ae039; });
function $76aa3adcef9f652a$export$2e2bcd8739ae039() {
    $76aa3adcef9f652a$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $76aa3adcef9f652a$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("fJZol", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b75aae100c3b30be$export$2e2bcd8739ae039; });
function $b75aae100c3b30be$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("2XZwC", function(module, exports) {
"use strict";

var $lyPio = parcelRequire("lyPio");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $2290d110b6d863d3$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $2290d110b6d863d3$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $2290d110b6d863d3$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $2290d110b6d863d3$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $2290d110b6d863d3$var$TYPE_STATICS = {};
$2290d110b6d863d3$var$TYPE_STATICS[$lyPio.ForwardRef] = $2290d110b6d863d3$var$FORWARD_REF_STATICS;
$2290d110b6d863d3$var$TYPE_STATICS[$lyPio.Memo] = $2290d110b6d863d3$var$MEMO_STATICS;
function $2290d110b6d863d3$var$getStatics(component) {
    // React v16.11 and below
    if ($lyPio.isMemo(component)) return $2290d110b6d863d3$var$MEMO_STATICS;
     // React v16.12 and above
    return $2290d110b6d863d3$var$TYPE_STATICS[component["$$typeof"]] || $2290d110b6d863d3$var$REACT_STATICS;
}
var $2290d110b6d863d3$var$defineProperty = Object.defineProperty;
var $2290d110b6d863d3$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $2290d110b6d863d3$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $2290d110b6d863d3$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2290d110b6d863d3$var$getPrototypeOf = Object.getPrototypeOf;
var $2290d110b6d863d3$var$objectPrototype = Object.prototype;
function $2290d110b6d863d3$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($2290d110b6d863d3$var$objectPrototype) {
            var inheritedComponent = $2290d110b6d863d3$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $2290d110b6d863d3$var$objectPrototype) $2290d110b6d863d3$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $2290d110b6d863d3$var$getOwnPropertyNames(sourceComponent);
        if ($2290d110b6d863d3$var$getOwnPropertySymbols) keys = keys.concat($2290d110b6d863d3$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $2290d110b6d863d3$var$getStatics(targetComponent);
        var sourceStatics = $2290d110b6d863d3$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$2290d110b6d863d3$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $2290d110b6d863d3$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $2290d110b6d863d3$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $2290d110b6d863d3$var$hoistNonReactStatics;

});
parcelRegister("lyPio", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dkuKa"));

});
parcelRegister("dkuKa", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $9b44fda7f2f47f3c$export$2b8d127b894957b9; }, function (v) { return $9b44fda7f2f47f3c$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $9b44fda7f2f47f3c$export$cea3a54a6425200c; }, function (v) { return $9b44fda7f2f47f3c$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $9b44fda7f2f47f3c$export$a7c73072b1a182ae; }, function (v) { return $9b44fda7f2f47f3c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $9b44fda7f2f47f3c$export$9f27bc3417b4524d; }, function (v) { return $9b44fda7f2f47f3c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $9b44fda7f2f47f3c$export$db77ccec0bb4ccac; }, function (v) { return $9b44fda7f2f47f3c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $9b44fda7f2f47f3c$export$8392c0c9d3dcbd35; }, function (v) { return $9b44fda7f2f47f3c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $9b44fda7f2f47f3c$export$ffb0004e005737fa; }, function (v) { return $9b44fda7f2f47f3c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $9b44fda7f2f47f3c$export$b624eff549462981; }, function (v) { return $9b44fda7f2f47f3c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $9b44fda7f2f47f3c$export$7897aa7841a5380c; }, function (v) { return $9b44fda7f2f47f3c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $9b44fda7f2f47f3c$export$602eac185826482c; }, function (v) { return $9b44fda7f2f47f3c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $9b44fda7f2f47f3c$export$e2c29f18771995cb; }, function (v) { return $9b44fda7f2f47f3c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $9b44fda7f2f47f3c$export$5f8d39834fd61797; }, function (v) { return $9b44fda7f2f47f3c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $9b44fda7f2f47f3c$export$74bf444e3cd11ea5; }, function (v) { return $9b44fda7f2f47f3c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $9b44fda7f2f47f3c$export$92387174baf9b227; }, function (v) { return $9b44fda7f2f47f3c$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $9b44fda7f2f47f3c$export$ec112efeb987d9c6; }, function (v) { return $9b44fda7f2f47f3c$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $9b44fda7f2f47f3c$export$b706b080d889d2c9; }, function (v) { return $9b44fda7f2f47f3c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $9b44fda7f2f47f3c$export$5be5a87408f70ddc; }, function (v) { return $9b44fda7f2f47f3c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $9b44fda7f2f47f3c$export$45a5e7f76e0caa8d; }, function (v) { return $9b44fda7f2f47f3c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $9b44fda7f2f47f3c$export$455c2e768291efa6; }, function (v) { return $9b44fda7f2f47f3c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $9b44fda7f2f47f3c$export$9522e17588c12572; }, function (v) { return $9b44fda7f2f47f3c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $9b44fda7f2f47f3c$export$2110ac352bb060b9; }, function (v) { return $9b44fda7f2f47f3c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $9b44fda7f2f47f3c$export$56885ab8b9c456ab; }, function (v) { return $9b44fda7f2f47f3c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $9b44fda7f2f47f3c$export$d927fcb6adf8f9de; }, function (v) { return $9b44fda7f2f47f3c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $9b44fda7f2f47f3c$export$b82d16f27459e05a; }, function (v) { return $9b44fda7f2f47f3c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $9b44fda7f2f47f3c$export$522c17b4f5e123e8; }, function (v) { return $9b44fda7f2f47f3c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $9b44fda7f2f47f3c$export$1aabd8a0274ecfd6; }, function (v) { return $9b44fda7f2f47f3c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $9b44fda7f2f47f3c$export$9b621391a187a31a; }, function (v) { return $9b44fda7f2f47f3c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $9b44fda7f2f47f3c$export$f5bbd400c2f4426f; }, function (v) { return $9b44fda7f2f47f3c$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9b44fda7f2f47f3c$export$2b8d127b894957b9;
var $9b44fda7f2f47f3c$export$cea3a54a6425200c;
var $9b44fda7f2f47f3c$export$a7c73072b1a182ae;
var $9b44fda7f2f47f3c$export$9f27bc3417b4524d;
var $9b44fda7f2f47f3c$export$db77ccec0bb4ccac;
var $9b44fda7f2f47f3c$export$8392c0c9d3dcbd35;
var $9b44fda7f2f47f3c$export$ffb0004e005737fa;
var $9b44fda7f2f47f3c$export$b624eff549462981;
var $9b44fda7f2f47f3c$export$7897aa7841a5380c;
var $9b44fda7f2f47f3c$export$602eac185826482c;
var $9b44fda7f2f47f3c$export$e2c29f18771995cb;
var $9b44fda7f2f47f3c$export$5f8d39834fd61797;
var $9b44fda7f2f47f3c$export$74bf444e3cd11ea5;
var $9b44fda7f2f47f3c$export$92387174baf9b227;
var $9b44fda7f2f47f3c$export$ec112efeb987d9c6;
var $9b44fda7f2f47f3c$export$b706b080d889d2c9;
var $9b44fda7f2f47f3c$export$5be5a87408f70ddc;
var $9b44fda7f2f47f3c$export$45a5e7f76e0caa8d;
var $9b44fda7f2f47f3c$export$455c2e768291efa6;
var $9b44fda7f2f47f3c$export$9522e17588c12572;
var $9b44fda7f2f47f3c$export$2110ac352bb060b9;
var $9b44fda7f2f47f3c$export$56885ab8b9c456ab;
var $9b44fda7f2f47f3c$export$d927fcb6adf8f9de;
var $9b44fda7f2f47f3c$export$b82d16f27459e05a;
var $9b44fda7f2f47f3c$export$522c17b4f5e123e8;
var $9b44fda7f2f47f3c$export$1aabd8a0274ecfd6;
var $9b44fda7f2f47f3c$export$9b621391a187a31a;
var $9b44fda7f2f47f3c$export$f5bbd400c2f4426f;
"use strict";
var $9b44fda7f2f47f3c$var$b = "function" === typeof Symbol && Symbol.for, $9b44fda7f2f47f3c$var$c = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.element") : 60103, $9b44fda7f2f47f3c$var$d = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.portal") : 60106, $9b44fda7f2f47f3c$var$e = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.fragment") : 60107, $9b44fda7f2f47f3c$var$f = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.strict_mode") : 60108, $9b44fda7f2f47f3c$var$g = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.profiler") : 60114, $9b44fda7f2f47f3c$var$h = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.provider") : 60109, $9b44fda7f2f47f3c$var$k = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.context") : 60110, $9b44fda7f2f47f3c$var$l = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.async_mode") : 60111, $9b44fda7f2f47f3c$var$m = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9b44fda7f2f47f3c$var$n = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.forward_ref") : 60112, $9b44fda7f2f47f3c$var$p = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.suspense") : 60113, $9b44fda7f2f47f3c$var$q = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.suspense_list") : 60120, $9b44fda7f2f47f3c$var$r = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.memo") : 60115, $9b44fda7f2f47f3c$var$t = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.lazy") : 60116, $9b44fda7f2f47f3c$var$v = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.block") : 60121, $9b44fda7f2f47f3c$var$w = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.fundamental") : 60117, $9b44fda7f2f47f3c$var$x = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.responder") : 60118, $9b44fda7f2f47f3c$var$y = $9b44fda7f2f47f3c$var$b ? Symbol.for("react.scope") : 60119;
function $9b44fda7f2f47f3c$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9b44fda7f2f47f3c$var$c:
                switch(a = a.type, a){
                    case $9b44fda7f2f47f3c$var$l:
                    case $9b44fda7f2f47f3c$var$m:
                    case $9b44fda7f2f47f3c$var$e:
                    case $9b44fda7f2f47f3c$var$g:
                    case $9b44fda7f2f47f3c$var$f:
                    case $9b44fda7f2f47f3c$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9b44fda7f2f47f3c$var$k:
                            case $9b44fda7f2f47f3c$var$n:
                            case $9b44fda7f2f47f3c$var$t:
                            case $9b44fda7f2f47f3c$var$r:
                            case $9b44fda7f2f47f3c$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9b44fda7f2f47f3c$var$d:
                return u;
        }
    }
}
function $9b44fda7f2f47f3c$var$A(a) {
    return $9b44fda7f2f47f3c$var$z(a) === $9b44fda7f2f47f3c$var$m;
}
$9b44fda7f2f47f3c$export$2b8d127b894957b9 = $9b44fda7f2f47f3c$var$l;
$9b44fda7f2f47f3c$export$cea3a54a6425200c = $9b44fda7f2f47f3c$var$m;
$9b44fda7f2f47f3c$export$a7c73072b1a182ae = $9b44fda7f2f47f3c$var$k;
$9b44fda7f2f47f3c$export$9f27bc3417b4524d = $9b44fda7f2f47f3c$var$h;
$9b44fda7f2f47f3c$export$db77ccec0bb4ccac = $9b44fda7f2f47f3c$var$c;
$9b44fda7f2f47f3c$export$8392c0c9d3dcbd35 = $9b44fda7f2f47f3c$var$n;
$9b44fda7f2f47f3c$export$ffb0004e005737fa = $9b44fda7f2f47f3c$var$e;
$9b44fda7f2f47f3c$export$b624eff549462981 = $9b44fda7f2f47f3c$var$t;
$9b44fda7f2f47f3c$export$7897aa7841a5380c = $9b44fda7f2f47f3c$var$r;
$9b44fda7f2f47f3c$export$602eac185826482c = $9b44fda7f2f47f3c$var$d;
$9b44fda7f2f47f3c$export$e2c29f18771995cb = $9b44fda7f2f47f3c$var$g;
$9b44fda7f2f47f3c$export$5f8d39834fd61797 = $9b44fda7f2f47f3c$var$f;
$9b44fda7f2f47f3c$export$74bf444e3cd11ea5 = $9b44fda7f2f47f3c$var$p;
$9b44fda7f2f47f3c$export$92387174baf9b227 = function(a) {
    return $9b44fda7f2f47f3c$var$A(a) || $9b44fda7f2f47f3c$var$z(a) === $9b44fda7f2f47f3c$var$l;
};
$9b44fda7f2f47f3c$export$ec112efeb987d9c6 = $9b44fda7f2f47f3c$var$A;
$9b44fda7f2f47f3c$export$b706b080d889d2c9 = function(a) {
    return $9b44fda7f2f47f3c$var$z(a) === $9b44fda7f2f47f3c$var$k;
};
$9b44fda7f2f47f3c$export$5be5a87408f70ddc = function(a) {
    return $9b44fda7f2f47f3c$var$z(a) === $9b44fda7f2f47f3c$var$h;
};
$9b44fda7f2f47f3c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9b44fda7f2f47f3c$var$c;
};
$9b44fda7f2f47f3c$export$455c2e768291efa6 = function(a) {
    return $9b44fda7f2f47f3c$var$z(a) === $9b44fda7f2f47f3c$var$n;
};
$9b44fda7f2f47f3c$export$9522e17588c12572 = function(a) {
    return $9b44fda7f2f47f3c$var$z(a) === $9b44fda7f2f47f3c$var$e;
};
$9b44fda7f2f47f3c$export$2110ac352bb060b9 = function(a) {
    return $9b44fda7f2f47f3c$var$z(a) === $9b44fda7f2f47f3c$var$t;
};
$9b44fda7f2f47f3c$export$56885ab8b9c456ab = function(a) {
    return $9b44fda7f2f47f3c$var$z(a) === $9b44fda7f2f47f3c$var$r;
};
$9b44fda7f2f47f3c$export$d927fcb6adf8f9de = function(a) {
    return $9b44fda7f2f47f3c$var$z(a) === $9b44fda7f2f47f3c$var$d;
};
$9b44fda7f2f47f3c$export$b82d16f27459e05a = function(a) {
    return $9b44fda7f2f47f3c$var$z(a) === $9b44fda7f2f47f3c$var$g;
};
$9b44fda7f2f47f3c$export$522c17b4f5e123e8 = function(a) {
    return $9b44fda7f2f47f3c$var$z(a) === $9b44fda7f2f47f3c$var$f;
};
$9b44fda7f2f47f3c$export$1aabd8a0274ecfd6 = function(a) {
    return $9b44fda7f2f47f3c$var$z(a) === $9b44fda7f2f47f3c$var$p;
};
$9b44fda7f2f47f3c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9b44fda7f2f47f3c$var$e || a === $9b44fda7f2f47f3c$var$m || a === $9b44fda7f2f47f3c$var$g || a === $9b44fda7f2f47f3c$var$f || a === $9b44fda7f2f47f3c$var$p || a === $9b44fda7f2f47f3c$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9b44fda7f2f47f3c$var$t || a.$$typeof === $9b44fda7f2f47f3c$var$r || a.$$typeof === $9b44fda7f2f47f3c$var$h || a.$$typeof === $9b44fda7f2f47f3c$var$k || a.$$typeof === $9b44fda7f2f47f3c$var$n || a.$$typeof === $9b44fda7f2f47f3c$var$w || a.$$typeof === $9b44fda7f2f47f3c$var$x || a.$$typeof === $9b44fda7f2f47f3c$var$y || a.$$typeof === $9b44fda7f2f47f3c$var$v);
};
$9b44fda7f2f47f3c$export$f5bbd400c2f4426f = $9b44fda7f2f47f3c$var$z;

});



parcelRegister("legPH", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kh5GO"));

});
parcelRegister("kh5GO", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $ec29cf02a9e09a63$export$a7c73072b1a182ae; }, function (v) { return $ec29cf02a9e09a63$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ec29cf02a9e09a63$export$9f27bc3417b4524d; }, function (v) { return $ec29cf02a9e09a63$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ec29cf02a9e09a63$export$db77ccec0bb4ccac; }, function (v) { return $ec29cf02a9e09a63$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ec29cf02a9e09a63$export$8392c0c9d3dcbd35; }, function (v) { return $ec29cf02a9e09a63$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ec29cf02a9e09a63$export$ffb0004e005737fa; }, function (v) { return $ec29cf02a9e09a63$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ec29cf02a9e09a63$export$b624eff549462981; }, function (v) { return $ec29cf02a9e09a63$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ec29cf02a9e09a63$export$7897aa7841a5380c; }, function (v) { return $ec29cf02a9e09a63$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ec29cf02a9e09a63$export$602eac185826482c; }, function (v) { return $ec29cf02a9e09a63$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ec29cf02a9e09a63$export$e2c29f18771995cb; }, function (v) { return $ec29cf02a9e09a63$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ec29cf02a9e09a63$export$5f8d39834fd61797; }, function (v) { return $ec29cf02a9e09a63$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ec29cf02a9e09a63$export$74bf444e3cd11ea5; }, function (v) { return $ec29cf02a9e09a63$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $ec29cf02a9e09a63$export$92387174baf9b227; }, function (v) { return $ec29cf02a9e09a63$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $ec29cf02a9e09a63$export$ec112efeb987d9c6; }, function (v) { return $ec29cf02a9e09a63$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ec29cf02a9e09a63$export$b706b080d889d2c9; }, function (v) { return $ec29cf02a9e09a63$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ec29cf02a9e09a63$export$5be5a87408f70ddc; }, function (v) { return $ec29cf02a9e09a63$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ec29cf02a9e09a63$export$45a5e7f76e0caa8d; }, function (v) { return $ec29cf02a9e09a63$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ec29cf02a9e09a63$export$455c2e768291efa6; }, function (v) { return $ec29cf02a9e09a63$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ec29cf02a9e09a63$export$9522e17588c12572; }, function (v) { return $ec29cf02a9e09a63$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ec29cf02a9e09a63$export$2110ac352bb060b9; }, function (v) { return $ec29cf02a9e09a63$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ec29cf02a9e09a63$export$56885ab8b9c456ab; }, function (v) { return $ec29cf02a9e09a63$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ec29cf02a9e09a63$export$d927fcb6adf8f9de; }, function (v) { return $ec29cf02a9e09a63$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ec29cf02a9e09a63$export$b82d16f27459e05a; }, function (v) { return $ec29cf02a9e09a63$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ec29cf02a9e09a63$export$522c17b4f5e123e8; }, function (v) { return $ec29cf02a9e09a63$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ec29cf02a9e09a63$export$1aabd8a0274ecfd6; }, function (v) { return $ec29cf02a9e09a63$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ec29cf02a9e09a63$export$9b621391a187a31a; }, function (v) { return $ec29cf02a9e09a63$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ec29cf02a9e09a63$export$f5bbd400c2f4426f; }, function (v) { return $ec29cf02a9e09a63$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ec29cf02a9e09a63$export$a7c73072b1a182ae;
var $ec29cf02a9e09a63$export$9f27bc3417b4524d;
var $ec29cf02a9e09a63$export$db77ccec0bb4ccac;
var $ec29cf02a9e09a63$export$8392c0c9d3dcbd35;
var $ec29cf02a9e09a63$export$ffb0004e005737fa;
var $ec29cf02a9e09a63$export$b624eff549462981;
var $ec29cf02a9e09a63$export$7897aa7841a5380c;
var $ec29cf02a9e09a63$export$602eac185826482c;
var $ec29cf02a9e09a63$export$e2c29f18771995cb;
var $ec29cf02a9e09a63$export$5f8d39834fd61797;
var $ec29cf02a9e09a63$export$74bf444e3cd11ea5;
var $ec29cf02a9e09a63$export$92387174baf9b227;
var $ec29cf02a9e09a63$export$ec112efeb987d9c6;
var $ec29cf02a9e09a63$export$b706b080d889d2c9;
var $ec29cf02a9e09a63$export$5be5a87408f70ddc;
var $ec29cf02a9e09a63$export$45a5e7f76e0caa8d;
var $ec29cf02a9e09a63$export$455c2e768291efa6;
var $ec29cf02a9e09a63$export$9522e17588c12572;
var $ec29cf02a9e09a63$export$2110ac352bb060b9;
var $ec29cf02a9e09a63$export$56885ab8b9c456ab;
var $ec29cf02a9e09a63$export$d927fcb6adf8f9de;
var $ec29cf02a9e09a63$export$b82d16f27459e05a;
var $ec29cf02a9e09a63$export$522c17b4f5e123e8;
var $ec29cf02a9e09a63$export$1aabd8a0274ecfd6;
var $ec29cf02a9e09a63$export$9b621391a187a31a;
var $ec29cf02a9e09a63$export$f5bbd400c2f4426f;
"use strict";
var $ec29cf02a9e09a63$var$b = 60103, $ec29cf02a9e09a63$var$c = 60106, $ec29cf02a9e09a63$var$d = 60107, $ec29cf02a9e09a63$var$e = 60108, $ec29cf02a9e09a63$var$f = 60114, $ec29cf02a9e09a63$var$g = 60109, $ec29cf02a9e09a63$var$h = 60110, $ec29cf02a9e09a63$var$k = 60112, $ec29cf02a9e09a63$var$l = 60113, $ec29cf02a9e09a63$var$m = 60120, $ec29cf02a9e09a63$var$n = 60115, $ec29cf02a9e09a63$var$p = 60116, $ec29cf02a9e09a63$var$q = 60121, $ec29cf02a9e09a63$var$r = 60122, $ec29cf02a9e09a63$var$u = 60117, $ec29cf02a9e09a63$var$v = 60129, $ec29cf02a9e09a63$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $ec29cf02a9e09a63$var$x = Symbol.for;
    $ec29cf02a9e09a63$var$b = $ec29cf02a9e09a63$var$x("react.element");
    $ec29cf02a9e09a63$var$c = $ec29cf02a9e09a63$var$x("react.portal");
    $ec29cf02a9e09a63$var$d = $ec29cf02a9e09a63$var$x("react.fragment");
    $ec29cf02a9e09a63$var$e = $ec29cf02a9e09a63$var$x("react.strict_mode");
    $ec29cf02a9e09a63$var$f = $ec29cf02a9e09a63$var$x("react.profiler");
    $ec29cf02a9e09a63$var$g = $ec29cf02a9e09a63$var$x("react.provider");
    $ec29cf02a9e09a63$var$h = $ec29cf02a9e09a63$var$x("react.context");
    $ec29cf02a9e09a63$var$k = $ec29cf02a9e09a63$var$x("react.forward_ref");
    $ec29cf02a9e09a63$var$l = $ec29cf02a9e09a63$var$x("react.suspense");
    $ec29cf02a9e09a63$var$m = $ec29cf02a9e09a63$var$x("react.suspense_list");
    $ec29cf02a9e09a63$var$n = $ec29cf02a9e09a63$var$x("react.memo");
    $ec29cf02a9e09a63$var$p = $ec29cf02a9e09a63$var$x("react.lazy");
    $ec29cf02a9e09a63$var$q = $ec29cf02a9e09a63$var$x("react.block");
    $ec29cf02a9e09a63$var$r = $ec29cf02a9e09a63$var$x("react.server.block");
    $ec29cf02a9e09a63$var$u = $ec29cf02a9e09a63$var$x("react.fundamental");
    $ec29cf02a9e09a63$var$v = $ec29cf02a9e09a63$var$x("react.debug_trace_mode");
    $ec29cf02a9e09a63$var$w = $ec29cf02a9e09a63$var$x("react.legacy_hidden");
}
function $ec29cf02a9e09a63$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $ec29cf02a9e09a63$var$b:
                switch(a = a.type, a){
                    case $ec29cf02a9e09a63$var$d:
                    case $ec29cf02a9e09a63$var$f:
                    case $ec29cf02a9e09a63$var$e:
                    case $ec29cf02a9e09a63$var$l:
                    case $ec29cf02a9e09a63$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ec29cf02a9e09a63$var$h:
                            case $ec29cf02a9e09a63$var$k:
                            case $ec29cf02a9e09a63$var$p:
                            case $ec29cf02a9e09a63$var$n:
                            case $ec29cf02a9e09a63$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $ec29cf02a9e09a63$var$c:
                return t;
        }
    }
}
var $ec29cf02a9e09a63$var$z = $ec29cf02a9e09a63$var$g, $ec29cf02a9e09a63$var$A = $ec29cf02a9e09a63$var$b, $ec29cf02a9e09a63$var$B = $ec29cf02a9e09a63$var$k, $ec29cf02a9e09a63$var$C = $ec29cf02a9e09a63$var$d, $ec29cf02a9e09a63$var$D = $ec29cf02a9e09a63$var$p, $ec29cf02a9e09a63$var$E = $ec29cf02a9e09a63$var$n, $ec29cf02a9e09a63$var$F = $ec29cf02a9e09a63$var$c, $ec29cf02a9e09a63$var$G = $ec29cf02a9e09a63$var$f, $ec29cf02a9e09a63$var$H = $ec29cf02a9e09a63$var$e, $ec29cf02a9e09a63$var$I = $ec29cf02a9e09a63$var$l;
$ec29cf02a9e09a63$export$a7c73072b1a182ae = $ec29cf02a9e09a63$var$h;
$ec29cf02a9e09a63$export$9f27bc3417b4524d = $ec29cf02a9e09a63$var$z;
$ec29cf02a9e09a63$export$db77ccec0bb4ccac = $ec29cf02a9e09a63$var$A;
$ec29cf02a9e09a63$export$8392c0c9d3dcbd35 = $ec29cf02a9e09a63$var$B;
$ec29cf02a9e09a63$export$ffb0004e005737fa = $ec29cf02a9e09a63$var$C;
$ec29cf02a9e09a63$export$b624eff549462981 = $ec29cf02a9e09a63$var$D;
$ec29cf02a9e09a63$export$7897aa7841a5380c = $ec29cf02a9e09a63$var$E;
$ec29cf02a9e09a63$export$602eac185826482c = $ec29cf02a9e09a63$var$F;
$ec29cf02a9e09a63$export$e2c29f18771995cb = $ec29cf02a9e09a63$var$G;
$ec29cf02a9e09a63$export$5f8d39834fd61797 = $ec29cf02a9e09a63$var$H;
$ec29cf02a9e09a63$export$74bf444e3cd11ea5 = $ec29cf02a9e09a63$var$I;
$ec29cf02a9e09a63$export$92387174baf9b227 = function() {
    return !1;
};
$ec29cf02a9e09a63$export$ec112efeb987d9c6 = function() {
    return !1;
};
$ec29cf02a9e09a63$export$b706b080d889d2c9 = function(a) {
    return $ec29cf02a9e09a63$var$y(a) === $ec29cf02a9e09a63$var$h;
};
$ec29cf02a9e09a63$export$5be5a87408f70ddc = function(a) {
    return $ec29cf02a9e09a63$var$y(a) === $ec29cf02a9e09a63$var$g;
};
$ec29cf02a9e09a63$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ec29cf02a9e09a63$var$b;
};
$ec29cf02a9e09a63$export$455c2e768291efa6 = function(a) {
    return $ec29cf02a9e09a63$var$y(a) === $ec29cf02a9e09a63$var$k;
};
$ec29cf02a9e09a63$export$9522e17588c12572 = function(a) {
    return $ec29cf02a9e09a63$var$y(a) === $ec29cf02a9e09a63$var$d;
};
$ec29cf02a9e09a63$export$2110ac352bb060b9 = function(a) {
    return $ec29cf02a9e09a63$var$y(a) === $ec29cf02a9e09a63$var$p;
};
$ec29cf02a9e09a63$export$56885ab8b9c456ab = function(a) {
    return $ec29cf02a9e09a63$var$y(a) === $ec29cf02a9e09a63$var$n;
};
$ec29cf02a9e09a63$export$d927fcb6adf8f9de = function(a) {
    return $ec29cf02a9e09a63$var$y(a) === $ec29cf02a9e09a63$var$c;
};
$ec29cf02a9e09a63$export$b82d16f27459e05a = function(a) {
    return $ec29cf02a9e09a63$var$y(a) === $ec29cf02a9e09a63$var$f;
};
$ec29cf02a9e09a63$export$522c17b4f5e123e8 = function(a) {
    return $ec29cf02a9e09a63$var$y(a) === $ec29cf02a9e09a63$var$e;
};
$ec29cf02a9e09a63$export$1aabd8a0274ecfd6 = function(a) {
    return $ec29cf02a9e09a63$var$y(a) === $ec29cf02a9e09a63$var$l;
};
$ec29cf02a9e09a63$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ec29cf02a9e09a63$var$d || a === $ec29cf02a9e09a63$var$f || a === $ec29cf02a9e09a63$var$v || a === $ec29cf02a9e09a63$var$e || a === $ec29cf02a9e09a63$var$l || a === $ec29cf02a9e09a63$var$m || a === $ec29cf02a9e09a63$var$w || "object" === typeof a && null !== a && (a.$$typeof === $ec29cf02a9e09a63$var$p || a.$$typeof === $ec29cf02a9e09a63$var$n || a.$$typeof === $ec29cf02a9e09a63$var$g || a.$$typeof === $ec29cf02a9e09a63$var$h || a.$$typeof === $ec29cf02a9e09a63$var$k || a.$$typeof === $ec29cf02a9e09a63$var$u || a.$$typeof === $ec29cf02a9e09a63$var$q || a[0] === $ec29cf02a9e09a63$var$r) ? !0 : !1;
};
$ec29cf02a9e09a63$export$f5bbd400c2f4426f = $ec29cf02a9e09a63$var$y;

});



parcelRegister("fbonu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0dacb0c59d769a7$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $fJZol = parcelRequire("fJZol");

var $inppm = parcelRequire("inppm");

var $dZ2ut = parcelRequire("dZ2ut");

var $jWTy3 = parcelRequire("jWTy3");

var $1UiQi = parcelRequire("1UiQi");

var $kbfaW = parcelRequire("kbfaW");

var $hBItB = parcelRequire("hBItB");
var $b0dacb0c59d769a7$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $b0dacb0c59d769a7$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $b0dacb0c59d769a7$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $b0dacb0c59d769a7$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $inppm.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $1UiQi.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $jWTy3.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $kbfaW.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $hBItB.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $b0dacb0c59d769a7$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $dZ2ut.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $dZ2ut.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $dZ2ut.default) : _ref3$areMergedPropsE, extraOptions = (0, $fJZol.default)(_ref3, $b0dacb0c59d769a7$var$_excluded);
        var initMapStateToProps = $b0dacb0c59d769a7$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $b0dacb0c59d769a7$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $b0dacb0c59d769a7$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $abElG.default)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $b0dacb0c59d769a7$export$2e2bcd8739ae039 = /*#__PURE__*/ $b0dacb0c59d769a7$export$9f9feb656dec1fc4();

});
parcelRegister("dZ2ut", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2e2e76e691378b1$export$2e2bcd8739ae039; });
function $a2e2e76e691378b1$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $a2e2e76e691378b1$export$2e2bcd8739ae039(objA, objB) {
    if ($a2e2e76e691378b1$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$a2e2e76e691378b1$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("jWTy3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e85e85d7d2c6fca2$export$2e2bcd8739ae039; });

var $cHzJ7 = parcelRequire("cHzJ7");

var $hbqxT = parcelRequire("hbqxT");
function $e85e85d7d2c6fca2$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $hbqxT.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $e85e85d7d2c6fca2$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $hbqxT.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $e85e85d7d2c6fca2$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $hbqxT.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $cHzJ7.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $e85e85d7d2c6fca2$export$2e2bcd8739ae039 = [
    $e85e85d7d2c6fca2$export$a9f27b4b187c1166,
    $e85e85d7d2c6fca2$export$ba20d1a7aa0c4a90,
    $e85e85d7d2c6fca2$export$94a6e55709d4d961
];

});
parcelRegister("cHzJ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93f536c00fc6d8b8$export$2e2bcd8739ae039; });
function $93f536c00fc6d8b8$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("hbqxT", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $c8280e301476df2b$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $c8280e301476df2b$export$8d46c7f53c8c602f; });
parcelRequire("9G4vJ");
function $c8280e301476df2b$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $c8280e301476df2b$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $c8280e301476df2b$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $c8280e301476df2b$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $c8280e301476df2b$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("9G4vJ", function(module, exports) {

var $5rqlr = parcelRequire("5rqlr");

var $eAA7M = parcelRequire("eAA7M");
function $70bb8906f84c68ff$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $5rqlr.default)(value)) (0, $eAA7M.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("5rqlr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f63e8e12ca5ff58$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $3f63e8e12ca5ff58$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("eAA7M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9f07307c58646db$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $a9f07307c58646db$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("1UiQi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1639a326cfcb8706$export$2e2bcd8739ae039; });

var $hbqxT = parcelRequire("hbqxT");
function $1639a326cfcb8706$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $hbqxT.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : undefined;
}
function $1639a326cfcb8706$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $hbqxT.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $1639a326cfcb8706$export$2e2bcd8739ae039 = [
    $1639a326cfcb8706$export$23fc470827b14aa,
    $1639a326cfcb8706$export$514bc8c1a53c1d66
];

});

parcelRegister("kbfaW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb109b48629b5c61$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");
parcelRequire("9G4vJ");
function $eb109b48629b5c61$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $abElG.default)({}, ownProps, stateProps, dispatchProps);
}
function $eb109b48629b5c61$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $eb109b48629b5c61$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $eb109b48629b5c61$export$5b105939c84b5234(mergeProps) : undefined;
}
function $eb109b48629b5c61$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $eb109b48629b5c61$export$691c327fc30bc857;
    } : undefined;
}
var $eb109b48629b5c61$export$2e2bcd8739ae039 = [
    $eb109b48629b5c61$export$d61b680184bc3f00,
    $eb109b48629b5c61$export$a13ba70ef50dda6d
];

});

parcelRegister("hBItB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd1864779d5347e4$export$2e2bcd8739ae039; });

var $fJZol = parcelRequire("fJZol");
parcelRequire("4G0Ts");
var $cd1864779d5347e4$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $cd1864779d5347e4$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $cd1864779d5347e4$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $cd1864779d5347e4$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $fJZol.default)(_ref2, $cd1864779d5347e4$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $cd1864779d5347e4$export$d20c0c2ca6eb2b6f : $cd1864779d5347e4$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("4G0Ts", function(module, exports) {

var $eAA7M = parcelRequire("eAA7M");
function $367bc714579854db$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $eAA7M.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $367bc714579854db$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $367bc714579854db$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $367bc714579854db$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $367bc714579854db$var$verify(mergeProps, "mergeProps", displayName);
}

});



parcelRegister("lrgBk", function(module, exports) {

var $lXqWn = parcelRequire("lXqWn");

var $1tyRm = parcelRequire("1tyRm");
function $f9b8ff3d2af2cc8a$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $lXqWn.ReactReduxContext);
    var useStore = context === (0, $lXqWn.ReactReduxContext) ? (0, $1tyRm.useStore) : (0, $1tyRm.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $f9b8ff3d2af2cc8a$export$8ad76b76a4c905f8 = /*#__PURE__*/ $f9b8ff3d2af2cc8a$export$bc9b55530897c558();

});
parcelRegister("1tyRm", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $11338a46f23a4533$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $11338a46f23a4533$export$6ccbb43953eebf8; });

var $arQ7u = parcelRequire("arQ7u");

var $lXqWn = parcelRequire("lXqWn");

var $eo4Du = parcelRequire("eo4Du");
function $11338a46f23a4533$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $lXqWn.ReactReduxContext);
    var useReduxContext = context === (0, $lXqWn.ReactReduxContext) ? (0, $eo4Du.useReduxContext) : function() {
        return (0, $arQ7u.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $11338a46f23a4533$export$6ccbb43953eebf8 = /*#__PURE__*/ $11338a46f23a4533$export$671dba69185d0304();

});
parcelRegister("eo4Du", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", function () { return $a796e72e86052c5d$export$c1275ca9a6fd3ec5; });

var $arQ7u = parcelRequire("arQ7u");

var $lXqWn = parcelRequire("lXqWn");
function $a796e72e86052c5d$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $arQ7u.useContext)((0, $lXqWn.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("b7CSV", function(module, exports) {

var $arQ7u = parcelRequire("arQ7u");

var $eo4Du = parcelRequire("eo4Du");

var $7xCP5 = parcelRequire("7xCP5");

var $aueyN = parcelRequire("aueyN");

var $lXqWn = parcelRequire("lXqWn");
var $818e82e2083e3c19$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $818e82e2083e3c19$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $arQ7u.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $arQ7u.useMemo)(function() {
        return (0, $7xCP5.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $arQ7u.useRef)();
    var latestSelector = (0, $arQ7u.useRef)();
    var latestStoreState = (0, $arQ7u.useRef)();
    var latestSelectedState = (0, $arQ7u.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $aueyN.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $aueyN.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $818e82e2083e3c19$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $lXqWn.ReactReduxContext);
    var useReduxContext = context === (0, $lXqWn.ReactReduxContext) ? (0, $eo4Du.useReduxContext) : function() {
        return (0, $arQ7u.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $818e82e2083e3c19$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $818e82e2083e3c19$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $arQ7u.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $818e82e2083e3c19$export$2105062e25df4afe = /*#__PURE__*/ $818e82e2083e3c19$export$2b53f90d2bd1cbfb();

});


parcelRegister("dNIRY", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("9sDDw")).unstable_batchedUpdates; });
/* eslint-disable import/no-unresolved */ 
var $9sDDw = parcelRequire("9sDDw");

});


parcelRegister("4Jbg8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3714193fba596db0$var$ReactIs, $3714193fba596db0$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("1Q3Bo"))();

});
parcelRegister("1Q3Bo", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $lEcEZ = parcelRequire("lEcEZ");
function $156d7114b4848849$var$emptyFunction() {}
function $156d7114b4848849$var$emptyFunctionWithReset() {}
$156d7114b4848849$var$emptyFunctionWithReset.resetWarningCache = $156d7114b4848849$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lEcEZ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $156d7114b4848849$var$emptyFunctionWithReset,
        resetWarningCache: $156d7114b4848849$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lEcEZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $fc27276d8eb52251$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $fc27276d8eb52251$var$ReactPropTypesSecret;

});



parcelRegister("hRjpy", function(module, exports) {

var $cUoe3 = parcelRequire("cUoe3");

var $eO1Mw = parcelRequire("eO1Mw");
/**
 * This method is like `_.set` except that accepts `updater` to produce the
 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
 * is invoked with one argument: (value).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
 * console.log(object.a[0].b.c);
 * // => 9
 *
 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
 * console.log(object.x[0].y.z);
 * // => 0
 */ function $d0067193f8dd757d$var$update(object, path, updater) {
    return object == null ? object : $cUoe3(object, path, $eO1Mw(updater));
}
module.exports = $d0067193f8dd757d$var$update;

});
parcelRegister("cUoe3", function(module, exports) {

var $kVyVU = parcelRequire("kVyVU");

var $g7tjp = parcelRequire("g7tjp");
/**
 * The base implementation of `_.update`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to update.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $965d81b4aafc1484$var$baseUpdate(object, path, updater, customizer) {
    return $g7tjp(object, path, updater($kVyVU(object, path)), customizer);
}
module.exports = $965d81b4aafc1484$var$baseUpdate;

});
parcelRegister("kVyVU", function(module, exports) {

var $hMUIl = parcelRequire("hMUIl");

var $fMmVj = parcelRequire("fMmVj");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $f3c43a82d178be2d$var$baseGet(object, path) {
    path = $hMUIl(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$fMmVj(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $f3c43a82d178be2d$var$baseGet;

});
parcelRegister("hMUIl", function(module, exports) {

var $eDRhj = parcelRequire("eDRhj");

var $h5FL5 = parcelRequire("h5FL5");

var $9OS4o = parcelRequire("9OS4o");

var $3zxVF = parcelRequire("3zxVF");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $cf32e99ae4b1c72e$var$castPath(value, object) {
    if ($eDRhj(value)) return value;
    return $h5FL5(value, object) ? [
        value
    ] : $9OS4o($3zxVF(value));
}
module.exports = $cf32e99ae4b1c72e$var$castPath;

});
parcelRegister("eDRhj", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $aa8e092628e6caaf$var$isArray = Array.isArray;
module.exports = $aa8e092628e6caaf$var$isArray;

});

parcelRegister("h5FL5", function(module, exports) {

var $eDRhj = parcelRequire("eDRhj");

var $ejqIN = parcelRequire("ejqIN");
/** Used to match property names within property paths. */ var $c7134ba4baf8e95c$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $c7134ba4baf8e95c$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $c7134ba4baf8e95c$var$isKey(value, object) {
    if ($eDRhj(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $ejqIN(value)) return true;
    return $c7134ba4baf8e95c$var$reIsPlainProp.test(value) || !$c7134ba4baf8e95c$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $c7134ba4baf8e95c$var$isKey;

});
parcelRegister("ejqIN", function(module, exports) {

var $hyuxh = parcelRequire("hyuxh");

var $cLyAa = parcelRequire("cLyAa");
/** `Object#toString` result references. */ var $a6b7915d6f9801ba$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $a6b7915d6f9801ba$var$isSymbol(value) {
    return typeof value == "symbol" || $cLyAa(value) && $hyuxh(value) == $a6b7915d6f9801ba$var$symbolTag;
}
module.exports = $a6b7915d6f9801ba$var$isSymbol;

});
parcelRegister("hyuxh", function(module, exports) {

var $7MX8u = parcelRequire("7MX8u");

var $jLmri = parcelRequire("jLmri");

var $iF3fm = parcelRequire("iF3fm");
/** `Object#toString` result references. */ var $cc7d4c64f2700052$var$nullTag = "[object Null]", $cc7d4c64f2700052$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $cc7d4c64f2700052$var$symToStringTag = $7MX8u ? $7MX8u.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $cc7d4c64f2700052$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $cc7d4c64f2700052$var$undefinedTag : $cc7d4c64f2700052$var$nullTag;
    return $cc7d4c64f2700052$var$symToStringTag && $cc7d4c64f2700052$var$symToStringTag in Object(value) ? $jLmri(value) : $iF3fm(value);
}
module.exports = $cc7d4c64f2700052$var$baseGetTag;

});
parcelRegister("7MX8u", function(module, exports) {

var $9svsg = parcelRequire("9svsg");
/** Built-in value references. */ var $5abae33dcc9165e4$var$Symbol = $9svsg.Symbol;
module.exports = $5abae33dcc9165e4$var$Symbol;

});
parcelRegister("9svsg", function(module, exports) {

var $bohmc = parcelRequire("bohmc");
/** Detect free variable `self`. */ var $6e2f20de85a5fbe5$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $6e2f20de85a5fbe5$var$root = $bohmc || $6e2f20de85a5fbe5$var$freeSelf || Function("return this")();
module.exports = $6e2f20de85a5fbe5$var$root;

});
parcelRegister("bohmc", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $84af665a35b63999$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $84af665a35b63999$var$freeGlobal;

});



parcelRegister("jLmri", function(module, exports) {

var $7MX8u = parcelRequire("7MX8u");
/** Used for built-in method references. */ var $e633d0193f150894$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e633d0193f150894$var$hasOwnProperty = $e633d0193f150894$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e633d0193f150894$var$nativeObjectToString = $e633d0193f150894$var$objectProto.toString;
/** Built-in value references. */ var $e633d0193f150894$var$symToStringTag = $7MX8u ? $7MX8u.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e633d0193f150894$var$getRawTag(value) {
    var isOwn = $e633d0193f150894$var$hasOwnProperty.call(value, $e633d0193f150894$var$symToStringTag), tag = value[$e633d0193f150894$var$symToStringTag];
    try {
        value[$e633d0193f150894$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e633d0193f150894$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e633d0193f150894$var$symToStringTag] = tag;
        else delete value[$e633d0193f150894$var$symToStringTag];
    }
    return result;
}
module.exports = $e633d0193f150894$var$getRawTag;

});

parcelRegister("iF3fm", function(module, exports) {
/** Used for built-in method references. */ var $d95e930e8b9a4680$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d95e930e8b9a4680$var$nativeObjectToString = $d95e930e8b9a4680$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $d95e930e8b9a4680$var$objectToString(value) {
    return $d95e930e8b9a4680$var$nativeObjectToString.call(value);
}
module.exports = $d95e930e8b9a4680$var$objectToString;

});


parcelRegister("cLyAa", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $94b4b326a29c307b$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $94b4b326a29c307b$var$isObjectLike;

});



parcelRegister("9OS4o", function(module, exports) {

var $blhGw = parcelRequire("blhGw");
/** Used to match property names within property paths. */ var $7262b9bb792d54da$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $7262b9bb792d54da$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $7262b9bb792d54da$var$stringToPath = $blhGw(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($7262b9bb792d54da$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($7262b9bb792d54da$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $7262b9bb792d54da$var$stringToPath;

});
parcelRegister("blhGw", function(module, exports) {

var $e8SF3 = parcelRequire("e8SF3");
/** Used as the maximum memoize cache size. */ var $841f5fbb8e9d26a4$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $841f5fbb8e9d26a4$var$memoizeCapped(func) {
    var result = $e8SF3(func, function(key) {
        if (cache.size === $841f5fbb8e9d26a4$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $841f5fbb8e9d26a4$var$memoizeCapped;

});
parcelRegister("e8SF3", function(module, exports) {

var $a2RYt = parcelRequire("a2RYt");
/** Error message constants. */ var $a4bc3699a5076ba9$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $a4bc3699a5076ba9$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($a4bc3699a5076ba9$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($a4bc3699a5076ba9$var$memoize.Cache || $a2RYt);
    return memoized;
}
// Expose `MapCache`.
$a4bc3699a5076ba9$var$memoize.Cache = $a2RYt;
module.exports = $a4bc3699a5076ba9$var$memoize;

});
parcelRegister("a2RYt", function(module, exports) {

var $8EG7J = parcelRequire("8EG7J");

var $hudNO = parcelRequire("hudNO");

var $1hHsA = parcelRequire("1hHsA");

var $bbHy4 = parcelRequire("bbHy4");

var $7N5Ra = parcelRequire("7N5Ra");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7503f573258301a7$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$7503f573258301a7$var$MapCache.prototype.clear = $8EG7J;
$7503f573258301a7$var$MapCache.prototype["delete"] = $hudNO;
$7503f573258301a7$var$MapCache.prototype.get = $1hHsA;
$7503f573258301a7$var$MapCache.prototype.has = $bbHy4;
$7503f573258301a7$var$MapCache.prototype.set = $7N5Ra;
module.exports = $7503f573258301a7$var$MapCache;

});
parcelRegister("8EG7J", function(module, exports) {

var $6qpfd = parcelRequire("6qpfd");

var $2aKFf = parcelRequire("2aKFf");

var $iPcKP = parcelRequire("iPcKP");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $64d2bc098aeb8a29$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $6qpfd,
        "map": new ($iPcKP || $2aKFf),
        "string": new $6qpfd
    };
}
module.exports = $64d2bc098aeb8a29$var$mapCacheClear;

});
parcelRegister("6qpfd", function(module, exports) {

var $2oS48 = parcelRequire("2oS48");

var $jL8M6 = parcelRequire("jL8M6");

var $jnOOv = parcelRequire("jnOOv");

var $cu4G1 = parcelRequire("cu4G1");

var $7Ugmo = parcelRequire("7Ugmo");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4ad8c0cc39e3ba6f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$4ad8c0cc39e3ba6f$var$Hash.prototype.clear = $2oS48;
$4ad8c0cc39e3ba6f$var$Hash.prototype["delete"] = $jL8M6;
$4ad8c0cc39e3ba6f$var$Hash.prototype.get = $jnOOv;
$4ad8c0cc39e3ba6f$var$Hash.prototype.has = $cu4G1;
$4ad8c0cc39e3ba6f$var$Hash.prototype.set = $7Ugmo;
module.exports = $4ad8c0cc39e3ba6f$var$Hash;

});
parcelRegister("2oS48", function(module, exports) {

var $cNGcb = parcelRequire("cNGcb");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $1bf7c2f4fd256c0f$var$hashClear() {
    this.__data__ = $cNGcb ? $cNGcb(null) : {};
    this.size = 0;
}
module.exports = $1bf7c2f4fd256c0f$var$hashClear;

});
parcelRegister("cNGcb", function(module, exports) {

var $6s8gY = parcelRequire("6s8gY");
/* Built-in method references that are verified to be native. */ var $951acacb00419a0f$var$nativeCreate = $6s8gY(Object, "create");
module.exports = $951acacb00419a0f$var$nativeCreate;

});
parcelRegister("6s8gY", function(module, exports) {

var $gWhVf = parcelRequire("gWhVf");

var $67kOe = parcelRequire("67kOe");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $4b2bc66165ad142f$var$getNative(object, key) {
    var value = $67kOe(object, key);
    return $gWhVf(value) ? value : undefined;
}
module.exports = $4b2bc66165ad142f$var$getNative;

});
parcelRegister("gWhVf", function(module, exports) {

var $4n8SM = parcelRequire("4n8SM");

var $dljB7 = parcelRequire("dljB7");

var $6Sqac = parcelRequire("6Sqac");

var $4LE2g = parcelRequire("4LE2g");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $c54ff72523496615$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $c54ff72523496615$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $c54ff72523496615$var$funcProto = Function.prototype, $c54ff72523496615$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c54ff72523496615$var$funcToString = $c54ff72523496615$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c54ff72523496615$var$hasOwnProperty = $c54ff72523496615$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $c54ff72523496615$var$reIsNative = RegExp("^" + $c54ff72523496615$var$funcToString.call($c54ff72523496615$var$hasOwnProperty).replace($c54ff72523496615$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $c54ff72523496615$var$baseIsNative(value) {
    if (!$6Sqac(value) || $dljB7(value)) return false;
    var pattern = $4n8SM(value) ? $c54ff72523496615$var$reIsNative : $c54ff72523496615$var$reIsHostCtor;
    return pattern.test($4LE2g(value));
}
module.exports = $c54ff72523496615$var$baseIsNative;

});
parcelRegister("4n8SM", function(module, exports) {

var $hyuxh = parcelRequire("hyuxh");

var $6Sqac = parcelRequire("6Sqac");
/** `Object#toString` result references. */ var $32f03345b886d057$var$asyncTag = "[object AsyncFunction]", $32f03345b886d057$var$funcTag = "[object Function]", $32f03345b886d057$var$genTag = "[object GeneratorFunction]", $32f03345b886d057$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $32f03345b886d057$var$isFunction(value) {
    if (!$6Sqac(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $hyuxh(value);
    return tag == $32f03345b886d057$var$funcTag || tag == $32f03345b886d057$var$genTag || tag == $32f03345b886d057$var$asyncTag || tag == $32f03345b886d057$var$proxyTag;
}
module.exports = $32f03345b886d057$var$isFunction;

});
parcelRegister("6Sqac", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $501c14bf00bcd19e$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $501c14bf00bcd19e$var$isObject;

});


parcelRegister("dljB7", function(module, exports) {

var $1VUh5 = parcelRequire("1VUh5");
/** Used to detect methods masquerading as native. */ var $9b6c703cdf2ce129$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($1VUh5 && $1VUh5.keys && $1VUh5.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $9b6c703cdf2ce129$var$isMasked(func) {
    return !!$9b6c703cdf2ce129$var$maskSrcKey && $9b6c703cdf2ce129$var$maskSrcKey in func;
}
module.exports = $9b6c703cdf2ce129$var$isMasked;

});
parcelRegister("1VUh5", function(module, exports) {

var $9svsg = parcelRequire("9svsg");
/** Used to detect overreaching core-js shims. */ var $1686c44a160f4158$var$coreJsData = $9svsg["__core-js_shared__"];
module.exports = $1686c44a160f4158$var$coreJsData;

});


parcelRegister("4LE2g", function(module, exports) {
/** Used for built-in method references. */ var $378a9b6edc912a7a$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $378a9b6edc912a7a$var$funcToString = $378a9b6edc912a7a$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $378a9b6edc912a7a$var$toSource(func) {
    if (func != null) {
        try {
            return $378a9b6edc912a7a$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $378a9b6edc912a7a$var$toSource;

});


parcelRegister("67kOe", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $474389c5f7bdfd82$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $474389c5f7bdfd82$var$getValue;

});




parcelRegister("jL8M6", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e629369ff235adf0$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $e629369ff235adf0$var$hashDelete;

});

parcelRegister("jnOOv", function(module, exports) {

var $cNGcb = parcelRequire("cNGcb");
/** Used to stand-in for `undefined` hash values. */ var $e1c794d8d280b14f$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $e1c794d8d280b14f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e1c794d8d280b14f$var$hasOwnProperty = $e1c794d8d280b14f$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e1c794d8d280b14f$var$hashGet(key) {
    var data = this.__data__;
    if ($cNGcb) {
        var result = data[key];
        return result === $e1c794d8d280b14f$var$HASH_UNDEFINED ? undefined : result;
    }
    return $e1c794d8d280b14f$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $e1c794d8d280b14f$var$hashGet;

});

parcelRegister("cu4G1", function(module, exports) {

var $cNGcb = parcelRequire("cNGcb");
/** Used for built-in method references. */ var $916bea18b01b6b41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $916bea18b01b6b41$var$hasOwnProperty = $916bea18b01b6b41$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $916bea18b01b6b41$var$hashHas(key) {
    var data = this.__data__;
    return $cNGcb ? data[key] !== undefined : $916bea18b01b6b41$var$hasOwnProperty.call(data, key);
}
module.exports = $916bea18b01b6b41$var$hashHas;

});

parcelRegister("7Ugmo", function(module, exports) {

var $cNGcb = parcelRequire("cNGcb");
/** Used to stand-in for `undefined` hash values. */ var $5c1a74297a56711e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $5c1a74297a56711e$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $cNGcb && value === undefined ? $5c1a74297a56711e$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $5c1a74297a56711e$var$hashSet;

});


parcelRegister("2aKFf", function(module, exports) {

var $bHJAF = parcelRequire("bHJAF");

var $eMfa5 = parcelRequire("eMfa5");

var $gffsA = parcelRequire("gffsA");

var $4JQLW = parcelRequire("4JQLW");

var $8dAFB = parcelRequire("8dAFB");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1950b67ab9ee430d$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$1950b67ab9ee430d$var$ListCache.prototype.clear = $bHJAF;
$1950b67ab9ee430d$var$ListCache.prototype["delete"] = $eMfa5;
$1950b67ab9ee430d$var$ListCache.prototype.get = $gffsA;
$1950b67ab9ee430d$var$ListCache.prototype.has = $4JQLW;
$1950b67ab9ee430d$var$ListCache.prototype.set = $8dAFB;
module.exports = $1950b67ab9ee430d$var$ListCache;

});
parcelRegister("bHJAF", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $88571328561b869e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $88571328561b869e$var$listCacheClear;

});

parcelRegister("eMfa5", function(module, exports) {

var $e088M = parcelRequire("e088M");
/** Used for built-in method references. */ var $ac214f284cd39929$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ac214f284cd39929$var$splice = $ac214f284cd39929$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ac214f284cd39929$var$listCacheDelete(key) {
    var data = this.__data__, index = $e088M(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ac214f284cd39929$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $ac214f284cd39929$var$listCacheDelete;

});
parcelRegister("e088M", function(module, exports) {

var $54juc = parcelRequire("54juc");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a3176156719c8cf2$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($54juc(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $a3176156719c8cf2$var$assocIndexOf;

});
parcelRegister("54juc", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $3b0c710074d087d3$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $3b0c710074d087d3$var$eq;

});



parcelRegister("gffsA", function(module, exports) {

var $e088M = parcelRequire("e088M");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $bd3a0a1ee286980f$var$listCacheGet(key) {
    var data = this.__data__, index = $e088M(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $bd3a0a1ee286980f$var$listCacheGet;

});

parcelRegister("4JQLW", function(module, exports) {

var $e088M = parcelRequire("e088M");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $37344ce2ce5daa98$var$listCacheHas(key) {
    return $e088M(this.__data__, key) > -1;
}
module.exports = $37344ce2ce5daa98$var$listCacheHas;

});

parcelRegister("8dAFB", function(module, exports) {

var $e088M = parcelRequire("e088M");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $5fbbfb89fd5aca33$var$listCacheSet(key, value) {
    var data = this.__data__, index = $e088M(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $5fbbfb89fd5aca33$var$listCacheSet;

});


parcelRegister("iPcKP", function(module, exports) {

var $6s8gY = parcelRequire("6s8gY");

var $9svsg = parcelRequire("9svsg");
/* Built-in method references that are verified to be native. */ var $db46e22917e7b543$var$Map = $6s8gY($9svsg, "Map");
module.exports = $db46e22917e7b543$var$Map;

});


parcelRegister("hudNO", function(module, exports) {

var $5m2Os = parcelRequire("5m2Os");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $cbaff1dc86d45242$var$mapCacheDelete(key) {
    var result = $5m2Os(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $cbaff1dc86d45242$var$mapCacheDelete;

});
parcelRegister("5m2Os", function(module, exports) {

var $g6xQ1 = parcelRequire("g6xQ1");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $3e61306b2c2e29a3$var$getMapData(map, key) {
    var data = map.__data__;
    return $g6xQ1(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $3e61306b2c2e29a3$var$getMapData;

});
parcelRegister("g6xQ1", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $bb977464aacb4436$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $bb977464aacb4436$var$isKeyable;

});



parcelRegister("1hHsA", function(module, exports) {

var $5m2Os = parcelRequire("5m2Os");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ef917411d2d8701$var$mapCacheGet(key) {
    return $5m2Os(this, key).get(key);
}
module.exports = $0ef917411d2d8701$var$mapCacheGet;

});

parcelRegister("bbHy4", function(module, exports) {

var $5m2Os = parcelRequire("5m2Os");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $82528098e3b7386c$var$mapCacheHas(key) {
    return $5m2Os(this, key).has(key);
}
module.exports = $82528098e3b7386c$var$mapCacheHas;

});

parcelRegister("7N5Ra", function(module, exports) {

var $5m2Os = parcelRequire("5m2Os");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $5ac1a6f9289a45d2$var$mapCacheSet(key, value) {
    var data = $5m2Os(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $5ac1a6f9289a45d2$var$mapCacheSet;

});





parcelRegister("3zxVF", function(module, exports) {

var $iVgxB = parcelRequire("iVgxB");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $299ef59705b32942$var$toString(value) {
    return value == null ? "" : $iVgxB(value);
}
module.exports = $299ef59705b32942$var$toString;

});
parcelRegister("iVgxB", function(module, exports) {

var $7MX8u = parcelRequire("7MX8u");

var $2CmH3 = parcelRequire("2CmH3");

var $eDRhj = parcelRequire("eDRhj");

var $ejqIN = parcelRequire("ejqIN");
/** Used as references for various `Number` constants. */ var $dc6a618c0046ad3f$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $dc6a618c0046ad3f$var$symbolProto = $7MX8u ? $7MX8u.prototype : undefined, $dc6a618c0046ad3f$var$symbolToString = $dc6a618c0046ad3f$var$symbolProto ? $dc6a618c0046ad3f$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $dc6a618c0046ad3f$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($eDRhj(value)) // Recursively convert values (susceptible to call stack limits).
    return $2CmH3(value, $dc6a618c0046ad3f$var$baseToString) + "";
    if ($ejqIN(value)) return $dc6a618c0046ad3f$var$symbolToString ? $dc6a618c0046ad3f$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$dc6a618c0046ad3f$var$INFINITY ? "-0" : result;
}
module.exports = $dc6a618c0046ad3f$var$baseToString;

});
parcelRegister("2CmH3", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $1e80bbcc5c9e7845$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $1e80bbcc5c9e7845$var$arrayMap;

});




parcelRegister("fMmVj", function(module, exports) {

var $ejqIN = parcelRequire("ejqIN");
/** Used as references for various `Number` constants. */ var $b7cd1ecf1cbfa01d$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $b7cd1ecf1cbfa01d$var$toKey(value) {
    if (typeof value == "string" || $ejqIN(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$b7cd1ecf1cbfa01d$var$INFINITY ? "-0" : result;
}
module.exports = $b7cd1ecf1cbfa01d$var$toKey;

});


parcelRegister("g7tjp", function(module, exports) {

var $3IABh = parcelRequire("3IABh");

var $hMUIl = parcelRequire("hMUIl");

var $ez2hV = parcelRequire("ez2hV");

var $6Sqac = parcelRequire("6Sqac");

var $fMmVj = parcelRequire("fMmVj");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $bbc40992ad817375$var$baseSet(object, path, value, customizer) {
    if (!$6Sqac(object)) return object;
    path = $hMUIl(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $fMmVj(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $6Sqac(objValue) ? objValue : $ez2hV(path[index + 1]) ? [] : {};
        }
        $3IABh(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $bbc40992ad817375$var$baseSet;

});
parcelRegister("3IABh", function(module, exports) {

var $hI9C8 = parcelRequire("hI9C8");

var $54juc = parcelRequire("54juc");
/** Used for built-in method references. */ var $2b51df330cd34983$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2b51df330cd34983$var$hasOwnProperty = $2b51df330cd34983$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $2b51df330cd34983$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($2b51df330cd34983$var$hasOwnProperty.call(object, key) && $54juc(objValue, value)) || value === undefined && !(key in object)) $hI9C8(object, key, value);
}
module.exports = $2b51df330cd34983$var$assignValue;

});
parcelRegister("hI9C8", function(module, exports) {

var $63tyq = parcelRequire("63tyq");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $ce4e00e58899ad4d$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $63tyq) $63tyq(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $ce4e00e58899ad4d$var$baseAssignValue;

});
parcelRegister("63tyq", function(module, exports) {

var $6s8gY = parcelRequire("6s8gY");
var $4689f2baf8033c8d$var$defineProperty = function() {
    try {
        var func = $6s8gY(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $4689f2baf8033c8d$var$defineProperty;

});



parcelRegister("ez2hV", function(module, exports) {
/** Used as references for various `Number` constants. */ var $a9a61bf7249d058a$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a9a61bf7249d058a$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a9a61bf7249d058a$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a9a61bf7249d058a$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $a9a61bf7249d058a$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $a9a61bf7249d058a$var$isIndex;

});



parcelRegister("eO1Mw", function(module, exports) {

var $l0EzR = parcelRequire("l0EzR");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $ac771dfde889df9f$var$castFunction(value) {
    return typeof value == "function" ? value : $l0EzR;
}
module.exports = $ac771dfde889df9f$var$castFunction;

});
parcelRegister("l0EzR", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $f4b912e117dfb81c$var$identity(value) {
    return value;
}
module.exports = $f4b912e117dfb81c$var$identity;

});



parcelRegister("eBGBV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa259302c7a82e6b$export$2e2bcd8739ae039; });

var $5RBw5 = parcelRequire("5RBw5");

var $caSXf = parcelRequire("caSXf");

var $cYLc6 = parcelRequire("cYLc6");

var $jI1lG = parcelRequire("jI1lG");

var $b7mwt = parcelRequire("b7mwt");

var $eDSSt = parcelRequire("eDSSt");

var $cB14h = parcelRequire("cB14h");

var $oozTF = parcelRequire("oozTF");

var $6VRNb = parcelRequire("6VRNb");
var $aa259302c7a82e6b$var$map = {
    annotations: (0, $caSXf.default),
    attribution: (0, $b7mwt.default),
    canvas: (0, $jI1lG.default),
    collection: (0, $6VRNb.default),
    custom: (0, $oozTF.default),
    info: (0, $cYLc6.default),
    layers: (0, $cB14h.default),
    search: (0, $eDSSt.default),
    thumbnailNavigation: (0, $5RBw5.default)
};
var $aa259302c7a82e6b$export$2e2bcd8739ae039 = $aa259302c7a82e6b$var$map;

});
parcelRegister("5RBw5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $444f00f7bfa9aa66$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $in9CU = parcelRequire("in9CU");

var $9OZfp = parcelRequire("9OZfp");

var $1MgBx = parcelRequire("1MgBx");
var $51Gx5 = parcelRequire("51Gx5");
var $24Kso = parcelRequire("24Kso");
var $jGts0 = parcelRequire("jGts0");
var $dy9HC = parcelRequire("dy9HC");
var $9E7MS = parcelRequire("9E7MS");
/**
 * mapStateToProps - used to hook up state to props
 * @memberof ThumbnailNavigation
 * @private
 */ var $444f00f7bfa9aa66$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var windowId = _ref.windowId;
    return {
        canvasGroupings: (0, $1MgBx.getCanvasGroupings)(state, {
            windowId: windowId
        }),
        canvasIndex: (0, $51Gx5.getCanvasIndex)(state, {
            windowId: windowId
        }),
        hasNextCanvas: !!(0, $1MgBx.getNextCanvasGrouping)(state, {
            windowId: windowId
        }),
        hasPreviousCanvas: !!(0, $1MgBx.getPreviousCanvasGrouping)(state, {
            windowId: windowId
        }),
        position: (0, $24Kso.getCompanionWindow)(state, {
            companionWindowId: (0, $dy9HC.getWindow)(state, {
                windowId: windowId
            }).thumbnailNavigationId
        }).position,
        thumbnailNavigation: (0, $jGts0.getConfig)(state).thumbnailNavigation,
        view: (0, $9E7MS.getWindowViewType)(state, {
            windowId: windowId
        }),
        viewingDirection: (0, $51Gx5.getSequenceViewingDirection)(state, {
            windowId: windowId
        })
    };
};
/**
 * mapDispatchToProps - used to hook up connect to action creators
 * @memberof ThumbnailNavigation
 * @private
 */ var $444f00f7bfa9aa66$var$mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
    var windowId = _ref2.windowId;
    return {
        setNextCanvas: function setNextCanvas() {
            return dispatch($in9CU.setNextCanvas(windowId));
        },
        setPreviousCanvas: function setPreviousCanvas() {
            return dispatch($in9CU.setPreviousCanvas(windowId));
        }
    };
};
/**
 * Styles for withStyles HOC
 */ var $444f00f7bfa9aa66$var$styles = function styles(theme) {
    return {
        thumbNavigation: {
            "&:focus": {
                boxShadow: 0,
                outline: 0
            }
        }
    };
};
var $444f00f7bfa9aa66$var$enhance = (0, $k19ic.compose)((0, $7EzGR.default)($444f00f7bfa9aa66$var$styles), (0, $eC0Mc.withTranslation)(), (0, $fbonu.default)($444f00f7bfa9aa66$var$mapStateToProps, $444f00f7bfa9aa66$var$mapDispatchToProps), (0, $7XHRd.withPlugins)("ThumbnailNavigation"));
var $444f00f7bfa9aa66$export$2e2bcd8739ae039 = $444f00f7bfa9aa66$var$enhance((0, $9OZfp.ThumbnailNavigation));

});
parcelRegister("k19ic", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $e92b1bf49b89bf6c$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $e92b1bf49b89bf6c$export$66e4520cdb265d18; });
$parcel$export(module.exports, "bindActionCreators", function () { return $e92b1bf49b89bf6c$export$aea084d96e84da92; });
$parcel$export(module.exports, "compose", function () { return $e92b1bf49b89bf6c$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $e92b1bf49b89bf6c$export$9ff26e0402cc7b7; });

var $2IpAt = parcelRequire("2IpAt");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $e92b1bf49b89bf6c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $e92b1bf49b89bf6c$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $e92b1bf49b89bf6c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $e92b1bf49b89bf6c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $e92b1bf49b89bf6c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $e92b1bf49b89bf6c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $e92b1bf49b89bf6c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $e92b1bf49b89bf6c$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $e92b1bf49b89bf6c$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($e92b1bf49b89bf6c$var$isDate(val)) return "date";
    if ($e92b1bf49b89bf6c$var$isError(val)) return "error";
    var constructorName = $e92b1bf49b89bf6c$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $e92b1bf49b89bf6c$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $e92b1bf49b89bf6c$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $e92b1bf49b89bf6c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $e92b1bf49b89bf6c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $e92b1bf49b89bf6c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(1));
        return enhancer($e92b1bf49b89bf6c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$e92b1bf49b89bf6c$var$isPlainObject(action)) throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $e92b1bf49b89bf6c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$e92b1bf49b89bf6c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $e92b1bf49b89bf6c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$e92b1bf49b89bf6c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $e92b1bf49b89bf6c$export$8928921ea2d3b126 = $e92b1bf49b89bf6c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $e92b1bf49b89bf6c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $e92b1bf49b89bf6c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $e92b1bf49b89bf6c$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$e92b1bf49b89bf6c$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $e92b1bf49b89bf6c$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $e92b1bf49b89bf6c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $e92b1bf49b89bf6c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $e92b1bf49b89bf6c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $e92b1bf49b89bf6c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $e92b1bf49b89bf6c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $e92b1bf49b89bf6c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $e92b1bf49b89bf6c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $e92b1bf49b89bf6c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $e92b1bf49b89bf6c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $e92b1bf49b89bf6c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $e92b1bf49b89bf6c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $e92b1bf49b89bf6c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($e92b1bf49b89bf6c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $e92b1bf49b89bf6c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $2IpAt.default)((0, $2IpAt.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("2IpAt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fa389edfb4e43d2$export$2e2bcd8739ae039; });

var $4g0WD = parcelRequire("4g0WD");
function $1fa389edfb4e43d2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fa389edfb4e43d2$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fa389edfb4e43d2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4g0WD.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fa389edfb4e43d2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("4g0WD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $319963a2c1581882$export$2e2bcd8739ae039; });

var $dp6tu = parcelRequire("dp6tu");
function $319963a2c1581882$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $dp6tu.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRegister("dp6tu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c22a1df8591f3d7$export$2e2bcd8739ae039; });

var $7Dbhg = parcelRequire("7Dbhg");

var $kKs6H = parcelRequire("kKs6H");
function $9c22a1df8591f3d7$export$2e2bcd8739ae039(t) {
    var i = (0, $kKs6H.default)(t, "string");
    return "symbol" == (0, $7Dbhg.default)(i) ? i : i + "";
}

});
parcelRegister("7Dbhg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58e4ec5d340e8f56$export$2e2bcd8739ae039; });
function $58e4ec5d340e8f56$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $58e4ec5d340e8f56$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $58e4ec5d340e8f56$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kKs6H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1ade8009a297e8c$export$2e2bcd8739ae039; });

var $7Dbhg = parcelRequire("7Dbhg");
function $f1ade8009a297e8c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $7Dbhg.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $7Dbhg.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("eC0Mc", function(module, exports) {

$parcel$export(module.exports, "withTranslation", function () { return $aa3537774b4bd90d$export$2dcb0053efd21124; });

var $5TZlQ = parcelRequire("5TZlQ");

var $79VTo = parcelRequire("79VTo");

var $gpjWH = parcelRequire("gpjWH");

var $arQ7u = parcelRequire("arQ7u");

var $3EyuQ = parcelRequire("3EyuQ");

var $2oPJy = parcelRequire("2oPJy");
var $aa3537774b4bd90d$var$_excluded = [
    "forwardedRef"
];
function $aa3537774b4bd90d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aa3537774b4bd90d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aa3537774b4bd90d$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5TZlQ)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aa3537774b4bd90d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aa3537774b4bd90d$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gpjWH)))(_ref, $aa3537774b4bd90d$var$_excluded);
            var _useTranslation = (0, $3EyuQ.useTranslation)(ns, $aa3537774b4bd90d$var$_objectSpread($aa3537774b4bd90d$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, (/*@__PURE__*/$parcel$interopDefault($79VTo)))(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $aa3537774b4bd90d$var$_objectSpread($aa3537774b4bd90d$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $arQ7u.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $2oPJy.getDisplayName)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $arQ7u.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $arQ7u.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}

});
parcelRegister("5TZlQ", function(module, exports) {

var $bideR = parcelRequire("bideR");
function $44c1aded27966d0f$var$_defineProperty(obj, key, value) {
    key = $bideR(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $44c1aded27966d0f$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bideR", function(module, exports) {

var $difjz = parcelRequire("difjz");
var $838ba50e2fe4998b$var$_typeof = $difjz.default;

var $4jnBY = parcelRequire("4jnBY");
function $838ba50e2fe4998b$var$toPropertyKey(t) {
    var i = $4jnBY(t, "string");
    return "symbol" == $838ba50e2fe4998b$var$_typeof(i) ? i : i + "";
}
module.exports = $838ba50e2fe4998b$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("difjz", function(module, exports) {
function $9ad8d5f3cc9fddb7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $9ad8d5f3cc9fddb7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9ad8d5f3cc9fddb7$var$_typeof(o);
}
module.exports = $9ad8d5f3cc9fddb7$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4jnBY", function(module, exports) {

var $difjz = parcelRequire("difjz");
var $323b408b56ed6b6a$var$_typeof = $difjz.default;
function $323b408b56ed6b6a$var$toPrimitive(t, r) {
    if ("object" != $323b408b56ed6b6a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $323b408b56ed6b6a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $323b408b56ed6b6a$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("79VTo", function(module, exports) {

var $knsW1 = parcelRequire("knsW1");

var $kFmRa = parcelRequire("kFmRa");

var $deGng = parcelRequire("deGng");

var $4w7N8 = parcelRequire("4w7N8");
function $536647e8a4e22f90$var$_slicedToArray(arr, i) {
    return $knsW1(arr) || $kFmRa(arr, i) || $deGng(arr, i) || $4w7N8();
}
module.exports = $536647e8a4e22f90$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("knsW1", function(module, exports) {
function $ed5c667e0bc3a532$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = $ed5c667e0bc3a532$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kFmRa", function(module, exports) {
function $f0b95dcd0b7a668d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $f0b95dcd0b7a668d$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("deGng", function(module, exports) {

var $h0jDb = parcelRequire("h0jDb");
function $9a2d73c8bd057d29$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $h0jDb(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $h0jDb(o, minLen);
}
module.exports = $9a2d73c8bd057d29$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("h0jDb", function(module, exports) {
function $c611aa133a82eae3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $c611aa133a82eae3$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4w7N8", function(module, exports) {
function $34a031d19a1aa80e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $34a031d19a1aa80e$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gpjWH", function(module, exports) {

var $kRLBD = parcelRequire("kRLBD");
function $bf1e73f8fe0fa75b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $kRLBD(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $bf1e73f8fe0fa75b$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kRLBD", function(module, exports) {
function $f30daf731901bb76$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $f30daf731901bb76$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3EyuQ", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return $2a8fddcd9d3d8c40$export$9fc83ad70ead8663; });

var $79VTo = parcelRequire("79VTo");

var $5TZlQ = parcelRequire("5TZlQ");

var $arQ7u = parcelRequire("arQ7u");

var $8LHwv = parcelRequire("8LHwv");

var $2oPJy = parcelRequire("2oPJy");
function $2a8fddcd9d3d8c40$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2a8fddcd9d3d8c40$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2a8fddcd9d3d8c40$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5TZlQ)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2a8fddcd9d3d8c40$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2a8fddcd9d3d8c40$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $arQ7u.useRef)();
    (0, $arQ7u.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $2a8fddcd9d3d8c40$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $arQ7u.useContext)((0, $8LHwv.I18nContext)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $8LHwv.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $8LHwv.ReportNamespaces)();
    if (!i18n) {
        (0, $2oPJy.warnOnce)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $2oPJy.warnOnce)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $2a8fddcd9d3d8c40$var$_objectSpread($2a8fddcd9d3d8c40$var$_objectSpread($2a8fddcd9d3d8c40$var$_objectSpread({}, (0, $8LHwv.getDefaults)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $2oPJy.hasLoadedNamespace)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $arQ7u.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($79VTo)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $2a8fddcd9d3d8c40$var$usePrevious(joinedNS);
    var isMounted = (0, $arQ7u.useRef)(true);
    (0, $arQ7u.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $2oPJy.loadNamespaces)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $arQ7u.useRef)(true);
    (0, $arQ7u.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $2oPJy.loadNamespaces)(i18n, namespaces, function() {
            resolve();
        });
    });
}

});
parcelRegister("8LHwv", function(module, exports) {

$parcel$export(module.exports, "I18nContext", function () { return $66247954e1d06dbb$export$5603ab5ced17ce64; });
$parcel$export(module.exports, "getDefaults", function () { return $66247954e1d06dbb$export$212bb2fc580a90a8; });
$parcel$export(module.exports, "ReportNamespaces", function () { return $66247954e1d06dbb$export$ea171b67e3820290; });
$parcel$export(module.exports, "getI18n", function () { return $66247954e1d06dbb$export$64af334f494c2f47; });
$parcel$export(module.exports, "initReactI18next", function () { return $66247954e1d06dbb$export$ae7e14d40d89f296; });

var $cbUDA = parcelRequire("cbUDA");

var $cxgyn = parcelRequire("cxgyn");

var $5TZlQ = parcelRequire("5TZlQ");

var $arQ7u = parcelRequire("arQ7u");

var $2H0IZ = parcelRequire("2H0IZ");
function $66247954e1d06dbb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $66247954e1d06dbb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $66247954e1d06dbb$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5TZlQ)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $66247954e1d06dbb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $66247954e1d06dbb$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $2H0IZ.unescape)
};
var $66247954e1d06dbb$var$i18nInstance;
var $66247954e1d06dbb$export$5603ab5ced17ce64 = (0, $arQ7u.createContext)();
function $66247954e1d06dbb$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $66247954e1d06dbb$var$defaultOptions = $66247954e1d06dbb$var$_objectSpread($66247954e1d06dbb$var$_objectSpread({}, $66247954e1d06dbb$var$defaultOptions), options);
}
function $66247954e1d06dbb$export$212bb2fc580a90a8() {
    return $66247954e1d06dbb$var$defaultOptions;
}
var $66247954e1d06dbb$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($cbUDA)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cxgyn)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $66247954e1d06dbb$export$a039134f2fc7e0(instance) {
    $66247954e1d06dbb$var$i18nInstance = instance;
}
function $66247954e1d06dbb$export$64af334f494c2f47() {
    return $66247954e1d06dbb$var$i18nInstance;
}
var $66247954e1d06dbb$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        $66247954e1d06dbb$export$2e2366488d12e20d(instance.options.react);
        $66247954e1d06dbb$export$a039134f2fc7e0(instance);
    }
};
function $66247954e1d06dbb$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $66247954e1d06dbb$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($66247954e1d06dbb$var$_objectSpread($66247954e1d06dbb$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $66247954e1d06dbb$export$704200e5d0b9e8f() {
    var i18n = $66247954e1d06dbb$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

});
parcelRegister("cbUDA", function(module, exports) {
function $8e027229b0fe7a69$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $8e027229b0fe7a69$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cxgyn", function(module, exports) {

var $bideR = parcelRequire("bideR");
function $92056842d5cb89a8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bideR(descriptor.key), descriptor);
    }
}
function $92056842d5cb89a8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $92056842d5cb89a8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $92056842d5cb89a8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $92056842d5cb89a8$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2H0IZ", function(module, exports) {

$parcel$export(module.exports, "unescape", function () { return $1f6028d737d99ea4$export$e8bacd2802a88316; });
var $1f6028d737d99ea4$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $1f6028d737d99ea4$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $1f6028d737d99ea4$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $1f6028d737d99ea4$var$htmlEntities[m];
};
var $1f6028d737d99ea4$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($1f6028d737d99ea4$var$matchHtmlEntity, $1f6028d737d99ea4$var$unescapeHtmlEntity);
};

});


parcelRegister("2oPJy", function(module, exports) {

$parcel$export(module.exports, "warnOnce", function () { return $1bf5f3edd281fb83$export$5b28268982f175ba; });
$parcel$export(module.exports, "loadNamespaces", function () { return $1bf5f3edd281fb83$export$83be934b53fff43b; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $1bf5f3edd281fb83$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "getDisplayName", function () { return $1bf5f3edd281fb83$export$be63e0664592e141; });
function $1bf5f3edd281fb83$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $1bf5f3edd281fb83$var$alreadyWarned = {};
function $1bf5f3edd281fb83$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $1bf5f3edd281fb83$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $1bf5f3edd281fb83$var$alreadyWarned[args[0]] = new Date();
    $1bf5f3edd281fb83$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $1bf5f3edd281fb83$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    });
}
function $1bf5f3edd281fb83$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $1bf5f3edd281fb83$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $1bf5f3edd281fb83$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $1bf5f3edd281fb83$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $1bf5f3edd281fb83$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}

});



parcelRegister("7EzGR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5927f42c1e01f72a$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $hDK8L = parcelRequire("hDK8L");

var $cFFej = parcelRequire("cFFej");
function $5927f42c1e01f72a$var$withStyles(stylesOrCreator, options) {
    return (0, $hDK8L.default)(stylesOrCreator, (0, $abElG.default)({
        defaultTheme: (0, $cFFej.default)
    }, options));
}
var $5927f42c1e01f72a$export$2e2bcd8739ae039 = $5927f42c1e01f72a$var$withStyles;

});
parcelRegister("hDK8L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd79deb107f4dc20$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $2XZwC = parcelRequire("2XZwC");


var $cN9Ce = parcelRequire("cN9Ce");

var $cgNhc = parcelRequire("cgNhc");

var $gkz9m = parcelRequire("gkz9m");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $cd79deb107f4dc20$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $dXEVX.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $cN9Ce.default)(stylesOrCreator, (0, $abElG.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $dXEVX.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $abElG.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === "string" || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $gkz9m.default)() || defaultTheme;
                if (name) more = (0, $cgNhc.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(Component, (0, $abElG.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2XZwC)))(WithStyles, Component);
        return WithStyles;
    };
};
var $cd79deb107f4dc20$export$2e2bcd8739ae039 = $cd79deb107f4dc20$var$withStyles;

});
parcelRegister("dXEVX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2a089ab4dfff22a$export$2e2bcd8739ae039; });

var $fJZol = parcelRequire("fJZol");
function $a2a089ab4dfff22a$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $fJZol.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});

parcelRegister("cN9Ce", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95018520c5014713$export$2e2bcd8739ae039; });

var $dXEVX = parcelRequire("dXEVX");

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");

var $1s5gz = parcelRequire("1s5gz");

var $s3KLs = parcelRequire("s3KLs");

var $29DQz = parcelRequire("29DQz");

var $gkz9m = parcelRequire("gkz9m");

var $6OzM9 = parcelRequire("6OzM9");

var $40YHw = parcelRequire("40YHw");

var $luB5R = parcelRequire("luB5R");

var $21Jjg = parcelRequire("21Jjg");
function $95018520c5014713$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $s3KLs.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $95018520c5014713$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $29DQz.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $29DQz.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $abElG.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $29DQz.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $abElG.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $29DQz.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $1s5gz.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $abElG.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $s3KLs.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $95018520c5014713$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $95018520c5014713$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $29DQz.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $29DQz.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $95018520c5014713$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $95018520c5014713$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $21Jjg.default) : _options$defaultTheme, stylesOptions2 = (0, $dXEVX.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $luB5R.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $40YHw.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $gkz9m.default)() || defaultTheme;
        var stylesOptions = (0, $abElG.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).useContext((0, $6OzM9.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).useRef();
        $95018520c5014713$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $95018520c5014713$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $95018520c5014713$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).useEffect(function() {
            if (shouldUpdate.current) $95018520c5014713$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $95018520c5014713$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("1s5gz", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $abElG = parcelRequire("abElG");

var $29wg8 = parcelRequire("29wg8");

var $cnLXI = parcelRequire("cnLXI");

var $b6hTo = parcelRequire("b6hTo");

var $arruZ = parcelRequire("arruZ");

var $7qIdT = parcelRequire("7qIdT");

var $fJZol = parcelRequire("fJZol");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += join(value[i], " ");
    }
    else cssValue = join(value, ", "); // Add !important, because it was ignored.
    if (value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr("}", indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, "\\$1");
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $arruZ.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $7qIdT.default)((0, $7qIdT.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $abElG.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $b6hTo.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $abElG.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $abElG.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $abElG.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $arruZ.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $abElG.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $abElG.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $abElG.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $abElG.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $fJZol.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $b6hTo.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf("!important") : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? "important" : "");
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $29wg8.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $abElG.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $abElG.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $abElG.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $cnLXI.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $cnLXI.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $b6hTo.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $10ec7dbe3a8aaee3$export$2e2bcd8739ae039 = index;

});
parcelRegister("29wg8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19157210131cb694$export$2e2bcd8739ae039; });
var $19157210131cb694$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $19157210131cb694$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $19157210131cb694$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $19157210131cb694$var$_typeof(document)) === "object" && document.nodeType === 9;
var $19157210131cb694$export$2e2bcd8739ae039 = $19157210131cb694$export$4e09c449d6c407f7;

});

parcelRegister("cnLXI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $903cd653cb9014f3$export$2e2bcd8739ae039; });
var $903cd653cb9014f3$var$isProduction = true;
function $903cd653cb9014f3$var$warning(condition, message) {
    if (!$903cd653cb9014f3$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $903cd653cb9014f3$export$2e2bcd8739ae039 = $903cd653cb9014f3$var$warning;

});

parcelRegister("b6hTo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $814e224ec1ccc517$export$2e2bcd8739ae039; });

var $dp6tu = parcelRequire("dp6tu");
function $814e224ec1ccc517$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $dp6tu.default)(descriptor.key), descriptor);
    }
}
function $814e224ec1ccc517$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $814e224ec1ccc517$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $814e224ec1ccc517$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("arruZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79a1c1aca5edc4cf$export$2e2bcd8739ae039; });

var $8LoK5 = parcelRequire("8LoK5");
function $79a1c1aca5edc4cf$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $8LoK5.default)(subClass, superClass);
}

});
parcelRegister("8LoK5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6615e7d8b41be13f$export$2e2bcd8739ae039; });
function $6615e7d8b41be13f$export$2e2bcd8739ae039(o, p) {
    $6615e7d8b41be13f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6615e7d8b41be13f$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("7qIdT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $568d43e864efbfa5$export$2e2bcd8739ae039; });
function $568d43e864efbfa5$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});


parcelRegister("s3KLs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $054586f5b8c228c1$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

function $054586f5b8c228c1$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $abElG.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRegister("29DQz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $191b54d129962215$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $191b54d129962215$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $191b54d129962215$export$2e2bcd8739ae039 = $191b54d129962215$var$multiKeyStore;

});

parcelRegister("gkz9m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be39c7a3399b74ea$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $1oPzq = parcelRequire("1oPzq");
function $be39c7a3399b74ea$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).useContext((0, $1oPzq.default));
    return theme;
}

});
parcelRegister("1oPzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10500923e53cb495$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");
var $10500923e53cb495$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createContext(null);
var $10500923e53cb495$export$2e2bcd8739ae039 = $10500923e53cb495$var$ThemeContext;

});


parcelRegister("6OzM9", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $4f6329e88ddedb3f$export$f4de434b269fe487; });
$parcel$export(module.exports, "default", function () { return $4f6329e88ddedb3f$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");



var $iPknr = parcelRequire("iPknr");

var $1s5gz = parcelRequire("1s5gz");

var $85CAN = parcelRequire("85CAN");
var $4f6329e88ddedb3f$var$jss = (0, $1s5gz.create)((0, $85CAN.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $4f6329e88ddedb3f$var$generateClassName = (0, $iPknr.default)(); // Exported for test purposes
var $4f6329e88ddedb3f$export$70a8aea9ff58d1cd = new Map();
var $4f6329e88ddedb3f$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $4f6329e88ddedb3f$var$generateClassName,
    jss: $4f6329e88ddedb3f$var$jss,
    sheetsCache: null,
    sheetsManager: $4f6329e88ddedb3f$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $4f6329e88ddedb3f$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createContext($4f6329e88ddedb3f$var$defaultOptions);
var $4f6329e88ddedb3f$var$injectFirstNode;
function $4f6329e88ddedb3f$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $dXEVX.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).useContext($4f6329e88ddedb3f$export$f4de434b269fe487);
    var context = (0, $abElG.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
        if (!$4f6329e88ddedb3f$var$injectFirstNode) {
            var head = document.head;
            $4f6329e88ddedb3f$var$injectFirstNode = document.createComment("mui-inject-first");
            head.insertBefore($4f6329e88ddedb3f$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $1s5gz.create)({
            plugins: (0, $85CAN.default)().plugins,
            insertionPoint: $4f6329e88ddedb3f$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($4f6329e88ddedb3f$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}

});
parcelRegister("iPknr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db4ccbe282074507$export$2e2bcd8739ae039; });

var $k7dzb = parcelRequire("k7dzb");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $db4ccbe282074507$var$pseudoClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
]; // Returns a function which generates unique class names based on counters.
function $db4ccbe282074507$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? "jss" : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? "" : _options$seed;
    var seedPrefix = seed === "" ? "" : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($db4ccbe282074507$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $k7dzb.default] || seed !== "") return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}

});
parcelRegister("k7dzb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea4efc188df5f646$export$2e2bcd8739ae039; });
var $ea4efc188df5f646$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $ea4efc188df5f646$export$2e2bcd8739ae039 = $ea4efc188df5f646$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRegister("85CAN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e3cba0b0bd65249$export$2e2bcd8739ae039; });

var $dvrr9 = parcelRequire("dvrr9");

var $d7WbW = parcelRequire("d7WbW");

var $a0KrL = parcelRequire("a0KrL");

var $lCyfi = parcelRequire("lCyfi");

var $9BtnJ = parcelRequire("9BtnJ");

var $eXxKY = parcelRequire("eXxKY");

var $7OX41 = parcelRequire("7OX41");
function $5e3cba0b0bd65249$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $dvrr9.default)(),
            (0, $d7WbW.default)(),
            (0, $a0KrL.default)(),
            (0, $lCyfi.default)(),
            (0, $9BtnJ.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $eXxKY.default)(),
            (0, $7OX41.default)()
        ]
    };
}

});
parcelRegister("dvrr9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d537400f6bbba83$export$2e2bcd8739ae039; });


var $1s5gz = parcelRequire("1s5gz");
var $9d537400f6bbba83$var$now = Date.now();
var $9d537400f6bbba83$var$fnValuesNs = "fnValues" + $9d537400f6bbba83$var$now;
var $9d537400f6bbba83$var$fnRuleNs = "fnStyle" + ++$9d537400f6bbba83$var$now;
var $9d537400f6bbba83$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $1s5gz.createRule)(name, {}, options);
            rule[$9d537400f6bbba83$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($9d537400f6bbba83$var$fnValuesNs in rule || $9d537400f6bbba83$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$9d537400f6bbba83$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$9d537400f6bbba83$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$9d537400f6bbba83$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $9d537400f6bbba83$export$2e2bcd8739ae039 = $9d537400f6bbba83$var$functionPlugin;

});

parcelRegister("d7WbW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98e9117397fd5e01$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $1s5gz = parcelRequire("1s5gz");
var $98e9117397fd5e01$var$at = "@global";
var $98e9117397fd5e01$var$atPrefix = "@global ";
var $98e9117397fd5e01$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $98e9117397fd5e01$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $1s5gz.RuleList)((0, $abElG.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $98e9117397fd5e01$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $98e9117397fd5e01$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($98e9117397fd5e01$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $abElG.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $98e9117397fd5e01$var$separatorRegExp = /\s*,\s*/g;
function $98e9117397fd5e01$var$addScope(selector, scope) {
    var parts = selector.split($98e9117397fd5e01$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $98e9117397fd5e01$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$98e9117397fd5e01$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $abElG.default)({}, options, {
        selector: $98e9117397fd5e01$var$addScope(name, rule.selector)
    }));
    delete style[$98e9117397fd5e01$var$at];
}
function $98e9117397fd5e01$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $98e9117397fd5e01$var$at.length) !== $98e9117397fd5e01$var$at) continue;
        var selector = $98e9117397fd5e01$var$addScope(prop.substr($98e9117397fd5e01$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $abElG.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $98e9117397fd5e01$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $98e9117397fd5e01$var$at) return new $98e9117397fd5e01$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $98e9117397fd5e01$var$atPrefix.length) === $98e9117397fd5e01$var$atPrefix) return new $98e9117397fd5e01$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $98e9117397fd5e01$var$handleNestedGlobalContainerRule(rule, sheet);
        $98e9117397fd5e01$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $98e9117397fd5e01$export$2e2bcd8739ae039 = $98e9117397fd5e01$var$jssGlobal;

});

parcelRegister("a0KrL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $749deed6aa451cbb$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $749deed6aa451cbb$var$separatorRegExp = /\s*,\s*/g;
var $749deed6aa451cbb$var$parentRegExp = /&/g;
var $749deed6aa451cbb$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $749deed6aa451cbb$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($749deed6aa451cbb$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($749deed6aa451cbb$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($749deed6aa451cbb$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $abElG.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $abElG.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($749deed6aa451cbb$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ("replaceRule" in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $abElG.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $abElG.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $749deed6aa451cbb$export$2e2bcd8739ae039 = $749deed6aa451cbb$var$jssNested;

});

parcelRegister("lCyfi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbd7b614b086f3b8$export$2e2bcd8739ae039; });

var $dcFLP = parcelRequire("dcFLP");
/**
 * Convert camel cased property names to dash separated.
 */ function $fbd7b614b086f3b8$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $dcFLP.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($fbd7b614b086f3b8$var$convertCase);
        else converted.fallbacks = $fbd7b614b086f3b8$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $fbd7b614b086f3b8$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $fbd7b614b086f3b8$var$convertCase(style[index]);
            return style;
        }
        return $fbd7b614b086f3b8$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $dcFLP.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $fbd7b614b086f3b8$export$2e2bcd8739ae039 = $fbd7b614b086f3b8$var$camelCase;

});
parcelRegister("dcFLP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99cccc19e8223547$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $99cccc19e8223547$var$uppercasePattern = /[A-Z]/g;
var $99cccc19e8223547$var$msPattern = /^ms-/;
var $99cccc19e8223547$var$cache = {};
function $99cccc19e8223547$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $99cccc19e8223547$var$hyphenateStyleName(name) {
    if ($99cccc19e8223547$var$cache.hasOwnProperty(name)) return $99cccc19e8223547$var$cache[name];
    var hName = name.replace($99cccc19e8223547$var$uppercasePattern, $99cccc19e8223547$var$toHyphenLower);
    return $99cccc19e8223547$var$cache[name] = $99cccc19e8223547$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $99cccc19e8223547$export$2e2bcd8739ae039 = $99cccc19e8223547$var$hyphenateStyleName;

});


parcelRegister("9BtnJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fde5c5917f02ea6$export$2e2bcd8739ae039; });

var $1s5gz = parcelRequire("1s5gz");
var $6fde5c5917f02ea6$var$px = (0, $1s5gz.hasCSSTOMSupport) && CSS ? CSS.px : "px";
var $6fde5c5917f02ea6$var$ms = (0, $1s5gz.hasCSSTOMSupport) && CSS ? CSS.ms : "ms";
var $6fde5c5917f02ea6$var$percent = (0, $1s5gz.hasCSSTOMSupport) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $6fde5c5917f02ea6$var$defaultUnits = {
    // Animation properties
    "animation-delay": $6fde5c5917f02ea6$var$ms,
    "animation-duration": $6fde5c5917f02ea6$var$ms,
    // Background properties
    "background-position": $6fde5c5917f02ea6$var$px,
    "background-position-x": $6fde5c5917f02ea6$var$px,
    "background-position-y": $6fde5c5917f02ea6$var$px,
    "background-size": $6fde5c5917f02ea6$var$px,
    // Border Properties
    border: $6fde5c5917f02ea6$var$px,
    "border-bottom": $6fde5c5917f02ea6$var$px,
    "border-bottom-left-radius": $6fde5c5917f02ea6$var$px,
    "border-bottom-right-radius": $6fde5c5917f02ea6$var$px,
    "border-bottom-width": $6fde5c5917f02ea6$var$px,
    "border-left": $6fde5c5917f02ea6$var$px,
    "border-left-width": $6fde5c5917f02ea6$var$px,
    "border-radius": $6fde5c5917f02ea6$var$px,
    "border-right": $6fde5c5917f02ea6$var$px,
    "border-right-width": $6fde5c5917f02ea6$var$px,
    "border-top": $6fde5c5917f02ea6$var$px,
    "border-top-left-radius": $6fde5c5917f02ea6$var$px,
    "border-top-right-radius": $6fde5c5917f02ea6$var$px,
    "border-top-width": $6fde5c5917f02ea6$var$px,
    "border-width": $6fde5c5917f02ea6$var$px,
    "border-block": $6fde5c5917f02ea6$var$px,
    "border-block-end": $6fde5c5917f02ea6$var$px,
    "border-block-end-width": $6fde5c5917f02ea6$var$px,
    "border-block-start": $6fde5c5917f02ea6$var$px,
    "border-block-start-width": $6fde5c5917f02ea6$var$px,
    "border-block-width": $6fde5c5917f02ea6$var$px,
    "border-inline": $6fde5c5917f02ea6$var$px,
    "border-inline-end": $6fde5c5917f02ea6$var$px,
    "border-inline-end-width": $6fde5c5917f02ea6$var$px,
    "border-inline-start": $6fde5c5917f02ea6$var$px,
    "border-inline-start-width": $6fde5c5917f02ea6$var$px,
    "border-inline-width": $6fde5c5917f02ea6$var$px,
    "border-start-start-radius": $6fde5c5917f02ea6$var$px,
    "border-start-end-radius": $6fde5c5917f02ea6$var$px,
    "border-end-start-radius": $6fde5c5917f02ea6$var$px,
    "border-end-end-radius": $6fde5c5917f02ea6$var$px,
    // Margin properties
    margin: $6fde5c5917f02ea6$var$px,
    "margin-bottom": $6fde5c5917f02ea6$var$px,
    "margin-left": $6fde5c5917f02ea6$var$px,
    "margin-right": $6fde5c5917f02ea6$var$px,
    "margin-top": $6fde5c5917f02ea6$var$px,
    "margin-block": $6fde5c5917f02ea6$var$px,
    "margin-block-end": $6fde5c5917f02ea6$var$px,
    "margin-block-start": $6fde5c5917f02ea6$var$px,
    "margin-inline": $6fde5c5917f02ea6$var$px,
    "margin-inline-end": $6fde5c5917f02ea6$var$px,
    "margin-inline-start": $6fde5c5917f02ea6$var$px,
    // Padding properties
    padding: $6fde5c5917f02ea6$var$px,
    "padding-bottom": $6fde5c5917f02ea6$var$px,
    "padding-left": $6fde5c5917f02ea6$var$px,
    "padding-right": $6fde5c5917f02ea6$var$px,
    "padding-top": $6fde5c5917f02ea6$var$px,
    "padding-block": $6fde5c5917f02ea6$var$px,
    "padding-block-end": $6fde5c5917f02ea6$var$px,
    "padding-block-start": $6fde5c5917f02ea6$var$px,
    "padding-inline": $6fde5c5917f02ea6$var$px,
    "padding-inline-end": $6fde5c5917f02ea6$var$px,
    "padding-inline-start": $6fde5c5917f02ea6$var$px,
    // Mask properties
    "mask-position-x": $6fde5c5917f02ea6$var$px,
    "mask-position-y": $6fde5c5917f02ea6$var$px,
    "mask-size": $6fde5c5917f02ea6$var$px,
    // Width and height properties
    height: $6fde5c5917f02ea6$var$px,
    width: $6fde5c5917f02ea6$var$px,
    "min-height": $6fde5c5917f02ea6$var$px,
    "max-height": $6fde5c5917f02ea6$var$px,
    "min-width": $6fde5c5917f02ea6$var$px,
    "max-width": $6fde5c5917f02ea6$var$px,
    // Position properties
    bottom: $6fde5c5917f02ea6$var$px,
    left: $6fde5c5917f02ea6$var$px,
    top: $6fde5c5917f02ea6$var$px,
    right: $6fde5c5917f02ea6$var$px,
    inset: $6fde5c5917f02ea6$var$px,
    "inset-block": $6fde5c5917f02ea6$var$px,
    "inset-block-end": $6fde5c5917f02ea6$var$px,
    "inset-block-start": $6fde5c5917f02ea6$var$px,
    "inset-inline": $6fde5c5917f02ea6$var$px,
    "inset-inline-end": $6fde5c5917f02ea6$var$px,
    "inset-inline-start": $6fde5c5917f02ea6$var$px,
    // Shadow properties
    "box-shadow": $6fde5c5917f02ea6$var$px,
    "text-shadow": $6fde5c5917f02ea6$var$px,
    // Column properties
    "column-gap": $6fde5c5917f02ea6$var$px,
    "column-rule": $6fde5c5917f02ea6$var$px,
    "column-rule-width": $6fde5c5917f02ea6$var$px,
    "column-width": $6fde5c5917f02ea6$var$px,
    // Font and text properties
    "font-size": $6fde5c5917f02ea6$var$px,
    "font-size-delta": $6fde5c5917f02ea6$var$px,
    "letter-spacing": $6fde5c5917f02ea6$var$px,
    "text-decoration-thickness": $6fde5c5917f02ea6$var$px,
    "text-indent": $6fde5c5917f02ea6$var$px,
    "text-stroke": $6fde5c5917f02ea6$var$px,
    "text-stroke-width": $6fde5c5917f02ea6$var$px,
    "word-spacing": $6fde5c5917f02ea6$var$px,
    // Motion properties
    motion: $6fde5c5917f02ea6$var$px,
    "motion-offset": $6fde5c5917f02ea6$var$px,
    // Outline properties
    outline: $6fde5c5917f02ea6$var$px,
    "outline-offset": $6fde5c5917f02ea6$var$px,
    "outline-width": $6fde5c5917f02ea6$var$px,
    // Perspective properties
    perspective: $6fde5c5917f02ea6$var$px,
    "perspective-origin-x": $6fde5c5917f02ea6$var$percent,
    "perspective-origin-y": $6fde5c5917f02ea6$var$percent,
    // Transform properties
    "transform-origin": $6fde5c5917f02ea6$var$percent,
    "transform-origin-x": $6fde5c5917f02ea6$var$percent,
    "transform-origin-y": $6fde5c5917f02ea6$var$percent,
    "transform-origin-z": $6fde5c5917f02ea6$var$percent,
    // Transition properties
    "transition-delay": $6fde5c5917f02ea6$var$ms,
    "transition-duration": $6fde5c5917f02ea6$var$ms,
    // Alignment properties
    "vertical-align": $6fde5c5917f02ea6$var$px,
    "flex-basis": $6fde5c5917f02ea6$var$px,
    // Some random properties
    "shape-margin": $6fde5c5917f02ea6$var$px,
    size: $6fde5c5917f02ea6$var$px,
    gap: $6fde5c5917f02ea6$var$px,
    // Grid properties
    grid: $6fde5c5917f02ea6$var$px,
    "grid-gap": $6fde5c5917f02ea6$var$px,
    "row-gap": $6fde5c5917f02ea6$var$px,
    "grid-row-gap": $6fde5c5917f02ea6$var$px,
    "grid-column-gap": $6fde5c5917f02ea6$var$px,
    "grid-template-rows": $6fde5c5917f02ea6$var$px,
    "grid-template-columns": $6fde5c5917f02ea6$var$px,
    "grid-auto-rows": $6fde5c5917f02ea6$var$px,
    "grid-auto-columns": $6fde5c5917f02ea6$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $6fde5c5917f02ea6$var$px,
    "box-shadow-y": $6fde5c5917f02ea6$var$px,
    "box-shadow-blur": $6fde5c5917f02ea6$var$px,
    "box-shadow-spread": $6fde5c5917f02ea6$var$px,
    "font-line-height": $6fde5c5917f02ea6$var$px,
    "text-shadow-x": $6fde5c5917f02ea6$var$px,
    "text-shadow-y": $6fde5c5917f02ea6$var$px,
    "text-shadow-blur": $6fde5c5917f02ea6$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $6fde5c5917f02ea6$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $6fde5c5917f02ea6$var$units = $6fde5c5917f02ea6$var$addCamelCasedVersion($6fde5c5917f02ea6$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $6fde5c5917f02ea6$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $6fde5c5917f02ea6$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $6fde5c5917f02ea6$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $6fde5c5917f02ea6$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $6fde5c5917f02ea6$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $6fde5c5917f02ea6$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $6fde5c5917f02ea6$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $6fde5c5917f02ea6$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $6fde5c5917f02ea6$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $6fde5c5917f02ea6$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $6fde5c5917f02ea6$export$2e2bcd8739ae039 = $6fde5c5917f02ea6$var$defaultUnit;

});

parcelRegister("eXxKY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae40c2bf0da03ffd$export$2e2bcd8739ae039; });

var $93uha = parcelRequire("93uha");

var $1s5gz = parcelRequire("1s5gz");
/**
 * Add vendor prefix to a property name when needed.
 */ function $ae40c2bf0da03ffd$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $93uha.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $93uha.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $93uha.supportedValue)(supportedProp, (0, $1s5gz.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $93uha.supportedValue)(prop, (0, $1s5gz.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $ae40c2bf0da03ffd$export$2e2bcd8739ae039 = $ae40c2bf0da03ffd$var$jssVendorPrefixer;

});
parcelRegister("93uha", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $697be106eadf73e7$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $697be106eadf73e7$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $697be106eadf73e7$export$511766124059c277; });

var $29wg8 = parcelRequire("29wg8");

var $lsH61 = parcelRequire("lsH61");
// Export javascript style and css style vendor prefixes.
var $697be106eadf73e7$var$js = "";
var $697be106eadf73e7$var$css = "";
var $697be106eadf73e7$var$vendor = "";
var $697be106eadf73e7$var$browser = "";
var $697be106eadf73e7$var$isTouch = (0, $29wg8.default) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $29wg8.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $697be106eadf73e7$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $697be106eadf73e7$var$_document$createEleme = document.createElement("p"), $697be106eadf73e7$var$style = $697be106eadf73e7$var$_document$createEleme.style;
    var $697be106eadf73e7$var$testProp = "Transform";
    for(var $697be106eadf73e7$var$key in $697be106eadf73e7$var$jsCssMap)if ($697be106eadf73e7$var$key + $697be106eadf73e7$var$testProp in $697be106eadf73e7$var$style) {
        $697be106eadf73e7$var$js = $697be106eadf73e7$var$key;
        $697be106eadf73e7$var$css = $697be106eadf73e7$var$jsCssMap[$697be106eadf73e7$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($697be106eadf73e7$var$js === "Webkit" && "msHyphens" in $697be106eadf73e7$var$style) {
        $697be106eadf73e7$var$js = "ms";
        $697be106eadf73e7$var$css = $697be106eadf73e7$var$jsCssMap.ms;
        $697be106eadf73e7$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($697be106eadf73e7$var$js === "Webkit" && "-apple-trailing-word" in $697be106eadf73e7$var$style) $697be106eadf73e7$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $697be106eadf73e7$export$82e9f45cca5ba907 = {
    js: $697be106eadf73e7$var$js,
    css: $697be106eadf73e7$var$css,
    vendor: $697be106eadf73e7$var$vendor,
    browser: $697be106eadf73e7$var$browser,
    isTouch: $697be106eadf73e7$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $697be106eadf73e7$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($697be106eadf73e7$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $697be106eadf73e7$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $697be106eadf73e7$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($697be106eadf73e7$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $697be106eadf73e7$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $697be106eadf73e7$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($697be106eadf73e7$export$82e9f45cca5ba907.js === "Webkit") return $697be106eadf73e7$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $697be106eadf73e7$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $697be106eadf73e7$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $697be106eadf73e7$var$camelize(str) {
    return str.replace($697be106eadf73e7$var$regExp, $697be106eadf73e7$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $697be106eadf73e7$var$pascalize(str) {
    return $697be106eadf73e7$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $697be106eadf73e7$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($697be106eadf73e7$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($697be106eadf73e7$var$camelize(longhand) in style) return prop;
            if ($697be106eadf73e7$export$82e9f45cca5ba907.js + $697be106eadf73e7$var$pascalize(longhand) in style) return $697be106eadf73e7$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $697be106eadf73e7$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($697be106eadf73e7$export$82e9f45cca5ba907.vendor === "apple" && !$697be106eadf73e7$export$82e9f45cca5ba907.isTouch) return $697be106eadf73e7$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $697be106eadf73e7$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $697be106eadf73e7$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $697be106eadf73e7$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $697be106eadf73e7$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $697be106eadf73e7$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($697be106eadf73e7$export$82e9f45cca5ba907.js === "Webkit" || $697be106eadf73e7$export$82e9f45cca5ba907.js === "ms" && $697be106eadf73e7$export$82e9f45cca5ba907.browser !== "edge") return $697be106eadf73e7$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $697be106eadf73e7$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($697be106eadf73e7$export$82e9f45cca5ba907.js === "Moz" || $697be106eadf73e7$export$82e9f45cca5ba907.js === "ms" || $697be106eadf73e7$export$82e9f45cca5ba907.vendor === "apple") return $697be106eadf73e7$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $697be106eadf73e7$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($697be106eadf73e7$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $697be106eadf73e7$var$pascalize(prop);
            return jsProp in style ? $697be106eadf73e7$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($697be106eadf73e7$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $697be106eadf73e7$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $697be106eadf73e7$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($697be106eadf73e7$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $697be106eadf73e7$export$82e9f45cca5ba907.js + $697be106eadf73e7$var$pascalize(newProp) in style ? $697be106eadf73e7$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $697be106eadf73e7$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $697be106eadf73e7$var$camelize(prop) in style ? prop : false;
    }
};
var $697be106eadf73e7$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $697be106eadf73e7$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($697be106eadf73e7$export$82e9f45cca5ba907.js + pascalized in style) return $697be106eadf73e7$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($697be106eadf73e7$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $697be106eadf73e7$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($697be106eadf73e7$export$82e9f45cca5ba907.js === "ms") return "" + $697be106eadf73e7$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $697be106eadf73e7$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($697be106eadf73e7$export$82e9f45cca5ba907.js === "ms") return $697be106eadf73e7$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $697be106eadf73e7$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $697be106eadf73e7$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $697be106eadf73e7$var$propMap[prop];
        if (!newProp) return false;
        return $697be106eadf73e7$export$82e9f45cca5ba907.js + $697be106eadf73e7$var$pascalize(newProp) in style ? $697be106eadf73e7$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $697be106eadf73e7$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $697be106eadf73e7$var$propKeys = Object.keys($697be106eadf73e7$var$propMap$1);
var $697be106eadf73e7$var$prefixCss = function prefixCss(p) {
    return $697be106eadf73e7$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $697be106eadf73e7$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($697be106eadf73e7$var$propKeys.indexOf(prop) > -1) {
            var newProp = $697be106eadf73e7$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $697be106eadf73e7$export$82e9f45cca5ba907.js + $697be106eadf73e7$var$pascalize(newProp) in style ? $697be106eadf73e7$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($697be106eadf73e7$export$82e9f45cca5ba907.js + $697be106eadf73e7$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($697be106eadf73e7$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $697be106eadf73e7$var$plugins = [
    $697be106eadf73e7$var$appearence,
    $697be106eadf73e7$var$colorAdjust,
    $697be106eadf73e7$var$mask,
    $697be106eadf73e7$var$textOrientation,
    $697be106eadf73e7$var$transform,
    $697be106eadf73e7$var$transition,
    $697be106eadf73e7$var$writingMode,
    $697be106eadf73e7$var$userSelect,
    $697be106eadf73e7$var$breakPropsOld,
    $697be106eadf73e7$var$inlineLogicalOld,
    $697be106eadf73e7$var$unprefixed,
    $697be106eadf73e7$var$prefixed,
    $697be106eadf73e7$var$scrollSnap,
    $697be106eadf73e7$var$overscrollBehavior,
    $697be106eadf73e7$var$flex2012,
    $697be106eadf73e7$var$flex2009
];
var $697be106eadf73e7$var$propertyDetectors = $697be106eadf73e7$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $697be106eadf73e7$var$noPrefill = $697be106eadf73e7$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $lsH61.default)(p.noPrefill));
    return a;
}, []);
var $697be106eadf73e7$var$el;
var $697be106eadf73e7$var$cache = {};
if (0, $29wg8.default) {
    $697be106eadf73e7$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $697be106eadf73e7$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $697be106eadf73e7$var$key$1 in $697be106eadf73e7$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($697be106eadf73e7$var$key$1)) $697be106eadf73e7$var$cache[$697be106eadf73e7$var$computed[$697be106eadf73e7$var$key$1]] = $697be106eadf73e7$var$computed[$697be106eadf73e7$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $697be106eadf73e7$var$noPrefill.forEach(function(x) {
        return delete $697be106eadf73e7$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $697be106eadf73e7$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$697be106eadf73e7$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($697be106eadf73e7$var$cache[prop] != null) return $697be106eadf73e7$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $697be106eadf73e7$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $697be106eadf73e7$var$propertyDetectors.length; i++){
        $697be106eadf73e7$var$cache[prop] = $697be106eadf73e7$var$propertyDetectors[i](prop, $697be106eadf73e7$var$el.style, options); // Break loop, if value found.
        if ($697be106eadf73e7$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $697be106eadf73e7$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $697be106eadf73e7$var$cache[prop];
}
var $697be106eadf73e7$var$cache$1 = {};
var $697be106eadf73e7$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $697be106eadf73e7$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $697be106eadf73e7$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $697be106eadf73e7$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $697be106eadf73e7$export$ce097f82c2e4551a(p1) : ", " + $697be106eadf73e7$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $29wg8.default) $697be106eadf73e7$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $697be106eadf73e7$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$697be106eadf73e7$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($697be106eadf73e7$var$cache$1[cacheKey] != null) return $697be106eadf73e7$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $697be106eadf73e7$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $697be106eadf73e7$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($697be106eadf73e7$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($697be106eadf73e7$var$transPropsRegExp, $697be106eadf73e7$var$prefixTransitionCallback);
    else if ($697be106eadf73e7$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $697be106eadf73e7$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $697be106eadf73e7$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $697be106eadf73e7$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($697be106eadf73e7$var$el$1.style[property] === "") {
            $697be106eadf73e7$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $697be106eadf73e7$var$el$1.style[property] = ""; // Write current value to cache.
    $697be106eadf73e7$var$cache$1[cacheKey] = prefixedValue;
    return $697be106eadf73e7$var$cache$1[cacheKey];
}

});
parcelRegister("lsH61", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9fda4825e29d0de$export$2e2bcd8739ae039; });

var $kZBxZ = parcelRequire("kZBxZ");

var $62bS2 = parcelRequire("62bS2");

var $4ECD0 = parcelRequire("4ECD0");

var $gjLgW = parcelRequire("gjLgW");
function $f9fda4825e29d0de$export$2e2bcd8739ae039(arr) {
    return (0, $kZBxZ.default)(arr) || (0, $62bS2.default)(arr) || (0, $4ECD0.default)(arr) || (0, $gjLgW.default)();
}

});
parcelRegister("kZBxZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f486a141d2503b16$export$2e2bcd8739ae039; });

var $hKSiz = parcelRequire("hKSiz");
function $f486a141d2503b16$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $hKSiz.default)(arr);
}

});
parcelRegister("hKSiz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ced0da1c7eaff495$export$2e2bcd8739ae039; });
function $ced0da1c7eaff495$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("62bS2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $464c23367c28878d$export$2e2bcd8739ae039; });
function $464c23367c28878d$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4ECD0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3638dc9310181be4$export$2e2bcd8739ae039; });

var $hKSiz = parcelRequire("hKSiz");
function $3638dc9310181be4$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $hKSiz.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $hKSiz.default)(o, minLen);
}

});

parcelRegister("gjLgW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be1316fdf792eaa1$export$2e2bcd8739ae039; });
function $be1316fdf792eaa1$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("7OX41", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b1b04c692be4af0$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $5b1b04c692be4af0$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $5b1b04c692be4af0$export$2e2bcd8739ae039 = $5b1b04c692be4af0$var$jssPropsSort;

});



parcelRegister("40YHw", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $2ec63f7722b07c7f$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $2ec63f7722b07c7f$var$indexCounter = -1000000000;
function $2ec63f7722b07c7f$export$a2647aa13413c947() {
    $2ec63f7722b07c7f$var$indexCounter += 1;
    return $2ec63f7722b07c7f$var$indexCounter;
}

});

parcelRegister("luB5R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa592c5272d95a95$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");
parcelRequire("7Dbhg");

var $52Kw7 = parcelRequire("52Kw7");

function $fa592c5272d95a95$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === "function";
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $abElG.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $52Kw7.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("52Kw7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ac138f9e2e4cc09$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $7Dbhg = parcelRequire("7Dbhg");
function $3ac138f9e2e4cc09$export$53b83ca8eaab0383(item) {
    return item && (0, $7Dbhg.default)(item) === "object" && item.constructor === Object;
}
function $3ac138f9e2e4cc09$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $abElG.default)({}, target) : target;
    if ($3ac138f9e2e4cc09$export$53b83ca8eaab0383(target) && $3ac138f9e2e4cc09$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($3ac138f9e2e4cc09$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $3ac138f9e2e4cc09$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});


parcelRegister("21Jjg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $179ed25449456f0f$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
var $179ed25449456f0f$var$noopTheme = {};
var $179ed25449456f0f$export$2e2bcd8739ae039 = $179ed25449456f0f$var$noopTheme;

});


parcelRegister("cgNhc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eed33ef123ce536$export$2e2bcd8739ae039; });
/* eslint-disable no-restricted-syntax */ function $8eed33ef123ce536$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRegister("cFFej", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93994bc1b3920569$export$2e2bcd8739ae039; });

var $ecQ1P = parcelRequire("ecQ1P");
var $93994bc1b3920569$var$defaultTheme = (0, $ecQ1P.default)();
var $93994bc1b3920569$export$2e2bcd8739ae039 = $93994bc1b3920569$var$defaultTheme;

});
parcelRegister("ecQ1P", function(module, exports) {

$parcel$export(module.exports, "createMuiTheme", function () { return $a57a8b74925fe97b$export$c469355549431d9b; });
$parcel$export(module.exports, "default", function () { return $a57a8b74925fe97b$export$2e2bcd8739ae039; });
parcelRequire("4g0WD");

var $dXEVX = parcelRequire("dXEVX");

var $52Kw7 = parcelRequire("52Kw7");

var $zFv3V = parcelRequire("zFv3V");

var $4rLxv = parcelRequire("4rLxv");

var $7ohoq = parcelRequire("7ohoq");

var $7hesT = parcelRequire("7hesT");

var $5cKJ3 = parcelRequire("5cKJ3");

var $kGBvU = parcelRequire("kGBvU");

var $cgwUV = parcelRequire("cgwUV");

var $jlqyK = parcelRequire("jlqyK");

var $gQhRu = parcelRequire("gQhRu");
function $a57a8b74925fe97b$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $dXEVX.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $7ohoq.default)(paletteInput);
    var breakpoints = (0, $zFv3V.default)(breakpointsInput);
    var spacing = (0, $cgwUV.default)(spacingInput);
    var muiTheme = (0, $52Kw7.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        mixins: (0, $4rLxv.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $5cKJ3.default),
        typography: (0, $7hesT.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $kGBvU.default),
        transitions: (0, $jlqyK.default),
        zIndex: (0, $gQhRu.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $52Kw7.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $a57a8b74925fe97b$var$warnedOnce = false;
function $a57a8b74925fe97b$export$c469355549431d9b() {
    return $a57a8b74925fe97b$var$createTheme.apply(void 0, arguments);
}
var $a57a8b74925fe97b$export$2e2bcd8739ae039 = $a57a8b74925fe97b$var$createTheme;

});
parcelRegister("zFv3V", function(module, exports) {

$parcel$export(module.exports, "keys", function () { return $06b376091e163c13$export$ed97f33186d4b816; });
$parcel$export(module.exports, "default", function () { return $06b376091e163c13$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");
var $06b376091e163c13$export$ed97f33186d4b816 = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
]; // Keep in mind that @media is inclusive by the CSS specification.
function $06b376091e163c13$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? "px" : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $dXEVX.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $06b376091e163c13$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$06b376091e163c13$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $06b376091e163c13$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up("xs");
        var value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $06b376091e163c13$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $06b376091e163c13$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$06b376091e163c13$export$ed97f33186d4b816[endIndex + 1]] === "number" ? values[$06b376091e163c13$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $abElG.default)({
        keys: $06b376091e163c13$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("4rLxv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33ce8f60539c2665$export$2e2bcd8739ae039; });

var $4g0WD = parcelRequire("4g0WD");

var $abElG = parcelRequire("abElG");
function $33ce8f60539c2665$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $abElG.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                "Material-UI: theme.mixins.gutters() is deprecated.",
                "You can use the source of the mixin directly:",
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join("\n"));
            return (0, $abElG.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $4g0WD.default)({}, breakpoints.up("sm"), (0, $abElG.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up("sm")])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $4g0WD.default)(_toolbar, "".concat(breakpoints.up("xs"), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $4g0WD.default)(_toolbar, breakpoints.up("sm"), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("7ohoq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5618443211befcfc$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $52Kw7 = parcelRequire("52Kw7");
var $eQGDD = parcelRequire("eQGDD");

var $aMKNP = parcelRequire("aMKNP");

var $j5VOo = parcelRequire("j5VOo");

var $3KSPi = parcelRequire("3KSPi");

var $ihUtX = parcelRequire("ihUtX");

var $18d2n = parcelRequire("18d2n");

var $k1FvP = parcelRequire("k1FvP");

var $bsmfh = parcelRequire("bsmfh");

var $ic6eg = parcelRequire("ic6eg");

var $6vqZH = parcelRequire("6vqZH");
var $5618443211befcfc$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.54)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)",
        // Text hints.
        hint: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $aMKNP.default).white,
        default: (0, $j5VOo.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $5618443211befcfc$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $aMKNP.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        hint: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: (0, $j5VOo.default)[800],
        default: "#303030"
    },
    action: {
        active: (0, $aMKNP.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $5618443211befcfc$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $6vqZH.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $6vqZH.darken)(intent.main, tonalOffsetDark);
    }
}
function $5618443211befcfc$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $3KSPi.default)[300],
        main: (0, $3KSPi.default)[500],
        dark: (0, $3KSPi.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $ihUtX.default).A200,
        main: (0, $ihUtX.default).A400,
        dark: (0, $ihUtX.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $18d2n.default)[300],
        main: (0, $18d2n.default)[500],
        dark: (0, $18d2n.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $k1FvP.default)[300],
        main: (0, $k1FvP.default)[500],
        dark: (0, $k1FvP.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $bsmfh.default)[300],
        main: (0, $bsmfh.default)[500],
        dark: (0, $bsmfh.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $ic6eg.default)[300],
        main: (0, $ic6eg.default)[500],
        dark: (0, $ic6eg.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? "light" : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $dXEVX.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $6vqZH.getContrastRatio)(background, $5618443211befcfc$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $5618443211befcfc$export$55ce6f3a06c59543.text.primary : $5618443211befcfc$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $abElG.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $eQGDD.default)(4, mainShade));
        if (typeof color.main !== "string") throw new Error((0, $eQGDD.default)(5, JSON.stringify(color.main)));
        $5618443211befcfc$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $5618443211befcfc$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $5618443211befcfc$export$55ce6f3a06c59543,
        light: $5618443211befcfc$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $52Kw7.default)((0, $abElG.default)({
        // A collection of common colors.
        common: (0, $aMKNP.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, "A400", "A200", "A700"),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $j5VOo.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("eQGDD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acf6ff1b34575c46$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $acf6ff1b34575c46$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = "https://mui.com/production-error/?code=" + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified Material-UI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});

parcelRegister("aMKNP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7da2b1181a4d952a$export$2e2bcd8739ae039; });
var $7da2b1181a4d952a$var$common = {
    black: "#000",
    white: "#fff"
};
var $7da2b1181a4d952a$export$2e2bcd8739ae039 = $7da2b1181a4d952a$var$common;

});

parcelRegister("j5VOo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de6b5427f322c183$export$2e2bcd8739ae039; });
var $de6b5427f322c183$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161"
};
var $de6b5427f322c183$export$2e2bcd8739ae039 = $de6b5427f322c183$var$grey;

});

parcelRegister("3KSPi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bc03256baad8b01$export$2e2bcd8739ae039; });
var $2bc03256baad8b01$var$indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
var $2bc03256baad8b01$export$2e2bcd8739ae039 = $2bc03256baad8b01$var$indigo;

});

parcelRegister("ihUtX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d505a0b356d575e1$export$2e2bcd8739ae039; });
var $d505a0b356d575e1$var$pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
var $d505a0b356d575e1$export$2e2bcd8739ae039 = $d505a0b356d575e1$var$pink;

});

parcelRegister("18d2n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d30a6bacba63d9b$export$2e2bcd8739ae039; });
var $0d30a6bacba63d9b$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $0d30a6bacba63d9b$export$2e2bcd8739ae039 = $0d30a6bacba63d9b$var$red;

});

parcelRegister("k1FvP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9441a24537fc1c5$export$2e2bcd8739ae039; });
var $e9441a24537fc1c5$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $e9441a24537fc1c5$export$2e2bcd8739ae039 = $e9441a24537fc1c5$var$orange;

});

parcelRegister("bsmfh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $857390bdf0980a33$export$2e2bcd8739ae039; });
var $857390bdf0980a33$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $857390bdf0980a33$export$2e2bcd8739ae039 = $857390bdf0980a33$var$blue;

});

parcelRegister("ic6eg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3ee2df846938bb8$export$2e2bcd8739ae039; });
var $d3ee2df846938bb8$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $d3ee2df846938bb8$export$2e2bcd8739ae039 = $d3ee2df846938bb8$var$green;

});

parcelRegister("6vqZH", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $0138f1de36cfae0a$export$d061e26956a60b0a; });
$parcel$export(module.exports, "emphasize", function () { return $0138f1de36cfae0a$export$e665714f76e581fd; });
$parcel$export(module.exports, "darken", function () { return $0138f1de36cfae0a$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $0138f1de36cfae0a$export$c0816ed86df316af; });
$parcel$export(module.exports, "alpha", function () { return $0138f1de36cfae0a$export$58f0f39f63f3cf42; });

var $eQGDD = parcelRequire("eQGDD");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $0138f1de36cfae0a$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $0138f1de36cfae0a$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", "), ")") : "";
}
function $0138f1de36cfae0a$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $0138f1de36cfae0a$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    var _decomposeColor = $0138f1de36cfae0a$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $0138f1de36cfae0a$var$intToHex(n);
    }).join(""));
}
function $0138f1de36cfae0a$export$29fb7152bd3f781a(color) {
    color = $0138f1de36cfae0a$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = "rgb";
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $0138f1de36cfae0a$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $0138f1de36cfae0a$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $0138f1de36cfae0a$export$677b39864803984e($0138f1de36cfae0a$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf("(");
    var type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla"
    ].indexOf(type) === -1) throw new Error((0, $eQGDD.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(",");
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $0138f1de36cfae0a$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf("hsl") !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(", "), ")");
}
function $0138f1de36cfae0a$export$d061e26956a60b0a(foreground, background) {
    var lumA = $0138f1de36cfae0a$export$c852d90bf7403b62(foreground);
    var lumB = $0138f1de36cfae0a$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $0138f1de36cfae0a$export$c852d90bf7403b62(color) {
    color = $0138f1de36cfae0a$export$677b39864803984e(color);
    var rgb = color.type === "hsl" ? $0138f1de36cfae0a$export$677b39864803984e($0138f1de36cfae0a$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $0138f1de36cfae0a$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $0138f1de36cfae0a$export$c852d90bf7403b62(color) > 0.5 ? $0138f1de36cfae0a$export$4b073707ff63303(color, coefficient) : $0138f1de36cfae0a$export$c0816ed86df316af(color, coefficient);
}
var $0138f1de36cfae0a$var$warnedOnce = false;
function $0138f1de36cfae0a$export$cbea29d068a2e18f(color, value) {
    return $0138f1de36cfae0a$export$58f0f39f63f3cf42(color, value);
}
function $0138f1de36cfae0a$export$58f0f39f63f3cf42(color, value) {
    color = $0138f1de36cfae0a$export$677b39864803984e(color);
    value = $0138f1de36cfae0a$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    color.values[3] = value;
    return $0138f1de36cfae0a$export$211a73f2b8c10ce4(color);
}
function $0138f1de36cfae0a$export$4b073707ff63303(color, coefficient) {
    color = $0138f1de36cfae0a$export$677b39864803984e(color);
    coefficient = $0138f1de36cfae0a$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $0138f1de36cfae0a$export$211a73f2b8c10ce4(color);
}
function $0138f1de36cfae0a$export$c0816ed86df316af(color, coefficient) {
    color = $0138f1de36cfae0a$export$677b39864803984e(color);
    coefficient = $0138f1de36cfae0a$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $0138f1de36cfae0a$export$211a73f2b8c10ce4(color);
}

});


parcelRegister("7hesT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54c5575c35ed0d8d$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $52Kw7 = parcelRequire("52Kw7");
function $54c5575c35ed0d8d$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $54c5575c35ed0d8d$var$warnedOnce = false;
function $54c5575c35ed0d8d$var$roundWithDeprecationWarning(value) {
    return $54c5575c35ed0d8d$var$round(value);
}
var $54c5575c35ed0d8d$var$caseAllCaps = {
    textTransform: "uppercase"
};
var $54c5575c35ed0d8d$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $54c5575c35ed0d8d$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === "function" ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $54c5575c35ed0d8d$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $dXEVX.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $abElG.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $54c5575c35ed0d8d$var$defaultFontFamily ? {
            letterSpacing: "".concat($54c5575c35ed0d8d$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $54c5575c35ed0d8d$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $54c5575c35ed0d8d$var$caseAllCaps)
    };
    return (0, $52Kw7.default)((0, $abElG.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $54c5575c35ed0d8d$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("5cKJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ca25179d0834d8a$export$2e2bcd8739ae039; });
var $3ca25179d0834d8a$var$shadowKeyUmbraOpacity = 0.2;
var $3ca25179d0834d8a$var$shadowKeyPenumbraOpacity = 0.14;
var $3ca25179d0834d8a$var$shadowAmbientShadowOpacity = 0.12;
function $3ca25179d0834d8a$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($3ca25179d0834d8a$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($3ca25179d0834d8a$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($3ca25179d0834d8a$var$shadowAmbientShadowOpacity, ")")
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $3ca25179d0834d8a$var$shadows = [
    "none",
    $3ca25179d0834d8a$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $3ca25179d0834d8a$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $3ca25179d0834d8a$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $3ca25179d0834d8a$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $3ca25179d0834d8a$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $3ca25179d0834d8a$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $3ca25179d0834d8a$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $3ca25179d0834d8a$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $3ca25179d0834d8a$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $3ca25179d0834d8a$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $3ca25179d0834d8a$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $3ca25179d0834d8a$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $3ca25179d0834d8a$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $3ca25179d0834d8a$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $3ca25179d0834d8a$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $3ca25179d0834d8a$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $3ca25179d0834d8a$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $3ca25179d0834d8a$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $3ca25179d0834d8a$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $3ca25179d0834d8a$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $3ca25179d0834d8a$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $3ca25179d0834d8a$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $3ca25179d0834d8a$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $3ca25179d0834d8a$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $3ca25179d0834d8a$export$2e2bcd8739ae039 = $3ca25179d0834d8a$var$shadows;

});

parcelRegister("kGBvU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0f4d44e6ce9f8c3$export$2e2bcd8739ae039; });
var $f0f4d44e6ce9f8c3$var$shape = {
    borderRadius: 4
};
var $f0f4d44e6ce9f8c3$export$2e2bcd8739ae039 = $f0f4d44e6ce9f8c3$var$shape;

});

parcelRegister("cgwUV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ee0834c727bb5be$export$2e2bcd8739ae039; });

var $1vnm9 = parcelRequire("1vnm9");
var $8ee0834c727bb5be$var$warnOnce;
function $8ee0834c727bb5be$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $1vnm9.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === "string") return argument;
            var output = transform(argument);
            return typeof output === "number" ? "".concat(output, "px") : output;
        }).join(" ");
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, "unit", {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("1vnm9", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", function () { return $118acdc5cda7a427$export$1def6f833384e3d1; });

var $kMfvj = parcelRequire("kMfvj");


var $iOMyb = parcelRequire("iOMyb");

var $5aKeq = parcelRequire("5aKeq");

var $f5hPu = parcelRequire("f5hPu");
var $118acdc5cda7a427$var$properties = {
    m: "margin",
    p: "padding"
};
var $118acdc5cda7a427$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
var $118acdc5cda7a427$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $118acdc5cda7a427$var$getCssProperties = (0, $f5hPu.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($118acdc5cda7a427$var$aliases[prop]) prop = $118acdc5cda7a427$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(""), _prop$split2 = (0, $kMfvj.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $118acdc5cda7a427$var$properties[a];
    var direction = $118acdc5cda7a427$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $118acdc5cda7a427$var$spacingKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY"
];
function $118acdc5cda7a427$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === "number") return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return function() {
        return undefined;
    };
}
function $118acdc5cda7a427$var$getValue(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return "-".concat(transformed);
}
function $118acdc5cda7a427$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $118acdc5cda7a427$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $118acdc5cda7a427$var$spacing(props) {
    var theme = props.theme;
    var transformer = $118acdc5cda7a427$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($118acdc5cda7a427$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $118acdc5cda7a427$var$getCssProperties(prop);
        var styleFromPropValue = $118acdc5cda7a427$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $iOMyb.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $5aKeq.default), {});
}
$118acdc5cda7a427$var$spacing.propTypes = {};
$118acdc5cda7a427$var$spacing.filterProps = $118acdc5cda7a427$var$spacingKeys;
var $118acdc5cda7a427$export$2e2bcd8739ae039 = $118acdc5cda7a427$var$spacing;

});
parcelRegister("kMfvj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f204511aed36cc80$export$2e2bcd8739ae039; });

var $4mfZm = parcelRequire("4mfZm");

var $2JBAF = parcelRequire("2JBAF");

var $4ECD0 = parcelRequire("4ECD0");

var $fmK1Z = parcelRequire("fmK1Z");
function $f204511aed36cc80$export$2e2bcd8739ae039(arr, i) {
    return (0, $4mfZm.default)(arr) || (0, $2JBAF.default)(arr, i) || (0, $4ECD0.default)(arr, i) || (0, $fmK1Z.default)();
}

});
parcelRegister("4mfZm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32c59e8630df04c6$export$2e2bcd8739ae039; });
function $32c59e8630df04c6$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("2JBAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fdcf168814b38d9$export$2e2bcd8739ae039; });
function $1fdcf168814b38d9$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("fmK1Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2fc9de489cdde9d$export$2e2bcd8739ae039; });
function $b2fc9de489cdde9d$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("iOMyb", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", function () { return $db328e9ba9a5f7c0$export$88347efdb2e19abd; });

var $lsH61 = parcelRequire("lsH61");

var $abElG = parcelRequire("abElG");

var $7Dbhg = parcelRequire("7Dbhg");


var $5aKeq = parcelRequire("5aKeq");
// For instance with the first breakpoint xs: [xs, sm[.
var $db328e9ba9a5f7c0$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $db328e9ba9a5f7c0$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: function up(key) {
        return "@media (min-width:".concat($db328e9ba9a5f7c0$var$values[key], "px)");
    }
};
function $db328e9ba9a5f7c0$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $db328e9ba9a5f7c0$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $7Dbhg.default)(propValue) === "object") {
        var _themeBreakpoints = props.theme.breakpoints || $db328e9ba9a5f7c0$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $db328e9ba9a5f7c0$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $db328e9ba9a5f7c0$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $abElG.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $5aKeq.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ].concat((0, $lsH61.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $db328e9ba9a5f7c0$export$2e2bcd8739ae039 = $db328e9ba9a5f7c0$var$breakpoints;

});
parcelRegister("5aKeq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c41bf9176c5f58d$export$2e2bcd8739ae039; });

var $52Kw7 = parcelRequire("52Kw7");
function $3c41bf9176c5f58d$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $52Kw7.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $3c41bf9176c5f58d$export$2e2bcd8739ae039 = $3c41bf9176c5f58d$var$merge;

});


parcelRegister("f5hPu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afb5273b07aa5900$export$2e2bcd8739ae039; });
function $afb5273b07aa5900$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("jlqyK", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $e15494a61df03139$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $e15494a61df03139$export$2e2bcd8739ae039; });

var $dXEVX = parcelRequire("dXEVX");
var $e15494a61df03139$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $e15494a61df03139$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $e15494a61df03139$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $e15494a61df03139$export$2e2bcd8739ae039 = {
    easing: $e15494a61df03139$export$24c5ac7c37452e7d,
    duration: $e15494a61df03139$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            "all"
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $e15494a61df03139$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $e15494a61df03139$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $dXEVX.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : $e15494a61df03139$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === "string" ? delay : $e15494a61df03139$var$formatMs(delay));
        }).join(",");
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});

parcelRegister("gQhRu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c42f5ba1b1a825d8$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $c42f5ba1b1a825d8$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $c42f5ba1b1a825d8$export$2e2bcd8739ae039 = $c42f5ba1b1a825d8$var$zIndex;

});




parcelRegister("7XHRd", function(module, exports) {

$parcel$export(module.exports, "withPlugins", function () { return $5cc010414c6a6767$export$bc996c07eb970c78; });

var $arQ7u = parcelRequire("arQ7u");

var $atexn = parcelRequire("atexn");

var $gSJ4Q = parcelRequire("gSJ4Q");

var $lLUHy = parcelRequire("lLUHy");
function $5cc010414c6a6767$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5cc010414c6a6767$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5cc010414c6a6767$var$ownKeys(Object(source), true).forEach(function(key) {
            $5cc010414c6a6767$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5cc010414c6a6767$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5cc010414c6a6767$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/** withPlugins should be the innermost HOC */ function $5cc010414c6a6767$var$_withPlugins(targetName, TargetComponent) {
    // eslint-disable-line no-underscore-dangle
    /** */ function PluginHoc(props, ref) {
        var pluginMap = (0, $arQ7u.useContext)((0, $lLUHy.default));
        var passDownProps = $5cc010414c6a6767$var$_objectSpread($5cc010414c6a6767$var$_objectSpread({}, props), ref ? {
            ref: ref
        } : {});
        var plugins = (pluginMap || {})[targetName];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gSJ4Q)))(plugins) || (0, (/*@__PURE__*/$parcel$interopDefault($gSJ4Q)))(plugins.wrap) && (0, (/*@__PURE__*/$parcel$interopDefault($gSJ4Q)))(plugins.add)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(TargetComponent, passDownProps);
        var PluginComponents = (plugins.add || []).map(function(plugin) {
            return plugin.component;
        });
        var targetComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(TargetComponent, Object.assign({}, passDownProps, {
            PluginComponents: PluginComponents
        }));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gSJ4Q)))(plugins.wrap)) return targetComponent;
        /** */ var pluginWrapper = function pluginWrapper(children, plugin) {
            var WrapPluginComponent = plugin.component;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(WrapPluginComponent, Object.assign({
                targetProps: passDownProps
            }, passDownProps, {
                PluginComponents: PluginComponents,
                TargetComponent: TargetComponent
            }), children);
        };
        return plugins.wrap.slice().reverse().reduce(pluginWrapper, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(TargetComponent, passDownProps));
    }
    var whatever = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).forwardRef(PluginHoc);
    whatever.displayName = "WithPlugins(".concat(targetName, ")");
    return whatever;
}
var $5cc010414c6a6767$export$bc996c07eb970c78 = (0, (/*@__PURE__*/$parcel$interopDefault($atexn)))($5cc010414c6a6767$var$_withPlugins);

});
parcelRegister("atexn", function(module, exports) {

var $fC8jd = parcelRequire("fC8jd");
/** Used to compose bitmasks for function metadata. */ var $79f7e39acbbb6e8a$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $79f7e39acbbb6e8a$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $fC8jd(func, $79f7e39acbbb6e8a$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $79f7e39acbbb6e8a$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$79f7e39acbbb6e8a$var$curry.placeholder = {};
module.exports = $79f7e39acbbb6e8a$var$curry;

});
parcelRegister("fC8jd", function(module, exports) {

var $9iI7n = parcelRequire("9iI7n");

var $96xFt = parcelRequire("96xFt");

var $l2wON = parcelRequire("l2wON");

var $cIGjZ = parcelRequire("cIGjZ");

var $eewWB = parcelRequire("eewWB");

var $5qK0p = parcelRequire("5qK0p");

var $94XRr = parcelRequire("94XRr");

var $gUJ5O = parcelRequire("gUJ5O");

var $d31q2 = parcelRequire("d31q2");

var $ltgXV = parcelRequire("ltgXV");
/** Error message constants. */ var $b5e0d99e09ccf09d$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to compose bitmasks for function metadata. */ var $b5e0d99e09ccf09d$var$WRAP_BIND_FLAG = 1, $b5e0d99e09ccf09d$var$WRAP_BIND_KEY_FLAG = 2, $b5e0d99e09ccf09d$var$WRAP_CURRY_FLAG = 8, $b5e0d99e09ccf09d$var$WRAP_CURRY_RIGHT_FLAG = 16, $b5e0d99e09ccf09d$var$WRAP_PARTIAL_FLAG = 32, $b5e0d99e09ccf09d$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b5e0d99e09ccf09d$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $b5e0d99e09ccf09d$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $b5e0d99e09ccf09d$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != "function") throw new TypeError($b5e0d99e09ccf09d$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($b5e0d99e09ccf09d$var$WRAP_PARTIAL_FLAG | $b5e0d99e09ccf09d$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $b5e0d99e09ccf09d$var$nativeMax($ltgXV(ary), 0);
    arity = arity === undefined ? arity : $ltgXV(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $b5e0d99e09ccf09d$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $5qK0p(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $94XRr(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $b5e0d99e09ccf09d$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($b5e0d99e09ccf09d$var$WRAP_CURRY_FLAG | $b5e0d99e09ccf09d$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($b5e0d99e09ccf09d$var$WRAP_CURRY_FLAG | $b5e0d99e09ccf09d$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $b5e0d99e09ccf09d$var$WRAP_BIND_FLAG) var result = $96xFt(func, bitmask, thisArg);
    else if (bitmask == $b5e0d99e09ccf09d$var$WRAP_CURRY_FLAG || bitmask == $b5e0d99e09ccf09d$var$WRAP_CURRY_RIGHT_FLAG) result = $l2wON(func, bitmask, arity);
    else if ((bitmask == $b5e0d99e09ccf09d$var$WRAP_PARTIAL_FLAG || bitmask == ($b5e0d99e09ccf09d$var$WRAP_BIND_FLAG | $b5e0d99e09ccf09d$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $eewWB(func, bitmask, thisArg, partials);
    else result = $cIGjZ.apply(undefined, newData);
    var setter = data ? $9iI7n : $gUJ5O;
    return $d31q2(setter(result, newData), func, bitmask);
}
module.exports = $b5e0d99e09ccf09d$var$createWrap;

});
parcelRegister("9iI7n", function(module, exports) {

var $l0EzR = parcelRequire("l0EzR");

var $1eK0f = parcelRequire("1eK0f");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $6c5804654d199170$var$baseSetData = !$1eK0f ? $l0EzR : function(func, data) {
    $1eK0f.set(func, data);
    return func;
};
module.exports = $6c5804654d199170$var$baseSetData;

});
parcelRegister("1eK0f", function(module, exports) {

var $gzEz9 = parcelRequire("gzEz9");
/** Used to store function metadata. */ var $0e6ac87b27c72537$var$metaMap = $gzEz9 && new $gzEz9;
module.exports = $0e6ac87b27c72537$var$metaMap;

});
parcelRegister("gzEz9", function(module, exports) {

var $6s8gY = parcelRequire("6s8gY");

var $9svsg = parcelRequire("9svsg");
/* Built-in method references that are verified to be native. */ var $c10f61c1f287c880$var$WeakMap = $6s8gY($9svsg, "WeakMap");
module.exports = $c10f61c1f287c880$var$WeakMap;

});



parcelRegister("96xFt", function(module, exports) {

var $3DkEC = parcelRequire("3DkEC");

var $9svsg = parcelRequire("9svsg");
/** Used to compose bitmasks for function metadata. */ var $6a0eca578ec8fd4d$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $6a0eca578ec8fd4d$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $6a0eca578ec8fd4d$var$WRAP_BIND_FLAG, Ctor = $3DkEC(func);
    function wrapper() {
        var fn = this && this !== $9svsg && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $6a0eca578ec8fd4d$var$createBind;

});
parcelRegister("3DkEC", function(module, exports) {

var $2Xhhy = parcelRequire("2Xhhy");

var $6Sqac = parcelRequire("6Sqac");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $2a550914c59f0713$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $2Xhhy(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $6Sqac(result) ? result : thisBinding;
    };
}
module.exports = $2a550914c59f0713$var$createCtor;

});
parcelRegister("2Xhhy", function(module, exports) {

var $6Sqac = parcelRequire("6Sqac");
/** Built-in value references. */ var $226e7f5943e499a1$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $226e7f5943e499a1$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$6Sqac(proto)) return {};
        if ($226e7f5943e499a1$var$objectCreate) return $226e7f5943e499a1$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $226e7f5943e499a1$var$baseCreate;

});



parcelRegister("l2wON", function(module, exports) {

var $gefDr = parcelRequire("gefDr");

var $3DkEC = parcelRequire("3DkEC");

var $cIGjZ = parcelRequire("cIGjZ");

var $gqe75 = parcelRequire("gqe75");

var $aBVjo = parcelRequire("aBVjo");

var $ekv1x = parcelRequire("ekv1x");

var $9svsg = parcelRequire("9svsg");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $f5133dedbfe35894$var$createCurry(func, bitmask, arity) {
    var Ctor = $3DkEC(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $aBVjo(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $ekv1x(args, placeholder);
        length -= holders.length;
        if (length < arity) return $gqe75(func, bitmask, $cIGjZ, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $9svsg && this instanceof wrapper ? Ctor : func;
        return $gefDr(fn, this, args);
    }
    return wrapper;
}
module.exports = $f5133dedbfe35894$var$createCurry;

});
parcelRegister("gefDr", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $bd0a14f5141b128c$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $bd0a14f5141b128c$var$apply;

});

parcelRegister("cIGjZ", function(module, exports) {

var $bLyyU = parcelRequire("bLyyU");

var $jG4rB = parcelRequire("jG4rB");

var $hdRYg = parcelRequire("hdRYg");

var $3DkEC = parcelRequire("3DkEC");

var $gqe75 = parcelRequire("gqe75");

var $aBVjo = parcelRequire("aBVjo");

var $fsNMm = parcelRequire("fsNMm");

var $ekv1x = parcelRequire("ekv1x");

var $9svsg = parcelRequire("9svsg");
/** Used to compose bitmasks for function metadata. */ var $942a6c3b7cbccedb$var$WRAP_BIND_FLAG = 1, $942a6c3b7cbccedb$var$WRAP_BIND_KEY_FLAG = 2, $942a6c3b7cbccedb$var$WRAP_CURRY_FLAG = 8, $942a6c3b7cbccedb$var$WRAP_CURRY_RIGHT_FLAG = 16, $942a6c3b7cbccedb$var$WRAP_ARY_FLAG = 128, $942a6c3b7cbccedb$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $942a6c3b7cbccedb$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $942a6c3b7cbccedb$var$WRAP_ARY_FLAG, isBind = bitmask & $942a6c3b7cbccedb$var$WRAP_BIND_FLAG, isBindKey = bitmask & $942a6c3b7cbccedb$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($942a6c3b7cbccedb$var$WRAP_CURRY_FLAG | $942a6c3b7cbccedb$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $942a6c3b7cbccedb$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $3DkEC(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $aBVjo(wrapper), holdersCount = $hdRYg(args, placeholder);
        if (partials) args = $bLyyU(args, partials, holders, isCurried);
        if (partialsRight) args = $jG4rB(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $ekv1x(args, placeholder);
            return $gqe75(func, bitmask, $942a6c3b7cbccedb$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $fsNMm(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $9svsg && this instanceof wrapper) fn = Ctor || $3DkEC(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $942a6c3b7cbccedb$var$createHybrid;

});
parcelRegister("bLyyU", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $890ee4d2b8ce452e$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $890ee4d2b8ce452e$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $890ee4d2b8ce452e$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $890ee4d2b8ce452e$var$composeArgs;

});

parcelRegister("jG4rB", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e535631aab83cc02$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $e535631aab83cc02$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $e535631aab83cc02$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $e535631aab83cc02$var$composeArgsRight;

});

parcelRegister("hdRYg", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $c89d84155e60997d$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $c89d84155e60997d$var$countHolders;

});

parcelRegister("gqe75", function(module, exports) {

var $deASb = parcelRequire("deASb");

var $gUJ5O = parcelRequire("gUJ5O");

var $d31q2 = parcelRequire("d31q2");
/** Used to compose bitmasks for function metadata. */ var $bf4a05adce8cfbcf$var$WRAP_BIND_FLAG = 1, $bf4a05adce8cfbcf$var$WRAP_BIND_KEY_FLAG = 2, $bf4a05adce8cfbcf$var$WRAP_CURRY_BOUND_FLAG = 4, $bf4a05adce8cfbcf$var$WRAP_CURRY_FLAG = 8, $bf4a05adce8cfbcf$var$WRAP_PARTIAL_FLAG = 32, $bf4a05adce8cfbcf$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $bf4a05adce8cfbcf$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $bf4a05adce8cfbcf$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $bf4a05adce8cfbcf$var$WRAP_PARTIAL_FLAG : $bf4a05adce8cfbcf$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $bf4a05adce8cfbcf$var$WRAP_PARTIAL_RIGHT_FLAG : $bf4a05adce8cfbcf$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $bf4a05adce8cfbcf$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($bf4a05adce8cfbcf$var$WRAP_BIND_FLAG | $bf4a05adce8cfbcf$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($deASb(func)) $gUJ5O(result, newData);
    result.placeholder = placeholder;
    return $d31q2(result, func, bitmask);
}
module.exports = $bf4a05adce8cfbcf$var$createRecurry;

});
parcelRegister("deASb", function(module, exports) {

var $lRSEs = parcelRequire("lRSEs");

var $5qK0p = parcelRequire("5qK0p");

var $hBuQN = parcelRequire("hBuQN");

var $lDN3j = parcelRequire("lDN3j");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $9a292f5a21247e1b$var$isLaziable(func) {
    var funcName = $hBuQN(func), other = $lDN3j[funcName];
    if (typeof other != "function" || !(funcName in $lRSEs.prototype)) return false;
    if (func === other) return true;
    var data = $5qK0p(other);
    return !!data && func === data[0];
}
module.exports = $9a292f5a21247e1b$var$isLaziable;

});
parcelRegister("lRSEs", function(module, exports) {

var $2Xhhy = parcelRequire("2Xhhy");

var $CZdgH = parcelRequire("CZdgH");
/** Used as references for the maximum length and index of an array. */ var $feb8f0da43480e7c$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $feb8f0da43480e7c$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $feb8f0da43480e7c$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$feb8f0da43480e7c$var$LazyWrapper.prototype = $2Xhhy($CZdgH.prototype);
$feb8f0da43480e7c$var$LazyWrapper.prototype.constructor = $feb8f0da43480e7c$var$LazyWrapper;
module.exports = $feb8f0da43480e7c$var$LazyWrapper;

});
parcelRegister("CZdgH", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $0753085a20581ad2$var$baseLodash() {
// No operation performed.
}
module.exports = $0753085a20581ad2$var$baseLodash;

});


parcelRegister("5qK0p", function(module, exports) {

var $1eK0f = parcelRequire("1eK0f");

var $5BjSL = parcelRequire("5BjSL");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $3f431136ce8d5ce7$var$getData = !$1eK0f ? $5BjSL : function(func) {
    return $1eK0f.get(func);
};
module.exports = $3f431136ce8d5ce7$var$getData;

});
parcelRegister("5BjSL", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $413fd4a546b1a5bd$var$noop() {
// No operation performed.
}
module.exports = $413fd4a546b1a5bd$var$noop;

});


parcelRegister("hBuQN", function(module, exports) {

var $697ug = parcelRequire("697ug");
/** Used for built-in method references. */ var $cd0dd2a197435152$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cd0dd2a197435152$var$hasOwnProperty = $cd0dd2a197435152$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $cd0dd2a197435152$var$getFuncName(func) {
    var result = func.name + "", array = $697ug[result], length = $cd0dd2a197435152$var$hasOwnProperty.call($697ug, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $cd0dd2a197435152$var$getFuncName;

});
parcelRegister("697ug", function(module, exports) {
/** Used to lookup unminified function names. */ var $4799641ae9140c25$var$realNames = {};
module.exports = $4799641ae9140c25$var$realNames;

});


parcelRegister("lDN3j", function(module, exports) {

var $lRSEs = parcelRequire("lRSEs");

var $f9dpb = parcelRequire("f9dpb");

var $CZdgH = parcelRequire("CZdgH");

var $eDRhj = parcelRequire("eDRhj");

var $cLyAa = parcelRequire("cLyAa");

var $fmgSf = parcelRequire("fmgSf");
/** Used for built-in method references. */ var $fc134a48f48b094a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fc134a48f48b094a$var$hasOwnProperty = $fc134a48f48b094a$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $fc134a48f48b094a$var$lodash(value) {
    if ($cLyAa(value) && !$eDRhj(value) && !(value instanceof $lRSEs)) {
        if (value instanceof $f9dpb) return value;
        if ($fc134a48f48b094a$var$hasOwnProperty.call(value, "__wrapped__")) return $fmgSf(value);
    }
    return new $f9dpb(value);
}
// Ensure wrappers are instances of `baseLodash`.
$fc134a48f48b094a$var$lodash.prototype = $CZdgH.prototype;
$fc134a48f48b094a$var$lodash.prototype.constructor = $fc134a48f48b094a$var$lodash;
module.exports = $fc134a48f48b094a$var$lodash;

});
parcelRegister("f9dpb", function(module, exports) {

var $2Xhhy = parcelRequire("2Xhhy");

var $CZdgH = parcelRequire("CZdgH");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $b072183fb1fe8cde$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$b072183fb1fe8cde$var$LodashWrapper.prototype = $2Xhhy($CZdgH.prototype);
$b072183fb1fe8cde$var$LodashWrapper.prototype.constructor = $b072183fb1fe8cde$var$LodashWrapper;
module.exports = $b072183fb1fe8cde$var$LodashWrapper;

});

parcelRegister("fmgSf", function(module, exports) {

var $lRSEs = parcelRequire("lRSEs");

var $f9dpb = parcelRequire("f9dpb");

var $iIgar = parcelRequire("iIgar");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $b2e5ffe2d6930233$var$wrapperClone(wrapper) {
    if (wrapper instanceof $lRSEs) return wrapper.clone();
    var result = new $f9dpb(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $iIgar(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $b2e5ffe2d6930233$var$wrapperClone;

});
parcelRegister("iIgar", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $d9f8e08eb1cba1e7$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $d9f8e08eb1cba1e7$var$copyArray;

});




parcelRegister("gUJ5O", function(module, exports) {

var $9iI7n = parcelRequire("9iI7n");

var $vhcaF = parcelRequire("vhcaF");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $c504dac34e873018$var$setData = $vhcaF($9iI7n);
module.exports = $c504dac34e873018$var$setData;

});
parcelRegister("vhcaF", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $05e03bfec5f2fac1$var$HOT_COUNT = 800, $05e03bfec5f2fac1$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $05e03bfec5f2fac1$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $05e03bfec5f2fac1$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $05e03bfec5f2fac1$var$nativeNow(), remaining = $05e03bfec5f2fac1$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $05e03bfec5f2fac1$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $05e03bfec5f2fac1$var$shortOut;

});


parcelRegister("d31q2", function(module, exports) {

var $fwAbB = parcelRequire("fwAbB");

var $6Ngev = parcelRequire("6Ngev");

var $kn1gs = parcelRequire("kn1gs");

var $hETw7 = parcelRequire("hETw7");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $97fca7f0300436c9$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + "";
    return $kn1gs(wrapper, $6Ngev(source, $hETw7($fwAbB(source), bitmask)));
}
module.exports = $97fca7f0300436c9$var$setWrapToString;

});
parcelRegister("fwAbB", function(module, exports) {
/** Used to match wrap detail comments. */ var $b4d5e9f76144e1d7$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $b4d5e9f76144e1d7$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $b4d5e9f76144e1d7$var$getWrapDetails(source) {
    var match = source.match($b4d5e9f76144e1d7$var$reWrapDetails);
    return match ? match[1].split($b4d5e9f76144e1d7$var$reSplitDetails) : [];
}
module.exports = $b4d5e9f76144e1d7$var$getWrapDetails;

});

parcelRegister("6Ngev", function(module, exports) {
/** Used to match wrap detail comments. */ var $4f23e9375c12027e$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $4f23e9375c12027e$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
    details = details.join(length > 2 ? ", " : " ");
    return source.replace($4f23e9375c12027e$var$reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
}
module.exports = $4f23e9375c12027e$var$insertWrapDetails;

});

parcelRegister("kn1gs", function(module, exports) {

var $4oFWg = parcelRequire("4oFWg");

var $vhcaF = parcelRequire("vhcaF");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $ed46efb5bdda9f54$var$setToString = $vhcaF($4oFWg);
module.exports = $ed46efb5bdda9f54$var$setToString;

});
parcelRegister("4oFWg", function(module, exports) {

var $kpgjf = parcelRequire("kpgjf");

var $63tyq = parcelRequire("63tyq");

var $l0EzR = parcelRequire("l0EzR");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $3339ef79fae6cc48$var$baseSetToString = !$63tyq ? $l0EzR : function(func, string) {
    return $63tyq(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $kpgjf(string),
        "writable": true
    });
};
module.exports = $3339ef79fae6cc48$var$baseSetToString;

});
parcelRegister("kpgjf", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $edb2cb28fd822dfe$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $edb2cb28fd822dfe$var$constant;

});



parcelRegister("hETw7", function(module, exports) {

var $e43Zj = parcelRequire("e43Zj");

var $2Q3DI = parcelRequire("2Q3DI");
/** Used to compose bitmasks for function metadata. */ var $cdb13ca565bd9b4a$var$WRAP_BIND_FLAG = 1, $cdb13ca565bd9b4a$var$WRAP_BIND_KEY_FLAG = 2, $cdb13ca565bd9b4a$var$WRAP_CURRY_FLAG = 8, $cdb13ca565bd9b4a$var$WRAP_CURRY_RIGHT_FLAG = 16, $cdb13ca565bd9b4a$var$WRAP_PARTIAL_FLAG = 32, $cdb13ca565bd9b4a$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $cdb13ca565bd9b4a$var$WRAP_ARY_FLAG = 128, $cdb13ca565bd9b4a$var$WRAP_REARG_FLAG = 256, $cdb13ca565bd9b4a$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $cdb13ca565bd9b4a$var$wrapFlags = [
    [
        "ary",
        $cdb13ca565bd9b4a$var$WRAP_ARY_FLAG
    ],
    [
        "bind",
        $cdb13ca565bd9b4a$var$WRAP_BIND_FLAG
    ],
    [
        "bindKey",
        $cdb13ca565bd9b4a$var$WRAP_BIND_KEY_FLAG
    ],
    [
        "curry",
        $cdb13ca565bd9b4a$var$WRAP_CURRY_FLAG
    ],
    [
        "curryRight",
        $cdb13ca565bd9b4a$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        "flip",
        $cdb13ca565bd9b4a$var$WRAP_FLIP_FLAG
    ],
    [
        "partial",
        $cdb13ca565bd9b4a$var$WRAP_PARTIAL_FLAG
    ],
    [
        "partialRight",
        $cdb13ca565bd9b4a$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        "rearg",
        $cdb13ca565bd9b4a$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $cdb13ca565bd9b4a$var$updateWrapDetails(details, bitmask) {
    $e43Zj($cdb13ca565bd9b4a$var$wrapFlags, function(pair) {
        var value = "_." + pair[0];
        if (bitmask & pair[1] && !$2Q3DI(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $cdb13ca565bd9b4a$var$updateWrapDetails;

});
parcelRegister("e43Zj", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $a3d48857cbc60b82$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $a3d48857cbc60b82$var$arrayEach;

});

parcelRegister("2Q3DI", function(module, exports) {

var $kFY1u = parcelRequire("kFY1u");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $211342d1e5a719ee$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $kFY1u(array, value, 0) > -1;
}
module.exports = $211342d1e5a719ee$var$arrayIncludes;

});
parcelRegister("kFY1u", function(module, exports) {

var $9B14a = parcelRequire("9B14a");

var $lECNS = parcelRequire("lECNS");

var $7azds = parcelRequire("7azds");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f0d6324cfb999d35$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $7azds(array, value, fromIndex) : $9B14a(array, $lECNS, fromIndex);
}
module.exports = $f0d6324cfb999d35$var$baseIndexOf;

});
parcelRegister("9B14a", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6fc8657b91d51654$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $6fc8657b91d51654$var$baseFindIndex;

});

parcelRegister("lECNS", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $0411798821d82101$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $0411798821d82101$var$baseIsNaN;

});

parcelRegister("7azds", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $5384c8c04c10a33d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $5384c8c04c10a33d$var$strictIndexOf;

});






parcelRegister("aBVjo", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $7b99d100e6e75191$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $7b99d100e6e75191$var$getHolder;

});

parcelRegister("fsNMm", function(module, exports) {

var $iIgar = parcelRequire("iIgar");

var $ez2hV = parcelRequire("ez2hV");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b42015a244ce2e1e$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $b42015a244ce2e1e$var$reorder(array, indexes) {
    var arrLength = array.length, length = $b42015a244ce2e1e$var$nativeMin(indexes.length, arrLength), oldArray = $iIgar(array);
    while(length--){
        var index = indexes[length];
        array[length] = $ez2hV(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $b42015a244ce2e1e$var$reorder;

});

parcelRegister("ekv1x", function(module, exports) {
/** Used as the internal argument placeholder. */ var $a6eaffa4cc9b4464$var$PLACEHOLDER = "__lodash_placeholder__";
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $a6eaffa4cc9b4464$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $a6eaffa4cc9b4464$var$PLACEHOLDER) {
            array[index] = $a6eaffa4cc9b4464$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $a6eaffa4cc9b4464$var$replaceHolders;

});



parcelRegister("eewWB", function(module, exports) {

var $gefDr = parcelRequire("gefDr");

var $3DkEC = parcelRequire("3DkEC");

var $9svsg = parcelRequire("9svsg");
/** Used to compose bitmasks for function metadata. */ var $a5cbed87a07de150$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $a5cbed87a07de150$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $a5cbed87a07de150$var$WRAP_BIND_FLAG, Ctor = $3DkEC(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $9svsg && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $gefDr(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $a5cbed87a07de150$var$createPartial;

});

parcelRegister("94XRr", function(module, exports) {

var $bLyyU = parcelRequire("bLyyU");

var $jG4rB = parcelRequire("jG4rB");

var $ekv1x = parcelRequire("ekv1x");
/** Used as the internal argument placeholder. */ var $69c2ebe6f75ae1b4$var$PLACEHOLDER = "__lodash_placeholder__";
/** Used to compose bitmasks for function metadata. */ var $69c2ebe6f75ae1b4$var$WRAP_BIND_FLAG = 1, $69c2ebe6f75ae1b4$var$WRAP_BIND_KEY_FLAG = 2, $69c2ebe6f75ae1b4$var$WRAP_CURRY_BOUND_FLAG = 4, $69c2ebe6f75ae1b4$var$WRAP_CURRY_FLAG = 8, $69c2ebe6f75ae1b4$var$WRAP_ARY_FLAG = 128, $69c2ebe6f75ae1b4$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $69c2ebe6f75ae1b4$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $69c2ebe6f75ae1b4$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($69c2ebe6f75ae1b4$var$WRAP_BIND_FLAG | $69c2ebe6f75ae1b4$var$WRAP_BIND_KEY_FLAG | $69c2ebe6f75ae1b4$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $69c2ebe6f75ae1b4$var$WRAP_ARY_FLAG && bitmask == $69c2ebe6f75ae1b4$var$WRAP_CURRY_FLAG || srcBitmask == $69c2ebe6f75ae1b4$var$WRAP_ARY_FLAG && bitmask == $69c2ebe6f75ae1b4$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($69c2ebe6f75ae1b4$var$WRAP_ARY_FLAG | $69c2ebe6f75ae1b4$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $69c2ebe6f75ae1b4$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $69c2ebe6f75ae1b4$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $69c2ebe6f75ae1b4$var$WRAP_BIND_FLAG ? 0 : $69c2ebe6f75ae1b4$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $bLyyU(partials, value, source[4]) : value;
        data[4] = partials ? $ekv1x(data[3], $69c2ebe6f75ae1b4$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $jG4rB(partials, value, source[6]) : value;
        data[6] = partials ? $ekv1x(data[5], $69c2ebe6f75ae1b4$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $69c2ebe6f75ae1b4$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $69c2ebe6f75ae1b4$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $69c2ebe6f75ae1b4$var$mergeData;

});

parcelRegister("ltgXV", function(module, exports) {

var $8k9lM = parcelRequire("8k9lM");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $fa19776c1c987914$var$toInteger(value) {
    var result = $8k9lM(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $fa19776c1c987914$var$toInteger;

});
parcelRegister("8k9lM", function(module, exports) {

var $3rZES = parcelRequire("3rZES");
/** Used as references for various `Number` constants. */ var $60f771c6340f556f$var$INFINITY = 1 / 0, $60f771c6340f556f$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $60f771c6340f556f$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $3rZES(value);
    if (value === $60f771c6340f556f$var$INFINITY || value === -$60f771c6340f556f$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $60f771c6340f556f$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $60f771c6340f556f$var$toFinite;

});
parcelRegister("3rZES", function(module, exports) {

var $kjze4 = parcelRequire("kjze4");

var $6Sqac = parcelRequire("6Sqac");

var $ejqIN = parcelRequire("ejqIN");
/** Used as references for various `Number` constants. */ var $2833b8bf74703a3a$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $2833b8bf74703a3a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $2833b8bf74703a3a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $2833b8bf74703a3a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $2833b8bf74703a3a$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $2833b8bf74703a3a$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($ejqIN(value)) return $2833b8bf74703a3a$var$NAN;
    if ($6Sqac(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $6Sqac(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $kjze4(value);
    var isBinary = $2833b8bf74703a3a$var$reIsBinary.test(value);
    return isBinary || $2833b8bf74703a3a$var$reIsOctal.test(value) ? $2833b8bf74703a3a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $2833b8bf74703a3a$var$reIsBadHex.test(value) ? $2833b8bf74703a3a$var$NAN : +value;
}
module.exports = $2833b8bf74703a3a$var$toNumber;

});
parcelRegister("kjze4", function(module, exports) {

var $lYWf7 = parcelRequire("lYWf7");
/** Used to match leading whitespace. */ var $eca0e827cced2a02$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $eca0e827cced2a02$var$baseTrim(string) {
    return string ? string.slice(0, $lYWf7(string) + 1).replace($eca0e827cced2a02$var$reTrimStart, "") : string;
}
module.exports = $eca0e827cced2a02$var$baseTrim;

});
parcelRegister("lYWf7", function(module, exports) {
/** Used to match a single whitespace character. */ var $04213b607c44499c$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $04213b607c44499c$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $04213b607c44499c$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $04213b607c44499c$var$trimmedEndIndex;

});







parcelRegister("gSJ4Q", function(module, exports) {

var $aff5X = parcelRequire("aff5X");

var $eGYov = parcelRequire("eGYov");

var $fc3fn = parcelRequire("fc3fn");

var $eDRhj = parcelRequire("eDRhj");

var $8kHR7 = parcelRequire("8kHR7");

var $lN48w = parcelRequire("lN48w");

var $3g81o = parcelRequire("3g81o");

var $loLm5 = parcelRequire("loLm5");
/** `Object#toString` result references. */ var $c4a4a7de0bf1cc8d$var$mapTag = "[object Map]", $c4a4a7de0bf1cc8d$var$setTag = "[object Set]";
/** Used for built-in method references. */ var $c4a4a7de0bf1cc8d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c4a4a7de0bf1cc8d$var$hasOwnProperty = $c4a4a7de0bf1cc8d$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $c4a4a7de0bf1cc8d$var$isEmpty(value) {
    if (value == null) return true;
    if ($8kHR7(value) && ($eDRhj(value) || typeof value == "string" || typeof value.splice == "function" || $lN48w(value) || $loLm5(value) || $fc3fn(value))) return !value.length;
    var tag = $eGYov(value);
    if (tag == $c4a4a7de0bf1cc8d$var$mapTag || tag == $c4a4a7de0bf1cc8d$var$setTag) return !value.size;
    if ($3g81o(value)) return !$aff5X(value).length;
    for(var key in value){
        if ($c4a4a7de0bf1cc8d$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $c4a4a7de0bf1cc8d$var$isEmpty;

});
parcelRegister("aff5X", function(module, exports) {

var $3g81o = parcelRequire("3g81o");

var $os6Ia = parcelRequire("os6Ia");
/** Used for built-in method references. */ var $775703a95e0ac7f9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $775703a95e0ac7f9$var$hasOwnProperty = $775703a95e0ac7f9$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $775703a95e0ac7f9$var$baseKeys(object) {
    if (!$3g81o(object)) return $os6Ia(object);
    var result = [];
    for(var key in Object(object))if ($775703a95e0ac7f9$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $775703a95e0ac7f9$var$baseKeys;

});
parcelRegister("3g81o", function(module, exports) {
/** Used for built-in method references. */ var $25f9169df7e8abc0$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $25f9169df7e8abc0$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $25f9169df7e8abc0$var$objectProto;
    return value === proto;
}
module.exports = $25f9169df7e8abc0$var$isPrototype;

});

parcelRegister("os6Ia", function(module, exports) {

var $kres7 = parcelRequire("kres7");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $04980b84fce92331$var$nativeKeys = $kres7(Object.keys, Object);
module.exports = $04980b84fce92331$var$nativeKeys;

});
parcelRegister("kres7", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ee118a39ee3047ff$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ee118a39ee3047ff$var$overArg;

});



parcelRegister("eGYov", function(module, exports) {

var $3snSN = parcelRequire("3snSN");

var $iPcKP = parcelRequire("iPcKP");

var $cUAD0 = parcelRequire("cUAD0");

var $8q4qD = parcelRequire("8q4qD");

var $gzEz9 = parcelRequire("gzEz9");

var $hyuxh = parcelRequire("hyuxh");

var $4LE2g = parcelRequire("4LE2g");
/** `Object#toString` result references. */ var $ab23d5ff5df8c996$var$mapTag = "[object Map]", $ab23d5ff5df8c996$var$objectTag = "[object Object]", $ab23d5ff5df8c996$var$promiseTag = "[object Promise]", $ab23d5ff5df8c996$var$setTag = "[object Set]", $ab23d5ff5df8c996$var$weakMapTag = "[object WeakMap]";
var $ab23d5ff5df8c996$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $ab23d5ff5df8c996$var$dataViewCtorString = $4LE2g($3snSN), $ab23d5ff5df8c996$var$mapCtorString = $4LE2g($iPcKP), $ab23d5ff5df8c996$var$promiseCtorString = $4LE2g($cUAD0), $ab23d5ff5df8c996$var$setCtorString = $4LE2g($8q4qD), $ab23d5ff5df8c996$var$weakMapCtorString = $4LE2g($gzEz9);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $ab23d5ff5df8c996$var$getTag = $hyuxh;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($3snSN && $ab23d5ff5df8c996$var$getTag(new $3snSN(new ArrayBuffer(1))) != $ab23d5ff5df8c996$var$dataViewTag || $iPcKP && $ab23d5ff5df8c996$var$getTag(new $iPcKP) != $ab23d5ff5df8c996$var$mapTag || $cUAD0 && $ab23d5ff5df8c996$var$getTag($cUAD0.resolve()) != $ab23d5ff5df8c996$var$promiseTag || $8q4qD && $ab23d5ff5df8c996$var$getTag(new $8q4qD) != $ab23d5ff5df8c996$var$setTag || $gzEz9 && $ab23d5ff5df8c996$var$getTag(new $gzEz9) != $ab23d5ff5df8c996$var$weakMapTag) $ab23d5ff5df8c996$var$getTag = function(value) {
    var result = $hyuxh(value), Ctor = result == $ab23d5ff5df8c996$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $4LE2g(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $ab23d5ff5df8c996$var$dataViewCtorString:
            return $ab23d5ff5df8c996$var$dataViewTag;
        case $ab23d5ff5df8c996$var$mapCtorString:
            return $ab23d5ff5df8c996$var$mapTag;
        case $ab23d5ff5df8c996$var$promiseCtorString:
            return $ab23d5ff5df8c996$var$promiseTag;
        case $ab23d5ff5df8c996$var$setCtorString:
            return $ab23d5ff5df8c996$var$setTag;
        case $ab23d5ff5df8c996$var$weakMapCtorString:
            return $ab23d5ff5df8c996$var$weakMapTag;
    }
    return result;
};
module.exports = $ab23d5ff5df8c996$var$getTag;

});
parcelRegister("3snSN", function(module, exports) {

var $6s8gY = parcelRequire("6s8gY");

var $9svsg = parcelRequire("9svsg");
/* Built-in method references that are verified to be native. */ var $284683457a77d0e9$var$DataView = $6s8gY($9svsg, "DataView");
module.exports = $284683457a77d0e9$var$DataView;

});

parcelRegister("cUAD0", function(module, exports) {

var $6s8gY = parcelRequire("6s8gY");

var $9svsg = parcelRequire("9svsg");
/* Built-in method references that are verified to be native. */ var $96672092dc340f9b$var$Promise = $6s8gY($9svsg, "Promise");
module.exports = $96672092dc340f9b$var$Promise;

});

parcelRegister("8q4qD", function(module, exports) {

var $6s8gY = parcelRequire("6s8gY");

var $9svsg = parcelRequire("9svsg");
/* Built-in method references that are verified to be native. */ var $62142fdb5c0d13da$var$Set = $6s8gY($9svsg, "Set");
module.exports = $62142fdb5c0d13da$var$Set;

});


parcelRegister("fc3fn", function(module, exports) {

var $9ah1u = parcelRequire("9ah1u");

var $cLyAa = parcelRequire("cLyAa");
/** Used for built-in method references. */ var $b0fa7ed07a09f2e4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b0fa7ed07a09f2e4$var$hasOwnProperty = $b0fa7ed07a09f2e4$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $b0fa7ed07a09f2e4$var$propertyIsEnumerable = $b0fa7ed07a09f2e4$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $b0fa7ed07a09f2e4$var$isArguments = $9ah1u(function() {
    return arguments;
}()) ? $9ah1u : function(value) {
    return $cLyAa(value) && $b0fa7ed07a09f2e4$var$hasOwnProperty.call(value, "callee") && !$b0fa7ed07a09f2e4$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $b0fa7ed07a09f2e4$var$isArguments;

});
parcelRegister("9ah1u", function(module, exports) {

var $hyuxh = parcelRequire("hyuxh");

var $cLyAa = parcelRequire("cLyAa");
/** `Object#toString` result references. */ var $6ac240a17c9581ac$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $6ac240a17c9581ac$var$baseIsArguments(value) {
    return $cLyAa(value) && $hyuxh(value) == $6ac240a17c9581ac$var$argsTag;
}
module.exports = $6ac240a17c9581ac$var$baseIsArguments;

});


parcelRegister("8kHR7", function(module, exports) {

var $4n8SM = parcelRequire("4n8SM");

var $1KYZK = parcelRequire("1KYZK");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $611235d9dbcf6b34$var$isArrayLike(value) {
    return value != null && $1KYZK(value.length) && !$4n8SM(value);
}
module.exports = $611235d9dbcf6b34$var$isArrayLike;

});
parcelRegister("1KYZK", function(module, exports) {
/** Used as references for various `Number` constants. */ var $147966a18bda32b2$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $147966a18bda32b2$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $147966a18bda32b2$var$MAX_SAFE_INTEGER;
}
module.exports = $147966a18bda32b2$var$isLength;

});


parcelRegister("lN48w", function(module, exports) {

var $9svsg = parcelRequire("9svsg");

var $99WwP = parcelRequire("99WwP");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $9svsg.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $99WwP;
module.exports = isBuffer;

});
parcelRegister("99WwP", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $6ab25ad72a729ed4$var$stubFalse() {
    return false;
}
module.exports = $6ab25ad72a729ed4$var$stubFalse;

});


parcelRegister("loLm5", function(module, exports) {

var $iouKP = parcelRequire("iouKP");

var $29wFm = parcelRequire("29wFm");

var $8TADj = parcelRequire("8TADj");
/* Node.js helper references. */ var $f940929b41d21e7c$var$nodeIsTypedArray = $8TADj && $8TADj.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $f940929b41d21e7c$var$isTypedArray = $f940929b41d21e7c$var$nodeIsTypedArray ? $29wFm($f940929b41d21e7c$var$nodeIsTypedArray) : $iouKP;
module.exports = $f940929b41d21e7c$var$isTypedArray;

});
parcelRegister("iouKP", function(module, exports) {

var $hyuxh = parcelRequire("hyuxh");

var $1KYZK = parcelRequire("1KYZK");

var $cLyAa = parcelRequire("cLyAa");
/** `Object#toString` result references. */ var $d64253069e98b558$var$argsTag = "[object Arguments]", $d64253069e98b558$var$arrayTag = "[object Array]", $d64253069e98b558$var$boolTag = "[object Boolean]", $d64253069e98b558$var$dateTag = "[object Date]", $d64253069e98b558$var$errorTag = "[object Error]", $d64253069e98b558$var$funcTag = "[object Function]", $d64253069e98b558$var$mapTag = "[object Map]", $d64253069e98b558$var$numberTag = "[object Number]", $d64253069e98b558$var$objectTag = "[object Object]", $d64253069e98b558$var$regexpTag = "[object RegExp]", $d64253069e98b558$var$setTag = "[object Set]", $d64253069e98b558$var$stringTag = "[object String]", $d64253069e98b558$var$weakMapTag = "[object WeakMap]";
var $d64253069e98b558$var$arrayBufferTag = "[object ArrayBuffer]", $d64253069e98b558$var$dataViewTag = "[object DataView]", $d64253069e98b558$var$float32Tag = "[object Float32Array]", $d64253069e98b558$var$float64Tag = "[object Float64Array]", $d64253069e98b558$var$int8Tag = "[object Int8Array]", $d64253069e98b558$var$int16Tag = "[object Int16Array]", $d64253069e98b558$var$int32Tag = "[object Int32Array]", $d64253069e98b558$var$uint8Tag = "[object Uint8Array]", $d64253069e98b558$var$uint8ClampedTag = "[object Uint8ClampedArray]", $d64253069e98b558$var$uint16Tag = "[object Uint16Array]", $d64253069e98b558$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $d64253069e98b558$var$typedArrayTags = {};
$d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$float32Tag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$float64Tag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$int8Tag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$int16Tag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$int32Tag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$uint8Tag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$uint8ClampedTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$uint16Tag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$uint32Tag] = true;
$d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$argsTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$arrayTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$arrayBufferTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$boolTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$dataViewTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$dateTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$errorTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$funcTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$mapTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$numberTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$objectTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$regexpTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$setTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$stringTag] = $d64253069e98b558$var$typedArrayTags[$d64253069e98b558$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $d64253069e98b558$var$baseIsTypedArray(value) {
    return $cLyAa(value) && $1KYZK(value.length) && !!$d64253069e98b558$var$typedArrayTags[$hyuxh(value)];
}
module.exports = $d64253069e98b558$var$baseIsTypedArray;

});

parcelRegister("29wFm", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $1915c2db37ec5a8a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $1915c2db37ec5a8a$var$baseUnary;

});

parcelRegister("8TADj", function(module, exports) {

var $bohmc = parcelRequire("bohmc");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $bohmc.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("lLUHy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd99f8782e2e3c16$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");
var $fd99f8782e2e3c16$var$PluginContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createContext();
var $fd99f8782e2e3c16$export$2e2bcd8739ae039 = $fd99f8782e2e3c16$var$PluginContext;

});


parcelRegister("in9CU", function(module, exports) {

$parcel$export(module.exports, "setCanvas", function () { return $d601d79e941cb926$export$79dccbf5b7f2d5b7; });
$parcel$export(module.exports, "setNextCanvas", function () { return $d601d79e941cb926$export$1e4a8de4c7587fd5; });
$parcel$export(module.exports, "setPreviousCanvas", function () { return $d601d79e941cb926$export$74924083e8ed6601; });
$parcel$export(module.exports, "updateViewport", function () { return $d601d79e941cb926$export$b0486eac0fb21786; });

var $7CtTT = parcelRequire("7CtTT");

var $1MgBx = parcelRequire("1MgBx");
function $d601d79e941cb926$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d601d79e941cb926$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d601d79e941cb926$var$ownKeys(Object(source), true).forEach(function(key) {
            $d601d79e941cb926$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d601d79e941cb926$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d601d79e941cb926$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d601d79e941cb926$export$79dccbf5b7f2d5b7(windowId, canvasId) {
    var newGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return function(dispatch, getState) {
        var state = getState();
        var visibleCanvases = newGroup;
        if (!visibleCanvases) {
            var group = (0, $1MgBx.getCanvasGrouping)(state, {
                canvasId: canvasId,
                windowId: windowId
            });
            visibleCanvases = (group || []).map(function(c) {
                return c.id;
            });
        }
        dispatch($d601d79e941cb926$var$_objectSpread($d601d79e941cb926$var$_objectSpread({}, options), {}, {
            canvasId: canvasId,
            type: (0, $7CtTT.default).SET_CANVAS,
            visibleCanvases: visibleCanvases,
            windowId: windowId
        }));
    };
}
function $d601d79e941cb926$export$1e4a8de4c7587fd5(windowId) {
    return function(dispatch, getState) {
        var state = getState();
        var newGroup = (0, $1MgBx.getNextCanvasGrouping)(state, {
            windowId: windowId
        });
        var ids = (newGroup || []).map(function(c) {
            return c.id;
        });
        newGroup && dispatch($d601d79e941cb926$export$79dccbf5b7f2d5b7(windowId, ids[0], ids));
    };
}
function $d601d79e941cb926$export$74924083e8ed6601(windowId) {
    return function(dispatch, getState) {
        var state = getState();
        var newGroup = (0, $1MgBx.getPreviousCanvasGrouping)(state, {
            windowId: windowId
        });
        var ids = (newGroup || []).map(function(c) {
            return c.id;
        });
        newGroup && dispatch($d601d79e941cb926$export$79dccbf5b7f2d5b7(windowId, ids[0], ids));
    };
}
function $d601d79e941cb926$export$b0486eac0fb21786(windowId, payload) {
    return {
        payload: payload,
        type: (0, $7CtTT.default).UPDATE_VIEWPORT,
        windowId: windowId
    };
}

});
parcelRegister("7CtTT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58c3469d3740e31b$export$2e2bcd8739ae039; });
/* eslint-disable sort-keys */ var $58c3469d3740e31b$var$ActionTypes = {
    ADD_COMPANION_WINDOW: "mirador/ADD_COMPANION_WINDOW",
    UPDATE_COMPANION_WINDOW: "mirador/UPDATE_COMPANION_WINDOW",
    REMOVE_COMPANION_WINDOW: "mirador/REMOVE_COMPANION_WINDOW",
    TOGGLE_TOC_NODE: "mirador/TOGGLE_TOC_NODE",
    UPDATE_WINDOW: "mirador/UPDATE_WINDOW",
    REQUEST_CANVAS_ANNOTATIONS: "mirador/REQUEST_CANVAS_ANNOTATIONS",
    HOVER_ANNOTATION: "mirador/HOVER_ANNOTATION",
    REQUEST_ANNOTATION: "mirador/REQUEST_ANNOTATION",
    RECEIVE_ANNOTATION: "mirador/RECEIVE_ANNOTATION",
    RECEIVE_ANNOTATION_FAILURE: "mirador/RECEIVE_ANNOTATION_FAILURE",
    DESELECT_ANNOTATION: "mirador/DESELECT_ANNOTATION",
    SELECT_ANNOTATION: "mirador/SELECT_ANNOTATION",
    TOGGLE_ANNOTATION_DISPLAY: "mirador/TOGGLE_ANNOTATION_DISPLAY",
    FOCUS_WINDOW: "mirador/FOCUS_WINDOW",
    SET_WORKSPACE_FULLSCREEN: "mirador/SET_WORKSPACE_FULLSCREEN",
    SET_WORKSPACE_VIEWPORT_POSITION: "mirador/SET_WORKSPACE_VIEWPORT_POSITION",
    ADD_MANIFEST: "mirador/ADD_MANIFEST",
    ADD_WINDOW: "mirador/ADD_WINDOW",
    ADD_ERROR: "mirador/ADD_ERROR",
    IMPORT_CONFIG: "mirador/IMPORT_CONFIG",
    IMPORT_MIRADOR_STATE: "mirador/IMPORT_MIRADOR_STATE",
    SET_CANVAS: "mirador/SET_CANVAS",
    MAXIMIZE_WINDOW: "mirador/MAXIMIZE_WINDOW",
    MINIMIZE_WINDOW: "mirador/MINIMIZE_WINDOW",
    UPDATE_WINDOW_POSITION: "mirador/UPDATE_WINDOW_POSITION",
    SET_WINDOW_SIZE: "mirador/SET_WINDOW_SIZE",
    REMOVE_WINDOW: "mirador/REMOVE_WINDOW",
    PICK_WINDOWING_SYSTEM: "mirador/PICK_WINDOWING_SYSTEM",
    REQUEST_MANIFEST: "mirador/REQUEST_MANIFEST",
    RECEIVE_MANIFEST: "mirador/RECEIVE_MANIFEST",
    RECEIVE_MANIFEST_FAILURE: "mirador/RECEIVE_MANIFEST_FAILURE",
    REMOVE_ERROR: "mirador/REMOVE_ERROR",
    SET_CONFIG: "mirador/SET_CONFIG",
    UPDATE_WORKSPACE: "mirador/UPDATE_WORKSPACE",
    SET_WINDOW_THUMBNAIL_POSITION: "mirador/SET_WINDOW_THUMBNAIL_POSITION",
    SET_WINDOW_VIEW_TYPE: "mirador/SET_WINDOW_VIEW_TYPE",
    SET_WORKSPACE_ADD_VISIBILITY: "mirador/SET_WORKSPACE_ADD_VISIBILITY",
    TOGGLE_WINDOW_SIDE_BAR: "mirador/TOGGLE_WINDOW_SIDE_BAR",
    TOGGLE_DRAGGING: "mirador/TOGGLE_DRAGGING",
    TOGGLE_ZOOM_CONTROLS: "mirador/TOGGLE_ZOOM_CONTROLS",
    UPDATE_CONFIG: "mirador/UPDATE_CONFIG",
    REMOVE_MANIFEST: "mirador/REMOVE_MANIFEST",
    REQUEST_INFO_RESPONSE: "mirador/REQUEST_INFO_RESPONSE",
    RECEIVE_INFO_RESPONSE: "mirador/RECEIVE_INFO_RESPONSE",
    RECEIVE_DEGRADED_INFO_RESPONSE: "mirador/RECEIVE_DEGRADED_INFO_RESPONSE",
    RECEIVE_INFO_RESPONSE_FAILURE: "mirador/RECEIVE_INFO_RESPONSE_FAILURE",
    REMOVE_INFO_RESPONSE: "mirador/REMOVE_INFO_RESPONSE",
    UPDATE_WORKSPACE_MOSAIC_LAYOUT: "mirador/UPDATE_WORKSPACE_MOSAIC_LAYOUT",
    UPDATE_VIEWPORT: "mirador/UPDATE_VIEWPORT",
    UPDATE_ELASTIC_WINDOW_LAYOUT: "mirador/UPDATE_ELASTIC_WINDOW_LAYOUT",
    ADD_AUTHENTICATION_REQUEST: "mirador/ADD_AUTHENTICATION_REQUEST",
    RESOLVE_AUTHENTICATION_REQUEST: "mirador/RESOLVE_AUTHENTICATION_REQUEST",
    REQUEST_ACCESS_TOKEN: "mirador/REQUEST_ACCESS_TOKEN",
    RECEIVE_ACCESS_TOKEN: "mirador/RECEIVE_ACCESS_TOKEN",
    RECEIVE_ACCESS_TOKEN_FAILURE: "mirador/RECEIVE_ACCESS_TOKEN_FAILURE",
    RESET_AUTHENTICATION_STATE: "mirador/RESET_AUTHENTICATION_STATE",
    CLEAR_ACCESS_TOKEN_QUEUE: "mirador/CLEAR_ACCESS_TOKEN_QUEUE",
    REQUEST_SEARCH: "mirador/REQUEST_SEARCH",
    RECEIVE_SEARCH: "mirador/RECEIVE_SEARCH",
    RECEIVE_SEARCH_FAILURE: "mirador/RECEIVE_SEARCH_FAILURE",
    REMOVE_SEARCH: "mirador/REMOVE_SEARCH",
    SET_CONTENT_SEARCH_CURRENT_ANNOTATIONS: "mirador/SET_CONTENT_SEARCH_CURRENT_ANNOTATIONS",
    UPDATE_LAYERS: "mirador/UPDATE_LAYERS",
    ADD_RESOURCE: "mirador/ADD_RESOURCE",
    REMOVE_RESOURCE: "mirador/REMOVE_RESOURCE",
    SHOW_COLLECTION_DIALOG: "mirador/SHOW_COLLECTION_DIALOG",
    HIDE_COLLECTION_DIALOG: "mirador/HIDE_COLLECTION_DIALOG"
};
var $58c3469d3740e31b$export$2e2bcd8739ae039 = $58c3469d3740e31b$var$ActionTypes;

});

parcelRegister("1MgBx", function(module, exports) {

$parcel$export(module.exports, "selectInfoResponses", function () { return $14b72771e7112bd9$export$9b1ab17709668543; });
$parcel$export(module.exports, "getCanvases", function () { return $14b72771e7112bd9$export$e14cfbafe6f397e7; });
$parcel$export(module.exports, "getCanvas", function () { return $14b72771e7112bd9$export$f80a6900d44a74ee; });
$parcel$export(module.exports, "getCurrentCanvas", function () { return $14b72771e7112bd9$export$e4fcede7b65762cd; });
$parcel$export(module.exports, "getVisibleCanvasIds", function () { return $14b72771e7112bd9$export$418559ffdb3cb079; });
$parcel$export(module.exports, "getVisibleCanvases", function () { return $14b72771e7112bd9$export$1bd6212fa88574fe; });
$parcel$export(module.exports, "getCanvasGroupings", function () { return $14b72771e7112bd9$export$c9dc139a80fd3994; });
$parcel$export(module.exports, "getCanvasGrouping", function () { return $14b72771e7112bd9$export$4bfc8a7d19a8dbb9; });
$parcel$export(module.exports, "getNextCanvasGrouping", function () { return $14b72771e7112bd9$export$252f4cf8f236fe05; });
$parcel$export(module.exports, "getPreviousCanvasGrouping", function () { return $14b72771e7112bd9$export$f55f90eafa702907; });
$parcel$export(module.exports, "getCanvasLabel", function () { return $14b72771e7112bd9$export$67034a5cb41eb1f3; });
$parcel$export(module.exports, "getCanvasDescription", function () { return $14b72771e7112bd9$export$800458d9fcd110c2; });
$parcel$export(module.exports, "getVisibleCanvasNonTiledResources", function () { return $14b72771e7112bd9$export$69f4600d35c3d957; });
$parcel$export(module.exports, "getVisibleCanvasVideoResources", function () { return $14b72771e7112bd9$export$83c2ad474239974b; });
$parcel$export(module.exports, "getVisibleCanvasCaptions", function () { return $14b72771e7112bd9$export$5e39c0cd1b2cadbb; });
$parcel$export(module.exports, "getVisibleCanvasAudioResources", function () { return $14b72771e7112bd9$export$d79742e53d61f753; });
$parcel$export(module.exports, "selectInfoResponse", function () { return $14b72771e7112bd9$export$cb6a2066ccc7a45e; });

var $1LbRi = parcelRequire("1LbRi");

var $bT1Wq = parcelRequire("bT1Wq");

var $ld60a = parcelRequire("ld60a");

var $izTcV = parcelRequire("izTcV");

var $fr77o = parcelRequire("fr77o");

var $dy9HC = parcelRequire("dy9HC");

var $51Gx5 = parcelRequire("51Gx5");

var $9E7MS = parcelRequire("9E7MS");
var $14b72771e7112bd9$export$9b1ab17709668543 = function selectInfoResponses(state) {
    return (0, $fr77o.miradorSlice)(state).infoResponses;
};
var $14b72771e7112bd9$export$e14cfbafe6f397e7 = (0, $1LbRi.createSelector)([
    (0, $51Gx5.getSequence)
], function(sequence) {
    return sequence && sequence.getCanvases() || [];
});
var $14b72771e7112bd9$export$f80a6900d44a74ee = (0, $1LbRi.createSelector)([
    (0, $51Gx5.getSequence),
    function(state, _ref) {
        var canvasId = _ref.canvasId;
        return canvasId;
    }
], function(sequence, canvasId) {
    if (!sequence || !canvasId) return undefined;
    return sequence.getCanvasById(canvasId);
});
var $14b72771e7112bd9$export$e4fcede7b65762cd = (0, $1LbRi.createSelector)([
    (0, $51Gx5.getSequence),
    (0, $dy9HC.getWindow)
], function(sequence, window) {
    if (!sequence || !window) return undefined;
    if (!window.canvasId) return sequence.getCanvasByIndex(0);
    return sequence.getCanvasById(window.canvasId);
});
var $14b72771e7112bd9$export$418559ffdb3cb079 = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWindow)
], function(window) {
    return window && (window.visibleCanvases || window.canvasId && [
        window.canvasId
    ]) || [];
});
var $14b72771e7112bd9$export$1bd6212fa88574fe = (0, $1LbRi.createSelector)([
    $14b72771e7112bd9$export$418559ffdb3cb079,
    $14b72771e7112bd9$export$e14cfbafe6f397e7
], function(canvasIds, canvases) {
    return (canvases || []).filter(function(c) {
        return canvasIds.includes(c.id);
    });
});
var $14b72771e7112bd9$export$c9dc139a80fd3994 = (0, $1LbRi.createSelector)([
    $14b72771e7112bd9$export$e14cfbafe6f397e7,
    (0, $9E7MS.getWindowViewType)
], function(canvases, view) {
    return canvases && new (0, $ld60a.default)(canvases, view).groupings();
});
var $14b72771e7112bd9$export$4bfc8a7d19a8dbb9 = (0, $1LbRi.createSelector)([
    $14b72771e7112bd9$export$c9dc139a80fd3994,
    function(state, _ref2) {
        var canvasId = _ref2.canvasId;
        return canvasId;
    }
], function(groupings, canvasId) {
    return groupings && groupings.find(function(group) {
        return group.some(function(c) {
            return c.id === canvasId;
        });
    }) || [];
});
var $14b72771e7112bd9$export$252f4cf8f236fe05 = (0, $1LbRi.createSelector)([
    $14b72771e7112bd9$export$c9dc139a80fd3994,
    $14b72771e7112bd9$export$e4fcede7b65762cd
], function(groupings, canvas, view) {
    if (!groupings || !canvas) return undefined;
    var currentGroupIndex = groupings.findIndex(function(group) {
        return group.some(function(c) {
            return c.id === canvas.id;
        });
    });
    if (currentGroupIndex < 0 || currentGroupIndex + 1 >= groupings.length) return undefined;
    var newGroup = groupings[currentGroupIndex + 1];
    return newGroup;
});
var $14b72771e7112bd9$export$f55f90eafa702907 = (0, $1LbRi.createSelector)([
    $14b72771e7112bd9$export$c9dc139a80fd3994,
    $14b72771e7112bd9$export$e4fcede7b65762cd
], function(groupings, canvas, view) {
    if (!groupings || !canvas) return undefined;
    var currentGroupIndex = groupings.findIndex(function(group) {
        return group.some(function(c) {
            return c.id === canvas.id;
        });
    });
    if (currentGroupIndex < 1) return undefined;
    var newGroup = groupings[currentGroupIndex - 1];
    return newGroup;
});
var $14b72771e7112bd9$export$67034a5cb41eb1f3 = (0, $1LbRi.createSelector)([
    $14b72771e7112bd9$export$f80a6900d44a74ee
], function(canvas) {
    return canvas && (canvas.getLabel().length > 0 ? canvas.getLabel().getValue() : String(canvas.index + 1));
});
var $14b72771e7112bd9$export$800458d9fcd110c2 = (0, $1LbRi.createSelector)([
    $14b72771e7112bd9$export$f80a6900d44a74ee
], function(canvas) {
    return canvas && canvas.getProperty("description");
});
var $14b72771e7112bd9$export$69f4600d35c3d957 = (0, $1LbRi.createSelector)([
    $14b72771e7112bd9$export$1bd6212fa88574fe
], function(canvases) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(canvases.map(function(canvas) {
        return new (0, $izTcV.default)(canvas).imageResources;
    })).filter(function(resource) {
        return resource.getServices().length < 1;
    });
});
var $14b72771e7112bd9$export$83c2ad474239974b = (0, $1LbRi.createSelector)([
    $14b72771e7112bd9$export$1bd6212fa88574fe
], function(canvases) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(canvases.map(function(canvas) {
        return new (0, $izTcV.default)(canvas).videoResources;
    }));
});
var $14b72771e7112bd9$export$5e39c0cd1b2cadbb = (0, $1LbRi.createSelector)([
    $14b72771e7112bd9$export$1bd6212fa88574fe
], function(canvases) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(canvases.map(function(canvas) {
        return new (0, $izTcV.default)(canvas).vttContent;
    }));
});
var $14b72771e7112bd9$export$d79742e53d61f753 = (0, $1LbRi.createSelector)([
    $14b72771e7112bd9$export$1bd6212fa88574fe
], function(canvases) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(canvases.map(function(canvas) {
        return new (0, $izTcV.default)(canvas).audioResources;
    }));
});
var $14b72771e7112bd9$export$cb6a2066ccc7a45e = (0, $1LbRi.createSelector)([
    function(state, _ref3) {
        var infoId = _ref3.infoId;
        return infoId;
    },
    $14b72771e7112bd9$export$f80a6900d44a74ee,
    $14b72771e7112bd9$export$9b1ab17709668543
], function(infoId, canvas, infoResponses) {
    var iiifServiceId = infoId;
    if (!infoId) {
        if (!canvas) return undefined;
        var miradorCanvas = new (0, $izTcV.default)(canvas);
        var image = miradorCanvas.iiifImageResources[0];
        iiifServiceId = image && image.getServices()[0].id;
    }
    return iiifServiceId && infoResponses[iiifServiceId] && !infoResponses[iiifServiceId].isFetching && infoResponses[iiifServiceId];
});

});
parcelRegister("1LbRi", function(module, exports) {

$parcel$export(module.exports, "createSelectorCreator", function () { return $1483611c30cd001a$export$5943f4447f6ef248; });
$parcel$export(module.exports, "createSelector", function () { return $1483611c30cd001a$export$595d22ed68ca2841; });
$parcel$export(module.exports, "createStructuredSelector", function () { return $1483611c30cd001a$export$75979cfcd91bf38f; });
$parcel$export(module.exports, "defaultMemoize", function () { return (parcelRequire("csBir")).defaultMemoize; });
$parcel$export(module.exports, "defaultEqualityCheck", function () { return (parcelRequire("csBir")).defaultEqualityCheck; });

var $csBir = parcelRequire("csBir");
function $1483611c30cd001a$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $1483611c30cd001a$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $1483611c30cd001a$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $1483611c30cd001a$export$595d22ed68ca2841 = /* #__PURE__ */ $1483611c30cd001a$export$5943f4447f6ef248((0, $csBir.defaultMemoize));
var $1483611c30cd001a$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $1483611c30cd001a$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("csBir", function(module, exports) {

$parcel$export(module.exports, "defaultEqualityCheck", function () { return $912507e1a39a885f$export$e0b28855d0126ccc; });
$parcel$export(module.exports, "defaultMemoize", function () { return $912507e1a39a885f$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $912507e1a39a885f$var$NOT_FOUND = "NOT_FOUND";
function $912507e1a39a885f$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $912507e1a39a885f$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $912507e1a39a885f$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $912507e1a39a885f$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $912507e1a39a885f$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $912507e1a39a885f$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $912507e1a39a885f$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $912507e1a39a885f$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $912507e1a39a885f$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $912507e1a39a885f$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $912507e1a39a885f$var$createSingletonCache(comparator) : $912507e1a39a885f$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $912507e1a39a885f$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("bT1Wq", function(module, exports) {

var $l83Sq = parcelRequire("l83Sq");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $8a765644c00ee283$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $l83Sq(array, 1) : [];
}
module.exports = $8a765644c00ee283$var$flatten;

});
parcelRegister("l83Sq", function(module, exports) {

var $gHWYa = parcelRequire("gHWYa");

var $lTYYz = parcelRequire("lTYYz");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $f61d5a2d34516e81$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $lTYYz);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $f61d5a2d34516e81$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $gHWYa(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $f61d5a2d34516e81$var$baseFlatten;

});
parcelRegister("gHWYa", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $c29e6792d4188700$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $c29e6792d4188700$var$arrayPush;

});

parcelRegister("lTYYz", function(module, exports) {

var $7MX8u = parcelRequire("7MX8u");

var $fc3fn = parcelRequire("fc3fn");

var $eDRhj = parcelRequire("eDRhj");
/** Built-in value references. */ var $ff1e089344f2d0b5$var$spreadableSymbol = $7MX8u ? $7MX8u.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $ff1e089344f2d0b5$var$isFlattenable(value) {
    return $eDRhj(value) || $fc3fn(value) || !!($ff1e089344f2d0b5$var$spreadableSymbol && value && value[$ff1e089344f2d0b5$var$spreadableSymbol]);
}
module.exports = $ff1e089344f2d0b5$var$isFlattenable;

});



parcelRegister("ld60a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f70f77af0d341215$export$2e2bcd8739ae039; });
function $f70f77af0d341215$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f70f77af0d341215$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f70f77af0d341215$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f70f77af0d341215$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f70f77af0d341215$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 *
 */ var $f70f77af0d341215$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   */ function CanvasGroupings(canvases) {
        var viewType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "single";
        $f70f77af0d341215$var$_classCallCheck(this, CanvasGroupings);
        this.canvases = canvases;
        this.viewType = viewType;
        this._groupings = null; // eslint-disable-line no-underscore-dangle
    }
    /**
   */ $f70f77af0d341215$var$_createClass(CanvasGroupings, [
        {
            key: "getCanvases",
            value: function getCanvases(index) {
                switch(this.viewType){
                    case "book":
                        return this.groupings()[Math.ceil(index / 2)];
                    default:
                        return this.groupings()[index];
                }
            }
        },
        {
            key: "groupings",
            value: function groupings() {
                if (this._groupings) // eslint-disable-line no-underscore-dangle
                return this._groupings; // eslint-disable-line no-underscore-dangle
                if (this.viewType === "scroll") return [
                    this.canvases
                ];
                if (this.viewType !== "book") return this.canvases.map(function(canvas) {
                    return [
                        canvas
                    ];
                });
                var groupings = [];
                this.canvases.forEach(function(canvas, i) {
                    if (i === 0) {
                        groupings.push([
                            canvas
                        ]);
                        return;
                    } // Odd page
                    if (i % 2 !== 0) groupings.push([
                        canvas
                    ]);
                    else // Even page
                    groupings[Math.ceil(i / 2)].push(canvas);
                });
                this._groupings = groupings; // eslint-disable-line no-underscore-dangle
                return groupings;
            }
        }
    ]);
    return CanvasGroupings;
}();

});

parcelRegister("izTcV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d86651e96e20699e$export$2e2bcd8739ae039; });

var $bT1Wq = parcelRequire("bT1Wq");

var $8baTt = parcelRequire("8baTt");

var $a4sDT = parcelRequire("a4sDT");
function $d86651e96e20699e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d86651e96e20699e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d86651e96e20699e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d86651e96e20699e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d86651e96e20699e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * MiradorCanvas - adds additional, testable logic around Manifesto's Canvas
 * https://iiif-commons.github.io/manifesto/classes/_canvas_.manifesto.canvas.html
 */ var $d86651e96e20699e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {MiradorCanvas} canvas
   */ function MiradorCanvas(canvas) {
        $d86651e96e20699e$var$_classCallCheck(this, MiradorCanvas);
        this.canvas = canvas;
    }
    /** */ $d86651e96e20699e$var$_createClass(MiradorCanvas, [
        {
            key: "id",
            get: function get() {
                return this.canvas.id;
            }
        },
        {
            key: "getWidth",
            value: function getWidth() {
                return this.canvas.getWidth();
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                return this.canvas.getHeight();
            }
        },
        {
            key: "aspectRatio",
            get: function get() {
                return this.canvas.getWidth() / this.canvas.getHeight();
            }
        },
        {
            key: "annotationListUris",
            get: function get() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(new Array(this.canvas.__jsonld.otherContent) // eslint-disable-line no-underscore-dangle
                ).filter(function(otherContent) {
                    return otherContent && (typeof otherContent === "string" || otherContent["@type"] === "sc:AnnotationList");
                }).map(function(otherContent) {
                    return typeof otherContent === "string" ? otherContent : otherContent["@id"];
                });
            }
        },
        {
            key: "canvasAnnotationPages",
            get: function get() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(new Array(this.canvas.__jsonld.annotations) // eslint-disable-line no-underscore-dangle
                ).filter(function(annotations) {
                    return annotations && annotations.type === "AnnotationPage";
                });
            }
        },
        {
            key: "imageResource",
            get: function get() {
                return this.imageResources[0];
            }
        },
        {
            key: "imageResources",
            get: function get() {
                var _this = this;
                var resources = (0, (/*@__PURE__*/$parcel$interopDefault($8baTt)))([
                    this.canvas.getImages().map(function(i) {
                        return i.getResource();
                    }),
                    this.canvas.getContent().map(function(i) {
                        return i.getBody();
                    })
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(resources.map(function(resource) {
                    switch(resource.getProperty("type")){
                        case "oa:Choice":
                            return new (0, $a4sDT.Canvas)({
                                images: (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))([
                                    resource.getProperty("default"),
                                    resource.getProperty("item")
                                ]).map(function(r) {
                                    return {
                                        resource: r
                                    };
                                })
                            }, _this.canvas.options).getImages().map(function(i) {
                                return i.getResource();
                            });
                        default:
                            return resource;
                    }
                }));
            }
        },
        {
            key: "videoResources",
            get: function get() {
                var resources = (0, (/*@__PURE__*/$parcel$interopDefault($8baTt)))([
                    this.canvas.getContent().map(function(i) {
                        return i.getBody();
                    })
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(resources.filter(function(resource) {
                    return resource.getProperty("type") === "Video";
                }));
            }
        },
        {
            key: "audioResources",
            get: function get() {
                var resources = (0, (/*@__PURE__*/$parcel$interopDefault($8baTt)))([
                    this.canvas.getContent().map(function(i) {
                        return i.getBody();
                    })
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(resources.filter(function(resource) {
                    return resource.getProperty("type") === "Sound";
                }));
            }
        },
        {
            key: "vttContent",
            get: function get() {
                var resources = (0, (/*@__PURE__*/$parcel$interopDefault($8baTt)))([
                    this.canvas.getContent().map(function(i) {
                        return i.getBody();
                    })
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(resources.filter(function(resource) {
                    return resource.getProperty("format") === "text/vtt";
                }));
            }
        },
        {
            key: "resourceAnnotations",
            get: function get() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($8baTt)))([
                    this.canvas.getImages(),
                    this.canvas.getContent()
                ]);
            }
        },
        {
            key: "resourceAnnotation",
            value: function resourceAnnotation(id) {
                return this.resourceAnnotations.find(function(anno) {
                    return anno.getResource().id === id || (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(new Array(anno.getBody())).some(function(body) {
                        return body.id === id;
                    });
                });
            }
        },
        {
            key: "onFragment",
            value: function onFragment(id) {
                var resourceAnnotation = this.resourceAnnotation(id);
                if (!resourceAnnotation) return undefined; // IIIF v2
                var on = resourceAnnotation.getProperty("on"); // IIIF v3
                var target = resourceAnnotation.getProperty("target");
                var fragmentMatch = (on || target).match(/xywh=(.*)$/);
                if (!fragmentMatch) return undefined;
                return fragmentMatch[1].split(",").map(function(str) {
                    return parseInt(str, 10);
                });
            }
        },
        {
            key: "iiifImageResources",
            get: function get() {
                return this.imageResources.filter(function(r) {
                    return r && r.getServices()[0] && r.getServices()[0].id;
                });
            }
        },
        {
            key: "imageServiceIds",
            get: function get() {
                return this.iiifImageResources.map(function(r) {
                    return r.getServices()[0].id;
                });
            }
        },
        {
            key: "service",
            get: function get() {
                return this.canvas.__jsonld.service; // eslint-disable-line no-underscore-dangle
            }
        },
        {
            key: "getLabel",
            value: function getLabel() {
                return this.canvas.getLabel().length > 0 ? this.canvas.getLabel().getValue() : String(this.canvas.index + 1);
            }
        }
    ]);
    return MiradorCanvas;
}();

});
parcelRegister("8baTt", function(module, exports) {

var $l83Sq = parcelRequire("l83Sq");
/** Used as references for various `Number` constants. */ var $5f47cd145060359d$var$INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function $5f47cd145060359d$var$flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? $l83Sq(array, $5f47cd145060359d$var$INFINITY) : [];
}
module.exports = $5f47cd145060359d$var$flattenDeep;

});

parcelRegister("a4sDT", function(module, exports) {
!function(e, t) {
    module.exports = t();
}("undefined" != typeof self ? self : module.exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 7);
    }([
        function(e, t, r) {
            "use strict";
            function n(e) {
                for(var r in e)t.hasOwnProperty(r) || (t[r] = e[r]);
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), n(r(9)), n(r(10)), n(r(11)), n(r(12)), n(r(13)), n(r(14)), n(r(15)), n(r(16)), n(r(17)), n(r(31)), n(r(32)), n(r(33)), n(r(34)), n(r(35)), n(r(38)), n(r(39)), n(r(40)), n(r(41)), n(r(42)), n(r(43)), n(r(44)), n(r(45)), n(r(46)), n(r(47)), n(r(48)), n(r(49)), n(r(50)), n(r(3));
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), function(e) {
                e.BOOKMARKING = "oa:bookmarking", e.CLASSIFYING = "oa:classifying", e.COMMENTING = "oa:commenting", e.DESCRIBING = "oa:describing", e.EDITING = "oa:editing", e.HIGHLIGHTING = "oa:highlighting", e.IDENTIFYING = "oa:identifying", e.LINKING = "oa:linking", e.MODERATING = "oa:moderating", e.PAINTING = "sc:painting", e.QUESTIONING = "oa:questioning", e.REPLYING = "oa:replying", e.TAGGING = "oa:tagging", e.TRANSCRIBING = "oad:transcribing";
            }(t.AnnotationMotivation || (t.AnnotationMotivation = {})), function(e) {
                e.AUTO_ADVANCE = "auto-advance", e.CONTINUOUS = "continuous", e.FACING_PAGES = "facing-pages", e.HIDDEN = "hidden", e.INDIVIDUALS = "individuals", e.MULTI_PART = "multi-part", e.NO_NAV = "no-nav", e.NON_PAGED = "non-paged", e.PAGED = "paged", e.REPEAT = "repeat", e.SEQUENCE = "sequence", e.THUMBNAIL_NAV = "thumbnail-nav", e.TOGETHER = "together", e.UNORDERED = "unordered";
            }(t.Behavior || (t.Behavior = {})), function(e) {
                e.CANVAS = "canvas", e.CHOICE = "choice", e.OA_CHOICE = "oa:choice", e.CONTENT_AS_TEXT = "contentastext", e.DATASET = "dataset", e.DOCUMENT = "document", e.IMAGE = "image", e.MODEL = "model", e.MOVING_IMAGE = "movingimage", e.PDF = "pdf", e.PHYSICAL_OBJECT = "physicalobject", e.SOUND = "sound", e.TEXT = "text", e.TEXTUALBODY = "textualbody", e.VIDEO = "video";
            }(t.ExternalResourceType || (t.ExternalResourceType = {})), function(e) {
                e.ANNOTATION = "annotation", e.CANVAS = "canvas", e.COLLECTION = "collection", e.MANIFEST = "manifest", e.RANGE = "range", e.SEQUENCE = "sequence";
            }(t.IIIFResourceType || (t.IIIFResourceType = {})), function(e) {
                e.AUDIO_MP4 = "audio/mp4", e.CORTO = "application/corto", e.DICOM = "application/dicom", e.DRACO = "application/draco", e.EPUB = "application/epub+zip", e.GIRDER = "image/vnd.kitware.girder", e.GLB = "model/gltf-binary", e.GLTF = "model/gltf+json", e.IIIF_PRESENTATION_2 = 'application/ld+json;profile="http://iiif.io/api/presentation/2/context.json"', e.IIIF_PRESENTATION_3 = 'application/ld+json;profile="http://iiif.io/api/presentation/3/context.json"', e.JPG = "image/jpeg", e.M3U8 = "application/vnd.apple.mpegurl", e.MP3 = "audio/mp3", e.MPEG_DASH = "application/dash+xml", e.OBJ = "text/plain", e.OPF = "application/oebps-package+xml", e.PDF = "application/pdf", e.PLY = "application/ply", e.THREEJS = "application/vnd.threejs+json", e.USDZ = "model/vnd.usd+zip", e.VIDEO_MP4 = "video/mp4", e.WAV = "audio/wav", e.WEBM = "video/webm";
            }(t.MediaType || (t.MediaType = {})), function(e) {
                e.DOC = "application/msword", e.DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document", e.PDF = "application/pdf";
            }(t.RenderingFormat || (t.RenderingFormat = {})), function(e) {
                e.IMAGE_0_COMPLIANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/compliance.html#level0", e.IMAGE_0_COMPLIANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/compliance.html#level1", e.IMAGE_0_COMPLIANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/compliance.html#level2", e.IMAGE_0_CONFORMANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/conformance.html#level0", e.IMAGE_0_CONFORMANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/conformance.html#level1", e.IMAGE_0_CONFORMANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/conformance.html#level2", e.IMAGE_1_COMPLIANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0", e.IMAGE_1_COMPLIANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level1", e.IMAGE_1_COMPLIANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2", e.IMAGE_1_CONFORMANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level0", e.IMAGE_1_CONFORMANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level1", e.IMAGE_1_CONFORMANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level2", e.IMAGE_1_LEVEL_0 = "http://iiif.io/api/image/1/level0.json", e.IMAGE_1_PROFILE_LEVEL_0 = "http://iiif.io/api/image/1/profiles/level0.json", e.IMAGE_1_LEVEL_1 = "http://iiif.io/api/image/1/level1.json", e.IMAGE_1_PROFILE_LEVEL_1 = "http://iiif.io/api/image/1/profiles/level1.json", e.IMAGE_1_LEVEL_2 = "http://iiif.io/api/image/1/level2.json", e.IMAGE_1_PROFILE_LEVEL_2 = "http://iiif.io/api/image/1/profiles/level2.json", e.IMAGE_2_LEVEL_0 = "http://iiif.io/api/image/2/level0.json", e.IMAGE_2_PROFILE_LEVEL_0 = "http://iiif.io/api/image/2/profiles/level0.json", e.IMAGE_2_LEVEL_1 = "http://iiif.io/api/image/2/level1.json", e.IMAGE_2_PROFILE_LEVEL_1 = "http://iiif.io/api/image/2/profiles/level1.json", e.IMAGE_2_LEVEL_2 = "http://iiif.io/api/image/2/level2.json", e.IMAGE_2_PROFILE_LEVEL_2 = "http://iiif.io/api/image/2/profiles/level2.json", e.AUTH_0_CLICK_THROUGH = "http://iiif.io/api/auth/0/login/clickthrough", e.AUTH_0_LOGIN = "http://iiif.io/api/auth/0/login", e.AUTH_0_LOGOUT = "http://iiif.io/api/auth/0/logout", e.AUTH_0_RESTRICTED = "http://iiif.io/api/auth/0/login/restricted", e.AUTH_0_TOKEN = "http://iiif.io/api/auth/0/token", e.AUTH_1_CLICK_THROUGH = "http://iiif.io/api/auth/1/clickthrough", e.AUTH_1_EXTERNAL = "http://iiif.io/api/auth/1/external", e.AUTH_1_KIOSK = "http://iiif.io/api/auth/1/kiosk", e.AUTH_1_LOGIN = "http://iiif.io/api/auth/1/login", e.AUTH_1_LOGOUT = "http://iiif.io/api/auth/1/logout", e.AUTH_1_PROBE = "http://iiif.io/api/auth/1/probe", e.AUTH_1_TOKEN = "http://iiif.io/api/auth/1/token", e.SEARCH_0 = "http://iiif.io/api/search/0/search", e.SEARCH_0_AUTO_COMPLETE = "http://iiif.io/api/search/0/autocomplete", e.SEARCH_1 = "http://iiif.io/api/search/1/search", e.SEARCH_1_AUTO_COMPLETE = "http://iiif.io/api/search/1/autocomplete", e.TRACKING_EXTENSIONS = "http://universalviewer.io/tracking-extensions-profile", e.UI_EXTENSIONS = "http://universalviewer.io/ui-extensions-profile", e.PRINT_EXTENSIONS = "http://universalviewer.io/print-extensions-profile", e.SHARE_EXTENSIONS = "http://universalviewer.io/share-extensions-profile", e.DOWNLOAD_EXTENSIONS = "http://universalviewer.io/download-extensions-profile", e.OTHER_MANIFESTATIONS = "http://iiif.io/api/otherManifestations.json", e.IXIF = "http://wellcomelibrary.org/ld/ixif/0/alpha.json";
            }(t.ServiceProfile || (t.ServiceProfile = {})), function(e) {
                e.IMAGE_SERVICE_2 = "ImageService2", e.IMAGE_SERVICE_3 = "ImageService3";
            }(t.ServiceType || (t.ServiceType = {})), function(e) {
                e.BOTTOM_TO_TOP = "bottom-to-top", e.LEFT_TO_RIGHT = "left-to-right", e.RIGHT_TO_LEFT = "right-to-left", e.TOP_TO_BOTTOM = "top-to-bottom";
            }(t.ViewingDirection || (t.ViewingDirection = {})), function(e) {
                e.CONTINUOUS = "continuous", e.INDIVIDUALS = "individuals", e.NON_PAGED = "non-paged", e.PAGED = "paged", e.TOP = "top";
            }(t.ViewingHint || (t.ViewingHint = {}));
        },
        function(e, t, r) {
            var n = r(21).Symbol;
            e.exports = n;
        },
        function(e, t, r) {
            "use strict";
            var n = this && this.__awaiter || function(e, t, r, n) {
                return new (r || (r = Promise))(function(i, o) {
                    function a(e) {
                        try {
                            u(n.next(e));
                        } catch (e) {
                            o(e);
                        }
                    }
                    function s(e) {
                        try {
                            u(n.throw(e));
                        } catch (e) {
                            o(e);
                        }
                    }
                    function u(e) {
                        var t;
                        e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                            e(t);
                        })).then(a, s);
                    }
                    u((n = n.apply(e, t || [])).next());
                });
            }, i = this && this.__generator || function(e, t) {
                var r, n, i, o, a = {
                    label: 0,
                    sent: function() {
                        if (1 & i[0]) throw i[1];
                        return i[1];
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: s(0),
                    throw: s(1),
                    return: s(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                    return this;
                }), o;
                function s(o) {
                    return function(s) {
                        return function(o) {
                            if (r) throw new TypeError("Generator is already executing.");
                            for(; a;)try {
                                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                                switch(n = 0, i && (o = [
                                    2 & o[0],
                                    i.value
                                ]), o[0]){
                                    case 0:
                                    case 1:
                                        i = o;
                                        break;
                                    case 4:
                                        return a.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        a.label++, n = o[1], o = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        o = a.ops.pop(), a.trys.pop();
                                        continue;
                                    default:
                                        if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                                            a = 0;
                                            continue;
                                        }
                                        if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                            a.label = o[1];
                                            break;
                                        }
                                        if (6 === o[0] && a.label < i[1]) {
                                            a.label = i[1], i = o;
                                            break;
                                        }
                                        if (i && a.label < i[2]) {
                                            a.label = i[2], a.ops.push(o);
                                            break;
                                        }
                                        i[2] && a.ops.pop(), a.trys.pop();
                                        continue;
                                }
                                o = t.call(e, a);
                            } catch (e) {
                                o = [
                                    6,
                                    e
                                ], n = 0;
                            } finally{
                                r = i = 0;
                            }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            };
                        }([
                            o,
                            s
                        ]);
                    };
                }
            };
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = r(0), a = r(1), s = r(36);
            r(37);
            var u = function() {
                function e() {}
                return e.getMediaType = function(e) {
                    return (e = (e = e.toLowerCase()).split(";")[0]).trim();
                }, e.getImageQuality = function(e) {
                    return e === a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_1 || e === a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_2 || e === a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_1 || e === a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_2 || e === a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_1 || e === a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_2 || e === a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_1 || e === a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_2 || e === a.ServiceProfile.IMAGE_1_LEVEL_1 || e === a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_1 || e === a.ServiceProfile.IMAGE_1_LEVEL_2 || e === a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_2 ? "native" : "default";
                }, e.getInexactLocale = function(e) {
                    return -1 !== e.indexOf("-") ? e.substr(0, e.indexOf("-")) : e;
                }, e.getLocalisedValue = function(e, t) {
                    if (!Array.isArray(e)) return e;
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        if (t === n["@language"]) return n["@value"];
                    }
                    var i = t.substr(0, t.indexOf("-"));
                    for(r = 0; r < e.length; r++){
                        var o = e[r];
                        if (o["@language"] === i) return o["@value"];
                    }
                    return null;
                }, e.generateTreeNodeIds = function(t, r) {
                    var n;
                    void 0 === r && (r = 0), n = t.parentNode ? t.parentNode.id + "-" + r : "0", t.id = n;
                    for(var i = 0; i < t.nodes.length; i++){
                        var o = t.nodes[i];
                        e.generateTreeNodeIds(o, i);
                    }
                }, e.normaliseType = function(e) {
                    return -1 !== (e = (e || "").toLowerCase()).indexOf(":") ? e.split(":")[1] : e;
                }, e.normaliseUrl = function(e) {
                    return -1 !== (e = e.substr(e.indexOf("://"))).indexOf("#") && (e = e.split("#")[0]), e;
                }, e.normalisedUrlsMatch = function(t, r) {
                    return e.normaliseUrl(t) === e.normaliseUrl(r);
                }, e.isImageProfile = function(t) {
                    return !!(e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_PROFILE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_PROFILE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_PROFILE_LEVEL_2));
                }, e.isImageServiceType = function(e) {
                    return null !== e && e.toLowerCase() === a.ServiceType.IMAGE_SERVICE_2.toLowerCase() || e === a.ServiceType.IMAGE_SERVICE_3.toLowerCase();
                }, e.isLevel0ImageProfile = function(t) {
                    return !!(e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_PROFILE_LEVEL_0));
                }, e.isLevel1ImageProfile = function(t) {
                    return !!(e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_PROFILE_LEVEL_1));
                }, e.isLevel2ImageProfile = function(t) {
                    return !!(e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_PROFILE_LEVEL_2));
                }, e.parseManifest = function(e, t) {
                    return o.Deserialiser.parse(e, t);
                }, e.checkStatus = function(e) {
                    if (e.ok) return e;
                    var t = new Error(e.statusText);
                    return t.response = e, Promise.reject(t);
                }, e.loadManifest = function(t) {
                    return new Promise(function(r, n) {
                        fetch(t).then(e.checkStatus).then(function(e) {
                            return e.json();
                        }).then(function(e) {
                            r(e);
                        }).catch(function(e) {
                            n();
                        });
                    });
                }, e.loadExternalResourcesAuth1 = function(t, r, n, i, o, a, s, u) {
                    return new Promise(function(c, l) {
                        var p = t.map(function(t) {
                            return e.loadExternalResourceAuth1(t, r, n, i, o, a, s, u);
                        });
                        Promise.all(p).then(function() {
                            c(t);
                        }).catch(function(e) {
                            l(e);
                        });
                    });
                }, e.loadExternalResourceAuth1 = function(t, r, o, a, u, c, l, p) {
                    return n(this, void 0, void 0, function() {
                        var n;
                        return i(this, function(i) {
                            switch(i.label){
                                case 0:
                                    return [
                                        4,
                                        a(t)
                                    ];
                                case 1:
                                    return (n = i.sent()) ? [
                                        4,
                                        t.getData(n)
                                    ] : [
                                        3,
                                        6
                                    ];
                                case 2:
                                    return i.sent(), t.status !== s.OK ? [
                                        3,
                                        3
                                    ] : [
                                        2,
                                        t
                                    ];
                                case 3:
                                    return [
                                        4,
                                        e.doAuthChain(t, r, o, u, c, l, p)
                                    ];
                                case 4:
                                    i.sent(), i.label = 5;
                                case 5:
                                    if (t.status === s.OK || t.status === s.MOVED_TEMPORARILY) return [
                                        2,
                                        t
                                    ];
                                    throw e.createAuthorizationFailedError();
                                case 6:
                                    return [
                                        4,
                                        t.getData()
                                    ];
                                case 7:
                                    return i.sent(), t.status !== s.MOVED_TEMPORARILY && t.status !== s.UNAUTHORIZED ? [
                                        3,
                                        9
                                    ] : [
                                        4,
                                        e.doAuthChain(t, r, o, u, c, l, p)
                                    ];
                                case 8:
                                    i.sent(), i.label = 9;
                                case 9:
                                    if (t.status === s.OK || t.status === s.MOVED_TEMPORARILY) return [
                                        2,
                                        t
                                    ];
                                    throw e.createAuthorizationFailedError();
                            }
                        });
                    });
                }, e.doAuthChain = function(t, r, o, a, u, c, l) {
                    return n(this, void 0, void 0, function() {
                        var n, p, f, h, _, g, d, v;
                        return i(this, function(i) {
                            switch(i.label){
                                case 0:
                                    return t.isAccessControlled() ? ((n = t.externalService) && (n.options = t.options), (p = t.kioskService) && (p.options = t.options), (f = t.clickThroughService) && (f.options = t.options), (h = t.loginService) && (h.options = t.options), t.isResponseHandled || t.status !== s.MOVED_TEMPORARILY ? [
                                        3,
                                        2
                                    ] : [
                                        4,
                                        c(t)
                                    ]) : [
                                        2,
                                        t
                                    ];
                                case 1:
                                    return i.sent(), [
                                        2,
                                        t
                                    ];
                                case 2:
                                    return _ = null, g = null, (_ = n) ? (g = _, [
                                        4,
                                        e.attemptResourceWithToken(t, o, _)
                                    ]) : [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return i.sent(), [
                                        2,
                                        t
                                    ];
                                case 4:
                                    return (_ = p) ? (g = _, (d = r(_)) ? [
                                        4,
                                        a(d)
                                    ] : [
                                        3,
                                        7
                                    ]) : [
                                        3,
                                        7
                                    ];
                                case 5:
                                    return i.sent(), [
                                        4,
                                        e.attemptResourceWithToken(t, o, _)
                                    ];
                                case 6:
                                    return i.sent(), [
                                        2,
                                        t
                                    ];
                                case 7:
                                    return (_ = f) ? (g = _, [
                                        4,
                                        u(t, _)
                                    ]) : [
                                        3,
                                        11
                                    ];
                                case 8:
                                    return (v = i.sent()) ? [
                                        4,
                                        a(v)
                                    ] : [
                                        3,
                                        11
                                    ];
                                case 9:
                                    return i.sent(), [
                                        4,
                                        e.attemptResourceWithToken(t, o, _)
                                    ];
                                case 10:
                                    return i.sent(), [
                                        2,
                                        t
                                    ];
                                case 11:
                                    return (_ = h) ? (g = _, [
                                        4,
                                        u(t, _)
                                    ]) : [
                                        3,
                                        15
                                    ];
                                case 12:
                                    return (v = i.sent()) ? [
                                        4,
                                        a(v)
                                    ] : [
                                        3,
                                        15
                                    ];
                                case 13:
                                    return i.sent(), [
                                        4,
                                        e.attemptResourceWithToken(t, o, _)
                                    ];
                                case 14:
                                    return i.sent(), [
                                        2,
                                        t
                                    ];
                                case 15:
                                    return g && l(t, g), [
                                        2
                                    ];
                            }
                        });
                    });
                }, e.attemptResourceWithToken = function(e, t, r) {
                    return n(this, void 0, void 0, function() {
                        var n, o;
                        return i(this, function(i) {
                            switch(i.label){
                                case 0:
                                    return (n = r.getService(a.ServiceProfile.AUTH_1_TOKEN)) ? [
                                        4,
                                        t(e, n)
                                    ] : [
                                        3,
                                        3
                                    ];
                                case 1:
                                    return (o = i.sent()) && o.accessToken ? [
                                        4,
                                        e.getData(o)
                                    ] : [
                                        3,
                                        3
                                    ];
                                case 2:
                                    return i.sent(), [
                                        2,
                                        e
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }, e.loadExternalResourcesAuth09 = function(t, r, n, i, o, a, s, u, c, l) {
                    return new Promise(function(p, f) {
                        var h = t.map(function(t) {
                            return e.loadExternalResourceAuth09(t, r, n, i, o, a, s, u, c, l);
                        });
                        Promise.all(h).then(function() {
                            p(t);
                        }).catch(function(e) {
                            f(e);
                        });
                    });
                }, e.loadExternalResourceAuth09 = function(t, r, n, i, o, a, u, c, l, p) {
                    return new Promise(function(f, h) {
                        p && p.pessimisticAccessControl ? t.getData().then(function() {
                            t.isAccessControlled() ? t.clickThroughService ? (f(n(t)), f(i(t))) : o(t).then(function() {
                                a(t, !0).then(function(r) {
                                    t.getData(r).then(function() {
                                        f(l(t));
                                    }).catch(function(t) {
                                        h(e.createInternalServerError(t));
                                    });
                                }).catch(function(t) {
                                    h(e.createInternalServerError(t));
                                });
                            }).catch(function(t) {
                                h(e.createInternalServerError(t));
                            }) : f(t);
                        }).catch(function(t) {
                            h(e.createInternalServerError(t));
                        }) : c(t, r).then(function(p) {
                            p ? t.getData(p).then(function() {
                                t.status === s.OK ? f(l(t)) : e.authorize(t, r, n, i, o, a, u, c).then(function() {
                                    f(l(t));
                                }).catch(function(t) {
                                    h(e.createAuthorizationFailedError());
                                });
                            }).catch(function(t) {
                                h(e.createAuthorizationFailedError());
                            }) : e.authorize(t, r, n, i, o, a, u, c).then(function() {
                                f(l(t));
                            }).catch(function(t) {
                                h(e.createAuthorizationFailedError());
                            });
                        }).catch(function(t) {
                            h(e.createAuthorizationFailedError());
                        });
                    });
                }, e.createError = function(e, t) {
                    var r = new Error;
                    return r.message = t, r.name = String(e), r;
                }, e.createAuthorizationFailedError = function() {
                    return e.createError(o.StatusCode.AUTHORIZATION_FAILED, "Authorization failed");
                }, e.createRestrictedError = function() {
                    return e.createError(o.StatusCode.RESTRICTED, "Restricted");
                }, e.createInternalServerError = function(t) {
                    return e.createError(o.StatusCode.INTERNAL_SERVER_ERROR, t);
                }, e.authorize = function(t, r, n, i, o, a, u, c) {
                    return new Promise(function(l, p) {
                        t.getData().then(function() {
                            t.isAccessControlled() ? c(t, r).then(function(c) {
                                c ? t.getData(c).then(function() {
                                    t.status === s.OK ? l(t) : e.showAuthInteraction(t, r, n, i, o, a, u, l, p);
                                }).catch(function(t) {
                                    p(e.createInternalServerError(t));
                                }) : a(t, !1).then(function(c) {
                                    c ? u(t, c, r).then(function() {
                                        t.getData(c).then(function() {
                                            t.status === s.OK ? l(t) : e.showAuthInteraction(t, r, n, i, o, a, u, l, p);
                                        }).catch(function(t) {
                                            p(e.createInternalServerError(t));
                                        });
                                    }).catch(function(t) {
                                        p(e.createInternalServerError(t));
                                    }) : e.showAuthInteraction(t, r, n, i, o, a, u, l, p);
                                });
                            }).catch(function(t) {
                                p(e.createInternalServerError(t));
                            }) : l(t);
                        });
                    });
                }, e.showAuthInteraction = function(t, r, n, i, o, a, u, c, l) {
                    t.status !== s.MOVED_TEMPORARILY || t.isResponseHandled ? t.clickThroughService && !t.isResponseHandled ? n(t).then(function() {
                        a(t, !0).then(function(n) {
                            u(t, n, r).then(function() {
                                t.getData(n).then(function() {
                                    c(t);
                                }).catch(function(t) {
                                    l(e.createInternalServerError(t));
                                });
                            }).catch(function(t) {
                                l(e.createInternalServerError(t));
                            });
                        }).catch(function(t) {
                            l(e.createInternalServerError(t));
                        });
                    }) : o(t).then(function() {
                        a(t, !0).then(function(n) {
                            u(t, n, r).then(function() {
                                t.getData(n).then(function() {
                                    c(t);
                                }).catch(function(t) {
                                    l(e.createInternalServerError(t));
                                });
                            }).catch(function(t) {
                                l(e.createInternalServerError(t));
                            });
                        }).catch(function(t) {
                            l(e.createInternalServerError(t));
                        });
                    }) : c(t);
                }, e.getService = function(e, t) {
                    for(var r = this.getServices(e), n = 0; n < r.length; n++){
                        var i = r[n];
                        if (i.getProfile() === t) return i;
                    }
                    return null;
                }, e.getResourceById = function(t, r) {
                    return e.traverseAndFind(t.__jsonld, "@id", r);
                }, e.traverseAndFind = function(t, r, n) {
                    if (t.hasOwnProperty(r) && t[r] === n) return t;
                    for(var i = 0; i < Object.keys(t).length; i++)if ("object" == typeof t[Object.keys(t)[i]]) {
                        var o = e.traverseAndFind(t[Object.keys(t)[i]], r, n);
                        if (null != o) return o;
                    }
                }, e.getServices = function(t, r) {
                    var n = void 0 === r ? {} : r, i = n.onlyService, a = void 0 !== i && i, s = n.onlyServices, u = void 0 !== s && s, c = n.skipParentResources, l = [];
                    !(void 0 !== c && c) && t && t.options && t.options.resource && t.options.resource !== t && l.push.apply(l, e.getServices(t.options.resource, {
                        onlyServices: !0
                    }));
                    var p = u ? [] : (t.__jsonld || t).service || [];
                    if (Array.isArray(p) || (p = [
                        p
                    ]), a || p.push.apply(p, (t.__jsonld || t).services || []), 0 === p.length) return l;
                    for(var f = 0; f < p.length; f++){
                        var h = p[f];
                        if ("string" == typeof h) {
                            var _ = this.getResourceById(t.options.resource, h);
                            _ && l.push(new o.Service(_.__jsonld || _, t.options));
                        } else l.push(new o.Service(h, t.options));
                    }
                    return l;
                }, e.getTemporalComponent = function(e) {
                    var t = /t=([^&]+)/g.exec(e), r = null;
                    return t && t[1] && (r = t[1].split(",")), r;
                }, e;
            }();
            t.Utils = u;
        },
        function(e, t, r) {
            var n = r(19), i = r(20);
            e.exports = function e(t, r, o, a, s) {
                var u = -1, c = t.length;
                for(o || (o = i), s || (s = []); ++u < c;){
                    var l = t[u];
                    r > 0 && o(l) ? r > 1 ? e(l, r - 1, o, a, s) : n(s, l) : a || (s[s.length] = l);
                }
                return s;
            };
        },
        function(e, t) {
            e.exports = function(e) {
                return null != e && "object" == typeof e;
            };
        },
        function(e, t, r) {
            "use strict";
            r.r(t), t.default = function(e, t) {
                return t = t || {}, new Promise(function(r, n) {
                    var i = new XMLHttpRequest, o = [], a = [], s = {}, u = function() {
                        return {
                            ok: 2 == (i.status / 100 | 0),
                            statusText: i.statusText,
                            status: i.status,
                            url: i.responseURL,
                            text: function() {
                                return Promise.resolve(i.responseText);
                            },
                            json: function() {
                                return Promise.resolve(JSON.parse(i.responseText));
                            },
                            blob: function() {
                                return Promise.resolve(new Blob([
                                    i.response
                                ]));
                            },
                            clone: u,
                            headers: {
                                keys: function() {
                                    return o;
                                },
                                entries: function() {
                                    return a;
                                },
                                get: function(e) {
                                    return s[e.toLowerCase()];
                                },
                                has: function(e) {
                                    return e.toLowerCase() in s;
                                }
                            }
                        };
                    };
                    for(var c in i.open(t.method || "get", e, !0), i.onload = function() {
                        i.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, t, r) {
                            o.push(t = t.toLowerCase()), a.push([
                                t,
                                r
                            ]), s[t] = s[t] ? s[t] + "," + r : r;
                        }), r(u());
                    }, i.onerror = n, i.withCredentials = "include" == t.credentials, t.headers)i.setRequestHeader(c, t.headers[c]);
                    i.send(t.body || null);
                });
            };
        },
        function(e, t, r) {
            e.exports = r(8);
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), function(e) {
                for(var r in e)t.hasOwnProperty(r) || (t[r] = e[r]);
            }(r(0));
            var n = r(3);
            t.loadManifest = function(e) {
                return n.Utils.loadManifest(e);
            }, t.parseManifest = function(e, t) {
                return n.Utils.parseManifest(e, t);
            };
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e) {
                    this.__jsonld = e, this.context = this.getProperty("context"), this.id = this.getProperty("id");
                }
                return e.prototype.getProperty = function(e) {
                    var t = null;
                    return this.__jsonld && ((t = this.__jsonld[e]) || (t = this.__jsonld["@" + e])), t;
                }, e;
            }();
            t.JSONLDResource = n;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = r(0), a = r(1), s = function(e) {
                function t(t, r) {
                    var n = e.call(this, t) || this;
                    return n.options = r, n;
                }
                return i(t, e), t.prototype.getIIIFResourceType = function() {
                    return o.Utils.normaliseType(this.getProperty("type"));
                }, t.prototype.getLabel = function() {
                    var e = this.getProperty("label");
                    return e ? o.PropertyValue.parse(e, this.options.locale) : new o.PropertyValue([], this.options.locale);
                }, t.prototype.getDefaultLabel = function() {
                    return this.getLabel().getValue(this.options.locale);
                }, t.prototype.getMetadata = function() {
                    var e = this.getProperty("metadata"), t = [];
                    if (!e) return t;
                    for(var r = 0; r < e.length; r++){
                        var n = e[r], i = new o.LabelValuePair(this.options.locale);
                        i.parse(n), t.push(i);
                    }
                    return t;
                }, t.prototype.getRendering = function(e) {
                    for(var t = this.getRenderings(), r = 0; r < t.length; r++){
                        var n = t[r];
                        if (n.getFormat() === e) return n;
                    }
                    return null;
                }, t.prototype.getRenderings = function() {
                    var e, t = [];
                    if (!(e = this.__jsonld ? this.__jsonld.rendering : this.rendering)) return t;
                    Array.isArray(e) || (e = [
                        e
                    ]);
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        t.push(new o.Rendering(n, this.options));
                    }
                    return t;
                }, t.prototype.getRequiredStatement = function() {
                    var e = null, t = this.getProperty("requiredStatement");
                    return t && (e = new o.LabelValuePair(this.options.locale)).parse(t), e;
                }, t.prototype.getService = function(e) {
                    return o.Utils.getService(this, e);
                }, t.prototype.getServices = function() {
                    return o.Utils.getServices(this);
                }, t.prototype.getThumbnail = function() {
                    var e = this.getProperty("thumbnail");
                    return Array.isArray(e) && (e = e[0]), e ? new o.Thumbnail(e, this.options) : null;
                }, t.prototype.isAnnotation = function() {
                    return this.getIIIFResourceType() === a.IIIFResourceType.ANNOTATION;
                }, t.prototype.isCanvas = function() {
                    return this.getIIIFResourceType() === a.IIIFResourceType.CANVAS;
                }, t.prototype.isCollection = function() {
                    return this.getIIIFResourceType() === a.IIIFResourceType.COLLECTION;
                }, t.prototype.isManifest = function() {
                    return this.getIIIFResourceType() === a.IIIFResourceType.MANIFEST;
                }, t.prototype.isRange = function() {
                    return this.getIIIFResourceType() === a.IIIFResourceType.RANGE;
                }, t.prototype.isSequence = function() {
                    return this.getIIIFResourceType() === a.IIIFResourceType.SEQUENCE;
                }, t;
            }(o.JSONLDResource);
            t.ManifestResource = s;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = r(0), a = function(e) {
                function t(t, r) {
                    return e.call(this, t, r) || this;
                }
                return i(t, e), t.prototype.getFormat = function() {
                    var e = this.getProperty("format");
                    return e ? e.toLowerCase() : null;
                }, t.prototype.getResources = function() {
                    var e = [];
                    if (!this.__jsonld.resources) return e;
                    for(var t = 0; t < this.__jsonld.resources.length; t++){
                        var r = this.__jsonld.resources[t], n = new o.Annotation(r, this.options);
                        e.push(n);
                    }
                    return e;
                }, t.prototype.getType = function() {
                    var e = this.getProperty("type");
                    return e ? o.Utils.normaliseType(e) : null;
                }, t.prototype.getWidth = function() {
                    return this.getProperty("width");
                }, t.prototype.getHeight = function() {
                    return this.getProperty("height");
                }, t.prototype.getMaxWidth = function() {
                    return this.getProperty("maxWidth");
                }, t.prototype.getMaxHeight = function() {
                    return this.getProperty("maxHeight") ? null : this.getMaxWidth();
                }, t;
            }(o.ManifestResource);
            t.Resource = a;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = r(0), a = r(1), s = function(e) {
                function t(t, r) {
                    var n = e.call(this, t, r) || this;
                    n.index = -1, n.isLoaded = !1;
                    var i = {
                        defaultLabel: "-",
                        locale: "en-GB",
                        resource: n,
                        pessimisticAccessControl: !1
                    };
                    return n.options = Object.assign(i, r), n;
                }
                return i(t, e), t.prototype.getAttribution = function() {
                    var e = this.getProperty("attribution");
                    return e ? o.PropertyValue.parse(e, this.options.locale) : new o.PropertyValue([], this.options.locale);
                }, t.prototype.getDescription = function() {
                    var e = this.getProperty("description");
                    return e ? o.PropertyValue.parse(e, this.options.locale) : new o.PropertyValue([], this.options.locale);
                }, t.prototype.getHomepage = function() {
                    var e = this.getProperty("homepage");
                    return e ? "string" == typeof e ? e : (Array.isArray(e) && e.length && (e = e[0]), e["@id"] || e.id) : null;
                }, t.prototype.getIIIFResourceType = function() {
                    return o.Utils.normaliseType(this.getProperty("type"));
                }, t.prototype.getLogo = function() {
                    var e = this.getProperty("logo");
                    if (!e) {
                        var t = this.getProperty("provider");
                        if (!t) return null;
                        e = t.logo;
                    }
                    return e ? "string" == typeof e ? e : (Array.isArray(e) && e.length && (e = e[0]), e["@id"] || e.id) : null;
                }, t.prototype.getLicense = function() {
                    return o.Utils.getLocalisedValue(this.getProperty("license"), this.options.locale);
                }, t.prototype.getNavDate = function() {
                    return new Date(this.getProperty("navDate"));
                }, t.prototype.getRelated = function() {
                    return this.getProperty("related");
                }, t.prototype.getSeeAlso = function() {
                    return this.getProperty("seeAlso");
                }, t.prototype.getTrackingLabel = function() {
                    var e = this.getService(a.ServiceProfile.TRACKING_EXTENSIONS);
                    return e ? e.getProperty("trackingLabel") : "";
                }, t.prototype.getDefaultTree = function() {
                    return this.defaultTree = new o.TreeNode("root"), this.defaultTree.data = this, this.defaultTree;
                }, t.prototype.getRequiredStatement = function() {
                    var e = null, t = this.getProperty("requiredStatement");
                    if (t) (e = new o.LabelValuePair(this.options.locale)).parse(t);
                    else {
                        var r = this.getAttribution();
                        r && ((e = new o.LabelValuePair(this.options.locale)).value = r);
                    }
                    return e;
                }, t.prototype.isCollection = function() {
                    return this.getIIIFResourceType() === a.IIIFResourceType.COLLECTION;
                }, t.prototype.isManifest = function() {
                    return this.getIIIFResourceType() === a.IIIFResourceType.MANIFEST;
                }, t.prototype.load = function() {
                    var e = this;
                    return new Promise(function(t) {
                        if (e.isLoaded) t(e);
                        else {
                            var r = e.options;
                            r.navDate = e.getNavDate();
                            var n = e.__jsonld.id;
                            n || (n = e.__jsonld["@id"]), o.Utils.loadManifest(n).then(function(n) {
                                e.parentLabel = e.getLabel().getValue(r.locale);
                                var i = o.Deserialiser.parse(n, r);
                                (e = Object.assign(e, i)).index = r.index, t(e);
                            });
                        }
                    });
                }, t;
            }(o.ManifestResource);
            t.IIIFResource = s;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = r(0), a = function(e) {
                function t(t, r) {
                    return e.call(this, t, r) || this;
                }
                return i(t, e), t.prototype.getBody = function() {
                    var e = [], t = this.getProperty("body");
                    if (t) {
                        if (Array.isArray(t)) for(var r = 0; r < t.length; r++){
                            if ((a = t[r]).items) for(var n = 0; n < a.items.length; n++){
                                var i = a.items[n];
                                e.push(new o.AnnotationBody(i, this.options));
                            }
                            else e.push(new o.AnnotationBody(a, this.options));
                        }
                        else if (t.items) for(r = 0; r < t.items.length; r++){
                            var a = t.items[r];
                            e.push(new o.AnnotationBody(a, this.options));
                        }
                        else e.push(new o.AnnotationBody(t, this.options));
                    }
                    return e;
                }, t.prototype.getMotivation = function() {
                    var e = this.getProperty("motivation");
                    return e || null;
                }, t.prototype.getOn = function() {
                    return this.getProperty("on");
                }, t.prototype.getTarget = function() {
                    return this.getProperty("target");
                }, t.prototype.getResource = function() {
                    return new o.Resource(this.getProperty("resource"), this.options);
                }, t;
            }(o.ManifestResource);
            t.Annotation = a;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = r(0), a = function(e) {
                function t(t, r) {
                    return e.call(this, t, r) || this;
                }
                return i(t, e), t.prototype.getFormat = function() {
                    var e = this.getProperty("format");
                    return e ? o.Utils.getMediaType(e) : null;
                }, t.prototype.getType = function() {
                    return this.getProperty("type") ? o.Utils.normaliseType(this.getProperty("type")) : null;
                }, t.prototype.getWidth = function() {
                    return this.getProperty("width");
                }, t.prototype.getHeight = function() {
                    return this.getProperty("height");
                }, t;
            }(o.ManifestResource);
            t.AnnotationBody = a;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = r(0), a = function(e) {
                function t(t, r, n) {
                    var i = e.call(this, r) || this;
                    return i.label = t, i.options = n, i;
                }
                return i(t, e), t.prototype.getIIIFResourceType = function() {
                    return o.Utils.normaliseType(this.getProperty("type"));
                }, t.prototype.getLabel = function() {
                    return this.label;
                }, t.prototype.getResources = function() {
                    var e = this;
                    return this.getProperty("resources").map(function(t) {
                        return new o.Annotation(t, e.options);
                    });
                }, t.prototype.load = function() {
                    var e = this;
                    return new Promise(function(t, r) {
                        if (e.isLoaded) t(e);
                        else {
                            var n = e.__jsonld.id;
                            n || (n = e.__jsonld["@id"]), o.Utils.loadManifest(n).then(function(r) {
                                e.__jsonld = r, e.context = e.getProperty("context"), e.id = e.getProperty("id"), e.isLoaded = !0, t(e);
                            }).catch(r);
                        }
                    });
                }, t;
            }(o.JSONLDResource);
            t.AnnotationList = a;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = function(e) {
                function t(t, r) {
                    return e.call(this, t, r) || this;
                }
                return i(t, e), t.prototype.getItems = function() {
                    return this.getProperty("items");
                }, t;
            }(r(0).ManifestResource);
            t.AnnotationPage = o;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            }), o = this && this.__importDefault || function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            };
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var a = r(1), s = r(0), u = o(r(18)), c = o(r(30)), l = function(e) {
                function t(t, r) {
                    return e.call(this, t, r) || this;
                }
                return i(t, e), t.prototype.getCanonicalImageUri = function(e) {
                    var t, r = null, n = "default", i = e;
                    if (this.externalResource && this.externalResource.data && this.externalResource.data["@id"]) r = this.externalResource.data["@id"], i || (i = this.externalResource.data.width), this.externalResource.data["@context"] && (this.externalResource.data["@context"].indexOf("/1.0/context.json") > -1 || this.externalResource.data["@context"].indexOf("/1.1/context.json") > -1 || this.externalResource.data["@context"].indexOf("/1/context.json") > -1) && (n = "native");
                    else {
                        var o = void 0;
                        if ((o = this.getImages()) && o.length) {
                            var a = o[0].getResource(), u = a.getServices();
                            if (i || (i = a.getWidth()), c = u ? u.find(function(e) {
                                return s.Utils.isImageProfile(e.getProfile()) || s.Utils.isImageServiceType(e.getIIIFResourceType());
                            }) : null) r = c.id, n = s.Utils.getImageQuality(c.getProfile());
                            else if (i === a.getWidth()) return a.id;
                        }
                        if ((o = this.getContent()) && o.length) {
                            var c, l = o[0].getBody()[0];
                            u = l.getServices();
                            if (i || (i = l.getWidth()), c = u ? u.find(function(e) {
                                return s.Utils.isImageServiceType(e.getIIIFResourceType());
                            }) : null) r = c.id, n = s.Utils.getImageQuality(c.getProfile());
                            else if (i === l.getWidth()) return l.id;
                        }
                        if (!r) {
                            var p = this.getProperty("thumbnail");
                            if (p) {
                                if ("string" == typeof p) return p;
                                if (p["@id"]) return p["@id"];
                                if (p.length) return p[0].id;
                            }
                        }
                    }
                    return t = i + ",", r && r.endsWith("/") && (r = r.substr(0, r.length - 1)), [
                        r,
                        "full",
                        t,
                        0,
                        n + ".jpg"
                    ].join("/");
                }, t.prototype.getMaxDimensions = function() {
                    var e, t = null;
                    return this.externalResource && this.externalResource.data && this.externalResource.data.profile && (e = this.externalResource.data.profile, Array.isArray(e) && (e = e.filter(function(e) {
                        return e.maxWidth;
                    })[0]) && (t = new s.Size(e.maxWidth, e.maxHeight ? e.maxHeight : e.maxWidth))), t;
                }, t.prototype.getContent = function() {
                    var e = [], t = this.__jsonld.items || this.__jsonld.content;
                    if (!t) return e;
                    var r = null;
                    if (t.length && (r = new s.AnnotationPage(t[0], this.options)), !r) return e;
                    for(var n = r.getItems(), i = 0; i < n.length; i++){
                        var o = n[i], a = new s.Annotation(o, this.options);
                        e.push(a);
                    }
                    return e;
                }, t.prototype.getDuration = function() {
                    return this.getProperty("duration");
                }, t.prototype.getImages = function() {
                    var e = [];
                    if (!this.__jsonld.images) return e;
                    for(var t = 0; t < this.__jsonld.images.length; t++){
                        var r = this.__jsonld.images[t], n = new s.Annotation(r, this.options);
                        e.push(n);
                    }
                    return e;
                }, t.prototype.getIndex = function() {
                    return this.getProperty("index");
                }, t.prototype.getOtherContent = function() {
                    var e = this, t = Array.isArray(this.getProperty("otherContent")) ? this.getProperty("otherContent") : [
                        this.getProperty("otherContent")
                    ], r = t.filter(function(e) {
                        var t, r;
                        return e && (t = e["@type"], r = "sc:AnnotationList", "string" == typeof t && "string" == typeof r && t.toLowerCase() == t.toLowerCase());
                    }).map(function(t, r) {
                        return new s.AnnotationList(t.label || "Annotation list " + r, t, e.options);
                    }).map(function(e) {
                        return e.load();
                    });
                    return Promise.all(r);
                }, t.prototype.getWidth = function() {
                    return this.getProperty("width");
                }, t.prototype.getHeight = function() {
                    return this.getProperty("height");
                }, t.prototype.getViewingHint = function() {
                    return this.getProperty("viewingHint");
                }, Object.defineProperty(t.prototype, "imageResources", {
                    get: function() {
                        var e = this, r = c.default([
                            this.getImages().map(function(e) {
                                return e.getResource();
                            }),
                            this.getContent().map(function(e) {
                                return e.getBody();
                            })
                        ]);
                        return u.default(r.map(function(r) {
                            switch(r.getProperty("type").toLowerCase()){
                                case a.ExternalResourceType.CHOICE:
                                case a.ExternalResourceType.OA_CHOICE:
                                    return new t({
                                        images: u.default([
                                            r.getProperty("default"),
                                            r.getProperty("item")
                                        ]).map(function(e) {
                                            return {
                                                resource: e
                                            };
                                        })
                                    }, e.options).getImages().map(function(e) {
                                        return e.getResource();
                                    });
                                default:
                                    return r;
                            }
                        }));
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t.prototype, "resourceAnnotations", {
                    get: function() {
                        return c.default([
                            this.getImages(),
                            this.getContent()
                        ]);
                    },
                    enumerable: !0,
                    configurable: !0
                }), t.prototype.resourceAnnotation = function(e) {
                    return this.resourceAnnotations.find(function(t) {
                        return t.getResource().id === e || u.default(new Array(t.getBody())).some(function(t) {
                            return t.id === e;
                        });
                    });
                }, t.prototype.onFragment = function(e) {
                    var t = this.resourceAnnotation(e);
                    if (t) {
                        var r = t.getProperty("on"), n = t.getProperty("target");
                        if (r && n) {
                            var i = (r || n).match(/xywh=(.*)$/);
                            if (i) return i[1].split(",").map(function(e) {
                                return parseInt(e, 10);
                            });
                        }
                    }
                }, Object.defineProperty(t.prototype, "iiifImageResources", {
                    get: function() {
                        return this.imageResources.filter(function(e) {
                            return e && e.getServices()[0] && e.getServices()[0].id;
                        });
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t.prototype, "imageServiceIds", {
                    get: function() {
                        return this.iiifImageResources.map(function(e) {
                            return e.getServices()[0].id;
                        });
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t.prototype, "aspectRatio", {
                    get: function() {
                        return this.getWidth() / this.getHeight();
                    },
                    enumerable: !0,
                    configurable: !0
                }), t;
            }(s.Resource);
            t.Canvas = l;
        },
        function(e, t, r) {
            var n = r(4);
            e.exports = function(e) {
                return (null == e ? 0 : e.length) ? n(e, 1) : [];
            };
        },
        function(e, t) {
            e.exports = function(e, t) {
                for(var r = -1, n = t.length, i = e.length; ++r < n;)e[i + r] = t[r];
                return e;
            };
        },
        function(e, t, r) {
            var n = r(2), i = r(24), o = r(29), a = n ? n.isConcatSpreadable : void 0;
            e.exports = function(e) {
                return o(e) || i(e) || !!(a && e && e[a]);
            };
        },
        function(e, t, r) {
            var n = r(22), i = "object" == typeof self && self && self.Object === Object && self, o = n || i || Function("return this")();
            e.exports = o;
        },
        function(e, t, r) {
            (function(t) {
                var r = "object" == typeof t && t && t.Object === Object && t;
                e.exports = r;
            }).call(this, r(23));
        },
        function(e, t) {
            var r;
            r = function() {
                return this;
            }();
            try {
                r = r || new Function("return this")();
            } catch (e) {
                "object" == typeof window && (r = window);
            }
            e.exports = r;
        },
        function(e, t, r) {
            var n = r(25), i = r(5), o = Object.prototype, a = o.hasOwnProperty, s = o.propertyIsEnumerable, u = n(function() {
                return arguments;
            }()) ? n : function(e) {
                return i(e) && a.call(e, "callee") && !s.call(e, "callee");
            };
            e.exports = u;
        },
        function(e, t, r) {
            var n = r(26), i = r(5), o = "[object Arguments]";
            e.exports = function(e) {
                return i(e) && n(e) == o;
            };
        },
        function(e, t, r) {
            var n = r(2), i = r(27), o = r(28), a = "[object Null]", s = "[object Undefined]", u = n ? n.toStringTag : void 0;
            e.exports = function(e) {
                return null == e ? void 0 === e ? s : a : u && u in Object(e) ? i(e) : o(e);
            };
        },
        function(e, t, r) {
            var n = r(2), i = Object.prototype, o = i.hasOwnProperty, a = i.toString, s = n ? n.toStringTag : void 0;
            e.exports = function(e) {
                var t = o.call(e, s), r = e[s];
                try {
                    e[s] = void 0;
                    var n = !0;
                } catch (e) {}
                var i = a.call(e);
                return n && (t ? e[s] = r : delete e[s]), i;
            };
        },
        function(e, t) {
            var r = Object.prototype.toString;
            e.exports = function(e) {
                return r.call(e);
            };
        },
        function(e, t) {
            var r = Array.isArray;
            e.exports = r;
        },
        function(e, t, r) {
            var n = r(4), i = 1 / 0;
            e.exports = function(e) {
                return (null == e ? 0 : e.length) ? n(e, i) : [];
            };
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = r(1), a = r(0), s = function(e) {
                function t(t, r) {
                    var n = e.call(this, t, r) || this;
                    return n.items = [], n._collections = null, n._manifests = null, t.__collection = n, n;
                }
                return i(t, e), t.prototype.getCollections = function() {
                    return this._collections ? this._collections : this._collections = this.items.filter(function(e) {
                        return e.isCollection();
                    });
                }, t.prototype.getManifests = function() {
                    return this._manifests ? this._manifests : this._manifests = this.items.filter(function(e) {
                        return e.isManifest();
                    });
                }, t.prototype.getCollectionByIndex = function(e) {
                    for(var t, r = this.getCollections(), n = 0; n < r.length; n++){
                        var i = r[n];
                        i.index === e && (t = i);
                    }
                    if (t) return t.options.index = e, t.load();
                    throw new Error("Collection index not found");
                }, t.prototype.getManifestByIndex = function(e) {
                    for(var t, r = this.getManifests(), n = 0; n < r.length; n++){
                        var i = r[n];
                        i.index === e && (t = i);
                    }
                    if (t) return t.options.index = e, t.load();
                    throw new Error("Manifest index not found");
                }, t.prototype.getTotalCollections = function() {
                    return this.getCollections().length;
                }, t.prototype.getTotalManifests = function() {
                    return this.getManifests().length;
                }, t.prototype.getTotalItems = function() {
                    return this.items.length;
                }, t.prototype.getViewingDirection = function() {
                    return this.getProperty("viewingDirection") ? this.getProperty("viewingDirection") : o.ViewingDirection.LEFT_TO_RIGHT;
                }, t.prototype.getBehavior = function() {
                    var e = this.getProperty("behavior");
                    return Array.isArray(e) && (e = e[0]), e || null;
                }, t.prototype.getViewingHint = function() {
                    return this.getProperty("viewingHint");
                }, t.prototype.getDefaultTree = function() {
                    return e.prototype.getDefaultTree.call(this), this.defaultTree.data.type = a.Utils.normaliseType(a.TreeNodeType.COLLECTION), this._parseManifests(this), this._parseCollections(this), a.Utils.generateTreeNodeIds(this.defaultTree), this.defaultTree;
                }, t.prototype._parseManifests = function(e) {
                    if (e.getManifests() && e.getManifests().length) for(var t = 0; t < e.getManifests().length; t++){
                        var r = e.getManifests()[t], n = r.getDefaultTree();
                        n.label = r.parentLabel || r.getLabel().getValue(this.options.locale) || "manifest " + (t + 1), n.navDate = r.getNavDate(), n.data.id = r.id, n.data.type = a.Utils.normaliseType(a.TreeNodeType.MANIFEST), e.defaultTree.addNode(n);
                    }
                }, t.prototype._parseCollections = function(e) {
                    if (e.getCollections() && e.getCollections().length) for(var t = 0; t < e.getCollections().length; t++){
                        var r = e.getCollections()[t], n = r.getDefaultTree();
                        n.label = r.parentLabel || r.getLabel().getValue(this.options.locale) || "collection " + (t + 1), n.navDate = r.getNavDate(), n.data.id = r.id, n.data.type = a.Utils.normaliseType(a.TreeNodeType.COLLECTION), e.defaultTree.addNode(n);
                    }
                }, t;
            }(a.IIIFResource);
            t.Collection = s;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    this.start = e, this.end = t;
                }
                return e.prototype.getLength = function() {
                    return this.end - this.start;
                }, e;
            }();
            t.Duration = n;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = r(0), i = function() {
                function e(e) {
                    this.defaultLocale = e;
                }
                return e.prototype.parse = function(e) {
                    this.resource = e, this.label = n.PropertyValue.parse(this.resource.label, this.defaultLocale), this.value = n.PropertyValue.parse(this.resource.value, this.defaultLocale);
                }, e.prototype.getLabel = function(e) {
                    return null === this.label ? null : (Array.isArray(e) && !e.length && (e = void 0), this.label.getValue(e || this.defaultLocale));
                }, e.prototype.setLabel = function(e) {
                    null === this.label && (this.label = new n.PropertyValue([])), this.label.setValue(e, this.defaultLocale);
                }, e.prototype.getValue = function(e, t) {
                    return void 0 === t && (t = "<br/>"), null === this.value ? null : (Array.isArray(e) && !e.length && (e = void 0), this.value.getValue(e || this.defaultLocale, t));
                }, e.prototype.getValues = function(e) {
                    return null === this.value ? [] : (Array.isArray(e) && !e.length && (e = void 0), this.value.getValues(e || this.defaultLocale));
                }, e.prototype.setValue = function(e) {
                    null === this.value && (this.value = new n.PropertyValue([])), this.value.setValue(e, this.defaultLocale);
                }, e;
            }();
            t.LabelValuePair = i;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = function(e) {
                function t() {
                    return null !== e && e.apply(this, arguments) || this;
                }
                return i(t, e), t.getValue = function(e, t) {
                    return e.getValue(t, "<br/>");
                }, t.getValues = function(e, t) {
                    return e.getValues(t);
                }, t;
            }(Array);
            t.LanguageMap = o;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            }), o = this && this.__spreadArrays || function() {
                for(var e = 0, t = 0, r = arguments.length; t < r; t++)e += arguments[t].length;
                var n = Array(e), i = 0;
                for(t = 0; t < r; t++)for(var o = arguments[t], a = 0, s = o.length; a < s; a++, i++)n[i] = o[a];
                return n;
            };
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var a = r(3), s = function() {
                function e(e, t, r) {
                    void 0 === r && (r = "none"), Array.isArray(e) && 1 === e.length ? this._value = e[0] : this._value = e, "none" !== t && "@none" !== t || (t = void 0), this._locale = t, this._defaultLocale = r;
                }
                return e.parseV2Value = function(t, r) {
                    return "string" == typeof t ? new e(t, void 0, r) : t["@value"] ? new e(t["@value"], t["@language"], r) : null;
                }, Object.defineProperty(e.prototype, "value", {
                    get: function() {
                        return Array.isArray(this._value) ? this._value.join("<br/>") : this._value;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "locale", {
                    get: function() {
                        return void 0 === this._locale ? this._defaultLocale : this._locale;
                    },
                    enumerable: !0,
                    configurable: !0
                }), e.prototype.addValue = function(e) {
                    Array.isArray(this._value) || (this._value = [
                        this._value
                    ]), Array.isArray(e) ? this._value = this._value.concat(e) : this._value.push(e);
                }, e;
            }();
            t.LocalizedValue = s;
            var u = function(e) {
                function t(r, n) {
                    void 0 === r && (r = []);
                    var i = e.apply(this, r) || this;
                    return i.__proto__ = t.prototype, i._defaultLocale = n, i;
                }
                return i(t, e), t.parse = function(e, r) {
                    if (!e) return new t([], r);
                    if (Array.isArray(e)) {
                        var n = (i = e.map(function(e) {
                            return s.parseV2Value(e, r);
                        }).filter(function(e) {
                            return null !== e;
                        })).reduce(function(e, t) {
                            var r = t._locale;
                            return r || (r = "none"), e[r] ? e[r].addValue(t._value) : e[r] = t, e;
                        }, {});
                        return new t(Object.values(n), r);
                    }
                    var i;
                    return "string" == typeof e ? new t([
                        new s(e, void 0, r)
                    ], r) : e["@language"] ? new t(null !== (i = s.parseV2Value(e)) ? [
                        i
                    ] : [], r) : e["@value"] ? new t(null !== (i = s.parseV2Value(e)) ? [
                        i
                    ] : [], r) : new t(Object.keys(e).map(function(t) {
                        var n = e[t];
                        if (!Array.isArray(n)) throw new Error("A IIIF v3 localized property value must have an array as the value for a given language.");
                        return new s(n, t, r);
                    }), r);
                }, t.prototype.getSuitableLocale = function(e) {
                    for(var t = o(this).map(function(e) {
                        return e._locale;
                    }).filter(function(e) {
                        return void 0 !== e;
                    }), r = function(e) {
                        var r = t.find(function(t) {
                            return t === e;
                        });
                        if (r) return {
                            value: r
                        };
                    }, n = 0, i = e; n < i.length; n++){
                        var s = r(i[n]);
                        if ("object" == typeof s) return s.value;
                    }
                    for(var u = function(e) {
                        var r = t.find(function(t) {
                            return a.Utils.getInexactLocale(t) === a.Utils.getInexactLocale(e);
                        });
                        if (r) return {
                            value: r
                        };
                    }, c = 0, l = e; c < l.length; c++){
                        var p = u(l[c]);
                        if ("object" == typeof p) return p.value;
                    }
                }, t.prototype.setValue = function(e, t) {
                    var r = void 0;
                    if (t) {
                        var n = this.getSuitableLocale([
                            t
                        ]);
                        n && (r = this.find(function(e) {
                            return e._locale === n;
                        }));
                    } else r = this.find(function(e) {
                        return void 0 === e._locale;
                    });
                    r ? r._value = e : this.push(new s(e, t, this._defaultLocale));
                }, t.prototype.getValue = function(e, t) {
                    var r = this.getValues(e);
                    return 0 === r.length ? null : t ? r.join(t) : r[0];
                }, t.prototype.getValues = function(e) {
                    if (!this.length) return [];
                    var t;
                    if (t = e ? Array.isArray(e) ? e : [
                        e
                    ] : [], 1 === this.length && void 0 === this[0]._locale) {
                        var r = this[0]._value;
                        return Array.isArray(r) ? r : [
                            r
                        ];
                    }
                    var n = this.getSuitableLocale(t);
                    if (n) {
                        r = this.find(function(e) {
                            return e._locale === n;
                        })._value;
                        return Array.isArray(r) ? r : [
                            r
                        ];
                    }
                    if (!this.find(function(e) {
                        return void 0 === e._locale;
                    })) {
                        r = this[0]._value;
                        return Array.isArray(r) ? r : [
                            r
                        ];
                    }
                    var i = this.find(function(e) {
                        return void 0 === e._locale;
                    });
                    return i ? Array.isArray(i._value) ? i._value : [
                        i._value
                    ] : [];
                }, t;
            }(Array);
            t.PropertyValue = u;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.CONTINUE = 100, t.SWITCHING_PROTOCOLS = 101, t.PROCESSING = 102, t.OK = 200, t.CREATED = 201, t.ACCEPTED = 202, t.NON_AUTHORITATIVE_INFORMATION = 203, t.NO_CONTENT = 204, t.RESET_CONTENT = 205, t.PARTIAL_CONTENT = 206, t.MULTI_STATUS = 207, t.MULTIPLE_CHOICES = 300, t.MOVED_PERMANENTLY = 301, t.MOVED_TEMPORARILY = 302, t.SEE_OTHER = 303, t.NOT_MODIFIED = 304, t.USE_PROXY = 305, t.TEMPORARY_REDIRECT = 307, t.BAD_REQUEST = 400, t.UNAUTHORIZED = 401, t.PAYMENT_REQUIRED = 402, t.FORBIDDEN = 403, t.NOT_FOUND = 404, t.METHOD_NOT_ALLOWED = 405, t.NOT_ACCEPTABLE = 406, t.PROXY_AUTHENTICATION_REQUIRED = 407, t.REQUEST_TIME_OUT = 408, t.CONFLICT = 409, t.GONE = 410, t.LENGTH_REQUIRED = 411, t.PRECONDITION_FAILED = 412, t.REQUEST_ENTITY_TOO_LARGE = 413, t.REQUEST_URI_TOO_LARGE = 414, t.UNSUPPORTED_MEDIA_TYPE = 415, t.REQUESTED_RANGE_NOT_SATISFIABLE = 416, t.EXPECTATION_FAILED = 417, t.IM_A_TEAPOT = 418, t.UNPROCESSABLE_ENTITY = 422, t.LOCKED = 423, t.FAILED_DEPENDENCY = 424, t.UNORDERED_COLLECTION = 425, t.UPGRADE_REQUIRED = 426, t.PRECONDITION_REQUIRED = 428, t.TOO_MANY_REQUESTS = 429, t.REQUEST_HEADER_FIELDS_TOO_LARGE = 431, t.INTERNAL_SERVER_ERROR = 500, t.NOT_IMPLEMENTED = 501, t.BAD_GATEWAY = 502, t.SERVICE_UNAVAILABLE = 503, t.GATEWAY_TIME_OUT = 504, t.HTTP_VERSION_NOT_SUPPORTED = 505, t.VARIANT_ALSO_NEGOTIATES = 506, t.INSUFFICIENT_STORAGE = 507, t.BANDWIDTH_LIMIT_EXCEEDED = 509, t.NOT_EXTENDED = 510, t.NETWORK_AUTHENTICATION_REQUIRED = 511;
        },
        function(e, t, r) {
            e.exports = window.fetch || (window.fetch = r(6).default || r(6));
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = r(1), a = r(0), s = function(e) {
                function t(t, r) {
                    var n = e.call(this, t, r) || this;
                    if (n.index = 0, n._allRanges = null, n.items = [], n._topRanges = [], n.__jsonld.structures && n.__jsonld.structures.length) for(var i = n._getTopRanges(), o = 0; o < i.length; o++){
                        var a = i[o];
                        n._parseRanges(a, String(o));
                    }
                    return n;
                }
                return i(t, e), t.prototype.getPosterCanvas = function() {
                    var e = this.getProperty("posterCanvas");
                    return e && (e = new a.Canvas(e, this.options)), e;
                }, t.prototype.getAccompanyingCanvas = function() {
                    var e = this.getProperty("accompanyingCanvas");
                    return e && (e = new a.Canvas(e, this.options)), e;
                }, t.prototype.getBehavior = function() {
                    var e = this.getProperty("behavior");
                    return Array.isArray(e) && (e = e[0]), e || null;
                }, t.prototype.getDefaultTree = function() {
                    if (e.prototype.getDefaultTree.call(this), this.defaultTree.data.type = a.Utils.normaliseType(a.TreeNodeType.MANIFEST), !this.isLoaded) return this.defaultTree;
                    var t = this.getTopRanges();
                    return t.length && t[0].getTree(this.defaultTree), a.Utils.generateTreeNodeIds(this.defaultTree), this.defaultTree;
                }, t.prototype._getTopRanges = function() {
                    var e = [];
                    if (this.__jsonld.structures && this.__jsonld.structures.length) {
                        for(var t = 0; t < this.__jsonld.structures.length; t++){
                            var r = this.__jsonld.structures[t];
                            r.viewingHint === o.ViewingHint.TOP && e.push(r);
                        }
                        if (!e.length) {
                            var n = {};
                            n.ranges = this.__jsonld.structures, e.push(n);
                        }
                    }
                    return e;
                }, t.prototype.getTopRanges = function() {
                    return this._topRanges;
                }, t.prototype._getRangeById = function(e) {
                    if (this.__jsonld.structures && this.__jsonld.structures.length) for(var t = 0; t < this.__jsonld.structures.length; t++){
                        var r = this.__jsonld.structures[t];
                        if (r["@id"] === e || r.id === e) return r;
                    }
                    return null;
                }, t.prototype._parseRanges = function(e, t, r) {
                    var n, i = null;
                    if ("string" == typeof e && (i = e, e = this._getRangeById(i)), e) {
                        (n = new a.Range(e, this.options)).parentRange = r, n.path = t, r ? r.items.push(n) : this._topRanges.push(n);
                        var o = e.items || e.members;
                        if (o) for(var s = 0; s < o.length; s++){
                            var u = o[s];
                            if (u["@type"] && "sc:range" === u["@type"].toLowerCase() || u.type && "range" === u.type.toLowerCase()) this._parseRanges(u, t + "/" + s, n);
                            else if (u["@type"] && "sc:canvas" === u["@type"].toLowerCase() || u.type && "canvas" === u.type.toLowerCase()) {
                                n.canvases || (n.canvases = []);
                                var c = u.id || u["@id"];
                                n.canvases.push(c);
                            }
                        }
                        else if (e.ranges) for(s = 0; s < e.ranges.length; s++)this._parseRanges(e.ranges[s], t + "/" + s, n);
                    } else console.warn("Range:", i, "does not exist");
                }, t.prototype.getAllRanges = function() {
                    if (null != this._allRanges) return this._allRanges;
                    this._allRanges = [];
                    for(var e = this.getTopRanges(), t = function(t) {
                        var n = e[t];
                        n.id && r._allRanges.push(n);
                        var i = function(e, t) {
                            e.add(t);
                            var r = t.getRanges();
                            return r.length ? r.reduce(i, e) : e;
                        }, o = Array.from(n.getRanges().reduce(i, new Set));
                        r._allRanges = r._allRanges.concat(o);
                    }, r = this, n = 0; n < e.length; n++)t(n);
                    return this._allRanges;
                }, t.prototype.getRangeById = function(e) {
                    for(var t = this.getAllRanges(), r = 0; r < t.length; r++){
                        var n = t[r];
                        if (n.id === e) return n;
                    }
                    return null;
                }, t.prototype.getRangeByPath = function(e) {
                    for(var t = this.getAllRanges(), r = 0; r < t.length; r++){
                        var n = t[r];
                        if (n.path === e) return n;
                    }
                    return null;
                }, t.prototype.getSequences = function() {
                    if (this.items.length) return this.items;
                    var e = this.__jsonld.mediaSequences || this.__jsonld.sequences;
                    if (e) for(var t = 0; t < e.length; t++){
                        var r = e[t], n = new a.Sequence(r, this.options);
                        this.items.push(n);
                    }
                    else if (this.__jsonld.items) {
                        n = new a.Sequence(this.__jsonld.items, this.options);
                        this.items.push(n);
                    }
                    return this.items;
                }, t.prototype.getSequenceByIndex = function(e) {
                    return this.getSequences()[e];
                }, t.prototype.getTotalSequences = function() {
                    return this.getSequences().length;
                }, t.prototype.getManifestType = function() {
                    var e = this.getService(o.ServiceProfile.UI_EXTENSIONS);
                    return e ? e.getProperty("manifestType") : a.ManifestType.EMPTY;
                }, t.prototype.isMultiSequence = function() {
                    return this.getTotalSequences() > 1;
                }, t.prototype.isPagingEnabled = function() {
                    var e = this.getViewingHint();
                    if (e) return e === o.ViewingHint.PAGED;
                    var t = this.getBehavior();
                    return !!t && t === o.Behavior.PAGED;
                }, t.prototype.getViewingDirection = function() {
                    return this.getProperty("viewingDirection");
                }, t.prototype.getViewingHint = function() {
                    return this.getProperty("viewingHint");
                }, t;
            }(a.IIIFResource);
            t.Manifest = s;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), function(e) {
                e.EMPTY = "", e.MANUSCRIPT = "manuscript", e.MONOGRAPH = "monograph";
            }(t.ManifestType || (t.ManifestType = {}));
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = r(0), a = r(1), s = function(e) {
                function t(t, r) {
                    var n = e.call(this, t, r) || this;
                    return n._ranges = null, n.canvases = null, n.items = [], n;
                }
                return i(t, e), t.prototype.getCanvasIds = function() {
                    return this.__jsonld.canvases ? this.__jsonld.canvases : this.canvases ? this.canvases : [];
                }, t.prototype.getDuration = function() {
                    if (this.canvases && this.canvases.length) {
                        for(var e = [], t = [], r = 0, n = this.canvases; r < n.length; r++)if (_ = n[r]) {
                            var i = _.match(/(.*)#t=([0-9.]+),?([0-9.]+)?/) || [
                                void 0,
                                _
                            ], a = i[1], s = i[2], u = i[3];
                            a && (e.push(parseFloat(s)), t.push(parseFloat(u)));
                        }
                        if (e.length && t.length) return new o.Duration(Math.min.apply(Math, e), Math.max.apply(Math, t));
                    } else {
                        e = [], t = [];
                        for(var c = 0, l = d = this.getRanges(); c < l.length; c++)(v = l[c].getDuration()) && (e.push(v.start), t.push(v.end));
                        if (e.length && t.length) return new o.Duration(Math.min.apply(Math, e), Math.max.apply(Math, t));
                    }
                    var p, f;
                    if (this.canvases && this.canvases.length) for(var h = 0; h < this.canvases.length; h++){
                        var _ = this.canvases[h], g = o.Utils.getTemporalComponent(_);
                        g && g.length > 1 && (0 === h && (p = Number(g[0])), h === this.canvases.length - 1 && (f = Number(g[1])));
                    }
                    else {
                        var d = this.getRanges();
                        for(h = 0; h < d.length; h++){
                            var v;
                            (v = d[h].getDuration()) && (0 === h && (p = v.start), h === d.length - 1 && (f = v.end));
                        }
                    }
                    if (void 0 !== p && void 0 !== f) return new o.Duration(p, f);
                }, t.prototype.getRanges = function() {
                    return this._ranges ? this._ranges : this._ranges = this.items.filter(function(e) {
                        return e.isRange();
                    });
                }, t.prototype.getBehavior = function() {
                    var e = this.getProperty("behavior");
                    return Array.isArray(e) && (e = e[0]), e || null;
                }, t.prototype.getViewingDirection = function() {
                    return this.getProperty("viewingDirection");
                }, t.prototype.getViewingHint = function() {
                    return this.getProperty("viewingHint");
                }, t.prototype.getTree = function(e) {
                    e.data = this, this.treeNode = e;
                    var t = this.getRanges();
                    if (t && t.length) for(var r = 0; r < t.length; r++){
                        var n = t[r], i = new o.TreeNode;
                        e.addNode(i), this._parseTreeNode(i, n);
                    }
                    return o.Utils.generateTreeNodeIds(e), e;
                }, t.prototype.spansTime = function(e) {
                    var t = this.getDuration();
                    return !!(t && e >= t.start && e <= t.end);
                }, t.prototype._parseTreeNode = function(e, t) {
                    e.label = t.getLabel().getValue(this.options.locale), e.data = t, e.data.type = o.Utils.normaliseType(o.TreeNodeType.RANGE), t.treeNode = e;
                    var r = t.getRanges();
                    if (r && r.length) for(var n = 0; n < r.length; n++){
                        var i = r[n];
                        if (i.getBehavior() !== a.Behavior.NO_NAV) {
                            var s = new o.TreeNode;
                            e.addNode(s), this._parseTreeNode(s, i);
                        }
                    }
                }, t;
            }(o.ManifestResource);
            t.Range = s;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = function(e) {
                function t(t, r) {
                    return e.call(this, t, r) || this;
                }
                return i(t, e), t.prototype.getFormat = function() {
                    return this.getProperty("format");
                }, t;
            }(r(0).ManifestResource);
            t.Rendering = o;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = r(1), a = r(0), s = function(e) {
                function t(t, r) {
                    var n = e.call(this, t, r) || this;
                    return n.items = [], n._thumbnails = null, n;
                }
                return i(t, e), t.prototype.getCanvases = function() {
                    if (this.items.length) return this.items;
                    var e = this.__jsonld.canvases || this.__jsonld.elements;
                    if (e) for(var t = 0; t < e.length; t++){
                        var r = e[t];
                        (n = new a.Canvas(r, this.options)).index = t, this.items.push(n);
                    }
                    else if (this.__jsonld) for(t = 0; t < this.__jsonld.length; t++){
                        var n;
                        r = this.__jsonld[t];
                        (n = new a.Canvas(r, this.options)).index = t, this.items.push(n);
                    }
                    return this.items;
                }, t.prototype.getCanvasById = function(e) {
                    for(var t = 0; t < this.getTotalCanvases(); t++){
                        var r = this.getCanvasByIndex(t), n = a.Utils.normaliseUrl(r.id);
                        if (a.Utils.normaliseUrl(e) === n) return r;
                    }
                    return null;
                }, t.prototype.getCanvasByIndex = function(e) {
                    return this.getCanvases()[e];
                }, t.prototype.getCanvasIndexById = function(e) {
                    for(var t = 0; t < this.getTotalCanvases(); t++){
                        if (this.getCanvasByIndex(t).id === e) return t;
                    }
                    return null;
                }, t.prototype.getCanvasIndexByLabel = function(e, t) {
                    e = e.trim(), isNaN(e) || (e = parseInt(e, 10).toString(), t && (e += "r"));
                    for(var r, n, i, o = /(\d*)\D+(\d*)/, a = 0; a < this.getTotalCanvases(); a++){
                        var s = this.getCanvasByIndex(a);
                        if (s.getLabel().getValue(this.options.locale) === e) return a;
                        if ((r = o.exec(e)) && (n = r[1], (i = r[2]) && new RegExp("^" + n + "\\D+" + i + "$").test(s.getLabel().toString()))) return a;
                    }
                    return -1;
                }, t.prototype.getLastCanvasLabel = function(e) {
                    for(var t = this.getTotalCanvases() - 1; t >= 0; t--){
                        var r = this.getCanvasByIndex(t).getLabel().getValue(this.options.locale);
                        if (e) {
                            if (/^[a-zA-Z0-9]*$/.test(r)) return r;
                        } else if (r) return r;
                    }
                    return this.options.defaultLabel;
                }, t.prototype.getLastPageIndex = function() {
                    return this.getTotalCanvases() - 1;
                }, t.prototype.getNextPageIndex = function(e, t) {
                    var r;
                    if (t) {
                        var n = this.getPagedIndices(e), i = this.getViewingDirection();
                        r = i && i === o.ViewingDirection.RIGHT_TO_LEFT ? n[0] + 1 : n[n.length - 1] + 1;
                    } else r = e + 1;
                    return r > this.getLastPageIndex() ? -1 : r;
                }, t.prototype.getPagedIndices = function(e, t) {
                    var r = [];
                    if (t) {
                        r = this.isFirstCanvas(e) || this.isLastCanvas(e) ? [
                            e
                        ] : e % 2 ? [
                            e,
                            e + 1
                        ] : [
                            e - 1,
                            e
                        ];
                        var n = this.getViewingDirection();
                        n && n === o.ViewingDirection.RIGHT_TO_LEFT && (r = r.reverse());
                    } else r.push(e);
                    return r;
                }, t.prototype.getPrevPageIndex = function(e, t) {
                    var r;
                    if (t) {
                        var n = this.getPagedIndices(e), i = this.getViewingDirection();
                        r = i && i === o.ViewingDirection.RIGHT_TO_LEFT ? n[n.length - 1] - 1 : n[0] - 1;
                    } else r = e - 1;
                    return r;
                }, t.prototype.getStartCanvasIndex = function() {
                    var e = this.getStartCanvas();
                    if (e) for(var t = 0; t < this.getTotalCanvases(); t++){
                        if (this.getCanvasByIndex(t).id === e) return t;
                    }
                    return 0;
                }, t.prototype.getThumbs = function(e, t) {
                    for(var r = [], n = this.getTotalCanvases(), i = 0; i < n; i++){
                        var o = this.getCanvasByIndex(i), s = new a.Thumb(e, o);
                        r.push(s);
                    }
                    return r;
                }, t.prototype.getThumbnails = function() {
                    if (null != this._thumbnails) return this._thumbnails;
                    this._thumbnails = [];
                    for(var e = this.getCanvases(), t = 0; t < e.length; t++){
                        var r = e[t].getThumbnail();
                        r && this._thumbnails.push(r);
                    }
                    return this._thumbnails;
                }, t.prototype.getStartCanvas = function() {
                    return this.getProperty("startCanvas");
                }, t.prototype.getTotalCanvases = function() {
                    return this.getCanvases().length;
                }, t.prototype.getViewingDirection = function() {
                    return this.getProperty("viewingDirection") ? this.getProperty("viewingDirection") : this.options.resource.getViewingDirection ? this.options.resource.getViewingDirection() : null;
                }, t.prototype.getViewingHint = function() {
                    return this.getProperty("viewingHint");
                }, t.prototype.isCanvasIndexOutOfRange = function(e) {
                    return e > this.getTotalCanvases() - 1;
                }, t.prototype.isFirstCanvas = function(e) {
                    return 0 === e;
                }, t.prototype.isLastCanvas = function(e) {
                    return e === this.getTotalCanvases() - 1;
                }, t.prototype.isMultiCanvas = function() {
                    return this.getTotalCanvases() > 1;
                }, t.prototype.isPagingEnabled = function() {
                    var e = this.getViewingHint();
                    return !!e && e === o.ViewingHint.PAGED;
                }, t.prototype.isTotalCanvasesEven = function() {
                    return this.getTotalCanvases() % 2 == 0;
                }, t;
            }(a.ManifestResource);
            t.Sequence = s;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = r(0), i = function() {
                function e() {}
                return e.parse = function(e, t) {
                    return "string" == typeof e && (e = JSON.parse(e)), this.parseJson(e, t);
                }, e.parseJson = function(e, t) {
                    var r;
                    if (t && t.navDate && !isNaN(t.navDate.getTime()) && (e.navDate = t.navDate.toString()), e["@type"]) switch(e["@type"]){
                        case "sc:Collection":
                            r = this.parseCollection(e, t);
                            break;
                        case "sc:Manifest":
                            r = this.parseManifest(e, t);
                            break;
                        default:
                            return null;
                    }
                    else switch(e.type){
                        case "Collection":
                            r = this.parseCollection(e, t);
                            break;
                        case "Manifest":
                            r = this.parseManifest(e, t);
                            break;
                        default:
                            return null;
                    }
                    return r.isLoaded = !0, r;
                }, e.parseCollection = function(e, t) {
                    var r = new n.Collection(e, t);
                    return t ? (r.index = t.index || 0, t.resource && (r.parentCollection = t.resource.parentCollection)) : r.index = 0, this.parseCollections(r, t), this.parseManifests(r, t), this.parseItems(r, t), r;
                }, e.parseCollections = function(e, t) {
                    var r;
                    if (e.__jsonld.collections ? r = e.__jsonld.collections : e.__jsonld.items && (r = e.__jsonld.items.filter(function(e) {
                        return "collection" === e.type.toLowerCase();
                    })), r) for(var n = 0; n < r.length; n++){
                        t && (t.index = n);
                        var i = this.parseCollection(r[n], t);
                        i.index = n, i.parentCollection = e, e.items.push(i);
                    }
                }, e.parseManifest = function(e, t) {
                    return new n.Manifest(e, t);
                }, e.parseManifests = function(e, t) {
                    var r;
                    if (e.__jsonld.manifests ? r = e.__jsonld.manifests : e.__jsonld.items && (r = e.__jsonld.items.filter(function(e) {
                        return "manifest" === e.type.toLowerCase();
                    })), r) for(var n = 0; n < r.length; n++){
                        var i = this.parseManifest(r[n], t);
                        i.index = n, i.parentCollection = e, e.items.push(i);
                    }
                }, e.parseItem = function(e, t) {
                    if (e["@type"]) {
                        if ("sc:manifest" === e["@type"].toLowerCase()) return this.parseManifest(e, t);
                        if ("sc:collection" === e["@type"].toLowerCase()) return this.parseCollection(e, t);
                    } else if (e.type) {
                        if ("manifest" === e.type.toLowerCase()) return this.parseManifest(e, t);
                        if ("collection" === e.type.toLowerCase()) return this.parseCollection(e, t);
                    }
                    return null;
                }, e.parseItems = function(e, t) {
                    var r = e.__jsonld.members || e.__jsonld.items;
                    if (r) for(var n = function(n) {
                        t && (t.index = n);
                        var o = i.parseItem(r[n], t);
                        return o ? e.items.filter(function(e) {
                            return e.id === o.id;
                        })[0] ? "continue" : (o.index = n, o.parentCollection = e, void e.items.push(o)) : {
                            value: void 0
                        };
                    }, i = this, o = 0; o < r.length; o++){
                        var a = n(o);
                        if ("object" == typeof a) return a.value;
                    }
                }, e;
            }();
            t.Deserialiser = i;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = r(0), a = function(e) {
                function t(t, r) {
                    return e.call(this, t, r) || this;
                }
                return i(t, e), t.prototype.getProfile = function() {
                    var e = this.getProperty("profile");
                    return e || (e = this.getProperty("dcterms:conformsTo")), Array.isArray(e) ? e[0] : e;
                }, t.prototype.getConfirmLabel = function() {
                    return o.Utils.getLocalisedValue(this.getProperty("confirmLabel"), this.options.locale);
                }, t.prototype.getDescription = function() {
                    return o.Utils.getLocalisedValue(this.getProperty("description"), this.options.locale);
                }, t.prototype.getFailureDescription = function() {
                    return o.Utils.getLocalisedValue(this.getProperty("failureDescription"), this.options.locale);
                }, t.prototype.getFailureHeader = function() {
                    return o.Utils.getLocalisedValue(this.getProperty("failureHeader"), this.options.locale);
                }, t.prototype.getHeader = function() {
                    return o.Utils.getLocalisedValue(this.getProperty("header"), this.options.locale);
                }, t.prototype.getServiceLabel = function() {
                    return o.Utils.getLocalisedValue(this.getProperty("label"), this.options.locale);
                }, t.prototype.getInfoUri = function() {
                    var e = this.id;
                    return e.endsWith("/") || (e += "/"), e += "info.json";
                }, t;
            }(o.ManifestResource);
            t.Service = a;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e, t) {
                this.width = e, this.height = t;
            };
            t.Size = n;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), function(e) {
                e[e.AUTHORIZATION_FAILED = 1] = "AUTHORIZATION_FAILED", e[e.FORBIDDEN = 2] = "FORBIDDEN", e[e.INTERNAL_SERVER_ERROR = 3] = "INTERNAL_SERVER_ERROR", e[e.RESTRICTED = 4] = "RESTRICTED";
            }(t.StatusCode || (t.StatusCode = {}));
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e, t) {
                this.data = t, this.index = t.index, this.width = e;
                var r = t.getHeight() / t.getWidth();
                this.height = r ? Math.floor(this.width * r) : e, this.uri = t.getCanonicalImageUri(e), this.label = t.getLabel().getValue(), this.viewingHint = t.getViewingHint();
            };
            t.Thumb = n;
        },
        function(e, t, r) {
            "use strict";
            var n, i = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = function(e) {
                function t(t, r) {
                    return e.call(this, t, r) || this;
                }
                return i(t, e), t;
            }(r(0).Resource);
            t.Thumbnail = o;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = r(0), i = function() {
                function e(e, t) {
                    this.label = e, this.data = t || {}, this.nodes = [];
                }
                return e.prototype.addNode = function(e) {
                    this.nodes.push(e), e.parentNode = this;
                }, e.prototype.isCollection = function() {
                    return this.data.type === n.Utils.normaliseType(n.TreeNodeType.COLLECTION);
                }, e.prototype.isManifest = function() {
                    return this.data.type === n.Utils.normaliseType(n.TreeNodeType.MANIFEST);
                }, e.prototype.isRange = function() {
                    return this.data.type === n.Utils.normaliseType(n.TreeNodeType.RANGE);
                }, e;
            }();
            t.TreeNode = i;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), function(e) {
                e.COLLECTION = "collection", e.MANIFEST = "manifest", e.RANGE = "range";
            }(t.TreeNodeType || (t.TreeNodeType = {}));
        }
    ]);
});

});


parcelRegister("fr77o", function(module, exports) {

$parcel$export(module.exports, "miradorSlice", function () { return $b3cee6296ba0cef3$export$934889db704bdd21; });

var $Kyao2 = parcelRequire("Kyao2");
function $b3cee6296ba0cef3$export$934889db704bdd21(state) {
    if ((0, $Kyao2.default).state.slice) return state[(0, $Kyao2.default).state.slice];
    return state;
}

});
parcelRegister("Kyao2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08beccc0bbca7411$export$2e2bcd8739ae039; });

var $aowE3 = parcelRequire("aowE3");
function $08beccc0bbca7411$var$_slicedToArray(arr, i) {
    return $08beccc0bbca7411$var$_arrayWithHoles(arr) || $08beccc0bbca7411$var$_iterableToArrayLimit(arr, i) || $08beccc0bbca7411$var$_unsupportedIterableToArray(arr, i) || $08beccc0bbca7411$var$_nonIterableRest();
}
function $08beccc0bbca7411$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $08beccc0bbca7411$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $08beccc0bbca7411$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $08beccc0bbca7411$var$_arrayLikeToArray(o, minLen);
}
function $08beccc0bbca7411$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $08beccc0bbca7411$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $08beccc0bbca7411$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $08beccc0bbca7411$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $08beccc0bbca7411$export$2e2bcd8739ae039 = {
    state: {},
    canvasNavigation: {
        // Set the height and width of canvas thumbnails in the  CanvasNavigation companion window
        height: 50,
        width: 50
    },
    selectedTheme: "light",
    // dark also available
    themes: {
        dark: {
            palette: {
                type: "dark",
                primary: {
                    main: "#4db6ac"
                },
                secondary: {
                    main: "#4db6ac"
                },
                shades: {
                    dark: "#000000",
                    main: "#424242",
                    light: "#616161"
                }
            }
        },
        light: {
            palette: {
                type: "light"
            }
        }
    },
    theme: {
        // Sets up a MaterialUI theme. See https://material-ui.com/customization/default-theme/
        palette: {
            type: "light",
            primary: {
                main: "#1967d2" // Controls the color of the Add button and current window indicator
            },
            secondary: {
                main: "#1967d2" // Controls the color of Selects and FormControls
            },
            shades: {
                // Shades that can be used to offset color areas of the Workspace / Window
                dark: "#eeeeee",
                main: "#ffffff",
                light: "#f5f5f5"
            },
            error: {
                main: "#b00020"
            },
            notification: {
                // Color used in MUI Badge dots
                main: "#ffa224"
            },
            hitCounter: {
                "default": "#bdbdbd"
            },
            highlights: {
                primary: "#ffff00",
                secondary: "#00BFFF"
            },
            section_divider: "rgba(0, 0, 0, 0.25)",
            annotations: {
                hidden: {
                    globalAlpha: 0
                },
                "default": {
                    strokeStyle: "#00BFFF",
                    globalAlpha: 1
                },
                hovered: {
                    strokeStyle: "#BF00FF",
                    globalAlpha: 1
                },
                selected: {
                    strokeStyle: "#ffff00",
                    globalAlpha: 1
                }
            },
            search: {
                "default": {
                    fillStyle: "#00BFFF",
                    globalAlpha: 0.3
                },
                hovered: {
                    fillStyle: "#00FFFF",
                    globalAlpha: 0.3
                },
                selected: {
                    fillStyle: "#ffff00",
                    globalAlpha: 0.3
                }
            }
        },
        typography: {
            body1: {
                fontSize: "1rem",
                letterSpacing: "0em",
                lineHeight: "1.6em"
            },
            body2: {
                fontSize: "0.878rem",
                letterSpacing: "0.015em",
                lineHeight: "1.6em"
            },
            button: {
                fontSize: "0.878rem",
                letterSpacing: "0.09em",
                lineHeight: "2.25rem",
                textTransform: "uppercase"
            },
            caption: {
                fontSize: "0.772rem",
                letterSpacing: "0.033em",
                lineHeight: "1.6rem"
            },
            body1Next: {
                fontSize: "1rem",
                letterSpacing: "0em",
                lineHeight: "1.6em"
            },
            body2Next: {
                fontSize: "0.878rem",
                letterSpacing: "0.015em",
                lineHeight: "1.6em"
            },
            buttonNext: {
                fontSize: "0.878rem",
                letterSpacing: "0.09em",
                lineHeight: "2.25rem"
            },
            captionNext: {
                fontSize: "0.772rem",
                letterSpacing: "0.33em",
                lineHeight: "1.6rem"
            },
            overline: {
                fontSize: "0.678rem",
                fontWeight: 500,
                letterSpacing: "0.166em",
                lineHeight: "2em",
                textTransform: "uppercase"
            },
            h1: {
                fontSize: "2.822rem",
                letterSpacing: "-0.015em",
                lineHeight: "1.2em"
            },
            h2: {
                fontSize: "1.575rem",
                letterSpacing: "0em",
                lineHeight: "1.33em"
            },
            h3: {
                fontSize: "1.383rem",
                fontWeight: 300,
                letterSpacing: "0em",
                lineHeight: "1.33em"
            },
            h4: {
                fontSize: "1.215rem",
                letterSpacing: "0.007em",
                lineHeight: "1.45em"
            },
            h5: {
                fontSize: "1.138rem",
                letterSpacing: "0.005em",
                lineHeight: "1.55em"
            },
            h6: {
                fontSize: "1.067rem",
                fontWeight: 400,
                letterSpacing: "0.01em",
                lineHeight: "1.6em"
            },
            subtitle1: {
                fontSize: "0.937rem",
                letterSpacing: "0.015em",
                lineHeight: "1.6em",
                fontWeight: 300
            },
            subtitle2: {
                fontSize: "0.878rem",
                fontWeight: 500,
                letterSpacing: "0.02em",
                lineHeight: "1.75em"
            },
            useNextVariants: true // set so that console deprecation warning is removed
        },
        overrides: {
            MuiListSubheader: {
                root: {
                    '&[role="presentation"]:focus': {
                        outline: 0
                    }
                }
            },
            MuiTooltip: {
                // Overridden from https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/Tooltip/Tooltip.js#L40-L70
                tooltipPlacementLeft: $08beccc0bbca7411$var$_defineProperty({}, "@media (min-width:600px)", {
                    margin: 0
                }),
                tooltipPlacementRight: $08beccc0bbca7411$var$_defineProperty({}, "@media (min-width:600px)", {
                    margin: 0
                }),
                tooltipPlacementTop: $08beccc0bbca7411$var$_defineProperty({}, "@media (min-width:600px)", {
                    margin: 0
                }),
                tooltipPlacementBottom: $08beccc0bbca7411$var$_defineProperty({}, "@media (min-width:600px)", {
                    margin: 0
                })
            },
            MuiTouchRipple: {
                childPulsate: {
                    animation: "none"
                },
                rippleVisible: {
                    animation: "none"
                }
            }
        },
        props: {
            MuiButtonBase: {
                disableTouchRipple: true
            },
            MuiLink: {
                underline: "always"
            }
        }
    },
    language: "en",
    // The default language set in the application
    availableLanguages: {
        // All the languages available in the language switcher
        ar: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        de: "Deutsch",
        en: "English",
        fr: "Fran\xe7ais",
        ja: "\u65E5\u672C\u8A9E",
        kr: "\uD55C\uAD6D\uC5B4",
        lt: "Lietuvi\u0173",
        nl: "Nederlands",
        "nb-NO": "Norwegian Bokm\xe5l",
        pl: "Polski",
        "pt-BR": "Portugu\xeas do Brasil",
        vi: "Ti\u1EBFng Vi\u1EC7t",
        "zh-CN": "\u4E2D\u6587(\u7B80\u4F53)",
        "zh-TW": "\u4E2D\u6587(\u7E41\u9AD4)",
        it: "Italiano",
        sr: "\u0421\u0440\u043F\u0441\u043A\u0438",
        sv: "Svenska"
    },
    annotations: {
        htmlSanitizationRuleSet: "iiif",
        // See src/lib/htmlRules.js for acceptable values
        filteredMotivations: [
            "oa:commenting",
            "oa:tagging",
            "sc:painting",
            "commenting",
            "tagging"
        ]
    },
    createGenerateClassNameOptions: {
        // Options passed directly to createGenerateClassName in Material-UI https://material-ui.com/styles/api/#creategenerateclassname-options-class-name-generator
        productionPrefix: "mirador"
    },
    requests: {
        preprocessors: [],
        postprocessors: []
    },
    translations: {},
    window: {
        //global window defaults
        allowClose: true,
        // Configure if windows can be closed or not
        allowFullscreen: false,
        // Configure to show a "fullscreen" button in the WindowTopBar
        allowMaximize: true,
        // Configure if windows can be maximized or not
        allowTopMenuButton: true,
        // Configure if window view and thumbnail display menu are visible or not
        allowWindowSideBar: true,
        // Configure if side bar menu is visible or not
        authNewWindowCenter: "parent",
        // Configure how to center a new window created by the authentication flow. Options: parent, screen
        sideBarPanel: "info",
        // Configure which sidebar is selected by default. Options: info, attribution, canvas, annotations, search
        defaultSidebarPanelHeight: 201,
        // Configure default sidebar height in pixels
        defaultSidebarPanelWidth: 235,
        // Configure default sidebar width in pixels
        defaultView: "single",
        // Configure which viewing mode (e.g. single, book, gallery) for windows to be opened in
        forceDrawAnnotations: false,
        hideWindowTitle: false,
        // Configure if the window title is shown in the window title bar or not
        highlightAllAnnotations: false,
        // Configure whether to display annotations on the canvas by default
        showLocalePicker: false,
        // Configure locale picker for multi-lingual metadata
        sideBarOpen: false,
        // Configure if the sidebar (and its content panel) is open by default
        switchCanvasOnSearch: true,
        // Configure if Mirador should automatically switch to the canvas of the first search result
        panels: {
            // Configure which panels are visible in WindowSideBarButtons
            info: true,
            attribution: true,
            canvas: true,
            annotations: true,
            search: true,
            layers: true
        },
        views: [
            {
                key: "single",
                behaviors: [
                    "individuals"
                ]
            },
            {
                key: "book",
                behaviors: [
                    "paged"
                ]
            },
            {
                key: "scroll",
                behaviors: [
                    "continuous"
                ]
            },
            {
                key: "gallery"
            }
        ],
        elastic: {
            height: 400,
            width: 480
        }
    },
    windows: [],
    thumbnails: {
        preferredFormats: [
            "jpg",
            "png",
            "webp",
            "tif"
        ]
    },
    thumbnailNavigation: {
        defaultPosition: "off",
        // Which position for the thumbnail navigation to be be displayed. Other possible values are "far-bottom" or "far-right"
        displaySettings: true,
        // Display the settings for this in WindowTopMenu
        height: 130,
        // height of entire ThumbnailNavigation area when position is "far-bottom"
        width: 100 // width of one canvas (doubled for book view) in ThumbnailNavigation area when position is "far-right"
    },
    workspace: {
        draggingEnabled: true,
        allowNewWindows: true,
        id: (0, $aowE3.default)(),
        isWorkspaceAddVisible: false,
        // Catalog/Workspace add window feature visible by default
        exposeModeOn: false,
        // unused?
        height: 5000,
        // height of the elastic mode's virtual canvas
        showZoomControls: false,
        // Configure if zoom controls should be displayed by default
        type: "mosaic",
        // Which workspace type to load by default. Other possible values are "elastic". If "mosaic" or "elastic" are not selected no worksapce type will be used.
        viewportPosition: {
            // center coordinates for the elastic mode workspace
            x: 0,
            y: 0
        },
        width: 5000 // width of the elastic mode's virtual canvas
    },
    workspaceControlPanel: {
        enabled: true // Configure if the control panel should be rendered.  Useful if you want to lock the viewer down to only the configured manifests
    },
    galleryView: {
        height: 120,
        // height of gallery view thumbnails
        width: null // width of gallery view thumbnails (or null, to auto-calculate an aspect-ratio appropriate size)
    },
    osdConfig: {
        // Default config used for OpenSeadragon
        alwaysBlend: false,
        blendTime: 0.1,
        preserveImageSizeOnResize: true,
        preserveViewport: true,
        showNavigationControl: false
    },
    "export": {
        catalog: true,
        companionWindows: true,
        config: true,
        elasticLayout: true,
        layers: true,
        // filter out anything re-retrievable:
        manifests: {
            filter: function filter(_ref) {
                var _ref2 = $08beccc0bbca7411$var$_slicedToArray(_ref, 2), id = _ref2[0], value = _ref2[1];
                return !id.startsWith("http");
            }
        },
        viewers: true,
        windows: true,
        workspace: true
    },
    audioOptions: {
        // Additional props passed to <audio> element
        controls: true,
        crossOrigin: "anonymous"
    },
    videoOptions: {
        // Additional props passed to <audio> element
        controls: true,
        crossOrigin: "anonymous"
    },
    auth: {
        serviceProfiles: [
            {
                profile: "http://iiif.io/api/auth/1/external",
                external: true
            },
            {
                profile: "http://iiif.io/api/auth/1/kiosk",
                kiosk: true
            },
            {
                profile: "http://iiif.io/api/auth/1/clickthrough"
            },
            {
                profile: "http://iiif.io/api/auth/1/login"
            },
            {
                profile: "http://iiif.io/api/auth/0/external",
                external: true
            },
            {
                profile: "http://iiif.io/api/auth/0/kiosk",
                kiosk: true
            },
            {
                profile: "http://iiif.io/api/auth/0/clickthrough"
            },
            {
                profile: "http://iiif.io/api/auth/0/login"
            }
        ]
    }
};

});
parcelRegister("aowE3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $791577e66398d717$export$2e2bcd8739ae039; });

var $321zH = parcelRequire("321zH");

var $4s67C = parcelRequire("4s67C");
function $791577e66398d717$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $321zH.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $4s67C.default)(rnds);
}
var $791577e66398d717$export$2e2bcd8739ae039 = $791577e66398d717$var$v4;

});
parcelRegister("321zH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2352c7b7be6717d4$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $2352c7b7be6717d4$var$getRandomValues;
var $2352c7b7be6717d4$var$rnds8 = new Uint8Array(16);
function $2352c7b7be6717d4$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$2352c7b7be6717d4$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $2352c7b7be6717d4$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$2352c7b7be6717d4$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $2352c7b7be6717d4$var$getRandomValues($2352c7b7be6717d4$var$rnds8);
}

});

parcelRegister("4s67C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33de869d562d0077$export$2e2bcd8739ae039; });

var $04Zu1 = parcelRequire("04Zu1");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $33de869d562d0077$var$byteToHex = [];
for(var $33de869d562d0077$var$i = 0; $33de869d562d0077$var$i < 256; ++$33de869d562d0077$var$i)$33de869d562d0077$var$byteToHex.push(($33de869d562d0077$var$i + 0x100).toString(16).substr(1));
function $33de869d562d0077$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($33de869d562d0077$var$byteToHex[arr[offset + 0]] + $33de869d562d0077$var$byteToHex[arr[offset + 1]] + $33de869d562d0077$var$byteToHex[arr[offset + 2]] + $33de869d562d0077$var$byteToHex[arr[offset + 3]] + "-" + $33de869d562d0077$var$byteToHex[arr[offset + 4]] + $33de869d562d0077$var$byteToHex[arr[offset + 5]] + "-" + $33de869d562d0077$var$byteToHex[arr[offset + 6]] + $33de869d562d0077$var$byteToHex[arr[offset + 7]] + "-" + $33de869d562d0077$var$byteToHex[arr[offset + 8]] + $33de869d562d0077$var$byteToHex[arr[offset + 9]] + "-" + $33de869d562d0077$var$byteToHex[arr[offset + 10]] + $33de869d562d0077$var$byteToHex[arr[offset + 11]] + $33de869d562d0077$var$byteToHex[arr[offset + 12]] + $33de869d562d0077$var$byteToHex[arr[offset + 13]] + $33de869d562d0077$var$byteToHex[arr[offset + 14]] + $33de869d562d0077$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $04Zu1.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $33de869d562d0077$export$2e2bcd8739ae039 = $33de869d562d0077$var$stringify;

});
parcelRegister("04Zu1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00f0111d770d46da$export$2e2bcd8739ae039; });

var $hNbcd = parcelRequire("hNbcd");
function $00f0111d770d46da$var$validate(uuid) {
    return typeof uuid === "string" && (0, $hNbcd.default).test(uuid);
}
var $00f0111d770d46da$export$2e2bcd8739ae039 = $00f0111d770d46da$var$validate;

});
parcelRegister("hNbcd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf3fb28f187aef5e$export$2e2bcd8739ae039; });
var $cf3fb28f187aef5e$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});






parcelRegister("dy9HC", function(module, exports) {

$parcel$export(module.exports, "getWindowManifests", function () { return $9dd5fa13649463ce$export$2184643cd1eb8f8e; });
$parcel$export(module.exports, "getWindows", function () { return $9dd5fa13649463ce$export$118fcd4280b7af08; });
$parcel$export(module.exports, "getWindow", function () { return $9dd5fa13649463ce$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getViewer", function () { return $9dd5fa13649463ce$export$acad91b3d0c8b9b0; });
$parcel$export(module.exports, "getWorkspace", function () { return $9dd5fa13649463ce$export$9c41d1c3b33f9caa; });
$parcel$export(module.exports, "getWindowIds", function () { return $9dd5fa13649463ce$export$5b658f1b1abc730e; });
$parcel$export(module.exports, "getManifests", function () { return $9dd5fa13649463ce$export$6f6da1fda8dcff29; });
$parcel$export(module.exports, "getManifest", function () { return $9dd5fa13649463ce$export$39e873de56f329d8; });
$parcel$export(module.exports, "getCatalog", function () { return $9dd5fa13649463ce$export$a00286f3d8250e9b; });

var $1LbRi = parcelRequire("1LbRi");

var $fr77o = parcelRequire("fr77o");
function $9dd5fa13649463ce$export$2184643cd1eb8f8e(state) {
    return Object.values((0, $fr77o.miradorSlice)(state).windows).map(function(window) {
        return window.manifestId;
    });
}
function $9dd5fa13649463ce$export$118fcd4280b7af08(state) {
    return (0, $fr77o.miradorSlice)(state).windows || {};
}
function $9dd5fa13649463ce$export$38b2d434cce3ea22(state, _ref) {
    var windowId = _ref.windowId;
    return $9dd5fa13649463ce$export$118fcd4280b7af08(state)[windowId];
}
var $9dd5fa13649463ce$export$acad91b3d0c8b9b0 = (0, $1LbRi.createSelector)([
    function(state) {
        return (0, $fr77o.miradorSlice)(state).viewers;
    },
    function(state, _ref2) {
        var windowId = _ref2.windowId;
        return windowId;
    }
], function(viewers, windowId) {
    return viewers[windowId];
});
function $9dd5fa13649463ce$export$9c41d1c3b33f9caa(state) {
    return (0, $fr77o.miradorSlice)(state).workspace;
}
var $9dd5fa13649463ce$export$5b658f1b1abc730e = (0, $1LbRi.createSelector)([
    $9dd5fa13649463ce$export$9c41d1c3b33f9caa
], function(_ref3) {
    var windowIds = _ref3.windowIds;
    return windowIds || [];
});
function $9dd5fa13649463ce$export$6f6da1fda8dcff29(state) {
    return (0, $fr77o.miradorSlice)(state).manifests || {};
}
function $9dd5fa13649463ce$export$39e873de56f329d8(state, _ref4) {
    var manifestId = _ref4.manifestId, windowId = _ref4.windowId;
    var manifests = $9dd5fa13649463ce$export$6f6da1fda8dcff29(state);
    return manifests && manifests[manifestId || windowId && ($9dd5fa13649463ce$export$38b2d434cce3ea22(state, {
        windowId: windowId
    }) || {}).manifestId];
}
function $9dd5fa13649463ce$export$a00286f3d8250e9b(state) {
    return (0, $fr77o.miradorSlice)(state).catalog || {};
}

});

parcelRegister("51Gx5", function(module, exports) {

$parcel$export(module.exports, "getSequences", function () { return $3a8e09d71e08b70c$export$c554f64eaaa85ca7; });
$parcel$export(module.exports, "getSequence", function () { return $3a8e09d71e08b70c$export$5c1e203ca018159a; });
$parcel$export(module.exports, "getCanvasIndex", function () { return $3a8e09d71e08b70c$export$8eb84fb92ed6ba45; });
$parcel$export(module.exports, "getSequenceViewingHint", function () { return $3a8e09d71e08b70c$export$59164c12b6f1ee41; });
$parcel$export(module.exports, "getSequenceViewingDirection", function () { return $3a8e09d71e08b70c$export$c44e765c4ff26b6a; });
$parcel$export(module.exports, "getSequenceBehaviors", function () { return $3a8e09d71e08b70c$export$c5ef4fcb2c9271c2; });
$parcel$export(module.exports, "getSequenceTreeStructure", function () { return $3a8e09d71e08b70c$export$da97640ab8c07283; });

var $1LbRi = parcelRequire("1LbRi");

var $a4sDT = parcelRequire("a4sDT");

var $7GY88 = parcelRequire("7GY88");

var $dy9HC = parcelRequire("dy9HC");
var $3a8e09d71e08b70c$export$c554f64eaaa85ca7 = (0, $1LbRi.createSelector)([
    (0, $7GY88.getManifestoInstance)
], function(manifest) {
    if (!manifest || !manifest.getTopRanges) return null;
    var topRangesOrRoot = manifest.getTopRanges();
    var v2TopRanges = topRangesOrRoot.filter(function(r) {
        return r.getProperty("viewingHint") === "top";
    });
    var v3RangeSequences = [];
    if (v2TopRanges.length === 0 && topRangesOrRoot.length === 1) v3RangeSequences = topRangesOrRoot[0].getRanges().filter(function(r) {
        return r.getBehavior() === "sequence";
    });
    var sequences = [].concat(manifest.getSequences(), v3RangeSequences);
    return sequences;
});
var $3a8e09d71e08b70c$export$5c1e203ca018159a = (0, $1LbRi.createSelector)([
    $3a8e09d71e08b70c$export$c554f64eaaa85ca7,
    (0, $dy9HC.getWindow),
    function(state, _ref) {
        var sequenceId = _ref.sequenceId;
        return sequenceId;
    }
], function(sequences, window, sequenceId) {
    if (!sequences) return null;
    if (sequenceId || window && window.sequenceId) {
        var currentSequence = sequences.find(function(s) {
            return s.id === (sequenceId || window.sequenceId);
        });
        if (currentSequence) return currentSequence;
    }
    return sequences[0];
});
var $3a8e09d71e08b70c$export$8eb84fb92ed6ba45 = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWindow),
    $3a8e09d71e08b70c$export$5c1e203ca018159a
], function(window, sequence) {
    return (sequence && window && window.canvasId && sequence.getCanvasById(window.canvasId) || {}).index || 0;
});
var $3a8e09d71e08b70c$export$59164c12b6f1ee41 = (0, $1LbRi.createSelector)([
    $3a8e09d71e08b70c$export$5c1e203ca018159a,
    (0, $7GY88.getManifestoInstance)
], function(sequence, manifest) {
    if (!manifest) return null;
    var viewingHint = sequence && sequence.getViewingHint() || manifest.getViewingHint();
    if (viewingHint) return viewingHint;
    return null;
});
var $3a8e09d71e08b70c$export$c44e765c4ff26b6a = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWindow),
    $3a8e09d71e08b70c$export$5c1e203ca018159a,
    (0, $7GY88.getManifestoInstance)
], function(window, sequence, manifest) {
    var viewingDirection = window && window.viewingDirection || sequence && sequence.getViewingDirection() || manifest && manifest.getViewingDirection();
    if (viewingDirection) return viewingDirection;
    return null;
});
var $3a8e09d71e08b70c$export$c5ef4fcb2c9271c2 = (0, $1LbRi.createSelector)([
    $3a8e09d71e08b70c$export$5c1e203ca018159a,
    (0, $7GY88.getManifestoInstance)
], function(sequence, manifest) {
    if (!manifest || !sequence) return [];
    var sequenceBehaviors = sequence && sequence.getProperty("behavior");
    if (sequenceBehaviors) {
        if (Array.isArray(sequenceBehaviors)) return sequenceBehaviors;
        return [
            sequenceBehaviors
        ];
    }
    var behaviors = manifest.getProperty("behavior");
    if (!behaviors) return [];
    if (Array.isArray(behaviors)) return behaviors;
    return [
        behaviors
    ];
});
var $3a8e09d71e08b70c$export$da97640ab8c07283 = (0, $1LbRi.createSelector)([
    $3a8e09d71e08b70c$export$5c1e203ca018159a,
    (0, $7GY88.getManifestoInstance)
], function(sequence, manifest) {
    if (sequence && sequence.getProperty("type") && sequence.isRange()) return sequence.getTree(new (0, $a4sDT.TreeNode)("root"));
    return manifest && manifest.getDefaultTree();
});

});
parcelRegister("7GY88", function(module, exports) {

$parcel$export(module.exports, "getManifestStatus", function () { return $599b193e500e462a$export$4ab9af08932f71fc; });
$parcel$export(module.exports, "getManifestError", function () { return $599b193e500e462a$export$80fa28f1c791d819; });
$parcel$export(module.exports, "getManifestoInstance", function () { return $599b193e500e462a$export$5714634748f3c3ee; });
$parcel$export(module.exports, "getManifestLocale", function () { return $599b193e500e462a$export$a9547185940a32ec; });
$parcel$export(module.exports, "getManifestLogo", function () { return $599b193e500e462a$export$ae86dbdea3498508; });
$parcel$export(module.exports, "getManifestProvider", function () { return $599b193e500e462a$export$b0ac4a162cd4ee61; });
$parcel$export(module.exports, "getManifestHomepage", function () { return $599b193e500e462a$export$978a7ae24f119389; });
$parcel$export(module.exports, "getManifestRenderings", function () { return $599b193e500e462a$export$966f99e90af333cc; });
$parcel$export(module.exports, "getManifestRelatedContent", function () { return $599b193e500e462a$export$7e2e68c22d209200; });
$parcel$export(module.exports, "getRequiredStatement", function () { return $599b193e500e462a$export$89c3d4068848620c; });
$parcel$export(module.exports, "getRights", function () { return $599b193e500e462a$export$11b9f7342e59eaab; });
$parcel$export(module.exports, "getManifestThumbnail", function () { return $599b193e500e462a$export$c618240fb053319; });
$parcel$export(module.exports, "getManifestTitle", function () { return $599b193e500e462a$export$c5385f5386938ff8; });
$parcel$export(module.exports, "getManifestDescription", function () { return $599b193e500e462a$export$4c4741fa6b70ea69; });
$parcel$export(module.exports, "getManifestUrl", function () { return $599b193e500e462a$export$6edffb2def03e10f; });
$parcel$export(module.exports, "getDestructuredMetadata", function () { return $599b193e500e462a$export$ce1df7902228a5c6; });
$parcel$export(module.exports, "getManifestMetadata", function () { return $599b193e500e462a$export$c554e94e58c084df; });
$parcel$export(module.exports, "getMetadataLocales", function () { return $599b193e500e462a$export$aa36c6554a668353; });
$parcel$export(module.exports, "getManifestSearchService", function () { return $599b193e500e462a$export$ae4d2cb574a20f85; });
$parcel$export(module.exports, "getManifestAutocompleteService", function () { return $599b193e500e462a$export$a95eb1a5830f5410; });

var $1LbRi = parcelRequire("1LbRi");

var $22YGY = parcelRequire("22YGY");

var $a4sDT = parcelRequire("a4sDT");

var $6zvk6 = parcelRequire("6zvk6");

var $eMT7M = parcelRequire("eMT7M");

var $24Kso = parcelRequire("24Kso");

var $dy9HC = parcelRequire("dy9HC");

var $jGts0 = parcelRequire("jGts0");
function $599b193e500e462a$var$_toConsumableArray(arr) {
    return $599b193e500e462a$var$_arrayWithoutHoles(arr) || $599b193e500e462a$var$_iterableToArray(arr) || $599b193e500e462a$var$_unsupportedIterableToArray(arr) || $599b193e500e462a$var$_nonIterableSpread();
}
function $599b193e500e462a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $599b193e500e462a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $599b193e500e462a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $599b193e500e462a$var$_arrayLikeToArray(o, minLen);
}
function $599b193e500e462a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $599b193e500e462a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $599b193e500e462a$var$_arrayLikeToArray(arr);
}
function $599b193e500e462a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/** */ function $599b193e500e462a$var$createManifestoInstance(json, locale) {
    if (!json) return undefined;
    var manifestoObject = (0, $a4sDT.Utils).parseManifest(json, locale ? {
        locale: locale
    } : undefined); // Local patching of Manifesto so that when its a Collection, it behaves similarly
    if (typeof manifestoObject.getSequences != "function") manifestoObject.getSequences = function() {
        return [];
    };
    return manifestoObject;
}
/** */ var $599b193e500e462a$var$getLocale = (0, $1LbRi.createSelector)([
    (0, $24Kso.getCompanionWindow),
    (0, $jGts0.getConfig)
], function() {
    var companionWindow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return companionWindow.locale || config.language;
});
var $599b193e500e462a$export$4ab9af08932f71fc = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getManifest)
], function(manifest) {
    return manifest || {
        missing: true
    };
});
var $599b193e500e462a$export$80fa28f1c791d819 = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getManifest)
], function(manifest) {
    return manifest && manifest.error;
});
/** Instantiate a manifesto instance */ var $599b193e500e462a$var$getContextualManifestoInstance = (0, (/*@__PURE__*/$parcel$interopDefault($22YGY)))((0, $dy9HC.getManifest), $599b193e500e462a$var$getLocale, function(manifest, locale) {
    return manifest && $599b193e500e462a$var$createManifestoInstance(manifest.json, locale);
})(function(state, _ref) {
    var companionWindowId = _ref.companionWindowId, manifestId = _ref.manifestId, windowId = _ref.windowId;
    return [
        manifestId,
        windowId,
        $599b193e500e462a$var$getLocale(state, {
            companionWindowId: companionWindowId
        })
    ].join(" - ");
} // Cache key consisting of manifestId, windowId, and locale
);
var $599b193e500e462a$export$5714634748f3c3ee = (0, $1LbRi.createSelector)($599b193e500e462a$var$getContextualManifestoInstance, function(state, _ref2) {
    var json = _ref2.json;
    return json;
}, $599b193e500e462a$var$getLocale, function(manifesto, manifestJson, locale) {
    return manifestJson && $599b193e500e462a$var$createManifestoInstance(manifestJson, locale) || manifesto;
});
var $599b193e500e462a$export$a9547185940a32ec = (0, $1LbRi.createSelector)([
    $599b193e500e462a$export$5714634748f3c3ee
], function(manifest) {
    return manifest && manifest.options && manifest.options.locale && manifest.options.locale.replace(/-.*$/, "");
});
/** */ function $599b193e500e462a$var$getProperty(property) {
    return (0, $1LbRi.createSelector)([
        $599b193e500e462a$export$5714634748f3c3ee
    ], function(manifest) {
        return manifest && manifest.getProperty(property);
    });
}
var $599b193e500e462a$export$ae86dbdea3498508 = (0, $1LbRi.createSelector)([
    $599b193e500e462a$export$5714634748f3c3ee
], function(manifest) {
    return manifest && manifest.getLogo();
});
var $599b193e500e462a$export$b0ac4a162cd4ee61 = (0, $1LbRi.createSelector)([
    $599b193e500e462a$var$getProperty("provider"),
    $599b193e500e462a$export$a9547185940a32ec
], function(provider, locale) {
    return provider && provider[0].label && (0, $a4sDT.PropertyValue).parse(provider[0].label, locale).getValue();
});
var $599b193e500e462a$export$978a7ae24f119389 = (0, $1LbRi.createSelector)([
    $599b193e500e462a$var$getProperty("homepage"),
    $599b193e500e462a$export$a9547185940a32ec
], function(homepages, locale) {
    return homepages && (0, $eMT7M.default)(homepages).map(function(homepage) {
        return {
            label: (0, $a4sDT.PropertyValue).parse(homepage.label, locale).getValue(),
            value: homepage.id || homepage["@id"]
        };
    });
});
var $599b193e500e462a$export$966f99e90af333cc = (0, $1LbRi.createSelector)([
    $599b193e500e462a$export$5714634748f3c3ee
], function(manifest) {
    return manifest && manifest.getRenderings().map(function(rendering) {
        return {
            label: rendering.getLabel().getValue(),
            value: rendering.id
        };
    });
});
var $599b193e500e462a$export$7e2e68c22d209200 = (0, $1LbRi.createSelector)([
    $599b193e500e462a$var$getProperty("seeAlso"),
    $599b193e500e462a$export$a9547185940a32ec
], function(seeAlso, locale) {
    return seeAlso && (0, $eMT7M.default)(seeAlso).map(function(related) {
        return {
            format: related.format,
            label: (0, $a4sDT.PropertyValue).parse(related.label, locale).getValue(),
            value: related.id || related["@id"]
        };
    });
});
var $599b193e500e462a$export$89c3d4068848620c = (0, $1LbRi.createSelector)([
    $599b193e500e462a$export$5714634748f3c3ee
], function(manifest) {
    return manifest && (0, $eMT7M.default)(manifest.getRequiredStatement()).filter(function(l) {
        return l.getValues().some(function(v) {
            return v;
        });
    }).map(function(labelValuePair) {
        return {
            label: labelValuePair.label && labelValuePair.label.getValue() || null,
            values: labelValuePair.getValues()
        };
    });
});
var $599b193e500e462a$export$11b9f7342e59eaab = (0, $1LbRi.createSelector)([
    $599b193e500e462a$var$getProperty("rights"),
    $599b193e500e462a$var$getProperty("license"),
    $599b193e500e462a$export$a9547185940a32ec
], function(rights, license, locale) {
    var data = rights || license;
    return (0, $eMT7M.default)((0, $a4sDT.PropertyValue).parse(data, locale).getValues());
});
function $599b193e500e462a$export$c618240fb053319(state, props) {
    var manifest = $599b193e500e462a$export$5714634748f3c3ee(state, props);
    var _getConfig = (0, $jGts0.getConfig)(state), _getConfig$thumbnails = _getConfig.thumbnails, thumbnails = _getConfig$thumbnails === void 0 ? {} : _getConfig$thumbnails;
    if (!manifest) return undefined;
    var thumbnail = (0, $6zvk6.default)(manifest, {
        maxHeight: 80,
        maxWidth: 120,
        preferredFormats: thumbnails.preferredFormats
    });
    return thumbnail && thumbnail.url;
}
var $599b193e500e462a$export$c5385f5386938ff8 = (0, $1LbRi.createSelector)([
    $599b193e500e462a$export$5714634748f3c3ee
], function(manifest) {
    return manifest && manifest.getLabel().getValue();
});
var $599b193e500e462a$export$4c4741fa6b70ea69 = (0, $1LbRi.createSelector)([
    $599b193e500e462a$export$5714634748f3c3ee
], function(manifest) {
    return manifest && manifest.getDescription().getValue();
});
var $599b193e500e462a$export$6edffb2def03e10f = (0, $1LbRi.createSelector)([
    $599b193e500e462a$export$5714634748f3c3ee
], function(manifest) {
    return manifest && manifest.id;
});
function $599b193e500e462a$export$ce1df7902228a5c6(iiifResource) {
    return iiifResource && iiifResource.getMetadata().map(function(labelValuePair) {
        return {
            label: labelValuePair.getLabel(),
            values: labelValuePair.getValues()
        };
    });
}
var $599b193e500e462a$export$c554e94e58c084df = (0, $1LbRi.createSelector)([
    $599b193e500e462a$export$5714634748f3c3ee
], function(manifest) {
    return manifest && $599b193e500e462a$export$ce1df7902228a5c6(manifest);
});
/** */ function $599b193e500e462a$var$getLocalesForStructure(item) {
    var languages = [];
    if (Array.isArray(item)) languages.push.apply(languages, $599b193e500e462a$var$_toConsumableArray(item.filter(function(i) {
        return typeof i === "object" && i["@language"];
    }).map(function(i) {
        return i["@language"];
    })));
    else if (item && typeof item === "object") {
        if (item["@language"]) languages.push(item["@language"]);
    }
    return languages;
}
/** */ function $599b193e500e462a$var$getLocales(resource) {
    if (!resource) return [];
    var metadata = resource.getProperty("metadata") || [];
    var languages = {};
    for(var i = 0; i < metadata.length; i += 1){
        var item = metadata[i];
        $599b193e500e462a$var$getLocalesForStructure(item.label).forEach(function(l) {
            languages[l] = true;
        });
        $599b193e500e462a$var$getLocalesForStructure(item.value).forEach(function(l) {
            languages[l] = true;
        });
    }
    return Object.keys(languages);
}
var $599b193e500e462a$export$aa36c6554a668353 = (0, $1LbRi.createSelector)([
    $599b193e500e462a$export$5714634748f3c3ee
], function(manifest) {
    return $599b193e500e462a$var$getLocales(manifest);
});
var $599b193e500e462a$export$ae4d2cb574a20f85 = (0, $1LbRi.createSelector)([
    $599b193e500e462a$export$5714634748f3c3ee
], function(manifest) {
    if (!manifest) return null;
    var searchService = manifest.getService("http://iiif.io/api/search/0/search") || manifest.getService("http://iiif.io/api/search/1/search");
    if (searchService) return searchService;
    return null;
});
var $599b193e500e462a$export$a95eb1a5830f5410 = (0, $1LbRi.createSelector)([
    $599b193e500e462a$export$ae4d2cb574a20f85
], function(searchService) {
    var autocompleteService = searchService && (searchService.getService("http://iiif.io/api/search/0/autocomplete") || searchService.getService("http://iiif.io/api/search/1/autocomplete"));
    return autocompleteService && autocompleteService;
});

});
parcelRegister("22YGY", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("1LbRi")));
})(module.exports, function(exports1, reselect) {
    "use strict";
    function isStringOrNumber(value) {
        return typeof value === "string" || typeof value === "number";
    }
    var FlatObjectCache = /*#__PURE__*/ function() {
        function FlatObjectCache() {
            this._cache = {};
        }
        var _proto = FlatObjectCache.prototype;
        _proto.set = function set(key, selectorFn) {
            this._cache[key] = selectorFn;
        };
        _proto.get = function get(key) {
            return this._cache[key];
        };
        _proto.remove = function remove(key) {
            delete this._cache[key];
        };
        _proto.clear = function clear() {
            this._cache = {};
        };
        _proto.isValidCacheKey = function isValidCacheKey(cacheKey) {
            return isStringOrNumber(cacheKey);
        };
        return FlatObjectCache;
    }();
    var defaultCacheCreator = FlatObjectCache;
    var defaultCacheKeyValidator = function defaultCacheKeyValidator() {
        return true;
    };
    function createCachedSelector() {
        for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
        return function(polymorphicOptions, legacyOptions) {
            if (legacyOptions) throw new Error('[re-reselect] "options" as second argument is not supported anymore. Please provide an option object as single argument.');
            var options = typeof polymorphicOptions === "function" ? {
                keySelector: polymorphicOptions
            } : Object.assign({}, polymorphicOptions); // https://github.com/reduxjs/reselect/blob/v4.0.0/src/index.js#L54
            var recomputations = 0;
            var resultFunc = funcs.pop();
            var dependencies = Array.isArray(funcs[0]) ? funcs[0] : [].concat(funcs);
            var resultFuncWithRecomputations = function resultFuncWithRecomputations() {
                recomputations++;
                return resultFunc.apply(void 0, arguments);
            };
            funcs.push(resultFuncWithRecomputations);
            var cache = options.cacheObject || new defaultCacheCreator();
            var selectorCreator = options.selectorCreator || reselect.createSelector;
            var isValidCacheKey = cache.isValidCacheKey || defaultCacheKeyValidator;
            if (options.keySelectorCreator) options.keySelector = options.keySelectorCreator({
                keySelector: options.keySelector,
                inputSelectors: dependencies,
                resultFunc: resultFunc
            });
             // Application receives this function
            var selector = function selector() {
                var cacheKey = options.keySelector.apply(options, arguments);
                if (isValidCacheKey(cacheKey)) {
                    var cacheResponse = cache.get(cacheKey);
                    if (cacheResponse === undefined) {
                        cacheResponse = selectorCreator.apply(void 0, funcs);
                        cache.set(cacheKey, cacheResponse);
                    }
                    return cacheResponse.apply(void 0, arguments);
                }
                console.warn('[re-reselect] Invalid cache key "' + cacheKey + '" has been returned by keySelector function.');
                return undefined;
            }; // Further selector methods
            selector.getMatchingSelector = function() {
                var cacheKey = options.keySelector.apply(options, arguments); // @NOTE It might update cache hit count in LRU-like caches
                return cache.get(cacheKey);
            };
            selector.removeMatchingSelector = function() {
                var cacheKey = options.keySelector.apply(options, arguments);
                cache.remove(cacheKey);
            };
            selector.clearCache = function() {
                cache.clear();
            };
            selector.resultFunc = resultFunc;
            selector.dependencies = dependencies;
            selector.cache = cache;
            selector.recomputations = function() {
                return recomputations;
            };
            selector.resetRecomputations = function() {
                return recomputations = 0;
            };
            selector.keySelector = options.keySelector;
            return selector;
        };
    }
    function createStructuredCachedSelector(selectors) {
        return reselect.createStructuredSelector(selectors, createCachedSelector);
    }
    function validateCacheSize(cacheSize) {
        if (cacheSize === undefined) throw new Error('Missing the required property "cacheSize".');
        if (!Number.isInteger(cacheSize) || cacheSize <= 0) throw new Error('The "cacheSize" property must be a positive integer value.');
    }
    var FifoObjectCache = /*#__PURE__*/ function() {
        function FifoObjectCache(_temp) {
            var _ref = _temp === void 0 ? {} : _temp, cacheSize = _ref.cacheSize;
            validateCacheSize(cacheSize);
            this._cache = {};
            this._cacheOrdering = [];
            this._cacheSize = cacheSize;
        }
        var _proto = FifoObjectCache.prototype;
        _proto.set = function set(key, selectorFn) {
            this._cache[key] = selectorFn;
            this._cacheOrdering.push(key);
            if (this._cacheOrdering.length > this._cacheSize) {
                var earliest = this._cacheOrdering[0];
                this.remove(earliest);
            }
        };
        _proto.get = function get(key) {
            return this._cache[key];
        };
        _proto.remove = function remove(key) {
            var index = this._cacheOrdering.indexOf(key);
            if (index > -1) this._cacheOrdering.splice(index, 1);
            delete this._cache[key];
        };
        _proto.clear = function clear() {
            this._cache = {};
            this._cacheOrdering = [];
        };
        _proto.isValidCacheKey = function isValidCacheKey(cacheKey) {
            return isStringOrNumber(cacheKey);
        };
        return FifoObjectCache;
    }();
    var LruObjectCache = /*#__PURE__*/ function() {
        function LruObjectCache(_temp) {
            var _ref = _temp === void 0 ? {} : _temp, cacheSize = _ref.cacheSize;
            validateCacheSize(cacheSize);
            this._cache = {};
            this._cacheOrdering = [];
            this._cacheSize = cacheSize;
        }
        var _proto = LruObjectCache.prototype;
        _proto.set = function set(key, selectorFn) {
            this._cache[key] = selectorFn;
            this._registerCacheHit(key);
            if (this._cacheOrdering.length > this._cacheSize) {
                var earliest = this._cacheOrdering[0];
                this.remove(earliest);
            }
        };
        _proto.get = function get(key) {
            this._registerCacheHit(key);
            return this._cache[key];
        };
        _proto.remove = function remove(key) {
            this._deleteCacheHit(key);
            delete this._cache[key];
        };
        _proto.clear = function clear() {
            this._cache = {};
            this._cacheOrdering = [];
        };
        _proto._registerCacheHit = function _registerCacheHit(key) {
            this._deleteCacheHit(key);
            this._cacheOrdering.push(key);
        };
        _proto._deleteCacheHit = function _deleteCacheHit(key) {
            var index = this._cacheOrdering.indexOf(key);
            if (index > -1) this._cacheOrdering.splice(index, 1);
        };
        _proto.isValidCacheKey = function isValidCacheKey(cacheKey) {
            return isStringOrNumber(cacheKey);
        };
        return LruObjectCache;
    }();
    var FlatMapCache = /*#__PURE__*/ function() {
        function FlatMapCache() {
            this._cache = new Map();
        }
        var _proto = FlatMapCache.prototype;
        _proto.set = function set(key, selectorFn) {
            this._cache.set(key, selectorFn);
        };
        _proto.get = function get(key) {
            return this._cache.get(key);
        };
        _proto.remove = function remove(key) {
            this._cache["delete"](key);
        };
        _proto.clear = function clear() {
            this._cache.clear();
        };
        return FlatMapCache;
    }();
    var FifoMapCache = /*#__PURE__*/ function() {
        function FifoMapCache(_temp) {
            var _ref = _temp === void 0 ? {} : _temp, cacheSize = _ref.cacheSize;
            validateCacheSize(cacheSize);
            this._cache = new Map();
            this._cacheSize = cacheSize;
        }
        var _proto = FifoMapCache.prototype;
        _proto.set = function set(key, selectorFn) {
            this._cache.set(key, selectorFn);
            if (this._cache.size > this._cacheSize) {
                var earliest = this._cache.keys().next().value;
                this.remove(earliest);
            }
        };
        _proto.get = function get(key) {
            return this._cache.get(key);
        };
        _proto.remove = function remove(key) {
            this._cache["delete"](key);
        };
        _proto.clear = function clear() {
            this._cache.clear();
        };
        return FifoMapCache;
    }();
    var LruMapCache = /*#__PURE__*/ function() {
        function LruMapCache(_temp) {
            var _ref = _temp === void 0 ? {} : _temp, cacheSize = _ref.cacheSize;
            validateCacheSize(cacheSize);
            this._cache = new Map();
            this._cacheSize = cacheSize;
        }
        var _proto = LruMapCache.prototype;
        _proto.set = function set(key, selectorFn) {
            this._cache.set(key, selectorFn);
            if (this._cache.size > this._cacheSize) {
                var earliest = this._cache.keys().next().value;
                this.remove(earliest);
            }
        };
        _proto.get = function get(key) {
            var value = this._cache.get(key); // Register cache hit
            if (this._cache.has(key)) {
                this.remove(key);
                this._cache.set(key, value);
            }
            return value;
        };
        _proto.remove = function remove(key) {
            this._cache["delete"](key);
        };
        _proto.clear = function clear() {
            this._cache.clear();
        };
        return LruMapCache;
    }();
    exports1.FifoMapCache = FifoMapCache;
    exports1.FifoObjectCache = FifoObjectCache;
    exports1.FlatMapCache = FlatMapCache;
    exports1.FlatObjectCache = FlatObjectCache;
    exports1.LruMapCache = LruMapCache;
    exports1.LruObjectCache = LruObjectCache;
    exports1.createCachedSelector = createCachedSelector;
    exports1.createStructuredCachedSelector = createStructuredCachedSelector;
    exports1["default"] = createCachedSelector;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});

parcelRegister("6zvk6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c8e4f1c47b3a720$export$2e2bcd8739ae039; });

var $a4sDT = parcelRequire("a4sDT");

var $25EET = parcelRequire("25EET");

var $izTcV = parcelRequire("izTcV");

var $eMT7M = parcelRequire("eMT7M");
function $4c8e4f1c47b3a720$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4c8e4f1c47b3a720$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4c8e4f1c47b3a720$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4c8e4f1c47b3a720$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4c8e4f1c47b3a720$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/** */ function $4c8e4f1c47b3a720$var$isLevel0ImageProfile(service) {
    var profile = service.getProfile(); // work around a bug in manifesto with normalized urls that strip # values.
    if (profile.endsWith("#level1") || profile.endsWith("#level2")) return false; // support IIIF v3-style profiles
    if (profile === "level0") return true;
    return (0, $a4sDT.Utils).isLevel0ImageProfile(profile);
}
/** */ function $4c8e4f1c47b3a720$var$isLevel2ImageProfile(service) {
    var profile = service.getProfile(); // work around a bug in manifesto with normalized urls that strip # values.
    if (profile.endsWith("#level0") || profile.endsWith("#level1")) return false; // support IIIF v3-style profiles
    if (profile === "level2") return true;
    return (0, $a4sDT.Utils).isLevel2ImageProfile(profile);
}
/** */ function $4c8e4f1c47b3a720$var$iiifv3ImageServiceType(service) {
    var type = service.getProperty("type") || [];
    return (0, $eMT7M.default)(type).some(function(v) {
        return v.startsWith("ImageService");
    });
}
/** */ function $4c8e4f1c47b3a720$var$iiifImageService(resource) {
    var service = resource && resource.getServices().find(function(s) {
        return $4c8e4f1c47b3a720$var$iiifv3ImageServiceType(s) || (0, $a4sDT.Utils).isImageProfile(s.getProfile());
    });
    if (!service) return undefined;
    return service;
}
/** */ var $4c8e4f1c47b3a720$export$5cc1500b1b223a4e = /*#__PURE__*/ function() {
    /** */ function ThumbnailFactory(resource) {
        var iiifOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $4c8e4f1c47b3a720$var$_classCallCheck(this, ThumbnailFactory);
        this.resource = resource;
        this.iiifOpts = iiifOpts;
    }
    /** */ $4c8e4f1c47b3a720$var$_createClass(ThumbnailFactory, [
        {
            key: "iiifThumbnailUrl",
            value: /**
     * Determines the appropriate thumbnail to use to represent an Image Resource.
     * @param {Object} resource The Image Resource from which to derive a thumbnail
     * @return {Object} The thumbnail URL and any spatial dimensions that can be determined
     */ function iiifThumbnailUrl(resource) {
                var size;
                var width;
                var height;
                var minDimension = 120;
                var maxHeight = minDimension;
                var maxWidth = minDimension;
                var _this$iiifOpts = this.iiifOpts, requestedMaxHeight = _this$iiifOpts.maxHeight, requestedMaxWidth = _this$iiifOpts.maxWidth;
                if (requestedMaxHeight) maxHeight = Math.max(requestedMaxHeight, minDimension);
                if (requestedMaxWidth) maxWidth = Math.max(requestedMaxWidth, minDimension);
                var service = $4c8e4f1c47b3a720$var$iiifImageService(resource);
                if (!service) return ThumbnailFactory.staticImageUrl(resource);
                var aspectRatio = resource.getWidth() && resource.getHeight() && resource.getWidth() / resource.getHeight();
                var target = requestedMaxWidth && requestedMaxHeight ? requestedMaxWidth * requestedMaxHeight : maxHeight * maxWidth;
                var closestSize = ThumbnailFactory.selectBestImageSize(service, target);
                if (closestSize) {
                    // Embedded service advertises an appropriate size
                    width = closestSize.width;
                    height = closestSize.height;
                    size = "".concat(width, ",").concat(height);
                } else if ($4c8e4f1c47b3a720$var$isLevel0ImageProfile(service)) {
                    /** Bail if the best available size is the full size.. maybe we'll get lucky with the @id */ if (!service.getProperty("height") && !service.getProperty("width")) return ThumbnailFactory.staticImageUrl(resource);
                } else if (requestedMaxHeight && requestedMaxWidth) {
                    // IIIF level 2, no problem.
                    if ($4c8e4f1c47b3a720$var$isLevel2ImageProfile(service)) {
                        size = "!".concat(maxWidth, ",").concat(maxHeight);
                        width = maxWidth;
                        height = maxHeight;
                        if (aspectRatio && aspectRatio > 1) height = Math.round(maxWidth / aspectRatio);
                        if (aspectRatio && aspectRatio < 1) width = Math.round(maxHeight * aspectRatio);
                    } else if (maxWidth / maxHeight < aspectRatio) {
                        size = "".concat(maxWidth, ",");
                        width = maxWidth;
                        if (aspectRatio) height = Math.round(maxWidth / aspectRatio);
                    } else {
                        size = ",".concat(maxHeight);
                        height = maxHeight;
                        if (aspectRatio) width = Math.round(maxHeight * aspectRatio);
                    }
                } else if (requestedMaxHeight && !requestedMaxWidth) {
                    size = ",".concat(maxHeight);
                    height = maxHeight;
                    if (aspectRatio) width = Math.round(maxHeight * aspectRatio);
                } else if (!requestedMaxHeight && requestedMaxWidth) {
                    size = "".concat(maxWidth, ",");
                    width = maxWidth;
                    if (aspectRatio) height = Math.round(maxWidth / aspectRatio);
                } else {
                    size = ",".concat(minDimension);
                    height = minDimension;
                    if (aspectRatio) width = Math.round(height * aspectRatio);
                }
                var region = "full";
                var quality = (0, $a4sDT.Utils).getImageQuality(service.getProfile());
                var id = service.id.replace(/\/+$/, "");
                var format = this.getFormat(service);
                return {
                    height: height,
                    url: [
                        id,
                        region,
                        size,
                        0,
                        "".concat(quality, ".").concat(format)
                    ].join("/"),
                    width: width
                };
            }
        },
        {
            key: "getFormat",
            value: function getFormat(service) {
                var _this$iiifOpts$prefer = this.iiifOpts.preferredFormats, preferredFormats = _this$iiifOpts$prefer === void 0 ? [] : _this$iiifOpts$prefer;
                var servicePreferredFormats = service.getProperty("preferredFormats");
                if (!servicePreferredFormats) return "jpg";
                var filteredFormats = servicePreferredFormats.filter(function(value) {
                    return preferredFormats.includes(value);
                }); // this is a format found in common between the preferred formats of the service
                // and the application
                if (filteredFormats[0]) return filteredFormats[0]; // IIIF Image API guarantees jpg support; if it wasn't provided by the service
                // but the application is fine with it, we might as well try it.
                if (!servicePreferredFormats.includes("jpg") && preferredFormats.includes("jpg")) return "jpg";
                 // there were no formats in common, and the application didn't want jpg... so
                // just trust that the IIIF service is advertising something useful?
                if (servicePreferredFormats[0]) return servicePreferredFormats[0]; // JPG support is guaranteed by the spec, so it's a good worst-case fallback
                return "jpg";
            }
        },
        {
            key: "getSourceContentResource",
            value: function getSourceContentResource(resource) {
                var thumbnail = resource.getThumbnail(); // Any resource type may have a thumbnail
                if (thumbnail) {
                    if (typeof thumbnail.__jsonld === "string") return thumbnail.__jsonld; // Prefer an image's ImageService over its image's thumbnail
                    // Note that Collection, Manifest, and Canvas don't have `getType()`
                    if (!resource.isCollection() && !resource.isManifest() && !resource.isCanvas()) {
                        if (resource.getType() === "image" && $4c8e4f1c47b3a720$var$iiifImageService(resource) && !$4c8e4f1c47b3a720$var$iiifImageService(thumbnail)) return resource;
                    }
                    return thumbnail;
                }
                if (resource.isCollection()) {
                    var firstManifest = resource.getManifests()[0];
                    if (firstManifest) return this.getSourceContentResource(firstManifest);
                    return undefined;
                }
                if (resource.isManifest()) {
                    var miradorManifest = new (0, $25EET.default)(resource);
                    var canvas = miradorManifest.startCanvas || miradorManifest.canvasAt(0);
                    if (canvas) return this.getSourceContentResource(canvas);
                    return undefined;
                }
                if (resource.isCanvas()) {
                    var image = ThumbnailFactory.getPreferredImage(resource);
                    if (image) return this.getSourceContentResource(image);
                    return undefined;
                }
                if (resource.getType() === "image") return resource;
                return undefined;
            }
        },
        {
            key: "get",
            value: function get() {
                if (!this.resource) return undefined; // Determine which content resource we should use to derive a thumbnail
                var sourceContentResource = this.getSourceContentResource(this.resource);
                if (!sourceContentResource) return undefined; // Special treatment for external resources
                if (typeof sourceContentResource === "string") return {
                    url: sourceContentResource
                };
                return this.iiifThumbnailUrl(sourceContentResource);
            }
        }
    ], [
        {
            key: "staticImageUrl",
            value: function staticImageUrl(resource) {
                return {
                    height: resource.getProperty("height"),
                    url: resource.id,
                    width: resource.getProperty("width")
                };
            }
        },
        {
            key: "getPreferredImage",
            value: function getPreferredImage(canvas) {
                var miradorCanvas = new (0, $izTcV.default)(canvas);
                return miradorCanvas.iiifImageResources[0] || miradorCanvas.imageResource;
            }
        },
        {
            key: "selectBestImageSize",
            value: function selectBestImageSize(service, targetArea) {
                var sizes = (0, $eMT7M.default)(service.getProperty("sizes"));
                var closestSize = {
                    "default": true,
                    height: service.getProperty("height") || Number.MAX_SAFE_INTEGER,
                    width: service.getProperty("width") || Number.MAX_SAFE_INTEGER
                };
                /** Compare the total image area to our target */ var imageFitness = function imageFitness(test) {
                    return test.width * test.height - targetArea;
                };
                /** Look for the size that's just bigger than we prefer... */ closestSize = sizes.reduce(function(best, test) {
                    var score = imageFitness(test);
                    if (score < 0) return best;
                    return Math.abs(score) < Math.abs(imageFitness(best)) ? test : best;
                }, closestSize);
                /** .... but not "too" big; we'd rather scale up an image than download too much */ if (closestSize.width * closestSize.height > targetArea * 6) closestSize = sizes.reduce(function(best, test) {
                    return Math.abs(imageFitness(test)) < Math.abs(imageFitness(best)) ? test : best;
                }, closestSize);
                if (closestSize["default"]) return undefined;
                return closestSize;
            }
        }
    ]);
    return ThumbnailFactory;
}();
/** */ function $4c8e4f1c47b3a720$export$2e2bcd8739ae039(resource, iiifOpts) {
    return new $4c8e4f1c47b3a720$export$5cc1500b1b223a4e(resource, iiifOpts).get();
}

});
parcelRegister("25EET", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $185b965ad0f76361$export$2e2bcd8739ae039; });
function $185b965ad0f76361$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $185b965ad0f76361$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $185b965ad0f76361$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $185b965ad0f76361$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $185b965ad0f76361$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * MiradorManifest - adds additional, testable logic around Manifesto's Manifest
 * https://iiif-commons.github.io/manifesto/classes/_canvas_.manifesto.canvas.html
 */ var $185b965ad0f76361$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /** */ function MiradorManifest(manifest) {
        $185b965ad0f76361$var$_classCallCheck(this, MiradorManifest);
        this.manifest = manifest;
    }
    /**
   * Returns the starting canvas specified in the manifest
   * @param {object} manifest manifesto instance
   * @param {number} canvasIndexFromState
   * @return {Canvas}
   */ $185b965ad0f76361$var$_createClass(MiradorManifest, [
        {
            key: "startCanvas",
            get: function get() {
                var canvasId;
                var sequence = this.manifest.getSequences()[0];
                if (!sequence) return undefined; // IIIF v2
                canvasId = sequence.getProperty("startCanvas");
                if (!canvasId) {
                    // IIIF v3
                    var start = this.manifest.getProperty("start") || sequence.getProperty("start");
                    canvasId = start && (start.id || start.source);
                }
                return canvasId && sequence.getCanvasById(canvasId) || undefined;
            }
        },
        {
            key: "canvasAt",
            value: function canvasAt(index) {
                var sequence = this.manifest.getSequences()[0];
                var canvases = sequence && sequence.getCanvases();
                return canvases && canvases[index];
            }
        }
    ]);
    return MiradorManifest;
}();

});

parcelRegister("eMT7M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac404efac4f56119$export$2e2bcd8739ae039; });
/**
 */ function $ac404efac4f56119$export$2e2bcd8739ae039(value) {
    if (value === undefined) return [];
    if (!Array.isArray(value)) return [
        value
    ];
    return value;
}

});


parcelRegister("24Kso", function(module, exports) {

$parcel$export(module.exports, "getCompanionWindows", function () { return $182ffde0538291ba$export$32d1ab69db1d2f2f; });
$parcel$export(module.exports, "getCompanionWindow", function () { return $182ffde0538291ba$export$491de7fbfa4c6fa7; });
$parcel$export(module.exports, "getThumbnailNavigationPosition", function () { return $182ffde0538291ba$export$ebab28d96b2adbf4; });
$parcel$export(module.exports, "getCompanionWindowsForPosition", function () { return $182ffde0538291ba$export$82ad1952eff70e20; });
$parcel$export(module.exports, "getCompanionWindowsForContent", function () { return $182ffde0538291ba$export$58e2e8765c24002d; });
$parcel$export(module.exports, "getCompanionWindowIdsForPosition", function () { return $182ffde0538291ba$export$9a940d1f143a8300; });
$parcel$export(module.exports, "getCompanionAreaVisibility", function () { return $182ffde0538291ba$export$cee4d42d1a433fd3; });
$parcel$export(module.exports, "selectCompanionWindowDimensions", function () { return $182ffde0538291ba$export$564cada766bff72; });

var $1LbRi = parcelRequire("1LbRi");

var $bqnYX = parcelRequire("bqnYX");

var $fr77o = parcelRequire("fr77o");

var $dy9HC = parcelRequire("dy9HC");
function $182ffde0538291ba$var$_toConsumableArray(arr) {
    return $182ffde0538291ba$var$_arrayWithoutHoles(arr) || $182ffde0538291ba$var$_iterableToArray(arr) || $182ffde0538291ba$var$_unsupportedIterableToArray(arr) || $182ffde0538291ba$var$_nonIterableSpread();
}
function $182ffde0538291ba$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $182ffde0538291ba$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $182ffde0538291ba$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $182ffde0538291ba$var$_arrayLikeToArray(o, minLen);
}
function $182ffde0538291ba$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $182ffde0538291ba$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $182ffde0538291ba$var$_arrayLikeToArray(arr);
}
function $182ffde0538291ba$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $182ffde0538291ba$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $182ffde0538291ba$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $182ffde0538291ba$var$ownKeys(Object(source), true).forEach(function(key) {
            $182ffde0538291ba$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $182ffde0538291ba$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $182ffde0538291ba$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $182ffde0538291ba$export$32d1ab69db1d2f2f(state) {
    return (0, $fr77o.miradorSlice)(state).companionWindows || {};
}
var $182ffde0538291ba$export$491de7fbfa4c6fa7 = (0, $1LbRi.createSelector)([
    $182ffde0538291ba$export$32d1ab69db1d2f2f,
    function(state, _ref) {
        var companionWindowId = _ref.companionWindowId;
        return companionWindowId;
    }
], function(companionWindows, companionWindowId) {
    return companionWindowId && companionWindows[companionWindowId];
});
var $182ffde0538291ba$export$ebab28d96b2adbf4 = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWindow),
    $182ffde0538291ba$export$32d1ab69db1d2f2f
], function(window, companionWindows) {
    return window && companionWindows[window.thumbnailNavigationId] && companionWindows[window.thumbnailNavigationId].position;
});
/**
* Return compantion window ids from a window
* @param {String} windowId
* @return {Array}
*/ var $182ffde0538291ba$var$getCompanionWindowIndexByWindowAndPosition = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWindows),
    $182ffde0538291ba$export$32d1ab69db1d2f2f
], function(windows, companionWindows) {
    return (Object.keys(windows) || []).reduce(function(obj, id) {
        return $182ffde0538291ba$var$_objectSpread($182ffde0538291ba$var$_objectSpread({}, obj), {}, $182ffde0538291ba$var$_defineProperty({}, id, (0, (/*@__PURE__*/$parcel$interopDefault($bqnYX)))(windows[id].companionWindowIds, function(cwid) {
            return companionWindows[cwid] && companionWindows[cwid].position;
        })));
    }, {});
});
/**
* Return compantion window ids from a window
* @param {String} windowId
* @return {Array}
*/ var $182ffde0538291ba$var$getCompanionWindowsByWindowAndPosition = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWindows),
    $182ffde0538291ba$export$32d1ab69db1d2f2f
], function(windows, companionWindows) {
    return (Object.keys(windows) || []).reduce(function(obj, id) {
        return $182ffde0538291ba$var$_objectSpread($182ffde0538291ba$var$_objectSpread({}, obj), {}, $182ffde0538291ba$var$_defineProperty({}, id, (0, (/*@__PURE__*/$parcel$interopDefault($bqnYX)))(windows[id].companionWindowIds.map(function(cwid) {
            return companionWindows[cwid];
        }), function(cw) {
            return cw.position;
        })));
    }, {});
});
/**
 * Return companion windows of a window
 * @param {String} windowId
 * @return {Array}
 */ var $182ffde0538291ba$var$getCompanionWindowsOfWindow = (0, $1LbRi.createSelector)([
    function(state, _ref2) {
        var windowId = _ref2.windowId;
        return windowId;
    },
    $182ffde0538291ba$var$getCompanionWindowsByWindowAndPosition
], function(windowId, companionWindows) {
    return companionWindows[windowId] || {};
});
/**
 * Return companion windows of a window
 * @param {String} windowId
 * @return {Array}
 */ var $182ffde0538291ba$var$getCompanionWindowIdsOfWindow = (0, $1LbRi.createSelector)([
    function(state, _ref3) {
        var windowId = _ref3.windowId;
        return windowId;
    },
    $182ffde0538291ba$var$getCompanionWindowIndexByWindowAndPosition
], function(windowId, companionWindowIds) {
    return companionWindowIds[windowId] || {};
});
var $182ffde0538291ba$export$82ad1952eff70e20 = (0, $1LbRi.createSelector)([
    $182ffde0538291ba$var$getCompanionWindowsOfWindow,
    function(state, _ref4) {
        var position = _ref4.position;
        return {
            position: position
        };
    }
], function(companionWindows, _ref5) {
    var position = _ref5.position;
    return companionWindows[position] || $182ffde0538291ba$var$EMPTY_ARRAY;
});
var $182ffde0538291ba$export$58e2e8765c24002d = (0, $1LbRi.createSelector)([
    $182ffde0538291ba$var$getCompanionWindowsOfWindow,
    function(state, _ref6) {
        var content = _ref6.content;
        return {
            content: content
        };
    }
], function(companionWindows, _ref7) {
    var _ref8;
    var content = _ref7.content;
    return (_ref8 = []).concat.apply(_ref8, $182ffde0538291ba$var$_toConsumableArray(Object.values(companionWindows))).filter(function(w) {
        return w.content === content;
    });
});
var $182ffde0538291ba$var$EMPTY_ARRAY = [];
var $182ffde0538291ba$export$9a940d1f143a8300 = (0, $1LbRi.createSelector)([
    $182ffde0538291ba$var$getCompanionWindowIdsOfWindow,
    function(state, _ref9) {
        var position = _ref9.position;
        return {
            position: position
        };
    }
], function(companionWindowIds, _ref10) {
    var position = _ref10.position;
    return companionWindowIds[position] || $182ffde0538291ba$var$EMPTY_ARRAY;
});
var $182ffde0538291ba$export$cee4d42d1a433fd3 = (0, $1LbRi.createSelector)([
    function(state, _ref11) {
        var position = _ref11.position;
        return position;
    },
    (0, $dy9HC.getWindow)
], function(position, window) {
    if (!window) return false;
    var companionAreaOpen = window.companionAreaOpen, sideBarOpen = window.sideBarOpen;
    if (position !== "left") return true;
    return !!(companionAreaOpen && sideBarOpen);
});
var $182ffde0538291ba$export$564cada766bff72 = (0, $1LbRi.createSelector)([
    $182ffde0538291ba$var$getCompanionWindowsOfWindow
], function(companionWindows) {
    var _ref12;
    var width = 0;
    var height = 0;
    (_ref12 = []).concat.apply(_ref12, $182ffde0538291ba$var$_toConsumableArray(Object.values(companionWindows))).forEach(function(cw) {
        if (cw.position.match(/right/)) width += 235;
        if (cw.position.match(/bottom/)) height += 201;
    });
    return {
        height: height,
        width: width
    };
});

});
parcelRegister("bqnYX", function(module, exports) {

var $hI9C8 = parcelRequire("hI9C8");

var $9X3xg = parcelRequire("9X3xg");
/** Used for built-in method references. */ var $8514b9c26c85a6ac$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8514b9c26c85a6ac$var$hasOwnProperty = $8514b9c26c85a6ac$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $8514b9c26c85a6ac$var$groupBy = $9X3xg(function(result, value, key) {
    if ($8514b9c26c85a6ac$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $hI9C8(result, key, [
        value
    ]);
});
module.exports = $8514b9c26c85a6ac$var$groupBy;

});
parcelRegister("9X3xg", function(module, exports) {

var $545F4 = parcelRequire("545F4");

var $4yX5H = parcelRequire("4yX5H");

var $hChE7 = parcelRequire("hChE7");

var $eDRhj = parcelRequire("eDRhj");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $73ec5dd34ecf9239$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $eDRhj(collection) ? $545F4 : $4yX5H, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $hChE7(iteratee, 2), accumulator);
    };
}
module.exports = $73ec5dd34ecf9239$var$createAggregator;

});
parcelRegister("545F4", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $3b01b7b50284871f$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $3b01b7b50284871f$var$arrayAggregator;

});

parcelRegister("4yX5H", function(module, exports) {

var $dWrTD = parcelRequire("dWrTD");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $35282c9d6ef39365$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $dWrTD(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $35282c9d6ef39365$var$baseAggregator;

});
parcelRegister("dWrTD", function(module, exports) {

var $eaB3q = parcelRequire("eaB3q");

var $atlyY = parcelRequire("atlyY");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $a26654c74a99db5d$var$baseEach = $atlyY($eaB3q);
module.exports = $a26654c74a99db5d$var$baseEach;

});
parcelRegister("eaB3q", function(module, exports) {

var $4Sj5d = parcelRequire("4Sj5d");

var $3FKAp = parcelRequire("3FKAp");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $a50ebe0972cd2806$var$baseForOwn(object, iteratee) {
    return object && $4Sj5d(object, iteratee, $3FKAp);
}
module.exports = $a50ebe0972cd2806$var$baseForOwn;

});
parcelRegister("4Sj5d", function(module, exports) {

var $fgzUD = parcelRequire("fgzUD");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $38cb021b0a769c33$var$baseFor = $fgzUD();
module.exports = $38cb021b0a769c33$var$baseFor;

});
parcelRegister("fgzUD", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b1d435178e8050d2$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $b1d435178e8050d2$var$createBaseFor;

});


parcelRegister("3FKAp", function(module, exports) {

var $N18tZ = parcelRequire("N18tZ");

var $aff5X = parcelRequire("aff5X");

var $8kHR7 = parcelRequire("8kHR7");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $2ac9567e0530b996$var$keys(object) {
    return $8kHR7(object) ? $N18tZ(object) : $aff5X(object);
}
module.exports = $2ac9567e0530b996$var$keys;

});
parcelRegister("N18tZ", function(module, exports) {

var $eTrOJ = parcelRequire("eTrOJ");

var $fc3fn = parcelRequire("fc3fn");

var $eDRhj = parcelRequire("eDRhj");

var $lN48w = parcelRequire("lN48w");

var $ez2hV = parcelRequire("ez2hV");

var $loLm5 = parcelRequire("loLm5");
/** Used for built-in method references. */ var $093575448e7e34f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $093575448e7e34f6$var$hasOwnProperty = $093575448e7e34f6$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $093575448e7e34f6$var$arrayLikeKeys(value, inherited) {
    var isArr = $eDRhj(value), isArg = !isArr && $fc3fn(value), isBuff = !isArr && !isArg && $lN48w(value), isType = !isArr && !isArg && !isBuff && $loLm5(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $eTrOJ(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $093575448e7e34f6$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $ez2hV(key, length)))) result.push(key);
    return result;
}
module.exports = $093575448e7e34f6$var$arrayLikeKeys;

});
parcelRegister("eTrOJ", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $ad7bc7ab9efa0a17$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $ad7bc7ab9efa0a17$var$baseTimes;

});




parcelRegister("atlyY", function(module, exports) {

var $8kHR7 = parcelRequire("8kHR7");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $79fd56d06e02fcc8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$8kHR7(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $79fd56d06e02fcc8$var$createBaseEach;

});



parcelRegister("hChE7", function(module, exports) {

var $1WRCr = parcelRequire("1WRCr");

var $9tWvI = parcelRequire("9tWvI");

var $l0EzR = parcelRequire("l0EzR");

var $eDRhj = parcelRequire("eDRhj");

var $cXoWg = parcelRequire("cXoWg");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $cd33ac6d6fc293a4$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $l0EzR;
    if (typeof value == "object") return $eDRhj(value) ? $9tWvI(value[0], value[1]) : $1WRCr(value);
    return $cXoWg(value);
}
module.exports = $cd33ac6d6fc293a4$var$baseIteratee;

});
parcelRegister("1WRCr", function(module, exports) {

var $bdkVi = parcelRequire("bdkVi");

var $cJkpt = parcelRequire("cJkpt");

var $dJBWR = parcelRequire("dJBWR");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $16b4ccd35e0b8571$var$baseMatches(source) {
    var matchData = $cJkpt(source);
    if (matchData.length == 1 && matchData[0][2]) return $dJBWR(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $bdkVi(object, source, matchData);
    };
}
module.exports = $16b4ccd35e0b8571$var$baseMatches;

});
parcelRegister("bdkVi", function(module, exports) {

var $l5Ia8 = parcelRequire("l5Ia8");

var $isgfd = parcelRequire("isgfd");
/** Used to compose bitmasks for value comparisons. */ var $82a123876a1438ce$var$COMPARE_PARTIAL_FLAG = 1, $82a123876a1438ce$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $82a123876a1438ce$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $l5Ia8;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $isgfd(srcValue, objValue, $82a123876a1438ce$var$COMPARE_PARTIAL_FLAG | $82a123876a1438ce$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $82a123876a1438ce$var$baseIsMatch;

});
parcelRegister("l5Ia8", function(module, exports) {

var $2aKFf = parcelRequire("2aKFf");

var $hSRLl = parcelRequire("hSRLl");

var $fLp7f = parcelRequire("fLp7f");

var $iIVYn = parcelRequire("iIVYn");

var $iKsTM = parcelRequire("iKsTM");

var $dw51r = parcelRequire("dw51r");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f5ac525362f87dfd$var$Stack(entries) {
    var data = this.__data__ = new $2aKFf(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$f5ac525362f87dfd$var$Stack.prototype.clear = $hSRLl;
$f5ac525362f87dfd$var$Stack.prototype["delete"] = $fLp7f;
$f5ac525362f87dfd$var$Stack.prototype.get = $iIVYn;
$f5ac525362f87dfd$var$Stack.prototype.has = $iKsTM;
$f5ac525362f87dfd$var$Stack.prototype.set = $dw51r;
module.exports = $f5ac525362f87dfd$var$Stack;

});
parcelRegister("hSRLl", function(module, exports) {

var $2aKFf = parcelRequire("2aKFf");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $d0512ef62c8fa46f$var$stackClear() {
    this.__data__ = new $2aKFf;
    this.size = 0;
}
module.exports = $d0512ef62c8fa46f$var$stackClear;

});

parcelRegister("fLp7f", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b79eba4f3e12221d$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $b79eba4f3e12221d$var$stackDelete;

});

parcelRegister("iIVYn", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $da194e3d10b28fcc$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $da194e3d10b28fcc$var$stackGet;

});

parcelRegister("iKsTM", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $da62f08974274a40$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $da62f08974274a40$var$stackHas;

});

parcelRegister("dw51r", function(module, exports) {

var $2aKFf = parcelRequire("2aKFf");

var $iPcKP = parcelRequire("iPcKP");

var $a2RYt = parcelRequire("a2RYt");
/** Used as the size to enable large array optimizations. */ var $9d7228d0040c2e1b$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9d7228d0040c2e1b$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $2aKFf) {
        var pairs = data.__data__;
        if (!$iPcKP || pairs.length < $9d7228d0040c2e1b$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $a2RYt(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9d7228d0040c2e1b$var$stackSet;

});


parcelRegister("isgfd", function(module, exports) {

var $9RhrK = parcelRequire("9RhrK");

var $cLyAa = parcelRequire("cLyAa");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $d6f77158cf3143f0$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$cLyAa(value) && !$cLyAa(other)) return value !== value && other !== other;
    return $9RhrK(value, other, bitmask, customizer, $d6f77158cf3143f0$var$baseIsEqual, stack);
}
module.exports = $d6f77158cf3143f0$var$baseIsEqual;

});
parcelRegister("9RhrK", function(module, exports) {

var $l5Ia8 = parcelRequire("l5Ia8");

var $2efuL = parcelRequire("2efuL");

var $9dbhn = parcelRequire("9dbhn");

var $biXPX = parcelRequire("biXPX");

var $eGYov = parcelRequire("eGYov");

var $eDRhj = parcelRequire("eDRhj");

var $lN48w = parcelRequire("lN48w");

var $loLm5 = parcelRequire("loLm5");
/** Used to compose bitmasks for value comparisons. */ var $72d698d6ca67f162$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $72d698d6ca67f162$var$argsTag = "[object Arguments]", $72d698d6ca67f162$var$arrayTag = "[object Array]", $72d698d6ca67f162$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $72d698d6ca67f162$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $72d698d6ca67f162$var$hasOwnProperty = $72d698d6ca67f162$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $72d698d6ca67f162$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $eDRhj(object), othIsArr = $eDRhj(other), objTag = objIsArr ? $72d698d6ca67f162$var$arrayTag : $eGYov(object), othTag = othIsArr ? $72d698d6ca67f162$var$arrayTag : $eGYov(other);
    objTag = objTag == $72d698d6ca67f162$var$argsTag ? $72d698d6ca67f162$var$objectTag : objTag;
    othTag = othTag == $72d698d6ca67f162$var$argsTag ? $72d698d6ca67f162$var$objectTag : othTag;
    var objIsObj = objTag == $72d698d6ca67f162$var$objectTag, othIsObj = othTag == $72d698d6ca67f162$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $lN48w(object)) {
        if (!$lN48w(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $l5Ia8);
        return objIsArr || $loLm5(object) ? $2efuL(object, other, bitmask, customizer, equalFunc, stack) : $9dbhn(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $72d698d6ca67f162$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $72d698d6ca67f162$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $72d698d6ca67f162$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $l5Ia8);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $l5Ia8);
    return $biXPX(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $72d698d6ca67f162$var$baseIsEqualDeep;

});
parcelRegister("2efuL", function(module, exports) {

var $gWi11 = parcelRequire("gWi11");

var $fPa9H = parcelRequire("fPa9H");

var $jDLRl = parcelRequire("jDLRl");
/** Used to compose bitmasks for value comparisons. */ var $19f8e8981c088a34$var$COMPARE_PARTIAL_FLAG = 1, $19f8e8981c088a34$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $19f8e8981c088a34$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $19f8e8981c088a34$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $19f8e8981c088a34$var$COMPARE_UNORDERED_FLAG ? new $gWi11 : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$fPa9H(other, function(othValue, othIndex) {
                if (!$jDLRl(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $19f8e8981c088a34$var$equalArrays;

});
parcelRegister("gWi11", function(module, exports) {

var $a2RYt = parcelRequire("a2RYt");

var $9ePQt = parcelRequire("9ePQt");

var $6FzdT = parcelRequire("6FzdT");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $c550099d5fd87c88$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $a2RYt;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$c550099d5fd87c88$var$SetCache.prototype.add = $c550099d5fd87c88$var$SetCache.prototype.push = $9ePQt;
$c550099d5fd87c88$var$SetCache.prototype.has = $6FzdT;
module.exports = $c550099d5fd87c88$var$SetCache;

});
parcelRegister("9ePQt", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $6b9da348058ce8da$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $6b9da348058ce8da$var$setCacheAdd(value) {
    this.__data__.set(value, $6b9da348058ce8da$var$HASH_UNDEFINED);
    return this;
}
module.exports = $6b9da348058ce8da$var$setCacheAdd;

});

parcelRegister("6FzdT", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $4db1e4fd6b1421aa$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $4db1e4fd6b1421aa$var$setCacheHas;

});


parcelRegister("fPa9H", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $b8537f1c182c07b8$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $b8537f1c182c07b8$var$arraySome;

});

parcelRegister("jDLRl", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e4c6c8b1aaa810a5$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $e4c6c8b1aaa810a5$var$cacheHas;

});


parcelRegister("9dbhn", function(module, exports) {

var $7MX8u = parcelRequire("7MX8u");

var $apQoP = parcelRequire("apQoP");

var $54juc = parcelRequire("54juc");

var $2efuL = parcelRequire("2efuL");

var $2DgJo = parcelRequire("2DgJo");

var $8LZj9 = parcelRequire("8LZj9");
/** Used to compose bitmasks for value comparisons. */ var $6b4e13cabc812a48$var$COMPARE_PARTIAL_FLAG = 1, $6b4e13cabc812a48$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $6b4e13cabc812a48$var$boolTag = "[object Boolean]", $6b4e13cabc812a48$var$dateTag = "[object Date]", $6b4e13cabc812a48$var$errorTag = "[object Error]", $6b4e13cabc812a48$var$mapTag = "[object Map]", $6b4e13cabc812a48$var$numberTag = "[object Number]", $6b4e13cabc812a48$var$regexpTag = "[object RegExp]", $6b4e13cabc812a48$var$setTag = "[object Set]", $6b4e13cabc812a48$var$stringTag = "[object String]", $6b4e13cabc812a48$var$symbolTag = "[object Symbol]";
var $6b4e13cabc812a48$var$arrayBufferTag = "[object ArrayBuffer]", $6b4e13cabc812a48$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $6b4e13cabc812a48$var$symbolProto = $7MX8u ? $7MX8u.prototype : undefined, $6b4e13cabc812a48$var$symbolValueOf = $6b4e13cabc812a48$var$symbolProto ? $6b4e13cabc812a48$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $6b4e13cabc812a48$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $6b4e13cabc812a48$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $6b4e13cabc812a48$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $apQoP(object), new $apQoP(other))) return false;
            return true;
        case $6b4e13cabc812a48$var$boolTag:
        case $6b4e13cabc812a48$var$dateTag:
        case $6b4e13cabc812a48$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $54juc(+object, +other);
        case $6b4e13cabc812a48$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $6b4e13cabc812a48$var$regexpTag:
        case $6b4e13cabc812a48$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $6b4e13cabc812a48$var$mapTag:
            var convert = $2DgJo;
        case $6b4e13cabc812a48$var$setTag:
            var isPartial = bitmask & $6b4e13cabc812a48$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $8LZj9);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $6b4e13cabc812a48$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $2efuL(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $6b4e13cabc812a48$var$symbolTag:
            if ($6b4e13cabc812a48$var$symbolValueOf) return $6b4e13cabc812a48$var$symbolValueOf.call(object) == $6b4e13cabc812a48$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $6b4e13cabc812a48$var$equalByTag;

});
parcelRegister("apQoP", function(module, exports) {

var $9svsg = parcelRequire("9svsg");
/** Built-in value references. */ var $7954e299e27a6cd8$var$Uint8Array = $9svsg.Uint8Array;
module.exports = $7954e299e27a6cd8$var$Uint8Array;

});

parcelRegister("2DgJo", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $1eac33bb18973efa$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $1eac33bb18973efa$var$mapToArray;

});

parcelRegister("8LZj9", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $663244fe80dd8d30$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $663244fe80dd8d30$var$setToArray;

});


parcelRegister("biXPX", function(module, exports) {

var $UV49P = parcelRequire("UV49P");
/** Used to compose bitmasks for value comparisons. */ var $83afca8cf46af98f$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $83afca8cf46af98f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $83afca8cf46af98f$var$hasOwnProperty = $83afca8cf46af98f$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $83afca8cf46af98f$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $83afca8cf46af98f$var$COMPARE_PARTIAL_FLAG, objProps = $UV49P(object), objLength = objProps.length, othProps = $UV49P(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $83afca8cf46af98f$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $83afca8cf46af98f$var$equalObjects;

});
parcelRegister("UV49P", function(module, exports) {

var $eGM7V = parcelRequire("eGM7V");

var $fUrke = parcelRequire("fUrke");

var $3FKAp = parcelRequire("3FKAp");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $0ab17f35136069c6$var$getAllKeys(object) {
    return $eGM7V(object, $3FKAp, $fUrke);
}
module.exports = $0ab17f35136069c6$var$getAllKeys;

});
parcelRegister("eGM7V", function(module, exports) {

var $gHWYa = parcelRequire("gHWYa");

var $eDRhj = parcelRequire("eDRhj");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $ab1a51e7969e5569$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $eDRhj(object) ? result : $gHWYa(result, symbolsFunc(object));
}
module.exports = $ab1a51e7969e5569$var$baseGetAllKeys;

});

parcelRegister("fUrke", function(module, exports) {

var $geLbU = parcelRequire("geLbU");

var $cJ0ms = parcelRequire("cJ0ms");
/** Used for built-in method references. */ var $b951483b84a4ce78$var$objectProto = Object.prototype;
/** Built-in value references. */ var $b951483b84a4ce78$var$propertyIsEnumerable = $b951483b84a4ce78$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b951483b84a4ce78$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b951483b84a4ce78$var$getSymbols = !$b951483b84a4ce78$var$nativeGetSymbols ? $cJ0ms : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $geLbU($b951483b84a4ce78$var$nativeGetSymbols(object), function(symbol) {
        return $b951483b84a4ce78$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $b951483b84a4ce78$var$getSymbols;

});
parcelRegister("geLbU", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $bd228f4a32ae01b1$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $bd228f4a32ae01b1$var$arrayFilter;

});

parcelRegister("cJ0ms", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $9439f7bdfb4bb747$var$stubArray() {
    return [];
}
module.exports = $9439f7bdfb4bb747$var$stubArray;

});







parcelRegister("cJkpt", function(module, exports) {

var $jiMio = parcelRequire("jiMio");

var $3FKAp = parcelRequire("3FKAp");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $944984f68ccd5933$var$getMatchData(object) {
    var result = $3FKAp(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $jiMio(value)
        ];
    }
    return result;
}
module.exports = $944984f68ccd5933$var$getMatchData;

});
parcelRegister("jiMio", function(module, exports) {

var $6Sqac = parcelRequire("6Sqac");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $e0d52947718e7643$var$isStrictComparable(value) {
    return value === value && !$6Sqac(value);
}
module.exports = $e0d52947718e7643$var$isStrictComparable;

});


parcelRegister("dJBWR", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $9ffcea18893f0b05$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $9ffcea18893f0b05$var$matchesStrictComparable;

});


parcelRegister("9tWvI", function(module, exports) {

var $isgfd = parcelRequire("isgfd");

var $eubrc = parcelRequire("eubrc");

var $hEhMZ = parcelRequire("hEhMZ");

var $h5FL5 = parcelRequire("h5FL5");

var $jiMio = parcelRequire("jiMio");

var $dJBWR = parcelRequire("dJBWR");

var $fMmVj = parcelRequire("fMmVj");
/** Used to compose bitmasks for value comparisons. */ var $6e74357c30aed8e9$var$COMPARE_PARTIAL_FLAG = 1, $6e74357c30aed8e9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $6e74357c30aed8e9$var$baseMatchesProperty(path, srcValue) {
    if ($h5FL5(path) && $jiMio(srcValue)) return $dJBWR($fMmVj(path), srcValue);
    return function(object) {
        var objValue = $eubrc(object, path);
        return objValue === undefined && objValue === srcValue ? $hEhMZ(object, path) : $isgfd(srcValue, objValue, $6e74357c30aed8e9$var$COMPARE_PARTIAL_FLAG | $6e74357c30aed8e9$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $6e74357c30aed8e9$var$baseMatchesProperty;

});
parcelRegister("eubrc", function(module, exports) {

var $kVyVU = parcelRequire("kVyVU");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $a8bcbd4b4717d89e$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $kVyVU(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $a8bcbd4b4717d89e$var$get;

});

parcelRegister("hEhMZ", function(module, exports) {

var $b2wLf = parcelRequire("b2wLf");

var $8gNBO = parcelRequire("8gNBO");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $cd93f8a10d110be8$var$hasIn(object, path) {
    return object != null && $8gNBO(object, path, $b2wLf);
}
module.exports = $cd93f8a10d110be8$var$hasIn;

});
parcelRegister("b2wLf", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $80994b41173e3b44$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $80994b41173e3b44$var$baseHasIn;

});

parcelRegister("8gNBO", function(module, exports) {

var $hMUIl = parcelRequire("hMUIl");

var $fc3fn = parcelRequire("fc3fn");

var $eDRhj = parcelRequire("eDRhj");

var $ez2hV = parcelRequire("ez2hV");

var $1KYZK = parcelRequire("1KYZK");

var $fMmVj = parcelRequire("fMmVj");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $60564ca0b5f98019$var$hasPath(object, path, hasFunc) {
    path = $hMUIl(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $fMmVj(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1KYZK(length) && $ez2hV(key, length) && ($eDRhj(object) || $fc3fn(object));
}
module.exports = $60564ca0b5f98019$var$hasPath;

});



parcelRegister("cXoWg", function(module, exports) {

var $5NsTH = parcelRequire("5NsTH");

var $hYSVE = parcelRequire("hYSVE");

var $h5FL5 = parcelRequire("h5FL5");

var $fMmVj = parcelRequire("fMmVj");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $96ee57068b8cabef$var$property(path) {
    return $h5FL5(path) ? $5NsTH($fMmVj(path)) : $hYSVE(path);
}
module.exports = $96ee57068b8cabef$var$property;

});
parcelRegister("5NsTH", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4387f1c1c2f247c0$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $4387f1c1c2f247c0$var$baseProperty;

});

parcelRegister("hYSVE", function(module, exports) {

var $kVyVU = parcelRequire("kVyVU");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d172a5f87ff6f9df$var$basePropertyDeep(path) {
    return function(object) {
        return $kVyVU(object, path);
    };
}
module.exports = $d172a5f87ff6f9df$var$basePropertyDeep;

});






parcelRegister("jGts0", function(module, exports) {

$parcel$export(module.exports, "getConfig", function () { return $e548c8e2e3d6bbb6$export$44487a86467333c3; });
$parcel$export(module.exports, "getExportableState", function () { return $e548c8e2e3d6bbb6$export$3a9aa37eeb6b2b2d; });
$parcel$export(module.exports, "getLanguagesFromConfigWithCurrent", function () { return $e548c8e2e3d6bbb6$export$3a1a2487b9c955f9; });
$parcel$export(module.exports, "getShowZoomControlsConfig", function () { return $e548c8e2e3d6bbb6$export$9d58b4d5101d8ad5; });
$parcel$export(module.exports, "getTheme", function () { return $e548c8e2e3d6bbb6$export$89cbf1a0881c8b9c; });
$parcel$export(module.exports, "getThemeIds", function () { return $e548c8e2e3d6bbb6$export$639f23662367b414; });
$parcel$export(module.exports, "getContainerId", function () { return $e548c8e2e3d6bbb6$export$7c8178cc9001d237; });
$parcel$export(module.exports, "getThemeDirection", function () { return $e548c8e2e3d6bbb6$export$c1f191360e364b5a; });
$parcel$export(module.exports, "getRequestsConfig", function () { return $e548c8e2e3d6bbb6$export$760dc9ccb8ccd623; });

var $1LbRi = parcelRequire("1LbRi");

var $iyYa0 = parcelRequire("iyYa0");

var $fr77o = parcelRequire("fr77o");

var $dy9HC = parcelRequire("dy9HC");
function $e548c8e2e3d6bbb6$var$_slicedToArray(arr, i) {
    return $e548c8e2e3d6bbb6$var$_arrayWithHoles(arr) || $e548c8e2e3d6bbb6$var$_iterableToArrayLimit(arr, i) || $e548c8e2e3d6bbb6$var$_unsupportedIterableToArray(arr, i) || $e548c8e2e3d6bbb6$var$_nonIterableRest();
}
function $e548c8e2e3d6bbb6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e548c8e2e3d6bbb6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e548c8e2e3d6bbb6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e548c8e2e3d6bbb6$var$_arrayLikeToArray(o, minLen);
}
function $e548c8e2e3d6bbb6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e548c8e2e3d6bbb6$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e548c8e2e3d6bbb6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e548c8e2e3d6bbb6$export$44487a86467333c3(state) {
    var slice = (0, $fr77o.miradorSlice)(state || {});
    return slice.config || {};
}
function $e548c8e2e3d6bbb6$export$3a9aa37eeb6b2b2d(state) {
    var exportConfig = $e548c8e2e3d6bbb6$export$44487a86467333c3(state)["export"];
    return Object.entries(exportConfig).reduce(function(acc, _ref) {
        var _ref2 = $e548c8e2e3d6bbb6$var$_slicedToArray(_ref, 2), stem = _ref2[0], value = _ref2[1];
        if (value === true) acc[stem] = state[stem];
        else if (value.filter) acc[stem] = Object.entries(state[stem]).filter(value.filter).reduce(function(stemAcc, _ref3) {
            var _ref4 = $e548c8e2e3d6bbb6$var$_slicedToArray(_ref3, 2), k = _ref4[0], v = _ref4[1];
            stemAcc[k] = v; // eslint-disable-line no-param-reassign
            return stemAcc;
        }, {});
        return acc;
    }, {});
}
var $e548c8e2e3d6bbb6$export$3a1a2487b9c955f9 = (0, $1LbRi.createSelector)([
    $e548c8e2e3d6bbb6$export$44487a86467333c3
], function(_ref5) {
    var availableLanguages = _ref5.availableLanguages, language = _ref5.language;
    return Object.keys(availableLanguages).map(function(key) {
        return {
            current: key === language,
            label: availableLanguages[key],
            locale: key
        };
    });
});
var $e548c8e2e3d6bbb6$export$9d58b4d5101d8ad5 = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWorkspace),
    $e548c8e2e3d6bbb6$export$44487a86467333c3
], function(workspace, config) {
    return workspace.showZoomControls === undefined ? config.workspace.showZoomControls : workspace.showZoomControls;
});
var $e548c8e2e3d6bbb6$export$89cbf1a0881c8b9c = (0, $1LbRi.createSelector)([
    $e548c8e2e3d6bbb6$export$44487a86467333c3
], function(_ref6) {
    var theme = _ref6.theme, themes = _ref6.themes, selectedTheme = _ref6.selectedTheme;
    return (0, (/*@__PURE__*/$parcel$interopDefault($iyYa0)))(theme, themes[selectedTheme] || {});
});
var $e548c8e2e3d6bbb6$export$639f23662367b414 = (0, $1LbRi.createSelector)([
    $e548c8e2e3d6bbb6$export$44487a86467333c3
], function(_ref7) {
    var themes = _ref7.themes;
    return Object.keys(themes);
});
var $e548c8e2e3d6bbb6$export$7c8178cc9001d237 = (0, $1LbRi.createSelector)([
    $e548c8e2e3d6bbb6$export$44487a86467333c3
], function(_ref8) {
    var id = _ref8.id;
    return id;
});
var $e548c8e2e3d6bbb6$export$c1f191360e364b5a = (0, $1LbRi.createSelector)([
    $e548c8e2e3d6bbb6$export$44487a86467333c3
], function(_ref9) {
    var theme = _ref9.theme;
    return theme.direction || "ltr";
});
var $e548c8e2e3d6bbb6$export$760dc9ccb8ccd623 = (0, $1LbRi.createSelector)([
    $e548c8e2e3d6bbb6$export$44487a86467333c3
], function(_ref10) {
    var requests = _ref10.requests;
    return requests || {};
});

});
parcelRegister("iyYa0", function(module, exports) {
"use strict";
var $d83a118b66dd2d6a$var$isMergeableObject = function isMergeableObject(value) {
    return $d83a118b66dd2d6a$var$isNonNullObject(value) && !$d83a118b66dd2d6a$var$isSpecial(value);
};
function $d83a118b66dd2d6a$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $d83a118b66dd2d6a$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $d83a118b66dd2d6a$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $d83a118b66dd2d6a$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $d83a118b66dd2d6a$var$REACT_ELEMENT_TYPE = $d83a118b66dd2d6a$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $d83a118b66dd2d6a$var$isReactElement(value) {
    return value.$$typeof === $d83a118b66dd2d6a$var$REACT_ELEMENT_TYPE;
}
function $d83a118b66dd2d6a$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $d83a118b66dd2d6a$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $d83a118b66dd2d6a$var$deepmerge($d83a118b66dd2d6a$var$emptyTarget(value), value, options) : value;
}
function $d83a118b66dd2d6a$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $d83a118b66dd2d6a$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $d83a118b66dd2d6a$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $d83a118b66dd2d6a$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $d83a118b66dd2d6a$var$deepmerge;
}
function $d83a118b66dd2d6a$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $d83a118b66dd2d6a$var$getKeys(target) {
    return Object.keys(target).concat($d83a118b66dd2d6a$var$getEnumerableOwnPropertySymbols(target));
}
function $d83a118b66dd2d6a$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $d83a118b66dd2d6a$var$propertyIsUnsafe(target, key) {
    return $d83a118b66dd2d6a$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $d83a118b66dd2d6a$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $d83a118b66dd2d6a$var$getKeys(target).forEach(function(key) {
        destination[key] = $d83a118b66dd2d6a$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $d83a118b66dd2d6a$var$getKeys(source).forEach(function(key) {
        if ($d83a118b66dd2d6a$var$propertyIsUnsafe(target, key)) return;
        if ($d83a118b66dd2d6a$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $d83a118b66dd2d6a$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $d83a118b66dd2d6a$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $d83a118b66dd2d6a$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $d83a118b66dd2d6a$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $d83a118b66dd2d6a$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $d83a118b66dd2d6a$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $d83a118b66dd2d6a$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $d83a118b66dd2d6a$var$mergeObject(target, source, options);
}
$d83a118b66dd2d6a$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $d83a118b66dd2d6a$var$deepmerge(prev, next, options);
    }, {});
};
var $d83a118b66dd2d6a$var$deepmerge_1 = $d83a118b66dd2d6a$var$deepmerge;
module.exports = $d83a118b66dd2d6a$var$deepmerge_1;

});




parcelRegister("9E7MS", function(module, exports) {

$parcel$export(module.exports, "getWindowConfig", function () { return $705de3e6684a953c$export$10554e57c751cc0c; });
$parcel$export(module.exports, "getWindowTitles", function () { return $705de3e6684a953c$export$42ccb6ef5c2f2f1; });
$parcel$export(module.exports, "getMaximizedWindowsIds", function () { return $705de3e6684a953c$export$d58fd565f35ab3f9; });
$parcel$export(module.exports, "getWindowViewType", function () { return $705de3e6684a953c$export$9957cfc1d9df3d7c; });
$parcel$export(module.exports, "getAllowedWindowViewTypes", function () { return $705de3e6684a953c$export$5508edb0263f618; });
$parcel$export(module.exports, "getWindowDraggability", function () { return $705de3e6684a953c$export$9ee3d2b89293a9cb; });

var $1LbRi = parcelRequire("1LbRi");

var $7GY88 = parcelRequire("7GY88");

var $jGts0 = parcelRequire("jGts0");

var $dy9HC = parcelRequire("dy9HC");

var $3DW53 = parcelRequire("3DW53");

var $51Gx5 = parcelRequire("51Gx5");
function $705de3e6684a953c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $705de3e6684a953c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $705de3e6684a953c$var$ownKeys(Object(source), true).forEach(function(key) {
            $705de3e6684a953c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $705de3e6684a953c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $705de3e6684a953c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $705de3e6684a953c$export$10554e57c751cc0c = (0, $1LbRi.createSelector)([
    (0, $jGts0.getConfig),
    (0, $dy9HC.getWindow)
], function(_ref) {
    var defaultConfig = _ref.window;
    var windowConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $705de3e6684a953c$var$_objectSpread($705de3e6684a953c$var$_objectSpread({}, defaultConfig), windowConfig);
});
function $705de3e6684a953c$export$42ccb6ef5c2f2f1(state) {
    var result = {};
    Object.keys((0, $dy9HC.getWindows)(state)).forEach(function(windowId) {
        result[windowId] = (0, $7GY88.getManifestTitle)(state, {
            windowId: windowId
        });
    });
    return result;
}
var $705de3e6684a953c$export$d58fd565f35ab3f9 = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWindows)
], function(windows) {
    return Object.values(windows).filter(function(window) {
        return window.maximized === true;
    }).map(function(window) {
        return window.id;
    });
});
var $705de3e6684a953c$export$9957cfc1d9df3d7c = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWindow),
    $705de3e6684a953c$export$10554e57c751cc0c,
    (0, $51Gx5.getSequenceViewingHint),
    (0, $51Gx5.getSequenceBehaviors)
], function(window, _ref2, manifestViewingHint, manifestBehaviors) {
    var _ref2$views = _ref2.views, views = _ref2$views === void 0 ? [] : _ref2$views, defaultView = _ref2.defaultView;
    if (window && window.view) return window.view;
    var config = (views || []).find(function(view) {
        return view.behaviors && view.behaviors.some(function(b) {
            return manifestViewingHint === b || manifestBehaviors.includes(b);
        });
    });
    return config && config.key || defaultView;
});
var $705de3e6684a953c$export$5508edb0263f618 = (0, $1LbRi.createSelector)([
    (0, $51Gx5.getSequenceViewingHint),
    (0, $51Gx5.getSequenceBehaviors),
    $705de3e6684a953c$export$10554e57c751cc0c
], function(manifestViewingHint, manifestBehaviors, _ref3) {
    var _ref3$views = _ref3.views, views = _ref3$views === void 0 ? [] : _ref3$views, defaultView = _ref3.defaultView;
    return (views || []).reduce(function(allowedViews, view) {
        if (view.key === defaultView || !view.behaviors || view.behaviors.some(function(b) {
            return manifestViewingHint === b || manifestBehaviors.includes(b);
        })) allowedViews.push(view.key);
        return allowedViews;
    }, []);
});
var $705de3e6684a953c$export$9ee3d2b89293a9cb = (0, $1LbRi.createSelector)([
    (0, $3DW53.getWorkspaceType),
    (0, $dy9HC.getWindow),
    function(state) {
        return (0, $dy9HC.getWindowIds)(state).length > 1;
    }
], function(workspaceType, window, manyWindows) {
    if (workspaceType === "elastic") return true;
    return manyWindows && window && window.maximized === false;
});

});
parcelRegister("3DW53", function(module, exports) {

$parcel$export(module.exports, "getElasticLayout", function () { return $2a721134fbe182a8$export$9c511d3b42124193; });
$parcel$export(module.exports, "getFullScreenEnabled", function () { return $2a721134fbe182a8$export$902b8e0cb15598ce; });
$parcel$export(module.exports, "getLatestError", function () { return $2a721134fbe182a8$export$dfc5fb73615a8a98; });
$parcel$export(module.exports, "getWorkspaceType", function () { return $2a721134fbe182a8$export$1780dd9998652096; });
$parcel$export(module.exports, "isFocused", function () { return $2a721134fbe182a8$export$d267344c6c72483b; });

var $1LbRi = parcelRequire("1LbRi");

var $dy9HC = parcelRequire("dy9HC");

var $fr77o = parcelRequire("fr77o");
function $2a721134fbe182a8$var$_slicedToArray(arr, i) {
    return $2a721134fbe182a8$var$_arrayWithHoles(arr) || $2a721134fbe182a8$var$_iterableToArrayLimit(arr, i) || $2a721134fbe182a8$var$_unsupportedIterableToArray(arr, i) || $2a721134fbe182a8$var$_nonIterableRest();
}
function $2a721134fbe182a8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2a721134fbe182a8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2a721134fbe182a8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2a721134fbe182a8$var$_arrayLikeToArray(o, minLen);
}
function $2a721134fbe182a8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2a721134fbe182a8$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2a721134fbe182a8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2a721134fbe182a8$export$9c511d3b42124193(state) {
    return (0, $fr77o.miradorSlice)(state).elasticLayout;
}
var $2a721134fbe182a8$export$902b8e0cb15598ce = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWorkspace)
], function(workspace) {
    return workspace.isFullscreenEnabled;
});
function $2a721134fbe182a8$export$dfc5fb73615a8a98(state) {
    var _miradorSlice$errors$ = $2a721134fbe182a8$var$_slicedToArray((0, $fr77o.miradorSlice)(state).errors.items, 1), errorId = _miradorSlice$errors$[0];
    return (0, $fr77o.miradorSlice)(state).errors[errorId];
}
var $2a721134fbe182a8$export$1780dd9998652096 = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWorkspace)
], function(_ref) {
    var type = _ref.type;
    return type;
});
var $2a721134fbe182a8$var$getFocusedWindowId = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWorkspace)
], function(_ref2) {
    var focusedWindowId = _ref2.focusedWindowId;
    return focusedWindowId;
});
var $2a721134fbe182a8$export$d267344c6c72483b = function isFocused(state, _ref3) {
    var windowId = _ref3.windowId;
    return $2a721134fbe182a8$var$getFocusedWindowId(state) === windowId;
};

});




parcelRegister("9OZfp", function(module, exports) {

$parcel$export(module.exports, "ThumbnailNavigation", function () { return $72684b0b133c6ef0$export$48239df39c679b3d; });

var $arQ7u = parcelRequire("arQ7u");

var $3f9WU = parcelRequire("3f9WU");

var $kesLx = parcelRequire("kesLx");

var $etBnI = parcelRequire("etBnI");

var $dErw7 = parcelRequire("dErw7");

var $2vCMW = parcelRequire("2vCMW");

var $5Y5nq = parcelRequire("5Y5nq");

var $1xlvK = parcelRequire("1xlvK");
function $72684b0b133c6ef0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $72684b0b133c6ef0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $72684b0b133c6ef0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $72684b0b133c6ef0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $72684b0b133c6ef0$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $72684b0b133c6ef0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $72684b0b133c6ef0$var$_setPrototypeOf(subClass, superClass);
}
function $72684b0b133c6ef0$var$_setPrototypeOf(o, p) {
    $72684b0b133c6ef0$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $72684b0b133c6ef0$var$_setPrototypeOf(o, p);
}
function $72684b0b133c6ef0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $72684b0b133c6ef0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $72684b0b133c6ef0$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $72684b0b133c6ef0$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $72684b0b133c6ef0$var$_possibleConstructorReturn(this, result);
    };
}
function $72684b0b133c6ef0$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $72684b0b133c6ef0$var$_assertThisInitialized(self);
}
function $72684b0b133c6ef0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $72684b0b133c6ef0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $72684b0b133c6ef0$var$_getPrototypeOf(o) {
    $72684b0b133c6ef0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $72684b0b133c6ef0$var$_getPrototypeOf(o);
}
var $72684b0b133c6ef0$export$48239df39c679b3d = /*#__PURE__*/ function(_Component) {
    $72684b0b133c6ef0$var$_inherits(ThumbnailNavigation, _Component);
    var _super = $72684b0b133c6ef0$var$_createSuper(ThumbnailNavigation);
    /**
   */ function ThumbnailNavigation(props) {
        var _this;
        $72684b0b133c6ef0$var$_classCallCheck(this, ThumbnailNavigation);
        _this = _super.call(this, props);
        _this.scrollbarSize = 15;
        _this.spacing = 8; // 2 * (2px margin + 2px border + 2px padding + 2px padding)
        _this.calculateScaledSize = _this.calculateScaledSize.bind($72684b0b133c6ef0$var$_assertThisInitialized(_this));
        _this.itemCount = _this.itemCount.bind($72684b0b133c6ef0$var$_assertThisInitialized(_this));
        _this.handleKeyUp = _this.handleKeyUp.bind($72684b0b133c6ef0$var$_assertThisInitialized(_this));
        _this.nextCanvas = _this.nextCanvas.bind($72684b0b133c6ef0$var$_assertThisInitialized(_this));
        _this.previousCanvas = _this.previousCanvas.bind($72684b0b133c6ef0$var$_assertThisInitialized(_this));
        _this.gridRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createRef();
        return _this;
    }
    /**
   * If the view has changed and the thumbnailNavigation is open, recompute all
   * of the grids
   */ $72684b0b133c6ef0$var$_createClass(ThumbnailNavigation, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props = this.props, canvasIndex = _this$props.canvasIndex, position = _this$props.position, view = _this$props.view;
                if (prevProps.view !== view && position !== "off") this.gridRef.current.resetAfterIndex(0);
                if (prevProps.canvasIndex !== canvasIndex) {
                    var index = canvasIndex;
                    if (view === "book") index = Math.ceil(index / 2);
                    this.gridRef.current.scrollToItem(index, "center");
                }
            }
        },
        {
            key: "handleKeyUp",
            value: function handleKeyUp(e) {
                var position = this.props.position;
                var nextKey = "ArrowRight";
                var previousKey = "ArrowLeft";
                if (position === "far-right") {
                    nextKey = "ArrowDown";
                    previousKey = "ArrowUp";
                }
                switch(e.key){
                    case nextKey:
                        this.nextCanvas();
                        break;
                    case previousKey:
                        this.previousCanvas();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "calculateScaledSize",
            value: function calculateScaledSize(index) {
                var _this$props2 = this.props, thumbnailNavigation = _this$props2.thumbnailNavigation, canvasGroupings = _this$props2.canvasGroupings, position = _this$props2.position;
                var canvases = canvasGroupings[index] || [];
                var world = new (0, $2vCMW.default)(canvases);
                var bounds = world.worldBounds();
                switch(position){
                    case "far-right":
                        var calc = Math.floor(this.calculatingWidth(canvases.length) * bounds[3] / bounds[2]);
                        if (!Number.isInteger(calc)) return thumbnailNavigation.width + this.spacing;
                        return calc + this.spacing;
                    // Default case bottom
                    default:
                        if (bounds[3] === 0) return thumbnailNavigation.width + this.spacing;
                        var _calc = Math.ceil((thumbnailNavigation.height - this.scrollbarSize - this.spacing - 4) * bounds[2] / bounds[3]);
                        return _calc;
                }
            }
        },
        {
            key: "calculatingWidth",
            value: function calculatingWidth(canvasesLength) {
                var thumbnailNavigation = this.props.thumbnailNavigation;
                if (canvasesLength === 1) return thumbnailNavigation.width;
                return thumbnailNavigation.width * 2;
            }
        },
        {
            key: "rightWidth",
            value: function rightWidth() {
                var _this$props3 = this.props, view = _this$props3.view, thumbnailNavigation = _this$props3.thumbnailNavigation;
                switch(view){
                    case "book":
                        return thumbnailNavigation.width * 2;
                    default:
                        return thumbnailNavigation.width;
                }
            }
        },
        {
            key: "style",
            value: function style() {
                var _this$props4 = this.props, position = _this$props4.position, thumbnailNavigation = _this$props4.thumbnailNavigation;
                switch(position){
                    case "far-right":
                        return {
                            height: "100%",
                            minHeight: 0,
                            width: "".concat(this.rightWidth() + this.scrollbarSize + this.spacing, "px")
                        };
                    // Default case bottom
                    default:
                        return {
                            height: "".concat(thumbnailNavigation.height, "px"),
                            width: "100%"
                        };
                }
            }
        },
        {
            key: "areaHeight",
            value: function areaHeight(height) {
                var _this$props5 = this.props, position = _this$props5.position, thumbnailNavigation = _this$props5.thumbnailNavigation;
                switch(position){
                    case "far-right":
                        return height;
                    // Default case bottom
                    default:
                        return thumbnailNavigation.height;
                }
            }
        },
        {
            key: "itemCount",
            value: function itemCount() {
                var canvasGroupings = this.props.canvasGroupings;
                return canvasGroupings.length;
            }
        },
        {
            key: "nextCanvas",
            value: function nextCanvas() {
                var _this$props6 = this.props, hasNextCanvas = _this$props6.hasNextCanvas, setNextCanvas = _this$props6.setNextCanvas;
                if (hasNextCanvas) setNextCanvas();
            }
        },
        {
            key: "previousCanvas",
            value: function previousCanvas() {
                var _this$props7 = this.props, hasPreviousCanvas = _this$props7.hasPreviousCanvas, setPreviousCanvas = _this$props7.setPreviousCanvas;
                if (hasPreviousCanvas) setPreviousCanvas();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props8 = this.props, t = _this$props8.t, canvasGroupings = _this$props8.canvasGroupings, classes = _this$props8.classes, position = _this$props8.position, thumbnailNavigation = _this$props8.thumbnailNavigation, viewingDirection = _this$props8.viewingDirection, windowId = _this$props8.windowId;
                if (position === "off") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null);
                var htmlDir = viewingDirection === "right-to-left" ? "rtl" : "ltr";
                var itemData = {
                    canvasGroupings: canvasGroupings,
                    height: thumbnailNavigation.height - this.spacing - this.scrollbarSize,
                    position: position,
                    windowId: windowId
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $3f9WU.default), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dErw7)))((0, $1xlvK.default)("thumb-navigation"), classes.thumbNavigation),
                    "aria-label": t("thumbnailNavigation"),
                    square: true,
                    elevation: 0,
                    style: this.style(),
                    tabIndex: 0,
                    onKeyUp: this.handleKeyUp,
                    role: "grid"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    role: "row",
                    style: {
                        height: "100%",
                        width: "100%"
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $kesLx.default), {
                    defaultHeight: 100,
                    defaultWidth: 400
                }, function(_ref) {
                    var height = _ref.height, width = _ref.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $etBnI.VariableSizeList), {
                        direction: htmlDir,
                        height: _this2.areaHeight(height),
                        itemCount: _this2.itemCount(),
                        itemSize: _this2.calculateScaledSize,
                        width: width,
                        layout: position === "far-bottom" ? "horizontal" : "vertical",
                        itemData: itemData,
                        ref: _this2.gridRef
                    }, (0, $5Y5nq.default));
                })));
            }
        }
    ]);
    return ThumbnailNavigation;
}((0, $arQ7u.Component));
$72684b0b133c6ef0$export$48239df39c679b3d.defaultProps = {
    hasNextCanvas: false,
    hasPreviousCanvas: false,
    setNextCanvas: function setNextCanvas() {},
    setPreviousCanvas: function setPreviousCanvas() {},
    view: undefined,
    viewingDirection: ""
};

});
parcelRegister("3f9WU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25ca7d845ae0b323$export$2e2bcd8739ae039; });

var $dXEVX = parcelRequire("dXEVX");

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");


var $7EzGR = parcelRequire("7EzGR");
var $25ca7d845ae0b323$export$9dd6ff9ea0189349 = function styles(theme) {
    var elevations = {};
    theme.shadows.forEach(function(shadow, index) {
        elevations["elevation".concat(index)] = {
            boxShadow: shadow
        };
    });
    return (0, $abElG.default)({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create("box-shadow")
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.divider)
        }
    }, elevations);
};
var $25ca7d845ae0b323$var$Paper = /*#__PURE__*/ $arQ7u.forwardRef(function Paper(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? "elevation" : _props$variant, other = (0, $dXEVX.default)(props, [
        "classes",
        "className",
        "component",
        "square",
        "elevation",
        "variant"
    ]);
    return /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, variant === "outlined" ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
        ref: ref
    }, other));
});
var $25ca7d845ae0b323$export$2e2bcd8739ae039 = (0, $7EzGR.default)($25ca7d845ae0b323$export$9dd6ff9ea0189349, {
    name: "MuiPaper"
})($25ca7d845ae0b323$var$Paper);

});
parcelRegister("5g55B", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $3d426502f21b0bfd$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $3d426502f21b0bfd$export$2e2bcd8739ae039; });
function $3d426502f21b0bfd$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $3d426502f21b0bfd$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $3d426502f21b0bfd$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $3d426502f21b0bfd$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $3d426502f21b0bfd$export$2e2bcd8739ae039 = $3d426502f21b0bfd$export$4f5d2d50c9deca37;

});


parcelRegister("kesLx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebab6dbe8fe635b5$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Use 'export' statement over 'module.exports' assignment
 **/ // Check `document` and `window` in case of server-side rendering
let $ebab6dbe8fe635b5$var$windowObject;
if (typeof window !== "undefined") $ebab6dbe8fe635b5$var$windowObject = window;
else if (typeof self !== "undefined") // eslint-disable-next-line no-restricted-globals
$ebab6dbe8fe635b5$var$windowObject = self;
else $ebab6dbe8fe635b5$var$windowObject = $parcel$global;
let $ebab6dbe8fe635b5$var$cancelFrame = null;
let $ebab6dbe8fe635b5$var$requestFrame = null;
const $ebab6dbe8fe635b5$var$TIMEOUT_DURATION = 20;
const $ebab6dbe8fe635b5$var$clearTimeoutFn = $ebab6dbe8fe635b5$var$windowObject.clearTimeout;
const $ebab6dbe8fe635b5$var$setTimeoutFn = $ebab6dbe8fe635b5$var$windowObject.setTimeout;
const $ebab6dbe8fe635b5$var$cancelAnimationFrameFn = $ebab6dbe8fe635b5$var$windowObject.cancelAnimationFrame || $ebab6dbe8fe635b5$var$windowObject.mozCancelAnimationFrame || $ebab6dbe8fe635b5$var$windowObject.webkitCancelAnimationFrame;
const $ebab6dbe8fe635b5$var$requestAnimationFrameFn = $ebab6dbe8fe635b5$var$windowObject.requestAnimationFrame || $ebab6dbe8fe635b5$var$windowObject.mozRequestAnimationFrame || $ebab6dbe8fe635b5$var$windowObject.webkitRequestAnimationFrame;
if ($ebab6dbe8fe635b5$var$cancelAnimationFrameFn == null || $ebab6dbe8fe635b5$var$requestAnimationFrameFn == null) {
    // For environments that don't support animation frame,
    // fallback to a setTimeout based approach.
    $ebab6dbe8fe635b5$var$cancelFrame = $ebab6dbe8fe635b5$var$clearTimeoutFn;
    $ebab6dbe8fe635b5$var$requestFrame = function requestAnimationFrameViaSetTimeout(callback) {
        return $ebab6dbe8fe635b5$var$setTimeoutFn(callback, $ebab6dbe8fe635b5$var$TIMEOUT_DURATION);
    };
} else {
    // Counter intuitively, environments that support animation frames can be trickier.
    // Chrome's "Throttle non-visible cross-origin iframes" flag can prevent rAFs from being called.
    // In this case, we should fallback to a setTimeout() implementation.
    $ebab6dbe8fe635b5$var$cancelFrame = function cancelFrame([animationFrameID, timeoutID]) {
        $ebab6dbe8fe635b5$var$cancelAnimationFrameFn(animationFrameID);
        $ebab6dbe8fe635b5$var$clearTimeoutFn(timeoutID);
    };
    $ebab6dbe8fe635b5$var$requestFrame = function requestAnimationFrameWithSetTimeoutFallback(callback) {
        const animationFrameID = $ebab6dbe8fe635b5$var$requestAnimationFrameFn(function animationFrameCallback() {
            $ebab6dbe8fe635b5$var$clearTimeoutFn(timeoutID);
            callback();
        });
        const timeoutID = $ebab6dbe8fe635b5$var$setTimeoutFn(function timeoutCallback() {
            $ebab6dbe8fe635b5$var$cancelAnimationFrameFn(animationFrameID);
            callback();
        }, $ebab6dbe8fe635b5$var$TIMEOUT_DURATION);
        return [
            animationFrameID,
            timeoutID
        ];
    };
}
function $ebab6dbe8fe635b5$var$createDetectElementResize(nonce) {
    let animationKeyframes;
    let animationName;
    let animationStartEvent;
    let animationStyle;
    let checkTriggers;
    let resetTriggers;
    let scrollListener;
    const attachEvent = typeof document !== "undefined" && document.attachEvent;
    if (!attachEvent) {
        resetTriggers = function(element) {
            const triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + "px";
            expandChild.style.height = expand.offsetHeight + 1 + "px";
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        checkTriggers = function(element) {
            return element.offsetWidth !== element.__resizeLast__.width || element.offsetHeight !== element.__resizeLast__.height;
        };
        scrollListener = function(e) {
            // Don't measure (which forces) reflow for scrolls that happen inside of children!
            if (e.target.className && typeof e.target.className.indexOf === "function" && e.target.className.indexOf("contract-trigger") < 0 && e.target.className.indexOf("expand-trigger") < 0) return;
            const element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) $ebab6dbe8fe635b5$var$cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = $ebab6dbe8fe635b5$var$requestFrame(function animationFrame() {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function forEachResizeListener(fn) {
                        fn.call(element, e);
                    });
                }
            });
        };
        /* Detect CSS Animations support to detect element display/re-attach */ let animation = false;
        let keyframeprefix = "";
        animationStartEvent = "animationstart";
        const domPrefixes = "Webkit Moz O ms".split(" ");
        let startEvents = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" ");
        let pfx = "";
        {
            const elm = document.createElement("fakeelement");
            if (elm.style.animationName !== undefined) animation = true;
            if (animation === false) {
                for(let i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + "AnimationName"] !== undefined) {
                    pfx = domPrefixes[i];
                    keyframeprefix = "-" + pfx.toLowerCase() + "-";
                    animationStartEvent = startEvents[i];
                    animation = true;
                    break;
                }
            }
        }
        animationName = "resizeanim";
        animationKeyframes = "@" + keyframeprefix + "keyframes " + animationName + " { from { opacity: 0; } to { opacity: 0; } } ";
        animationStyle = keyframeprefix + "animation: 1ms " + animationName + "; ";
    }
    const createStyles = function(doc) {
        if (!doc.getElementById("detectElementResize")) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            const css = (animationKeyframes ? animationKeyframes : "") + ".resize-triggers { " + (animationStyle ? animationStyle : "") + "visibility: hidden; opacity: 0; } " + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName("head")[0], style = doc.createElement("style");
            style.id = "detectElementResize";
            style.type = "text/css";
            if (nonce != null) style.setAttribute("nonce", nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            head.appendChild(style);
        }
    };
    const addResizeListener = function(element, fn) {
        if (attachEvent) element.attachEvent("onresize", fn);
        else {
            if (!element.__resizeTriggers__) {
                const doc = element.ownerDocument;
                const elementStyle = $ebab6dbe8fe635b5$var$windowObject.getComputedStyle(element);
                if (elementStyle && elementStyle.position === "static") element.style.position = "relative";
                createStyles(doc);
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = doc.createElement("div")).className = "resize-triggers";
                const expandTrigger = doc.createElement("div");
                expandTrigger.className = "expand-trigger";
                expandTrigger.appendChild(doc.createElement("div"));
                const contractTrigger = doc.createElement("div");
                contractTrigger.className = "contract-trigger";
                element.__resizeTriggers__.appendChild(expandTrigger);
                element.__resizeTriggers__.appendChild(contractTrigger);
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener("scroll", scrollListener, true);
                /* Listen for a css animation to detect element display/re-attach */ if (animationStartEvent) {
                    element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                        if (e.animationName === animationName) resetTriggers(element);
                    };
                    element.__resizeTriggers__.addEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
                }
            }
            element.__resizeListeners__.push(fn);
        }
    };
    const removeResizeListener = function(element, fn) {
        if (attachEvent) element.detachEvent("onresize", fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                element.removeEventListener("scroll", scrollListener, true);
                if (element.__resizeTriggers__.__animationListener__) {
                    element.__resizeTriggers__.removeEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
                    element.__resizeTriggers__.__animationListener__ = null;
                }
                try {
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                } catch (e) {
                // Preact compat; see developit/preact-compat/issues/228
                }
            }
        }
    };
    return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener
    };
}
class $ebab6dbe8fe635b5$export$2e2bcd8739ae039 extends (0, $arQ7u.Component) {
    componentDidMount() {
        const { nonce: nonce } = this.props;
        const parentNode = this._autoSizer ? this._autoSizer.parentNode : null;
        if (parentNode != null && parentNode.ownerDocument && parentNode.ownerDocument.defaultView && parentNode instanceof parentNode.ownerDocument.defaultView.HTMLElement) {
            // Delay access of parentNode until mount.
            // This handles edge-cases where the component has already been unmounted before its ref has been set,
            // As well as libraries like react-lite which have a slightly different lifecycle.
            this._parentNode = parentNode;
            // Use ResizeObserver from the same context where parentNode (which we will observe) was defined
            // Using just global can result into onResize events not being emitted in cases with multiple realms
            const ResizeObserverInstance = parentNode.ownerDocument.defaultView.ResizeObserver;
            if (ResizeObserverInstance != null) {
                this._resizeObserver = new ResizeObserverInstance(()=>{
                    // Guard against "ResizeObserver loop limit exceeded" error;
                    // could be triggered if the state update causes the ResizeObserver handler to run long.
                    // See https://github.com/bvaughn/react-virtualized-auto-sizer/issues/55
                    this._timeoutId = setTimeout(this._onResize, 0);
                });
                this._resizeObserver.observe(parentNode);
            } else {
                // Defer requiring resize handler in order to support server-side rendering.
                // See issue #41
                this._detectElementResize = $ebab6dbe8fe635b5$var$createDetectElementResize(nonce);
                this._detectElementResize.addResizeListener(parentNode, this._onResize);
            }
            this._onResize();
        }
    }
    componentWillUnmount() {
        if (this._parentNode) {
            if (this._detectElementResize) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
            if (this._timeoutId !== null) clearTimeout(this._timeoutId);
            if (this._resizeObserver) this._resizeObserver.disconnect();
        }
    }
    render() {
        const { children: children, defaultHeight: defaultHeight, defaultWidth: defaultWidth, disableHeight: disableHeight = false, disableWidth: disableWidth = false, doNotBailOutOnEmptyChildren: doNotBailOutOnEmptyChildren = false, nonce: nonce, onResize: onResize, style: style = {}, tagName: tagName = "div", ...rest } = this.props;
        const { height: height, scaledHeight: scaledHeight, scaledWidth: scaledWidth, width: width } = this.state;
        // Outer div should not force width/height since that may prevent containers from shrinking.
        // Inner component should overflow and use calculated width/height.
        // See issue #68 for more information.
        const outerStyle = {
            overflow: "visible"
        };
        const childParams = {};
        // Avoid rendering children before the initial measurements have been collected.
        // At best this would just be wasting cycles.
        let bailoutOnChildren = false;
        if (!disableHeight) {
            if (height === 0) bailoutOnChildren = true;
            outerStyle.height = 0;
            childParams.height = height;
            childParams.scaledHeight = scaledHeight;
        }
        if (!disableWidth) {
            if (width === 0) bailoutOnChildren = true;
            outerStyle.width = 0;
            childParams.width = width;
            childParams.scaledWidth = scaledWidth;
        }
        if (doNotBailOutOnEmptyChildren) bailoutOnChildren = false;
        return (0, $arQ7u.createElement)(tagName, {
            ref: this._setRef,
            style: {
                ...outerStyle,
                ...style
            },
            ...rest
        }, !bailoutOnChildren && children(childParams));
    }
    constructor(...args){
        super(...args);
        this.state = {
            height: this.props.defaultHeight || 0,
            scaledHeight: this.props.defaultHeight || 0,
            scaledWidth: this.props.defaultWidth || 0,
            width: this.props.defaultWidth || 0
        };
        this._autoSizer = null;
        this._detectElementResize = null;
        this._parentNode = null;
        this._resizeObserver = null;
        this._timeoutId = null;
        this._onResize = ()=>{
            this._timeoutId = null;
            const { disableHeight: disableHeight, disableWidth: disableWidth, onResize: onResize } = this.props;
            if (this._parentNode) {
                // Guard against AutoSizer component being removed from the DOM immediately after being added.
                // This can result in invalid style values which can result in NaN values if we don't handle them.
                // See issue #150 for more context.
                const style = window.getComputedStyle(this._parentNode) || {};
                const paddingLeft = parseFloat(style.paddingLeft || "0");
                const paddingRight = parseFloat(style.paddingRight || "0");
                const paddingTop = parseFloat(style.paddingTop || "0");
                const paddingBottom = parseFloat(style.paddingBottom || "0");
                const rect = this._parentNode.getBoundingClientRect();
                const scaledHeight = rect.height - paddingTop - paddingBottom;
                const scaledWidth = rect.width - paddingLeft - paddingRight;
                const height = this._parentNode.offsetHeight - paddingTop - paddingBottom;
                const width = this._parentNode.offsetWidth - paddingLeft - paddingRight;
                if (!disableHeight && (this.state.height !== height || this.state.scaledHeight !== scaledHeight) || !disableWidth && (this.state.width !== width || this.state.scaledWidth !== scaledWidth)) {
                    this.setState({
                        height: height,
                        width: width,
                        scaledHeight: scaledHeight,
                        scaledWidth: scaledWidth
                    });
                    if (typeof onResize === "function") onResize({
                        height: height,
                        scaledHeight: scaledHeight,
                        scaledWidth: scaledWidth,
                        width: width
                    });
                }
            }
        };
        this._setRef = (autoSizer)=>{
            this._autoSizer = autoSizer;
        };
    }
}
function $ebab6dbe8fe635b5$export$6a9e233b3261c1f(props) {
    return props && props.disableHeight !== true && props.disableWidth !== true;
}
function $ebab6dbe8fe635b5$export$232069b3e05ce32a(props) {
    return props && props.disableHeight !== true && props.disableWidth === true;
}
function $ebab6dbe8fe635b5$export$10ec32941a097f36(props) {
    return props && props.disableHeight === true && props.disableWidth !== true;
}

});

parcelRegister("etBnI", function(module, exports) {

$parcel$export(module.exports, "VariableSizeList", function () { return $a8a0c54eb63ca02e$export$d8ac3b6b20be856e; });

var $abElG = parcelRequire("abElG");

var $7qIdT = parcelRequire("7qIdT");

var $arruZ = parcelRequire("arruZ");

var $6BHCT = parcelRequire("6BHCT");

var $arQ7u = parcelRequire("arQ7u");

var $fJZol = parcelRequire("fJZol");
// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $a8a0c54eb63ca02e$var$hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
var $a8a0c54eb63ca02e$var$now = $a8a0c54eb63ca02e$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $a8a0c54eb63ca02e$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $a8a0c54eb63ca02e$var$requestTimeout(callback, delay) {
    var start = $a8a0c54eb63ca02e$var$now();
    function tick() {
        if ($a8a0c54eb63ca02e$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $a8a0c54eb63ca02e$var$size = -1; // This utility copied from "dom-helpers" package.
function $a8a0c54eb63ca02e$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($a8a0c54eb63ca02e$var$size === -1 || recalculate) {
        var div = document.createElement("div");
        var style = div.style;
        style.width = "50px";
        style.height = "50px";
        style.overflow = "scroll";
        document.body.appendChild(div);
        $a8a0c54eb63ca02e$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $a8a0c54eb63ca02e$var$size;
}
var $a8a0c54eb63ca02e$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $a8a0c54eb63ca02e$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($a8a0c54eb63ca02e$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement("div");
        var outerStyle = outerDiv.style;
        outerStyle.width = "50px";
        outerStyle.height = "50px";
        outerStyle.overflow = "scroll";
        outerStyle.direction = "rtl";
        var innerDiv = document.createElement("div");
        var innerStyle = innerDiv.style;
        innerStyle.width = "100px";
        innerStyle.height = "100px";
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $a8a0c54eb63ca02e$var$cachedRTLResult = "positive-descending";
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $a8a0c54eb63ca02e$var$cachedRTLResult = "negative";
            else $a8a0c54eb63ca02e$var$cachedRTLResult = "positive-ascending";
        }
        document.body.removeChild(outerDiv);
        return $a8a0c54eb63ca02e$var$cachedRTLResult;
    }
    return $a8a0c54eb63ca02e$var$cachedRTLResult;
}
var $a8a0c54eb63ca02e$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $a8a0c54eb63ca02e$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $a8a0c54eb63ca02e$var$devWarningsOverscanCount = null;
var $a8a0c54eb63ca02e$var$devWarningsOverscanRowsColumnsCount = null;
var $a8a0c54eb63ca02e$var$devWarningsTagName = null;
function $a8a0c54eb63ca02e$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $arruZ.default)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $7qIdT.default)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $7qIdT.default)(_this),
                isScrolling: false,
                horizontalScrollDirection: "forward",
                scrollLeft: typeof _this.props.initialScrollLeft === "number" ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === "number" ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: "forward"
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $6BHCT.default)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $6BHCT.default)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === "rtl";
                    itemStyleCache[key] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $6BHCT.default)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === "rtl") switch($a8a0c54eb63ca02e$var$getRTLOffsetType()){
                        case "negative":
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case "positive-descending":
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward",
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $a8a0c54eb63ca02e$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $a8a0c54eb63ca02e$var$requestTimeout(_this._resetIsScrolling, $a8a0c54eb63ca02e$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $a8a0c54eb63ca02e$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward"
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? "auto" : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $a8a0c54eb63ca02e$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === "number") outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === "number") outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === "rtl") switch($a8a0c54eb63ca02e$var$getRTLOffsetType()){
                    case "negative":
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case "positive-ascending":
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $a8a0c54eb63ca02e$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $a8a0c54eb63ca02e$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $arQ7u.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $arQ7u.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $abElG.default)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $arQ7u.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === "function") {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === "function") {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $arQ7u.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $a8a0c54eb63ca02e$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $a8a0c54eb63ca02e$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $a8a0c54eb63ca02e$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $a8a0c54eb63ca02e$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $a8a0c54eb63ca02e$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === "column") instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $a8a0c54eb63ca02e$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $a8a0c54eb63ca02e$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $a8a0c54eb63ca02e$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $a8a0c54eb63ca02e$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $a8a0c54eb63ca02e$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $a8a0c54eb63ca02e$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === "column" ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $a8a0c54eb63ca02e$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $a8a0c54eb63ca02e$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $a8a0c54eb63ca02e$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === "column" ? props.width : props.height;
    var itemMetadata = $a8a0c54eb63ca02e$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === "column" ? $a8a0c54eb63ca02e$var$getEstimatedTotalWidth(props, instanceProps) : $a8a0c54eb63ca02e$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === "smart") {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
        else align = "center";
    }
    switch(align){
        case "start":
            return maxOffset;
        case "end":
            return minOffset;
        case "center":
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case "auto":
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $a8a0c54eb63ca02e$export$32c206c84102e73c = /*#__PURE__*/ $a8a0c54eb63ca02e$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $a8a0c54eb63ca02e$var$getItemMetadata("column", props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $a8a0c54eb63ca02e$var$findNearestItem("column", props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $a8a0c54eb63ca02e$var$getItemMetadata("column", props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $a8a0c54eb63ca02e$var$getItemMetadata("column", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $a8a0c54eb63ca02e$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $a8a0c54eb63ca02e$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $a8a0c54eb63ca02e$var$getOffsetForIndexAndAlignment("column", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $a8a0c54eb63ca02e$var$getOffsetForIndexAndAlignment("row", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $a8a0c54eb63ca02e$var$getItemMetadata("row", props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $a8a0c54eb63ca02e$var$findNearestItem("row", props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $a8a0c54eb63ca02e$var$getItemMetadata("row", props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $a8a0c54eb63ca02e$var$getItemMetadata("row", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $a8a0c54eb63ca02e$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $a8a0c54eb63ca02e$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === "number") instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === "number") instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $a8a0c54eb63ca02e$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $a8a0c54eb63ca02e$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $a8a0c54eb63ca02e$var$devWarningsDirection = null;
var $a8a0c54eb63ca02e$var$devWarningsTagName$1 = null;
function $a8a0c54eb63ca02e$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $arruZ.default)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $7qIdT.default)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $7qIdT.default)(_this),
                isScrolling: false,
                scrollDirection: "forward",
                scrollOffset: typeof _this.props.initialScrollOffset === "number" ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $6BHCT.default)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $6BHCT.default)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === "horizontal" || layout === "horizontal";
                    var isRtl = direction === "rtl";
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : "100%",
                        width: isHorizontal ? size : "100%"
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $6BHCT.default)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($a8a0c54eb63ca02e$var$getRTLOffsetType()){
                        case "negative":
                            scrollOffset = -scrollLeft;
                            break;
                        case "positive-descending":
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $a8a0c54eb63ca02e$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $a8a0c54eb63ca02e$var$requestTimeout(_this._resetIsScrolling, $a8a0c54eb63ca02e$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $a8a0c54eb63ca02e$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = "auto";
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === "vertical") scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? $a8a0c54eb63ca02e$var$getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? $a8a0c54eb63ca02e$var$getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === "number" && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") {
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($a8a0c54eb63ca02e$var$getRTLOffsetType()){
                        case "negative":
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case "positive-ascending":
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $a8a0c54eb63ca02e$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? $a8a0c54eb63ca02e$var$defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === "horizontal" || layout === "horizontal";
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $arQ7u.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $arQ7u.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $abElG.default)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $arQ7u.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? "100%" : estimatedTotalSize,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: isHorizontal ? estimatedTotalSize : "100%"
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === "function") {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === "function") {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === "backward" ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === "forward" ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $arQ7u.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        layout: "vertical",
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $a8a0c54eb63ca02e$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $a8a0c54eb63ca02e$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $a8a0c54eb63ca02e$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $a8a0c54eb63ca02e$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $a8a0c54eb63ca02e$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $a8a0c54eb63ca02e$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $a8a0c54eb63ca02e$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $a8a0c54eb63ca02e$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $a8a0c54eb63ca02e$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $a8a0c54eb63ca02e$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $a8a0c54eb63ca02e$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $a8a0c54eb63ca02e$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $a8a0c54eb63ca02e$export$d8ac3b6b20be856e = /*#__PURE__*/ $a8a0c54eb63ca02e$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $a8a0c54eb63ca02e$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $a8a0c54eb63ca02e$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $a8a0c54eb63ca02e$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $a8a0c54eb63ca02e$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $a8a0c54eb63ca02e$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $a8a0c54eb63ca02e$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $a8a0c54eb63ca02e$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $a8a0c54eb63ca02e$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $a8a0c54eb63ca02e$export$f331158cccad7361 = /*#__PURE__*/ $a8a0c54eb63ca02e$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === "smart") {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === "smart") {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $a8a0c54eb63ca02e$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $a8a0c54eb63ca02e$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $a8a0c54eb63ca02e$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $a8a0c54eb63ca02e$var$_excluded = [
    "style"
], $a8a0c54eb63ca02e$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $a8a0c54eb63ca02e$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $fJZol.default)(prevProps, $a8a0c54eb63ca02e$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $fJZol.default)(nextProps, $a8a0c54eb63ca02e$var$_excluded2);
    return !$a8a0c54eb63ca02e$var$shallowDiffers(prevStyle, nextStyle) && !$a8a0c54eb63ca02e$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $a8a0c54eb63ca02e$export$aa365c903ed149ff(nextProps, nextState) {
    return !$a8a0c54eb63ca02e$export$b141efd0b0fb9174(this.props, nextProps) || $a8a0c54eb63ca02e$var$shallowDiffers(this.state, nextState);
}

});
parcelRegister("6BHCT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cf80a13ac4b41b3$export$2e2bcd8739ae039; });
var $4cf80a13ac4b41b3$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $4cf80a13ac4b41b3$var$isEqual(first, second) {
    if (first === second) return true;
    if ($4cf80a13ac4b41b3$var$safeIsNaN(first) && $4cf80a13ac4b41b3$var$safeIsNaN(second)) return true;
    return false;
}
function $4cf80a13ac4b41b3$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$4cf80a13ac4b41b3$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $4cf80a13ac4b41b3$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $4cf80a13ac4b41b3$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $4cf80a13ac4b41b3$export$2e2bcd8739ae039 = $4cf80a13ac4b41b3$var$memoizeOne;

});


parcelRegister("dErw7", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("2vCMW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d3c90975ef7c588$export$2e2bcd8739ae039; });

var $5lva4 = parcelRequire("5lva4");

var $izTcV = parcelRequire("izTcV");
function $1d3c90975ef7c588$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1d3c90975ef7c588$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1d3c90975ef7c588$var$ownKeys(Object(source), true).forEach(function(key) {
            $1d3c90975ef7c588$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1d3c90975ef7c588$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1d3c90975ef7c588$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1d3c90975ef7c588$var$_toConsumableArray(arr) {
    return $1d3c90975ef7c588$var$_arrayWithoutHoles(arr) || $1d3c90975ef7c588$var$_iterableToArray(arr) || $1d3c90975ef7c588$var$_unsupportedIterableToArray(arr) || $1d3c90975ef7c588$var$_nonIterableSpread();
}
function $1d3c90975ef7c588$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1d3c90975ef7c588$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1d3c90975ef7c588$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1d3c90975ef7c588$var$_arrayLikeToArray(arr);
}
function $1d3c90975ef7c588$var$_slicedToArray(arr, i) {
    return $1d3c90975ef7c588$var$_arrayWithHoles(arr) || $1d3c90975ef7c588$var$_iterableToArrayLimit(arr, i) || $1d3c90975ef7c588$var$_unsupportedIterableToArray(arr, i) || $1d3c90975ef7c588$var$_nonIterableRest();
}
function $1d3c90975ef7c588$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1d3c90975ef7c588$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1d3c90975ef7c588$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1d3c90975ef7c588$var$_arrayLikeToArray(o, minLen);
}
function $1d3c90975ef7c588$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1d3c90975ef7c588$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1d3c90975ef7c588$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1d3c90975ef7c588$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1d3c90975ef7c588$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1d3c90975ef7c588$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1d3c90975ef7c588$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1d3c90975ef7c588$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * CanvasWorld
 */ var $1d3c90975ef7c588$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {Array} canvases - Array of Manifesto:Canvas objects to create a
   * world from.
   */ function CanvasWorld(canvases, layers) {
        var viewingDirection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "left-to-right";
        $1d3c90975ef7c588$var$_classCallCheck(this, CanvasWorld);
        this.canvases = canvases.map(function(c) {
            return new (0, $izTcV.default)(c);
        });
        this.layers = layers;
        this.viewingDirection = viewingDirection;
        this._canvasDimensions = null; // eslint-disable-line no-underscore-dangle
    }
    /** */ $1d3c90975ef7c588$var$_createClass(CanvasWorld, [
        {
            key: "canvasIds",
            get: function get() {
                return this.canvases.map(function(canvas) {
                    return canvas.id;
                });
            }
        },
        {
            key: "canvasDimensions",
            get: function get() {
                if (this._canvasDimensions) // eslint-disable-line no-underscore-dangle
                return this._canvasDimensions; // eslint-disable-line no-underscore-dangle
                var _this$canvasDirection = $1d3c90975ef7c588$var$_slicedToArray(this.canvasDirection, 2), dirX = _this$canvasDirection[0], dirY = _this$canvasDirection[1];
                var scale = dirY === 0 ? Math.min.apply(Math, $1d3c90975ef7c588$var$_toConsumableArray(this.canvases.map(function(c) {
                    return c.getHeight();
                }))) : Math.min.apply(Math, $1d3c90975ef7c588$var$_toConsumableArray(this.canvases.map(function(c) {
                    return c.getWidth();
                })));
                var incX = 0;
                var incY = 0;
                var canvasDims = this.canvases.reduce(function(acc, canvas) {
                    var canvasHeight = 0;
                    var canvasWidth = 0;
                    if (!isNaN(canvas.aspectRatio)) {
                        if (dirY === 0) {
                            // constant height
                            canvasHeight = scale;
                            canvasWidth = Math.floor(scale * canvas.aspectRatio);
                        } else {
                            // constant width
                            canvasWidth = scale;
                            canvasHeight = Math.floor(scale * (1 / canvas.aspectRatio));
                        }
                    }
                    acc.push({
                        canvas: canvas,
                        height: canvasHeight,
                        width: canvasWidth,
                        x: incX,
                        y: incY
                    });
                    incX += dirX * canvasWidth;
                    incY += dirY * canvasHeight;
                    return acc;
                }, []);
                var worldHeight = dirY === 0 ? scale : Math.abs(incY);
                var worldWidth = dirX === 0 ? scale : Math.abs(incX);
                this._canvasDimensions = canvasDims // eslint-disable-line no-underscore-dangle
                .reduce(function(acc, dims) {
                    acc.push($1d3c90975ef7c588$var$_objectSpread($1d3c90975ef7c588$var$_objectSpread({}, dims), {}, {
                        x: dirX === -1 ? dims.x + worldWidth - dims.width : dims.x,
                        y: dirY === -1 ? dims.y + worldHeight - dims.height : dims.y
                    }));
                    return acc;
                }, []);
                return this._canvasDimensions; // eslint-disable-line no-underscore-dangle
            }
        },
        {
            key: "contentResourceToWorldCoordinates",
            value: function contentResourceToWorldCoordinates(contentResource) {
                var miradorCanvasIndex = this.canvases.findIndex(function(c) {
                    return c.imageResources.find(function(r) {
                        return r.id === contentResource.id;
                    });
                });
                var canvas = this.canvases[miradorCanvasIndex];
                if (!canvas) return [];
                var _this$canvasToWorldCo = this.canvasToWorldCoordinates(canvas.id), _this$canvasToWorldCo2 = $1d3c90975ef7c588$var$_slicedToArray(_this$canvasToWorldCo, 4), x = _this$canvasToWorldCo2[0], y = _this$canvasToWorldCo2[1], w = _this$canvasToWorldCo2[2], h = _this$canvasToWorldCo2[3];
                var fragmentOffset = canvas.onFragment(contentResource.id);
                if (fragmentOffset) return [
                    x + fragmentOffset[0],
                    y + fragmentOffset[1],
                    fragmentOffset[2],
                    fragmentOffset[3]
                ];
                return [
                    x,
                    y,
                    w,
                    h
                ];
            }
        },
        {
            key: "canvasToWorldCoordinates",
            value: function canvasToWorldCoordinates(canvasId) {
                var canvasDimensions = this.canvasDimensions.find(function(c) {
                    return c.canvas.id === canvasId;
                });
                return [
                    canvasDimensions.x,
                    canvasDimensions.y,
                    canvasDimensions.width,
                    canvasDimensions.height
                ];
            }
        },
        {
            key: "canvasDirection",
            get: function get() {
                switch(this.viewingDirection){
                    case "left-to-right":
                        return [
                            1,
                            0
                        ];
                    case "right-to-left":
                        return [
                            -1,
                            0
                        ];
                    case "top-to-bottom":
                        return [
                            0,
                            1
                        ];
                    case "bottom-to-top":
                        return [
                            0,
                            -1
                        ];
                    default:
                        return [
                            1,
                            0
                        ];
                }
            }
        },
        {
            key: "contentResource",
            value: function contentResource(infoResponseId) {
                var miradorCanvas = this.canvases.find(function(c) {
                    return c.imageServiceIds.some(function(id) {
                        return (0, (/*@__PURE__*/$parcel$interopDefault($5lva4)))(id, {
                            stripAuthentication: false
                        }) === (0, (/*@__PURE__*/$parcel$interopDefault($5lva4)))(infoResponseId, {
                            stripAuthentication: false
                        });
                    });
                });
                if (!miradorCanvas) return undefined;
                return miradorCanvas.imageResources.find(function(r) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5lva4)))(r.getServices()[0].id, {
                        stripAuthentication: false
                    }) === (0, (/*@__PURE__*/$parcel$interopDefault($5lva4)))(infoResponseId, {
                        stripAuthentication: false
                    });
                });
            }
        },
        {
            key: "getLayerMetadata",
            value: function getLayerMetadata(contentResource) {
                if (!this.layers) return undefined;
                var miradorCanvas = this.canvases.find(function(c) {
                    return c.imageResources.find(function(r) {
                        return r.id === contentResource.id;
                    });
                });
                if (!miradorCanvas) return undefined;
                var resourceIndex = miradorCanvas.imageResources.findIndex(function(r) {
                    return r.id === contentResource.id;
                });
                var layer = this.layers[miradorCanvas.canvas.id];
                var imageResourceLayer = layer && layer[contentResource.id];
                return $1d3c90975ef7c588$var$_objectSpread({
                    index: resourceIndex,
                    opacity: 1,
                    total: miradorCanvas.imageResources.length,
                    visibility: true
                }, imageResourceLayer);
            }
        },
        {
            key: "layerOpacityOfImageResource",
            value: function layerOpacityOfImageResource(contentResource) {
                var layer = this.getLayerMetadata(contentResource);
                if (!layer) return 1;
                if (!layer.visibility) return 0;
                return layer.opacity;
            }
        },
        {
            key: "layerIndexOfImageResource",
            value: function layerIndexOfImageResource(contentResource) {
                var layer = this.getLayerMetadata(contentResource);
                if (!layer) return undefined;
                return layer.total - layer.index - 1;
            }
        },
        {
            key: "offsetByCanvas",
            value: function offsetByCanvas(canvasTarget) {
                var coordinates = this.canvasToWorldCoordinates(canvasTarget);
                return {
                    x: coordinates[0],
                    y: coordinates[1]
                };
            }
        },
        {
            key: "worldBounds",
            value: function worldBounds() {
                var worldWidth = Math.max.apply(Math, $1d3c90975ef7c588$var$_toConsumableArray(this.canvasDimensions.map(function(c) {
                    return c.x + c.width;
                })));
                var worldHeight = Math.max.apply(Math, $1d3c90975ef7c588$var$_toConsumableArray(this.canvasDimensions.map(function(c) {
                    return c.y + c.height;
                })));
                return [
                    0,
                    0,
                    worldWidth,
                    worldHeight
                ];
            }
        },
        {
            key: "canvasAtPoint",
            value: function canvasAtPoint(point) {
                var canvasDimensions = this.canvasDimensions.find(function(c) {
                    return c.x <= point.x && point.x <= c.x + c.width && c.y <= point.y && point.y <= c.y + c.height;
                });
                return canvasDimensions && canvasDimensions.canvas;
            }
        }
    ]);
    return CanvasWorld;
}();

});
parcelRegister("5lva4", function(module, exports) {
"use strict";

// TODO: Use the `URL` global when targeting Node.js 10
const $3e4715efa4c85cca$var$URLParser = typeof URL === "undefined" ? (parcelRequire("9Zqck")).URL : URL;
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
const $3e4715efa4c85cca$var$DATA_URL_DEFAULT_MIME_TYPE = "text/plain";
const $3e4715efa4c85cca$var$DATA_URL_DEFAULT_CHARSET = "us-ascii";
const $3e4715efa4c85cca$var$testParameter = (name, filters)=>{
    return filters.some((filter)=>filter instanceof RegExp ? filter.test(name) : filter === name);
};
const $3e4715efa4c85cca$var$normalizeDataURL = (urlString, { stripHash: stripHash })=>{
    const parts = urlString.match(/^data:([^,]*?),([^#]*?)(?:#(.*))?$/);
    if (!parts) throw new Error(`Invalid URL: ${urlString}`);
    const mediaType = parts[1].split(";");
    const body = parts[2];
    const hash = stripHash ? "" : parts[3];
    let base64 = false;
    if (mediaType[mediaType.length - 1] === "base64") {
        mediaType.pop();
        base64 = true;
    }
    // Lowercase MIME type
    const mimeType = (mediaType.shift() || "").toLowerCase();
    const attributes = mediaType.map((attribute)=>{
        let [key, value = ""] = attribute.split("=").map((string)=>string.trim());
        // Lowercase `charset`
        if (key === "charset") {
            value = value.toLowerCase();
            if (value === $3e4715efa4c85cca$var$DATA_URL_DEFAULT_CHARSET) return "";
        }
        return `${key}${value ? `=${value}` : ""}`;
    }).filter(Boolean);
    const normalizedMediaType = [
        ...attributes
    ];
    if (base64) normalizedMediaType.push("base64");
    if (normalizedMediaType.length !== 0 || mimeType && mimeType !== $3e4715efa4c85cca$var$DATA_URL_DEFAULT_MIME_TYPE) normalizedMediaType.unshift(mimeType);
    return `data:${normalizedMediaType.join(";")},${base64 ? body.trim() : body}${hash ? `#${hash}` : ""}`;
};
const $3e4715efa4c85cca$var$normalizeUrl = (urlString, options)=>{
    options = {
        defaultProtocol: "http:",
        normalizeProtocol: true,
        forceHttp: false,
        forceHttps: false,
        stripAuthentication: true,
        stripHash: false,
        stripWWW: true,
        removeQueryParameters: [
            /^utm_\w+/i
        ],
        removeTrailingSlash: true,
        removeDirectoryIndex: false,
        sortQueryParameters: true,
        ...options
    };
    // TODO: Remove this at some point in the future
    if (Reflect.has(options, "normalizeHttps")) throw new Error("options.normalizeHttps is renamed to options.forceHttp");
    if (Reflect.has(options, "normalizeHttp")) throw new Error("options.normalizeHttp is renamed to options.forceHttps");
    if (Reflect.has(options, "stripFragment")) throw new Error("options.stripFragment is renamed to options.stripHash");
    urlString = urlString.trim();
    // Data URL
    if (/^data:/i.test(urlString)) return $3e4715efa4c85cca$var$normalizeDataURL(urlString, options);
    const hasRelativeProtocol = urlString.startsWith("//");
    const isRelativeUrl = !hasRelativeProtocol && /^\.*\//.test(urlString);
    // Prepend protocol
    if (!isRelativeUrl) urlString = urlString.replace(/^(?!(?:\w+:)?\/\/)|^\/\//, options.defaultProtocol);
    const urlObj = new $3e4715efa4c85cca$var$URLParser(urlString);
    if (options.forceHttp && options.forceHttps) throw new Error("The `forceHttp` and `forceHttps` options cannot be used together");
    if (options.forceHttp && urlObj.protocol === "https:") urlObj.protocol = "http:";
    if (options.forceHttps && urlObj.protocol === "http:") urlObj.protocol = "https:";
    // Remove auth
    if (options.stripAuthentication) {
        urlObj.username = "";
        urlObj.password = "";
    }
    // Remove hash
    if (options.stripHash) urlObj.hash = "";
    // Remove duplicate slashes if not preceded by a protocol
    if (urlObj.pathname) // TODO: Use the following instead when targeting Node.js 10
    // `urlObj.pathname = urlObj.pathname.replace(/(?<!https?:)\/{2,}/g, '/');`
    urlObj.pathname = urlObj.pathname.replace(/((?!:).|^)\/{2,}/g, (_, p1)=>{
        if (/^(?!\/)/g.test(p1)) return `${p1}/`;
        return "/";
    });
    // Decode URI octets
    if (urlObj.pathname) urlObj.pathname = decodeURI(urlObj.pathname);
    // Remove directory index
    if (options.removeDirectoryIndex === true) options.removeDirectoryIndex = [
        /^index\.[a-z]+$/
    ];
    if (Array.isArray(options.removeDirectoryIndex) && options.removeDirectoryIndex.length > 0) {
        let pathComponents = urlObj.pathname.split("/");
        const lastComponent = pathComponents[pathComponents.length - 1];
        if ($3e4715efa4c85cca$var$testParameter(lastComponent, options.removeDirectoryIndex)) {
            pathComponents = pathComponents.slice(0, pathComponents.length - 1);
            urlObj.pathname = pathComponents.slice(1).join("/") + "/";
        }
    }
    if (urlObj.hostname) {
        // Remove trailing dot
        urlObj.hostname = urlObj.hostname.replace(/\.$/, "");
        // Remove `www.`
        if (options.stripWWW && /^www\.([a-z\-\d]{2,63})\.([a-z.]{2,5})$/.test(urlObj.hostname)) // Each label should be max 63 at length (min: 2).
        // The extension should be max 5 at length (min: 2).
        // Source: https://en.wikipedia.org/wiki/Hostname#Restrictions_on_valid_host_names
        urlObj.hostname = urlObj.hostname.replace(/^www\./, "");
    }
    // Remove query unwanted parameters
    if (Array.isArray(options.removeQueryParameters)) {
        for (const key of [
            ...urlObj.searchParams.keys()
        ])if ($3e4715efa4c85cca$var$testParameter(key, options.removeQueryParameters)) urlObj.searchParams.delete(key);
    }
    // Sort query parameters
    if (options.sortQueryParameters) urlObj.searchParams.sort();
    if (options.removeTrailingSlash) urlObj.pathname = urlObj.pathname.replace(/\/$/, "");
    // Take advantage of many of the Node `url` normalizations
    urlString = urlObj.toString();
    // Remove ending `/`
    if ((options.removeTrailingSlash || urlObj.pathname === "/") && urlObj.hash === "") urlString = urlString.replace(/\/$/, "");
    // Restore relative protocol, if applicable
    if (hasRelativeProtocol && !options.normalizeProtocol) urlString = urlString.replace(/^http:\/\//, "//");
    // Remove http/https
    if (options.stripProtocol) urlString = urlString.replace(/^(?:https?:)?\/\//, "");
    return urlString;
};
module.exports = $3e4715efa4c85cca$var$normalizeUrl;
// TODO: Remove this for the next major release
module.exports.default = $3e4715efa4c85cca$var$normalizeUrl;

});
parcelRegister("9Zqck", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";

var $bz0YV = parcelRequire("bz0YV");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $dvMx2 = parcelRequire("dvMx2");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $dvMx2.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $bz0YV.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $dvMx2.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $dvMx2.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("bz0YV", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("dvMx2", function(module, exports) {
"use strict";

var $ftWy6 = parcelRequire("ftWy6");

var $KnGwc = parcelRequire("KnGwc");

var $92vss = parcelRequire("92vss");
module.exports = {
    formats: $92vss,
    parse: $KnGwc,
    stringify: $ftWy6
};

});
parcelRegister("ftWy6", function(module, exports) {
"use strict";

var $btSfC = parcelRequire("btSfC");

var $ikGsG = parcelRequire("ikGsG");

var $92vss = parcelRequire("92vss");
var $b456fb14c99695e9$var$has = Object.prototype.hasOwnProperty;
var $b456fb14c99695e9$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $b456fb14c99695e9$var$isArray = Array.isArray;
var $b456fb14c99695e9$var$push = Array.prototype.push;
var $b456fb14c99695e9$var$pushToArray = function(arr, valueOrArray) {
    $b456fb14c99695e9$var$push.apply(arr, $b456fb14c99695e9$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $b456fb14c99695e9$var$toISO = Date.prototype.toISOString;
var $b456fb14c99695e9$var$defaultFormat = $92vss.default;
var $b456fb14c99695e9$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $ikGsG.encode,
    encodeValuesOnly: false,
    format: $b456fb14c99695e9$var$defaultFormat,
    formatter: $92vss.formatters[$b456fb14c99695e9$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $b456fb14c99695e9$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $b456fb14c99695e9$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $b456fb14c99695e9$var$sentinel = {};
var $b456fb14c99695e9$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($b456fb14c99695e9$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($b456fb14c99695e9$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $b456fb14c99695e9$var$isArray(obj)) obj = $ikGsG.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $b456fb14c99695e9$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($b456fb14c99695e9$var$isNonNullishPrimitive(obj) || $ikGsG.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $b456fb14c99695e9$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $b456fb14c99695e9$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $b456fb14c99695e9$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $ikGsG.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($b456fb14c99695e9$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $b456fb14c99695e9$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $b456fb14c99695e9$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $b456fb14c99695e9$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $btSfC();
        valueSideChannel.set($b456fb14c99695e9$var$sentinel, sideChannel);
        $b456fb14c99695e9$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $b456fb14c99695e9$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $b456fb14c99695e9$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $b456fb14c99695e9$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $b456fb14c99695e9$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $92vss.default;
    if (typeof opts.format !== "undefined") {
        if (!$b456fb14c99695e9$var$has.call($92vss.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $92vss.formatters[format];
    var filter = $b456fb14c99695e9$var$defaults.filter;
    if (typeof opts.filter === "function" || $b456fb14c99695e9$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $b456fb14c99695e9$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $b456fb14c99695e9$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $b456fb14c99695e9$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $b456fb14c99695e9$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $b456fb14c99695e9$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $b456fb14c99695e9$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $b456fb14c99695e9$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $b456fb14c99695e9$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $b456fb14c99695e9$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $b456fb14c99695e9$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $b456fb14c99695e9$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $b456fb14c99695e9$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $b456fb14c99695e9$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $b456fb14c99695e9$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $b456fb14c99695e9$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($b456fb14c99695e9$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $b456fb14c99695e9$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $btSfC();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $b456fb14c99695e9$var$pushToArray(keys, $b456fb14c99695e9$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("btSfC", function(module, exports) {
"use strict";

var $joxVa = parcelRequire("joxVa");

var $475LV = parcelRequire("475LV");

var $LLMrp = parcelRequire("LLMrp");

var $bj2CC = parcelRequire("bj2CC");
var $85bc7c431baf92aa$var$$WeakMap = $joxVa("%WeakMap%", true);
var $85bc7c431baf92aa$var$$Map = $joxVa("%Map%", true);
var $85bc7c431baf92aa$var$$weakMapGet = $475LV("WeakMap.prototype.get", true);
var $85bc7c431baf92aa$var$$weakMapSet = $475LV("WeakMap.prototype.set", true);
var $85bc7c431baf92aa$var$$weakMapHas = $475LV("WeakMap.prototype.has", true);
var $85bc7c431baf92aa$var$$mapGet = $475LV("Map.prototype.get", true);
var $85bc7c431baf92aa$var$$mapSet = $475LV("Map.prototype.set", true);
var $85bc7c431baf92aa$var$$mapHas = $475LV("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $85bc7c431baf92aa$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $85bc7c431baf92aa$var$listGet = function(objects, key) {
    var node = $85bc7c431baf92aa$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $85bc7c431baf92aa$var$listSet = function(objects, key, value) {
    var node = $85bc7c431baf92aa$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $85bc7c431baf92aa$var$listHas = function(objects, key) {
    return !!$85bc7c431baf92aa$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $bj2CC("Side channel does not contain " + $LLMrp(key));
        },
        get: function(key) {
            if ($85bc7c431baf92aa$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $85bc7c431baf92aa$var$$weakMapGet($wm, key);
            } else if ($85bc7c431baf92aa$var$$Map) {
                if ($m) return $85bc7c431baf92aa$var$$mapGet($m, key);
            } else {
                if ($o) return $85bc7c431baf92aa$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($85bc7c431baf92aa$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $85bc7c431baf92aa$var$$weakMapHas($wm, key);
            } else if ($85bc7c431baf92aa$var$$Map) {
                if ($m) return $85bc7c431baf92aa$var$$mapHas($m, key);
            } else {
                if ($o) return $85bc7c431baf92aa$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($85bc7c431baf92aa$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $85bc7c431baf92aa$var$$WeakMap();
                $85bc7c431baf92aa$var$$weakMapSet($wm, key, value);
            } else if ($85bc7c431baf92aa$var$$Map) {
                if (!$m) $m = new $85bc7c431baf92aa$var$$Map();
                $85bc7c431baf92aa$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $85bc7c431baf92aa$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("joxVa", function(module, exports) {
"use strict";
var $e1ea923eb6892485$var$undefined1;

var $atnQV = parcelRequire("atnQV");

var $aDHOl = parcelRequire("aDHOl");

var $bPRSa = parcelRequire("bPRSa");

var $75SiM = parcelRequire("75SiM");

var $a70Dd = parcelRequire("a70Dd");

var $bj2CC = parcelRequire("bj2CC");

var $esSQ0 = parcelRequire("esSQ0");
var $e1ea923eb6892485$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $e1ea923eb6892485$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $e1ea923eb6892485$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $e1ea923eb6892485$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($e1ea923eb6892485$var$$gOPD) try {
    $e1ea923eb6892485$var$$gOPD({}, "");
} catch (e) {
    $e1ea923eb6892485$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $e1ea923eb6892485$var$throwTypeError = function() {
    throw new $bj2CC();
};
var $e1ea923eb6892485$var$ThrowTypeError = $e1ea923eb6892485$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $e1ea923eb6892485$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $e1ea923eb6892485$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $e1ea923eb6892485$var$throwTypeError;
        }
    }
}() : $e1ea923eb6892485$var$throwTypeError;

var $e1ea923eb6892485$var$hasSymbols = (parcelRequire("c3lz9"))();

var $e1ea923eb6892485$var$hasProto = (parcelRequire("8NsyZ"))();
var $e1ea923eb6892485$var$getProto = Object.getPrototypeOf || ($e1ea923eb6892485$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $e1ea923eb6892485$var$needsEval = {};
var $e1ea923eb6892485$var$TypedArray = typeof Uint8Array === "undefined" || !$e1ea923eb6892485$var$getProto ? undefined : $e1ea923eb6892485$var$getProto(Uint8Array);
var $e1ea923eb6892485$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $e1ea923eb6892485$var$hasSymbols && $e1ea923eb6892485$var$getProto ? $e1ea923eb6892485$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $e1ea923eb6892485$var$needsEval,
    "%AsyncGenerator%": $e1ea923eb6892485$var$needsEval,
    "%AsyncGeneratorFunction%": $e1ea923eb6892485$var$needsEval,
    "%AsyncIteratorPrototype%": $e1ea923eb6892485$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $atnQV,
    "%eval%": eval,
    "%EvalError%": $aDHOl,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $e1ea923eb6892485$var$$Function,
    "%GeneratorFunction%": $e1ea923eb6892485$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $e1ea923eb6892485$var$hasSymbols && $e1ea923eb6892485$var$getProto ? $e1ea923eb6892485$var$getProto($e1ea923eb6892485$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$e1ea923eb6892485$var$hasSymbols || !$e1ea923eb6892485$var$getProto ? undefined : $e1ea923eb6892485$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $bPRSa,
    "%ReferenceError%": $75SiM,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$e1ea923eb6892485$var$hasSymbols || !$e1ea923eb6892485$var$getProto ? undefined : $e1ea923eb6892485$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $e1ea923eb6892485$var$hasSymbols && $e1ea923eb6892485$var$getProto ? $e1ea923eb6892485$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $e1ea923eb6892485$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $a70Dd,
    "%ThrowTypeError%": $e1ea923eb6892485$var$ThrowTypeError,
    "%TypedArray%": $e1ea923eb6892485$var$TypedArray,
    "%TypeError%": $bj2CC,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $esSQ0,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($e1ea923eb6892485$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $e1ea923eb6892485$var$errorProto = $e1ea923eb6892485$var$getProto($e1ea923eb6892485$var$getProto(e));
    $e1ea923eb6892485$var$INTRINSICS["%Error.prototype%"] = $e1ea923eb6892485$var$errorProto;
}
var $e1ea923eb6892485$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $e1ea923eb6892485$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $e1ea923eb6892485$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $e1ea923eb6892485$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $e1ea923eb6892485$var$getProto) value = $e1ea923eb6892485$var$getProto(gen.prototype);
    }
    $e1ea923eb6892485$var$INTRINSICS[name] = value;
    return value;
};
var $e1ea923eb6892485$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $cHPAD = parcelRequire("cHPAD");

var $7xxge = parcelRequire("7xxge");
var $e1ea923eb6892485$var$$concat = $cHPAD.call(Function.call, Array.prototype.concat);
var $e1ea923eb6892485$var$$spliceApply = $cHPAD.call(Function.apply, Array.prototype.splice);
var $e1ea923eb6892485$var$$replace = $cHPAD.call(Function.call, String.prototype.replace);
var $e1ea923eb6892485$var$$strSlice = $cHPAD.call(Function.call, String.prototype.slice);
var $e1ea923eb6892485$var$$exec = $cHPAD.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $e1ea923eb6892485$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $e1ea923eb6892485$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $e1ea923eb6892485$var$stringToPath = function stringToPath(string) {
    var first = $e1ea923eb6892485$var$$strSlice(string, 0, 1);
    var last = $e1ea923eb6892485$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $a70Dd("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $a70Dd("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $e1ea923eb6892485$var$$replace(string, $e1ea923eb6892485$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $e1ea923eb6892485$var$$replace(subString, $e1ea923eb6892485$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $e1ea923eb6892485$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7xxge($e1ea923eb6892485$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $e1ea923eb6892485$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($7xxge($e1ea923eb6892485$var$INTRINSICS, intrinsicName)) {
        var value = $e1ea923eb6892485$var$INTRINSICS[intrinsicName];
        if (value === $e1ea923eb6892485$var$needsEval) value = $e1ea923eb6892485$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $bj2CC("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $a70Dd("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $bj2CC("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $bj2CC('"allowMissing" argument must be a boolean');
    if ($e1ea923eb6892485$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $a70Dd("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $e1ea923eb6892485$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $e1ea923eb6892485$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $e1ea923eb6892485$var$$spliceApply(parts, $e1ea923eb6892485$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $e1ea923eb6892485$var$$strSlice(part, 0, 1);
        var last = $e1ea923eb6892485$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $a70Dd("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($7xxge($e1ea923eb6892485$var$INTRINSICS, intrinsicRealName)) value = $e1ea923eb6892485$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $bj2CC("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($e1ea923eb6892485$var$$gOPD && i + 1 >= parts.length) {
                var desc = $e1ea923eb6892485$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7xxge(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $e1ea923eb6892485$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("atnQV", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("aDHOl", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("bPRSa", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("75SiM", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("a70Dd", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("bj2CC", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("esSQ0", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("c3lz9", function(module, exports) {
"use strict";
var $8c667e65393ea3b8$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $6D3Fl = parcelRequire("6D3Fl");
module.exports = function hasNativeSymbols() {
    if (typeof $8c667e65393ea3b8$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $8c667e65393ea3b8$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $6D3Fl();
};

});
parcelRegister("6D3Fl", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("8NsyZ", function(module, exports) {
"use strict";
var $66790e6d8d3ad189$var$test = {
    __proto__: null,
    foo: {}
};
var $66790e6d8d3ad189$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $66790e6d8d3ad189$var$test
    }).foo === $66790e6d8d3ad189$var$test.foo && !($66790e6d8d3ad189$var$test instanceof $66790e6d8d3ad189$var$$Object);
};

});

parcelRegister("cHPAD", function(module, exports) {
"use strict";

var $5shbP = parcelRequire("5shbP");
module.exports = Function.prototype.bind || $5shbP;

});
parcelRegister("5shbP", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $3f8ce6d046d3cd0c$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $3f8ce6d046d3cd0c$var$toStr = Object.prototype.toString;
var $3f8ce6d046d3cd0c$var$max = Math.max;
var $3f8ce6d046d3cd0c$var$funcType = "[object Function]";
var $3f8ce6d046d3cd0c$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $3f8ce6d046d3cd0c$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $3f8ce6d046d3cd0c$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $3f8ce6d046d3cd0c$var$toStr.apply(target) !== $3f8ce6d046d3cd0c$var$funcType) throw new TypeError($3f8ce6d046d3cd0c$var$ERROR_MESSAGE + target);
    var args = $3f8ce6d046d3cd0c$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $3f8ce6d046d3cd0c$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $3f8ce6d046d3cd0c$var$concatty(args, arguments));
    };
    var boundLength = $3f8ce6d046d3cd0c$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $3f8ce6d046d3cd0c$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("7xxge", function(module, exports) {
"use strict";
var $57d56a5f48ee3b29$var$call = Function.prototype.call;
var $57d56a5f48ee3b29$var$$hasOwn = Object.prototype.hasOwnProperty;

var $cHPAD = parcelRequire("cHPAD");
/** @type {import('.')} */ module.exports = $cHPAD.call($57d56a5f48ee3b29$var$call, $57d56a5f48ee3b29$var$$hasOwn);

});


parcelRegister("475LV", function(module, exports) {
"use strict";

var $joxVa = parcelRequire("joxVa");

var $94ZMB = parcelRequire("94ZMB");
var $2fec4b1725b37ff4$var$$indexOf = $94ZMB($joxVa("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $joxVa(name, !!allowMissing);
    if (typeof intrinsic === "function" && $2fec4b1725b37ff4$var$$indexOf(name, ".prototype.") > -1) return $94ZMB(intrinsic);
    return intrinsic;
};

});
parcelRegister("94ZMB", function(module, exports) {
"use strict";

var $cHPAD = parcelRequire("cHPAD");

var $joxVa = parcelRequire("joxVa");

var $1jeHN = parcelRequire("1jeHN");

var $bj2CC = parcelRequire("bj2CC");
var $69c46999d85413df$var$$apply = $joxVa("%Function.prototype.apply%");
var $69c46999d85413df$var$$call = $joxVa("%Function.prototype.call%");
var $69c46999d85413df$var$$reflectApply = $joxVa("%Reflect.apply%", true) || $cHPAD.call($69c46999d85413df$var$$call, $69c46999d85413df$var$$apply);

var $hMEtL = parcelRequire("hMEtL");
var $69c46999d85413df$var$$max = $joxVa("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $bj2CC("a function is required");
    var func = $69c46999d85413df$var$$reflectApply($cHPAD, $69c46999d85413df$var$$call, arguments);
    return $1jeHN(func, 1 + $69c46999d85413df$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $69c46999d85413df$var$applyBind = function applyBind() {
    return $69c46999d85413df$var$$reflectApply($cHPAD, $69c46999d85413df$var$$apply, arguments);
};
if ($hMEtL) $hMEtL(module.exports, "apply", {
    value: $69c46999d85413df$var$applyBind
});
else module.exports.apply = $69c46999d85413df$var$applyBind;

});
parcelRegister("1jeHN", function(module, exports) {
"use strict";

var $joxVa = parcelRequire("joxVa");

var $fOlM5 = parcelRequire("fOlM5");

var $0f42f8f6b5a7ff5e$var$hasDescriptors = (parcelRequire("cgrV5"))();

var $a4peS = parcelRequire("a4peS");

var $bj2CC = parcelRequire("bj2CC");
var $0f42f8f6b5a7ff5e$var$$floor = $joxVa("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $bj2CC("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $0f42f8f6b5a7ff5e$var$$floor(length) !== length) throw new $bj2CC("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $a4peS) {
        var desc = $a4peS(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($0f42f8f6b5a7ff5e$var$hasDescriptors) $fOlM5(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $fOlM5(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("fOlM5", function(module, exports) {
"use strict";

var $hMEtL = parcelRequire("hMEtL");

var $a70Dd = parcelRequire("a70Dd");

var $bj2CC = parcelRequire("bj2CC");

var $a4peS = parcelRequire("a4peS");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $bj2CC("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $bj2CC("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $bj2CC("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $bj2CC("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $bj2CC("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $bj2CC("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$a4peS && $a4peS(obj, property);
    if ($hMEtL) $hMEtL(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $a70Dd("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("hMEtL", function(module, exports) {
"use strict";

var $joxVa = parcelRequire("joxVa");
/** @type {import('.')} */ var $cf2651aa915f9918$var$$defineProperty = $joxVa("%Object.defineProperty%", true) || false;
if ($cf2651aa915f9918$var$$defineProperty) try {
    $cf2651aa915f9918$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $cf2651aa915f9918$var$$defineProperty = false;
}
module.exports = $cf2651aa915f9918$var$$defineProperty;

});

parcelRegister("a4peS", function(module, exports) {
"use strict";

var $joxVa = parcelRequire("joxVa");
var $754ddb0ae5ff9adf$var$$gOPD = $joxVa("%Object.getOwnPropertyDescriptor%", true);
if ($754ddb0ae5ff9adf$var$$gOPD) try {
    $754ddb0ae5ff9adf$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $754ddb0ae5ff9adf$var$$gOPD = null;
}
module.exports = $754ddb0ae5ff9adf$var$$gOPD;

});


parcelRegister("cgrV5", function(module, exports) {
"use strict";

var $hMEtL = parcelRequire("hMEtL");
var $8edca2f1206abdc3$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$hMEtL;
};
$8edca2f1206abdc3$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$hMEtL) return null;
    try {
        return $hMEtL([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $8edca2f1206abdc3$var$hasPropertyDescriptors;

});




parcelRegister("LLMrp", function(module, exports) {
var $08f9741316e985b2$var$hasMap = typeof Map === "function" && Map.prototype;
var $08f9741316e985b2$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $08f9741316e985b2$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $08f9741316e985b2$var$mapSize = $08f9741316e985b2$var$hasMap && $08f9741316e985b2$var$mapSizeDescriptor && typeof $08f9741316e985b2$var$mapSizeDescriptor.get === "function" ? $08f9741316e985b2$var$mapSizeDescriptor.get : null;
var $08f9741316e985b2$var$mapForEach = $08f9741316e985b2$var$hasMap && Map.prototype.forEach;
var $08f9741316e985b2$var$hasSet = typeof Set === "function" && Set.prototype;
var $08f9741316e985b2$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $08f9741316e985b2$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $08f9741316e985b2$var$setSize = $08f9741316e985b2$var$hasSet && $08f9741316e985b2$var$setSizeDescriptor && typeof $08f9741316e985b2$var$setSizeDescriptor.get === "function" ? $08f9741316e985b2$var$setSizeDescriptor.get : null;
var $08f9741316e985b2$var$setForEach = $08f9741316e985b2$var$hasSet && Set.prototype.forEach;
var $08f9741316e985b2$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $08f9741316e985b2$var$weakMapHas = $08f9741316e985b2$var$hasWeakMap ? WeakMap.prototype.has : null;
var $08f9741316e985b2$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $08f9741316e985b2$var$weakSetHas = $08f9741316e985b2$var$hasWeakSet ? WeakSet.prototype.has : null;
var $08f9741316e985b2$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $08f9741316e985b2$var$weakRefDeref = $08f9741316e985b2$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $08f9741316e985b2$var$booleanValueOf = Boolean.prototype.valueOf;
var $08f9741316e985b2$var$objectToString = Object.prototype.toString;
var $08f9741316e985b2$var$functionToString = Function.prototype.toString;
var $08f9741316e985b2$var$$match = String.prototype.match;
var $08f9741316e985b2$var$$slice = String.prototype.slice;
var $08f9741316e985b2$var$$replace = String.prototype.replace;
var $08f9741316e985b2$var$$toUpperCase = String.prototype.toUpperCase;
var $08f9741316e985b2$var$$toLowerCase = String.prototype.toLowerCase;
var $08f9741316e985b2$var$$test = RegExp.prototype.test;
var $08f9741316e985b2$var$$concat = Array.prototype.concat;
var $08f9741316e985b2$var$$join = Array.prototype.join;
var $08f9741316e985b2$var$$arrSlice = Array.prototype.slice;
var $08f9741316e985b2$var$$floor = Math.floor;
var $08f9741316e985b2$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $08f9741316e985b2$var$gOPS = Object.getOwnPropertySymbols;
var $08f9741316e985b2$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $08f9741316e985b2$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $08f9741316e985b2$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $08f9741316e985b2$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $08f9741316e985b2$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $08f9741316e985b2$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $08f9741316e985b2$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $08f9741316e985b2$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$08f9741316e985b2$var$$floor(-num) : $08f9741316e985b2$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $08f9741316e985b2$var$$slice.call(str, intStr.length + 1);
            return $08f9741316e985b2$var$$replace.call(intStr, sepRegex, "$&_") + "." + $08f9741316e985b2$var$$replace.call($08f9741316e985b2$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $08f9741316e985b2$var$$replace.call(str, sepRegex, "$&_");
}

var $do2nr = parcelRequire("do2nr");
var $08f9741316e985b2$var$inspectCustom = $do2nr.custom;
var $08f9741316e985b2$var$inspectSymbol = $08f9741316e985b2$var$isSymbol($08f9741316e985b2$var$inspectCustom) ? $08f9741316e985b2$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($08f9741316e985b2$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($08f9741316e985b2$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $08f9741316e985b2$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($08f9741316e985b2$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($08f9741316e985b2$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $08f9741316e985b2$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $08f9741316e985b2$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $08f9741316e985b2$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $08f9741316e985b2$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $08f9741316e985b2$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($08f9741316e985b2$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $08f9741316e985b2$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($08f9741316e985b2$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$08f9741316e985b2$var$isRegExp(obj)) {
        var name = $08f9741316e985b2$var$nameOf(obj);
        var keys = $08f9741316e985b2$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $08f9741316e985b2$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($08f9741316e985b2$var$isSymbol(obj)) {
        var symString = $08f9741316e985b2$var$hasShammedSymbols ? $08f9741316e985b2$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $08f9741316e985b2$var$symToString.call(obj);
        return typeof obj === "object" && !$08f9741316e985b2$var$hasShammedSymbols ? $08f9741316e985b2$var$markBoxed(symString) : symString;
    }
    if ($08f9741316e985b2$var$isElement(obj)) {
        var s = "<" + $08f9741316e985b2$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $08f9741316e985b2$var$wrapQuotes($08f9741316e985b2$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $08f9741316e985b2$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($08f9741316e985b2$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $08f9741316e985b2$var$arrObjKeys(obj, inspect);
        if (indent && !$08f9741316e985b2$var$singleLineValues(xs)) return "[" + $08f9741316e985b2$var$indentedJoin(xs, indent) + "]";
        return "[ " + $08f9741316e985b2$var$$join.call(xs, ", ") + " ]";
    }
    if ($08f9741316e985b2$var$isError(obj)) {
        var parts = $08f9741316e985b2$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$08f9741316e985b2$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $08f9741316e985b2$var$$join.call($08f9741316e985b2$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $08f9741316e985b2$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($08f9741316e985b2$var$inspectSymbol && typeof obj[$08f9741316e985b2$var$inspectSymbol] === "function" && $do2nr) return $do2nr(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($08f9741316e985b2$var$isMap(obj)) {
        var mapParts = [];
        if ($08f9741316e985b2$var$mapForEach) $08f9741316e985b2$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $08f9741316e985b2$var$collectionOf("Map", $08f9741316e985b2$var$mapSize.call(obj), mapParts, indent);
    }
    if ($08f9741316e985b2$var$isSet(obj)) {
        var setParts = [];
        if ($08f9741316e985b2$var$setForEach) $08f9741316e985b2$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $08f9741316e985b2$var$collectionOf("Set", $08f9741316e985b2$var$setSize.call(obj), setParts, indent);
    }
    if ($08f9741316e985b2$var$isWeakMap(obj)) return $08f9741316e985b2$var$weakCollectionOf("WeakMap");
    if ($08f9741316e985b2$var$isWeakSet(obj)) return $08f9741316e985b2$var$weakCollectionOf("WeakSet");
    if ($08f9741316e985b2$var$isWeakRef(obj)) return $08f9741316e985b2$var$weakCollectionOf("WeakRef");
    if ($08f9741316e985b2$var$isNumber(obj)) return $08f9741316e985b2$var$markBoxed(inspect(Number(obj)));
    if ($08f9741316e985b2$var$isBigInt(obj)) return $08f9741316e985b2$var$markBoxed(inspect($08f9741316e985b2$var$bigIntValueOf.call(obj)));
    if ($08f9741316e985b2$var$isBoolean(obj)) return $08f9741316e985b2$var$markBoxed($08f9741316e985b2$var$booleanValueOf.call(obj));
    if ($08f9741316e985b2$var$isString(obj)) return $08f9741316e985b2$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$08f9741316e985b2$var$isDate(obj) && !$08f9741316e985b2$var$isRegExp(obj)) {
        var ys = $08f9741316e985b2$var$arrObjKeys(obj, inspect);
        var isPlainObject = $08f9741316e985b2$var$gPO ? $08f9741316e985b2$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $08f9741316e985b2$var$toStringTag && Object(obj) === obj && $08f9741316e985b2$var$toStringTag in obj ? $08f9741316e985b2$var$$slice.call($08f9741316e985b2$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $08f9741316e985b2$var$$join.call($08f9741316e985b2$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $08f9741316e985b2$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $08f9741316e985b2$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $08f9741316e985b2$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $08f9741316e985b2$var$quote(s) {
    return $08f9741316e985b2$var$$replace.call(String(s), /"/g, "&quot;");
}
function $08f9741316e985b2$var$isArray(obj) {
    return $08f9741316e985b2$var$toStr(obj) === "[object Array]" && (!$08f9741316e985b2$var$toStringTag || !(typeof obj === "object" && $08f9741316e985b2$var$toStringTag in obj));
}
function $08f9741316e985b2$var$isDate(obj) {
    return $08f9741316e985b2$var$toStr(obj) === "[object Date]" && (!$08f9741316e985b2$var$toStringTag || !(typeof obj === "object" && $08f9741316e985b2$var$toStringTag in obj));
}
function $08f9741316e985b2$var$isRegExp(obj) {
    return $08f9741316e985b2$var$toStr(obj) === "[object RegExp]" && (!$08f9741316e985b2$var$toStringTag || !(typeof obj === "object" && $08f9741316e985b2$var$toStringTag in obj));
}
function $08f9741316e985b2$var$isError(obj) {
    return $08f9741316e985b2$var$toStr(obj) === "[object Error]" && (!$08f9741316e985b2$var$toStringTag || !(typeof obj === "object" && $08f9741316e985b2$var$toStringTag in obj));
}
function $08f9741316e985b2$var$isString(obj) {
    return $08f9741316e985b2$var$toStr(obj) === "[object String]" && (!$08f9741316e985b2$var$toStringTag || !(typeof obj === "object" && $08f9741316e985b2$var$toStringTag in obj));
}
function $08f9741316e985b2$var$isNumber(obj) {
    return $08f9741316e985b2$var$toStr(obj) === "[object Number]" && (!$08f9741316e985b2$var$toStringTag || !(typeof obj === "object" && $08f9741316e985b2$var$toStringTag in obj));
}
function $08f9741316e985b2$var$isBoolean(obj) {
    return $08f9741316e985b2$var$toStr(obj) === "[object Boolean]" && (!$08f9741316e985b2$var$toStringTag || !(typeof obj === "object" && $08f9741316e985b2$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $08f9741316e985b2$var$isSymbol(obj) {
    if ($08f9741316e985b2$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$08f9741316e985b2$var$symToString) return false;
    try {
        $08f9741316e985b2$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $08f9741316e985b2$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$08f9741316e985b2$var$bigIntValueOf) return false;
    try {
        $08f9741316e985b2$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $08f9741316e985b2$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $08f9741316e985b2$var$has(obj, key) {
    return $08f9741316e985b2$var$hasOwn.call(obj, key);
}
function $08f9741316e985b2$var$toStr(obj) {
    return $08f9741316e985b2$var$objectToString.call(obj);
}
function $08f9741316e985b2$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $08f9741316e985b2$var$$match.call($08f9741316e985b2$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $08f9741316e985b2$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $08f9741316e985b2$var$isMap(x) {
    if (!$08f9741316e985b2$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $08f9741316e985b2$var$mapSize.call(x);
        try {
            $08f9741316e985b2$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $08f9741316e985b2$var$isWeakMap(x) {
    if (!$08f9741316e985b2$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $08f9741316e985b2$var$weakMapHas.call(x, $08f9741316e985b2$var$weakMapHas);
        try {
            $08f9741316e985b2$var$weakSetHas.call(x, $08f9741316e985b2$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $08f9741316e985b2$var$isWeakRef(x) {
    if (!$08f9741316e985b2$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $08f9741316e985b2$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $08f9741316e985b2$var$isSet(x) {
    if (!$08f9741316e985b2$var$setSize || !x || typeof x !== "object") return false;
    try {
        $08f9741316e985b2$var$setSize.call(x);
        try {
            $08f9741316e985b2$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $08f9741316e985b2$var$isWeakSet(x) {
    if (!$08f9741316e985b2$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $08f9741316e985b2$var$weakSetHas.call(x, $08f9741316e985b2$var$weakSetHas);
        try {
            $08f9741316e985b2$var$weakMapHas.call(x, $08f9741316e985b2$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $08f9741316e985b2$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $08f9741316e985b2$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $08f9741316e985b2$var$inspectString($08f9741316e985b2$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $08f9741316e985b2$var$$replace.call($08f9741316e985b2$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $08f9741316e985b2$var$lowbyte);
    return $08f9741316e985b2$var$wrapQuotes(s, "single", opts);
}
function $08f9741316e985b2$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $08f9741316e985b2$var$$toUpperCase.call(n.toString(16));
}
function $08f9741316e985b2$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $08f9741316e985b2$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $08f9741316e985b2$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $08f9741316e985b2$var$indentedJoin(entries, indent) : $08f9741316e985b2$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $08f9741316e985b2$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($08f9741316e985b2$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $08f9741316e985b2$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $08f9741316e985b2$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $08f9741316e985b2$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $08f9741316e985b2$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $08f9741316e985b2$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $08f9741316e985b2$var$arrObjKeys(obj, inspect) {
    var isArr = $08f9741316e985b2$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $08f9741316e985b2$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $08f9741316e985b2$var$gOPS === "function" ? $08f9741316e985b2$var$gOPS(obj) : [];
    var symMap;
    if ($08f9741316e985b2$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$08f9741316e985b2$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($08f9741316e985b2$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($08f9741316e985b2$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $08f9741316e985b2$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($08f9741316e985b2$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("do2nr", function(module, exports) {
"use strict";

});



parcelRegister("ikGsG", function(module, exports) {
"use strict";

var $92vss = parcelRequire("92vss");
var $d58b083f7176aca2$var$has = Object.prototype.hasOwnProperty;
var $d58b083f7176aca2$var$isArray = Array.isArray;
var $d58b083f7176aca2$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $d58b083f7176aca2$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d58b083f7176aca2$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d58b083f7176aca2$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $d58b083f7176aca2$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($d58b083f7176aca2$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$d58b083f7176aca2$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($d58b083f7176aca2$var$isArray(target) && !$d58b083f7176aca2$var$isArray(source)) mergeTarget = $d58b083f7176aca2$var$arrayToObject(target, options);
    if ($d58b083f7176aca2$var$isArray(target) && $d58b083f7176aca2$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d58b083f7176aca2$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d58b083f7176aca2$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d58b083f7176aca2$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d58b083f7176aca2$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d58b083f7176aca2$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $d58b083f7176aca2$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $d58b083f7176aca2$var$limit){
        var segment = string.length >= $d58b083f7176aca2$var$limit ? string.slice(j, j + $d58b083f7176aca2$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $92vss.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $d58b083f7176aca2$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $d58b083f7176aca2$var$hexTable[0xC0 | c >> 6] + $d58b083f7176aca2$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $d58b083f7176aca2$var$hexTable[0xE0 | c >> 12] + $d58b083f7176aca2$var$hexTable[0x80 | c >> 6 & 0x3F] + $d58b083f7176aca2$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $d58b083f7176aca2$var$hexTable[0xF0 | c >> 18] + $d58b083f7176aca2$var$hexTable[0x80 | c >> 12 & 0x3F] + $d58b083f7176aca2$var$hexTable[0x80 | c >> 6 & 0x3F] + $d58b083f7176aca2$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $d58b083f7176aca2$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d58b083f7176aca2$var$compactQueue(queue);
    return value;
};
var $d58b083f7176aca2$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $d58b083f7176aca2$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d58b083f7176aca2$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $d58b083f7176aca2$var$maybeMap = function maybeMap(val, fn) {
    if ($d58b083f7176aca2$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $d58b083f7176aca2$var$arrayToObject,
    assign: $d58b083f7176aca2$var$assign,
    combine: $d58b083f7176aca2$var$combine,
    compact: $d58b083f7176aca2$var$compact,
    decode: $d58b083f7176aca2$var$decode,
    encode: $d58b083f7176aca2$var$encode,
    isBuffer: $d58b083f7176aca2$var$isBuffer,
    isRegExp: $d58b083f7176aca2$var$isRegExp,
    maybeMap: $d58b083f7176aca2$var$maybeMap,
    merge: $d58b083f7176aca2$var$merge
};

});
parcelRegister("92vss", function(module, exports) {
"use strict";
var $694cb3db241013a8$var$replace = String.prototype.replace;
var $694cb3db241013a8$var$percentTwenties = /%20/g;
var $694cb3db241013a8$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $694cb3db241013a8$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $694cb3db241013a8$var$replace.call(value, $694cb3db241013a8$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $694cb3db241013a8$var$Format.RFC1738,
    RFC3986: $694cb3db241013a8$var$Format.RFC3986
};

});



parcelRegister("KnGwc", function(module, exports) {
"use strict";

var $ikGsG = parcelRequire("ikGsG");
var $08b6ab4bf54595f5$var$has = Object.prototype.hasOwnProperty;
var $08b6ab4bf54595f5$var$isArray = Array.isArray;
var $08b6ab4bf54595f5$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $ikGsG.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $08b6ab4bf54595f5$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $08b6ab4bf54595f5$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $08b6ab4bf54595f5$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $08b6ab4bf54595f5$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $08b6ab4bf54595f5$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $08b6ab4bf54595f5$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $08b6ab4bf54595f5$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $08b6ab4bf54595f5$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $08b6ab4bf54595f5$var$defaults.decoder, charset, "key");
            val = $ikGsG.maybeMap($08b6ab4bf54595f5$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $08b6ab4bf54595f5$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $08b6ab4bf54595f5$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $08b6ab4bf54595f5$var$isArray(val) ? [
            val
        ] : val;
        var existing = $08b6ab4bf54595f5$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $ikGsG.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $08b6ab4bf54595f5$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $08b6ab4bf54595f5$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && leaf === "" ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $08b6ab4bf54595f5$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $08b6ab4bf54595f5$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $08b6ab4bf54595f5$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $08b6ab4bf54595f5$var$parseObject(keys, val, options, valuesParsed);
};
var $08b6ab4bf54595f5$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $08b6ab4bf54595f5$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $08b6ab4bf54595f5$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $08b6ab4bf54595f5$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $08b6ab4bf54595f5$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $08b6ab4bf54595f5$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $08b6ab4bf54595f5$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $08b6ab4bf54595f5$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $08b6ab4bf54595f5$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $08b6ab4bf54595f5$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $08b6ab4bf54595f5$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $08b6ab4bf54595f5$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $08b6ab4bf54595f5$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $ikGsG.isRegExp(opts.delimiter) ? opts.delimiter : $08b6ab4bf54595f5$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $08b6ab4bf54595f5$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $08b6ab4bf54595f5$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $08b6ab4bf54595f5$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $08b6ab4bf54595f5$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $08b6ab4bf54595f5$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $08b6ab4bf54595f5$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $08b6ab4bf54595f5$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $08b6ab4bf54595f5$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $ikGsG.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $ikGsG.compact(obj);
};

});





parcelRegister("5Y5nq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4586ba123dcbfc08$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $kUnI3 = parcelRequire("kUnI3");

var $1MgBx = parcelRequire("1MgBx");

var $9U2Zv = parcelRequire("9U2Zv");
/**
 * mapDispatchToProps - used to hook up connect to action creators
 * @memberof ThumbnailCanvasGrouping
 * @private
 */ var $4586ba123dcbfc08$var$mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
    var data = _ref.data;
    return {
        setCanvas: function setCanvas() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return dispatch($kUnI3.setCanvas.apply($kUnI3, [
                data.windowId
            ].concat(args)));
        }
    };
};
/**
 * mapStateToProps - used to hook up state to props
 * @memberof ThumbnailCanvasGrouping
 * @private
 */ var $4586ba123dcbfc08$var$mapStateToProps = function mapStateToProps(state, _ref2) {
    var data = _ref2.data;
    return {
        currentCanvasId: ((0, $1MgBx.getCurrentCanvas)(state, {
            windowId: data.windowId
        }) || {}).id
    };
};
/**
 * Styles for withStyles HOC
 */ var $4586ba123dcbfc08$var$styles = function styles(theme) {
    return {
        canvas: {
            "&$currentCanvas": {
                outline: "2px solid ".concat(theme.palette.primary.main),
                outlineOffset: "3px"
            },
            "&:hover": {
                outline: "9px solid ".concat(theme.palette.action.hover),
                outlineOffset: "-2px"
            },
            boxSizing: "border-box",
            color: theme.palette.common.white,
            cursor: "pointer",
            display: "inline-block",
            outline: 0,
            whiteSpace: "nowrap"
        },
        currentCanvas: {}
    };
};
var $4586ba123dcbfc08$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $7EzGR.default)($4586ba123dcbfc08$var$styles), (0, $fbonu.default)($4586ba123dcbfc08$var$mapStateToProps, $4586ba123dcbfc08$var$mapDispatchToProps), (0, $7XHRd.withPlugins)("ThumbnailCanvasGrouping"));
var $4586ba123dcbfc08$export$2e2bcd8739ae039 = $4586ba123dcbfc08$var$enhance((0, $9U2Zv.ThumbnailCanvasGrouping));

});
parcelRegister("kUnI3", function(module, exports) {
/**
 * Action Creators for Mirador
 * @namespace ActionCreators
 */ 
var $10Wbc = parcelRequire("10Wbc");

var $2H2ri = parcelRequire("2H2ri");

var $1bcju = parcelRequire("1bcju");

var $k4YEs = parcelRequire("k4YEs");

var $6PGpp = parcelRequire("6PGpp");

var $kPH0F = parcelRequire("kPH0F");

var $in9CU = parcelRequire("in9CU");

var $bcVRp = parcelRequire("bcVRp");

var $61Aec = parcelRequire("61Aec");

var $aeQGD = parcelRequire("aeQGD");

var $iACUj = parcelRequire("iACUj");

var $kQy7d = parcelRequire("kQy7d");

var $2Ux4D = parcelRequire("2Ux4D");

var $jRTT7 = parcelRequire("jRTT7");
$parcel$exportWildcard(module.exports, $10Wbc);
$parcel$exportWildcard(module.exports, $2H2ri);
$parcel$exportWildcard(module.exports, $1bcju);
$parcel$exportWildcard(module.exports, $k4YEs);
$parcel$exportWildcard(module.exports, $6PGpp);
$parcel$exportWildcard(module.exports, $kPH0F);
$parcel$exportWildcard(module.exports, $in9CU);
$parcel$exportWildcard(module.exports, $bcVRp);
$parcel$exportWildcard(module.exports, $61Aec);
$parcel$exportWildcard(module.exports, $aeQGD);
$parcel$exportWildcard(module.exports, $iACUj);
$parcel$exportWildcard(module.exports, $kQy7d);
$parcel$exportWildcard(module.exports, $2Ux4D);
$parcel$exportWildcard(module.exports, $jRTT7);

});
parcelRegister("10Wbc", function(module, exports) {

$parcel$export(module.exports, "addCompanionWindow", function () { return $0bd2ebcee6b0c362$export$4d2a8a26b6f9e3f5; });
$parcel$export(module.exports, "addOrUpdateCompanionWindow", function () { return $0bd2ebcee6b0c362$export$27c883c6c7fb7da8; });
$parcel$export(module.exports, "updateCompanionWindow", function () { return $0bd2ebcee6b0c362$export$bd5002d617c534f9; });
$parcel$export(module.exports, "removeCompanionWindow", function () { return $0bd2ebcee6b0c362$export$f780a79dfbaa88b9; });
$parcel$export(module.exports, "toggleNode", function () { return $0bd2ebcee6b0c362$export$1363736a0901ba3e; });

var $aowE3 = parcelRequire("aowE3");

var $7CtTT = parcelRequire("7CtTT");

var $24Kso = parcelRequire("24Kso");
var $dJvB2 = parcelRequire("dJvB2");
function $0bd2ebcee6b0c362$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0bd2ebcee6b0c362$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0bd2ebcee6b0c362$var$ownKeys(Object(source), true).forEach(function(key) {
            $0bd2ebcee6b0c362$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0bd2ebcee6b0c362$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0bd2ebcee6b0c362$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $0bd2ebcee6b0c362$var$defaultProps = {
    content: null,
    position: null
};
function $0bd2ebcee6b0c362$export$4d2a8a26b6f9e3f5(windowId, payload) {
    var defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0bd2ebcee6b0c362$var$defaultProps;
    var id = "cw-".concat((0, $aowE3.default)());
    return {
        id: id,
        payload: $0bd2ebcee6b0c362$var$_objectSpread($0bd2ebcee6b0c362$var$_objectSpread($0bd2ebcee6b0c362$var$_objectSpread({}, defaults), payload), {}, {
            id: id,
            windowId: windowId
        }),
        type: (0, $7CtTT.default).ADD_COMPANION_WINDOW,
        windowId: windowId
    };
}
function $0bd2ebcee6b0c362$export$27c883c6c7fb7da8(windowId, payload) {
    var defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0bd2ebcee6b0c362$var$defaultProps;
    return function(dispatch, getState) {
        var state = getState();
        var position = payload.position;
        var updatableWindowId = position === "left" && (0, $24Kso.getCompanionWindowIdsForPosition)(state, {
            position: position,
            windowId: windowId
        })[0];
        if (updatableWindowId) dispatch($0bd2ebcee6b0c362$export$bd5002d617c534f9(windowId, updatableWindowId, payload));
        else dispatch($0bd2ebcee6b0c362$export$4d2a8a26b6f9e3f5(windowId, payload, defaults));
    };
}
function $0bd2ebcee6b0c362$export$bd5002d617c534f9(windowId, id, payload) {
    return {
        id: id,
        payload: payload,
        type: (0, $7CtTT.default).UPDATE_COMPANION_WINDOW,
        windowId: windowId
    };
}
function $0bd2ebcee6b0c362$export$f780a79dfbaa88b9(windowId, id) {
    return {
        id: id,
        type: (0, $7CtTT.default).REMOVE_COMPANION_WINDOW,
        windowId: windowId
    };
}
function $0bd2ebcee6b0c362$export$1363736a0901ba3e(windowId, id, nodeId) {
    return function(dispatch, getState) {
        var state = getState();
        var collapsedNodeIds = (0, $dJvB2.getManuallyExpandedNodeIds)(state, {
            companionWindowId: id
        }, false);
        var expandedNodeIds = (0, $dJvB2.getManuallyExpandedNodeIds)(state, {
            companionWindowId: id
        }, true);
        var visibleNodeIds = (0, $dJvB2.getVisibleNodeIds)(state, {
            id: id,
            windowId: windowId
        });
        var expand = collapsedNodeIds.indexOf(nodeId) !== -1 || expandedNodeIds.indexOf(nodeId) === -1 && visibleNodeIds.indexOf(nodeId) === -1;
        return dispatch({
            id: id,
            payload: $0bd2ebcee6b0c362$var$_defineProperty({}, nodeId, {
                expanded: expand
            }),
            type: (0, $7CtTT.default).TOGGLE_TOC_NODE,
            windowId: windowId
        });
    };
}

});
parcelRegister("dJvB2", function(module, exports) {

$parcel$export(module.exports, "getVisibleNodeIds", function () { return $9ff7fcb350b294a0$export$70d73c05b45a4f79; });
$parcel$export(module.exports, "getManuallyExpandedNodeIds", function () { return $9ff7fcb350b294a0$export$850469e84cdc69fb; });
$parcel$export(module.exports, "getExpandedNodeIds", function () { return $9ff7fcb350b294a0$export$867763ec8b8397a1; });
$parcel$export(module.exports, "getNodeIdToScrollTo", function () { return $9ff7fcb350b294a0$export$8652116de6e58c2a; });
$parcel$export(module.exports, "getDefaultSidebarVariant", function () { return $9ff7fcb350b294a0$export$f275b35bcc081f89; });

var $1LbRi = parcelRequire("1LbRi");

var $gsPMN = parcelRequire("gsPMN");

var $8sxbG = parcelRequire("8sxbG");

var $a4sDT = parcelRequire("a4sDT");

var $1MgBx = parcelRequire("1MgBx");

var $24Kso = parcelRequire("24Kso");

var $51Gx5 = parcelRequire("51Gx5");
function $9ff7fcb350b294a0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9ff7fcb350b294a0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9ff7fcb350b294a0$var$ownKeys(Object(source), true).forEach(function(key) {
            $9ff7fcb350b294a0$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9ff7fcb350b294a0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9ff7fcb350b294a0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9ff7fcb350b294a0$var$_extends() {
    $9ff7fcb350b294a0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9ff7fcb350b294a0$var$_extends.apply(this, arguments);
}
function $9ff7fcb350b294a0$var$_toConsumableArray(arr) {
    return $9ff7fcb350b294a0$var$_arrayWithoutHoles(arr) || $9ff7fcb350b294a0$var$_iterableToArray(arr) || $9ff7fcb350b294a0$var$_unsupportedIterableToArray(arr) || $9ff7fcb350b294a0$var$_nonIterableSpread();
}
function $9ff7fcb350b294a0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9ff7fcb350b294a0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9ff7fcb350b294a0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9ff7fcb350b294a0$var$_arrayLikeToArray(o, minLen);
}
function $9ff7fcb350b294a0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9ff7fcb350b294a0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9ff7fcb350b294a0$var$_arrayLikeToArray(arr);
}
function $9ff7fcb350b294a0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/** */ function $9ff7fcb350b294a0$var$rangeContainsCanvasId(range, canvasId) {
    var canvasIds = range.getCanvasIds();
    for(var i = 0; i < canvasIds.length; i += 1){
        if ((0, $a4sDT.Utils).normalisedUrlsMatch(canvasIds[i], canvasId)) return true;
    }
    return false;
}
/** */ function $9ff7fcb350b294a0$var$getAllParentIds(node) {
    if (node.parentNode === undefined) return [];
    if (node.parentNode.parentNode === undefined) return [
        node.parentNode.id
    ];
    return [].concat($9ff7fcb350b294a0$var$_toConsumableArray($9ff7fcb350b294a0$var$getAllParentIds(node.parentNode)), [
        node.parentNode.id
    ]);
}
/** */ function $9ff7fcb350b294a0$var$getVisibleNodeIdsInSubTree(nodes, canvasIds) {
    return nodes.reduce(function(nodeIdAcc, node) {
        var result = [];
        result.push.apply(result, $9ff7fcb350b294a0$var$_toConsumableArray(nodeIdAcc));
        var nodeContainsVisibleCanvas = canvasIds.reduce(function(acc, canvasId) {
            return acc || $9ff7fcb350b294a0$var$rangeContainsCanvasId(node.data, canvasId);
        }, false);
        var subTreeVisibleNodeIds = node.nodes.length > 0 ? $9ff7fcb350b294a0$var$getVisibleNodeIdsInSubTree(node.nodes, canvasIds) : [];
        result.push.apply(result, $9ff7fcb350b294a0$var$_toConsumableArray(subTreeVisibleNodeIds));
        if (nodeContainsVisibleCanvas || subTreeVisibleNodeIds.length > 0) result.push({
            containsVisibleCanvas: nodeContainsVisibleCanvas,
            descendantsContainVisibleCanvas: subTreeVisibleNodeIds.length > 0,
            id: node.id,
            leaf: node.nodes.length === 0,
            parentIds: $9ff7fcb350b294a0$var$getAllParentIds(node)
        });
        return result;
    }, []);
}
/** */ var $9ff7fcb350b294a0$var$getVisibleLeafAndBranchNodeIds = (0, $1LbRi.createSelector)([
    (0, $51Gx5.getSequenceTreeStructure),
    (0, $1MgBx.getVisibleCanvasIds)
], function(tree, canvasIds) {
    if (canvasIds.length === 0 || !tree) return [];
    return $9ff7fcb350b294a0$var$getVisibleNodeIdsInSubTree(tree.nodes, canvasIds);
});
var $9ff7fcb350b294a0$export$70d73c05b45a4f79 = (0, $1LbRi.createSelector)([
    $9ff7fcb350b294a0$var$getVisibleLeafAndBranchNodeIds
], function(visibleLeafAndBranchNodeIds) {
    return visibleLeafAndBranchNodeIds.map(function(item) {
        return item.id;
    });
});
var $9ff7fcb350b294a0$var$getVisibleBranchNodeIds = (0, $1LbRi.createSelector)([
    $9ff7fcb350b294a0$var$getVisibleLeafAndBranchNodeIds
], function(visibleLeafAndBranchNodeIds) {
    return visibleLeafAndBranchNodeIds.reduce(function(acc, item) {
        return item.leaf || !item.descendantsContainVisibleCanvas ? acc : [].concat($9ff7fcb350b294a0$var$_toConsumableArray(acc), [
            item.id
        ]);
    }, []);
});
var $9ff7fcb350b294a0$var$getCanvasContainingNodeIds = (0, $1LbRi.createSelector)([
    $9ff7fcb350b294a0$var$getVisibleLeafAndBranchNodeIds
], function(visibleLeafAndBranchNodeIds) {
    return visibleLeafAndBranchNodeIds.reduce(function(acc, item) {
        return item.containsVisibleCanvas ? [].concat($9ff7fcb350b294a0$var$_toConsumableArray(acc), [
            item
        ]) : acc;
    }, []);
});
function $9ff7fcb350b294a0$export$850469e84cdc69fb(state, _ref, expanded) {
    var companionWindowId = _ref.companionWindowId;
    var companionWindow = (0, $24Kso.getCompanionWindow)(state, {
        companionWindowId: companionWindowId
    });
    return companionWindow.tocNodes ? Object.keys(companionWindow.tocNodes).reduce(function(acc, nodeId) {
        return companionWindow.tocNodes[nodeId].expanded === expanded ? [].concat($9ff7fcb350b294a0$var$_toConsumableArray(acc), [
            nodeId
        ]) : acc;
    }, []) : [];
}
function $9ff7fcb350b294a0$export$867763ec8b8397a1(state, _ref2) {
    var companionWindowId = _ref2.companionWindowId, windowId = _ref2.windowId;
    var visibleBranchNodeIds = $9ff7fcb350b294a0$var$getVisibleBranchNodeIds(state, {
        companionWindowId: companionWindowId,
        windowId: windowId
    });
    var manuallyExpandedNodeIds = $9ff7fcb350b294a0$export$850469e84cdc69fb(state, {
        companionWindowId: companionWindowId
    }, true);
    var manuallyClosedNodeIds = $9ff7fcb350b294a0$export$850469e84cdc69fb(state, {
        companionWindowId: companionWindowId
    }, false);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8sxbG))).apply(void 0, [
        (0, (/*@__PURE__*/$parcel$interopDefault($gsPMN)))(manuallyExpandedNodeIds, visibleBranchNodeIds)
    ].concat($9ff7fcb350b294a0$var$_toConsumableArray(manuallyClosedNodeIds)));
}
function $9ff7fcb350b294a0$export$8652116de6e58c2a(state, _ref3) {
    var args = $9ff7fcb350b294a0$var$_extends({}, _ref3);
    var canvasContainingNodeIds = $9ff7fcb350b294a0$var$getCanvasContainingNodeIds(state, $9ff7fcb350b294a0$var$_objectSpread({}, args));
    var collapsedNodeIds = $9ff7fcb350b294a0$export$850469e84cdc69fb(state, args, false);
    if (canvasContainingNodeIds && canvasContainingNodeIds.length > 0) {
        for(var i = 0; i < canvasContainingNodeIds[0].parentIds.length; i += 1){
            if (collapsedNodeIds.indexOf(canvasContainingNodeIds[0].parentIds[i]) !== -1) return canvasContainingNodeIds[0].parentIds[i];
        }
        return canvasContainingNodeIds[0].id;
    }
    return null;
}
var $9ff7fcb350b294a0$export$f275b35bcc081f89 = (0, $1LbRi.createSelector)([
    (0, $51Gx5.getSequenceTreeStructure)
], function(tree) {
    return tree && tree.nodes && tree.nodes.length > 0 ? "tableOfContents" : "item";
});

});
parcelRegister("gsPMN", function(module, exports) {

var $l83Sq = parcelRequire("l83Sq");

var $4sIyf = parcelRequire("4sIyf");

var $LRL4h = parcelRequire("LRL4h");

var $dxIjI = parcelRequire("dxIjI");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $bfc76e7e782e4cd0$var$union = $4sIyf(function(arrays) {
    return $LRL4h($l83Sq(arrays, 1, $dxIjI, true));
});
module.exports = $bfc76e7e782e4cd0$var$union;

});
parcelRegister("4sIyf", function(module, exports) {

var $l0EzR = parcelRequire("l0EzR");

var $86CUP = parcelRequire("86CUP");

var $kn1gs = parcelRequire("kn1gs");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $33fc55e9af916f6e$var$baseRest(func, start) {
    return $kn1gs($86CUP(func, start, $l0EzR), func + "");
}
module.exports = $33fc55e9af916f6e$var$baseRest;

});
parcelRegister("86CUP", function(module, exports) {

var $gefDr = parcelRequire("gefDr");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5e6d121bbaa86323$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $5e6d121bbaa86323$var$overRest(func, start, transform) {
    start = $5e6d121bbaa86323$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $5e6d121bbaa86323$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $gefDr(func, this, otherArgs);
    };
}
module.exports = $5e6d121bbaa86323$var$overRest;

});


parcelRegister("LRL4h", function(module, exports) {

var $gWi11 = parcelRequire("gWi11");

var $2Q3DI = parcelRequire("2Q3DI");

var $1SQwH = parcelRequire("1SQwH");

var $jDLRl = parcelRequire("jDLRl");

var $8kx4Q = parcelRequire("8kx4Q");

var $8LZj9 = parcelRequire("8LZj9");
/** Used as the size to enable large array optimizations. */ var $08fe1726f118b073$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $08fe1726f118b073$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $2Q3DI, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $1SQwH;
    } else if (length >= $08fe1726f118b073$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $8kx4Q(array);
        if (set) return $8LZj9(set);
        isCommon = false;
        includes = $jDLRl;
        seen = new $gWi11;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $08fe1726f118b073$var$baseUniq;

});
parcelRegister("1SQwH", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $15f394387f27490a$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $15f394387f27490a$var$arrayIncludesWith;

});

parcelRegister("8kx4Q", function(module, exports) {

var $8q4qD = parcelRequire("8q4qD");

var $5BjSL = parcelRequire("5BjSL");

var $8LZj9 = parcelRequire("8LZj9");
/** Used as references for various `Number` constants. */ var $6109d97109a645f2$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $6109d97109a645f2$var$createSet = !($8q4qD && 1 / $8LZj9(new $8q4qD([
    ,
    -0
]))[1] == $6109d97109a645f2$var$INFINITY) ? $5BjSL : function(values) {
    return new $8q4qD(values);
};
module.exports = $6109d97109a645f2$var$createSet;

});


parcelRegister("dxIjI", function(module, exports) {

var $8kHR7 = parcelRequire("8kHR7");

var $cLyAa = parcelRequire("cLyAa");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $9dc0bbe125ea890c$var$isArrayLikeObject(value) {
    return $cLyAa(value) && $8kHR7(value);
}
module.exports = $9dc0bbe125ea890c$var$isArrayLikeObject;

});


parcelRegister("8sxbG", function(module, exports) {

var $4Iun6 = parcelRequire("4Iun6");

var $4sIyf = parcelRequire("4sIyf");

var $dxIjI = parcelRequire("dxIjI");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $628aae9d5f59a487$var$without = $4sIyf(function(array, values) {
    return $dxIjI(array) ? $4Iun6(array, values) : [];
});
module.exports = $628aae9d5f59a487$var$without;

});
parcelRegister("4Iun6", function(module, exports) {

var $gWi11 = parcelRequire("gWi11");

var $2Q3DI = parcelRequire("2Q3DI");

var $1SQwH = parcelRequire("1SQwH");

var $2CmH3 = parcelRequire("2CmH3");

var $29wFm = parcelRequire("29wFm");

var $jDLRl = parcelRequire("jDLRl");
/** Used as the size to enable large array optimizations. */ var $36f2d4aacd1ccb53$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $36f2d4aacd1ccb53$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $2Q3DI, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $2CmH3(values, $29wFm(iteratee));
    if (comparator) {
        includes = $1SQwH;
        isCommon = false;
    } else if (values.length >= $36f2d4aacd1ccb53$var$LARGE_ARRAY_SIZE) {
        includes = $jDLRl;
        isCommon = false;
        values = new $gWi11(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $36f2d4aacd1ccb53$var$baseDifference;

});




parcelRegister("2H2ri", function(module, exports) {

$parcel$export(module.exports, "importConfig", function () { return $1f617d5191f35e66$export$f8e3c1f829b275d3; });
$parcel$export(module.exports, "setConfig", function () { return $1f617d5191f35e66$export$940a7873bb071df8; });
$parcel$export(module.exports, "updateConfig", function () { return $1f617d5191f35e66$export$2eaf9172a83ee9e7; });
$parcel$export(module.exports, "importMiradorState", function () { return $1f617d5191f35e66$export$70728cb6cb979705; });

var $aowE3 = parcelRequire("aowE3");

var $7CtTT = parcelRequire("7CtTT");
function $1f617d5191f35e66$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1f617d5191f35e66$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1f617d5191f35e66$var$ownKeys(Object(source), true).forEach(function(key) {
            $1f617d5191f35e66$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1f617d5191f35e66$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1f617d5191f35e66$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1f617d5191f35e66$export$f8e3c1f829b275d3(config) {
    return {
        config: config,
        type: (0, $7CtTT.default).IMPORT_CONFIG
    };
}
function $1f617d5191f35e66$export$940a7873bb071df8(config) {
    return {
        config: config,
        type: (0, $7CtTT.default).SET_CONFIG
    };
}
function $1f617d5191f35e66$export$2eaf9172a83ee9e7(config) {
    return {
        config: config,
        type: (0, $7CtTT.default).UPDATE_CONFIG
    };
}
function $1f617d5191f35e66$export$70728cb6cb979705(state) {
    var newState = $1f617d5191f35e66$var$_objectSpread($1f617d5191f35e66$var$_objectSpread({}, state), {}, {
        workspace: $1f617d5191f35e66$var$_objectSpread($1f617d5191f35e66$var$_objectSpread({}, state.workspace), {}, {
            id: (0, $aowE3.default)()
        })
    });
    return {
        state: newState,
        type: (0, $7CtTT.default).IMPORT_MIRADOR_STATE
    };
}

});

parcelRegister("1bcju", function(module, exports) {

$parcel$export(module.exports, "addError", function () { return $0dc05eb83cdd0d67$export$239c33984d9b1367; });
$parcel$export(module.exports, "removeError", function () { return $0dc05eb83cdd0d67$export$220bda22c3bcb06f; });

var $aowE3 = parcelRequire("aowE3");

var $7CtTT = parcelRequire("7CtTT");
function $0dc05eb83cdd0d67$export$239c33984d9b1367(error) {
    return {
        id: "error-".concat((0, $aowE3.default)()),
        message: error,
        type: (0, $7CtTT.default).ADD_ERROR
    };
}
function $0dc05eb83cdd0d67$export$220bda22c3bcb06f(id) {
    return {
        id: id,
        type: (0, $7CtTT.default).REMOVE_ERROR
    };
}

});

parcelRegister("k4YEs", function(module, exports) {

$parcel$export(module.exports, "focusWindow", function () { return $e9e33a800bf003cc$export$fc9e6a6bc4f86a34; });
$parcel$export(module.exports, "addWindow", function () { return $e9e33a800bf003cc$export$2fc8dd750d0d0e39; });
$parcel$export(module.exports, "updateWindow", function () { return $e9e33a800bf003cc$export$bc7735fc73ef2009; });
$parcel$export(module.exports, "maximizeWindow", function () { return $e9e33a800bf003cc$export$e94db0e119b85135; });
$parcel$export(module.exports, "minimizeWindow", function () { return $e9e33a800bf003cc$export$40ead4e8c4962e0; });
$parcel$export(module.exports, "setCompanionAreaOpen", function () { return $e9e33a800bf003cc$export$c931bcfdc756800d; });
$parcel$export(module.exports, "removeWindow", function () { return $e9e33a800bf003cc$export$118547e79305dcdc; });
$parcel$export(module.exports, "toggleWindowSideBar", function () { return $e9e33a800bf003cc$export$e3c18edf81c7f58f; });
$parcel$export(module.exports, "setWindowThumbnailPosition", function () { return $e9e33a800bf003cc$export$2684913035901670; });
$parcel$export(module.exports, "setWindowViewType", function () { return $e9e33a800bf003cc$export$865749153ea4cdcb; });
$parcel$export(module.exports, "showCollectionDialog", function () { return $e9e33a800bf003cc$export$31b7b1c33632d024; });
$parcel$export(module.exports, "hideCollectionDialog", function () { return $e9e33a800bf003cc$export$1a64b0c8b3c5a479; });

var $aowE3 = parcelRequire("aowE3");

var $7CtTT = parcelRequire("7CtTT");

var $fr77o = parcelRequire("fr77o");
var $e9e33a800bf003cc$var$_excluded = [
    "companionWindows",
    "manifest"
];
function $e9e33a800bf003cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e9e33a800bf003cc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e9e33a800bf003cc$var$ownKeys(Object(source), true).forEach(function(key) {
            $e9e33a800bf003cc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e9e33a800bf003cc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e9e33a800bf003cc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e9e33a800bf003cc$var$_toConsumableArray(arr) {
    return $e9e33a800bf003cc$var$_arrayWithoutHoles(arr) || $e9e33a800bf003cc$var$_iterableToArray(arr) || $e9e33a800bf003cc$var$_unsupportedIterableToArray(arr) || $e9e33a800bf003cc$var$_nonIterableSpread();
}
function $e9e33a800bf003cc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e9e33a800bf003cc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e9e33a800bf003cc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e9e33a800bf003cc$var$_arrayLikeToArray(o, minLen);
}
function $e9e33a800bf003cc$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e9e33a800bf003cc$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e9e33a800bf003cc$var$_arrayLikeToArray(arr);
}
function $e9e33a800bf003cc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e9e33a800bf003cc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e9e33a800bf003cc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e9e33a800bf003cc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e9e33a800bf003cc$export$fc9e6a6bc4f86a34(windowId) {
    var pan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return {
        pan: pan,
        type: (0, $7CtTT.default).FOCUS_WINDOW,
        windowId: windowId
    };
}
function $e9e33a800bf003cc$export$2fc8dd750d0d0e39(_ref) {
    var companionWindows = _ref.companionWindows, manifest = _ref.manifest, options = $e9e33a800bf003cc$var$_objectWithoutProperties(_ref, $e9e33a800bf003cc$var$_excluded);
    return function(dispatch, getState) {
        var _miradorSlice = (0, $fr77o.miradorSlice)(getState()), config = _miradorSlice.config, _miradorSlice$workspa = _miradorSlice.workspace.windowIds, windowIds = _miradorSlice$workspa === void 0 ? [] : _miradorSlice$workspa;
        var numWindows = windowIds.length;
        var windowId = options.id || "window-".concat((0, $aowE3.default)());
        var cwThumbs = "cw-".concat((0, $aowE3.default)());
        var defaultCompanionWindows = [
            {
                content: "thumbnailNavigation",
                "default": true,
                id: cwThumbs,
                position: options.thumbnailNavigationPosition || config.thumbnailNavigation.defaultPosition,
                windowId: windowId
            }
        ].concat($e9e33a800bf003cc$var$_toConsumableArray((companionWindows || []).map(function(cw, i) {
            return $e9e33a800bf003cc$var$_objectSpread($e9e33a800bf003cc$var$_objectSpread({}, cw), {}, {
                id: "cw-".concat((0, $aowE3.default)())
            });
        })));
        if (options.sideBarPanel || config.window.defaultSideBarPanel || config.window.sideBarPanel) defaultCompanionWindows.unshift({
            content: options.sideBarPanel || options.defaultSearchQuery && "search" || config.window.defaultSideBarPanel || config.window.sideBarPanel,
            "default": true,
            id: "cw-".concat((0, $aowE3.default)()),
            position: "left",
            windowId: windowId
        });
        var defaultOptions = {
            canvasId: undefined,
            collectionIndex: 0,
            companionAreaOpen: true,
            companionWindowIds: defaultCompanionWindows.map(function(cw) {
                return cw.id;
            }),
            draggingEnabled: true,
            highlightAllAnnotations: config.window.highlightAllAnnotations || false,
            id: windowId,
            manifestId: null,
            maximized: false,
            rangeId: null,
            rotation: null,
            selectedAnnotations: {},
            sideBarOpen: config.window.sideBarOpenByDefault !== undefined ? config.window.sideBarOpenByDefault || !!options.defaultSearchQuery : config.window.sideBarOpen || !!options.defaultSearchQuery,
            sideBarPanel: options.sideBarPanel || config.window.defaultSideBarPanel || config.window.sideBarPanel,
            thumbnailNavigationId: cwThumbs
        };
        var elasticLayout = $e9e33a800bf003cc$var$_objectSpread($e9e33a800bf003cc$var$_objectSpread({}, config.window.elastic || {
            height: 400,
            width: 480
        }), {}, {
            x: 200 + (Math.floor(numWindows / 10) * 50 + numWindows * 30 % 300),
            y: 200 + numWindows * 50 % 300
        });
        dispatch({
            companionWindows: defaultCompanionWindows,
            elasticLayout: elasticLayout,
            manifest: manifest,
            type: (0, $7CtTT.default).ADD_WINDOW,
            window: $e9e33a800bf003cc$var$_objectSpread($e9e33a800bf003cc$var$_objectSpread({}, defaultOptions), options)
        });
    };
}
function $e9e33a800bf003cc$export$bc7735fc73ef2009(id, payload) {
    return {
        id: id,
        payload: payload,
        type: (0, $7CtTT.default).UPDATE_WINDOW
    };
}
function $e9e33a800bf003cc$export$e94db0e119b85135(windowId, layout) {
    return {
        type: (0, $7CtTT.default).MAXIMIZE_WINDOW,
        windowId: windowId
    };
}
function $e9e33a800bf003cc$export$40ead4e8c4962e0(windowId) {
    return {
        type: (0, $7CtTT.default).MINIMIZE_WINDOW,
        windowId: windowId
    };
}
function $e9e33a800bf003cc$export$c931bcfdc756800d(id, companionAreaOpen) {
    return {
        id: id,
        payload: {
            companionAreaOpen: companionAreaOpen
        },
        type: (0, $7CtTT.default).UPDATE_WINDOW
    };
}
function $e9e33a800bf003cc$export$118547e79305dcdc(windowId) {
    return {
        type: (0, $7CtTT.default).REMOVE_WINDOW,
        windowId: windowId
    };
}
function $e9e33a800bf003cc$export$e3c18edf81c7f58f(windowId) {
    return {
        type: (0, $7CtTT.default).TOGGLE_WINDOW_SIDE_BAR,
        windowId: windowId
    };
}
function $e9e33a800bf003cc$export$2684913035901670(windowId, position) {
    return function(dispatch, getState) {
        var _getState = getState(), windows = _getState.windows;
        var thumbnailNavigationId = windows[windowId].thumbnailNavigationId;
        dispatch({
            id: thumbnailNavigationId,
            payload: {
                position: position
            },
            type: (0, $7CtTT.default).UPDATE_COMPANION_WINDOW
        });
    };
}
function $e9e33a800bf003cc$export$865749153ea4cdcb(windowId, viewType) {
    return {
        type: (0, $7CtTT.default).SET_WINDOW_VIEW_TYPE,
        viewType: viewType,
        windowId: windowId
    };
}
function $e9e33a800bf003cc$export$31b7b1c33632d024(manifestId) {
    var collectionPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var windowId = arguments.length > 2 ? arguments[2] : undefined;
    return {
        collectionPath: collectionPath,
        manifestId: manifestId,
        type: (0, $7CtTT.default).SHOW_COLLECTION_DIALOG,
        windowId: windowId
    };
}
function $e9e33a800bf003cc$export$1a64b0c8b3c5a479(windowId) {
    return {
        type: (0, $7CtTT.default).HIDE_COLLECTION_DIALOG,
        windowId: windowId
    };
}

});

parcelRegister("6PGpp", function(module, exports) {

$parcel$export(module.exports, "requestManifest", function () { return $4f986700fca97dbc$export$92b2d3db5fb5acce; });
$parcel$export(module.exports, "receiveManifest", function () { return $4f986700fca97dbc$export$9e8ff483b364b608; });
$parcel$export(module.exports, "receiveManifestFailure", function () { return $4f986700fca97dbc$export$a3055c3fed6193e0; });
$parcel$export(module.exports, "fetchManifest", function () { return $4f986700fca97dbc$export$314985ea6858ebe9; });
$parcel$export(module.exports, "removeManifest", function () { return $4f986700fca97dbc$export$8f250b41d8cc2516; });

var $7CtTT = parcelRequire("7CtTT");
function $4f986700fca97dbc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4f986700fca97dbc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4f986700fca97dbc$var$ownKeys(Object(source), true).forEach(function(key) {
            $4f986700fca97dbc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4f986700fca97dbc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4f986700fca97dbc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4f986700fca97dbc$export$92b2d3db5fb5acce(manifestId, properties) {
    return {
        manifestId: manifestId,
        properties: properties,
        type: (0, $7CtTT.default).REQUEST_MANIFEST
    };
}
function $4f986700fca97dbc$export$9e8ff483b364b608(manifestId, manifestJson) {
    return {
        manifestId: manifestId,
        manifestJson: manifestJson,
        type: (0, $7CtTT.default).RECEIVE_MANIFEST
    };
}
function $4f986700fca97dbc$export$a3055c3fed6193e0(manifestId, error) {
    return {
        error: error,
        manifestId: manifestId,
        type: (0, $7CtTT.default).RECEIVE_MANIFEST_FAILURE
    };
}
function $4f986700fca97dbc$export$314985ea6858ebe9(manifestId, properties) {
    return $4f986700fca97dbc$export$92b2d3db5fb5acce(manifestId, $4f986700fca97dbc$var$_objectSpread($4f986700fca97dbc$var$_objectSpread({}, properties), {}, {
        isFetching: true
    }));
}
function $4f986700fca97dbc$export$8f250b41d8cc2516(manifestId) {
    return {
        manifestId: manifestId,
        type: (0, $7CtTT.default).REMOVE_MANIFEST
    };
}

});

parcelRegister("kPH0F", function(module, exports) {

$parcel$export(module.exports, "requestInfoResponse", function () { return $f2a9eeeea42f1c1c$export$a53797a42fa2c49f; });
$parcel$export(module.exports, "receiveInfoResponse", function () { return $f2a9eeeea42f1c1c$export$32260ba4327c35e0; });
$parcel$export(module.exports, "receiveDegradedInfoResponse", function () { return $f2a9eeeea42f1c1c$export$95a7de59ec756631; });
$parcel$export(module.exports, "receiveInfoResponseFailure", function () { return $f2a9eeeea42f1c1c$export$260ecd0a7a67f3; });
$parcel$export(module.exports, "fetchInfoResponse", function () { return $f2a9eeeea42f1c1c$export$7b9a02b272fcba97; });
$parcel$export(module.exports, "removeInfoResponse", function () { return $f2a9eeeea42f1c1c$export$fd3ef10b91b72c1c; });

var $7CtTT = parcelRequire("7CtTT");
function $f2a9eeeea42f1c1c$export$a53797a42fa2c49f(infoId, imageResource, windowId) {
    return {
        imageResource: imageResource,
        infoId: infoId,
        type: (0, $7CtTT.default).REQUEST_INFO_RESPONSE,
        windowId: windowId
    };
}
function $f2a9eeeea42f1c1c$export$32260ba4327c35e0(infoId, infoJson, ok, tokenServiceId) {
    return {
        infoId: infoId,
        infoJson: infoJson,
        ok: ok,
        tokenServiceId: tokenServiceId,
        type: (0, $7CtTT.default).RECEIVE_INFO_RESPONSE
    };
}
function $f2a9eeeea42f1c1c$export$95a7de59ec756631(infoId, infoJson, ok, tokenServiceId, windowId) {
    return {
        infoId: infoId,
        infoJson: infoJson,
        ok: ok,
        tokenServiceId: tokenServiceId,
        type: (0, $7CtTT.default).RECEIVE_DEGRADED_INFO_RESPONSE,
        windowId: windowId
    };
}
function $f2a9eeeea42f1c1c$export$260ecd0a7a67f3(infoId, error, tokenServiceId) {
    return {
        error: error,
        infoId: infoId,
        tokenServiceId: tokenServiceId,
        type: (0, $7CtTT.default).RECEIVE_INFO_RESPONSE_FAILURE
    };
}
function $f2a9eeeea42f1c1c$export$7b9a02b272fcba97(_ref) {
    var imageId = _ref.imageId, imageResource = _ref.imageResource, windowId = _ref.windowId;
    var imageService = imageResource && imageResource.getServices()[0];
    var infoId = imageId || imageService.id;
    return $f2a9eeeea42f1c1c$export$a53797a42fa2c49f(infoId, imageService, windowId);
}
function $f2a9eeeea42f1c1c$export$fd3ef10b91b72c1c(infoId) {
    return {
        infoId: infoId,
        type: (0, $7CtTT.default).REMOVE_INFO_RESPONSE
    };
}

});

parcelRegister("bcVRp", function(module, exports) {

$parcel$export(module.exports, "updateWorkspace", function () { return $828db2917ec44107$export$3680af82c1780a0e; });
$parcel$export(module.exports, "setWorkspaceFullscreen", function () { return $828db2917ec44107$export$4d8e5298943b7c10; });
$parcel$export(module.exports, "toggleZoomControls", function () { return $828db2917ec44107$export$bfe2f9a566724a2b; });
$parcel$export(module.exports, "updateWorkspaceMosaicLayout", function () { return $828db2917ec44107$export$b7e327c7b0ac7337; });
$parcel$export(module.exports, "setWorkspaceAddVisibility", function () { return $828db2917ec44107$export$bc90f30b8dfd0d65; });
$parcel$export(module.exports, "setWorkspaceViewportPosition", function () { return $828db2917ec44107$export$41784851fb3534e0; });
$parcel$export(module.exports, "setWorkspaceViewportDimensions", function () { return $828db2917ec44107$export$ac04cbb9ef0e48d4; });
$parcel$export(module.exports, "toggleDraggingEnabled", function () { return $828db2917ec44107$export$3c0fb8ab5f389510; });

var $7CtTT = parcelRequire("7CtTT");
function $828db2917ec44107$export$3680af82c1780a0e(config) {
    return {
        config: config,
        type: (0, $7CtTT.default).UPDATE_WORKSPACE
    };
}
function $828db2917ec44107$export$4d8e5298943b7c10(isFullscreenEnabled) {
    return {
        isFullscreenEnabled: isFullscreenEnabled,
        type: (0, $7CtTT.default).SET_WORKSPACE_FULLSCREEN
    };
}
function $828db2917ec44107$export$bfe2f9a566724a2b(showZoomControls) {
    return {
        showZoomControls: showZoomControls,
        type: (0, $7CtTT.default).TOGGLE_ZOOM_CONTROLS
    };
}
function $828db2917ec44107$export$b7e327c7b0ac7337(layout) {
    return {
        layout: layout,
        type: (0, $7CtTT.default).UPDATE_WORKSPACE_MOSAIC_LAYOUT
    };
}
function $828db2917ec44107$export$bc90f30b8dfd0d65(isWorkspaceAddVisible) {
    return {
        isWorkspaceAddVisible: isWorkspaceAddVisible,
        type: (0, $7CtTT.default).SET_WORKSPACE_ADD_VISIBILITY
    };
}
function $828db2917ec44107$export$41784851fb3534e0(_ref) {
    var x = _ref.x, y = _ref.y;
    return {
        payload: {
            position: {
                x: x,
                y: y
            }
        },
        type: (0, $7CtTT.default).SET_WORKSPACE_VIEWPORT_POSITION
    };
}
function $828db2917ec44107$export$ac04cbb9ef0e48d4(_ref2) {
    var width = _ref2.width, height = _ref2.height;
    return {
        payload: {
            position: {
                height: height,
                width: width
            }
        },
        type: (0, $7CtTT.default).SET_WORKSPACE_VIEWPORT_POSITION
    };
}
function $828db2917ec44107$export$3c0fb8ab5f389510() {
    return {
        type: (0, $7CtTT.default).TOGGLE_DRAGGING
    };
}

});

parcelRegister("61Aec", function(module, exports) {

$parcel$export(module.exports, "requestCanvasAnnotations", function () { return $462ef02ebd27960a$export$3a96f01d70c48e1e; });
$parcel$export(module.exports, "requestAnnotation", function () { return $462ef02ebd27960a$export$b74fb667c21de137; });
$parcel$export(module.exports, "receiveAnnotation", function () { return $462ef02ebd27960a$export$4d39f3ee142b7b17; });
$parcel$export(module.exports, "receiveAnnotationFailure", function () { return $462ef02ebd27960a$export$5d43eb6d1be77d92; });
$parcel$export(module.exports, "selectAnnotation", function () { return $462ef02ebd27960a$export$264f6d4d99a072ad; });
$parcel$export(module.exports, "deselectAnnotation", function () { return $462ef02ebd27960a$export$ff1398258af321bf; });
$parcel$export(module.exports, "toggleAnnotationDisplay", function () { return $462ef02ebd27960a$export$8e3e61dd1ef5cef4; });
$parcel$export(module.exports, "hoverAnnotation", function () { return $462ef02ebd27960a$export$b5cae6b344382781; });

var $7CtTT = parcelRequire("7CtTT");
function $462ef02ebd27960a$export$3a96f01d70c48e1e(windowId, canvasId) {
    return {
        canvasId: canvasId,
        type: (0, $7CtTT.default).REQUEST_CANVAS_ANNOTATIONS,
        windowId: windowId
    };
}
function $462ef02ebd27960a$export$b74fb667c21de137(targetId, annotationId) {
    return {
        annotationId: annotationId,
        targetId: targetId,
        type: (0, $7CtTT.default).REQUEST_ANNOTATION
    };
}
function $462ef02ebd27960a$export$4d39f3ee142b7b17(targetId, annotationId, annotationJson) {
    return {
        annotationId: annotationId,
        annotationJson: annotationJson,
        targetId: targetId,
        type: (0, $7CtTT.default).RECEIVE_ANNOTATION
    };
}
function $462ef02ebd27960a$export$5d43eb6d1be77d92(targetId, annotationId, error) {
    return {
        annotationId: annotationId,
        error: error,
        targetId: targetId,
        type: (0, $7CtTT.default).RECEIVE_ANNOTATION_FAILURE
    };
}
function $462ef02ebd27960a$export$264f6d4d99a072ad(windowId, annotationId) {
    return {
        annotationId: annotationId,
        type: (0, $7CtTT.default).SELECT_ANNOTATION,
        windowId: windowId
    };
}
function $462ef02ebd27960a$export$ff1398258af321bf(windowId, annotationId) {
    return {
        annotationId: annotationId,
        type: (0, $7CtTT.default).DESELECT_ANNOTATION,
        windowId: windowId
    };
}
function $462ef02ebd27960a$export$8e3e61dd1ef5cef4(windowId) {
    return {
        type: (0, $7CtTT.default).TOGGLE_ANNOTATION_DISPLAY,
        windowId: windowId
    };
}
function $462ef02ebd27960a$export$b5cae6b344382781(windowId, annotationIds) {
    return {
        annotationIds: annotationIds,
        type: (0, $7CtTT.default).HOVER_ANNOTATION,
        windowId: windowId
    };
}

});

parcelRegister("aeQGD", function(module, exports) {

$parcel$export(module.exports, "addAuthenticationRequest", function () { return $774414ab54af035c$export$6763d1d26f2803f8; });
$parcel$export(module.exports, "resolveAuthenticationRequest", function () { return $774414ab54af035c$export$63bfbf190889d72a; });
$parcel$export(module.exports, "requestAccessToken", function () { return $774414ab54af035c$export$13987b025a5be541; });
$parcel$export(module.exports, "receiveAccessToken", function () { return $774414ab54af035c$export$d7f6453813abca85; });
$parcel$export(module.exports, "receiveAccessTokenFailure", function () { return $774414ab54af035c$export$e8c242423e024b53; });
$parcel$export(module.exports, "resolveAccessTokenRequest", function () { return $774414ab54af035c$export$4ee1e626776b870; });
$parcel$export(module.exports, "resetAuthenticationState", function () { return $774414ab54af035c$export$12503b873d357ec4; });

var $7CtTT = parcelRequire("7CtTT");
function $774414ab54af035c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $774414ab54af035c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $774414ab54af035c$var$ownKeys(Object(source), true).forEach(function(key) {
            $774414ab54af035c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $774414ab54af035c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $774414ab54af035c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $774414ab54af035c$export$6763d1d26f2803f8(windowId, id) {
    var profile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    return {
        id: id,
        profile: profile,
        type: (0, $7CtTT.default).ADD_AUTHENTICATION_REQUEST,
        windowId: windowId
    };
}
function $774414ab54af035c$export$63bfbf190889d72a(id, tokenServiceId, props) {
    return $774414ab54af035c$var$_objectSpread({
        id: id,
        tokenServiceId: tokenServiceId,
        type: (0, $7CtTT.default).RESOLVE_AUTHENTICATION_REQUEST
    }, props);
}
function $774414ab54af035c$export$13987b025a5be541(serviceId, authId) {
    return {
        authId: authId,
        serviceId: serviceId,
        type: (0, $7CtTT.default).REQUEST_ACCESS_TOKEN
    };
}
function $774414ab54af035c$export$d7f6453813abca85(authId, serviceId, json) {
    return {
        authId: authId,
        json: json,
        serviceId: serviceId,
        type: (0, $7CtTT.default).RECEIVE_ACCESS_TOKEN
    };
}
function $774414ab54af035c$export$e8c242423e024b53(authId, serviceId, error) {
    return {
        authId: authId,
        error: error,
        serviceId: serviceId,
        type: (0, $7CtTT.default).RECEIVE_ACCESS_TOKEN_FAILURE
    };
}
function $774414ab54af035c$export$4ee1e626776b870(authServiceId, tokenServiceId, json) {
    if (!json.accessToken) return $774414ab54af035c$export$e8c242423e024b53(authServiceId, tokenServiceId, json);
    return $774414ab54af035c$export$d7f6453813abca85(authServiceId, tokenServiceId, json);
}
function $774414ab54af035c$export$12503b873d357ec4(_ref) {
    var authServiceId = _ref.authServiceId, tokenServiceId = _ref.tokenServiceId;
    return {
        id: authServiceId,
        tokenServiceId: tokenServiceId,
        type: (0, $7CtTT.default).RESET_AUTHENTICATION_STATE
    };
}

});

parcelRegister("iACUj", function(module, exports) {

$parcel$export(module.exports, "updateElasticWindowLayout", function () { return $d889c4f8833d4cf0$export$1eedb461123f87fc; });

var $7CtTT = parcelRequire("7CtTT");
function $d889c4f8833d4cf0$export$1eedb461123f87fc(windowId, payload) {
    return {
        payload: payload,
        type: (0, $7CtTT.default).UPDATE_ELASTIC_WINDOW_LAYOUT,
        windowId: windowId
    };
}

});

parcelRegister("kQy7d", function(module, exports) {

$parcel$export(module.exports, "requestSearch", function () { return $f2d3209ade47d055$export$251b2a81f0a71323; });
$parcel$export(module.exports, "receiveSearch", function () { return $f2d3209ade47d055$export$47ecd4d98c98b11b; });
$parcel$export(module.exports, "receiveSearchFailure", function () { return $f2d3209ade47d055$export$1c10d2bb50448156; });
$parcel$export(module.exports, "removeSearch", function () { return $f2d3209ade47d055$export$79b5181a1ae695e3; });
$parcel$export(module.exports, "fetchSearch", function () { return $f2d3209ade47d055$export$6f539dc45dead1c; });
$parcel$export(module.exports, "setContentSearchCurrentAnnotation", function () { return $f2d3209ade47d055$export$9060fcd8fdae1191; });

var $7CtTT = parcelRequire("7CtTT");
function $f2d3209ade47d055$export$251b2a81f0a71323(windowId, companionWindowId, searchId, query) {
    return {
        companionWindowId: companionWindowId,
        query: query,
        searchId: searchId,
        type: (0, $7CtTT.default).REQUEST_SEARCH,
        windowId: windowId
    };
}
function $f2d3209ade47d055$export$47ecd4d98c98b11b(windowId, companionWindowId, searchId, searchJson) {
    return {
        companionWindowId: companionWindowId,
        searchId: searchId,
        searchJson: searchJson,
        type: (0, $7CtTT.default).RECEIVE_SEARCH,
        windowId: windowId
    };
}
function $f2d3209ade47d055$export$1c10d2bb50448156(windowId, companionWindowId, searchId, error) {
    return {
        companionWindowId: companionWindowId,
        error: error,
        searchId: searchId,
        type: (0, $7CtTT.default).RECEIVE_SEARCH_FAILURE,
        windowId: windowId
    };
}
function $f2d3209ade47d055$export$79b5181a1ae695e3(windowId, companionWindowId) {
    return {
        companionWindowId: companionWindowId,
        type: (0, $7CtTT.default).REMOVE_SEARCH,
        windowId: windowId
    };
}
function $f2d3209ade47d055$export$6f539dc45dead1c(windowId, companionWindowId, searchId, query) {
    return $f2d3209ade47d055$export$251b2a81f0a71323(windowId, companionWindowId, searchId, query);
}
function $f2d3209ade47d055$export$9060fcd8fdae1191(windowId, companionWindowId, annotationIds) {
    return {
        annotationIds: annotationIds,
        companionWindowId: companionWindowId,
        type: (0, $7CtTT.default).SET_CONTENT_SEARCH_CURRENT_ANNOTATIONS,
        windowId: windowId
    };
}

});

parcelRegister("2Ux4D", function(module, exports) {

$parcel$export(module.exports, "updateLayers", function () { return $21ea777bcaa8705b$export$a4ab5e6d6e814445; });

var $7CtTT = parcelRequire("7CtTT");
function $21ea777bcaa8705b$export$a4ab5e6d6e814445(windowId, canvasId, payload) {
    return {
        canvasId: canvasId,
        payload: payload,
        type: (0, $7CtTT.default).UPDATE_LAYERS,
        windowId: windowId
    };
}

});

parcelRegister("jRTT7", function(module, exports) {

$parcel$export(module.exports, "addResource", function () { return $e76e51bf683f3388$export$dd712f36c1a9cd08; });
$parcel$export(module.exports, "removeResource", function () { return $e76e51bf683f3388$export$c823747c8d5b8150; });

var $7CtTT = parcelRequire("7CtTT");
function $e76e51bf683f3388$export$dd712f36c1a9cd08(manifestId) {
    var manifestJson = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var payload = arguments.length > 2 ? arguments[2] : undefined;
    return {
        manifestId: manifestId,
        manifestJson: manifestJson,
        payload: payload,
        type: (0, $7CtTT.default).ADD_RESOURCE
    };
}
function $e76e51bf683f3388$export$c823747c8d5b8150(manifestId) {
    return {
        manifestId: manifestId,
        type: (0, $7CtTT.default).REMOVE_RESOURCE
    };
}

});


parcelRegister("9U2Zv", function(module, exports) {

$parcel$export(module.exports, "ThumbnailCanvasGrouping", function () { return $735ba9f4f9ff705e$export$103cbc08f0529e15; });

var $arQ7u = parcelRequire("arQ7u");

var $dErw7 = parcelRequire("dErw7");

var $YLOIV = parcelRequire("YLOIV");

var $1xlvK = parcelRequire("1xlvK");
function $735ba9f4f9ff705e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $735ba9f4f9ff705e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $735ba9f4f9ff705e$var$ownKeys(Object(source), true).forEach(function(key) {
            $735ba9f4f9ff705e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $735ba9f4f9ff705e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $735ba9f4f9ff705e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $735ba9f4f9ff705e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $735ba9f4f9ff705e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $735ba9f4f9ff705e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $735ba9f4f9ff705e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $735ba9f4f9ff705e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $735ba9f4f9ff705e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $735ba9f4f9ff705e$var$_setPrototypeOf(subClass, superClass);
}
function $735ba9f4f9ff705e$var$_setPrototypeOf(o, p) {
    $735ba9f4f9ff705e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $735ba9f4f9ff705e$var$_setPrototypeOf(o, p);
}
function $735ba9f4f9ff705e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $735ba9f4f9ff705e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $735ba9f4f9ff705e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $735ba9f4f9ff705e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $735ba9f4f9ff705e$var$_possibleConstructorReturn(this, result);
    };
}
function $735ba9f4f9ff705e$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $735ba9f4f9ff705e$var$_assertThisInitialized(self);
}
function $735ba9f4f9ff705e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $735ba9f4f9ff705e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $735ba9f4f9ff705e$var$_getPrototypeOf(o) {
    $735ba9f4f9ff705e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $735ba9f4f9ff705e$var$_getPrototypeOf(o);
}
var $735ba9f4f9ff705e$export$103cbc08f0529e15 = /*#__PURE__*/ function(_PureComponent) {
    $735ba9f4f9ff705e$var$_inherits(ThumbnailCanvasGrouping, _PureComponent);
    var _super = $735ba9f4f9ff705e$var$_createSuper(ThumbnailCanvasGrouping);
    /** */ function ThumbnailCanvasGrouping(props) {
        var _this;
        $735ba9f4f9ff705e$var$_classCallCheck(this, ThumbnailCanvasGrouping);
        _this = _super.call(this, props);
        _this.setCanvas = _this.setCanvas.bind($735ba9f4f9ff705e$var$_assertThisInitialized(_this));
        return _this;
    }
    /** */ $735ba9f4f9ff705e$var$_createClass(ThumbnailCanvasGrouping, [
        {
            key: "setCanvas",
            value: function setCanvas(e) {
                var setCanvas = this.props.setCanvas;
                setCanvas(e.currentTarget.dataset.canvasId);
            }
        },
        {
            key: "currentCanvasClass",
            value: function currentCanvasClass(canvasIndices) {
                var index = this.props.index;
                if (canvasIndices.includes(index)) return "current-canvas-grouping";
                return "";
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, index = _this$props.index, style = _this$props.style, data = _this$props.data, classes = _this$props.classes, currentCanvasId = _this$props.currentCanvasId;
                var canvasGroupings = data.canvasGroupings, position = data.position, height = data.height;
                var currentGroupings = canvasGroupings[index];
                var SPACING = 8;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    style: $735ba9f4f9ff705e$var$_objectSpread($735ba9f4f9ff705e$var$_objectSpread({}, style), {}, {
                        boxSizing: "content-box",
                        height: Number.isInteger(style.height) ? style.height - SPACING : null,
                        left: style.left + SPACING,
                        top: style.top + SPACING,
                        width: Number.isInteger(style.width) ? style.width - SPACING : null
                    }),
                    className: (0, $1xlvK.default)("thumbnail-nav-container"),
                    role: "gridcell",
                    "aria-colindex": index + 1
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    role: "button",
                    "data-canvas-id": currentGroupings[0].id,
                    "data-canvas-index": currentGroupings[0].index,
                    onKeyUp: this.setCanvas,
                    onClick: this.setCanvas,
                    tabIndex: -1,
                    style: {
                        height: position === "far-right" ? "auto" : "".concat(height - SPACING, "px"),
                        width: position === "far-bottom" ? "auto" : "".concat(style.width, "px")
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dErw7)))((0, $1xlvK.default)([
                        "thumbnail-nav-canvas",
                        "thumbnail-nav-canvas-".concat(index),
                        this.currentCanvasClass(currentGroupings.map(function(canvas) {
                            return canvas.index;
                        }))
                    ]), classes.canvas, $735ba9f4f9ff705e$var$_defineProperty({}, classes.currentCanvas, currentGroupings.map(function(canvas) {
                        return canvas.id;
                    }).includes(currentCanvasId)))
                }, currentGroupings.map(function(canvas, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $YLOIV.default), {
                        key: canvas.id,
                        resource: canvas,
                        labelled: true,
                        maxHeight: position === "far-right" ? style.height - 1.5 * SPACING : height - 1.5 * SPACING,
                        variant: "inside"
                    });
                })));
            }
        }
    ]);
    return ThumbnailCanvasGrouping;
}((0, $arQ7u.PureComponent));

});
parcelRegister("YLOIV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b6ab2320a0472de$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $jGts0 = parcelRequire("jGts0");

var $hZKiF = parcelRequire("hZKiF");
/**
 * mapStateToProps - to hook up connect
 * @private
 */ var $0b6ab2320a0472de$var$mapStateToProps = function mapStateToProps(state) {
    return {
        thumbnailsConfig: (0, $jGts0.getConfig)(state).thumbnails
    };
};
/**
 * Styles for withStyles HOC
 */ var $0b6ab2320a0472de$var$styles = function styles(theme) {
    return {
        caption: {
            lineHeight: "1.5em",
            wordBreak: "break-word"
        },
        image: {},
        insideCaption: {
            color: "#ffffff",
            lineClamp: "1",
            whiteSpace: "nowrap"
        },
        insideLabel: {
            background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
            bottom: "5px",
            boxSizing: "border-box",
            left: "0px",
            padding: "4px",
            position: "absolute",
            width: "100%"
        },
        insideRoot: {
            display: "inline-block",
            height: "inherit",
            position: "relative"
        },
        label: {
            overflow: "hidden",
            textOverflow: "ellipsis"
        },
        outsideCaption: {
            boxOrient: "vertical",
            display: "-webkit-box",
            lineClamp: "2",
            maxHeight: "3em"
        },
        outsideLabel: {},
        outsideRoot: {},
        root: {}
    };
};
var $0b6ab2320a0472de$var$enhance = (0, $k19ic.compose)((0, $7EzGR.default)($0b6ab2320a0472de$var$styles), (0, $eC0Mc.withTranslation)(), (0, $fbonu.default)($0b6ab2320a0472de$var$mapStateToProps), (0, $7XHRd.withPlugins)("IIIFThumbnail"));
var $0b6ab2320a0472de$export$2e2bcd8739ae039 = $0b6ab2320a0472de$var$enhance((0, $hZKiF.IIIFThumbnail));

});
parcelRegister("hZKiF", function(module, exports) {

$parcel$export(module.exports, "IIIFThumbnail", function () { return $d19c0c6b9b95004f$export$56773befd72da4e7; });

var $arQ7u = parcelRequire("arQ7u");
parcelRequire("91cpx");

var $hsH5s = parcelRequire("hsH5s");
parcelRequire("1DhSQ");
var $fhzsZ = parcelRequire("fhzsZ");

var $dErw7 = parcelRequire("dErw7");

var $6zvk6 = parcelRequire("6zvk6");
function $d19c0c6b9b95004f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d19c0c6b9b95004f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d19c0c6b9b95004f$var$ownKeys(Object(source), true).forEach(function(key) {
            $d19c0c6b9b95004f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d19c0c6b9b95004f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d19c0c6b9b95004f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d19c0c6b9b95004f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d19c0c6b9b95004f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d19c0c6b9b95004f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d19c0c6b9b95004f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d19c0c6b9b95004f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d19c0c6b9b95004f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d19c0c6b9b95004f$var$_setPrototypeOf(subClass, superClass);
}
function $d19c0c6b9b95004f$var$_setPrototypeOf(o, p) {
    $d19c0c6b9b95004f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d19c0c6b9b95004f$var$_setPrototypeOf(o, p);
}
function $d19c0c6b9b95004f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d19c0c6b9b95004f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d19c0c6b9b95004f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d19c0c6b9b95004f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d19c0c6b9b95004f$var$_possibleConstructorReturn(this, result);
    };
}
function $d19c0c6b9b95004f$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d19c0c6b9b95004f$var$_assertThisInitialized(self);
}
function $d19c0c6b9b95004f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d19c0c6b9b95004f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d19c0c6b9b95004f$var$_getPrototypeOf(o) {
    $d19c0c6b9b95004f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d19c0c6b9b95004f$var$_getPrototypeOf(o);
}
var $d19c0c6b9b95004f$export$56773befd72da4e7 = /*#__PURE__*/ function(_Component) {
    $d19c0c6b9b95004f$var$_inherits(IIIFThumbnail, _Component);
    var _super = $d19c0c6b9b95004f$var$_createSuper(IIIFThumbnail);
    /**
   */ function IIIFThumbnail(props) {
        var _this;
        $d19c0c6b9b95004f$var$_classCallCheck(this, IIIFThumbnail);
        _this = _super.call(this, props);
        _this.state = {
            loaded: false
        };
        _this.handleIntersection = _this.handleIntersection.bind($d19c0c6b9b95004f$var$_assertThisInitialized(_this));
        return _this;
    }
    /** */ $d19c0c6b9b95004f$var$_createClass(IIIFThumbnail, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                this.setState(function(state) {
                    return $d19c0c6b9b95004f$var$_objectSpread($d19c0c6b9b95004f$var$_objectSpread({}, state), {}, {
                        image: _this2.image()
                    });
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this3 = this;
                var _this$props = this.props, maxHeight = _this$props.maxHeight, maxWidth = _this$props.maxWidth, resource = _this$props.resource;
                if (prevProps.maxHeight !== maxHeight || prevProps.maxWidth !== maxWidth || prevProps.resource !== resource) this.setState(function(state) {
                    return $d19c0c6b9b95004f$var$_objectSpread($d19c0c6b9b95004f$var$_objectSpread({}, state), {}, {
                        image: _this3.image()
                    });
                }); // eslint-disable-line
            }
        },
        {
            key: "handleIntersection",
            value: function handleIntersection(event) {
                var loaded = this.state.loaded;
                if (loaded || !event.isIntersecting) return;
                this.setState(function(state) {
                    return $d19c0c6b9b95004f$var$_objectSpread($d19c0c6b9b95004f$var$_objectSpread({}, state), {}, {
                        loaded: true
                    });
                });
            }
        },
        {
            key: "imageStyles",
            value: function imageStyles() {
                var _this$props2 = this.props, maxHeight = _this$props2.maxHeight, maxWidth = _this$props2.maxWidth, style = _this$props2.style;
                var image = this.image();
                var styleProps = {
                    height: "auto",
                    width: "auto"
                };
                if (!image) return $d19c0c6b9b95004f$var$_objectSpread($d19c0c6b9b95004f$var$_objectSpread({}, style), {}, {
                    height: maxHeight || "auto",
                    width: maxWidth || "auto"
                });
                var thumbHeight = image.height, thumbWidth = image.width;
                if (thumbHeight && thumbWidth) {
                    if (maxHeight && thumbHeight > maxHeight || maxWidth && thumbWidth > maxWidth) {
                        var aspectRatio = thumbWidth / thumbHeight;
                        if (maxHeight && maxWidth) {
                            if (maxWidth / maxHeight < aspectRatio) {
                                styleProps.height = Math.round(maxWidth / aspectRatio);
                                styleProps.width = maxWidth;
                            } else {
                                styleProps.height = maxHeight;
                                styleProps.width = Math.round(maxHeight * aspectRatio);
                            }
                        } else if (maxHeight) {
                            styleProps.height = maxHeight;
                            styleProps.maxWidth = Math.round(maxHeight * aspectRatio);
                        } else if (maxWidth) {
                            styleProps.width = maxWidth;
                            styleProps.maxHeight = Math.round(maxWidth / aspectRatio);
                        }
                    } else {
                        styleProps.width = thumbWidth;
                        styleProps.height = thumbHeight;
                    }
                } else if (thumbHeight && !thumbWidth) styleProps.height = maxHeight;
                else if (!thumbHeight && thumbWidth) styleProps.width = maxWidth;
                else {
                    // The thumbnail wasn't retrieved via an Image API service,
                    // and its dimensions are not specified in the JSON-LD
                    // (note that this may result in a blurry image)
                    styleProps.width = maxWidth;
                    styleProps.height = maxHeight;
                }
                return $d19c0c6b9b95004f$var$_objectSpread($d19c0c6b9b95004f$var$_objectSpread({}, styleProps), style);
            }
        },
        {
            key: "image",
            value: function image() {
                var _this$props3 = this.props, thumbnail = _this$props3.thumbnail, resource = _this$props3.resource, maxHeight = _this$props3.maxHeight, maxWidth = _this$props3.maxWidth, thumbnailsConfig = _this$props3.thumbnailsConfig;
                if (thumbnail) return thumbnail;
                var image = (0, $6zvk6.default)(resource, $d19c0c6b9b95004f$var$_objectSpread($d19c0c6b9b95004f$var$_objectSpread({}, thumbnailsConfig), {}, {
                    maxHeight: maxHeight,
                    maxWidth: maxWidth
                }));
                if (image && image.url) return image;
                return undefined;
            }
        },
        {
            key: "label",
            value: function label() {
                var _this$props4 = this.props, label = _this$props4.label, resource = _this$props4.resource;
                return label || IIIFThumbnail.getUseableLabel(resource);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, children = _this$props5.children, classes = _this$props5.classes, imagePlaceholder = _this$props5.imagePlaceholder, labelled = _this$props5.labelled, thumbnail = _this$props5.thumbnail, variant = _this$props5.variant;
                var _this$state = this.state, image = _this$state.image, loaded = _this$state.loaded;
                var _ref = loaded && (thumbnail || image) || {}, _ref$url = _ref.url, src = _ref$url === void 0 ? imagePlaceholder : _ref$url;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dErw7)))(classes.root, $d19c0c6b9b95004f$var$_defineProperty({}, classes["".concat(variant, "Root")], variant))
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $fhzsZ.default), {
                    onChange: this.handleIntersection
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("img", {
                    alt: "",
                    role: "presentation",
                    src: src,
                    style: this.imageStyles(),
                    className: classes.image
                })), labelled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dErw7)))(classes.label, $d19c0c6b9b95004f$var$_defineProperty({}, classes["".concat(variant, "Label")], variant))
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "caption",
                    classes: {
                        root: (0, (/*@__PURE__*/$parcel$interopDefault($dErw7)))(classes.caption, $d19c0c6b9b95004f$var$_defineProperty({}, classes["".concat(variant, "Caption")], variant))
                    }
                }, this.label())), children);
            }
        }
    ], [
        {
            key: "getUseableLabel",
            value: /** */ function getUseableLabel(resource, index) {
                return resource && resource.getLabel && resource.getLabel().length > 0 ? resource.getLabel().getValue() : String(index + 1);
            }
        }
    ]);
    return IIIFThumbnail;
}((0, $arQ7u.Component));
$d19c0c6b9b95004f$export$56773befd72da4e7.defaultProps = {
    children: null,
    classes: {},
    // Transparent "gray"
    imagePlaceholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mMMDQmtBwADgwF/Op8FmAAAAABJRU5ErkJggg==",
    label: undefined,
    labelled: false,
    maxHeight: null,
    maxWidth: null,
    style: {},
    thumbnail: null,
    thumbnailsConfig: {},
    variant: null
};

});
parcelRegister("91cpx", function(module, exports) {
/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */ (function() {
    "use strict";
    // Exit early if we're not running in a browser.
    if (typeof window !== "object") return;
    // Exit early if all IntersectionObserver and IntersectionObserverEntry
    // features are natively supported.
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
        // Minimal polyfill for Edge 15's lack of `isIntersecting`
        // See: https://github.com/w3c/IntersectionObserver/issues/211
        if (!("isIntersecting" in window.IntersectionObserverEntry.prototype)) Object.defineProperty(window.IntersectionObserverEntry.prototype, "isIntersecting", {
            get: function() {
                return this.intersectionRatio > 0;
            }
        });
        return;
    }
    /**
 * A local reference to the document.
 */ var document = window.document;
    /**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */ var registry = [];
    /**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */ var crossOriginUpdater = null;
    /**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */ var crossOriginRect = null;
    /**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */ function IntersectionObserverEntry(entry) {
        this.time = entry.time;
        this.target = entry.target;
        this.rootBounds = ensureDOMRect(entry.rootBounds);
        this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
        this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
        this.isIntersecting = !!entry.intersectionRect;
        // Calculates the intersection ratio.
        var targetRect = this.boundingClientRect;
        var targetArea = targetRect.width * targetRect.height;
        var intersectionRect = this.intersectionRect;
        var intersectionArea = intersectionRect.width * intersectionRect.height;
        // Sets intersection ratio.
        if (targetArea) // Round the intersection ratio to avoid floating point math issues:
        // https://github.com/w3c/IntersectionObserver/issues/324
        this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
        else // If area is zero and is intersecting, sets to 1, otherwise to 0
        this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
    /**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */ function IntersectionObserver(callback, opt_options) {
        var options = opt_options || {};
        if (typeof callback != "function") throw new Error("callback must be a function");
        if (options.root && options.root.nodeType != 1) throw new Error("root must be an Element");
        // Binds and throttles `this._checkForIntersections`.
        this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
        // Private properties.
        this._callback = callback;
        this._observationTargets = [];
        this._queuedEntries = [];
        this._rootMarginValues = this._parseRootMargin(options.rootMargin);
        // Public properties.
        this.thresholds = this._initThresholds(options.threshold);
        this.root = options.root || null;
        this.rootMargin = this._rootMarginValues.map(function(margin) {
            return margin.value + margin.unit;
        }).join(" ");
        /** @private @const {!Array<!Document>} */ this._monitoringDocuments = [];
        /** @private @const {!Array<function()>} */ this._monitoringUnsubscribes = [];
    }
    /**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */ IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
    /**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */ IntersectionObserver.prototype.POLL_INTERVAL = null;
    /**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */ IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
    /**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */ IntersectionObserver._setupCrossOriginUpdater = function() {
        if (!crossOriginUpdater) /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */ crossOriginUpdater = function(boundingClientRect, intersectionRect) {
            if (!boundingClientRect || !intersectionRect) crossOriginRect = getEmptyRect();
            else crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
            registry.forEach(function(observer) {
                observer._checkForIntersections();
            });
        };
        return crossOriginUpdater;
    };
    /**
 * Resets the cross-origin mode.
 */ IntersectionObserver._resetCrossOriginUpdater = function() {
        crossOriginUpdater = null;
        crossOriginRect = null;
    };
    /**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */ IntersectionObserver.prototype.observe = function(target) {
        var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
            return item.element == target;
        });
        if (isTargetAlreadyObserved) return;
        if (!(target && target.nodeType == 1)) throw new Error("target must be an Element");
        this._registerInstance();
        this._observationTargets.push({
            element: target,
            entry: null
        });
        this._monitorIntersections(target.ownerDocument);
        this._checkForIntersections();
    };
    /**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */ IntersectionObserver.prototype.unobserve = function(target) {
        this._observationTargets = this._observationTargets.filter(function(item) {
            return item.element != target;
        });
        this._unmonitorIntersections(target.ownerDocument);
        if (this._observationTargets.length == 0) this._unregisterInstance();
    };
    /**
 * Stops observing all target elements for intersection changes.
 */ IntersectionObserver.prototype.disconnect = function() {
        this._observationTargets = [];
        this._unmonitorAllIntersections();
        this._unregisterInstance();
    };
    /**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */ IntersectionObserver.prototype.takeRecords = function() {
        var records = this._queuedEntries.slice();
        this._queuedEntries = [];
        return records;
    };
    /**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */ IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
        var threshold = opt_threshold || [
            0
        ];
        if (!Array.isArray(threshold)) threshold = [
            threshold
        ];
        return threshold.sort().filter(function(t, i, a) {
            if (typeof t != "number" || isNaN(t) || t < 0 || t > 1) throw new Error("threshold must be a number between 0 and 1 inclusively");
            return t !== a[i - 1];
        });
    };
    /**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */ IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
        var marginString = opt_rootMargin || "0px";
        var margins = marginString.split(/\s+/).map(function(margin) {
            var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
            if (!parts) throw new Error("rootMargin must be specified in pixels or percent");
            return {
                value: parseFloat(parts[1]),
                unit: parts[2]
            };
        });
        // Handles shorthand.
        margins[1] = margins[1] || margins[0];
        margins[2] = margins[2] || margins[0];
        margins[3] = margins[3] || margins[1];
        return margins;
    };
    /**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */ IntersectionObserver.prototype._monitorIntersections = function(doc) {
        var win = doc.defaultView;
        if (!win) // Already destroyed.
        return;
        if (this._monitoringDocuments.indexOf(doc) != -1) // Already monitoring.
        return;
        // Private state for monitoring.
        var callback = this._checkForIntersections;
        var monitoringInterval = null;
        var domObserver = null;
        // If a poll interval is set, use polling instead of listening to
        // resize and scroll events or DOM mutations.
        if (this.POLL_INTERVAL) monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
        else {
            addEvent(win, "resize", callback, true);
            addEvent(doc, "scroll", callback, true);
            if (this.USE_MUTATION_OBSERVER && "MutationObserver" in win) {
                domObserver = new win.MutationObserver(callback);
                domObserver.observe(doc, {
                    attributes: true,
                    childList: true,
                    characterData: true,
                    subtree: true
                });
            }
        }
        this._monitoringDocuments.push(doc);
        this._monitoringUnsubscribes.push(function() {
            // Get the window object again. When a friendly iframe is destroyed, it
            // will be null.
            var win = doc.defaultView;
            if (win) {
                if (monitoringInterval) win.clearInterval(monitoringInterval);
                removeEvent(win, "resize", callback, true);
            }
            removeEvent(doc, "scroll", callback, true);
            if (domObserver) domObserver.disconnect();
        });
        // Also monitor the parent.
        if (doc != (this.root && this.root.ownerDocument || document)) {
            var frame = getFrameElement(doc);
            if (frame) this._monitorIntersections(frame.ownerDocument);
        }
    };
    /**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */ IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
        var index = this._monitoringDocuments.indexOf(doc);
        if (index == -1) return;
        var rootDoc = this.root && this.root.ownerDocument || document;
        // Check if any dependent targets are still remaining.
        var hasDependentTargets = this._observationTargets.some(function(item) {
            var itemDoc = item.element.ownerDocument;
            // Target is in this context.
            if (itemDoc == doc) return true;
            // Target is nested in this context.
            while(itemDoc && itemDoc != rootDoc){
                var frame = getFrameElement(itemDoc);
                itemDoc = frame && frame.ownerDocument;
                if (itemDoc == doc) return true;
            }
            return false;
        });
        if (hasDependentTargets) return;
        // Unsubscribe.
        var unsubscribe = this._monitoringUnsubscribes[index];
        this._monitoringDocuments.splice(index, 1);
        this._monitoringUnsubscribes.splice(index, 1);
        unsubscribe();
        // Also unmonitor the parent.
        if (doc != rootDoc) {
            var frame = getFrameElement(doc);
            if (frame) this._unmonitorIntersections(frame.ownerDocument);
        }
    };
    /**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */ IntersectionObserver.prototype._unmonitorAllIntersections = function() {
        var unsubscribes = this._monitoringUnsubscribes.slice(0);
        this._monitoringDocuments.length = 0;
        this._monitoringUnsubscribes.length = 0;
        for(var i = 0; i < unsubscribes.length; i++)unsubscribes[i]();
    };
    /**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */ IntersectionObserver.prototype._checkForIntersections = function() {
        if (!this.root && crossOriginUpdater && !crossOriginRect) // Cross origin monitoring, but no initial data available yet.
        return;
        var rootIsInDom = this._rootIsInDom();
        var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
        this._observationTargets.forEach(function(item) {
            var target = item.element;
            var targetRect = getBoundingClientRect(target);
            var rootContainsTarget = this._rootContainsTarget(target);
            var oldEntry = item.entry;
            var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);
            var newEntry = item.entry = new IntersectionObserverEntry({
                time: now(),
                target: target,
                boundingClientRect: targetRect,
                rootBounds: crossOriginUpdater && !this.root ? null : rootRect,
                intersectionRect: intersectionRect
            });
            if (!oldEntry) this._queuedEntries.push(newEntry);
            else if (rootIsInDom && rootContainsTarget) // If the new entry intersection ratio has crossed any of the
            // thresholds, add a new entry.
            {
                if (this._hasCrossedThreshold(oldEntry, newEntry)) this._queuedEntries.push(newEntry);
            } else // If the root is not in the DOM or target is not contained within
            // root but the previous entry for this target had an intersection,
            // add a new record indicating removal.
            if (oldEntry && oldEntry.isIntersecting) this._queuedEntries.push(newEntry);
        }, this);
        if (this._queuedEntries.length) this._callback(this.takeRecords(), this);
    };
    /**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */ IntersectionObserver.prototype._computeTargetAndRootIntersection = function(target, targetRect, rootRect) {
        // If the element isn't displayed, an intersection can't happen.
        if (window.getComputedStyle(target).display == "none") return;
        var intersectionRect = targetRect;
        var parent = getParentNode(target);
        var atRoot = false;
        while(!atRoot && parent){
            var parentRect = null;
            var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};
            // If the parent isn't displayed, an intersection can't happen.
            if (parentComputedStyle.display == "none") return null;
            if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
                atRoot = true;
                if (parent == this.root || parent == document) {
                    if (crossOriginUpdater && !this.root) {
                        if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
                            // A 0-size cross-origin intersection means no-intersection.
                            parent = null;
                            parentRect = null;
                            intersectionRect = null;
                        } else parentRect = crossOriginRect;
                    } else parentRect = rootRect;
                } else {
                    // Check if there's a frame that can be navigated to.
                    var frame = getParentNode(parent);
                    var frameRect = frame && getBoundingClientRect(frame);
                    var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
                    if (frameRect && frameIntersect) {
                        parent = frame;
                        parentRect = convertFromParentRect(frameRect, frameIntersect);
                    } else {
                        parent = null;
                        intersectionRect = null;
                    }
                }
            } else {
                // If the element has a non-visible overflow, and it's not the <body>
                // or <html> element, update the intersection rect.
                // Note: <body> and <html> cannot be clipped to a rect that's not also
                // the document rect, so no need to compute a new intersection.
                var doc = parent.ownerDocument;
                if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != "visible") parentRect = getBoundingClientRect(parent);
            }
            // If either of the above conditionals set a new parentRect,
            // calculate new intersection data.
            if (parentRect) intersectionRect = computeRectIntersection(parentRect, intersectionRect);
            if (!intersectionRect) break;
            parent = parent && getParentNode(parent);
        }
        return intersectionRect;
    };
    /**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */ IntersectionObserver.prototype._getRootRect = function() {
        var rootRect;
        if (this.root) rootRect = getBoundingClientRect(this.root);
        else {
            // Use <html>/<body> instead of window since scroll bars affect size.
            var html = document.documentElement;
            var body = document.body;
            rootRect = {
                top: 0,
                left: 0,
                right: html.clientWidth || body.clientWidth,
                width: html.clientWidth || body.clientWidth,
                bottom: html.clientHeight || body.clientHeight,
                height: html.clientHeight || body.clientHeight
            };
        }
        return this._expandRectByRootMargin(rootRect);
    };
    /**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */ IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
        var margins = this._rootMarginValues.map(function(margin, i) {
            return margin.unit == "px" ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
        });
        var newRect = {
            top: rect.top - margins[0],
            right: rect.right + margins[1],
            bottom: rect.bottom + margins[2],
            left: rect.left - margins[3]
        };
        newRect.width = newRect.right - newRect.left;
        newRect.height = newRect.bottom - newRect.top;
        return newRect;
    };
    /**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */ IntersectionObserver.prototype._hasCrossedThreshold = function(oldEntry, newEntry) {
        // To make comparing easier, an entry that has a ratio of 0
        // but does not actually intersect is given a value of -1
        var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
        var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;
        // Ignore unchanged ratios
        if (oldRatio === newRatio) return;
        for(var i = 0; i < this.thresholds.length; i++){
            var threshold = this.thresholds[i];
            // Return true if an entry matches a threshold or if the new ratio
            // and the old ratio are on the opposite sides of a threshold.
            if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) return true;
        }
    };
    /**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */ IntersectionObserver.prototype._rootIsInDom = function() {
        return !this.root || containsDeep(document, this.root);
    };
    /**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */ IntersectionObserver.prototype._rootContainsTarget = function(target) {
        return containsDeep(this.root || document, target) && (!this.root || this.root.ownerDocument == target.ownerDocument);
    };
    /**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */ IntersectionObserver.prototype._registerInstance = function() {
        if (registry.indexOf(this) < 0) registry.push(this);
    };
    /**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */ IntersectionObserver.prototype._unregisterInstance = function() {
        var index = registry.indexOf(this);
        if (index != -1) registry.splice(index, 1);
    };
    /**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */ function now() {
        return window.performance && performance.now && performance.now();
    }
    /**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */ function throttle(fn, timeout) {
        var timer = null;
        return function() {
            if (!timer) timer = setTimeout(function() {
                fn();
                timer = null;
            }, timeout);
        };
    }
    /**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */ function addEvent(node, event, fn, opt_useCapture) {
        if (typeof node.addEventListener == "function") node.addEventListener(event, fn, opt_useCapture || false);
        else if (typeof node.attachEvent == "function") node.attachEvent("on" + event, fn);
    }
    /**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */ function removeEvent(node, event, fn, opt_useCapture) {
        if (typeof node.removeEventListener == "function") node.removeEventListener(event, fn, opt_useCapture || false);
        else if (typeof node.detatchEvent == "function") node.detatchEvent("on" + event, fn);
    }
    /**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */ function computeRectIntersection(rect1, rect2) {
        var top = Math.max(rect1.top, rect2.top);
        var bottom = Math.min(rect1.bottom, rect2.bottom);
        var left = Math.max(rect1.left, rect2.left);
        var right = Math.min(rect1.right, rect2.right);
        var width = right - left;
        var height = bottom - top;
        return width >= 0 && height >= 0 && {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            width: width,
            height: height
        } || null;
    }
    /**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */ function getBoundingClientRect(el) {
        var rect;
        try {
            rect = el.getBoundingClientRect();
        } catch (err) {
        // Ignore Windows 7 IE11 "Unspecified error"
        // https://github.com/w3c/IntersectionObserver/pull/205
        }
        if (!rect) return getEmptyRect();
        // Older IE
        if (!(rect.width && rect.height)) rect = {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.right - rect.left,
            height: rect.bottom - rect.top
        };
        return rect;
    }
    /**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */ function getEmptyRect() {
        return {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 0,
            height: 0
        };
    }
    /**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */ function ensureDOMRect(rect) {
        // A `DOMRect` object has `x` and `y` fields.
        if (!rect || "x" in rect) return rect;
        // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
        // for internally calculated Rect objects. For the purposes of
        // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
        // for these fields.
        return {
            top: rect.top,
            y: rect.top,
            bottom: rect.bottom,
            left: rect.left,
            x: rect.left,
            right: rect.right,
            width: rect.width,
            height: rect.height
        };
    }
    /**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */ function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
        var top = parentIntersectionRect.top - parentBoundingRect.top;
        var left = parentIntersectionRect.left - parentBoundingRect.left;
        return {
            top: top,
            left: left,
            height: parentIntersectionRect.height,
            width: parentIntersectionRect.width,
            bottom: top + parentIntersectionRect.height,
            right: left + parentIntersectionRect.width
        };
    }
    /**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */ function containsDeep(parent, child) {
        var node = child;
        while(node){
            if (node == parent) return true;
            node = getParentNode(node);
        }
        return false;
    }
    /**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */ function getParentNode(node) {
        var parent = node.parentNode;
        if (node.nodeType == /* DOCUMENT */ 9 && node != document) // If this node is a document node, look for the embedding frame.
        return getFrameElement(node);
        if (parent && parent.nodeType == 11 && parent.host) // If the parent is a shadow root, return the host element.
        return parent.host;
        if (parent && parent.assignedSlot) // If the parent is distributed in a <slot>, return the parent of a slot.
        return parent.assignedSlot.parentNode;
        return parent;
    }
    /**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */ function getFrameElement(doc) {
        try {
            return doc.defaultView && doc.defaultView.frameElement || null;
        } catch (e) {
            // Ignore the error.
            return null;
        }
    }
    // Exposes the constructors globally.
    window.IntersectionObserver = IntersectionObserver;
    window.IntersectionObserverEntry = IntersectionObserverEntry;
})();

});

parcelRegister("hsH5s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb667964dbe1ed12$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");

var $kaLUp = parcelRequire("kaLUp");
var $cb667964dbe1ed12$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: "absolute",
            height: 1,
            width: 1,
            overflow: "hidden"
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: "left"
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: "center"
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: "right"
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: "justify"
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: "0.35em"
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: "inline"
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: "block"
        }
    };
};
var $cb667964dbe1ed12$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p"
};
var $cb667964dbe1ed12$var$Typography = /*#__PURE__*/ $arQ7u.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? "inherit" : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "initial" : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? "initial" : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? "body1" : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $cb667964dbe1ed12$var$defaultVariantMapping : _props$variantMapping, other = (0, $dXEVX.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? "p" : variantMapping[variant] || $cb667964dbe1ed12$var$defaultVariantMapping[variant]) || "span";
    return /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, variant !== "inherit" && classes[variant], color !== "initial" && classes["color".concat((0, $kaLUp.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== "inherit" && classes["align".concat((0, $kaLUp.default)(align))], display !== "initial" && classes["display".concat((0, $kaLUp.default)(display))]),
        ref: ref
    }, other));
});
var $cb667964dbe1ed12$export$2e2bcd8739ae039 = (0, $7EzGR.default)($cb667964dbe1ed12$export$9dd6ff9ea0189349, {
    name: "MuiTypography"
})($cb667964dbe1ed12$var$Typography);

});
parcelRegister("kaLUp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaf9e77f93adc317$export$2e2bcd8739ae039; });

var $eQGDD = parcelRequire("eQGDD");
function $eaf9e77f93adc317$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $eQGDD.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("1DhSQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("fhzsZ")).default; });

var $fhzsZ = parcelRequire("fhzsZ");

var $khEBC = parcelRequire("khEBC");
parcelRequire("4ETsb");

});
parcelRegister("fhzsZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b203f47c05801bbc$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $9sDDw = parcelRequire("9sDDw");

var $kM4k2 = parcelRequire("kM4k2");

var $khEBC = parcelRequire("khEBC");
parcelRequire("5EZvY");
var $b203f47c05801bbc$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b203f47c05801bbc$var$observerOptions = [
    "root",
    "rootMargin",
    "threshold"
];
var $b203f47c05801bbc$var$observableProps = [
    "root",
    "rootMargin",
    "threshold",
    "disabled"
];
var $b203f47c05801bbc$export$d2312e68e1f5ad00 = function(props) {
    return $b203f47c05801bbc$var$observerOptions.reduce(function(options, key) {
        var _a;
        var isRootString = key === "root" && (0, $khEBC.toString).call(props.root) === "[object String]";
        return Object.assign(options, (_a = {}, _a[key] = isRootString ? document.querySelector(props[key]) : props[key], _a));
    }, {});
};
var $b203f47c05801bbc$var$ReactIntersectionObserver = /** @class */ function(_super) {
    $b203f47c05801bbc$var$__extends(ReactIntersectionObserver, _super);
    function ReactIntersectionObserver() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function(event) {
            _this.props.onChange(event, _this.externalUnobserve);
        };
        _this.handleNode = function(target) {
            var children = _this.props.children;
            /**
             * Forward hijacked ref to user.
             */ if ((0, $khEBC.isChildrenWithRef)(children)) {
                var childenRef = children.ref;
                if (typeof childenRef === "function") childenRef(target);
                else if (childenRef && (0, $khEBC.hasOwnProperty).call(childenRef, "current")) /*
                     * The children ref.current is read-only, we aren't allowed to do this, so
                     * in future release it has to go away, and the ref shall be
                     * forwarded and assigned to a DOM node by the user.
                     */ childenRef.current = target;
            }
            _this.targetNode = undefined;
            if (target) {
                var targetNode = (0, $9sDDw.findDOMNode)(target);
                if (targetNode && targetNode.nodeType === 1) _this.targetNode = targetNode;
            }
        };
        _this.observe = function() {
            if (_this.props.children == null || _this.props.disabled) return false;
            if (!_this.targetNode) throw new Error("ReactIntersectionObserver: Can't find DOM node in the provided children. Make sure to render at least one DOM node in the tree.");
            _this.observer = (0, $kM4k2.createObserver)($b203f47c05801bbc$export$d2312e68e1f5ad00(_this.props));
            _this.target = _this.targetNode;
            (0, $kM4k2.observeElement)(_this);
            return true;
        };
        _this.unobserve = function(target) {
            (0, $kM4k2.unobserveElement)(_this, target);
        };
        _this.externalUnobserve = function() {
            if (_this.targetNode) _this.unobserve(_this.targetNode);
        };
        return _this;
    }
    ReactIntersectionObserver.prototype.getSnapshotBeforeUpdate = function(prevProps) {
        var _this = this;
        this.prevTargetNode = this.targetNode;
        var relatedPropsChanged = $b203f47c05801bbc$var$observableProps.some(function(prop) {
            return (0, $khEBC.shallowCompare)(_this.props[prop], prevProps[prop]);
        });
        if (relatedPropsChanged) {
            if (this.prevTargetNode) {
                if (!prevProps.disabled) this.unobserve(this.prevTargetNode);
            }
        }
        return relatedPropsChanged;
    };
    ReactIntersectionObserver.prototype.componentDidUpdate = function(_, __, relatedPropsChanged) {
        var targetNodeChanged = false;
        // check if we didn't unobserve previously due to a prop change
        if (!relatedPropsChanged) {
            targetNodeChanged = this.prevTargetNode !== this.targetNode;
            // check we have a previous node we want to unobserve
            if (targetNodeChanged && this.prevTargetNode != null) this.unobserve(this.prevTargetNode);
        }
        if (relatedPropsChanged || targetNodeChanged) this.observe();
    };
    ReactIntersectionObserver.prototype.componentDidMount = function() {
        this.observe();
    };
    ReactIntersectionObserver.prototype.componentWillUnmount = function() {
        if (this.targetNode) this.unobserve(this.targetNode);
    };
    ReactIntersectionObserver.prototype.render = function() {
        var children = this.props.children;
        return children != null ? (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Children.only(children), {
            ref: this.handleNode
        }) : null;
    };
    ReactIntersectionObserver.displayName = "IntersectionObserver";
    return ReactIntersectionObserver;
}((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Component);
var $b203f47c05801bbc$export$2e2bcd8739ae039 = $b203f47c05801bbc$var$ReactIntersectionObserver;

});
parcelRegister("kM4k2", function(module, exports) {

$parcel$export(module.exports, "createObserver", function () { return $f1fba4a3a8039d02$export$9e6a5ff84f57576; });
$parcel$export(module.exports, "observeElement", function () { return $f1fba4a3a8039d02$export$9137ee61fe58d50e; });
$parcel$export(module.exports, "unobserveElement", function () { return $f1fba4a3a8039d02$export$4d125402ac99f1b; });

var $khEBC = parcelRequire("khEBC");
var $f1fba4a3a8039d02$export$15ae5810cd32ac8e = new Map();
function $f1fba4a3a8039d02$export$ea0b39db4c225769(options) {
    if (options === void 0) options = {};
    var root = options.root || null;
    var rootMargin = (0, $khEBC.parseRootMargin)(options.rootMargin);
    var threshold = Array.isArray(options.threshold) ? options.threshold : [
        options.threshold != null ? options.threshold : 0
    ];
    var observers = $f1fba4a3a8039d02$export$15ae5810cd32ac8e.keys();
    var observer;
    while(observer = observers.next().value){
        var unmatched = root !== observer.root || rootMargin !== observer.rootMargin || (0, $khEBC.shallowCompare)(threshold, observer.thresholds);
        if (!unmatched) return observer;
    }
    return null;
}
function $f1fba4a3a8039d02$export$4ac60e7ac6e753a5(observer, entry) {
    var elements = $f1fba4a3a8039d02$export$15ae5810cd32ac8e.get(observer);
    if (elements) {
        var values = elements.values();
        var element = void 0;
        while(element = values.next().value){
            if (element.target === entry.target) return element;
        }
    }
    return null;
}
function $f1fba4a3a8039d02$export$eb872837e3137261(entries, observer) {
    for(var i = 0; i < entries.length; i++){
        var element = $f1fba4a3a8039d02$export$4ac60e7ac6e753a5(observer, entries[i]);
        /* istanbul ignore next line */ if (element) element.handleChange(entries[i]);
    }
}
function $f1fba4a3a8039d02$export$9e6a5ff84f57576(options) {
    var pooled = $f1fba4a3a8039d02$export$ea0b39db4c225769(options);
    if (pooled) return pooled;
    var observer = new IntersectionObserver($f1fba4a3a8039d02$export$eb872837e3137261, options);
    $f1fba4a3a8039d02$export$15ae5810cd32ac8e.set(observer, new Set());
    return observer;
}
function $f1fba4a3a8039d02$export$9137ee61fe58d50e(element) {
    var _a;
    if (element.observer && !$f1fba4a3a8039d02$export$15ae5810cd32ac8e.has(element.observer)) $f1fba4a3a8039d02$export$15ae5810cd32ac8e.set(element.observer, new Set());
    (_a = $f1fba4a3a8039d02$export$15ae5810cd32ac8e.get(element.observer)) === null || _a === void 0 || _a.add(element);
    element.observer.observe(element.target);
}
function $f1fba4a3a8039d02$export$4d125402ac99f1b(element, target) {
    if ($f1fba4a3a8039d02$export$15ae5810cd32ac8e.has(element.observer)) {
        var targets = $f1fba4a3a8039d02$export$15ae5810cd32ac8e.get(element.observer);
        if (targets === null || targets === void 0 ? void 0 : targets.delete(element)) {
            if (targets.size > 0) element.observer.unobserve(target);
            else {
                element.observer.disconnect();
                $f1fba4a3a8039d02$export$15ae5810cd32ac8e.delete(element.observer);
            }
        }
    }
}

});
parcelRegister("khEBC", function(module, exports) {

$parcel$export(module.exports, "parseRootMargin", function () { return $ec44e4a78a119285$export$de484a340a88ad5a; });
$parcel$export(module.exports, "shallowCompare", function () { return $ec44e4a78a119285$export$90e866afbd6b9f1a; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $ec44e4a78a119285$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "toString", function () { return $ec44e4a78a119285$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "isChildrenWithRef", function () { return $ec44e4a78a119285$export$d98f1c5e81a96584; });
$parcel$export(module.exports, "thresholdCacheKey", function () { return $ec44e4a78a119285$export$61ddcd3328730b2e; });
var $ec44e4a78a119285$var$_a;
var $ec44e4a78a119285$var$marginRE = /^-?\d*\.?\d+(px|%)$/;
function $ec44e4a78a119285$export$de484a340a88ad5a(rootMargin) {
    var marginString = rootMargin ? rootMargin.trim() : "0px";
    var result = marginString.split(/\s+/).map(function(margin) {
        if (!$ec44e4a78a119285$var$marginRE.test(margin)) throw new Error("rootMargin must be a string literal containing pixels and/or percent values");
        return margin;
    });
    var m0 = result.shift();
    var _a = result[0], m1 = _a === void 0 ? m0 : _a, _b = result[1], m2 = _b === void 0 ? m0 : _b, _c = result[2], m3 = _c === void 0 ? m1 : _c;
    return m0 + " " + m1 + " " + m2 + " " + m3;
}
function $ec44e4a78a119285$export$90e866afbd6b9f1a(next, prev) {
    if (Array.isArray(next) && Array.isArray(prev)) {
        if (next.length === prev.length) return next.some(function(_, index) {
            return $ec44e4a78a119285$export$90e866afbd6b9f1a(next[index], prev[index]);
        });
    }
    return next !== prev;
}
var $ec44e4a78a119285$export$5a15a386532a5ea4 = ($ec44e4a78a119285$var$_a = Object.prototype, $ec44e4a78a119285$var$_a.hasOwnProperty), $ec44e4a78a119285$export$f84e8e69fd4488a5 = $ec44e4a78a119285$var$_a.toString;
function $ec44e4a78a119285$export$d98f1c5e81a96584(children) {
    return children && $ec44e4a78a119285$export$5a15a386532a5ea4.call(children, "ref");
}
function $ec44e4a78a119285$export$61ddcd3328730b2e(threshold) {
    if (!threshold || typeof threshold === "number") return threshold;
    return threshold.join(",");
}

});


parcelRegister("5EZvY", function(module, exports) {

});


parcelRegister("4ETsb", function(module, exports) {

var $arQ7u = parcelRequire("arQ7u");

var $kM4k2 = parcelRequire("kM4k2");

var $khEBC = parcelRequire("khEBC");
var $3645e9c67fb1fce0$var$noop = function() {};
var $3645e9c67fb1fce0$export$a7395f9832c00176 = function(/**
 * Function that will be invoked whenever the intersection value for this element changes.
 */ onChange, _a) {
    var _b = _a === void 0 ? {} : _a, root = _b.root, rootMargin = _b.rootMargin, threshold = _b.threshold, disabled = _b.disabled;
    var observingRef = (0, $arQ7u.useRef)(false);
    var instanceRef = (0, $arQ7u.useRef)({
        // unobserve function needs an instance and instance.handleChange needs an unobserve to be caught by closure.
        // So it's essentially a circular reference that's resolved by assigning handleChange later
        handleChange: function(event) {
            /* istanbul ignore next line */ onChange(event, $3645e9c67fb1fce0$var$noop);
        }
    });
    var unobserve = (0, $arQ7u.useCallback)(function() {
        if (instanceRef.current.target && observingRef.current) {
            (0, $kM4k2.unobserveElement)(instanceRef.current, instanceRef.current.target);
            observingRef.current = false;
        }
    }, []);
    instanceRef.current.handleChange = function handleChange(event) {
        /* istanbul ignore next line */ onChange(event, unobserve);
    };
    var observe = function() {
        if (instanceRef.current.observer && instanceRef.current.target && !observingRef.current) {
            (0, $kM4k2.observeElement)(instanceRef.current);
            observingRef.current = true;
        }
    };
    var memoizedThreshold = (0, $arQ7u.useMemo)(function() {
        return threshold;
    }, [
        (0, $khEBC.thresholdCacheKey)(threshold)
    ]);
    var observer = (0, $arQ7u.useMemo)(function() {
        if (disabled) {
            unobserve();
            instanceRef.current.observer = undefined;
            return undefined;
        }
        var rootOption = typeof root === "string" ? document.querySelector(root) : root;
        var obs = (0, $kM4k2.createObserver)({
            root: rootOption,
            rootMargin: rootMargin,
            threshold: memoizedThreshold
        });
        instanceRef.current.observer = obs;
        unobserve();
        observe();
        return obs;
    }, [
        root,
        rootMargin,
        memoizedThreshold,
        disabled
    ]);
    var setRef = (0, $arQ7u.useCallback)(function(node) {
        var isNewNode = node != null && instanceRef.current.target !== node;
        if (!observer) unobserve();
        if (isNewNode) {
            unobserve();
            instanceRef.current.target = node;
            observe();
        }
        if (!node) {
            unobserve();
            instanceRef.current.target = undefined;
        }
    }, [
        observer
    ]);
    return [
        setRef,
        unobserve
    ];
};

});




parcelRegister("1xlvK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11e98f28d6c90cd9$export$2e2bcd8739ae039; });

var $Kyao2 = parcelRequire("Kyao2");

var $bT1Wq = parcelRequire("bT1Wq");
/**
 * export ns - sets up css namespacing for everything to be `mirador-`
 */ var $11e98f28d6c90cd9$var$ns = function ns(classNames) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))([
        classNames
    ]).map(function(className) {
        return [
            (0, $Kyao2.default).createGenerateClassNameOptions.productionPrefix,
            className
        ].join("-");
    }).join(" ");
};
var $11e98f28d6c90cd9$export$2e2bcd8739ae039 = $11e98f28d6c90cd9$var$ns;

});





parcelRegister("caSXf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dd10c086a4c10d4$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $dj0kG = parcelRequire("dj0kG");
var $1MgBx = parcelRequire("1MgBx");

var $ddtyi = parcelRequire("ddtyi");
/**
 * mapStateToProps - to hook up connect
 * @memberof WindowSideBarAnnotationsPanel
 * @private
 */ var $8dd10c086a4c10d4$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var windowId = _ref.windowId;
    return {
        annotationCount: (0, $dj0kG.getAnnotationResourcesByMotivation)(state, {
            windowId: windowId
        }).length,
        canvasIds: (0, $1MgBx.getVisibleCanvasIds)(state, {
            windowId: windowId
        })
    };
};
/** */ var $8dd10c086a4c10d4$var$styles = function styles(theme) {
    return {
        section: {
            borderBottom: ".5px solid ".concat(theme.palette.section_divider),
            paddingBottom: theme.spacing(1),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(1),
            paddingTop: theme.spacing(2)
        }
    };
};
var $8dd10c086a4c10d4$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $7EzGR.default)($8dd10c086a4c10d4$var$styles), (0, $fbonu.default)($8dd10c086a4c10d4$var$mapStateToProps, null), (0, $7XHRd.withPlugins)("WindowSideBarAnnotationsPanel") // further HOC
);
var $8dd10c086a4c10d4$export$2e2bcd8739ae039 = $8dd10c086a4c10d4$var$enhance((0, $ddtyi.WindowSideBarAnnotationsPanel));

});
parcelRegister("dj0kG", function(module, exports) {

$parcel$export(module.exports, "getAnnotations", function () { return $9afd4ec32f9b0691$export$ef1244b182aaad16; });
$parcel$export(module.exports, "getPresentAnnotationsOnSelectedCanvases", function () { return $9afd4ec32f9b0691$export$aa14bcf5c2342be; });
$parcel$export(module.exports, "getAnnotationResourcesByMotivationForCanvas", function () { return $9afd4ec32f9b0691$export$aa99390b2b864b28; });
$parcel$export(module.exports, "getAnnotationResourcesByMotivation", function () { return $9afd4ec32f9b0691$export$94548d933cf81e74; });
$parcel$export(module.exports, "getSelectedAnnotationId", function () { return $9afd4ec32f9b0691$export$6ff4687c5af47dd2; });
$parcel$export(module.exports, "getSelectedAnnotationsOnCanvases", function () { return $9afd4ec32f9b0691$export$c07029c8a0cd588e; });

var $1LbRi = parcelRequire("1LbRi");

var $aML5Q = parcelRequire("aML5Q");

var $bT1Wq = parcelRequire("bT1Wq");

var $7SqqM = parcelRequire("7SqqM");

var $fr77o = parcelRequire("fr77o");

var $1MgBx = parcelRequire("1MgBx");

var $jGts0 = parcelRequire("jGts0");

var $dy9HC = parcelRequire("dy9HC");
var $9afd4ec32f9b0691$var$_excluded = [
    "canvasId"
];
function $9afd4ec32f9b0691$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9afd4ec32f9b0691$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9afd4ec32f9b0691$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9afd4ec32f9b0691$export$ef1244b182aaad16 = function getAnnotations(state) {
    return (0, $fr77o.miradorSlice)(state).annotations;
};
var $9afd4ec32f9b0691$var$getMotivation = (0, $1LbRi.createSelector)([
    (0, $jGts0.getConfig),
    function(state, _ref) {
        var motivations = _ref.motivations;
        return motivations;
    }
], function(config, motivations) {
    return motivations || config.annotations.filteredMotivations;
});
var $9afd4ec32f9b0691$var$getAnnotationsOnCanvas = (0, $1LbRi.createSelector)([
    (0, $1MgBx.getCanvas),
    $9afd4ec32f9b0691$export$ef1244b182aaad16
], function(canvas, annotations) {
    if (!annotations || !canvas) return [];
    if (!annotations[canvas.id]) return [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(Object.values(annotations[canvas.id]));
});
var $9afd4ec32f9b0691$var$getPresentAnnotationsCanvas = (0, $1LbRi.createSelector)([
    $9afd4ec32f9b0691$var$getAnnotationsOnCanvas
], function(annotations) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aML5Q)))(Object.values(annotations).map(function(annotation) {
        return annotation && (0, $7SqqM.default).determineAnnotation(annotation.json);
    }), function(annotation) {
        return annotation && annotation.present();
    });
});
var $9afd4ec32f9b0691$var$getAnnotationsOnSelectedCanvases = (0, $1LbRi.createSelector)([
    function(state, _ref2) {
        var canvasId = _ref2.canvasId, otherProps = $9afd4ec32f9b0691$var$_objectWithoutProperties(_ref2, $9afd4ec32f9b0691$var$_excluded);
        return canvasId ? [
            canvasId
        ] : (0, $1MgBx.getVisibleCanvasIds)(state, otherProps);
    },
    $9afd4ec32f9b0691$export$ef1244b182aaad16
], function(canvasIds, annotations) {
    if (!annotations || canvasIds.length === 0) return [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(canvasIds.map(function(targetId) {
        return annotations[targetId] && Object.values(annotations[targetId]);
    }));
});
var $9afd4ec32f9b0691$export$aa14bcf5c2342be = (0, $1LbRi.createSelector)([
    $9afd4ec32f9b0691$var$getAnnotationsOnSelectedCanvases
], function(annotations) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aML5Q)))(Object.values(annotations).map(function(annotation) {
        return annotation && (0, $7SqqM.default).determineAnnotation(annotation.json);
    }), function(annotation) {
        return annotation && annotation.present();
    });
});
var $9afd4ec32f9b0691$export$aa99390b2b864b28 = (0, $1LbRi.createSelector)([
    $9afd4ec32f9b0691$var$getPresentAnnotationsCanvas,
    $9afd4ec32f9b0691$var$getMotivation
], function(annotations, motivations) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aML5Q)))((0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(annotations.map(function(annotation) {
        return annotation.resources;
    })), function(resource) {
        return resource.motivations.some(function(motivation) {
            return motivations.includes(motivation);
        });
    });
});
var $9afd4ec32f9b0691$export$94548d933cf81e74 = (0, $1LbRi.createSelector)([
    $9afd4ec32f9b0691$export$aa14bcf5c2342be,
    $9afd4ec32f9b0691$var$getMotivation
], function(annotations, motivations) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aML5Q)))((0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(annotations.map(function(annotation) {
        return annotation.resources;
    })), function(resource) {
        return resource.motivations.some(function(motivation) {
            return motivations.includes(motivation);
        });
    });
});
var $9afd4ec32f9b0691$export$6ff4687c5af47dd2 = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWindow)
], function(_ref3) {
    var selectedAnnotationId = _ref3.selectedAnnotationId;
    return selectedAnnotationId;
});
var $9afd4ec32f9b0691$export$c07029c8a0cd588e = (0, $1LbRi.createSelector)([
    $9afd4ec32f9b0691$export$aa14bcf5c2342be,
    $9afd4ec32f9b0691$export$6ff4687c5af47dd2
], function(canvasAnnotations, selectedAnnotationId) {
    return canvasAnnotations.map(function(annotation) {
        return {
            id: annotation["@id"] || annotation.id,
            resources: annotation.resources.filter(function(r) {
                return selectedAnnotationId === r.id;
            })
        };
    }).filter(function(val) {
        return val.resources.length > 0;
    });
});

});
parcelRegister("aML5Q", function(module, exports) {

var $geLbU = parcelRequire("geLbU");

var $b6KMj = parcelRequire("b6KMj");

var $hChE7 = parcelRequire("hChE7");

var $eDRhj = parcelRequire("eDRhj");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $7da2eacdb9092b06$var$filter(collection, predicate) {
    var func = $eDRhj(collection) ? $geLbU : $b6KMj;
    return func(collection, $hChE7(predicate, 3));
}
module.exports = $7da2eacdb9092b06$var$filter;

});
parcelRegister("b6KMj", function(module, exports) {

var $dWrTD = parcelRequire("dWrTD");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $81648a6ab3da1cf3$var$baseFilter(collection, predicate) {
    var result = [];
    $dWrTD(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $81648a6ab3da1cf3$var$baseFilter;

});


parcelRegister("7SqqM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bc21433356bb7c8$export$2e2bcd8739ae039; });

var $cfUZ3 = parcelRequire("cfUZ3");

var $lNkUm = parcelRequire("lNkUm");
function $5bc21433356bb7c8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5bc21433356bb7c8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5bc21433356bb7c8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5bc21433356bb7c8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5bc21433356bb7c8$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Used to determine the type of Annotation supported by a version of the IIIF
 * Presentation API.
 */ var $5bc21433356bb7c8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnnotationFactory() {
        $5bc21433356bb7c8$var$_classCallCheck(this, AnnotationFactory);
    }
    $5bc21433356bb7c8$var$_createClass(AnnotationFactory, null, [
        {
            key: "determineAnnotation",
            value: /** */ function determineAnnotation(json, target) {
                if (!json) return null;
                 // IIIF Presentation API v3. AnnotationPage
                if (json.type === "AnnotationPage") return new (0, $lNkUm.default)(json, target);
                 // IIIF Presentation API v2. OpenAnnotation and SharedCanvas models
                return new (0, $cfUZ3.default)(json, target);
            }
        }
    ]);
    return AnnotationFactory;
}();

});
parcelRegister("cfUZ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec316891a924178$export$2e2bcd8739ae039; });

var $bT1Wq = parcelRequire("bT1Wq");

var $2rGCc = parcelRequire("2rGCc");
function $8ec316891a924178$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8ec316891a924178$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8ec316891a924178$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8ec316891a924178$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8ec316891a924178$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/** */ var $8ec316891a924178$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /** */ function AnnotationList(json, target) {
        $8ec316891a924178$var$_classCallCheck(this, AnnotationList);
        this.json = json;
        this.target = target;
    }
    /** */ $8ec316891a924178$var$_createClass(AnnotationList, [
        {
            key: "id",
            get: function get() {
                return this.json["@id"];
            }
        },
        {
            key: "present",
            value: function present() {
                return this.resources && this.resources.length > 0;
            }
        },
        {
            key: "resources",
            get: function get() {
                var _this = this;
                this._resources = this._resources || function() {
                    // eslint-disable-line no-underscore-dangle
                    if (!_this.json || !_this.json.resources) return [];
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))([
                        _this.json.resources
                    ]).map(function(resource) {
                        return new (0, $2rGCc.default)(resource);
                    });
                }();
                return this._resources; // eslint-disable-line no-underscore-dangle
            }
        }
    ]);
    return AnnotationList;
}();

});
parcelRegister("2rGCc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c7f28e2b36c0e28$export$2e2bcd8739ae039; });

var $2QlC3 = parcelRequire("2QlC3");

var $bT1Wq = parcelRequire("bT1Wq");

var $aowE3 = parcelRequire("aowE3");
function $1c7f28e2b36c0e28$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1c7f28e2b36c0e28$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1c7f28e2b36c0e28$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1c7f28e2b36c0e28$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1c7f28e2b36c0e28$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/** */ var $1c7f28e2b36c0e28$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /** */ function AnnotationResource() {
        var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $1c7f28e2b36c0e28$var$_classCallCheck(this, AnnotationResource);
        this.resource = resource;
    }
    /** */ $1c7f28e2b36c0e28$var$_createClass(AnnotationResource, [
        {
            key: "isOnlyTag",
            value: function isOnlyTag() {
                return this.motivations.length === 1 && this.motivations[0] === "oa:tagging";
            }
        },
        {
            key: "id",
            get: function get() {
                this._id = this._id || this.resource["@id"] || this.resources[0] && this.resources[0]["@id"] || (0, $aowE3.default)();
                return this._id; // eslint-disable-line no-underscore-dangle
            }
        },
        {
            key: "targetId",
            get: function get() {
                var on = this.on[0];
                switch(typeof on){
                    case "string":
                        return on.replace(/#?xywh=(.*)$/, "");
                    case "object":
                        return on.full.replace(/#?xywh=(.*)$/, "");
                    default:
                        return null;
                }
            }
        },
        {
            key: "motivations",
            get: function get() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))((0, (/*@__PURE__*/$parcel$interopDefault($2QlC3)))(new Array(this.resource.motivation)));
            }
        },
        {
            key: "resources",
            get: function get() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))((0, (/*@__PURE__*/$parcel$interopDefault($2QlC3)))(new Array(this.resource.resource)));
            }
        },
        {
            key: "on",
            get: function get() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))((0, (/*@__PURE__*/$parcel$interopDefault($2QlC3)))(new Array(this.resource.on)));
            }
        },
        {
            key: "tags",
            get: function get() {
                if (this.isOnlyTag()) return this.resources.map(function(r) {
                    return r.chars;
                });
                return this.resources.filter(function(r) {
                    return r["@type"] === "oa:Tag";
                }).map(function(r) {
                    return r.chars;
                });
            }
        },
        {
            key: "chars",
            get: function get() {
                return this.resources.filter(function(r) {
                    return r["@type"] !== "oa:Tag";
                }).map(function(r) {
                    return r.chars;
                }).join(" ");
            }
        },
        {
            key: "selector",
            get: function get() {
                var on = this.on[0];
                switch(typeof on){
                    case "string":
                        return on;
                    case "object":
                        // For choices, just return the default for now. FIXME: enhance for SVG
                        // selectors
                        if (on.selector["@type"] === "oa:Choice") return on.selector["default"];
                        return on.selector;
                    default:
                        return null;
                }
            }
        },
        {
            key: "svgSelector",
            get: function get() {
                var on = this.on[0];
                switch(typeof on){
                    case "string":
                        return null;
                    case "object":
                        if (on.selector && on.selector.item && on.selector.item["@type"] === "oa:SvgSelector") return on.selector.item;
                        return null;
                    default:
                        return null;
                }
            }
        },
        {
            key: "fragmentSelector",
            get: function get() {
                var selector = this.selector;
                var match;
                switch(typeof selector){
                    case "string":
                        match = selector.match(/xywh=(.*)$/);
                        break;
                    case "object":
                        match = selector.value.match(/xywh=(.*)$/);
                        break;
                    default:
                        return null;
                }
                return match && match[1].split(",").map(function(str) {
                    return parseInt(str, 10);
                });
            }
        }
    ]);
    return AnnotationResource;
}();

});
parcelRegister("2QlC3", function(module, exports) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function $212133f6d3de7608$var$compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = $212133f6d3de7608$var$compact;

});



parcelRegister("lNkUm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdde64804e5f3f09$export$2e2bcd8739ae039; });

var $bT1Wq = parcelRequire("bT1Wq");

var $2kO0C = parcelRequire("2kO0C");
function $fdde64804e5f3f09$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fdde64804e5f3f09$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fdde64804e5f3f09$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fdde64804e5f3f09$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fdde64804e5f3f09$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Annotation representation for IIIF Presentation v3
 * https://iiif.io/api/presentation/3.0/#55-annotation-page
 */ var $fdde64804e5f3f09$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /** */ function AnnotationPage(json, target) {
        $fdde64804e5f3f09$var$_classCallCheck(this, AnnotationPage);
        this.json = json;
        this.target = target;
    }
    /** */ $fdde64804e5f3f09$var$_createClass(AnnotationPage, [
        {
            key: "id",
            get: function get() {
                return this.json.id;
            }
        },
        {
            key: "present",
            value: function present() {
                return this.items && this.items.length > 0;
            }
        },
        {
            key: "items",
            get: function get() {
                var _this = this;
                this._items = this._items || function() {
                    // eslint-disable-line no-underscore-dangle
                    if (!_this.json || !_this.json.items) return [];
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))([
                        _this.json.items
                    ]).map(function(resource) {
                        return new (0, $2kO0C.default)(resource);
                    });
                }();
                return this._items; // eslint-disable-line no-underscore-dangle
            }
        },
        {
            key: "resources",
            get: function get() {
                return this.items;
            }
        }
    ]);
    return AnnotationPage;
}();

});
parcelRegister("2kO0C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b343dc09a6766ac$export$2e2bcd8739ae039; });

var $2QlC3 = parcelRequire("2QlC3");

var $bT1Wq = parcelRequire("bT1Wq");

var $aowE3 = parcelRequire("aowE3");
function $1b343dc09a6766ac$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1b343dc09a6766ac$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1b343dc09a6766ac$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1b343dc09a6766ac$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1b343dc09a6766ac$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * A modeled WebAnnotation item
 */ var $1b343dc09a6766ac$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /** */ function AnnotationItem() {
        var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $1b343dc09a6766ac$var$_classCallCheck(this, AnnotationItem);
        this.resource = resource;
    }
    /** */ $1b343dc09a6766ac$var$_createClass(AnnotationItem, [
        {
            key: "isOnlyTag",
            value: function isOnlyTag() {
                return this.motivations.length === 1 && this.motivations[0] === "tagging";
            }
        },
        {
            key: "id",
            get: function get() {
                this._id = this._id || this.resource.id || (0, $aowE3.default)(); // eslint-disable-line no-underscore-dangle
                return this._id; // eslint-disable-line no-underscore-dangle
            }
        },
        {
            key: "targetId",
            get: function get() {
                var target = this.target[0];
                switch(typeof target){
                    case "string":
                        return target.replace(/#?xywh=(.*)$/, "");
                    case "object":
                        return target.source && target.source.id || target.source || target.id;
                    default:
                        return null;
                }
            }
        },
        {
            key: "motivations",
            get: function get() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))((0, (/*@__PURE__*/$parcel$interopDefault($2QlC3)))(new Array(this.resource.motivation)));
            }
        },
        {
            key: "body",
            get: function get() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))((0, (/*@__PURE__*/$parcel$interopDefault($2QlC3)))(new Array(this.resource.body)));
            }
        },
        {
            key: "resources",
            get: function get() {
                return this.body;
            }
        },
        {
            key: "tags",
            get: function get() {
                if (this.isOnlyTag()) return this.body.map(function(r) {
                    return r.value;
                });
                return this.body.filter(function(r) {
                    return r.purpose === "tagging";
                }).map(function(r) {
                    return r.value;
                });
            }
        },
        {
            key: "target",
            get: function get() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))((0, (/*@__PURE__*/$parcel$interopDefault($2QlC3)))(new Array(this.resource.target)));
            }
        },
        {
            key: "chars",
            get: function get() {
                if (this.isOnlyTag()) return null;
                return this.body.filter(function(r) {
                    return r.purpose !== "tagging";
                }).map(function(r) {
                    return r.value;
                }).join(" ");
            }
        },
        {
            key: "selector",
            get: function get() {
                var target = this.target[0];
                switch(typeof target){
                    case "string":
                        return target;
                    case "object":
                        return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))((0, (/*@__PURE__*/$parcel$interopDefault($2QlC3)))(new Array(target.selector)));
                    default:
                        return null;
                }
            }
        },
        {
            key: "svgSelector",
            get: function get() {
                var selector = this.selector;
                switch(typeof selector){
                    case "string":
                        return null;
                    case "object":
                        return selector.find(function(s) {
                            return s.type && s.type === "SvgSelector";
                        });
                    default:
                        return null;
                }
            }
        },
        {
            key: "fragmentSelector",
            get: function get() {
                var selector = this.selector;
                var match;
                var fragmentSelector;
                switch(typeof selector){
                    case "string":
                        match = selector.match(/xywh=(.*)$/);
                        break;
                    case "object":
                        fragmentSelector = selector.find(function(s) {
                            return s.type && s.type === "FragmentSelector";
                        });
                        match = fragmentSelector && fragmentSelector.value.match(/xywh=(.*)$/);
                        break;
                    default:
                        return null;
                }
                return match && match[1].split(",").map(function(str) {
                    return parseInt(str, 10);
                });
            }
        }
    ]);
    return AnnotationItem;
}();

});




parcelRegister("ddtyi", function(module, exports) {

$parcel$export(module.exports, "WindowSideBarAnnotationsPanel", function () { return $99f369b0f41ce303$export$38df5120230f8b23; });

var $arQ7u = parcelRequire("arQ7u");

var $hsH5s = parcelRequire("hsH5s");

var $9MiYo = parcelRequire("9MiYo");

var $3UJeG = parcelRequire("3UJeG");

var $iXAXt = parcelRequire("iXAXt");

var $1xlvK = parcelRequire("1xlvK");
function $99f369b0f41ce303$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $99f369b0f41ce303$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $99f369b0f41ce303$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $99f369b0f41ce303$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $99f369b0f41ce303$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $99f369b0f41ce303$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $99f369b0f41ce303$var$_setPrototypeOf(subClass, superClass);
}
function $99f369b0f41ce303$var$_setPrototypeOf(o, p) {
    $99f369b0f41ce303$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $99f369b0f41ce303$var$_setPrototypeOf(o, p);
}
function $99f369b0f41ce303$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $99f369b0f41ce303$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $99f369b0f41ce303$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $99f369b0f41ce303$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $99f369b0f41ce303$var$_possibleConstructorReturn(this, result);
    };
}
function $99f369b0f41ce303$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $99f369b0f41ce303$var$_assertThisInitialized(self);
}
function $99f369b0f41ce303$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $99f369b0f41ce303$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $99f369b0f41ce303$var$_getPrototypeOf(o) {
    $99f369b0f41ce303$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $99f369b0f41ce303$var$_getPrototypeOf(o);
}
var $99f369b0f41ce303$export$38df5120230f8b23 = /*#__PURE__*/ function(_Component) {
    $99f369b0f41ce303$var$_inherits(WindowSideBarAnnotationsPanel, _Component);
    var _super = $99f369b0f41ce303$var$_createSuper(WindowSideBarAnnotationsPanel);
    /** */ function WindowSideBarAnnotationsPanel(props) {
        var _this;
        $99f369b0f41ce303$var$_classCallCheck(this, WindowSideBarAnnotationsPanel);
        _this = _super.call(this, props);
        _this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createRef();
        return _this;
    }
    /**
   * Returns the rendered component
  */ $99f369b0f41ce303$var$_createClass(WindowSideBarAnnotationsPanel, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, annotationCount = _this$props.annotationCount, classes = _this$props.classes, canvasIds = _this$props.canvasIds, t = _this$props.t, windowId = _this$props.windowId, id = _this$props.id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iXAXt.default), {
                    title: t("annotations"),
                    paperClassName: (0, $1xlvK.default)("window-sidebar-annotation-panel"),
                    windowId: windowId,
                    id: id,
                    ref: this.containerRef,
                    otherRef: this.containerRef,
                    titleControls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $9MiYo.default), {
                        windowId: windowId
                    })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    className: classes.section
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    component: "p",
                    variant: "subtitle2"
                }, t("showingNumAnnotations", {
                    count: annotationCount,
                    number: annotationCount
                }))), canvasIds.map(function(canvasId, index) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $3UJeG.default), {
                        canvasId: canvasId,
                        containerRef: _this2.containerRef,
                        key: canvasId,
                        index: index,
                        totalSize: canvasIds.length,
                        windowId: windowId
                    });
                }));
            }
        }
    ]);
    return WindowSideBarAnnotationsPanel;
}((0, $arQ7u.Component));
$99f369b0f41ce303$export$38df5120230f8b23.defaultProps = {
    canvasIds: [],
    t: function t(key) {
        return key;
    }
};

});
parcelRegister("9MiYo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71e750638e6a184f$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $61Aec = parcelRequire("61Aec");

var $7XHRd = parcelRequire("7XHRd");

var $dj0kG = parcelRequire("dj0kG");
var $dy9HC = parcelRequire("dy9HC");

var $73H09 = parcelRequire("73H09");
/**
 * Mapping redux state to component props using connect
 */ var $71e750638e6a184f$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var windowId = _ref.windowId;
    return {
        displayAll: (0, $dy9HC.getWindow)(state, {
            windowId: windowId
        }).highlightAllAnnotations,
        displayAllDisabled: (0, $dj0kG.getAnnotationResourcesByMotivation)(state, {
            windowId: windowId
        }).length < 2
    };
};
/**
 * Mapping redux action dispatches to component props using connect
 */ var $71e750638e6a184f$var$mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
    var windowId = _ref2.windowId;
    return {
        toggleAnnotationDisplay: function toggleAnnotationDisplay() {
            dispatch($61Aec.toggleAnnotationDisplay(windowId));
        }
    };
};
var $71e750638e6a184f$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $fbonu.default)($71e750638e6a184f$var$mapStateToProps, $71e750638e6a184f$var$mapDispatchToProps), (0, $7XHRd.withPlugins)("AnnotationSettings"));
var $71e750638e6a184f$export$2e2bcd8739ae039 = $71e750638e6a184f$var$enhance((0, $73H09.AnnotationSettings));

});
parcelRegister("73H09", function(module, exports) {

$parcel$export(module.exports, "AnnotationSettings", function () { return $523a2b6e014b3934$export$9f0f2098b07af05e; });

var $arQ7u = parcelRequire("arQ7u");

var $lEwG9 = parcelRequire("lEwG9");

var $hWehD = parcelRequire("hWehD");

var $029Oc = parcelRequire("029Oc");
function $523a2b6e014b3934$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $523a2b6e014b3934$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $523a2b6e014b3934$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $523a2b6e014b3934$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $523a2b6e014b3934$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $523a2b6e014b3934$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $523a2b6e014b3934$var$_setPrototypeOf(subClass, superClass);
}
function $523a2b6e014b3934$var$_setPrototypeOf(o, p) {
    $523a2b6e014b3934$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $523a2b6e014b3934$var$_setPrototypeOf(o, p);
}
function $523a2b6e014b3934$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $523a2b6e014b3934$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $523a2b6e014b3934$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $523a2b6e014b3934$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $523a2b6e014b3934$var$_possibleConstructorReturn(this, result);
    };
}
function $523a2b6e014b3934$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $523a2b6e014b3934$var$_assertThisInitialized(self);
}
function $523a2b6e014b3934$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $523a2b6e014b3934$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $523a2b6e014b3934$var$_getPrototypeOf(o) {
    $523a2b6e014b3934$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $523a2b6e014b3934$var$_getPrototypeOf(o);
}
var $523a2b6e014b3934$export$9f0f2098b07af05e = /*#__PURE__*/ function(_Component) {
    $523a2b6e014b3934$var$_inherits(AnnotationSettings, _Component);
    var _super = $523a2b6e014b3934$var$_createSuper(AnnotationSettings);
    function AnnotationSettings() {
        $523a2b6e014b3934$var$_classCallCheck(this, AnnotationSettings);
        return _super.apply(this, arguments);
    }
    $523a2b6e014b3934$var$_createClass(AnnotationSettings, [
        {
            key: "render",
            value: /**
     * Returns the rendered component
    */ function render() {
                var _this$props = this.props, displayAll = _this$props.displayAll, displayAllDisabled = _this$props.displayAllDisabled, t = _this$props.t, toggleAnnotationDisplay = _this$props.toggleAnnotationDisplay;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $029Oc.default), {
                    "aria-label": t(displayAll ? "displayNoAnnotations" : "highlightAllAnnotations"),
                    onClick: toggleAnnotationDisplay,
                    disabled: displayAllDisabled,
                    size: "small"
                }, displayAll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lEwG9))), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWehD))), null));
            }
        }
    ]);
    return AnnotationSettings;
}((0, $arQ7u.Component));

});
parcelRegister("lEwG9", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc36aec2893e12dc$var$React = $363GR((parcelRequire("arQ7u")));

var $fc36aec2893e12dc$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $fc36aec2893e12dc$var$_default = (0, $fc36aec2893e12dc$var$_createSvgIcon.default)(/*#__PURE__*/ $fc36aec2893e12dc$var$React.createElement("path", {
    d: "M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
}), "VisibilitySharp");
module.exports.default = $fc36aec2893e12dc$var$_default;

});
parcelRegister("kr74f", function(module, exports) {
function $ee0bcfbd63b8c1f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $ee0bcfbd63b8c1f9$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("363GR", function(module, exports) {

var $difjz = parcelRequire("difjz");
var $2414cb70ecc2edd8$var$_typeof = $difjz.default;
function $2414cb70ecc2edd8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2414cb70ecc2edd8$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2414cb70ecc2edd8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $2414cb70ecc2edd8$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $2414cb70ecc2edd8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
module.exports = $2414cb70ecc2edd8$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hkOZE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $2Ml3G.default;
    }
});

var $2Ml3G = parcelRequire("2Ml3G");

});
parcelRegister("2Ml3G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20606636e9c6418f$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");

var $apDjf = parcelRequire("apDjf");
function $20606636e9c6418f$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $apDjf.default), (0, $abElG.default)({
            ref: ref
        }, props), path);
    };
    Component.muiName = (0, $apDjf.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).forwardRef(Component));
}

});
parcelRegister("apDjf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $794abb3e42cb870c$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");


var $7EzGR = parcelRequire("7EzGR");

var $kaLUp = parcelRequire("kaLUp");
var $794abb3e42cb870c$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: "none",
            width: "1em",
            height: "1em",
            display: "inline-block",
            fill: "currentColor",
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create("fill", {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: "inherit"
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $794abb3e42cb870c$var$SvgIcon = /*#__PURE__*/ $arQ7u.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "inherit" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "svg" : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? "medium" : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? "0 0 24 24" : _props$viewBox, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $kaLUp.default)(color))], fontSize !== "default" && fontSize !== "medium" && classes["fontSize".concat((0, $kaLUp.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $arQ7u.createElement("title", null, titleAccess) : null);
});
$794abb3e42cb870c$var$SvgIcon.muiName = "SvgIcon";
var $794abb3e42cb870c$export$2e2bcd8739ae039 = (0, $7EzGR.default)($794abb3e42cb870c$export$9dd6ff9ea0189349, {
    name: "MuiSvgIcon"
})($794abb3e42cb870c$var$SvgIcon);

});




parcelRegister("hWehD", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0f2eedadc187fde$var$React = $363GR((parcelRequire("arQ7u")));

var $d0f2eedadc187fde$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $d0f2eedadc187fde$var$_default = (0, $d0f2eedadc187fde$var$_createSvgIcon.default)(/*#__PURE__*/ $d0f2eedadc187fde$var$React.createElement("path", {
    d: "M12 6.5c2.76 0 5 2.24 5 5 0 .51-.1 1-.24 1.46l3.06 3.06c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l2.17 2.17c.47-.14.96-.24 1.47-.24zM3.42 2.45L2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.97-.3 4.31-.82l3.43 3.43 1.41-1.41L3.42 2.45zM12 16.5c-2.76 0-5-2.24-5-5 0-.77.18-1.5.49-2.14l1.57 1.57c-.03.18-.06.37-.06.57 0 1.66 1.34 3 3 3 .2 0 .38-.03.57-.07L14.14 16c-.65.32-1.37.5-2.14.5zm2.97-5.33c-.15-1.4-1.25-2.49-2.64-2.64l2.64 2.64z"
}), "VisibilityOffSharp");
module.exports.default = $d0f2eedadc187fde$var$_default;

});

parcelRegister("029Oc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0067cbd5f2564460$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $7XHRd = parcelRequire("7XHRd");

var $bds4h = parcelRequire("bds4h");

var $jGts0 = parcelRequire("jGts0");
/** */ var $0067cbd5f2564460$var$mapStateToProps = function mapStateToProps(state) {
    return {
        containerId: (0, $jGts0.getContainerId)(state)
    };
};
var $0067cbd5f2564460$var$enhance = (0, $k19ic.compose)((0, $fbonu.default)($0067cbd5f2564460$var$mapStateToProps, null), (0, $7XHRd.withPlugins)("MiradorMenuButton"));
var $0067cbd5f2564460$export$2e2bcd8739ae039 = $0067cbd5f2564460$var$enhance((0, $bds4h.MiradorMenuButton));

});
parcelRegister("bds4h", function(module, exports) {

$parcel$export(module.exports, "MiradorMenuButton", function () { return $82a6ae5594e2e371$export$94ddc653db6a05bf; });

var $arQ7u = parcelRequire("arQ7u");

var $lJKnE = parcelRequire("lJKnE");

var $4i20X = parcelRequire("4i20X");

var $e59gp = parcelRequire("e59gp");

var $1xlvK = parcelRequire("1xlvK");
var $82a6ae5594e2e371$var$_excluded = [
    "badge",
    "children",
    "containerId",
    "dispatch",
    "BadgeProps",
    "TooltipProps"
];
function $82a6ae5594e2e371$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $82a6ae5594e2e371$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $82a6ae5594e2e371$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $82a6ae5594e2e371$export$94ddc653db6a05bf(props) {
    var ariaLabel = props["aria-label"];
    var badge = props.badge, children = props.children, containerId = props.containerId, dispatch = props.dispatch, BadgeProps = props.BadgeProps, TooltipProps = props.TooltipProps, iconButtonProps = $82a6ae5594e2e371$var$_objectWithoutProperties(props, $82a6ae5594e2e371$var$_excluded);
    var button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $4i20X.default), iconButtonProps, badge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $lJKnE.default), BadgeProps, children) : children);
    if (iconButtonProps.disabled) return button;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $e59gp.default), Object.assign({
        PopperProps: {
            container: document.querySelector("#".concat(containerId, " .").concat((0, $1xlvK.default)("viewer")))
        },
        title: ariaLabel
    }, TooltipProps), button);
}
$82a6ae5594e2e371$export$94ddc653db6a05bf.defaultProps = {
    badge: false,
    BadgeProps: {},
    dispatch: function dispatch() {},
    TooltipProps: {}
};

});
parcelRegister("lJKnE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd31c71f104fc3fb$export$2e2bcd8739ae039; });
parcelRequire("kMfvj");

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");


var $7EzGR = parcelRequire("7EzGR");

var $kaLUp = parcelRequire("kaLUp");
var $fd31c71f104fc3fb$var$RADIUS_STANDARD = 10;
var $fd31c71f104fc3fb$var$RADIUS_DOT = 4;
var $fd31c71f104fc3fb$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            display: "inline-flex",
            // For correct alignment with the text.
            verticalAlign: "middle",
            flexShrink: 0
        },
        /* Styles applied to the badge `span` element. */ badge: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            position: "absolute",
            boxSizing: "border-box",
            fontFamily: theme.typography.fontFamily,
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: theme.typography.pxToRem(12),
            minWidth: $fd31c71f104fc3fb$var$RADIUS_STANDARD * 2,
            lineHeight: 1,
            padding: "0 6px",
            height: $fd31c71f104fc3fb$var$RADIUS_STANDARD * 2,
            borderRadius: $fd31c71f104fc3fb$var$RADIUS_STANDARD,
            zIndex: 1,
            // Render the badge on top of potential ripples.
            transition: theme.transitions.create("transform", {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.enteringScreen
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText
        },
        /* Styles applied to the root element if `variant="dot"`. */ dot: {
            borderRadius: $fd31c71f104fc3fb$var$RADIUS_DOT,
            height: $fd31c71f104fc3fb$var$RADIUS_DOT * 2,
            minWidth: $fd31c71f104fc3fb$var$RADIUS_DOT * 2,
            padding: 0
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */ anchorOriginTopRightRectangle: {
            top: 0,
            right: 0,
            transform: "scale(1) translate(50%, -50%)",
            transformOrigin: "100% 0%",
            "&$invisible": {
                transform: "scale(0) translate(50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangular"`. */ anchorOriginTopRightRectangular: {
            top: 0,
            right: 0,
            transform: "scale(1) translate(50%, -50%)",
            transformOrigin: "100% 0%",
            "&$invisible": {
                transform: "scale(0) translate(50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */ anchorOriginBottomRightRectangle: {
            bottom: 0,
            right: 0,
            transform: "scale(1) translate(50%, 50%)",
            transformOrigin: "100% 100%",
            "&$invisible": {
                transform: "scale(0) translate(50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangular"`. */ anchorOriginBottomRightRectangular: {
            bottom: 0,
            right: 0,
            transform: "scale(1) translate(50%, 50%)",
            transformOrigin: "100% 100%",
            "&$invisible": {
                transform: "scale(0) translate(50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */ anchorOriginTopLeftRectangle: {
            top: 0,
            left: 0,
            transform: "scale(1) translate(-50%, -50%)",
            transformOrigin: "0% 0%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangular"`. */ anchorOriginTopLeftRectangular: {
            top: 0,
            left: 0,
            transform: "scale(1) translate(-50%, -50%)",
            transformOrigin: "0% 0%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */ anchorOriginBottomLeftRectangle: {
            bottom: 0,
            left: 0,
            transform: "scale(1) translate(-50%, 50%)",
            transformOrigin: "0% 100%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangular"`. */ anchorOriginBottomLeftRectangular: {
            bottom: 0,
            left: 0,
            transform: "scale(1) translate(-50%, 50%)",
            transformOrigin: "0% 100%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */ anchorOriginTopRightCircle: {
            top: "14%",
            right: "14%",
            transform: "scale(1) translate(50%, -50%)",
            transformOrigin: "100% 0%",
            "&$invisible": {
                transform: "scale(0) translate(50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circular"`. */ anchorOriginTopRightCircular: {
            top: "14%",
            right: "14%",
            transform: "scale(1) translate(50%, -50%)",
            transformOrigin: "100% 0%",
            "&$invisible": {
                transform: "scale(0) translate(50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */ anchorOriginBottomRightCircle: {
            bottom: "14%",
            right: "14%",
            transform: "scale(1) translate(50%, 50%)",
            transformOrigin: "100% 100%",
            "&$invisible": {
                transform: "scale(0) translate(50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circular"`. */ anchorOriginBottomRightCircular: {
            bottom: "14%",
            right: "14%",
            transform: "scale(1) translate(50%, 50%)",
            transformOrigin: "100% 100%",
            "&$invisible": {
                transform: "scale(0) translate(50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */ anchorOriginTopLeftCircle: {
            top: "14%",
            left: "14%",
            transform: "scale(1) translate(-50%, -50%)",
            transformOrigin: "0% 0%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circular"`. */ anchorOriginTopLeftCircular: {
            top: "14%",
            left: "14%",
            transform: "scale(1) translate(-50%, -50%)",
            transformOrigin: "0% 0%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */ anchorOriginBottomLeftCircle: {
            bottom: "14%",
            left: "14%",
            transform: "scale(1) translate(-50%, 50%)",
            transformOrigin: "0% 100%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circular"`. */ anchorOriginBottomLeftCircular: {
            bottom: "14%",
            left: "14%",
            transform: "scale(1) translate(-50%, 50%)",
            transformOrigin: "0% 100%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, 50%)"
            }
        },
        /* Pseudo-class to the badge `span` element if `invisible={true}`. */ invisible: {
            transition: theme.transitions.create("transform", {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.leavingScreen
            })
        }
    };
};
var $fd31c71f104fc3fb$var$Badge = /*#__PURE__*/ $arQ7u.forwardRef(function Badge(props, ref) {
    var _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: "top",
        horizontal: "right"
    } : _props$anchorOrigin, badgeContent = props.badgeContent, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, ComponentProp = _props$component === void 0 ? "span" : _props$component, invisibleProp = props.invisible, _props$max = props.max, max = _props$max === void 0 ? 99 : _props$max, _props$overlap = props.overlap, overlap = _props$overlap === void 0 ? "rectangle" : _props$overlap, _props$showZero = props.showZero, showZero = _props$showZero === void 0 ? false : _props$showZero, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $dXEVX.default)(props, [
        "anchorOrigin",
        "badgeContent",
        "children",
        "classes",
        "className",
        "color",
        "component",
        "invisible",
        "max",
        "overlap",
        "showZero",
        "variant"
    ]);
    var invisible = invisibleProp;
    if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== "dot")) invisible = true;
    var displayValue = "";
    if (variant !== "dot") displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
    return /*#__PURE__*/ $arQ7u.createElement(ComponentProp, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className),
        ref: ref
    }, other), children, /*#__PURE__*/ $arQ7u.createElement("span", {
        className: (0, $5g55B.default)(classes.badge, classes["".concat(anchorOrigin.horizontal).concat((0, $kaLUp.default)(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat((0, $kaLUp.default)(anchorOrigin.vertical)).concat((0, $kaLUp.default)(anchorOrigin.horizontal)).concat((0, $kaLUp.default)(overlap))], color !== "default" && classes["color".concat((0, $kaLUp.default)(color))], invisible && classes.invisible, variant === "dot" && classes.dot)
    }, displayValue));
});
var $fd31c71f104fc3fb$export$2e2bcd8739ae039 = (0, $7EzGR.default)($fd31c71f104fc3fb$export$9dd6ff9ea0189349, {
    name: "MuiBadge"
})($fd31c71f104fc3fb$var$Badge);

});

parcelRegister("4i20X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31fa67e35c13aef6$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");


var $7EzGR = parcelRequire("7EzGR");

var $6vqZH = parcelRequire("6vqZH");

var $b71IR = parcelRequire("b71IR");

var $kaLUp = parcelRequire("kaLUp");
var $31fa67e35c13aef6$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: "center",
            flex: "0 0 auto",
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: "50%",
            overflow: "visible",
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                backgroundColor: "transparent",
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            "$sizeSmall&": {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            "$sizeSmall&": {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: "100%",
            display: "flex",
            alignItems: "inherit",
            justifyContent: "inherit"
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $31fa67e35c13aef6$var$IconButton = /*#__PURE__*/ $arQ7u.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $dXEVX.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $arQ7u.createElement((0, $b71IR.default), (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, color !== "default" && classes["color".concat((0, $kaLUp.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $kaLUp.default)(size))], {
            "start": classes.edgeStart,
            "end": classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $arQ7u.createElement("span", {
        className: classes.label
    }, children));
});
var $31fa67e35c13aef6$export$2e2bcd8739ae039 = (0, $7EzGR.default)($31fa67e35c13aef6$export$9dd6ff9ea0189349, {
    name: "MuiIconButton"
})($31fa67e35c13aef6$var$IconButton);

});
parcelRegister("b71IR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8171af398aeab8f9$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $9sDDw = parcelRequire("9sDDw");

var $5g55B = parcelRequire("5g55B");


var $nGnd5 = parcelRequire("nGnd5");

var $e3Evk = parcelRequire("e3Evk");


var $7EzGR = parcelRequire("7EzGR");

var $cvMUO = parcelRequire("cvMUO");

var $b9eZB = parcelRequire("b9eZB");
var $8171af398aeab8f9$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        textDecoration: "none",
        // So we take precedent over the style of a native <a /> element.
        color: "inherit",
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$disabled": {
            pointerEvents: "none",
            // Disable link interactions
            cursor: "default"
        },
        "@media print": {
            colorAdjust: "exact"
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $8171af398aeab8f9$var$ButtonBase = /*#__PURE__*/ $arQ7u.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, other = (0, $dXEVX.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $arQ7u.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $9sDDw.findDOMNode(buttonRef.current);
    }
    var rippleRef = $arQ7u.useRef(null);
    var _React$useState = $arQ7u.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $cvMUO.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $arQ7u.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $arQ7u.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $e3Evk.default)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler("start", onMouseDown);
    var handleDragLeave = useRippleHandler("stop", onDragLeave);
    var handleMouseUp = useRippleHandler("stop", onMouseUp);
    var handleMouseLeave = useRippleHandler("stop", function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler("start", onTouchStart);
    var handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    var handleTouchMove = useRippleHandler("stop", onTouchMove);
    var handleBlur = useRippleHandler("stop", function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $e3Evk.default)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $arQ7u.useRef(false);
    var handleKeyDown = (0, $e3Evk.default)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $e3Evk.default)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === "button" && other.href) ComponentProp = "a";
    var buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== "a" || !other.href) buttonProps.role = "button";
        buttonProps["aria-disabled"] = disabled;
    }
    var handleUserRef = (0, $nGnd5.default)(buttonRefProp, ref);
    var handleOwnRef = (0, $nGnd5.default)(focusVisibleRef, buttonRef);
    var handleRef = (0, $nGnd5.default)(handleUserRef, handleOwnRef);
    var _React$useState2 = $arQ7u.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $arQ7u.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $arQ7u.createElement(ComponentProp, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $arQ7u.createElement((0, $b9eZB.default), (0, $abElG.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $8171af398aeab8f9$export$2e2bcd8739ae039 = (0, $7EzGR.default)($8171af398aeab8f9$export$9dd6ff9ea0189349, {
    name: "MuiButtonBase"
})($8171af398aeab8f9$var$ButtonBase);

});
parcelRegister("nGnd5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $047304903a0329ff$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $KZePB = parcelRequire("KZePB");
function $047304903a0329ff$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $arQ7u.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $KZePB.default)(refA, refValue);
            (0, $KZePB.default)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}

});
parcelRegister("KZePB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08d3cca05d0eb4ac$export$2e2bcd8739ae039; });
// TODO v5: consider to make it private
function $08d3cca05d0eb4ac$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("e3Evk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3c0c3cd05e4fe61$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");
var $a3c0c3cd05e4fe61$var$useEnhancedEffect = typeof window !== "undefined" ? $arQ7u.useLayoutEffect : $arQ7u.useEffect;
function $a3c0c3cd05e4fe61$export$2e2bcd8739ae039(fn) {
    var ref = $arQ7u.useRef(fn);
    $a3c0c3cd05e4fe61$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $arQ7u.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}

});

parcelRegister("cvMUO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91be52dd470fc8e7$export$2e2bcd8739ae039; });
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $arQ7u = parcelRequire("arQ7u");

var $9sDDw = parcelRequire("9sDDw");
var $91be52dd470fc8e7$var$hadKeyboardEvent = true;
var $91be52dd470fc8e7$var$hadFocusVisibleRecently = false;
var $91be52dd470fc8e7$var$hadFocusVisibleRecentlyTimeout = null;
var $91be52dd470fc8e7$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $91be52dd470fc8e7$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === "INPUT" && $91be52dd470fc8e7$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $91be52dd470fc8e7$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $91be52dd470fc8e7$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $91be52dd470fc8e7$var$handlePointerDown() {
    $91be52dd470fc8e7$var$hadKeyboardEvent = false;
}
function $91be52dd470fc8e7$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($91be52dd470fc8e7$var$hadFocusVisibleRecently) $91be52dd470fc8e7$var$hadKeyboardEvent = true;
    }
}
function $91be52dd470fc8e7$var$prepare(doc) {
    doc.addEventListener("keydown", $91be52dd470fc8e7$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $91be52dd470fc8e7$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $91be52dd470fc8e7$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $91be52dd470fc8e7$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $91be52dd470fc8e7$var$handleVisibilityChange, true);
}
function $91be52dd470fc8e7$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $91be52dd470fc8e7$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $91be52dd470fc8e7$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $91be52dd470fc8e7$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $91be52dd470fc8e7$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $91be52dd470fc8e7$var$handleVisibilityChange, true);
}
function $91be52dd470fc8e7$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(":focus-visible");
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $91be52dd470fc8e7$var$hadKeyboardEvent || $91be52dd470fc8e7$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $91be52dd470fc8e7$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $91be52dd470fc8e7$var$hadFocusVisibleRecently = true;
    window.clearTimeout($91be52dd470fc8e7$var$hadFocusVisibleRecentlyTimeout);
    $91be52dd470fc8e7$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $91be52dd470fc8e7$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $91be52dd470fc8e7$export$2e2bcd8739ae039() {
    var ref = $arQ7u.useCallback(function(instance) {
        var node = $9sDDw.findDOMNode(instance);
        if (node != null) $91be52dd470fc8e7$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $91be52dd470fc8e7$var$isFocusVisible,
        onBlurVisible: $91be52dd470fc8e7$var$handleBlurVisible,
        ref: ref
    };
}

});

parcelRegister("b9eZB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81dc2a3534d7bd2f$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $lsH61 = parcelRequire("lsH61");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $eYkNj = parcelRequire("eYkNj");

var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");

var $1XUsk = parcelRequire("1XUsk");
var $81dc2a3534d7bd2f$var$DURATION = 550;
var $81dc2a3534d7bd2f$export$95d0c9356b2231a3 = 80;
var $81dc2a3534d7bd2f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit"
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: "absolute"
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: "scale(1)",
            animation: "$enter ".concat($81dc2a3534d7bd2f$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: "block",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: "currentColor"
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($81dc2a3534d7bd2f$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: "absolute",
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        "@keyframes enter": {
            "0%": {
                transform: "scale(0)",
                opacity: 0.1
            },
            "100%": {
                transform: "scale(1)",
                opacity: 0.3
            }
        },
        "@keyframes exit": {
            "0%": {
                opacity: 1
            },
            "100%": {
                opacity: 0
            }
        },
        "@keyframes pulsate": {
            "0%": {
                transform: "scale(1)"
            },
            "50%": {
                transform: "scale(0.92)"
            },
            "100%": {
                transform: "scale(1)"
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $81dc2a3534d7bd2f$var$TouchRipple = /*#__PURE__*/ $arQ7u.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $dXEVX.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $arQ7u.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $arQ7u.useRef(0);
    var rippleCallback = $arQ7u.useRef(null);
    $arQ7u.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $arQ7u.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $arQ7u.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $arQ7u.useRef(null);
    var container = $arQ7u.useRef(null);
    $arQ7u.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $arQ7u.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $lsH61.default)(oldRipples), [
                /*#__PURE__*/ $arQ7u.createElement((0, $1XUsk.default), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $81dc2a3534d7bd2f$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $arQ7u.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === "touchstart") ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $81dc2a3534d7bd2f$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $arQ7u.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $arQ7u.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === "touchend" && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $arQ7u.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $arQ7u.createElement("span", (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $arQ7u.createElement((0, $eYkNj.default), {
        component: null,
        exit: true
    }, ripples));
});
var $81dc2a3534d7bd2f$export$2e2bcd8739ae039 = (0, $7EzGR.default)($81dc2a3534d7bd2f$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiTouchRipple"
})(/*#__PURE__*/ $arQ7u.memo($81dc2a3534d7bd2f$var$TouchRipple));

});
parcelRegister("eYkNj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae66cca26ca03621$export$2e2bcd8739ae039; });

var $fJZol = parcelRequire("fJZol");

var $abElG = parcelRequire("abElG");

var $7qIdT = parcelRequire("7qIdT");

var $arruZ = parcelRequire("arruZ");


var $arQ7u = parcelRequire("arQ7u");

var $kATtR = parcelRequire("kATtR");

var $iur0v = parcelRequire("iur0v");
var $ae66cca26ca03621$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $ae66cca26ca03621$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $ae66cca26ca03621$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $arruZ.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $7qIdT.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $iur0v.getInitialChildMapping)(nextProps, handleExited) : (0, $iur0v.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $iur0v.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $abElG.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $fJZol.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $ae66cca26ca03621$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $kATtR.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $kATtR.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Component);
$ae66cca26ca03621$var$TransitionGroup.propTypes = {};
$ae66cca26ca03621$var$TransitionGroup.defaultProps = $ae66cca26ca03621$var$defaultProps;
var $ae66cca26ca03621$export$2e2bcd8739ae039 = $ae66cca26ca03621$var$TransitionGroup;

});
parcelRegister("kATtR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efe234be086a5de1$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");
var $efe234be086a5de1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createContext(null);

});

parcelRegister("iur0v", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $d75ffa68b8b8045c$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $d75ffa68b8b8045c$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $d75ffa68b8b8045c$export$36fd1af28d383ec0; });

var $arQ7u = parcelRequire("arQ7u");
function $d75ffa68b8b8045c$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $arQ7u.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $arQ7u.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $d75ffa68b8b8045c$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $d75ffa68b8b8045c$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $d75ffa68b8b8045c$export$fa71e2345c31d7a2(props, onExited) {
    return $d75ffa68b8b8045c$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $arQ7u.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $d75ffa68b8b8045c$var$getProp(child, "appear", props),
            enter: $d75ffa68b8b8045c$var$getProp(child, "enter", props),
            exit: $d75ffa68b8b8045c$var$getProp(child, "exit", props)
        });
    });
}
function $d75ffa68b8b8045c$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $d75ffa68b8b8045c$export$bbc8a025727ea824(nextProps.children);
    var children = $d75ffa68b8b8045c$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $arQ7u.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $arQ7u.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $arQ7u.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $d75ffa68b8b8045c$var$getProp(child, "exit", nextProps),
            enter: $d75ffa68b8b8045c$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $arQ7u.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $arQ7u.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $arQ7u.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $d75ffa68b8b8045c$var$getProp(child, "exit", nextProps),
            enter: $d75ffa68b8b8045c$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("1XUsk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16e7181d23b719e9$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $e3Evk = parcelRequire("e3Evk");
var $16e7181d23b719e9$var$useEnhancedEffect = typeof window === "undefined" ? $arQ7u.useEffect : $arQ7u.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $16e7181d23b719e9$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $arQ7u.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $5g55B.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $5g55B.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $e3Evk.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $16e7181d23b719e9$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $arQ7u.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $arQ7u.createElement("span", {
        className: childClassName
    }));
}
var $16e7181d23b719e9$export$2e2bcd8739ae039 = $16e7181d23b719e9$var$Ripple;

});




parcelRegister("e59gp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a408b7e5196b2661$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $kMfvj = parcelRequire("kMfvj");

var $dXEVX = parcelRequire("dXEVX");

var $4g0WD = parcelRequire("4g0WD");

var $arQ7u = parcelRequire("arQ7u");

var $9sDDw = parcelRequire("9sDDw");


var $5g55B = parcelRequire("5g55B");

var $52Kw7 = parcelRequire("52Kw7");

var $6vqZH = parcelRequire("6vqZH");

var $7EzGR = parcelRequire("7EzGR");

var $kaLUp = parcelRequire("kaLUp");

var $5fs1a = parcelRequire("5fs1a");

var $4zh2f = parcelRequire("4zh2f");

var $nGnd5 = parcelRequire("nGnd5");

var $eIm5l = parcelRequire("eIm5l");

var $KZePB = parcelRequire("KZePB");

var $cvMUO = parcelRequire("cvMUO");

var $lhLsx = parcelRequire("lhLsx");

var $j1k3T = parcelRequire("j1k3T");
function $a408b7e5196b2661$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
function $a408b7e5196b2661$var$arrowGenerator() {
    return {
        '&[x-placement*="bottom"] $arrow': {
            top: 0,
            left: 0,
            marginTop: "-0.71em",
            marginLeft: 4,
            marginRight: 4,
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        '&[x-placement*="top"] $arrow': {
            bottom: 0,
            left: 0,
            marginBottom: "-0.71em",
            marginLeft: 4,
            marginRight: 4,
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        '&[x-placement*="right"] $arrow': {
            left: 0,
            marginLeft: "-0.71em",
            height: "1em",
            width: "0.71em",
            marginTop: 4,
            marginBottom: 4,
            "&::before": {
                transformOrigin: "100% 100%"
            }
        },
        '&[x-placement*="left"] $arrow': {
            right: 0,
            marginRight: "-0.71em",
            height: "1em",
            width: "0.71em",
            marginTop: 4,
            marginBottom: 4,
            "&::before": {
                transformOrigin: "0 0"
            }
        }
    };
}
var $a408b7e5196b2661$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the Popper component. */ popper: {
            zIndex: theme.zIndex.tooltip,
            pointerEvents: "none" // disable jss-rtl plugin
        },
        /* Styles applied to the Popper component if `interactive={true}`. */ popperInteractive: {
            pointerEvents: "auto"
        },
        /* Styles applied to the Popper component if `arrow={true}`. */ popperArrow: $a408b7e5196b2661$var$arrowGenerator(),
        /* Styles applied to the tooltip (label wrapper) element. */ tooltip: {
            backgroundColor: (0, $6vqZH.alpha)(theme.palette.grey[700], 0.9),
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.common.white,
            fontFamily: theme.typography.fontFamily,
            padding: "4px 8px",
            fontSize: theme.typography.pxToRem(10),
            lineHeight: "".concat($a408b7e5196b2661$var$round(1.4), "em"),
            maxWidth: 300,
            wordWrap: "break-word",
            fontWeight: theme.typography.fontWeightMedium
        },
        /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */ tooltipArrow: {
            position: "relative",
            margin: "0"
        },
        /* Styles applied to the arrow element. */ arrow: {
            overflow: "hidden",
            position: "absolute",
            width: "1em",
            height: "0.71em",
            boxSizing: "border-box",
            color: (0, $6vqZH.alpha)(theme.palette.grey[700], 0.9),
            "&::before": {
                content: '""',
                margin: "auto",
                display: "block",
                width: "100%",
                height: "100%",
                backgroundColor: "currentColor",
                transform: "rotate(45deg)"
            }
        },
        /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */ touch: {
            padding: "8px 16px",
            fontSize: theme.typography.pxToRem(14),
            lineHeight: "".concat($a408b7e5196b2661$var$round(16 / 14), "em"),
            fontWeight: theme.typography.fontWeightRegular
        },
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */ tooltipPlacementLeft: (0, $4g0WD.default)({
            transformOrigin: "right center",
            margin: "0 24px "
        }, theme.breakpoints.up("sm"), {
            margin: "0 14px"
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */ tooltipPlacementRight: (0, $4g0WD.default)({
            transformOrigin: "left center",
            margin: "0 24px"
        }, theme.breakpoints.up("sm"), {
            margin: "0 14px"
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */ tooltipPlacementTop: (0, $4g0WD.default)({
            transformOrigin: "center bottom",
            margin: "24px 0"
        }, theme.breakpoints.up("sm"), {
            margin: "14px 0"
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */ tooltipPlacementBottom: (0, $4g0WD.default)({
            transformOrigin: "center top",
            margin: "24px 0"
        }, theme.breakpoints.up("sm"), {
            margin: "14px 0"
        })
    };
};
var $a408b7e5196b2661$var$hystersisOpen = false;
var $a408b7e5196b2661$var$hystersisTimer = null;
function $a408b7e5196b2661$export$b9ee5a7ace0541f8() {
    $a408b7e5196b2661$var$hystersisOpen = false;
    clearTimeout($a408b7e5196b2661$var$hystersisTimer);
}
var $a408b7e5196b2661$var$Tooltip = /*#__PURE__*/ $arQ7u.forwardRef(function Tooltip(props, ref) {
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, children = props.children, classes = props.classes, _props$disableFocusLi = props.disableFocusListener, disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi, _props$disableHoverLi = props.disableHoverListener, disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi, _props$disableTouchLi = props.disableTouchListener, disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi, _props$enterDelay = props.enterDelay, enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay, _props$enterNextDelay = props.enterNextDelay, enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay, _props$enterTouchDela = props.enterTouchDelay, enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela, idProp = props.id, _props$interactive = props.interactive, interactive = _props$interactive === void 0 ? false : _props$interactive, _props$leaveDelay = props.leaveDelay, leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay, _props$leaveTouchDela = props.leaveTouchDelay, leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela, onClose = props.onClose, onOpen = props.onOpen, openProp = props.open, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottom" : _props$placement, _props$PopperComponen = props.PopperComponent, PopperComponent = _props$PopperComponen === void 0 ? (0, $4zh2f.default) : _props$PopperComponen, PopperProps = props.PopperProps, title = props.title, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $5fs1a.default) : _props$TransitionComp, TransitionProps = props.TransitionProps, other = (0, $dXEVX.default)(props, [
        "arrow",
        "children",
        "classes",
        "disableFocusListener",
        "disableHoverListener",
        "disableTouchListener",
        "enterDelay",
        "enterNextDelay",
        "enterTouchDelay",
        "id",
        "interactive",
        "leaveDelay",
        "leaveTouchDelay",
        "onClose",
        "onOpen",
        "open",
        "placement",
        "PopperComponent",
        "PopperProps",
        "title",
        "TransitionComponent",
        "TransitionProps"
    ]);
    var theme = (0, $j1k3T.default)();
    var _React$useState = $arQ7u.useState(), childNode = _React$useState[0], setChildNode = _React$useState[1];
    var _React$useState2 = $arQ7u.useState(null), arrowRef = _React$useState2[0], setArrowRef = _React$useState2[1];
    var ignoreNonTouchEvents = $arQ7u.useRef(false);
    var closeTimer = $arQ7u.useRef();
    var enterTimer = $arQ7u.useRef();
    var leaveTimer = $arQ7u.useRef();
    var touchTimer = $arQ7u.useRef();
    var _useControlled = (0, $lhLsx.default)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    }), _useControlled2 = (0, $kMfvj.default)(_useControlled, 2), openState = _useControlled2[0], setOpenState = _useControlled2[1];
    var open = openState;
    var _React$useRef, isControlled;
    var id = (0, $eIm5l.default)(idProp);
    $arQ7u.useEffect(function() {
        return function() {
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            clearTimeout(touchTimer.current);
        };
    }, []);
    var handleOpen = function handleOpen(event) {
        clearTimeout($a408b7e5196b2661$var$hystersisTimer);
        $a408b7e5196b2661$var$hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen) onOpen(event);
    };
    var handleEnter = function handleEnter() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            var childrenProps = children.props;
            if (event.type === "mouseover" && childrenProps.onMouseOver && forward) childrenProps.onMouseOver(event);
            if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
             // Remove the title ahead of time.
            // We don't want to wait for the next render commit.
            // We would risk displaying two tooltips at the same time (native + this one).
            if (childNode) childNode.removeAttribute("title");
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            if (enterDelay || $a408b7e5196b2661$var$hystersisOpen && enterNextDelay) {
                event.persist();
                enterTimer.current = setTimeout(function() {
                    handleOpen(event);
                }, $a408b7e5196b2661$var$hystersisOpen ? enterNextDelay : enterDelay);
            } else handleOpen(event);
        };
    };
    var _useIsFocusVisible = (0, $cvMUO.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState3 = $arQ7u.useState(false), childIsFocusVisible = _React$useState3[0], setChildIsFocusVisible = _React$useState3[1];
    var handleBlur = function handleBlur() {
        if (childIsFocusVisible) {
            setChildIsFocusVisible(false);
            onBlurVisible();
        }
    };
    var handleFocus = function handleFocus() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            // Workaround for https://github.com/facebook/react/issues/7769
            // The autoFocus of React might trigger the event before the componentDidMount.
            // We need to account for this eventuality.
            if (!childNode) setChildNode(event.currentTarget);
            if (isFocusVisible(event)) {
                setChildIsFocusVisible(true);
                handleEnter()(event);
            }
            var childrenProps = children.props;
            if (childrenProps.onFocus && forward) childrenProps.onFocus(event);
        };
    };
    var handleClose = function handleClose(event) {
        clearTimeout($a408b7e5196b2661$var$hystersisTimer);
        $a408b7e5196b2661$var$hystersisTimer = setTimeout(function() {
            $a408b7e5196b2661$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(function() {
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    };
    var handleLeave = function handleLeave() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            var childrenProps = children.props;
            if (event.type === "blur") {
                if (childrenProps.onBlur && forward) childrenProps.onBlur(event);
                handleBlur();
            }
            if (event.type === "mouseleave" && childrenProps.onMouseLeave && event.currentTarget === childNode) childrenProps.onMouseLeave(event);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            event.persist();
            leaveTimer.current = setTimeout(function() {
                handleClose(event);
            }, leaveDelay);
        };
    };
    var detectTouchStart = function detectTouchStart(event) {
        ignoreNonTouchEvents.current = true;
        var childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    var handleTouchStart = function handleTouchStart(event) {
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        clearTimeout(touchTimer.current);
        event.persist();
        touchTimer.current = setTimeout(function() {
            handleEnter()(event);
        }, enterTouchDelay);
    };
    var handleTouchEnd = function handleTouchEnd(event) {
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        clearTimeout(touchTimer.current);
        clearTimeout(leaveTimer.current);
        event.persist();
        leaveTimer.current = setTimeout(function() {
            handleClose(event);
        }, leaveTouchDelay);
    };
    var handleUseRef = (0, $nGnd5.default)(setChildNode, ref);
    var handleFocusRef = (0, $nGnd5.default)(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $arQ7u.useCallback(function(instance) {
        // #StrictMode ready
        (0, $KZePB.default)(handleFocusRef, $9sDDw.findDOMNode(instance));
    }, [
        handleFocusRef
    ]);
    var handleRef = (0, $nGnd5.default)(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.
    if (title === "") open = false;
     // For accessibility and SEO concerns, we render the title to the DOM node when
    // the tooltip is hidden. However, we have made a tradeoff when
    // `disableHoverListener` is set. This title logic is disabled.
    // It's allowing us to keep the implementation size minimal.
    // We are open to change the tradeoff.
    var shouldShowNativeTitle = !open && !disableHoverListener;
    var childrenProps = (0, $abElG.default)({
        "aria-describedby": open ? id : null,
        title: shouldShowNativeTitle && typeof title === "string" ? title : null
    }, other, children.props, {
        className: (0, $5g55B.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    });
    var interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = handleEnter();
        childrenProps.onMouseLeave = handleLeave();
        if (interactive) {
            interactiveWrapperListeners.onMouseOver = handleEnter(false);
            interactiveWrapperListeners.onMouseLeave = handleLeave(false);
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = handleFocus();
        childrenProps.onBlur = handleLeave();
        if (interactive) {
            interactiveWrapperListeners.onFocus = handleFocus(false);
            interactiveWrapperListeners.onBlur = handleLeave(false);
        }
    }
    var mergedPopperProps = $arQ7u.useMemo(function() {
        return (0, $52Kw7.default)({
            popperOptions: {
                modifiers: {
                    arrow: {
                        enabled: Boolean(arrowRef),
                        element: arrowRef
                    }
                }
            }
        }, PopperProps);
    }, [
        arrowRef,
        PopperProps
    ]);
    return /*#__PURE__*/ $arQ7u.createElement($arQ7u.Fragment, null, /*#__PURE__*/ $arQ7u.cloneElement(children, childrenProps), /*#__PURE__*/ $arQ7u.createElement(PopperComponent, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
        placement: placement,
        anchorEl: childNode,
        open: childNode ? open : false,
        id: childrenProps["aria-describedby"],
        transition: true
    }, interactiveWrapperListeners, mergedPopperProps), function(_ref) {
        var placementInner = _ref.placement, TransitionPropsInner = _ref.TransitionProps;
        return /*#__PURE__*/ $arQ7u.createElement(TransitionComponent, (0, $abElG.default)({
            timeout: theme.transitions.duration.shorter
        }, TransitionPropsInner, TransitionProps), /*#__PURE__*/ $arQ7u.createElement("div", {
            className: (0, $5g55B.default)(classes.tooltip, classes["tooltipPlacement".concat((0, $kaLUp.default)(placementInner.split("-")[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
        }, title, arrow ? /*#__PURE__*/ $arQ7u.createElement("span", {
            className: classes.arrow,
            ref: setArrowRef
        }) : null));
    }));
});
var $a408b7e5196b2661$export$2e2bcd8739ae039 = (0, $7EzGR.default)($a408b7e5196b2661$export$9dd6ff9ea0189349, {
    name: "MuiTooltip",
    flip: false
})($a408b7e5196b2661$var$Tooltip);

});
parcelRegister("5fs1a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d2416361b2cae2f$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $kMfvj = parcelRequire("kMfvj");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $d4AeH = parcelRequire("d4AeH");

var $j1k3T = parcelRequire("j1k3T");

var $GtXv4 = parcelRequire("GtXv4");

var $nGnd5 = parcelRequire("nGnd5");
function $3d2416361b2cae2f$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $3d2416361b2cae2f$var$styles = {
    entering: {
        opacity: 1,
        transform: $3d2416361b2cae2f$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $3d2416361b2cae2f$var$Grow = /*#__PURE__*/ $arQ7u.forwardRef(function Grow(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? "auto" : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $d4AeH.default) : _props$TransitionComp, other = (0, $dXEVX.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var timer = $arQ7u.useRef();
    var autoTimeout = $arQ7u.useRef();
    var theme = (0, $j1k3T.default)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $arQ7u.useRef(null);
    var foreignRef = (0, $nGnd5.default)(children.ref, ref);
    var handleRef = (0, $nGnd5.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $kMfvj.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $GtXv4.reflow)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $GtXv4.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps2 = (0, $GtXv4.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay || duration * 0.333
            })
        ].join(",");
        node.style.opacity = "0";
        node.style.transform = $3d2416361b2cae2f$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
    };
    $arQ7u.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ $arQ7u.createElement(TransitionComponent, (0, $abElG.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $arQ7u.cloneElement(children, (0, $abElG.default)({
            style: (0, $abElG.default)({
                opacity: 0,
                transform: $3d2416361b2cae2f$var$getScale(0.75),
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, $3d2416361b2cae2f$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$3d2416361b2cae2f$var$Grow.muiSupportAuto = true;
var $3d2416361b2cae2f$export$2e2bcd8739ae039 = $3d2416361b2cae2f$var$Grow;

});
parcelRegister("d4AeH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9847c1d2a9203caa$export$2e2bcd8739ae039; });

var $fJZol = parcelRequire("fJZol");

var $arruZ = parcelRequire("arruZ");


var $arQ7u = parcelRequire("arQ7u");

var $9sDDw = parcelRequire("9sDDw");

var $2IUQ3 = parcelRequire("2IUQ3");


var $kATtR = parcelRequire("kATtR");

var $8BGbt = parcelRequire("8BGbt");
var $9847c1d2a9203caa$export$bb38bb9a1161268 = "unmounted";
var $9847c1d2a9203caa$export$84cbff306f539230 = "exited";
var $9847c1d2a9203caa$export$df38205c966be359 = "entering";
var $9847c1d2a9203caa$export$78e9e6e3e014d60a = "entered";
var $9847c1d2a9203caa$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $9847c1d2a9203caa$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $arruZ.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $9847c1d2a9203caa$export$84cbff306f539230;
                _this.appearStatus = $9847c1d2a9203caa$export$df38205c966be359;
            } else initialStatus = $9847c1d2a9203caa$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $9847c1d2a9203caa$export$bb38bb9a1161268;
        else initialStatus = $9847c1d2a9203caa$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $9847c1d2a9203caa$export$bb38bb9a1161268) return {
            status: $9847c1d2a9203caa$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $9847c1d2a9203caa$export$df38205c966be359 && status !== $9847c1d2a9203caa$export$78e9e6e3e014d60a) nextStatus = $9847c1d2a9203caa$export$df38205c966be359;
            } else if (status === $9847c1d2a9203caa$export$df38205c966be359 || status === $9847c1d2a9203caa$export$78e9e6e3e014d60a) nextStatus = $9847c1d2a9203caa$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $9847c1d2a9203caa$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9sDDw))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $8BGbt.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $9847c1d2a9203caa$export$84cbff306f539230) this.setState({
            status: $9847c1d2a9203caa$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($9sDDw))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $2IUQ3.default).disabled) {
            this.safeSetState({
                status: $9847c1d2a9203caa$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $9847c1d2a9203caa$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $9847c1d2a9203caa$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($9sDDw))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $2IUQ3.default).disabled) {
            this.safeSetState({
                status: $9847c1d2a9203caa$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $9847c1d2a9203caa$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $9847c1d2a9203caa$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9sDDw))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $9847c1d2a9203caa$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $fJZol.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $kATtR.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Component);
$9847c1d2a9203caa$var$Transition.contextType = (0, $kATtR.default);
$9847c1d2a9203caa$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $9847c1d2a9203caa$var$noop() {}
$9847c1d2a9203caa$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $9847c1d2a9203caa$var$noop,
    onEntering: $9847c1d2a9203caa$var$noop,
    onEntered: $9847c1d2a9203caa$var$noop,
    onExit: $9847c1d2a9203caa$var$noop,
    onExiting: $9847c1d2a9203caa$var$noop,
    onExited: $9847c1d2a9203caa$var$noop
};
$9847c1d2a9203caa$var$Transition.UNMOUNTED = $9847c1d2a9203caa$export$bb38bb9a1161268;
$9847c1d2a9203caa$var$Transition.EXITED = $9847c1d2a9203caa$export$84cbff306f539230;
$9847c1d2a9203caa$var$Transition.ENTERING = $9847c1d2a9203caa$export$df38205c966be359;
$9847c1d2a9203caa$var$Transition.ENTERED = $9847c1d2a9203caa$export$78e9e6e3e014d60a;
$9847c1d2a9203caa$var$Transition.EXITING = $9847c1d2a9203caa$export$4aacc83d4d59139f;
var $9847c1d2a9203caa$export$2e2bcd8739ae039 = $9847c1d2a9203caa$var$Transition;

});
parcelRegister("2IUQ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fbbc7c4934e25b3$export$2e2bcd8739ae039; });
var $1fbbc7c4934e25b3$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("8BGbt", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $019df9cfa12a9414$export$7d26bbb1236dafd6; });
var $019df9cfa12a9414$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("j1k3T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd8dac2cf772ee48$export$2e2bcd8739ae039; });

var $gkz9m = parcelRequire("gkz9m");
parcelRequire("arQ7u");

var $cFFej = parcelRequire("cFFej");
function $dd8dac2cf772ee48$export$2e2bcd8739ae039() {
    var theme = (0, $gkz9m.default)() || (0, $cFFej.default);
    return theme;
}

});

parcelRegister("GtXv4", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $07fb298729c4feae$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $07fb298729c4feae$export$8cb1e9b404609ae9; });
var $07fb298729c4feae$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $07fb298729c4feae$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}

});


parcelRegister("4zh2f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3537a523972f3a21$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $7vFgs = parcelRequire("7vFgs");


var $gkz9m = parcelRequire("gkz9m");

var $hdq6i = parcelRequire("hdq6i");

var $1S9Kw = parcelRequire("1S9Kw");

var $KZePB = parcelRequire("KZePB");

var $nGnd5 = parcelRequire("nGnd5");
function $3537a523972f3a21$var$flipPlacement(placement, theme) {
    var direction = theme && theme.direction || "ltr";
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $3537a523972f3a21$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
var $3537a523972f3a21$var$useEnhancedEffect = typeof window !== "undefined" ? $arQ7u.useLayoutEffect : $arQ7u.useEffect;
var $3537a523972f3a21$var$defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */ var $3537a523972f3a21$var$Popper = /*#__PURE__*/ $arQ7u.forwardRef(function Popper(props, ref) {
    var anchorEl = props.anchorEl, children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, modifiers = props.modifiers, open = props.open, _props$placement = props.placement, initialPlacement = _props$placement === void 0 ? "bottom" : _props$placement, _props$popperOptions = props.popperOptions, popperOptions = _props$popperOptions === void 0 ? $3537a523972f3a21$var$defaultPopperOptions : _props$popperOptions, popperRefProp = props.popperRef, style = props.style, _props$transition = props.transition, transition = _props$transition === void 0 ? false : _props$transition, other = (0, $dXEVX.default)(props, [
        "anchorEl",
        "children",
        "container",
        "disablePortal",
        "keepMounted",
        "modifiers",
        "open",
        "placement",
        "popperOptions",
        "popperRef",
        "style",
        "transition"
    ]);
    var tooltipRef = $arQ7u.useRef(null);
    var ownRef = (0, $nGnd5.default)(tooltipRef, ref);
    var popperRef = $arQ7u.useRef(null);
    var handlePopperRef = (0, $nGnd5.default)(popperRef, popperRefProp);
    var handlePopperRefRef = $arQ7u.useRef(handlePopperRef);
    $3537a523972f3a21$var$useEnhancedEffect(function() {
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $arQ7u.useImperativeHandle(popperRefProp, function() {
        return popperRef.current;
    }, []);
    var _React$useState = $arQ7u.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var theme = (0, $gkz9m.default)();
    var rtlPlacement = $3537a523972f3a21$var$flipPlacement(initialPlacement, theme);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ var _React$useState2 = $arQ7u.useState(rtlPlacement), placement = _React$useState2[0], setPlacement = _React$useState2[1];
    $arQ7u.useEffect(function() {
        if (popperRef.current) popperRef.current.update();
    });
    var handleOpen = $arQ7u.useCallback(function() {
        if (!tooltipRef.current || !anchorEl || !open) return;
        if (popperRef.current) {
            popperRef.current.destroy();
            handlePopperRefRef.current(null);
        }
        var handlePopperUpdate = function handlePopperUpdate(data) {
            setPlacement(data.placement);
        };
        var resolvedAnchorEl = $3537a523972f3a21$var$getAnchorEl(anchorEl);
        var box;
        var popper = new (0, $7vFgs.default)($3537a523972f3a21$var$getAnchorEl(anchorEl), tooltipRef.current, (0, $abElG.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: (0, $abElG.default)({}, disablePortal ? {} : {
                // It's using scrollParent by default, we can use the viewport when using a portal.
                preventOverflow: {
                    boundariesElement: "window"
                }
            }, modifiers, popperOptions.modifiers),
            // We could have been using a custom modifier like react-popper is doing.
            // But it seems this is the best public API for this use case.
            onCreate: (0, $1S9Kw.default)(handlePopperUpdate, popperOptions.onCreate),
            onUpdate: (0, $1S9Kw.default)(handlePopperUpdate, popperOptions.onUpdate)
        }));
        handlePopperRefRef.current(popper);
    }, [
        anchorEl,
        disablePortal,
        modifiers,
        open,
        rtlPlacement,
        popperOptions
    ]);
    var handleRef = $arQ7u.useCallback(function(node) {
        (0, $KZePB.default)(ownRef, node);
        handleOpen();
    }, [
        ownRef,
        handleOpen
    ]);
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleClose = function handleClose() {
        if (!popperRef.current) return;
        popperRef.current.destroy();
        handlePopperRefRef.current(null);
    };
    var handleExited = function handleExited() {
        setExited(true);
        handleClose();
    };
    $arQ7u.useEffect(function() {
        return function() {
            handleClose();
        };
    }, []);
    $arQ7u.useEffect(function() {
        if (!open && !transition) // Otherwise handleExited will call this.
        handleClose();
    }, [
        open,
        transition
    ]);
    if (!keepMounted && !open && (!transition || exited)) return null;
    var childProps = {
        placement: placement
    };
    if (transition) childProps.TransitionProps = {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    };
    return /*#__PURE__*/ $arQ7u.createElement((0, $hdq6i.default), {
        disablePortal: disablePortal,
        container: container
    }, /*#__PURE__*/ $arQ7u.createElement("div", (0, $abElG.default)({
        ref: handleRef,
        role: "tooltip"
    }, other, {
        style: (0, $abElG.default)({
            // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
            position: "fixed",
            // Fix Popper.js display issue
            top: 0,
            left: 0,
            display: !open && keepMounted && !transition ? "none" : null
        }, style)
    }), typeof children === "function" ? children(childProps) : children));
});
var $3537a523972f3a21$export$2e2bcd8739ae039 = $3537a523972f3a21$var$Popper;

});
parcelRegister("7vFgs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $577b6fef00a0bb84$export$2e2bcd8739ae039; });
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $577b6fef00a0bb84$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
var $577b6fef00a0bb84$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        "Edge",
        "Trident",
        "Firefox"
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($577b6fef00a0bb84$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $577b6fef00a0bb84$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $577b6fef00a0bb84$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $577b6fef00a0bb84$var$timeoutDuration);
        }
    };
}
var $577b6fef00a0bb84$var$supportsMicroTasks = $577b6fef00a0bb84$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $577b6fef00a0bb84$var$debounce = $577b6fef00a0bb84$var$supportsMicroTasks ? $577b6fef00a0bb84$var$microtaskDebounce : $577b6fef00a0bb84$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $577b6fef00a0bb84$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $577b6fef00a0bb84$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $577b6fef00a0bb84$var$getParentNode(element) {
    if (element.nodeName === "HTML") return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $577b6fef00a0bb84$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case "HTML":
        case "BODY":
            return element.ownerDocument.body;
        case "#document":
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $577b6fef00a0bb84$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $577b6fef00a0bb84$var$getScrollParent($577b6fef00a0bb84$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $577b6fef00a0bb84$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $577b6fef00a0bb84$var$isIE11 = $577b6fef00a0bb84$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $577b6fef00a0bb84$var$isIE10 = $577b6fef00a0bb84$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $577b6fef00a0bb84$var$isIE(version) {
    if (version === 11) return $577b6fef00a0bb84$var$isIE11;
    if (version === 10) return $577b6fef00a0bb84$var$isIE10;
    return $577b6fef00a0bb84$var$isIE11 || $577b6fef00a0bb84$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $577b6fef00a0bb84$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $577b6fef00a0bb84$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === "BODY" || nodeName === "HTML") return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        "TH",
        "TD",
        "TABLE"
    ].indexOf(offsetParent.nodeName) !== -1 && $577b6fef00a0bb84$var$getStyleComputedProperty(offsetParent, "position") === "static") return $577b6fef00a0bb84$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $577b6fef00a0bb84$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY") return false;
    return nodeName === "HTML" || $577b6fef00a0bb84$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $577b6fef00a0bb84$var$getRoot(node) {
    if (node.parentNode !== null) return $577b6fef00a0bb84$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $577b6fef00a0bb84$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($577b6fef00a0bb84$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $577b6fef00a0bb84$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $577b6fef00a0bb84$var$getRoot(element1);
    if (element1root.host) return $577b6fef00a0bb84$var$findCommonOffsetParent(element1root.host, element2);
    else return $577b6fef00a0bb84$var$findCommonOffsetParent(element1, $577b6fef00a0bb84$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $577b6fef00a0bb84$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
    var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $577b6fef00a0bb84$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $577b6fef00a0bb84$var$getScroll(element, "top");
    var scrollLeft = $577b6fef00a0bb84$var$getScroll(element, "left");
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $577b6fef00a0bb84$var$getBordersSize(styles, axis) {
    var sideA = axis === "x" ? "Left" : "Top";
    var sideB = sideA === "Left" ? "Right" : "Bottom";
    return parseFloat(styles["border" + sideA + "Width"]) + parseFloat(styles["border" + sideB + "Width"]);
}
function $577b6fef00a0bb84$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], $577b6fef00a0bb84$var$isIE(10) ? parseInt(html["offset" + axis]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
}
function $577b6fef00a0bb84$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $577b6fef00a0bb84$var$isIE(10) && getComputedStyle(html);
    return {
        height: $577b6fef00a0bb84$var$getSize("Height", body, html, computedStyle),
        width: $577b6fef00a0bb84$var$getSize("Width", body, html, computedStyle)
    };
}
var $577b6fef00a0bb84$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $577b6fef00a0bb84$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $577b6fef00a0bb84$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $577b6fef00a0bb84$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $577b6fef00a0bb84$var$getClientRect(offsets) {
    return $577b6fef00a0bb84$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $577b6fef00a0bb84$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($577b6fef00a0bb84$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $577b6fef00a0bb84$var$getScroll(element, "top");
            var scrollLeft = $577b6fef00a0bb84$var$getScroll(element, "left");
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === "HTML" ? $577b6fef00a0bb84$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $577b6fef00a0bb84$var$getStyleComputedProperty(element);
        horizScrollbar -= $577b6fef00a0bb84$var$getBordersSize(styles, "x");
        vertScrollbar -= $577b6fef00a0bb84$var$getBordersSize(styles, "y");
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $577b6fef00a0bb84$var$getClientRect(result);
}
function $577b6fef00a0bb84$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $577b6fef00a0bb84$var$isIE(10);
    var isHTML = parent.nodeName === "HTML";
    var childrenRect = $577b6fef00a0bb84$var$getBoundingClientRect(children);
    var parentRect = $577b6fef00a0bb84$var$getBoundingClientRect(parent);
    var scrollParent = $577b6fef00a0bb84$var$getScrollParent(children);
    var styles = $577b6fef00a0bb84$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $577b6fef00a0bb84$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== "BODY") offsets = $577b6fef00a0bb84$var$includeScroll(offsets, parent);
    return offsets;
}
function $577b6fef00a0bb84$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $577b6fef00a0bb84$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $577b6fef00a0bb84$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $577b6fef00a0bb84$var$getScroll(html, "left") : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $577b6fef00a0bb84$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $577b6fef00a0bb84$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") return false;
    if ($577b6fef00a0bb84$var$getStyleComputedProperty(element, "position") === "fixed") return true;
    var parentNode = $577b6fef00a0bb84$var$getParentNode(element);
    if (!parentNode) return false;
    return $577b6fef00a0bb84$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $577b6fef00a0bb84$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $577b6fef00a0bb84$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $577b6fef00a0bb84$var$getStyleComputedProperty(el, "transform") === "none")el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $577b6fef00a0bb84$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $577b6fef00a0bb84$var$getFixedPositionOffsetParent(popper) : $577b6fef00a0bb84$var$findCommonOffsetParent(popper, $577b6fef00a0bb84$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === "viewport") boundaries = $577b6fef00a0bb84$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === "scrollParent") {
            boundariesNode = $577b6fef00a0bb84$var$getScrollParent($577b6fef00a0bb84$var$getParentNode(reference));
            if (boundariesNode.nodeName === "BODY") boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === "window") boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $577b6fef00a0bb84$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === "HTML" && !$577b6fef00a0bb84$var$isFixed(offsetParent)) {
            var _getWindowSizes = $577b6fef00a0bb84$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === "number";
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $577b6fef00a0bb84$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $577b6fef00a0bb84$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf("auto") === -1) return placement;
    var boundaries = $577b6fef00a0bb84$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $577b6fef00a0bb84$var$_extends({
            key: key
        }, rects[key], {
            area: $577b6fef00a0bb84$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split("-")[1];
    return computedPlacement + (variation ? "-" + variation : "");
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $577b6fef00a0bb84$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $577b6fef00a0bb84$var$getFixedPositionOffsetParent(popper) : $577b6fef00a0bb84$var$findCommonOffsetParent(popper, $577b6fef00a0bb84$var$getReferenceNode(reference));
    return $577b6fef00a0bb84$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $577b6fef00a0bb84$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $577b6fef00a0bb84$var$getOppositePlacement(placement) {
    var hash = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom"
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $577b6fef00a0bb84$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split("-")[0];
    // Get popper node sizes
    var popperRect = $577b6fef00a0bb84$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        "right",
        "left"
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? "top" : "left";
    var secondarySide = isHoriz ? "left" : "top";
    var measurement = isHoriz ? "height" : "width";
    var secondaryMeasurement = !isHoriz ? "height" : "width";
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$577b6fef00a0bb84$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $577b6fef00a0bb84$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $577b6fef00a0bb84$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $577b6fef00a0bb84$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $577b6fef00a0bb84$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $577b6fef00a0bb84$var$findIndex(modifiers, "name", ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier["function"]) // eslint-disable-line dot-notation
        console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
        var fn = modifier["function"] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $577b6fef00a0bb84$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $577b6fef00a0bb84$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $577b6fef00a0bb84$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $577b6fef00a0bb84$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $577b6fef00a0bb84$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $577b6fef00a0bb84$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $577b6fef00a0bb84$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
    // run the modifiers
    data = $577b6fef00a0bb84$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $577b6fef00a0bb84$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $577b6fef00a0bb84$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        "ms",
        "Webkit",
        "Moz",
        "O"
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? "" + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== "undefined") return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $577b6fef00a0bb84$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($577b6fef00a0bb84$var$isModifierEnabled(this.modifiers, "applyStyle")) {
        this.popper.removeAttribute("x-placement");
        this.popper.style.position = "";
        this.popper.style.top = "";
        this.popper.style.left = "";
        this.popper.style.right = "";
        this.popper.style.bottom = "";
        this.popper.style.willChange = "";
        this.popper.style[$577b6fef00a0bb84$var$getSupportedPropertyName("transform")] = "";
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $577b6fef00a0bb84$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $577b6fef00a0bb84$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === "BODY";
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $577b6fef00a0bb84$var$attachToScrollParents($577b6fef00a0bb84$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $577b6fef00a0bb84$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $577b6fef00a0bb84$var$getWindow(reference).addEventListener("resize", state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $577b6fef00a0bb84$var$getScrollParent(reference);
    $577b6fef00a0bb84$var$attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $577b6fef00a0bb84$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $577b6fef00a0bb84$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $577b6fef00a0bb84$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $577b6fef00a0bb84$var$getWindow(reference).removeEventListener("resize", state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener("scroll", state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $577b6fef00a0bb84$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $577b6fef00a0bb84$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $577b6fef00a0bb84$var$isNumeric(n) {
    return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $577b6fef00a0bb84$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = "";
        // add unit if the value is numeric and is one of the following
        if ([
            "width",
            "height",
            "top",
            "right",
            "bottom",
            "left"
        ].indexOf(prop) !== -1 && $577b6fef00a0bb84$var$isNumeric(styles[prop])) unit = "px";
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $577b6fef00a0bb84$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $577b6fef00a0bb84$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $577b6fef00a0bb84$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $577b6fef00a0bb84$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $577b6fef00a0bb84$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $577b6fef00a0bb84$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $577b6fef00a0bb84$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $577b6fef00a0bb84$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute("x-placement", placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $577b6fef00a0bb84$var$setStyles(popper, {
        position: options.positionFixed ? "fixed" : "absolute"
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $577b6fef00a0bb84$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        "left",
        "right"
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf("-") !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $577b6fef00a0bb84$var$isFirefox = $577b6fef00a0bb84$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $577b6fef00a0bb84$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $577b6fef00a0bb84$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === "applyStyle";
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $577b6fef00a0bb84$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $577b6fef00a0bb84$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $577b6fef00a0bb84$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$577b6fef00a0bb84$var$isFirefox);
    var sideA = x === "bottom" ? "top" : "bottom";
    var sideB = y === "right" ? "left" : "right";
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $577b6fef00a0bb84$var$getSupportedPropertyName("transform");
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === "bottom") {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === "HTML") top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === "right") {
        if (offsetParent.nodeName === "HTML") left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = "transform";
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === "bottom" ? -1 : 1;
        var invertLeft = sideB === "right" ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ", " + sideB;
    }
    // Attributes
    var attributes = {
        "x-placement": data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $577b6fef00a0bb84$var$_extends({}, attributes, data.attributes);
    data.styles = $577b6fef00a0bb84$var$_extends({}, styles, data.styles);
    data.arrowStyles = $577b6fef00a0bb84$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $577b6fef00a0bb84$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $577b6fef00a0bb84$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = "`" + requestingName + "`";
        var requested = "`" + requestedName + "`";
        console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $577b6fef00a0bb84$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$577b6fef00a0bb84$var$isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn("WARNING: `arrow.element` must be child of its popper element!");
        return data;
    }
    var placement = data.placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        "left",
        "right"
    ].indexOf(placement) !== -1;
    var len = isVertical ? "height" : "width";
    var sideCapitalized = isVertical ? "Top" : "Left";
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? "left" : "top";
    var opSide = isVertical ? "bottom" : "right";
    var arrowElementSize = $577b6fef00a0bb84$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $577b6fef00a0bb84$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $577b6fef00a0bb84$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css["margin" + sideCapitalized]);
    var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"]);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $577b6fef00a0bb84$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $577b6fef00a0bb84$var$defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $577b6fef00a0bb84$var$getOppositeVariation(variation) {
    if (variation === "end") return "start";
    else if (variation === "start") return "end";
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $577b6fef00a0bb84$var$placements = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start"
];
// Get rid of `auto` `auto-start` and `auto-end`
var $577b6fef00a0bb84$var$validPlacements = $577b6fef00a0bb84$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $577b6fef00a0bb84$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $577b6fef00a0bb84$var$validPlacements.indexOf(placement);
    var arr = $577b6fef00a0bb84$var$validPlacements.slice(index + 1).concat($577b6fef00a0bb84$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $577b6fef00a0bb84$var$BEHAVIORS = {
    FLIP: "flip",
    CLOCKWISE: "clockwise",
    COUNTERCLOCKWISE: "counterclockwise"
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $577b6fef00a0bb84$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($577b6fef00a0bb84$var$isModifierEnabled(data.instance.modifiers, "inner")) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $577b6fef00a0bb84$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split("-")[0];
    var placementOpposite = $577b6fef00a0bb84$var$getOppositePlacement(placement);
    var variation = data.placement.split("-")[1] || "";
    var flipOrder = [];
    switch(options.behavior){
        case $577b6fef00a0bb84$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $577b6fef00a0bb84$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $577b6fef00a0bb84$var$clockwise(placement);
            break;
        case $577b6fef00a0bb84$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $577b6fef00a0bb84$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split("-")[0];
        placementOpposite = $577b6fef00a0bb84$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            "top",
            "bottom"
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $577b6fef00a0bb84$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? "-" + variation : "");
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $577b6fef00a0bb84$var$_extends({}, data.offsets.popper, $577b6fef00a0bb84$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $577b6fef00a0bb84$var$runModifiers(data.instance.modifiers, data, "flip");
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $577b6fef00a0bb84$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split("-")[0];
    var floor = Math.floor;
    var isVertical = [
        "top",
        "bottom"
    ].indexOf(placement) !== -1;
    var side = isVertical ? "right" : "bottom";
    var opSide = isVertical ? "left" : "top";
    var measurement = isVertical ? "width" : "height";
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $577b6fef00a0bb84$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf("%") === 0) {
        var element = void 0;
        switch(unit){
            case "%p":
                element = popperOffsets;
                break;
            case "%":
            case "%r":
            default:
                element = referenceOffsets;
        }
        var rect = $577b6fef00a0bb84$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === "vh" || unit === "vw") {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === "vh") size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $577b6fef00a0bb84$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        "right",
        "left"
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($577b6fef00a0bb84$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(",") === -1) console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? "height" : "width";
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === "" && [
                "+",
                "-"
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $577b6fef00a0bb84$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($577b6fef00a0bb84$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $577b6fef00a0bb84$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split("-")[0];
    var offsets = void 0;
    if ($577b6fef00a0bb84$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $577b6fef00a0bb84$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === "left") {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === "right") {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === "top") {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === "bottom") {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $577b6fef00a0bb84$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $577b6fef00a0bb84$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $577b6fef00a0bb84$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $577b6fef00a0bb84$var$getSupportedPropertyName("transform");
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = "";
    popperStyles.left = "";
    popperStyles[transformProp] = "";
    var boundaries = $577b6fef00a0bb84$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $577b6fef00a0bb84$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === "right" ? "left" : "top";
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
            return $577b6fef00a0bb84$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            "left",
            "top"
        ].indexOf(placement) !== -1 ? "primary" : "secondary";
        popper = $577b6fef00a0bb84$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $577b6fef00a0bb84$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var shiftvariation = placement.split("-")[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            "bottom",
            "top"
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? "left" : "top";
        var measurement = isVertical ? "width" : "height";
        var shiftOffsets = {
            start: $577b6fef00a0bb84$var$defineProperty({}, side, reference[side]),
            end: $577b6fef00a0bb84$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $577b6fef00a0bb84$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $577b6fef00a0bb84$var$hide(data) {
    if (!$577b6fef00a0bb84$var$isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) return data;
    var refRect = data.offsets.reference;
    var bound = $577b6fef00a0bb84$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === "preventOverflow";
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes["x-out-of-boundaries"] = "";
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes["x-out-of-boundaries"] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $577b6fef00a0bb84$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        "left",
        "right"
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        "top",
        "left"
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
    data.placement = $577b6fef00a0bb84$var$getOppositePlacement(placement);
    data.offsets.popper = $577b6fef00a0bb84$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $577b6fef00a0bb84$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $577b6fef00a0bb84$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $577b6fef00a0bb84$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $577b6fef00a0bb84$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: "scrollParent"
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $577b6fef00a0bb84$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $577b6fef00a0bb84$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: "[x-arrow]"
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $577b6fef00a0bb84$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: "flip",
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: "viewport",
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $577b6fef00a0bb84$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $577b6fef00a0bb84$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $577b6fef00a0bb84$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: "bottom",
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: "right"
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $577b6fef00a0bb84$var$applyStyle,
        /** @prop {Function} */ onLoad: $577b6fef00a0bb84$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $577b6fef00a0bb84$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: "bottom",
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $577b6fef00a0bb84$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $577b6fef00a0bb84$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $577b6fef00a0bb84$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $577b6fef00a0bb84$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $577b6fef00a0bb84$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($577b6fef00a0bb84$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $577b6fef00a0bb84$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $577b6fef00a0bb84$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $577b6fef00a0bb84$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $577b6fef00a0bb84$var$createClass(Popper, [
        {
            key: "update",
            value: function update$$1() {
                return $577b6fef00a0bb84$var$update.call(this);
            }
        },
        {
            key: "destroy",
            value: function destroy$$1() {
                return $577b6fef00a0bb84$var$destroy.call(this);
            }
        },
        {
            key: "enableEventListeners",
            value: function enableEventListeners$$1() {
                return $577b6fef00a0bb84$var$enableEventListeners.call(this);
            }
        },
        {
            key: "disableEventListeners",
            value: function disableEventListeners$$1() {
                return $577b6fef00a0bb84$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $577b6fef00a0bb84$var$Popper.Utils = (typeof window !== "undefined" ? window : $parcel$global).PopperUtils;
$577b6fef00a0bb84$var$Popper.placements = $577b6fef00a0bb84$var$placements;
$577b6fef00a0bb84$var$Popper.Defaults = $577b6fef00a0bb84$var$Defaults;
var $577b6fef00a0bb84$export$2e2bcd8739ae039 = $577b6fef00a0bb84$var$Popper;

});

parcelRegister("hdq6i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c887e5931e5427bd$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $9sDDw = parcelRequire("9sDDw");




var $KZePB = parcelRequire("KZePB");

var $nGnd5 = parcelRequire("nGnd5");
function $c887e5931e5427bd$var$getContainer(container) {
    container = typeof container === "function" ? container() : container; // #StrictMode ready
    return $9sDDw.findDOMNode(container);
}
var $c887e5931e5427bd$var$useEnhancedEffect = typeof window !== "undefined" ? $arQ7u.useLayoutEffect : $arQ7u.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ var $c887e5931e5427bd$var$Portal = /*#__PURE__*/ $arQ7u.forwardRef(function Portal(props, ref) {
    var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
    var _React$useState = $arQ7u.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
    var handleRef = (0, $nGnd5.default)(/*#__PURE__*/ $arQ7u.isValidElement(children) ? children.ref : null, ref);
    $c887e5931e5427bd$var$useEnhancedEffect(function() {
        if (!disablePortal) setMountNode($c887e5931e5427bd$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    $c887e5931e5427bd$var$useEnhancedEffect(function() {
        if (mountNode && !disablePortal) {
            (0, $KZePB.default)(ref, mountNode);
            return function() {
                (0, $KZePB.default)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    $c887e5931e5427bd$var$useEnhancedEffect(function() {
        if (onRendered && (mountNode || disablePortal)) onRendered();
    }, [
        onRendered,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $arQ7u.isValidElement(children)) return /*#__PURE__*/ $arQ7u.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $9sDDw.createPortal(children, mountNode) : mountNode;
});
var $c887e5931e5427bd$export$2e2bcd8739ae039 = $c887e5931e5427bd$var$Portal;

});

parcelRegister("1S9Kw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15d2659c36d07383$export$2e2bcd8739ae039; });
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $15d2659c36d07383$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}

});


parcelRegister("eIm5l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab664e6432bd0a77$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");
function $ab664e6432bd0a77$export$2e2bcd8739ae039(idOverride) {
    var _React$useState = $arQ7u.useState(idOverride), defaultId = _React$useState[0], setDefaultId = _React$useState[1];
    var id = idOverride || defaultId;
    $arQ7u.useEffect(function() {
        if (defaultId == null) // Fallback to this default id when possible.
        // Use the random value for client-side rendering only.
        // We can't use it server-side.
        setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }, [
        defaultId
    ]);
    return id;
}

});

parcelRegister("lhLsx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7effff217a4939f$export$2e2bcd8739ae039; });
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $arQ7u = parcelRequire("arQ7u");
function $f7effff217a4939f$export$2e2bcd8739ae039(_ref) {
    var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? "value" : _ref$state;
    var _React$useRef = $arQ7u.useRef(controlled !== undefined), isControlled = _React$useRef.current;
    var _React$useState = $arQ7u.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
    var value = isControlled ? controlled : valueState;
    var _React$useRef2, defaultValue;
    var setValueIfUncontrolled = $arQ7u.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});






parcelRegister("3UJeG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d99b0f3fcd70394$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $61Aec = parcelRequire("61Aec");

var $dj0kG = parcelRequire("dj0kG");
var $1MgBx = parcelRequire("1MgBx");
var $jGts0 = parcelRequire("jGts0");

var $33kNK = parcelRequire("33kNK");
/**
 * @param {Array} resources
 * @return {Array} [{ id: 'abc123', content: 'Annotation Content' }, ...]
 */ function $2d99b0f3fcd70394$var$getIdAndContentOfResources(resources) {
    return resources.map(function(resource, i) {
        return {
            content: resource.chars,
            id: resource.id,
            tags: resource.tags,
            targetId: resource.targetId
        };
    });
}
/** For connect */ var $2d99b0f3fcd70394$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var canvasId = _ref.canvasId, windowId = _ref.windowId;
    return {
        annotations: $2d99b0f3fcd70394$var$getIdAndContentOfResources((0, $dj0kG.getAnnotationResourcesByMotivationForCanvas)(state, {
            canvasId: canvasId,
            windowId: windowId
        })),
        htmlSanitizationRuleSet: (0, $jGts0.getConfig)(state).annotations.htmlSanitizationRuleSet,
        label: (0, $1MgBx.getCanvasLabel)(state, {
            canvasId: canvasId,
            windowId: windowId
        }),
        selectedAnnotationId: (0, $dj0kG.getSelectedAnnotationId)(state, {
            windowId: windowId
        })
    };
};
/**
 * mapDispatchToProps - to hook up connect
 * @memberof WindowSideBarAnnotationsPanel
 * @private
 */ var $2d99b0f3fcd70394$var$mapDispatchToProps = {
    deselectAnnotation: $61Aec.deselectAnnotation,
    hoverAnnotation: $61Aec.hoverAnnotation,
    selectAnnotation: $61Aec.selectAnnotation
};
/** For withStlyes */ var $2d99b0f3fcd70394$var$styles = function styles(theme) {
    return {
        annotationListItem: {
            "&$hovered": {
                backgroundColor: theme.palette.action.hover
            },
            "&:hover,&:focus": {
                backgroundColor: theme.palette.action.hover
            },
            borderBottom: "0.5px solid ".concat(theme.palette.divider),
            cursor: "pointer",
            whiteSpace: "normal"
        },
        chip: {
            backgroundColor: theme.palette.background.paper,
            marginRight: theme.spacing(0.5),
            marginTop: theme.spacing(1)
        },
        hovered: {},
        sectionHeading: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(1),
            paddingTop: theme.spacing(2)
        }
    };
};
var $2d99b0f3fcd70394$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $7EzGR.default)($2d99b0f3fcd70394$var$styles), (0, $fbonu.default)($2d99b0f3fcd70394$var$mapStateToProps, $2d99b0f3fcd70394$var$mapDispatchToProps), (0, $7XHRd.withPlugins)("CanvasAnnotations"));
var $2d99b0f3fcd70394$export$2e2bcd8739ae039 = $2d99b0f3fcd70394$var$enhance((0, $33kNK.CanvasAnnotations));

});
parcelRegister("33kNK", function(module, exports) {

$parcel$export(module.exports, "CanvasAnnotations", function () { return $2391c99c94553552$export$de5fd8999a921497; });

var $arQ7u = parcelRequire("arQ7u");

var $5g55B = parcelRequire("5g55B");

var $dSvjd = parcelRequire("dSvjd");

var $6lUyS = parcelRequire("6lUyS");

var $2NDUy = parcelRequire("2NDUy");

var $TXAJ5 = parcelRequire("TXAJ5");

var $hsH5s = parcelRequire("hsH5s");

var $7TK2Y = parcelRequire("7TK2Y");

var $k3oId = parcelRequire("k3oId");
function $2391c99c94553552$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2391c99c94553552$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2391c99c94553552$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2391c99c94553552$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2391c99c94553552$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2391c99c94553552$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $2391c99c94553552$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $2391c99c94553552$var$_setPrototypeOf(subClass, superClass);
}
function $2391c99c94553552$var$_setPrototypeOf(o, p) {
    $2391c99c94553552$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2391c99c94553552$var$_setPrototypeOf(o, p);
}
function $2391c99c94553552$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2391c99c94553552$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $2391c99c94553552$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2391c99c94553552$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2391c99c94553552$var$_possibleConstructorReturn(this, result);
    };
}
function $2391c99c94553552$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2391c99c94553552$var$_assertThisInitialized(self);
}
function $2391c99c94553552$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2391c99c94553552$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2391c99c94553552$var$_getPrototypeOf(o) {
    $2391c99c94553552$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2391c99c94553552$var$_getPrototypeOf(o);
}
var $2391c99c94553552$export$de5fd8999a921497 = /*#__PURE__*/ function(_Component) {
    $2391c99c94553552$var$_inherits(CanvasAnnotations, _Component);
    var _super = $2391c99c94553552$var$_createSuper(CanvasAnnotations);
    /**
   * constructor -
   */ function CanvasAnnotations(props) {
        var _this;
        $2391c99c94553552$var$_classCallCheck(this, CanvasAnnotations);
        _this = _super.call(this, props);
        _this.handleClick = _this.handleClick.bind($2391c99c94553552$var$_assertThisInitialized(_this));
        _this.handleAnnotationHover = _this.handleAnnotationHover.bind($2391c99c94553552$var$_assertThisInitialized(_this));
        _this.handleAnnotationBlur = _this.handleAnnotationBlur.bind($2391c99c94553552$var$_assertThisInitialized(_this));
        return _this;
    }
    /**
   * Handle click event of an annotation.
  */ $2391c99c94553552$var$_createClass(CanvasAnnotations, [
        {
            key: "handleClick",
            value: function handleClick(event, annotation) {
                var _this$props = this.props, deselectAnnotation = _this$props.deselectAnnotation, selectAnnotation = _this$props.selectAnnotation, selectedAnnotationId = _this$props.selectedAnnotationId, windowId = _this$props.windowId;
                if (selectedAnnotationId === annotation.id) deselectAnnotation(windowId, annotation.id);
                else selectAnnotation(windowId, annotation.id);
            }
        },
        {
            key: "handleAnnotationHover",
            value: function handleAnnotationHover(annotation) {
                var _this$props2 = this.props, hoverAnnotation = _this$props2.hoverAnnotation, windowId = _this$props2.windowId;
                hoverAnnotation(windowId, [
                    annotation.id
                ]);
            }
        },
        {
            key: "handleAnnotationBlur",
            value: function handleAnnotationBlur() {
                var _this$props3 = this.props, hoverAnnotation = _this$props3.hoverAnnotation, windowId = _this$props3.windowId;
                hoverAnnotation(windowId, []);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props4 = this.props, annotations = _this$props4.annotations, classes = _this$props4.classes, index = _this$props4.index, label = _this$props4.label, selectedAnnotationId = _this$props4.selectedAnnotationId, t = _this$props4.t, totalSize = _this$props4.totalSize, listContainerComponent = _this$props4.listContainerComponent, htmlSanitizationRuleSet = _this$props4.htmlSanitizationRuleSet, hoveredAnnotationIds = _this$props4.hoveredAnnotationIds, containerRef = _this$props4.containerRef;
                if (annotations.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    className: classes.sectionHeading,
                    variant: "overline"
                }, t("annotationCanvasLabel", {
                    context: "".concat(index + 1, "/").concat(totalSize),
                    label: label
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $6lUyS.default), {
                    autoFocusItem: true,
                    variant: "selectedMenu"
                }, annotations.map(function(annotation) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $k3oId.ScrollTo), {
                        containerRef: containerRef,
                        key: "".concat(annotation.id, "-scroll"),
                        offsetTop: 96 // offset for the height of the form above
                        ,
                        scrollTo: selectedAnnotationId === annotation.id
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $2NDUy.default), {
                        button: true,
                        component: listContainerComponent,
                        className: (0, $5g55B.default)(classes.annotationListItem, $2391c99c94553552$var$_defineProperty({}, classes.hovered, hoveredAnnotationIds.includes(annotation.id))),
                        key: annotation.id,
                        annotationid: annotation.id,
                        selected: selectedAnnotationId === annotation.id,
                        onClick: function onClick(e) {
                            return _this2.handleClick(e, annotation);
                        },
                        onFocus: function onFocus() {
                            return _this2.handleAnnotationHover(annotation);
                        },
                        onBlur: _this2.handleAnnotationBlur,
                        onMouseEnter: function onMouseEnter() {
                            return _this2.handleAnnotationHover(annotation);
                        },
                        onMouseLeave: _this2.handleAnnotationBlur
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $TXAJ5.default), {
                        primaryTypographyProps: {
                            variant: "body2"
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7TK2Y.default), {
                        ruleSet: htmlSanitizationRuleSet,
                        htmlString: annotation.content
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", null, annotation.tags.map(function(tag) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $dSvjd.default), {
                            size: "small",
                            variant: "outlined",
                            label: tag,
                            id: tag,
                            className: classes.chip,
                            key: tag.toString()
                        });
                    })))));
                })));
            }
        }
    ]);
    return CanvasAnnotations;
}((0, $arQ7u.Component));
$2391c99c94553552$export$de5fd8999a921497.defaultProps = {
    annotations: [],
    classes: {},
    containerRef: undefined,
    hoveredAnnotationIds: [],
    htmlSanitizationRuleSet: "iiif",
    listContainerComponent: "li",
    selectedAnnotationId: undefined
};

});
parcelRegister("dSvjd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1a89acf7b432170$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $6yXLp = parcelRequire("6yXLp");

var $7EzGR = parcelRequire("7EzGR");

var $6vqZH = parcelRequire("6vqZH");

var $nGnd5 = parcelRequire("nGnd5");


var $kaLUp = parcelRequire("kaLUp");

var $b71IR = parcelRequire("b71IR");
var $a1a89acf7b432170$export$9dd6ff9ea0189349 = function styles(theme) {
    var backgroundColor = theme.palette.type === "light" ? theme.palette.grey[300] : theme.palette.grey[700];
    var deleteIconColor = (0, $6vqZH.alpha)(theme.palette.text.primary, 0.26);
    return {
        /* Styles applied to the root element. */ root: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(13),
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            height: 32,
            color: theme.palette.getContrastText(backgroundColor),
            backgroundColor: backgroundColor,
            borderRadius: 16,
            whiteSpace: "nowrap",
            transition: theme.transitions.create([
                "background-color",
                "box-shadow"
            ]),
            // label will inherit this from root, then `clickable` class overrides this for both
            cursor: "default",
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0,
            textDecoration: "none",
            border: "none",
            // Remove `button` border
            padding: 0,
            // Remove `button` padding
            verticalAlign: "middle",
            boxSizing: "border-box",
            "&$disabled": {
                opacity: 0.5,
                pointerEvents: "none"
            },
            "& $avatar": {
                marginLeft: 5,
                marginRight: -6,
                width: 24,
                height: 24,
                color: theme.palette.type === "light" ? theme.palette.grey[700] : theme.palette.grey[300],
                fontSize: theme.typography.pxToRem(12)
            },
            "& $avatarColorPrimary": {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.dark
            },
            "& $avatarColorSecondary": {
                color: theme.palette.secondary.contrastText,
                backgroundColor: theme.palette.secondary.dark
            },
            "& $avatarSmall": {
                marginLeft: 4,
                marginRight: -4,
                width: 18,
                height: 18,
                fontSize: theme.typography.pxToRem(10)
            }
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            height: 24
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */ clickable: {
            userSelect: "none",
            WebkitTapHighlightColor: "transparent",
            cursor: "pointer",
            "&:hover, &:focus": {
                backgroundColor: (0, $6vqZH.emphasize)(backgroundColor, 0.08)
            },
            "&:active": {
                boxShadow: theme.shadows[1]
            }
        },
        /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */ clickableColorPrimary: {
            "&:hover, &:focus": {
                backgroundColor: (0, $6vqZH.emphasize)(theme.palette.primary.main, 0.08)
            }
        },
        /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */ clickableColorSecondary: {
            "&:hover, &:focus": {
                backgroundColor: (0, $6vqZH.emphasize)(theme.palette.secondary.main, 0.08)
            }
        },
        /* Styles applied to the root element if `onDelete` is defined. */ deletable: {
            "&:focus": {
                backgroundColor: (0, $6vqZH.emphasize)(backgroundColor, 0.08)
            }
        },
        /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */ deletableColorPrimary: {
            "&:focus": {
                backgroundColor: (0, $6vqZH.emphasize)(theme.palette.primary.main, 0.2)
            }
        },
        /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */ deletableColorSecondary: {
            "&:focus": {
                backgroundColor: (0, $6vqZH.emphasize)(theme.palette.secondary.main, 0.2)
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            backgroundColor: "transparent",
            border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
            "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
            },
            "& $avatar": {
                marginLeft: 4
            },
            "& $avatarSmall": {
                marginLeft: 2
            },
            "& $icon": {
                marginLeft: 4
            },
            "& $iconSmall": {
                marginLeft: 2
            },
            "& $deleteIcon": {
                marginRight: 5
            },
            "& $deleteIconSmall": {
                marginRight: 3
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat(theme.palette.primary.main),
            "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat(theme.palette.secondary.main),
            "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
            }
        },
        // TODO v5: remove
        /* Styles applied to the `avatar` element. */ avatar: {},
        /* Styles applied to the `avatar` element if `size="small"`. */ avatarSmall: {},
        /* Styles applied to the `avatar` element if `color="primary"`. */ avatarColorPrimary: {},
        /* Styles applied to the `avatar` element if `color="secondary"`. */ avatarColorSecondary: {},
        /* Styles applied to the `icon` element. */ icon: {
            color: theme.palette.type === "light" ? theme.palette.grey[700] : theme.palette.grey[300],
            marginLeft: 5,
            marginRight: -6
        },
        /* Styles applied to the `icon` element if `size="small"`. */ iconSmall: {
            width: 18,
            height: 18,
            marginLeft: 4,
            marginRight: -4
        },
        /* Styles applied to the `icon` element if `color="primary"`. */ iconColorPrimary: {
            color: "inherit"
        },
        /* Styles applied to the `icon` element if `color="secondary"`. */ iconColorSecondary: {
            color: "inherit"
        },
        /* Styles applied to the label `span` element. */ label: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            paddingLeft: 12,
            paddingRight: 12,
            whiteSpace: "nowrap"
        },
        /* Styles applied to the label `span` element if `size="small"`. */ labelSmall: {
            paddingLeft: 8,
            paddingRight: 8
        },
        /* Styles applied to the `deleteIcon` element. */ deleteIcon: {
            WebkitTapHighlightColor: "transparent",
            color: deleteIconColor,
            height: 22,
            width: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: (0, $6vqZH.alpha)(deleteIconColor, 0.4)
            }
        },
        /* Styles applied to the `deleteIcon` element if `size="small"`. */ deleteIconSmall: {
            height: 16,
            width: 16,
            marginRight: 4,
            marginLeft: -4
        },
        /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */ deleteIconColorPrimary: {
            color: (0, $6vqZH.alpha)(theme.palette.primary.contrastText, 0.7),
            "&:hover, &:active": {
                color: theme.palette.primary.contrastText
            }
        },
        /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */ deleteIconColorSecondary: {
            color: (0, $6vqZH.alpha)(theme.palette.secondary.contrastText, 0.7),
            "&:hover, &:active": {
                color: theme.palette.secondary.contrastText
            }
        },
        /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */ deleteIconOutlinedColorPrimary: {
            color: (0, $6vqZH.alpha)(theme.palette.primary.main, 0.7),
            "&:hover, &:active": {
                color: theme.palette.primary.main
            }
        },
        /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */ deleteIconOutlinedColorSecondary: {
            color: (0, $6vqZH.alpha)(theme.palette.secondary.main, 0.7),
            "&:hover, &:active": {
                color: theme.palette.secondary.main
            }
        }
    };
};
function $a1a89acf7b432170$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ var $a1a89acf7b432170$var$Chip = /*#__PURE__*/ $arQ7u.forwardRef(function Chip(props, ref) {
    var avatarProp = props.avatar, classes = props.classes, className = props.className, clickableProp = props.clickable, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, ComponentProp = props.component, deleteIconProp = props.deleteIcon, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, iconProp = props.icon, label = props.label, onClick = props.onClick, onDelete = props.onDelete, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? "default" : _props$variant, other = (0, $dXEVX.default)(props, [
        "avatar",
        "classes",
        "className",
        "clickable",
        "color",
        "component",
        "deleteIcon",
        "disabled",
        "icon",
        "label",
        "onClick",
        "onDelete",
        "onKeyDown",
        "onKeyUp",
        "size",
        "variant"
    ]);
    var chipRef = $arQ7u.useRef(null);
    var handleRef = (0, $nGnd5.default)(chipRef, ref);
    var handleDeleteIconClick = function handleDeleteIconClick(event) {
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    var handleKeyDown = function handleKeyDown(event) {
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $a1a89acf7b432170$var$isDeleteKeyboardEvent(event)) // will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    var handleKeyUp = function handleKeyUp(event) {
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $a1a89acf7b432170$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    var clickable = clickableProp !== false && onClick ? true : clickableProp;
    var small = size === "small";
    var Component = ComponentProp || (clickable ? (0, $b71IR.default) : "div");
    var moreProps = Component === (0, $b71IR.default) ? {
        component: "div"
    } : {};
    var deleteIcon = null;
    if (onDelete) {
        var customClasses = (0, $5g55B.default)(color !== "default" && (variant === "default" ? classes["deleteIconColor".concat((0, $kaLUp.default)(color))] : classes["deleteIconOutlinedColor".concat((0, $kaLUp.default)(color))]), small && classes.deleteIconSmall);
        deleteIcon = deleteIconProp && /*#__PURE__*/ $arQ7u.isValidElement(deleteIconProp) ? /*#__PURE__*/ $arQ7u.cloneElement(deleteIconProp, {
            className: (0, $5g55B.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        }) : /*#__PURE__*/ $arQ7u.createElement((0, $6yXLp.default), {
            className: (0, $5g55B.default)(classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        });
    }
    var avatar = null;
    if (avatarProp && /*#__PURE__*/ $arQ7u.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $arQ7u.cloneElement(avatarProp, {
        className: (0, $5g55B.default)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== "default" && classes["avatarColor".concat((0, $kaLUp.default)(color))])
    });
    var icon = null;
    if (iconProp && /*#__PURE__*/ $arQ7u.isValidElement(iconProp)) icon = /*#__PURE__*/ $arQ7u.cloneElement(iconProp, {
        className: (0, $5g55B.default)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== "default" && classes["iconColor".concat((0, $kaLUp.default)(color))])
    });
    return /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        role: clickable || onDelete ? "button" : undefined,
        className: (0, $5g55B.default)(classes.root, className, color !== "default" && [
            classes["color".concat((0, $kaLUp.default)(color))],
            clickable && classes["clickableColor".concat((0, $kaLUp.default)(color))],
            onDelete && classes["deletableColor".concat((0, $kaLUp.default)(color))]
        ], variant !== "default" && [
            classes.outlined,
            {
                "primary": classes.outlinedPrimary,
                "secondary": classes.outlinedSecondary
            }[color]
        ], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
        "aria-disabled": disabled ? true : undefined,
        tabIndex: clickable || onDelete ? 0 : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef
    }, moreProps, other), avatar || icon, /*#__PURE__*/ $arQ7u.createElement("span", {
        className: (0, $5g55B.default)(classes.label, small && classes.labelSmall)
    }, label), deleteIcon);
});
var $a1a89acf7b432170$export$2e2bcd8739ae039 = (0, $7EzGR.default)($a1a89acf7b432170$export$9dd6ff9ea0189349, {
    name: "MuiChip"
})($a1a89acf7b432170$var$Chip);

});
parcelRegister("6yXLp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c7446e2bf294397$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $2Ml3G = parcelRequire("2Ml3G");
var /**
 * @ignore - internal component.
 */ $4c7446e2bf294397$export$2e2bcd8739ae039 = (0, $2Ml3G.default)(/*#__PURE__*/ $arQ7u.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");

});


parcelRegister("6lUyS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a009434c6fbd135$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");
parcelRequire("legPH");


var $9sDDw = parcelRequire("9sDDw");

var $5Yg7t = parcelRequire("5Yg7t");

var $48mel = parcelRequire("48mel");

var $k5Hn9 = parcelRequire("k5Hn9");

var $nGnd5 = parcelRequire("nGnd5");
function $4a009434c6fbd135$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $4a009434c6fbd135$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $4a009434c6fbd135$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    var text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $4a009434c6fbd135$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$4a009434c6fbd135$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return;
        }
    }
}
var $4a009434c6fbd135$var$useEnhancedEffect = typeof window === "undefined" ? $arQ7u.useEffect : $arQ7u.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ var $4a009434c6fbd135$var$MenuList = /*#__PURE__*/ $arQ7u.forwardRef(function MenuList(props, ref) {
    var actions = props.actions, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$autoFocusItem = props.autoFocusItem, autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem, children = props.children, className = props.className, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, onKeyDown = props.onKeyDown, _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0, $dXEVX.default)(props, [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant"
    ]);
    var listRef = $arQ7u.useRef(null);
    var textCriteriaRef = $arQ7u.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    $4a009434c6fbd135$var$useEnhancedEffect(function() {
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $arQ7u.useImperativeHandle(actions, function() {
        return {
            adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, $k5Hn9.default)(true), "px");
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
                return listRef.current;
            }
        };
    }, []);
    var handleKeyDown = function handleKeyDown(event) {
        var list = listRef.current;
        var key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ var currentFocus = (0, $5Yg7t.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $4a009434c6fbd135$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $4a009434c6fbd135$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $4a009434c6fbd135$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $4a009434c6fbd135$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $4a009434c6fbd135$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $4a009434c6fbd135$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $4a009434c6fbd135$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $4a009434c6fbd135$var$previousItem);
        } else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && $4a009434c6fbd135$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $4a009434c6fbd135$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $4a009434c6fbd135$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleOwnRef = $arQ7u.useCallback(function(instance) {
        // #StrictMode ready
        listRef.current = $9sDDw.findDOMNode(instance);
    }, []);
    var handleRef = (0, $nGnd5.default)(handleOwnRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $arQ7u.Children.forEach(children, function(child, index) {
        if (!/*#__PURE__*/ $arQ7u.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $arQ7u.Children.map(children, function(child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $arQ7u.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ $arQ7u.createElement((0, $48mel.default), (0, $abElG.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other), items);
});
var $4a009434c6fbd135$export$2e2bcd8739ae039 = $4a009434c6fbd135$var$MenuList;

});
parcelRegister("5Yg7t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $458f0f5c3c898883$export$2e2bcd8739ae039; });
function $458f0f5c3c898883$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("48mel", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30292746e2a88d03$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");

var $eouD9 = parcelRequire("eouD9");
var $30292746e2a88d03$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    },
    /* Styles applied to the root element if `disablePadding={false}`. */ padding: {
        paddingTop: 8,
        paddingBottom: 8
    },
    /* Styles applied to the root element if dense. */ dense: {},
    /* Styles applied to the root element if a `subheader` is provided. */ subheader: {
        paddingTop: 0
    }
};
var $30292746e2a88d03$var$List = /*#__PURE__*/ $arQ7u.forwardRef(function List(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "ul" : _props$component, _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disablePadding = props.disablePadding, disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding, subheader = props.subheader, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    var context = $arQ7u.useMemo(function() {
        return {
            dense: dense
        };
    }, [
        dense
    ]);
    return /*#__PURE__*/ $arQ7u.createElement((0, $eouD9.default).Provider, {
        value: context
    }, /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
        ref: ref
    }, other), subheader, children));
});
var $30292746e2a88d03$export$2e2bcd8739ae039 = (0, $7EzGR.default)($30292746e2a88d03$export$9dd6ff9ea0189349, {
    name: "MuiList"
})($30292746e2a88d03$var$List);

});
parcelRegister("eouD9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7ab1127fc142413$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");
/**
 * @ignore - internal component.
 */ var $a7ab1127fc142413$var$ListContext = $arQ7u.createContext({});
var $a7ab1127fc142413$export$2e2bcd8739ae039 = $a7ab1127fc142413$var$ListContext;

});


parcelRegister("k5Hn9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea05eb2566004ad8$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function $ea05eb2566004ad8$export$2e2bcd8739ae039() {
    var scrollDiv = document.createElement("div");
    scrollDiv.style.width = "99px";
    scrollDiv.style.height = "99px";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}

});


parcelRegister("2NDUy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $209f1deaaa7f1fb6$export$2e2bcd8739ae039; });

var $dXEVX = parcelRequire("dXEVX");

var $4g0WD = parcelRequire("4g0WD");

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");

var $iUlUh = parcelRequire("iUlUh");
var $209f1deaaa7f1fb6$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $abElG.default)({}, theme.typography.body1, (0, $4g0WD.default)({
            minHeight: 48,
            paddingTop: 6,
            paddingBottom: 6,
            boxSizing: "border-box",
            width: "auto",
            overflow: "hidden",
            whiteSpace: "nowrap"
        }, theme.breakpoints.up("sm"), {
            minHeight: "auto"
        })),
        // TODO v5: remove
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: {},
        /* Styles applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the root element if dense. */ dense: (0, $abElG.default)({}, theme.typography.body2, {
            minHeight: "auto"
        })
    };
};
var $209f1deaaa7f1fb6$var$MenuItem = /*#__PURE__*/ $arQ7u.forwardRef(function MenuItem(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "li" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, ListItemClasses = props.ListItemClasses, _props$role = props.role, role = _props$role === void 0 ? "menuitem" : _props$role, selected = props.selected, tabIndexProp = props.tabIndex, other = (0, $dXEVX.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "ListItemClasses",
        "role",
        "selected",
        "tabIndex"
    ]);
    var tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ $arQ7u.createElement((0, $iUlUh.default), (0, $abElG.default)({
        button: true,
        role: role,
        tabIndex: tabIndex,
        component: component,
        selected: selected,
        disableGutters: disableGutters,
        classes: (0, $abElG.default)({
            dense: classes.dense
        }, ListItemClasses),
        className: (0, $5g55B.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $209f1deaaa7f1fb6$export$2e2bcd8739ae039 = (0, $7EzGR.default)($209f1deaaa7f1fb6$export$9dd6ff9ea0189349, {
    name: "MuiMenuItem"
})($209f1deaaa7f1fb6$var$MenuItem);

});
parcelRegister("iUlUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc3e73307301e994$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");


var $7EzGR = parcelRequire("7EzGR");

var $b71IR = parcelRequire("b71IR");

var $jOGar = parcelRequire("jOGar");

var $nGnd5 = parcelRequire("nGnd5");

var $eouD9 = parcelRequire("eouD9");

var $9sDDw = parcelRequire("9sDDw");
var $dc3e73307301e994$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */ root: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            position: "relative",
            textDecoration: "none",
            width: "100%",
            boxSizing: "border-box",
            textAlign: "left",
            paddingTop: 8,
            paddingBottom: 8,
            "&$focusVisible": {
                backgroundColor: theme.palette.action.selected
            },
            "&$selected, &$selected:hover": {
                backgroundColor: theme.palette.action.selected
            },
            "&$disabled": {
                opacity: 0.5
            }
        },
        /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */ container: {
            position: "relative"
        },
        /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */ focusVisible: {},
        /* Styles applied to the `component` element if dense. */ dense: {
            paddingTop: 4,
            paddingBottom: 4
        },
        /* Styles applied to the `component` element if `alignItems="flex-start"`. */ alignItemsFlexStart: {
            alignItems: "flex-start"
        },
        /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the inner `component` element if `divider={true}`. */ divider: {
            borderBottom: "1px solid ".concat(theme.palette.divider),
            backgroundClip: "padding-box"
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the inner `component` element if `button={true}`. */ button: {
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */ secondaryAction: {
            // Add some space to avoid collision as `ListItemSecondaryAction`
            // is absolutely positioned.
            paddingRight: 48
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {}
    };
};
var $dc3e73307301e994$var$useEnhancedEffect = typeof window === "undefined" ? $arQ7u.useEffect : $arQ7u.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ var $dc3e73307301e994$var$ListItem = /*#__PURE__*/ $arQ7u.forwardRef(function ListItem(props, ref) {
    var _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "center" : _props$alignItems, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$button = props.button, button = _props$button === void 0 ? false : _props$button, childrenProp = props.children, classes = props.classes, className = props.className, componentProp = props.component, _props$ContainerCompo = props.ContainerComponent, ContainerComponent = _props$ContainerCompo === void 0 ? "li" : _props$ContainerCompo, _props$ContainerProps = props.ContainerProps;
    _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
    var ContainerClassName = _props$ContainerProps.className, ContainerProps = (0, $dXEVX.default)(_props$ContainerProps, [
        "className"
    ]), _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$divider = props.divider, divider = _props$divider === void 0 ? false : _props$divider, focusVisibleClassName = props.focusVisibleClassName, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $dXEVX.default)(props, [
        "alignItems",
        "autoFocus",
        "button",
        "children",
        "classes",
        "className",
        "component",
        "ContainerComponent",
        "ContainerProps",
        "dense",
        "disabled",
        "disableGutters",
        "divider",
        "focusVisibleClassName",
        "selected"
    ]);
    var context = $arQ7u.useContext((0, $eouD9.default));
    var childContext = {
        dense: dense || context.dense || false,
        alignItems: alignItems
    };
    var listItemRef = $arQ7u.useRef(null);
    $dc3e73307301e994$var$useEnhancedEffect(function() {
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    var children = $arQ7u.Children.toArray(childrenProp);
    var hasSecondaryAction = children.length && (0, $jOGar.default)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    var handleOwnRef = $arQ7u.useCallback(function(instance) {
        // #StrictMode ready
        listItemRef.current = $9sDDw.findDOMNode(instance);
    }, []);
    var handleRef = (0, $nGnd5.default)(handleOwnRef, ref);
    var componentProps = (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
        disabled: disabled
    }, other);
    var Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $5g55B.default)(classes.focusVisible, focusVisibleClassName);
        Component = (0, $b71IR.default);
    }
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component; // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ $arQ7u.createElement((0, $eouD9.default).Provider, {
            value: childContext
        }, /*#__PURE__*/ $arQ7u.createElement(ContainerComponent, (0, $abElG.default)({
            className: (0, $5g55B.default)(classes.container, ContainerClassName),
            ref: handleRef
        }, ContainerProps), /*#__PURE__*/ $arQ7u.createElement(Component, componentProps, children), children.pop()));
    }
    return /*#__PURE__*/ $arQ7u.createElement((0, $eouD9.default).Provider, {
        value: childContext
    }, /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        ref: handleRef
    }, componentProps), children));
});
var $dc3e73307301e994$export$2e2bcd8739ae039 = (0, $7EzGR.default)($dc3e73307301e994$export$9dd6ff9ea0189349, {
    name: "MuiListItem"
})($dc3e73307301e994$var$ListItem);

});
parcelRegister("jOGar", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6d36568fd97e66d$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");
function $e6d36568fd97e66d$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $arQ7u.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

});



parcelRegister("TXAJ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a835cc55d724131$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");

var $hsH5s = parcelRequire("hsH5s");

var $eouD9 = parcelRequire("eouD9");
var $0a835cc55d724131$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    },
    /* Styles applied to the `Typography` components if primary and secondary are set. */ multiline: {
        marginTop: 6,
        marginBottom: 6
    },
    /* Styles applied to the `Typography` components if dense. */ dense: {},
    /* Styles applied to the root element if `inset={true}`. */ inset: {
        paddingLeft: 56
    },
    /* Styles applied to the primary `Typography` component. */ primary: {},
    /* Styles applied to the secondary `Typography` component. */ secondary: {}
};
var $0a835cc55d724131$var$ListItemText = /*#__PURE__*/ $arQ7u.forwardRef(function ListItemText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, _props$inset = props.inset, inset = _props$inset === void 0 ? false : _props$inset, primaryProp = props.primary, primaryTypographyProps = props.primaryTypographyProps, secondaryProp = props.secondary, secondaryTypographyProps = props.secondaryTypographyProps, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "className",
        "disableTypography",
        "inset",
        "primary",
        "primaryTypographyProps",
        "secondary",
        "secondaryTypographyProps"
    ]);
    var _React$useContext = $arQ7u.useContext((0, $eouD9.default)), dense = _React$useContext.dense;
    var primary = primaryProp != null ? primaryProp : children;
    if (primary != null && primary.type !== (0, $hsH5s.default) && !disableTypography) primary = /*#__PURE__*/ $arQ7u.createElement((0, $hsH5s.default), (0, $abElG.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: "span",
        display: "block"
    }, primaryTypographyProps), primary);
    var secondary = secondaryProp;
    if (secondary != null && secondary.type !== (0, $hsH5s.default) && !disableTypography) secondary = /*#__PURE__*/ $arQ7u.createElement((0, $hsH5s.default), (0, $abElG.default)({
        variant: "body2",
        className: classes.secondary,
        color: "textSecondary",
        display: "block"
    }, secondaryTypographyProps), secondary);
    return /*#__PURE__*/ $arQ7u.createElement("div", (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
        ref: ref
    }, other), primary, secondary);
});
var $0a835cc55d724131$export$2e2bcd8739ae039 = (0, $7EzGR.default)($0a835cc55d724131$export$9dd6ff9ea0189349, {
    name: "MuiListItemText"
})($0a835cc55d724131$var$ListItemText);

});

parcelRegister("7TK2Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c016367d46bddd3$export$2e2bcd8739ae039; });

var $7EzGR = parcelRequire("7EzGR");

var $3Iiii = parcelRequire("3Iiii");
/**
 * Styles for withStyles HOC
 */ var $5c016367d46bddd3$var$styles = function styles(theme) {
    return {
        root: {
            "& a": {
                color: theme.palette.primary.main,
                textDecoration: "underline"
            }
        }
    };
};
var $5c016367d46bddd3$export$2e2bcd8739ae039 = (0, $7EzGR.default)($5c016367d46bddd3$var$styles)((0, $3Iiii.SanitizedHtml));

});
parcelRegister("3Iiii", function(module, exports) {

$parcel$export(module.exports, "SanitizedHtml", function () { return $2b43abfcadee5821$export$6e2f1cf591d7b78; });

var $arQ7u = parcelRequire("arQ7u");

var $fB4h0 = parcelRequire("fB4h0");

var $1xlvK = parcelRequire("1xlvK");

var $4gnPX = parcelRequire("4gnPX");
function $2b43abfcadee5821$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2b43abfcadee5821$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2b43abfcadee5821$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2b43abfcadee5821$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2b43abfcadee5821$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $2b43abfcadee5821$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $2b43abfcadee5821$var$_setPrototypeOf(subClass, superClass);
}
function $2b43abfcadee5821$var$_setPrototypeOf(o, p) {
    $2b43abfcadee5821$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2b43abfcadee5821$var$_setPrototypeOf(o, p);
}
function $2b43abfcadee5821$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2b43abfcadee5821$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $2b43abfcadee5821$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2b43abfcadee5821$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2b43abfcadee5821$var$_possibleConstructorReturn(this, result);
    };
}
function $2b43abfcadee5821$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2b43abfcadee5821$var$_assertThisInitialized(self);
}
function $2b43abfcadee5821$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2b43abfcadee5821$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2b43abfcadee5821$var$_getPrototypeOf(o) {
    $2b43abfcadee5821$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2b43abfcadee5821$var$_getPrototypeOf(o);
}
var $2b43abfcadee5821$export$6e2f1cf591d7b78 = /*#__PURE__*/ function(_Component) {
    $2b43abfcadee5821$var$_inherits(SanitizedHtml, _Component);
    var _super = $2b43abfcadee5821$var$_createSuper(SanitizedHtml);
    function SanitizedHtml() {
        $2b43abfcadee5821$var$_classCallCheck(this, SanitizedHtml);
        return _super.apply(this, arguments);
    }
    $2b43abfcadee5821$var$_createClass(SanitizedHtml, [
        {
            key: "render",
            value: /**
    */ function render() {
                var _this$props = this.props, classes = _this$props.classes, htmlString = _this$props.htmlString, ruleSet = _this$props.ruleSet; // Add a hook to make all links open a new window
                (0, (/*@__PURE__*/$parcel$interopDefault($fB4h0))).addHook("afterSanitizeAttributes", function(node) {
                    // set all elements owning target to target=_blank
                    if ("target" in node) {
                        node.setAttribute("target", "_blank"); // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
                        node.setAttribute("rel", "noopener noreferrer");
                    }
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("span", {
                    className: [
                        classes.root,
                        (0, $1xlvK.default)("third-party-html")
                    ].join(" "),
                    dangerouslySetInnerHTML: {
                        // eslint-disable-line react/no-danger
                        __html: (0, (/*@__PURE__*/$parcel$interopDefault($fB4h0))).sanitize(htmlString, (0, $4gnPX.default)[ruleSet])
                    }
                });
            }
        }
    ]);
    return SanitizedHtml;
}((0, $arQ7u.Component));
$2b43abfcadee5821$export$6e2f1cf591d7b78.defaultProps = {
    classes: {}
};

});
parcelRegister("fB4h0", function(module, exports) {
/*! @license DOMPurify 2.5.2 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.2/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== "undefined" && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === "string") {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn("fallback value for", element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "select",
        "shadow",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]);
    // SVG
    var svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    var svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "fedropshadow",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    var mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover"
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    var text = freeze([
        "#text"
    ]);
    var html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "pattern",
        "placeholder",
        "playsinline",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "xmlns",
        "slot"
    ]);
    var svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    var mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    var xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = "data-tt-policy-suffix";
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = "2.5.2";
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        var getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        var getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        var getParentNode = lookupGetter(ElementPrototype, "parentNode");
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === "function") {
            var template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML("") : "";
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        var MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Specify the maximum element nesting depth to prevent mXSS */ var MAX_NESTING_DEPTH = 255;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement("form");
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== "object") cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = "ALLOWED_TAGS" in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = "ALLOWED_ATTR" in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = "ALLOWED_NAMESPACES" in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = "ADD_URI_SAFE_ATTR" in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = "ADD_DATA_URI_TAGS" in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = "FORBID_CONTENTS" in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = "FORBID_TAGS" in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = "FORBID_ATTR" in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = "USE_PROFILES" in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            "foreignobject",
            "annotation-xml"
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: "template"
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === "is" && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.__depth !== "undefined" && typeof elm.__depth !== "number" || typeof elm.__removalCount !== "undefined" && typeof elm.__removalCount !== "number" || typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function" || typeof elm.hasChildNodes !== "function");
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === "object" ? object instanceof Node : object && _typeof(object) === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string";
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook("beforeSanitizeElements", currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook("uponSanitizeElement", currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === "select" && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, " ");
                content = stringReplace(content, ERB_EXPR$1, " ");
                content = stringReplace(content, TMPLIT_EXPR$1, " ");
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeElements", currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== "annotation-xml" && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook("beforeSanitizeAttributes", currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === "value" ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, " ");
                    value = stringReplace(value, ERB_EXPR$1, " ");
                    value = stringReplace(value, TMPLIT_EXPR$1, " ");
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === "object" && typeof trustedTypes.getAttributeType === "function") {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case "TrustedHTML":
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case "TrustedScriptURL":
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeAttributes", currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook("beforeSanitizeShadowDOM", fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook("uponSanitizeShadowNode", shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                var parentNode = getParentNode(shadowNode);
                /* Set the nesting depth of an element */ if (shadowNode.nodeType === 1) {
                    if (parentNode && parentNode.__depth) /*
              We want the depth of the node in the original tree, which can
              change when it's removed from its parent.
            */ shadowNode.__depth = (shadowNode.__removalCount || 0) + parentNode.__depth + 1;
                    else shadowNode.__depth = 1;
                }
                /* Remove an element if nested too deeply to avoid mXSS */ if (shadowNode.__depth >= MAX_NESTING_DEPTH) _forceRemove(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) {
                    shadowNode.content.__depth = shadowNode.__depth;
                    _sanitizeShadowDOM(shadowNode.content);
                }
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeShadowDOM", fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
                if (typeof dirty.toString === "function") {
                    dirty = dirty.toString();
                    if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
                } else throw typeErrorCreate("toString is not a function");
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === "object" || typeof window1.toStaticHTML === "function") {
                    if (typeof dirty === "string") return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                var parentNode = getParentNode(currentNode);
                /* Set the nesting depth of an element */ if (currentNode.nodeType === 1) {
                    if (parentNode && parentNode.__depth) /*
              We want the depth of the node in the original tree, which can
              change when it's removed from its parent.
            */ currentNode.__depth = (currentNode.__removalCount || 0) + parentNode.__depth + 1;
                    else currentNode.__depth = 1;
                }
                /* Remove an element if nested too deeply to avoid mXSS */ if (currentNode.__depth >= MAX_NESTING_DEPTH) _forceRemove(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) {
                    currentNode.content.__depth = currentNode.__depth;
                    _sanitizeShadowDOM(currentNode.content);
                }
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, " ");
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, " ");
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, " ");
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("4gnPX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31ab259217810002$export$2e2bcd8739ae039; });
// Only remove security related tags and attributes. Allow each other.
var $31ab259217810002$var$liberal = {}; // No html at all. Only text will remain.
var $31ab259217810002$var$noHtml = {
    ALLOWED_TAGS: []
}; // Presentation API 2 suggestion.
var $31ab259217810002$var$iiif = {
    ALLOWED_ATTR: [
        "href",
        "src",
        "alt"
    ],
    ALLOWED_TAGS: [
        "a",
        "b",
        "br",
        "i",
        "img",
        "p",
        "span"
    ]
}; // Rule set that is used in Mirador 2.
var $31ab259217810002$var$mirador2 = {
    ALLOWED_ATTR: [
        "href",
        "target",
        "src",
        "alt",
        "dir"
    ],
    ALLOWED_TAGS: [
        "a",
        "b",
        "br",
        "i",
        "img",
        "p",
        "span",
        "strong",
        "em",
        "ul",
        "ol",
        "li"
    ]
};
var $31ab259217810002$var$htmlRules = {
    iiif: $31ab259217810002$var$iiif,
    liberal: $31ab259217810002$var$liberal,
    mirador2: $31ab259217810002$var$mirador2,
    noHtml: $31ab259217810002$var$noHtml
};
var $31ab259217810002$export$2e2bcd8739ae039 = $31ab259217810002$var$htmlRules;

});



parcelRegister("k3oId", function(module, exports) {

$parcel$export(module.exports, "ScrollTo", function () { return $e99741c15d6f0451$export$30318940d8eafabd; });

var $arQ7u = parcelRequire("arQ7u");
function $e99741c15d6f0451$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e99741c15d6f0451$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e99741c15d6f0451$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e99741c15d6f0451$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e99741c15d6f0451$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e99741c15d6f0451$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e99741c15d6f0451$var$_setPrototypeOf(subClass, superClass);
}
function $e99741c15d6f0451$var$_setPrototypeOf(o, p) {
    $e99741c15d6f0451$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e99741c15d6f0451$var$_setPrototypeOf(o, p);
}
function $e99741c15d6f0451$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e99741c15d6f0451$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e99741c15d6f0451$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e99741c15d6f0451$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e99741c15d6f0451$var$_possibleConstructorReturn(this, result);
    };
}
function $e99741c15d6f0451$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e99741c15d6f0451$var$_assertThisInitialized(self);
}
function $e99741c15d6f0451$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e99741c15d6f0451$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e99741c15d6f0451$var$_getPrototypeOf(o) {
    $e99741c15d6f0451$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e99741c15d6f0451$var$_getPrototypeOf(o);
}
var $e99741c15d6f0451$export$30318940d8eafabd = /*#__PURE__*/ function(_Component) {
    $e99741c15d6f0451$var$_inherits(ScrollTo, _Component);
    var _super = $e99741c15d6f0451$var$_createSuper(ScrollTo);
    /** */ function ScrollTo(props) {
        var _this;
        $e99741c15d6f0451$var$_classCallCheck(this, ScrollTo);
        _this = _super.call(this, props);
        _this.scrollToRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createRef();
        return _this;
    }
    /** */ $e99741c15d6f0451$var$_createClass(ScrollTo, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var scrollTo = this.props.scrollTo;
                if (!scrollTo) return;
                this.scrollToElement();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var scrollTo = this.props.scrollTo;
                if (scrollTo && prevProps.scrollTo !== scrollTo) this.scrollToElement();
            }
        },
        {
            key: "containerBoundingRect",
            value: function containerBoundingRect() {
                var containerRef = this.props.containerRef;
                if (!containerRef || !containerRef.current || !containerRef.current.domEl) return {};
                return containerRef.current.domEl.getBoundingClientRect();
            }
        },
        {
            key: "scrollToBoundingRect",
            value: function scrollToBoundingRect() {
                if (!this.elementToScrollTo()) return {};
                return this.elementToScrollTo().getBoundingClientRect();
            }
        },
        {
            key: "elementToScrollTo",
            value: function elementToScrollTo() {
                if (!this.scrollToRef || !this.scrollToRef.current) return null;
                return this.scrollToRef.current;
            }
        },
        {
            key: "scrollabelContainer",
            value: function scrollabelContainer() {
                var containerRef = this.props.containerRef;
                if (!containerRef || !containerRef.current || !containerRef.current.domEl) return null;
                return containerRef.current.domEl.getElementsByClassName("mirador-scrollto-scrollable")[0];
            }
        },
        {
            key: "elementIsVisible",
            value: function elementIsVisible() {
                var offsetTop = this.props.offsetTop;
                if (this.scrollToBoundingRect().top < this.containerBoundingRect().top + offsetTop) return false;
                if (this.scrollToBoundingRect().bottom > this.containerBoundingRect().bottom) return false;
                return true;
            }
        },
        {
            key: "scrollToElement",
            value: function scrollToElement() {
                var _this$props = this.props, offsetTop = _this$props.offsetTop, scrollTo = _this$props.scrollTo;
                if (!scrollTo) return;
                if (!this.elementToScrollTo()) return;
                if (this.elementIsVisible()) return;
                if (!this.scrollabelContainer()) return;
                var scrollBy = this.elementToScrollTo().offsetTop - this.containerBoundingRect().height / 2 + offsetTop;
                this.scrollabelContainer().scrollTo(0, scrollBy);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, scrollTo = _this$props2.scrollTo;
                if (!scrollTo) return children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    ref: this.scrollToRef
                }, children);
            }
        }
    ]);
    return ScrollTo;
}((0, $arQ7u.Component));
$e99741c15d6f0451$export$30318940d8eafabd.defaultProps = {
    offsetTop: 0
};

});



parcelRegister("iXAXt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcda67d44ab63d0c$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7E6Jm = parcelRequire("7E6Jm");

var $7XHRd = parcelRequire("7XHRd");

var $f4x9d = parcelRequire("f4x9d");

var $kUnI3 = parcelRequire("kUnI3");

var $24Kso = parcelRequire("24Kso");
var $jGts0 = parcelRequire("jGts0");
var $9E7MS = parcelRequire("9E7MS");

var $lCCRC = parcelRequire("lCCRC");
function $dcda67d44ab63d0c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dcda67d44ab63d0c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dcda67d44ab63d0c$var$ownKeys(Object(source), true).forEach(function(key) {
            $dcda67d44ab63d0c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dcda67d44ab63d0c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dcda67d44ab63d0c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * mapStateToProps - to hook up connect
 * @memberof CompanionWindow
 * @private
 */ var $dcda67d44ab63d0c$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, windowId = _ref.windowId;
    var companionWindow = (0, $24Kso.getCompanionWindow)(state, {
        companionWindowId: id
    });
    var _getWindowConfig = (0, $9E7MS.getWindowConfig)(state, {
        windowId: windowId
    }), defaultSidebarPanelHeight = _getWindowConfig.defaultSidebarPanelHeight, defaultSidebarPanelWidth = _getWindowConfig.defaultSidebarPanelWidth;
    return $dcda67d44ab63d0c$var$_objectSpread($dcda67d44ab63d0c$var$_objectSpread({}, companionWindow), {}, {
        defaultSidebarPanelHeight: defaultSidebarPanelHeight,
        defaultSidebarPanelWidth: defaultSidebarPanelWidth,
        direction: (0, $jGts0.getThemeDirection)(state),
        isDisplayed: companionWindow && companionWindow.content && companionWindow.content.length > 0
    });
};
/**
 * mapDispatchToProps - to hook up connect
 * @memberof CompanionWindow
 * @private
 */ var $dcda67d44ab63d0c$var$mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
    var windowId = _ref2.windowId, id = _ref2.id;
    return {
        onCloseClick: function onCloseClick() {
            return dispatch($kUnI3.removeCompanionWindow(windowId, id));
        },
        updateCompanionWindow: function updateCompanionWindow() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return dispatch($kUnI3.updateCompanionWindow.apply($kUnI3, [
                windowId,
                id
            ].concat(args)));
        }
    };
};
/**
 *
 * @param theme
 * @returns {{closeButton: {top: number, position: string, right: number},
 * root: {overflowY: string, width: string}}}
 */ var $dcda67d44ab63d0c$var$styles = function styles(theme) {
    return {
        closeButton: {
            order: 4
        },
        "companionWindow-bottom": {
            borderTop: "0.5px solid ".concat(theme.palette.divider)
        },
        "companionWindow-left": {
            borderRight: "0.5px solid ".concat(theme.palette.divider)
        },
        "companionWindow-right": {
            borderLeft: "0.5px solid ".concat(theme.palette.divider)
        },
        companionWindowHeader: {
            flexWrap: "wrap"
        },
        companionWindowTitleControls: {
            flexGrow: 1,
            order: 1000
        },
        companionWindowTitleControlsBottom: {
            order: "unset"
        },
        content: {
            overflowY: "auto",
            wordBreak: "break-word"
        },
        horizontal: {},
        positionButton: {
            marginLeft: -16,
            order: -100,
            width: 24
        },
        rnd: {
            display: "flex",
            flexDirection: "column",
            minHeight: 0
        },
        root: {
            boxShadow: "none",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            minHeight: 0
        },
        small: {},
        titleControls: {
            alignItems: "center",
            display: "flex",
            flexFlow: "row wrap",
            minHeight: 48,
            order: 3
        },
        toolbar: {
            "&$small": {
                "& $closeButton": {
                    order: "unset"
                },
                "& $titleControls": {
                    order: "unset"
                }
            },
            alignItems: "flex-start",
            background: theme.palette.shades.light,
            justifyContent: "space-between",
            minHeight: "max-content",
            paddingLeft: theme.spacing(2)
        },
        vertical: {},
        windowSideBarTitle: $dcda67d44ab63d0c$var$_objectSpread($dcda67d44ab63d0c$var$_objectSpread({}, theme.typography.subtitle1), {}, {
            alignSelf: "center",
            flexGrow: 1,
            width: 160
        })
    };
};
var $dcda67d44ab63d0c$var$enhance = (0, $k19ic.compose)((0, $f4x9d.withRef)(), (0, $eC0Mc.withTranslation)(), (0, $7EzGR.default)($dcda67d44ab63d0c$var$styles), (0, $7E6Jm.withSize)(), (0, $fbonu.default)($dcda67d44ab63d0c$var$mapStateToProps, $dcda67d44ab63d0c$var$mapDispatchToProps), (0, $7XHRd.withPlugins)("CompanionWindow"));
var $dcda67d44ab63d0c$export$2e2bcd8739ae039 = $dcda67d44ab63d0c$var$enhance((0, $lCCRC.CompanionWindow));

});
parcelRegister("7E6Jm", function(module, exports) {
"use strict";
function $59117d65ddbaec58$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $arQ7u = parcelRequire("arQ7u");
var $59117d65ddbaec58$var$React__default = $59117d65ddbaec58$var$_interopDefault($arQ7u);

var $59117d65ddbaec58$var$ReactDOM = $59117d65ddbaec58$var$_interopDefault((parcelRequire("9sDDw")));

var $59117d65ddbaec58$var$invariant = $59117d65ddbaec58$var$_interopDefault((parcelRequire("hA4w2")));

var $8tub5 = parcelRequire("8tub5");

var $59117d65ddbaec58$var$createResizeDetector = $59117d65ddbaec58$var$_interopDefault((parcelRequire("lsBBm")));

var $59117d65ddbaec58$var$isShallowEqual = $59117d65ddbaec58$var$_interopDefault((parcelRequire("dHASG")));
function $59117d65ddbaec58$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $59117d65ddbaec58$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $59117d65ddbaec58$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $59117d65ddbaec58$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $59117d65ddbaec58$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $59117d65ddbaec58$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $59117d65ddbaec58$var$_extends() {
    $59117d65ddbaec58$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $59117d65ddbaec58$var$_extends.apply(this, arguments);
}
function $59117d65ddbaec58$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $59117d65ddbaec58$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $59117d65ddbaec58$var$ownKeys(Object(source), true).forEach(function(key) {
            $59117d65ddbaec58$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $59117d65ddbaec58$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $59117d65ddbaec58$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $59117d65ddbaec58$var$_setPrototypeOf(subClass, superClass);
}
function $59117d65ddbaec58$var$_getPrototypeOf(o) {
    $59117d65ddbaec58$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $59117d65ddbaec58$var$_getPrototypeOf(o);
}
function $59117d65ddbaec58$var$_setPrototypeOf(o, p) {
    $59117d65ddbaec58$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $59117d65ddbaec58$var$_setPrototypeOf(o, p);
}
function $59117d65ddbaec58$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $59117d65ddbaec58$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $59117d65ddbaec58$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $59117d65ddbaec58$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $59117d65ddbaec58$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $59117d65ddbaec58$var$_assertThisInitialized(self);
}
var $59117d65ddbaec58$var$instances = {}; // Lazily require to not cause bug
// https://github.com/ctrlplusb/react-sizeme/issues/6
function $59117d65ddbaec58$var$resizeDetector() {
    var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "scroll";
    if (!$59117d65ddbaec58$var$instances[strategy]) $59117d65ddbaec58$var$instances[strategy] = $59117d65ddbaec58$var$createResizeDetector({
        strategy: strategy
    });
    return $59117d65ddbaec58$var$instances[strategy];
}
var $59117d65ddbaec58$var$errMsg = "react-sizeme: an error occurred whilst stopping to listen to node size changes";
var $59117d65ddbaec58$var$defaultConfig = {
    monitorWidth: true,
    monitorHeight: false,
    monitorPosition: false,
    refreshRate: 16,
    refreshMode: "throttle",
    noPlaceholder: false,
    resizeDetectorStrategy: "scroll"
};
function $59117d65ddbaec58$var$getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
/**
 * This is a utility wrapper component that will allow our higher order
 * component to get a ref handle on our wrapped components html.
 * @see https://gist.github.com/jimfb/32b587ee6177665fb4cf
 */ var $59117d65ddbaec58$var$ReferenceWrapper = /*#__PURE__*/ function(_Component) {
    $59117d65ddbaec58$var$_inherits(ReferenceWrapper, _Component);
    function ReferenceWrapper() {
        $59117d65ddbaec58$var$_classCallCheck(this, ReferenceWrapper);
        return $59117d65ddbaec58$var$_possibleConstructorReturn(this, $59117d65ddbaec58$var$_getPrototypeOf(ReferenceWrapper).apply(this, arguments));
    }
    $59117d65ddbaec58$var$_createClass(ReferenceWrapper, [
        {
            key: "render",
            value: function render() {
                return $arQ7u.Children.only(this.props.children);
            }
        }
    ]);
    return ReferenceWrapper;
}($arQ7u.Component);
$59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$ReferenceWrapper, "displayName", "SizeMeReferenceWrapper");
function $59117d65ddbaec58$var$Placeholder(_ref) {
    var className = _ref.className, style = _ref.style;
    // Lets create the props for the temp element.
    var phProps = {}; // We will use any provided className/style or else make the temp
    // container take the full available space.
    if (!className && !style) phProps.style = {
        width: "100%",
        height: "100%"
    };
    else {
        if (className) phProps.className = className;
        if (style) phProps.style = style;
    }
    return $59117d65ddbaec58$var$React__default.createElement("div", phProps);
}
$59117d65ddbaec58$var$Placeholder.displayName = "SizeMePlaceholder";
/**
 * As we need to maintain a ref on the root node that is rendered within our
 * SizeMe component we need to wrap our entire render in a sub component.
 * Without this, we lose the DOM ref after the placeholder is removed from
 * the render and the actual component is rendered.
 * It took me forever to figure this out, so tread extra careful on this one!
 */ var $59117d65ddbaec58$var$renderWrapper = function renderWrapper(WrappedComponent) {
    function SizeMeRenderer(props) {
        var explicitRef = props.explicitRef, className = props.className, style = props.style, size = props.size, disablePlaceholder = props.disablePlaceholder, onSize = props.onSize, restProps = $59117d65ddbaec58$var$_objectWithoutProperties(props, [
            "explicitRef",
            "className",
            "style",
            "size",
            "disablePlaceholder",
            "onSize"
        ]);
        var noSizeData = size == null || size.width == null && size.height == null && size.position == null;
        var renderPlaceholder = noSizeData && !disablePlaceholder;
        var renderProps = {
            className: className,
            style: style
        };
        if (size != null) renderProps.size = size;
        var toRender = renderPlaceholder ? $59117d65ddbaec58$var$React__default.createElement($59117d65ddbaec58$var$Placeholder, {
            className: className,
            style: style
        }) : $59117d65ddbaec58$var$React__default.createElement(WrappedComponent, $59117d65ddbaec58$var$_extends({}, renderProps, restProps));
        return $59117d65ddbaec58$var$React__default.createElement($59117d65ddbaec58$var$ReferenceWrapper, {
            ref: explicitRef
        }, toRender);
    }
    SizeMeRenderer.displayName = "SizeMeRenderer(".concat($59117d65ddbaec58$var$getDisplayName(WrappedComponent), ")");
    return SizeMeRenderer;
};
/**
 * :: config -> Component -> WrappedComponent
 *
 * Higher order component that allows the wrapped component to become aware
 * of it's size, by receiving it as an object within it's props.
 *
 * @param  monitorWidth
 *   Default true, whether changes in the element's width should be monitored,
 *   causing a size property to be broadcast.
 * @param  monitorHeight
 *   Default false, whether changes in the element's height should be monitored,
 *   causing a size property to be broadcast.
 *
 * @return The wrapped component.
 */ function $59117d65ddbaec58$var$withSize() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $59117d65ddbaec58$var$defaultConfig;
    var _config$monitorWidth = config.monitorWidth, monitorWidth = _config$monitorWidth === void 0 ? $59117d65ddbaec58$var$defaultConfig.monitorWidth : _config$monitorWidth, _config$monitorHeight = config.monitorHeight, monitorHeight = _config$monitorHeight === void 0 ? $59117d65ddbaec58$var$defaultConfig.monitorHeight : _config$monitorHeight, _config$monitorPositi = config.monitorPosition, monitorPosition = _config$monitorPositi === void 0 ? $59117d65ddbaec58$var$defaultConfig.monitorPosition : _config$monitorPositi, _config$refreshRate = config.refreshRate, refreshRate = _config$refreshRate === void 0 ? $59117d65ddbaec58$var$defaultConfig.refreshRate : _config$refreshRate, _config$refreshMode = config.refreshMode, refreshMode = _config$refreshMode === void 0 ? $59117d65ddbaec58$var$defaultConfig.refreshMode : _config$refreshMode, _config$noPlaceholder = config.noPlaceholder, noPlaceholder = _config$noPlaceholder === void 0 ? $59117d65ddbaec58$var$defaultConfig.noPlaceholder : _config$noPlaceholder, _config$resizeDetecto = config.resizeDetectorStrategy, resizeDetectorStrategy = _config$resizeDetecto === void 0 ? $59117d65ddbaec58$var$defaultConfig.resizeDetectorStrategy : _config$resizeDetecto;
    $59117d65ddbaec58$var$invariant(monitorWidth || monitorHeight || monitorPosition, 'You have to monitor at least one of the width, height, or position when using "sizeMe"');
    $59117d65ddbaec58$var$invariant(refreshRate >= 16, "It is highly recommended that you don't put your refreshRate lower than 16 as this may cause layout thrashing.");
    $59117d65ddbaec58$var$invariant(refreshMode === "throttle" || refreshMode === "debounce", 'The refreshMode should have a value of "throttle" or "debounce"');
    var refreshDelayStrategy = refreshMode === "throttle" ? $8tub5.throttle : $8tub5.debounce;
    return function WrapComponent(WrappedComponent) {
        var SizeMeRenderWrapper = $59117d65ddbaec58$var$renderWrapper(WrappedComponent);
        var SizeAwareComponent = /*#__PURE__*/ function(_React$Component) {
            $59117d65ddbaec58$var$_inherits(SizeAwareComponent, _React$Component);
            function SizeAwareComponent() {
                var _getPrototypeOf2;
                var _this;
                $59117d65ddbaec58$var$_classCallCheck(this, SizeAwareComponent);
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = $59117d65ddbaec58$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $59117d65ddbaec58$var$_getPrototypeOf(SizeAwareComponent)).call.apply(_getPrototypeOf2, [
                    this
                ].concat(args)));
                $59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$_assertThisInitialized(_this), "domEl", null);
                $59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$_assertThisInitialized(_this), "state", {
                    width: undefined,
                    height: undefined,
                    position: undefined
                });
                $59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$_assertThisInitialized(_this), "uninstall", function() {
                    if (_this.domEl) {
                        try {
                            _this.detector.uninstall(_this.domEl);
                        } catch (err) {
                            // eslint-disable-next-line no-console
                            console.warn($59117d65ddbaec58$var$errMsg);
                        }
                        _this.domEl = null;
                    }
                });
                $59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$_assertThisInitialized(_this), "determineStrategy", function(props) {
                    if (props.onSize) {
                        if (!_this.callbackState) _this.callbackState = $59117d65ddbaec58$var$_objectSpread2({}, _this.state);
                        _this.strategy = "callback";
                    } else _this.strategy = "render";
                });
                $59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$_assertThisInitialized(_this), "strategisedSetState", function(state) {
                    if (_this.strategy === "callback") {
                        _this.callbackState = state;
                        _this.props.onSize(state);
                    }
                    _this.setState(state);
                });
                $59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$_assertThisInitialized(_this), "strategisedGetState", function() {
                    return _this.strategy === "callback" ? _this.callbackState : _this.state;
                });
                $59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$_assertThisInitialized(_this), "refCallback", function(element) {
                    _this.element = element;
                });
                $59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$_assertThisInitialized(_this), "hasSizeChanged", function(current, next) {
                    var c = current;
                    var n = next;
                    var cp = c.position || {};
                    var np = n.position || {};
                    return monitorWidth && c.width !== n.width || monitorHeight && c.height !== n.height || monitorPosition && (cp.top !== np.top || cp.left !== np.left || cp.bottom !== np.bottom || cp.right !== np.right);
                });
                $59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$_assertThisInitialized(_this), "checkIfSizeChanged", refreshDelayStrategy(refreshRate, function(el) {
                    var _el$getBoundingClient = el.getBoundingClientRect(), width = _el$getBoundingClient.width, height = _el$getBoundingClient.height, right = _el$getBoundingClient.right, left = _el$getBoundingClient.left, top = _el$getBoundingClient.top, bottom = _el$getBoundingClient.bottom;
                    var next = {
                        width: monitorWidth ? width : null,
                        height: monitorHeight ? height : null,
                        position: monitorPosition ? {
                            right: right,
                            left: left,
                            top: top,
                            bottom: bottom
                        } : null
                    };
                    if (_this.hasSizeChanged(_this.strategisedGetState(), next)) _this.strategisedSetState(next);
                }));
                return _this;
            }
            $59117d65ddbaec58$var$_createClass(SizeAwareComponent, [
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        this.detector = $59117d65ddbaec58$var$resizeDetector(resizeDetectorStrategy);
                        this.determineStrategy(this.props);
                        this.handleDOMNode();
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function componentDidUpdate() {
                        this.determineStrategy(this.props);
                        this.handleDOMNode();
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        // Change our size checker to a noop just in case we have some
                        // late running events.
                        this.hasSizeChanged = function() {
                            return undefined;
                        };
                        this.checkIfSizeChanged = function() {
                            return undefined;
                        };
                        this.uninstall();
                    }
                },
                {
                    key: "handleDOMNode",
                    value: function handleDOMNode() {
                        var found = this.element && $59117d65ddbaec58$var$ReactDOM.findDOMNode(this.element);
                        if (!found) {
                            // If we previously had a dom node then we need to ensure that
                            // we remove any existing listeners to avoid memory leaks.
                            this.uninstall();
                            return;
                        }
                        if (!this.domEl) {
                            this.domEl = found;
                            this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
                        } else if (this.domEl.isSameNode && !this.domEl.isSameNode(found) || this.domEl !== found) {
                            this.uninstall();
                            this.domEl = found;
                            this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
                        }
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var disablePlaceholder = $59117d65ddbaec58$var$withSize.enableSSRBehaviour || $59117d65ddbaec58$var$withSize.noPlaceholders || noPlaceholder || this.strategy === "callback";
                        var size = $59117d65ddbaec58$var$_objectSpread2({}, this.state);
                        return $59117d65ddbaec58$var$React__default.createElement(SizeMeRenderWrapper, $59117d65ddbaec58$var$_extends({
                            explicitRef: this.refCallback,
                            size: this.strategy === "callback" ? null : size,
                            disablePlaceholder: disablePlaceholder
                        }, this.props));
                    }
                }
            ]);
            return SizeAwareComponent;
        }($59117d65ddbaec58$var$React__default.Component);
        $59117d65ddbaec58$var$_defineProperty(SizeAwareComponent, "displayName", "SizeMe(".concat($59117d65ddbaec58$var$getDisplayName(WrappedComponent), ")"));
        SizeAwareComponent.WrappedComponent = WrappedComponent;
        return SizeAwareComponent;
    };
}
/**
 * Allow SizeMe to run within SSR environments.  This is a "global" behaviour
 * flag that should be set within the initialisation phase of your application.
 *
 * Warning: don't set this flag unless you need to as using it may cause
 * extra render cycles to happen within your components depending on the logic
 * contained within them around the usage of the `size` data.
 *
 * DEPRECATED: Please use the global noPlaceholders
 */ $59117d65ddbaec58$var$withSize.enableSSRBehaviour = false;
/**
 * Global configuration allowing to disable placeholder rendering for all
 * sizeMe components.
 */ $59117d65ddbaec58$var$withSize.noPlaceholders = false;
var $59117d65ddbaec58$var$SizeMe = /*#__PURE__*/ function(_Component) {
    $59117d65ddbaec58$var$_inherits(SizeMe, _Component);
    function SizeMe(props) {
        var _this;
        $59117d65ddbaec58$var$_classCallCheck(this, SizeMe);
        _this = $59117d65ddbaec58$var$_possibleConstructorReturn(this, $59117d65ddbaec58$var$_getPrototypeOf(SizeMe).call(this, props));
        $59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$_assertThisInitialized(_this), "createComponent", function(config) {
            _this.SizeAware = $59117d65ddbaec58$var$withSize(config)(function(_ref) {
                var children = _ref.children;
                return children;
            });
        });
        $59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$_assertThisInitialized(_this), "onSize", function(size) {
            return _this.setState({
                size: size
            });
        });
        var _children = props.children, render = props.render, sizeMeConfig = $59117d65ddbaec58$var$_objectWithoutProperties(props, [
            "children",
            "render"
        ]);
        _this.createComponent(sizeMeConfig);
        _this.state = {
            size: {
                width: undefined,
                height: undefined
            }
        };
        return _this;
    }
    $59117d65ddbaec58$var$_createClass(SizeMe, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props = this.props, prevChildren = _this$props.children, prevRender = _this$props.render, currentSizeMeConfig = $59117d65ddbaec58$var$_objectWithoutProperties(_this$props, [
                    "children",
                    "render"
                ]);
                var nextChildren = prevProps.children, nextRender = prevProps.render, prevSizeMeConfig = $59117d65ddbaec58$var$_objectWithoutProperties(prevProps, [
                    "children",
                    "render"
                ]);
                if (!$59117d65ddbaec58$var$isShallowEqual(currentSizeMeConfig, prevSizeMeConfig)) this.createComponent(currentSizeMeConfig);
            }
        },
        {
            key: "render",
            value: function render() {
                var SizeAware = this.SizeAware;
                var render = this.props.children || this.props.render;
                return $59117d65ddbaec58$var$React__default.createElement(SizeAware, {
                    onSize: this.onSize
                }, render({
                    size: this.state.size
                }));
            }
        }
    ]);
    return SizeMe;
}($arQ7u.Component);
$59117d65ddbaec58$var$_defineProperty($59117d65ddbaec58$var$SizeMe, "defaultProps", {
    children: undefined,
    render: undefined
});
$59117d65ddbaec58$var$withSize.SizeMe = $59117d65ddbaec58$var$SizeMe;
$59117d65ddbaec58$var$withSize.withSize = $59117d65ddbaec58$var$withSize;
module.exports = $59117d65ddbaec58$var$withSize;

});
parcelRegister("hA4w2", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $ccc94d33afc689dc$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $ccc94d33afc689dc$var$invariant;

});

parcelRegister("8tub5", function(module, exports) {
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    /* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
	 * Throttle execution of a function. Especially useful for rate limiting
	 * execution of handlers on events like resize and scroll.
	 *
	 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
	 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
	 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
	 *                                    the internal counter is reset).
	 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                    to `callback` when the throttled-function is executed.
	 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
	 *                                    schedule `callback` to execute after `delay` ms.
	 *
	 * @returns {Function}  A new, throttled, function.
	 */ function throttle(delay, noTrailing, callback, debounceMode) {
        /*
	   * After wrapper has stopped being called, this timeout ensures that
	   * `callback` is executed at the proper times in `throttle` and `end`
	   * debounce modes.
	   */ var timeoutID;
        var cancelled = false; // Keep track of the last time `callback` was executed.
        var lastExec = 0; // Function to clear existing timeout
        function clearExistingTimeout() {
            if (timeoutID) clearTimeout(timeoutID);
        } // Function to cancel next exec
        function cancel() {
            clearExistingTimeout();
            cancelled = true;
        } // `noTrailing` defaults to falsy.
        if (typeof noTrailing !== "boolean") {
            debounceMode = callback;
            callback = noTrailing;
            noTrailing = undefined;
        }
        /*
	   * The `wrapper` function encapsulates all of the throttling / debouncing
	   * functionality and when executed will limit the rate at which `callback`
	   * is executed.
	   */ function wrapper() {
            for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
            var self = this;
            var elapsed = Date.now() - lastExec;
            if (cancelled) return;
             // Execute `callback` and update the `lastExec` timestamp.
            function exec() {
                lastExec = Date.now();
                callback.apply(self, arguments_);
            }
            /*
	     * If `debounceMode` is true (at begin) this is used to clear the flag
	     * to allow future `callback` executions.
	     */ function clear() {
                timeoutID = undefined;
            }
            if (debounceMode && !timeoutID) /*
	       * Since `wrapper` is being called for the first time and
	       * `debounceMode` is true (at begin), execute `callback`.
	       */ exec();
            clearExistingTimeout();
            if (debounceMode === undefined && elapsed > delay) /*
	       * In throttle mode, if `delay` time has been exceeded, execute
	       * `callback`.
	       */ exec();
            else if (noTrailing !== true) /*
	       * In trailing throttle mode, since `delay` time has not been
	       * exceeded, schedule `callback` to execute `delay` ms after most
	       * recent execution.
	       *
	       * If `debounceMode` is true (at begin), schedule `clear` to execute
	       * after `delay` ms.
	       *
	       * If `debounceMode` is false (at end), schedule `callback` to
	       * execute after `delay` ms.
	       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
        }
        wrapper.cancel = cancel; // Return the wrapper function.
        return wrapper;
    }
    /* eslint-disable no-undefined */ /**
	 * Debounce execution of a function. Debouncing, unlike throttling,
	 * guarantees that a function is only executed a single time, either at the
	 * very beginning of a series of calls, or at the very end.
	 *
	 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
	 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
	 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
	 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                  to `callback` when the debounced-function is executed.
	 *
	 * @returns {Function} A new, debounced function.
	 */ function debounce(delay, atBegin, callback) {
        return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
    }
    exports1.debounce = debounce;
    exports1.throttle = throttle;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});

parcelRegister("lsBBm", function(module, exports) {
"use strict";

var $6ScW9 = parcelRequire("6ScW9");
var $f9f96168e0974a01$require$forEach = $6ScW9.forEach;

var $jhbSc = parcelRequire("jhbSc");

var $5hn8G = parcelRequire("5hn8G");

var $5vKXo = parcelRequire("5vKXo");

var $5B643 = parcelRequire("5B643");

var $1Ls5y = parcelRequire("1Ls5y");

var $69MQB = parcelRequire("69MQB");

var $4wJm4 = parcelRequire("4wJm4");

var $4vyXM = parcelRequire("4vyXM");

var $lmOzw = parcelRequire("lmOzw");

var $95Ba3 = parcelRequire("95Ba3");
function $f9f96168e0974a01$var$isCollection(obj) {
    return Array.isArray(obj) || obj.length !== undefined;
}
function $f9f96168e0974a01$var$toArray(collection) {
    if (!Array.isArray(collection)) {
        var array = [];
        $f9f96168e0974a01$require$forEach(collection, function(obj) {
            array.push(obj);
        });
        return array;
    } else return collection;
}
function $f9f96168e0974a01$var$isElement(obj) {
    return obj && obj.nodeType === 1;
}
/**
 * @typedef idHandler
 * @type {object}
 * @property {function} get Gets the resize detector id of the element.
 * @property {function} set Generate and sets the resize detector id of the element.
 */ /**
 * @typedef Options
 * @type {object}
 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
                                    If not provided, a default id handler will be used.
 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
                                    If not provided, a default id handler will be used.
                                    If set to false, then nothing will be reported.
 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
 */ /**
 * Creates an element resize detector instance.
 * @public
 * @param {Options?} options Optional global options object that will decide how this instance will work.
 */ module.exports = function(options) {
    options = options || {};
    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var idHandler;
    if (options.idHandler) // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
    // so that readonly flag always is true when it's used here. This may be removed next major version bump.
    idHandler = {
        get: function(element) {
            return options.idHandler.get(element, true);
        },
        set: options.idHandler.set
    };
    else {
        var idGenerator = $5vKXo();
        var defaultIdHandler = $5B643({
            idGenerator: idGenerator,
            stateHandler: $4vyXM
        });
        idHandler = defaultIdHandler;
    }
    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var reporter = options.reporter;
    if (!reporter) {
        //If options.reporter is false, then the reporter should be quiet.
        var quiet = reporter === false;
        reporter = $1Ls5y(quiet);
    }
    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var batchProcessor = $f9f96168e0974a01$var$getOption(options, "batchProcessor", $4wJm4({
        reporter: reporter
    }));
    //Options to be used as default for the listenTo function.
    var globalOptions = {};
    globalOptions.callOnAdd = !!$f9f96168e0974a01$var$getOption(options, "callOnAdd", true);
    globalOptions.debug = !!$f9f96168e0974a01$var$getOption(options, "debug", false);
    var eventListenerHandler = $5hn8G(idHandler);
    var elementUtils = $jhbSc({
        stateHandler: $4vyXM
    });
    //The detection strategy to be used.
    var detectionStrategy;
    var desiredStrategy = $f9f96168e0974a01$var$getOption(options, "strategy", "object");
    var importantCssRules = $f9f96168e0974a01$var$getOption(options, "important", false);
    var strategyOptions = {
        reporter: reporter,
        batchProcessor: batchProcessor,
        stateHandler: $4vyXM,
        idHandler: idHandler,
        important: importantCssRules
    };
    if (desiredStrategy === "scroll") {
        if ($69MQB.isLegacyOpera()) {
            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
            desiredStrategy = "object";
        } else if ($69MQB.isIE(9)) {
            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
            desiredStrategy = "object";
        }
    }
    if (desiredStrategy === "scroll") detectionStrategy = $95Ba3(strategyOptions);
    else if (desiredStrategy === "object") detectionStrategy = $lmOzw(strategyOptions);
    else throw new Error("Invalid strategy name: " + desiredStrategy);
    //Calls can be made to listenTo with elements that are still being installed.
    //Also, same elements can occur in the elements list in the listenTo function.
    //With this map, the ready callbacks can be synchronized between the calls
    //so that the ready callback can always be called when an element is ready - even if
    //it wasn't installed from the function itself.
    var onReadyCallbacks = {};
    /**
     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
     * @public
     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
     * @param {function} listener The callback to be executed for each resize event for each element.
     */ function listenTo(options, elements, listener) {
        function onResizeCallback(element) {
            var listeners = eventListenerHandler.get(element);
            $f9f96168e0974a01$require$forEach(listeners, function callListenerProxy(listener) {
                listener(element);
            });
        }
        function addListener(callOnAdd, element, listener) {
            eventListenerHandler.add(element, listener);
            if (callOnAdd) listener(element);
        }
        //Options object may be omitted.
        if (!listener) {
            listener = elements;
            elements = options;
            options = {};
        }
        if (!elements) throw new Error("At least one element required.");
        if (!listener) throw new Error("Listener required.");
        if ($f9f96168e0974a01$var$isElement(elements)) // A single element has been passed in.
        elements = [
            elements
        ];
        else if ($f9f96168e0974a01$var$isCollection(elements)) // Convert collection to array for plugins.
        // TODO: May want to check so that all the elements in the collection are valid elements.
        elements = $f9f96168e0974a01$var$toArray(elements);
        else return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        var elementsReady = 0;
        var callOnAdd = $f9f96168e0974a01$var$getOption(options, "callOnAdd", globalOptions.callOnAdd);
        var onReadyCallback = $f9f96168e0974a01$var$getOption(options, "onReady", function noop() {});
        var debug = $f9f96168e0974a01$var$getOption(options, "debug", globalOptions.debug);
        $f9f96168e0974a01$require$forEach(elements, function attachListenerToElement(element) {
            if (!$4vyXM.getState(element)) {
                $4vyXM.initState(element);
                idHandler.set(element);
            }
            var id = idHandler.get(element);
            debug && reporter.log("Attaching listener to element", id, element);
            if (!elementUtils.isDetectable(element)) {
                debug && reporter.log(id, "Not detectable.");
                if (elementUtils.isBusy(element)) {
                    debug && reporter.log(id, "System busy making it detectable");
                    //The element is being prepared to be detectable. Do not make it detectable.
                    //Just add the listener, because the element will soon be detectable.
                    addListener(callOnAdd, element, listener);
                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
                    onReadyCallbacks[id].push(function onReady() {
                        elementsReady++;
                        if (elementsReady === elements.length) onReadyCallback();
                    });
                    return;
                }
                debug && reporter.log(id, "Making detectable...");
                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
                elementUtils.markBusy(element, true);
                return detectionStrategy.makeDetectable({
                    debug: debug,
                    important: importantCssRules
                }, element, function onElementDetectable(element) {
                    debug && reporter.log(id, "onElementDetectable");
                    if ($4vyXM.getState(element)) {
                        elementUtils.markAsDetectable(element);
                        elementUtils.markBusy(element, false);
                        detectionStrategy.addListener(element, onResizeCallback);
                        addListener(callOnAdd, element, listener);
                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
                        // so that a resize event may be emitted.
                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
                        var state = $4vyXM.getState(element);
                        if (state && state.startSize) {
                            var width = element.offsetWidth;
                            var height = element.offsetHeight;
                            if (state.startSize.width !== width || state.startSize.height !== height) onResizeCallback(element);
                        }
                        if (onReadyCallbacks[id]) $f9f96168e0974a01$require$forEach(onReadyCallbacks[id], function(callback) {
                            callback();
                        });
                    } else // The element has been unisntalled before being detectable.
                    debug && reporter.log(id, "Element uninstalled before being detectable.");
                    delete onReadyCallbacks[id];
                    elementsReady++;
                    if (elementsReady === elements.length) onReadyCallback();
                });
            }
            debug && reporter.log(id, "Already detecable, adding listener.");
            //The element has been prepared to be detectable and is ready to be listened to.
            addListener(callOnAdd, element, listener);
            elementsReady++;
        });
        if (elementsReady === elements.length) onReadyCallback();
    }
    function uninstall(elements) {
        if (!elements) return reporter.error("At least one element is required.");
        if ($f9f96168e0974a01$var$isElement(elements)) // A single element has been passed in.
        elements = [
            elements
        ];
        else if ($f9f96168e0974a01$var$isCollection(elements)) // Convert collection to array for plugins.
        // TODO: May want to check so that all the elements in the collection are valid elements.
        elements = $f9f96168e0974a01$var$toArray(elements);
        else return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        $f9f96168e0974a01$require$forEach(elements, function(element) {
            eventListenerHandler.removeAllListeners(element);
            detectionStrategy.uninstall(element);
            $4vyXM.cleanState(element);
        });
    }
    function initDocument(targetDocument) {
        detectionStrategy.initDocument && detectionStrategy.initDocument(targetDocument);
    }
    return {
        listenTo: listenTo,
        removeListener: eventListenerHandler.removeListener,
        removeAllListeners: eventListenerHandler.removeAllListeners,
        uninstall: uninstall,
        initDocument: initDocument
    };
};
function $f9f96168e0974a01$var$getOption(options, name, defaultValue) {
    var value = options[name];
    if ((value === undefined || value === null) && defaultValue !== undefined) return defaultValue;
    return value;
}

});
parcelRegister("6ScW9", function(module, exports) {
"use strict";
var $5011d236c3938ad8$var$utils = module.exports = {};
/**
 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
 * @public
 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
 */ $5011d236c3938ad8$var$utils.forEach = function(collection, callback) {
    for(var i = 0; i < collection.length; i++){
        var result = callback(collection[i]);
        if (result) return result;
    }
};

});

parcelRegister("jhbSc", function(module, exports) {
"use strict";
module.exports = function(options) {
    var getState = options.stateHandler.getState;
    /**
     * Tells if the element has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is detectable or not.
     */ function isDetectable(element) {
        var state = getState(element);
        return state && !!state.isDetectable;
    }
    /**
     * Marks the element that it has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to mark.
     */ function markAsDetectable(element) {
        getState(element).isDetectable = true;
    }
    /**
     * Tells if the element is busy or not.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is busy or not.
     */ function isBusy(element) {
        return !!getState(element).busy;
    }
    /**
     * Marks the object is busy and should not be made detectable.
     * @public
     * @param {element} element The element to mark.
     * @param {boolean} busy If the element is busy or not.
     */ function markBusy(element, busy) {
        getState(element).busy = !!busy;
    }
    return {
        isDetectable: isDetectable,
        markAsDetectable: markAsDetectable,
        isBusy: isBusy,
        markBusy: markBusy
    };
};

});

parcelRegister("5hn8G", function(module, exports) {
"use strict";
module.exports = function(idHandler) {
    var eventListeners = {};
    /**
     * Gets all listeners for the given element.
     * @public
     * @param {element} element The element to get all listeners for.
     * @returns All listeners for the given element.
     */ function getListeners(element) {
        var id = idHandler.get(element);
        if (id === undefined) return [];
        return eventListeners[id] || [];
    }
    /**
     * Stores the given listener for the given element. Will not actually add the listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The callback that the element has added.
     */ function addListener(element, listener) {
        var id = idHandler.get(element);
        if (!eventListeners[id]) eventListeners[id] = [];
        eventListeners[id].push(listener);
    }
    function removeListener(element, listener) {
        var listeners = getListeners(element);
        for(var i = 0, len = listeners.length; i < len; ++i)if (listeners[i] === listener) {
            listeners.splice(i, 1);
            break;
        }
    }
    function removeAllListeners(element) {
        var listeners = getListeners(element);
        if (!listeners) return;
        listeners.length = 0;
    }
    return {
        get: getListeners,
        add: addListener,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners
    };
};

});

parcelRegister("5vKXo", function(module, exports) {
"use strict";
module.exports = function() {
    var idCount = 1;
    /**
     * Generates a new unique id in the context.
     * @public
     * @returns {number} A unique id in the context.
     */ function generate() {
        return idCount++;
    }
    return {
        generate: generate
    };
};

});

parcelRegister("5B643", function(module, exports) {
"use strict";
module.exports = function(options) {
    var idGenerator = options.idGenerator;
    var getState = options.stateHandler.getState;
    /**
     * Gets the resize detector id of the element.
     * @public
     * @param {element} element The target element to get the id of.
     * @returns {string|number|null} The id of the element. Null if it has no id.
     */ function getId(element) {
        var state = getState(element);
        if (state && state.id !== undefined) return state.id;
        return null;
    }
    /**
     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
     * @public
     * @param {element} element The target element to set the id of.
     * @returns {string|number|null} The id of the element.
     */ function setId(element) {
        var state = getState(element);
        if (!state) throw new Error("setId required the element to have a resize detection state.");
        var id = idGenerator.generate();
        state.id = id;
        return id;
    }
    return {
        get: getId,
        set: setId
    };
};

});

parcelRegister("1Ls5y", function(module, exports) {
"use strict";
/* global console: false */ /**
 * Reporter that handles the reporting of logs, warnings and errors.
 * @public
 * @param {boolean} quiet Tells if the reporter should be quiet or not.
 */ module.exports = function(quiet) {
    function noop() {
    //Does nothing.
    }
    var reporter = {
        log: noop,
        warn: noop,
        error: noop
    };
    if (!quiet && window.console) {
        var attachFunction = function(reporter, name) {
            //The proxy is needed to be able to call the method with the console context,
            //since we cannot use bind.
            reporter[name] = function reporterProxy() {
                var f = console[name];
                if (f.apply) f.apply(console, arguments);
                else for(var i = 0; i < arguments.length; i++)f(arguments[i]);
            };
        };
        attachFunction(reporter, "log");
        attachFunction(reporter, "warn");
        attachFunction(reporter, "error");
    }
    return reporter;
};

});

parcelRegister("69MQB", function(module, exports) {
"use strict";
var $47b9796abd222b52$var$detector = module.exports = {};
$47b9796abd222b52$var$detector.isIE = function(version) {
    function isAnyIeVersion() {
        var agent = navigator.userAgent.toLowerCase();
        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
    }
    if (!isAnyIeVersion()) return false;
    if (!version) return true;
    //Shamelessly stolen from https://gist.github.com/padolsey/527683
    var ieVersion = function() {
        var undef, v = 3, div = document.createElement("div"), all = div.getElementsByTagName("i");
        do div.innerHTML = "<!--[if gt IE " + ++v + "]><i></i><![endif]-->";
        while (all[0]);
        return v > 4 ? v : undef;
    }();
    return version === ieVersion;
};
$47b9796abd222b52$var$detector.isLegacyOpera = function() {
    return !!window.opera;
};

});

parcelRegister("4wJm4", function(module, exports) {
"use strict";

var $dfnwP = parcelRequire("dfnwP");
module.exports = function batchProcessorMaker(options) {
    options = options || {};
    var reporter = options.reporter;
    var asyncProcess = $dfnwP.getOption(options, "async", true);
    var autoProcess = $dfnwP.getOption(options, "auto", true);
    if (autoProcess && !asyncProcess) {
        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
        asyncProcess = true;
    }
    var batch = $34bd55228f942c9d$var$Batch();
    var asyncFrameHandler;
    var isProcessing = false;
    function addFunction(level, fn) {
        if (!isProcessing && autoProcess && asyncProcess && batch.size() === 0) // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
        // This needs to be done before, since we're checking the size of the batch to be 0.
        processBatchAsync();
        batch.add(level, fn);
    }
    function processBatch() {
        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
        isProcessing = true;
        while(batch.size()){
            var processingBatch = batch;
            batch = $34bd55228f942c9d$var$Batch();
            processingBatch.process();
        }
        isProcessing = false;
    }
    function forceProcessBatch(localAsyncProcess) {
        if (isProcessing) return;
        if (localAsyncProcess === undefined) localAsyncProcess = asyncProcess;
        if (asyncFrameHandler) {
            cancelFrame(asyncFrameHandler);
            asyncFrameHandler = null;
        }
        if (localAsyncProcess) processBatchAsync();
        else processBatch();
    }
    function processBatchAsync() {
        asyncFrameHandler = requestFrame(processBatch);
    }
    function clearBatch() {
        batch = {};
        batchSize = 0;
        topLevel = 0;
        bottomLevel = 0;
    }
    function cancelFrame(listener) {
        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
        var cancel = clearTimeout;
        return cancel(listener);
    }
    function requestFrame(callback) {
        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
        var raf = function(fn) {
            return setTimeout(fn, 0);
        };
        return raf(callback);
    }
    return {
        add: addFunction,
        force: forceProcessBatch
    };
};
function $34bd55228f942c9d$var$Batch() {
    var batch = {};
    var size = 0;
    var topLevel1 = 0;
    var bottomLevel1 = 0;
    function add(level, fn) {
        if (!fn) {
            fn = level;
            level = 0;
        }
        if (level > topLevel1) topLevel1 = level;
        else if (level < bottomLevel1) bottomLevel1 = level;
        if (!batch[level]) batch[level] = [];
        batch[level].push(fn);
        size++;
    }
    function process() {
        for(var level = bottomLevel1; level <= topLevel1; level++){
            var fns = batch[level];
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                fn();
            }
        }
    }
    function getSize() {
        return size;
    }
    return {
        add: add,
        process: process,
        size: getSize
    };
}

});
parcelRegister("dfnwP", function(module, exports) {
"use strict";
var $9a4eed526307e2df$var$utils = module.exports = {};
$9a4eed526307e2df$var$utils.getOption = $9a4eed526307e2df$var$getOption;
function $9a4eed526307e2df$var$getOption(options, name, defaultValue) {
    var value = options[name];
    if ((value === undefined || value === null) && defaultValue !== undefined) return defaultValue;
    return value;
}

});


parcelRegister("4vyXM", function(module, exports) {
"use strict";
var $34852d9ded12d430$var$prop = "_erd";
function $34852d9ded12d430$var$initState(element) {
    element[$34852d9ded12d430$var$prop] = {};
    return $34852d9ded12d430$var$getState(element);
}
function $34852d9ded12d430$var$getState(element) {
    return element[$34852d9ded12d430$var$prop];
}
function $34852d9ded12d430$var$cleanState(element) {
    delete element[$34852d9ded12d430$var$prop];
}
module.exports = {
    initState: $34852d9ded12d430$var$initState,
    getState: $34852d9ded12d430$var$getState,
    cleanState: $34852d9ded12d430$var$cleanState
};

});

parcelRegister("lmOzw", function(module, exports) {
/**
 * Resize detection strategy that injects objects to elements in order to detect resize events.
 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
 */ "use strict";

var $69MQB = parcelRequire("69MQB");
module.exports = function(options) {
    options = options || {};
    var reporter = options.reporter;
    var batchProcessor = options.batchProcessor;
    var getState = options.stateHandler.getState;
    if (!reporter) throw new Error("Missing required dependency: reporter.");
    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */ function addListener(element, listener) {
        function listenerProxy() {
            listener(element);
        }
        if ($69MQB.isIE(8)) {
            //IE 8 does not support object, but supports the resize event directly on elements.
            getState(element).object = {
                proxy: listenerProxy
            };
            element.attachEvent("onresize", listenerProxy);
        } else {
            var object = getObject(element);
            if (!object) throw new Error("Element is not detectable by this strategy.");
            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
        }
    }
    function buildCssTextString(rules) {
        var seperator = options.important ? " !important; " : "; ";
        return (rules.join(seperator) + seperator).trim();
    }
    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */ function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }
        options = options || {};
        var debug = options.debug;
        function injectObject(element, callback) {
            var OBJECT_STYLE = buildCssTextString([
                "display: block",
                "position: absolute",
                "top: 0",
                "left: 0",
                "width: 100%",
                "height: 100%",
                "border: none",
                "padding: 0",
                "margin: 0",
                "opacity: 0",
                "z-index: -1000",
                "pointer-events: none"
            ]);
            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.
            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
            var positionCheckPerformed = false;
            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
            var style = window.getComputedStyle(element);
            var width = element.offsetWidth;
            var height = element.offsetHeight;
            getState(element).startSize = {
                width: width,
                height: height
            };
            function mutateDom() {
                function alterPositionStyles() {
                    if (style.position === "static") {
                        element.style.setProperty("position", "relative", options.important ? "important" : "");
                        var removeRelativeStyles = function(reporter, element, style, property) {
                            function getNumericalValue(value) {
                                return value.replace(/[^-\d\.]/g, "");
                            }
                            var value = style[property];
                            if (value !== "auto" && getNumericalValue(value) !== "0") {
                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                                element.style.setProperty(property, "0", options.important ? "important" : "");
                            }
                        };
                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                        removeRelativeStyles(reporter, element, style, "top");
                        removeRelativeStyles(reporter, element, style, "right");
                        removeRelativeStyles(reporter, element, style, "bottom");
                        removeRelativeStyles(reporter, element, style, "left");
                    }
                }
                function onObjectLoad() {
                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
                    if (!positionCheckPerformed) alterPositionStyles();
                    /*jshint validthis: true */ function getDocument(element, callback) {
                        //Opera 12 seem to call the object.onload before the actual document has been created.
                        //So if it is not present, poll it with an timeout until it is present.
                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
                        if (!element.contentDocument) {
                            var state = getState(element);
                            if (state.checkForObjectDocumentTimeoutId) window.clearTimeout(state.checkForObjectDocumentTimeoutId);
                            state.checkForObjectDocumentTimeoutId = setTimeout(function checkForObjectDocument() {
                                state.checkForObjectDocumentTimeoutId = 0;
                                getDocument(element, callback);
                            }, 100);
                            return;
                        }
                        callback(element.contentDocument);
                    }
                    //Mutating the object element here seems to fire another load event.
                    //Mutating the inner document of the object element is fine though.
                    var objectElement = this;
                    //Create the style element to be added to the object.
                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
                        //Notify that the element is ready to be listened to.
                        callback(element);
                    });
                }
                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
                if (style.position !== "") {
                    alterPositionStyles(style);
                    positionCheckPerformed = true;
                }
                //Add an object element as a child to the target element that will be listened to for resize events.
                var object = document.createElement("object");
                object.style.cssText = OBJECT_STYLE;
                object.tabIndex = -1;
                object.type = "text/html";
                object.setAttribute("aria-hidden", "true");
                object.onload = onObjectLoad;
                //Safari: This must occur before adding the object to the DOM.
                //IE: Does not like that this happens before, even if it is also added after.
                if (!$69MQB.isIE()) object.data = "about:blank";
                if (!getState(element)) // The element has been uninstalled before the actual loading happened.
                return;
                element.appendChild(object);
                getState(element).object = object;
                //IE: This must occur after adding the object to the DOM.
                if ($69MQB.isIE()) object.data = "about:blank";
            }
            if (batchProcessor) batchProcessor.add(mutateDom);
            else mutateDom();
        }
        if ($69MQB.isIE(8)) //IE 8 does not support objects properly. Luckily they do support the resize event.
        //So do not inject the object and notify that the element is already ready to be listened to.
        //The event handler for the resize event is attached in the utils.addListener instead.
        callback(element);
        else injectObject(element, callback);
    }
    /**
     * Returns the child object of the target element.
     * @private
     * @param {element} element The target element.
     * @returns The object element of the target.
     */ function getObject(element) {
        return getState(element).object;
    }
    function uninstall(element) {
        if (!getState(element)) return;
        var object = getObject(element);
        if (!object) return;
        if ($69MQB.isIE(8)) element.detachEvent("onresize", object.proxy);
        else element.removeChild(object);
        if (getState(element).checkForObjectDocumentTimeoutId) window.clearTimeout(getState(element).checkForObjectDocumentTimeoutId);
        delete getState(element).object;
    }
    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};

});

parcelRegister("95Ba3", function(module, exports) {
/**
 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
 */ "use strict";

var $6ScW9 = parcelRequire("6ScW9");
var $69e1681e2d0234dd$require$forEach = $6ScW9.forEach;
module.exports = function(options) {
    options = options || {};
    var reporter = options.reporter;
    var batchProcessor = options.batchProcessor;
    var getState = options.stateHandler.getState;
    var hasState = options.stateHandler.hasState;
    var idHandler = options.idHandler;
    if (!batchProcessor) throw new Error("Missing required dependency: batchProcessor");
    if (!reporter) throw new Error("Missing required dependency: reporter.");
    //TODO: Could this perhaps be done at installation time?
    var scrollbarSizes = getScrollbarSizes();
    var styleId = "erd_scroll_detection_scrollbar_style";
    var detectionContainerClass = "erd_scroll_detection_container";
    function initDocument(targetDocument) {
        // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
        // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
        injectScrollStyle(targetDocument, styleId, detectionContainerClass);
    }
    initDocument(window.document);
    function buildCssTextString(rules) {
        var seperator = options.important ? " !important; " : "; ";
        return (rules.join(seperator) + seperator).trim();
    }
    function getScrollbarSizes() {
        var width = 500;
        var height = 500;
        var child = document.createElement("div");
        child.style.cssText = buildCssTextString([
            "position: absolute",
            "width: " + width * 2 + "px",
            "height: " + height * 2 + "px",
            "visibility: hidden",
            "margin: 0",
            "padding: 0"
        ]);
        var container = document.createElement("div");
        container.style.cssText = buildCssTextString([
            "position: absolute",
            "width: " + width + "px",
            "height: " + height + "px",
            "overflow: scroll",
            "visibility: none",
            "top: " + -width * 3 + "px",
            "left: " + -height * 3 + "px",
            "visibility: hidden",
            "margin: 0",
            "padding: 0"
        ]);
        container.appendChild(child);
        document.body.insertBefore(container, document.body.firstChild);
        var widthSize = width - container.clientWidth;
        var heightSize = height - container.clientHeight;
        document.body.removeChild(container);
        return {
            width: widthSize,
            height: heightSize
        };
    }
    function injectScrollStyle(targetDocument, styleId, containerClass) {
        function injectStyle(style, method) {
            method = method || function(element) {
                targetDocument.head.appendChild(element);
            };
            var styleElement = targetDocument.createElement("style");
            styleElement.innerHTML = style;
            styleElement.id = styleId;
            method(styleElement);
            return styleElement;
        }
        if (!targetDocument.getElementById(styleId)) {
            var containerAnimationClass = containerClass + "_animation";
            var containerAnimationActiveClass = containerClass + "_animation_active";
            var style = "/* Created by the element-resize-detector library. */\n";
            style += "." + containerClass + " > div::-webkit-scrollbar { " + buildCssTextString([
                "display: none"
            ]) + " }\n\n";
            style += "." + containerAnimationActiveClass + " { " + buildCssTextString([
                "-webkit-animation-duration: 0.1s",
                "animation-duration: 0.1s",
                "-webkit-animation-name: " + containerAnimationClass,
                "animation-name: " + containerAnimationClass
            ]) + " }\n";
            style += "@-webkit-keyframes " + containerAnimationClass + " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
            style += "@keyframes " + containerAnimationClass + " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
            injectStyle(style);
        }
    }
    function addAnimationClass(element) {
        element.className += " " + detectionContainerClass + "_animation_active";
    }
    function addEvent(el, name, cb) {
        if (el.addEventListener) el.addEventListener(name, cb);
        else if (el.attachEvent) el.attachEvent("on" + name, cb);
        else return reporter.error("[scroll] Don't know how to add event listeners.");
    }
    function removeEvent(el, name, cb) {
        if (el.removeEventListener) el.removeEventListener(name, cb);
        else if (el.detachEvent) el.detachEvent("on" + name, cb);
        else return reporter.error("[scroll] Don't know how to remove event listeners.");
    }
    function getExpandElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
    }
    function getShrinkElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
    }
    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */ function addListener(element, listener) {
        var listeners = getState(element).listeners;
        if (!listeners.push) throw new Error("Cannot add listener to an element that is not detectable.");
        getState(element).listeners.push(listener);
    }
    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */ function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }
        options = options || {};
        function debug() {
            if (options.debug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift(idHandler.get(element), "Scroll: ");
                if (reporter.log.apply) reporter.log.apply(null, args);
                else for(var i = 0; i < args.length; i++)reporter.log(args[i]);
            }
        }
        function isDetached(element) {
            function isInDocument(element) {
                var isInShadowRoot = element.getRootNode && element.getRootNode().contains(element);
                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element) || isInShadowRoot;
            }
            if (!isInDocument(element)) return true;
            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
            if (window.getComputedStyle(element) === null) return true;
            return false;
        }
        function isUnrendered(element) {
            // Check the absolute positioned container since the top level container is display: inline.
            var container = getState(element).container.childNodes[0];
            var style = window.getComputedStyle(container);
            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
        }
        function getStyle() {
            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
            var elementStyle = window.getComputedStyle(element);
            var style = {};
            style.position = elementStyle.position;
            style.width = element.offsetWidth;
            style.height = element.offsetHeight;
            style.top = elementStyle.top;
            style.right = elementStyle.right;
            style.bottom = elementStyle.bottom;
            style.left = elementStyle.left;
            style.widthCSS = elementStyle.width;
            style.heightCSS = elementStyle.height;
            return style;
        }
        function storeStartSize() {
            var style = getStyle();
            getState(element).startSize = {
                width: style.width,
                height: style.height
            };
            debug("Element start size", getState(element).startSize);
        }
        function initListeners() {
            getState(element).listeners = [];
        }
        function storeStyle() {
            debug("storeStyle invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }
            var style = getStyle();
            getState(element).style = style;
        }
        function storeCurrentSize(element, width, height) {
            getState(element).lastWidth = width;
            getState(element).lastHeight = height;
        }
        function getExpandChildElement(element) {
            return getExpandElement(element).childNodes[0];
        }
        function getWidthOffset() {
            return 2 * scrollbarSizes.width + 1;
        }
        function getHeightOffset() {
            return 2 * scrollbarSizes.height + 1;
        }
        function getExpandWidth(width) {
            return width + 10 + getWidthOffset();
        }
        function getExpandHeight(height) {
            return height + 10 + getHeightOffset();
        }
        function getShrinkWidth(width) {
            return width * 2 + getWidthOffset();
        }
        function getShrinkHeight(height) {
            return height * 2 + getHeightOffset();
        }
        function positionScrollbars(element, width, height) {
            var expand = getExpandElement(element);
            var shrink = getShrinkElement(element);
            var expandWidth = getExpandWidth(width);
            var expandHeight = getExpandHeight(height);
            var shrinkWidth = getShrinkWidth(width);
            var shrinkHeight = getShrinkHeight(height);
            expand.scrollLeft = expandWidth;
            expand.scrollTop = expandHeight;
            shrink.scrollLeft = shrinkWidth;
            shrink.scrollTop = shrinkHeight;
        }
        function injectContainerElement() {
            var container = getState(element).container;
            if (!container) {
                container = document.createElement("div");
                container.className = detectionContainerClass;
                container.style.cssText = buildCssTextString([
                    "visibility: hidden",
                    "display: inline",
                    "width: 0px",
                    "height: 0px",
                    "z-index: -1",
                    "overflow: hidden",
                    "margin: 0",
                    "padding: 0"
                ]);
                getState(element).container = container;
                addAnimationClass(container);
                element.appendChild(container);
                var onAnimationStart = function() {
                    getState(element).onRendered && getState(element).onRendered();
                };
                addEvent(container, "animationstart", onAnimationStart);
                // Store the event handler here so that they may be removed when uninstall is called.
                // See uninstall function for an explanation why it is needed.
                getState(element).onAnimationStart = onAnimationStart;
            }
            return container;
        }
        function injectScrollElements() {
            function alterPositionStyles() {
                var style = getState(element).style;
                if (style.position === "static") {
                    element.style.setProperty("position", "relative", options.important ? "important" : "");
                    var removeRelativeStyles = function(reporter, element, style, property) {
                        function getNumericalValue(value) {
                            return value.replace(/[^-\d\.]/g, "");
                        }
                        var value = style[property];
                        if (value !== "auto" && getNumericalValue(value) !== "0") {
                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                            element.style[property] = 0;
                        }
                    };
                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                    removeRelativeStyles(reporter, element, style, "top");
                    removeRelativeStyles(reporter, element, style, "right");
                    removeRelativeStyles(reporter, element, style, "bottom");
                    removeRelativeStyles(reporter, element, style, "left");
                }
            }
            function getLeftTopBottomRightCssText(left, top, bottom, right) {
                left = !left ? "0" : left + "px";
                top = !top ? "0" : top + "px";
                bottom = !bottom ? "0" : bottom + "px";
                right = !right ? "0" : right + "px";
                return [
                    "left: " + left,
                    "top: " + top,
                    "right: " + right,
                    "bottom: " + bottom
                ];
            }
            debug("Injecting elements");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }
            alterPositionStyles();
            var rootContainer = getState(element).container;
            if (!rootContainer) rootContainer = injectContainerElement();
            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
            // the targeted element.
            // When the bug is resolved, "containerContainer" may be removed.
            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.
            var scrollbarWidth = scrollbarSizes.width;
            var scrollbarHeight = scrollbarSizes.height;
            var containerContainerStyle = buildCssTextString([
                "position: absolute",
                "flex: none",
                "overflow: hidden",
                "z-index: -1",
                "visibility: hidden",
                "width: 100%",
                "height: 100%",
                "left: 0px",
                "top: 0px"
            ]);
            var containerStyle = buildCssTextString([
                "position: absolute",
                "flex: none",
                "overflow: hidden",
                "z-index: -1",
                "visibility: hidden"
            ].concat(getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth)));
            var expandStyle = buildCssTextString([
                "position: absolute",
                "flex: none",
                "overflow: scroll",
                "z-index: -1",
                "visibility: hidden",
                "width: 100%",
                "height: 100%"
            ]);
            var shrinkStyle = buildCssTextString([
                "position: absolute",
                "flex: none",
                "overflow: scroll",
                "z-index: -1",
                "visibility: hidden",
                "width: 100%",
                "height: 100%"
            ]);
            var expandChildStyle = buildCssTextString([
                "position: absolute",
                "left: 0",
                "top: 0"
            ]);
            var shrinkChildStyle = buildCssTextString([
                "position: absolute",
                "width: 200%",
                "height: 200%"
            ]);
            var containerContainer = document.createElement("div");
            var container = document.createElement("div");
            var expand = document.createElement("div");
            var expandChild = document.createElement("div");
            var shrink = document.createElement("div");
            var shrinkChild = document.createElement("div");
            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
            containerContainer.dir = "ltr";
            containerContainer.style.cssText = containerContainerStyle;
            containerContainer.className = detectionContainerClass;
            container.className = detectionContainerClass;
            container.style.cssText = containerStyle;
            expand.style.cssText = expandStyle;
            expandChild.style.cssText = expandChildStyle;
            shrink.style.cssText = shrinkStyle;
            shrinkChild.style.cssText = shrinkChildStyle;
            expand.appendChild(expandChild);
            shrink.appendChild(shrinkChild);
            container.appendChild(expand);
            container.appendChild(shrink);
            containerContainer.appendChild(container);
            rootContainer.appendChild(containerContainer);
            function onExpandScroll() {
                var state = getState(element);
                if (state && state.onExpand) state.onExpand();
                else debug("Aborting expand scroll handler: element has been uninstalled");
            }
            function onShrinkScroll() {
                var state = getState(element);
                if (state && state.onShrink) state.onShrink();
                else debug("Aborting shrink scroll handler: element has been uninstalled");
            }
            addEvent(expand, "scroll", onExpandScroll);
            addEvent(shrink, "scroll", onShrinkScroll);
            // Store the event handlers here so that they may be removed when uninstall is called.
            // See uninstall function for an explanation why it is needed.
            getState(element).onExpandScroll = onExpandScroll;
            getState(element).onShrinkScroll = onShrinkScroll;
        }
        function registerListenersAndPositionElements() {
            function updateChildSizes(element, width, height) {
                var expandChild = getExpandChildElement(element);
                var expandWidth = getExpandWidth(width);
                var expandHeight = getExpandHeight(height);
                expandChild.style.setProperty("width", expandWidth + "px", options.important ? "important" : "");
                expandChild.style.setProperty("height", expandHeight + "px", options.important ? "important" : "");
            }
            function updateDetectorElements(done) {
                var width = element.offsetWidth;
                var height = element.offsetHeight;
                // Check whether the size has actually changed since last time the algorithm ran. If not, some steps may be skipped.
                var sizeChanged = width !== getState(element).lastWidth || height !== getState(element).lastHeight;
                debug("Storing current size", width, height);
                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
                // Otherwise the if-check in handleScroll is useless.
                storeCurrentSize(element, width, height);
                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.
                batchProcessor.add(0, function performUpdateChildSizes() {
                    if (!sizeChanged) return;
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }
                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }
                    if (options.debug) {
                        var w = element.offsetWidth;
                        var h = element.offsetHeight;
                        if (w !== width || h !== height) reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
                    }
                    updateChildSizes(element, width, height);
                });
                batchProcessor.add(1, function updateScrollbars() {
                    // This function needs to be invoked event though the size is unchanged. The element could have been resized very quickly and then
                    // been restored to the original size, which will have changed the scrollbar positions.
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }
                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }
                    positionScrollbars(element, width, height);
                });
                if (sizeChanged && done) batchProcessor.add(2, function() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }
                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }
                    done();
                });
            }
            function areElementsInjected() {
                return !!getState(element).container;
            }
            function notifyListenersIfNeeded() {
                function isFirstNotify() {
                    return getState(element).lastNotifiedWidth === undefined;
                }
                debug("notifyListenersIfNeeded invoked");
                var state = getState(element);
                // Don't notify if the current size is the start size, and this is the first notification.
                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
                // Don't notify if the size already has been notified.
                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) return debug("Not notifying: Size already notified");
                debug("Current size not notified, notifying...");
                state.lastNotifiedWidth = state.lastWidth;
                state.lastNotifiedHeight = state.lastHeight;
                $69e1681e2d0234dd$require$forEach(getState(element).listeners, function(listener) {
                    listener(element);
                });
            }
            function handleRender() {
                debug("startanimation triggered.");
                if (isUnrendered(element)) {
                    debug("Ignoring since element is still unrendered...");
                    return;
                }
                debug("Element rendered.");
                var expand = getExpandElement(element);
                var shrink = getShrinkElement(element);
                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
                    debug("Scrollbars out of sync. Updating detector elements...");
                    updateDetectorElements(notifyListenersIfNeeded);
                }
            }
            function handleScroll() {
                debug("Scroll detected.");
                if (isUnrendered(element)) {
                    // Element is still unrendered. Skip this scroll event.
                    debug("Scroll event fired while unrendered. Ignoring...");
                    return;
                }
                updateDetectorElements(notifyListenersIfNeeded);
            }
            debug("registerListenersAndPositionElements invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }
            getState(element).onRendered = handleRender;
            getState(element).onExpand = handleScroll;
            getState(element).onShrink = handleScroll;
            var style = getState(element).style;
            updateChildSizes(element, style.width, style.height);
        }
        function finalizeDomMutation() {
            debug("finalizeDomMutation invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }
            var style = getState(element).style;
            storeCurrentSize(element, style.width, style.height);
            positionScrollbars(element, style.width, style.height);
        }
        function ready() {
            callback(element);
        }
        function install() {
            debug("Installing...");
            initListeners();
            storeStartSize();
            batchProcessor.add(0, storeStyle);
            batchProcessor.add(1, injectScrollElements);
            batchProcessor.add(2, registerListenersAndPositionElements);
            batchProcessor.add(3, finalizeDomMutation);
            batchProcessor.add(4, ready);
        }
        debug("Making detectable...");
        if (isDetached(element)) {
            debug("Element is detached");
            injectContainerElement();
            debug("Waiting until element is attached...");
            getState(element).onRendered = function() {
                debug("Element is now attached");
                install();
            };
        } else install();
    }
    function uninstall(element) {
        var state = getState(element);
        if (!state) // Uninstall has been called on a non-erd element.
        return;
        // Uninstall may have been called in the following scenarios:
        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
        // So to be on the safe side, let's check for each thing before removing.
        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);
        state.container && element.removeChild(state.container);
    }
    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall,
        initDocument: initDocument
    };
};

});


parcelRegister("dHASG", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});


parcelRegister("f4x9d", function(module, exports) {

$parcel$export(module.exports, "withRef", function () { return $af90f126b0895f46$export$dc456d9dd53275ad; });

var $arQ7u = parcelRequire("arQ7u");
var $af90f126b0895f46$export$dc456d9dd53275ad = function withRef() {
    return function(Component) {
        var WithRefs = /*#__PURE__*/ (0, $arQ7u.forwardRef)(function(props, ref) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(Component, Object.assign({
                innerRef: ref
            }, props));
        });
        return WithRefs;
    };
};

});

parcelRegister("lCCRC", function(module, exports) {

$parcel$export(module.exports, "CompanionWindow", function () { return $fbdb4b1ff815506d$export$87a9123597e45a6f; });

var $arQ7u = parcelRequire("arQ7u");

var $9cuMj = parcelRequire("9cuMj");

var $i8Q6X = parcelRequire("i8Q6X");

var $6YZYI = parcelRequire("6YZYI");

var $3f9WU = parcelRequire("3f9WU");

var $hsH5s = parcelRequire("hsH5s");

var $cG8Hv = parcelRequire("cG8Hv");

var $hmn35 = parcelRequire("hmn35");

var $029Oc = parcelRequire("029Oc");

var $1xlvK = parcelRequire("1xlvK");
function $fbdb4b1ff815506d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fbdb4b1ff815506d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $fbdb4b1ff815506d$var$ownKeys(Object(source), true).forEach(function(key) {
            $fbdb4b1ff815506d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $fbdb4b1ff815506d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fbdb4b1ff815506d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fbdb4b1ff815506d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fbdb4b1ff815506d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fbdb4b1ff815506d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fbdb4b1ff815506d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fbdb4b1ff815506d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $fbdb4b1ff815506d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $fbdb4b1ff815506d$var$_setPrototypeOf(subClass, superClass);
}
function $fbdb4b1ff815506d$var$_setPrototypeOf(o, p) {
    $fbdb4b1ff815506d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fbdb4b1ff815506d$var$_setPrototypeOf(o, p);
}
function $fbdb4b1ff815506d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fbdb4b1ff815506d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $fbdb4b1ff815506d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $fbdb4b1ff815506d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $fbdb4b1ff815506d$var$_possibleConstructorReturn(this, result);
    };
}
function $fbdb4b1ff815506d$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $fbdb4b1ff815506d$var$_assertThisInitialized(self);
}
function $fbdb4b1ff815506d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fbdb4b1ff815506d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $fbdb4b1ff815506d$var$_getPrototypeOf(o) {
    $fbdb4b1ff815506d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fbdb4b1ff815506d$var$_getPrototypeOf(o);
}
var $fbdb4b1ff815506d$export$87a9123597e45a6f = /*#__PURE__*/ function(_Component) {
    $fbdb4b1ff815506d$var$_inherits(CompanionWindow, _Component);
    var _super = $fbdb4b1ff815506d$var$_createSuper(CompanionWindow);
    function CompanionWindow() {
        $fbdb4b1ff815506d$var$_classCallCheck(this, CompanionWindow);
        return _super.apply(this, arguments);
    }
    $fbdb4b1ff815506d$var$_createClass(CompanionWindow, [
        {
            key: "openInNewStyle",
            value: /** */ function openInNewStyle() {
                var direction = this.props.direction;
                if (direction === "rtl") return {
                    transform: "scale(-1, 1)"
                };
                return {};
            }
        },
        {
            key: "resizeHandles",
            value: function resizeHandles() {
                var _this$props = this.props, direction = _this$props.direction, position = _this$props.position;
                var positions = {
                    ltr: {
                        "default": "left",
                        opposite: "right"
                    },
                    rtl: {
                        "default": "right",
                        opposite: "left"
                    }
                };
                var base = {
                    bottom: false,
                    bottomLeft: false,
                    bottomRight: false,
                    left: false,
                    right: false,
                    top: false,
                    topLeft: false,
                    topRight: false
                };
                if (position === "right" || position === "far-right") return $fbdb4b1ff815506d$var$_objectSpread($fbdb4b1ff815506d$var$_objectSpread({}, base), {}, $fbdb4b1ff815506d$var$_defineProperty({}, positions[direction]["default"], true));
                if (position === "left") return $fbdb4b1ff815506d$var$_objectSpread($fbdb4b1ff815506d$var$_objectSpread({}, base), {}, $fbdb4b1ff815506d$var$_defineProperty({}, positions[direction].opposite, true));
                if (position === "bottom" || position === "far-bottom") return $fbdb4b1ff815506d$var$_objectSpread($fbdb4b1ff815506d$var$_objectSpread({}, base), {}, {
                    top: true
                });
                return base;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, ariaLabel = _this$props2.ariaLabel, classes = _this$props2.classes, paperClassName = _this$props2.paperClassName, onCloseClick = _this$props2.onCloseClick, updateCompanionWindow = _this$props2.updateCompanionWindow, isDisplayed = _this$props2.isDisplayed, position = _this$props2.position, t = _this$props2.t, title = _this$props2.title, children = _this$props2.children, titleControls = _this$props2.titleControls, size = _this$props2.size, defaultSidebarPanelWidth = _this$props2.defaultSidebarPanelWidth, defaultSidebarPanelHeight = _this$props2.defaultSidebarPanelHeight;
                var isBottom = position === "bottom" || position === "far-bottom";
                var childrenWithAdditionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Children.map(children, function(child) {
                    if (!child) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).cloneElement(child, {
                        parentactions: {
                            closeCompanionWindow: onCloseClick
                        }
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $3f9WU.default), {
                    className: [
                        classes.root,
                        position === "bottom" ? classes.horizontal : classes.vertical,
                        classes["companionWindow-".concat(position)],
                        (0, $1xlvK.default)("companion-window-".concat(position)),
                        paperClassName
                    ].join(" "),
                    style: {
                        display: isDisplayed ? null : "none",
                        order: position === "left" ? -1 : null
                    },
                    square: true,
                    component: "aside",
                    "aria-label": ariaLabel || title
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hmn35.Rnd), {
                    className: [
                        classes.rnd
                    ],
                    style: {
                        display: "flex",
                        position: "relative"
                    },
                    "default": {
                        height: isBottom ? defaultSidebarPanelHeight : "100%",
                        width: isBottom ? "auto" : defaultSidebarPanelWidth
                    },
                    disableDragging: true,
                    enableResizing: this.resizeHandles(),
                    minHeight: 50,
                    minWidth: position === "left" ? 235 : 100
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $cG8Hv.default), {
                    className: [
                        classes.toolbar,
                        classes.companionWindowHeader,
                        size.width < 370 ? classes.small : null,
                        (0, $1xlvK.default)("companion-window-header")
                    ].join(" "),
                    disableGutters: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "h3",
                    className: classes.windowSideBarTitle
                }, title), position === "left" ? updateCompanionWindow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $029Oc.default), {
                    "aria-label": t("openInCompanionWindow"),
                    onClick: function onClick() {
                        updateCompanionWindow({
                            position: "right"
                        });
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i8Q6X))), {
                    style: this.openInNewStyle()
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, updateCompanionWindow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $029Oc.default), {
                    "aria-label": position === "bottom" ? t("moveCompanionWindowToRight") : t("moveCompanionWindowToBottom"),
                    className: classes.positionButton,
                    onClick: function onClick() {
                        updateCompanionWindow({
                            position: position === "bottom" ? "right" : "bottom"
                        });
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6YZYI))), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $029Oc.default), {
                    "aria-label": t("closeCompanionWindow"),
                    className: classes.closeButton,
                    onClick: onCloseClick
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9cuMj))), null))), titleControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    className: [
                        classes.titleControls,
                        isBottom ? classes.companionWindowTitleControlsBottom : classes.companionWindowTitleControls,
                        (0, $1xlvK.default)("companion-window-title-controls")
                    ].join(" ")
                }, titleControls)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $3f9WU.default), {
                    className: [
                        classes.content,
                        (0, $1xlvK.default)("scrollto-scrollable")
                    ].join(" "),
                    elevation: 0
                }, childrenWithAdditionalProps)));
            }
        }
    ]);
    return CompanionWindow;
}((0, $arQ7u.Component));
$fbdb4b1ff815506d$export$87a9123597e45a6f.defaultProps = {
    ariaLabel: undefined,
    children: undefined,
    defaultSidebarPanelHeight: 201,
    defaultSidebarPanelWidth: 235,
    isDisplayed: false,
    onCloseClick: function onCloseClick() {},
    paperClassName: "",
    position: null,
    size: {},
    t: function t(key) {
        return key;
    },
    title: null,
    titleControls: null,
    updateCompanionWindow: undefined
};

});
parcelRegister("9cuMj", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b2d1bf5b73e2e4e$var$React = $363GR((parcelRequire("arQ7u")));

var $6b2d1bf5b73e2e4e$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $6b2d1bf5b73e2e4e$var$_default = (0, $6b2d1bf5b73e2e4e$var$_createSvgIcon.default)(/*#__PURE__*/ $6b2d1bf5b73e2e4e$var$React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}), "CloseSharp");
module.exports.default = $6b2d1bf5b73e2e4e$var$_default;

});

parcelRegister("i8Q6X", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3516589d64a12f4$var$React = $363GR((parcelRequire("arQ7u")));

var $d3516589d64a12f4$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $d3516589d64a12f4$var$_default = (0, $d3516589d64a12f4$var$_createSvgIcon.default)(/*#__PURE__*/ $d3516589d64a12f4$var$React.createElement("path", {
    d: "M19 19H5V5h7V3H3v18h18v-9h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
}), "OpenInNewSharp");
module.exports.default = $d3516589d64a12f4$var$_default;

});

parcelRegister("6YZYI", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51586c4522a3c4eb$var$React = $363GR((parcelRequire("arQ7u")));

var $51586c4522a3c4eb$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $51586c4522a3c4eb$var$_default = (0, $51586c4522a3c4eb$var$_createSvgIcon.default)(/*#__PURE__*/ $51586c4522a3c4eb$var$React.createElement("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "DragIndicatorSharp");
module.exports.default = $51586c4522a3c4eb$var$_default;

});

parcelRegister("cG8Hv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93b02809286bbce8$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $4g0WD = parcelRequire("4g0WD");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");
var $93b02809286bbce8$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            display: "flex",
            alignItems: "center"
        },
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: (0, $4g0WD.default)({
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        }, theme.breakpoints.up("sm"), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `variant="regular"`. */ regular: theme.mixins.toolbar,
        /* Styles applied to the root element if `variant="dense"`. */ dense: {
            minHeight: 48
        }
    };
};
var $93b02809286bbce8$var$Toolbar = /*#__PURE__*/ $arQ7u.forwardRef(function Toolbar(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$variant = props.variant, variant = _props$variant === void 0 ? "regular" : _props$variant, other = (0, $dXEVX.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "variant"
    ]);
    return /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $93b02809286bbce8$export$2e2bcd8739ae039 = (0, $7EzGR.default)($93b02809286bbce8$export$9dd6ff9ea0189349, {
    name: "MuiToolbar"
})($93b02809286bbce8$var$Toolbar);

});

parcelRegister("hmn35", function(module, exports) {

$parcel$export(module.exports, "Rnd", function () { return $ca365ec5132f7547$export$1568a3397381fb0e; });

var $arQ7u = parcelRequire("arQ7u");

var $9HKv9 = parcelRequire("9HKv9");

var $ILDD9 = parcelRequire("ILDD9");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $ca365ec5132f7547$var$extendStatics = function(d, b) {
    $ca365ec5132f7547$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ca365ec5132f7547$var$extendStatics(d, b);
};
function $ca365ec5132f7547$var$__extends(d, b) {
    $ca365ec5132f7547$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ca365ec5132f7547$var$__assign = function() {
    $ca365ec5132f7547$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ca365ec5132f7547$var$__assign.apply(this, arguments);
};
function $ca365ec5132f7547$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $ca365ec5132f7547$var$resizableStyle = {
    width: "auto",
    height: "auto",
    display: "inline-block",
    position: "absolute",
    top: 0,
    left: 0
};
var $ca365ec5132f7547$var$getEnableResizingByFlag = function(flag) {
    return {
        bottom: flag,
        bottomLeft: flag,
        bottomRight: flag,
        left: flag,
        right: flag,
        top: flag,
        topLeft: flag,
        topRight: flag
    };
};
var $ca365ec5132f7547$export$1568a3397381fb0e = /** @class */ function(_super) {
    $ca365ec5132f7547$var$__extends(Rnd, _super);
    function Rnd(props) {
        var _this = _super.call(this, props) || this;
        _this.resizingPosition = {
            x: 0,
            y: 0
        };
        _this.offsetFromParent = {
            left: 0,
            top: 0
        };
        _this.resizableElement = {
            current: null
        };
        _this.originalPosition = {
            x: 0,
            y: 0
        };
        _this.refDraggable = function(c) {
            if (!c) return;
            _this.draggable = c;
        };
        _this.refResizable = function(c) {
            if (!c) return;
            _this.resizable = c;
            _this.resizableElement.current = c.resizable;
        };
        _this.state = {
            resizing: false,
            bounds: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            maxWidth: props.maxWidth,
            maxHeight: props.maxHeight
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onResize = _this.onResize.bind(_this);
        _this.onResizeStop = _this.onResizeStop.bind(_this);
        _this.onDragStart = _this.onDragStart.bind(_this);
        _this.onDrag = _this.onDrag.bind(_this);
        _this.onDragStop = _this.onDragStop.bind(_this);
        _this.getMaxSizesFromProps = _this.getMaxSizesFromProps.bind(_this);
        return _this;
    }
    Rnd.prototype.componentDidMount = function() {
        this.updateOffsetFromParent();
        var _a = this.offsetFromParent, left = _a.left, top = _a.top;
        var _b = this.getDraggablePosition(), x = _b.x, y = _b.y;
        this.draggable.setState({
            x: x - left,
            y: y - top
        });
        // HACK: Apply position adjustment
        this.forceUpdate();
    };
    // HACK: To get `react-draggable` state x and y.
    Rnd.prototype.getDraggablePosition = function() {
        var _a = this.draggable.state, x = _a.x, y = _a.y;
        return {
            x: x,
            y: y
        };
    };
    Rnd.prototype.getParent = function() {
        return this.resizable && this.resizable.parentNode;
    };
    Rnd.prototype.getParentSize = function() {
        return this.resizable.getParentSize();
    };
    Rnd.prototype.getMaxSizesFromProps = function() {
        var maxWidth = typeof this.props.maxWidth === "undefined" ? Number.MAX_SAFE_INTEGER : this.props.maxWidth;
        var maxHeight = typeof this.props.maxHeight === "undefined" ? Number.MAX_SAFE_INTEGER : this.props.maxHeight;
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Rnd.prototype.getSelfElement = function() {
        return this.resizable && this.resizable.resizable;
    };
    Rnd.prototype.getOffsetHeight = function(boundary) {
        var scale = this.props.scale;
        switch(this.props.bounds){
            case "window":
                return window.innerHeight / scale;
            case "body":
                return document.body.offsetHeight / scale;
            default:
                return boundary.offsetHeight;
        }
    };
    Rnd.prototype.getOffsetWidth = function(boundary) {
        var scale = this.props.scale;
        switch(this.props.bounds){
            case "window":
                return window.innerWidth / scale;
            case "body":
                return document.body.offsetWidth / scale;
            default:
                return boundary.offsetWidth;
        }
    };
    Rnd.prototype.onDragStart = function(e, data) {
        if (this.props.onDragStart) this.props.onDragStart(e, data);
        var pos = this.getDraggablePosition();
        this.originalPosition = pos;
        if (!this.props.bounds) return;
        var parent = this.getParent();
        var scale = this.props.scale;
        var boundary;
        if (this.props.bounds === "parent") boundary = parent;
        else if (this.props.bounds === "body") {
            var parentRect_1 = parent.getBoundingClientRect();
            var parentLeft_1 = parentRect_1.left;
            var parentTop_1 = parentRect_1.top;
            var bodyRect = document.body.getBoundingClientRect();
            var left_1 = -(parentLeft_1 - parent.offsetLeft * scale - bodyRect.left) / scale;
            var top_1 = -(parentTop_1 - parent.offsetTop * scale - bodyRect.top) / scale;
            var right = (document.body.offsetWidth - this.resizable.size.width * scale) / scale + left_1;
            var bottom = (document.body.offsetHeight - this.resizable.size.height * scale) / scale + top_1;
            return this.setState({
                bounds: {
                    top: top_1,
                    right: right,
                    bottom: bottom,
                    left: left_1
                }
            });
        } else if (this.props.bounds === "window") {
            if (!this.resizable) return;
            var parentRect_2 = parent.getBoundingClientRect();
            var parentLeft_2 = parentRect_2.left;
            var parentTop_2 = parentRect_2.top;
            var left_2 = -(parentLeft_2 - parent.offsetLeft * scale) / scale;
            var top_2 = -(parentTop_2 - parent.offsetTop * scale) / scale;
            var right = (window.innerWidth - this.resizable.size.width * scale) / scale + left_2;
            var bottom = (window.innerHeight - this.resizable.size.height * scale) / scale + top_2;
            return this.setState({
                bounds: {
                    top: top_2,
                    right: right,
                    bottom: bottom,
                    left: left_2
                }
            });
        } else if (typeof this.props.bounds === "string") boundary = document.querySelector(this.props.bounds);
        else if (this.props.bounds instanceof HTMLElement) boundary = this.props.bounds;
        if (!(boundary instanceof HTMLElement) || !(parent instanceof HTMLElement)) return;
        var boundaryRect = boundary.getBoundingClientRect();
        var boundaryLeft = boundaryRect.left;
        var boundaryTop = boundaryRect.top;
        var parentRect = parent.getBoundingClientRect();
        var parentLeft = parentRect.left;
        var parentTop = parentRect.top;
        var left = (boundaryLeft - parentLeft) / scale;
        var top = boundaryTop - parentTop;
        if (!this.resizable) return;
        this.updateOffsetFromParent();
        var offset = this.offsetFromParent;
        this.setState({
            bounds: {
                top: top - offset.top,
                right: left + (boundary.offsetWidth - this.resizable.size.width) - offset.left / scale,
                bottom: top + (boundary.offsetHeight - this.resizable.size.height) - offset.top,
                left: left - offset.left / scale
            }
        });
    };
    Rnd.prototype.onDrag = function(e, data) {
        if (!this.props.onDrag) return;
        var _a = this.offsetFromParent, left = _a.left, top = _a.top;
        if (!this.props.dragAxis || this.props.dragAxis === "both") return this.props.onDrag(e, $ca365ec5132f7547$var$__assign($ca365ec5132f7547$var$__assign({}, data), {
            x: data.x + left,
            y: data.y + top
        }));
        else if (this.props.dragAxis === "x") return this.props.onDrag(e, $ca365ec5132f7547$var$__assign($ca365ec5132f7547$var$__assign({}, data), {
            x: data.x + left,
            y: this.originalPosition.y + top,
            deltaY: 0
        }));
        else if (this.props.dragAxis === "y") return this.props.onDrag(e, $ca365ec5132f7547$var$__assign($ca365ec5132f7547$var$__assign({}, data), {
            x: this.originalPosition.x + left,
            y: data.y + top,
            deltaX: 0
        }));
    };
    Rnd.prototype.onDragStop = function(e, data) {
        if (!this.props.onDragStop) return;
        var _a = this.offsetFromParent, left = _a.left, top = _a.top;
        if (!this.props.dragAxis || this.props.dragAxis === "both") return this.props.onDragStop(e, $ca365ec5132f7547$var$__assign($ca365ec5132f7547$var$__assign({}, data), {
            x: data.x + left,
            y: data.y + top
        }));
        else if (this.props.dragAxis === "x") return this.props.onDragStop(e, $ca365ec5132f7547$var$__assign($ca365ec5132f7547$var$__assign({}, data), {
            x: data.x + left,
            y: this.originalPosition.y + top,
            deltaY: 0
        }));
        else if (this.props.dragAxis === "y") return this.props.onDragStop(e, $ca365ec5132f7547$var$__assign($ca365ec5132f7547$var$__assign({}, data), {
            x: this.originalPosition.x + left,
            y: data.y + top,
            deltaX: 0
        }));
    };
    Rnd.prototype.onResizeStart = function(e, dir, elementRef) {
        e.stopPropagation();
        this.setState({
            resizing: true
        });
        var scale = this.props.scale;
        var offset = this.offsetFromParent;
        var pos = this.getDraggablePosition();
        this.resizingPosition = {
            x: pos.x + offset.left,
            y: pos.y + offset.top
        };
        this.originalPosition = pos;
        if (this.props.bounds) {
            var parent_1 = this.getParent();
            var boundary = void 0;
            if (this.props.bounds === "parent") boundary = parent_1;
            else if (this.props.bounds === "body") boundary = document.body;
            else if (this.props.bounds === "window") boundary = window;
            else if (typeof this.props.bounds === "string") boundary = document.querySelector(this.props.bounds);
            else if (this.props.bounds instanceof HTMLElement) boundary = this.props.bounds;
            var self_1 = this.getSelfElement();
            if (self_1 instanceof Element && (boundary instanceof HTMLElement || boundary === window) && parent_1 instanceof HTMLElement) {
                var _a = this.getMaxSizesFromProps(), maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
                var parentSize = this.getParentSize();
                if (maxWidth && typeof maxWidth === "string") {
                    if (maxWidth.endsWith("%")) {
                        var ratio = Number(maxWidth.replace("%", "")) / 100;
                        maxWidth = parentSize.width * ratio;
                    } else if (maxWidth.endsWith("px")) maxWidth = Number(maxWidth.replace("px", ""));
                }
                if (maxHeight && typeof maxHeight === "string") {
                    if (maxHeight.endsWith("%")) {
                        var ratio = Number(maxHeight.replace("%", "")) / 100;
                        maxHeight = parentSize.height * ratio;
                    } else if (maxHeight.endsWith("px")) maxHeight = Number(maxHeight.replace("px", ""));
                }
                var selfRect = self_1.getBoundingClientRect();
                var selfLeft = selfRect.left;
                var selfTop = selfRect.top;
                var boundaryRect = this.props.bounds === "window" ? {
                    left: 0,
                    top: 0
                } : boundary.getBoundingClientRect();
                var boundaryLeft = boundaryRect.left;
                var boundaryTop = boundaryRect.top;
                var offsetWidth = this.getOffsetWidth(boundary);
                var offsetHeight = this.getOffsetHeight(boundary);
                var hasLeft = dir.toLowerCase().endsWith("left");
                var hasRight = dir.toLowerCase().endsWith("right");
                var hasTop = dir.startsWith("top");
                var hasBottom = dir.startsWith("bottom");
                if ((hasLeft || hasTop) && this.resizable) {
                    var max = (selfLeft - boundaryLeft) / scale + this.resizable.size.width;
                    this.setState({
                        maxWidth: max > Number(maxWidth) ? maxWidth : max
                    });
                }
                // INFO: To set bounds in `lock aspect ratio with bounds` case. See also that story.
                if (hasRight || this.props.lockAspectRatio && !hasLeft && !hasTop) {
                    var max = offsetWidth + (boundaryLeft - selfLeft) / scale;
                    this.setState({
                        maxWidth: max > Number(maxWidth) ? maxWidth : max
                    });
                }
                if ((hasTop || hasLeft) && this.resizable) {
                    var max = (selfTop - boundaryTop) / scale + this.resizable.size.height;
                    this.setState({
                        maxHeight: max > Number(maxHeight) ? maxHeight : max
                    });
                }
                // INFO: To set bounds in `lock aspect ratio with bounds` case. See also that story.
                if (hasBottom || this.props.lockAspectRatio && !hasTop && !hasLeft) {
                    var max = offsetHeight + (boundaryTop - selfTop) / scale;
                    this.setState({
                        maxHeight: max > Number(maxHeight) ? maxHeight : max
                    });
                }
            }
        } else this.setState({
            maxWidth: this.props.maxWidth,
            maxHeight: this.props.maxHeight
        });
        if (this.props.onResizeStart) this.props.onResizeStart(e, dir, elementRef);
    };
    Rnd.prototype.onResize = function(e, direction, elementRef, delta) {
        // INFO: Apply x and y position adjustments caused by resizing to draggable
        var newPos = {
            x: this.originalPosition.x,
            y: this.originalPosition.y
        };
        var left = -delta.width;
        var top = -delta.height;
        var directions = [
            "top",
            "left",
            "topLeft",
            "bottomLeft",
            "topRight"
        ];
        if (directions.includes(direction)) {
            if (direction === "bottomLeft") newPos.x += left;
            else if (direction === "topRight") newPos.y += top;
            else {
                newPos.x += left;
                newPos.y += top;
            }
        }
        var draggableState = this.draggable.state;
        if (newPos.x !== draggableState.x || newPos.y !== draggableState.y) this.draggable.setState(newPos);
        this.updateOffsetFromParent();
        var offset = this.offsetFromParent;
        var x = this.getDraggablePosition().x + offset.left;
        var y = this.getDraggablePosition().y + offset.top;
        this.resizingPosition = {
            x: x,
            y: y
        };
        if (!this.props.onResize) return;
        this.props.onResize(e, direction, elementRef, delta, {
            x: x,
            y: y
        });
    };
    Rnd.prototype.onResizeStop = function(e, direction, elementRef, delta) {
        this.setState({
            resizing: false
        });
        var _a = this.getMaxSizesFromProps(), maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
        this.setState({
            maxWidth: maxWidth,
            maxHeight: maxHeight
        });
        if (this.props.onResizeStop) this.props.onResizeStop(e, direction, elementRef, delta, this.resizingPosition);
    };
    Rnd.prototype.updateSize = function(size) {
        if (!this.resizable) return;
        this.resizable.updateSize({
            width: size.width,
            height: size.height
        });
    };
    Rnd.prototype.updatePosition = function(position) {
        this.draggable.setState(position);
    };
    Rnd.prototype.updateOffsetFromParent = function() {
        var scale = this.props.scale;
        var parent = this.getParent();
        var self = this.getSelfElement();
        if (!parent || self === null) return {
            top: 0,
            left: 0
        };
        var parentRect = parent.getBoundingClientRect();
        var parentLeft = parentRect.left;
        var parentTop = parentRect.top;
        var selfRect = self.getBoundingClientRect();
        var position = this.getDraggablePosition();
        var scrollLeft = parent.scrollLeft;
        var scrollTop = parent.scrollTop;
        this.offsetFromParent = {
            left: selfRect.left - parentLeft + scrollLeft - position.x * scale,
            top: selfRect.top - parentTop + scrollTop - position.y * scale
        };
    };
    Rnd.prototype.render = function() {
        var _a = this.props, disableDragging = _a.disableDragging, style = _a.style, dragHandleClassName = _a.dragHandleClassName, position = _a.position, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, dragAxis = _a.dragAxis, dragGrid = _a.dragGrid, bounds = _a.bounds, enableUserSelectHack = _a.enableUserSelectHack, cancel = _a.cancel, children = _a.children, onResizeStart = _a.onResizeStart, onResize = _a.onResize, onResizeStop = _a.onResizeStop, onDragStart = _a.onDragStart, onDrag = _a.onDrag, onDragStop = _a.onDragStop, resizeHandleStyles = _a.resizeHandleStyles, resizeHandleClasses = _a.resizeHandleClasses, resizeHandleComponent = _a.resizeHandleComponent, enableResizing = _a.enableResizing, resizeGrid = _a.resizeGrid, resizeHandleWrapperClass = _a.resizeHandleWrapperClass, resizeHandleWrapperStyle = _a.resizeHandleWrapperStyle, scale = _a.scale, allowAnyClick = _a.allowAnyClick, resizableProps = $ca365ec5132f7547$var$__rest(_a, [
            "disableDragging",
            "style",
            "dragHandleClassName",
            "position",
            "onMouseDown",
            "onMouseUp",
            "dragAxis",
            "dragGrid",
            "bounds",
            "enableUserSelectHack",
            "cancel",
            "children",
            "onResizeStart",
            "onResize",
            "onResizeStop",
            "onDragStart",
            "onDrag",
            "onDragStop",
            "resizeHandleStyles",
            "resizeHandleClasses",
            "resizeHandleComponent",
            "enableResizing",
            "resizeGrid",
            "resizeHandleWrapperClass",
            "resizeHandleWrapperStyle",
            "scale",
            "allowAnyClick"
        ]);
        var defaultValue = this.props.default ? $ca365ec5132f7547$var$__assign({}, this.props.default) : undefined;
        // Remove unknown props, see also https://reactjs.org/warnings/unknown-prop.html
        delete resizableProps.default;
        var cursorStyle = disableDragging || dragHandleClassName ? {
            cursor: "auto"
        } : {
            cursor: "move"
        };
        var innerStyle = $ca365ec5132f7547$var$__assign($ca365ec5132f7547$var$__assign($ca365ec5132f7547$var$__assign({}, $ca365ec5132f7547$var$resizableStyle), cursorStyle), style);
        var _b = this.offsetFromParent, left = _b.left, top = _b.top;
        var draggablePosition;
        if (position) draggablePosition = {
            x: position.x - left,
            y: position.y - top
        };
        // INFO: Make uncontorolled component when resizing to control position by setPostion.
        var pos = this.state.resizing ? undefined : draggablePosition;
        var dragAxisOrUndefined = this.state.resizing ? "both" : dragAxis;
        return (0, $arQ7u.createElement)((0, (/*@__PURE__*/$parcel$interopDefault($9HKv9))), {
            ref: this.refDraggable,
            handle: dragHandleClassName ? ".".concat(dragHandleClassName) : undefined,
            defaultPosition: defaultValue,
            onMouseDown: onMouseDown,
            // @ts-expect-error
            onMouseUp: onMouseUp,
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop,
            axis: dragAxisOrUndefined,
            disabled: disableDragging,
            grid: dragGrid,
            bounds: bounds ? this.state.bounds : undefined,
            position: pos,
            enableUserSelectHack: enableUserSelectHack,
            cancel: cancel,
            scale: scale,
            allowAnyClick: allowAnyClick,
            nodeRef: this.resizableElement
        }, (0, $arQ7u.createElement)((0, $ILDD9.Resizable), $ca365ec5132f7547$var$__assign({}, resizableProps, {
            ref: this.refResizable,
            defaultSize: defaultValue,
            size: this.props.size,
            enable: typeof enableResizing === "boolean" ? $ca365ec5132f7547$var$getEnableResizingByFlag(enableResizing) : enableResizing,
            onResizeStart: this.onResizeStart,
            onResize: this.onResize,
            onResizeStop: this.onResizeStop,
            style: innerStyle,
            minWidth: this.props.minWidth,
            minHeight: this.props.minHeight,
            maxWidth: this.state.resizing ? this.state.maxWidth : this.props.maxWidth,
            maxHeight: this.state.resizing ? this.state.maxHeight : this.props.maxHeight,
            grid: resizeGrid,
            handleWrapperClass: resizeHandleWrapperClass,
            handleWrapperStyle: resizeHandleWrapperStyle,
            lockAspectRatio: this.props.lockAspectRatio,
            lockAspectRatioExtraWidth: this.props.lockAspectRatioExtraWidth,
            lockAspectRatioExtraHeight: this.props.lockAspectRatioExtraHeight,
            handleStyles: resizeHandleStyles,
            handleClasses: resizeHandleClasses,
            handleComponent: resizeHandleComponent,
            scale: this.props.scale
        }), children));
    };
    Rnd.defaultProps = {
        maxWidth: Number.MAX_SAFE_INTEGER,
        maxHeight: Number.MAX_SAFE_INTEGER,
        scale: 1,
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        onDragStart: function() {},
        onDrag: function() {},
        onDragStop: function() {}
    };
    return Rnd;
}((0, $arQ7u.PureComponent));

});
parcelRegister("9HKv9", function(module, exports) {
"use strict";

var $86wX8 = parcelRequire("86wX8");
var $710c336baa6412e0$require$Draggable = $86wX8.default;
var $710c336baa6412e0$require$DraggableCore = $86wX8.DraggableCore;
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = $710c336baa6412e0$require$Draggable;
module.exports.default = $710c336baa6412e0$require$Draggable;
module.exports.DraggableCore = $710c336baa6412e0$require$DraggableCore;

});
parcelRegister("86wX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return $5e6871fc7d490947$var$_DraggableCore.default;
    }
});
module.exports.default = void 0;

var $5e6871fc7d490947$var$React = $5e6871fc7d490947$var$_interopRequireWildcard((parcelRequire("arQ7u")));

var $5e6871fc7d490947$var$_propTypes = $5e6871fc7d490947$var$_interopRequireDefault((parcelRequire("4Jbg8")));

var $5e6871fc7d490947$var$_reactDom = $5e6871fc7d490947$var$_interopRequireDefault((parcelRequire("9sDDw")));

var $5e6871fc7d490947$var$_clsx = $5e6871fc7d490947$var$_interopRequireDefault((parcelRequire("5g55B")));

var $fLI2M = parcelRequire("fLI2M");

var $bPRmQ = parcelRequire("bPRmQ");

var $hexx7 = parcelRequire("hexx7");

var $5e6871fc7d490947$var$_DraggableCore = $5e6871fc7d490947$var$_interopRequireDefault((parcelRequire("6dxC7")));

var $5e6871fc7d490947$var$_log = $5e6871fc7d490947$var$_interopRequireDefault((parcelRequire("grrM2")));
function $5e6871fc7d490947$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5e6871fc7d490947$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5e6871fc7d490947$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5e6871fc7d490947$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5e6871fc7d490947$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5e6871fc7d490947$var$_extends() {
    $5e6871fc7d490947$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5e6871fc7d490947$var$_extends.apply(this, arguments);
}
function $5e6871fc7d490947$var$_defineProperty(obj, key, value) {
    key = $5e6871fc7d490947$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5e6871fc7d490947$var$_toPropertyKey(arg) {
    var key = $5e6871fc7d490947$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5e6871fc7d490947$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class $5e6871fc7d490947$var$Draggable extends $5e6871fc7d490947$var$React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position: position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition: prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, $5e6871fc7d490947$var$_log.default)("Draggable: getDerivedStateFromProps %j", {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props$nodeRef$c, _this$props;
        return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : $5e6871fc7d490947$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, $bPRmQ.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, $bPRmQ.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, $fLI2M.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, $fLI2M.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, $5e6871fc7d490947$var$_clsx.default)(children.props.className || "", defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $5e6871fc7d490947$var$React.createElement($5e6871fc7d490947$var$_DraggableCore.default, $5e6871fc7d490947$var$_extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ $5e6871fc7d490947$var$React.cloneElement($5e6871fc7d490947$var$React.Children.only(children), {
            className: className,
            style: {
                ...children.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        $5e6871fc7d490947$var$_defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, $5e6871fc7d490947$var$_log.default)("Draggable: onDragStart: %j", coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, $bPRmQ.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        $5e6871fc7d490947$var$_defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, $5e6871fc7d490947$var$_log.default)("Draggable: onDrag: %j", coreData);
            const uiData = (0, $bPRmQ.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x: x, y: y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, $bPRmQ.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        $5e6871fc7d490947$var$_defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, $bPRmQ.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, $5e6871fc7d490947$var$_log.default)("Draggable: onDragStop: %j", coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
}
module.exports.default = $5e6871fc7d490947$var$Draggable;
$5e6871fc7d490947$var$_defineProperty($5e6871fc7d490947$var$Draggable, "displayName", "Draggable");
$5e6871fc7d490947$var$_defineProperty($5e6871fc7d490947$var$Draggable, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...$5e6871fc7d490947$var$_DraggableCore.default.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $5e6871fc7d490947$var$_propTypes.default.oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $5e6871fc7d490947$var$_propTypes.default.oneOfType([
        $5e6871fc7d490947$var$_propTypes.default.shape({
            left: $5e6871fc7d490947$var$_propTypes.default.number,
            right: $5e6871fc7d490947$var$_propTypes.default.number,
            top: $5e6871fc7d490947$var$_propTypes.default.number,
            bottom: $5e6871fc7d490947$var$_propTypes.default.number
        }),
        $5e6871fc7d490947$var$_propTypes.default.string,
        $5e6871fc7d490947$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $5e6871fc7d490947$var$_propTypes.default.string,
    defaultClassNameDragging: $5e6871fc7d490947$var$_propTypes.default.string,
    defaultClassNameDragged: $5e6871fc7d490947$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $5e6871fc7d490947$var$_propTypes.default.shape({
        x: $5e6871fc7d490947$var$_propTypes.default.number,
        y: $5e6871fc7d490947$var$_propTypes.default.number
    }),
    positionOffset: $5e6871fc7d490947$var$_propTypes.default.shape({
        x: $5e6871fc7d490947$var$_propTypes.default.oneOfType([
            $5e6871fc7d490947$var$_propTypes.default.number,
            $5e6871fc7d490947$var$_propTypes.default.string
        ]),
        y: $5e6871fc7d490947$var$_propTypes.default.oneOfType([
            $5e6871fc7d490947$var$_propTypes.default.number,
            $5e6871fc7d490947$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $5e6871fc7d490947$var$_propTypes.default.shape({
        x: $5e6871fc7d490947$var$_propTypes.default.number,
        y: $5e6871fc7d490947$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $hexx7.dontSetMe,
    style: $hexx7.dontSetMe,
    transform: $hexx7.dontSetMe
});
$5e6871fc7d490947$var$_defineProperty($5e6871fc7d490947$var$Draggable, "defaultProps", {
    ...$5e6871fc7d490947$var$_DraggableCore.default.defaultProps,
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
});

});
parcelRegister("fLI2M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $b7ad68fa7302cf41$var$addClassName;
module.exports.addEvent = $b7ad68fa7302cf41$var$addEvent;
module.exports.addUserSelectStyles = $b7ad68fa7302cf41$var$addUserSelectStyles;
module.exports.createCSSTransform = $b7ad68fa7302cf41$var$createCSSTransform;
module.exports.createSVGTransform = $b7ad68fa7302cf41$var$createSVGTransform;
module.exports.getTouch = $b7ad68fa7302cf41$var$getTouch;
module.exports.getTouchIdentifier = $b7ad68fa7302cf41$var$getTouchIdentifier;
module.exports.getTranslation = $b7ad68fa7302cf41$var$getTranslation;
module.exports.innerHeight = $b7ad68fa7302cf41$var$innerHeight;
module.exports.innerWidth = $b7ad68fa7302cf41$var$innerWidth;
module.exports.matchesSelector = $b7ad68fa7302cf41$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $b7ad68fa7302cf41$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $b7ad68fa7302cf41$var$offsetXYFromParent;
module.exports.outerHeight = $b7ad68fa7302cf41$var$outerHeight;
module.exports.outerWidth = $b7ad68fa7302cf41$var$outerWidth;
module.exports.removeClassName = $b7ad68fa7302cf41$var$removeClassName;
module.exports.removeEvent = $b7ad68fa7302cf41$var$removeEvent;
module.exports.removeUserSelectStyles = $b7ad68fa7302cf41$var$removeUserSelectStyles;

var $hexx7 = parcelRequire("hexx7");

var $b7ad68fa7302cf41$var$_getPrefix = $b7ad68fa7302cf41$var$_interopRequireWildcard((parcelRequire("fSZFb")));
function $b7ad68fa7302cf41$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b7ad68fa7302cf41$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b7ad68fa7302cf41$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b7ad68fa7302cf41$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let $b7ad68fa7302cf41$var$matchesSelectorFunc = "";
function $b7ad68fa7302cf41$var$matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!$b7ad68fa7302cf41$var$matchesSelectorFunc) $b7ad68fa7302cf41$var$matchesSelectorFunc = (0, $hexx7.findInArray)([
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector"
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $hexx7.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $hexx7.isFunction)(el[$b7ad68fa7302cf41$var$matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[$b7ad68fa7302cf41$var$matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function $b7ad68fa7302cf41$var$matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if ($b7ad68fa7302cf41$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function $b7ad68fa7302cf41$var$addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = handler;
}
function $b7ad68fa7302cf41$var$removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = null;
}
function $b7ad68fa7302cf41$var$outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $hexx7.int)(computedStyle.borderTopWidth);
    height += (0, $hexx7.int)(computedStyle.borderBottomWidth);
    return height;
}
function $b7ad68fa7302cf41$var$outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $hexx7.int)(computedStyle.borderLeftWidth);
    width += (0, $hexx7.int)(computedStyle.borderRightWidth);
    return width;
}
function $b7ad68fa7302cf41$var$innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $hexx7.int)(computedStyle.paddingTop);
    height -= (0, $hexx7.int)(computedStyle.paddingBottom);
    return height;
}
function $b7ad68fa7302cf41$var$innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $hexx7.int)(computedStyle.paddingLeft);
    width -= (0, $hexx7.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $b7ad68fa7302cf41$var$offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $b7ad68fa7302cf41$var$createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = $b7ad68fa7302cf41$var$getTranslation(controlPos, positionOffset, "px");
    return {
        [(0, $b7ad68fa7302cf41$var$_getPrefix.browserPrefixToKey)("transform", $b7ad68fa7302cf41$var$_getPrefix.default)]: translation
    };
}
function $b7ad68fa7302cf41$var$createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = $b7ad68fa7302cf41$var$getTranslation(controlPos, positionOffset, "");
    return translation;
}
function $b7ad68fa7302cf41$var$getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x: x, y: y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        const defaultX = "".concat(typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
        const defaultY = "".concat(typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function $b7ad68fa7302cf41$var$getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $hexx7.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, $hexx7.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function $b7ad68fa7302cf41$var$getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $b7ad68fa7302cf41$var$addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById("react-draggable-style-el");
    if (!styleEl) {
        styleEl = doc.createElement("style");
        styleEl.type = "text/css";
        styleEl.id = "react-draggable-style-el";
        styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
        styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
        doc.getElementsByTagName("head")[0].appendChild(styleEl);
    }
    if (doc.body) $b7ad68fa7302cf41$var$addClassName(doc.body, "react-draggable-transparent-selection");
}
function $b7ad68fa7302cf41$var$removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) $b7ad68fa7302cf41$var$removeClassName(doc.body, "react-draggable-transparent-selection");
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== "Caret") selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function $b7ad68fa7302cf41$var$addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function $b7ad68fa7302cf41$var$removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), "g"), "");
}

});
parcelRegister("hexx7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $c8bdc1749fb7e9a6$var$dontSetMe;
module.exports.findInArray = $c8bdc1749fb7e9a6$var$findInArray;
module.exports.int = $c8bdc1749fb7e9a6$var$int;
module.exports.isFunction = $c8bdc1749fb7e9a6$var$isFunction;
module.exports.isNum = $c8bdc1749fb7e9a6$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $c8bdc1749fb7e9a6$var$findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $c8bdc1749fb7e9a6$var$isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function $c8bdc1749fb7e9a6$var$isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === "number" && !isNaN(num);
}
function $c8bdc1749fb7e9a6$var$int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function $c8bdc1749fb7e9a6$var$dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

});

parcelRegister("fSZFb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $b90bbb365f19bd4e$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $b90bbb365f19bd4e$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $b90bbb365f19bd4e$var$getPrefix;
const $b90bbb365f19bd4e$var$prefixes = [
    "Moz",
    "Webkit",
    "O",
    "ms"
];
function $b90bbb365f19bd4e$var$getPrefix() /*: string*/ {
    var _window$document;
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === "undefined") return "";
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
    if (!style) return "";
    if (prop in style) return "";
    for(let i = 0; i < $b90bbb365f19bd4e$var$prefixes.length; i++){
        if ($b90bbb365f19bd4e$var$browserPrefixToKey(prop, $b90bbb365f19bd4e$var$prefixes[i]) in style) return $b90bbb365f19bd4e$var$prefixes[i];
    }
    return "";
}
function $b90bbb365f19bd4e$var$browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "".concat(prefix).concat($b90bbb365f19bd4e$var$kebabToTitleCase(prop)) : prop;
}
function $b90bbb365f19bd4e$var$browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function $b90bbb365f19bd4e$var$kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = "";
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === "-") shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $b90bbb365f19bd4e$var$_default = module.exports.default = $b90bbb365f19bd4e$var$getPrefix();

});


parcelRegister("bPRmQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $89dddac62a956586$var$canDragX;
module.exports.canDragY = $89dddac62a956586$var$canDragY;
module.exports.createCoreData = $89dddac62a956586$var$createCoreData;
module.exports.createDraggableData = $89dddac62a956586$var$createDraggableData;
module.exports.getBoundPosition = $89dddac62a956586$var$getBoundPosition;
module.exports.getControlPosition = $89dddac62a956586$var$getControlPosition;
module.exports.snapToGrid = $89dddac62a956586$var$snapToGrid;

var $hexx7 = parcelRequire("hexx7");

var $fLI2M = parcelRequire("fLI2M");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function $89dddac62a956586$var$getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === "string" ? bounds : $89dddac62a956586$var$cloneBounds(bounds);
    const node = $89dddac62a956586$var$findDOMNode(draggable);
    if (typeof bounds === "string") {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === "parent") boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $hexx7.int)(boundNodeStyle.paddingLeft) + (0, $hexx7.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $hexx7.int)(boundNodeStyle.paddingTop) + (0, $hexx7.int)(nodeStyle.marginTop),
            right: (0, $fLI2M.innerWidth)(boundNodeEl) - (0, $fLI2M.outerWidth)(node) - node.offsetLeft + (0, $hexx7.int)(boundNodeStyle.paddingRight) - (0, $hexx7.int)(nodeStyle.marginRight),
            bottom: (0, $fLI2M.innerHeight)(boundNodeEl) - (0, $fLI2M.outerHeight)(node) - node.offsetTop + (0, $hexx7.int)(boundNodeStyle.paddingBottom) - (0, $hexx7.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, $hexx7.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $hexx7.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, $hexx7.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $hexx7.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $89dddac62a956586$var$snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $89dddac62a956586$var$canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function $89dddac62a956586$var$canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "y";
}
// Get {x, y} positions from event.
function $89dddac62a956586$var$getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === "number" ? (0, $fLI2M.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === "number" && !touchObj) return null; // not the right touch
    const node = $89dddac62a956586$var$findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $fLI2M.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function $89dddac62a956586$var$createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, $hexx7.isNum)(draggable.lastX);
    const node = $89dddac62a956586$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
// Create an data exposed by <Draggable>'s events
function $89dddac62a956586$var$createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function $89dddac62a956586$var$cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $89dddac62a956586$var$findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error("<DraggableCore>: Unmounted during event!");
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("6dxC7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $486e07f846b3d0f7$var$React = $486e07f846b3d0f7$var$_interopRequireWildcard((parcelRequire("arQ7u")));

var $486e07f846b3d0f7$var$_propTypes = $486e07f846b3d0f7$var$_interopRequireDefault((parcelRequire("4Jbg8")));

var $486e07f846b3d0f7$var$_reactDom = $486e07f846b3d0f7$var$_interopRequireDefault((parcelRequire("9sDDw")));

var $fLI2M = parcelRequire("fLI2M");

var $bPRmQ = parcelRequire("bPRmQ");

var $hexx7 = parcelRequire("hexx7");

var $486e07f846b3d0f7$var$_log = $486e07f846b3d0f7$var$_interopRequireDefault((parcelRequire("grrM2")));
function $486e07f846b3d0f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $486e07f846b3d0f7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($486e07f846b3d0f7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $486e07f846b3d0f7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $486e07f846b3d0f7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $486e07f846b3d0f7$var$_defineProperty(obj, key, value) {
    key = $486e07f846b3d0f7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $486e07f846b3d0f7$var$_toPropertyKey(arg) {
    var key = $486e07f846b3d0f7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $486e07f846b3d0f7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const $486e07f846b3d0f7$var$eventsFor = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
    }
};
// Default to mouse events.
let $486e07f846b3d0f7$var$dragEventFor = $486e07f846b3d0f7$var$eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class $486e07f846b3d0f7$var$DraggableCore extends $486e07f846b3d0f7$var$React.Component /*:: <DraggableCoreProps>*/  {
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, $fLI2M.addEvent)(thisNode, $486e07f846b3d0f7$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            (0, $fLI2M.removeEvent)(ownerDocument, $486e07f846b3d0f7$var$eventsFor.mouse.move, this.handleDrag);
            (0, $fLI2M.removeEvent)(ownerDocument, $486e07f846b3d0f7$var$eventsFor.touch.move, this.handleDrag);
            (0, $fLI2M.removeEvent)(ownerDocument, $486e07f846b3d0f7$var$eventsFor.mouse.stop, this.handleDragStop);
            (0, $fLI2M.removeEvent)(ownerDocument, $486e07f846b3d0f7$var$eventsFor.touch.stop, this.handleDragStop);
            (0, $fLI2M.removeEvent)(thisNode, $486e07f846b3d0f7$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, $fLI2M.removeUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props, _this$props2;
        return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : $486e07f846b3d0f7$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $486e07f846b3d0f7$var$React.cloneElement($486e07f846b3d0f7$var$React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
    constructor(){
        super(...arguments);
        $486e07f846b3d0f7$var$_defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        $486e07f846b3d0f7$var$_defineProperty(this, "lastX", NaN);
        $486e07f846b3d0f7$var$_defineProperty(this, "lastY", NaN);
        $486e07f846b3d0f7$var$_defineProperty(this, "touchIdentifier", null);
        $486e07f846b3d0f7$var$_defineProperty(this, "mounted", false);
        $486e07f846b3d0f7$var$_defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
            const { ownerDocument: ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, $fLI2M.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, $fLI2M.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === "touchstart") e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, $fLI2M.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $bPRmQ.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x: x, y: y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, $bPRmQ.createCoreData)(this, x, y);
            (0, $486e07f846b3d0f7$var$_log.default)("DraggableCore: handleDragStart: %j", coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, $486e07f846b3d0f7$var$_log.default)("calling", this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, $fLI2M.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $fLI2M.addEvent)(ownerDocument, $486e07f846b3d0f7$var$dragEventFor.move, this.handleDrag);
            (0, $fLI2M.addEvent)(ownerDocument, $486e07f846b3d0f7$var$dragEventFor.stop, this.handleDragStop);
        });
        $486e07f846b3d0f7$var$_defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $bPRmQ.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, $bPRmQ.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $bPRmQ.createCoreData)(this, x, y);
            (0, $486e07f846b3d0f7$var$_log.default)("DraggableCore: handleDrag: %j", coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent("mouseup"));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent("MouseEvents");
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        $486e07f846b3d0f7$var$_defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, $bPRmQ.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, $bPRmQ.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $bPRmQ.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, $fLI2M.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $486e07f846b3d0f7$var$_log.default)("DraggableCore: handleDragStop: %j", coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, $486e07f846b3d0f7$var$_log.default)("DraggableCore: Removing handlers");
                (0, $fLI2M.removeEvent)(thisNode.ownerDocument, $486e07f846b3d0f7$var$dragEventFor.move, this.handleDrag);
                (0, $fLI2M.removeEvent)(thisNode.ownerDocument, $486e07f846b3d0f7$var$dragEventFor.stop, this.handleDragStop);
            }
        });
        $486e07f846b3d0f7$var$_defineProperty(this, "onMouseDown", (e)=>{
            $486e07f846b3d0f7$var$dragEventFor = $486e07f846b3d0f7$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        $486e07f846b3d0f7$var$_defineProperty(this, "onMouseUp", (e)=>{
            $486e07f846b3d0f7$var$dragEventFor = $486e07f846b3d0f7$var$eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        $486e07f846b3d0f7$var$_defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            $486e07f846b3d0f7$var$dragEventFor = $486e07f846b3d0f7$var$eventsFor.touch;
            return this.handleDragStart(e);
        });
        $486e07f846b3d0f7$var$_defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            $486e07f846b3d0f7$var$dragEventFor = $486e07f846b3d0f7$var$eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
}
module.exports.default = $486e07f846b3d0f7$var$DraggableCore;
$486e07f846b3d0f7$var$_defineProperty($486e07f846b3d0f7$var$DraggableCore, "displayName", "DraggableCore");
$486e07f846b3d0f7$var$_defineProperty($486e07f846b3d0f7$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $486e07f846b3d0f7$var$_propTypes.default.bool,
    children: $486e07f846b3d0f7$var$_propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $486e07f846b3d0f7$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $486e07f846b3d0f7$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $486e07f846b3d0f7$var$_propTypes.default.arrayOf($486e07f846b3d0f7$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $486e07f846b3d0f7$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $486e07f846b3d0f7$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $486e07f846b3d0f7$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $486e07f846b3d0f7$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $486e07f846b3d0f7$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $486e07f846b3d0f7$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $486e07f846b3d0f7$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $486e07f846b3d0f7$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $hexx7.dontSetMe,
    style: $hexx7.dontSetMe,
    transform: $hexx7.dontSetMe
});
$486e07f846b3d0f7$var$_defineProperty($486e07f846b3d0f7$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

});
parcelRegister("grrM2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf84b6420927c491$var$log;
/*eslint no-console:0*/ function $bf84b6420927c491$var$log() {}

});




parcelRegister("ILDD9", function(module, exports) {

$parcel$export(module.exports, "Resizable", function () { return $086910213d80c940$export$e82068809229c83c; });

var $arQ7u = parcelRequire("arQ7u");

var $9sDDw = parcelRequire("9sDDw");

var $g88uJ = parcelRequire("g88uJ");
var $086910213d80c940$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $086910213d80c940$var$__assign = undefined && undefined.__assign || function() {
    $086910213d80c940$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $086910213d80c940$var$__assign.apply(this, arguments);
};
var $086910213d80c940$var$DEFAULT_SIZE = {
    width: "auto",
    height: "auto"
};
var $086910213d80c940$var$clamp = function(n, min, max) {
    return Math.max(Math.min(n, max), min);
};
var $086910213d80c940$var$snap = function(n, size) {
    return Math.round(n / size) * size;
};
var $086910213d80c940$var$hasDirection = function(dir, target) {
    return new RegExp(dir, "i").test(target);
};
// INFO: In case of window is a Proxy and does not porxy Events correctly, use isTouchEvent & isMouseEvent to distinguish event type instead of `instanceof`.
var $086910213d80c940$var$isTouchEvent = function(event) {
    return Boolean(event.touches && event.touches.length);
};
var $086910213d80c940$var$isMouseEvent = function(event) {
    return Boolean((event.clientX || event.clientX === 0) && (event.clientY || event.clientY === 0));
};
var $086910213d80c940$var$findClosestSnap = function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
};
var $086910213d80c940$var$getStringSize = function(n) {
    n = n.toString();
    if (n === "auto") return n;
    if (n.endsWith("px")) return n;
    if (n.endsWith("%")) return n;
    if (n.endsWith("vh")) return n;
    if (n.endsWith("vw")) return n;
    if (n.endsWith("vmax")) return n;
    if (n.endsWith("vmin")) return n;
    return n + "px";
};
var $086910213d80c940$var$getPixelSize = function(size, parentSize, innerWidth, innerHeight) {
    if (size && typeof size === "string") {
        if (size.endsWith("px")) return Number(size.replace("px", ""));
        if (size.endsWith("%")) {
            var ratio = Number(size.replace("%", "")) / 100;
            return parentSize * ratio;
        }
        if (size.endsWith("vw")) {
            var ratio = Number(size.replace("vw", "")) / 100;
            return innerWidth * ratio;
        }
        if (size.endsWith("vh")) {
            var ratio = Number(size.replace("vh", "")) / 100;
            return innerHeight * ratio;
        }
    }
    return size;
};
var $086910213d80c940$var$calculateNewMax = function(parentSize, innerWidth, innerHeight, maxWidth, maxHeight, minWidth, minHeight) {
    maxWidth = $086910213d80c940$var$getPixelSize(maxWidth, parentSize.width, innerWidth, innerHeight);
    maxHeight = $086910213d80c940$var$getPixelSize(maxHeight, parentSize.height, innerWidth, innerHeight);
    minWidth = $086910213d80c940$var$getPixelSize(minWidth, parentSize.width, innerWidth, innerHeight);
    minHeight = $086910213d80c940$var$getPixelSize(minHeight, parentSize.height, innerWidth, innerHeight);
    return {
        maxWidth: typeof maxWidth === "undefined" ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === "undefined" ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === "undefined" ? undefined : Number(minWidth),
        minHeight: typeof minHeight === "undefined" ? undefined : Number(minHeight)
    };
};
var $086910213d80c940$var$definedProps = [
    "as",
    "style",
    "className",
    "grid",
    "snap",
    "bounds",
    "boundsByDirection",
    "size",
    "defaultSize",
    "minWidth",
    "minHeight",
    "maxWidth",
    "maxHeight",
    "lockAspectRatio",
    "lockAspectRatioExtraWidth",
    "lockAspectRatioExtraHeight",
    "enable",
    "handleStyles",
    "handleClasses",
    "handleWrapperStyle",
    "handleWrapperClass",
    "children",
    "onResizeStart",
    "onResize",
    "onResizeStop",
    "handleComponent",
    "scale",
    "resizeRatio",
    "snapGap"
];
// HACK: This class is used to calculate % size.
var $086910213d80c940$var$baseClassName = "__resizable_base__";
var $086910213d80c940$export$e82068809229c83c = /** @class */ function(_super) {
    $086910213d80c940$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableRight = 0;
        _this.resizableTop = 0;
        _this.resizableBottom = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.appendBase = function() {
            if (!_this.resizable || !_this.window) return null;
            var parent = _this.parentNode;
            if (!parent) return null;
            var element = _this.window.document.createElement("div");
            element.style.width = "100%";
            element.style.height = "100%";
            element.style.position = "absolute";
            element.style.transform = "scale(0, 0)";
            element.style.left = "0";
            element.style.flex = "0 0 100%";
            if (element.classList) element.classList.add($086910213d80c940$var$baseClassName);
            else element.className += $086910213d80c940$var$baseClassName;
            parent.appendChild(element);
            return element;
        };
        _this.removeBase = function(base) {
            var parent = _this.parentNode;
            if (!parent) return;
            parent.removeChild(base);
        };
        _this.ref = function(c) {
            if (c) _this.resizable = c;
        };
        _this.state = {
            isResizing: false,
            width: typeof (_this.propsSize && _this.propsSize.width) === "undefined" ? "auto" : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === "undefined" ? "auto" : _this.propsSize && _this.propsSize.height,
            direction: "right",
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            },
            backgroundStyle: {
                height: "100%",
                width: "100%",
                backgroundColor: "rgba(0,0,0,0)",
                cursor: "auto",
                opacity: 0,
                position: "fixed",
                zIndex: 9999,
                top: "0",
                left: "0",
                bottom: "0",
                right: "0"
            },
            flexBasis: undefined
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "window", {
        get: function() {
            if (!this.resizable) return null;
            if (!this.resizable.ownerDocument) return null;
            return this.resizable.ownerDocument.defaultView;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $086910213d80c940$var$DEFAULT_SIZE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (this.resizable && this.window) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== "relative") this.resizable.style.position = "relative";
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === "undefined" || _this.state[key] === "auto") return "auto";
                if (_this.propsSize && _this.propsSize[key] && _this.propsSize[key].toString().endsWith("%")) {
                    if (_this.state[key].toString().endsWith("%")) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace("px", ""));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $086910213d80c940$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== "undefined" && !this.state.isResizing ? $086910213d80c940$var$getStringSize(size.width) : getSize("width");
            var height = size && typeof size.height !== "undefined" && !this.state.isResizing ? $086910213d80c940$var$getStringSize(size.height) : getSize("height");
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.parentNode) {
            if (!this.window) return {
                width: 0,
                height: 0
            };
            return {
                width: this.window.innerWidth,
                height: this.window.innerHeight
            };
        }
        var base = this.appendBase();
        if (!base) return {
            width: 0,
            height: 0
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        if (wrap !== "wrap") {
            wrapChanged = true;
            this.parentNode.style.flexWrap = "wrap";
        // HACK: Use relative to get parent padding size
        }
        base.style.position = "relative";
        base.style.minWidth = "100%";
        base.style.minHeight = "100%";
        var size = {
            width: base.offsetWidth,
            height: base.offsetHeight
        };
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.removeBase(base);
        return size;
    };
    Resizable.prototype.bindEvents = function() {
        if (this.window) {
            this.window.addEventListener("mouseup", this.onMouseUp);
            this.window.addEventListener("mousemove", this.onMouseMove);
            this.window.addEventListener("mouseleave", this.onMouseUp);
            this.window.addEventListener("touchmove", this.onMouseMove, {
                capture: true,
                passive: false
            });
            this.window.addEventListener("touchend", this.onMouseUp);
        }
    };
    Resizable.prototype.unbindEvents = function() {
        if (this.window) {
            this.window.removeEventListener("mouseup", this.onMouseUp);
            this.window.removeEventListener("mousemove", this.onMouseMove);
            this.window.removeEventListener("mouseleave", this.onMouseUp);
            this.window.removeEventListener("touchmove", this.onMouseMove, true);
            this.window.removeEventListener("touchend", this.onMouseUp);
        }
    };
    Resizable.prototype.componentDidMount = function() {
        if (!this.resizable || !this.window) return;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height,
            flexBasis: computedStyle.flexBasis !== "auto" ? computedStyle.flexBasis : undefined
        });
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (this.window) this.unbindEvents();
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === "auto" && this.state.original[kind] === newSize && (typeof propsSize === "undefined" || propsSize === "auto") ? "auto" : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        var boundsByDirection = this.props.boundsByDirection;
        var direction = this.state.direction;
        var widthByDirection = boundsByDirection && $086910213d80c940$var$hasDirection("left", direction);
        var heightByDirection = boundsByDirection && $086910213d80c940$var$hasDirection("top", direction);
        var boundWidth;
        var boundHeight;
        if (this.props.bounds === "parent") {
            var parent_1 = this.parentNode;
            if (parent_1) {
                boundWidth = widthByDirection ? this.resizableRight - this.parentLeft : parent_1.offsetWidth + (this.parentLeft - this.resizableLeft);
                boundHeight = heightByDirection ? this.resizableBottom - this.parentTop : parent_1.offsetHeight + (this.parentTop - this.resizableTop);
            }
        } else if (this.props.bounds === "window") {
            if (this.window) {
                boundWidth = widthByDirection ? this.resizableRight : this.window.innerWidth - this.resizableLeft;
                boundHeight = heightByDirection ? this.resizableBottom : this.window.innerHeight - this.resizableTop;
            }
        } else if (this.props.bounds) {
            boundWidth = widthByDirection ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            boundHeight = heightByDirection ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
        }
        if (boundWidth && Number.isFinite(boundWidth)) maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
        if (boundHeight && Number.isFinite(boundHeight)) maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($086910213d80c940$var$hasDirection("right", direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($086910213d80c940$var$hasDirection("left", direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($086910213d80c940$var$hasDirection("bottom", direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($086910213d80c940$var$hasDirection("top", direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === "undefined" ? 10 : min.width;
        var computedMaxWidth = typeof max.width === "undefined" || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === "undefined" ? 10 : min.height;
        var computedMaxHeight = typeof max.height === "undefined" || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $086910213d80c940$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $086910213d80c940$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $086910213d80c940$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $086910213d80c940$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === "parent") {
            var parent_2 = this.parentNode;
            if (parent_2) {
                var parentRect = parent_2.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds && typeof this.props.bounds !== "string") {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top, right = _a.right, bottom = _a.bottom;
            this.resizableLeft = left;
            this.resizableRight = right;
            this.resizableTop = top_1;
            this.resizableBottom = bottom;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        if (!this.resizable || !this.window) return;
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent && $086910213d80c940$var$isMouseEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
        } else if (event.nativeEvent && $086910213d80c940$var$isTouchEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== "undefined" && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== "undefined" && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var flexBasis;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        if (computedStyle.flexBasis !== "auto") {
            var parent_3 = this.parentNode;
            if (parent_3) {
                var dir = this.window.getComputedStyle(parent_3).flexDirection;
                this.flexDir = dir.startsWith("row") ? "row" : "column";
                flexBasis = computedStyle.flexBasis;
            }
        }
        // For boundary
        this.setBoundingClientRect();
        this.bindEvents();
        var state = {
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            backgroundStyle: $086910213d80c940$var$__assign($086910213d80c940$var$__assign({}, this.state.backgroundStyle), {
                cursor: this.window.getComputedStyle(event.target).cursor || "auto"
            }),
            direction: direction,
            flexBasis: flexBasis
        };
        this.setState(state);
    };
    Resizable.prototype.onMouseMove = function(event) {
        var _this = this;
        if (!this.state.isResizing || !this.resizable || !this.window) return;
        if (this.window.TouchEvent && $086910213d80c940$var$isTouchEvent(event)) try {
            event.preventDefault();
            event.stopPropagation();
        } catch (e) {
        // Ignore on fail
        }
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = $086910213d80c940$var$isTouchEvent(event) ? event.touches[0].clientX : event.clientX;
        var clientY = $086910213d80c940$var$isTouchEvent(event) ? event.touches[0].clientY : event.clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $086910213d80c940$var$calculateNewMax(parentSize, this.window.innerWidth, this.window.innerHeight, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        if (this.props.snap && this.props.snap.x) newWidth = $086910213d80c940$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $086910213d80c940$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $086910213d80c940$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $086910213d80c940$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            var w = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            var h = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
            newWidth = w;
            newHeight = h;
        }
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === "string") {
            if (width.endsWith("%")) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if (width.endsWith("vw")) {
                var vw = newWidth / this.window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if (width.endsWith("vh")) {
                var vh = newWidth / this.window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === "string") {
            if (height.endsWith("%")) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if (height.endsWith("vw")) {
                var vw = newHeight / this.window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if (height.endsWith("vh")) {
                var vh = newHeight / this.window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        var newState = {
            width: this.createSizeForCssProperty(newWidth, "width"),
            height: this.createSizeForCssProperty(newHeight, "height")
        };
        if (this.flexDir === "row") newState.flexBasis = newState.width;
        else if (this.flexDir === "column") newState.flexBasis = newState.height;
        var widthChanged = this.state.width !== newState.width;
        var heightChanged = this.state.height !== newState.height;
        var flexBaseChanged = this.state.flexBasis !== newState.flexBasis;
        var changed = widthChanged || heightChanged || flexBaseChanged;
        if (changed) // For v18, update state sync
        (0, $9sDDw.flushSync)(function() {
            _this.setState(newState);
        });
        if (this.props.onResize) {
            if (changed) this.props.onResize(event, direction, this.resizable, delta);
        }
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.unbindEvents();
        this.setState({
            isResizing: false,
            backgroundStyle: $086910213d80c940$var$__assign($086910213d80c940$var$__assign({}, this.state.backgroundStyle), {
                cursor: "auto"
            })
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $arQ7u.createElement((0, $g88uJ.Resizer), {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $arQ7u.createElement("div", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($086910213d80c940$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        var style = $086910213d80c940$var$__assign($086910213d80c940$var$__assign($086910213d80c940$var$__assign({
            position: "relative",
            userSelect: this.state.isResizing ? "none" : "auto"
        }, this.props.style), this.sizeStyle), {
            maxWidth: this.props.maxWidth,
            maxHeight: this.props.maxHeight,
            minWidth: this.props.minWidth,
            minHeight: this.props.minHeight,
            boxSizing: "border-box",
            flexShrink: 0
        });
        if (this.state.flexBasis) style.flexBasis = this.state.flexBasis;
        var Wrapper = this.props.as || "div";
        return $arQ7u.createElement(Wrapper, $086910213d80c940$var$__assign({
            ref: this.ref,
            style: style,
            className: this.props.className
        }, extendsProps), this.state.isResizing && $arQ7u.createElement("div", {
            style: this.state.backgroundStyle
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        as: "div",
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($arQ7u.PureComponent);

});
parcelRegister("g88uJ", function(module, exports) {

$parcel$export(module.exports, "Resizer", function () { return $bbe3fb8e33d4ef75$export$48a76196cafe3b93; });

var $arQ7u = parcelRequire("arQ7u");
var $bbe3fb8e33d4ef75$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $bbe3fb8e33d4ef75$var$__assign = undefined && undefined.__assign || function() {
    $bbe3fb8e33d4ef75$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bbe3fb8e33d4ef75$var$__assign.apply(this, arguments);
};
var $bbe3fb8e33d4ef75$var$rowSizeBase = {
    width: "100%",
    height: "10px",
    top: "0px",
    left: "0px",
    cursor: "row-resize"
};
var $bbe3fb8e33d4ef75$var$colSizeBase = {
    width: "10px",
    height: "100%",
    top: "0px",
    left: "0px",
    cursor: "col-resize"
};
var $bbe3fb8e33d4ef75$var$edgeBase = {
    width: "20px",
    height: "20px",
    position: "absolute"
};
var $bbe3fb8e33d4ef75$var$styles = {
    top: $bbe3fb8e33d4ef75$var$__assign($bbe3fb8e33d4ef75$var$__assign({}, $bbe3fb8e33d4ef75$var$rowSizeBase), {
        top: "-5px"
    }),
    right: $bbe3fb8e33d4ef75$var$__assign($bbe3fb8e33d4ef75$var$__assign({}, $bbe3fb8e33d4ef75$var$colSizeBase), {
        left: undefined,
        right: "-5px"
    }),
    bottom: $bbe3fb8e33d4ef75$var$__assign($bbe3fb8e33d4ef75$var$__assign({}, $bbe3fb8e33d4ef75$var$rowSizeBase), {
        top: undefined,
        bottom: "-5px"
    }),
    left: $bbe3fb8e33d4ef75$var$__assign($bbe3fb8e33d4ef75$var$__assign({}, $bbe3fb8e33d4ef75$var$colSizeBase), {
        left: "-5px"
    }),
    topRight: $bbe3fb8e33d4ef75$var$__assign($bbe3fb8e33d4ef75$var$__assign({}, $bbe3fb8e33d4ef75$var$edgeBase), {
        right: "-10px",
        top: "-10px",
        cursor: "ne-resize"
    }),
    bottomRight: $bbe3fb8e33d4ef75$var$__assign($bbe3fb8e33d4ef75$var$__assign({}, $bbe3fb8e33d4ef75$var$edgeBase), {
        right: "-10px",
        bottom: "-10px",
        cursor: "se-resize"
    }),
    bottomLeft: $bbe3fb8e33d4ef75$var$__assign($bbe3fb8e33d4ef75$var$__assign({}, $bbe3fb8e33d4ef75$var$edgeBase), {
        left: "-10px",
        bottom: "-10px",
        cursor: "sw-resize"
    }),
    topLeft: $bbe3fb8e33d4ef75$var$__assign($bbe3fb8e33d4ef75$var$__assign({}, $bbe3fb8e33d4ef75$var$edgeBase), {
        left: "-10px",
        top: "-10px",
        cursor: "nw-resize"
    })
};
var $bbe3fb8e33d4ef75$export$48a76196cafe3b93 = /** @class */ function(_super) {
    $bbe3fb8e33d4ef75$var$__extends(Resizer, _super);
    function Resizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseDown = function(e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        _this.onTouchStart = function(e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        return _this;
    }
    Resizer.prototype.render = function() {
        return $arQ7u.createElement("div", {
            className: this.props.className || "",
            style: $bbe3fb8e33d4ef75$var$__assign($bbe3fb8e33d4ef75$var$__assign({
                position: "absolute",
                userSelect: "none"
            }, $bbe3fb8e33d4ef75$var$styles[this.props.direction]), this.props.replaceStyles || {}),
            onMouseDown: this.onMouseDown,
            onTouchStart: this.onTouchStart
        }, this.props.children);
    };
    return Resizer;
}($arQ7u.PureComponent);

});







parcelRegister("cYLc6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $972fb265509ba495$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $10Wbc = parcelRequire("10Wbc");

var $24Kso = parcelRequire("24Kso");
var $7GY88 = parcelRequire("7GY88");
var $1MgBx = parcelRequire("1MgBx");
var $dy9HC = parcelRequire("dy9HC");
var $9E7MS = parcelRequire("9E7MS");

var $ansoT = parcelRequire("ansoT");
/**
 * mapStateToProps - to hook up connect
 * @memberof WindowSideBarInfoPanel
 * @private
 */ var $972fb265509ba495$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, windowId = _ref.windowId;
    return {
        availableLocales: (0, $7GY88.getMetadataLocales)(state, {
            companionWindowId: id,
            windowId: windowId
        }),
        canvasIds: (0, $1MgBx.getVisibleCanvasIds)(state, {
            windowId: windowId
        }),
        collectionPath: ((0, $dy9HC.getWindow)(state, {
            windowId: windowId
        }) || {}).collectionPath,
        locale: (0, $24Kso.getCompanionWindow)(state, {
            companionWindowId: id
        }).locale || (0, $7GY88.getManifestLocale)(state, {
            windowId: windowId
        }),
        showLocalePicker: (0, $9E7MS.getWindowConfig)(state, {
            windowId: windowId
        }).showLocalePicker
    };
};
/** */ var $972fb265509ba495$var$mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
    var windowId = _ref2.windowId, id = _ref2.id;
    return {
        setLocale: function setLocale(locale) {
            return dispatch($10Wbc.updateCompanionWindow(windowId, id, {
                locale: locale
            }));
        }
    };
};
/**
 *
 * @param theme
 * @returns {label: {paddingLeft: number}}}
 */ var $972fb265509ba495$var$styles = function styles(theme) {
    return {
        section: {
            borderBottom: ".5px solid ".concat(theme.palette.section_divider),
            paddingBottom: theme.spacing(1),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(1),
            paddingTop: theme.spacing(2)
        }
    };
};
var $972fb265509ba495$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $7EzGR.default)($972fb265509ba495$var$styles), (0, $fbonu.default)($972fb265509ba495$var$mapStateToProps, $972fb265509ba495$var$mapDispatchToProps), (0, $7XHRd.withPlugins)("WindowSideBarInfoPanel"));
var $972fb265509ba495$export$2e2bcd8739ae039 = $972fb265509ba495$var$enhance((0, $ansoT.WindowSideBarInfoPanel));

});
parcelRegister("ansoT", function(module, exports) {

$parcel$export(module.exports, "WindowSideBarInfoPanel", function () { return $78e21522e5ff311e$export$a7467ec49c2b5a27; });

var $arQ7u = parcelRequire("arQ7u");

var $iXAXt = parcelRequire("iXAXt");

var $g4Fn4 = parcelRequire("g4Fn4");

var $jlZqW = parcelRequire("jlZqW");

var $uc6Q2 = parcelRequire("uc6Q2");

var $krFes = parcelRequire("krFes");

var $jS07C = parcelRequire("jS07C");

var $1xlvK = parcelRequire("1xlvK");
function $78e21522e5ff311e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $78e21522e5ff311e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $78e21522e5ff311e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $78e21522e5ff311e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $78e21522e5ff311e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $78e21522e5ff311e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $78e21522e5ff311e$var$_setPrototypeOf(subClass, superClass);
}
function $78e21522e5ff311e$var$_setPrototypeOf(o, p) {
    $78e21522e5ff311e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $78e21522e5ff311e$var$_setPrototypeOf(o, p);
}
function $78e21522e5ff311e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $78e21522e5ff311e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $78e21522e5ff311e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $78e21522e5ff311e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $78e21522e5ff311e$var$_possibleConstructorReturn(this, result);
    };
}
function $78e21522e5ff311e$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $78e21522e5ff311e$var$_assertThisInitialized(self);
}
function $78e21522e5ff311e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $78e21522e5ff311e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $78e21522e5ff311e$var$_getPrototypeOf(o) {
    $78e21522e5ff311e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $78e21522e5ff311e$var$_getPrototypeOf(o);
}
var $78e21522e5ff311e$export$a7467ec49c2b5a27 = /*#__PURE__*/ function(_Component) {
    $78e21522e5ff311e$var$_inherits(WindowSideBarInfoPanel, _Component);
    var _super = $78e21522e5ff311e$var$_createSuper(WindowSideBarInfoPanel);
    function WindowSideBarInfoPanel() {
        $78e21522e5ff311e$var$_classCallCheck(this, WindowSideBarInfoPanel);
        return _super.apply(this, arguments);
    }
    $78e21522e5ff311e$var$_createClass(WindowSideBarInfoPanel, [
        {
            key: "render",
            value: /**
     * render
     * @return
     */ function render() {
                var _this$props = this.props, windowId = _this$props.windowId, id = _this$props.id, canvasIds = _this$props.canvasIds, classes = _this$props.classes, collectionPath = _this$props.collectionPath, t = _this$props.t, locale = _this$props.locale, setLocale = _this$props.setLocale, availableLocales = _this$props.availableLocales, showLocalePicker = _this$props.showLocalePicker;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iXAXt.default), {
                    title: t("aboutThisItem"),
                    paperClassName: (0, $1xlvK.default)("window-sidebar-info-panel"),
                    windowId: windowId,
                    id: id,
                    titleControls: showLocalePicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $jlZqW.default), {
                        locale: locale,
                        setLocale: setLocale,
                        availableLocales: availableLocales
                    })
                }, canvasIds.map(function(canvasId, index) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                        key: canvasId,
                        className: classes.section
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $g4Fn4.default), {
                        id: id,
                        canvasId: canvasId,
                        index: index,
                        totalSize: canvasIds.length,
                        windowId: windowId
                    }));
                }), collectionPath.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    className: classes.section
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $krFes.default), {
                    id: id,
                    windowId: windowId
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    className: classes.section
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $uc6Q2.default), {
                    id: id,
                    windowId: windowId
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    className: classes.section
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $jS07C.default), {
                    id: id,
                    windowId: windowId
                })));
            }
        }
    ]);
    return WindowSideBarInfoPanel;
}((0, $arQ7u.Component));
$78e21522e5ff311e$export$a7467ec49c2b5a27.defaultProps = {
    availableLocales: [],
    canvasIds: [],
    classes: {},
    collectionPath: [],
    locale: "",
    setLocale: undefined,
    showLocalePicker: false,
    t: function t(key) {
        return key;
    }
};

});
parcelRegister("g4Fn4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb3d1c7aa1360c26$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7XHRd = parcelRequire("7XHRd");

var $1MgBx = parcelRequire("1MgBx");
var $7GY88 = parcelRequire("7GY88");

var $1cFhB = parcelRequire("1cFhB");
/**
 * mapStateToProps - to hook up connect
 * @memberof WindowSideBarInfoPanel
 * @private
 */ var $bb3d1c7aa1360c26$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var canvasId = _ref.canvasId, id = _ref.id, windowId = _ref.windowId;
    return {
        canvasDescription: (0, $1MgBx.getCanvasDescription)(state, {
            canvasId: canvasId,
            companionWindowId: id,
            windowId: windowId
        }),
        canvasLabel: (0, $1MgBx.getCanvasLabel)(state, {
            canvasId: canvasId,
            companionWindowId: id,
            windowId: windowId
        }),
        canvasMetadata: (0, $7GY88.getDestructuredMetadata)((0, $1MgBx.getCanvas)(state, {
            canvasId: canvasId,
            companionWindowId: id,
            windowId: windowId
        }))
    };
};
var $bb3d1c7aa1360c26$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $fbonu.default)($bb3d1c7aa1360c26$var$mapStateToProps), (0, $7XHRd.withPlugins)("CanvasInfo"));
var $bb3d1c7aa1360c26$export$2e2bcd8739ae039 = $bb3d1c7aa1360c26$var$enhance((0, $1cFhB.CanvasInfo));

});
parcelRegister("1cFhB", function(module, exports) {

$parcel$export(module.exports, "CanvasInfo", function () { return $0e06ef59c5ca4396$export$afd240e97dc80c74; });

var $arQ7u = parcelRequire("arQ7u");

var $hsH5s = parcelRequire("hsH5s");

var $ltnUe = parcelRequire("ltnUe");

var $7TK2Y = parcelRequire("7TK2Y");

var $acwox = parcelRequire("acwox");

var $lyw4f = parcelRequire("lyw4f");
function $0e06ef59c5ca4396$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0e06ef59c5ca4396$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0e06ef59c5ca4396$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0e06ef59c5ca4396$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0e06ef59c5ca4396$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $0e06ef59c5ca4396$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $0e06ef59c5ca4396$var$_setPrototypeOf(subClass, superClass);
}
function $0e06ef59c5ca4396$var$_setPrototypeOf(o, p) {
    $0e06ef59c5ca4396$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0e06ef59c5ca4396$var$_setPrototypeOf(o, p);
}
function $0e06ef59c5ca4396$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0e06ef59c5ca4396$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $0e06ef59c5ca4396$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $0e06ef59c5ca4396$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $0e06ef59c5ca4396$var$_possibleConstructorReturn(this, result);
    };
}
function $0e06ef59c5ca4396$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0e06ef59c5ca4396$var$_assertThisInitialized(self);
}
function $0e06ef59c5ca4396$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0e06ef59c5ca4396$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $0e06ef59c5ca4396$var$_getPrototypeOf(o) {
    $0e06ef59c5ca4396$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0e06ef59c5ca4396$var$_getPrototypeOf(o);
}
var $0e06ef59c5ca4396$export$afd240e97dc80c74 = /*#__PURE__*/ function(_Component) {
    $0e06ef59c5ca4396$var$_inherits(CanvasInfo, _Component);
    var _super = $0e06ef59c5ca4396$var$_createSuper(CanvasInfo);
    function CanvasInfo() {
        $0e06ef59c5ca4396$var$_classCallCheck(this, CanvasInfo);
        return _super.apply(this, arguments);
    }
    $0e06ef59c5ca4396$var$_createClass(CanvasInfo, [
        {
            key: "render",
            value: /**
     * render
     * @return
     */ function render() {
                var _this$props = this.props, canvasDescription = _this$props.canvasDescription, canvasLabel = _this$props.canvasLabel, canvasMetadata = _this$props.canvasMetadata, id = _this$props.id, index = _this$props.index, t = _this$props.t, totalSize = _this$props.totalSize;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $ltnUe.default), {
                    id: "".concat(id, "-currentItem-").concat(index),
                    label: t("currentItem", {
                        context: "".concat(index + 1, "/").concat(totalSize)
                    })
                }, canvasLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    "aria-labelledby": "".concat(id, "-currentItem-").concat(index, " ").concat(id, "-currentItem-").concat(index, "-heading"),
                    id: "".concat(id, "-currentItem-").concat(index, "-heading"),
                    variant: "h4",
                    component: "h5"
                }, canvasLabel), canvasDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "body1"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7TK2Y.default), {
                    htmlString: canvasDescription,
                    ruleSet: "iiif"
                })), canvasMetadata && canvasMetadata.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $acwox.LabelValueMetadata), {
                    labelValuePairs: canvasMetadata
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $lyw4f.PluginHook), this.props));
            }
        }
    ]);
    return CanvasInfo;
}((0, $arQ7u.Component));
$0e06ef59c5ca4396$export$afd240e97dc80c74.defaultProps = {
    canvasDescription: null,
    canvasLabel: null,
    canvasMetadata: [],
    index: 1,
    t: function t(key) {
        return key;
    },
    totalSize: 1
};

});
parcelRegister("ltnUe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa1ed99c712002fa$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $6oVoy = parcelRequire("6oVoy");
var $fa1ed99c712002fa$var$styles = {
    button: {
        padding: 0
    },
    container: {
        display: "flex",
        justifyContent: "space-between"
    },
    heading: {
        cursor: "pointer"
    }
};
var $fa1ed99c712002fa$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $7EzGR.default)($fa1ed99c712002fa$var$styles));
var $fa1ed99c712002fa$export$2e2bcd8739ae039 = $fa1ed99c712002fa$var$enhance((0, $6oVoy.CollapsibleSection));

});
parcelRegister("6oVoy", function(module, exports) {

$parcel$export(module.exports, "CollapsibleSection", function () { return $4a9181728ad3d719$export$55b973e094275b13; });

var $arQ7u = parcelRequire("arQ7u");

var $hsH5s = parcelRequire("hsH5s");

var $3vCp3 = parcelRequire("3vCp3");

var $kSHzR = parcelRequire("kSHzR");

var $029Oc = parcelRequire("029Oc");
function $4a9181728ad3d719$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4a9181728ad3d719$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4a9181728ad3d719$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4a9181728ad3d719$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4a9181728ad3d719$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4a9181728ad3d719$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $4a9181728ad3d719$var$_setPrototypeOf(subClass, superClass);
}
function $4a9181728ad3d719$var$_setPrototypeOf(o, p) {
    $4a9181728ad3d719$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4a9181728ad3d719$var$_setPrototypeOf(o, p);
}
function $4a9181728ad3d719$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4a9181728ad3d719$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4a9181728ad3d719$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4a9181728ad3d719$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4a9181728ad3d719$var$_possibleConstructorReturn(this, result);
    };
}
function $4a9181728ad3d719$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4a9181728ad3d719$var$_assertThisInitialized(self);
}
function $4a9181728ad3d719$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4a9181728ad3d719$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4a9181728ad3d719$var$_getPrototypeOf(o) {
    $4a9181728ad3d719$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4a9181728ad3d719$var$_getPrototypeOf(o);
}
var $4a9181728ad3d719$export$55b973e094275b13 = /*#__PURE__*/ function(_Component) {
    $4a9181728ad3d719$var$_inherits(CollapsibleSection, _Component);
    var _super = $4a9181728ad3d719$var$_createSuper(CollapsibleSection);
    /** */ function CollapsibleSection(props) {
        var _this;
        $4a9181728ad3d719$var$_classCallCheck(this, CollapsibleSection);
        _this = _super.call(this, props);
        _this.state = {
            open: true
        };
        _this.toggleSection = _this.toggleSection.bind($4a9181728ad3d719$var$_assertThisInitialized(_this));
        return _this;
    }
    /** */ $4a9181728ad3d719$var$_createClass(CollapsibleSection, [
        {
            key: "toggleSection",
            value: function toggleSection() {
                var open = this.state.open;
                this.setState({
                    open: !open
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, classes = _this$props.classes, id = _this$props.id, label = _this$props.label, t = _this$props.t;
                var open = this.state.open;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    className: classes.container
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    className: classes.heading,
                    id: id,
                    onClick: this.toggleSection,
                    variant: "overline",
                    component: "h4"
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $029Oc.default), {
                    "aria-label": t(open ? "collapseSection" : "expandSection", {
                        section: label
                    }),
                    "aria-expanded": open,
                    className: classes.button,
                    onClick: this.toggleSection
                }, open ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kSHzR))), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3vCp3))), null))), open && children);
            }
        }
    ]);
    return CollapsibleSection;
}((0, $arQ7u.Component));

});
parcelRegister("3vCp3", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28e20e690380a658$var$React = $363GR((parcelRequire("arQ7u")));

var $28e20e690380a658$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $28e20e690380a658$var$_default = (0, $28e20e690380a658$var$_createSvgIcon.default)(/*#__PURE__*/ $28e20e690380a658$var$React.createElement("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), "KeyboardArrowDownSharp");
module.exports.default = $28e20e690380a658$var$_default;

});

parcelRegister("kSHzR", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f33aa75b67caf911$var$React = $363GR((parcelRequire("arQ7u")));

var $f33aa75b67caf911$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $f33aa75b67caf911$var$_default = (0, $f33aa75b67caf911$var$_createSvgIcon.default)(/*#__PURE__*/ $f33aa75b67caf911$var$React.createElement("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
}), "KeyboardArrowUpSharp");
module.exports.default = $f33aa75b67caf911$var$_default;

});



parcelRegister("acwox", function(module, exports) {

$parcel$export(module.exports, "LabelValueMetadata", function () { return $76d4274b0121b841$export$1440d7938dde4692; });

var $arQ7u = parcelRequire("arQ7u");

var $hsH5s = parcelRequire("hsH5s");

var $7TK2Y = parcelRequire("7TK2Y");

var $1xlvK = parcelRequire("1xlvK");
function $76d4274b0121b841$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $76d4274b0121b841$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $76d4274b0121b841$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $76d4274b0121b841$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $76d4274b0121b841$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $76d4274b0121b841$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $76d4274b0121b841$var$_setPrototypeOf(subClass, superClass);
}
function $76d4274b0121b841$var$_setPrototypeOf(o, p) {
    $76d4274b0121b841$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $76d4274b0121b841$var$_setPrototypeOf(o, p);
}
function $76d4274b0121b841$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $76d4274b0121b841$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $76d4274b0121b841$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $76d4274b0121b841$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $76d4274b0121b841$var$_possibleConstructorReturn(this, result);
    };
}
function $76d4274b0121b841$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $76d4274b0121b841$var$_assertThisInitialized(self);
}
function $76d4274b0121b841$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $76d4274b0121b841$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $76d4274b0121b841$var$_getPrototypeOf(o) {
    $76d4274b0121b841$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $76d4274b0121b841$var$_getPrototypeOf(o);
}
var $76d4274b0121b841$export$1440d7938dde4692 = /*#__PURE__*/ function(_Component) {
    $76d4274b0121b841$var$_inherits(LabelValueMetadata, _Component);
    var _super = $76d4274b0121b841$var$_createSuper(LabelValueMetadata);
    function LabelValueMetadata() {
        $76d4274b0121b841$var$_classCallCheck(this, LabelValueMetadata);
        return _super.apply(this, arguments);
    }
    $76d4274b0121b841$var$_createClass(LabelValueMetadata, [
        {
            key: "render",
            value: /**
     * render
     * @return {String} - HTML markup for the component
     */ function render() {
                var _this$props = this.props, defaultLabel = _this$props.defaultLabel, labelValuePairs = _this$props.labelValuePairs;
                if (labelValuePairs.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null);
                /* eslint-disable react/no-array-index-key */ // Disabling array index key for dt/dd elements as
                // they are intended to display metadata that will not
                // need to be re-rendered internally in any meaningful way
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("dl", {
                    className: (0, $1xlvK.default)("label-value-metadata")
                }, labelValuePairs.reduce(function(acc, labelValuePair, i) {
                    return acc.concat([
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                            component: "dt",
                            key: "label-".concat(i),
                            variant: "subtitle2"
                        }, labelValuePair.label || defaultLabel),
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                            style: {
                                marginBottom: ".5em",
                                marginLeft: "0px"
                            },
                            component: "dd",
                            key: "value-".concat(i),
                            variant: "body1"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7TK2Y.default), {
                            htmlString: labelValuePair.values.join(", "),
                            ruleSet: "iiif"
                        }))
                    ]);
                }, []));
            /* eslint-enable react/no-array-index-key */ }
        }
    ]);
    return LabelValueMetadata;
}((0, $arQ7u.Component));
$76d4274b0121b841$export$1440d7938dde4692.defaultProps = {
    defaultLabel: undefined
};

});

parcelRegister("lyw4f", function(module, exports) {

$parcel$export(module.exports, "PluginHook", function () { return $fb15a5e1339ce158$export$449ace64bf040744; });

var $arQ7u = parcelRequire("arQ7u");
var $fb15a5e1339ce158$var$_excluded = [
    "classes"
];
function $fb15a5e1339ce158$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fb15a5e1339ce158$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $fb15a5e1339ce158$var$ownKeys(Object(source), true).forEach(function(key) {
            $fb15a5e1339ce158$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $fb15a5e1339ce158$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fb15a5e1339ce158$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fb15a5e1339ce158$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fb15a5e1339ce158$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fb15a5e1339ce158$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fb15a5e1339ce158$export$449ace64bf040744 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).forwardRef(function(props, ref) {
    var PluginComponents = props.PluginComponents; // eslint-disable-line react/prop-types
    var classes = props.classes, otherProps = $fb15a5e1339ce158$var$_objectWithoutProperties(props, $fb15a5e1339ce158$var$_excluded); // eslint-disable-line react/prop-types
    return PluginComponents ? PluginComponents.map(function(PluginComponent, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).isValidElement(PluginComponent) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).cloneElement(PluginComponent, $fb15a5e1339ce158$var$_objectSpread($fb15a5e1339ce158$var$_objectSpread({}, otherProps), {}, {
            ref: ref
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(PluginComponent, Object.assign({
            ref: ref
        }, otherProps, {
            key: index // eslint-disable-line react/no-array-index-key
        }));
    }) : null;
});

});



parcelRegister("jlZqW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e16fa1e1c138ff2e$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $cRGxp = parcelRequire("cRGxp");
/**
 *
 * @param theme
 * @returns {label: {paddingLeft: number}}}
 */ var $e16fa1e1c138ff2e$var$styles = function styles(theme) {
    return {
        select: {
            "&:focus": {
                backgroundColor: theme.palette.background.paper
            }
        },
        selectEmpty: {
            backgroundColor: theme.palette.background.paper
        }
    };
};
var $e16fa1e1c138ff2e$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $7EzGR.default)($e16fa1e1c138ff2e$var$styles));
var $e16fa1e1c138ff2e$export$2e2bcd8739ae039 = $e16fa1e1c138ff2e$var$enhance((0, $cRGxp.LocalePicker));

});
parcelRegister("cRGxp", function(module, exports) {

$parcel$export(module.exports, "LocalePicker", function () { return $95db6e6412cc7932$export$3170d3214a55335c; });

var $arQ7u = parcelRequire("arQ7u");

var $2NDUy = parcelRequire("2NDUy");

var $f3WEt = parcelRequire("f3WEt");

var $c6RGo = parcelRequire("c6RGo");

var $hsH5s = parcelRequire("hsH5s");
function $95db6e6412cc7932$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $95db6e6412cc7932$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $95db6e6412cc7932$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $95db6e6412cc7932$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $95db6e6412cc7932$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $95db6e6412cc7932$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $95db6e6412cc7932$var$_setPrototypeOf(subClass, superClass);
}
function $95db6e6412cc7932$var$_setPrototypeOf(o, p) {
    $95db6e6412cc7932$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $95db6e6412cc7932$var$_setPrototypeOf(o, p);
}
function $95db6e6412cc7932$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $95db6e6412cc7932$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $95db6e6412cc7932$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $95db6e6412cc7932$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $95db6e6412cc7932$var$_possibleConstructorReturn(this, result);
    };
}
function $95db6e6412cc7932$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $95db6e6412cc7932$var$_assertThisInitialized(self);
}
function $95db6e6412cc7932$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $95db6e6412cc7932$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $95db6e6412cc7932$var$_getPrototypeOf(o) {
    $95db6e6412cc7932$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $95db6e6412cc7932$var$_getPrototypeOf(o);
}
var $95db6e6412cc7932$export$3170d3214a55335c = /*#__PURE__*/ function(_Component) {
    $95db6e6412cc7932$var$_inherits(LocalePicker, _Component);
    var _super = $95db6e6412cc7932$var$_createSuper(LocalePicker);
    function LocalePicker() {
        $95db6e6412cc7932$var$_classCallCheck(this, LocalePicker);
        return _super.apply(this, arguments);
    }
    $95db6e6412cc7932$var$_createClass(LocalePicker, [
        {
            key: "render",
            value: /**
     * render
     * @return
     */ function render() {
                var _this$props = this.props, availableLocales = _this$props.availableLocales, classes = _this$props.classes, locale = _this$props.locale, setLocale = _this$props.setLocale;
                if (!setLocale || availableLocales.length < 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $f3WEt.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $c6RGo.default), {
                    MenuProps: {
                        anchorOrigin: {
                            horizontal: "left",
                            vertical: "bottom"
                        },
                        getContentAnchorEl: null
                    },
                    displayEmpty: true,
                    value: locale,
                    onChange: function onChange(e) {
                        setLocale(e.target.value);
                    },
                    name: "locale",
                    classes: {
                        select: classes.select
                    },
                    className: classes.selectEmpty
                }, availableLocales.map(function(l) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $2NDUy.default), {
                        key: l,
                        value: l
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                        variant: "body2"
                    }, l));
                })));
            }
        }
    ]);
    return LocalePicker;
}((0, $arQ7u.Component));
$95db6e6412cc7932$export$3170d3214a55335c.defaultProps = {
    availableLocales: [],
    classes: {},
    locale: "",
    setLocale: undefined
};

});
parcelRegister("f3WEt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af74a1decf7e6830$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $gynfe = parcelRequire("gynfe");

var $7EzGR = parcelRequire("7EzGR");

var $kaLUp = parcelRequire("kaLUp");

var $jOGar = parcelRequire("jOGar");

var $jzox3 = parcelRequire("jzox3");
var $af74a1decf7e6830$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top" // Fix alignment issue on Safari.
    },
    /* Styles applied to the root element if `margin="normal"`. */ marginNormal: {
        marginTop: 16,
        marginBottom: 8
    },
    /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
        marginTop: 8,
        marginBottom: 4
    },
    /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
        width: "100%"
    }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */ var $af74a1decf7e6830$var$FormControl = /*#__PURE__*/ $arQ7u.forwardRef(function FormControl(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, visuallyFocused = props.focused, _props$hiddenLabel = props.hiddenLabel, hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel, _props$margin = props.margin, margin = _props$margin === void 0 ? "none" : _props$margin, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, size = props.size, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "fullWidth",
        "focused",
        "hiddenLabel",
        "margin",
        "required",
        "size",
        "variant"
    ]);
    var _React$useState = $arQ7u.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) $arQ7u.Children.forEach(children, function(child) {
            if (!(0, $jOGar.default)(child, [
                "Input",
                "Select"
            ])) return;
            var input = (0, $jOGar.default)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $gynfe.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    }), adornedStart = _React$useState[0], setAdornedStart = _React$useState[1];
    var _React$useState2 = $arQ7u.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) $arQ7u.Children.forEach(children, function(child) {
            if (!(0, $jOGar.default)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $gynfe.isFilled)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    }), filled = _React$useState2[0], setFilled = _React$useState2[1];
    var _React$useState3 = $arQ7u.useState(false), _focused = _React$useState3[0], setFocused = _React$useState3[1];
    var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
    if (disabled && focused) setFocused(false);
    var registerEffect;
    var registeredInput;
    var onFilled = $arQ7u.useCallback(function() {
        setFilled(true);
    }, []);
    var onEmpty = $arQ7u.useCallback(function() {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: (size === "small" ? "dense" : undefined) || margin,
        onBlur: function onBlur() {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function onFocus() {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ $arQ7u.createElement((0, $jzox3.default).Provider, {
        value: childContext
    }, /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, margin !== "none" && classes["margin".concat((0, $kaLUp.default)(margin))], fullWidth && classes.fullWidth),
        ref: ref
    }, other), children));
});
var $af74a1decf7e6830$export$2e2bcd8739ae039 = (0, $7EzGR.default)($af74a1decf7e6830$export$9dd6ff9ea0189349, {
    name: "MuiFormControl"
})($af74a1decf7e6830$var$FormControl);

});
parcelRegister("gynfe", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $c0d1da334bfd9594$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $c0d1da334bfd9594$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $c0d1da334bfd9594$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $c0d1da334bfd9594$export$d652b828d7fdeff8(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return obj && ($c0d1da334bfd9594$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $c0d1da334bfd9594$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
} // Determine if an Input is adorned on start.
function $c0d1da334bfd9594$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("jzox3", function(module, exports) {

$parcel$export(module.exports, "useFormControl", function () { return $e3f450c8c3b898a1$export$62ecd8ad1bbe1a18; });
$parcel$export(module.exports, "default", function () { return $e3f450c8c3b898a1$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");
/**
 * @ignore - internal component.
 */ var $e3f450c8c3b898a1$var$FormControlContext = $arQ7u.createContext();
function $e3f450c8c3b898a1$export$62ecd8ad1bbe1a18() {
    return $arQ7u.useContext($e3f450c8c3b898a1$var$FormControlContext);
}
var $e3f450c8c3b898a1$export$2e2bcd8739ae039 = $e3f450c8c3b898a1$var$FormControlContext;

});


parcelRegister("c6RGo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d0fafd3fe590d9a$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $s3KLs = parcelRequire("s3KLs");

var $bO51I = parcelRequire("bO51I");

var $tTTvC = parcelRequire("tTTvC");

var $6cXJA = parcelRequire("6cXJA");

var $7EzGR = parcelRequire("7EzGR");

var $6v4nJ = parcelRequire("6v4nJ");

var $iwnYb = parcelRequire("iwnYb");

var $3H36o = parcelRequire("3H36o");

var $9IYfE = parcelRequire("9IYfE");

var $ajiku = parcelRequire("ajiku");

var $8h9eG = parcelRequire("8h9eG");
var $8d0fafd3fe590d9a$export$9dd6ff9ea0189349 = (0, $3H36o.styles);
var $8d0fafd3fe590d9a$var$_ref = /*#__PURE__*/ $arQ7u.createElement((0, $iwnYb.default), null);
var $8d0fafd3fe590d9a$var$_ref2 = /*#__PURE__*/ $arQ7u.createElement((0, $ajiku.default), null);
var $8d0fafd3fe590d9a$var$Select = /*#__PURE__*/ $arQ7u.forwardRef(function Select(props, ref) {
    var _props$autoWidth = props.autoWidth, autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth, children = props.children, classes = props.classes, _props$displayEmpty = props.displayEmpty, displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $6v4nJ.default) : _props$IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, MenuProps = props.MenuProps, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$native = props.native, native = _props$native === void 0 ? false : _props$native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, _props$variant = props.variant, variantProps = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $dXEVX.default)(props, [
        "autoWidth",
        "children",
        "classes",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "labelWidth",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant"
    ]);
    var inputComponent = native ? (0, $9IYfE.default) : (0, $bO51I.default);
    var muiFormControl = (0, $6cXJA.default)();
    var fcs = (0, $tTTvC.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    var variant = fcs.variant || variantProps;
    var InputComponent = input || ({
        standard: $8d0fafd3fe590d9a$var$_ref,
        outlined: /*#__PURE__*/ $arQ7u.createElement((0, $8h9eG.default), {
            label: label,
            labelWidth: labelWidth
        }),
        filled: $8d0fafd3fe590d9a$var$_ref2
    })[variant];
    return /*#__PURE__*/ $arQ7u.cloneElement(InputComponent, (0, $abElG.default)({
        // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: inputComponent,
        inputProps: (0, $abElG.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            // We render a select. We can ignore the type provided by the `Input`.
            multiple: multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $abElG.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $s3KLs.default)({
                baseClasses: classes,
                newClasses: inputProps.classes,
                Component: Select
            }) : classes
        }, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$8d0fafd3fe590d9a$var$Select.muiName = "Select";
var $8d0fafd3fe590d9a$export$2e2bcd8739ae039 = (0, $7EzGR.default)($8d0fafd3fe590d9a$export$9dd6ff9ea0189349, {
    name: "MuiSelect"
})($8d0fafd3fe590d9a$var$Select);

});
parcelRegister("bO51I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0237e00e1d6eae0d$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $kMfvj = parcelRequire("kMfvj");

var $dXEVX = parcelRequire("dXEVX");

var $7Dbhg = parcelRequire("7Dbhg");

var $eQGDD = parcelRequire("eQGDD");

var $arQ7u = parcelRequire("arQ7u");
parcelRequire("legPH");


var $5g55B = parcelRequire("5g55B");

var $5Yg7t = parcelRequire("5Yg7t");

var $kaLUp = parcelRequire("kaLUp");

var $cAKaz = parcelRequire("cAKaz");

var $gynfe = parcelRequire("gynfe");

var $nGnd5 = parcelRequire("nGnd5");

var $lhLsx = parcelRequire("lhLsx");
function $0237e00e1d6eae0d$var$areEqualValues(a, b) {
    if ((0, $7Dbhg.default)(b) === "object" && b !== null) return a === b;
    return String(a) === String(b);
}
function $0237e00e1d6eae0d$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
/**
 * @ignore - internal component.
 */ var $0237e00e1d6eae0d$var$SelectInput = /*#__PURE__*/ $arQ7u.forwardRef(function SelectInput(props, ref) {
    var ariaLabel = props["aria-label"], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, classes = props.classes, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props$MenuProps = props.MenuProps, MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props$SelectDisplayP = props.SelectDisplayProps, SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP, tabIndexProp = props.tabIndex, type = props.type, valueProp = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $dXEVX.default)(props, [
        "aria-label",
        "autoFocus",
        "autoWidth",
        "children",
        "classes",
        "className",
        "defaultValue",
        "disabled",
        "displayEmpty",
        "IconComponent",
        "inputRef",
        "labelId",
        "MenuProps",
        "multiple",
        "name",
        "onBlur",
        "onChange",
        "onClose",
        "onFocus",
        "onOpen",
        "open",
        "readOnly",
        "renderValue",
        "SelectDisplayProps",
        "tabIndex",
        "type",
        "value",
        "variant"
    ]);
    var _useControlled = (0, $lhLsx.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    }), _useControlled2 = (0, $kMfvj.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var inputRef = $arQ7u.useRef(null);
    var _React$useState = $arQ7u.useState(null), displayNode = _React$useState[0], setDisplayNode = _React$useState[1];
    var _React$useRef = $arQ7u.useRef(openProp != null), isOpenControlled = _React$useRef.current;
    var _React$useState2 = $arQ7u.useState(), menuMinWidthState = _React$useState2[0], setMenuMinWidthState = _React$useState2[1];
    var _React$useState3 = $arQ7u.useState(false), openState = _React$useState3[0], setOpenState = _React$useState3[1];
    var handleRef = (0, $nGnd5.default)(ref, inputRefProp);
    $arQ7u.useImperativeHandle(handleRef, function() {
        return {
            focus: function focus() {
                displayNode.focus();
            },
            node: inputRef.current,
            value: value
        };
    }, [
        displayNode,
        value
    ]);
    $arQ7u.useEffect(function() {
        if (autoFocus && displayNode) displayNode.focus();
    }, [
        autoFocus,
        displayNode
    ]);
    $arQ7u.useEffect(function() {
        if (displayNode) {
            var label = (0, $5Yg7t.default)(displayNode).getElementById(labelId);
            if (label) {
                var handler = function handler() {
                    if (getSelection().isCollapsed) displayNode.focus();
                };
                label.addEventListener("click", handler);
                return function() {
                    label.removeEventListener("click", handler);
                };
            }
        }
        return undefined;
    }, [
        labelId,
        displayNode
    ]);
    var update = function update(open, event) {
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function handleMouseDown(event) {
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayNode.focus();
        update(true, event);
    };
    var handleClose = function handleClose(event) {
        update(false, event);
    };
    var childrenArray = $arQ7u.Children.toArray(children); // Support autofill.
    var handleChange = function handleChange(event) {
        var index = childrenArray.map(function(child) {
            return child.props.value;
        }).indexOf(event.target.value);
        if (index === -1) return;
        var child = childrenArray[index];
        setValue(child.props.value);
        if (onChange) onChange(event, child);
    };
    var handleItemClick = function handleItemClick(child) {
        return function(event) {
            if (!multiple) update(false, event);
            var newValue;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                var itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value === newValue) return;
            setValue(newValue);
            if (onChange) {
                event.persist(); // Preact support, target is read only property on a native event.
                Object.defineProperty(event, "target", {
                    writable: true,
                    value: {
                        value: newValue,
                        name: name
                    }
                });
                onChange(event, child);
            }
        };
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (!readOnly) {
            var validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && (isOpenControlled ? openProp : openState);
    var handleBlur = function handleBlur(event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            event.persist(); // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $gynfe.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    var items = childrenArray.map(function(child) {
        if (!/*#__PURE__*/ $arQ7u.isValidElement(child)) return null;
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $eQGDD.default)(2));
            selected = value.some(function(v) {
                return $0237e00e1d6eae0d$var$areEqualValues(v, child.props.value);
            });
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $0237e00e1d6eae0d$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $arQ7u.cloneElement(child, {
            "aria-selected": selected ? "true" : undefined,
            onClick: handleItemClick(child),
            onKeyUp: function onKeyUp(event) {
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    if (computeDisplay) display = multiple ? displayMultiple.join(", ") : displaySingle;
     // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    var tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
    return /*#__PURE__*/ $arQ7u.createElement($arQ7u.Fragment, null, /*#__PURE__*/ $arQ7u.createElement("div", (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
        ref: setDisplayNode,
        tabIndex: tabIndex,
        role: "button",
        "aria-disabled": disabled ? "true" : undefined,
        "aria-expanded": open ? "true" : undefined,
        "aria-haspopup": "listbox",
        "aria-label": ariaLabel,
        "aria-labelledby": [
            labelId,
            buttonId
        ].filter(Boolean).join(" ") || undefined,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
    }, SelectDisplayProps, {
        // The id is required for proper a11y
        id: buttonId
    }), $0237e00e1d6eae0d$var$isEmpty(display) ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $arQ7u.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    }) : display), /*#__PURE__*/ $arQ7u.createElement("input", (0, $abElG.default)({
        value: Array.isArray(value) ? value.join(",") : value,
        name: name,
        ref: inputRef,
        "aria-hidden": true,
        onChange: handleChange,
        tabIndex: -1,
        className: classes.nativeInput,
        autoFocus: autoFocus
    }, other)), /*#__PURE__*/ $arQ7u.createElement(IconComponent, {
        className: (0, $5g55B.default)(classes.icon, classes["icon".concat((0, $kaLUp.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
    }), /*#__PURE__*/ $arQ7u.createElement((0, $cAKaz.default), (0, $abElG.default)({
        id: "menu-".concat(name || ""),
        anchorEl: displayNode,
        open: open,
        onClose: handleClose
    }, MenuProps, {
        MenuListProps: (0, $abElG.default)({
            "aria-labelledby": labelId,
            role: "listbox",
            disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: (0, $abElG.default)({}, MenuProps.PaperProps, {
            style: (0, $abElG.default)({
                minWidth: menuMinWidth
            }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
    }), items));
});
var $0237e00e1d6eae0d$export$2e2bcd8739ae039 = $0237e00e1d6eae0d$var$SelectInput;

});
parcelRegister("cAKaz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92aca91d2ef9958a$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");
parcelRequire("legPH");


var $5g55B = parcelRequire("5g55B");


var $7EzGR = parcelRequire("7EzGR");

var $bi2qn = parcelRequire("bi2qn");

var $6lUyS = parcelRequire("6lUyS");

var $9sDDw = parcelRequire("9sDDw");

var $KZePB = parcelRequire("KZePB");

var $j1k3T = parcelRequire("j1k3T");

var $92aca91d2ef9958a$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
var $92aca91d2ef9958a$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
var $92aca91d2ef9958a$export$9dd6ff9ea0189349 = {
    /* Styles applied to the `Paper` component. */ paper: {
        // specZ: The maximum height of a simple menu should be one or more rows less than the view
        // height. This ensures a tapable area outside of the simple menu with which to dismiss
        // the menu.
        maxHeight: "calc(100% - 96px)",
        // Add iOS momentum scrolling.
        WebkitOverflowScrolling: "touch"
    },
    /* Styles applied to the `List` component via `MenuList`. */ list: {
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $92aca91d2ef9958a$var$Menu = /*#__PURE__*/ $arQ7u.forwardRef(function Menu(props, ref) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, children = props.children, classes = props.classes, _props$disableAutoFoc = props.disableAutoFocusItem, disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$MenuListProps = props.MenuListProps, MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps, onClose = props.onClose, onEnteringProp = props.onEntering, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, PopoverClasses = props.PopoverClasses, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps;
    _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;
    var onEntering = _props$TransitionProp.onEntering, TransitionProps = (0, $dXEVX.default)(_props$TransitionProp, [
        "onEntering"
    ]), _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0, $dXEVX.default)(props, [
        "autoFocus",
        "children",
        "classes",
        "disableAutoFocusItem",
        "MenuListProps",
        "onClose",
        "onEntering",
        "open",
        "PaperProps",
        "PopoverClasses",
        "transitionDuration",
        "TransitionProps",
        "variant"
    ]);
    var theme = (0, $j1k3T.default)();
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = $arQ7u.useRef(null);
    var contentAnchorRef = $arQ7u.useRef(null);
    var getContentAnchorEl = function getContentAnchorEl() {
        return contentAnchorRef.current;
    };
    var handleEntering = function handleEntering(element, isAppearing) {
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEnteringProp) onEnteringProp(element, isAppearing);
        if (onEntering) onEntering(element, isAppearing);
    };
    var handleListKeyDown = function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $arQ7u.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ $arQ7u.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant !== "menu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $arQ7u.Children.map(children, function(child, index) {
        if (index === activeItemIndex) return /*#__PURE__*/ $arQ7u.cloneElement(child, {
            ref: function ref(instance) {
                // #StrictMode ready
                contentAnchorRef.current = $9sDDw.findDOMNode(instance);
                (0, $KZePB.default)(child.ref, instance);
            }
        });
        return child;
    });
    return /*#__PURE__*/ $arQ7u.createElement((0, $bi2qn.default), (0, $abElG.default)({
        getContentAnchorEl: getContentAnchorEl,
        classes: PopoverClasses,
        onClose: onClose,
        TransitionProps: (0, $abElG.default)({
            onEntering: handleEntering
        }, TransitionProps),
        anchorOrigin: theme.direction === "rtl" ? $92aca91d2ef9958a$var$RTL_ORIGIN : $92aca91d2ef9958a$var$LTR_ORIGIN,
        transformOrigin: theme.direction === "rtl" ? $92aca91d2ef9958a$var$RTL_ORIGIN : $92aca91d2ef9958a$var$LTR_ORIGIN,
        PaperProps: (0, $abElG.default)({}, PaperProps, {
            classes: (0, $abElG.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        open: open,
        ref: ref,
        transitionDuration: transitionDuration
    }, other), /*#__PURE__*/ $arQ7u.createElement((0, $6lUyS.default), (0, $abElG.default)({
        onKeyDown: handleListKeyDown,
        actions: menuListActionsRef,
        autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
        autoFocusItem: autoFocusItem,
        variant: variant
    }, MenuListProps, {
        className: (0, $5g55B.default)(classes.list, MenuListProps.className)
    }), items));
});
var $92aca91d2ef9958a$export$2e2bcd8739ae039 = (0, $7EzGR.default)($92aca91d2ef9958a$export$9dd6ff9ea0189349, {
    name: "MuiMenu"
})($92aca91d2ef9958a$var$Menu);

});
parcelRegister("bi2qn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83834193d766a8b6$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $9sDDw = parcelRequire("9sDDw");


var $iEYEM = parcelRequire("iEYEM");

var $5g55B = parcelRequire("5g55B");

var $5Yg7t = parcelRequire("5Yg7t");

var $eUmzP = parcelRequire("eUmzP");

var $1S9Kw = parcelRequire("1S9Kw");


var $7EzGR = parcelRequire("7EzGR");

var $kuaAd = parcelRequire("kuaAd");

var $5fs1a = parcelRequire("5fs1a");

var $3f9WU = parcelRequire("3f9WU");
function $83834193d766a8b6$export$6fcff0dc60346367(rect, vertical) {
    var offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $83834193d766a8b6$export$a6a488ff68b1bf7b(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $83834193d766a8b6$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map(function(n) {
        return typeof n === "number" ? "".concat(n, "px") : n;
    }).join(" ");
} // Sum the scrollTop between two elements.
function $83834193d766a8b6$var$getScrollParent(parent, child) {
    var element = child;
    var scrollTop = 0;
    while(element && element !== parent){
        element = element.parentElement;
        scrollTop += element.scrollTop;
    }
    return scrollTop;
}
function $83834193d766a8b6$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
var $83834193d766a8b6$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the `Paper` component. */ paper: {
        position: "absolute",
        overflowY: "auto",
        overflowX: "hidden",
        // So we see the popover when it's empty.
        // It's most likely on issue on userland.
        minWidth: 16,
        minHeight: 16,
        maxWidth: "calc(100% - 32px)",
        maxHeight: "calc(100% - 32px)",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $83834193d766a8b6$var$Popover = /*#__PURE__*/ $arQ7u.forwardRef(function Popover(props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props$anchorOrigin, anchorPosition = props.anchorPosition, _props$anchorReferenc = props.anchorReference, anchorReference = _props$anchorReferenc === void 0 ? "anchorEl" : _props$anchorReferenc, children = props.children, classes = props.classes, className = props.className, containerProp = props.container, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 8 : _props$elevation, getContentAnchorEl = props.getContentAnchorEl, _props$marginThreshol = props.marginThreshold, marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$transformOrigi = props.transformOrigin, transformOrigin = _props$transformOrigi === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props$transformOrigi, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $5fs1a.default) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps, TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp, other = (0, $dXEVX.default)(props, [
        "action",
        "anchorEl",
        "anchorOrigin",
        "anchorPosition",
        "anchorReference",
        "children",
        "classes",
        "className",
        "container",
        "elevation",
        "getContentAnchorEl",
        "marginThreshold",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperProps",
        "transformOrigin",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var paperRef = $arQ7u.useRef(); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = $arQ7u.useCallback(function(contentAnchorOffset) {
        if (anchorReference === "anchorPosition") return anchorPosition;
        var resolvedAnchorEl = $83834193d766a8b6$var$getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $5Yg7t.default)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        var box;
        var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : "center";
        return {
            top: anchorRect.top + $83834193d766a8b6$export$6fcff0dc60346367(anchorRect, anchorVertical),
            left: anchorRect.left + $83834193d766a8b6$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the vertical offset of inner content to anchor the transform on if provided
    var getContentAnchorOffset = $arQ7u.useCallback(function(element) {
        var contentAnchorOffset = 0;
        if (getContentAnchorEl && anchorReference === "anchorEl") {
            var contentAnchorEl = getContentAnchorEl(element);
            if (contentAnchorEl && element.contains(contentAnchorEl)) {
                var scrollTop = $83834193d766a8b6$var$getScrollParent(element, contentAnchorEl);
                contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
            } // != the default value
        }
        return contentAnchorOffset;
    }, [
        anchorOrigin.vertical,
        anchorReference,
        getContentAnchorEl
    ]); // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use
    var getTransformOrigin = $arQ7u.useCallback(function(elemRect) {
        var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return {
            vertical: $83834193d766a8b6$export$6fcff0dc60346367(elemRect, transformOrigin.vertical) + contentAnchorOffset,
            horizontal: $83834193d766a8b6$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    var getPositioningStyle = $arQ7u.useCallback(function(element) {
        // Check if the parent has requested anchoring on an inner content node
        var contentAnchorOffset = getContentAnchorOffset(element);
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $83834193d766a8b6$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of of the anchoring element
        var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
        var top = anchorOffset.top - elemTransformOrigin.vertical;
        var left = anchorOffset.left - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        var containerWindow = (0, $eUmzP.default)($83834193d766a8b6$var$getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            var _diff = bottom - heightThreshold;
            top -= _diff;
            elemTransformOrigin.vertical += _diff;
        }
        if (left < marginThreshold) {
            var _diff2 = left - marginThreshold;
            left -= _diff2;
            elemTransformOrigin.horizontal += _diff2;
        } else if (right > widthThreshold) {
            var _diff3 = right - widthThreshold;
            left -= _diff3;
            elemTransformOrigin.horizontal += _diff3;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: $83834193d766a8b6$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getContentAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    var setPositioningStyles = $arQ7u.useCallback(function() {
        var element = paperRef.current;
        if (!element) return;
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    var handleEntering = function handleEntering(element, isAppearing) {
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    var handlePaperRef = $arQ7u.useCallback(function(instance) {
        // #StrictMode ready
        paperRef.current = $9sDDw.findDOMNode(instance);
    }, []);
    $arQ7u.useEffect(function() {
        if (open) setPositioningStyles();
    });
    $arQ7u.useImperativeHandle(action, function() {
        return open ? {
            updatePosition: function updatePosition() {
                setPositioningStyles();
            }
        } : null;
    }, [
        open,
        setPositioningStyles
    ]);
    $arQ7u.useEffect(function() {
        if (!open) return undefined;
        var handleResize = (0, $iEYEM.default)(function() {
            setPositioningStyles();
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        open,
        setPositioningStyles
    ]);
    var transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, $5Yg7t.default)($83834193d766a8b6$var$getAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ $arQ7u.createElement((0, $kuaAd.default), (0, $abElG.default)({
        container: container,
        open: open,
        ref: ref,
        BackdropProps: {
            invisible: true
        },
        className: (0, $5g55B.default)(classes.root, className)
    }, other), /*#__PURE__*/ $arQ7u.createElement(TransitionComponent, (0, $abElG.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        timeout: transitionDuration
    }, TransitionProps, {
        onEntering: (0, $1S9Kw.default)(handleEntering, TransitionProps.onEntering)
    }), /*#__PURE__*/ $arQ7u.createElement((0, $3f9WU.default), (0, $abElG.default)({
        elevation: elevation,
        ref: handlePaperRef
    }, PaperProps, {
        className: (0, $5g55B.default)(classes.paper, PaperProps.className)
    }), children)));
});
var $83834193d766a8b6$export$2e2bcd8739ae039 = (0, $7EzGR.default)($83834193d766a8b6$export$9dd6ff9ea0189349, {
    name: "MuiPopover"
})($83834193d766a8b6$var$Popover);

});
parcelRegister("iEYEM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d95b039927b97ab1$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $d95b039927b97ab1$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRegister("eUmzP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ada7cef941c63165$export$2e2bcd8739ae039; });

var $5Yg7t = parcelRequire("5Yg7t");
function $ada7cef941c63165$export$2e2bcd8739ae039(node) {
    var doc = (0, $5Yg7t.default)(node);
    return doc.defaultView || window;
}

});

parcelRegister("kuaAd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee9ed18f0225e23f$export$2e2bcd8739ae039; });

var $dXEVX = parcelRequire("dXEVX");

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");

var $9sDDw = parcelRequire("9sDDw");


var $cgNhc = parcelRequire("cgNhc");
var $gkz9m = parcelRequire("gkz9m");



var $5Yg7t = parcelRequire("5Yg7t");

var $hdq6i = parcelRequire("hdq6i");

var $1S9Kw = parcelRequire("1S9Kw");

var $nGnd5 = parcelRequire("nGnd5");

var $e3Evk = parcelRequire("e3Evk");

var $gQhRu = parcelRequire("gQhRu");

var $gf0UM = parcelRequire("gf0UM");

var $amKEl = parcelRequire("amKEl");

var $8zt5B = parcelRequire("8zt5B");
function $ee9ed18f0225e23f$var$getContainer(container) {
    container = typeof container === "function" ? container() : container;
    return $9sDDw.findDOMNode(container);
}
function $ee9ed18f0225e23f$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty("in") : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $ee9ed18f0225e23f$var$defaultManager = new (0, $gf0UM.default)();
var $ee9ed18f0225e23f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "fixed",
            zIndex: theme.zIndex.modal,
            right: 0,
            bottom: 0,
            top: 0,
            left: 0
        },
        /* Styles applied to the root element if the `Modal` has exited. */ hidden: {
            visibility: "hidden"
        }
    };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $ee9ed18f0225e23f$var$Modal = /*#__PURE__*/ $arQ7u.forwardRef(function Modal(inProps, ref) {
    var theme = (0, $gkz9m.default)();
    var props = (0, $cgNhc.default)({
        name: "MuiModal",
        props: (0, $abElG.default)({}, inProps),
        theme: theme
    });
    var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? (0, $8zt5B.default) : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? $ee9ed18f0225e23f$var$defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0, $dXEVX.default)(props, [
        "BackdropComponent",
        "BackdropProps",
        "children",
        "closeAfterTransition",
        "container",
        "disableAutoFocus",
        "disableBackdropClick",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "manager",
        "onBackdropClick",
        "onClose",
        "onEscapeKeyDown",
        "onRendered",
        "open"
    ]);
    var _React$useState = $arQ7u.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var modal = $arQ7u.useRef({});
    var mountNodeRef = $arQ7u.useRef(null);
    var modalRef = $arQ7u.useRef(null);
    var handleRef = (0, $nGnd5.default)(modalRef, ref);
    var hasTransition = $ee9ed18f0225e23f$var$getHasTransition(props);
    var getDoc = function getDoc() {
        return (0, $5Yg7t.default)(mountNodeRef.current);
    };
    var getModal = function getModal() {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function handleMounted() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $e3Evk.default)(function() {
        var resolvedContainer = $ee9ed18f0225e23f$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $arQ7u.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $e3Evk.default)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (onRendered) onRendered();
        if (open && isTopModal()) handleMounted();
        else (0, $gf0UM.ariaHidden)(modalRef.current, true);
    });
    var handleClose = $arQ7u.useCallback(function() {
        manager.remove(getModal());
    }, [
        manager
    ]);
    $arQ7u.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $arQ7u.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleExited = function handleExited() {
        setExited(true);
        if (closeAfterTransition) handleClose();
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, "backdropClick");
    };
    var handleKeyDown = function handleKeyDown(event) {
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviours like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (onEscapeKeyDown) onEscapeKeyDown(event);
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    var inlineStyle = $ee9ed18f0225e23f$export$9dd6ff9ea0189349(theme || {
        zIndex: (0, $gQhRu.default)
    });
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = children.props.tabIndex || "-1";
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $1S9Kw.default)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $1S9Kw.default)(handleExited, children.props.onExited);
    }
    return /*#__PURE__*/ $arQ7u.createElement((0, $hdq6i.default), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal
    }, /*#__PURE__*/ $arQ7u.createElement("div", (0, $abElG.default)({
        ref: handleRef,
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, other, {
        style: (0, $abElG.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
    }), hideBackdrop ? null : /*#__PURE__*/ $arQ7u.createElement(BackdropComponent, (0, $abElG.default)({
        open: open,
        onClick: handleBackdropClick
    }, BackdropProps)), /*#__PURE__*/ $arQ7u.createElement((0, $amKEl.default), {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        getDoc: getDoc,
        isEnabled: isTopModal,
        open: open
    }, /*#__PURE__*/ $arQ7u.cloneElement(children, childProps))));
});
var $ee9ed18f0225e23f$export$2e2bcd8739ae039 = $ee9ed18f0225e23f$var$Modal;

});
parcelRegister("gf0UM", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $bd2ec1b60f13847e$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "default", function () { return $bd2ec1b60f13847e$export$2e2bcd8739ae039; });

var $9mrtf = parcelRequire("9mrtf");

var $b6hTo = parcelRequire("b6hTo");

var $lsH61 = parcelRequire("lsH61");

var $k5Hn9 = parcelRequire("k5Hn9");

var $5Yg7t = parcelRequire("5Yg7t");

var $eUmzP = parcelRequire("eUmzP");
function $bd2ec1b60f13847e$var$isOverflowing(container) {
    var doc = (0, $5Yg7t.default)(container);
    if (doc.body === container) return (0, $eUmzP.default)(doc).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $bd2ec1b60f13847e$export$e1bd0c6150f13d96(node, show) {
    if (show) node.setAttribute("aria-hidden", "true");
    else node.removeAttribute("aria-hidden");
}
function $bd2ec1b60f13847e$var$getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)["padding-right"], 10) || 0;
}
function $bd2ec1b60f13847e$var$ariaHiddenSiblings(container, mountNode, currentNode) {
    var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [
        mountNode,
        currentNode
    ].concat((0, $lsH61.default)(nodesToExclude));
    var blacklistTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE"
    ];
    [].forEach.call(container.children, function(node) {
        if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) $bd2ec1b60f13847e$export$e1bd0c6150f13d96(node, show);
    });
}
function $bd2ec1b60f13847e$var$findIndexOf(containerInfo, callback) {
    var idx = -1;
    containerInfo.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $bd2ec1b60f13847e$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var restorePaddings = [];
    var container = containerInfo.container;
    var fixedNodes;
    if (!props.disableScrollLock) {
        if ($bd2ec1b60f13847e$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $k5Hn9.default)();
            restoreStyle.push({
                value: container.style.paddingRight,
                key: "padding-right",
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style["padding-right"] = "".concat($bd2ec1b60f13847e$var$getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
            fixedNodes = (0, $5Yg7t.default)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedNodes, function(node) {
                restorePaddings.push(node.style.paddingRight);
                node.style.paddingRight = "".concat($bd2ec1b60f13847e$var$getPaddingRight(node) + scrollbarSize, "px");
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent = container.parentElement;
        var scrollContainer = parent.nodeName === "HTML" && window.getComputedStyle(parent)["overflow-y"] === "scroll" ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            key: "overflow",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    var restore = function restore() {
        if (fixedNodes) [].forEach.call(fixedNodes, function(node, i) {
            if (restorePaddings[i]) node.style.paddingRight = restorePaddings[i];
            else node.style.removeProperty("padding-right");
        });
        restoreStyle.forEach(function(_ref) {
            var value = _ref.value, el = _ref.el, key = _ref.key;
            if (value) el.style.setProperty(key, value);
            else el.style.removeProperty(key);
        });
    };
    return restore;
}
function $bd2ec1b60f13847e$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(node) {
        if (node.getAttribute && node.getAttribute("aria-hidden") === "true") hiddenSiblings.push(node);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ var $bd2ec1b60f13847e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ModalManager() {
        (0, $9mrtf.default)(this, ModalManager);
        // this.modals[modalIndex] = modal
        this.modals = []; // this.containers[containerIndex] = {
        //   modals: [],
        //   container,
        //   restore: null,
        // }
        this.containers = [];
    }
    (0, $b6hTo.default)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal); // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $bd2ec1b60f13847e$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblingNodes = $bd2ec1b60f13847e$var$getHiddenSiblings(container);
                $bd2ec1b60f13847e$var$ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
                var containerIndex = $bd2ec1b60f13847e$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblingNodes: hiddenSiblingNodes
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $bd2ec1b60f13847e$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $bd2ec1b60f13847e$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $bd2ec1b60f13847e$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $bd2ec1b60f13847e$export$e1bd0c6150f13d96(modal.modalRef, true);
                    $bd2ec1b60f13847e$var$ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $bd2ec1b60f13847e$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();

});
parcelRegister("9mrtf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d0b7a43593027d8$export$2e2bcd8739ae039; });
function $6d0b7a43593027d8$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});


parcelRegister("amKEl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78c02518cc0edc66$export$2e2bcd8739ae039; });
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */ 
var $arQ7u = parcelRequire("arQ7u");

var $9sDDw = parcelRequire("9sDDw");


var $5Yg7t = parcelRequire("5Yg7t");

var $nGnd5 = parcelRequire("nGnd5");

/**
 * Utility component that locks focus inside the component.
 */ function $78c02518cc0edc66$var$Unstable_TrapFocus(props) {
    var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $arQ7u.useRef();
    var sentinelStart = $arQ7u.useRef(null);
    var sentinelEnd = $arQ7u.useRef(null);
    var nodeToRestore = $arQ7u.useRef();
    var rootRef = $arQ7u.useRef(null); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $arQ7u.useCallback(function(instance) {
        // #StrictMode ready
        rootRef.current = $9sDDw.findDOMNode(instance);
    }, []);
    var handleRef = (0, $nGnd5.default)(children.ref, handleOwnRef);
    var prevOpenRef = $arQ7u.useRef();
    $arQ7u.useEffect(function() {
        prevOpenRef.current = open;
    }, [
        open
    ]);
    if (!prevOpenRef.current && open && typeof window !== "undefined") // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
    $arQ7u.useEffect(function() {
        if (!open) return;
        var doc = (0, $5Yg7t.default)(rootRef.current); // We might render an empty child.
        if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", -1);
            rootRef.current.focus();
        }
        var contain = function contain() {
            var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (rootRef.current && !rootRef.current.contains(doc.activeElement)) rootRef.current.focus();
        };
        var loopFocus = function loopFocus(event) {
            // 9 = Tab
            if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) return;
             // Make sure the next tab starts from the right place.
            if (doc.activeElement === rootRef.current) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (event.shiftKey) sentinelEnd.current.focus();
                else sentinelStart.current.focus();
            }
        };
        doc.addEventListener("focus", contain, true);
        doc.addEventListener("keydown", loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener("focus", contain, true);
            doc.removeEventListener("keydown", loopFocus, true); // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE 11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE 11 have a focus method.
                // Once IE 11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open
    ]);
    return /*#__PURE__*/ $arQ7u.createElement($arQ7u.Fragment, null, /*#__PURE__*/ $arQ7u.createElement("div", {
        tabIndex: 0,
        ref: sentinelStart,
        "data-test": "sentinelStart"
    }), /*#__PURE__*/ $arQ7u.cloneElement(children, {
        ref: handleRef
    }), /*#__PURE__*/ $arQ7u.createElement("div", {
        tabIndex: 0,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
    }));
}
var $78c02518cc0edc66$export$2e2bcd8739ae039 = $78c02518cc0edc66$var$Unstable_TrapFocus;

});

parcelRegister("8zt5B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63d8282d6720d72d$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");

var $63d8282d6720d72d$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        zIndex: -1,
        position: "fixed",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: "transparent"
    }
};
/**
 * @ignore - internal component.
 */ var $63d8282d6720d72d$var$SimpleBackdrop = /*#__PURE__*/ $arQ7u.forwardRef(function SimpleBackdrop(props, ref) {
    var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0, $dXEVX.default)(props, [
        "invisible",
        "open"
    ]);
    return open ? /*#__PURE__*/ $arQ7u.createElement("div", (0, $abElG.default)({
        "aria-hidden": true,
        ref: ref
    }, other, {
        style: (0, $abElG.default)({}, $63d8282d6720d72d$export$9dd6ff9ea0189349.root, invisible ? $63d8282d6720d72d$export$9dd6ff9ea0189349.invisible : {}, other.style)
    })) : null;
});
var $63d8282d6720d72d$export$2e2bcd8739ae039 = $63d8282d6720d72d$var$SimpleBackdrop;

});





parcelRegister("tTTvC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $059e10fe4a839300$export$2e2bcd8739ae039; });
function $059e10fe4a839300$export$2e2bcd8739ae039(_ref) {
    var props = _ref.props, states = _ref.states, muiFormControl = _ref.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("6cXJA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4852330b5fa590d0$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $jzox3 = parcelRequire("jzox3");
function $4852330b5fa590d0$export$2e2bcd8739ae039() {
    return $arQ7u.useContext((0, $jzox3.default));
}

});

parcelRegister("6v4nJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bb909731da92bb4$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $2Ml3G = parcelRequire("2Ml3G");
var /**
 * @ignore - internal component.
 */ $4bb909731da92bb4$export$2e2bcd8739ae039 = (0, $2Ml3G.default)(/*#__PURE__*/ $arQ7u.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

});

parcelRegister("iwnYb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7bdcf0f505735b8$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");


var $9SCZl = parcelRequire("9SCZl");

var $7EzGR = parcelRequire("7EzGR");
var $d7bdcf0f505735b8$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative"
        },
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            "label + &": {
                marginTop: 16
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            "&$underline:after": {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            "&:after": {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            },
            "&$error:after": {
                borderBottomColor: theme.palette.error.main,
                transform: "scaleX(1)" // error is always underlined in red
            },
            "&:before": {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: theme.transitions.create("border-bottom-color", {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&:hover:not($disabled):before": {
                borderBottom: "2px solid ".concat(theme.palette.text.primary),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    borderBottom: "1px solid ".concat(bottomLineColor)
                }
            },
            "&$disabled:before": {
                borderBottomStyle: "dotted"
            }
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {},
        /* Styles applied to the `input` element. */ input: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {},
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {},
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {}
    };
};
var $d7bdcf0f505735b8$var$Input = /*#__PURE__*/ $arQ7u.forwardRef(function Input(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $dXEVX.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $arQ7u.createElement((0, $9SCZl.default), (0, $abElG.default)({
        classes: (0, $abElG.default)({}, classes, {
            root: (0, $5g55B.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$d7bdcf0f505735b8$var$Input.muiName = "Input";
var $d7bdcf0f505735b8$export$2e2bcd8739ae039 = (0, $7EzGR.default)($d7bdcf0f505735b8$export$9dd6ff9ea0189349, {
    name: "MuiInput"
})($d7bdcf0f505735b8$var$Input);

});
parcelRegister("9SCZl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73176678e686dba7$export$2e2bcd8739ae039; });

var $dXEVX = parcelRequire("dXEVX");

var $abElG = parcelRequire("abElG");

var $eQGDD = parcelRequire("eQGDD");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $tTTvC = parcelRequire("tTTvC");

var $jzox3 = parcelRequire("jzox3");

var $7EzGR = parcelRequire("7EzGR");

var $kaLUp = parcelRequire("kaLUp");

var $nGnd5 = parcelRequire("nGnd5");

var $IaZmi = parcelRequire("IaZmi");

var $gynfe = parcelRequire("gynfe");
var $73176678e686dba7$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var placeholder = {
        color: "currentColor",
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
    var placeholderHidden = {
        opacity: "0 !important"
    };
    var placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return {
        "@global": {
            "@keyframes mui-auto-fill": {},
            "@keyframes mui-auto-fill-cancel": {}
        },
        /* Styles applied to the root element. */ root: (0, $abElG.default)({}, theme.typography.body1, {
            color: theme.palette.text.primary,
            lineHeight: "1.1876em",
            // Reset (19px), match the native input line-height
            boxSizing: "border-box",
            // Prevent padding issue with fullWidth.
            position: "relative",
            cursor: "text",
            display: "inline-flex",
            alignItems: "center",
            "&$disabled": {
                color: theme.palette.text.disabled,
                cursor: "default"
            }
        }),
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {},
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {},
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            "&$marginDense": {
                paddingTop: 3
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the `input` element. */ input: {
            font: "inherit",
            letterSpacing: "inherit",
            color: "currentColor",
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            border: 0,
            boxSizing: "content-box",
            background: "none",
            height: "1.1876em",
            // Reset (19px), match the native input line-height
            margin: 0,
            // Reset for Safari
            WebkitTapHighlightColor: "transparent",
            display: "block",
            // Make the flex item shrink with Firefox
            minWidth: 0,
            width: "100%",
            // Fix IE 11 width issue
            animationName: "mui-auto-fill-cancel",
            animationDuration: "10ms",
            "&::-webkit-input-placeholder": placeholder,
            "&::-moz-placeholder": placeholder,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholder,
            // IE 11
            "&::-ms-input-placeholder": placeholder,
            // Edge
            "&:focus": {
                outline: 0
            },
            // Reset Firefox invalid required input style
            "&:invalid": {
                boxShadow: "none"
            },
            "&::-webkit-search-decoration": {
                // Remove the padding when type=search.
                "-webkit-appearance": "none"
            },
            // Show and hide the placeholder logic
            "label[data-shrink=false] + $formControl &": {
                "&::-webkit-input-placeholder": placeholderHidden,
                "&::-moz-placeholder": placeholderHidden,
                // Firefox 19+
                "&:-ms-input-placeholder": placeholderHidden,
                // IE 11
                "&::-ms-input-placeholder": placeholderHidden,
                // Edge
                "&:focus::-webkit-input-placeholder": placeholderVisible,
                "&:focus::-moz-placeholder": placeholderVisible,
                // Firefox 19+
                "&:focus:-ms-input-placeholder": placeholderVisible,
                // IE 11
                "&:focus::-ms-input-placeholder": placeholderVisible // Edge
            },
            "&$disabled": {
                opacity: 1 // Reset iOS opacity
            },
            "&:-webkit-autofill": {
                animationDuration: "5000s",
                animationName: "mui-auto-fill"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 3
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            height: "auto",
            resize: "none",
            padding: 0
        },
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {
            // Improve type search style.
            "-moz-appearance": "textfield",
            "-webkit-appearance": "textfield"
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {},
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {},
        /* Styles applied to the `input` element if `hiddenLabel={true}`. */ inputHiddenLabel: {}
    };
};
var $73176678e686dba7$var$useEnhancedEffect = typeof window === "undefined" ? $arQ7u.useEffect : $arQ7u.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ var $73176678e686dba7$var$InputBase = /*#__PURE__*/ $arQ7u.forwardRef(function InputBase(props, ref) {
    var ariaDescribedby = props["aria-describedby"], autoComplete = props.autoComplete, autoFocus = props.autoFocus, classes = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, disabled = props.disabled, endAdornment = props.endAdornment, error = props.error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, id = props.id, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$inputProps = props.inputProps, inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps, inputRefProp = props.inputRef, margin = props.margin, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, rowsMax = props.rowsMax, rowsMin = props.rowsMin, maxRows = props.maxRows, minRows = props.minRows, startAdornment = props.startAdornment, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, valueProp = props.value, other = (0, $dXEVX.default)(props, [
        "aria-describedby",
        "autoComplete",
        "autoFocus",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "endAdornment",
        "error",
        "fullWidth",
        "id",
        "inputComponent",
        "inputProps",
        "inputRef",
        "margin",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onClick",
        "onFocus",
        "onKeyDown",
        "onKeyUp",
        "placeholder",
        "readOnly",
        "renderSuffix",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "startAdornment",
        "type",
        "value"
    ]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var _React$useRef = $arQ7u.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $arQ7u.useRef();
    var handleInputRefWarning = $arQ7u.useCallback(function(instance) {}, []);
    var handleInputPropsRefProp = (0, $nGnd5.default)(inputPropsProp.ref, handleInputRefWarning);
    var handleInputRefProp = (0, $nGnd5.default)(inputRefProp, handleInputPropsRefProp);
    var handleInputRef = (0, $nGnd5.default)(inputRef, handleInputRefProp);
    var _React$useState = $arQ7u.useState(false), focused = _React$useState[0], setFocused = _React$useState[1];
    var muiFormControl = (0, $jzox3.useFormControl)();
    var fcs = (0, $tTTvC.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "margin",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $arQ7u.useEffect(function() {
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = $arQ7u.useCallback(function(obj) {
        if ((0, $gynfe.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    $73176678e686dba7$var$useEnhancedEffect(function() {
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    var handleFocus = function handleFocus(event) {
        // Fix a bug with IE 11 where the focus/blur events are triggered
        // while the input is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) {
            var element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $eQGDD.default)(1));
            checkDirty({
                value: element.value
            });
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (inputPropsProp.onChange) inputPropsProp.onChange.apply(inputPropsProp, [
            event
        ].concat(args));
         // Perform in the willUpdate
        if (onChange) onChange.apply(void 0, [
            event
        ].concat(args));
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $arQ7u.useEffect(function() {
        checkDirty(inputRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var handleClick = function handleClick(event) {
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    var InputComponent = inputComponent;
    var inputProps = (0, $abElG.default)({}, inputPropsProp, {
        ref: handleInputRef
    });
    if (typeof InputComponent !== "string") inputProps = (0, $abElG.default)({
        // Rename ref to inputRef as we don't know the
        // provided `inputComponent` structure.
        inputRef: handleInputRef,
        type: type
    }, inputProps, {
        ref: null
    });
    else if (multiline) {
        if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) InputComponent = "textarea";
        else {
            inputProps = (0, $abElG.default)({
                minRows: rows || minRows,
                rowsMax: rowsMax,
                maxRows: maxRows
            }, inputProps);
            InputComponent = (0, $IaZmi.default);
        }
    } else inputProps = (0, $abElG.default)({
        type: type
    }, inputProps);
    var handleAutoFill = function handleAutoFill(event) {
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $arQ7u.useEffect(function() {
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    return /*#__PURE__*/ $arQ7u.createElement("div", (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, classes["color".concat((0, $kaLUp.default)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === "dense" && classes.marginDense),
        onClick: handleClick,
        ref: ref
    }, other), startAdornment, /*#__PURE__*/ $arQ7u.createElement((0, $jzox3.default).Provider, {
        value: null
    }, /*#__PURE__*/ $arQ7u.createElement(InputComponent, (0, $abElG.default)({
        "aria-invalid": fcs.error,
        "aria-describedby": ariaDescribedby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        onAnimationStart: handleAutoFill,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }, inputProps, {
        className: (0, $5g55B.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === "search" && classes.inputTypeSearch, fcs.margin === "dense" && classes.inputMarginDense),
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus
    }))), endAdornment, renderSuffix ? renderSuffix((0, $abElG.default)({}, fcs, {
        startAdornment: startAdornment
    })) : null);
});
var $73176678e686dba7$export$2e2bcd8739ae039 = (0, $7EzGR.default)($73176678e686dba7$export$9dd6ff9ea0189349, {
    name: "MuiInputBase"
})($73176678e686dba7$var$InputBase);

});
parcelRegister("IaZmi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $084ca24b27fb3a96$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $iEYEM = parcelRequire("iEYEM");

var $nGnd5 = parcelRequire("nGnd5");

function $084ca24b27fb3a96$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
var $084ca24b27fb3a96$var$useEnhancedEffect = typeof window !== "undefined" ? $arQ7u.useLayoutEffect : $arQ7u.useEffect;
var $084ca24b27fb3a96$var$styles = {
    /* Styles applied to the shadow textarea element. */ shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
var $084ca24b27fb3a96$var$TextareaAutosize = /*#__PURE__*/ $arQ7u.forwardRef(function TextareaAutosize(props, ref) {
    var onChange = props.onChange, rows = props.rows, rowsMax = props.rowsMax, rowsMinProp = props.rowsMin, maxRowsProp = props.maxRows, _props$minRows = props.minRows, minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows, style = props.style, value = props.value, other = (0, $dXEVX.default)(props, [
        "onChange",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "style",
        "value"
    ]);
    var maxRows = maxRowsProp || rowsMax;
    var minRows = rows || rowsMinProp || minRowsProp;
    var _React$useRef = $arQ7u.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $arQ7u.useRef(null);
    var handleRef = (0, $nGnd5.default)(ref, inputRef);
    var shadowRef = $arQ7u.useRef(null);
    var renders = $arQ7u.useRef(0);
    var _React$useState = $arQ7u.useState({}), state = _React$useState[0], setState = _React$useState[1];
    var syncHeight = $arQ7u.useCallback(function() {
        var input = inputRef.current;
        var computedStyle = window.getComputedStyle(input);
        var inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        var boxSizing = computedStyle["box-sizing"];
        var padding = $084ca24b27fb3a96$var$getStyleValue(computedStyle, "padding-bottom") + $084ca24b27fb3a96$var$getStyleValue(computedStyle, "padding-top");
        var border = $084ca24b27fb3a96$var$getStyleValue(computedStyle, "border-bottom-width") + $084ca24b27fb3a96$var$getStyleValue(computedStyle, "border-top-width"); // The height of the inner content
        var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
        inputShallow.value = "x";
        var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
        var outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        var outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        var overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState(function(prevState) {
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            return prevState;
        });
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    $arQ7u.useEffect(function() {
        var handleResize = (0, $iEYEM.default)(function() {
            renders.current = 0;
            syncHeight();
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        syncHeight
    ]);
    $084ca24b27fb3a96$var$useEnhancedEffect(function() {
        syncHeight();
    });
    $arQ7u.useEffect(function() {
        renders.current = 0;
    }, [
        value
    ]);
    var handleChange = function handleChange(event) {
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ $arQ7u.createElement($arQ7u.Fragment, null, /*#__PURE__*/ $arQ7u.createElement("textarea", (0, $abElG.default)({
        value: value,
        onChange: handleChange,
        ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
        ,
        rows: minRows,
        style: (0, $abElG.default)({
            height: state.outerHeightStyle,
            // Need a large enough difference to allow scrolling.
            // This prevents infinite rendering loop.
            overflow: state.overflow ? "hidden" : null
        }, style)
    }, other)), /*#__PURE__*/ $arQ7u.createElement("textarea", {
        "aria-hidden": true,
        className: props.className,
        readOnly: true,
        ref: shadowRef,
        tabIndex: -1,
        style: (0, $abElG.default)({}, $084ca24b27fb3a96$var$styles.shadow, style)
    }));
});
var $084ca24b27fb3a96$export$2e2bcd8739ae039 = $084ca24b27fb3a96$var$TextareaAutosize;

});



parcelRegister("3H36o", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2b07cb47d9b690bc$export$9dd6ff9ea0189349; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $9IYfE = parcelRequire("9IYfE");

var $7EzGR = parcelRequire("7EzGR");

var $tTTvC = parcelRequire("tTTvC");

var $6cXJA = parcelRequire("6cXJA");

var $6v4nJ = parcelRequire("6v4nJ");

var $iwnYb = parcelRequire("iwnYb");
var $2b07cb47d9b690bc$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the select component `root` class. */ root: {},
        /* Styles applied to the select component `select` class. */ select: {
            "-moz-appearance": "none",
            // Reset
            "-webkit-appearance": "none",
            // Reset
            // When interacting quickly, the text can end up selected.
            // Native select can't be selected either.
            userSelect: "none",
            borderRadius: 0,
            // Reset
            minWidth: 16,
            // So it doesn't collapse.
            cursor: "pointer",
            "&:focus": {
                // Show that it's not an text input
                backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
                borderRadius: 0 // Reset Chrome style
            },
            // Remove IE 11 arrow
            "&::-ms-expand": {
                display: "none"
            },
            "&$disabled": {
                cursor: "default"
            },
            "&[multiple]": {
                height: "auto"
            },
            "&:not([multiple]) option, &:not([multiple]) optgroup": {
                backgroundColor: theme.palette.background.paper
            },
            "&&": {
                paddingRight: 24
            }
        },
        /* Styles applied to the select component if `variant="filled"`. */ filled: {
            "&&": {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component if `variant="outlined"`. */ outlined: {
            borderRadius: theme.shape.borderRadius,
            "&&": {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component `selectMenu` class. */ selectMenu: {
            height: "auto",
            // Resets for multpile select with chips
            minHeight: "1.1876em",
            // Required for select\text-field height consistency
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden"
        },
        /* Pseudo-class applied to the select component `disabled` class. */ disabled: {},
        /* Styles applied to the icon component. */ icon: {
            // We use a position absolute over a flexbox in order to forward the pointer events
            // to the input and to support wrapping tags..
            position: "absolute",
            right: 0,
            top: "calc(50% - 12px)",
            // Center vertically
            pointerEvents: "none",
            // Don't block pointer events on the select under the icon.
            color: theme.palette.action.active,
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the icon component if the popup is open. */ iconOpen: {
            transform: "rotate(180deg)"
        },
        /* Styles applied to the icon component if `variant="filled"`. */ iconFilled: {
            right: 7
        },
        /* Styles applied to the icon component if `variant="outlined"`. */ iconOutlined: {
            right: 7
        },
        /* Styles applied to the underlying native input component. */ nativeInput: {
            bottom: 0,
            left: 0,
            position: "absolute",
            opacity: 0,
            pointerEvents: "none",
            width: "100%"
        }
    };
};
var $2b07cb47d9b690bc$var$defaultInput = /*#__PURE__*/ $arQ7u.createElement((0, $iwnYb.default), null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ var $2b07cb47d9b690bc$var$NativeSelect = /*#__PURE__*/ $arQ7u.forwardRef(function NativeSelect(props, ref) {
    var children = props.children, classes = props.classes, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $6v4nJ.default) : _props$IconComponent, _props$input = props.input, input = _props$input === void 0 ? $2b07cb47d9b690bc$var$defaultInput : _props$input, inputProps = props.inputProps, variant = props.variant, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "IconComponent",
        "input",
        "inputProps",
        "variant"
    ]);
    var muiFormControl = (0, $6cXJA.default)();
    var fcs = (0, $tTTvC.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    return /*#__PURE__*/ $arQ7u.cloneElement(input, (0, $abElG.default)({
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: (0, $9IYfE.default),
        inputProps: (0, $abElG.default)({
            children: children,
            classes: classes,
            IconComponent: IconComponent,
            variant: fcs.variant,
            type: undefined
        }, inputProps, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$2b07cb47d9b690bc$var$NativeSelect.muiName = "Select";
var $2b07cb47d9b690bc$export$2e2bcd8739ae039 = (0, $7EzGR.default)($2b07cb47d9b690bc$export$9dd6ff9ea0189349, {
    name: "MuiNativeSelect"
})($2b07cb47d9b690bc$var$NativeSelect);

});
parcelRegister("9IYfE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7146f5c6d89f1980$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");


var $kaLUp = parcelRequire("kaLUp");
/**
 * @ignore - internal component.
 */ var $7146f5c6d89f1980$var$NativeSelectInput = /*#__PURE__*/ $arQ7u.forwardRef(function NativeSelectInput(props, ref) {
    var classes = props.classes, className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $dXEVX.default)(props, [
        "classes",
        "className",
        "disabled",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    return /*#__PURE__*/ $arQ7u.createElement($arQ7u.Fragment, null, /*#__PURE__*/ $arQ7u.createElement("select", (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, classes.select, classes[variant], className, disabled && classes.disabled),
        disabled: disabled,
        ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/ $arQ7u.createElement(IconComponent, {
        className: (0, $5g55B.default)(classes.icon, classes["icon".concat((0, $kaLUp.default)(variant))], disabled && classes.disabled)
    }));
});
var $7146f5c6d89f1980$export$2e2bcd8739ae039 = $7146f5c6d89f1980$var$NativeSelectInput;

});


parcelRegister("ajiku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7819e590e6053a35$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");


var $9SCZl = parcelRequire("9SCZl");

var $7EzGR = parcelRequire("7EzGR");
var $7819e590e6053a35$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    var backgroundColor = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            backgroundColor: backgroundColor,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            "&:hover": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: backgroundColor
                }
            },
            "&$focused": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"
            },
            "&$disabled": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
            }
        },
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            "&$underline:after": {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            "&:after": {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            },
            "&$error:after": {
                borderBottomColor: theme.palette.error.main,
                transform: "scaleX(1)" // error is always underlined in red
            },
            "&:before": {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: theme.transitions.create("border-bottom-color", {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&:hover:before": {
                borderBottom: "1px solid ".concat(theme.palette.text.primary)
            },
            "&$disabled:before": {
                borderBottomStyle: "dotted"
            }
        },
        /* Pseudo-class applied to the root element if the component is focused. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 12
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 12
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "27px 12px 10px",
            "&$marginDense": {
                paddingTop: 23,
                paddingBottom: 6
            }
        },
        /* Styles applied to the `input` element. */ input: {
            padding: "27px 12px 10px",
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
                caretColor: theme.palette.type === "light" ? null : "#fff",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 23,
            paddingBottom: 6
        },
        /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */ inputHiddenLabel: {
            paddingTop: 18,
            paddingBottom: 19,
            "&$inputMarginDense": {
                paddingTop: 10,
                paddingBottom: 11
            }
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $7819e590e6053a35$var$FilledInput = /*#__PURE__*/ $arQ7u.forwardRef(function FilledInput(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $dXEVX.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $arQ7u.createElement((0, $9SCZl.default), (0, $abElG.default)({
        classes: (0, $abElG.default)({}, classes, {
            root: (0, $5g55B.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$7819e590e6053a35$var$FilledInput.muiName = "Input";
var $7819e590e6053a35$export$2e2bcd8739ae039 = (0, $7EzGR.default)($7819e590e6053a35$export$9dd6ff9ea0189349, {
    name: "MuiFilledInput"
})($7819e590e6053a35$var$FilledInput);

});

parcelRegister("8h9eG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6067134fab2e7e1a$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");


var $9SCZl = parcelRequire("9SCZl");

var $kXkG8 = parcelRequire("kXkG8");

var $7EzGR = parcelRequire("7EzGR");
var $6067134fab2e7e1a$export$9dd6ff9ea0189349 = function styles(theme) {
    var borderColor = theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            borderRadius: theme.shape.borderRadius,
            "&:hover $notchedOutline": {
                borderColor: theme.palette.text.primary
            },
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                "&:hover $notchedOutline": {
                    borderColor: borderColor
                }
            },
            "&$focused $notchedOutline": {
                borderColor: theme.palette.primary.main,
                borderWidth: 2
            },
            "&$error $notchedOutline": {
                borderColor: theme.palette.error.main
            },
            "&$disabled $notchedOutline": {
                borderColor: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            "&$focused $notchedOutline": {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 14
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 14
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "18.5px 14px",
            "&$marginDense": {
                paddingTop: 10.5,
                paddingBottom: 10.5
            }
        },
        /* Styles applied to the `NotchedOutline` element. */ notchedOutline: {
            borderColor: borderColor
        },
        /* Styles applied to the `input` element. */ input: {
            padding: "18.5px 14px",
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
                caretColor: theme.palette.type === "light" ? null : "#fff",
                borderRadius: "inherit"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 10.5,
            paddingBottom: 10.5
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $6067134fab2e7e1a$var$OutlinedInput = /*#__PURE__*/ $arQ7u.forwardRef(function OutlinedInput(props, ref) {
    var classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, label = props.label, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, notched = props.notched, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $dXEVX.default)(props, [
        "classes",
        "fullWidth",
        "inputComponent",
        "label",
        "labelWidth",
        "multiline",
        "notched",
        "type"
    ]);
    return /*#__PURE__*/ $arQ7u.createElement((0, $9SCZl.default), (0, $abElG.default)({
        renderSuffix: function renderSuffix(state) {
            return /*#__PURE__*/ $arQ7u.createElement((0, $kXkG8.default), {
                className: classes.notchedOutline,
                label: label,
                labelWidth: labelWidth,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        classes: (0, $abElG.default)({}, classes, {
            root: (0, $5g55B.default)(classes.root, classes.underline),
            notchedOutline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$6067134fab2e7e1a$var$OutlinedInput.muiName = "Input";
var $6067134fab2e7e1a$export$2e2bcd8739ae039 = (0, $7EzGR.default)($6067134fab2e7e1a$export$9dd6ff9ea0189349, {
    name: "MuiOutlinedInput"
})($6067134fab2e7e1a$var$OutlinedInput);

});
parcelRegister("kXkG8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4195ba96ee46780$export$2e2bcd8739ae039; });

var $4g0WD = parcelRequire("4g0WD");

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");

var $j1k3T = parcelRequire("j1k3T");

var $kaLUp = parcelRequire("kaLUp");
var $f4195ba96ee46780$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "absolute",
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: "0 8px",
            pointerEvents: "none",
            borderRadius: "inherit",
            borderStyle: "solid",
            borderWidth: 1,
            overflow: "hidden"
        },
        /* Styles applied to the legend element when `labelWidth` is provided. */ legend: {
            textAlign: "left",
            padding: 0,
            lineHeight: "11px",
            // sync with `height` in `legend` styles
            transition: theme.transitions.create("width", {
                duration: 150,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the legend element. */ legendLabelled: {
            display: "block",
            width: "auto",
            textAlign: "left",
            padding: 0,
            height: 11,
            // sync with `lineHeight` in `legend` styles
            fontSize: "0.75em",
            visibility: "hidden",
            maxWidth: 0.01,
            transition: theme.transitions.create("max-width", {
                duration: 50,
                easing: theme.transitions.easing.easeOut
            }),
            "& > span": {
                paddingLeft: 5,
                paddingRight: 5,
                display: "inline-block"
            }
        },
        /* Styles applied to the legend element is notched. */ legendNotched: {
            maxWidth: 1000,
            transition: theme.transitions.create("max-width", {
                duration: 100,
                easing: theme.transitions.easing.easeOut,
                delay: 50
            })
        }
    };
};
/**
 * @ignore - internal component.
 */ var $f4195ba96ee46780$var$NotchedOutline = /*#__PURE__*/ $arQ7u.forwardRef(function NotchedOutline(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, label = props.label, labelWidthProp = props.labelWidth, notched = props.notched, style = props.style, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "className",
        "label",
        "labelWidth",
        "notched",
        "style"
    ]);
    var theme = (0, $j1k3T.default)();
    var align = theme.direction === "rtl" ? "right" : "left";
    if (label !== undefined) return /*#__PURE__*/ $arQ7u.createElement("fieldset", (0, $abElG.default)({
        "aria-hidden": true,
        className: (0, $5g55B.default)(classes.root, className),
        ref: ref,
        style: style
    }, other), /*#__PURE__*/ $arQ7u.createElement("legend", {
        className: (0, $5g55B.default)(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/ $arQ7u.createElement("span", null, label) : /*#__PURE__*/ $arQ7u.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    })));
    var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
    return /*#__PURE__*/ $arQ7u.createElement("fieldset", (0, $abElG.default)({
        "aria-hidden": true,
        style: (0, $abElG.default)((0, $4g0WD.default)({}, "padding".concat((0, $kaLUp.default)(align)), 8), style),
        className: (0, $5g55B.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $arQ7u.createElement("legend", {
        className: classes.legend,
        style: {
            // IE 11: fieldset with legend does not render
            // a border radius. This maintains consistency
            // by always having a legend rendered
            width: notched ? labelWidth : 0.01
        }
    }, /*#__PURE__*/ $arQ7u.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    })));
});
var $f4195ba96ee46780$export$2e2bcd8739ae039 = (0, $7EzGR.default)($f4195ba96ee46780$export$9dd6ff9ea0189349, {
    name: "PrivateNotchedOutline"
})($f4195ba96ee46780$var$NotchedOutline);

});





parcelRegister("uc6Q2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05ac321c4dde9689$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7XHRd = parcelRequire("7XHRd");

var $7GY88 = parcelRequire("7GY88");

var $4G9jR = parcelRequire("4G9jR");
/**
 * mapStateToProps - to hook up connect
 * @memberof WindowSideBarInfoPanel
 * @private
 */ var $05ac321c4dde9689$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, manifestId = _ref.manifestId, windowId = _ref.windowId;
    return {
        manifestDescription: (0, $7GY88.getManifestDescription)(state, {
            companionWindowId: id,
            manifestId: manifestId,
            windowId: windowId
        }),
        manifestLabel: (0, $7GY88.getManifestTitle)(state, {
            companionWindowId: id,
            manifestId: manifestId,
            windowId: windowId
        }),
        manifestMetadata: (0, $7GY88.getManifestMetadata)(state, {
            companionWindowId: id,
            manifestId: manifestId,
            windowId: windowId
        })
    };
};
var $05ac321c4dde9689$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $fbonu.default)($05ac321c4dde9689$var$mapStateToProps), (0, $7XHRd.withPlugins)("ManifestInfo"));
var $05ac321c4dde9689$export$2e2bcd8739ae039 = $05ac321c4dde9689$var$enhance((0, $4G9jR.ManifestInfo));

});
parcelRegister("4G9jR", function(module, exports) {

$parcel$export(module.exports, "ManifestInfo", function () { return $3682504fba732654$export$1cd15c8c883002f4; });

var $arQ7u = parcelRequire("arQ7u");

var $hsH5s = parcelRequire("hsH5s");

var $ltnUe = parcelRequire("ltnUe");

var $7TK2Y = parcelRequire("7TK2Y");

var $acwox = parcelRequire("acwox");

var $lyw4f = parcelRequire("lyw4f");
function $3682504fba732654$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3682504fba732654$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3682504fba732654$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3682504fba732654$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3682504fba732654$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3682504fba732654$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3682504fba732654$var$_setPrototypeOf(subClass, superClass);
}
function $3682504fba732654$var$_setPrototypeOf(o, p) {
    $3682504fba732654$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3682504fba732654$var$_setPrototypeOf(o, p);
}
function $3682504fba732654$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3682504fba732654$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3682504fba732654$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3682504fba732654$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3682504fba732654$var$_possibleConstructorReturn(this, result);
    };
}
function $3682504fba732654$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3682504fba732654$var$_assertThisInitialized(self);
}
function $3682504fba732654$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3682504fba732654$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3682504fba732654$var$_getPrototypeOf(o) {
    $3682504fba732654$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3682504fba732654$var$_getPrototypeOf(o);
}
var $3682504fba732654$export$1cd15c8c883002f4 = /*#__PURE__*/ function(_Component) {
    $3682504fba732654$var$_inherits(ManifestInfo, _Component);
    var _super = $3682504fba732654$var$_createSuper(ManifestInfo);
    function ManifestInfo() {
        $3682504fba732654$var$_classCallCheck(this, ManifestInfo);
        return _super.apply(this, arguments);
    }
    $3682504fba732654$var$_createClass(ManifestInfo, [
        {
            key: "render",
            value: /**
     * render
     * @return
     */ function render() {
                var _this$props = this.props, manifestDescription = _this$props.manifestDescription, manifestLabel = _this$props.manifestLabel, manifestMetadata = _this$props.manifestMetadata, id = _this$props.id, t = _this$props.t;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $ltnUe.default), {
                    id: "".concat(id, "-resource"),
                    label: t("resource")
                }, manifestLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    "aria-labelledby": "".concat(id, "-resource ").concat(id, "-resource-heading"),
                    id: "".concat(id, "-resource-heading"),
                    variant: "h4",
                    component: "h5"
                }, manifestLabel), manifestDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "body1"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7TK2Y.default), {
                    htmlString: manifestDescription,
                    ruleSet: "iiif"
                })), manifestMetadata.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $acwox.LabelValueMetadata), {
                    labelValuePairs: manifestMetadata
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $lyw4f.PluginHook), this.props));
            }
        }
    ]);
    return ManifestInfo;
}((0, $arQ7u.Component));
$3682504fba732654$export$1cd15c8c883002f4.defaultProps = {
    manifestDescription: null,
    manifestLabel: null,
    manifestMetadata: [],
    t: function t(key) {
        return key;
    }
};

});


parcelRegister("krFes", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee26501c2914ccfd$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7XHRd = parcelRequire("7XHRd");

var $7GY88 = parcelRequire("7GY88");
var $dy9HC = parcelRequire("dy9HC");

var $k4YEs = parcelRequire("k4YEs");

var $6P1PD = parcelRequire("6P1PD");
/**
 * mapStateToProps - to hook up connect
 * @memberof WindowSideBarInfoPanel
 * @private
 */ var $ee26501c2914ccfd$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, windowId = _ref.windowId;
    var _ref2 = (0, $dy9HC.getWindow)(state, {
        windowId: windowId
    }) || {}, collectionPath = _ref2.collectionPath;
    var manifestId = collectionPath[collectionPath.length - 1];
    return {
        collectionLabel: (0, $7GY88.getManifestTitle)(state, {
            manifestId: manifestId
        }),
        collectionPath: collectionPath
    };
};
var $ee26501c2914ccfd$var$mapDispatchToProps = {
    showCollectionDialog: $k4YEs.showCollectionDialog
};
var $ee26501c2914ccfd$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $fbonu.default)($ee26501c2914ccfd$var$mapStateToProps, $ee26501c2914ccfd$var$mapDispatchToProps), (0, $7XHRd.withPlugins)("CollectionInfo"));
var $ee26501c2914ccfd$export$2e2bcd8739ae039 = $ee26501c2914ccfd$var$enhance((0, $6P1PD.CollectionInfo));

});
parcelRegister("6P1PD", function(module, exports) {

$parcel$export(module.exports, "CollectionInfo", function () { return $4f78ed414a8a8db1$export$f8b6fec5d143bad8; });

var $arQ7u = parcelRequire("arQ7u");

var $lBY5E = parcelRequire("lBY5E");

var $hsH5s = parcelRequire("hsH5s");

var $elqE0 = parcelRequire("elqE0");

var $ltnUe = parcelRequire("ltnUe");
function $4f78ed414a8a8db1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4f78ed414a8a8db1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4f78ed414a8a8db1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4f78ed414a8a8db1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4f78ed414a8a8db1$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4f78ed414a8a8db1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $4f78ed414a8a8db1$var$_setPrototypeOf(subClass, superClass);
}
function $4f78ed414a8a8db1$var$_setPrototypeOf(o, p) {
    $4f78ed414a8a8db1$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4f78ed414a8a8db1$var$_setPrototypeOf(o, p);
}
function $4f78ed414a8a8db1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4f78ed414a8a8db1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4f78ed414a8a8db1$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4f78ed414a8a8db1$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4f78ed414a8a8db1$var$_possibleConstructorReturn(this, result);
    };
}
function $4f78ed414a8a8db1$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4f78ed414a8a8db1$var$_assertThisInitialized(self);
}
function $4f78ed414a8a8db1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4f78ed414a8a8db1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4f78ed414a8a8db1$var$_getPrototypeOf(o) {
    $4f78ed414a8a8db1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4f78ed414a8a8db1$var$_getPrototypeOf(o);
}
var $4f78ed414a8a8db1$export$f8b6fec5d143bad8 = /*#__PURE__*/ function(_Component) {
    $4f78ed414a8a8db1$var$_inherits(CollectionInfo, _Component);
    var _super = $4f78ed414a8a8db1$var$_createSuper(CollectionInfo);
    /** */ function CollectionInfo(props) {
        var _this;
        $4f78ed414a8a8db1$var$_classCallCheck(this, CollectionInfo);
        _this = _super.call(this, props);
        _this.openCollectionDialog = _this.openCollectionDialog.bind($4f78ed414a8a8db1$var$_assertThisInitialized(_this));
        return _this;
    }
    /** */ $4f78ed414a8a8db1$var$_createClass(CollectionInfo, [
        {
            key: "openCollectionDialog",
            value: function openCollectionDialog() {
                var _this$props = this.props, collectionPath = _this$props.collectionPath, showCollectionDialog = _this$props.showCollectionDialog, windowId = _this$props.windowId;
                var manifestId = collectionPath[collectionPath.length - 1];
                showCollectionDialog(manifestId, collectionPath.slice(0, -1), windowId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, collectionLabel = _this$props2.collectionLabel, collectionPath = _this$props2.collectionPath, id = _this$props2.id, t = _this$props2.t;
                if (collectionPath.length === 0) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $ltnUe.default), {
                    id: "".concat(id, "-collection"),
                    label: t("collection")
                }, collectionLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    "aria-labelledby": "".concat(id, "-resource ").concat(id, "-resource-heading"),
                    id: "".concat(id, "-resource-heading"),
                    variant: "h4"
                }, collectionLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $lBY5E.default), {
                    color: "primary",
                    onClick: this.openCollectionDialog,
                    startIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elqE0))), null)
                }, t("showCollection")));
            }
        }
    ]);
    return CollectionInfo;
}((0, $arQ7u.Component));
$4f78ed414a8a8db1$export$f8b6fec5d143bad8.defaultProps = {
    collectionLabel: null,
    collectionPath: [],
    t: function t(key) {
        return key;
    },
    windowId: null
};

});
parcelRegister("lBY5E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbbbaa513a82e075$export$2e2bcd8739ae039; });

var $dXEVX = parcelRequire("dXEVX");

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");

var $6vqZH = parcelRequire("6vqZH");

var $b71IR = parcelRequire("b71IR");

var $kaLUp = parcelRequire("kaLUp");
var $fbbbaa513a82e075$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $abElG.default)({}, theme.typography.button, {
            boxSizing: "border-box",
            minWidth: 64,
            padding: "6px 16px",
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                "background-color",
                "box-shadow",
                "border"
            ], {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                },
                "&$disabled": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: "100%",
            // Ensure the correct width for iOS Safari
            display: "inherit",
            alignItems: "inherit",
            justifyContent: "inherit"
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: "6px 8px"
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: "5px 15px",
            border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $6vqZH.alpha)(theme.palette.primary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $6vqZH.alpha)(theme.palette.secondary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            "&:hover": {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                "&$disabled": {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            "&$focusVisible": {
                boxShadow: theme.shadows[6]
            },
            "&:active": {
                boxShadow: theme.shadows[8]
            },
            "&$disabled": {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: "none",
            "&:hover": {
                boxShadow: "none"
            },
            "&$focusVisible": {
                boxShadow: "none"
            },
            "&:active": {
                boxShadow: "none"
            },
            "&$disabled": {
                boxShadow: "none"
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit",
            borderColor: "currentColor"
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: "4px 5px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: "8px 11px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: "3px 9px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: "7px 21px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: "4px 10px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: "8px 22px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: "inherit",
            marginRight: 8,
            marginLeft: -4,
            "&$iconSizeSmall": {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: "inherit",
            marginRight: -4,
            marginLeft: 8,
            "&$iconSizeSmall": {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            "& > *:first-child": {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            "& > *:first-child": {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            "& > *:first-child": {
                fontSize: 22
            }
        }
    };
};
var $fbbbaa513a82e075$var$Button = /*#__PURE__*/ $arQ7u.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? "text" : _props$variant, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $arQ7u.createElement("span", {
        className: (0, $5g55B.default)(classes.startIcon, classes["iconSize".concat((0, $kaLUp.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $arQ7u.createElement("span", {
        className: (0, $5g55B.default)(classes.endIcon, classes["iconSize".concat((0, $kaLUp.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $arQ7u.createElement((0, $b71IR.default), (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, classes[variant], className, color === "inherit" ? classes.colorInherit : color !== "default" && classes["".concat(variant).concat((0, $kaLUp.default)(color))], size !== "medium" && [
            classes["".concat(variant, "Size").concat((0, $kaLUp.default)(size))],
            classes["size".concat((0, $kaLUp.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $5g55B.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $arQ7u.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $fbbbaa513a82e075$export$2e2bcd8739ae039 = (0, $7EzGR.default)($fbbbaa513a82e075$export$9dd6ff9ea0189349, {
    name: "MuiButton"
})($fbbbaa513a82e075$var$Button);

});

parcelRegister("elqE0", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a717b1dd3f42f37d$var$React = $363GR((parcelRequire("arQ7u")));

var $a717b1dd3f42f37d$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $a717b1dd3f42f37d$var$_default = (0, $a717b1dd3f42f37d$var$_createSvgIcon.default)(/*#__PURE__*/ $a717b1dd3f42f37d$var$React.createElement("path", {
    d: "M3 14h4v-4H3v4zm0 5h4v-4H3v4zM3 9h4V5H3v4zm5 5h12v-4H8v4zm0 5h12v-4H8v4zM8 5v4h12V5H8z"
}), "ViewListSharp");
module.exports.default = $a717b1dd3f42f37d$var$_default;

});



parcelRegister("jS07C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e77327ad98b8a6fb$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $7GY88 = parcelRequire("7GY88");

var $bMHoB = parcelRequire("bMHoB");
/**
 * mapStateToProps - to hook up connect
 * @memberof WindowSideBarInfoPanel
 * @private
 */ var $e77327ad98b8a6fb$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, windowId = _ref.windowId;
    return {
        homepage: (0, $7GY88.getManifestHomepage)(state, {
            windowId: windowId
        }),
        manifestUrl: (0, $7GY88.getManifestUrl)(state, {
            windowId: windowId
        }),
        renderings: (0, $7GY88.getManifestRenderings)(state, {
            windowId: windowId
        }),
        seeAlso: (0, $7GY88.getManifestRelatedContent)(state, {
            windowId: windowId
        })
    };
};
var $e77327ad98b8a6fb$var$styles = {
    labelValueMetadata: {
        "& dd": {
            marginBottom: ".5em",
            marginLeft: "0"
        }
    }
};
var $e77327ad98b8a6fb$var$enhance = (0, $k19ic.compose)((0, $7EzGR.default)($e77327ad98b8a6fb$var$styles), (0, $eC0Mc.withTranslation)(), (0, $fbonu.default)($e77327ad98b8a6fb$var$mapStateToProps), (0, $7XHRd.withPlugins)("ManifestRelatedLinks"));
var $e77327ad98b8a6fb$export$2e2bcd8739ae039 = $e77327ad98b8a6fb$var$enhance((0, $bMHoB.ManifestRelatedLinks));

});
parcelRegister("bMHoB", function(module, exports) {

$parcel$export(module.exports, "ManifestRelatedLinks", function () { return $8945d6ea9ab2c144$export$bff9c1990357d91b; });

var $arQ7u = parcelRequire("arQ7u");

var $hsH5s = parcelRequire("hsH5s");

var $8Mo9a = parcelRequire("8Mo9a");

var $dErw7 = parcelRequire("dErw7");

var $ltnUe = parcelRequire("ltnUe");

var $1xlvK = parcelRequire("1xlvK");

var $lyw4f = parcelRequire("lyw4f");
function $8945d6ea9ab2c144$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8945d6ea9ab2c144$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8945d6ea9ab2c144$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8945d6ea9ab2c144$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8945d6ea9ab2c144$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8945d6ea9ab2c144$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8945d6ea9ab2c144$var$_setPrototypeOf(subClass, superClass);
}
function $8945d6ea9ab2c144$var$_setPrototypeOf(o, p) {
    $8945d6ea9ab2c144$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8945d6ea9ab2c144$var$_setPrototypeOf(o, p);
}
function $8945d6ea9ab2c144$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8945d6ea9ab2c144$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8945d6ea9ab2c144$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8945d6ea9ab2c144$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8945d6ea9ab2c144$var$_possibleConstructorReturn(this, result);
    };
}
function $8945d6ea9ab2c144$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8945d6ea9ab2c144$var$_assertThisInitialized(self);
}
function $8945d6ea9ab2c144$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8945d6ea9ab2c144$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8945d6ea9ab2c144$var$_getPrototypeOf(o) {
    $8945d6ea9ab2c144$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8945d6ea9ab2c144$var$_getPrototypeOf(o);
}
var $8945d6ea9ab2c144$export$bff9c1990357d91b = /*#__PURE__*/ function(_Component) {
    $8945d6ea9ab2c144$var$_inherits(ManifestRelatedLinks, _Component);
    var _super = $8945d6ea9ab2c144$var$_createSuper(ManifestRelatedLinks);
    function ManifestRelatedLinks() {
        $8945d6ea9ab2c144$var$_classCallCheck(this, ManifestRelatedLinks);
        return _super.apply(this, arguments);
    }
    $8945d6ea9ab2c144$var$_createClass(ManifestRelatedLinks, [
        {
            key: "render",
            value: /**
     * render
     * @return
     */ function render() {
                var _this$props = this.props, classes = _this$props.classes, homepage = _this$props.homepage, manifestUrl = _this$props.manifestUrl, renderings = _this$props.renderings, seeAlso = _this$props.seeAlso, id = _this$props.id, t = _this$props.t;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $ltnUe.default), {
                    id: "".concat(id, "-related"),
                    label: t("related")
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    "aria-labelledby": "".concat(id, "-related ").concat(id, "-related-heading"),
                    id: "".concat(id, "-related-heading"),
                    variant: "h4",
                    component: "h5"
                }, t("links")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("dl", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dErw7)))((0, $1xlvK.default)("label-value-metadata"), classes.labelValueMetadata)
                }, homepage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "subtitle2",
                    component: "dt"
                }, t("iiif_homepage")), homepage.map(function(page) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                        key: page.value,
                        variant: "body1",
                        component: "dd"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $8Mo9a.default), {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: page.value
                    }, page.label || page.value));
                })), renderings && renderings.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "subtitle2",
                    component: "dt"
                }, t("iiif_renderings")), renderings.map(function(rendering) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                        key: rendering.value,
                        variant: "body1",
                        component: "dd"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $8Mo9a.default), {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: rendering.value
                    }, rendering.label || rendering.value));
                })), seeAlso && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "subtitle2",
                    component: "dt"
                }, t("iiif_seeAlso")), seeAlso.map(function(related) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                        key: related.value,
                        variant: "body1",
                        component: "dd"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $8Mo9a.default), {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: related.value
                    }, related.label || related.value), related.format && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                        component: "span"
                    }, " (".concat(related.format, ")")));
                })), manifestUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "subtitle2",
                    component: "dt"
                }, t("iiif_manifest")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "body1",
                    component: "dd"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $8Mo9a.default), {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: manifestUrl
                }, manifestUrl)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $lyw4f.PluginHook), this.props));
            }
        }
    ]);
    return ManifestRelatedLinks;
}((0, $arQ7u.Component));
$8945d6ea9ab2c144$export$bff9c1990357d91b.defaultProps = {
    homepage: null,
    manifestUrl: null,
    renderings: null,
    seeAlso: null,
    t: function t(key) {
        return key;
    }
};

});
parcelRegister("8Mo9a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6645897da9af09de$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $kaLUp = parcelRequire("kaLUp");

var $7EzGR = parcelRequire("7EzGR");


var $cvMUO = parcelRequire("cvMUO");

var $nGnd5 = parcelRequire("nGnd5");

var $hsH5s = parcelRequire("hsH5s");
var $6645897da9af09de$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the root element if `underline="none"`. */ underlineNone: {
        textDecoration: "none"
    },
    /* Styles applied to the root element if `underline="hover"`. */ underlineHover: {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
    /* Styles applied to the root element if `underline="always"`. */ underlineAlways: {
        textDecoration: "underline"
    },
    // Same reset as ButtonBase.root
    /* Styles applied to the root element if `component="button"`. */ button: {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$focusVisible": {
            outline: "auto"
        }
    },
    /* Pseudo-class applied to the root element if the link is keyboard focused. */ focusVisible: {}
};
var $6645897da9af09de$var$Link = /*#__PURE__*/ $arQ7u.forwardRef(function Link(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "a" : _props$component, onBlur = props.onBlur, onFocus = props.onFocus, TypographyClasses = props.TypographyClasses, _props$underline = props.underline, underline = _props$underline === void 0 ? "hover" : _props$underline, _props$variant = props.variant, variant = _props$variant === void 0 ? "inherit" : _props$variant, other = (0, $dXEVX.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "onBlur",
        "onFocus",
        "TypographyClasses",
        "underline",
        "variant"
    ]);
    var _useIsFocusVisible = (0, $cvMUO.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState = $arQ7u.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    var handlerRef = (0, $nGnd5.default)(ref, focusVisibleRef);
    var handleBlur = function handleBlur(event) {
        if (focusVisible) {
            onBlurVisible();
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    };
    var handleFocus = function handleFocus(event) {
        if (isFocusVisible(event)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ $arQ7u.createElement((0, $hsH5s.default), (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, classes["underline".concat((0, $kaLUp.default)(underline))], className, focusVisible && classes.focusVisible, component === "button" && classes.button),
        classes: TypographyClasses,
        color: color,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        variant: variant
    }, other));
});
var $6645897da9af09de$export$2e2bcd8739ae039 = (0, $7EzGR.default)($6645897da9af09de$export$9dd6ff9ea0189349, {
    name: "MuiLink"
})($6645897da9af09de$var$Link);

});





parcelRegister("jI1lG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5932c37aa7cb04c$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $10Wbc = parcelRequire("10Wbc");
var $k4YEs = parcelRequire("k4YEs");

var $a1Xdj = parcelRequire("a1Xdj");

var $24Kso = parcelRequire("24Kso");
var $dJvB2 = parcelRequire("dJvB2");
var $7GY88 = parcelRequire("7GY88");
var $51Gx5 = parcelRequire("51Gx5");
var $dy9HC = parcelRequire("dy9HC");
/**
 * mapStateToProps - to hook up connect
 */ var $e5932c37aa7cb04c$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, windowId = _ref.windowId;
    var treeStructure = (0, $51Gx5.getSequenceTreeStructure)(state, {
        windowId: windowId
    });
    var window = (0, $dy9HC.getWindow)(state, {
        windowId: windowId
    });
    var config = state.config;
    var companionWindow = (0, $24Kso.getCompanionWindow)(state, {
        companionWindowId: id
    });
    var collectionPath = window.collectionPath || [];
    var collectionId = collectionPath && collectionPath[collectionPath.length - 1];
    var sequence = (0, $51Gx5.getSequence)(state, {
        windowId: windowId
    });
    return {
        collection: collectionId && (0, $7GY88.getManifestoInstance)(state, {
            manifestId: collectionId
        }),
        config: config,
        sequenceId: sequence && sequence.id,
        sequences: (0, $51Gx5.getSequences)(state, {
            windowId: windowId
        }),
        showToc: treeStructure && treeStructure.nodes && treeStructure.nodes.length > 0,
        variant: companionWindow.variant || (0, $dJvB2.getDefaultSidebarVariant)(state, {
            windowId: windowId
        })
    };
};
/**
 * mapStateToProps - used to hook up connect to state
 * @memberof WindowSideBarCanvasPanel
 * @private
 */ var $e5932c37aa7cb04c$var$mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
    var id = _ref2.id, windowId = _ref2.windowId;
    return {
        showMultipart: function showMultipart() {
            return dispatch($10Wbc.addOrUpdateCompanionWindow(windowId, {
                content: "collection",
                position: "right"
            }));
        },
        updateSequence: function updateSequence(sequenceId) {
            return dispatch($k4YEs.updateWindow(windowId, {
                sequenceId: sequenceId
            }));
        },
        updateVariant: function updateVariant(variant) {
            return dispatch($10Wbc.updateCompanionWindow(windowId, id, {
                variant: variant
            }));
        }
    };
};
/**
 *
 * @param theme
 */ var $e5932c37aa7cb04c$var$styles = function styles(theme) {
    return {
        "break": {
            flexBasis: "100%",
            height: 0
        },
        collectionNavigationButton: {
            textTransform: "none"
        },
        label: {
            paddingLeft: theme.spacing(1)
        },
        select: {
            "&:focus": {
                backgroundColor: theme.palette.background.paper
            }
        },
        selectEmpty: {
            backgroundColor: theme.palette.background.paper
        },
        variantTab: {
            minWidth: "auto"
        }
    };
};
var $e5932c37aa7cb04c$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $7EzGR.default)($e5932c37aa7cb04c$var$styles), (0, $fbonu.default)($e5932c37aa7cb04c$var$mapStateToProps, $e5932c37aa7cb04c$var$mapDispatchToProps), (0, $7XHRd.withPlugins)("WindowSideBarCanvasPanel"));
var $e5932c37aa7cb04c$export$2e2bcd8739ae039 = $e5932c37aa7cb04c$var$enhance((0, $a1Xdj.WindowSideBarCanvasPanel));

});
parcelRegister("a1Xdj", function(module, exports) {

$parcel$export(module.exports, "WindowSideBarCanvasPanel", function () { return $74d7edf82b782cd4$export$1ba7ae229efb6422; });

var $arQ7u = parcelRequire("arQ7u");

var $jLvDK = parcelRequire("jLvDK");

var $2Djn5 = parcelRequire("2Djn5");

var $e59gp = parcelRequire("e59gp");

var $lBY5E = parcelRequire("lBY5E");

var $04lw7 = parcelRequire("04lw7");

var $i4Kex = parcelRequire("i4Kex");

var $elqE0 = parcelRequire("elqE0");

var $hsH5s = parcelRequire("hsH5s");

var $61uru = parcelRequire("61uru");

var $f3WEt = parcelRequire("f3WEt");

var $c6RGo = parcelRequire("c6RGo");

var $2NDUy = parcelRequire("2NDUy");

var $iXAXt = parcelRequire("iXAXt");

var $79FNp = parcelRequire("79FNp");

var $64PgQ = parcelRequire("64PgQ");
function $74d7edf82b782cd4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $74d7edf82b782cd4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $74d7edf82b782cd4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $74d7edf82b782cd4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $74d7edf82b782cd4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $74d7edf82b782cd4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $74d7edf82b782cd4$var$_setPrototypeOf(subClass, superClass);
}
function $74d7edf82b782cd4$var$_setPrototypeOf(o, p) {
    $74d7edf82b782cd4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $74d7edf82b782cd4$var$_setPrototypeOf(o, p);
}
function $74d7edf82b782cd4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $74d7edf82b782cd4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $74d7edf82b782cd4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $74d7edf82b782cd4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $74d7edf82b782cd4$var$_possibleConstructorReturn(this, result);
    };
}
function $74d7edf82b782cd4$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $74d7edf82b782cd4$var$_assertThisInitialized(self);
}
function $74d7edf82b782cd4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $74d7edf82b782cd4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $74d7edf82b782cd4$var$_getPrototypeOf(o) {
    $74d7edf82b782cd4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $74d7edf82b782cd4$var$_getPrototypeOf(o);
}
var $74d7edf82b782cd4$export$1ba7ae229efb6422 = /*#__PURE__*/ function(_Component) {
    $74d7edf82b782cd4$var$_inherits(WindowSideBarCanvasPanel, _Component);
    var _super = $74d7edf82b782cd4$var$_createSuper(WindowSideBarCanvasPanel);
    /** */ function WindowSideBarCanvasPanel(props) {
        var _this;
        $74d7edf82b782cd4$var$_classCallCheck(this, WindowSideBarCanvasPanel);
        _this = _super.call(this, props);
        _this.handleSequenceChange = _this.handleSequenceChange.bind($74d7edf82b782cd4$var$_assertThisInitialized(_this));
        _this.handleVariantChange = _this.handleVariantChange.bind($74d7edf82b782cd4$var$_assertThisInitialized(_this));
        _this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createRef();
        return _this;
    }
    /** */ $74d7edf82b782cd4$var$_createClass(WindowSideBarCanvasPanel, [
        {
            key: "handleSequenceChange",
            value: /** @private */ function handleSequenceChange(event) {
                var updateSequence = this.props.updateSequence;
                updateSequence(event.target.value);
            }
        },
        {
            key: "handleVariantChange",
            value: function handleVariantChange(event, value) {
                var updateVariant = this.props.updateVariant;
                updateVariant(value);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, classes = _this$props.classes, collection = _this$props.collection, id = _this$props.id, showMultipart = _this$props.showMultipart, sequenceId = _this$props.sequenceId, sequences = _this$props.sequences, t = _this$props.t, variant = _this$props.variant, showToc = _this$props.showToc, windowId = _this$props.windowId;
                var listComponent;
                if (variant === "tableOfContents") listComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $64PgQ.default), {
                    id: id,
                    containerRef: this.containerRef,
                    windowId: windowId
                });
                else listComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $79FNp.default), {
                    id: id,
                    containerRef: this.containerRef,
                    windowId: windowId
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iXAXt.default), {
                    title: t("canvasIndex"),
                    id: id,
                    windowId: windowId,
                    ref: this.containerRef,
                    otherRef: this.containerRef,
                    titleControls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, sequences && sequences.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $f3WEt.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $c6RGo.default), {
                        MenuProps: {
                            anchorOrigin: {
                                horizontal: "left",
                                vertical: "bottom"
                            },
                            getContentAnchorEl: null
                        },
                        displayEmpty: true,
                        value: sequenceId,
                        onChange: this.handleSequenceChange,
                        name: "sequenceId",
                        classes: {
                            select: classes.select
                        },
                        className: classes.selectEmpty
                    }, sequences.map(function(s, i) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $2NDUy.default), {
                            value: s.id,
                            key: s.id
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                            variant: "body2"
                        }, WindowSideBarCanvasPanel.getUseableLabel(s, i)));
                    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                        className: classes["break"]
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $jLvDK.default), {
                        value: variant,
                        onChange: this.handleVariantChange,
                        variant: "fullWidth",
                        indicatorColor: "primary",
                        textColor: "primary"
                    }, showToc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $e59gp.default), {
                        title: t("tableOfContentsList"),
                        value: "tableOfContents"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $2Djn5.default), {
                        className: classes.variantTab,
                        value: "tableOfContents",
                        "aria-label": t("tableOfContentsList"),
                        "aria-controls": "tab-panel-".concat(id),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i4Kex))), {
                            style: {
                                transform: "scale(-1, 1)"
                            }
                        })
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $e59gp.default), {
                        title: t("itemList"),
                        value: "item"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $2Djn5.default), {
                        className: classes.variantTab,
                        value: "item",
                        "aria-label": t("itemList"),
                        "aria-controls": "tab-panel-".concat(id),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($04lw7))), null)
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $e59gp.default), {
                        title: t("thumbnailList"),
                        value: "thumbnail"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $2Djn5.default), {
                        className: classes.variantTab,
                        value: "thumbnail",
                        "aria-label": t("thumbnailList"),
                        "aria-controls": "tab-panel-".concat(id),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elqE0))), null)
                    }))))
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    id: "tab-panel-".concat(id)
                }, collection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $lBY5E.default), {
                    fullWidth: true,
                    onClick: showMultipart,
                    endIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($61uru))), null)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    className: classes.collectionNavigationButton
                }, WindowSideBarCanvasPanel.getUseableLabel(collection))), listComponent));
            }
        }
    ], [
        {
            key: "getUseableLabel",
            value: function getUseableLabel(resource, index) {
                return resource && resource.getLabel && resource.getLabel().length > 0 ? resource.getLabel().getValue() : resource.id;
            }
        }
    ]);
    return WindowSideBarCanvasPanel;
}((0, $arQ7u.Component));
$74d7edf82b782cd4$export$1ba7ae229efb6422.defaultProps = {
    collection: null,
    sequenceId: null,
    sequences: [],
    showToc: false
};

});
parcelRegister("jLvDK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e63af32d34c79e6c$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $4g0WD = parcelRequire("4g0WD");

var $arQ7u = parcelRequire("arQ7u");
parcelRequire("legPH");


var $5g55B = parcelRequire("5g55B");


var $iEYEM = parcelRequire("iEYEM");

var $eUmzP = parcelRequire("eUmzP");

var $81idJ = parcelRequire("81idJ");

var $cCz4K = parcelRequire("cCz4K");

var $iFfml = parcelRequire("iFfml");

var $7EzGR = parcelRequire("7EzGR");

var $hl8T3 = parcelRequire("hl8T3");

var $ghcLq = parcelRequire("ghcLq");

var $e3Evk = parcelRequire("e3Evk");

var $j1k3T = parcelRequire("j1k3T");
var $e63af32d34c79e6c$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: "hidden",
            minHeight: 48,
            WebkitOverflowScrolling: "touch",
            // Add iOS momentum scrolling.
            display: "flex"
        },
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
            flexDirection: "column"
        },
        /* Styles applied to the flex container element. */ flexContainer: {
            display: "flex"
        },
        /* Styles applied to the flex container element if `orientation="vertical"`. */ flexContainerVertical: {
            flexDirection: "column"
        },
        /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */ centered: {
            justifyContent: "center"
        },
        /* Styles applied to the tablist element. */ scroller: {
            position: "relative",
            display: "inline-block",
            flex: "1 1 auto",
            whiteSpace: "nowrap"
        },
        /* Styles applied to the tablist element if `!variant="scrollable"`. */ fixed: {
            overflowX: "hidden",
            width: "100%"
        },
        /* Styles applied to the tablist element if `variant="scrollable"`. */ scrollable: {
            overflowX: "scroll",
            // Hide dimensionless scrollbar on MacOS
            scrollbarWidth: "none",
            // Firefox
            "&::-webkit-scrollbar": {
                display: "none" // Safari + Chrome
            }
        },
        /* Styles applied to the `ScrollButtonComponent` component. */ scrollButtons: {},
        /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */ scrollButtonsDesktop: (0, $4g0WD.default)({}, theme.breakpoints.down("xs"), {
            display: "none"
        }),
        /* Styles applied to the `TabIndicator` component. */ indicator: {}
    };
};
var $e63af32d34c79e6c$var$Tabs = /*#__PURE__*/ $arQ7u.forwardRef(function Tabs(props, ref) {
    var ariaLabel = props["aria-label"], ariaLabelledBy = props["aria-labelledby"], action = props.action, _props$centered = props.centered, centered = _props$centered === void 0 ? false : _props$centered, childrenProp = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$indicatorColor = props.indicatorColor, indicatorColor = _props$indicatorColor === void 0 ? "secondary" : _props$indicatorColor, onChange = props.onChange, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, _props$ScrollButtonCo = props.ScrollButtonComponent, ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? (0, $ghcLq.default) : _props$ScrollButtonCo, _props$scrollButtons = props.scrollButtons, scrollButtons = _props$scrollButtons === void 0 ? "auto" : _props$scrollButtons, selectionFollowsFocus = props.selectionFollowsFocus, _props$TabIndicatorPr = props.TabIndicatorProps, TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr, TabScrollButtonProps = props.TabScrollButtonProps, _props$textColor = props.textColor, textColor = _props$textColor === void 0 ? "inherit" : _props$textColor, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $dXEVX.default)(props, [
        "aria-label",
        "aria-labelledby",
        "action",
        "centered",
        "children",
        "classes",
        "className",
        "component",
        "indicatorColor",
        "onChange",
        "orientation",
        "ScrollButtonComponent",
        "scrollButtons",
        "selectionFollowsFocus",
        "TabIndicatorProps",
        "TabScrollButtonProps",
        "textColor",
        "value",
        "variant"
    ]);
    var theme = (0, $j1k3T.default)();
    var scrollable = variant === "scrollable";
    var isRtl = theme.direction === "rtl";
    var vertical = orientation === "vertical";
    var scrollStart = vertical ? "scrollTop" : "scrollLeft";
    var start = vertical ? "top" : "left";
    var end = vertical ? "bottom" : "right";
    var clientSize = vertical ? "clientHeight" : "clientWidth";
    var size = vertical ? "height" : "width";
    var _React$useState = $arQ7u.useState(false), mounted = _React$useState[0], setMounted = _React$useState[1];
    var _React$useState2 = $arQ7u.useState({}), indicatorStyle = _React$useState2[0], setIndicatorStyle = _React$useState2[1];
    var _React$useState3 = $arQ7u.useState({
        start: false,
        end: false
    }), displayScroll = _React$useState3[0], setDisplayScroll = _React$useState3[1];
    var _React$useState4 = $arQ7u.useState({
        overflow: "hidden",
        marginBottom: null
    }), scrollerStyle = _React$useState4[0], setScrollerStyle = _React$useState4[1];
    var valueToIndex = new Map();
    var tabsRef = $arQ7u.useRef(null);
    var tabListRef = $arQ7u.useRef(null);
    var getTabsMeta = function getTabsMeta() {
        var tabsNode = tabsRef.current;
        var tabsMeta;
        if (tabsNode) {
            var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $81idJ.getNormalizedScrollLeft)(tabsNode, theme.direction),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        var tabMeta;
        if (tabsNode && value !== false) {
            var _children = tabListRef.current.children;
            if (_children.length > 0) {
                var tab = _children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    var updateIndicatorState = (0, $e3Evk.default)(function() {
        var _newIndicatorStyle;
        var _getTabsMeta = getTabsMeta(), tabsMeta = _getTabsMeta.tabsMeta, tabMeta = _getTabsMeta.tabMeta;
        var startValue = 0;
        if (tabMeta && tabsMeta) {
            if (vertical) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
            else {
                var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = tabMeta.left - tabsMeta.left + correction;
            }
        }
        var newIndicatorStyle = (_newIndicatorStyle = {}, (0, $4g0WD.default)(_newIndicatorStyle, start, startValue), (0, $4g0WD.default)(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);
        if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
            var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    var scroll = function scroll(scrollValue) {
        (0, $cCz4K.default)(scrollStart, tabsRef.current, scrollValue);
    };
    var moveTabsScroll = function moveTabsScroll(delta) {
        var scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge
            scrollValue *= isRtl && (0, $81idJ.detectScrollType)() === "reverse" ? -1 : 1;
        }
        scroll(scrollValue);
    };
    var handleStartScrollClick = function handleStartScrollClick() {
        moveTabsScroll(-tabsRef.current[clientSize]);
    };
    var handleEndScrollClick = function handleEndScrollClick() {
        moveTabsScroll(tabsRef.current[clientSize]);
    };
    var handleScrollbarSizeChange = $arQ7u.useCallback(function(scrollbarHeight) {
        setScrollerStyle({
            overflow: null,
            marginBottom: -scrollbarHeight
        });
    }, []);
    var getConditionalElements = function getConditionalElements() {
        var conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ $arQ7u.createElement((0, $iFfml.default), {
            className: classes.scrollable,
            onChange: handleScrollbarSizeChange
        }) : null;
        var scrollButtonsActive = displayScroll.start || displayScroll.end;
        var showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === "desktop" || scrollButtons === "on");
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ $arQ7u.createElement(ScrollButtonComponent, (0, $abElG.default)({
            orientation: orientation,
            direction: isRtl ? "right" : "left",
            onClick: handleStartScrollClick,
            disabled: !displayScroll.start,
            className: (0, $5g55B.default)(classes.scrollButtons, scrollButtons !== "on" && classes.scrollButtonsDesktop)
        }, TabScrollButtonProps)) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ $arQ7u.createElement(ScrollButtonComponent, (0, $abElG.default)({
            orientation: orientation,
            direction: isRtl ? "left" : "right",
            onClick: handleEndScrollClick,
            disabled: !displayScroll.end,
            className: (0, $5g55B.default)(classes.scrollButtons, scrollButtons !== "on" && classes.scrollButtonsDesktop)
        }, TabScrollButtonProps)) : null;
        return conditionalElements;
    };
    var scrollSelectedIntoView = (0, $e3Evk.default)(function() {
        var _getTabsMeta2 = getTabsMeta(), tabsMeta = _getTabsMeta2.tabsMeta, tabMeta = _getTabsMeta2.tabMeta;
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart);
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(_nextScrollStart);
        }
    });
    var updateScrollButtonState = (0, $e3Evk.default)(function() {
        if (scrollable && scrollButtons !== "off") {
            var _tabsRef$current = tabsRef.current, scrollTop = _tabsRef$current.scrollTop, scrollHeight = _tabsRef$current.scrollHeight, clientHeight = _tabsRef$current.clientHeight, scrollWidth = _tabsRef$current.scrollWidth, clientWidth = _tabsRef$current.clientWidth;
            var showStartScroll;
            var showEndScroll;
            if (vertical) {
                showStartScroll = scrollTop > 1;
                showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
            } else {
                var scrollLeft = (0, $81idJ.getNormalizedScrollLeft)(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.
                showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
                showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
            }
            if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) setDisplayScroll({
                start: showStartScroll,
                end: showEndScroll
            });
        }
    });
    $arQ7u.useEffect(function() {
        var handleResize = (0, $iEYEM.default)(function() {
            updateIndicatorState();
            updateScrollButtonState();
        });
        var win = (0, $eUmzP.default)(tabsRef.current);
        win.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            win.removeEventListener("resize", handleResize);
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    var handleTabsScroll = $arQ7u.useCallback((0, $iEYEM.default)(function() {
        updateScrollButtonState();
    }));
    $arQ7u.useEffect(function() {
        return function() {
            handleTabsScroll.clear();
        };
    }, [
        handleTabsScroll
    ]);
    $arQ7u.useEffect(function() {
        setMounted(true);
    }, []);
    $arQ7u.useEffect(function() {
        updateIndicatorState();
        updateScrollButtonState();
    });
    $arQ7u.useEffect(function() {
        scrollSelectedIntoView();
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $arQ7u.useImperativeHandle(action, function() {
        return {
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    var indicator = /*#__PURE__*/ $arQ7u.createElement((0, $hl8T3.default), (0, $abElG.default)({
        className: classes.indicator,
        orientation: orientation,
        color: indicatorColor
    }, TabIndicatorProps, {
        style: (0, $abElG.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    var childIndex = 0;
    var children = $arQ7u.Children.map(childrenProp, function(child) {
        if (!/*#__PURE__*/ $arQ7u.isValidElement(child)) return null;
        var childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        var selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $arQ7u.cloneElement(child, {
            fullWidth: variant === "fullWidth",
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        });
    });
    var handleKeyDown = function handleKeyDown(event) {
        var target = event.target; // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        var role = target.getAttribute("role");
        if (role !== "tab") return;
        var newFocusTarget = null;
        var previousItemKey = orientation !== "vertical" ? "ArrowLeft" : "ArrowUp";
        var nextItemKey = orientation !== "vertical" ? "ArrowRight" : "ArrowDown";
        if (orientation !== "vertical" && theme.direction === "rtl") {
            // swap previousItemKey with nextItemKey
            previousItemKey = "ArrowRight";
            nextItemKey = "ArrowLeft";
        }
        switch(event.key){
            case previousItemKey:
                newFocusTarget = target.previousElementSibling || tabListRef.current.lastChild;
                break;
            case nextItemKey:
                newFocusTarget = target.nextElementSibling || tabListRef.current.firstChild;
                break;
            case "Home":
                newFocusTarget = tabListRef.current.firstChild;
                break;
            case "End":
                newFocusTarget = tabListRef.current.lastChild;
                break;
            default:
                break;
        }
        if (newFocusTarget !== null) {
            newFocusTarget.focus();
            event.preventDefault();
        }
    };
    var conditionalElements = getConditionalElements();
    return /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, vertical && classes.vertical),
        ref: ref
    }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/ $arQ7u.createElement("div", {
        className: (0, $5g55B.default)(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
        style: scrollerStyle,
        ref: tabsRef,
        onScroll: handleTabsScroll
    }, /*#__PURE__*/ $arQ7u.createElement("div", {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        className: (0, $5g55B.default)(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
        onKeyDown: handleKeyDown,
        ref: tabListRef,
        role: "tablist"
    }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
});
var $e63af32d34c79e6c$export$2e2bcd8739ae039 = (0, $7EzGR.default)($e63af32d34c79e6c$export$9dd6ff9ea0189349, {
    name: "MuiTabs"
})($e63af32d34c79e6c$var$Tabs);

});
parcelRegister("81idJ", function(module, exports) {

$parcel$export(module.exports, "detectScrollType", function () { return $5d6c8ce88299a931$export$a10970ffb6510128; });
$parcel$export(module.exports, "getNormalizedScrollLeft", function () { return $5d6c8ce88299a931$export$3c615b88e5d7e4f6; });
// Source from https://github.com/alitaheri/normalize-scroll-left
var $5d6c8ce88299a931$var$cachedType;
function $5d6c8ce88299a931$export$a10970ffb6510128() {
    if ($5d6c8ce88299a931$var$cachedType) return $5d6c8ce88299a931$var$cachedType;
    var dummy = document.createElement("div");
    var container = document.createElement("div");
    container.style.width = "10px";
    container.style.height = "1px";
    dummy.appendChild(container);
    dummy.dir = "rtl";
    dummy.style.fontSize = "14px";
    dummy.style.width = "4px";
    dummy.style.height = "1px";
    dummy.style.position = "absolute";
    dummy.style.top = "-1000px";
    dummy.style.overflow = "scroll";
    document.body.appendChild(dummy);
    $5d6c8ce88299a931$var$cachedType = "reverse";
    if (dummy.scrollLeft > 0) $5d6c8ce88299a931$var$cachedType = "default";
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $5d6c8ce88299a931$var$cachedType = "negative";
    }
    document.body.removeChild(dummy);
    return $5d6c8ce88299a931$var$cachedType;
} // Based on https://stackoverflow.com/a/24394376
function $5d6c8ce88299a931$export$3c615b88e5d7e4f6(element, direction) {
    var scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== "rtl") return scrollLeft;
    var type = $5d6c8ce88299a931$export$a10970ffb6510128();
    switch(type){
        case "negative":
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case "reverse":
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}

});

parcelRegister("cCz4K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93043de6af8eb281$export$2e2bcd8739ae039; });
function $93043de6af8eb281$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $93043de6af8eb281$export$2e2bcd8739ae039(property, element, to) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function() {};
    var _options$ease = options.ease, ease = _options$ease === void 0 ? $93043de6af8eb281$var$easeInOutSin : _options$ease, _options$duration = options.duration, duration = _options$duration === void 0 ? 300 : _options$duration;
    var start = null;
    var from = element[property];
    var cancelled = false;
    var cancel = function cancel() {
        cancelled = true;
    };
    var step = function step(timestamp) {
        if (cancelled) {
            cb(new Error("Animation cancelled"));
            return;
        }
        if (start === null) start = timestamp;
        var time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(function() {
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error("Element already at target position"));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

});

parcelRegister("iFfml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d967f85f62e13a2c$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $iEYEM = parcelRequire("iEYEM");
var $d967f85f62e13a2c$var$styles = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll"
};
function $d967f85f62e13a2c$export$2e2bcd8739ae039(props) {
    var onChange = props.onChange, other = (0, $dXEVX.default)(props, [
        "onChange"
    ]);
    var scrollbarHeight = $arQ7u.useRef();
    var nodeRef = $arQ7u.useRef(null);
    var setMeasurements = function setMeasurements() {
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    $arQ7u.useEffect(function() {
        var handleResize = (0, $iEYEM.default)(function() {
            var prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        onChange
    ]);
    $arQ7u.useEffect(function() {
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ $arQ7u.createElement("div", (0, $abElG.default)({
        style: $d967f85f62e13a2c$var$styles,
        ref: nodeRef
    }, other));
}

});

parcelRegister("hl8T3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9fb4a9b81e057e2$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");

var $kaLUp = parcelRequire("kaLUp");
var $c9fb4a9b81e057e2$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        root: {
            position: "absolute",
            height: 2,
            bottom: 0,
            width: "100%",
            transition: theme.transitions.create()
        },
        colorPrimary: {
            backgroundColor: theme.palette.primary.main
        },
        colorSecondary: {
            backgroundColor: theme.palette.secondary.main
        },
        vertical: {
            height: "100%",
            width: 2,
            right: 0
        }
    };
};
/**
 * @ignore - internal component.
 */ var $c9fb4a9b81e057e2$var$TabIndicator = /*#__PURE__*/ $arQ7u.forwardRef(function TabIndicator(props, ref) {
    var classes = props.classes, className = props.className, color = props.color, orientation = props.orientation, other = (0, $dXEVX.default)(props, [
        "classes",
        "className",
        "color",
        "orientation"
    ]);
    return /*#__PURE__*/ $arQ7u.createElement("span", (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, classes["color".concat((0, $kaLUp.default)(color))], className, orientation === "vertical" && classes.vertical),
        ref: ref
    }, other));
});
var $c9fb4a9b81e057e2$export$2e2bcd8739ae039 = (0, $7EzGR.default)($c9fb4a9b81e057e2$export$9dd6ff9ea0189349, {
    name: "PrivateTabIndicator"
})($c9fb4a9b81e057e2$var$TabIndicator);

});

parcelRegister("ghcLq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd982289c98ea88e$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $8zhjD = parcelRequire("8zhjD");

var $6S01B = parcelRequire("6S01B");

var $7EzGR = parcelRequire("7EzGR");

var $b71IR = parcelRequire("b71IR");
var $bd982289c98ea88e$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        "&$disabled": {
            opacity: 0
        }
    },
    /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
        width: "100%",
        height: 40,
        "& svg": {
            transform: "rotate(90deg)"
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {}
};
var $bd982289c98ea88e$var$_ref = /*#__PURE__*/ $arQ7u.createElement((0, $8zhjD.default), {
    fontSize: "small"
});
var $bd982289c98ea88e$var$_ref2 = /*#__PURE__*/ $arQ7u.createElement((0, $6S01B.default), {
    fontSize: "small"
});
var $bd982289c98ea88e$var$TabScrollButton = /*#__PURE__*/ $arQ7u.forwardRef(function TabScrollButton(props, ref) {
    var classes = props.classes, classNameProp = props.className, direction = props.direction, orientation = props.orientation, disabled = props.disabled, other = (0, $dXEVX.default)(props, [
        "classes",
        "className",
        "direction",
        "orientation",
        "disabled"
    ]);
    return /*#__PURE__*/ $arQ7u.createElement((0, $b71IR.default), (0, $abElG.default)({
        component: "div",
        className: (0, $5g55B.default)(classes.root, classNameProp, disabled && classes.disabled, orientation === "vertical" && classes.vertical),
        ref: ref,
        role: null,
        tabIndex: null
    }, other), direction === "left" ? $bd982289c98ea88e$var$_ref : $bd982289c98ea88e$var$_ref2);
});
var $bd982289c98ea88e$export$2e2bcd8739ae039 = (0, $7EzGR.default)($bd982289c98ea88e$export$9dd6ff9ea0189349, {
    name: "MuiTabScrollButton"
})($bd982289c98ea88e$var$TabScrollButton);

});
parcelRegister("8zhjD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63cf06221904baf5$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $2Ml3G = parcelRequire("2Ml3G");
var /**
 * @ignore - internal component.
 */ $63cf06221904baf5$export$2e2bcd8739ae039 = (0, $2Ml3G.default)(/*#__PURE__*/ $arQ7u.createElement("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");

});

parcelRegister("6S01B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5007ce295c489649$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $2Ml3G = parcelRequire("2Ml3G");
var /**
 * @ignore - internal component.
 */ $5007ce295c489649$export$2e2bcd8739ae039 = (0, $2Ml3G.default)(/*#__PURE__*/ $arQ7u.createElement("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");

});



parcelRegister("2Djn5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eae401078d51902$export$2e2bcd8739ae039; });

var $dXEVX = parcelRequire("dXEVX");

var $4g0WD = parcelRequire("4g0WD");

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");

var $b71IR = parcelRequire("b71IR");

var $kaLUp = parcelRequire("kaLUp");

var $1eae401078d51902$export$9dd6ff9ea0189349 = function styles(theme) {
    var _extends2;
    return {
        /* Styles applied to the root element. */ root: (0, $abElG.default)({}, theme.typography.button, (_extends2 = {
            maxWidth: 264,
            minWidth: 72,
            position: "relative",
            boxSizing: "border-box",
            minHeight: 48,
            flexShrink: 0,
            padding: "6px 12px"
        }, (0, $4g0WD.default)(_extends2, theme.breakpoints.up("sm"), {
            padding: "6px 24px"
        }), (0, $4g0WD.default)(_extends2, "overflow", "hidden"), (0, $4g0WD.default)(_extends2, "whiteSpace", "normal"), (0, $4g0WD.default)(_extends2, "textAlign", "center"), (0, $4g0WD.default)(_extends2, theme.breakpoints.up("sm"), {
            minWidth: 160
        }), _extends2)),
        /* Styles applied to the root element if both `icon` and `label` are provided. */ labelIcon: {
            minHeight: 72,
            paddingTop: 9,
            "& $wrapper > *:first-child": {
                marginBottom: 6
            }
        },
        /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */ textColorInherit: {
            color: "inherit",
            opacity: 0.7,
            "&$selected": {
                opacity: 1
            },
            "&$disabled": {
                opacity: 0.5
            }
        },
        /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */ textColorPrimary: {
            color: theme.palette.text.secondary,
            "&$selected": {
                color: theme.palette.primary.main
            },
            "&$disabled": {
                color: theme.palette.text.disabled
            }
        },
        /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */ textColorSecondary: {
            color: theme.palette.text.secondary,
            "&$selected": {
                color: theme.palette.secondary.main
            },
            "&$disabled": {
                color: theme.palette.text.disabled
            }
        },
        /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */ selected: {},
        /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */ disabled: {},
        /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */ fullWidth: {
            flexShrink: 1,
            flexGrow: 1,
            flexBasis: 0,
            maxWidth: "none"
        },
        /* Styles applied to the root element if `wrapped={true}`. */ wrapped: {
            fontSize: theme.typography.pxToRem(12),
            lineHeight: 1.5
        },
        /* Styles applied to the `icon` and `label`'s wrapper element. */ wrapper: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            flexDirection: "column"
        }
    };
};
var $1eae401078d51902$var$Tab = /*#__PURE__*/ $arQ7u.forwardRef(function Tab(props, ref) {
    var classes = props.classes, className = props.className, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, fullWidth = props.fullWidth, icon = props.icon, indicator = props.indicator, label = props.label, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, selected = props.selected, selectionFollowsFocus = props.selectionFollowsFocus, _props$textColor = props.textColor, textColor = _props$textColor === void 0 ? "inherit" : _props$textColor, value = props.value, _props$wrapped = props.wrapped, wrapped = _props$wrapped === void 0 ? false : _props$wrapped, other = (0, $dXEVX.default)(props, [
        "classes",
        "className",
        "disabled",
        "disableFocusRipple",
        "fullWidth",
        "icon",
        "indicator",
        "label",
        "onChange",
        "onClick",
        "onFocus",
        "selected",
        "selectionFollowsFocus",
        "textColor",
        "value",
        "wrapped"
    ]);
    var handleClick = function handleClick(event) {
        if (onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    var handleFocus = function handleFocus(event) {
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ $arQ7u.createElement((0, $b71IR.default), (0, $abElG.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $5g55B.default)(classes.root, classes["textColor".concat((0, $kaLUp.default)(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        tabIndex: selected ? 0 : -1
    }, other), /*#__PURE__*/ $arQ7u.createElement("span", {
        className: classes.wrapper
    }, icon, label), indicator);
});
var $1eae401078d51902$export$2e2bcd8739ae039 = (0, $7EzGR.default)($1eae401078d51902$export$9dd6ff9ea0189349, {
    name: "MuiTab"
})($1eae401078d51902$var$Tab);

});

parcelRegister("04lw7", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00d110aa3d5a3532$var$React = $363GR((parcelRequire("arQ7u")));

var $00d110aa3d5a3532$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $00d110aa3d5a3532$var$_default = (0, $00d110aa3d5a3532$var$_createSvgIcon.default)(/*#__PURE__*/ $00d110aa3d5a3532$var$React.createElement("path", {
    d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
}), "ReorderSharp");
module.exports.default = $00d110aa3d5a3532$var$_default;

});

parcelRegister("i4Kex", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d28c76b6540993e2$var$React = $363GR((parcelRequire("arQ7u")));

var $d28c76b6540993e2$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $d28c76b6540993e2$var$_default = (0, $d28c76b6540993e2$var$_createSvgIcon.default)(/*#__PURE__*/ $d28c76b6540993e2$var$React.createElement("path", {
    d: "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
}), "SortSharp");
module.exports.default = $d28c76b6540993e2$var$_default;

});

parcelRegister("61uru", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $462a734a07224f7b$var$React = $363GR((parcelRequire("arQ7u")));

var $462a734a07224f7b$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $462a734a07224f7b$var$_default = (0, $462a734a07224f7b$var$_createSvgIcon.default)(/*#__PURE__*/ $462a734a07224f7b$var$React.createElement("path", {
    d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"
}), "ArrowForwardSharp");
module.exports.default = $462a734a07224f7b$var$_default;

});

parcelRegister("79FNp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5359cb7589108d53$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $kUnI3 = parcelRequire("kUnI3");

var $1MgBx = parcelRequire("1MgBx");
var $24Kso = parcelRequire("24Kso");

var $4dIYM = parcelRequire("4dIYM");
/**
 * mapStateToProps - to hook up connect
 */ var $5359cb7589108d53$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, windowId = _ref.windowId;
    return {
        canvases: (0, $1MgBx.getCanvases)(state, {
            windowId: windowId
        }),
        selectedCanvasIds: (0, $1MgBx.getVisibleCanvasIds)(state, {
            windowId: windowId
        }),
        variant: (0, $24Kso.getCompanionWindow)(state, {
            companionWindowId: id,
            windowId: windowId
        }).variant
    };
};
/**
 * mapStateToProps - used to hook up connect to state
 * @memberof SidebarIndexList
 * @private
 */ var $5359cb7589108d53$var$mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
    var id = _ref2.id, windowId = _ref2.windowId;
    return {
        setCanvas: function setCanvas() {
            return dispatch($kUnI3.setCanvas.apply($kUnI3, arguments));
        }
    };
};
/**
 * Styles for withStyles HOC
 */ var $5359cb7589108d53$var$styles = function styles(theme) {
    return {
        label: {
            paddingLeft: theme.spacing(1)
        },
        listItem: {
            borderBottom: "0.5px solid ".concat(theme.palette.divider),
            paddingRight: theme.spacing(1)
        }
    };
};
var $5359cb7589108d53$var$enhance = (0, $k19ic.compose)((0, $7EzGR.default)($5359cb7589108d53$var$styles), (0, $eC0Mc.withTranslation)(), (0, $fbonu.default)($5359cb7589108d53$var$mapStateToProps, $5359cb7589108d53$var$mapDispatchToProps), (0, $7XHRd.withPlugins)("SidebarIndexList"));
var $5359cb7589108d53$export$2e2bcd8739ae039 = $5359cb7589108d53$var$enhance((0, $4dIYM.SidebarIndexList));

});
parcelRegister("4dIYM", function(module, exports) {

$parcel$export(module.exports, "SidebarIndexList", function () { return $312b444c419f7a1a$export$a8fc5effebe968e4; });

var $arQ7u = parcelRequire("arQ7u");

var $6lUyS = parcelRequire("6lUyS");

var $2NDUy = parcelRequire("2NDUy");

var $k3oId = parcelRequire("k3oId");

var $izTcV = parcelRequire("izTcV");

var $4PICg = parcelRequire("4PICg");

var $8U6OY = parcelRequire("8U6OY");
function $312b444c419f7a1a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $312b444c419f7a1a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $312b444c419f7a1a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $312b444c419f7a1a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $312b444c419f7a1a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $312b444c419f7a1a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $312b444c419f7a1a$var$_setPrototypeOf(subClass, superClass);
}
function $312b444c419f7a1a$var$_setPrototypeOf(o, p) {
    $312b444c419f7a1a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $312b444c419f7a1a$var$_setPrototypeOf(o, p);
}
function $312b444c419f7a1a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $312b444c419f7a1a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $312b444c419f7a1a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $312b444c419f7a1a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $312b444c419f7a1a$var$_possibleConstructorReturn(this, result);
    };
}
function $312b444c419f7a1a$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $312b444c419f7a1a$var$_assertThisInitialized(self);
}
function $312b444c419f7a1a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $312b444c419f7a1a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $312b444c419f7a1a$var$_getPrototypeOf(o) {
    $312b444c419f7a1a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $312b444c419f7a1a$var$_getPrototypeOf(o);
}
var $312b444c419f7a1a$export$a8fc5effebe968e4 = /*#__PURE__*/ function(_Component) {
    $312b444c419f7a1a$var$_inherits(SidebarIndexList, _Component);
    var _super = $312b444c419f7a1a$var$_createSuper(SidebarIndexList);
    function SidebarIndexList() {
        $312b444c419f7a1a$var$_classCallCheck(this, SidebarIndexList);
        return _super.apply(this, arguments);
    }
    $312b444c419f7a1a$var$_createClass(SidebarIndexList, [
        {
            key: "getIdAndLabelOfCanvases",
            value: /** @private */ function getIdAndLabelOfCanvases() {
                var canvases = this.props.canvases;
                return canvases.map(function(canvas, index) {
                    return {
                        id: canvas.id,
                        label: new (0, $izTcV.default)(canvas).getLabel()
                    };
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, canvases = _this$props.canvases, classes = _this$props.classes, containerRef = _this$props.containerRef, selectedCanvasIds = _this$props.selectedCanvasIds, setCanvas = _this$props.setCanvas, variant = _this$props.variant, windowId = _this$props.windowId;
                var canvasesIdAndLabel = this.getIdAndLabelOfCanvases(canvases);
                var Item;
                switch(variant){
                    case "thumbnail":
                        Item = (0, $8U6OY.default);
                        break;
                    default:
                        Item = (0, $4PICg.default);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $6lUyS.default), {
                    variant: "selectedMenu"
                }, canvasesIdAndLabel.map(function(canvas, canvasIndex) {
                    var onClick = function onClick() {
                        setCanvas(windowId, canvas.id);
                    }; // eslint-disable-line require-jsdoc, max-len
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $k3oId.ScrollTo), {
                        containerRef: containerRef,
                        key: "".concat(canvas.id, "-").concat(variant),
                        offsetTop: 96 // offset for the height of the form above
                        ,
                        scrollTo: selectedCanvasIds.includes(canvas.id)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $2NDUy.default), {
                        key: canvas.id,
                        className: classes.listItem,
                        alignItems: "flex-start",
                        onClick: onClick,
                        button: true,
                        component: "li",
                        selected: selectedCanvasIds.includes(canvas.id)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(Item, {
                        label: canvas.label,
                        canvas: canvases[canvasIndex]
                    })));
                }));
            }
        }
    ]);
    return SidebarIndexList;
}((0, $arQ7u.Component));
$312b444c419f7a1a$export$a8fc5effebe968e4.defaultProps = {
    selectedCanvasIds: [],
    variant: "item"
};

});
parcelRegister("4PICg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $384e88a9d92dbb6f$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $6hbo2 = parcelRequire("6hbo2");
/**
 * Styles for withStyles HOC
 */ var $384e88a9d92dbb6f$var$styles = function styles(theme) {
    return {
        label: {
            paddingLeft: theme.spacing(1)
        }
    };
};
var $384e88a9d92dbb6f$var$enhance = (0, $k19ic.compose)((0, $7EzGR.default)($384e88a9d92dbb6f$var$styles), (0, $eC0Mc.withTranslation)(), (0, $fbonu.default)(null, null), (0, $7XHRd.withPlugins)("SidebarIndexItem"));
var $384e88a9d92dbb6f$export$2e2bcd8739ae039 = $384e88a9d92dbb6f$var$enhance((0, $6hbo2.SidebarIndexItem));

});
parcelRegister("6hbo2", function(module, exports) {

$parcel$export(module.exports, "SidebarIndexItem", function () { return $491d29c838b773fa$export$b36b6dc46ad49767; });

var $arQ7u = parcelRequire("arQ7u");

var $hsH5s = parcelRequire("hsH5s");

var $dErw7 = parcelRequire("dErw7");
function $491d29c838b773fa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $491d29c838b773fa$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $491d29c838b773fa$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $491d29c838b773fa$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $491d29c838b773fa$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $491d29c838b773fa$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $491d29c838b773fa$var$_setPrototypeOf(subClass, superClass);
}
function $491d29c838b773fa$var$_setPrototypeOf(o, p) {
    $491d29c838b773fa$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $491d29c838b773fa$var$_setPrototypeOf(o, p);
}
function $491d29c838b773fa$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $491d29c838b773fa$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $491d29c838b773fa$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $491d29c838b773fa$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $491d29c838b773fa$var$_possibleConstructorReturn(this, result);
    };
}
function $491d29c838b773fa$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $491d29c838b773fa$var$_assertThisInitialized(self);
}
function $491d29c838b773fa$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $491d29c838b773fa$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $491d29c838b773fa$var$_getPrototypeOf(o) {
    $491d29c838b773fa$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $491d29c838b773fa$var$_getPrototypeOf(o);
}
var $491d29c838b773fa$export$b36b6dc46ad49767 = /*#__PURE__*/ function(_Component) {
    $491d29c838b773fa$var$_inherits(SidebarIndexItem, _Component);
    var _super = $491d29c838b773fa$var$_createSuper(SidebarIndexItem);
    function SidebarIndexItem() {
        $491d29c838b773fa$var$_classCallCheck(this, SidebarIndexItem);
        return _super.apply(this, arguments);
    }
    $491d29c838b773fa$var$_createClass(SidebarIndexItem, [
        {
            key: "render",
            value: /** */ function render() {
                var _this$props = this.props, classes = _this$props.classes, label = _this$props.label;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dErw7)))(classes.label),
                    variant: "body1"
                }, label));
            }
        }
    ]);
    return SidebarIndexItem;
}((0, $arQ7u.Component));

});


parcelRegister("8U6OY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67b8d83a3da927a3$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $iUbfS = parcelRequire("iUbfS");

var $jGts0 = parcelRequire("jGts0");
function $67b8d83a3da927a3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $67b8d83a3da927a3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $67b8d83a3da927a3$var$ownKeys(Object(source), true).forEach(function(key) {
            $67b8d83a3da927a3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $67b8d83a3da927a3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $67b8d83a3da927a3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * mapStateToProps - used to hook up state to props
 * @memberof SidebarIndexThumbnail
 * @private
 */ var $67b8d83a3da927a3$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var data = _ref.data;
    return $67b8d83a3da927a3$var$_objectSpread({}, (0, $jGts0.getConfig)(state).canvasNavigation || {});
};
/**
 * Styles for withStyles HOC
 */ var $67b8d83a3da927a3$var$styles = function styles(theme) {
    return {
        label: {
            paddingLeft: theme.spacing(1)
        }
    };
};
var $67b8d83a3da927a3$var$enhance = (0, $k19ic.compose)((0, $7EzGR.default)($67b8d83a3da927a3$var$styles), (0, $eC0Mc.withTranslation)(), (0, $fbonu.default)($67b8d83a3da927a3$var$mapStateToProps, null), (0, $7XHRd.withPlugins)("SidebarIndexThumbnail"));
var $67b8d83a3da927a3$export$2e2bcd8739ae039 = $67b8d83a3da927a3$var$enhance((0, $iUbfS.SidebarIndexThumbnail));

});
parcelRegister("iUbfS", function(module, exports) {

$parcel$export(module.exports, "SidebarIndexThumbnail", function () { return $dc362ffec53775fa$export$e16e49d0c55efd08; });

var $arQ7u = parcelRequire("arQ7u");

var $hsH5s = parcelRequire("hsH5s");

var $dErw7 = parcelRequire("dErw7");

var $YLOIV = parcelRequire("YLOIV");
function $dc362ffec53775fa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dc362ffec53775fa$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $dc362ffec53775fa$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dc362ffec53775fa$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dc362ffec53775fa$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $dc362ffec53775fa$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $dc362ffec53775fa$var$_setPrototypeOf(subClass, superClass);
}
function $dc362ffec53775fa$var$_setPrototypeOf(o, p) {
    $dc362ffec53775fa$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dc362ffec53775fa$var$_setPrototypeOf(o, p);
}
function $dc362ffec53775fa$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $dc362ffec53775fa$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $dc362ffec53775fa$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $dc362ffec53775fa$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $dc362ffec53775fa$var$_possibleConstructorReturn(this, result);
    };
}
function $dc362ffec53775fa$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $dc362ffec53775fa$var$_assertThisInitialized(self);
}
function $dc362ffec53775fa$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $dc362ffec53775fa$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $dc362ffec53775fa$var$_getPrototypeOf(o) {
    $dc362ffec53775fa$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dc362ffec53775fa$var$_getPrototypeOf(o);
}
var $dc362ffec53775fa$export$e16e49d0c55efd08 = /*#__PURE__*/ function(_Component) {
    $dc362ffec53775fa$var$_inherits(SidebarIndexThumbnail, _Component);
    var _super = $dc362ffec53775fa$var$_createSuper(SidebarIndexThumbnail);
    function SidebarIndexThumbnail() {
        $dc362ffec53775fa$var$_classCallCheck(this, SidebarIndexThumbnail);
        return _super.apply(this, arguments);
    }
    $dc362ffec53775fa$var$_createClass(SidebarIndexThumbnail, [
        {
            key: "render",
            value: /** */ function render() {
                var _this$props = this.props, classes = _this$props.classes, canvas = _this$props.canvas, height = _this$props.height, label = _this$props.label, width = _this$props.width;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    style: {
                        minWidth: 50
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $YLOIV.default), {
                    label: label,
                    resource: canvas,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dErw7)))(classes.clickable),
                    maxHeight: height,
                    maxWidth: width
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($dErw7)))(classes.label),
                    variant: "body1"
                }, label));
            }
        }
    ]);
    return SidebarIndexThumbnail;
}((0, $arQ7u.Component));
$dc362ffec53775fa$export$e16e49d0c55efd08.defaultProps = {
    height: undefined,
    width: undefined
};

});




parcelRegister("64PgQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46cae3122dead16b$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $6U1Fo = parcelRequire("6U1Fo");

var $7XHRd = parcelRequire("7XHRd");

var $lqduJ = parcelRequire("lqduJ");

var $dJvB2 = parcelRequire("dJvB2");
var $51Gx5 = parcelRequire("51Gx5");

var $kUnI3 = parcelRequire("kUnI3");
/**
 * mapStateToProps - to hook up connect
 */ var $46cae3122dead16b$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, windowId = _ref.windowId;
    return {
        expandedNodeIds: (0, $dJvB2.getExpandedNodeIds)(state, {
            companionWindowId: id,
            windowId: windowId
        }),
        nodeIdToScrollTo: (0, $dJvB2.getNodeIdToScrollTo)(state, {
            companionWindowId: id,
            windowId: windowId
        }),
        treeStructure: (0, $51Gx5.getSequenceTreeStructure)(state, {
            windowId: windowId
        }),
        visibleNodeIds: (0, $dJvB2.getVisibleNodeIds)(state, {
            companionWindowId: id,
            windowId: windowId
        })
    };
};
/**
 * mapStateToProps - used to hook up connect to state
 * @memberof SidebarIndexTableOfContents
 * @private
 */ var $46cae3122dead16b$var$mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
    var id = _ref2.id, windowId = _ref2.windowId;
    return {
        setCanvas: function setCanvas() {
            return dispatch($kUnI3.setCanvas.apply($kUnI3, arguments));
        },
        toggleNode: function toggleNode(nodeId) {
            return dispatch($kUnI3.toggleNode(windowId, id, nodeId));
        }
    };
};
/**
 * Styles for withStyles HOC
 */ var $46cae3122dead16b$var$styles = function styles(theme) {
    return {
        content: {
            alignItems: "flex-start",
            borderLeft: "1px solid transparent",
            padding: "8px 16px 8px 0",
            width: "auto"
        },
        group: {
            borderLeft: "1px solid ".concat(theme.palette.grey[300])
        },
        label: {
            paddingLeft: 0
        },
        // needed for pseudo $label class
        root: {
            flexGrow: 1
        },
        selected: {},
        // needed for pseudo $selected class
        treeItemRoot: {
            "&:focus > $content": {
                backgroundColor: theme.palette.action.selected
            },
            "&:hover > $content": {
                backgroundColor: theme.palette.action.hover
            },
            "&:hover >$content $label, &:focus > $content $label, &$selected > $content $label, &$selected > $content $label:hover, &$selected:focus > $content $label": {
                backgroundColor: "transparent"
            }
        },
        visibleNode: {
            backgroundColor: (0, $6U1Fo.fade)(theme.palette.highlights.primary, 0.35),
            display: "inline"
        }
    };
};
var $46cae3122dead16b$var$enhance = (0, $k19ic.compose)((0, $7EzGR.default)($46cae3122dead16b$var$styles), (0, $eC0Mc.withTranslation)(), (0, $fbonu.default)($46cae3122dead16b$var$mapStateToProps, $46cae3122dead16b$var$mapDispatchToProps), (0, $7XHRd.withPlugins)("SidebarIndexTableOfContents"));
var $46cae3122dead16b$export$2e2bcd8739ae039 = $46cae3122dead16b$var$enhance((0, $lqduJ.SidebarIndexTableOfContents));

});
parcelRegister("6U1Fo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hexToRgb = $506943fdffd0c2d1$var$hexToRgb;
module.exports.rgbToHex = $506943fdffd0c2d1$var$rgbToHex;
module.exports.hslToRgb = $506943fdffd0c2d1$var$hslToRgb;
module.exports.decomposeColor = $506943fdffd0c2d1$var$decomposeColor;
module.exports.recomposeColor = $506943fdffd0c2d1$var$recomposeColor;
module.exports.getContrastRatio = $506943fdffd0c2d1$var$getContrastRatio;
module.exports.getLuminance = $506943fdffd0c2d1$var$getLuminance;
module.exports.emphasize = $506943fdffd0c2d1$var$emphasize;
module.exports.fade = $506943fdffd0c2d1$var$fade;
module.exports.alpha = $506943fdffd0c2d1$var$alpha;
module.exports.darken = $506943fdffd0c2d1$var$darken;
module.exports.lighten = $506943fdffd0c2d1$var$lighten;

var $eQGDD = parcelRequire("eQGDD");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $506943fdffd0c2d1$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $506943fdffd0c2d1$var$hexToRgb(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", "), ")") : "";
}
function $506943fdffd0c2d1$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $506943fdffd0c2d1$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    var _decomposeColor = $506943fdffd0c2d1$var$decomposeColor(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $506943fdffd0c2d1$var$intToHex(n);
    }).join(""));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $506943fdffd0c2d1$var$hslToRgb(color) {
    color = $506943fdffd0c2d1$var$decomposeColor(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = "rgb";
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $506943fdffd0c2d1$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $506943fdffd0c2d1$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $506943fdffd0c2d1$var$decomposeColor($506943fdffd0c2d1$var$hexToRgb(color));
    var marker = color.indexOf("(");
    var type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla"
    ].indexOf(type) === -1) throw new Error((0, $eQGDD.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(",");
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ function $506943fdffd0c2d1$var$recomposeColor(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf("hsl") !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(", "), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $506943fdffd0c2d1$var$getContrastRatio(foreground, background) {
    var lumA = $506943fdffd0c2d1$var$getLuminance(foreground);
    var lumB = $506943fdffd0c2d1$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $506943fdffd0c2d1$var$getLuminance(color) {
    color = $506943fdffd0c2d1$var$decomposeColor(color);
    var rgb = color.type === "hsl" ? $506943fdffd0c2d1$var$decomposeColor($506943fdffd0c2d1$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $506943fdffd0c2d1$var$emphasize(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $506943fdffd0c2d1$var$getLuminance(color) > 0.5 ? $506943fdffd0c2d1$var$darken(color, coefficient) : $506943fdffd0c2d1$var$lighten(color, coefficient);
}
var $506943fdffd0c2d1$var$warnedOnce = false;
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 *
 * @deprecated
 * Use `import { alpha } from '@material-ui/core/styles'` instead.
 */ function $506943fdffd0c2d1$var$fade(color, value) {
    return $506943fdffd0c2d1$var$alpha(color, value);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha value is overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0-1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $506943fdffd0c2d1$var$alpha(color, value) {
    color = $506943fdffd0c2d1$var$decomposeColor(color);
    value = $506943fdffd0c2d1$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    color.values[3] = value;
    return $506943fdffd0c2d1$var$recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $506943fdffd0c2d1$var$darken(color, coefficient) {
    color = $506943fdffd0c2d1$var$decomposeColor(color);
    coefficient = $506943fdffd0c2d1$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $506943fdffd0c2d1$var$recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $506943fdffd0c2d1$var$lighten(color, coefficient) {
    color = $506943fdffd0c2d1$var$decomposeColor(color);
    coefficient = $506943fdffd0c2d1$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $506943fdffd0c2d1$var$recomposeColor(color);
}

});

parcelRegister("lqduJ", function(module, exports) {

$parcel$export(module.exports, "SidebarIndexTableOfContents", function () { return $f9867e702e81253c$export$a1f20c24b3adb3c5; });

var $arQ7u = parcelRequire("arQ7u");

var $e6cGH = parcelRequire("e6cGH");

var $jZhy9 = parcelRequire("jZhy9");

var $41I7Q = parcelRequire("41I7Q");

var $e24TX = parcelRequire("e24TX");

var $5g55B = parcelRequire("5g55B");

var $k3oId = parcelRequire("k3oId");
function $f9867e702e81253c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f9867e702e81253c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f9867e702e81253c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f9867e702e81253c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f9867e702e81253c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f9867e702e81253c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f9867e702e81253c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f9867e702e81253c$var$_setPrototypeOf(subClass, superClass);
}
function $f9867e702e81253c$var$_setPrototypeOf(o, p) {
    $f9867e702e81253c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f9867e702e81253c$var$_setPrototypeOf(o, p);
}
function $f9867e702e81253c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f9867e702e81253c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f9867e702e81253c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f9867e702e81253c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f9867e702e81253c$var$_possibleConstructorReturn(this, result);
    };
}
function $f9867e702e81253c$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f9867e702e81253c$var$_assertThisInitialized(self);
}
function $f9867e702e81253c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f9867e702e81253c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f9867e702e81253c$var$_getPrototypeOf(o) {
    $f9867e702e81253c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f9867e702e81253c$var$_getPrototypeOf(o);
}
/** */ function $f9867e702e81253c$var$getStartCanvasId(node) {
    var jsonld = node.data.__jsonld; // eslint-disable-line no-underscore-dangle
    if (jsonld.startCanvas && typeof jsonld.startCanvas === "string") return jsonld.startCanvas;
    if (jsonld.start) {
        if (jsonld.start.type === "Canvas" && typeof jsonld.start.id === "string") return jsonld.start.id;
        if (jsonld.start.type === "SpecificResource" && typeof jsonld.start.source === "string") return jsonld.start.source;
    }
    return node.data.getCanvasIds()[0];
}
var $f9867e702e81253c$export$a1f20c24b3adb3c5 = /*#__PURE__*/ function(_Component) {
    $f9867e702e81253c$var$_inherits(SidebarIndexTableOfContents, _Component);
    var _super = $f9867e702e81253c$var$_createSuper(SidebarIndexTableOfContents);
    function SidebarIndexTableOfContents() {
        $f9867e702e81253c$var$_classCallCheck(this, SidebarIndexTableOfContents);
        return _super.apply(this, arguments);
    }
    $f9867e702e81253c$var$_createClass(SidebarIndexTableOfContents, [
        {
            key: "handleKeyPressed",
            value: /** */ function handleKeyPressed(event, node) {
                var _this$props = this.props, expandedNodeIds = _this$props.expandedNodeIds, toggleNode = _this$props.toggleNode;
                if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") this.selectTreeItem(node);
                if (event.key === "ArrowLeft" && expandedNodeIds.indexOf(node.id) !== -1 || event.key === "ArrowRight" && expandedNodeIds.indexOf(node.id) === -1 && node.nodes.length > 0) toggleNode(node.id);
            }
        },
        {
            key: "selectTreeItem",
            value: function selectTreeItem(node) {
                var _this$props2 = this.props, setCanvas = _this$props2.setCanvas, toggleNode = _this$props2.toggleNode, windowId = _this$props2.windowId;
                if (node.nodes.length > 0) toggleNode(node.id);
                 // Do not select if there are no canvases listed or it has children
                if (!node.data.getCanvasIds() || node.data.getCanvasIds().length === 0 || node.nodes.length > 0) return;
                var target = $f9867e702e81253c$var$getStartCanvasId(node);
                var canvasId = target.indexOf("#") === -1 ? target : target.substr(0, target.indexOf("#"));
                setCanvas(windowId, canvasId);
            }
        },
        {
            key: "buildTreeItems",
            value: function buildTreeItems(nodes, visibleNodeIds, containerRef, nodeIdToScrollTo) {
                var _this = this;
                var classes = this.props.classes;
                if (!nodes) return null;
                return nodes.map(function(node) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $k3oId.ScrollTo), {
                        containerRef: containerRef,
                        key: "".concat(node.id, "-scroll"),
                        offsetTop: 96 // offset for the height of the form above
                        ,
                        scrollTo: nodeIdToScrollTo === node.id
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $e24TX.default), {
                        key: node.id,
                        nodeId: node.id,
                        classes: {
                            content: classes.content,
                            group: classes.group,
                            label: classes.label,
                            root: classes.treeItemRoot,
                            selected: classes.selected
                        },
                        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                            className: (0, $5g55B.default)($f9867e702e81253c$var$_defineProperty({}, classes.visibleNode, visibleNodeIds.indexOf(node.id) !== -1))
                        }, node.label),
                        onClick: function onClick() {
                            return _this.selectTreeItem(node);
                        },
                        onKeyDown: function onKeyDown(e) {
                            return _this.handleKeyPressed(e, node);
                        }
                    }, node.nodes && node.nodes.length > 0 ? _this.buildTreeItems(node.nodes, visibleNodeIds, containerRef, nodeIdToScrollTo) : null));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props3 = this.props, classes = _this$props3.classes, treeStructure = _this$props3.treeStructure, visibleNodeIds = _this$props3.visibleNodeIds, expandedNodeIds = _this$props3.expandedNodeIds, containerRef = _this$props3.containerRef, nodeIdToScrollTo = _this$props3.nodeIdToScrollTo;
                if (!treeStructure) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $e6cGH.default), {
                    className: classes.root,
                    defaultCollapseIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jZhy9))), {
                        color: "action"
                    }),
                    defaultExpandIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41I7Q))), {
                        color: "action"
                    }),
                    defaultEndIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null),
                    expanded: expandedNodeIds
                }, this.buildTreeItems(treeStructure.nodes, visibleNodeIds, containerRef, nodeIdToScrollTo)));
            }
        }
    ]);
    return SidebarIndexTableOfContents;
}((0, $arQ7u.Component));

});
parcelRegister("e6cGH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a43b77c04fc886cf$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $kMfvj = parcelRequire("kMfvj");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");

var $5g55B = parcelRequire("5g55B");


var $7EzGR = parcelRequire("7EzGR");

var $lhLsx = parcelRequire("lhLsx");

var $4K0ZS = parcelRequire("4K0ZS");
var $a43b77c04fc886cf$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        padding: 0,
        margin: 0,
        listStyle: "none"
    }
};
function $a43b77c04fc886cf$var$arrayDiff(arr1, arr2) {
    if (arr1.length !== arr2.length) return true;
    for(var i = 0; i < arr1.length; i += 1){
        if (arr1[i] !== arr2[i]) return true;
    }
    return false;
}
var $a43b77c04fc886cf$var$findNextFirstChar = function findNextFirstChar(firstChars, startIndex, char) {
    for(var i = startIndex; i < firstChars.length; i += 1){
        if (char === firstChars[i]) return i;
    }
    return -1;
};
var $a43b77c04fc886cf$var$defaultExpandedDefault = [];
var $a43b77c04fc886cf$var$defaultSelectedDefault = [];
var $a43b77c04fc886cf$var$TreeView = /*#__PURE__*/ $arQ7u.forwardRef(function TreeView(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, defaultCollapseIcon = props.defaultCollapseIcon, defaultEndIcon = props.defaultEndIcon, _props$defaultExpande = props.defaultExpanded, defaultExpanded = _props$defaultExpande === void 0 ? $a43b77c04fc886cf$var$defaultExpandedDefault : _props$defaultExpande, defaultExpandIcon = props.defaultExpandIcon, defaultParentIcon = props.defaultParentIcon, _props$defaultSelecte = props.defaultSelected, defaultSelected = _props$defaultSelecte === void 0 ? $a43b77c04fc886cf$var$defaultSelectedDefault : _props$defaultSelecte, _props$disableSelecti = props.disableSelection, disableSelection = _props$disableSelecti === void 0 ? false : _props$disableSelecti, _props$multiSelect = props.multiSelect, multiSelect = _props$multiSelect === void 0 ? false : _props$multiSelect, expandedProp = props.expanded, onNodeSelect = props.onNodeSelect, onNodeToggle = props.onNodeToggle, selectedProp = props.selected, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "className",
        "defaultCollapseIcon",
        "defaultEndIcon",
        "defaultExpanded",
        "defaultExpandIcon",
        "defaultParentIcon",
        "defaultSelected",
        "disableSelection",
        "multiSelect",
        "expanded",
        "onNodeSelect",
        "onNodeToggle",
        "selected"
    ]);
    var _React$useState = $arQ7u.useState(null), tabbable = _React$useState[0], setTabbable = _React$useState[1];
    var _React$useState2 = $arQ7u.useState(null), focusedNodeId = _React$useState2[0], setFocusedNodeId = _React$useState2[1];
    var nodeMap = $arQ7u.useRef({});
    var firstCharMap = $arQ7u.useRef({});
    var visibleNodes = $arQ7u.useRef([]);
    var _useControlled = (0, $lhLsx.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: "TreeView",
        state: "expanded"
    }), _useControlled2 = (0, $kMfvj.default)(_useControlled, 2), expanded = _useControlled2[0], setExpandedState = _useControlled2[1];
    var _useControlled3 = (0, $lhLsx.default)({
        controlled: selectedProp,
        default: defaultSelected,
        name: "TreeView",
        state: "selected"
    }), _useControlled4 = (0, $kMfvj.default)(_useControlled3, 2), selected = _useControlled4[0], setSelectedState = _useControlled4[1];
    /*
   * Status Helpers
   */ var isExpanded = $arQ7u.useCallback(function(id) {
        return Array.isArray(expanded) ? expanded.indexOf(id) !== -1 : false;
    }, [
        expanded
    ]);
    var isSelected = $arQ7u.useCallback(function(id) {
        return Array.isArray(selected) ? selected.indexOf(id) !== -1 : selected === id;
    }, [
        selected
    ]);
    var isTabbable = function isTabbable(id) {
        return tabbable === id;
    };
    var isFocused = function isFocused(id) {
        return focusedNodeId === id;
    };
    /*
   * Node Helpers
   */ var getNextNode = function getNextNode(id) {
        var nodeIndex = visibleNodes.current.indexOf(id);
        if (nodeIndex !== -1 && nodeIndex + 1 < visibleNodes.current.length) return visibleNodes.current[nodeIndex + 1];
        return null;
    };
    var getPreviousNode = function getPreviousNode(id) {
        var nodeIndex = visibleNodes.current.indexOf(id);
        if (nodeIndex !== -1 && nodeIndex - 1 >= 0) return visibleNodes.current[nodeIndex - 1];
        return null;
    };
    var getLastNode = function getLastNode() {
        return visibleNodes.current[visibleNodes.current.length - 1];
    };
    var getFirstNode = function getFirstNode() {
        return visibleNodes.current[0];
    };
    var getParent = function getParent(id) {
        return nodeMap.current[id].parent;
    };
    var getNodesInRange = function getNodesInRange(a, b) {
        var aIndex = visibleNodes.current.indexOf(a);
        var bIndex = visibleNodes.current.indexOf(b);
        var start = Math.min(aIndex, bIndex);
        var end = Math.max(aIndex, bIndex);
        return visibleNodes.current.slice(start, end + 1);
    };
    /*
   * Focus Helpers
   */ var focus = function focus(id) {
        if (id) {
            setTabbable(id);
            setFocusedNodeId(id);
        }
    };
    var focusNextNode = function focusNextNode(id) {
        return focus(getNextNode(id));
    };
    var focusPreviousNode = function focusPreviousNode(id) {
        return focus(getPreviousNode(id));
    };
    var focusFirstNode = function focusFirstNode() {
        return focus(getFirstNode());
    };
    var focusLastNode = function focusLastNode() {
        return focus(getLastNode());
    };
    var focusByFirstCharacter = function focusByFirstCharacter(id, char) {
        var start;
        var index;
        var lowercaseChar = char.toLowerCase();
        var firstCharIds = [];
        var firstChars = []; // This really only works since the ids are strings
        Object.keys(firstCharMap.current).forEach(function(nodeId) {
            var firstChar = firstCharMap.current[nodeId];
            var map = nodeMap.current[nodeId];
            var visible = map.parent ? isExpanded(map.parent) : true;
            if (visible) {
                firstCharIds.push(nodeId);
                firstChars.push(firstChar);
            }
        }); // Get start index for search based on position of currentItem
        start = firstCharIds.indexOf(id) + 1;
        if (start === nodeMap.current.length) start = 0;
         // Check remaining slots in the menu
        index = $a43b77c04fc886cf$var$findNextFirstChar(firstChars, start, lowercaseChar); // If not found in remaining slots, check from beginning
        if (index === -1) index = $a43b77c04fc886cf$var$findNextFirstChar(firstChars, 0, lowercaseChar);
         // If match was found...
        if (index > -1) focus(firstCharIds[index]);
    };
    /*
   * Expansion Helpers
   */ var toggleExpansion = function toggleExpansion(event) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : focusedNodeId;
        var newExpanded;
        if (expanded.indexOf(value) !== -1) {
            newExpanded = expanded.filter(function(id) {
                return id !== value;
            });
            setTabbable(function(oldTabbable) {
                var map = nodeMap.current[oldTabbable];
                if (oldTabbable && (map && map.parent ? map.parent.id : null) === value) return value;
                return oldTabbable;
            });
        } else newExpanded = [
            value
        ].concat(expanded);
        if (onNodeToggle) onNodeToggle(event, newExpanded);
        setExpandedState(newExpanded);
    };
    var expandAllSiblings = function expandAllSiblings(event, id) {
        var map = nodeMap.current[id];
        var parent = nodeMap.current[map.parent];
        var diff;
        if (parent) diff = parent.children.filter(function(child) {
            return !isExpanded(child);
        });
        else {
            var topLevelNodes = nodeMap.current[-1].children;
            diff = topLevelNodes.filter(function(node) {
                return !isExpanded(node);
            });
        }
        var newExpanded = expanded.concat(diff);
        if (diff.length > 0) {
            setExpandedState(newExpanded);
            if (onNodeToggle) onNodeToggle(event, newExpanded);
        }
    };
    /*
   * Selection Helpers
   */ var lastSelectedNode = $arQ7u.useRef(null);
    var lastSelectionWasRange = $arQ7u.useRef(false);
    var currentRangeSelection = $arQ7u.useRef([]);
    var handleRangeArrowSelect = function handleRangeArrowSelect(event, nodes) {
        var base = selected;
        var start = nodes.start, next = nodes.next, current = nodes.current;
        if (!next || !current) return;
        if (currentRangeSelection.current.indexOf(current) === -1) currentRangeSelection.current = [];
        if (lastSelectionWasRange.current) {
            if (currentRangeSelection.current.indexOf(next) !== -1) {
                base = base.filter(function(id) {
                    return id === start || id !== current;
                });
                currentRangeSelection.current = currentRangeSelection.current.filter(function(id) {
                    return id === start || id !== current;
                });
            } else {
                base.push(next);
                currentRangeSelection.current.push(next);
            }
        } else {
            base.push(next);
            currentRangeSelection.current.push(current, next);
        }
        if (onNodeSelect) onNodeSelect(event, base);
        setSelectedState(base);
    };
    var handleRangeSelect = function handleRangeSelect(event, nodes) {
        var base = selected;
        var start = nodes.start, end = nodes.end; // If last selection was a range selection ignore nodes that were selected.
        if (lastSelectionWasRange.current) base = selected.filter(function(id) {
            return currentRangeSelection.current.indexOf(id) === -1;
        });
        var range = getNodesInRange(start, end);
        currentRangeSelection.current = range;
        var newSelected = base.concat(range);
        newSelected = newSelected.filter(function(id, i) {
            return newSelected.indexOf(id) === i;
        });
        if (onNodeSelect) onNodeSelect(event, newSelected);
        setSelectedState(newSelected);
    };
    var handleMultipleSelect = function handleMultipleSelect(event, value) {
        var newSelected = [];
        if (selected.indexOf(value) !== -1) newSelected = selected.filter(function(id) {
            return id !== value;
        });
        else newSelected = [
            value
        ].concat(selected);
        if (onNodeSelect) onNodeSelect(event, newSelected);
        setSelectedState(newSelected);
    };
    var handleSingleSelect = function handleSingleSelect(event, value) {
        var newSelected = multiSelect ? [
            value
        ] : value;
        if (onNodeSelect) onNodeSelect(event, newSelected);
        setSelectedState(newSelected);
    };
    var selectNode = function selectNode(event, id) {
        var multiple = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        if (id) {
            if (multiple) handleMultipleSelect(event, id);
            else handleSingleSelect(event, id);
            lastSelectedNode.current = id;
            lastSelectionWasRange.current = false;
            currentRangeSelection.current = [];
            return true;
        }
        return false;
    };
    var selectRange = function selectRange(event, nodes) {
        var stacked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var _nodes$start = nodes.start, start = _nodes$start === void 0 ? lastSelectedNode.current : _nodes$start, end = nodes.end, current = nodes.current;
        if (stacked) handleRangeArrowSelect(event, {
            start: start,
            next: end,
            current: current
        });
        else handleRangeSelect(event, {
            start: start,
            end: end
        });
        lastSelectionWasRange.current = true;
        return true;
    };
    var rangeSelectToFirst = function rangeSelectToFirst(event, id) {
        if (!lastSelectedNode.current) lastSelectedNode.current = id;
        var start = lastSelectionWasRange.current ? lastSelectedNode.current : id;
        return selectRange(event, {
            start: start,
            end: getFirstNode()
        });
    };
    var rangeSelectToLast = function rangeSelectToLast(event, id) {
        if (!lastSelectedNode.current) lastSelectedNode.current = id;
        var start = lastSelectionWasRange.current ? lastSelectedNode.current : id;
        return selectRange(event, {
            start: start,
            end: getLastNode()
        });
    };
    var selectNextNode = function selectNextNode(event, id) {
        return selectRange(event, {
            end: getNextNode(id),
            current: id
        }, true);
    };
    var selectPreviousNode = function selectPreviousNode(event, id) {
        return selectRange(event, {
            end: getPreviousNode(id),
            current: id
        }, true);
    };
    var selectAllNodes = function selectAllNodes(event) {
        return selectRange(event, {
            start: getFirstNode(),
            end: getLastNode()
        });
    };
    /*
   * Mapping Helpers
   */ var addNodeToNodeMap = function addNodeToNodeMap(id, childrenIds) {
        var currentMap = nodeMap.current[id];
        nodeMap.current[id] = (0, $abElG.default)({}, currentMap, {
            children: childrenIds,
            id: id
        });
        childrenIds.forEach(function(childId) {
            var currentChildMap = nodeMap.current[childId];
            nodeMap.current[childId] = (0, $abElG.default)({}, currentChildMap, {
                parent: id,
                id: childId
            });
        });
    };
    var getNodesToRemove = $arQ7u.useCallback(function(id) {
        var map = nodeMap.current[id];
        var nodes = [];
        if (map) {
            nodes.push(id);
            if (map.children) {
                nodes.concat(map.children);
                map.children.forEach(function(node) {
                    nodes.concat(getNodesToRemove(node));
                });
            }
        }
        return nodes;
    }, []);
    var cleanUpFirstCharMap = $arQ7u.useCallback(function(nodes) {
        var newMap = (0, $abElG.default)({}, firstCharMap.current);
        nodes.forEach(function(node) {
            if (newMap[node]) delete newMap[node];
        });
        firstCharMap.current = newMap;
    }, []);
    var removeNodeFromNodeMap = $arQ7u.useCallback(function(id) {
        var nodes = getNodesToRemove(id);
        cleanUpFirstCharMap(nodes);
        var newMap = (0, $abElG.default)({}, nodeMap.current);
        nodes.forEach(function(node) {
            var map = newMap[node];
            if (map) {
                if (map.parent) {
                    var parentMap = newMap[map.parent];
                    if (parentMap && parentMap.children) {
                        var parentChildren = parentMap.children.filter(function(c) {
                            return c !== node;
                        });
                        newMap[map.parent] = (0, $abElG.default)({}, parentMap, {
                            children: parentChildren
                        });
                    }
                }
                delete newMap[node];
            }
        });
        nodeMap.current = newMap;
        setFocusedNodeId(function(oldFocusedNodeId) {
            if (oldFocusedNodeId === id) return null;
            return oldFocusedNodeId;
        });
    }, [
        getNodesToRemove,
        cleanUpFirstCharMap
    ]);
    var mapFirstChar = function mapFirstChar(id, firstChar) {
        firstCharMap.current[id] = firstChar;
    };
    var prevChildIds = $arQ7u.useRef([]);
    var _React$useState3 = $arQ7u.useState(false), childrenCalculated = _React$useState3[0], setChildrenCalculated = _React$useState3[1];
    $arQ7u.useEffect(function() {
        var childIds = [];
        $arQ7u.Children.forEach(children, function(child) {
            if (/*#__PURE__*/ $arQ7u.isValidElement(child) && child.props.nodeId) childIds.push(child.props.nodeId);
        });
        if ($a43b77c04fc886cf$var$arrayDiff(prevChildIds.current, childIds)) {
            nodeMap.current[-1] = {
                parent: null,
                children: childIds
            };
            childIds.forEach(function(id, index) {
                if (index === 0) setTabbable(id);
            });
            visibleNodes.current = nodeMap.current[-1].children;
            prevChildIds.current = childIds;
            setChildrenCalculated(true);
        }
    }, [
        children
    ]);
    $arQ7u.useEffect(function() {
        var buildVisible = function buildVisible(nodes) {
            var list = [];
            for(var i = 0; i < nodes.length; i += 1){
                var item = nodes[i];
                list.push(item);
                var childs = nodeMap.current[item].children;
                if (isExpanded(item) && childs) list = list.concat(buildVisible(childs));
            }
            return list;
        };
        if (childrenCalculated) visibleNodes.current = buildVisible(nodeMap.current[-1].children);
    }, [
        expanded,
        childrenCalculated,
        isExpanded,
        children
    ]);
    var noopSelection = function noopSelection() {
        return false;
    };
    return /*#__PURE__*/ $arQ7u.createElement((0, $4K0ZS.default).Provider, {
        value: {
            icons: {
                defaultCollapseIcon: defaultCollapseIcon,
                defaultExpandIcon: defaultExpandIcon,
                defaultParentIcon: defaultParentIcon,
                defaultEndIcon: defaultEndIcon
            },
            focus: focus,
            focusFirstNode: focusFirstNode,
            focusLastNode: focusLastNode,
            focusNextNode: focusNextNode,
            focusPreviousNode: focusPreviousNode,
            focusByFirstCharacter: focusByFirstCharacter,
            expandAllSiblings: expandAllSiblings,
            toggleExpansion: toggleExpansion,
            isExpanded: isExpanded,
            isFocused: isFocused,
            isSelected: isSelected,
            selectNode: disableSelection ? noopSelection : selectNode,
            selectRange: disableSelection ? noopSelection : selectRange,
            selectNextNode: disableSelection ? noopSelection : selectNextNode,
            selectPreviousNode: disableSelection ? noopSelection : selectPreviousNode,
            rangeSelectToFirst: disableSelection ? noopSelection : rangeSelectToFirst,
            rangeSelectToLast: disableSelection ? noopSelection : rangeSelectToLast,
            selectAllNodes: disableSelection ? noopSelection : selectAllNodes,
            isTabbable: isTabbable,
            multiSelect: multiSelect,
            getParent: getParent,
            mapFirstChar: mapFirstChar,
            addNodeToNodeMap: addNodeToNodeMap,
            removeNodeFromNodeMap: removeNodeFromNodeMap
        }
    }, /*#__PURE__*/ $arQ7u.createElement("ul", (0, $abElG.default)({
        role: "tree",
        "aria-multiselectable": multiSelect,
        className: (0, $5g55B.default)(classes.root, className),
        ref: ref
    }, other), children));
});
var $a43b77c04fc886cf$export$2e2bcd8739ae039 = (0, $7EzGR.default)($a43b77c04fc886cf$export$9dd6ff9ea0189349, {
    name: "MuiTreeView"
})($a43b77c04fc886cf$var$TreeView);

});
parcelRegister("4K0ZS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $373c3b43d17c8d29$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");
/**
 * @ignore - internal component.
 */ var $373c3b43d17c8d29$var$TreeViewContext = $arQ7u.createContext({});
var $373c3b43d17c8d29$export$2e2bcd8739ae039 = $373c3b43d17c8d29$var$TreeViewContext;

});


parcelRegister("jZhy9", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8d153d5ea670365$var$React = $363GR((parcelRequire("arQ7u")));

var $e8d153d5ea670365$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $e8d153d5ea670365$var$_default = (0, $e8d153d5ea670365$var$_createSvgIcon.default)(/*#__PURE__*/ $e8d153d5ea670365$var$React.createElement("path", {
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
module.exports.default = $e8d153d5ea670365$var$_default;

});

parcelRegister("41I7Q", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ee97bd1cc202483$var$React = $363GR((parcelRequire("arQ7u")));

var $2ee97bd1cc202483$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $2ee97bd1cc202483$var$_default = (0, $2ee97bd1cc202483$var$_createSvgIcon.default)(/*#__PURE__*/ $2ee97bd1cc202483$var$React.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");
module.exports.default = $2ee97bd1cc202483$var$_default;

});

parcelRegister("e24TX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3750de9578dfd7d$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");

var $5g55B = parcelRequire("5g55B");


var $hsH5s = parcelRequire("hsH5s");

var $9VEsQ = parcelRequire("9VEsQ");

var $6vqZH = parcelRequire("6vqZH");
var $j1k3T = parcelRequire("j1k3T");
var $7EzGR = parcelRequire("7EzGR");

var $nGnd5 = parcelRequire("nGnd5");

var $4K0ZS = parcelRequire("4K0ZS");
var $a3750de9578dfd7d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            listStyle: "none",
            margin: 0,
            padding: 0,
            outline: 0,
            WebkitTapHighlightColor: "transparent",
            "&:focus > $content $label": {
                backgroundColor: theme.palette.action.hover
            },
            "&$selected > $content $label": {
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            },
            "&$selected > $content $label:hover, &$selected:focus > $content $label": {
                backgroundColor: (0, $6vqZH.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Pseudo-class applied to the root element when expanded. */ expanded: {},
        /* Pseudo-class applied to the root element when selected. */ selected: {},
        /* Styles applied to the `role="group"` element. */ group: {
            margin: 0,
            padding: 0,
            marginLeft: 17
        },
        /* Styles applied to the tree node content. */ content: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            cursor: "pointer"
        },
        /* Styles applied to the tree node icon and collapse/expand icon. */ iconContainer: {
            marginRight: 4,
            width: 15,
            display: "flex",
            flexShrink: 0,
            justifyContent: "center",
            "& svg": {
                fontSize: 18
            }
        },
        /* Styles applied to the label element. */ label: {
            width: "100%",
            paddingLeft: 4,
            position: "relative",
            "&:hover": {
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        }
    };
};
var $a3750de9578dfd7d$var$isPrintableCharacter = function isPrintableCharacter(str) {
    return str && str.length === 1 && str.match(/\S/);
};
var $a3750de9578dfd7d$var$TreeItem = /*#__PURE__*/ $arQ7u.forwardRef(function TreeItem(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, collapseIcon = props.collapseIcon, endIcon = props.endIcon, expandIcon = props.expandIcon, iconProp = props.icon, label = props.label, nodeId = props.nodeId, onClick = props.onClick, onLabelClick = props.onLabelClick, onIconClick = props.onIconClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onMouseDown = props.onMouseDown, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $9VEsQ.default) : _props$TransitionComp, TransitionProps = props.TransitionProps, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "className",
        "collapseIcon",
        "endIcon",
        "expandIcon",
        "icon",
        "label",
        "nodeId",
        "onClick",
        "onLabelClick",
        "onIconClick",
        "onFocus",
        "onKeyDown",
        "onMouseDown",
        "TransitionComponent",
        "TransitionProps"
    ]);
    var _React$useContext = $arQ7u.useContext((0, $4K0ZS.default)), contextIcons = _React$useContext.icons, focus = _React$useContext.focus, focusFirstNode = _React$useContext.focusFirstNode, focusLastNode = _React$useContext.focusLastNode, focusNextNode = _React$useContext.focusNextNode, focusPreviousNode = _React$useContext.focusPreviousNode, focusByFirstCharacter = _React$useContext.focusByFirstCharacter, selectNode = _React$useContext.selectNode, selectRange = _React$useContext.selectRange, selectNextNode = _React$useContext.selectNextNode, selectPreviousNode = _React$useContext.selectPreviousNode, rangeSelectToFirst = _React$useContext.rangeSelectToFirst, rangeSelectToLast = _React$useContext.rangeSelectToLast, selectAllNodes = _React$useContext.selectAllNodes, expandAllSiblings = _React$useContext.expandAllSiblings, toggleExpansion = _React$useContext.toggleExpansion, isExpanded = _React$useContext.isExpanded, isFocused = _React$useContext.isFocused, isSelected = _React$useContext.isSelected, isTabbable = _React$useContext.isTabbable, multiSelect = _React$useContext.multiSelect, getParent = _React$useContext.getParent, mapFirstChar = _React$useContext.mapFirstChar, addNodeToNodeMap = _React$useContext.addNodeToNodeMap, removeNodeFromNodeMap = _React$useContext.removeNodeFromNodeMap;
    var nodeRef = $arQ7u.useRef(null);
    var contentRef = $arQ7u.useRef(null);
    var handleRef = (0, $nGnd5.default)(nodeRef, ref);
    var icon = iconProp;
    var expandable = Boolean(Array.isArray(children) ? children.length : children);
    var expanded = isExpanded ? isExpanded(nodeId) : false;
    var focused = isFocused ? isFocused(nodeId) : false;
    var tabbable = isTabbable ? isTabbable(nodeId) : false;
    var selected = isSelected ? isSelected(nodeId) : false;
    var icons = contextIcons || {};
    var theme = (0, $j1k3T.default)();
    if (!icon) {
        if (expandable) {
            if (!expanded) icon = expandIcon || icons.defaultExpandIcon;
            else icon = collapseIcon || icons.defaultCollapseIcon;
            if (!icon) icon = icons.defaultParentIcon;
        } else icon = endIcon || icons.defaultEndIcon;
    }
    var handleClick = function handleClick(event) {
        if (!focused) focus(nodeId);
        var multiple = multiSelect && (event.shiftKey || event.ctrlKey || event.metaKey); // If already expanded and trying to toggle selection don't close
        if (expandable && !event.defaultPrevented && !(multiple && isExpanded(nodeId))) toggleExpansion(event, nodeId);
        if (multiple) {
            if (event.shiftKey) selectRange(event, {
                end: nodeId
            });
            else selectNode(event, nodeId, true);
        } else selectNode(event, nodeId);
        if (onClick) onClick(event);
    };
    var handleMouseDown = function handleMouseDown(event) {
        if (event.shiftKey || event.ctrlKey || event.metaKey) event.preventDefault();
        if (onMouseDown) onMouseDown(event);
    };
    var handleNextArrow = function handleNextArrow(event) {
        if (expandable) {
            if (expanded) focusNextNode(nodeId);
            else toggleExpansion(event);
        }
        return true;
    };
    var handlePreviousArrow = function handlePreviousArrow(event) {
        if (expanded) {
            toggleExpansion(event, nodeId);
            return true;
        }
        var parent = getParent(nodeId);
        if (parent) {
            focus(parent);
            return true;
        }
        return false;
    };
    var handleKeyDown = function handleKeyDown(event) {
        var flag = false;
        var key = event.key;
        if (event.altKey || event.currentTarget !== event.target) return;
        var ctrlPressed = event.ctrlKey || event.metaKey;
        switch(key){
            case " ":
                if (nodeRef.current === event.currentTarget) {
                    if (multiSelect && event.shiftKey) flag = selectRange(event, {
                        end: nodeId
                    });
                    else if (multiSelect) flag = selectNode(event, nodeId, true);
                    else flag = selectNode(event, nodeId);
                }
                event.stopPropagation();
                break;
            case "Enter":
                if (nodeRef.current === event.currentTarget && expandable) {
                    toggleExpansion(event);
                    flag = true;
                }
                event.stopPropagation();
                break;
            case "ArrowDown":
                if (multiSelect && event.shiftKey) selectNextNode(event, nodeId);
                focusNextNode(nodeId);
                flag = true;
                break;
            case "ArrowUp":
                if (multiSelect && event.shiftKey) selectPreviousNode(event, nodeId);
                focusPreviousNode(nodeId);
                flag = true;
                break;
            case "ArrowRight":
                if (theme.direction === "rtl") flag = handlePreviousArrow(event);
                else flag = handleNextArrow(event);
                break;
            case "ArrowLeft":
                if (theme.direction === "rtl") flag = handleNextArrow(event);
                else flag = handlePreviousArrow(event);
                break;
            case "Home":
                if (multiSelect && ctrlPressed && event.shiftKey) rangeSelectToFirst(event, nodeId);
                focusFirstNode();
                flag = true;
                break;
            case "End":
                if (multiSelect && ctrlPressed && event.shiftKey) rangeSelectToLast(event, nodeId);
                focusLastNode();
                flag = true;
                break;
            default:
                if (key === "*") {
                    expandAllSiblings(event, nodeId);
                    flag = true;
                } else if (multiSelect && ctrlPressed && key.toLowerCase() === "a") flag = selectAllNodes(event);
                else if (!ctrlPressed && !event.shiftKey && $a3750de9578dfd7d$var$isPrintableCharacter(key)) {
                    focusByFirstCharacter(nodeId, key);
                    flag = true;
                }
        }
        if (flag) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleFocus = function handleFocus(event) {
        if (!focused && event.currentTarget === event.target) focus(nodeId);
        if (onFocus) onFocus(event);
    };
    $arQ7u.useEffect(function() {
        if (addNodeToNodeMap) {
            var childIds = [];
            $arQ7u.Children.forEach(children, function(child) {
                if (/*#__PURE__*/ $arQ7u.isValidElement(child) && child.props.nodeId) childIds.push(child.props.nodeId);
            });
            addNodeToNodeMap(nodeId, childIds);
        }
    }, [
        children,
        nodeId,
        addNodeToNodeMap
    ]);
    $arQ7u.useEffect(function() {
        if (removeNodeFromNodeMap) return function() {
            removeNodeFromNodeMap(nodeId);
        };
        return undefined;
    }, [
        nodeId,
        removeNodeFromNodeMap
    ]);
    $arQ7u.useEffect(function() {
        if (mapFirstChar && label) mapFirstChar(nodeId, contentRef.current.textContent.substring(0, 1).toLowerCase());
    }, [
        mapFirstChar,
        nodeId,
        label
    ]);
    $arQ7u.useEffect(function() {
        if (focused) nodeRef.current.focus();
    }, [
        focused
    ]);
    var ariaSelected;
    if (multiSelect) ariaSelected = selected;
    else if (selected) // single-selection trees unset aria-selected
    ariaSelected = true;
    return /*#__PURE__*/ $arQ7u.createElement("li", (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, expanded && classes.expanded, selected && classes.selected),
        role: "treeitem",
        onKeyDown: handleKeyDown,
        onFocus: handleFocus,
        "aria-expanded": expandable ? expanded : null,
        "aria-selected": ariaSelected,
        ref: handleRef,
        tabIndex: tabbable ? 0 : -1
    }, other), /*#__PURE__*/ $arQ7u.createElement("div", {
        className: classes.content,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        ref: contentRef
    }, /*#__PURE__*/ $arQ7u.createElement("div", {
        onClick: onIconClick,
        className: classes.iconContainer
    }, icon), /*#__PURE__*/ $arQ7u.createElement((0, $hsH5s.default), {
        onClick: onLabelClick,
        component: "div",
        className: classes.label
    }, label)), children && /*#__PURE__*/ $arQ7u.createElement(TransitionComponent, (0, $abElG.default)({
        unmountOnExit: true,
        className: classes.group,
        in: expanded,
        component: "ul",
        role: "group"
    }, TransitionProps), children));
});
var $a3750de9578dfd7d$export$2e2bcd8739ae039 = (0, $7EzGR.default)($a3750de9578dfd7d$export$9dd6ff9ea0189349, {
    name: "MuiTreeItem"
})($a3750de9578dfd7d$var$TreeItem);

});
parcelRegister("9VEsQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73a8d342f3017eae$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $kMfvj = parcelRequire("kMfvj");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");

var $5g55B = parcelRequire("5g55B");



var $d4AeH = parcelRequire("d4AeH");

var $7EzGR = parcelRequire("7EzGR");

var $jlqyK = parcelRequire("jlqyK");


var $GtXv4 = parcelRequire("GtXv4");

var $j1k3T = parcelRequire("j1k3T");

var $nGnd5 = parcelRequire("nGnd5");
var $73a8d342f3017eae$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 0,
            overflow: "hidden",
            transition: theme.transitions.create("height")
        },
        /* Styles applied to the root element when the transition has entered. */ entered: {
            height: "auto",
            overflow: "visible"
        },
        /* Styles applied to the root element when the transition has exited and `collapsedSize` != 0px. */ hidden: {
            visibility: "hidden"
        },
        /* Styles applied to the outer wrapper element. */ wrapper: {
            // Hack to get children with a negative margin to not falsify the height computation.
            display: "flex"
        },
        /* Styles applied to the inner wrapper element. */ wrapperInner: {
            width: "100%"
        }
    };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $73a8d342f3017eae$var$Collapse = /*#__PURE__*/ $arQ7u.forwardRef(function Collapse(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, collapsedHeight = props.collapsedHeight, _props$collapsedSize = props.collapsedSize, collapsedSizeProp = _props$collapsedSize === void 0 ? "0px" : _props$collapsedSize, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? (0, $jlqyK.duration).standard : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $d4AeH.default) : _props$TransitionComp, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "className",
        "collapsedHeight",
        "collapsedSize",
        "component",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $j1k3T.default)();
    var timer = $arQ7u.useRef();
    var wrapperRef = $arQ7u.useRef(null);
    var autoTransitionDuration = $arQ7u.useRef();
    var collapsedSize = typeof (collapsedHeight || collapsedSizeProp) === "number" ? "".concat(collapsedHeight || collapsedSizeProp, "px") : collapsedHeight || collapsedSizeProp;
    $arQ7u.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $arQ7u.useRef(null);
    var handleRef = (0, $nGnd5.default)(ref, enableStrictModeCompat ? nodeRef : undefined);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $kMfvj.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps = (0, $GtXv4.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration;
        if (timeout === "auto") {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = "".concat(wrapperHeight, "px");
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    var handleExit = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        node.style.height = "".concat(wrapperHeight, "px");
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleExiting = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps2 = (0, $GtXv4.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        }), transitionDuration = _getTransitionProps2.duration;
        if (timeout === "auto") {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = collapsedSize;
        if (onExiting) onExiting(node);
    });
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === "auto") timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    };
    return /*#__PURE__*/ $arQ7u.createElement(TransitionComponent, (0, $abElG.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        timeout: timeout === "auto" ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
            className: (0, $5g55B.default)(classes.root, classes.container, className, {
                "entered": classes.entered,
                "exited": !inProp && collapsedSize === "0px" && classes.hidden
            }[state]),
            style: (0, $abElG.default)({
                minHeight: collapsedSize
            }, style),
            ref: handleRef
        }, childProps), /*#__PURE__*/ $arQ7u.createElement("div", {
            className: classes.wrapper,
            ref: wrapperRef
        }, /*#__PURE__*/ $arQ7u.createElement("div", {
            className: classes.wrapperInner
        }, children)));
    });
});
$73a8d342f3017eae$var$Collapse.muiSupportAuto = true;
var $73a8d342f3017eae$export$2e2bcd8739ae039 = (0, $7EzGR.default)($73a8d342f3017eae$export$9dd6ff9ea0189349, {
    name: "MuiCollapse"
})($73a8d342f3017eae$var$Collapse);

});






parcelRegister("b7mwt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8181d1b2150ebce8$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $7GY88 = parcelRequire("7GY88");

var $kOyte = parcelRequire("kOyte");
/**
 * mapStateToProps - to hook up connect
 * @memberof WindowSideBarInfoPanel
 * @private
 */ var $8181d1b2150ebce8$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, windowId = _ref.windowId;
    return {
        manifestLogo: (0, $7GY88.getManifestLogo)(state, {
            windowId: windowId
        }),
        requiredStatement: (0, $7GY88.getRequiredStatement)(state, {
            windowId: windowId
        }),
        rights: (0, $7GY88.getRights)(state, {
            windowId: windowId
        })
    };
};
/**
 *
 * @param theme
 * @returns {label: {paddingLeft: number}}}
 */ var $8181d1b2150ebce8$var$styles = function styles(theme) {
    return {
        logo: {
            maxWidth: "100%"
        },
        placeholder: {
            backgroundColor: theme.palette.grey[300]
        },
        section: {
            borderBottom: ".5px solid ".concat(theme.palette.section_divider),
            paddingBottom: theme.spacing(1),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(1),
            paddingTop: theme.spacing(2)
        }
    };
};
var $8181d1b2150ebce8$var$enhance = (0, $k19ic.compose)((0, $7EzGR.default)($8181d1b2150ebce8$var$styles), (0, $eC0Mc.withTranslation)(), (0, $fbonu.default)($8181d1b2150ebce8$var$mapStateToProps), (0, $7XHRd.withPlugins)("AttributionPanel"));
var $8181d1b2150ebce8$export$2e2bcd8739ae039 = $8181d1b2150ebce8$var$enhance((0, $kOyte.AttributionPanel));

});
parcelRegister("kOyte", function(module, exports) {

$parcel$export(module.exports, "AttributionPanel", function () { return $f273374b6ea518a4$export$ddf2f365688f7da5; });

var $arQ7u = parcelRequire("arQ7u");

var $hsH5s = parcelRequire("hsH5s");

var $8Mo9a = parcelRequire("8Mo9a");

var $fNvti = parcelRequire("fNvti");

var $dyKtV = parcelRequire("dyKtV");

var $iXAXt = parcelRequire("iXAXt");

var $acwox = parcelRequire("acwox");

var $1xlvK = parcelRequire("1xlvK");

var $lyw4f = parcelRequire("lyw4f");
function $f273374b6ea518a4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f273374b6ea518a4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f273374b6ea518a4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f273374b6ea518a4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f273374b6ea518a4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f273374b6ea518a4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f273374b6ea518a4$var$_setPrototypeOf(subClass, superClass);
}
function $f273374b6ea518a4$var$_setPrototypeOf(o, p) {
    $f273374b6ea518a4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f273374b6ea518a4$var$_setPrototypeOf(o, p);
}
function $f273374b6ea518a4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f273374b6ea518a4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f273374b6ea518a4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f273374b6ea518a4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f273374b6ea518a4$var$_possibleConstructorReturn(this, result);
    };
}
function $f273374b6ea518a4$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f273374b6ea518a4$var$_assertThisInitialized(self);
}
function $f273374b6ea518a4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f273374b6ea518a4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f273374b6ea518a4$var$_getPrototypeOf(o) {
    $f273374b6ea518a4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f273374b6ea518a4$var$_getPrototypeOf(o);
}
var $f273374b6ea518a4$export$ddf2f365688f7da5 = /*#__PURE__*/ function(_Component) {
    $f273374b6ea518a4$var$_inherits(AttributionPanel, _Component);
    var _super = $f273374b6ea518a4$var$_createSuper(AttributionPanel);
    function AttributionPanel() {
        $f273374b6ea518a4$var$_classCallCheck(this, AttributionPanel);
        return _super.apply(this, arguments);
    }
    $f273374b6ea518a4$var$_createClass(AttributionPanel, [
        {
            key: "render",
            value: /**
     * render
     * @return
     */ function render() {
                var _this$props = this.props, manifestLogo = _this$props.manifestLogo, requiredStatement = _this$props.requiredStatement, rights = _this$props.rights, windowId = _this$props.windowId, id = _this$props.id, classes = _this$props.classes, t = _this$props.t;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iXAXt.default), {
                    title: t("attributionTitle"),
                    paperClassName: (0, $1xlvK.default)("attribution-panel"),
                    windowId: windowId,
                    id: id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    className: classes.section
                }, requiredStatement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $acwox.LabelValueMetadata), {
                    labelValuePairs: requiredStatement,
                    defaultLabel: t("attribution")
                }), rights && rights.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("dl", {
                    className: (0, $1xlvK.default)("label-value-metadata")
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "subtitle2",
                    component: "dt"
                }, t("rights")), rights.map(function(v) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                        variant: "body1",
                        component: "dd",
                        key: v.toString()
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $8Mo9a.default), {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: v
                    }, v));
                }))), manifestLogo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    className: classes.section
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $dyKtV.Img), {
                    src: [
                        manifestLogo
                    ],
                    alt: "",
                    role: "presentation",
                    className: classes.logo,
                    unloader: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $fNvti.default), {
                        className: classes.placeholder,
                        variant: "rect",
                        height: 60,
                        width: 60
                    })
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $lyw4f.PluginHook), this.props));
            }
        }
    ]);
    return AttributionPanel;
}((0, $arQ7u.Component));
$f273374b6ea518a4$export$ddf2f365688f7da5.defaultProps = {
    classes: {},
    manifestLogo: null,
    requiredStatement: null,
    rights: null,
    t: function t(key) {
        return key;
    }
};

});
parcelRegister("fNvti", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b803d833d89f2e8e$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");

var $5g55B = parcelRequire("5g55B");


var $6vqZH = parcelRequire("6vqZH");
var $7EzGR = parcelRequire("7EzGR");
var $b803d833d89f2e8e$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "block",
            // Create a "on paper" color with sufficient contrast retaining the color
            backgroundColor: (0, $6vqZH.alpha)(theme.palette.text.primary, theme.palette.type === "light" ? 0.11 : 0.13),
            height: "1.2em"
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            marginTop: 0,
            marginBottom: 0,
            height: "auto",
            transformOrigin: "0 60%",
            transform: "scale(1, 0.60)",
            borderRadius: theme.shape.borderRadius,
            "&:empty:before": {
                content: '"\\00a0"'
            }
        },
        /* Styles applied to the root element if `variant="rect"`. */ rect: {},
        /* Styles applied to the root element if `variant="circle"`. */ circle: {
            borderRadius: "50%"
        },
        /* Styles applied to the root element if `animation="pulse"`. */ pulse: {
            animation: "$pulse 1.5s ease-in-out 0.5s infinite"
        },
        "@keyframes pulse": {
            "0%": {
                opacity: 1
            },
            "50%": {
                opacity: 0.4
            },
            "100%": {
                opacity: 1
            }
        },
        /* Styles applied to the root element if `animation="wave"`. */ wave: {
            position: "relative",
            overflow: "hidden",
            "&::after": {
                animation: "$wave 1.6s linear 0.5s infinite",
                background: "linear-gradient(90deg, transparent, ".concat(theme.palette.action.hover, ", transparent)"),
                content: '""',
                position: "absolute",
                transform: "translateX(-100%)",
                // Avoid flash during server-side hydration
                bottom: 0,
                left: 0,
                right: 0,
                top: 0
            }
        },
        "@keyframes wave": {
            "0%": {
                transform: "translateX(-100%)"
            },
            "60%": {
                // +0.5s of delay between each loop
                transform: "translateX(100%)"
            },
            "100%": {
                transform: "translateX(100%)"
            }
        },
        /* Styles applied when the component is passed children. */ withChildren: {
            "& > *": {
                visibility: "hidden"
            }
        },
        /* Styles applied when the component is passed children and no width. */ fitContent: {
            maxWidth: "fit-content"
        },
        /* Styles applied when the component is passed children and no height. */ heightAuto: {
            height: "auto"
        }
    };
};
var $b803d833d89f2e8e$var$Skeleton = /*#__PURE__*/ $arQ7u.forwardRef(function Skeleton(props, ref) {
    var _props$animation = props.animation, animation = _props$animation === void 0 ? "pulse" : _props$animation, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "span" : _props$component, height = props.height, _props$variant = props.variant, variant = _props$variant === void 0 ? "text" : _props$variant, width = props.width, other = (0, $dXEVX.default)(props, [
        "animation",
        "classes",
        "className",
        "component",
        "height",
        "variant",
        "width"
    ]);
    var hasChildren = Boolean(other.children);
    return /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        ref: ref,
        className: (0, $5g55B.default)(classes.root, classes[variant], className, hasChildren && [
            classes.withChildren,
            !width && classes.fitContent,
            !height && classes.heightAuto
        ], animation !== false && classes[animation])
    }, other, {
        style: (0, $abElG.default)({
            width: width,
            height: height
        }, other.style)
    }));
});
var $b803d833d89f2e8e$export$2e2bcd8739ae039 = (0, $7EzGR.default)($b803d833d89f2e8e$export$9dd6ff9ea0189349, {
    name: "MuiSkeleton"
})($b803d833d89f2e8e$var$Skeleton);

});

parcelRegister("dyKtV", function(module, exports) {



(function(a, b) {
    b(module.exports, (parcelRequire("5TZlQ")), (parcelRequire("kRLBD")), (parcelRequire("arQ7u")));
})(module.exports, function(a, b, c, d) {
    "use strict";
    function e(a) {
        return a && "object" == typeof a && "default" in a ? a : {
            default: a
        };
    }
    function f(a, b) {
        var c = Object.keys(a);
        if (Object.getOwnPropertySymbols) {
            var d = Object.getOwnPropertySymbols(a);
            b && (d = d.filter(function(b) {
                return Object.getOwnPropertyDescriptor(a, b).enumerable;
            })), c.push.apply(c, d);
        }
        return c;
    }
    function g(a) {
        for(var b, c = 1; c < arguments.length; c++)b = null == arguments[c] ? {} : arguments[c], c % 2 ? f(Object(b), !0).forEach(function(c) {
            l["default"](a, c, b[c]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : f(Object(b)).forEach(function(c) {
            Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
        });
        return a;
    }
    function h(a) {
        var b = a.srcList, c = a.imgPromise, e = void 0 === c ? o({
            decode: !0
        }) : c, f = a.useSuspense, h = void 0 === f || f, i = d.useState(!1), j = i[1], k = p(q(b)), l = k.join("");
        if (r[l] || (r[l] = {
            promise: s(k, e),
            cache: "pending",
            error: null
        }), "resolved" === r[l].cache) return {
            src: r[l].src,
            isLoading: !1,
            error: null
        };
        if ("rejected" === r[l].cache) {
            if (h) throw r[l].error;
            return {
                isLoading: !1,
                error: r[l].error,
                src: void 0
            };
        }
        if (r[l].promise.then(function(a) {
            r[l] = g(g({}, r[l]), {}, {
                cache: "resolved",
                src: a
            }), h || j(l);
        })["catch"](function(a) {
            r[l] = g(g({}, r[l]), {}, {
                cache: "rejected",
                error: a
            }), h || j(l);
        }), h) throw r[l].promise;
        return {
            isLoading: !0,
            src: void 0,
            error: null
        };
    }
    function j(a, b) {
        var c = Object.keys(a);
        if (Object.getOwnPropertySymbols) {
            var d = Object.getOwnPropertySymbols(a);
            b && (d = d.filter(function(b) {
                return Object.getOwnPropertyDescriptor(a, b).enumerable;
            })), c.push.apply(c, d);
        }
        return c;
    }
    function k(a) {
        for(var b, c = 1; c < arguments.length; c++)b = null == arguments[c] ? {} : arguments[c], c % 2 ? j(Object(b), !0).forEach(function(c) {
            l["default"](a, c, b[c]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : j(Object(b)).forEach(function(c) {
            Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
        });
        return a;
    }
    var l = e(b), m = e(c), n = e(d), o = function(a) {
        var b = a.decode, c = a.crossOrigin, d = void 0 === c ? "" : c;
        return function(a) {
            return new Promise(function(c, e) {
                var f = new Image;
                d && (f.crossOrigin = d), f.onload = function() {
                    (!(void 0 !== b) || b) && f.decode ? f.decode().then(c)["catch"](e) : c();
                }, f.onerror = e, f.src = a;
            });
        };
    }, p = function(b) {
        return b.filter(function(a) {
            return a;
        });
    }, q = function(a) {
        return Array.isArray(a) ? a : [
            a
        ];
    }, r = {}, s = function(a, b) {
        var c = !1;
        return new Promise(function(d, e) {
            var f = function(a) {
                return b(a).then(function() {
                    c = !0, d(a);
                });
            };
            a.reduce(function(a, b) {
                return a["catch"](function() {
                    if (!c) return f(b);
                });
            }, f(a.shift()))["catch"](e);
        });
    }, t = [
        "decode",
        "src",
        "loader",
        "unloader",
        "container",
        "loaderContainer",
        "unloaderContainer",
        "imgPromise",
        "crossorigin",
        "useSuspense"
    ], u = function(a) {
        return a;
    };
    a.Img = function(a) {
        var b = a.decode, c = a.src, d = void 0 === c ? [] : c, e = a.loader, f = void 0 === e ? null : e, g = a.unloader, i = void 0 === g ? null : g, j = a.container, l = void 0 === j ? u : j, p = a.loaderContainer, q = void 0 === p ? u : p, r = a.unloaderContainer, s = void 0 === r ? u : r, v = a.imgPromise, w = a.crossorigin, x = a.useSuspense, y = void 0 !== x && x, z = m["default"](a, t);
        v = v || o({
            decode: !(void 0 !== b) || b,
            crossOrigin: w
        });
        var A = h({
            srcList: d,
            imgPromise: v,
            useSuspense: y
        }), B = A.src, C = A.isLoading;
        return B ? l(n["default"].createElement("img", k({
            src: B
        }, z))) : !y && C ? q(f) : !y && i ? s(i) : null;
    }, a.useImage = h, Object.defineProperty(a, "__esModule", {
        value: !0
    });
}); //# sourceMappingURL=index.js.map

});



parcelRegister("eDSSt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa8f46bc4c5dff59$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $kQy7d = parcelRequire("kQy7d");

var $7XHRd = parcelRequire("7XHRd");

var $eTBXc = parcelRequire("eTBXc");

var $7GY88 = parcelRequire("7GY88");
var $bvh50 = parcelRequire("bvh50");
var $dy9HC = parcelRequire("dy9HC");
/** */ var $aa8f46bc4c5dff59$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, windowId = _ref.windowId;
    return {
        query: (0, $bvh50.getSearchQuery)(state, {
            companionWindowId: id,
            windowId: windowId
        }),
        searchService: (0, $7GY88.getManifestSearchService)(state, {
            windowId: windowId
        }),
        suggestedSearches: (0, $dy9HC.getWindow)(state, {
            windowId: windowId
        }).suggestedSearches
    };
};
/** */ var $aa8f46bc4c5dff59$var$mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
    return {
        fetchSearch: function fetchSearch(searchId, query) {
            return dispatch($kQy7d.fetchSearch(props.windowId, props.id, searchId, query));
        },
        removeSearch: function removeSearch() {
            return dispatch($kQy7d.removeSearch(props.windowId, props.id));
        }
    };
};
/**
* Styles for withStyles HOC
*/ var $aa8f46bc4c5dff59$var$styles = function styles(theme) {
    return {
        clearChip: {
            marginLeft: theme.spacing(1)
        },
        inlineButton: {
            "& span": {
                lineHeight: "1.5em"
            },
            margin: theme.spacing(2),
            padding: 0,
            textAlign: "inherit",
            textTransform: "none"
        }
    };
};
var $aa8f46bc4c5dff59$var$enhance = (0, $k19ic.compose)((0, $fbonu.default)($aa8f46bc4c5dff59$var$mapStateToProps, $aa8f46bc4c5dff59$var$mapDispatchToProps), (0, $7EzGR.default)($aa8f46bc4c5dff59$var$styles), (0, $eC0Mc.withTranslation)(), (0, $7XHRd.withPlugins)("SearchPanel"));
var $aa8f46bc4c5dff59$export$2e2bcd8739ae039 = $aa8f46bc4c5dff59$var$enhance((0, $eTBXc.SearchPanel));

});
parcelRegister("eTBXc", function(module, exports) {

$parcel$export(module.exports, "SearchPanel", function () { return $ad83a48f2f8e143e$export$ea47151d20780fe9; });

var $arQ7u = parcelRequire("arQ7u");

var $lBY5E = parcelRequire("lBY5E");

var $dSvjd = parcelRequire("dSvjd");

var $hsH5s = parcelRequire("hsH5s");

var $iXAXt = parcelRequire("iXAXt");

var $3XdTs = parcelRequire("3XdTs");

var $ABegu = parcelRequire("ABegu");
function $ad83a48f2f8e143e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ad83a48f2f8e143e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ad83a48f2f8e143e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ad83a48f2f8e143e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ad83a48f2f8e143e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ad83a48f2f8e143e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ad83a48f2f8e143e$var$_setPrototypeOf(subClass, superClass);
}
function $ad83a48f2f8e143e$var$_setPrototypeOf(o, p) {
    $ad83a48f2f8e143e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ad83a48f2f8e143e$var$_setPrototypeOf(o, p);
}
function $ad83a48f2f8e143e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ad83a48f2f8e143e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ad83a48f2f8e143e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ad83a48f2f8e143e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ad83a48f2f8e143e$var$_possibleConstructorReturn(this, result);
    };
}
function $ad83a48f2f8e143e$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ad83a48f2f8e143e$var$_assertThisInitialized(self);
}
function $ad83a48f2f8e143e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ad83a48f2f8e143e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ad83a48f2f8e143e$var$_getPrototypeOf(o) {
    $ad83a48f2f8e143e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ad83a48f2f8e143e$var$_getPrototypeOf(o);
}
var $ad83a48f2f8e143e$export$ea47151d20780fe9 = /*#__PURE__*/ function(_Component) {
    $ad83a48f2f8e143e$var$_inherits(SearchPanel, _Component);
    var _super = $ad83a48f2f8e143e$var$_createSuper(SearchPanel);
    /** */ function SearchPanel(props) {
        var _this;
        $ad83a48f2f8e143e$var$_classCallCheck(this, SearchPanel);
        _this = _super.call(this, props);
        _this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createRef();
        return _this;
    }
    /** */ $ad83a48f2f8e143e$var$_createClass(SearchPanel, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, classes = _this$props.classes, fetchSearch = _this$props.fetchSearch, windowId = _this$props.windowId, id = _this$props.id, query = _this$props.query, removeSearch = _this$props.removeSearch, searchService = _this$props.searchService, suggestedSearches = _this$props.suggestedSearches, t = _this$props.t;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iXAXt.default), {
                    ariaLabel: t("searchTitle"),
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, t("searchTitle"), query && query !== "" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $dSvjd.default), {
                        className: classes.clearChip,
                        color: "secondary",
                        label: t("clearSearch"),
                        onClick: removeSearch,
                        onDelete: removeSearch,
                        size: "small",
                        variant: "outlined"
                    })),
                    windowId: windowId,
                    id: id,
                    titleControls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $3XdTs.default), {
                        companionWindowId: id,
                        windowId: windowId
                    }),
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $ABegu.default), {
                    containerRef: this.containerRef,
                    companionWindowId: id,
                    windowId: windowId
                }), fetchSearch && suggestedSearches && query === "" && suggestedSearches.map(function(search) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                        component: "p",
                        key: search,
                        variant: "body1"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $lBY5E.default), {
                        className: classes.inlineButton,
                        color: "secondary",
                        onClick: function onClick() {
                            return fetchSearch("".concat(searchService.id, "?q=").concat(search), search);
                        }
                    }, t("suggestSearch", {
                        query: search
                    })));
                }));
            }
        }
    ]);
    return SearchPanel;
}((0, $arQ7u.Component));
$ad83a48f2f8e143e$export$ea47151d20780fe9.defaultProps = {
    classes: {},
    fetchSearch: undefined,
    query: "",
    suggestedSearches: [],
    t: function t(key) {
        return key;
    }
};

});
parcelRegister("3XdTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e11a8b94d07b3ab$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $cFj8E = parcelRequire("cFj8E");

var $kQy7d = parcelRequire("kQy7d");

var $7GY88 = parcelRequire("7GY88");
var $bvh50 = parcelRequire("bvh50");
/**
 * mapStateToProps - used to hook up connect to state
 * @memberof SearchPanelControls
 * @private
 */ var $2e11a8b94d07b3ab$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var companionWindowId = _ref.companionWindowId, windowId = _ref.windowId;
    return {
        autocompleteService: (0, $7GY88.getManifestAutocompleteService)(state, {
            windowId: windowId
        }),
        query: (0, $bvh50.getSearchQuery)(state, {
            companionWindowId: companionWindowId,
            windowId: windowId
        }),
        searchIsFetching: (0, $bvh50.getSearchIsFetching)(state, {
            companionWindowId: companionWindowId,
            windowId: windowId
        }),
        searchService: (0, $7GY88.getManifestSearchService)(state, {
            windowId: windowId
        })
    };
};
/**
 * mapDispatchToProps - to hook up connect
 * @memberof SearchPanelControls
 * @private
 */ var $2e11a8b94d07b3ab$var$mapDispatchToProps = {
    fetchSearch: $kQy7d.fetchSearch
};
/** */ var $2e11a8b94d07b3ab$var$styles = function styles(theme) {
    return {
        endAdornment: {
            position: "absolute",
            right: 0
        },
        form: {
            paddingBottom: theme.spacing(1),
            paddingRight: theme.spacing(1.5),
            width: "100%"
        },
        searchProgress: {
            position: "absolute",
            right: 0
        }
    };
};
var $2e11a8b94d07b3ab$var$enhance = (0, $k19ic.compose)((0, $fbonu.default)($2e11a8b94d07b3ab$var$mapStateToProps, $2e11a8b94d07b3ab$var$mapDispatchToProps), (0, $7EzGR.default)($2e11a8b94d07b3ab$var$styles), (0, $eC0Mc.withTranslation)(), (0, $7XHRd.withPlugins)("SearchPanelControls"));
var $2e11a8b94d07b3ab$export$2e2bcd8739ae039 = $2e11a8b94d07b3ab$var$enhance((0, $cFj8E.SearchPanelControls));

});
parcelRegister("cFj8E", function(module, exports) {

$parcel$export(module.exports, "SearchPanelControls", function () { return $938828e2d5567c25$export$d291f0980c79ab9b; });

var $arQ7u = parcelRequire("arQ7u");

var $8EMiy = parcelRequire("8EMiy");

var $lQg1V = parcelRequire("lQg1V");

var $6Sqac = parcelRequire("6Sqac");

var $aalg4 = parcelRequire("aalg4");

var $8bWR8 = parcelRequire("8bWR8");

var $iw2n5 = parcelRequire("iw2n5");

var $ku9BZ = parcelRequire("ku9BZ");

var $029Oc = parcelRequire("029Oc");

var $g1IVl = parcelRequire("g1IVl");
function $938828e2d5567c25$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $938828e2d5567c25$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $938828e2d5567c25$var$ownKeys(Object(source), true).forEach(function(key) {
            $938828e2d5567c25$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $938828e2d5567c25$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $938828e2d5567c25$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $938828e2d5567c25$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $938828e2d5567c25$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $938828e2d5567c25$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $938828e2d5567c25$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $938828e2d5567c25$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $938828e2d5567c25$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $938828e2d5567c25$var$_setPrototypeOf(subClass, superClass);
}
function $938828e2d5567c25$var$_setPrototypeOf(o, p) {
    $938828e2d5567c25$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $938828e2d5567c25$var$_setPrototypeOf(o, p);
}
function $938828e2d5567c25$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $938828e2d5567c25$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $938828e2d5567c25$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $938828e2d5567c25$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $938828e2d5567c25$var$_possibleConstructorReturn(this, result);
    };
}
function $938828e2d5567c25$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $938828e2d5567c25$var$_assertThisInitialized(self);
}
function $938828e2d5567c25$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $938828e2d5567c25$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $938828e2d5567c25$var$_getPrototypeOf(o) {
    $938828e2d5567c25$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $938828e2d5567c25$var$_getPrototypeOf(o);
}
/** Sometimes an autocomplete match can be a simple string, other times an object
    with a `match` property, this function abstracts that away */ var $938828e2d5567c25$var$getMatch = function getMatch(option) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6Sqac)))(option) ? option.match : option;
};
var $938828e2d5567c25$export$d291f0980c79ab9b = /*#__PURE__*/ function(_Component) {
    $938828e2d5567c25$var$_inherits(SearchPanelControls, _Component);
    var _super = $938828e2d5567c25$var$_createSuper(SearchPanelControls);
    /** */ function SearchPanelControls(props) {
        var _this;
        $938828e2d5567c25$var$_classCallCheck(this, SearchPanelControls);
        _this = _super.call(this, props);
        _this.state = {
            search: props.query,
            suggestions: []
        };
        _this.handleChange = _this.handleChange.bind($938828e2d5567c25$var$_assertThisInitialized(_this));
        _this.submitSearch = _this.submitSearch.bind($938828e2d5567c25$var$_assertThisInitialized(_this));
        _this.getSuggestions = _this.getSuggestions.bind($938828e2d5567c25$var$_assertThisInitialized(_this));
        _this.selectItem = _this.selectItem.bind($938828e2d5567c25$var$_assertThisInitialized(_this));
        _this.fetchAutocomplete = (0, (/*@__PURE__*/$parcel$interopDefault($lQg1V)))(_this.fetchAutocomplete.bind($938828e2d5567c25$var$_assertThisInitialized(_this)), 500);
        _this.receiveAutocomplete = _this.receiveAutocomplete.bind($938828e2d5567c25$var$_assertThisInitialized(_this));
        return _this;
    }
    /**
   * Update the query in the component state if the query has changed in the redux store
   */ $938828e2d5567c25$var$_createClass(SearchPanelControls, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var query = this.props.query;
                if (query !== prevProps.query) // We are setting local state directly here ONLY when the query prop (from redux)
                // changed
                this.setState({
                    // eslint-disable-line react/no-did-update-set-state
                    search: query
                });
            }
        },
        {
            key: "handleChange",
            value: function handleChange(event, value, reason) {
                // For some reason the value gets reset to an empty value from the
                // useAutocomplete hook sometimes, we just ignore these cases
                if (reason === "reset" && !value) return;
                this.setState({
                    search: value,
                    suggestions: []
                });
                if (value) this.fetchAutocomplete(value);
            }
        },
        {
            key: "getSuggestions",
            value: function getSuggestions(value) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$showEmpty = _ref.showEmpty, showEmpty = _ref$showEmpty === void 0 ? false : _ref$showEmpty;
                var suggestions = this.state.suggestions;
                var inputValue = (0, (/*@__PURE__*/$parcel$interopDefault($8EMiy)))(value.trim()).toLowerCase();
                var inputLength = inputValue.length;
                return inputLength === 0 && !showEmpty ? [] : suggestions;
            }
        },
        {
            key: "fetchAutocomplete",
            value: function fetchAutocomplete(value) {
                var autocompleteService = this.props.autocompleteService;
                if (!autocompleteService) return;
                if (!value) return;
                fetch("".concat(autocompleteService.id, "?q=").concat(value)).then(function(response) {
                    return response.json();
                }).then(this.receiveAutocomplete);
            }
        },
        {
            key: "receiveAutocomplete",
            value: function receiveAutocomplete(json) {
                this.setState({
                    suggestions: json.terms
                });
            }
        },
        {
            key: "submitSearch",
            value: function submitSearch(event) {
                var _this$props = this.props, companionWindowId = _this$props.companionWindowId, fetchSearch = _this$props.fetchSearch, searchService = _this$props.searchService, windowId = _this$props.windowId;
                var search = this.state.search;
                event && event.preventDefault();
                if (!search) return;
                fetchSearch(windowId, companionWindowId, "".concat(searchService.id, "?q=").concat(search), search);
            }
        },
        {
            key: "selectItem",
            value: function selectItem(_event, selectedItem, _reason) {
                if (selectedItem && $938828e2d5567c25$var$getMatch(selectedItem)) this.setState({
                    search: $938828e2d5567c25$var$getMatch(selectedItem)
                }, this.submitSearch);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, classes = _this$props2.classes, companionWindowId = _this$props2.companionWindowId, searchIsFetching = _this$props2.searchIsFetching, t = _this$props2.t, windowId = _this$props2.windowId;
                var _this$state = this.state, search = _this$state.search, suggestions = _this$state.suggestions;
                var id = "search-".concat(companionWindowId);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("form", {
                    onSubmit: this.submitSearch,
                    className: classes.form
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $aalg4.default), {
                    id: id,
                    inputValue: search,
                    options: suggestions,
                    getOptionLabel: $938828e2d5567c25$var$getMatch,
                    getOptionSelected: function getOptionSelected(option, value) {
                        return (0, (/*@__PURE__*/$parcel$interopDefault($8EMiy)))($938828e2d5567c25$var$getMatch(option).trim()).toLowerCase() === (0, (/*@__PURE__*/$parcel$interopDefault($8EMiy)))($938828e2d5567c25$var$getMatch(value).trim()).toLowerCase();
                    },
                    noOptionsText: "",
                    onChange: this.selectItem,
                    onInputChange: this.handleChange,
                    freeSolo: true,
                    renderInput: function renderInput(params) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iw2n5.default), Object.assign({}, params, {
                            label: t("searchInputLabel"),
                            InputProps: $938828e2d5567c25$var$_objectSpread($938828e2d5567c25$var$_objectSpread({}, params.InputProps), {}, {
                                endAdornment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                                    className: classes.endAdornment
                                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $029Oc.default), {
                                    "aria-label": t("searchSubmitAria"),
                                    type: "submit"
                                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ku9BZ))), null)), Boolean(searchIsFetching) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $8bWR8.default), {
                                    className: classes.searchProgress,
                                    size: 50
                                }))
                            })
                        }));
                    }
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $g1IVl.default), {
                    windowId: windowId,
                    companionWindowId: companionWindowId
                }));
            }
        }
    ]);
    return SearchPanelControls;
}((0, $arQ7u.Component));
$938828e2d5567c25$export$d291f0980c79ab9b.defaultProps = {
    autocompleteService: undefined,
    classes: {},
    query: "",
    t: function t(key) {
        return key;
    }
};

});
parcelRegister("8EMiy", function(module, exports) {

var $jzfF8 = parcelRequire("jzfF8");

var $3zxVF = parcelRequire("3zxVF");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $64d78631dc1d331b$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $64d78631dc1d331b$var$rsComboMarksRange = "\\u0300-\\u036f", $64d78631dc1d331b$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $64d78631dc1d331b$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $64d78631dc1d331b$var$rsComboRange = $64d78631dc1d331b$var$rsComboMarksRange + $64d78631dc1d331b$var$reComboHalfMarksRange + $64d78631dc1d331b$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $64d78631dc1d331b$var$rsCombo = "[" + $64d78631dc1d331b$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $64d78631dc1d331b$var$reComboMark = RegExp($64d78631dc1d331b$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $64d78631dc1d331b$var$deburr(string) {
    string = $3zxVF(string);
    return string && string.replace($64d78631dc1d331b$var$reLatin, $jzfF8).replace($64d78631dc1d331b$var$reComboMark, "");
}
module.exports = $64d78631dc1d331b$var$deburr;

});
parcelRegister("jzfF8", function(module, exports) {

var $kUpQU = parcelRequire("kUpQU");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $e3ed6f73fa83da07$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $e3ed6f73fa83da07$var$deburrLetter = $kUpQU($e3ed6f73fa83da07$var$deburredLetters);
module.exports = $e3ed6f73fa83da07$var$deburrLetter;

});
parcelRegister("kUpQU", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $f38d17608020b31e$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $f38d17608020b31e$var$basePropertyOf;

});



parcelRegister("lQg1V", function(module, exports) {

var $6Sqac = parcelRequire("6Sqac");

var $lnlSe = parcelRequire("lnlSe");

var $3rZES = parcelRequire("3rZES");
/** Error message constants. */ var $fe6ae38684002b9e$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fe6ae38684002b9e$var$nativeMax = Math.max, $fe6ae38684002b9e$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $fe6ae38684002b9e$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($fe6ae38684002b9e$var$FUNC_ERROR_TEXT);
    wait = $3rZES(wait) || 0;
    if ($6Sqac(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $fe6ae38684002b9e$var$nativeMax($3rZES(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $fe6ae38684002b9e$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $lnlSe();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($lnlSe());
    }
    function debounced() {
        var time = $lnlSe(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $fe6ae38684002b9e$var$debounce;

});
parcelRegister("lnlSe", function(module, exports) {

var $9svsg = parcelRequire("9svsg");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $f8fcb6a330341b3a$var$now = function() {
    return $9svsg.Date.now();
};
module.exports = $f8fcb6a330341b3a$var$now;

});


parcelRegister("aalg4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $766b53fb72ef505e$export$2e2bcd8739ae039; });

var $dXEVX = parcelRequire("dXEVX");

var $4g0WD = parcelRequire("4g0WD");

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");

var $4zh2f = parcelRequire("4zh2f");

var $79JQ7 = parcelRequire("79JQ7");

var $3f9WU = parcelRequire("3f9WU");

var $4i20X = parcelRequire("4i20X");

var $dSvjd = parcelRequire("dSvjd");

var $hBHPZ = parcelRequire("hBHPZ");

var $hYFQ8 = parcelRequire("hYFQ8");

var $2lpUk = parcelRequire("2lpUk");
var $766b53fb72ef505e$export$9dd6ff9ea0189349 = function styles(theme) {
    var _option;
    return {
        /* Styles applied to the root element. */ root: {
            "&$focused $clearIndicatorDirty": {
                visibility: "visible"
            },
            /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
                "&:hover $clearIndicatorDirty": {
                    visibility: "visible"
                }
            }
        },
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Pseudo-class applied to the root element if focused. */ focused: {},
        /* Styles applied to the tag elements, e.g. the chips. */ tag: {
            margin: 3,
            maxWidth: "calc(100% - 6px)"
        },
        /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */ tagSizeSmall: {
            margin: 2,
            maxWidth: "calc(100% - 4px)"
        },
        /* Styles applied when the popup icon is rendered. */ hasPopupIcon: {},
        /* Styles applied when the clear icon is rendered. */ hasClearIcon: {},
        /* Styles applied to the Input element. */ inputRoot: {
            flexWrap: "wrap",
            "$hasPopupIcon &, $hasClearIcon &": {
                paddingRight: 30
            },
            "$hasPopupIcon$hasClearIcon &": {
                paddingRight: 56
            },
            "& $input": {
                width: 0,
                minWidth: 30
            },
            '&[class*="MuiInput-root"]': {
                paddingBottom: 1,
                "& $input": {
                    padding: 4
                },
                "& $input:first-child": {
                    padding: "6px 0"
                }
            },
            '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
                "& $input": {
                    padding: "4px 4px 5px"
                },
                "& $input:first-child": {
                    padding: "3px 0 6px"
                }
            },
            '&[class*="MuiOutlinedInput-root"]': {
                padding: 9,
                "$hasPopupIcon &, $hasClearIcon &": {
                    paddingRight: 39
                },
                "$hasPopupIcon$hasClearIcon &": {
                    paddingRight: 65
                },
                "& $input": {
                    padding: "9.5px 4px"
                },
                "& $input:first-child": {
                    paddingLeft: 6
                },
                "& $endAdornment": {
                    right: 9
                }
            },
            '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
                padding: 6,
                "& $input": {
                    padding: "4.5px 4px"
                }
            },
            '&[class*="MuiFilledInput-root"]': {
                paddingTop: 19,
                paddingLeft: 8,
                "$hasPopupIcon &, $hasClearIcon &": {
                    paddingRight: 39
                },
                "$hasPopupIcon$hasClearIcon &": {
                    paddingRight: 65
                },
                "& $input": {
                    padding: "9px 4px"
                },
                "& $endAdornment": {
                    right: 9
                }
            },
            '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
                paddingBottom: 1,
                "& $input": {
                    padding: "4.5px 4px"
                }
            }
        },
        /* Styles applied to the input element. */ input: {
            flexGrow: 1,
            textOverflow: "ellipsis",
            opacity: 0
        },
        /* Styles applied to the input element if tag focused. */ inputFocused: {
            opacity: 1
        },
        /* Styles applied to the endAdornment element. */ endAdornment: {
            // We use a position absolute to support wrapping tags.
            position: "absolute",
            right: 0,
            top: "calc(50% - 14px)" // Center vertically
        },
        /* Styles applied to the clear indicator. */ clearIndicator: {
            marginRight: -2,
            padding: 4,
            visibility: "hidden"
        },
        /* Styles applied to the clear indicator if the input is dirty. */ clearIndicatorDirty: {},
        /* Styles applied to the popup indicator. */ popupIndicator: {
            padding: 2,
            marginRight: -2
        },
        /* Styles applied to the popup indicator if the popup is open. */ popupIndicatorOpen: {
            transform: "rotate(180deg)"
        },
        /* Styles applied to the popper element. */ popper: {
            zIndex: theme.zIndex.modal
        },
        /* Styles applied to the popper element if `disablePortal={true}`. */ popperDisablePortal: {
            position: "absolute"
        },
        /* Styles applied to the `Paper` component. */ paper: (0, $abElG.default)({}, theme.typography.body1, {
            overflow: "hidden",
            margin: "4px 0"
        }),
        /* Styles applied to the `listbox` component. */ listbox: {
            listStyle: "none",
            margin: 0,
            padding: "8px 0",
            maxHeight: "40vh",
            overflow: "auto"
        },
        /* Styles applied to the loading wrapper. */ loading: {
            color: theme.palette.text.secondary,
            padding: "14px 16px"
        },
        /* Styles applied to the no option wrapper. */ noOptions: {
            color: theme.palette.text.secondary,
            padding: "14px 16px"
        },
        /* Styles applied to the option elements. */ option: (_option = {
            minHeight: 48,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16
        }, (0, $4g0WD.default)(_option, theme.breakpoints.up("sm"), {
            minHeight: "auto"
        }), (0, $4g0WD.default)(_option, '&[aria-selected="true"]', {
            backgroundColor: theme.palette.action.selected
        }), (0, $4g0WD.default)(_option, '&[data-focus="true"]', {
            backgroundColor: theme.palette.action.hover
        }), (0, $4g0WD.default)(_option, "&:active", {
            backgroundColor: theme.palette.action.selected
        }), (0, $4g0WD.default)(_option, '&[aria-disabled="true"]', {
            opacity: theme.palette.action.disabledOpacity,
            pointerEvents: "none"
        }), _option),
        /* Styles applied to the group's label elements. */ groupLabel: {
            backgroundColor: theme.palette.background.paper,
            top: -8
        },
        /* Styles applied to the group's ul elements. */ groupUl: {
            padding: 0,
            "& $option": {
                paddingLeft: 24
            }
        }
    };
};
function $766b53fb72ef505e$var$DisablePortal(props) {
    // eslint-disable-next-line react/prop-types
    var anchorEl = props.anchorEl, open = props.open, other = (0, $dXEVX.default)(props, [
        "anchorEl",
        "open"
    ]);
    return /*#__PURE__*/ $arQ7u.createElement("div", other);
}
var $766b53fb72ef505e$var$_ref = /*#__PURE__*/ $arQ7u.createElement((0, $hBHPZ.default), {
    fontSize: "small"
});
var $766b53fb72ef505e$var$_ref2 = /*#__PURE__*/ $arQ7u.createElement((0, $hYFQ8.default), null);
var $766b53fb72ef505e$var$Autocomplete = /*#__PURE__*/ $arQ7u.forwardRef(function Autocomplete(props, ref) {
    /* eslint-disable no-unused-vars */ var _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete, _props$autoHighlight = props.autoHighlight, autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight, _props$autoSelect = props.autoSelect, autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect, _props$blurOnSelect = props.blurOnSelect, blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect, ChipProps = props.ChipProps, classes = props.classes, className = props.className, _props$clearOnBlur = props.clearOnBlur, clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur, _props$clearOnEscape = props.clearOnEscape, clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape, _props$clearText = props.clearText, clearText = _props$clearText === void 0 ? "Clear" : _props$clearText, _props$closeIcon = props.closeIcon, closeIcon = _props$closeIcon === void 0 ? $766b53fb72ef505e$var$_ref : _props$closeIcon, _props$closeText = props.closeText, closeText = _props$closeText === void 0 ? "Close" : _props$closeText, _props$debug = props.debug, debug = _props$debug === void 0 ? false : _props$debug, _props$defaultValue = props.defaultValue, defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue, _props$disableClearab = props.disableClearable, disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab, _props$disableCloseOn = props.disableCloseOnSelect, disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, filterOptions = props.filterOptions, _props$filterSelected = props.filterSelectedOptions, filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected, _props$forcePopupIcon = props.forcePopupIcon, forcePopupIcon = _props$forcePopupIcon === void 0 ? "auto" : _props$forcePopupIcon, _props$freeSolo = props.freeSolo, freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$getLimitTagsTe = props.getLimitTagsText, getLimitTagsText = _props$getLimitTagsTe === void 0 ? function(more) {
        return "+".concat(more);
    } : _props$getLimitTagsTe, getOptionDisabled = props.getOptionDisabled, _props$getOptionLabel = props.getOptionLabel, getOptionLabel = _props$getOptionLabel === void 0 ? function(x) {
        return x;
    } : _props$getOptionLabel, getOptionSelected = props.getOptionSelected, groupBy = props.groupBy, _props$handleHomeEndK = props.handleHomeEndKeys, handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK, idProp = props.id, _props$includeInputIn = props.includeInputInList, includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn, inputValueProp = props.inputValue, _props$limitTags = props.limitTags, limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags, _props$ListboxCompone = props.ListboxComponent, ListboxComponent = _props$ListboxCompone === void 0 ? "ul" : _props$ListboxCompone, ListboxProps = props.ListboxProps, _props$loading = props.loading, loading = _props$loading === void 0 ? false : _props$loading, _props$loadingText = props.loadingText, loadingText = _props$loadingText === void 0 ? "Loading\u2026" : _props$loadingText, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$noOptionsText = props.noOptionsText, noOptionsText = _props$noOptionsText === void 0 ? "No options" : _props$noOptionsText, onChange = props.onChange, onClose = props.onClose, onHighlightChange = props.onHighlightChange, onInputChange = props.onInputChange, onOpen = props.onOpen, open = props.open, _props$openOnFocus = props.openOnFocus, openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus, _props$openText = props.openText, openText = _props$openText === void 0 ? "Open" : _props$openText, options = props.options, _props$PaperComponent = props.PaperComponent, PaperComponent = _props$PaperComponent === void 0 ? (0, $3f9WU.default) : _props$PaperComponent, _props$PopperComponen = props.PopperComponent, PopperComponentProp = _props$PopperComponen === void 0 ? (0, $4zh2f.default) : _props$PopperComponen, _props$popupIcon = props.popupIcon, popupIcon = _props$popupIcon === void 0 ? $766b53fb72ef505e$var$_ref2 : _props$popupIcon, renderGroupProp = props.renderGroup, renderInput = props.renderInput, renderOptionProp = props.renderOption, renderTags = props.renderTags, _props$selectOnFocus = props.selectOnFocus, selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, valueProp = props.value, other = (0, $dXEVX.default)(props, [
        "autoComplete",
        "autoHighlight",
        "autoSelect",
        "blurOnSelect",
        "ChipProps",
        "classes",
        "className",
        "clearOnBlur",
        "clearOnEscape",
        "clearText",
        "closeIcon",
        "closeText",
        "debug",
        "defaultValue",
        "disableClearable",
        "disableCloseOnSelect",
        "disabled",
        "disabledItemsFocusable",
        "disableListWrap",
        "disablePortal",
        "filterOptions",
        "filterSelectedOptions",
        "forcePopupIcon",
        "freeSolo",
        "fullWidth",
        "getLimitTagsText",
        "getOptionDisabled",
        "getOptionLabel",
        "getOptionSelected",
        "groupBy",
        "handleHomeEndKeys",
        "id",
        "includeInputInList",
        "inputValue",
        "limitTags",
        "ListboxComponent",
        "ListboxProps",
        "loading",
        "loadingText",
        "multiple",
        "noOptionsText",
        "onChange",
        "onClose",
        "onHighlightChange",
        "onInputChange",
        "onOpen",
        "open",
        "openOnFocus",
        "openText",
        "options",
        "PaperComponent",
        "PopperComponent",
        "popupIcon",
        "renderGroup",
        "renderInput",
        "renderOption",
        "renderTags",
        "selectOnFocus",
        "size",
        "value"
    ]);
    /* eslint-enable no-unused-vars */ var PopperComponent = disablePortal ? $766b53fb72ef505e$var$DisablePortal : PopperComponentProp;
    var _useAutocomplete = (0, $2lpUk.default)((0, $abElG.default)({}, props, {
        componentName: "Autocomplete"
    })), getRootProps = _useAutocomplete.getRootProps, getInputProps = _useAutocomplete.getInputProps, getInputLabelProps = _useAutocomplete.getInputLabelProps, getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps, getClearProps = _useAutocomplete.getClearProps, getTagProps = _useAutocomplete.getTagProps, getListboxProps = _useAutocomplete.getListboxProps, getOptionProps = _useAutocomplete.getOptionProps, value = _useAutocomplete.value, dirty = _useAutocomplete.dirty, id = _useAutocomplete.id, popupOpen = _useAutocomplete.popupOpen, focused = _useAutocomplete.focused, focusedTag = _useAutocomplete.focusedTag, anchorEl = _useAutocomplete.anchorEl, setAnchorEl = _useAutocomplete.setAnchorEl, inputValue = _useAutocomplete.inputValue, groupedOptions = _useAutocomplete.groupedOptions;
    var startAdornment;
    if (multiple && value.length > 0) {
        var getCustomizedTagProps = function getCustomizedTagProps(params) {
            return (0, $abElG.default)({
                className: (0, $5g55B.default)(classes.tag, size === "small" && classes.tagSizeSmall),
                disabled: disabled
            }, getTagProps(params));
        };
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps);
        else startAdornment = value.map(function(option, index) {
            return /*#__PURE__*/ $arQ7u.createElement((0, $dSvjd.default), (0, $abElG.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps));
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        var more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ $arQ7u.createElement("span", {
                className: classes.tag,
                key: startAdornment.length
            }, getLimitTagsText(more)));
        }
    }
    var defaultRenderGroup = function defaultRenderGroup(params) {
        return /*#__PURE__*/ $arQ7u.createElement("li", {
            key: params.key
        }, /*#__PURE__*/ $arQ7u.createElement((0, $79JQ7.default), {
            className: classes.groupLabel,
            component: "div"
        }, params.group), /*#__PURE__*/ $arQ7u.createElement("ul", {
            className: classes.groupUl
        }, params.children));
    };
    var renderGroup = renderGroupProp || defaultRenderGroup;
    var renderOption = renderOptionProp || getOptionLabel;
    var renderListOption = function renderListOption(option, index) {
        var optionProps = getOptionProps({
            option: option,
            index: index
        });
        return /*#__PURE__*/ $arQ7u.createElement("li", (0, $abElG.default)({}, optionProps, {
            className: classes.option
        }), renderOption(option, {
            selected: optionProps["aria-selected"],
            inputValue: inputValue
        }));
    };
    var hasClearIcon = !disableClearable && !disabled;
    var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    return /*#__PURE__*/ $arQ7u.createElement($arQ7u.Fragment, null, /*#__PURE__*/ $arQ7u.createElement("div", (0, $abElG.default)({
        ref: ref,
        className: (0, $5g55B.default)(classes.root, className, focused && classes.focused, fullWidth && classes.fullWidth, hasClearIcon && classes.hasClearIcon, hasPopupIcon && classes.hasPopupIcon)
    }, getRootProps(other)), renderInput({
        id: id,
        disabled: disabled,
        fullWidth: true,
        size: size === "small" ? "small" : undefined,
        InputLabelProps: getInputLabelProps(),
        InputProps: {
            ref: setAnchorEl,
            className: classes.inputRoot,
            startAdornment: startAdornment,
            endAdornment: /*#__PURE__*/ $arQ7u.createElement("div", {
                className: classes.endAdornment
            }, hasClearIcon ? /*#__PURE__*/ $arQ7u.createElement((0, $4i20X.default), (0, $abElG.default)({}, getClearProps(), {
                "aria-label": clearText,
                title: clearText,
                className: (0, $5g55B.default)(classes.clearIndicator, dirty && classes.clearIndicatorDirty)
            }), closeIcon) : null, hasPopupIcon ? /*#__PURE__*/ $arQ7u.createElement((0, $4i20X.default), (0, $abElG.default)({}, getPopupIndicatorProps(), {
                disabled: disabled,
                "aria-label": popupOpen ? closeText : openText,
                title: popupOpen ? closeText : openText,
                className: (0, $5g55B.default)(classes.popupIndicator, popupOpen && classes.popupIndicatorOpen)
            }), popupIcon) : null)
        },
        inputProps: (0, $abElG.default)({
            className: (0, $5g55B.default)(classes.input, focusedTag === -1 && classes.inputFocused),
            disabled: disabled
        }, getInputProps())
    })), popupOpen && anchorEl ? /*#__PURE__*/ $arQ7u.createElement(PopperComponent, {
        className: (0, $5g55B.default)(classes.popper, disablePortal && classes.popperDisablePortal),
        style: {
            width: anchorEl ? anchorEl.clientWidth : null
        },
        role: "presentation",
        anchorEl: anchorEl,
        open: true
    }, /*#__PURE__*/ $arQ7u.createElement(PaperComponent, {
        className: classes.paper
    }, loading && groupedOptions.length === 0 ? /*#__PURE__*/ $arQ7u.createElement("div", {
        className: classes.loading
    }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ $arQ7u.createElement("div", {
        className: classes.noOptions
    }, noOptionsText) : null, groupedOptions.length > 0 ? /*#__PURE__*/ $arQ7u.createElement(ListboxComponent, (0, $abElG.default)({
        className: classes.listbox
    }, getListboxProps(), ListboxProps), groupedOptions.map(function(option, index) {
        if (groupBy) return renderGroup({
            key: option.key,
            group: option.group,
            children: option.options.map(function(option2, index2) {
                return renderListOption(option2, option.index + index2);
            })
        });
        return renderListOption(option, index);
    })) : null)) : null);
});
var $766b53fb72ef505e$export$2e2bcd8739ae039 = (0, $7EzGR.default)($766b53fb72ef505e$export$9dd6ff9ea0189349, {
    name: "MuiAutocomplete"
})($766b53fb72ef505e$var$Autocomplete);

});
parcelRegister("79JQ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $535cee70d5085767$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");

var $kaLUp = parcelRequire("kaLUp");
var $535cee70d5085767$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            boxSizing: "border-box",
            lineHeight: "48px",
            listStyle: "none",
            color: theme.palette.text.secondary,
            fontFamily: theme.typography.fontFamily,
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: theme.typography.pxToRem(14)
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the root element if `inset={true}`. */ inset: {
            paddingLeft: 72
        },
        /* Styles applied to the root element if `disableSticky={false}`. */ sticky: {
            position: "sticky",
            top: 0,
            zIndex: 1,
            backgroundColor: "inherit"
        }
    };
};
var $535cee70d5085767$var$ListSubheader = /*#__PURE__*/ $arQ7u.forwardRef(function ListSubheader(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "li" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$disableSticky = props.disableSticky, disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky, _props$inset = props.inset, inset = _props$inset === void 0 ? false : _props$inset, other = (0, $dXEVX.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "disableGutters",
        "disableSticky",
        "inset"
    ]);
    return /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, color !== "default" && classes["color".concat((0, $kaLUp.default)(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $535cee70d5085767$export$2e2bcd8739ae039 = (0, $7EzGR.default)($535cee70d5085767$export$9dd6ff9ea0189349, {
    name: "MuiListSubheader"
})($535cee70d5085767$var$ListSubheader);

});

parcelRegister("hBHPZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd17e59aceda4ae2$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $2Ml3G = parcelRequire("2Ml3G");
var /**
 * @ignore - internal component.
 */ $cd17e59aceda4ae2$export$2e2bcd8739ae039 = (0, $2Ml3G.default)(/*#__PURE__*/ $arQ7u.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

});

parcelRegister("hYFQ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1687ecffbda8216$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $2Ml3G = parcelRequire("2Ml3G");
var /**
 * @ignore - internal component.
 */ $d1687ecffbda8216$export$2e2bcd8739ae039 = (0, $2Ml3G.default)(/*#__PURE__*/ $arQ7u.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

});

parcelRegister("2lpUk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b51a39c66cd5796$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $kMfvj = parcelRequire("kMfvj");
parcelRequire("7Dbhg");

var $arQ7u = parcelRequire("arQ7u");

var $KZePB = parcelRequire("KZePB");
var $eIm5l = parcelRequire("eIm5l");
var $lhLsx = parcelRequire("lhLsx");
var $e3Evk = parcelRequire("e3Evk");
// Give up on IE 11 support for this feature
function $1b51a39c66cd5796$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $1b51a39c66cd5796$export$f76f94b238d946d8() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$ignoreAccents = config.ignoreAccents, ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents, _config$ignoreCase = config.ignoreCase, ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase, limit = config.limit, _config$matchFrom = config.matchFrom, matchFrom = _config$matchFrom === void 0 ? "any" : _config$matchFrom, stringify = config.stringify, _config$trim = config.trim, trim = _config$trim === void 0 ? false : _config$trim;
    return function(options, _ref) {
        var inputValue = _ref.inputValue, getOptionLabel = _ref.getOptionLabel;
        var input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $1b51a39c66cd5796$var$stripDiacritics(input);
        var filteredOptions = options.filter(function(option) {
            var candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $1b51a39c66cd5796$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
} // To replace with .findIndex() once we stop IE 11 support.
function $1b51a39c66cd5796$var$findIndex(array, comp) {
    for(var i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
var $1b51a39c66cd5796$var$defaultFilterOptions = $1b51a39c66cd5796$export$f76f94b238d946d8(); // Number of options to jump in list box when pageup and pagedown keys are used.
var $1b51a39c66cd5796$var$pageSize = 5;
function $1b51a39c66cd5796$export$2e2bcd8739ae039(props) {
    var _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete, _props$autoHighlight = props.autoHighlight, autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight, _props$autoSelect = props.autoSelect, autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect, _props$blurOnSelect = props.blurOnSelect, blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect, _props$clearOnBlur = props.clearOnBlur, clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur, _props$clearOnEscape = props.clearOnEscape, clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape, _props$componentName = props.componentName, componentName = _props$componentName === void 0 ? "useAutocomplete" : _props$componentName, _props$debug = props.debug, debug = _props$debug === void 0 ? false : _props$debug, _props$defaultValue = props.defaultValue, defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue, _props$disableClearab = props.disableClearable, disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab, _props$disableCloseOn = props.disableCloseOnSelect, disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, _props$filterOptions = props.filterOptions, filterOptions = _props$filterOptions === void 0 ? $1b51a39c66cd5796$var$defaultFilterOptions : _props$filterOptions, _props$filterSelected = props.filterSelectedOptions, filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected, _props$freeSolo = props.freeSolo, freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo, getOptionDisabled = props.getOptionDisabled, _props$getOptionLabel = props.getOptionLabel, getOptionLabelProp = _props$getOptionLabel === void 0 ? function(option) {
        return option;
    } : _props$getOptionLabel, _props$getOptionSelec = props.getOptionSelected, getOptionSelected = _props$getOptionSelec === void 0 ? function(option, value) {
        return option === value;
    } : _props$getOptionSelec, groupBy = props.groupBy, _props$handleHomeEndK = props.handleHomeEndKeys, handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK, idProp = props.id, _props$includeInputIn = props.includeInputInList, includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn, inputValueProp = props.inputValue, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, onChange = props.onChange, onClose = props.onClose, onHighlightChange = props.onHighlightChange, onInputChange = props.onInputChange, onOpen = props.onOpen, openProp = props.open, _props$openOnFocus = props.openOnFocus, openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus, options = props.options, _props$selectOnFocus = props.selectOnFocus, selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus, valueProp = props.value;
    var id = (0, $eIm5l.default)(idProp);
    var getOptionLabel = getOptionLabelProp;
    var ignoreFocus = $arQ7u.useRef(false);
    var firstFocus = $arQ7u.useRef(true);
    var inputRef = $arQ7u.useRef(null);
    var listboxRef = $arQ7u.useRef(null);
    var _React$useState = $arQ7u.useState(null), anchorEl = _React$useState[0], setAnchorEl = _React$useState[1];
    var _React$useState2 = $arQ7u.useState(-1), focusedTag = _React$useState2[0], setFocusedTag = _React$useState2[1];
    var defaultHighlighted = autoHighlight ? 0 : -1;
    var highlightedIndexRef = $arQ7u.useRef(defaultHighlighted);
    var _useControlled = (0, $lhLsx.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    }), _useControlled2 = (0, $kMfvj.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var _useControlled3 = (0, $lhLsx.default)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    }), _useControlled4 = (0, $kMfvj.default)(_useControlled3, 2), inputValue = _useControlled4[0], setInputValue = _useControlled4[1];
    var _React$useState3 = $arQ7u.useState(false), focused = _React$useState3[0], setFocused = _React$useState3[1];
    var resetInputValue = (0, $e3Evk.default)(function(event, newValue) {
        var newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            var optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValue(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    });
    $arQ7u.useEffect(function() {
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue
    ]);
    var _useControlled5 = (0, $lhLsx.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    }), _useControlled6 = (0, $kMfvj.default)(_useControlled5, 2), open = _useControlled6[0], setOpenState = _useControlled6[1];
    var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    var popupOpen = open;
    var filteredOptions = popupOpen ? filterOptions(options.filter(function(option) {
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some(function(value2) {
            return value2 !== null && getOptionSelected(option, value2);
        })) return false;
        return true;
    }), // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    var missingValue;
    var focusTag = (0, $e3Evk.default)(function(tagToFocus) {
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector('[data-tag-index="'.concat(tagToFocus, '"]')).focus();
    }); // Ensure the focusedTag is never inconsistent
    $arQ7u.useEffect(function() {
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index === -1) return -1;
        var nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === filteredOptions.length || direction === "previous" && nextFocus === -1) return -1;
            var option = listboxRef.current.querySelector('[data-option-index="'.concat(nextFocus, '"]')); // Same logic as MenuList.js
            var nextFocusDisabled = disabledItemsFocusable ? false : option && (option.disabled || option.getAttribute("aria-disabled") === "true");
            if (option && !option.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
            nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    var setHighlightedIndex = (0, $e3Evk.default)(function(_ref2) {
        var event = _ref2.event, index = _ref2.index, _ref2$reason = _ref2.reason, reason = _ref2$reason === void 0 ? "auto" : _ref2$reason;
        highlightedIndexRef.current = index; // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", "".concat(id, "-option-").concat(index));
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        var prev = listboxRef.current.querySelector("[data-focus]");
        if (prev) prev.removeAttribute("data-focus");
        var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        var option = listboxRef.current.querySelector('[data-option-index="'.concat(index, '"]'));
        if (!option) return;
        option.setAttribute("data-focus", "true"); // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
        //
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse") {
            var element = option;
            var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            var elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    var changeHighlightedIndex = (0, $e3Evk.default)(function(_ref3) {
        var event = _ref3.event, diff = _ref3.diff, _ref3$direction = _ref3.direction, direction = _ref3$direction === void 0 ? "next" : _ref3$direction, _ref3$reason = _ref3.reason, reason = _ref3$reason === void 0 ? "auto" : _ref3$reason;
        if (!popupOpen) return;
        var getNextIndex = function getNextIndex() {
            var maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            var newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        var nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        }); // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                var option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                var index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    var syncHighlightedIndex = $arQ7u.useCallback(function() {
        if (!popupOpen) return;
        var valueItem = multiple ? value[0] : value; // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
         // Synchronize the value with the highlighted index
        if (!filterSelectedOptions && valueItem != null) {
            var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible
            if (multiple && currentOption && $1b51a39c66cd5796$var$findIndex(value, function(val) {
                return getOptionSelected(currentOption, val);
            }) !== -1) return;
            var itemIndex = $1b51a39c66cd5796$var$findIndex(filteredOptions, function(optionItem) {
                return getOptionSelected(optionItem, valueItem);
            });
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        } // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        } // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        }); // Ignore filteredOptions (and options, getOptionSelected, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        filteredOptions.length === 0,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    var handleListboxRef = (0, $e3Evk.default)(function(node) {
        (0, $KZePB.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $arQ7u.useEffect(function() {
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    var handleOpen = function handleOpen(event) {
        if (open) return;
        setOpenState(true);
        if (onOpen) onOpen(event);
    };
    var handleClose = function handleClose(event, reason) {
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    var handleValue = function handleValue(event, newValue, reason, details) {
        if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValue(newValue);
    };
    var isTouch = $arQ7u.useRef(false);
    var selectNewValue = function selectNewValue(event, option) {
        var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "select-option";
        var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "options";
        var reason = reasonProp;
        var newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            var matches;
            var itemIndex = $1b51a39c66cd5796$var$findIndex(newValue, function(valueItem) {
                return getOptionSelected(option, valueItem);
            });
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "remove-option";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        var nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            var option = anchorEl.querySelector('[data-tag-index="'.concat(nextFocus, '"]')); // Same logic as MenuList.js
            if (option && (!option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true")) nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    var handleFocusTag = function handleFocusTag(event, direction) {
        if (!multiple) return;
        handleClose(event, "toggleInput");
        var nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    var handleClear = function handleClear(event) {
        ignoreFocus.current = true;
        setInputValue("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    var handleKeyDown = function handleKeyDown(other) {
        return function(event) {
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$1b51a39c66cd5796$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $1b51a39c66cd5796$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    // Wait until IME is settled.
                    if (event.which === 229) break;
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        var option = filteredOptions[highlightedIndexRef.current];
                        var disabled = getOptionDisabled ? getOptionDisabled(option) : false; // We don't want to validate the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "select-option"); // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "create-option", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault(); // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault(); // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    if (multiple && inputValue === "" && value.length > 0) {
                        var index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        var newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "remove-option", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
            if (other.onKeyDown) other.onKeyDown(event);
        };
    };
    var handleFocus = function handleFocus(event) {
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    var handleBlur = function handleBlur(event) {
        // Ignore the event when using the scrollbar with IE 11
        if (listboxRef.current !== null && document.activeElement === listboxRef.current.parentElement) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (debug && inputValue !== "") return;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    var handleInputChange = function handleInputChange(event) {
        var newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValue(newValue);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    var handleOptionMouseOver = function handleOptionMouseOver(event) {
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "mouse"
        });
    };
    var handleOptionTouchStart = function handleOptionTouchStart() {
        isTouch.current = true;
    };
    var handleOptionClick = function handleOptionClick(event) {
        var index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "select-option");
        isTouch.current = false;
    };
    var handleTagDelete = function handleTagDelete(index) {
        return function(event) {
            var newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "remove-option", {
                option: value[index]
            });
        };
    };
    var handlePopupIndicator = function handlePopupIndicator(event) {
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    }; // Prevent input blur when interacting with the combobox
    var handleMouseDown = function handleMouseDown(event) {
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    }; // Focus the input when interacting with the combobox
    var handleClick = function handleClick() {
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    var handleInputMouseDown = function handleInputMouseDown(event) {
        if (inputValue === "" || !open) handlePopupIndicator(event);
    };
    var dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    var groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        var indexBy = new Map();
        var warn = false;
        groupedOptions = filteredOptions.reduce(function(acc, option, index) {
            var group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    return {
        getRootProps: function getRootProps() {
            var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return (0, $abElG.default)({
                "aria-owns": popupOpen ? "".concat(id, "-popup") : null,
                role: "combobox",
                "aria-expanded": popupOpen
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            });
        },
        getInputLabelProps: function getInputLabelProps() {
            return {
                id: "".concat(id, "-label"),
                htmlFor: id
            };
        },
        getInputProps: function getInputProps() {
            return {
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperativeley so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": popupOpen ? "".concat(id, "-popup") : null,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false"
            };
        },
        getClearProps: function getClearProps() {
            return {
                tabIndex: -1,
                onClick: handleClear
            };
        },
        getPopupIndicatorProps: function getPopupIndicatorProps() {
            return {
                tabIndex: -1,
                onClick: handlePopupIndicator
            };
        },
        getTagProps: function getTagProps(_ref4) {
            var index = _ref4.index;
            return {
                key: index,
                "data-tag-index": index,
                tabIndex: -1,
                onDelete: handleTagDelete(index)
            };
        },
        getListboxProps: function getListboxProps() {
            return {
                role: "listbox",
                id: "".concat(id, "-popup"),
                "aria-labelledby": "".concat(id, "-label"),
                ref: handleListboxRef,
                onMouseDown: function onMouseDown(event) {
                    // Prevent blur
                    event.preventDefault();
                }
            };
        },
        getOptionProps: function getOptionProps(_ref5) {
            var index = _ref5.index, option = _ref5.option;
            var selected = (multiple ? value : [
                value
            ]).some(function(value2) {
                return value2 != null && getOptionSelected(option, value2);
            });
            var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: index,
                tabIndex: -1,
                role: "option",
                id: "".concat(id, "-option-").concat(index),
                onMouseOver: handleOptionMouseOver,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}

});


parcelRegister("8bWR8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $018a0426b8740cae$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");


var $7EzGR = parcelRequire("7EzGR");

var $kaLUp = parcelRequire("kaLUp");
var $018a0426b8740cae$var$SIZE = 44;
var $018a0426b8740cae$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "inline-block"
        },
        /* Styles applied to the root element if `variant="static"`. */ static: {
            transition: theme.transitions.create("transform")
        },
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {
            animation: "$circular-rotate 1.4s linear infinite"
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {
            transition: theme.transitions.create("transform")
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the `svg` element. */ svg: {
            display: "block" // Keeps the progress centered
        },
        /* Styles applied to the `circle` svg path. */ circle: {
            stroke: "currentColor" // Use butt to follow the specification, by chance, it's already the default CSS value.
        },
        /* Styles applied to the `circle` svg path if `variant="static"`. */ circleStatic: {
            transition: theme.transitions.create("stroke-dashoffset")
        },
        /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */ circleIndeterminate: {
            animation: "$circular-dash 1.4s ease-in-out infinite",
            // Some default value that looks fine waiting for the animation to kicks in.
            strokeDasharray: "80px, 200px",
            strokeDashoffset: "0px" // Add the unit to fix a Edge 16 and below bug.
        },
        /* Styles applied to the `circle` svg path if `variant="determinate"`. */ circleDeterminate: {
            transition: theme.transitions.create("stroke-dashoffset")
        },
        "@keyframes circular-rotate": {
            "0%": {
                // Fix IE 11 wobbly
                transformOrigin: "50% 50%"
            },
            "100%": {
                transform: "rotate(360deg)"
            }
        },
        "@keyframes circular-dash": {
            "0%": {
                strokeDasharray: "1px, 200px",
                strokeDashoffset: "0px"
            },
            "50%": {
                strokeDasharray: "100px, 200px",
                strokeDashoffset: "-15px"
            },
            "100%": {
                strokeDasharray: "100px, 200px",
                strokeDashoffset: "-125px"
            }
        },
        /* Styles applied to the `circle` svg path if `disableShrink={true}`. */ circleDisableShrink: {
            animation: "none"
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $018a0426b8740cae$var$CircularProgress = /*#__PURE__*/ $arQ7u.forwardRef(function CircularProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$disableShrink = props.disableShrink, disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink, _props$size = props.size, size = _props$size === void 0 ? 40 : _props$size, style = props.style, _props$thickness = props.thickness, thickness = _props$thickness === void 0 ? 3.6 : _props$thickness, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, _props$variant = props.variant, variant = _props$variant === void 0 ? "indeterminate" : _props$variant, other = (0, $dXEVX.default)(props, [
        "classes",
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};
    if (variant === "determinate" || variant === "static") {
        var circumference = 2 * Math.PI * (($018a0426b8740cae$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ $arQ7u.createElement("div", (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $kaLUp.default)(color))], {
            "determinate": classes.determinate,
            "indeterminate": classes.indeterminate,
            "static": classes.static
        }[variant]),
        style: (0, $abElG.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ref: ref,
        role: "progressbar"
    }, rootProps, other), /*#__PURE__*/ $arQ7u.createElement("svg", {
        className: classes.svg,
        viewBox: "".concat($018a0426b8740cae$var$SIZE / 2, " ").concat($018a0426b8740cae$var$SIZE / 2, " ").concat($018a0426b8740cae$var$SIZE, " ").concat($018a0426b8740cae$var$SIZE)
    }, /*#__PURE__*/ $arQ7u.createElement("circle", {
        className: (0, $5g55B.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
            "determinate": classes.circleDeterminate,
            "indeterminate": classes.circleIndeterminate,
            "static": classes.circleStatic
        }[variant]),
        style: circleStyle,
        cx: $018a0426b8740cae$var$SIZE,
        cy: $018a0426b8740cae$var$SIZE,
        r: ($018a0426b8740cae$var$SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
    })));
});
var $018a0426b8740cae$export$2e2bcd8739ae039 = (0, $7EzGR.default)($018a0426b8740cae$export$9dd6ff9ea0189349, {
    name: "MuiCircularProgress",
    flip: false
})($018a0426b8740cae$var$CircularProgress);

});

parcelRegister("iw2n5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7ad0e14310081a0$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");



var $iwnYb = parcelRequire("iwnYb");

var $ajiku = parcelRequire("ajiku");

var $8h9eG = parcelRequire("8h9eG");

var $77ver = parcelRequire("77ver");

var $f3WEt = parcelRequire("f3WEt");

var $3HQmy = parcelRequire("3HQmy");

var $c6RGo = parcelRequire("c6RGo");

var $7EzGR = parcelRequire("7EzGR");
var $d7ad0e14310081a0$var$variantComponent = {
    standard: (0, $iwnYb.default),
    filled: (0, $ajiku.default),
    outlined: (0, $8h9eG.default)
};
var $d7ad0e14310081a0$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var $d7ad0e14310081a0$var$TextField = /*#__PURE__*/ $arQ7u.forwardRef(function TextField(props, ref) {
    var autoComplete = props.autoComplete, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, FormHelperTextProps = props.FormHelperTextProps, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, rows = props.rows, rowsMax = props.rowsMax, maxRows = props.maxRows, minRows = props.minRows, _props$select = props.select, select = _props$select === void 0 ? false : _props$select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $dXEVX.default)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "hiddenLabel",
        "id",
        "InputLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "rowsMax",
        "maxRows",
        "minRows",
        "select",
        "SelectProps",
        "type",
        "value",
        "variant"
    ]);
    var InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        if (label) {
            var _InputLabelProps$requ;
            var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
            InputMore.label = /*#__PURE__*/ $arQ7u.createElement($arQ7u.Fragment, null, label, displayRequired && "\xa0*");
        }
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = $d7ad0e14310081a0$var$variantComponent[variant];
    var InputElement = /*#__PURE__*/ $arQ7u.createElement(InputComponent, (0, $abElG.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ $arQ7u.createElement((0, $f3WEt.default), (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        ref: ref,
        required: required,
        color: color,
        variant: variant
    }, other), label && /*#__PURE__*/ $arQ7u.createElement((0, $77ver.default), (0, $abElG.default)({
        htmlFor: id,
        id: inputLabelId
    }, InputLabelProps), label), select ? /*#__PURE__*/ $arQ7u.createElement((0, $c6RGo.default), (0, $abElG.default)({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement
    }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/ $arQ7u.createElement((0, $3HQmy.default), (0, $abElG.default)({
        id: helperTextId
    }, FormHelperTextProps), helperText));
});
var $d7ad0e14310081a0$export$2e2bcd8739ae039 = (0, $7EzGR.default)($d7ad0e14310081a0$export$9dd6ff9ea0189349, {
    name: "MuiTextField"
})($d7ad0e14310081a0$var$TextField);

});
parcelRegister("77ver", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52f169d7de9ce301$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $tTTvC = parcelRequire("tTTvC");

var $6cXJA = parcelRequire("6cXJA");

var $7EzGR = parcelRequire("7EzGR");

var $kiii3 = parcelRequire("kiii3");
var $52f169d7de9ce301$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "block",
            transformOrigin: "top left"
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Pseudo-class applied to the asterisk element. */ asterisk: {},
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            position: "absolute",
            left: 0,
            top: 0,
            // slight alteration to spec spacing to match visual spec result
            transform: "translate(0, 24px) scale(1)"
        },
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            // Compensation for the `Input.inputDense` style.
            transform: "translate(0, 21px) scale(1)"
        },
        /* Styles applied to the `input` element if `shrink={true}`. */ shrink: {
            transform: "translate(0, 1.5px) scale(0.75)",
            transformOrigin: "top left"
        },
        /* Styles applied to the `input` element if `disableAnimation={false}`. */ animated: {
            transition: theme.transitions.create([
                "color",
                "transform"
            ], {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the root element if `variant="filled"`. */ filled: {
            // Chrome's autofill feature gives the input field a yellow background.
            // Since the input field is behind the label in the HTML tree,
            // the input field is drawn last and hides the label with an opaque background color.
            // zIndex: 1 will raise the label above opaque background-colors of input.
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(12px, 20px) scale(1)",
            "&$marginDense": {
                transform: "translate(12px, 17px) scale(1)"
            },
            "&$shrink": {
                transform: "translate(12px, 10px) scale(0.75)",
                "&$marginDense": {
                    transform: "translate(12px, 7px) scale(0.75)"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            // see comment above on filled.zIndex
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(14px, 20px) scale(1)",
            "&$marginDense": {
                transform: "translate(14px, 12px) scale(1)"
            },
            "&$shrink": {
                transform: "translate(14px, -6px) scale(0.75)"
            }
        }
    };
};
var $52f169d7de9ce301$var$InputLabel = /*#__PURE__*/ $arQ7u.forwardRef(function InputLabel(props, ref) {
    var classes = props.classes, className = props.className, _props$disableAnimati = props.disableAnimation, disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati, margin = props.margin, shrinkProp = props.shrink, variant = props.variant, other = (0, $dXEVX.default)(props, [
        "classes",
        "className",
        "disableAnimation",
        "margin",
        "shrink",
        "variant"
    ]);
    var muiFormControl = (0, $6cXJA.default)();
    var shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    var fcs = (0, $tTTvC.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "margin",
            "variant"
        ]
    });
    return /*#__PURE__*/ $arQ7u.createElement((0, $kiii3.default), (0, $abElG.default)({
        "data-shrink": shrink,
        className: (0, $5g55B.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === "dense" && classes.marginDense, {
            "filled": classes.filled,
            "outlined": classes.outlined
        }[fcs.variant]),
        classes: {
            focused: classes.focused,
            disabled: classes.disabled,
            error: classes.error,
            required: classes.required,
            asterisk: classes.asterisk
        },
        ref: ref
    }, other));
});
var $52f169d7de9ce301$export$2e2bcd8739ae039 = (0, $7EzGR.default)($52f169d7de9ce301$export$9dd6ff9ea0189349, {
    name: "MuiInputLabel"
})($52f169d7de9ce301$var$InputLabel);

});
parcelRegister("kiii3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec63ad2a501c4e71$export$2e2bcd8739ae039; });

var $dXEVX = parcelRequire("dXEVX");

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $tTTvC = parcelRequire("tTTvC");

var $6cXJA = parcelRequire("6cXJA");

var $kaLUp = parcelRequire("kaLUp");

var $7EzGR = parcelRequire("7EzGR");
var $ec63ad2a501c4e71$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $abElG.default)({
            color: theme.palette.text.secondary
        }, theme.typography.body1, {
            lineHeight: 1,
            padding: 0,
            "&$focused": {
                color: theme.palette.primary.main
            },
            "&$disabled": {
                color: theme.palette.text.disabled
            },
            "&$error": {
                color: theme.palette.error.main
            }
        }),
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            "&$focused": {
                color: theme.palette.secondary.main
            }
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Styles applied to the asterisk element. */ asterisk: {
            "&$error": {
                color: theme.palette.error.main
            }
        }
    };
};
var $ec63ad2a501c4e71$var$FormLabel = /*#__PURE__*/ $arQ7u.forwardRef(function FormLabel(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, color = props.color, _props$component = props.component, Component = _props$component === void 0 ? "label" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, required = props.required, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "required"
    ]);
    var muiFormControl = (0, $6cXJA.default)();
    var fcs = (0, $tTTvC.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    return /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, classes["color".concat((0, $kaLUp.default)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
        ref: ref
    }, other), children, fcs.required && /*#__PURE__*/ $arQ7u.createElement("span", {
        "aria-hidden": true,
        className: (0, $5g55B.default)(classes.asterisk, fcs.error && classes.error)
    }, "\u2009", "*"));
});
var $ec63ad2a501c4e71$export$2e2bcd8739ae039 = (0, $7EzGR.default)($ec63ad2a501c4e71$export$9dd6ff9ea0189349, {
    name: "MuiFormLabel"
})($ec63ad2a501c4e71$var$FormLabel);

});


parcelRegister("3HQmy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b2e016e633a4c0b$export$2e2bcd8739ae039; });

var $dXEVX = parcelRequire("dXEVX");

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $tTTvC = parcelRequire("tTTvC");

var $6cXJA = parcelRequire("6cXJA");

var $7EzGR = parcelRequire("7EzGR");
var $2b2e016e633a4c0b$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $abElG.default)({
            color: theme.palette.text.secondary
        }, theme.typography.caption, {
            textAlign: "left",
            marginTop: 3,
            margin: 0,
            "&$disabled": {
                color: theme.palette.text.disabled
            },
            "&$error": {
                color: theme.palette.error.main
            }
        }),
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            marginTop: 4
        },
        /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */ contained: {
            marginLeft: 14,
            marginRight: 14
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {}
    };
};
var $2b2e016e633a4c0b$var$FormHelperText = /*#__PURE__*/ $arQ7u.forwardRef(function FormHelperText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "p" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    var muiFormControl = (0, $6cXJA.default)();
    var fcs = (0, $tTTvC.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "margin",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    return /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, (fcs.variant === "filled" || fcs.variant === "outlined") && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === "dense" && classes.marginDense),
        ref: ref
    }, other), children === " " ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $arQ7u.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    }) : children);
});
var $2b2e016e633a4c0b$export$2e2bcd8739ae039 = (0, $7EzGR.default)($2b2e016e633a4c0b$export$9dd6ff9ea0189349, {
    name: "MuiFormHelperText"
})($2b2e016e633a4c0b$var$FormHelperText);

});


parcelRegister("ku9BZ", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee9e10a84dcc3623$var$React = $363GR((parcelRequire("arQ7u")));

var $ee9e10a84dcc3623$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $ee9e10a84dcc3623$var$_default = (0, $ee9e10a84dcc3623$var$_createSvgIcon.default)(/*#__PURE__*/ $ee9e10a84dcc3623$var$React.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "SearchSharp");
module.exports.default = $ee9e10a84dcc3623$var$_default;

});

parcelRegister("g1IVl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baaf964ec2b0b6cc$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $6mFPF = parcelRequire("6mFPF");

var $kUnI3 = parcelRequire("kUnI3");

var $bvh50 = parcelRequire("bvh50");
var $jGts0 = parcelRequire("jGts0");
/**
 * mapStateToProps - used to hook up connect to state
 * @memberof SearchPanelControls
 * @private
 */ var $baaf964ec2b0b6cc$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var companionWindowId = _ref.companionWindowId, windowId = _ref.windowId;
    return {
        direction: (0, $jGts0.getThemeDirection)(state),
        numTotal: (0, $bvh50.getSearchNumTotal)(state, {
            companionWindowId: companionWindowId,
            windowId: windowId
        }),
        searchHits: (0, $bvh50.getSortedSearchHitsForCompanionWindow)(state, {
            companionWindowId: companionWindowId,
            windowId: windowId
        }),
        selectedContentSearchAnnotation: (0, $bvh50.getSelectedContentSearchAnnotationIds)(state, {
            companionWindowId: companionWindowId,
            windowId: windowId
        })
    };
};
/**
 * mapDispatchToProps - to hook up connect
 * @memberof SearchPanelNavigation
 * @private
 */ var $baaf964ec2b0b6cc$var$mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
    var windowId = _ref2.windowId;
    return {
        selectAnnotation: function selectAnnotation() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return dispatch($kUnI3.selectAnnotation.apply($kUnI3, [
                windowId
            ].concat(args)));
        }
    };
};
/** */ var $baaf964ec2b0b6cc$var$styles = function styles(theme) {
    return {
        body2: {
            marginLeft: "-16px",
            width: "100%"
        }
    };
};
var $baaf964ec2b0b6cc$var$enhance = (0, $k19ic.compose)((0, $fbonu.default)($baaf964ec2b0b6cc$var$mapStateToProps, $baaf964ec2b0b6cc$var$mapDispatchToProps), (0, $7EzGR.default)($baaf964ec2b0b6cc$var$styles), (0, $eC0Mc.withTranslation)(), (0, $7XHRd.withPlugins)("SearchPanelNavigation"));
var $baaf964ec2b0b6cc$export$2e2bcd8739ae039 = $baaf964ec2b0b6cc$var$enhance((0, $6mFPF.SearchPanelNavigation));

});
parcelRegister("6mFPF", function(module, exports) {

$parcel$export(module.exports, "SearchPanelNavigation", function () { return $4a253f2f23381b04$export$55ac5ec21265d75; });

var $arQ7u = parcelRequire("arQ7u");

var $6pMPJ = parcelRequire("6pMPJ");

var $jXTrJ = parcelRequire("jXTrJ");

var $hsH5s = parcelRequire("hsH5s");

var $029Oc = parcelRequire("029Oc");
function $4a253f2f23381b04$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4a253f2f23381b04$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4a253f2f23381b04$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4a253f2f23381b04$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4a253f2f23381b04$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4a253f2f23381b04$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $4a253f2f23381b04$var$_setPrototypeOf(subClass, superClass);
}
function $4a253f2f23381b04$var$_setPrototypeOf(o, p) {
    $4a253f2f23381b04$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4a253f2f23381b04$var$_setPrototypeOf(o, p);
}
function $4a253f2f23381b04$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4a253f2f23381b04$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4a253f2f23381b04$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4a253f2f23381b04$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4a253f2f23381b04$var$_possibleConstructorReturn(this, result);
    };
}
function $4a253f2f23381b04$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4a253f2f23381b04$var$_assertThisInitialized(self);
}
function $4a253f2f23381b04$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4a253f2f23381b04$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4a253f2f23381b04$var$_getPrototypeOf(o) {
    $4a253f2f23381b04$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4a253f2f23381b04$var$_getPrototypeOf(o);
}
var $4a253f2f23381b04$export$55ac5ec21265d75 = /*#__PURE__*/ function(_Component) {
    $4a253f2f23381b04$var$_inherits(SearchPanelNavigation, _Component);
    var _super = $4a253f2f23381b04$var$_createSuper(SearchPanelNavigation);
    function SearchPanelNavigation() {
        $4a253f2f23381b04$var$_classCallCheck(this, SearchPanelNavigation);
        return _super.apply(this, arguments);
    }
    $4a253f2f23381b04$var$_createClass(SearchPanelNavigation, [
        {
            key: "nextSearchResult",
            value: /** */ function nextSearchResult(currentHitIndex) {
                var _this$props = this.props, searchHits = _this$props.searchHits, selectAnnotation = _this$props.selectAnnotation;
                selectAnnotation(searchHits[currentHitIndex + 1].annotations[0]);
            }
        },
        {
            key: "previousSearchResult",
            value: function previousSearchResult(currentHitIndex) {
                var _this$props2 = this.props, searchHits = _this$props2.searchHits, selectAnnotation = _this$props2.selectAnnotation;
                selectAnnotation(searchHits[currentHitIndex - 1].annotations[0]);
            }
        },
        {
            key: "hasNextResult",
            value: function hasNextResult(currentHitIndex) {
                var searchHits = this.props.searchHits;
                if (searchHits.length === 0) return false;
                if (currentHitIndex < searchHits.length - 1) return true;
                return false;
            }
        },
        {
            key: "hasPreviousResult",
            value: function hasPreviousResult(currentHitIndex) {
                var searchHits = this.props.searchHits;
                if (searchHits.length === 0) return false;
                if (currentHitIndex > 0) return true;
                return false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props3 = this.props, numTotal = _this$props3.numTotal, searchHits = _this$props3.searchHits, selectedContentSearchAnnotation = _this$props3.selectedContentSearchAnnotation, classes = _this$props3.classes, t = _this$props3.t, direction = _this$props3.direction;
                var iconStyle = direction === "rtl" ? {
                    transform: "rotate(180deg)"
                } : {};
                var currentHitIndex = searchHits.findIndex(function(val) {
                    return val.annotations.includes(selectedContentSearchAnnotation[0]);
                });
                var lengthText = searchHits.length;
                if (searchHits.length < numTotal) lengthText += "+";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, searchHits.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "body2",
                    align: "center",
                    classes: classes
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $029Oc.default), {
                    "aria-label": t("searchPreviousResult"),
                    disabled: !this.hasPreviousResult(currentHitIndex),
                    onClick: function onClick() {
                        return _this.previousSearchResult(currentHitIndex);
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6pMPJ))), {
                    style: iconStyle
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("span", {
                    style: {
                        unicodeBidi: "plaintext"
                    }
                }, t("pagination", {
                    current: currentHitIndex + 1,
                    total: lengthText
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $029Oc.default), {
                    "aria-label": t("searchNextResult"),
                    disabled: !this.hasNextResult(currentHitIndex),
                    onClick: function onClick() {
                        return _this.nextSearchResult(currentHitIndex);
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXTrJ))), {
                    style: iconStyle
                }))));
            }
        }
    ]);
    return SearchPanelNavigation;
}((0, $arQ7u.Component));
$4a253f2f23381b04$export$55ac5ec21265d75.defaultProps = {
    classes: {},
    numTotal: undefined,
    searchHits: [],
    t: function t(key) {
        return key;
    }
};

});
parcelRegister("6pMPJ", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4abaf525f9ee4b1a$var$React = $363GR((parcelRequire("arQ7u")));

var $4abaf525f9ee4b1a$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $4abaf525f9ee4b1a$var$_default = (0, $4abaf525f9ee4b1a$var$_createSvgIcon.default)(/*#__PURE__*/ $4abaf525f9ee4b1a$var$React.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"
}), "ChevronLeftSharp");
module.exports.default = $4abaf525f9ee4b1a$var$_default;

});

parcelRegister("jXTrJ", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e88e897d06566292$var$React = $363GR((parcelRequire("arQ7u")));

var $e88e897d06566292$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $e88e897d06566292$var$_default = (0, $e88e897d06566292$var$_createSvgIcon.default)(/*#__PURE__*/ $e88e897d06566292$var$React.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"
}), "ChevronRightSharp");
module.exports.default = $e88e897d06566292$var$_default;

});


parcelRegister("bvh50", function(module, exports) {

$parcel$export(module.exports, "getSearchForWindow", function () { return $85ffd6a0b18aca66$export$77f9d2f8a9e1ebba; });
$parcel$export(module.exports, "getSearchQuery", function () { return $85ffd6a0b18aca66$export$1664b92369554829; });
$parcel$export(module.exports, "getSearchIsFetching", function () { return $85ffd6a0b18aca66$export$a682fefbc289e0c4; });
$parcel$export(module.exports, "getSearchNumTotal", function () { return $85ffd6a0b18aca66$export$fe860571917b5583; });
$parcel$export(module.exports, "getNextSearchId", function () { return $85ffd6a0b18aca66$export$28d1e53139895171; });
$parcel$export(module.exports, "getSortedSearchHitsForCompanionWindow", function () { return $85ffd6a0b18aca66$export$65df1d5bc1fa8c90; });
$parcel$export(module.exports, "getResourceAnnotationForSearchHit", function () { return $85ffd6a0b18aca66$export$7a157c9aaa86e7a7; });
$parcel$export(module.exports, "getSearchAnnotationsForCompanionWindow", function () { return $85ffd6a0b18aca66$export$b61e84d73c307c85; });
$parcel$export(module.exports, "sortSearchAnnotationsByCanvasOrder", function () { return $85ffd6a0b18aca66$export$111b70c6a9495b96; });
$parcel$export(module.exports, "getSortedSearchAnnotationsForCompanionWindow", function () { return $85ffd6a0b18aca66$export$65f941ea0740ca35; });
$parcel$export(module.exports, "getSearchAnnotationsForWindow", function () { return $85ffd6a0b18aca66$export$8d87ffb0187672f0; });
$parcel$export(module.exports, "getSelectedContentSearchAnnotationIds", function () { return $85ffd6a0b18aca66$export$d4ac1c5191cf6263; });
$parcel$export(module.exports, "getResourceAnnotationLabel", function () { return $85ffd6a0b18aca66$export$c38a3ab4a91d2f80; });
$parcel$export(module.exports, "getCanvasForAnnotation", function () { return $85ffd6a0b18aca66$export$2a3b3733916a681f; });

var $1LbRi = parcelRequire("1LbRi");

var $a4sDT = parcelRequire("a4sDT");

var $bT1Wq = parcelRequire("bT1Wq");

var $cfUZ3 = parcelRequire("cfUZ3");

var $1MgBx = parcelRequire("1MgBx");

var $dy9HC = parcelRequire("dy9HC");

var $7GY88 = parcelRequire("7GY88");

var $fr77o = parcelRequire("fr77o");
/** Get searches from state */ var $85ffd6a0b18aca66$var$getSearches = function getSearches(state) {
    return (0, $fr77o.miradorSlice)(state).searches;
};
var $85ffd6a0b18aca66$export$77f9d2f8a9e1ebba = (0, $1LbRi.createSelector)([
    function(state, _ref) {
        var windowId = _ref.windowId;
        return windowId;
    },
    $85ffd6a0b18aca66$var$getSearches
], function(windowId, searches) {
    if (!windowId || !searches) return {};
    return searches[windowId];
});
var $85ffd6a0b18aca66$var$getSearchForCompanionWindow = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$export$77f9d2f8a9e1ebba,
    function(state, _ref2) {
        var companionWindowId = _ref2.companionWindowId;
        return companionWindowId;
    }
], function(results, companionWindowId) {
    if (!results || !companionWindowId) return undefined;
    return results[companionWindowId];
});
var $85ffd6a0b18aca66$var$getSearchResponsesForCompanionWindow = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$var$getSearchForCompanionWindow
], function(results) {
    if (!results) return [];
    return Object.values(results.data);
});
var $85ffd6a0b18aca66$export$1664b92369554829 = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$var$getSearchForCompanionWindow
], function(results) {
    return results && results.query;
});
var $85ffd6a0b18aca66$export$a682fefbc289e0c4 = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$var$getSearchResponsesForCompanionWindow
], function(results) {
    return results.some(function(result) {
        return result.isFetching;
    });
});
var $85ffd6a0b18aca66$export$fe860571917b5583 = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$var$getSearchForCompanionWindow
], function(results) {
    var _resultWithWithin$jso, _resultWithWithin$jso2;
    if (!results || !results.data) return undefined;
    var resultWithWithin = Object.values(results.data).find(function(result) {
        return !result.isFetching && result.json && result.json.within;
    });
    return resultWithWithin === null || resultWithWithin === void 0 ? void 0 : (_resultWithWithin$jso = resultWithWithin.json) === null || _resultWithWithin$jso === void 0 ? void 0 : (_resultWithWithin$jso2 = _resultWithWithin$jso.within) === null || _resultWithWithin$jso2 === void 0 ? void 0 : _resultWithWithin$jso2.total;
});
var $85ffd6a0b18aca66$export$28d1e53139895171 = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$var$getSearchForCompanionWindow
], function(results) {
    if (!results || !results.data) return undefined;
    var resultWithAnUnresolvedNext = Object.values(results.data).find(function(result) {
        return !result.isFetching && result.json && result.json.next && !results.data[result.json.next];
    });
    return resultWithAnUnresolvedNext && resultWithAnUnresolvedNext.json && resultWithAnUnresolvedNext.json.next;
});
var $85ffd6a0b18aca66$var$getSearchHitsForCompanionWindow = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$var$getSearchResponsesForCompanionWindow
], function(results) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(results.map(function(result) {
        if (!result || !result.json || result.isFetching || !result.json.hits) return [];
        return result.json.hits;
    }));
});
var $85ffd6a0b18aca66$export$65df1d5bc1fa8c90 = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$var$getSearchHitsForCompanionWindow,
    (0, $1MgBx.getCanvases),
    function(state, _ref3) {
        var companionWindowId = _ref3.companionWindowId, windowId = _ref3.windowId;
        return function(annotationUri) {
            return $85ffd6a0b18aca66$export$7a157c9aaa86e7a7(state, {
                annotationUri: annotationUri,
                companionWindowId: companionWindowId,
                windowId: windowId
            });
        };
    }
], function(searchHits, canvases, annotationForSearchHit) {
    if (!canvases || canvases.length === 0) return [];
    if (!searchHits || searchHits.length === 0) return [];
    var canvasIds = canvases.map(function(canvas) {
        return canvas.id;
    });
    return [].concat(searchHits).sort(function(a, b) {
        var hitA = annotationForSearchHit(a.annotations[0]);
        var hitB = annotationForSearchHit(b.annotations[0]);
        return canvasIds.indexOf(hitA.targetId) - canvasIds.indexOf(hitB.targetId);
    });
});
/** convert search results to an annotation */ var $85ffd6a0b18aca66$var$searchResultsToAnnotation = function searchResultsToAnnotation(results) {
    var annotations = results.map(function(result) {
        if (!result || !result.json || result.isFetching || !result.json.resources) return undefined;
        var anno = new (0, $cfUZ3.default)(result.json);
        return {
            id: anno.id,
            resources: anno.resources
        };
    }).filter(Boolean);
    return {
        id: (annotations.find(function(a) {
            return a.id;
        }) || {}).id,
        resources: (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(annotations.map(function(a) {
            return a.resources;
        }))
    };
};
var $85ffd6a0b18aca66$export$b61e84d73c307c85 = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$var$getSearchResponsesForCompanionWindow
], function(results) {
    return results && $85ffd6a0b18aca66$var$searchResultsToAnnotation(results);
});
function $85ffd6a0b18aca66$export$111b70c6a9495b96(searchAnnotations, canvases) {
    if (!searchAnnotations || !searchAnnotations.resources || searchAnnotations.length === 0) return [];
    if (!canvases || canvases.length === 0) return [];
    var canvasIds = canvases.map(function(canvas) {
        return canvas.id;
    });
    return [].concat(searchAnnotations.resources).sort(function(annoA, annoB) {
        return canvasIds.indexOf(annoA.targetId) - canvasIds.indexOf(annoB.targetId);
    });
}
var $85ffd6a0b18aca66$export$65f941ea0740ca35 = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$export$b61e84d73c307c85,
    (0, $1MgBx.getCanvases)
], function(searchAnnotations, canvases) {
    return $85ffd6a0b18aca66$export$111b70c6a9495b96(searchAnnotations, canvases);
});
var $85ffd6a0b18aca66$export$8d87ffb0187672f0 = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$export$77f9d2f8a9e1ebba
], function(results) {
    if (!results) return [];
    var data = Object.values(results).map(function(r) {
        return Object.values(r.data);
    });
    return data.map(function(d) {
        return $85ffd6a0b18aca66$var$searchResultsToAnnotation(d);
    }).filter(function(a) {
        return a.resources.length > 0;
    });
});
var $85ffd6a0b18aca66$export$d4ac1c5191cf6263 = (0, $1LbRi.createSelector)([
    (0, $dy9HC.getWindow),
    $85ffd6a0b18aca66$var$getSearchForCompanionWindow
], function(window, search) {
    return search && search.selectedContentSearchAnnotationIds || [];
});
var $85ffd6a0b18aca66$export$7a157c9aaa86e7a7 = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$export$b61e84d73c307c85,
    function(state, _ref4) {
        var annotationUri = _ref4.annotationUri;
        return annotationUri;
    }
], function(annotation, annotationUri) {
    return annotation.resources.find(function(r) {
        return r.id === annotationUri;
    });
});
var $85ffd6a0b18aca66$export$c38a3ab4a91d2f80 = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$export$7a157c9aaa86e7a7,
    (0, $7GY88.getManifestLocale)
], function(resourceAnnotation, locale) {
    if (!(resourceAnnotation && resourceAnnotation.resource && resourceAnnotation.resource.label)) return [];
    return (0, $a4sDT.PropertyValue).parse(resourceAnnotation.resource.label, locale).getValues();
});
var $85ffd6a0b18aca66$var$getAnnotationById = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$export$8d87ffb0187672f0,
    function(state, _ref5) {
        var annotationId = _ref5.annotationId;
        return annotationId;
    }
], function(annotations, annotationId) {
    var resourceAnnotations = (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(annotations.map(function(a) {
        return a.resources;
    }));
    return resourceAnnotations.find(function(r) {
        return r.id === annotationId;
    });
});
var $85ffd6a0b18aca66$export$2a3b3733916a681f = (0, $1LbRi.createSelector)([
    $85ffd6a0b18aca66$var$getAnnotationById,
    function(state, _ref6) {
        var windowId = _ref6.windowId;
        return function(canvasId) {
            return (0, $1MgBx.getCanvas)(state, {
                canvasId: canvasId,
                windowId: windowId
            });
        };
    }
], function(annotation, getCanvasById) {
    var canvasId = annotation && annotation.targetId;
    return canvasId && getCanvasById(canvasId);
});

});




parcelRegister("ABegu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06e03dd3b9afdc37$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $hG2po = parcelRequire("hG2po");

var $kQy7d = parcelRequire("kQy7d");

var $bvh50 = parcelRequire("bvh50");
function $06e03dd3b9afdc37$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $06e03dd3b9afdc37$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $06e03dd3b9afdc37$var$ownKeys(Object(source), true).forEach(function(key) {
            $06e03dd3b9afdc37$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $06e03dd3b9afdc37$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $06e03dd3b9afdc37$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * mapStateToProps - used to hook up connect to state
 * @memberof SearchResult
 * @private
 */ var $06e03dd3b9afdc37$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var companionWindowId = _ref.companionWindowId, windowId = _ref.windowId;
    return {
        isFetching: (0, $bvh50.getSearchIsFetching)(state, {
            companionWindowId: companionWindowId,
            windowId: windowId
        }),
        nextSearch: (0, $bvh50.getNextSearchId)(state, {
            companionWindowId: companionWindowId,
            windowId: windowId
        }),
        query: (0, $bvh50.getSearchQuery)(state, {
            companionWindowId: companionWindowId,
            windowId: windowId
        }),
        searchAnnotations: (0, $bvh50.getSortedSearchAnnotationsForCompanionWindow)(state, {
            companionWindowId: companionWindowId,
            windowId: windowId
        }),
        searchHits: (0, $bvh50.getSortedSearchHitsForCompanionWindow)(state, {
            companionWindowId: companionWindowId,
            windowId: windowId
        }),
        searchNumTotal: (0, $bvh50.getSearchNumTotal)(state, {
            companionWindowId: companionWindowId,
            windowId: windowId
        })
    };
};
var $06e03dd3b9afdc37$var$mapDispatchToProps = {
    fetchSearch: $kQy7d.fetchSearch
};
/** */ var $06e03dd3b9afdc37$var$styles = function styles(theme) {
    return {
        moreButton: {
            width: "100%"
        },
        navigation: {
            textTransform: "none"
        },
        noResults: $06e03dd3b9afdc37$var$_objectSpread($06e03dd3b9afdc37$var$_objectSpread({}, theme.typography.h6), {}, {
            padding: theme.spacing(2)
        }),
        toggleFocus: $06e03dd3b9afdc37$var$_objectSpread({}, theme.typography.subtitle1)
    };
};
var $06e03dd3b9afdc37$var$enhance = (0, $k19ic.compose)((0, $fbonu.default)($06e03dd3b9afdc37$var$mapStateToProps, $06e03dd3b9afdc37$var$mapDispatchToProps), (0, $7EzGR.default)($06e03dd3b9afdc37$var$styles), (0, $eC0Mc.withTranslation)(), (0, $7XHRd.withPlugins)("SearchResults"));
var $06e03dd3b9afdc37$export$2e2bcd8739ae039 = $06e03dd3b9afdc37$var$enhance((0, $hG2po.SearchResults));

});
parcelRegister("hG2po", function(module, exports) {

$parcel$export(module.exports, "SearchResults", function () { return $cde83a3398a7ce58$export$aee53da69e9839be; });

var $arQ7u = parcelRequire("arQ7u");

var $lBY5E = parcelRequire("lBY5E");

var $48mel = parcelRequire("48mel");

var $hsH5s = parcelRequire("hsH5s");

var $3tSUK = parcelRequire("3tSUK");
parcelRequire("cox1R");
var $5Os85 = parcelRequire("5Os85");

var $hlNPJ = parcelRequire("hlNPJ");

var $k3oId = parcelRequire("k3oId");
function $cde83a3398a7ce58$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cde83a3398a7ce58$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cde83a3398a7ce58$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cde83a3398a7ce58$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cde83a3398a7ce58$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $cde83a3398a7ce58$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $cde83a3398a7ce58$var$_setPrototypeOf(subClass, superClass);
}
function $cde83a3398a7ce58$var$_setPrototypeOf(o, p) {
    $cde83a3398a7ce58$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cde83a3398a7ce58$var$_setPrototypeOf(o, p);
}
function $cde83a3398a7ce58$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cde83a3398a7ce58$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $cde83a3398a7ce58$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $cde83a3398a7ce58$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cde83a3398a7ce58$var$_possibleConstructorReturn(this, result);
    };
}
function $cde83a3398a7ce58$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $cde83a3398a7ce58$var$_assertThisInitialized(self);
}
function $cde83a3398a7ce58$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cde83a3398a7ce58$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cde83a3398a7ce58$var$_getPrototypeOf(o) {
    $cde83a3398a7ce58$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cde83a3398a7ce58$var$_getPrototypeOf(o);
}
var $cde83a3398a7ce58$export$aee53da69e9839be = /*#__PURE__*/ function(_Component) {
    $cde83a3398a7ce58$var$_inherits(SearchResults, _Component);
    var _super = $cde83a3398a7ce58$var$_createSuper(SearchResults);
    /** */ function SearchResults(props) {
        var _this;
        $cde83a3398a7ce58$var$_classCallCheck(this, SearchResults);
        _this = _super.call(this, props);
        _this.state = {
            focused: false
        };
        _this.toggleFocus = _this.toggleFocus.bind($cde83a3398a7ce58$var$_assertThisInitialized(_this));
        return _this;
    }
    /** */ $cde83a3398a7ce58$var$_createClass(SearchResults, [
        {
            key: "toggleFocus",
            value: function toggleFocus() {
                var focused = this.state.focused;
                this.setState({
                    focused: !focused
                });
            }
        },
        {
            key: "renderSearchHitsAndAnnotations",
            value: function renderSearchHitsAndAnnotations(announcer) {
                var _this2 = this;
                var _this$props = this.props, companionWindowId = _this$props.companionWindowId, containerRef = _this$props.containerRef, searchAnnotations = _this$props.searchAnnotations, searchHits = _this$props.searchHits, windowId = _this$props.windowId;
                var focused = this.state.focused;
                if (searchHits.length === 0 && searchAnnotations.length > 0) return searchAnnotations.map(function(anno, index) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hlNPJ.default), {
                        announcer: announcer,
                        annotationId: anno.id,
                        companionWindowId: companionWindowId,
                        containerRef: containerRef,
                        key: anno.id,
                        focused: focused,
                        index: index,
                        total: searchAnnotations.length,
                        windowId: windowId,
                        showDetails: _this2.toggleFocus
                    });
                });
                return searchHits.map(function(hit, index) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hlNPJ.default), {
                        announcer: announcer,
                        containerRef: containerRef,
                        companionWindowId: companionWindowId,
                        key: hit.annotations[0],
                        focused: focused,
                        hit: hit,
                        index: index,
                        total: searchHits.length,
                        windowId: windowId,
                        showDetails: _this2.toggleFocus
                    });
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props2 = this.props, classes = _this$props2.classes, companionWindowId = _this$props2.companionWindowId, containerRef = _this$props2.containerRef, isFetching = _this$props2.isFetching, fetchSearch = _this$props2.fetchSearch, nextSearch = _this$props2.nextSearch, query = _this$props2.query, searchAnnotations = _this$props2.searchAnnotations, searchHits = _this$props2.searchHits, searchNumTotal = _this$props2.searchNumTotal, t = _this$props2.t, windowId = _this$props2.windowId;
                var focused = this.state.focused;
                var noResultsState = query && !isFetching && searchHits.length === 0 && searchAnnotations.length === 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, focused && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $k3oId.ScrollTo), {
                    containerRef: containerRef,
                    offsetTop: 96,
                    scrollTo: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $lBY5E.default), {
                    onClick: this.toggleFocus,
                    className: classes.navigation,
                    size: "small"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3tSUK))), null), t("backToResults"))), noResultsState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    className: classes.noResults
                }, t("searchNoResults")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $48mel.default), {
                    disablePadding: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $5Os85.default), null, function(_ref) {
                    var announcePolite = _ref.announcePolite;
                    return _this3.renderSearchHitsAndAnnotations(announcePolite);
                })), nextSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $lBY5E.default), {
                    className: classes.moreButton,
                    color: "secondary",
                    onClick: function onClick() {
                        return fetchSearch(windowId, companionWindowId, nextSearch, query);
                    }
                }, t("moreResults"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("br", null), "(".concat(t("searchResultsRemaining", {
                    numLeft: searchNumTotal - searchHits.length
                }), ")")));
            }
        }
    ]);
    return SearchResults;
}((0, $arQ7u.Component));
$cde83a3398a7ce58$export$aee53da69e9839be.defaultProps = {
    classes: {},
    containerRef: undefined,
    isFetching: false,
    nextSearch: undefined,
    query: undefined,
    searchAnnotations: [],
    searchHits: [],
    searchNumTotal: undefined,
    t: function t(k) {
        return k;
    }
};

});
parcelRegister("3tSUK", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $288ead6276afd0dc$var$React = $363GR((parcelRequire("arQ7u")));

var $288ead6276afd0dc$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $288ead6276afd0dc$var$_default = (0, $288ead6276afd0dc$var$_createSvgIcon.default)(/*#__PURE__*/ $288ead6276afd0dc$var$React.createElement("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
}), "ArrowBackSharp");
module.exports.default = $288ead6276afd0dc$var$_default;

});

parcelRegister("cox1R", function(module, exports) {

$parcel$export(module.exports, "LiveAnnouncer", function () { return (parcelRequire("7Abnn")).default; });
$parcel$export(module.exports, "LiveMessenger", function () { return (parcelRequire("5Os85")).default; });

var $7Abnn = parcelRequire("7Abnn");

var $8doy0 = parcelRequire("8doy0");

var $5Os85 = parcelRequire("5Os85");

});
parcelRegister("7Abnn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5854b8436f22d980$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $eqTQh = parcelRequire("eqTQh");

var $7L71R = parcelRequire("7L71R");
function $5854b8436f22d980$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5854b8436f22d980$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5854b8436f22d980$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5854b8436f22d980$var$LiveAnnouncer = function(_Component) {
    $5854b8436f22d980$var$_inherits(LiveAnnouncer, _Component);
    function LiveAnnouncer(props) {
        $5854b8436f22d980$var$_classCallCheck(this, LiveAnnouncer);
        var _this = $5854b8436f22d980$var$_possibleConstructorReturn(this, _Component.call(this, props));
        _this.announcePolite = function(message, id) {
            _this.setState({
                announcePoliteMessage: message,
                politeMessageId: id ? id : ""
            });
        };
        _this.announceAssertive = function(message, id) {
            _this.setState({
                announceAssertiveMessage: message,
                assertiveMessageId: id ? id : ""
            });
        };
        _this.state = {
            announcePoliteMessage: "",
            politeMessageId: "",
            announceAssertiveMessage: "",
            assertiveMessageId: "",
            updateFunctions: {
                announcePolite: _this.announcePolite,
                announceAssertive: _this.announceAssertive
            }
        };
        return _this;
    }
    LiveAnnouncer.prototype.render = function render() {
        var _state = this.state, announcePoliteMessage = _state.announcePoliteMessage, politeMessageId = _state.politeMessageId, announceAssertiveMessage = _state.announceAssertiveMessage, assertiveMessageId = _state.assertiveMessageId, updateFunctions = _state.updateFunctions;
        return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7L71R.default).Provider, {
            value: updateFunctions
        }, this.props.children, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $eqTQh.default), {
            assertiveMessage: announceAssertiveMessage,
            assertiveMessageId: assertiveMessageId,
            politeMessage: announcePoliteMessage,
            politeMessageId: politeMessageId
        }));
    };
    return LiveAnnouncer;
}((0, $arQ7u.Component));
var $5854b8436f22d980$export$2e2bcd8739ae039 = $5854b8436f22d980$var$LiveAnnouncer;

});
parcelRegister("eqTQh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a81ecf7f64a3a48e$export$2e2bcd8739ae039; });


var $arQ7u = parcelRequire("arQ7u");

var $4yD6g = parcelRequire("4yD6g");
function $a81ecf7f64a3a48e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a81ecf7f64a3a48e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a81ecf7f64a3a48e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a81ecf7f64a3a48e$var$Announcer = function(_Component) {
    $a81ecf7f64a3a48e$var$_inherits(Announcer, _Component);
    function Announcer() {
        var _temp, _this, _ret;
        $a81ecf7f64a3a48e$var$_classCallCheck(this, Announcer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $a81ecf7f64a3a48e$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.state = {
            assertiveMessage1: "",
            assertiveMessage2: "",
            politeMessage1: "",
            politeMessage2: "",
            oldPolitemessage: "",
            oldPoliteMessageId: "",
            oldAssertiveMessage: "",
            oldAssertiveMessageId: "",
            setAlternatePolite: false,
            setAlternateAssertive: false
        }, _temp), $a81ecf7f64a3a48e$var$_possibleConstructorReturn(_this, _ret);
    }
    Announcer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
        var oldPolitemessage = state.oldPolitemessage, oldPoliteMessageId = state.oldPoliteMessageId, oldAssertiveMessage = state.oldAssertiveMessage, oldAssertiveMessageId = state.oldAssertiveMessageId;
        var politeMessage = nextProps.politeMessage, politeMessageId = nextProps.politeMessageId, assertiveMessage = nextProps.assertiveMessage, assertiveMessageId = nextProps.assertiveMessageId;
        if (oldPolitemessage !== politeMessage || oldPoliteMessageId !== politeMessageId) return {
            politeMessage1: state.setAlternatePolite ? "" : politeMessage,
            politeMessage2: state.setAlternatePolite ? politeMessage : "",
            oldPolitemessage: politeMessage,
            oldPoliteMessageId: politeMessageId,
            setAlternatePolite: !state.setAlternatePolite
        };
        if (oldAssertiveMessage !== assertiveMessage || oldAssertiveMessageId !== assertiveMessageId) return {
            assertiveMessage1: state.setAlternateAssertive ? "" : assertiveMessage,
            assertiveMessage2: state.setAlternateAssertive ? assertiveMessage : "",
            oldAssertiveMessage: assertiveMessage,
            oldAssertiveMessageId: assertiveMessageId,
            setAlternateAssertive: !state.setAlternateAssertive
        };
        return null;
    };
    Announcer.prototype.render = function render() {
        var _state = this.state, assertiveMessage1 = _state.assertiveMessage1, assertiveMessage2 = _state.assertiveMessage2, politeMessage1 = _state.politeMessage1, politeMessage2 = _state.politeMessage2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $4yD6g.default), {
            "aria-live": "assertive",
            message: assertiveMessage1
        }), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $4yD6g.default), {
            "aria-live": "assertive",
            message: assertiveMessage2
        }), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $4yD6g.default), {
            "aria-live": "polite",
            message: politeMessage1
        }), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $4yD6g.default), {
            "aria-live": "polite",
            message: politeMessage2
        }));
    };
    return Announcer;
}((0, $arQ7u.Component));
$a81ecf7f64a3a48e$var$Announcer.propTypes = {};
var $a81ecf7f64a3a48e$export$2e2bcd8739ae039 = $a81ecf7f64a3a48e$var$Announcer;

});
parcelRegister("4yD6g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3518aadff18e690d$export$2e2bcd8739ae039; });


var $arQ7u = parcelRequire("arQ7u");
var $3518aadff18e690d$var$offScreenStyle = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    padding: 0,
    width: "1px",
    position: "absolute"
};
var $3518aadff18e690d$var$MessageBlock = function MessageBlock(_ref) {
    var message = _ref.message, ariaLive = _ref["aria-live"];
    return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
        style: $3518aadff18e690d$var$offScreenStyle,
        role: "log",
        "aria-live": ariaLive
    }, message ? message : "");
};
$3518aadff18e690d$var$MessageBlock.propTypes = {};
var $3518aadff18e690d$export$2e2bcd8739ae039 = $3518aadff18e690d$var$MessageBlock;

});


parcelRegister("7L71R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a626005407fffe0$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");
var $5a626005407fffe0$var$AnnouncerContext = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createContext({
    announceAssertive: $5a626005407fffe0$var$logContextWarning,
    announcePolite: $5a626005407fffe0$var$logContextWarning
});
function $5a626005407fffe0$var$logContextWarning() {
    console.warn("Announcement failed, LiveAnnouncer context is missing");
}
var $5a626005407fffe0$export$2e2bcd8739ae039 = $5a626005407fffe0$var$AnnouncerContext;

});


parcelRegister("8doy0", function(module, exports) {

var $arQ7u = parcelRequire("arQ7u");


var $7L71R = parcelRequire("7L71R");

var $7TXyY = parcelRequire("7TXyY");
var $5fb2943972716415$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5fb2943972716415$var$LiveMessage = function LiveMessage(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7L71R.default).Consumer, null, function(contextProps) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7TXyY.default), $5fb2943972716415$var$_extends({}, contextProps, props));
    });
};
$5fb2943972716415$var$LiveMessage.propTypes = {};
var $5fb2943972716415$export$2e2bcd8739ae039 = $5fb2943972716415$var$LiveMessage;

});
parcelRegister("7TXyY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c0bdf6ca35c6a9a$export$2e2bcd8739ae039; });


var $arQ7u = parcelRequire("arQ7u");

var $bW4Pv = parcelRequire("bW4Pv");
function $5c0bdf6ca35c6a9a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5c0bdf6ca35c6a9a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5c0bdf6ca35c6a9a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5c0bdf6ca35c6a9a$var$AnnouncerMessage = function(_Component) {
    $5c0bdf6ca35c6a9a$var$_inherits(AnnouncerMessage, _Component);
    function AnnouncerMessage() {
        var _temp, _this, _ret;
        $5c0bdf6ca35c6a9a$var$_classCallCheck(this, AnnouncerMessage);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $5c0bdf6ca35c6a9a$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.announce = function() {
            var _this$props = _this.props, message = _this$props.message, ariaLive = _this$props["aria-live"], announceAssertive = _this$props.announceAssertive, announcePolite = _this$props.announcePolite;
            if (ariaLive === "assertive") announceAssertive(message || "", (0, (/*@__PURE__*/$parcel$interopDefault($bW4Pv)))());
            if (ariaLive === "polite") announcePolite(message || "", (0, (/*@__PURE__*/$parcel$interopDefault($bW4Pv)))());
        }, _temp), $5c0bdf6ca35c6a9a$var$_possibleConstructorReturn(_this, _ret);
    }
    AnnouncerMessage.prototype.componentDidMount = function componentDidMount() {
        this.announce();
    };
    AnnouncerMessage.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var message = this.props.message;
        if (message !== prevProps.message) this.announce();
    };
    AnnouncerMessage.prototype.componentWillUnmount = function componentWillUnmount() {
        var _props = this.props, clearOnUnmount = _props.clearOnUnmount, announceAssertive = _props.announceAssertive, announcePolite = _props.announcePolite;
        if (clearOnUnmount === true || clearOnUnmount === "true") {
            announceAssertive("");
            announcePolite("");
        }
    };
    AnnouncerMessage.prototype.render = function render() {
        return null;
    };
    return AnnouncerMessage;
}((0, $arQ7u.Component));
$5c0bdf6ca35c6a9a$var$AnnouncerMessage.propTypes = {};
var $5c0bdf6ca35c6a9a$export$2e2bcd8739ae039 = $5c0bdf6ca35c6a9a$var$AnnouncerMessage;

});
parcelRegister("bW4Pv", function(module, exports) {

var $akETq = parcelRequire("akETq");

var $4qg4r = parcelRequire("4qg4r");
function $8b08db90e94a2550$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $akETq)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $4qg4r(rnds);
}
module.exports = $8b08db90e94a2550$var$v4;

});
parcelRegister("akETq", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $785b7e1f4ed21fce$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($785b7e1f4ed21fce$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $785b7e1f4ed21fce$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $785b7e1f4ed21fce$var$getRandomValues($785b7e1f4ed21fce$var$rnds8);
        return $785b7e1f4ed21fce$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $785b7e1f4ed21fce$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $785b7e1f4ed21fce$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $785b7e1f4ed21fce$var$rnds;
    };
}

});

parcelRegister("4qg4r", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $33860e6be42d8830$var$byteToHex = [];
for(var $33860e6be42d8830$var$i = 0; $33860e6be42d8830$var$i < 256; ++$33860e6be42d8830$var$i)$33860e6be42d8830$var$byteToHex[$33860e6be42d8830$var$i] = ($33860e6be42d8830$var$i + 0x100).toString(16).substr(1);
function $33860e6be42d8830$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $33860e6be42d8830$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $33860e6be42d8830$var$bytesToUuid;

});




parcelRegister("5Os85", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43b7712edb104179$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");


var $7L71R = parcelRequire("7L71R");
var $43b7712edb104179$var$LiveMessenger = function LiveMessenger(_ref) {
    var children = _ref.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7L71R.default).Consumer, null, function(contextProps) {
        return children(contextProps);
    });
};
$43b7712edb104179$var$LiveMessenger.propTypes = {};
var $43b7712edb104179$export$2e2bcd8739ae039 = $43b7712edb104179$var$LiveMessenger;

});


parcelRegister("hlNPJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca1b0daf409702ad$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $fQX83 = parcelRequire("fQX83");

var $kUnI3 = parcelRequire("kUnI3");

var $1MgBx = parcelRequire("1MgBx");
var $bvh50 = parcelRequire("bvh50");
var $dj0kG = parcelRequire("dj0kG");
function $ca1b0daf409702ad$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ca1b0daf409702ad$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ca1b0daf409702ad$var$ownKeys(Object(source), true).forEach(function(key) {
            $ca1b0daf409702ad$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ca1b0daf409702ad$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ca1b0daf409702ad$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ca1b0daf409702ad$var$_toConsumableArray(arr) {
    return $ca1b0daf409702ad$var$_arrayWithoutHoles(arr) || $ca1b0daf409702ad$var$_iterableToArray(arr) || $ca1b0daf409702ad$var$_unsupportedIterableToArray(arr) || $ca1b0daf409702ad$var$_nonIterableSpread();
}
function $ca1b0daf409702ad$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ca1b0daf409702ad$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ca1b0daf409702ad$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ca1b0daf409702ad$var$_arrayLikeToArray(o, minLen);
}
function $ca1b0daf409702ad$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ca1b0daf409702ad$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ca1b0daf409702ad$var$_arrayLikeToArray(arr);
}
function $ca1b0daf409702ad$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * mapStateToProps - used to hook up connect to state
 * @memberof SearchHit
 * @private
 */ var $ca1b0daf409702ad$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var annotationId = _ref.annotationId, _ref$hit = _ref.hit, hit = _ref$hit === void 0 ? {
        annotations: []
    } : _ref$hit, companionWindowId = _ref.companionWindowId, windowId = _ref.windowId;
    var realAnnoId = annotationId || hit.annotations[0];
    var hitAnnotation = (0, $bvh50.getResourceAnnotationForSearchHit)(state, {
        annotationUri: realAnnoId,
        companionWindowId: companionWindowId,
        windowId: windowId
    });
    var annotationLabel = (0, $bvh50.getResourceAnnotationLabel)(state, {
        annotationUri: realAnnoId,
        companionWindowId: companionWindowId,
        windowId: windowId
    });
    var selectedCanvasIds = (0, $1MgBx.getVisibleCanvasIds)(state, {
        windowId: windowId
    });
    var selectedContentSearchAnnotationsIds = (0, $bvh50.getSelectedContentSearchAnnotationIds)(state, {
        companionWindowId: companionWindowId,
        windowId: windowId
    });
    var windowSelectedAnnotationId = (0, $dj0kG.getSelectedAnnotationId)(state, {
        windowId: windowId
    });
    var allAnnoIds = [
        annotationId
    ].concat($ca1b0daf409702ad$var$_toConsumableArray(hit.annotations));
    return {
        adjacent: selectedCanvasIds.includes(hitAnnotation.targetId),
        annotation: hitAnnotation,
        annotationId: realAnnoId,
        annotationLabel: annotationLabel[0],
        canvasLabel: hitAnnotation && (0, $1MgBx.getCanvasLabel)(state, {
            canvasId: hitAnnotation.targetId,
            windowId: windowId
        }),
        selected: selectedContentSearchAnnotationsIds[0] && allAnnoIds.includes(selectedContentSearchAnnotationsIds[0]),
        windowSelected: windowSelectedAnnotationId && allAnnoIds.includes(windowSelectedAnnotationId)
    };
};
/**
 * mapDispatchToProps - to hook up connect
 * @memberof SearchPanelNavigation
 * @private
 */ var $ca1b0daf409702ad$var$mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
    var windowId = _ref2.windowId;
    return {
        selectAnnotation: function selectAnnotation() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return dispatch($kUnI3.selectAnnotation.apply($kUnI3, [
                windowId
            ].concat(args)));
        }
    };
};
/** */ var $ca1b0daf409702ad$var$styles = function styles(theme) {
    return {
        adjacent: {},
        focused: {},
        hitCounter: $ca1b0daf409702ad$var$_objectSpread($ca1b0daf409702ad$var$_objectSpread({}, theme.typography.subtitle2), {}, {
            backgroundColor: theme.palette.hitCounter["default"],
            height: 30,
            marginRight: theme.spacing(1),
            verticalAlign: "inherit"
        }),
        inlineButton: {
            "& span": {
                lineHeight: "1.5em"
            },
            margin: 0,
            padding: 0,
            textTransform: "none"
        },
        listItem: {
            "&$adjacent": {
                "& $hitCounter": {
                    backgroundColor: theme.palette.highlights.secondary
                },
                "&$windowSelected": {
                    "& $hitCounter": {
                        backgroundColor: theme.palette.highlights.primary
                    }
                }
            },
            "&$windowSelected": {
                "& $hitCounter": {
                    backgroundColor: theme.palette.highlights.primary
                },
                "&$focused": {
                    "&:hover": {
                        backgroundColor: "inherit"
                    },
                    backgroundColor: "inherit"
                }
            },
            borderBottom: "0.5px solid ".concat(theme.palette.divider),
            paddingRight: 8
        },
        selected: {},
        subtitle: {
            marginBottom: theme.spacing(1.5)
        },
        windowSelected: {}
    };
};
var $ca1b0daf409702ad$var$enhance = (0, $k19ic.compose)((0, $fbonu.default)($ca1b0daf409702ad$var$mapStateToProps, $ca1b0daf409702ad$var$mapDispatchToProps), (0, $7EzGR.default)($ca1b0daf409702ad$var$styles), (0, $eC0Mc.withTranslation)(), (0, $7XHRd.withPlugins)("SearchHit"));
var $ca1b0daf409702ad$export$2e2bcd8739ae039 = $ca1b0daf409702ad$var$enhance((0, $fQX83.SearchHit));

});
parcelRegister("fQX83", function(module, exports) {

$parcel$export(module.exports, "SearchHit", function () { return $b8a9941d48c32206$export$2960223478d51a93; });

var $arQ7u = parcelRequire("arQ7u");

var $5g55B = parcelRequire("5g55B");

var $lBY5E = parcelRequire("lBY5E");

var $iUlUh = parcelRequire("iUlUh");

var $TXAJ5 = parcelRequire("TXAJ5");

var $hsH5s = parcelRequire("hsH5s");

var $dSvjd = parcelRequire("dSvjd");

var $7TK2Y = parcelRequire("7TK2Y");

var $cl7w4 = parcelRequire("cl7w4");

var $k3oId = parcelRequire("k3oId");
function $b8a9941d48c32206$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b8a9941d48c32206$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b8a9941d48c32206$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b8a9941d48c32206$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b8a9941d48c32206$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b8a9941d48c32206$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b8a9941d48c32206$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b8a9941d48c32206$var$_setPrototypeOf(subClass, superClass);
}
function $b8a9941d48c32206$var$_setPrototypeOf(o, p) {
    $b8a9941d48c32206$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b8a9941d48c32206$var$_setPrototypeOf(o, p);
}
function $b8a9941d48c32206$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b8a9941d48c32206$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b8a9941d48c32206$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b8a9941d48c32206$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b8a9941d48c32206$var$_possibleConstructorReturn(this, result);
    };
}
function $b8a9941d48c32206$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b8a9941d48c32206$var$_assertThisInitialized(self);
}
function $b8a9941d48c32206$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b8a9941d48c32206$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b8a9941d48c32206$var$_getPrototypeOf(o) {
    $b8a9941d48c32206$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b8a9941d48c32206$var$_getPrototypeOf(o);
}
var $b8a9941d48c32206$export$2960223478d51a93 = /*#__PURE__*/ function(_Component) {
    $b8a9941d48c32206$var$_inherits(SearchHit, _Component);
    var _super = $b8a9941d48c32206$var$_createSuper(SearchHit);
    /** */ function SearchHit(props) {
        var _this;
        $b8a9941d48c32206$var$_classCallCheck(this, SearchHit);
        _this = _super.call(this, props);
        _this.handleClick = _this.handleClick.bind($b8a9941d48c32206$var$_assertThisInitialized(_this));
        return _this;
    }
    /**
   * Announce the annotation content if the component is mounted selected
   */ $b8a9941d48c32206$var$_createClass(SearchHit, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var selected = this.props.selected;
                if (selected) this.announceHit();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var selected = this.props.selected;
                if (selected && selected !== prevProps.selected) this.announceHit();
            }
        },
        {
            key: "handleClick",
            value: function handleClick() {
                var _this$props = this.props, annotation = _this$props.annotation, annotationId = _this$props.annotationId, selectAnnotation = _this$props.selectAnnotation;
                if (annotation && annotationId) selectAnnotation(annotationId);
            }
        },
        {
            key: "announceHit",
            value: function announceHit() {
                var _this$props2 = this.props, annotation = _this$props2.annotation, annotationLabel = _this$props2.annotationLabel, announcer = _this$props2.announcer, canvasLabel = _this$props2.canvasLabel, hit = _this$props2.hit, index = _this$props2.index, t = _this$props2.t, total = _this$props2.total;
                if (!hit) return;
                var truncatedHit = new (0, $cl7w4.default)(hit, annotation);
                announcer([
                    t("pagination", {
                        current: index + 1,
                        total: total
                    }),
                    canvasLabel,
                    annotationLabel,
                    truncatedHit.before,
                    truncatedHit.match,
                    truncatedHit.after
                ].join(" "));
            }
        },
        {
            key: "render",
            value: function render() {
                var _clsx;
                var _this$props3 = this.props, adjacent = _this$props3.adjacent, annotation = _this$props3.annotation, annotationLabel = _this$props3.annotationLabel, canvasLabel = _this$props3.canvasLabel, classes = _this$props3.classes, companionWindowId = _this$props3.companionWindowId, containerRef = _this$props3.containerRef, hit = _this$props3.hit, focused = _this$props3.focused, index = _this$props3.index, showDetails = _this$props3.showDetails, selected = _this$props3.selected, t = _this$props3.t, windowSelected = _this$props3.windowSelected;
                if (focused && !selected) return null;
                var truncatedHit = focused ? hit : hit && new (0, $cl7w4.default)(hit, annotation);
                var truncated = hit && truncatedHit.before !== hit.before && truncatedHit.after !== hit.after;
                var canvasLabelHtmlId = "".concat(companionWindowId, "-").concat(index);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $k3oId.ScrollTo), {
                    containerRef: containerRef,
                    offsetTop: 96 // offset for the height of the form above
                    ,
                    scrollTo: windowSelected && !focused
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iUlUh.default), {
                    className: (0, $5g55B.default)(classes.listItem, (_clsx = {}, $b8a9941d48c32206$var$_defineProperty(_clsx, classes.adjacent, adjacent), $b8a9941d48c32206$var$_defineProperty(_clsx, classes.selected, selected), $b8a9941d48c32206$var$_defineProperty(_clsx, classes.focused, focused), $b8a9941d48c32206$var$_defineProperty(_clsx, classes.windowSelected, windowSelected), _clsx)),
                    button: !selected,
                    component: "li",
                    onClick: this.handleClick,
                    selected: selected
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $TXAJ5.default), {
                    primaryTypographyProps: {
                        variant: "body1"
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "subtitle2",
                    className: classes.subtitle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $dSvjd.default), {
                    component: "span",
                    label: index + 1,
                    className: classes.hitCounter
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("span", {
                    id: canvasLabelHtmlId
                }, canvasLabel)), annotationLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    variant: "subtitle2"
                }, annotationLabel), hit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7TK2Y.default), {
                    ruleSet: "iiif",
                    htmlString: truncatedHit.before
                }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("strong", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7TK2Y.default), {
                    ruleSet: "iiif",
                    htmlString: truncatedHit.match
                })), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7TK2Y.default), {
                    ruleSet: "iiif",
                    htmlString: truncatedHit.after
                }), " ", truncated && !focused && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $lBY5E.default), {
                    className: classes.inlineButton,
                    onClick: showDetails,
                    color: "secondary",
                    size: "small",
                    "aria-describedby": canvasLabelHtmlId
                }, t("more"))), !hit && annotation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7TK2Y.default), {
                    ruleSet: "iiif",
                    htmlString: annotation.chars
                }))));
            }
        }
    ]);
    return SearchHit;
}((0, $arQ7u.Component));
$b8a9941d48c32206$export$2960223478d51a93.defaultProps = {
    adjacent: false,
    annotation: undefined,
    annotationId: undefined,
    annotationLabel: undefined,
    canvasLabel: undefined,
    classes: {},
    companionWindowId: undefined,
    containerRef: undefined,
    focused: false,
    hit: undefined,
    index: undefined,
    selectAnnotation: function selectAnnotation() {},
    selected: false,
    showDetails: function showDetails() {},
    t: function t(k) {
        return k;
    },
    total: undefined,
    windowSelected: false
};

});
parcelRegister("cl7w4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fbd46c467c294a9$export$2e2bcd8739ae039; });
function $8fbd46c467c294a9$var$_toConsumableArray(arr) {
    return $8fbd46c467c294a9$var$_arrayWithoutHoles(arr) || $8fbd46c467c294a9$var$_iterableToArray(arr) || $8fbd46c467c294a9$var$_unsupportedIterableToArray(arr) || $8fbd46c467c294a9$var$_nonIterableSpread();
}
function $8fbd46c467c294a9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8fbd46c467c294a9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8fbd46c467c294a9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8fbd46c467c294a9$var$_arrayLikeToArray(o, minLen);
}
function $8fbd46c467c294a9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8fbd46c467c294a9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8fbd46c467c294a9$var$_arrayLikeToArray(arr);
}
function $8fbd46c467c294a9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8fbd46c467c294a9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8fbd46c467c294a9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8fbd46c467c294a9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8fbd46c467c294a9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8fbd46c467c294a9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/** */ var $8fbd46c467c294a9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /** */ function TruncatedHit(hit) {
        var annotation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
        var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref$maxChars = _ref.maxChars, maxChars = _ref$maxChars === void 0 ? 200 : _ref$maxChars, _ref$minimum = _ref.minimum, minimum = _ref$minimum === void 0 ? 20 : _ref$minimum;
        $8fbd46c467c294a9$var$_classCallCheck(this, TruncatedHit);
        this.hit = hit;
        this.annotation = annotation;
        this.maxChars = maxChars || 200;
        this.minimum = minimum || 20;
    }
    /** */ $8fbd46c467c294a9$var$_createClass(TruncatedHit, [
        {
            key: "match",
            get: function get() {
                return this.hit.match || this.annotation && this.annotation.resource.resource.chars || "-";
            }
        },
        {
            key: "charsOnSide",
            get: function get() {
                var resultingChars = (this.maxChars - this.match.length) / 2;
                var measured = [
                    (this.hit.before || "").length,
                    (this.hit.after || "").length
                ].filter(function(length) {
                    return length > 0;
                });
                return Math.max(Math.min.apply(Math, [
                    resultingChars
                ].concat($8fbd46c467c294a9$var$_toConsumableArray(measured))), this.minimum);
            }
        },
        {
            key: "before",
            get: function get() {
                if (!this.hit.before) return "";
                return this.hit.before.substring(this.hit.before.length - this.charsOnSide, this.hit.before.length);
            }
        },
        {
            key: "after",
            get: function get() {
                if (!this.hit.after) return "";
                return this.hit.after.substring(0, Math.min(this.hit.after.length, this.charsOnSide));
            }
        }
    ]);
    return TruncatedHit;
}();

});







parcelRegister("cB14h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92b9c4cfcdce1c8a$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $kUU2w = parcelRequire("kUU2w");

var $1MgBx = parcelRequire("1MgBx");
/**
 * mapStateToProps - to hook up connect
 */ var $92b9c4cfcdce1c8a$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, windowId = _ref.windowId;
    return {
        canvasIds: (0, $1MgBx.getVisibleCanvasIds)(state, {
            windowId: windowId
        })
    };
};
/**
 *
 * @param theme
 * @returns {label: {paddingLeft: number}}}
 */ var $92b9c4cfcdce1c8a$var$styles = function styles(theme) {
    return {};
};
var $92b9c4cfcdce1c8a$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $7EzGR.default)($92b9c4cfcdce1c8a$var$styles), (0, $fbonu.default)($92b9c4cfcdce1c8a$var$mapStateToProps), (0, $7XHRd.withPlugins)("LayersPanel"));
var $92b9c4cfcdce1c8a$export$2e2bcd8739ae039 = $92b9c4cfcdce1c8a$var$enhance((0, $kUU2w.LayersPanel));

});
parcelRegister("kUU2w", function(module, exports) {

$parcel$export(module.exports, "LayersPanel", function () { return $f3a481ebc9792d87$export$cad78fcea3d1f543; });

var $arQ7u = parcelRequire("arQ7u");

var $iXAXt = parcelRequire("iXAXt");

var $22yTo = parcelRequire("22yTo");
function $f3a481ebc9792d87$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f3a481ebc9792d87$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f3a481ebc9792d87$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f3a481ebc9792d87$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f3a481ebc9792d87$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f3a481ebc9792d87$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f3a481ebc9792d87$var$_setPrototypeOf(subClass, superClass);
}
function $f3a481ebc9792d87$var$_setPrototypeOf(o, p) {
    $f3a481ebc9792d87$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f3a481ebc9792d87$var$_setPrototypeOf(o, p);
}
function $f3a481ebc9792d87$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f3a481ebc9792d87$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f3a481ebc9792d87$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f3a481ebc9792d87$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f3a481ebc9792d87$var$_possibleConstructorReturn(this, result);
    };
}
function $f3a481ebc9792d87$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f3a481ebc9792d87$var$_assertThisInitialized(self);
}
function $f3a481ebc9792d87$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f3a481ebc9792d87$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f3a481ebc9792d87$var$_getPrototypeOf(o) {
    $f3a481ebc9792d87$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f3a481ebc9792d87$var$_getPrototypeOf(o);
}
var $f3a481ebc9792d87$export$cad78fcea3d1f543 = /*#__PURE__*/ function(_Component) {
    $f3a481ebc9792d87$var$_inherits(LayersPanel, _Component);
    var _super = $f3a481ebc9792d87$var$_createSuper(LayersPanel);
    function LayersPanel() {
        $f3a481ebc9792d87$var$_classCallCheck(this, LayersPanel);
        return _super.apply(this, arguments);
    }
    $f3a481ebc9792d87$var$_createClass(LayersPanel, [
        {
            key: "render",
            value: /**
     * render
     */ function render() {
                var _this$props = this.props, canvasIds = _this$props.canvasIds, id = _this$props.id, t = _this$props.t, windowId = _this$props.windowId;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iXAXt.default), {
                    title: t("layers"),
                    id: id,
                    windowId: windowId
                }, canvasIds.map(function(canvasId, index) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $22yTo.default), {
                        canvasId: canvasId,
                        index: index,
                        key: canvasId,
                        totalSize: canvasIds.length,
                        windowId: windowId
                    });
                }));
            }
        }
    ]);
    return LayersPanel;
}((0, $arQ7u.Component));
$f3a481ebc9792d87$export$cad78fcea3d1f543.defaultProps = {
    canvasIds: []
};

});
parcelRegister("22yTo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17c6d591d9a41eef$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $2Ux4D = parcelRequire("2Ux4D");

var $1MgBx = parcelRequire("1MgBx");
var $konAW = parcelRequire("konAW");

var $4dlxl = parcelRequire("4dlxl");
function $17c6d591d9a41eef$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $17c6d591d9a41eef$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $17c6d591d9a41eef$var$ownKeys(Object(source), true).forEach(function(key) {
            $17c6d591d9a41eef$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $17c6d591d9a41eef$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $17c6d591d9a41eef$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/** For connect */ var $17c6d591d9a41eef$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var canvasId = _ref.canvasId, windowId = _ref.windowId;
    return {
        label: (0, $1MgBx.getCanvasLabel)(state, {
            canvasId: canvasId,
            windowId: windowId
        }),
        layerMetadata: (0, $konAW.getLayers)(state, {
            canvasId: canvasId,
            windowId: windowId
        }),
        layers: (0, $konAW.getSortedLayers)(state, {
            canvasId: canvasId,
            windowId: windowId
        })
    };
};
/**
 * mapDispatchToProps - to hook up connect
 * @memberof WindowSideBarAnnotationsPanel
 * @private
 */ var $17c6d591d9a41eef$var$mapDispatchToProps = {
    updateLayers: $2Ux4D.updateLayers
};
/** For withStlyes */ var $17c6d591d9a41eef$var$styles = function styles(theme) {
    return {
        dragging: {},
        dragHandle: {
            alignItems: "center",
            borderRight: "0.5px solid ".concat(theme.palette.divider),
            display: "flex",
            flex: 1,
            flexDirection: "row",
            marginBottom: -1 * theme.spacing(2) + 0.5,
            marginRight: theme.spacing(1),
            marginTop: -1 * theme.spacing(2),
            maxWidth: theme.spacing(3),
            width: theme.spacing(3)
        },
        image: {
            borderBottom: "1px solid ".concat(theme.palette.divider)
        },
        label: {
            paddingLeft: theme.spacing(1)
        },
        list: {
            paddingTop: 0
        },
        listItem: {
            "& $dragHandle": {
                "&:hover": {
                    backgroundColor: theme.palette.action.hover
                },
                backgroundColor: theme.palette.shades.light
            },
            "&$dragging": {
                "& $dragHandle, & $dragHandle:hover": {
                    backgroundColor: theme.palette.action.selected
                },
                backgroundColor: theme.palette.action.hover
            },
            alignItems: "stretch",
            borderBottom: "0.5px solid ".concat(theme.palette.divider),
            cursor: "pointer",
            paddingBottom: theme.spacing(2),
            paddingRight: theme.spacing(1),
            paddingTop: theme.spacing(2)
        },
        opacityIcon: {
            marginRight: theme.spacing(0.5)
        },
        opacityInput: $17c6d591d9a41eef$var$_objectSpread($17c6d591d9a41eef$var$_objectSpread({}, theme.typography.caption), {}, {
            "&::-webkit-outer-spin-button,&::-webkit-inner-spin-button": {
                "-webkit-appearance": "none",
                margin: 0
            },
            "-moz-appearance": "textfield",
            textAlign: "right",
            width: "3ch"
        }),
        sectionHeading: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(1),
            paddingTop: theme.spacing(2)
        },
        slider: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            maxWidth: 150
        },
        thumbnail: {
            minWidth: 50
        }
    };
};
var $17c6d591d9a41eef$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $7EzGR.default)($17c6d591d9a41eef$var$styles), (0, $fbonu.default)($17c6d591d9a41eef$var$mapStateToProps, $17c6d591d9a41eef$var$mapDispatchToProps));
var $17c6d591d9a41eef$export$2e2bcd8739ae039 = $17c6d591d9a41eef$var$enhance((0, $4dlxl.CanvasLayers));

});
parcelRegister("konAW", function(module, exports) {

$parcel$export(module.exports, "getCanvasLayers", function () { return $ed8859fd9d3800c0$export$d99a1d5a69f95386; });
$parcel$export(module.exports, "getLayers", function () { return $ed8859fd9d3800c0$export$61f6a9c831786408; });
$parcel$export(module.exports, "getSortedLayers", function () { return $ed8859fd9d3800c0$export$d6d96dcffa629d70; });
$parcel$export(module.exports, "getLayersForVisibleCanvases", function () { return $ed8859fd9d3800c0$export$f42a0119943a0911; });

var $1LbRi = parcelRequire("1LbRi");

var $izTcV = parcelRequire("izTcV");

var $1MgBx = parcelRequire("1MgBx");

var $fr77o = parcelRequire("fr77o");
var $ed8859fd9d3800c0$export$d99a1d5a69f95386 = (0, $1LbRi.createSelector)([
    (0, $1MgBx.getCanvas)
], function(canvas) {
    if (!canvas) return [];
    var miradorCanvas = new (0, $izTcV.default)(canvas);
    return miradorCanvas.imageResources;
});
var $ed8859fd9d3800c0$export$61f6a9c831786408 = (0, $1LbRi.createSelector)([
    function(state) {
        return (0, $fr77o.miradorSlice)(state).layers || {};
    },
    function(state, _ref) {
        var windowId = _ref.windowId;
        return windowId;
    },
    function(state, _ref2) {
        var canvasId = _ref2.canvasId;
        return canvasId;
    }
], function(layers, windowId, canvasId) {
    return (layers[windowId] || {})[canvasId];
});
var $ed8859fd9d3800c0$export$d6d96dcffa629d70 = (0, $1LbRi.createSelector)([
    $ed8859fd9d3800c0$export$d99a1d5a69f95386,
    $ed8859fd9d3800c0$export$61f6a9c831786408
], function(canvasLayers, layerConfig) {
    if (!layerConfig) return canvasLayers;
    var sorted = canvasLayers.sort(function(a, b) {
        if (layerConfig[a.id] && layerConfig[a.id].index !== undefined && layerConfig[b.id] && layerConfig[b.id].index !== undefined) return layerConfig[a.id].index - layerConfig[b.id].index;
         // sort a layer with index data above layers without
        if (layerConfig[a.id] && layerConfig[a.id].index !== undefined) return -1;
        if (layerConfig[b.id] && layerConfig[b.id].index !== undefined) return 1;
        return 0;
    });
    return sorted;
});
var $ed8859fd9d3800c0$export$f42a0119943a0911 = (0, $1LbRi.createSelector)([
    (0, $1MgBx.getVisibleCanvasIds),
    function(state, _ref3) {
        var windowId = _ref3.windowId;
        return function(canvasId) {
            return $ed8859fd9d3800c0$export$61f6a9c831786408(state, {
                canvasId: canvasId,
                windowId: windowId
            });
        };
    }
], function(canvasIds, getLayersForCanvas) {
    return canvasIds.reduce(function(acc, canvasId) {
        acc[canvasId] = getLayersForCanvas(canvasId);
        return acc;
    }, {});
});

});

parcelRegister("4dlxl", function(module, exports) {

$parcel$export(module.exports, "CanvasLayers", function () { return $3119150feebfec1b$export$a12bafd054826d4f; });

var $arQ7u = parcelRequire("arQ7u");

var $5g55B = parcelRequire("5g55B");

var $aowE3 = parcelRequire("aowE3");

var $iwnYb = parcelRequire("iwnYb");

var $6cNKv = parcelRequire("6cNKv");

var $48mel = parcelRequire("48mel");

var $iUlUh = parcelRequire("iUlUh");

var $gzsLn = parcelRequire("gzsLn");

var $e59gp = parcelRequire("e59gp");

var $9AGn3 = parcelRequire("9AGn3");

var $ggVgu = parcelRequire("ggVgu");

var $lEwG9 = parcelRequire("lEwG9");

var $hWehD = parcelRequire("hWehD");

var $kz1EW = parcelRequire("kz1EW");

var $hsH5s = parcelRequire("hsH5s");

var $g5rVJ = parcelRequire("g5rVJ");

var $029Oc = parcelRequire("029Oc");

var $YLOIV = parcelRequire("YLOIV");
function $3119150feebfec1b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3119150feebfec1b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3119150feebfec1b$var$ownKeys(Object(source), true).forEach(function(key) {
            $3119150feebfec1b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3119150feebfec1b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3119150feebfec1b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3119150feebfec1b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3119150feebfec1b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3119150feebfec1b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3119150feebfec1b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3119150feebfec1b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3119150feebfec1b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3119150feebfec1b$var$_setPrototypeOf(subClass, superClass);
}
function $3119150feebfec1b$var$_setPrototypeOf(o, p) {
    $3119150feebfec1b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3119150feebfec1b$var$_setPrototypeOf(o, p);
}
function $3119150feebfec1b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3119150feebfec1b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3119150feebfec1b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3119150feebfec1b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3119150feebfec1b$var$_possibleConstructorReturn(this, result);
    };
}
function $3119150feebfec1b$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3119150feebfec1b$var$_assertThisInitialized(self);
}
function $3119150feebfec1b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3119150feebfec1b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3119150feebfec1b$var$_getPrototypeOf(o) {
    $3119150feebfec1b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3119150feebfec1b$var$_getPrototypeOf(o);
}
function $3119150feebfec1b$var$_slicedToArray(arr, i) {
    return $3119150feebfec1b$var$_arrayWithHoles(arr) || $3119150feebfec1b$var$_iterableToArrayLimit(arr, i) || $3119150feebfec1b$var$_unsupportedIterableToArray(arr, i) || $3119150feebfec1b$var$_nonIterableRest();
}
function $3119150feebfec1b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3119150feebfec1b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3119150feebfec1b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3119150feebfec1b$var$_arrayLikeToArray(o, minLen);
}
function $3119150feebfec1b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3119150feebfec1b$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3119150feebfec1b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/** */ var $3119150feebfec1b$var$reorder = function reorder(list, startIndex, endIndex) {
    var result = Array.from(list);
    var _result$splice = result.splice(startIndex, 1), _result$splice2 = $3119150feebfec1b$var$_slicedToArray(_result$splice, 1), removed = _result$splice2[0];
    result.splice(endIndex, 0, removed);
    return result;
};
var $3119150feebfec1b$export$a12bafd054826d4f = /*#__PURE__*/ function(_Component) {
    $3119150feebfec1b$var$_inherits(CanvasLayers, _Component);
    var _super = $3119150feebfec1b$var$_createSuper(CanvasLayers);
    /** */ function CanvasLayers(props) {
        var _this;
        $3119150feebfec1b$var$_classCallCheck(this, CanvasLayers);
        _this = _super.call(this, props);
        _this.droppableId = (0, $aowE3.default)();
        _this.onDragEnd = _this.onDragEnd.bind($3119150feebfec1b$var$_assertThisInitialized(_this));
        _this.handleOpacityChange = _this.handleOpacityChange.bind($3119150feebfec1b$var$_assertThisInitialized(_this));
        _this.setLayerVisibility = _this.setLayerVisibility.bind($3119150feebfec1b$var$_assertThisInitialized(_this));
        _this.moveToTop = _this.moveToTop.bind($3119150feebfec1b$var$_assertThisInitialized(_this));
        return _this;
    }
    /** */ $3119150feebfec1b$var$_createClass(CanvasLayers, [
        {
            key: "handleOpacityChange",
            value: function handleOpacityChange(layerId, value) {
                var _this$props = this.props, canvasId = _this$props.canvasId, updateLayers = _this$props.updateLayers, windowId = _this$props.windowId;
                var payload = $3119150feebfec1b$var$_defineProperty({}, layerId, {
                    opacity: value / 100.0
                });
                updateLayers(windowId, canvasId, payload);
            }
        },
        {
            key: "onDragEnd",
            value: function onDragEnd(result) {
                var _this$props2 = this.props, canvasId = _this$props2.canvasId, layers = _this$props2.layers, updateLayers = _this$props2.updateLayers, windowId = _this$props2.windowId;
                if (!result.destination) return;
                if (result.destination.droppableId !== this.droppableId) return;
                if (result.source.droppableId !== this.droppableId) return;
                var sortedLayers = $3119150feebfec1b$var$reorder(layers.map(function(l) {
                    return l.id;
                }), result.source.index, result.destination.index);
                var payload = layers.reduce(function(acc, layer) {
                    acc[layer.id] = {
                        index: sortedLayers.indexOf(layer.id)
                    };
                    return acc;
                }, {});
                updateLayers(windowId, canvasId, payload);
            }
        },
        {
            key: "setLayerVisibility",
            value: function setLayerVisibility(layerId, value) {
                var _this$props3 = this.props, canvasId = _this$props3.canvasId, updateLayers = _this$props3.updateLayers, windowId = _this$props3.windowId;
                var payload = $3119150feebfec1b$var$_defineProperty({}, layerId, {
                    visibility: value
                });
                updateLayers(windowId, canvasId, payload);
            }
        },
        {
            key: "moveToTop",
            value: function moveToTop(layerId) {
                var _this$props4 = this.props, canvasId = _this$props4.canvasId, layers = _this$props4.layers, updateLayers = _this$props4.updateLayers, windowId = _this$props4.windowId;
                var sortedLayers = $3119150feebfec1b$var$reorder(layers.map(function(l) {
                    return l.id;
                }), layers.findIndex(function(l) {
                    return l.id === layerId;
                }), 0);
                var payload = layers.reduce(function(acc, layer) {
                    acc[layer.id] = {
                        index: sortedLayers.indexOf(layer.id)
                    };
                    return acc;
                }, {});
                updateLayers(windowId, canvasId, payload);
            }
        },
        {
            key: "renderLayer",
            value: function renderLayer(resource, index) {
                var _this2 = this;
                var _this$props5 = this.props, classes = _this$props5.classes, layerMetadata = _this$props5.layerMetadata, t = _this$props5.t;
                var _height$width = {
                    height: undefined,
                    width: 50
                }, width = _height$width.width, height = _height$width.height;
                var layer = $3119150feebfec1b$var$_objectSpread({
                    opacity: 1,
                    visibility: true
                }, (layerMetadata || {})[resource.id]);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    style: {
                        flex: 1
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    style: {
                        alignItems: "flex-start",
                        display: "flex"
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $YLOIV.default), {
                    maxHeight: height,
                    maxWidth: width,
                    resource: resource,
                    classes: {
                        image: classes.image,
                        root: classes.thumbnail
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    className: classes.label,
                    component: "div",
                    variant: "body1"
                }, CanvasLayers.getUseableLabel(resource, index), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $029Oc.default), {
                    "aria-label": t(layer.visibility ? "layer_hide" : "layer_show"),
                    edge: "start",
                    size: "small",
                    onClick: function onClick() {
                        _this2.setLayerVisibility(resource.id, !layer.visibility);
                    }
                }, layer.visibility ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lEwG9))), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWehD))), null)), layer.index !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $029Oc.default), {
                    "aria-label": t("layer_moveToTop"),
                    size: "small",
                    onClick: function onClick() {
                        _this2.moveToTop(resource.id);
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggVgu))), null))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
                    style: {
                        alignItems: "center",
                        display: "flex"
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $e59gp.default), {
                    title: t("layer_opacity")
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kz1EW))), {
                    className: classes.opacityIcon,
                    color: layer.visibility ? "inherit" : "disabled",
                    fontSize: "small"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iwnYb.default), {
                    classes: {
                        input: classes.opacityInput
                    },
                    disabled: !layer.visibility,
                    value: Math.round(layer.opacity * 100),
                    type: "number",
                    min: 0,
                    max: 100,
                    onChange: function onChange(e) {
                        return _this2.handleOpacityChange(resource.id, e.target.value);
                    },
                    endAdornment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $6cNKv.default), {
                        disableTypography: true,
                        position: "end"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                        variant: "caption"
                    }, "%")),
                    inputProps: {
                        "aria-label": t("layer_opacity")
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $gzsLn.default), {
                    className: classes.slider,
                    disabled: !layer.visibility,
                    value: layer.opacity * 100,
                    onChange: function onChange(e, value) {
                        return _this2.handleOpacityChange(resource.id, value);
                    }
                })));
            }
        },
        {
            key: "renderDraggableLayer",
            value: function renderDraggableLayer(resource, index) {
                var _this3 = this;
                var _this$props6 = this.props, classes = _this$props6.classes, t = _this$props6.t;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $g5rVJ.Draggable), {
                    key: resource.id,
                    draggableId: resource.id,
                    index: index
                }, function(provided, snapshot) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iUlUh.default), Object.assign({
                        ref: provided.innerRef
                    }, provided.draggableProps, {
                        component: "li",
                        className: (0, $5g55B.default)(classes.listItem, $3119150feebfec1b$var$_defineProperty({}, classes.dragging, snapshot.isDragging)),
                        disableGutters: true,
                        key: resource.id
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", Object.assign({}, provided.dragHandleProps, {
                        className: classes.dragHandle
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $e59gp.default), {
                        title: t("layer_move")
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9AGn3))), null))), _this3.renderLayer(resource, index));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _this$props7 = this.props, classes = _this$props7.classes, index = _this$props7.index, label = _this$props7.label, layers = _this$props7.layers, t = _this$props7.t, totalSize = _this$props7.totalSize;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, totalSize > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                    className: classes.sectionHeading,
                    variant: "overline"
                }, t("annotationCanvasLabel", {
                    context: "".concat(index + 1, "/").concat(totalSize),
                    label: label
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $g5rVJ.DragDropContext), {
                    onDragEnd: this.onDragEnd
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $g5rVJ.Droppable), {
                    droppableId: this.droppableId
                }, function(provided, snapshot) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $48mel.default), Object.assign({
                        className: classes.list
                    }, provided.droppableProps, {
                        ref: provided.innerRef
                    }), layers && layers.map(function(r, i) {
                        return _this4.renderDraggableLayer(r, i);
                    }), provided.placeholder);
                })));
            }
        }
    ], [
        {
            key: "getUseableLabel",
            value: /** */ function getUseableLabel(resource, index) {
                return resource && resource.getLabel && resource.getLabel().length > 0 ? resource.getLabel().getValue() : String(index + 1);
            }
        }
    ]);
    return CanvasLayers;
}((0, $arQ7u.Component));
$3119150feebfec1b$export$a12bafd054826d4f.defaultProps = {
    classes: {},
    layerMetadata: undefined
};

});
parcelRegister("6cNKv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $484a7436a97b50d0$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $hsH5s = parcelRequire("hsH5s");

var $7EzGR = parcelRequire("7EzGR");

var $jzox3 = parcelRequire("jzox3");
var $484a7436a97b50d0$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "flex",
        height: "0.01em",
        // Fix IE 11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap"
    },
    /* Styles applied to the root element if `variant="filled"`. */ filled: {
        "&$positionStart:not($hiddenLabel)": {
            marginTop: 16
        }
    },
    /* Styles applied to the root element if `position="start"`. */ positionStart: {
        marginRight: 8
    },
    /* Styles applied to the root element if `position="end"`. */ positionEnd: {
        marginLeft: 8
    },
    /* Styles applied to the root element if `disablePointerEvents=true`. */ disablePointerEvents: {
        pointerEvents: "none"
    },
    /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */ hiddenLabel: {},
    /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */ marginDense: {}
};
var $484a7436a97b50d0$var$InputAdornment = /*#__PURE__*/ $arQ7u.forwardRef(function InputAdornment(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disablePointer = props.disablePointerEvents, disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, position = props.position, variantProp = props.variant, other = (0, $dXEVX.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disablePointerEvents",
        "disableTypography",
        "position",
        "variant"
    ]);
    var muiFormControl = (0, $jzox3.useFormControl)() || {};
    var variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    return /*#__PURE__*/ $arQ7u.createElement((0, $jzox3.default).Provider, {
        value: null
    }, /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, position === "end" ? classes.positionEnd : classes.positionStart, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === "filled" && classes.filled, muiFormControl.margin === "dense" && classes.marginDense),
        ref: ref
    }, other), typeof children === "string" && !disableTypography ? /*#__PURE__*/ $arQ7u.createElement((0, $hsH5s.default), {
        color: "textSecondary"
    }, children) : children));
});
var $484a7436a97b50d0$export$2e2bcd8739ae039 = (0, $7EzGR.default)($484a7436a97b50d0$export$9dd6ff9ea0189349, {
    name: "MuiInputAdornment"
})($484a7436a97b50d0$var$InputAdornment);

});

parcelRegister("gzsLn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c10639fa83652aa7$export$2e2bcd8739ae039; });

var $lsH61 = parcelRequire("lsH61");

var $kMfvj = parcelRequire("kMfvj");

var $dXEVX = parcelRequire("dXEVX");

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");


var $7EzGR = parcelRequire("7EzGR");

var $j1k3T = parcelRequire("j1k3T");

var $6vqZH = parcelRequire("6vqZH");

var $cvMUO = parcelRequire("cvMUO");

var $5Yg7t = parcelRequire("5Yg7t");

var $e3Evk = parcelRequire("e3Evk");

var $nGnd5 = parcelRequire("nGnd5");

var $kaLUp = parcelRequire("kaLUp");

var $lhLsx = parcelRequire("lhLsx");

var $3IB0P = parcelRequire("3IB0P");
function $c10639fa83652aa7$var$asc(a, b) {
    return a - b;
}
function $c10639fa83652aa7$var$clamp(value, min, max) {
    return Math.min(Math.max(min, value), max);
}
function $c10639fa83652aa7$var$findClosest(values, currentValue) {
    var _values$reduce = values.reduce(function(acc, value, index) {
        var distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null), closestIndex = _values$reduce.index;
    return closestIndex;
}
function $c10639fa83652aa7$var$trackFinger(event, touchId) {
    if (touchId.current !== undefined && event.changedTouches) {
        for(var i = 0; i < event.changedTouches.length; i += 1){
            var touch = event.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $c10639fa83652aa7$var$valueToPercent(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $c10639fa83652aa7$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $c10639fa83652aa7$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        var parts = num.toExponential().split("e-");
        var matissaDecimalPart = parts[0].split(".")[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    var decimalPart = num.toString().split(".")[1];
    return decimalPart ? decimalPart.length : 0;
}
function $c10639fa83652aa7$var$roundValueToStep(value, step, min) {
    var nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($c10639fa83652aa7$var$getDecimalPrecision(step)));
}
function $c10639fa83652aa7$var$setValueIndex(_ref) {
    var values = _ref.values, source = _ref.source, newValue = _ref.newValue, index = _ref.index;
    // Performance shortcut
    if (values[index] === newValue) return source;
    var output = values.slice();
    output[index] = newValue;
    return output;
}
function $c10639fa83652aa7$var$focusThumb(_ref2) {
    var sliderRef = _ref2.sliderRef, activeIndex = _ref2.activeIndex, setActive = _ref2.setActive;
    if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute("data-index")) !== activeIndex) sliderRef.current.querySelector('[role="slider"][data-index="'.concat(activeIndex, '"]')).focus();
    if (setActive) setActive(activeIndex);
}
var $c10639fa83652aa7$var$axisProps = {
    horizontal: {
        offset: function offset(percent) {
            return {
                left: "".concat(percent, "%")
            };
        },
        leap: function leap(percent) {
            return {
                width: "".concat(percent, "%")
            };
        }
    },
    "horizontal-reverse": {
        offset: function offset(percent) {
            return {
                right: "".concat(percent, "%")
            };
        },
        leap: function leap(percent) {
            return {
                width: "".concat(percent, "%")
            };
        }
    },
    vertical: {
        offset: function offset(percent) {
            return {
                bottom: "".concat(percent, "%")
            };
        },
        leap: function leap(percent) {
            return {
                height: "".concat(percent, "%")
            };
        }
    }
};
var $c10639fa83652aa7$var$Identity = function Identity(x) {
    return x;
};
var $c10639fa83652aa7$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 2,
            width: "100%",
            boxSizing: "content-box",
            padding: "13px 0",
            display: "inline-block",
            position: "relative",
            cursor: "pointer",
            touchAction: "none",
            color: theme.palette.primary.main,
            WebkitTapHighlightColor: "transparent",
            "&$disabled": {
                pointerEvents: "none",
                cursor: "default",
                color: theme.palette.grey[400]
            },
            "&$vertical": {
                width: 2,
                height: "100%",
                padding: "0 13px"
            },
            // The primary input mechanism of the device includes a pointing device of limited accuracy.
            "@media (pointer: coarse)": {
                // Reach 42px touch target, about ~8mm on screen.
                padding: "20px 0",
                "&$vertical": {
                    padding: "0 20px"
                }
            },
            "@media print": {
                colorAdjust: "exact"
            }
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {},
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `marks` is provided with at least one label. */ marked: {
            marginBottom: 20,
            "&$vertical": {
                marginBottom: "auto",
                marginRight: 20
            }
        },
        /* Pseudo-class applied to the root element if `orientation="vertical"`. */ vertical: {},
        /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the rail element. */ rail: {
            display: "block",
            position: "absolute",
            width: "100%",
            height: 2,
            borderRadius: 1,
            backgroundColor: "currentColor",
            opacity: 0.38,
            "$vertical &": {
                height: "100%",
                width: 2
            }
        },
        /* Styles applied to the track element. */ track: {
            display: "block",
            position: "absolute",
            height: 2,
            borderRadius: 1,
            backgroundColor: "currentColor",
            "$vertical &": {
                width: 2
            }
        },
        /* Styles applied to the track element if `track={false}`. */ trackFalse: {
            "& $track": {
                display: "none"
            }
        },
        /* Styles applied to the track element if `track="inverted"`. */ trackInverted: {
            "& $track": {
                backgroundColor: theme.palette.type === "light" ? (0, $6vqZH.lighten)(theme.palette.primary.main, 0.62) : (0, $6vqZH.darken)(theme.palette.primary.main, 0.5)
            },
            "& $rail": {
                opacity: 1
            }
        },
        /* Styles applied to the thumb element. */ thumb: {
            position: "absolute",
            width: 12,
            height: 12,
            marginLeft: -6,
            marginTop: -5,
            boxSizing: "border-box",
            borderRadius: "50%",
            outline: 0,
            backgroundColor: "currentColor",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: theme.transitions.create([
                "box-shadow"
            ], {
                duration: theme.transitions.duration.shortest
            }),
            "&::after": {
                position: "absolute",
                content: '""',
                borderRadius: "50%",
                // reach 42px hit target (2 * 15 + thumb diameter)
                left: -15,
                top: -15,
                right: -15,
                bottom: -15
            },
            "&$focusVisible,&:hover": {
                boxShadow: "0px 0px 0px 8px ".concat((0, $6vqZH.alpha)(theme.palette.primary.main, 0.16)),
                "@media (hover: none)": {
                    boxShadow: "none"
                }
            },
            "&$active": {
                boxShadow: "0px 0px 0px 14px ".concat((0, $6vqZH.alpha)(theme.palette.primary.main, 0.16))
            },
            "&$disabled": {
                width: 8,
                height: 8,
                marginLeft: -4,
                marginTop: -3,
                "&:hover": {
                    boxShadow: "none"
                }
            },
            "$vertical &": {
                marginLeft: -5,
                marginBottom: -6
            },
            "$vertical &$disabled": {
                marginLeft: -3,
                marginBottom: -4
            }
        },
        /* Styles applied to the thumb element if `color="primary"`. */ thumbColorPrimary: {},
        /* Styles applied to the thumb element if `color="secondary"`. */ thumbColorSecondary: {
            "&$focusVisible,&:hover": {
                boxShadow: "0px 0px 0px 8px ".concat((0, $6vqZH.alpha)(theme.palette.secondary.main, 0.16))
            },
            "&$active": {
                boxShadow: "0px 0px 0px 14px ".concat((0, $6vqZH.alpha)(theme.palette.secondary.main, 0.16))
            }
        },
        /* Pseudo-class applied to the thumb element if it's active. */ active: {},
        /* Pseudo-class applied to the thumb element if keyboard focused. */ focusVisible: {},
        /* Styles applied to the thumb label element. */ valueLabel: {
            // IE 11 centering bug, to remove from the customization demos once no longer supported
            left: "calc(-50% - 4px)"
        },
        /* Styles applied to the mark element. */ mark: {
            position: "absolute",
            width: 2,
            height: 2,
            borderRadius: 1,
            backgroundColor: "currentColor"
        },
        /* Styles applied to the mark element if active (depending on the value). */ markActive: {
            backgroundColor: theme.palette.background.paper,
            opacity: 0.8
        },
        /* Styles applied to the mark label element. */ markLabel: (0, $abElG.default)({}, theme.typography.body2, {
            color: theme.palette.text.secondary,
            position: "absolute",
            top: 26,
            transform: "translateX(-50%)",
            whiteSpace: "nowrap",
            "$vertical &": {
                top: "auto",
                left: 26,
                transform: "translateY(50%)"
            },
            "@media (pointer: coarse)": {
                top: 40,
                "$vertical &": {
                    left: 31
                }
            }
        }),
        /* Styles applied to the mark label element if active (depending on the value). */ markLabelActive: {
            color: theme.palette.text.primary
        }
    };
};
var $c10639fa83652aa7$var$Slider = /*#__PURE__*/ $arQ7u.forwardRef(function Slider(props, ref) {
    var ariaLabel = props["aria-label"], ariaLabelledby = props["aria-labelledby"], ariaValuetext = props["aria-valuetext"], classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "span" : _props$component, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, getAriaLabel = props.getAriaLabel, getAriaValueText = props.getAriaValueText, _props$marks = props.marks, marksProp = _props$marks === void 0 ? false : _props$marks, _props$max = props.max, max = _props$max === void 0 ? 100 : _props$max, _props$min = props.min, min = _props$min === void 0 ? 0 : _props$min, name = props.name, onChange = props.onChange, onChangeCommitted = props.onChangeCommitted, onMouseDown = props.onMouseDown, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, _props$scale = props.scale, scale = _props$scale === void 0 ? $c10639fa83652aa7$var$Identity : _props$scale, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, _props$ThumbComponent = props.ThumbComponent, ThumbComponent = _props$ThumbComponent === void 0 ? "span" : _props$ThumbComponent, _props$track = props.track, track = _props$track === void 0 ? "normal" : _props$track, valueProp = props.value, _props$ValueLabelComp = props.ValueLabelComponent, ValueLabelComponent = _props$ValueLabelComp === void 0 ? (0, $3IB0P.default) : _props$ValueLabelComp, _props$valueLabelDisp = props.valueLabelDisplay, valueLabelDisplay = _props$valueLabelDisp === void 0 ? "off" : _props$valueLabelDisp, _props$valueLabelForm = props.valueLabelFormat, valueLabelFormat = _props$valueLabelForm === void 0 ? $c10639fa83652aa7$var$Identity : _props$valueLabelForm, other = (0, $dXEVX.default)(props, [
        "aria-label",
        "aria-labelledby",
        "aria-valuetext",
        "classes",
        "className",
        "color",
        "component",
        "defaultValue",
        "disabled",
        "getAriaLabel",
        "getAriaValueText",
        "marks",
        "max",
        "min",
        "name",
        "onChange",
        "onChangeCommitted",
        "onMouseDown",
        "orientation",
        "scale",
        "step",
        "ThumbComponent",
        "track",
        "value",
        "ValueLabelComponent",
        "valueLabelDisplay",
        "valueLabelFormat"
    ]);
    var theme = (0, $j1k3T.default)();
    var touchId = $arQ7u.useRef(); // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transfered when inversing a range slider.
    var _React$useState = $arQ7u.useState(-1), active = _React$useState[0], setActive = _React$useState[1];
    var _React$useState2 = $arQ7u.useState(-1), open = _React$useState2[0], setOpen = _React$useState2[1];
    var _useControlled = (0, $lhLsx.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Slider"
    }), _useControlled2 = (0, $kMfvj.default)(_useControlled, 2), valueDerived = _useControlled2[0], setValueState = _useControlled2[1];
    var range = Array.isArray(valueDerived);
    var values = range ? valueDerived.slice().sort($c10639fa83652aa7$var$asc) : [
        valueDerived
    ];
    values = values.map(function(value) {
        return $c10639fa83652aa7$var$clamp(value, min, max);
    });
    var marks = marksProp === true && step !== null ? (0, $lsH61.default)(Array(Math.floor((max - min) / step) + 1)).map(function(_, index) {
        return {
            value: min + step * index
        };
    }) : marksProp || [];
    var _useIsFocusVisible = (0, $cvMUO.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState3 = $arQ7u.useState(-1), focusVisible = _React$useState3[0], setFocusVisible = _React$useState3[1];
    var sliderRef = $arQ7u.useRef();
    var handleFocusRef = (0, $nGnd5.default)(focusVisibleRef, sliderRef);
    var handleRef = (0, $nGnd5.default)(ref, handleFocusRef);
    var handleFocus = (0, $e3Evk.default)(function(event) {
        var index = Number(event.currentTarget.getAttribute("data-index"));
        if (isFocusVisible(event)) setFocusVisible(index);
        setOpen(index);
    });
    var handleBlur = (0, $e3Evk.default)(function() {
        if (focusVisible !== -1) {
            setFocusVisible(-1);
            onBlurVisible();
        }
        setOpen(-1);
    });
    var handleMouseOver = (0, $e3Evk.default)(function(event) {
        var index = Number(event.currentTarget.getAttribute("data-index"));
        setOpen(index);
    });
    var handleMouseLeave = (0, $e3Evk.default)(function() {
        setOpen(-1);
    });
    var isRtl = theme.direction === "rtl";
    var handleKeyDown = (0, $e3Evk.default)(function(event) {
        var index = Number(event.currentTarget.getAttribute("data-index"));
        var value = values[index];
        var tenPercents = (max - min) / 10;
        var marksValues = marks.map(function(mark) {
            return mark.value;
        });
        var marksIndex = marksValues.indexOf(value);
        var newValue;
        var increaseKey = isRtl ? "ArrowLeft" : "ArrowRight";
        var decreaseKey = isRtl ? "ArrowRight" : "ArrowLeft";
        switch(event.key){
            case "Home":
                newValue = min;
                break;
            case "End":
                newValue = max;
                break;
            case "PageUp":
                if (step) newValue = value + tenPercents;
                break;
            case "PageDown":
                if (step) newValue = value - tenPercents;
                break;
            case increaseKey:
            case "ArrowUp":
                if (step) newValue = value + step;
                else newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
                break;
            case decreaseKey:
            case "ArrowDown":
                if (step) newValue = value - step;
                else newValue = marksValues[marksIndex - 1] || marksValues[0];
                break;
            default:
                return;
        } // Prevent scroll of the page
        event.preventDefault();
        if (step) newValue = $c10639fa83652aa7$var$roundValueToStep(newValue, step, min);
        newValue = $c10639fa83652aa7$var$clamp(newValue, min, max);
        if (range) {
            var previousValue = newValue;
            newValue = $c10639fa83652aa7$var$setValueIndex({
                values: values,
                source: valueDerived,
                newValue: newValue,
                index: index
            }).sort($c10639fa83652aa7$var$asc);
            $c10639fa83652aa7$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: newValue.indexOf(previousValue)
            });
        }
        setValueState(newValue);
        setFocusVisible(index);
        if (onChange) onChange(event, newValue);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
    });
    var previousIndex = $arQ7u.useRef();
    var axis = orientation;
    if (isRtl && orientation !== "vertical") axis += "-reverse";
    var getFingerNewValue = function getFingerNewValue(_ref3) {
        var finger = _ref3.finger, _ref3$move = _ref3.move, move = _ref3$move === void 0 ? false : _ref3$move, values2 = _ref3.values, source = _ref3.source;
        var slider = sliderRef.current;
        var _slider$getBoundingCl = slider.getBoundingClientRect(), width = _slider$getBoundingCl.width, height = _slider$getBoundingCl.height, bottom = _slider$getBoundingCl.bottom, left = _slider$getBoundingCl.left;
        var percent;
        if (axis.indexOf("vertical") === 0) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.indexOf("-reverse") !== -1) percent = 1 - percent;
        var newValue;
        newValue = $c10639fa83652aa7$var$percentToValue(percent, min, max);
        if (step) newValue = $c10639fa83652aa7$var$roundValueToStep(newValue, step, min);
        else {
            var marksValues = marks.map(function(mark) {
                return mark.value;
            });
            var closestIndex = $c10639fa83652aa7$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = $c10639fa83652aa7$var$clamp(newValue, min, max);
        var activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $c10639fa83652aa7$var$findClosest(values2, newValue);
            else activeIndex = previousIndex.current;
            var previousValue = newValue;
            newValue = $c10639fa83652aa7$var$setValueIndex({
                values: values2,
                source: source,
                newValue: newValue,
                index: activeIndex
            }).sort($c10639fa83652aa7$var$asc);
            activeIndex = newValue.indexOf(previousValue);
            previousIndex.current = activeIndex;
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    var handleTouchMove = (0, $e3Evk.default)(function(event) {
        var finger = $c10639fa83652aa7$var$trackFinger(event, touchId);
        if (!finger) return;
        var _getFingerNewValue = getFingerNewValue({
            finger: finger,
            move: true,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue.newValue, activeIndex = _getFingerNewValue.activeIndex;
        $c10639fa83652aa7$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
    });
    var handleTouchEnd = (0, $e3Evk.default)(function(event) {
        var finger = $c10639fa83652aa7$var$trackFinger(event, touchId);
        if (!finger) return;
        var _getFingerNewValue2 = getFingerNewValue({
            finger: finger,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue2.newValue;
        setActive(-1);
        if (event.type === "touchend") setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
        touchId.current = undefined;
        var doc = (0, $5Yg7t.default)(sliderRef.current);
        doc.removeEventListener("mousemove", handleTouchMove);
        doc.removeEventListener("mouseup", handleTouchEnd);
        doc.removeEventListener("touchmove", handleTouchMove);
        doc.removeEventListener("touchend", handleTouchEnd);
    });
    var handleTouchStart = (0, $e3Evk.default)(function(event) {
        // Workaround as Safari has partial support for touchAction: 'none'.
        event.preventDefault();
        var touch = event.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        var finger = $c10639fa83652aa7$var$trackFinger(event, touchId);
        var _getFingerNewValue3 = getFingerNewValue({
            finger: finger,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue3.newValue, activeIndex = _getFingerNewValue3.activeIndex;
        $c10639fa83652aa7$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
        var doc = (0, $5Yg7t.default)(sliderRef.current);
        doc.addEventListener("touchmove", handleTouchMove);
        doc.addEventListener("touchend", handleTouchEnd);
    });
    $arQ7u.useEffect(function() {
        var slider = sliderRef.current;
        slider.addEventListener("touchstart", handleTouchStart);
        var doc = (0, $5Yg7t.default)(slider);
        return function() {
            slider.removeEventListener("touchstart", handleTouchStart);
            doc.removeEventListener("mousemove", handleTouchMove);
            doc.removeEventListener("mouseup", handleTouchEnd);
            doc.removeEventListener("touchmove", handleTouchMove);
            doc.removeEventListener("touchend", handleTouchEnd);
        };
    }, [
        handleTouchEnd,
        handleTouchMove,
        handleTouchStart
    ]);
    var handleMouseDown = (0, $e3Evk.default)(function(event) {
        if (onMouseDown) onMouseDown(event);
        event.preventDefault();
        var finger = $c10639fa83652aa7$var$trackFinger(event, touchId);
        var _getFingerNewValue4 = getFingerNewValue({
            finger: finger,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue4.newValue, activeIndex = _getFingerNewValue4.activeIndex;
        $c10639fa83652aa7$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
        var doc = (0, $5Yg7t.default)(sliderRef.current);
        doc.addEventListener("mousemove", handleTouchMove);
        doc.addEventListener("mouseup", handleTouchEnd);
    });
    var trackOffset = $c10639fa83652aa7$var$valueToPercent(range ? values[0] : min, min, max);
    var trackLeap = $c10639fa83652aa7$var$valueToPercent(values[values.length - 1], min, max) - trackOffset;
    var trackStyle = (0, $abElG.default)({}, $c10639fa83652aa7$var$axisProps[axis].offset(trackOffset), $c10639fa83652aa7$var$axisProps[axis].leap(trackLeap));
    return /*#__PURE__*/ $arQ7u.createElement(Component, (0, $abElG.default)({
        ref: handleRef,
        className: (0, $5g55B.default)(classes.root, classes["color".concat((0, $kaLUp.default)(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function(mark) {
            return mark.label;
        }) && classes.marked, track === false && classes.trackFalse, orientation === "vertical" && classes.vertical, track === "inverted" && classes.trackInverted),
        onMouseDown: handleMouseDown
    }, other), /*#__PURE__*/ $arQ7u.createElement("span", {
        className: classes.rail
    }), /*#__PURE__*/ $arQ7u.createElement("span", {
        className: classes.track,
        style: trackStyle
    }), /*#__PURE__*/ $arQ7u.createElement("input", {
        value: values.join(","),
        name: name,
        type: "hidden"
    }), marks.map(function(mark, index) {
        var percent = $c10639fa83652aa7$var$valueToPercent(mark.value, min, max);
        var style = $c10639fa83652aa7$var$axisProps[axis].offset(percent);
        var markActive;
        if (track === false) markActive = values.indexOf(mark.value) !== -1;
        else markActive = track === "normal" && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === "inverted" && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
        return /*#__PURE__*/ $arQ7u.createElement($arQ7u.Fragment, {
            key: mark.value
        }, /*#__PURE__*/ $arQ7u.createElement("span", {
            style: style,
            "data-index": index,
            className: (0, $5g55B.default)(classes.mark, markActive && classes.markActive)
        }), mark.label != null ? /*#__PURE__*/ $arQ7u.createElement("span", {
            "aria-hidden": true,
            "data-index": index,
            style: style,
            className: (0, $5g55B.default)(classes.markLabel, markActive && classes.markLabelActive)
        }, mark.label) : null);
    }), values.map(function(value, index) {
        var percent = $c10639fa83652aa7$var$valueToPercent(value, min, max);
        var style = $c10639fa83652aa7$var$axisProps[axis].offset(percent);
        return /*#__PURE__*/ $arQ7u.createElement(ValueLabelComponent, {
            key: index,
            valueLabelFormat: valueLabelFormat,
            valueLabelDisplay: valueLabelDisplay,
            className: classes.valueLabel,
            value: typeof valueLabelFormat === "function" ? valueLabelFormat(scale(value), index) : valueLabelFormat,
            index: index,
            open: open === index || active === index || valueLabelDisplay === "on",
            disabled: disabled
        }, /*#__PURE__*/ $arQ7u.createElement(ThumbComponent, {
            className: (0, $5g55B.default)(classes.thumb, classes["thumbColor".concat((0, $kaLUp.default)(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
            tabIndex: disabled ? null : 0,
            role: "slider",
            style: style,
            "data-index": index,
            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-orientation": orientation,
            "aria-valuemax": scale(max),
            "aria-valuemin": scale(min),
            "aria-valuenow": scale(value),
            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
            onKeyDown: handleKeyDown,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onMouseOver: handleMouseOver,
            onMouseLeave: handleMouseLeave
        }));
    }));
});
var $c10639fa83652aa7$export$2e2bcd8739ae039 = (0, $7EzGR.default)($c10639fa83652aa7$export$9dd6ff9ea0189349, {
    name: "MuiSlider"
})($c10639fa83652aa7$var$Slider);

});
parcelRegister("3IB0P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b523106f2436b75$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");

var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");
var $2b523106f2436b75$var$styles = function styles(theme) {
    return {
        thumb: {
            "&$open": {
                "& $offset": {
                    transform: "scale(1) translateY(-10px)"
                }
            }
        },
        open: {},
        offset: (0, $abElG.default)({
            zIndex: 1
        }, theme.typography.body2, {
            fontSize: theme.typography.pxToRem(12),
            lineHeight: 1.2,
            transition: theme.transitions.create([
                "transform"
            ], {
                duration: theme.transitions.duration.shortest
            }),
            top: -34,
            transformOrigin: "bottom center",
            transform: "scale(0)",
            position: "absolute"
        }),
        circle: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 32,
            height: 32,
            borderRadius: "50% 50% 50% 0",
            backgroundColor: "currentColor",
            transform: "rotate(-45deg)"
        },
        label: {
            color: theme.palette.primary.contrastText,
            transform: "rotate(45deg)"
        }
    };
};
/**
 * @ignore - internal component.
 */ function $2b523106f2436b75$var$ValueLabel(props) {
    var children = props.children, classes = props.classes, className = props.className, open = props.open, value = props.value, valueLabelDisplay = props.valueLabelDisplay;
    if (valueLabelDisplay === "off") return children;
    return /*#__PURE__*/ $arQ7u.cloneElement(children, {
        className: (0, $5g55B.default)(children.props.className, (open || valueLabelDisplay === "on") && classes.open, classes.thumb)
    }, /*#__PURE__*/ $arQ7u.createElement("span", {
        className: (0, $5g55B.default)(classes.offset, className)
    }, /*#__PURE__*/ $arQ7u.createElement("span", {
        className: classes.circle
    }, /*#__PURE__*/ $arQ7u.createElement("span", {
        className: classes.label
    }, value))));
}
var $2b523106f2436b75$export$2e2bcd8739ae039 = (0, $7EzGR.default)($2b523106f2436b75$var$styles, {
    name: "PrivateValueLabel"
})($2b523106f2436b75$var$ValueLabel);

});


parcelRegister("9AGn3", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fb857cd1686afb4$var$React = $363GR((parcelRequire("arQ7u")));

var $6fb857cd1686afb4$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $6fb857cd1686afb4$var$_default = (0, $6fb857cd1686afb4$var$_createSvgIcon.default)(/*#__PURE__*/ $6fb857cd1686afb4$var$React.createElement("path", {
    d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
}), "DragHandleSharp");
module.exports.default = $6fb857cd1686afb4$var$_default;

});

parcelRegister("ggVgu", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd8a8f9c656d2f75$var$React = $363GR((parcelRequire("arQ7u")));

var $bd8a8f9c656d2f75$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $bd8a8f9c656d2f75$var$_default = (0, $bd8a8f9c656d2f75$var$_createSvgIcon.default)(/*#__PURE__*/ $bd8a8f9c656d2f75$var$React.createElement("path", {
    d: "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
}), "VerticalAlignTopSharp");
module.exports.default = $bd8a8f9c656d2f75$var$_default;

});

parcelRegister("kz1EW", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef885d0e938408cf$var$React = $363GR((parcelRequire("arQ7u")));

var $ef885d0e938408cf$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $ef885d0e938408cf$var$_default = (0, $ef885d0e938408cf$var$_createSvgIcon.default)(/*#__PURE__*/ $ef885d0e938408cf$var$React.createElement("path", {
    d: "M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
}), "OpacitySharp");
module.exports.default = $ef885d0e938408cf$var$_default;

});

parcelRegister("g5rVJ", function(module, exports) {

$parcel$export(module.exports, "DragDropContext", function () { return $bb62c756e34fa51f$export$237bd83162c14364; });
$parcel$export(module.exports, "Draggable", function () { return $bb62c756e34fa51f$export$f2a139e5d18b9882; });
$parcel$export(module.exports, "Droppable", function () { return $bb62c756e34fa51f$export$423ec2075359570a; });

var $arQ7u = parcelRequire("arQ7u");

var $arruZ = parcelRequire("arruZ");

var $abElG = parcelRequire("abElG");

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");
var $iEjUn = parcelRequire("iEjUn");

var $b1OmR = parcelRequire("b1OmR");

var $2MAtZ = parcelRequire("2MAtZ");

var $6BHCT = parcelRequire("6BHCT");

var $b4uBG = parcelRequire("b4uBG");

var $9sDDw = parcelRequire("9sDDw");
var $bb62c756e34fa51f$var$isProduction = true;
var $bb62c756e34fa51f$var$spacesAndTabs = /[ \t]{2,}/g;
var $bb62c756e34fa51f$var$lineStartWithSpaces = /^[ \t]*/gm;
var $bb62c756e34fa51f$var$clean = function clean(value) {
    return value.replace($bb62c756e34fa51f$var$spacesAndTabs, " ").replace($bb62c756e34fa51f$var$lineStartWithSpaces, "").trim();
};
var $bb62c756e34fa51f$var$getDevMessage = function getDevMessage(message) {
    return $bb62c756e34fa51f$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $bb62c756e34fa51f$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $bb62c756e34fa51f$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $bb62c756e34fa51f$var$getDevMessage(message),
        "color: #00C584; font-size: 1.2em; font-weight: bold;",
        "line-height: 1.5",
        "color: #723874;"
    ];
};
var $bb62c756e34fa51f$var$isDisabledFlag = "__react-beautiful-dnd-disable-dev-warnings";
function $bb62c756e34fa51f$var$log(type, message) {
    var _console;
    if ($bb62c756e34fa51f$var$isProduction) return;
    if (typeof window !== "undefined" && window[$bb62c756e34fa51f$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $bb62c756e34fa51f$var$getFormattedMessage(message));
}
var $bb62c756e34fa51f$var$warning = $bb62c756e34fa51f$var$log.bind(null, "warn");
var $bb62c756e34fa51f$var$error = $bb62c756e34fa51f$var$log.bind(null, "error");
function $bb62c756e34fa51f$var$noop() {}
function $bb62c756e34fa51f$var$getOptions(shared, fromBinding) {
    return (0, $abElG.default)({}, shared, {}, fromBinding);
}
function $bb62c756e34fa51f$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $bb62c756e34fa51f$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $bb62c756e34fa51f$var$isProduction$1 = true;
var $bb62c756e34fa51f$var$prefix = "Invariant failed";
function $bb62c756e34fa51f$var$RbdInvariant(message) {
    this.message = message;
}
$bb62c756e34fa51f$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $bb62c756e34fa51f$var$invariant(condition, message) {
    if (condition) return;
    if ($bb62c756e34fa51f$var$isProduction$1) throw new $bb62c756e34fa51f$var$RbdInvariant($bb62c756e34fa51f$var$prefix);
    else throw new $bb62c756e34fa51f$var$RbdInvariant($bb62c756e34fa51f$var$prefix + ": " + (message || ""));
}
var $bb62c756e34fa51f$var$ErrorBoundary = function(_React$Component) {
    (0, $arruZ.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $bb62c756e34fa51f$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $bb62c756e34fa51f$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $bb62c756e34fa51f$var$bindEvents(window, [
            {
                eventName: "error",
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $bb62c756e34fa51f$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Component);
var $bb62c756e34fa51f$var$dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";
var $bb62c756e34fa51f$var$position = function position(index) {
    return index + 1;
};
var $bb62c756e34fa51f$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $bb62c756e34fa51f$var$position(start.source.index) + "\n";
};
var $bb62c756e34fa51f$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $bb62c756e34fa51f$var$position(source.index);
    var endPosition = $bb62c756e34fa51f$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $bb62c756e34fa51f$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $bb62c756e34fa51f$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $bb62c756e34fa51f$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $bb62c756e34fa51f$var$withCombine(update.draggableId, update.source, combine);
    return "You are over an area that cannot be dropped on";
};
var $bb62c756e34fa51f$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $bb62c756e34fa51f$var$position(source.index) + "\n";
};
var $bb62c756e34fa51f$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === "CANCEL") return "\n      Movement cancelled.\n      " + $bb62c756e34fa51f$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $bb62c756e34fa51f$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $bb62c756e34fa51f$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $bb62c756e34fa51f$var$returnedToStart(result.source) + "\n  ";
};
var $bb62c756e34fa51f$var$preset = {
    dragHandleUsageInstructions: $bb62c756e34fa51f$var$dragHandleUsageInstructions,
    onDragStart: $bb62c756e34fa51f$var$onDragStart,
    onDragUpdate: $bb62c756e34fa51f$var$onDragUpdate,
    onDragEnd: $bb62c756e34fa51f$var$onDragEnd
};
var $bb62c756e34fa51f$var$origin = {
    x: 0,
    y: 0
};
var $bb62c756e34fa51f$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $bb62c756e34fa51f$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $bb62c756e34fa51f$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $bb62c756e34fa51f$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $bb62c756e34fa51f$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === "x" ? "y" : "x"] = otherValue, _ref;
};
var $bb62c756e34fa51f$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $bb62c756e34fa51f$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $bb62c756e34fa51f$var$distance(target, point);
    }));
};
var $bb62c756e34fa51f$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $bb62c756e34fa51f$var$executeClip = function(frame, subject) {
    var result = (0, $2MAtZ.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $bb62c756e34fa51f$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $bb62c756e34fa51f$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $bb62c756e34fa51f$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $bb62c756e34fa51f$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $bb62c756e34fa51f$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $bb62c756e34fa51f$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $abElG.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $bb62c756e34fa51f$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $bb62c756e34fa51f$var$executeClip(frame.pageMarginBox, target);
    return (0, $2MAtZ.getRect)(target);
};
var $bb62c756e34fa51f$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $bb62c756e34fa51f$var$scroll(page.marginBox, frame);
    var increased = $bb62c756e34fa51f$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $bb62c756e34fa51f$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $bb62c756e34fa51f$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $bb62c756e34fa51f$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $bb62c756e34fa51f$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $bb62c756e34fa51f$var$negate(scrollDiff);
    var frame = (0, $abElG.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $bb62c756e34fa51f$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $abElG.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $bb62c756e34fa51f$var$isInteger(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function $bb62c756e34fa51f$var$values(map) {
    if (Object.values) return Object.values(map);
    return Object.keys(map).map(function(key) {
        return map[key];
    });
}
function $bb62c756e34fa51f$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $bb62c756e34fa51f$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $bb62c756e34fa51f$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $bb62c756e34fa51f$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $bb62c756e34fa51f$var$toDroppableMap = (0, $6BHCT.default)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $bb62c756e34fa51f$var$toDraggableMap = (0, $6BHCT.default)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $bb62c756e34fa51f$var$toDroppableList = (0, $6BHCT.default)(function(droppables) {
    return $bb62c756e34fa51f$var$values(droppables);
});
var $bb62c756e34fa51f$var$toDraggableList = (0, $6BHCT.default)(function(draggables) {
    return $bb62c756e34fa51f$var$values(draggables);
});
var $bb62c756e34fa51f$var$getDraggablesInsideDroppable = (0, $6BHCT.default)(function(droppableId, draggables) {
    var result = $bb62c756e34fa51f$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $bb62c756e34fa51f$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === "REORDER") return impact.at.destination;
    return null;
}
function $bb62c756e34fa51f$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === "COMBINE") return impact.at.combine;
    return null;
}
var $bb62c756e34fa51f$var$removeDraggableFromList = (0, $6BHCT.default)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $bb62c756e34fa51f$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $bb62c756e34fa51f$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: "COMBINE",
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $abElG.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $bb62c756e34fa51f$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $bb62c756e34fa51f$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $bb62c756e34fa51f$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $bb62c756e34fa51f$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $bb62c756e34fa51f$var$noDisplacedBy = {
    point: $bb62c756e34fa51f$var$origin,
    value: 0
};
var $bb62c756e34fa51f$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $bb62c756e34fa51f$var$noImpact = {
    displaced: $bb62c756e34fa51f$var$emptyGroups,
    displacedBy: $bb62c756e34fa51f$var$noDisplacedBy,
    at: null
};
var $bb62c756e34fa51f$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $bb62c756e34fa51f$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $bb62c756e34fa51f$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $bb62c756e34fa51f$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $bb62c756e34fa51f$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $bb62c756e34fa51f$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $bb62c756e34fa51f$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $bb62c756e34fa51f$var$vertical = {
    direction: "vertical",
    line: "y",
    crossAxisLine: "x",
    start: "top",
    end: "bottom",
    size: "height",
    crossAxisStart: "left",
    crossAxisEnd: "right",
    crossAxisSize: "width"
};
var $bb62c756e34fa51f$var$horizontal = {
    direction: "horizontal",
    line: "x",
    crossAxisLine: "y",
    start: "left",
    end: "right",
    size: "width",
    crossAxisStart: "top",
    crossAxisEnd: "bottom",
    crossAxisSize: "height"
};
var $bb62c756e34fa51f$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $bb62c756e34fa51f$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $bb62c756e34fa51f$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $bb62c756e34fa51f$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $bb62c756e34fa51f$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $bb62c756e34fa51f$var$origin;
    return $bb62c756e34fa51f$var$offsetByPosition(target, displacement);
};
var $bb62c756e34fa51f$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $bb62c756e34fa51f$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $bb62c756e34fa51f$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $bb62c756e34fa51f$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $bb62c756e34fa51f$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $bb62c756e34fa51f$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $bb62c756e34fa51f$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $bb62c756e34fa51f$var$isVisible((0, $abElG.default)({}, args, {
        isVisibleThroughFrameFn: $bb62c756e34fa51f$var$isPartiallyVisibleThroughFrame
    }));
};
var $bb62c756e34fa51f$var$isTotallyVisible = function isTotallyVisible(args) {
    return $bb62c756e34fa51f$var$isVisible((0, $abElG.default)({}, args, {
        isVisibleThroughFrameFn: $bb62c756e34fa51f$var$isTotallyVisibleThroughFrame
    }));
};
var $bb62c756e34fa51f$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $bb62c756e34fa51f$var$isVisible((0, $abElG.default)({}, args, {
        isVisibleThroughFrameFn: $bb62c756e34fa51f$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $bb62c756e34fa51f$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === "boolean") return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $bb62c756e34fa51f$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $2MAtZ.getRect)((0, $2MAtZ.expand)(marginBox, expandBy));
}
function $bb62c756e34fa51f$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $bb62c756e34fa51f$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $bb62c756e34fa51f$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $bb62c756e34fa51f$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $bb62c756e34fa51f$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $bb62c756e34fa51f$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $bb62c756e34fa51f$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $bb62c756e34fa51f$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $bb62c756e34fa51f$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $bb62c756e34fa51f$var$isHomeOf(draggable, destination);
    if (index == null) return $bb62c756e34fa51f$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $bb62c756e34fa51f$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $bb62c756e34fa51f$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $bb62c756e34fa51f$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $bb62c756e34fa51f$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $bb62c756e34fa51f$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $bb62c756e34fa51f$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $bb62c756e34fa51f$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $bb62c756e34fa51f$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $bb62c756e34fa51f$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $bb62c756e34fa51f$var$invariant(false);
    if (wasAt.type === "REORDER") {
        var _newIndex = $bb62c756e34fa51f$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $bb62c756e34fa51f$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $bb62c756e34fa51f$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $bb62c756e34fa51f$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $bb62c756e34fa51f$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($bb62c756e34fa51f$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $bb62c756e34fa51f$var$origin : $bb62c756e34fa51f$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $bb62c756e34fa51f$var$origin;
};
var $bb62c756e34fa51f$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $bb62c756e34fa51f$var$tryGetCombine(impact);
    !combine && $bb62c756e34fa51f$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $bb62c756e34fa51f$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $bb62c756e34fa51f$var$add(center, displaceBy);
};
var $bb62c756e34fa51f$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $bb62c756e34fa51f$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $bb62c756e34fa51f$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $bb62c756e34fa51f$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $bb62c756e34fa51f$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $bb62c756e34fa51f$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $bb62c756e34fa51f$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $bb62c756e34fa51f$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $bb62c756e34fa51f$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $bb62c756e34fa51f$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $bb62c756e34fa51f$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $bb62c756e34fa51f$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $bb62c756e34fa51f$var$patch(axis.line, moveInto.contentBox[axis.start] + $bb62c756e34fa51f$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $bb62c756e34fa51f$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $bb62c756e34fa51f$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $bb62c756e34fa51f$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $bb62c756e34fa51f$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($bb62c756e34fa51f$var$didStartAfterCritical(closestAfter, afterCritical)) return $bb62c756e34fa51f$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $2MAtZ.offset)(closest.page, displacedBy.point);
        return $bb62c756e34fa51f$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($bb62c756e34fa51f$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $2MAtZ.offset)(last.page, $bb62c756e34fa51f$var$negate(afterCritical.displacedBy.point));
        return $bb62c756e34fa51f$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $bb62c756e34fa51f$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $bb62c756e34fa51f$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $bb62c756e34fa51f$var$add(point, frame.scroll.diff.displacement);
};
var $bb62c756e34fa51f$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === "REORDER") return $bb62c756e34fa51f$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $bb62c756e34fa51f$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $bb62c756e34fa51f$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $bb62c756e34fa51f$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $bb62c756e34fa51f$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $bb62c756e34fa51f$var$scrollViewport = function(viewport, newScroll) {
    var diff = $bb62c756e34fa51f$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $bb62c756e34fa51f$var$negate(diff);
    var frame = (0, $2MAtZ.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $bb62c756e34fa51f$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $bb62c756e34fa51f$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $bb62c756e34fa51f$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $bb62c756e34fa51f$var$scrollViewport(viewport, $bb62c756e34fa51f$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $bb62c756e34fa51f$var$scrollDroppable(destination, $bb62c756e34fa51f$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $bb62c756e34fa51f$var$getDisplacementGroups({
        afterDragging: $bb62c756e34fa51f$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $bb62c756e34fa51f$var$getDisplacementGroups({
        afterDragging: $bb62c756e34fa51f$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $bb62c756e34fa51f$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $abElG.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $bb62c756e34fa51f$var$withViewportDisplacement = function(viewport, point) {
    return $bb62c756e34fa51f$var$add(viewport.scroll.diff.displacement, point);
};
var $bb62c756e34fa51f$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $bb62c756e34fa51f$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $bb62c756e34fa51f$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $bb62c756e34fa51f$var$add(draggable.client.borderBox.center, offset);
};
var $bb62c756e34fa51f$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $bb62c756e34fa51f$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $bb62c756e34fa51f$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $bb62c756e34fa51f$var$isTotallyVisibleOnAxis(args) : $bb62c756e34fa51f$var$isTotallyVisible(args);
};
var $bb62c756e34fa51f$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $bb62c756e34fa51f$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $bb62c756e34fa51f$var$isHomeOf(draggable, destination);
    var impact = $bb62c756e34fa51f$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $bb62c756e34fa51f$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $bb62c756e34fa51f$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $bb62c756e34fa51f$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $bb62c756e34fa51f$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $bb62c756e34fa51f$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $bb62c756e34fa51f$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $bb62c756e34fa51f$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $bb62c756e34fa51f$var$invariant(false);
    return rect;
};
var $bb62c756e34fa51f$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $bb62c756e34fa51f$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $bb62c756e34fa51f$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $bb62c756e34fa51f$var$isPartiallyVisibleThroughFrame(viewport.frame)($bb62c756e34fa51f$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $bb62c756e34fa51f$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $bb62c756e34fa51f$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $bb62c756e34fa51f$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $bb62c756e34fa51f$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $bb62c756e34fa51f$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $bb62c756e34fa51f$var$getKnownActive(droppable)[axis.crossAxisStart] === $bb62c756e34fa51f$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $bb62c756e34fa51f$var$isWithin($bb62c756e34fa51f$var$getKnownActive(droppable)[axis.start], $bb62c756e34fa51f$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $bb62c756e34fa51f$var$getKnownActive(a)[axis.start] - $bb62c756e34fa51f$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $bb62c756e34fa51f$var$closest(pageBorderBoxCenter, $bb62c756e34fa51f$var$getCorners($bb62c756e34fa51f$var$getKnownActive(a)));
        var second = $bb62c756e34fa51f$var$closest(pageBorderBoxCenter, $bb62c756e34fa51f$var$getCorners($bb62c756e34fa51f$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $bb62c756e34fa51f$var$getKnownActive(a)[axis.start] - $bb62c756e34fa51f$var$getKnownActive(b)[axis.start];
    })[0];
};
var $bb62c756e34fa51f$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $bb62c756e34fa51f$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $bb62c756e34fa51f$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $bb62c756e34fa51f$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $bb62c756e34fa51f$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $bb62c756e34fa51f$var$offsetByPosition(original, $bb62c756e34fa51f$var$negate(afterCritical.displacedBy.point)) : original;
};
var $bb62c756e34fa51f$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $bb62c756e34fa51f$var$isTotallyVisible({
            target: $bb62c756e34fa51f$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $bb62c756e34fa51f$var$distance(pageBorderBoxCenter, $bb62c756e34fa51f$var$withDroppableDisplacement(destination, $bb62c756e34fa51f$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $bb62c756e34fa51f$var$distance(pageBorderBoxCenter, $bb62c756e34fa51f$var$withDroppableDisplacement(destination, $bb62c756e34fa51f$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $bb62c756e34fa51f$var$getDisplacedBy = (0, $6BHCT.default)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $bb62c756e34fa51f$var$patch(axis.line, displacement)
    };
});
var $bb62c756e34fa51f$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === "virtual") return $bb62c756e34fa51f$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $bb62c756e34fa51f$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $bb62c756e34fa51f$var$patch(axis.line, needsToGrowBy);
};
var $bb62c756e34fa51f$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $abElG.default)({}, frame, {
        scroll: (0, $abElG.default)({}, frame.scroll, {
            max: max
        })
    });
};
var $bb62c756e34fa51f$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$bb62c756e34fa51f$var$isHomeOf(draggable, droppable) && $bb62c756e34fa51f$var$invariant(false);
    !!droppable.subject.withPlaceholder && $bb62c756e34fa51f$var$invariant(false);
    var placeholderSize = $bb62c756e34fa51f$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $bb62c756e34fa51f$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $bb62c756e34fa51f$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $abElG.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $bb62c756e34fa51f$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $bb62c756e34fa51f$var$withMaxScroll(frame, maxScroll);
    var subject = $bb62c756e34fa51f$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $abElG.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $bb62c756e34fa51f$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $bb62c756e34fa51f$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $bb62c756e34fa51f$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $abElG.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $bb62c756e34fa51f$var$invariant(false);
    var newFrame = $bb62c756e34fa51f$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $bb62c756e34fa51f$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $abElG.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $bb62c756e34fa51f$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $bb62c756e34fa51f$var$emptyGroups,
            displacedBy: $bb62c756e34fa51f$var$noDisplacedBy,
            at: {
                type: "REORDER",
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $bb62c756e34fa51f$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $bb62c756e34fa51f$var$isHomeOf(draggable, destination) ? destination : $bb62c756e34fa51f$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $bb62c756e34fa51f$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $bb62c756e34fa51f$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $bb62c756e34fa51f$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $bb62c756e34fa51f$var$emptyGroups,
        index: proposedIndex
    });
};
var $bb62c756e34fa51f$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $bb62c756e34fa51f$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $bb62c756e34fa51f$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $bb62c756e34fa51f$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $bb62c756e34fa51f$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $bb62c756e34fa51f$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $bb62c756e34fa51f$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $bb62c756e34fa51f$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === "REORDER") return at.destination.droppableId;
    return at.combine.droppableId;
};
var $bb62c756e34fa51f$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $bb62c756e34fa51f$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $bb62c756e34fa51f$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $bb62c756e34fa51f$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === "vertical" && (type === "MOVE_UP" || type === "MOVE_DOWN") || direction === "horizontal" && (type === "MOVE_LEFT" || type === "MOVE_RIGHT");
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === "MOVE_DOWN" || type === "MOVE_RIGHT";
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $bb62c756e34fa51f$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $bb62c756e34fa51f$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $bb62c756e34fa51f$var$isMovementAllowed(state) {
    return state.phase === "DRAGGING" || state.phase === "COLLECTING";
}
function $bb62c756e34fa51f$var$isPositionInFrame(frame) {
    var isWithinVertical = $bb62c756e34fa51f$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $bb62c756e34fa51f$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $bb62c756e34fa51f$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $bb62c756e34fa51f$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $bb62c756e34fa51f$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $bb62c756e34fa51f$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $bb62c756e34fa51f$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $bb62c756e34fa51f$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$bb62c756e34fa51f$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($bb62c756e34fa51f$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $bb62c756e34fa51f$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $bb62c756e34fa51f$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $bb62c756e34fa51f$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $2MAtZ.getRect)($bb62c756e34fa51f$var$offsetByPosition(rect, point));
};
var $bb62c756e34fa51f$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $bb62c756e34fa51f$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $bb62c756e34fa51f$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $bb62c756e34fa51f$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $bb62c756e34fa51f$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $bb62c756e34fa51f$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $bb62c756e34fa51f$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $bb62c756e34fa51f$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $bb62c756e34fa51f$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $bb62c756e34fa51f$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $bb62c756e34fa51f$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $bb62c756e34fa51f$var$isHomeOf(draggable, destination)
    });
    return $bb62c756e34fa51f$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $bb62c756e34fa51f$var$combineThresholdDivisor = 4;
var $bb62c756e34fa51f$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $bb62c756e34fa51f$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $bb62c756e34fa51f$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $bb62c756e34fa51f$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $bb62c756e34fa51f$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $bb62c756e34fa51f$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $bb62c756e34fa51f$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: "COMBINE",
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $bb62c756e34fa51f$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $bb62c756e34fa51f$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $bb62c756e34fa51f$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $bb62c756e34fa51f$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $bb62c756e34fa51f$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $bb62c756e34fa51f$var$withDroppableScroll(destination, pageBorderBox);
    return $bb62c756e34fa51f$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $bb62c756e34fa51f$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $bb62c756e34fa51f$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $abElG.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $bb62c756e34fa51f$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $bb62c756e34fa51f$var$whatIsDraggedOver(previousImpact);
    var now = $bb62c756e34fa51f$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $bb62c756e34fa51f$var$removePlaceholder(lastDroppable);
    return $bb62c756e34fa51f$var$patchDroppableMap(droppables, updated);
};
var $bb62c756e34fa51f$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $bb62c756e34fa51f$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $bb62c756e34fa51f$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($bb62c756e34fa51f$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $bb62c756e34fa51f$var$addPlaceholder(droppable, draggable, draggables);
    return $bb62c756e34fa51f$var$patchDroppableMap(cleaned, patched);
};
var $bb62c756e34fa51f$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $bb62c756e34fa51f$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $bb62c756e34fa51f$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $bb62c756e34fa51f$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $bb62c756e34fa51f$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $bb62c756e34fa51f$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === "COLLECTING") return (0, $abElG.default)({
        phase: "COLLECTING"
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $bb62c756e34fa51f$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $bb62c756e34fa51f$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $abElG.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $bb62c756e34fa51f$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $bb62c756e34fa51f$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $bb62c756e34fa51f$var$getDraggables$1(last.all, draggables);
    var displaced = $bb62c756e34fa51f$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $abElG.default)({}, impact, {
        displaced: displaced
    });
};
var $bb62c756e34fa51f$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $bb62c756e34fa51f$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $bb62c756e34fa51f$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $bb62c756e34fa51f$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === "SNAP") && $bb62c756e34fa51f$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $bb62c756e34fa51f$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $bb62c756e34fa51f$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $bb62c756e34fa51f$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $bb62c756e34fa51f$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $bb62c756e34fa51f$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $bb62c756e34fa51f$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $bb62c756e34fa51f$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $bb62c756e34fa51f$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $bb62c756e34fa51f$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $bb62c756e34fa51f$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === "virtual",
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $bb62c756e34fa51f$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: $bb62c756e34fa51f$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $bb62c756e34fa51f$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $bb62c756e34fa51f$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $bb62c756e34fa51f$var$start = function start(key) {};
var $bb62c756e34fa51f$var$finish = function finish(key) {};
var $bb62c756e34fa51f$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $2MAtZ.offset)(draggable.client, offset$1);
    var page = (0, $2MAtZ.withScroll)(client, initialWindowScroll);
    var moved = (0, $abElG.default)({}, draggable, {
        placeholder: (0, $abElG.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $bb62c756e34fa51f$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $bb62c756e34fa51f$var$invariant(false);
    return frame;
};
var $bb62c756e34fa51f$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $bb62c756e34fa51f$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $bb62c756e34fa51f$var$add(windowScrollChange, droppableScrollChange);
        var moved = $bb62c756e34fa51f$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $bb62c756e34fa51f$var$publishWhileDraggingInVirtual = function(_ref) {
    var state = _ref.state, published = _ref.published;
    $bb62c756e34fa51f$var$start();
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $bb62c756e34fa51f$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $abElG.default)({}, state.dimensions.droppables, {}, $bb62c756e34fa51f$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $bb62c756e34fa51f$var$toDraggableMap($bb62c756e34fa51f$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $abElG.default)({}, state.dimensions.draggables, {}, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $bb62c756e34fa51f$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $bb62c756e34fa51f$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $bb62c756e34fa51f$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $bb62c756e34fa51f$var$finish();
    var draggingState = (0, $abElG.default)({
        phase: "DRAGGING"
    }, state, {
        phase: "DRAGGING",
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    });
    if (state.phase === "COLLECTING") return draggingState;
    var dropPending = (0, $abElG.default)({
        phase: "DROP_PENDING"
    }, draggingState, {
        phase: "DROP_PENDING",
        reason: state.reason,
        isWaiting: false
    });
    return dropPending;
};
var $bb62c756e34fa51f$var$isSnapping = function isSnapping(state) {
    return state.movementMode === "SNAP";
};
var $bb62c756e34fa51f$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $bb62c756e34fa51f$var$patchDimensionMap(state.dimensions, updated);
    if (!$bb62c756e34fa51f$var$isSnapping(state) || isEnabledChanging) return $bb62c756e34fa51f$var$update({
        state: state,
        dimensions: dimensions
    });
    return $bb62c756e34fa51f$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $bb62c756e34fa51f$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === "SNAP") return (0, $abElG.default)({
        phase: "DRAGGING"
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $bb62c756e34fa51f$var$idle = {
    phase: "IDLE",
    completed: null,
    shouldFlush: false
};
var $bb62c756e34fa51f$var$reducer = function(state, action) {
    if (state === void 0) state = $bb62c756e34fa51f$var$idle;
    if (action.type === "FLUSH") return (0, $abElG.default)({}, $bb62c756e34fa51f$var$idle, {
        shouldFlush: true
    });
    if (action.type === "INITIAL_PUBLISH") {
        !(state.phase === "IDLE") && $bb62c756e34fa51f$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $bb62c756e34fa51f$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $bb62c756e34fa51f$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $bb62c756e34fa51f$var$add(client.selection, viewport.scroll.initial),
                offset: $bb62c756e34fa51f$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $bb62c756e34fa51f$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $bb62c756e34fa51f$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: "DRAGGING",
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === "COLLECTION_STARTING") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $bb62c756e34fa51f$var$invariant(false);
        var _result = (0, $abElG.default)({
            phase: "COLLECTING"
        }, state, {
            phase: "COLLECTING"
        });
        return _result;
    }
    if (action.type === "PUBLISH_WHILE_DRAGGING") {
        !(state.phase === "COLLECTING" || state.phase === "DROP_PENDING") && $bb62c756e34fa51f$var$invariant(false);
        return $bb62c756e34fa51f$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === "MOVE") {
        if (state.phase === "DROP_PENDING") return state;
        !$bb62c756e34fa51f$var$isMovementAllowed(state) && $bb62c756e34fa51f$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($bb62c756e34fa51f$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $bb62c756e34fa51f$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $bb62c756e34fa51f$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === "UPDATE_DROPPABLE_SCROLL") {
        if (state.phase === "DROP_PENDING") return $bb62c756e34fa51f$var$removeScrollJumpRequest(state);
        if (state.phase === "COLLECTING") return $bb62c756e34fa51f$var$removeScrollJumpRequest(state);
        !$bb62c756e34fa51f$var$isMovementAllowed(state) && $bb62c756e34fa51f$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $bb62c756e34fa51f$var$scrollDroppable(target, newScroll);
        return $bb62c756e34fa51f$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$bb62c756e34fa51f$var$isMovementAllowed(state) && $bb62c756e34fa51f$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $bb62c756e34fa51f$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $bb62c756e34fa51f$var$invariant(false);
        var updated = (0, $abElG.default)({}, _target, {
            isEnabled: isEnabled
        });
        return $bb62c756e34fa51f$var$postDroppableChange(state, updated, true);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$bb62c756e34fa51f$var$isMovementAllowed(state) && $bb62c756e34fa51f$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $bb62c756e34fa51f$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $bb62c756e34fa51f$var$invariant(false);
        var _updated = (0, $abElG.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $bb62c756e34fa51f$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === "MOVE_BY_WINDOW_SCROLL") {
        if (state.phase === "DROP_PENDING" || state.phase === "DROP_ANIMATING") return state;
        !$bb62c756e34fa51f$var$isMovementAllowed(state) && $bb62c756e34fa51f$var$invariant(false);
        !state.isWindowScrollAllowed && $bb62c756e34fa51f$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($bb62c756e34fa51f$var$isEqual(state.viewport.scroll.current, _newScroll)) return $bb62c756e34fa51f$var$removeScrollJumpRequest(state);
        var _viewport = $bb62c756e34fa51f$var$scrollViewport(state.viewport, _newScroll);
        if ($bb62c756e34fa51f$var$isSnapping(state)) return $bb62c756e34fa51f$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $bb62c756e34fa51f$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
        if (!$bb62c756e34fa51f$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($bb62c756e34fa51f$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $abElG.default)({}, state.viewport, {
            scroll: (0, $abElG.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $abElG.default)({
            phase: "DRAGGING"
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === "MOVE_UP" || action.type === "MOVE_DOWN" || action.type === "MOVE_LEFT" || action.type === "MOVE_RIGHT") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $bb62c756e34fa51f$var$invariant(false);
        var _result2 = $bb62c756e34fa51f$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $bb62c756e34fa51f$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === "DROP_PENDING") {
        var reason = action.payload.reason;
        !(state.phase === "COLLECTING") && $bb62c756e34fa51f$var$invariant(false);
        var newState = (0, $abElG.default)({
            phase: "DROP_PENDING"
        }, state, {
            phase: "DROP_PENDING",
            isWaiting: true,
            reason: reason
        });
        return newState;
    }
    if (action.type === "DROP_ANIMATE") {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $bb62c756e34fa51f$var$invariant(false);
        var _result3 = {
            phase: "DROP_ANIMATING",
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === "DROP_COMPLETE") {
        var _completed = action.payload.completed;
        return {
            phase: "IDLE",
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $bb62c756e34fa51f$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: "BEFORE_INITIAL_CAPTURE",
        payload: args
    };
};
var $bb62c756e34fa51f$var$lift = function lift(args) {
    return {
        type: "LIFT",
        payload: args
    };
};
var $bb62c756e34fa51f$var$initialPublish = function initialPublish(args) {
    return {
        type: "INITIAL_PUBLISH",
        payload: args
    };
};
var $bb62c756e34fa51f$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: "PUBLISH_WHILE_DRAGGING",
        payload: args
    };
};
var $bb62c756e34fa51f$var$collectionStarting = function collectionStarting() {
    return {
        type: "COLLECTION_STARTING",
        payload: null
    };
};
var $bb62c756e34fa51f$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: "UPDATE_DROPPABLE_SCROLL",
        payload: args
    };
};
var $bb62c756e34fa51f$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_ENABLED",
        payload: args
    };
};
var $bb62c756e34fa51f$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
        payload: args
    };
};
var $bb62c756e34fa51f$var$move = function move(args) {
    return {
        type: "MOVE",
        payload: args
    };
};
var $bb62c756e34fa51f$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: "MOVE_BY_WINDOW_SCROLL",
        payload: args
    };
};
var $bb62c756e34fa51f$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: "UPDATE_VIEWPORT_MAX_SCROLL",
        payload: args
    };
};
var $bb62c756e34fa51f$var$moveUp = function moveUp() {
    return {
        type: "MOVE_UP",
        payload: null
    };
};
var $bb62c756e34fa51f$var$moveDown = function moveDown() {
    return {
        type: "MOVE_DOWN",
        payload: null
    };
};
var $bb62c756e34fa51f$var$moveRight = function moveRight() {
    return {
        type: "MOVE_RIGHT",
        payload: null
    };
};
var $bb62c756e34fa51f$var$moveLeft = function moveLeft() {
    return {
        type: "MOVE_LEFT",
        payload: null
    };
};
var $bb62c756e34fa51f$var$flush = function flush() {
    return {
        type: "FLUSH",
        payload: null
    };
};
var $bb62c756e34fa51f$var$animateDrop = function animateDrop(args) {
    return {
        type: "DROP_ANIMATE",
        payload: args
    };
};
var $bb62c756e34fa51f$var$completeDrop = function completeDrop(args) {
    return {
        type: "DROP_COMPLETE",
        payload: args
    };
};
var $bb62c756e34fa51f$var$drop = function drop(args) {
    return {
        type: "DROP",
        payload: args
    };
};
var $bb62c756e34fa51f$var$dropPending = function dropPending(args) {
    return {
        type: "DROP_PENDING",
        payload: args
    };
};
var $bb62c756e34fa51f$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: "DROP_ANIMATION_FINISHED",
        payload: null
    };
};
function $bb62c756e34fa51f$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(", ");
}
function $bb62c756e34fa51f$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $bb62c756e34fa51f$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== "LIFT") {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === "DROP_ANIMATING") dispatch($bb62c756e34fa51f$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === "IDLE") && $bb62c756e34fa51f$var$invariant(false);
                dispatch($bb62c756e34fa51f$var$flush());
                dispatch($bb62c756e34fa51f$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === "SNAP"
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $bb62c756e34fa51f$var$validateDimensions(critical, dimensions);
                dispatch($bb62c756e34fa51f$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $bb62c756e34fa51f$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") marshal.dragging();
                if (action.type === "DROP_ANIMATE") marshal.dropping(action.payload.completed.result.reason);
                if (action.type === "FLUSH" || action.type === "DROP_COMPLETE") marshal.resting();
                next(action);
            };
        };
    };
};
var $bb62c756e34fa51f$var$curves = {
    outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
    drop: "cubic-bezier(.2,1,.1,1)"
};
var $bb62c756e34fa51f$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $bb62c756e34fa51f$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $bb62c756e34fa51f$var$outOfTheWayTiming = $bb62c756e34fa51f$var$timings.outOfTheWay + "s " + $bb62c756e34fa51f$var$curves.outOfTheWay;
var $bb62c756e34fa51f$var$transitions = {
    fluid: "opacity " + $bb62c756e34fa51f$var$outOfTheWayTiming,
    snap: "transform " + $bb62c756e34fa51f$var$outOfTheWayTiming + ", opacity " + $bb62c756e34fa51f$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $bb62c756e34fa51f$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $bb62c756e34fa51f$var$outOfTheWayTiming,
    placeholder: "height " + $bb62c756e34fa51f$var$outOfTheWayTiming + ", width " + $bb62c756e34fa51f$var$outOfTheWayTiming + ", margin " + $bb62c756e34fa51f$var$outOfTheWayTiming
};
var $bb62c756e34fa51f$var$moveTo = function moveTo(offset) {
    return $bb62c756e34fa51f$var$isEqual(offset, $bb62c756e34fa51f$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $bb62c756e34fa51f$var$transforms = {
    moveTo: $bb62c756e34fa51f$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $bb62c756e34fa51f$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $bb62c756e34fa51f$var$combine.scale.drop + ")";
    }
};
var $bb62c756e34fa51f$var$minDropTime = $bb62c756e34fa51f$var$timings.minDropTime, $bb62c756e34fa51f$var$maxDropTime = $bb62c756e34fa51f$var$timings.maxDropTime;
var $bb62c756e34fa51f$var$dropTimeRange = $bb62c756e34fa51f$var$maxDropTime - $bb62c756e34fa51f$var$minDropTime;
var $bb62c756e34fa51f$var$maxDropTimeAtDistance = 1500;
var $bb62c756e34fa51f$var$cancelDropModifier = 0.6;
var $bb62c756e34fa51f$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $bb62c756e34fa51f$var$distance(current, destination);
    if (distance$1 <= 0) return $bb62c756e34fa51f$var$minDropTime;
    if (distance$1 >= $bb62c756e34fa51f$var$maxDropTimeAtDistance) return $bb62c756e34fa51f$var$maxDropTime;
    var percentage = distance$1 / $bb62c756e34fa51f$var$maxDropTimeAtDistance;
    var duration = $bb62c756e34fa51f$var$minDropTime + $bb62c756e34fa51f$var$dropTimeRange * percentage;
    var withDuration = reason === "CANCEL" ? duration * $bb62c756e34fa51f$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $bb62c756e34fa51f$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $bb62c756e34fa51f$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $bb62c756e34fa51f$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $bb62c756e34fa51f$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $bb62c756e34fa51f$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== "DROP") {
        var recomputedHomeImpact = $bb62c756e34fa51f$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === "REORDER") return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $abElG.default)({}, lastImpact, {
        displaced: $bb62c756e34fa51f$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $bb62c756e34fa51f$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== "DROP") {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === "COLLECTING") {
                dispatch($bb62c756e34fa51f$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === "IDLE") return;
            var isWaitingForDrop = state.phase === "DROP_PENDING" && state.isWaiting;
            !!isWaitingForDrop && $bb62c756e34fa51f$var$invariant(false);
            !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $bb62c756e34fa51f$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $bb62c756e34fa51f$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $bb62c756e34fa51f$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $bb62c756e34fa51f$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $bb62c756e34fa51f$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$bb62c756e34fa51f$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($bb62c756e34fa51f$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $bb62c756e34fa51f$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($bb62c756e34fa51f$var$animateDrop(args));
        };
    };
};
var $bb62c756e34fa51f$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $bb62c756e34fa51f$var$getWindowScrollBinding(update) {
    return {
        eventName: "scroll",
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $bb62c756e34fa51f$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($bb62c756e34fa51f$var$getWindowScroll());
    }
    var scheduled = (0, $b4uBG.default)(updateScroll);
    var binding = $bb62c756e34fa51f$var$getWindowScrollBinding(scheduled);
    var unbind = $bb62c756e34fa51f$var$noop;
    function isActive() {
        return unbind !== $bb62c756e34fa51f$var$noop;
    }
    function start() {
        !!isActive() && $bb62c756e34fa51f$var$invariant(false);
        unbind = $bb62c756e34fa51f$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $bb62c756e34fa51f$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $bb62c756e34fa51f$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $bb62c756e34fa51f$var$shouldEnd = function shouldEnd(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var $bb62c756e34fa51f$var$scrollListener = function(store) {
    var listener = $bb62c756e34fa51f$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($bb62c756e34fa51f$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === "INITIAL_PUBLISH") listener.start();
            if (listener.isActive() && $bb62c756e34fa51f$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $bb62c756e34fa51f$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $bb62c756e34fa51f$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $bb62c756e34fa51f$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $bb62c756e34fa51f$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $bb62c756e34fa51f$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $bb62c756e34fa51f$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $bb62c756e34fa51f$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $bb62c756e34fa51f$var$withTimings = function withTimings(key, fn) {
    $bb62c756e34fa51f$var$start();
    fn();
    $bb62c756e34fa51f$var$finish();
};
var $bb62c756e34fa51f$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $bb62c756e34fa51f$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $bb62c756e34fa51f$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $bb62c756e34fa51f$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $bb62c756e34fa51f$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $bb62c756e34fa51f$var$invariant(false);
        $bb62c756e34fa51f$var$withTimings("onBeforeCapture", function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $bb62c756e34fa51f$var$invariant(false);
        $bb62c756e34fa51f$var$withTimings("onBeforeDragStart", function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($bb62c756e34fa51f$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $bb62c756e34fa51f$var$invariant(false);
        var data = $bb62c756e34fa51f$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $bb62c756e34fa51f$var$withTimings("onDragStart", function() {
                return $bb62c756e34fa51f$var$execute(getResponders().onDragStart, data, announce, $bb62c756e34fa51f$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $bb62c756e34fa51f$var$tryGetDestination(impact);
        var combine = $bb62c756e34fa51f$var$tryGetCombine(impact);
        !dragging && $bb62c756e34fa51f$var$invariant(false);
        var hasCriticalChanged = !$bb62c756e34fa51f$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$bb62c756e34fa51f$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$bb62c756e34fa51f$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $abElG.default)({}, $bb62c756e34fa51f$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $bb62c756e34fa51f$var$withTimings("onDragUpdate", function() {
                return $bb62c756e34fa51f$var$execute(getResponders().onDragUpdate, data, announce, $bb62c756e34fa51f$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $bb62c756e34fa51f$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $bb62c756e34fa51f$var$invariant(false);
        dragging = null;
        $bb62c756e34fa51f$var$withTimings("onDragEnd", function() {
            return $bb62c756e34fa51f$var$execute(getResponders().onDragEnd, result, announce, $bb62c756e34fa51f$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $abElG.default)({}, $bb62c756e34fa51f$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: "CANCEL"
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $bb62c756e34fa51f$var$responders = function(getResponders, announce) {
    var publisher = $bb62c756e34fa51f$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === "BEFORE_INITIAL_CAPTURE") {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === "FLUSH") {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === "DRAGGING") publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $bb62c756e34fa51f$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== "DROP_ANIMATION_FINISHED") {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === "DROP_ANIMATING") && $bb62c756e34fa51f$var$invariant(false);
            store.dispatch($bb62c756e34fa51f$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $bb62c756e34fa51f$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === "FLUSH" || action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATION_FINISHED") clear();
            next(action);
            if (action.type !== "DROP_ANIMATE") return;
            var binding = {
                eventName: "scroll",
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === "DROP_ANIMATING") store.dispatch($bb62c756e34fa51f$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $bb62c756e34fa51f$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $bb62c756e34fa51f$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "DROP_COMPLETE" || action.type === "FLUSH" || action.type === "DROP_ANIMATE") marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $bb62c756e34fa51f$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === "FLUSH") {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $bb62c756e34fa51f$var$shouldStop = function shouldStop(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var $bb62c756e34fa51f$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($bb62c756e34fa51f$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    next(action);
                    var state = store.getState();
                    !(state.phase === "DRAGGING") && $bb62c756e34fa51f$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $bb62c756e34fa51f$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== "PUBLISH_WHILE_DRAGGING") return;
            var postActionState = store.getState();
            if (postActionState.phase !== "DROP_PENDING") return;
            if (postActionState.isWaiting) return;
            store.dispatch($bb62c756e34fa51f$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $bb62c756e34fa51f$var$composeEnhancers = (0, $k19ic.compose);
var $bb62c756e34fa51f$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $k19ic.createStore)($bb62c756e34fa51f$var$reducer, $bb62c756e34fa51f$var$composeEnhancers((0, $k19ic.applyMiddleware)($bb62c756e34fa51f$var$style(styleMarshal), $bb62c756e34fa51f$var$dimensionMarshalStopper(dimensionMarshal), $bb62c756e34fa51f$var$lift$1(dimensionMarshal), $bb62c756e34fa51f$var$drop$1, $bb62c756e34fa51f$var$dropAnimationFinish, $bb62c756e34fa51f$var$dropAnimationFlushOnScroll, $bb62c756e34fa51f$var$pendingDrop, $bb62c756e34fa51f$var$autoScroll(autoScroller), $bb62c756e34fa51f$var$scrollListener, $bb62c756e34fa51f$var$focus(focusMarshal), $bb62c756e34fa51f$var$responders(getResponders, announce))));
};
var $bb62c756e34fa51f$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
function $bb62c756e34fa51f$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $bb62c756e34fa51f$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $bb62c756e34fa51f$var$start();
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = Object.keys(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($bb62c756e34fa51f$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = Object.keys(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = $bb62c756e34fa51f$var$clean$1();
            $bb62c756e34fa51f$var$finish();
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $bb62c756e34fa51f$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $bb62c756e34fa51f$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $bb62c756e34fa51f$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $bb62c756e34fa51f$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $bb62c756e34fa51f$var$invariant(false);
    return doc;
};
var $bb62c756e34fa51f$var$getMaxWindowScroll = function() {
    var doc = $bb62c756e34fa51f$var$getDocumentElement();
    var maxScroll = $bb62c756e34fa51f$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $bb62c756e34fa51f$var$getViewport = function() {
    var scroll = $bb62c756e34fa51f$var$getWindowScroll();
    var maxScroll = $bb62c756e34fa51f$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $bb62c756e34fa51f$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $2MAtZ.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $bb62c756e34fa51f$var$origin,
                displacement: $bb62c756e34fa51f$var$origin
            }
        }
    };
    return viewport;
};
var $bb62c756e34fa51f$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    $bb62c756e34fa51f$var$start();
    var viewport = $bb62c756e34fa51f$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $bb62c756e34fa51f$var$toDraggableMap(draggables),
        droppables: $bb62c756e34fa51f$var$toDroppableMap(droppables)
    };
    $bb62c756e34fa51f$var$finish();
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $bb62c756e34fa51f$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== "virtual") return false;
    return true;
}
var $bb62c756e34fa51f$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $bb62c756e34fa51f$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $bb62c756e34fa51f$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $bb62c756e34fa51f$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $bb62c756e34fa51f$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $bb62c756e34fa51f$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === "ADDITION") {
            if ($bb62c756e34fa51f$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === "REMOVAL") {
            if ($bb62c756e34fa51f$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $bb62c756e34fa51f$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $bb62c756e34fa51f$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $bb62c756e34fa51f$var$canStartDrag = function(state, id) {
    if (state.phase === "IDLE") return true;
    if (state.phase !== "DROP_ANIMATING") return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === "DROP";
};
var $bb62c756e34fa51f$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $bb62c756e34fa51f$var$getScrollableDroppables = (0, $6BHCT.default)(function(droppables) {
    return $bb62c756e34fa51f$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $bb62c756e34fa51f$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $bb62c756e34fa51f$var$find($bb62c756e34fa51f$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $bb62c756e34fa51f$var$invariant(false);
        return $bb62c756e34fa51f$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $bb62c756e34fa51f$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $bb62c756e34fa51f$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $bb62c756e34fa51f$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $bb62c756e34fa51f$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $bb62c756e34fa51f$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $bb62c756e34fa51f$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $bb62c756e34fa51f$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $bb62c756e34fa51f$var$minScroll = 1;
var $bb62c756e34fa51f$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $bb62c756e34fa51f$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $bb62c756e34fa51f$var$minScroll;
    var percentageFromMaxScrollValueAt = $bb62c756e34fa51f$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $bb62c756e34fa51f$var$config.maxPixelScroll * $bb62c756e34fa51f$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $bb62c756e34fa51f$var$accelerateAt = $bb62c756e34fa51f$var$config.durationDampening.accelerateAt;
var $bb62c756e34fa51f$var$stopAt = $bb62c756e34fa51f$var$config.durationDampening.stopDampeningAt;
var $bb62c756e34fa51f$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $bb62c756e34fa51f$var$stopAt;
    var now = Date.now();
    var runTime = now - startOfRange;
    if (runTime >= $bb62c756e34fa51f$var$stopAt) return proposedScroll;
    if (runTime < $bb62c756e34fa51f$var$accelerateAt) return $bb62c756e34fa51f$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $bb62c756e34fa51f$var$getPercentage({
        startOfRange: $bb62c756e34fa51f$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $bb62c756e34fa51f$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $bb62c756e34fa51f$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $bb62c756e34fa51f$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($bb62c756e34fa51f$var$dampenValueByTime(scroll, dragStartTime), $bb62c756e34fa51f$var$minScroll);
};
var $bb62c756e34fa51f$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $bb62c756e34fa51f$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $bb62c756e34fa51f$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $bb62c756e34fa51f$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $bb62c756e34fa51f$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $bb62c756e34fa51f$var$clean$2 = $bb62c756e34fa51f$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $bb62c756e34fa51f$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $bb62c756e34fa51f$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $bb62c756e34fa51f$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $bb62c756e34fa51f$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $bb62c756e34fa51f$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $bb62c756e34fa51f$var$clean$2({
        x: x,
        y: y
    });
    if ($bb62c756e34fa51f$var$isEqual(required, $bb62c756e34fa51f$var$origin)) return null;
    var limited = $bb62c756e34fa51f$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $bb62c756e34fa51f$var$isEqual(limited, $bb62c756e34fa51f$var$origin) ? null : limited;
};
var $bb62c756e34fa51f$var$smallestSigned = $bb62c756e34fa51f$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $bb62c756e34fa51f$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $bb62c756e34fa51f$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($bb62c756e34fa51f$var$isEqual(overlap, $bb62c756e34fa51f$var$origin)) return null;
        return overlap;
    };
}();
var $bb62c756e34fa51f$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $bb62c756e34fa51f$var$smallestSigned(change);
    var overlap = $bb62c756e34fa51f$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $bb62c756e34fa51f$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $bb62c756e34fa51f$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $bb62c756e34fa51f$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$bb62c756e34fa51f$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $bb62c756e34fa51f$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $bb62c756e34fa51f$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $bb62c756e34fa51f$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $bb62c756e34fa51f$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$bb62c756e34fa51f$var$canScrollDroppable(droppable, change)) return null;
    return $bb62c756e34fa51f$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $bb62c756e34fa51f$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $bb62c756e34fa51f$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $bb62c756e34fa51f$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $bb62c756e34fa51f$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $bb62c756e34fa51f$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $bb62c756e34fa51f$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $bb62c756e34fa51f$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $bb62c756e34fa51f$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $bb62c756e34fa51f$var$getBestScrollableDroppable({
        center: center,
        destination: $bb62c756e34fa51f$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $bb62c756e34fa51f$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $bb62c756e34fa51f$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $b4uBG.default)(scrollWindow);
    var scheduleDroppableScroll = (0, $b4uBG.default)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $bb62c756e34fa51f$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $bb62c756e34fa51f$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $bb62c756e34fa51f$var$start();
        !!dragging && $bb62c756e34fa51f$var$invariant(false);
        var dragStartTime = Date.now();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $bb62c756e34fa51f$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $bb62c756e34fa51f$var$finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $bb62c756e34fa51f$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $bb62c756e34fa51f$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$bb62c756e34fa51f$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $bb62c756e34fa51f$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $bb62c756e34fa51f$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $bb62c756e34fa51f$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$bb62c756e34fa51f$var$canScrollWindow(viewport, change)) return change;
        var overlap = $bb62c756e34fa51f$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $bb62c756e34fa51f$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $bb62c756e34fa51f$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $bb62c756e34fa51f$var$whatIsDraggedOver(state.impact);
        !destination && $bb62c756e34fa51f$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $bb62c756e34fa51f$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $bb62c756e34fa51f$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $bb62c756e34fa51f$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== "DRAGGING") return;
        if (state.movementMode === "FLUID") {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $bb62c756e34fa51f$var$prefix$1 = "data-rbd";
var $bb62c756e34fa51f$var$dragHandle = function() {
    var base = $bb62c756e34fa51f$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $bb62c756e34fa51f$var$draggable = function() {
    var base = $bb62c756e34fa51f$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $bb62c756e34fa51f$var$droppable = function() {
    var base = $bb62c756e34fa51f$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $bb62c756e34fa51f$var$scrollContainer = {
    contextId: $bb62c756e34fa51f$var$prefix$1 + "-scroll-container-context-id"
};
var $bb62c756e34fa51f$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + '="' + context + '"]';
    };
};
var $bb62c756e34fa51f$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return "";
        return rule.selector + " { " + value + " }";
    }).join(" ");
};
var $bb62c756e34fa51f$var$noPointerEvents = "pointer-events: none;";
var $bb62c756e34fa51f$var$getStyles$1 = function(contextId) {
    var getSelector = $bb62c756e34fa51f$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($bb62c756e34fa51f$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $bb62c756e34fa51f$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $bb62c756e34fa51f$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($bb62c756e34fa51f$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($bb62c756e34fa51f$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: "body",
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $bb62c756e34fa51f$var$getStyles(rules, "always"),
        resting: $bb62c756e34fa51f$var$getStyles(rules, "resting"),
        dragging: $bb62c756e34fa51f$var$getStyles(rules, "dragging"),
        dropAnimating: $bb62c756e34fa51f$var$getStyles(rules, "dropAnimating"),
        userCancel: $bb62c756e34fa51f$var$getStyles(rules, "userCancel")
    };
};
var $bb62c756e34fa51f$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $arQ7u.useLayoutEffect) : (0, $arQ7u.useEffect);
var $bb62c756e34fa51f$var$getHead = function getHead() {
    var head = document.querySelector("head");
    !head && $bb62c756e34fa51f$var$invariant(false);
    return head;
};
var $bb62c756e34fa51f$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.type = "text/css";
    return el;
};
function $bb62c756e34fa51f$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $b1OmR.useMemo)(function() {
        return $bb62c756e34fa51f$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $arQ7u.useRef)(null);
    var dynamicRef = (0, $arQ7u.useRef)(null);
    var setDynamicStyle = (0, $b1OmR.useCallback)((0, $6BHCT.default)(function(proposed) {
        var el = dynamicRef.current;
        !el && $bb62c756e34fa51f$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $b1OmR.useCallback)(function(proposed) {
        var el = alwaysRef.current;
        !el && $bb62c756e34fa51f$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $bb62c756e34fa51f$var$invariant(false);
        var always = $bb62c756e34fa51f$var$createStyleEl(nonce);
        var dynamic = $bb62c756e34fa51f$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($bb62c756e34fa51f$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($bb62c756e34fa51f$var$prefix$1 + "-dynamic", contextId);
        $bb62c756e34fa51f$var$getHead().appendChild(always);
        $bb62c756e34fa51f$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $bb62c756e34fa51f$var$invariant(false);
                $bb62c756e34fa51f$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $b1OmR.useCallback)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $b1OmR.useCallback)(function(reason) {
        if (reason === "DROP") {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $b1OmR.useCallback)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $b1OmR.useMemo)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $bb62c756e34fa51f$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $bb62c756e34fa51f$var$isHtmlElement(el) {
    return el instanceof $bb62c756e34fa51f$var$getWindowFromEl(el).HTMLElement;
}
function $bb62c756e34fa51f$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $bb62c756e34fa51f$var$dragHandle.contextId + '="' + contextId + '"]';
    var possible = $bb62c756e34fa51f$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $bb62c756e34fa51f$var$find(possible, function(el) {
        return el.getAttribute($bb62c756e34fa51f$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$bb62c756e34fa51f$var$isHtmlElement(handle)) return null;
    return handle;
}
function $bb62c756e34fa51f$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $arQ7u.useRef)({});
    var recordRef = (0, $arQ7u.useRef)(null);
    var restoreFocusFrameRef = (0, $arQ7u.useRef)(null);
    var isMountedRef = (0, $arQ7u.useRef)(false);
    var register = (0, $b1OmR.useCallback)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $b1OmR.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $bb62c756e34fa51f$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $b1OmR.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $b1OmR.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $b1OmR.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($bb62c756e34fa51f$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $b1OmR.useMemo)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $bb62c756e34fa51f$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $bb62c756e34fa51f$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: "ADDITION",
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: "REMOVAL",
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $bb62c756e34fa51f$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $bb62c756e34fa51f$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $bb62c756e34fa51f$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $bb62c756e34fa51f$var$useRegistry() {
    var registry = (0, $b1OmR.useMemo)($bb62c756e34fa51f$var$createRegistry, []);
    (0, $arQ7u.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $bb62c756e34fa51f$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createContext(null);
var $bb62c756e34fa51f$var$getBodyElement = function() {
    var body = document.body;
    !body && $bb62c756e34fa51f$var$invariant(false);
    return body;
};
var $bb62c756e34fa51f$var$visuallyHidden = {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    border: "0",
    padding: "0",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    "clip-path": "inset(100%)"
};
var $bb62c756e34fa51f$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $bb62c756e34fa51f$var$useAnnouncer(contextId) {
    var id = (0, $b1OmR.useMemo)(function() {
        return $bb62c756e34fa51f$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $arQ7u.useRef)(null);
    (0, $arQ7u.useEffect)(function setup() {
        var el = document.createElement("div");
        ref.current = el;
        el.id = id;
        el.setAttribute("aria-live", "assertive");
        el.setAttribute("aria-atomic", "true");
        (0, $abElG.default)(el.style, $bb62c756e34fa51f$var$visuallyHidden);
        $bb62c756e34fa51f$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                var body = $bb62c756e34fa51f$var$getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $b1OmR.useCallback)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $bb62c756e34fa51f$var$count = 0;
var $bb62c756e34fa51f$var$defaults = {
    separator: "::"
};
function $bb62c756e34fa51f$var$reset() {
    $bb62c756e34fa51f$var$count = 0;
}
function $bb62c756e34fa51f$var$useUniqueId(prefix, options) {
    if (options === void 0) options = $bb62c756e34fa51f$var$defaults;
    return (0, $b1OmR.useMemo)(function() {
        return "" + prefix + options.separator + $bb62c756e34fa51f$var$count++;
    }, [
        options.separator,
        prefix
    ]);
}
function $bb62c756e34fa51f$var$getElementId(_ref) {
    var contextId = _ref.contextId, uniqueId = _ref.uniqueId;
    return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function $bb62c756e34fa51f$var$useHiddenTextElement(_ref2) {
    var contextId = _ref2.contextId, text = _ref2.text;
    var uniqueId = $bb62c756e34fa51f$var$useUniqueId("hidden-text", {
        separator: "-"
    });
    var id = (0, $b1OmR.useMemo)(function() {
        return $bb62c756e34fa51f$var$getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        });
    }, [
        uniqueId,
        contextId
    ]);
    (0, $arQ7u.useEffect)(function mount() {
        var el = document.createElement("div");
        el.id = id;
        el.textContent = text;
        el.style.display = "none";
        $bb62c756e34fa51f$var$getBodyElement().appendChild(el);
        return function unmount() {
            var body = $bb62c756e34fa51f$var$getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var $bb62c756e34fa51f$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createContext(null);
var $bb62c756e34fa51f$var$peerDependencies = {
    react: "^16.8.5 || ^17.0.0 || ^18.0.0",
    "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};
var $bb62c756e34fa51f$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $bb62c756e34fa51f$var$getVersion = function getVersion(value) {
    var result = $bb62c756e34fa51f$var$semver.exec(value);
    !(result != null) && $bb62c756e34fa51f$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $bb62c756e34fa51f$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $bb62c756e34fa51f$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $bb62c756e34fa51f$var$getVersion(peerDepValue);
    var actual = $bb62c756e34fa51f$var$getVersion(actualValue);
    if ($bb62c756e34fa51f$var$isSatisfied(peerDep, actual)) return;
};
var $bb62c756e34fa51f$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $bb62c756e34fa51f$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $bb62c756e34fa51f$var$useDev(useHook) {}
function $bb62c756e34fa51f$var$useDevSetupWarning(fn, inputs) {
    $bb62c756e34fa51f$var$useDev(function() {
        (0, $arQ7u.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $bb62c756e34fa51f$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $bb62c756e34fa51f$var$useStartupValidation() {
    $bb62c756e34fa51f$var$useDevSetupWarning(function() {
        $bb62c756e34fa51f$var$checkReactVersion($bb62c756e34fa51f$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).version);
        $bb62c756e34fa51f$var$checkDoctype(document);
    }, []);
}
function $bb62c756e34fa51f$var$usePrevious(current) {
    var ref = (0, $arQ7u.useRef)(current);
    (0, $arQ7u.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $bb62c756e34fa51f$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $bb62c756e34fa51f$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $bb62c756e34fa51f$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $bb62c756e34fa51f$var$tab = 9;
var $bb62c756e34fa51f$var$enter = 13;
var $bb62c756e34fa51f$var$escape = 27;
var $bb62c756e34fa51f$var$space = 32;
var $bb62c756e34fa51f$var$pageUp = 33;
var $bb62c756e34fa51f$var$pageDown = 34;
var $bb62c756e34fa51f$var$end = 35;
var $bb62c756e34fa51f$var$home = 36;
var $bb62c756e34fa51f$var$arrowLeft = 37;
var $bb62c756e34fa51f$var$arrowUp = 38;
var $bb62c756e34fa51f$var$arrowRight = 39;
var $bb62c756e34fa51f$var$arrowDown = 40;
var $bb62c756e34fa51f$var$_preventedKeys;
var $bb62c756e34fa51f$var$preventedKeys = ($bb62c756e34fa51f$var$_preventedKeys = {}, $bb62c756e34fa51f$var$_preventedKeys[$bb62c756e34fa51f$var$enter] = true, $bb62c756e34fa51f$var$_preventedKeys[$bb62c756e34fa51f$var$tab] = true, $bb62c756e34fa51f$var$_preventedKeys);
var $bb62c756e34fa51f$var$preventStandardKeyEvents = function(event) {
    if ($bb62c756e34fa51f$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $bb62c756e34fa51f$var$supportedEventName = function() {
    var base = "visibilitychange";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $bb62c756e34fa51f$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $bb62c756e34fa51f$var$primaryButton = 0;
var $bb62c756e34fa51f$var$sloppyClickThreshold = 5;
function $bb62c756e34fa51f$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $bb62c756e34fa51f$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $bb62c756e34fa51f$var$sloppyClickThreshold;
}
var $bb62c756e34fa51f$var$idle$1 = {
    type: "IDLE"
};
function $bb62c756e34fa51f$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: "mousemove",
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $bb62c756e34fa51f$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === "DRAGGING") {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === "PENDING") && $bb62c756e34fa51f$var$invariant(false);
                var pending = phase.point;
                if (!$bb62c756e34fa51f$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: "DRAGGING",
                    actions: actions
                });
            }
        },
        {
            eventName: "mouseup",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "mousedown",
            fn: function fn(event) {
                if (getPhase().type === "DRAGGING") event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === "PENDING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $bb62c756e34fa51f$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $bb62c756e34fa51f$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "scroll",
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === "PENDING") cancel();
            }
        },
        {
            eventName: "webkitmouseforcedown",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && $bb62c756e34fa51f$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $bb62c756e34fa51f$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $bb62c756e34fa51f$export$2f59cd992b42195a(api) {
    var phaseRef = (0, $arQ7u.useRef)($bb62c756e34fa51f$var$idle$1);
    var unbindEventsRef = (0, $arQ7u.useRef)($bb62c756e34fa51f$var$noop);
    var startCaptureBinding = (0, $b1OmR.useMemo)(function() {
        return {
            eventName: "mousedown",
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $bb62c756e34fa51f$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $b1OmR.useMemo)(function() {
        return {
            eventName: "webkitmouseforcewillbegin",
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $b1OmR.useCallback)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $bb62c756e34fa51f$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $b1OmR.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        phaseRef.current = $bb62c756e34fa51f$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $b1OmR.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $b1OmR.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $bb62c756e34fa51f$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $bb62c756e34fa51f$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $b1OmR.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === "IDLE") && $bb62c756e34fa51f$var$invariant(false);
        phaseRef.current = {
            type: "PENDING",
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $bb62c756e34fa51f$var$_scrollJumpKeys;
function $bb62c756e34fa51f$var$noop$1() {}
var $bb62c756e34fa51f$var$scrollJumpKeys = ($bb62c756e34fa51f$var$_scrollJumpKeys = {}, $bb62c756e34fa51f$var$_scrollJumpKeys[$bb62c756e34fa51f$var$pageDown] = true, $bb62c756e34fa51f$var$_scrollJumpKeys[$bb62c756e34fa51f$var$pageUp] = true, $bb62c756e34fa51f$var$_scrollJumpKeys[$bb62c756e34fa51f$var$home] = true, $bb62c756e34fa51f$var$_scrollJumpKeys[$bb62c756e34fa51f$var$end] = true, $bb62c756e34fa51f$var$_scrollJumpKeys);
function $bb62c756e34fa51f$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (event.keyCode === $bb62c756e34fa51f$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $bb62c756e34fa51f$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $bb62c756e34fa51f$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $bb62c756e34fa51f$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $bb62c756e34fa51f$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $bb62c756e34fa51f$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($bb62c756e34fa51f$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $bb62c756e34fa51f$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "mousedown",
            fn: cancel
        },
        {
            eventName: "mouseup",
            fn: cancel
        },
        {
            eventName: "click",
            fn: cancel
        },
        {
            eventName: "touchstart",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "wheel",
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $bb62c756e34fa51f$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $bb62c756e34fa51f$export$42b74264faad0714(api) {
    var unbindEventsRef = (0, $arQ7u.useRef)($bb62c756e34fa51f$var$noop$1);
    var startCaptureBinding = (0, $b1OmR.useMemo)(function() {
        return {
            eventName: "keydown",
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $bb62c756e34fa51f$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $bb62c756e34fa51f$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $bb62c756e34fa51f$var$bindEvents(window, $bb62c756e34fa51f$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $b1OmR.useCallback)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $bb62c756e34fa51f$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $bb62c756e34fa51f$var$idle$2 = {
    type: "IDLE"
};
var $bb62c756e34fa51f$var$timeForLongPress = 120;
var $bb62c756e34fa51f$var$forcePressThreshold = 0.15;
function $bb62c756e34fa51f$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: "orientationchange",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "contextmenu",
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $bb62c756e34fa51f$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $bb62c756e34fa51f$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $bb62c756e34fa51f$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: "touchmove",
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: "touchend",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "touchcancel",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "touchforcechange",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && $bb62c756e34fa51f$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $bb62c756e34fa51f$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === "PENDING") {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $bb62c756e34fa51f$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $bb62c756e34fa51f$export$ac235fd3a7bcf7b4(api) {
    var phaseRef = (0, $arQ7u.useRef)($bb62c756e34fa51f$var$idle$2);
    var unbindEventsRef = (0, $arQ7u.useRef)($bb62c756e34fa51f$var$noop);
    var getPhase = (0, $b1OmR.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $b1OmR.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $b1OmR.useMemo)(function() {
        return {
            eventName: "touchstart",
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $b1OmR.useCallback)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $bb62c756e34fa51f$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $b1OmR.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        if (current.type === "PENDING") clearTimeout(current.longPressTimerId);
        setPhase($bb62c756e34fa51f$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $b1OmR.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $b1OmR.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $bb62c756e34fa51f$var$bindEvents(window, $bb62c756e34fa51f$var$getHandleBindings(args), options);
        var unbindWindow = $bb62c756e34fa51f$var$bindEvents(window, $bb62c756e34fa51f$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $b1OmR.useCallback)(function startDragging() {
        var phase = getPhase();
        !(phase.type === "PENDING") && $bb62c756e34fa51f$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: "DRAGGING",
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $b1OmR.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === "IDLE") && $bb62c756e34fa51f$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $bb62c756e34fa51f$var$timeForLongPress);
        setPhase({
            type: "PENDING",
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === "PENDING") {
                clearTimeout(phase.longPressTimerId);
                setPhase($bb62c756e34fa51f$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $bb62c756e34fa51f$var$bindEvents(window, [
            {
                eventName: "touchmove",
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $bb62c756e34fa51f$var$useValidateSensorHooks(sensorHooks) {
    $bb62c756e34fa51f$var$useDev(function() {
        var previousRef = $bb62c756e34fa51f$var$usePrevious(sensorHooks);
        $bb62c756e34fa51f$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $bb62c756e34fa51f$var$invariant(false);
        });
    });
}
var $bb62c756e34fa51f$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $bb62c756e34fa51f$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($bb62c756e34fa51f$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute("contenteditable");
    if (attribute === "true" || attribute === "") return true;
    if (current === parent) return false;
    return $bb62c756e34fa51f$var$isAnInteractiveElement(parent, current.parentElement);
}
function $bb62c756e34fa51f$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$bb62c756e34fa51f$var$isHtmlElement(target)) return false;
    return $bb62c756e34fa51f$var$isAnInteractiveElement(draggable, target);
}
var $bb62c756e34fa51f$var$getBorderBoxCenterPosition = function(el) {
    return (0, $2MAtZ.getRect)(el.getBoundingClientRect()).center;
};
function $bb62c756e34fa51f$var$isElement(el) {
    return el instanceof $bb62c756e34fa51f$var$getWindowFromEl(el).Element;
}
var $bb62c756e34fa51f$var$supportedMatchesName = function() {
    var base = "matches";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "msMatchesSelector",
        "webkitMatchesSelector"
    ];
    var value = $bb62c756e34fa51f$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $bb62c756e34fa51f$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$bb62c756e34fa51f$var$supportedMatchesName](selector)) return el;
    return $bb62c756e34fa51f$var$closestPonyfill(el.parentElement, selector);
}
function $bb62c756e34fa51f$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $bb62c756e34fa51f$var$closestPonyfill(el, selector);
}
function $bb62c756e34fa51f$var$getSelector(contextId) {
    return "[" + $bb62c756e34fa51f$var$dragHandle.contextId + '="' + contextId + '"]';
}
function $bb62c756e34fa51f$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$bb62c756e34fa51f$var$isElement(target)) return null;
    var selector = $bb62c756e34fa51f$var$getSelector(contextId);
    var handle = $bb62c756e34fa51f$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$bb62c756e34fa51f$var$isHtmlElement(handle)) return null;
    return handle;
}
function $bb62c756e34fa51f$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $bb62c756e34fa51f$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($bb62c756e34fa51f$var$dragHandle.draggableId);
}
function $bb62c756e34fa51f$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $bb62c756e34fa51f$var$draggable.contextId + '="' + contextId + '"]';
    var possible = $bb62c756e34fa51f$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $bb62c756e34fa51f$var$find(possible, function(el) {
        return el.getAttribute($bb62c756e34fa51f$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$bb62c756e34fa51f$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $bb62c756e34fa51f$var$preventDefault(event) {
    event.preventDefault();
}
function $bb62c756e34fa51f$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $bb62c756e34fa51f$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$bb62c756e34fa51f$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $bb62c756e34fa51f$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $bb62c756e34fa51f$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $bb62c756e34fa51f$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $bb62c756e34fa51f$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $bb62c756e34fa51f$var$noop);
    var phase = "PRE_DRAG";
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($bb62c756e34fa51f$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(null, "DRAGGING");
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = "COMPLETED";
        }
        if (phase !== "PRE_DRAG") {
            completed();
            !(phase === "PRE_DRAG") && $bb62c756e34fa51f$var$invariant(false);
        }
        store.dispatch($bb62c756e34fa51f$var$lift(args.liftActionArgs));
        phase = "DRAGGING";
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $bb62c756e34fa51f$var$bindEvents(window, [
                    {
                        eventName: "click",
                        fn: $bb62c756e34fa51f$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($bb62c756e34fa51f$var$drop({
                reason: reason
            }));
        }
        return (0, $abElG.default)({
            isActive: function isActive() {
                return $bb62c756e34fa51f$var$_isActive({
                    expected: "DRAGGING",
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish("DROP", options);
            },
            cancel: function cancel(options) {
                return finish("CANCEL", options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $b4uBG.default)(function(client) {
            tryDispatchWhenDragging(function() {
                return $bb62c756e34fa51f$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: "FLUID"
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $abElG.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($bb62c756e34fa51f$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($bb62c756e34fa51f$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($bb62c756e34fa51f$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($bb62c756e34fa51f$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $bb62c756e34fa51f$var$getBorderBoxCenterPosition(el),
                movementMode: "SNAP"
            },
            cleanup: $bb62c756e34fa51f$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $bb62c756e34fa51f$var$_isActive({
            expected: "PRE_DRAG",
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $bb62c756e34fa51f$var$_isActive({
                expected: "PRE_DRAG",
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $bb62c756e34fa51f$var$defaultSensors = [
    $bb62c756e34fa51f$export$2f59cd992b42195a,
    $bb62c756e34fa51f$export$42b74264faad0714,
    $bb62c756e34fa51f$export$ac235fd3a7bcf7b4
];
function $bb62c756e34fa51f$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $bb62c756e34fa51f$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $arQ7u.useState)(function() {
        return $bb62c756e34fa51f$var$create();
    })[0];
    var tryAbandonLock = (0, $b1OmR.useCallback)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $b1OmR.useCallback)(function(draggableId) {
        return $bb62c756e34fa51f$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $b1OmR.useCallback)(function(draggableId, forceStop, options) {
        return $bb62c756e34fa51f$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $b1OmR.useCallback)(function(event) {
        return $bb62c756e34fa51f$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $b1OmR.useCallback)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $b1OmR.useCallback)(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== "IDLE") store.dispatch($bb62c756e34fa51f$var$flush());
    }, [
        lockAPI,
        store
    ]);
    var isLockClaimed = (0, $b1OmR.useCallback)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $b1OmR.useMemo)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $bb62c756e34fa51f$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $bb62c756e34fa51f$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $bb62c756e34fa51f$var$getStore(lazyRef) {
    !lazyRef.current && $bb62c756e34fa51f$var$invariant(false);
    return lazyRef.current;
}
function $bb62c756e34fa51f$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, dragHandleUsageInstructions = props.dragHandleUsageInstructions;
    var lazyStoreRef = (0, $arQ7u.useRef)(null);
    $bb62c756e34fa51f$var$useStartupValidation();
    var lastPropsRef = $bb62c756e34fa51f$var$usePrevious(props);
    var getResponders = (0, $b1OmR.useCallback)(function() {
        return $bb62c756e34fa51f$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $bb62c756e34fa51f$var$useAnnouncer(contextId);
    var dragHandleUsageInstructionsId = $bb62c756e34fa51f$var$useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    var styleMarshal = $bb62c756e34fa51f$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $b1OmR.useCallback)(function(action) {
        $bb62c756e34fa51f$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $b1OmR.useMemo)(function() {
        return (0, $k19ic.bindActionCreators)({
            publishWhileDragging: $bb62c756e34fa51f$var$publishWhileDragging,
            updateDroppableScroll: $bb62c756e34fa51f$var$updateDroppableScroll,
            updateDroppableIsEnabled: $bb62c756e34fa51f$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $bb62c756e34fa51f$var$updateDroppableIsCombineEnabled,
            collectionStarting: $bb62c756e34fa51f$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $bb62c756e34fa51f$var$useRegistry();
    var dimensionMarshal = (0, $b1OmR.useMemo)(function() {
        return $bb62c756e34fa51f$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $b1OmR.useMemo)(function() {
        return $bb62c756e34fa51f$var$createAutoScroller((0, $abElG.default)({
            scrollWindow: $bb62c756e34fa51f$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $k19ic.bindActionCreators)({
            move: $bb62c756e34fa51f$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $bb62c756e34fa51f$var$useFocusMarshal(contextId);
    var store = (0, $b1OmR.useMemo)(function() {
        return $bb62c756e34fa51f$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $b1OmR.useCallback)(function() {
        var current = $bb62c756e34fa51f$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== "IDLE") current.dispatch($bb62c756e34fa51f$var$flush());
    }, []);
    var isDragging = (0, $b1OmR.useCallback)(function() {
        var state = $bb62c756e34fa51f$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === "DROP_ANIMATING";
    }, []);
    var appCallbacks = (0, $b1OmR.useMemo)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $b1OmR.useCallback)(function(id) {
        return $bb62c756e34fa51f$var$canStartDrag($bb62c756e34fa51f$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $b1OmR.useCallback)(function() {
        return $bb62c756e34fa51f$var$isMovementAllowed($bb62c756e34fa51f$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $b1OmR.useMemo)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    $bb62c756e34fa51f$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $arQ7u.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($bb62c756e34fa51f$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iEjUn.default), {
        context: $bb62c756e34fa51f$var$StoreContext,
        store: store
    }, props.children));
}
var $bb62c756e34fa51f$var$count$1 = 0;
function $bb62c756e34fa51f$var$reset$1() {
    $bb62c756e34fa51f$var$count$1 = 0;
}
function $bb62c756e34fa51f$var$useInstanceCount() {
    return (0, $b1OmR.useMemo)(function() {
        return "" + $bb62c756e34fa51f$var$count$1++;
    }, []);
}
function $bb62c756e34fa51f$export$2bfe52350fc0150d() {
    $bb62c756e34fa51f$var$reset$1();
    $bb62c756e34fa51f$var$reset();
}
function $bb62c756e34fa51f$export$237bd83162c14364(props) {
    var contextId = $bb62c756e34fa51f$var$useInstanceCount();
    var dragHandleUsageInstructions = props.dragHandleUsageInstructions || $bb62c756e34fa51f$var$preset.dragHandleUsageInstructions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($bb62c756e34fa51f$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($bb62c756e34fa51f$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $bb62c756e34fa51f$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $bb62c756e34fa51f$var$isScroll = $bb62c756e34fa51f$var$isEqual$1("scroll");
var $bb62c756e34fa51f$var$isAuto = $bb62c756e34fa51f$var$isEqual$1("auto");
var $bb62c756e34fa51f$var$isVisible$1 = $bb62c756e34fa51f$var$isEqual$1("visible");
var $bb62c756e34fa51f$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $bb62c756e34fa51f$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $bb62c756e34fa51f$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $bb62c756e34fa51f$var$isEither(overflow, $bb62c756e34fa51f$var$isScroll) || $bb62c756e34fa51f$var$isEither(overflow, $bb62c756e34fa51f$var$isAuto);
};
var $bb62c756e34fa51f$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $bb62c756e34fa51f$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $bb62c756e34fa51f$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$bb62c756e34fa51f$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $bb62c756e34fa51f$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $bb62c756e34fa51f$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $bb62c756e34fa51f$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $bb62c756e34fa51f$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === "fixed") return true;
    return getIsFixed(el.parentElement);
};
var $bb62c756e34fa51f$var$getEnv = function(start) {
    var closestScrollable = $bb62c756e34fa51f$var$getClosestScrollable(start);
    var isFixedOnPage = $bb62c756e34fa51f$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $bb62c756e34fa51f$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $bb62c756e34fa51f$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $bb62c756e34fa51f$var$origin,
                    displacement: $bb62c756e34fa51f$var$origin
                }
            }
        };
    }();
    var axis = direction === "vertical" ? $bb62c756e34fa51f$var$vertical : $bb62c756e34fa51f$var$horizontal;
    var subject = $bb62c756e34fa51f$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $bb62c756e34fa51f$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $2MAtZ.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $2MAtZ.expand)(paddingBox, base.border);
    var client = (0, $2MAtZ.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $bb62c756e34fa51f$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $bb62c756e34fa51f$var$getClient(ref, closestScrollable);
    var page = (0, $2MAtZ.withScroll)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $2MAtZ.getBox)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $2MAtZ.withScroll)(frameClient, windowScroll),
            scroll: $bb62c756e34fa51f$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $bb62c756e34fa51f$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $bb62c756e34fa51f$var$immediate = {
    passive: false
};
var $bb62c756e34fa51f$var$delayed = {
    passive: true
};
var $bb62c756e34fa51f$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $bb62c756e34fa51f$var$immediate : $bb62c756e34fa51f$var$delayed;
};
function $bb62c756e34fa51f$var$useRequiredContext(Context) {
    var result = (0, $arQ7u.useContext)(Context);
    !result && $bb62c756e34fa51f$var$invariant(false);
    return result;
}
var $bb62c756e34fa51f$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $bb62c756e34fa51f$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $arQ7u.useRef)(null);
    var appContext = $bb62c756e34fa51f$var$useRequiredContext($bb62c756e34fa51f$var$AppContext);
    var uniqueId = $bb62c756e34fa51f$var$useUniqueId("droppable");
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $bb62c756e34fa51f$var$usePrevious(args);
    var descriptor = (0, $b1OmR.useMemo)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $arQ7u.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $b1OmR.useMemo)(function() {
        return (0, $6BHCT.default)(function(x, y) {
            !whileDraggingRef.current && $bb62c756e34fa51f$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $b1OmR.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $bb62c756e34fa51f$var$origin;
        return $bb62c756e34fa51f$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $b1OmR.useCallback)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $b1OmR.useMemo)(function() {
        return (0, $b4uBG.default)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $b1OmR.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $bb62c756e34fa51f$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $bb62c756e34fa51f$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $b1OmR.useCallback)(function(windowScroll, options) {
        !!whileDraggingRef.current && $bb62c756e34fa51f$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $bb62c756e34fa51f$var$invariant(false);
        var env = $bb62c756e34fa51f$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $bb62c756e34fa51f$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($bb62c756e34fa51f$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener("scroll", onClosestScroll, $bb62c756e34fa51f$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $b1OmR.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $bb62c756e34fa51f$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $bb62c756e34fa51f$var$invariant(false);
        return $bb62c756e34fa51f$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $b1OmR.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $bb62c756e34fa51f$var$invariant(false);
        var closest = $bb62c756e34fa51f$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($bb62c756e34fa51f$var$scrollContainer.contextId);
        closest.removeEventListener("scroll", onClosestScroll, $bb62c756e34fa51f$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $b1OmR.useCallback)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $bb62c756e34fa51f$var$invariant(false);
        var closest = $bb62c756e34fa51f$var$getClosestScrollableFromDrag(dragging);
        !closest && $bb62c756e34fa51f$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $b1OmR.useMemo)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $b1OmR.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $bb62c756e34fa51f$var$noop$2() {}
var $bb62c756e34fa51f$var$empty = {
    width: 0,
    height: 0,
    margin: $bb62c756e34fa51f$var$noSpacing
};
var $bb62c756e34fa51f$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $bb62c756e34fa51f$var$empty;
    if (animate === "close") return $bb62c756e34fa51f$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $bb62c756e34fa51f$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $bb62c756e34fa51f$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: "border-box",
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: "0",
        flexGrow: "0",
        pointerEvents: "none",
        transition: animate !== "none" ? $bb62c756e34fa51f$var$transitions.placeholder : null
    };
};
function $bb62c756e34fa51f$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $arQ7u.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $b1OmR.useCallback)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $arQ7u.useState)(props.animate === "open"), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $arQ7u.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $bb62c756e34fa51f$var$noop$2;
        if (animate !== "open") {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $bb62c756e34fa51f$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $bb62c756e34fa51f$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $b1OmR.useCallback)(function(event) {
        if (event.propertyName !== "height") return;
        onTransitionEnd();
        if (animate === "close") onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $bb62c756e34fa51f$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(props.placeholder.tagName, {
        style: style,
        "data-rbd-placeholder-context-id": contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $bb62c756e34fa51f$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).memo($bb62c756e34fa51f$var$Placeholder);
var $bb62c756e34fa51f$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createContext(null);
function $bb62c756e34fa51f$var$checkIsValidInnerRef(el) {
    !(el && $bb62c756e34fa51f$var$isHtmlElement(el)) && $bb62c756e34fa51f$var$invariant(false);
}
function $bb62c756e34fa51f$var$isBoolean(value) {
    return typeof value === "boolean";
}
function $bb62c756e34fa51f$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $bb62c756e34fa51f$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $bb62c756e34fa51f$var$invariant(false);
        !(typeof props.droppableId === "string") && $bb62c756e34fa51f$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$bb62c756e34fa51f$var$isBoolean(props.isDropDisabled) && $bb62c756e34fa51f$var$invariant(false);
        !$bb62c756e34fa51f$var$isBoolean(props.isCombineEnabled) && $bb62c756e34fa51f$var$invariant(false);
        !$bb62c756e34fa51f$var$isBoolean(props.ignoreContainerClipping) && $bb62c756e34fa51f$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $bb62c756e34fa51f$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $bb62c756e34fa51f$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $bb62c756e34fa51f$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $bb62c756e34fa51f$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $bb62c756e34fa51f$var$invariant(false);
    }
];
function $bb62c756e34fa51f$var$useValidation(args) {
    $bb62c756e34fa51f$var$useDevSetupWarning(function() {
        $bb62c756e34fa51f$var$runChecks(args, $bb62c756e34fa51f$var$shared);
        if (args.props.mode === "standard") $bb62c756e34fa51f$var$runChecks(args, $bb62c756e34fa51f$var$standard);
        if (args.props.mode === "virtual") $bb62c756e34fa51f$var$runChecks(args, $bb62c756e34fa51f$var$virtual);
    });
}
var $bb62c756e34fa51f$var$AnimateInOut = function(_React$PureComponent) {
    (0, $arruZ.default)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? "open" : "none"
        };
        _this.onClose = function() {
            if (_this.state.animate !== "close") return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: "none"
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: "open"
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: "close"
        };
        return {
            isVisible: false,
            animate: "close",
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).PureComponent);
var $bb62c756e34fa51f$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $bb62c756e34fa51f$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $bb62c756e34fa51f$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $bb62c756e34fa51f$var$transitions.snap;
    return $bb62c756e34fa51f$var$transitions.fluid;
};
var $bb62c756e34fa51f$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $bb62c756e34fa51f$var$combine.opacity.drop : $bb62c756e34fa51f$var$combine.opacity.combining;
};
var $bb62c756e34fa51f$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === "SNAP";
};
function $bb62c756e34fa51f$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $bb62c756e34fa51f$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $bb62c756e34fa51f$var$transforms.drop(offset, isCombining) : $bb62c756e34fa51f$var$transforms.moveTo(offset);
    var style = {
        position: "fixed",
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: "border-box",
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $bb62c756e34fa51f$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $bb62c756e34fa51f$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $bb62c756e34fa51f$var$zIndexOptions.dropAnimating : $bb62c756e34fa51f$var$zIndexOptions.dragging,
        pointerEvents: "none"
    };
    return style;
}
function $bb62c756e34fa51f$var$getSecondaryStyle(secondary) {
    return {
        transform: $bb62c756e34fa51f$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : "none"
    };
}
function $bb62c756e34fa51f$var$getStyle$1(mapped) {
    return mapped.type === "DRAGGING" ? $bb62c756e34fa51f$var$getDraggingStyle(mapped) : $bb62c756e34fa51f$var$getSecondaryStyle(mapped);
}
function $bb62c756e34fa51f$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $bb62c756e34fa51f$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $2MAtZ.calculateBox)(borderBox, computedStyles);
    var page = (0, $2MAtZ.withScroll)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $bb62c756e34fa51f$var$useDraggablePublisher(args) {
    var uniqueId = $bb62c756e34fa51f$var$useUniqueId("draggable");
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $b1OmR.useMemo)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $b1OmR.useCallback)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $bb62c756e34fa51f$var$invariant(false);
        return $bb62c756e34fa51f$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $b1OmR.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $arQ7u.useRef)(entry);
    var isFirstPublishRef = (0, $arQ7u.useRef)(true);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $bb62c756e34fa51f$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $bb62c756e34fa51f$var$useValidation$1(props, contextId, getRef) {
    $bb62c756e34fa51f$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $bb62c756e34fa51f$var$invariant(false);
        !(typeof id === "string") && $bb62c756e34fa51f$var$invariant(false);
        !$bb62c756e34fa51f$var$isInteger(props.index) && $bb62c756e34fa51f$var$invariant(false);
        if (props.mapped.type === "DRAGGING") return;
        $bb62c756e34fa51f$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$bb62c756e34fa51f$var$findDragHandle(contextId, id) && $bb62c756e34fa51f$var$invariant(false);
    });
}
function $bb62c756e34fa51f$var$useClonePropValidation(isClone) {
    $bb62c756e34fa51f$var$useDev(function() {
        var initialRef = (0, $arQ7u.useRef)(isClone);
        $bb62c756e34fa51f$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $bb62c756e34fa51f$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $bb62c756e34fa51f$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $bb62c756e34fa51f$var$Draggable(props) {
    var ref = (0, $arQ7u.useRef)(null);
    var setRef = (0, $b1OmR.useCallback)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $b1OmR.useCallback)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $bb62c756e34fa51f$var$useRequiredContext($bb62c756e34fa51f$var$AppContext), contextId = _useRequiredContext.contextId, dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $bb62c756e34fa51f$var$useRequiredContext($bb62c756e34fa51f$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $b1OmR.useMemo)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $bb62c756e34fa51f$var$useValidation$1(props, contextId, getRef);
    $bb62c756e34fa51f$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $b1OmR.useMemo)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $bb62c756e34fa51f$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $b1OmR.useMemo)(function() {
        return isEnabled ? {
            tabIndex: 0,
            role: "button",
            "aria-describedby": dragHandleUsageInstructionsId,
            "data-rbd-drag-handle-draggable-id": draggableId,
            "data-rbd-drag-handle-context-id": contextId,
            draggable: false,
            onDragStart: $bb62c756e34fa51f$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    var onMoveEnd = (0, $b1OmR.useCallback)(function(event) {
        if (mapped.type !== "DRAGGING") return;
        if (!mapped.dropping) return;
        if (event.propertyName !== "transform") return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $b1OmR.useMemo)(function() {
        var style = $bb62c756e34fa51f$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === "DRAGGING" && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                "data-rbd-draggable-context-id": contextId,
                "data-rbd-draggable-id": draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $b1OmR.useMemo)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $bb62c756e34fa51f$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $bb62c756e34fa51f$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $bb62c756e34fa51f$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $bb62c756e34fa51f$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === "COMBINE" ? impact.at.combine.draggableId : null;
};
function $bb62c756e34fa51f$var$getDraggableSelector() {
    var memoizedOffset = (0, $6BHCT.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $6BHCT.default)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $6BHCT.default)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: "DRAGGING",
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $bb62c756e34fa51f$var$whatIsDraggedOver(state.impact);
            var combineWith = $bb62c756e34fa51f$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $bb62c756e34fa51f$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $bb62c756e34fa51f$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $bb62c756e34fa51f$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $bb62c756e34fa51f$var$combine.opacity.drop : null,
                scale: _combineWith ? $bb62c756e34fa51f$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: "DRAGGING",
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $bb62c756e34fa51f$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $bb62c756e34fa51f$var$atRest = {
    mapped: {
        type: "SECONDARY",
        offset: $bb62c756e34fa51f$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $bb62c756e34fa51f$var$getSecondarySnapshot(null)
    }
};
function $bb62c756e34fa51f$var$getSecondarySelector() {
    var memoizedOffset = (0, $6BHCT.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $6BHCT.default)($bb62c756e34fa51f$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $6BHCT.default)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: "SECONDARY",
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($bb62c756e34fa51f$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $bb62c756e34fa51f$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $bb62c756e34fa51f$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $bb62c756e34fa51f$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $bb62c756e34fa51f$var$getDraggableSelector();
    var secondarySelector = $bb62c756e34fa51f$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $bb62c756e34fa51f$var$atRest;
    };
    return selector;
};
var $bb62c756e34fa51f$var$mapDispatchToProps = {
    dropAnimationFinished: $bb62c756e34fa51f$var$dropAnimationFinished
};
var $bb62c756e34fa51f$var$ConnectedDraggable = (0, $fbonu.default)($bb62c756e34fa51f$var$makeMapStateToProps, $bb62c756e34fa51f$var$mapDispatchToProps, null, {
    context: $bb62c756e34fa51f$var$StoreContext,
    pure: true,
    areStatePropsEqual: $bb62c756e34fa51f$var$isStrictEqual
})($bb62c756e34fa51f$var$Draggable);
function $bb62c756e34fa51f$var$PrivateDraggable(props) {
    var droppableContext = $bb62c756e34fa51f$var$useRequiredContext($bb62c756e34fa51f$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($bb62c756e34fa51f$var$ConnectedDraggable, props);
}
function $bb62c756e34fa51f$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === "boolean" ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($bb62c756e34fa51f$var$PrivateDraggable, (0, $abElG.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $bb62c756e34fa51f$var$Droppable(props) {
    var appContext = (0, $arQ7u.useContext)($bb62c756e34fa51f$var$AppContext);
    !appContext && $bb62c756e34fa51f$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $arQ7u.useRef)(null);
    var placeholderRef = (0, $arQ7u.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $b1OmR.useCallback)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $b1OmR.useCallback)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $b1OmR.useCallback)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $b1OmR.useCallback)(function(value) {
        placeholderRef.current = value;
    }, []);
    $bb62c756e34fa51f$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $b1OmR.useCallback)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $bb62c756e34fa51f$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $bb62c756e34fa51f$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($bb62c756e34fa51f$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($bb62c756e34fa51f$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $b1OmR.useMemo)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                "data-rbd-droppable-id": droppableId,
                "data-rbd-droppable-context-id": contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $b1OmR.useMemo)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($bb62c756e34fa51f$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($9sDDw))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($bb62c756e34fa51f$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $bb62c756e34fa51f$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $bb62c756e34fa51f$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $bb62c756e34fa51f$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $abElG.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $6BHCT.default)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $6BHCT.default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$bb62c756e34fa51f$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $bb62c756e34fa51f$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $bb62c756e34fa51f$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (!$bb62c756e34fa51f$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $bb62c756e34fa51f$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $bb62c756e34fa51f$var$whatIsDraggedOverFromResult(completed.result) === id, $bb62c756e34fa51f$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === "IDLE" && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$bb62c756e34fa51f$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $bb62c756e34fa51f$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === "COMBINE");
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $bb62c756e34fa51f$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $bb62c756e34fa51f$var$updateViewportMaxScroll
};
function $bb62c756e34fa51f$var$getBody() {
    !document.body && $bb62c756e34fa51f$var$invariant(false);
    return document.body;
}
var $bb62c756e34fa51f$var$defaultProps = {
    mode: "standard",
    type: "DEFAULT",
    direction: "vertical",
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $bb62c756e34fa51f$var$getBody
};
var $bb62c756e34fa51f$export$423ec2075359570a = (0, $fbonu.default)($bb62c756e34fa51f$var$makeMapStateToProps$1, $bb62c756e34fa51f$var$mapDispatchToProps$1, null, {
    context: $bb62c756e34fa51f$var$StoreContext,
    pure: true,
    areStatePropsEqual: $bb62c756e34fa51f$var$isStrictEqual
})($bb62c756e34fa51f$var$Droppable);
$bb62c756e34fa51f$export$423ec2075359570a.defaultProps = $bb62c756e34fa51f$var$defaultProps;

});
parcelRegister("b1OmR", function(module, exports) {

$parcel$export(module.exports, "useMemo", function () { return $8076dbaef1a0c8af$export$1538c33de8887b59; });
$parcel$export(module.exports, "useCallback", function () { return $8076dbaef1a0c8af$export$35808ee640e87ca7; });

var $arQ7u = parcelRequire("arQ7u");
function $8076dbaef1a0c8af$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $8076dbaef1a0c8af$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $arQ7u.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $arQ7u.useRef)(true);
    var committed = (0, $arQ7u.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $8076dbaef1a0c8af$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $arQ7u.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $8076dbaef1a0c8af$export$33752cf3ee811995(callback, inputs) {
    return $8076dbaef1a0c8af$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $8076dbaef1a0c8af$export$1538c33de8887b59 = $8076dbaef1a0c8af$export$b6feb8998cd9b342;
var $8076dbaef1a0c8af$export$35808ee640e87ca7 = $8076dbaef1a0c8af$export$33752cf3ee811995;

});

parcelRegister("2MAtZ", function(module, exports) {

$parcel$export(module.exports, "getRect", function () { return $206c5d288cf56ed1$export$4b834cebd9e5cebe; });
$parcel$export(module.exports, "expand", function () { return $206c5d288cf56ed1$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "createBox", function () { return $206c5d288cf56ed1$export$6459fc9e86be362e; });
$parcel$export(module.exports, "offset", function () { return $206c5d288cf56ed1$export$cc800923e997bb8; });
$parcel$export(module.exports, "withScroll", function () { return $206c5d288cf56ed1$export$1d0caec378d7d0ae; });
$parcel$export(module.exports, "calculateBox", function () { return $206c5d288cf56ed1$export$b8dfc5d4e552b8e1; });
$parcel$export(module.exports, "getBox", function () { return $206c5d288cf56ed1$export$34928e660d2a8702; });

var $2QHlK = parcelRequire("2QHlK");
var $206c5d288cf56ed1$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $206c5d288cf56ed1$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $206c5d288cf56ed1$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $206c5d288cf56ed1$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $206c5d288cf56ed1$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $206c5d288cf56ed1$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $206c5d288cf56ed1$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $206c5d288cf56ed1$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $206c5d288cf56ed1$var$noSpacing : _ref2$padding;
    var marginBox = $206c5d288cf56ed1$export$4b834cebd9e5cebe($206c5d288cf56ed1$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $206c5d288cf56ed1$export$4b834cebd9e5cebe($206c5d288cf56ed1$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $206c5d288cf56ed1$export$4b834cebd9e5cebe($206c5d288cf56ed1$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $206c5d288cf56ed1$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $206c5d288cf56ed1$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== "px") return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $2QHlK.default)(false);
    return result;
};
var $206c5d288cf56ed1$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $206c5d288cf56ed1$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $206c5d288cf56ed1$var$shift(borderBox, change);
    return $206c5d288cf56ed1$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $206c5d288cf56ed1$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $206c5d288cf56ed1$var$getWindowScroll();
    return $206c5d288cf56ed1$export$cc800923e997bb8(original, scroll);
};
var $206c5d288cf56ed1$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $206c5d288cf56ed1$var$parse(styles.marginTop),
        right: $206c5d288cf56ed1$var$parse(styles.marginRight),
        bottom: $206c5d288cf56ed1$var$parse(styles.marginBottom),
        left: $206c5d288cf56ed1$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $206c5d288cf56ed1$var$parse(styles.paddingTop),
        right: $206c5d288cf56ed1$var$parse(styles.paddingRight),
        bottom: $206c5d288cf56ed1$var$parse(styles.paddingBottom),
        left: $206c5d288cf56ed1$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $206c5d288cf56ed1$var$parse(styles.borderTopWidth),
        right: $206c5d288cf56ed1$var$parse(styles.borderRightWidth),
        bottom: $206c5d288cf56ed1$var$parse(styles.borderBottomWidth),
        left: $206c5d288cf56ed1$var$parse(styles.borderLeftWidth)
    };
    return $206c5d288cf56ed1$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $206c5d288cf56ed1$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $206c5d288cf56ed1$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});
parcelRegister("2QHlK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2132107a16e41c72$export$2e2bcd8739ae039; });
var $2132107a16e41c72$var$isProduction = true;
var $2132107a16e41c72$var$prefix = "Invariant failed";
function $2132107a16e41c72$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($2132107a16e41c72$var$isProduction) throw new Error($2132107a16e41c72$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($2132107a16e41c72$var$prefix, ": ").concat(provided) : $2132107a16e41c72$var$prefix;
    throw new Error(value);
}

});


parcelRegister("b4uBG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80f7cf4b8257ae15$export$2e2bcd8739ae039; });
var $80f7cf4b8257ae15$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $80f7cf4b8257ae15$export$2e2bcd8739ae039 = $80f7cf4b8257ae15$var$rafSchd;

});






parcelRegister("oozTF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04954eae35490f22$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $70nsX = parcelRequire("70nsX");
/**
 * mapStateToProps - to hook up connect
 */ var $04954eae35490f22$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, windowId = _ref.windowId;
    return {};
};
/**
 *
 * @param theme
 * @returns {label: {paddingLeft: number}}}
 */ var $04954eae35490f22$var$styles = function styles(theme) {
    return {};
};
var $04954eae35490f22$var$enhance = (0, $k19ic.compose)((0, $eC0Mc.withTranslation)(), (0, $7EzGR.default)($04954eae35490f22$var$styles), (0, $fbonu.default)($04954eae35490f22$var$mapStateToProps), (0, $7XHRd.withPlugins)("CustomPanel"));
var $04954eae35490f22$export$2e2bcd8739ae039 = $04954eae35490f22$var$enhance((0, $70nsX.CustomPanel));

});
parcelRegister("70nsX", function(module, exports) {

$parcel$export(module.exports, "CustomPanel", function () { return $519abc5a24e12a91$export$327757885c45eb04; });

var $arQ7u = parcelRequire("arQ7u");

var $iXAXt = parcelRequire("iXAXt");
function $519abc5a24e12a91$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $519abc5a24e12a91$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $519abc5a24e12a91$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $519abc5a24e12a91$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $519abc5a24e12a91$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $519abc5a24e12a91$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $519abc5a24e12a91$var$_setPrototypeOf(subClass, superClass);
}
function $519abc5a24e12a91$var$_setPrototypeOf(o, p) {
    $519abc5a24e12a91$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $519abc5a24e12a91$var$_setPrototypeOf(o, p);
}
function $519abc5a24e12a91$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $519abc5a24e12a91$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $519abc5a24e12a91$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $519abc5a24e12a91$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $519abc5a24e12a91$var$_possibleConstructorReturn(this, result);
    };
}
function $519abc5a24e12a91$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $519abc5a24e12a91$var$_assertThisInitialized(self);
}
function $519abc5a24e12a91$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $519abc5a24e12a91$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $519abc5a24e12a91$var$_getPrototypeOf(o) {
    $519abc5a24e12a91$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $519abc5a24e12a91$var$_getPrototypeOf(o);
}
var $519abc5a24e12a91$export$327757885c45eb04 = /*#__PURE__*/ function(_Component) {
    $519abc5a24e12a91$var$_inherits(CustomPanel, _Component);
    var _super = $519abc5a24e12a91$var$_createSuper(CustomPanel);
    function CustomPanel() {
        $519abc5a24e12a91$var$_classCallCheck(this, CustomPanel);
        return _super.apply(this, arguments);
    }
    $519abc5a24e12a91$var$_createClass(CustomPanel, [
        {
            key: "render",
            value: /**
     * render
     */ function render() {
                var _this$props = this.props, id = _this$props.id, children = _this$props.children, t = _this$props.t, title = _this$props.title, windowId = _this$props.windowId;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iXAXt.default), {
                    title: t(title),
                    id: id,
                    windowId: windowId
                }, children);
            }
        }
    ]);
    return CustomPanel;
}((0, $arQ7u.Component));
$519abc5a24e12a91$export$327757885c45eb04.defaultProps = {
    children: null
};

});


parcelRegister("6VRNb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50c1caf5fe3ef010$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eC0Mc = parcelRequire("eC0Mc");

var $7EzGR = parcelRequire("7EzGR");

var $7XHRd = parcelRequire("7XHRd");

var $kUnI3 = parcelRequire("kUnI3");

var $24Kso = parcelRequire("24Kso");
var $dJvB2 = parcelRequire("dJvB2");
var $dy9HC = parcelRequire("dy9HC");
var $7GY88 = parcelRequire("7GY88");

var $76zeB = parcelRequire("76zeB");
/**
 * mapStateToProps - to hook up connect
 */ var $50c1caf5fe3ef010$var$mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id, windowId = _ref.windowId;
    var window = (0, $dy9HC.getWindow)(state, {
        windowId: windowId
    });
    var companionWindow = (0, $24Kso.getCompanionWindow)(state, {
        companionWindowId: id
    });
    var localCollectionPath = companionWindow.collectionPath;
    var collectionPath = localCollectionPath || window.collectionPath;
    var collectionId = collectionPath && collectionPath[collectionPath.length - 1];
    var parentCollectionId = collectionPath && collectionPath[collectionPath.length - 2];
    var collection = collectionId && (0, $dy9HC.getManifest)(state, {
        manifestId: collectionId
    });
    var parentCollection = parentCollectionId && (0, $dy9HC.getManifest)(state, {
        manifestId: parentCollectionId
    });
    var manifest = (0, $dy9HC.getManifest)(state, {
        windowId: windowId
    });
    return {
        canvasNavigation: state.config.canvasNavigation,
        collection: collection && (0, $7GY88.getManifestoInstance)(state, {
            manifestId: collection.id
        }),
        collectionId: collectionId,
        collectionPath: collectionPath,
        error: collection && collection.error,
        isFetching: collection && collection.isFetching,
        manifestId: manifest && manifest.id,
        parentCollection: parentCollection && (0, $7GY88.getManifestoInstance)(state, {
            manifestId: parentCollection.id
        }),
        ready: collection && !!collection.json,
        variant: companionWindow.variant || (0, $dJvB2.getDefaultSidebarVariant)(state, {
            windowId: windowId
        })
    };
};
/**
 * mapStateToProps - used to hook up connect to state
 * @memberof SidebarIndexList
 * @private
 */ var $50c1caf5fe3ef010$var$mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
    var id = _ref2.id, windowId = _ref2.windowId;
    return {
        updateCompanionWindow: function updateCompanionWindow() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return dispatch($kUnI3.updateCompanionWindow.apply($kUnI3, [
                windowId,
                id
            ].concat(args)));
        },
        updateWindow: function updateWindow() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return dispatch($kUnI3.updateWindow.apply($kUnI3, [
                windowId
            ].concat(args)));
        }
    };
};
/**
 * Styles for withStyles HOC
 */ var $50c1caf5fe3ef010$var$styles = function styles(theme) {
    return {
        label: {
            paddingLeft: theme.spacing(1)
        },
        menuItem: {
            borderBottom: "0.5px solid ".concat(theme.palette.divider),
            paddingRight: theme.spacing(1),
            whiteSpace: "normal"
        }
    };
};
var $50c1caf5fe3ef010$var$enhance = (0, $k19ic.compose)((0, $7EzGR.default)($50c1caf5fe3ef010$var$styles), (0, $eC0Mc.withTranslation)(), (0, $fbonu.default)($50c1caf5fe3ef010$var$mapStateToProps, $50c1caf5fe3ef010$var$mapDispatchToProps), (0, $7XHRd.withPlugins)("WindowSideBarCollectionPanel"));
var $50c1caf5fe3ef010$export$2e2bcd8739ae039 = $50c1caf5fe3ef010$var$enhance((0, $76zeB.WindowSideBarCollectionPanel));

});
parcelRegister("76zeB", function(module, exports) {

$parcel$export(module.exports, "WindowSideBarCollectionPanel", function () { return $52c46cc2d3af8b96$export$ab547f17dddcf81c; });

var $arQ7u = parcelRequire("arQ7u");

var $48mel = parcelRequire("48mel");

var $iUlUh = parcelRequire("iUlUh");

var $kUHj7 = parcelRequire("kUHj7");

var $TXAJ5 = parcelRequire("TXAJ5");

var $6lUyS = parcelRequire("6lUyS");

var $2NDUy = parcelRequire("2NDUy");

var $hsH5s = parcelRequire("hsH5s");

var $fNvti = parcelRequire("fNvti");

var $jKRFy = parcelRequire("jKRFy");

var $iXAXt = parcelRequire("iXAXt");

var $YLOIV = parcelRequire("YLOIV");
var $52c46cc2d3af8b96$var$_excluded = [
    "manifest"
];
function $52c46cc2d3af8b96$var$_toConsumableArray(arr) {
    return $52c46cc2d3af8b96$var$_arrayWithoutHoles(arr) || $52c46cc2d3af8b96$var$_iterableToArray(arr) || $52c46cc2d3af8b96$var$_unsupportedIterableToArray(arr) || $52c46cc2d3af8b96$var$_nonIterableSpread();
}
function $52c46cc2d3af8b96$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $52c46cc2d3af8b96$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $52c46cc2d3af8b96$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $52c46cc2d3af8b96$var$_arrayLikeToArray(o, minLen);
}
function $52c46cc2d3af8b96$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $52c46cc2d3af8b96$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $52c46cc2d3af8b96$var$_arrayLikeToArray(arr);
}
function $52c46cc2d3af8b96$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $52c46cc2d3af8b96$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $52c46cc2d3af8b96$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $52c46cc2d3af8b96$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $52c46cc2d3af8b96$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $52c46cc2d3af8b96$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $52c46cc2d3af8b96$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $52c46cc2d3af8b96$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $52c46cc2d3af8b96$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $52c46cc2d3af8b96$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $52c46cc2d3af8b96$var$_setPrototypeOf(subClass, superClass);
}
function $52c46cc2d3af8b96$var$_setPrototypeOf(o, p) {
    $52c46cc2d3af8b96$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $52c46cc2d3af8b96$var$_setPrototypeOf(o, p);
}
function $52c46cc2d3af8b96$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $52c46cc2d3af8b96$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $52c46cc2d3af8b96$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $52c46cc2d3af8b96$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $52c46cc2d3af8b96$var$_possibleConstructorReturn(this, result);
    };
}
function $52c46cc2d3af8b96$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $52c46cc2d3af8b96$var$_assertThisInitialized(self);
}
function $52c46cc2d3af8b96$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $52c46cc2d3af8b96$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $52c46cc2d3af8b96$var$_getPrototypeOf(o) {
    $52c46cc2d3af8b96$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $52c46cc2d3af8b96$var$_getPrototypeOf(o);
}
var $52c46cc2d3af8b96$export$ab547f17dddcf81c = /*#__PURE__*/ function(_Component) {
    $52c46cc2d3af8b96$var$_inherits(WindowSideBarCollectionPanel, _Component);
    var _super = $52c46cc2d3af8b96$var$_createSuper(WindowSideBarCollectionPanel);
    function WindowSideBarCollectionPanel() {
        $52c46cc2d3af8b96$var$_classCallCheck(this, WindowSideBarCollectionPanel);
        return _super.apply(this, arguments);
    }
    $52c46cc2d3af8b96$var$_createClass(WindowSideBarCollectionPanel, [
        {
            key: "isMultipart",
            value: /** */ function isMultipart() {
                var collection = this.props.collection;
                if (!collection) return false;
                var behaviors = collection.getProperty("behavior");
                if (Array.isArray(behaviors)) return collection.includes("multi-part");
                return behaviors === "multi-part";
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, canvasNavigation = _this$props.canvasNavigation, classes = _this$props.classes, collectionPath = _this$props.collectionPath, collection = _this$props.collection, id = _this$props.id, isFetching = _this$props.isFetching, manifestId = _this$props.manifestId, parentCollection = _this$props.parentCollection, updateCompanionWindow = _this$props.updateCompanionWindow, updateWindow = _this$props.updateWindow, t = _this$props.t, variant = _this$props.variant, windowId = _this$props.windowId;
                /** */ var Item = function Item(_ref) {
                    var manifest = _ref.manifest, otherProps = $52c46cc2d3af8b96$var$_objectWithoutProperties(_ref, $52c46cc2d3af8b96$var$_excluded);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $2NDUy.default), Object.assign({
                        className: classes.menuItem,
                        alignItems: "flex-start",
                        button: true,
                        component: "li",
                        selected: manifestId === manifest.id
                    }, otherProps), variant === "thumbnail" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $kUHj7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $YLOIV.default), {
                        resource: manifest,
                        maxHeight: canvasNavigation.height,
                        maxWidth: canvasNavigation.width
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $TXAJ5.default), null, WindowSideBarCollectionPanel.getUseableLabel(manifest)));
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iXAXt.default), {
                    title: t(this.isMultipart() ? "multipartCollection" : "collection"),
                    windowId: windowId,
                    id: id,
                    titleControls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, parentCollection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $48mel.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iUlUh.default), {
                        button: true,
                        onClick: function onClick() {
                            return updateCompanionWindow({
                                collectionPath: collectionPath.slice(0, -1)
                            });
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $kUHj7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jKRFy))), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $TXAJ5.default), {
                        primaryTypographyProps: {
                            variant: "body1"
                        }
                    }, WindowSideBarCollectionPanel.getUseableLabel(parentCollection)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $hsH5s.default), {
                        variant: "h6"
                    }, collection && WindowSideBarCollectionPanel.getUseableLabel(collection), isFetching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $fNvti.default), {
                        className: classes.placeholder,
                        variant: "text"
                    })))
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $6lUyS.default), null, isFetching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $2NDUy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $TXAJ5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $fNvti.default), {
                    className: classes.placeholder,
                    variant: "text"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $fNvti.default), {
                    className: classes.placeholder,
                    variant: "text"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $fNvti.default), {
                    className: classes.placeholder,
                    variant: "text"
                }))), collection && collection.getCollections().map(function(manifest) {
                    /** select the new manifest and go back to the normal index */ var onClick = function onClick() {
                        // close collection
                        updateCompanionWindow({
                            collectionPath: [].concat($52c46cc2d3af8b96$var$_toConsumableArray(collectionPath), [
                                manifest.id
                            ])
                        });
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(Item, {
                        key: manifest.id,
                        onClick: onClick,
                        manifest: manifest
                    });
                }), collection && collection.getManifests().map(function(manifest) {
                    /** select the new manifest and go back to the normal index */ var onClick = function onClick() {
                        // select new manifest
                        updateWindow({
                            canvasId: null,
                            collectionPath: collectionPath,
                            manifestId: manifest.id
                        }); // close collection
                        updateCompanionWindow({
                            multipart: false
                        });
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(Item, {
                        key: manifest.id,
                        onClick: onClick,
                        manifest: manifest
                    });
                })));
            }
        }
    ], [
        {
            key: "getUseableLabel",
            value: /** */ function getUseableLabel(resource, index) {
                return resource && resource.getLabel && resource.getLabel().length > 0 ? resource.getLabel().getValue() : resource.id;
            }
        }
    ]);
    return WindowSideBarCollectionPanel;
}((0, $arQ7u.Component));
$52c46cc2d3af8b96$export$ab547f17dddcf81c.defaultProps = {
    collection: null,
    collectionPath: [],
    error: null,
    isFetching: false,
    parentCollection: null,
    ready: false,
    t: function t(k) {
        return k;
    },
    variant: null
};

});
parcelRegister("kUHj7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f39aa18fc642441f$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $5g55B = parcelRequire("5g55B");

var $7EzGR = parcelRequire("7EzGR");

var $eouD9 = parcelRequire("eouD9");
var $f39aa18fc642441f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            minWidth: 56,
            color: theme.palette.action.active,
            flexShrink: 0,
            display: "inline-flex"
        },
        /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */ alignItemsFlexStart: {
            marginTop: 8
        }
    };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ var $f39aa18fc642441f$var$ListItemIcon = /*#__PURE__*/ $arQ7u.forwardRef(function ListItemIcon(props, ref) {
    var classes = props.classes, className = props.className, other = (0, $dXEVX.default)(props, [
        "classes",
        "className"
    ]);
    var context = $arQ7u.useContext((0, $eouD9.default));
    return /*#__PURE__*/ $arQ7u.createElement("div", (0, $abElG.default)({
        className: (0, $5g55B.default)(classes.root, className, context.alignItems === "flex-start" && classes.alignItemsFlexStart),
        ref: ref
    }, other));
});
var $f39aa18fc642441f$export$2e2bcd8739ae039 = (0, $7EzGR.default)($f39aa18fc642441f$export$9dd6ff9ea0189349, {
    name: "MuiListItemIcon"
})($f39aa18fc642441f$var$ListItemIcon);

});

parcelRegister("jKRFy", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e61bf1c64dae23f7$var$React = $363GR((parcelRequire("arQ7u")));

var $e61bf1c64dae23f7$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $e61bf1c64dae23f7$var$_default = (0, $e61bf1c64dae23f7$var$_createSvgIcon.default)(/*#__PURE__*/ $e61bf1c64dae23f7$var$React.createElement("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), "ArrowUpwardSharp");
module.exports.default = $e61bf1c64dae23f7$var$_default;

});




parcelRegister("3nbWv", function(module, exports) {

$parcel$export(module.exports, "DndContext", function () { return $274cc89e3d1c88e9$export$2d5c5ceac203fc1e; });
$parcel$export(module.exports, "createDndContext", function () { return $274cc89e3d1c88e9$export$109658f7451ecf66; });

var $arQ7u = parcelRequire("arQ7u");

var $mrXYX = parcelRequire("mrXYX");
var $274cc89e3d1c88e9$export$2d5c5ceac203fc1e = $arQ7u.createContext({
    dragDropManager: undefined
});
function $274cc89e3d1c88e9$export$109658f7451ecf66(backend, context, options, debugMode) {
    return {
        dragDropManager: (0, $mrXYX.createDragDropManager)(backend, context, options, debugMode)
    };
}

});
parcelRegister("mrXYX", function(module, exports) {

$parcel$export(module.exports, "createDragDropManager", function () { return $0437bfbe5f6635d8$export$ff47aa43d5fd3e5d; });

var $b8hj3 = parcelRequire("b8hj3");
function $0437bfbe5f6635d8$export$ff47aa43d5fd3e5d(backendFactory, globalContext, backendOptions, debugMode) {
    var manager = new (0, $b8hj3.default)(debugMode);
    var backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}

});
parcelRegister("b8hj3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81adddbadf528d18$export$2e2bcd8739ae039; });

var $k19ic = parcelRequire("k19ic");

var $4u7jD = parcelRequire("4u7jD");

var $iJWSq = parcelRequire("iJWSq");

var $8P4Rs = parcelRequire("8P4Rs");

var $czOOq = parcelRequire("czOOq");
function $81adddbadf528d18$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $81adddbadf528d18$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $81adddbadf528d18$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $81adddbadf528d18$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $81adddbadf528d18$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $81adddbadf528d18$var$makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    var reduxDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;
    return (0, $k19ic.createStore)((0, $4u7jD.default), debugMode && reduxDevTools && reduxDevTools({
        name: "dnd-core",
        instanceId: "dnd-core"
    }));
}
var $81adddbadf528d18$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DragDropManagerImpl() {
        var _this = this;
        var debugMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        $81adddbadf528d18$var$_classCallCheck(this, DragDropManagerImpl);
        this.isSetUp = false;
        this.handleRefCountChange = function() {
            var shouldSetUp = _this.store.getState().refCount > 0;
            if (_this.backend) {
                if (shouldSetUp && !_this.isSetUp) {
                    _this.backend.setup();
                    _this.isSetUp = true;
                } else if (!shouldSetUp && _this.isSetUp) {
                    _this.backend.teardown();
                    _this.isSetUp = false;
                }
            }
        };
        var store = $81adddbadf528d18$var$makeStoreInstance(debugMode);
        this.store = store;
        this.monitor = new (0, $8P4Rs.default)(store, new (0, $czOOq.default)(store));
        store.subscribe(this.handleRefCountChange);
    }
    $81adddbadf528d18$var$_createClass(DragDropManagerImpl, [
        {
            key: "receiveBackend",
            value: function receiveBackend(backend) {
                this.backend = backend;
            }
        },
        {
            key: "getMonitor",
            value: function getMonitor() {
                return this.monitor;
            }
        },
        {
            key: "getBackend",
            value: function getBackend() {
                return this.backend;
            }
        },
        {
            key: "getRegistry",
            value: function getRegistry() {
                return this.monitor.registry;
            }
        },
        {
            key: "getActions",
            value: function getActions() {
                /* eslint-disable-next-line @typescript-eslint/no-this-alias */ var manager = this;
                var dispatch = this.store.dispatch;
                function bindActionCreator(actionCreator) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        var action = actionCreator.apply(manager, args);
                        if (typeof action !== "undefined") dispatch(action);
                    };
                }
                var actions = (0, $iJWSq.default)(this);
                return Object.keys(actions).reduce(function(boundActions, key) {
                    var action = actions[key];
                    boundActions[key] = bindActionCreator(action);
                    return boundActions;
                }, {});
            }
        },
        {
            key: "dispatch",
            value: function dispatch(action) {
                this.store.dispatch(action);
            }
        }
    ]);
    return DragDropManagerImpl;
}();

});
parcelRegister("4u7jD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $343fa384ae00e0a1$export$2e2bcd8739ae039; });

var $6ZeZM = parcelRequire("6ZeZM");

var $kH8c4 = parcelRequire("kH8c4");

var $04fkE = parcelRequire("04fkE");

var $e6XSr = parcelRequire("e6XSr");

var $9G65w = parcelRequire("9G65w");

var $9fBuM = parcelRequire("9fBuM");
function $343fa384ae00e0a1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $343fa384ae00e0a1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $343fa384ae00e0a1$var$ownKeys(Object(source), true).forEach(function(key) {
            $343fa384ae00e0a1$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $343fa384ae00e0a1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $343fa384ae00e0a1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $343fa384ae00e0a1$export$2e2bcd8739ae039() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    return {
        dirtyHandlerIds: (0, $e6XSr.default)(state.dirtyHandlerIds, {
            type: action.type,
            payload: $343fa384ae00e0a1$var$_objectSpread({}, action.payload, {
                prevTargetIds: (0, $9fBuM.get)(state, "dragOperation.targetIds", [])
            })
        }),
        dragOffset: (0, $6ZeZM.default)(state.dragOffset, action),
        refCount: (0, $04fkE.default)(state.refCount, action),
        dragOperation: (0, $kH8c4.default)(state.dragOperation, action),
        stateId: (0, $9G65w.default)(state.stateId)
    };
}

});
parcelRegister("6ZeZM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5164125dd72b08d8$export$2e2bcd8739ae039; });

var $58UNb = parcelRequire("58UNb");

var $54bkE = parcelRequire("54bkE");
function $5164125dd72b08d8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5164125dd72b08d8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5164125dd72b08d8$var$ownKeys(Object(source), true).forEach(function(key) {
            $5164125dd72b08d8$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5164125dd72b08d8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5164125dd72b08d8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5164125dd72b08d8$var$initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $5164125dd72b08d8$export$2e2bcd8739ae039() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $5164125dd72b08d8$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var payload = action.payload;
    switch(action.type){
        case 0, $58UNb.INIT_COORDS:
        case 0, $58UNb.BEGIN_DRAG:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case 0, $58UNb.HOVER:
            if ((0, $54bkE.areCoordsEqual)(state.clientOffset, payload.clientOffset)) return state;
            return $5164125dd72b08d8$var$_objectSpread({}, state, {
                clientOffset: payload.clientOffset
            });
        case 0, $58UNb.END_DRAG:
        case 0, $58UNb.DROP:
            return $5164125dd72b08d8$var$initialState;
        default:
            return state;
    }
}

});
parcelRegister("58UNb", function(module, exports) {

$parcel$export(module.exports, "INIT_COORDS", function () { return $3be9c0e25c72a6c4$export$3fc3a33e48b33945; });
$parcel$export(module.exports, "BEGIN_DRAG", function () { return $3be9c0e25c72a6c4$export$98f9b4193e6b55e6; });
$parcel$export(module.exports, "PUBLISH_DRAG_SOURCE", function () { return $3be9c0e25c72a6c4$export$22d1d88e2de0d0e0; });
$parcel$export(module.exports, "HOVER", function () { return $3be9c0e25c72a6c4$export$9d358706ccac3727; });
$parcel$export(module.exports, "DROP", function () { return $3be9c0e25c72a6c4$export$b4af72c40fd57063; });
$parcel$export(module.exports, "END_DRAG", function () { return $3be9c0e25c72a6c4$export$d300627d16aeb9cc; });
var $3be9c0e25c72a6c4$export$3fc3a33e48b33945 = "dnd-core/INIT_COORDS";
var $3be9c0e25c72a6c4$export$98f9b4193e6b55e6 = "dnd-core/BEGIN_DRAG";
var $3be9c0e25c72a6c4$export$22d1d88e2de0d0e0 = "dnd-core/PUBLISH_DRAG_SOURCE";
var $3be9c0e25c72a6c4$export$9d358706ccac3727 = "dnd-core/HOVER";
var $3be9c0e25c72a6c4$export$b4af72c40fd57063 = "dnd-core/DROP";
var $3be9c0e25c72a6c4$export$d300627d16aeb9cc = "dnd-core/END_DRAG";

});

parcelRegister("54bkE", function(module, exports) {

$parcel$export(module.exports, "areCoordsEqual", function () { return $3b061dce60dd9fae$export$102b20725d4d2263; });
$parcel$export(module.exports, "areArraysEqual", function () { return $3b061dce60dd9fae$export$94fd53d40f0652a; });
var $3b061dce60dd9fae$export$2116cbe61f6a442a = function strictEquality(a, b) {
    return a === b;
};
function $3b061dce60dd9fae$export$102b20725d4d2263(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function $3b061dce60dd9fae$export$94fd53d40f0652a(a, b) {
    var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $3b061dce60dd9fae$export$2116cbe61f6a442a;
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}

});


parcelRegister("kH8c4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f10e2de1e7576408$export$2e2bcd8739ae039; });

var $58UNb = parcelRequire("58UNb");

var $58sP2 = parcelRequire("58sP2");

var $9fBuM = parcelRequire("9fBuM");
function $f10e2de1e7576408$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f10e2de1e7576408$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f10e2de1e7576408$var$ownKeys(Object(source), true).forEach(function(key) {
            $f10e2de1e7576408$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f10e2de1e7576408$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f10e2de1e7576408$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $f10e2de1e7576408$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $f10e2de1e7576408$export$2e2bcd8739ae039() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $f10e2de1e7576408$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var payload = action.payload;
    switch(action.type){
        case 0, $58UNb.BEGIN_DRAG:
            return $f10e2de1e7576408$var$_objectSpread({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case 0, $58UNb.PUBLISH_DRAG_SOURCE:
            return $f10e2de1e7576408$var$_objectSpread({}, state, {
                isSourcePublic: true
            });
        case 0, $58UNb.HOVER:
            return $f10e2de1e7576408$var$_objectSpread({}, state, {
                targetIds: payload.targetIds
            });
        case 0, $58sP2.REMOVE_TARGET:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return $f10e2de1e7576408$var$_objectSpread({}, state, {
                targetIds: (0, $9fBuM.without)(state.targetIds, payload.targetId)
            });
        case 0, $58UNb.DROP:
            return $f10e2de1e7576408$var$_objectSpread({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case 0, $58UNb.END_DRAG:
            return $f10e2de1e7576408$var$_objectSpread({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}

});
parcelRegister("58sP2", function(module, exports) {

$parcel$export(module.exports, "ADD_SOURCE", function () { return $3bd40e9730f3e41c$export$b36933c81fb1c092; });
$parcel$export(module.exports, "ADD_TARGET", function () { return $3bd40e9730f3e41c$export$2c313542981556ae; });
$parcel$export(module.exports, "REMOVE_SOURCE", function () { return $3bd40e9730f3e41c$export$13332566b98b8783; });
$parcel$export(module.exports, "REMOVE_TARGET", function () { return $3bd40e9730f3e41c$export$82ace346d17d8869; });
$parcel$export(module.exports, "addSource", function () { return $3bd40e9730f3e41c$export$bc333c64f07a75c4; });
$parcel$export(module.exports, "addTarget", function () { return $3bd40e9730f3e41c$export$9dd68fe78f37278b; });
$parcel$export(module.exports, "removeSource", function () { return $3bd40e9730f3e41c$export$c724aacd61334138; });
$parcel$export(module.exports, "removeTarget", function () { return $3bd40e9730f3e41c$export$20ae7ec87f7f8696; });
var $3bd40e9730f3e41c$export$b36933c81fb1c092 = "dnd-core/ADD_SOURCE";
var $3bd40e9730f3e41c$export$2c313542981556ae = "dnd-core/ADD_TARGET";
var $3bd40e9730f3e41c$export$13332566b98b8783 = "dnd-core/REMOVE_SOURCE";
var $3bd40e9730f3e41c$export$82ace346d17d8869 = "dnd-core/REMOVE_TARGET";
function $3bd40e9730f3e41c$export$bc333c64f07a75c4(sourceId) {
    return {
        type: $3bd40e9730f3e41c$export$b36933c81fb1c092,
        payload: {
            sourceId: sourceId
        }
    };
}
function $3bd40e9730f3e41c$export$9dd68fe78f37278b(targetId) {
    return {
        type: $3bd40e9730f3e41c$export$2c313542981556ae,
        payload: {
            targetId: targetId
        }
    };
}
function $3bd40e9730f3e41c$export$c724aacd61334138(sourceId) {
    return {
        type: $3bd40e9730f3e41c$export$13332566b98b8783,
        payload: {
            sourceId: sourceId
        }
    };
}
function $3bd40e9730f3e41c$export$20ae7ec87f7f8696(targetId) {
    return {
        type: $3bd40e9730f3e41c$export$82ace346d17d8869,
        payload: {
            targetId: targetId
        }
    };
}

});

parcelRegister("9fBuM", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $6bc2999741acaa8e$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "without", function () { return $6bc2999741acaa8e$export$5d14bf425b37f49e; });
$parcel$export(module.exports, "isObject", function () { return $6bc2999741acaa8e$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "xor", function () { return $6bc2999741acaa8e$export$6444ef5cd411280c; });
$parcel$export(module.exports, "intersection", function () { return $6bc2999741acaa8e$export$bc86dfbf7795668c; });
function $6bc2999741acaa8e$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6bc2999741acaa8e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6bc2999741acaa8e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6bc2999741acaa8e$var$_typeof(obj);
}
function $6bc2999741acaa8e$export$3988ae62b71be9a3(obj, path, defaultValue) {
    return path.split(".").reduce(function(a, c) {
        return a && a[c] ? a[c] : defaultValue || null;
    }, obj);
}
function $6bc2999741acaa8e$export$5d14bf425b37f49e(items, item) {
    return items.filter(function(i) {
        return i !== item;
    });
}
function $6bc2999741acaa8e$export$844ec244b1367d54(input) {
    return typeof input === "string";
}
function $6bc2999741acaa8e$export$a6cdc56e425d0d0a(input) {
    return $6bc2999741acaa8e$var$_typeof(input) === "object";
}
function $6bc2999741acaa8e$export$6444ef5cd411280c(itemsA, itemsB) {
    var map = new Map();
    var insertItem = function insertItem(item) {
        return map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    var result = [];
    map.forEach(function(count, key) {
        if (count === 1) result.push(key);
    });
    return result;
}
function $6bc2999741acaa8e$export$bc86dfbf7795668c(itemsA, itemsB) {
    return itemsA.filter(function(t) {
        return itemsB.indexOf(t) > -1;
    });
}

});


parcelRegister("04fkE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00cc447bb41c0da3$export$2e2bcd8739ae039; });

var $58sP2 = parcelRequire("58sP2");
function $00cc447bb41c0da3$export$2e2bcd8739ae039() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $58sP2.ADD_SOURCE:
        case 0, $58sP2.ADD_TARGET:
            return state + 1;
        case 0, $58sP2.REMOVE_SOURCE:
        case 0, $58sP2.REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}

});

parcelRegister("e6XSr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a460128f7a8925c7$export$2e2bcd8739ae039; });

var $58UNb = parcelRequire("58UNb");

var $58sP2 = parcelRequire("58sP2");

var $54bkE = parcelRequire("54bkE");

var $l3srr = parcelRequire("l3srr");

var $9fBuM = parcelRequire("9fBuM");
function $a460128f7a8925c7$export$2e2bcd8739ae039() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $l3srr.NONE);
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $58UNb.HOVER:
            break;
        case 0, $58sP2.ADD_SOURCE:
        case 0, $58sP2.ADD_TARGET:
        case 0, $58sP2.REMOVE_TARGET:
        case 0, $58sP2.REMOVE_SOURCE:
            return 0, $l3srr.NONE;
        case 0, $58UNb.BEGIN_DRAG:
        case 0, $58UNb.PUBLISH_DRAG_SOURCE:
        case 0, $58UNb.END_DRAG:
        case 0, $58UNb.DROP:
        default:
            return 0, $l3srr.ALL;
    }
    var _action$payload = action.payload, _action$payload$targe = _action$payload.targetIds, targetIds = _action$payload$targe === void 0 ? [] : _action$payload$targe, _action$payload$prevT = _action$payload.prevTargetIds, prevTargetIds = _action$payload$prevT === void 0 ? [] : _action$payload$prevT;
    var result = (0, $9fBuM.xor)(targetIds, prevTargetIds);
    var didChange = result.length > 0 || !(0, $54bkE.areArraysEqual)(targetIds, prevTargetIds);
    if (!didChange) return 0, $l3srr.NONE;
     // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    var innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}

});
parcelRegister("l3srr", function(module, exports) {

$parcel$export(module.exports, "NONE", function () { return $f53ff0b46cdaa14a$export$c53d0f541b41b88e; });
$parcel$export(module.exports, "ALL", function () { return $f53ff0b46cdaa14a$export$61b49a5ae59d663; });
$parcel$export(module.exports, "areDirty", function () { return $f53ff0b46cdaa14a$export$3347776eeed47180; });

var $9fBuM = parcelRequire("9fBuM");
var $f53ff0b46cdaa14a$export$c53d0f541b41b88e = [];
var $f53ff0b46cdaa14a$export$61b49a5ae59d663 = [];
$f53ff0b46cdaa14a$export$c53d0f541b41b88e.__IS_NONE__ = true;
$f53ff0b46cdaa14a$export$61b49a5ae59d663.__IS_ALL__ = true;
function $f53ff0b46cdaa14a$export$3347776eeed47180(dirtyIds, handlerIds) {
    if (dirtyIds === $f53ff0b46cdaa14a$export$c53d0f541b41b88e) return false;
    if (dirtyIds === $f53ff0b46cdaa14a$export$61b49a5ae59d663 || typeof handlerIds === "undefined") return true;
    var commonIds = (0, $9fBuM.intersection)(handlerIds, dirtyIds);
    return commonIds.length > 0;
}

});


parcelRegister("9G65w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70bcc246ad9d5b7e$export$2e2bcd8739ae039; });
function $70bcc246ad9d5b7e$export$2e2bcd8739ae039() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return state + 1;
}

});


parcelRegister("iJWSq", function(module, exports) {
$parcel$export(module.exports, "BEGIN_DRAG", function () { return (parcelRequire("58UNb")).BEGIN_DRAG; });
$parcel$export(module.exports, "DROP", function () { return (parcelRequire("58UNb")).DROP; });
$parcel$export(module.exports, "END_DRAG", function () { return (parcelRequire("58UNb")).END_DRAG; });
$parcel$export(module.exports, "HOVER", function () { return (parcelRequire("58UNb")).HOVER; });
$parcel$export(module.exports, "INIT_COORDS", function () { return (parcelRequire("58UNb")).INIT_COORDS; });
$parcel$export(module.exports, "PUBLISH_DRAG_SOURCE", function () { return (parcelRequire("58UNb")).PUBLISH_DRAG_SOURCE; });

$parcel$export(module.exports, "default", function () { return $da4a19aa6c5b7b68$export$2e2bcd8739ae039; });

var $gx3xE = parcelRequire("gx3xE");

var $feKq9 = parcelRequire("feKq9");

var $8DmSh = parcelRequire("8DmSh");

var $4xahV = parcelRequire("4xahV");

var $7GvC6 = parcelRequire("7GvC6");
parcelRequire("58UNb");
function $da4a19aa6c5b7b68$export$2e2bcd8739ae039(manager) {
    return {
        beginDrag: (0, $gx3xE.default)(manager),
        publishDragSource: (0, $feKq9.default)(manager),
        hover: (0, $8DmSh.default)(manager),
        drop: (0, $4xahV.default)(manager),
        endDrag: (0, $7GvC6.default)(manager)
    };
}

});
parcelRegister("gx3xE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c09279be1e2ab4e6$export$2e2bcd8739ae039; });

var $jWomj = parcelRequire("jWomj");

var $gu4no = parcelRequire("gu4no");

var $9fBuM = parcelRequire("9fBuM");

var $58UNb = parcelRequire("58UNb");
var $c09279be1e2ab4e6$var$ResetCoordinatesAction = {
    type: (0, $58UNb.INIT_COORDS),
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function $c09279be1e2ab4e6$export$2e2bcd8739ae039(manager) {
    return function beginDrag() {
        var sourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            publishSource: true
        };
        var _options$publishSourc = options.publishSource, publishSource = _options$publishSourc === void 0 ? true : _options$publishSourc, clientOffset = options.clientOffset, getSourceClientOffset = options.getSourceClientOffset;
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry(); // Initialize the coordinates using the client offset
        manager.dispatch((0, $gu4no.setClientOffset)(clientOffset));
        $c09279be1e2ab4e6$var$verifyInvariants(sourceIds, monitor, registry); // Get the draggable source
        var sourceId = $c09279be1e2ab4e6$var$getDraggableSource(sourceIds, monitor);
        if (sourceId === null) {
            manager.dispatch($c09279be1e2ab4e6$var$ResetCoordinatesAction);
            return;
        } // Get the source client offset
        var sourceClientOffset = null;
        if (clientOffset) {
            $c09279be1e2ab4e6$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        } // Initialize the full coordinates
        manager.dispatch((0, $gu4no.setClientOffset)(clientOffset, sourceClientOffset));
        var source = registry.getSource(sourceId);
        var item = source.beginDrag(monitor, sourceId);
        $c09279be1e2ab4e6$var$verifyItemIsObject(item);
        registry.pinSource(sourceId);
        var itemType = registry.getSourceType(sourceId);
        return {
            type: (0, $58UNb.BEGIN_DRAG),
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function $c09279be1e2ab4e6$var$verifyInvariants(sourceIds, monitor, registry) {
    (0, $jWomj.invariant)(!monitor.isDragging(), "Cannot call beginDrag while dragging.");
    sourceIds.forEach(function(sourceId) {
        (0, $jWomj.invariant)(registry.getSource(sourceId), "Expected sourceIds to be registered.");
    });
}
function $c09279be1e2ab4e6$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    (0, $jWomj.invariant)(typeof getSourceClientOffset === "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function $c09279be1e2ab4e6$var$verifyItemIsObject(item) {
    (0, $jWomj.invariant)((0, $9fBuM.isObject)(item), "Item must be an object.");
}
function $c09279be1e2ab4e6$var$getDraggableSource(sourceIds, monitor) {
    var sourceId = null;
    for(var i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}

});
parcelRegister("jWomj", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $e846543fe64af49d$export$f5708dca728d7177; });
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ function $e846543fe64af49d$export$f5708dca728d7177(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}

});

parcelRegister("gu4no", function(module, exports) {

$parcel$export(module.exports, "setClientOffset", function () { return $c002d7b61597cdb1$export$844048139dfc906d; });

var $58UNb = parcelRequire("58UNb");
function $c002d7b61597cdb1$export$844048139dfc906d(clientOffset, sourceClientOffset) {
    return {
        type: (0, $58UNb.INIT_COORDS),
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}

});


parcelRegister("feKq9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b17c2c0880442a8d$export$2e2bcd8739ae039; });

var $58UNb = parcelRequire("58UNb");
function $b17c2c0880442a8d$export$2e2bcd8739ae039(manager) {
    return function publishDragSource() {
        var monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: (0, $58UNb.PUBLISH_DRAG_SOURCE)
        };
    };
}

});

parcelRegister("8DmSh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6493b5a3b8903ad0$export$2e2bcd8739ae039; });

var $jWomj = parcelRequire("jWomj");

var $38crt = parcelRequire("38crt");

var $58UNb = parcelRequire("58UNb");
function $6493b5a3b8903ad0$export$2e2bcd8739ae039(manager) {
    return function hover(targetIdsArg) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, clientOffset = _ref.clientOffset;
        $6493b5a3b8903ad0$var$verifyTargetIdsIsArray(targetIdsArg);
        var targetIds = targetIdsArg.slice(0);
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        $6493b5a3b8903ad0$var$checkInvariants(targetIds, monitor, registry);
        var draggedItemType = monitor.getItemType();
        $6493b5a3b8903ad0$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        $6493b5a3b8903ad0$var$hoverAllTargets(targetIds, monitor, registry);
        return {
            type: (0, $58UNb.HOVER),
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function $6493b5a3b8903ad0$var$verifyTargetIdsIsArray(targetIdsArg) {
    (0, $jWomj.invariant)(Array.isArray(targetIdsArg), "Expected targetIds to be an array.");
}
function $6493b5a3b8903ad0$var$checkInvariants(targetIds, monitor, registry) {
    (0, $jWomj.invariant)(monitor.isDragging(), "Cannot call hover while not dragging.");
    (0, $jWomj.invariant)(!monitor.didDrop(), "Cannot call hover after drop.");
    for(var i = 0; i < targetIds.length; i++){
        var targetId = targetIds[i];
        (0, $jWomj.invariant)(targetIds.lastIndexOf(targetId) === i, "Expected targetIds to be unique in the passed array.");
        var target = registry.getTarget(targetId);
        (0, $jWomj.invariant)(target, "Expected targetIds to be registered.");
    }
}
function $6493b5a3b8903ad0$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(var i = targetIds.length - 1; i >= 0; i--){
        var targetId = targetIds[i];
        var targetType = registry.getTargetType(targetId);
        if (!(0, $38crt.default)(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function $6493b5a3b8903ad0$var$hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        var target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}

});
parcelRegister("38crt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $247bc53364b8da5d$export$2e2bcd8739ae039; });
function $247bc53364b8da5d$export$2e2bcd8739ae039(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some(function(t) {
        return t === draggedItemType;
    }) : targetType === draggedItemType;
}

});


parcelRegister("4xahV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d2397a1b78b91d$export$2e2bcd8739ae039; });

var $jWomj = parcelRequire("jWomj");

var $58UNb = parcelRequire("58UNb");

var $9fBuM = parcelRequire("9fBuM");
function $34d2397a1b78b91d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $34d2397a1b78b91d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $34d2397a1b78b91d$var$ownKeys(Object(source), true).forEach(function(key) {
            $34d2397a1b78b91d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $34d2397a1b78b91d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $34d2397a1b78b91d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $34d2397a1b78b91d$export$2e2bcd8739ae039(manager) {
    return function drop() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        $34d2397a1b78b91d$var$verifyInvariants(monitor);
        var targetIds = $34d2397a1b78b91d$var$getDroppableTargets(monitor); // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach(function(targetId, index) {
            var dropResult = $34d2397a1b78b91d$var$determineDropResult(targetId, index, registry, monitor);
            var action = {
                type: (0, $58UNb.DROP),
                payload: {
                    dropResult: $34d2397a1b78b91d$var$_objectSpread({}, options, {}, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function $34d2397a1b78b91d$var$verifyInvariants(monitor) {
    (0, $jWomj.invariant)(monitor.isDragging(), "Cannot call drop while not dragging.");
    (0, $jWomj.invariant)(!monitor.didDrop(), "Cannot call drop twice during one drag operation.");
}
function $34d2397a1b78b91d$var$determineDropResult(targetId, index, registry, monitor) {
    var target = registry.getTarget(targetId);
    var dropResult = target ? target.drop(monitor, targetId) : undefined;
    $34d2397a1b78b91d$var$verifyDropResultType(dropResult);
    if (typeof dropResult === "undefined") dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function $34d2397a1b78b91d$var$verifyDropResultType(dropResult) {
    (0, $jWomj.invariant)(typeof dropResult === "undefined" || (0, $9fBuM.isObject)(dropResult), "Drop result must either be an object or undefined.");
}
function $34d2397a1b78b91d$var$getDroppableTargets(monitor) {
    var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}

});

parcelRegister("7GvC6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5984fa6b85f57636$export$2e2bcd8739ae039; });

var $jWomj = parcelRequire("jWomj");

var $58UNb = parcelRequire("58UNb");
function $5984fa6b85f57636$export$2e2bcd8739ae039(manager) {
    return function endDrag() {
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        $5984fa6b85f57636$var$verifyIsDragging(monitor);
        var sourceId = monitor.getSourceId();
        var source = registry.getSource(sourceId, true);
        source.endDrag(monitor, sourceId);
        registry.unpinSource();
        return {
            type: (0, $58UNb.END_DRAG)
        };
    };
}
function $5984fa6b85f57636$var$verifyIsDragging(monitor) {
    (0, $jWomj.invariant)(monitor.isDragging(), "Cannot call endDrag while not dragging.");
}

});


parcelRegister("8P4Rs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66c6db78a37229c5$export$2e2bcd8739ae039; });

var $jWomj = parcelRequire("jWomj");

var $38crt = parcelRequire("38crt");

var $fXFuC = parcelRequire("fXFuC");

var $l3srr = parcelRequire("l3srr");
function $66c6db78a37229c5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $66c6db78a37229c5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $66c6db78a37229c5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $66c6db78a37229c5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $66c6db78a37229c5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $66c6db78a37229c5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DragDropMonitorImpl(store, registry) {
        $66c6db78a37229c5$var$_classCallCheck(this, DragDropMonitorImpl);
        this.store = store;
        this.registry = registry;
    }
    $66c6db78a37229c5$var$_createClass(DragDropMonitorImpl, [
        {
            key: "subscribeToStateChange",
            value: function subscribeToStateChange(listener) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    handlerIds: undefined
                };
                var handlerIds = options.handlerIds;
                (0, $jWomj.invariant)(typeof listener === "function", "listener must be a function.");
                (0, $jWomj.invariant)(typeof handlerIds === "undefined" || Array.isArray(handlerIds), "handlerIds, when specified, must be an array of strings.");
                var prevStateId = this.store.getState().stateId;
                var handleChange = function handleChange() {
                    var state = _this.store.getState();
                    var currentStateId = state.stateId;
                    try {
                        var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, $l3srr.areDirty)(state.dirtyHandlerIds, handlerIds);
                        if (!canSkipListener) listener();
                    } finally{
                        prevStateId = currentStateId;
                    }
                };
                return this.store.subscribe(handleChange);
            }
        },
        {
            key: "subscribeToOffsetChange",
            value: function subscribeToOffsetChange(listener) {
                var _this2 = this;
                (0, $jWomj.invariant)(typeof listener === "function", "listener must be a function.");
                var previousState = this.store.getState().dragOffset;
                var handleChange = function handleChange() {
                    var nextState = _this2.store.getState().dragOffset;
                    if (nextState === previousState) return;
                    previousState = nextState;
                    listener();
                };
                return this.store.subscribe(handleChange);
            }
        },
        {
            key: "canDragSource",
            value: function canDragSource(sourceId) {
                if (!sourceId) return false;
                var source = this.registry.getSource(sourceId);
                (0, $jWomj.invariant)(source, "Expected to find a valid source.");
                if (this.isDragging()) return false;
                return source.canDrag(this, sourceId);
            }
        },
        {
            key: "canDropOnTarget",
            value: function canDropOnTarget(targetId) {
                // undefined on initial render
                if (!targetId) return false;
                var target = this.registry.getTarget(targetId);
                (0, $jWomj.invariant)(target, "Expected to find a valid target.");
                if (!this.isDragging() || this.didDrop()) return false;
                var targetType = this.registry.getTargetType(targetId);
                var draggedItemType = this.getItemType();
                return (0, $38crt.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
            }
        },
        {
            key: "isDragging",
            value: function isDragging() {
                return Boolean(this.getItemType());
            }
        },
        {
            key: "isDraggingSource",
            value: function isDraggingSource(sourceId) {
                // undefined on initial render
                if (!sourceId) return false;
                var source = this.registry.getSource(sourceId, true);
                (0, $jWomj.invariant)(source, "Expected to find a valid source.");
                if (!this.isDragging() || !this.isSourcePublic()) return false;
                var sourceType = this.registry.getSourceType(sourceId);
                var draggedItemType = this.getItemType();
                if (sourceType !== draggedItemType) return false;
                return source.isDragging(this, sourceId);
            }
        },
        {
            key: "isOverTarget",
            value: function isOverTarget(targetId) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    shallow: false
                };
                // undefined on initial render
                if (!targetId) return false;
                var shallow = options.shallow;
                if (!this.isDragging()) return false;
                var targetType = this.registry.getTargetType(targetId);
                var draggedItemType = this.getItemType();
                if (draggedItemType && !(0, $38crt.default)(targetType, draggedItemType)) return false;
                var targetIds = this.getTargetIds();
                if (!targetIds.length) return false;
                var index = targetIds.indexOf(targetId);
                if (shallow) return index === targetIds.length - 1;
                else return index > -1;
            }
        },
        {
            key: "getItemType",
            value: function getItemType() {
                return this.store.getState().dragOperation.itemType;
            }
        },
        {
            key: "getItem",
            value: function getItem() {
                return this.store.getState().dragOperation.item;
            }
        },
        {
            key: "getSourceId",
            value: function getSourceId() {
                return this.store.getState().dragOperation.sourceId;
            }
        },
        {
            key: "getTargetIds",
            value: function getTargetIds() {
                return this.store.getState().dragOperation.targetIds;
            }
        },
        {
            key: "getDropResult",
            value: function getDropResult() {
                return this.store.getState().dragOperation.dropResult;
            }
        },
        {
            key: "didDrop",
            value: function didDrop() {
                return this.store.getState().dragOperation.didDrop;
            }
        },
        {
            key: "isSourcePublic",
            value: function isSourcePublic() {
                return this.store.getState().dragOperation.isSourcePublic;
            }
        },
        {
            key: "getInitialClientOffset",
            value: function getInitialClientOffset() {
                return this.store.getState().dragOffset.initialClientOffset;
            }
        },
        {
            key: "getInitialSourceClientOffset",
            value: function getInitialSourceClientOffset() {
                return this.store.getState().dragOffset.initialSourceClientOffset;
            }
        },
        {
            key: "getClientOffset",
            value: function getClientOffset() {
                return this.store.getState().dragOffset.clientOffset;
            }
        },
        {
            key: "getSourceClientOffset",
            value: function getSourceClientOffset() {
                return (0, $fXFuC.getSourceClientOffset)(this.store.getState().dragOffset);
            }
        },
        {
            key: "getDifferenceFromInitialOffset",
            value: function getDifferenceFromInitialOffset() {
                return (0, $fXFuC.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
            }
        }
    ]);
    return DragDropMonitorImpl;
}();

});
parcelRegister("fXFuC", function(module, exports) {

$parcel$export(module.exports, "getSourceClientOffset", function () { return $b9ec8d523c30932d$export$b6a5970fca17c71e; });
$parcel$export(module.exports, "getDifferenceFromInitialOffset", function () { return $b9ec8d523c30932d$export$b57ee1a41eb1620b; });
/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $b9ec8d523c30932d$export$e16d8520af44a096(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function $b9ec8d523c30932d$export$4e2d2ead65e5f7e3(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $b9ec8d523c30932d$export$b6a5970fca17c71e(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset, initialSourceClientOffset = state.initialSourceClientOffset;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return $b9ec8d523c30932d$export$4e2d2ead65e5f7e3($b9ec8d523c30932d$export$e16d8520af44a096(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function $b9ec8d523c30932d$export$b57ee1a41eb1620b(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset;
    if (!clientOffset || !initialClientOffset) return null;
    return $b9ec8d523c30932d$export$4e2d2ead65e5f7e3(clientOffset, initialClientOffset);
}

});


parcelRegister("czOOq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92802b31a9e1aaa1$export$2e2bcd8739ae039; });

var $jWomj = parcelRequire("jWomj");

var $58sP2 = parcelRequire("58sP2");

var $8qYAB = parcelRequire("8qYAB");

var $lUHOP = parcelRequire("lUHOP");

var $bJViG = parcelRequire("bJViG");

var $bvBp0 = parcelRequire("bvBp0");
function $92802b31a9e1aaa1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $92802b31a9e1aaa1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $92802b31a9e1aaa1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $92802b31a9e1aaa1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $92802b31a9e1aaa1$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $92802b31a9e1aaa1$var$_slicedToArray(arr, i) {
    return $92802b31a9e1aaa1$var$_arrayWithHoles(arr) || $92802b31a9e1aaa1$var$_iterableToArrayLimit(arr, i) || $92802b31a9e1aaa1$var$_nonIterableRest();
}
function $92802b31a9e1aaa1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $92802b31a9e1aaa1$var$_iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $92802b31a9e1aaa1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $92802b31a9e1aaa1$var$getNextHandlerId(role) {
    var id = (0, $8qYAB.default)().toString();
    switch(role){
        case (0, $lUHOP.HandlerRole).SOURCE:
            return "S".concat(id);
        case (0, $lUHOP.HandlerRole).TARGET:
            return "T".concat(id);
        default:
            throw new Error("Unknown Handler Role: ".concat(role));
    }
}
function $92802b31a9e1aaa1$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case "S":
            return (0, $lUHOP.HandlerRole).SOURCE;
        case "T":
            return (0, $lUHOP.HandlerRole).TARGET;
        default:
            (0, $jWomj.invariant)(false, "Cannot parse handler ID: ".concat(handlerId));
    }
}
function $92802b31a9e1aaa1$var$mapContainsValue(map, searchValue) {
    var entries = map.entries();
    var isDone = false;
    do {
        var _entries$next = entries.next(), done = _entries$next.done, _entries$next$value = $92802b31a9e1aaa1$var$_slicedToArray(_entries$next.value, 2), value = _entries$next$value[1];
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
var $92802b31a9e1aaa1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function HandlerRegistryImpl(store) {
        $92802b31a9e1aaa1$var$_classCallCheck(this, HandlerRegistryImpl);
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
    $92802b31a9e1aaa1$var$_createClass(HandlerRegistryImpl, [
        {
            key: "addSource",
            value: function addSource(type, source) {
                (0, $bJViG.validateType)(type);
                (0, $bJViG.validateSourceContract)(source);
                var sourceId = this.addHandler((0, $lUHOP.HandlerRole).SOURCE, type, source);
                this.store.dispatch((0, $58sP2.addSource)(sourceId));
                return sourceId;
            }
        },
        {
            key: "addTarget",
            value: function addTarget(type, target) {
                (0, $bJViG.validateType)(type, true);
                (0, $bJViG.validateTargetContract)(target);
                var targetId = this.addHandler((0, $lUHOP.HandlerRole).TARGET, type, target);
                this.store.dispatch((0, $58sP2.addTarget)(targetId));
                return targetId;
            }
        },
        {
            key: "containsHandler",
            value: function containsHandler(handler) {
                return $92802b31a9e1aaa1$var$mapContainsValue(this.dragSources, handler) || $92802b31a9e1aaa1$var$mapContainsValue(this.dropTargets, handler);
            }
        },
        {
            key: "getSource",
            value: function getSource(sourceId) {
                var includePinned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                (0, $jWomj.invariant)(this.isSourceId(sourceId), "Expected a valid source ID.");
                var isPinned = includePinned && sourceId === this.pinnedSourceId;
                var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
                return source;
            }
        },
        {
            key: "getTarget",
            value: function getTarget(targetId) {
                (0, $jWomj.invariant)(this.isTargetId(targetId), "Expected a valid target ID.");
                return this.dropTargets.get(targetId);
            }
        },
        {
            key: "getSourceType",
            value: function getSourceType(sourceId) {
                (0, $jWomj.invariant)(this.isSourceId(sourceId), "Expected a valid source ID.");
                return this.types.get(sourceId);
            }
        },
        {
            key: "getTargetType",
            value: function getTargetType(targetId) {
                (0, $jWomj.invariant)(this.isTargetId(targetId), "Expected a valid target ID.");
                return this.types.get(targetId);
            }
        },
        {
            key: "isSourceId",
            value: function isSourceId(handlerId) {
                var role = $92802b31a9e1aaa1$var$parseRoleFromHandlerId(handlerId);
                return role === (0, $lUHOP.HandlerRole).SOURCE;
            }
        },
        {
            key: "isTargetId",
            value: function isTargetId(handlerId) {
                var role = $92802b31a9e1aaa1$var$parseRoleFromHandlerId(handlerId);
                return role === (0, $lUHOP.HandlerRole).TARGET;
            }
        },
        {
            key: "removeSource",
            value: function removeSource(sourceId) {
                var _this = this;
                (0, $jWomj.invariant)(this.getSource(sourceId), "Expected an existing source.");
                this.store.dispatch((0, $58sP2.removeSource)(sourceId));
                (0, $bvBp0.asap)(function() {
                    _this.dragSources.delete(sourceId);
                    _this.types.delete(sourceId);
                });
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(targetId) {
                (0, $jWomj.invariant)(this.getTarget(targetId), "Expected an existing target.");
                this.store.dispatch((0, $58sP2.removeTarget)(targetId));
                this.dropTargets.delete(targetId);
                this.types.delete(targetId);
            }
        },
        {
            key: "pinSource",
            value: function pinSource(sourceId) {
                var source = this.getSource(sourceId);
                (0, $jWomj.invariant)(source, "Expected an existing source.");
                this.pinnedSourceId = sourceId;
                this.pinnedSource = source;
            }
        },
        {
            key: "unpinSource",
            value: function unpinSource() {
                (0, $jWomj.invariant)(this.pinnedSource, "No source is pinned at the time.");
                this.pinnedSourceId = null;
                this.pinnedSource = null;
            }
        },
        {
            key: "addHandler",
            value: function addHandler(role, type, handler) {
                var id = $92802b31a9e1aaa1$var$getNextHandlerId(role);
                this.types.set(id, type);
                if (role === (0, $lUHOP.HandlerRole).SOURCE) this.dragSources.set(id, handler);
                else if (role === (0, $lUHOP.HandlerRole).TARGET) this.dropTargets.set(id, handler);
                return id;
            }
        }
    ]);
    return HandlerRegistryImpl;
}();

});
parcelRegister("8qYAB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $623fc03e715173ea$export$2e2bcd8739ae039; });
var $623fc03e715173ea$var$nextUniqueId = 0;
function $623fc03e715173ea$export$2e2bcd8739ae039() {
    return $623fc03e715173ea$var$nextUniqueId++;
}

});

parcelRegister("lUHOP", function(module, exports) {

$parcel$export(module.exports, "HandlerRole", function () { return $ff40d16fa832801d$export$bb8f0843d7d66cb0; });
var $ff40d16fa832801d$export$bb8f0843d7d66cb0;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})($ff40d16fa832801d$export$bb8f0843d7d66cb0 || ($ff40d16fa832801d$export$bb8f0843d7d66cb0 = {}));

});

parcelRegister("bJViG", function(module, exports) {

$parcel$export(module.exports, "validateSourceContract", function () { return $88c0584efc2b09fe$export$a7a13c013ce18993; });
$parcel$export(module.exports, "validateTargetContract", function () { return $88c0584efc2b09fe$export$77d3cd1340fdeb5a; });
$parcel$export(module.exports, "validateType", function () { return $88c0584efc2b09fe$export$831a593efd22380d; });

var $jWomj = parcelRequire("jWomj");
function $88c0584efc2b09fe$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $88c0584efc2b09fe$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $88c0584efc2b09fe$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $88c0584efc2b09fe$var$_typeof(obj);
}
function $88c0584efc2b09fe$export$a7a13c013ce18993(source) {
    (0, $jWomj.invariant)(typeof source.canDrag === "function", "Expected canDrag to be a function.");
    (0, $jWomj.invariant)(typeof source.beginDrag === "function", "Expected beginDrag to be a function.");
    (0, $jWomj.invariant)(typeof source.endDrag === "function", "Expected endDrag to be a function.");
}
function $88c0584efc2b09fe$export$77d3cd1340fdeb5a(target) {
    (0, $jWomj.invariant)(typeof target.canDrop === "function", "Expected canDrop to be a function.");
    (0, $jWomj.invariant)(typeof target.hover === "function", "Expected hover to be a function.");
    (0, $jWomj.invariant)(typeof target.drop === "function", "Expected beginDrag to be a function.");
}
function $88c0584efc2b09fe$export$831a593efd22380d(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach(function(t) {
            return $88c0584efc2b09fe$export$831a593efd22380d(t, false);
        });
        return;
    }
    (0, $jWomj.invariant)(typeof type === "string" || $88c0584efc2b09fe$var$_typeof(type) === "symbol", allowArray ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}

});

parcelRegister("bvBp0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $860f9a478e8477e7$var$_exportNames = {};

var $860f9a478e8477e7$var$_asapJs = $860f9a478e8477e7$var$_interopRequireWildcard((parcelRequire("8nRDj")));
Object.keys($860f9a478e8477e7$var$_asapJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($860f9a478e8477e7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $860f9a478e8477e7$var$_asapJs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $860f9a478e8477e7$var$_asapJs[key];
        }
    });
});

var $860f9a478e8477e7$var$_typesJs = $860f9a478e8477e7$var$_interopRequireWildcard((parcelRequire("6H5zJ")));
Object.keys($860f9a478e8477e7$var$_typesJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($860f9a478e8477e7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $860f9a478e8477e7$var$_typesJs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $860f9a478e8477e7$var$_typesJs[key];
        }
    });
});

var $860f9a478e8477e7$var$_asapQueueJs = $860f9a478e8477e7$var$_interopRequireWildcard((parcelRequire("iohOc")));
Object.keys($860f9a478e8477e7$var$_asapQueueJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($860f9a478e8477e7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $860f9a478e8477e7$var$_asapQueueJs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $860f9a478e8477e7$var$_asapQueueJs[key];
        }
    });
});

var $860f9a478e8477e7$var$_taskFactoryJs = $860f9a478e8477e7$var$_interopRequireWildcard((parcelRequire("3MJZs")));
Object.keys($860f9a478e8477e7$var$_taskFactoryJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($860f9a478e8477e7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $860f9a478e8477e7$var$_taskFactoryJs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $860f9a478e8477e7$var$_taskFactoryJs[key];
        }
    });
});
function $860f9a478e8477e7$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}

});
parcelRegister("8nRDj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.asap = $61aa132013e39d1d$var$asap;

var $iohOc = parcelRequire("iohOc");

var $3MJZs = parcelRequire("3MJZs");
const $61aa132013e39d1d$var$asapQueue = new $iohOc.AsapQueue();
const $61aa132013e39d1d$var$taskFactory = new $3MJZs.TaskFactory($61aa132013e39d1d$var$asapQueue.registerPendingError);
function $61aa132013e39d1d$var$asap(task) {
    $61aa132013e39d1d$var$asapQueue.enqueueTask($61aa132013e39d1d$var$taskFactory.create(task));
}

});
parcelRegister("iohOc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jx6tc = parcelRequire("jx6tc");
class $d638484f7aae3d61$var$AsapQueue {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q, requestFlush: requestFlush } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = $jx6tc.makeRequestCall(this.flush);
        this.requestErrorThrow = $jx6tc.makeRequestCallFromTimer(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.
// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// // its existence.
// rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
module.exports.AsapQueue = $d638484f7aae3d61$var$AsapQueue;

});
parcelRegister("jx6tc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeRequestCallFromTimer = $e3861e33d9a88160$var$makeRequestCallFromTimer;
module.exports.makeRequestCallFromMutationObserver = $e3861e33d9a88160$var$makeRequestCallFromMutationObserver;
module.exports.makeRequestCall = void 0;
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const $e3861e33d9a88160$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
const $e3861e33d9a88160$var$BrowserMutationObserver = $e3861e33d9a88160$var$scope.MutationObserver || $e3861e33d9a88160$var$scope.WebKitMutationObserver;
function $e3861e33d9a88160$var$makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
function $e3861e33d9a88160$var$makeRequestCallFromMutationObserver(callback) {
    let toggle = 1;
    const observer = new $e3861e33d9a88160$var$BrowserMutationObserver(callback);
    const node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const $e3861e33d9a88160$var$makeRequestCall = typeof $e3861e33d9a88160$var$BrowserMutationObserver === "function" ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
$e3861e33d9a88160$var$makeRequestCallFromMutationObserver : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
$e3861e33d9a88160$var$makeRequestCallFromTimer;
module.exports.makeRequestCall = $e3861e33d9a88160$var$makeRequestCall;

});


parcelRegister("3MJZs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fYdTG = parcelRequire("fYdTG");
class $2c19877e875a9408$var$TaskFactory {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new $fYdTG.RawTask(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}
module.exports.TaskFactory = $2c19877e875a9408$var$TaskFactory;

});
parcelRegister("fYdTG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $ba073d480d7c17e7$var$RawTask {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}
module.exports.RawTask = $ba073d480d7c17e7$var$RawTask;

});



parcelRegister("6H5zJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});






parcelRegister("1lzPe", function(module, exports) {

$parcel$export(module.exports, "DndProvider", function () { return $0fb38ac8e7e3a31b$export$9861489d68213f9c; });

var $arQ7u = parcelRequire("arQ7u");

var $3nbWv = parcelRequire("3nbWv");
function $0fb38ac8e7e3a31b$var$_slicedToArray(arr, i) {
    return $0fb38ac8e7e3a31b$var$_arrayWithHoles(arr) || $0fb38ac8e7e3a31b$var$_iterableToArrayLimit(arr, i) || $0fb38ac8e7e3a31b$var$_nonIterableRest();
}
function $0fb38ac8e7e3a31b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $0fb38ac8e7e3a31b$var$_iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0fb38ac8e7e3a31b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0fb38ac8e7e3a31b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0fb38ac8e7e3a31b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0fb38ac8e7e3a31b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0fb38ac8e7e3a31b$var$refCount = 0;
var $0fb38ac8e7e3a31b$export$9861489d68213f9c = (0, $arQ7u.memo)(function(_ref) {
    var children = _ref.children, props = $0fb38ac8e7e3a31b$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    var _getDndContextValue = $0fb38ac8e7e3a31b$var$getDndContextValue(props), _getDndContextValue2 = $0fb38ac8e7e3a31b$var$_slicedToArray(_getDndContextValue, 2), manager = _getDndContextValue2[0], isGlobalInstance = _getDndContextValue2[1]; // memoized from props
    /**
   * If the global context was used to store the DND context
   * then where theres no more references to it we should
   * clean it up to avoid memory leaks
   */ $arQ7u.useEffect(function() {
        if (isGlobalInstance) $0fb38ac8e7e3a31b$var$refCount++;
        return function() {
            if (isGlobalInstance) {
                $0fb38ac8e7e3a31b$var$refCount--;
                if ($0fb38ac8e7e3a31b$var$refCount === 0) {
                    var context = $0fb38ac8e7e3a31b$var$getGlobalContext();
                    context[$0fb38ac8e7e3a31b$var$instanceSymbol] = null;
                }
            }
        };
    }, []);
    return $arQ7u.createElement((0, $3nbWv.DndContext).Provider, {
        value: manager
    }, children);
});
$0fb38ac8e7e3a31b$export$9861489d68213f9c.displayName = "DndProvider";
function $0fb38ac8e7e3a31b$var$getDndContextValue(props) {
    if ("manager" in props) {
        var _manager = {
            dragDropManager: props.manager
        };
        return [
            _manager,
            false
        ];
    }
    var manager = $0fb38ac8e7e3a31b$var$createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    var isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
var $0fb38ac8e7e3a31b$var$instanceSymbol = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
function $0fb38ac8e7e3a31b$var$createSingletonDndContext(backend) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0fb38ac8e7e3a31b$var$getGlobalContext();
    var options = arguments.length > 2 ? arguments[2] : undefined;
    var debugMode = arguments.length > 3 ? arguments[3] : undefined;
    var ctx = context;
    if (!ctx[$0fb38ac8e7e3a31b$var$instanceSymbol]) ctx[$0fb38ac8e7e3a31b$var$instanceSymbol] = (0, $3nbWv.createDndContext)(backend, context, options, debugMode);
    return ctx[$0fb38ac8e7e3a31b$var$instanceSymbol];
}
function $0fb38ac8e7e3a31b$var$getGlobalContext() {
    return typeof $parcel$global !== "undefined" ? $parcel$global : window;
}

});

parcelRegister("iCfXF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9I5De")).default; });
$parcel$export(module.exports, "HTML5DragTransition", function () { return (parcelRequire("aCRhC")).HTML5DragTransition; });
$parcel$export(module.exports, "TouchTransition", function () { return (parcelRequire("aCRhC")).TouchTransition; });
$parcel$export(module.exports, "MouseTransition", function () { return (parcelRequire("aCRhC")).MouseTransition; });
$parcel$export(module.exports, "createTransition", function () { return (parcelRequire("lT4tj")).default; });
$parcel$export(module.exports, "Preview", function () { return (parcelRequire("krhw9")).default; });
parcelRequire("9I5De");
var $lT4tj = parcelRequire("lT4tj");
var $9I5De = parcelRequire("9I5De");
var $aCRhC = parcelRequire("aCRhC");

var $krhw9 = parcelRequire("krhw9");

});
parcelRegister("9I5De", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $711c9774936db820$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "HTML5DragTransition", function () { return (parcelRequire("aCRhC")).HTML5DragTransition; });
$parcel$export(module.exports, "TouchTransition", function () { return (parcelRequire("aCRhC")).TouchTransition; });
$parcel$export(module.exports, "MouseTransition", function () { return (parcelRequire("aCRhC")).MouseTransition; });
$parcel$export(module.exports, "createTransition", function () { return (parcelRequire("lT4tj")).default; });
$parcel$export(module.exports, "PreviewManager", function () { return (parcelRequire("EcyC5")).PreviewManager; });

var $aCRhC = parcelRequire("aCRhC");

var $lT4tj = parcelRequire("lT4tj");

var $EcyC5 = parcelRequire("EcyC5");
var $711c9774936db820$export$2e2bcd8739ae039 = function(manager, context, options) {
    return new (0, $EcyC5.default)(manager, context, options);
};

});
parcelRegister("aCRhC", function(module, exports) {

$parcel$export(module.exports, "TouchTransition", function () { return $7bc6c8eae8d4914e$export$91e99a52278bf8a5; });
$parcel$export(module.exports, "HTML5DragTransition", function () { return $7bc6c8eae8d4914e$export$9528ec74b6ffc6f; });
$parcel$export(module.exports, "MouseTransition", function () { return $7bc6c8eae8d4914e$export$6863e369d9a30d41; });

var $lT4tj = parcelRequire("lT4tj");
var $7bc6c8eae8d4914e$export$91e99a52278bf8a5 = (0, $lT4tj.default)("touchstart", function(event) {
    return event.touches != null; // eslint-disable-line no-eq-null, eqeqeq
});
var $7bc6c8eae8d4914e$export$9528ec74b6ffc6f = (0, $lT4tj.default)("dragstart", function(event) {
    if (event.type) return event.type.indexOf("drag") !== -1 || event.type.indexOf("drop") !== -1;
    return false;
});
var $7bc6c8eae8d4914e$export$6863e369d9a30d41 = (0, $lT4tj.default)("mousedown", function(event) {
    if (event.type) return event.type.indexOf("touch") === -1 && event.type.indexOf("mouse") !== -1;
    return false;
});

});
parcelRegister("lT4tj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef2340c48ac9a4d$export$2e2bcd8739ae039; });
var $fef2340c48ac9a4d$export$2e2bcd8739ae039 = function(event, check) {
    return {
        _isMBTransition: true,
        event: event,
        check: check
    };
};

});


parcelRegister("EcyC5", function(module, exports) {

$parcel$export(module.exports, "PreviewManager", function () { return $078d7a27d1dd49ad$export$2ed2aee2f13b45ca; });
$parcel$export(module.exports, "default", function () { return $078d7a27d1dd49ad$export$2e2bcd8739ae039; });

var $f26nT = parcelRequire("f26nT");
function $078d7a27d1dd49ad$var$_toConsumableArray(arr) {
    return $078d7a27d1dd49ad$var$_arrayWithoutHoles(arr) || $078d7a27d1dd49ad$var$_iterableToArray(arr) || $078d7a27d1dd49ad$var$_unsupportedIterableToArray(arr) || $078d7a27d1dd49ad$var$_nonIterableSpread();
}
function $078d7a27d1dd49ad$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $078d7a27d1dd49ad$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $078d7a27d1dd49ad$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $078d7a27d1dd49ad$var$_arrayLikeToArray(arr);
}
function $078d7a27d1dd49ad$var$_createForOfIteratorHelper(o) {
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $078d7a27d1dd49ad$var$_unsupportedIterableToArray(o))) {
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var it, normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $078d7a27d1dd49ad$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $078d7a27d1dd49ad$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $078d7a27d1dd49ad$var$_arrayLikeToArray(o, minLen);
}
function $078d7a27d1dd49ad$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $078d7a27d1dd49ad$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $078d7a27d1dd49ad$var$PreviewList = function PreviewList() {
    var _this = this;
    $078d7a27d1dd49ad$var$_classCallCheck(this, PreviewList);
    this.register = function(preview) {
        _this.previews.push(preview);
    };
    this.unregister = function(preview) {
        var index;
        while((index = _this.previews.indexOf(preview)) !== -1)_this.previews.splice(index, 1);
    };
    this.backendChanged = function(backend) {
        var _iterator = $078d7a27d1dd49ad$var$_createForOfIteratorHelper(_this.previews), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var preview = _step.value;
                preview.backendChanged(backend);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    this.previews = [];
};
var $078d7a27d1dd49ad$export$2ed2aee2f13b45ca = new $078d7a27d1dd49ad$var$PreviewList();
var $078d7a27d1dd49ad$export$2e2bcd8739ae039 = function _default(manager, context, sourceOptions) {
    var _this2 = this;
    $078d7a27d1dd49ad$var$_classCallCheck(this, _default);
    this.setup = function() {
        if (typeof window === "undefined") return;
        if (_this2.constructor.isSetUp) throw new Error("Cannot have two MultiBackends at the same time.");
        _this2.constructor.isSetUp = true;
        _this2.addEventListeners(window);
        _this2.backends[_this2.current].instance.setup();
    };
    this.teardown = function() {
        if (typeof window === "undefined") return;
        _this2.constructor.isSetUp = false;
        _this2.removeEventListeners(window);
        _this2.backends[_this2.current].instance.teardown();
    };
    this.connectDragSource = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _this2.connectBackend("connectDragSource", args);
    };
    this.connectDragPreview = function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return _this2.connectBackend("connectDragPreview", args);
    };
    this.connectDropTarget = function() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return _this2.connectBackend("connectDropTarget", args);
    };
    this.previewEnabled = function() {
        return _this2.backends[_this2.current].preview;
    };
    this.addEventListeners = function(target) {
        _this2.backends.forEach(function(backend) {
            if (backend.transition) target.addEventListener(backend.transition.event, _this2.backendSwitcher, true);
        });
    };
    this.removeEventListeners = function(target) {
        _this2.backends.forEach(function(backend) {
            if (backend.transition) target.removeEventListener(backend.transition.event, _this2.backendSwitcher, true);
        });
    };
    this.backendSwitcher = function(event) {
        var oldBackend = _this2.current;
        var i = 0;
        _this2.backends.some(function(backend) {
            if (i !== _this2.current && backend.transition && backend.transition.check(event)) {
                _this2.current = i;
                return true;
            }
            i += 1;
            return false;
        });
        if (_this2.current !== oldBackend) {
            _this2.backends[oldBackend].instance.teardown();
            Object.keys(_this2.nodes).forEach(function(id) {
                var node = _this2.nodes[id];
                node.handler();
                node.handler = _this2.callBackend(node.func, node.args);
            });
            $078d7a27d1dd49ad$export$2ed2aee2f13b45ca.backendChanged(_this2);
            var newBackend = _this2.backends[_this2.current];
            newBackend.instance.setup();
            if (newBackend.skipDispatchOnTransition) return;
            var newEvent = null;
            try {
                newEvent = new event.constructor(event.type, event);
            } catch (_e) {
                newEvent = document.createEvent("Event");
                newEvent.initEvent(event.type, event.bubbles, event.cancelable);
            }
            event.target.dispatchEvent(newEvent);
        }
    };
    this.callBackend = function(func, args) {
        var _this2$backends$_this;
        return (_this2$backends$_this = _this2.backends[_this2.current].instance)[func].apply(_this2$backends$_this, $078d7a27d1dd49ad$var$_toConsumableArray(args));
    };
    this.connectBackend = function(func, args) {
        var nodeId = "".concat(func, "_").concat(args[0]);
        var handler = _this2.callBackend(func, args);
        _this2.nodes[nodeId] = {
            func: func,
            args: args,
            handler: handler
        };
        return function() {
            var _this2$nodes$nodeId;
            var r = (_this2$nodes$nodeId = _this2.nodes[nodeId]).handler.apply(_this2$nodes$nodeId, arguments);
            delete _this2.nodes[nodeId];
            return r;
        };
    };
    var options = (0, $f26nT.default)({
        backends: []
    }, sourceOptions || {});
    if (options.backends.length < 1) throw new Error("You must specify at least one Backend, if you are coming from 2.x.x (or don't understand this error)\n        see this guide: https://github.com/louisbrunner/dnd-multi-backend/tree/master/packages/react-dnd-multi-backend#migrating-from-2xx");
    this.current = 0;
    this.backends = [];
    options.backends.forEach(function(backend) {
        if (!backend.backend) throw new Error("You must specify a 'backend' property in your Backend entry: ".concat(backend));
        var transition = backend.transition;
        if (transition && !transition._isMBTransition) throw new Error("You must specify a valid 'transition' property (either undefined or the return of 'createTransition') in your Backend entry: ".concat(backend));
        _this2.backends.push({
            instance: backend.backend(manager, context, backend.options),
            preview: backend.preview || false,
            transition: transition,
            skipDispatchOnTransition: Boolean(backend.skipDispatchOnTransition)
        });
    });
    this.nodes = {};
} // DnD Backend API
;

});
parcelRegister("f26nT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af1bfeb3c3ed3567$export$2e2bcd8739ae039; });
function $af1bfeb3c3ed3567$export$2e2bcd8739ae039(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    sources.forEach(function(source) {
        for(var name in source)if (Object.prototype.hasOwnProperty.call(source, name)) target[name] = source[name];
    });
    return target;
}

});



parcelRegister("krhw9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee13eae1ad044950$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $bL7mH = parcelRequire("bL7mH");
parcelRequire("9I5De");
var $EcyC5 = parcelRequire("EcyC5");
function $ee13eae1ad044950$var$_slicedToArray(arr, i) {
    return $ee13eae1ad044950$var$_arrayWithHoles(arr) || $ee13eae1ad044950$var$_iterableToArrayLimit(arr, i) || $ee13eae1ad044950$var$_unsupportedIterableToArray(arr, i) || $ee13eae1ad044950$var$_nonIterableRest();
}
function $ee13eae1ad044950$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ee13eae1ad044950$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ee13eae1ad044950$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ee13eae1ad044950$var$_arrayLikeToArray(o, minLen);
}
function $ee13eae1ad044950$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ee13eae1ad044950$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ee13eae1ad044950$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $ee13eae1ad044950$var$Preview = function Preview(props) {
    var _useState = (0, $arQ7u.useState)(false), _useState2 = $ee13eae1ad044950$var$_slicedToArray(_useState, 2), enabled = _useState2[0], setEnabled = _useState2[1];
    (0, $arQ7u.useEffect)(function() {
        var observer = {
            backendChanged: function backendChanged(backend) {
                setEnabled(backend.previewEnabled());
            }
        };
        (0, $EcyC5.PreviewManager).register(observer);
        return function() {
            (0, $EcyC5.PreviewManager).unregister(observer);
        };
    });
    if (!enabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $bL7mH.default), props);
};
$ee13eae1ad044950$var$Preview.Context = (0, $bL7mH.Context);
$ee13eae1ad044950$var$Preview.propTypes = (0, $bL7mH.default).propTypes;
var $ee13eae1ad044950$export$2e2bcd8739ae039 = $ee13eae1ad044950$var$Preview;

});
parcelRegister("bL7mH", function(module, exports) {

$parcel$export(module.exports, "Context", function () { return $88f9cc0cfdd3e6d2$export$841858b892ce1f4c; });
$parcel$export(module.exports, "default", function () { return $88f9cc0cfdd3e6d2$export$2e2bcd8739ae039; });

var $arQ7u = parcelRequire("arQ7u");

var $4Jbg8 = parcelRequire("4Jbg8");

var $kD2Pu = parcelRequire("kD2Pu");
var $88f9cc0cfdd3e6d2$var$PreviewContext = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createContext();
var $88f9cc0cfdd3e6d2$var$getStyle = function getStyle(currentOffset) {
    var transform = "translate(".concat(currentOffset.x, "px, ").concat(currentOffset.y, "px)");
    return {
        pointerEvents: "none",
        position: "fixed",
        top: 0,
        left: 0,
        transform: transform,
        WebkitTransform: transform
    };
};
var $88f9cc0cfdd3e6d2$var$Preview = function Preview(props) {
    var collectedProps = (0, $kD2Pu.useDragLayer)(function(monitor) {
        return {
            currentOffset: monitor.getSourceClientOffset(),
            isDragging: monitor.isDragging(),
            itemType: monitor.getItemType(),
            item: monitor.getItem()
        };
    });
    if (!collectedProps.isDragging || collectedProps.currentOffset === null) return null;
    var data = {
        itemType: collectedProps.itemType,
        item: collectedProps.item,
        style: $88f9cc0cfdd3e6d2$var$getStyle(collectedProps.currentOffset)
    };
    var child;
    if (props.children && typeof props.children === "function") child = props.children(data);
    else if (props.children) child = props.children;
    else child = props.generator(data);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($88f9cc0cfdd3e6d2$var$PreviewContext.Provider, {
        value: data
    }, child);
};
$88f9cc0cfdd3e6d2$var$Preview.propTypes = {
    generator: (0, (/*@__PURE__*/$parcel$interopDefault($4Jbg8))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4Jbg8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4Jbg8))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($4Jbg8))).func
    ])
};
var $88f9cc0cfdd3e6d2$export$841858b892ce1f4c = $88f9cc0cfdd3e6d2$var$PreviewContext;
var $88f9cc0cfdd3e6d2$export$2e2bcd8739ae039 = $88f9cc0cfdd3e6d2$var$Preview;

});
parcelRegister("kD2Pu", function(module, exports) {

$parcel$export(module.exports, "useDragLayer", function () { return $f049a50df9271adb$export$d7d88e78e2243a79; });

var $arQ7u = parcelRequire("arQ7u");

var $8qOUR = parcelRequire("8qOUR");

var $19NWj = parcelRequire("19NWj");
function $f049a50df9271adb$var$_slicedToArray(arr, i) {
    return $f049a50df9271adb$var$_arrayWithHoles(arr) || $f049a50df9271adb$var$_iterableToArrayLimit(arr, i) || $f049a50df9271adb$var$_nonIterableRest();
}
function $f049a50df9271adb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $f049a50df9271adb$var$_iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f049a50df9271adb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f049a50df9271adb$export$d7d88e78e2243a79(collect) {
    var dragDropManager = (0, $8qOUR.useDragDropManager)();
    var monitor = dragDropManager.getMonitor();
    var _useCollector = (0, $19NWj.useCollector)(monitor, collect), _useCollector2 = $f049a50df9271adb$var$_slicedToArray(_useCollector, 2), collected = _useCollector2[0], updateCollected = _useCollector2[1];
    (0, $arQ7u.useEffect)(function() {
        return monitor.subscribeToOffsetChange(updateCollected);
    });
    (0, $arQ7u.useEffect)(function() {
        return monitor.subscribeToStateChange(updateCollected);
    });
    return collected;
}

});
parcelRegister("8qOUR", function(module, exports) {

$parcel$export(module.exports, "useDragDropManager", function () { return $01958d6887193699$export$49db7e1a057ab0fa; });

var $arQ7u = parcelRequire("arQ7u");

var $jWomj = parcelRequire("jWomj");

var $3nbWv = parcelRequire("3nbWv");
function $01958d6887193699$export$49db7e1a057ab0fa() {
    var _useContext = (0, $arQ7u.useContext)((0, $3nbWv.DndContext)), dragDropManager = _useContext.dragDropManager;
    (0, $jWomj.invariant)(dragDropManager != null, "Expected drag drop context");
    return dragDropManager;
}

});

parcelRegister("19NWj", function(module, exports) {

$parcel$export(module.exports, "useCollector", function () { return $0d7d5ead65a3bcc7$export$e32e64a4387f290a; });

var $1TE6p = parcelRequire("1TE6p");

var $arQ7u = parcelRequire("arQ7u");

var $iYEnc = parcelRequire("iYEnc");
function $0d7d5ead65a3bcc7$var$_slicedToArray(arr, i) {
    return $0d7d5ead65a3bcc7$var$_arrayWithHoles(arr) || $0d7d5ead65a3bcc7$var$_iterableToArrayLimit(arr, i) || $0d7d5ead65a3bcc7$var$_nonIterableRest();
}
function $0d7d5ead65a3bcc7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $0d7d5ead65a3bcc7$var$_iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0d7d5ead65a3bcc7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0d7d5ead65a3bcc7$export$e32e64a4387f290a(monitor, collect, onUpdate) {
    var _useState = (0, $arQ7u.useState)(function() {
        return collect(monitor);
    }), _useState2 = $0d7d5ead65a3bcc7$var$_slicedToArray(_useState, 2), collected = _useState2[0], setCollected = _useState2[1];
    var updateCollected = (0, $arQ7u.useCallback)(function() {
        var nextValue = collect(monitor);
        if (!(0, $1TE6p.shallowEqual)(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]); // update the collected properties after the first render
    // and the components are attached to dnd-core
    (0, $iYEnc.useIsomorphicLayoutEffect)(updateCollected, []);
    return [
        collected,
        updateCollected
    ];
}

});
parcelRegister("1TE6p", function(module, exports) {

$parcel$export(module.exports, "shallowEqual", function () { return $161a0903adf9e2a4$export$d36bdfa510afb180; });
function $161a0903adf9e2a4$export$d36bdfa510afb180(objA, objB, compare, compareContext) {
    var compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}

});

parcelRegister("iYEnc", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $dd0d25dcfb529faa$export$700979bc83e7db82; });

var $arQ7u = parcelRequire("arQ7u");
var $dd0d25dcfb529faa$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $arQ7u.useLayoutEffect) : (0, $arQ7u.useEffect);

});






parcelRegister("1I9Y5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13f1a1f601ed9dec$var$_reactDndHtml5Backend = $13f1a1f601ed9dec$var$_interopRequireDefault((parcelRequire("3fT1I")));

var $13f1a1f601ed9dec$var$_reactDndTouchBackend = $13f1a1f601ed9dec$var$_interopRequireDefault((parcelRequire("avTyj")));
parcelRequire("9I5De");
var $aCRhC = parcelRequire("aCRhC");
function $13f1a1f601ed9dec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $13f1a1f601ed9dec$var$_default = {
    backends: [
        {
            backend: $13f1a1f601ed9dec$var$_reactDndHtml5Backend.default,
            transition: $aCRhC.MouseTransition
        },
        {
            backend: $13f1a1f601ed9dec$var$_reactDndTouchBackend.default,
            options: {
                enableMouseEvents: true
            },
            preview: true,
            transition: $aCRhC.TouchTransition
        }
    ]
};
module.exports.default = $13f1a1f601ed9dec$var$_default;

});
parcelRegister("3fT1I", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $25ed74fd0c15c2cd$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getEmptyImage", function () { return (parcelRequire("czvRk")).getEmptyImage; });
$parcel$export(module.exports, "NativeTypes", function () { return (parcelRequire("8UI3r")); });

var $9Cx5Y = parcelRequire("9Cx5Y");

var $8UI3r = parcelRequire("8UI3r");

var $czvRk = parcelRequire("czvRk");
var $25ed74fd0c15c2cd$var$createBackend = function createBackend(manager, context) {
    return new (0, $9Cx5Y.default)(manager, context);
};
var $25ed74fd0c15c2cd$export$2e2bcd8739ae039 = $25ed74fd0c15c2cd$var$createBackend;

});
parcelRegister("9Cx5Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $701155b882113f2d$export$2e2bcd8739ae039; });

var $edBFN = parcelRequire("edBFN");

var $jCjrj = parcelRequire("jCjrj");

var $fTuNs = parcelRequire("fTuNs");

var $8fnOq = parcelRequire("8fnOq");

var $8UI3r = parcelRequire("8UI3r");

var $2IemK = parcelRequire("2IemK");
function $701155b882113f2d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $701155b882113f2d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $701155b882113f2d$var$ownKeys(Object(source), true).forEach(function(key) {
            $701155b882113f2d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $701155b882113f2d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $701155b882113f2d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $701155b882113f2d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $701155b882113f2d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $701155b882113f2d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $701155b882113f2d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $701155b882113f2d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $701155b882113f2d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function HTML5Backend(manager, globalContext) {
        var _this = this;
        $701155b882113f2d$var$_classCallCheck(this, HTML5Backend);
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.getSourceClientOffset = function(sourceId) {
            return (0, $fTuNs.getNodeClientOffset)(_this.sourceNodes.get(sourceId));
        };
        this.endDragNativeItem = function() {
            if (!_this.isDraggingNativeItem()) return;
            _this.actions.endDrag();
            _this.registry.removeSource(_this.currentNativeHandle);
            _this.currentNativeHandle = null;
            _this.currentNativeSource = null;
        };
        this.isNodeInDocument = function(node) {
            // Check the node either in the main document or in the current context
            return _this.document && _this.document.body && document.body.contains(node);
        };
        this.endDragIfSourceWasRemovedFromDOM = function() {
            var node = _this.currentDragSourceNode;
            if (_this.isNodeInDocument(node)) return;
            if (_this.clearCurrentDragSourceNode()) _this.actions.endDrag();
        };
        this.handleTopDragStartCapture = function() {
            _this.clearCurrentDragSourceNode();
            _this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = function(e) {
            if (e.defaultPrevented) return;
            var dragStartSourceIds = _this.dragStartSourceIds;
            _this.dragStartSourceIds = null;
            var clientOffset = (0, $fTuNs.getEventClientOffset)(e); // Avoid crashing if we missed a drop event or our previous drag died
            if (_this.monitor.isDragging()) _this.actions.endDrag();
             // Don't publish the source just yet (see why below)
            _this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: _this.getSourceClientOffset,
                clientOffset: clientOffset
            });
            var dataTransfer = e.dataTransfer;
            var nativeType = (0, $8fnOq.matchNativeItemType)(dataTransfer);
            if (_this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === "function") {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    var sourceId = _this.monitor.getSourceId();
                    var sourceNode = _this.sourceNodes.get(sourceId);
                    var dragPreview = _this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        var _this$getCurrentSourc = _this.getCurrentSourcePreviewNodeOptions(), anchorX = _this$getCurrentSourc.anchorX, anchorY = _this$getCurrentSourc.anchorY, offsetX = _this$getCurrentSourc.offsetX, offsetY = _this$getCurrentSourc.offsetY;
                        var anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        var offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        var dragPreviewOffset = (0, $fTuNs.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer.setData("application/json", {});
                } catch (err) {} // IE doesn't support MIME types in setData
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                _this.setCurrentDragSourceNode(e.target); // Now we are ready to publish the drag source.. or are we not?
                var _this$getCurrentSourc2 = _this.getCurrentSourcePreviewNodeOptions(), captureDraggingState = _this$getCurrentSourc2.captureDraggingState;
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(function() {
                    return _this.actions.publishDragSource();
                }, 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                _this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            _this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute("draggable"))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        };
        this.handleTopDragEndCapture = function() {
            if (_this.clearCurrentDragSourceNode()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            _this.actions.endDrag();
        };
        this.handleTopDragEnterCapture = function(e) {
            _this.dragEnterTargetIds = [];
            var isFirstEnter = _this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || _this.monitor.isDragging()) return;
            var dataTransfer = e.dataTransfer;
            var nativeType = (0, $8fnOq.matchNativeItemType)(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            _this.beginDragNativeItem(nativeType, dataTransfer);
        };
        this.handleTopDragEnter = function(e) {
            var dragEnterTargetIds = _this.dragEnterTargetIds;
            _this.dragEnterTargetIds = [];
            if (!_this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            _this.altKeyPressed = e.altKey;
            if (!(0, $jCjrj.isFirefox)()) // Don't emit hover in `dragenter` on Firefox due to an edge case.
            // If the target changes position as the result of `dragenter`, Firefox
            // will still happily dispatch `dragover` despite target being no longer
            // there. The easy solution is to only fire `hover` in `dragover` on FF.
            _this.actions.hover(dragEnterTargetIds, {
                clientOffset: (0, $fTuNs.getEventClientOffset)(e)
            });
            var canDrop = dragEnterTargetIds.some(function(targetId) {
                return _this.monitor.canDropOnTarget(targetId);
            });
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
            }
        };
        this.handleTopDragOverCapture = function() {
            _this.dragOverTargetIds = [];
        };
        this.handleTopDragOver = function(e) {
            var dragOverTargetIds = _this.dragOverTargetIds;
            _this.dragOverTargetIds = [];
            if (!_this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
                return;
            }
            _this.altKeyPressed = e.altKey;
            _this.actions.hover(dragOverTargetIds || [], {
                clientOffset: (0, $fTuNs.getEventClientOffset)(e)
            });
            var canDrop = (dragOverTargetIds || []).some(function(targetId) {
                return _this.monitor.canDropOnTarget(targetId);
            });
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
            } else if (_this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
            }
        };
        this.handleTopDragLeaveCapture = function(e) {
            if (_this.isDraggingNativeItem()) e.preventDefault();
            var isLastLeave = _this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (_this.isDraggingNativeItem()) _this.endDragNativeItem();
        };
        this.handleTopDropCapture = function(e) {
            _this.dropTargetIds = [];
            e.preventDefault();
            if (_this.isDraggingNativeItem()) _this.currentNativeSource.loadDataTransfer(e.dataTransfer);
            _this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = function(e) {
            var dropTargetIds = _this.dropTargetIds;
            _this.dropTargetIds = [];
            _this.actions.hover(dropTargetIds, {
                clientOffset: (0, $fTuNs.getEventClientOffset)(e)
            });
            _this.actions.drop({
                dropEffect: _this.getCurrentDropEffect()
            });
            if (_this.isDraggingNativeItem()) _this.endDragNativeItem();
            else _this.endDragIfSourceWasRemovedFromDOM();
        };
        this.handleSelectStart = function(e) {
            var target = e.target; // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== "function") return;
             // Inputs and textareas should be selectable
            if (target.tagName === "INPUT" || target.tagName === "SELECT" || target.tagName === "TEXTAREA" || target.isContentEditable) return;
             // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new (0, $2IemK.OptionsReader)(globalContext);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new (0, $edBFN.default)(this.isNodeInDocument);
    } // public for test
    $701155b882113f2d$var$_createClass(HTML5Backend, [
        {
            key: "setup",
            value: function setup() {
                if (this.window === undefined) return;
                if (this.window.__isReactDndBackendSetUp) throw new Error("Cannot have two HTML5 backends at the same time.");
                this.window.__isReactDndBackendSetUp = true;
                this.addEventListeners(this.window);
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                if (this.window === undefined) return;
                this.window.__isReactDndBackendSetUp = false;
                this.removeEventListeners(this.window);
                this.clearCurrentDragSourceNode();
                if (this.asyncEndDragFrameId) this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
            }
        },
        {
            key: "connectDragPreview",
            value: function connectDragPreview(sourceId, node, options) {
                var _this2 = this;
                this.sourcePreviewNodeOptions.set(sourceId, options);
                this.sourcePreviewNodes.set(sourceId, node);
                return function() {
                    _this2.sourcePreviewNodes.delete(sourceId);
                    _this2.sourcePreviewNodeOptions.delete(sourceId);
                };
            }
        },
        {
            key: "connectDragSource",
            value: function connectDragSource(sourceId, node, options) {
                var _this3 = this;
                this.sourceNodes.set(sourceId, node);
                this.sourceNodeOptions.set(sourceId, options);
                var handleDragStart = function handleDragStart(e) {
                    return _this3.handleDragStart(e, sourceId);
                };
                var handleSelectStart = function handleSelectStart(e) {
                    return _this3.handleSelectStart(e);
                };
                node.setAttribute("draggable", "true");
                node.addEventListener("dragstart", handleDragStart);
                node.addEventListener("selectstart", handleSelectStart);
                return function() {
                    _this3.sourceNodes.delete(sourceId);
                    _this3.sourceNodeOptions.delete(sourceId);
                    node.removeEventListener("dragstart", handleDragStart);
                    node.removeEventListener("selectstart", handleSelectStart);
                    node.setAttribute("draggable", "false");
                };
            }
        },
        {
            key: "connectDropTarget",
            value: function connectDropTarget(targetId, node) {
                var _this4 = this;
                var handleDragEnter = function handleDragEnter(e) {
                    return _this4.handleDragEnter(e, targetId);
                };
                var handleDragOver = function handleDragOver(e) {
                    return _this4.handleDragOver(e, targetId);
                };
                var handleDrop = function handleDrop(e) {
                    return _this4.handleDrop(e, targetId);
                };
                node.addEventListener("dragenter", handleDragEnter);
                node.addEventListener("dragover", handleDragOver);
                node.addEventListener("drop", handleDrop);
                return function() {
                    node.removeEventListener("dragenter", handleDragEnter);
                    node.removeEventListener("dragover", handleDragOver);
                    node.removeEventListener("drop", handleDrop);
                };
            }
        },
        {
            key: "addEventListeners",
            value: function addEventListeners(target) {
                // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
                if (!target.addEventListener) return;
                target.addEventListener("dragstart", this.handleTopDragStart);
                target.addEventListener("dragstart", this.handleTopDragStartCapture, true);
                target.addEventListener("dragend", this.handleTopDragEndCapture, true);
                target.addEventListener("dragenter", this.handleTopDragEnter);
                target.addEventListener("dragenter", this.handleTopDragEnterCapture, true);
                target.addEventListener("dragleave", this.handleTopDragLeaveCapture, true);
                target.addEventListener("dragover", this.handleTopDragOver);
                target.addEventListener("dragover", this.handleTopDragOverCapture, true);
                target.addEventListener("drop", this.handleTopDrop);
                target.addEventListener("drop", this.handleTopDropCapture, true);
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners(target) {
                // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
                if (!target.removeEventListener) return;
                target.removeEventListener("dragstart", this.handleTopDragStart);
                target.removeEventListener("dragstart", this.handleTopDragStartCapture, true);
                target.removeEventListener("dragend", this.handleTopDragEndCapture, true);
                target.removeEventListener("dragenter", this.handleTopDragEnter);
                target.removeEventListener("dragenter", this.handleTopDragEnterCapture, true);
                target.removeEventListener("dragleave", this.handleTopDragLeaveCapture, true);
                target.removeEventListener("dragover", this.handleTopDragOver);
                target.removeEventListener("dragover", this.handleTopDragOverCapture, true);
                target.removeEventListener("drop", this.handleTopDrop);
                target.removeEventListener("drop", this.handleTopDropCapture, true);
            }
        },
        {
            key: "getCurrentSourceNodeOptions",
            value: function getCurrentSourceNodeOptions() {
                var sourceId = this.monitor.getSourceId();
                var sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
                return $701155b882113f2d$var$_objectSpread({
                    dropEffect: this.altKeyPressed ? "copy" : "move"
                }, sourceNodeOptions || {});
            }
        },
        {
            key: "getCurrentDropEffect",
            value: function getCurrentDropEffect() {
                if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
                return "copy";
                return this.getCurrentSourceNodeOptions().dropEffect;
            }
        },
        {
            key: "getCurrentSourcePreviewNodeOptions",
            value: function getCurrentSourcePreviewNodeOptions() {
                var sourceId = this.monitor.getSourceId();
                var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
                return $701155b882113f2d$var$_objectSpread({
                    anchorX: 0.5,
                    anchorY: 0.5,
                    captureDraggingState: false
                }, sourcePreviewNodeOptions || {});
            }
        },
        {
            key: "isDraggingNativeItem",
            value: function isDraggingNativeItem() {
                var itemType = this.monitor.getItemType();
                return Object.keys($8UI3r).some(function(key) {
                    return $8UI3r[key] === itemType;
                });
            }
        },
        {
            key: "beginDragNativeItem",
            value: function beginDragNativeItem(type, dataTransfer) {
                this.clearCurrentDragSourceNode();
                this.currentNativeSource = (0, $8fnOq.createNativeDragSource)(type, dataTransfer);
                this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
                this.actions.beginDrag([
                    this.currentNativeHandle
                ]);
            }
        },
        {
            key: "setCurrentDragSourceNode",
            value: function setCurrentDragSourceNode(node) {
                var _this5 = this;
                this.clearCurrentDragSourceNode();
                this.currentDragSourceNode = node; // A timeout of > 0 is necessary to resolve Firefox issue referenced
                // See:
                //   * https://github.com/react-dnd/react-dnd/pull/928
                //   * https://github.com/react-dnd/react-dnd/issues/869
                var MOUSE_MOVE_TIMEOUT = 1000; // Receiving a mouse event in the middle of a dragging operation
                // means it has ended and the drag source node disappeared from DOM,
                // so the browser didn't dispatch the dragend event.
                //
                // We need to wait before we start listening for mousemove events.
                // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
                // immediately in some browsers.
                //
                // See:
                //   * https://github.com/react-dnd/react-dnd/pull/928
                //   * https://github.com/react-dnd/react-dnd/issues/869
                //
                this.mouseMoveTimeoutTimer = setTimeout(function() {
                    return _this5.window && _this5.window.addEventListener("mousemove", _this5.endDragIfSourceWasRemovedFromDOM, true);
                }, MOUSE_MOVE_TIMEOUT);
            }
        },
        {
            key: "clearCurrentDragSourceNode",
            value: function clearCurrentDragSourceNode() {
                if (this.currentDragSourceNode) {
                    this.currentDragSourceNode = null;
                    if (this.window) {
                        this.window.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                        this.window.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
                    }
                    this.mouseMoveTimeoutTimer = null;
                    return true;
                }
                return false;
            }
        },
        {
            key: "handleDragStart",
            value: function handleDragStart(e, sourceId) {
                if (e.defaultPrevented) return;
                if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
                this.dragStartSourceIds.unshift(sourceId);
            }
        },
        {
            key: "handleDragEnter",
            value: function handleDragEnter(e, targetId) {
                this.dragEnterTargetIds.unshift(targetId);
            }
        },
        {
            key: "handleDragOver",
            value: function handleDragOver(e, targetId) {
                if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
                this.dragOverTargetIds.unshift(targetId);
            }
        },
        {
            key: "handleDrop",
            value: function handleDrop(e, targetId) {
                this.dropTargetIds.unshift(targetId);
            }
        },
        {
            key: "window",
            get: function get() {
                return this.options.window;
            }
        },
        {
            key: "document",
            get: function get() {
                return this.options.document;
            }
        }
    ]);
    return HTML5Backend;
}();

});
parcelRegister("edBFN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a59f80ab65d0069c$export$2e2bcd8739ae039; });

var $4nBH2 = parcelRequire("4nBH2");
function $a59f80ab65d0069c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a59f80ab65d0069c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a59f80ab65d0069c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a59f80ab65d0069c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a59f80ab65d0069c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $a59f80ab65d0069c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function EnterLeaveCounter(isNodeInDocument) {
        $a59f80ab65d0069c$var$_classCallCheck(this, EnterLeaveCounter);
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
    $a59f80ab65d0069c$var$_createClass(EnterLeaveCounter, [
        {
            key: "enter",
            value: function enter(enteringNode) {
                var _this = this;
                var previousLength = this.entered.length;
                var isNodeEntered = function isNodeEntered(node) {
                    return _this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
                };
                this.entered = (0, $4nBH2.union)(this.entered.filter(isNodeEntered), [
                    enteringNode
                ]);
                return previousLength === 0 && this.entered.length > 0;
            }
        },
        {
            key: "leave",
            value: function leave(leavingNode) {
                var previousLength = this.entered.length;
                this.entered = (0, $4nBH2.without)(this.entered.filter(this.isNodeInDocument), leavingNode);
                return previousLength > 0 && this.entered.length === 0;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.entered = [];
            }
        }
    ]);
    return EnterLeaveCounter;
}();

});
parcelRegister("4nBH2", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $33068c77f2956f5b$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "without", function () { return $33068c77f2956f5b$export$5d14bf425b37f49e; });
$parcel$export(module.exports, "union", function () { return $33068c77f2956f5b$export$971dd5b0dfd021b6; });
// cheap lodash replacements
function $33068c77f2956f5b$export$fc10aeed3a532e2a(fn) {
    var result = null;
    var memoized = function memoized() {
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
function $33068c77f2956f5b$export$5d14bf425b37f49e(items, item) {
    return items.filter(function(i) {
        return i !== item;
    });
}
function $33068c77f2956f5b$export$971dd5b0dfd021b6(itemsA, itemsB) {
    var set = new Set();
    var insertItem = function insertItem(item) {
        return set.add(item);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    var result = [];
    set.forEach(function(key) {
        return result.push(key);
    });
    return result;
}

});


parcelRegister("jCjrj", function(module, exports) {

$parcel$export(module.exports, "isFirefox", function () { return $e480a537b5488d13$export$b7d78993b74f766d; });
$parcel$export(module.exports, "isSafari", function () { return $e480a537b5488d13$export$95df08bae54cb4df; });

var $4nBH2 = parcelRequire("4nBH2");
var $e480a537b5488d13$export$b7d78993b74f766d = (0, $4nBH2.memoize)(function() {
    return /firefox/i.test(navigator.userAgent);
});
var $e480a537b5488d13$export$95df08bae54cb4df = (0, $4nBH2.memoize)(function() {
    return Boolean(window.safari);
});

});

parcelRegister("fTuNs", function(module, exports) {

$parcel$export(module.exports, "getNodeClientOffset", function () { return $b923e1a4dfad47b0$export$8419e8612027b1d8; });
$parcel$export(module.exports, "getEventClientOffset", function () { return $b923e1a4dfad47b0$export$710c829989c68339; });
$parcel$export(module.exports, "getDragPreviewOffset", function () { return $b923e1a4dfad47b0$export$e99fdbb90efc75c5; });

var $jCjrj = parcelRequire("jCjrj");

var $tO0Dm = parcelRequire("tO0Dm");
var $b923e1a4dfad47b0$var$ELEMENT_NODE = 1;
function $b923e1a4dfad47b0$export$8419e8612027b1d8(node) {
    var el = node.nodeType === $b923e1a4dfad47b0$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return null;
    var _el$getBoundingClient = el.getBoundingClientRect(), top = _el$getBoundingClient.top, left = _el$getBoundingClient.left;
    return {
        x: left,
        y: top
    };
}
function $b923e1a4dfad47b0$export$710c829989c68339(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function $b923e1a4dfad47b0$var$isImageNode(node) {
    return node.nodeName === "IMG" && ((0, $jCjrj.isFirefox)() || !document.documentElement.contains(node));
}
function $b923e1a4dfad47b0$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight; // Work around @2x coordinate discrepancies in browsers
    if ((0, $jCjrj.isSafari)() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function $b923e1a4dfad47b0$export$e99fdbb90efc75c5(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    var isImage = $b923e1a4dfad47b0$var$isImageNode(dragPreview);
    var dragPreviewNode = isImage ? sourceNode : dragPreview;
    var dragPreviewNodeOffsetFromClient = $b923e1a4dfad47b0$export$8419e8612027b1d8(dragPreviewNode);
    var offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    var sourceWidth = sourceNode.offsetWidth, sourceHeight = sourceNode.offsetHeight;
    var anchorX = anchorPoint.anchorX, anchorY = anchorPoint.anchorY;
    var _getDragPreviewSize = $b923e1a4dfad47b0$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight), dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth, dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;
    var calculateYOffset = function calculateYOffset() {
        var interpolantY = new (0, $tO0Dm.default)([
            0,
            0.5,
            1
        ], [
            offsetFromDragPreview.y,
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        var y = interpolantY.interpolate(anchorY); // Work around Safari 8 positioning bug
        if ((0, $jCjrj.isSafari)() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    var calculateXOffset = function calculateXOffset() {
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        var interpolantX = new (0, $tO0Dm.default)([
            0,
            0.5,
            1
        ], [
            offsetFromDragPreview.x,
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    }; // Force offsets if specified in the options.
    var offsetX = offsetPoint.offsetX, offsetY = offsetPoint.offsetY;
    var isManualOffsetX = offsetX === 0 || offsetX;
    var isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}

});
parcelRegister("tO0Dm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $059980568d580cc5$export$2e2bcd8739ae039; });
function $059980568d580cc5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $059980568d580cc5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $059980568d580cc5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $059980568d580cc5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $059980568d580cc5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $059980568d580cc5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function MonotonicInterpolant(xs, ys) {
        $059980568d580cc5$var$_classCallCheck(this, MonotonicInterpolant);
        var length = xs.length; // Rearrange xs and ys so that xs is sorted
        var indexes = [];
        for(var i = 0; i < length; i++)indexes.push(i);
        indexes.sort(function(a, b) {
            return xs[a] < xs[b] ? -1 : 1;
        }); // Get consecutive differences and slopes
        var dys = [];
        var dxs = [];
        var ms = [];
        var dx;
        var dy;
        for(var _i = 0; _i < length - 1; _i++){
            dx = xs[_i + 1] - xs[_i];
            dy = ys[_i + 1] - ys[_i];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        } // Get degree-1 coefficients
        var c1s = [
            ms[0]
        ];
        for(var _i2 = 0; _i2 < dxs.length - 1; _i2++){
            var m2 = ms[_i2];
            var mNext = ms[_i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[_i2];
                var dxNext = dxs[_i2 + 1];
                var common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]); // Get degree-2 and degree-3 coefficients
        var c2s = [];
        var c3s = [];
        var m;
        for(var _i3 = 0; _i3 < c1s.length - 1; _i3++){
            m = ms[_i3];
            var c1 = c1s[_i3];
            var invDx = 1 / dxs[_i3];
            var _common = c1 + c1s[_i3 + 1] - m - m;
            c2s.push((m - c1 - _common) * invDx);
            c3s.push(_common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
    $059980568d580cc5$var$_createClass(MonotonicInterpolant, [
        {
            key: "interpolate",
            value: function interpolate(x) {
                var xs = this.xs, ys = this.ys, c1s = this.c1s, c2s = this.c2s, c3s = this.c3s; // The rightmost point in the dataset should give an exact result
                var i = xs.length - 1;
                if (x === xs[i]) return ys[i];
                 // Search for the interval x is in, returning the corresponding y if x is one of the original xs
                var low = 0;
                var high = c3s.length - 1;
                var mid;
                while(low <= high){
                    mid = Math.floor(0.5 * (low + high));
                    var xHere = xs[mid];
                    if (xHere < x) low = mid + 1;
                    else if (xHere > x) high = mid - 1;
                    else return ys[mid];
                }
                i = Math.max(0, high); // Interpolate
                var diff = x - xs[i];
                var diffSq = diff * diff;
                return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
            }
        }
    ]);
    return MonotonicInterpolant;
}();

});


parcelRegister("8fnOq", function(module, exports) {

$parcel$export(module.exports, "createNativeDragSource", function () { return $6012321146fd6c20$export$ada362c01636774d; });
$parcel$export(module.exports, "matchNativeItemType", function () { return $6012321146fd6c20$export$11b547ed8c182c11; });

var $hp7gD = parcelRequire("hp7gD");

var $edLCL = parcelRequire("edLCL");
function $6012321146fd6c20$export$ada362c01636774d(type, dataTransfer) {
    var result = new (0, $edLCL.NativeDragSource)((0, $hp7gD.nativeTypesConfig)[type]);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function $6012321146fd6c20$export$11b547ed8c182c11(dataTransfer) {
    if (!dataTransfer) return null;
    var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys((0, $hp7gD.nativeTypesConfig)).filter(function(nativeItemType) {
        var matchesTypes = (0, $hp7gD.nativeTypesConfig)[nativeItemType].matchesTypes;
        return matchesTypes.some(function(t) {
            return dataTransferTypes.indexOf(t) > -1;
        });
    })[0] || null;
}

});
parcelRegister("hp7gD", function(module, exports) {

$parcel$export(module.exports, "nativeTypesConfig", function () { return $caba68970b6ff297$export$8cc89d9b8cb1bd88; });

var $8UI3r = parcelRequire("8UI3r");

var $jrDzo = parcelRequire("jrDzo");
var $caba68970b6ff297$var$_nativeTypesConfig;
function $caba68970b6ff297$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $caba68970b6ff297$export$8cc89d9b8cb1bd88 = ($caba68970b6ff297$var$_nativeTypesConfig = {}, $caba68970b6ff297$var$_defineProperty($caba68970b6ff297$var$_nativeTypesConfig, $8UI3r.FILE, {
    exposeProperties: {
        files: function files(dataTransfer) {
            return Array.prototype.slice.call(dataTransfer.files);
        },
        items: function items(dataTransfer) {
            return dataTransfer.items;
        }
    },
    matchesTypes: [
        "Files"
    ]
}), $caba68970b6ff297$var$_defineProperty($caba68970b6ff297$var$_nativeTypesConfig, $8UI3r.URL, {
    exposeProperties: {
        urls: function urls(dataTransfer, matchesTypes) {
            return (0, $jrDzo.getDataFromDataTransfer)(dataTransfer, matchesTypes, "").split("\n");
        }
    },
    matchesTypes: [
        "Url",
        "text/uri-list"
    ]
}), $caba68970b6ff297$var$_defineProperty($caba68970b6ff297$var$_nativeTypesConfig, $8UI3r.TEXT, {
    exposeProperties: {
        text: function text(dataTransfer, matchesTypes) {
            return (0, $jrDzo.getDataFromDataTransfer)(dataTransfer, matchesTypes, "");
        }
    },
    matchesTypes: [
        "Text",
        "text/plain"
    ]
}), $caba68970b6ff297$var$_nativeTypesConfig);

});
parcelRegister("8UI3r", function(module, exports) {

$parcel$export(module.exports, "FILE", function () { return $67d5b9fe84735dfe$export$1802dbfd31b58482; });
$parcel$export(module.exports, "URL", function () { return $67d5b9fe84735dfe$export$61abde59b50deb8e; });
$parcel$export(module.exports, "TEXT", function () { return $67d5b9fe84735dfe$export$d597759d33be802e; });
var $67d5b9fe84735dfe$export$1802dbfd31b58482 = "__NATIVE_FILE__";
var $67d5b9fe84735dfe$export$61abde59b50deb8e = "__NATIVE_URL__";
var $67d5b9fe84735dfe$export$d597759d33be802e = "__NATIVE_TEXT__";

});

parcelRegister("jrDzo", function(module, exports) {

$parcel$export(module.exports, "getDataFromDataTransfer", function () { return $e27f3bb4f6d6d929$export$dc02f6a7b68f305f; });
function $e27f3bb4f6d6d929$export$dc02f6a7b68f305f(dataTransfer, typesToTry, defaultValue) {
    var result = typesToTry.reduce(function(resultSoFar, typeToTry) {
        return resultSoFar || dataTransfer.getData(typeToTry);
    }, "");
    return result != null ? result : defaultValue;
}

});


parcelRegister("edLCL", function(module, exports) {

$parcel$export(module.exports, "NativeDragSource", function () { return $a5a738c65f96f4ce$export$f22384f077cf51c4; });
function $a5a738c65f96f4ce$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a5a738c65f96f4ce$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a5a738c65f96f4ce$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a5a738c65f96f4ce$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a5a738c65f96f4ce$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $a5a738c65f96f4ce$export$f22384f077cf51c4 = /*#__PURE__*/ function() {
    function NativeDragSource(config) {
        $a5a738c65f96f4ce$var$_classCallCheck(this, NativeDragSource);
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
    $a5a738c65f96f4ce$var$_createClass(NativeDragSource, [
        {
            key: "initializeExposedProperties",
            value: function initializeExposedProperties() {
                var _this = this;
                Object.keys(this.config.exposeProperties).forEach(function(property) {
                    Object.defineProperty(_this.item, property, {
                        configurable: true,
                        enumerable: true,
                        get: function get() {
                            // eslint-disable-next-line no-console
                            console.warn("Browser doesn't allow reading \"".concat(property, '" until the drop event.'));
                            return null;
                        }
                    });
                });
            }
        },
        {
            key: "loadDataTransfer",
            value: function loadDataTransfer(dataTransfer) {
                var _this2 = this;
                if (dataTransfer) {
                    var newProperties = {};
                    Object.keys(this.config.exposeProperties).forEach(function(property) {
                        newProperties[property] = {
                            value: _this2.config.exposeProperties[property](dataTransfer, _this2.config.matchesTypes),
                            configurable: true,
                            enumerable: true
                        };
                    });
                    Object.defineProperties(this.item, newProperties);
                }
            }
        },
        {
            key: "canDrag",
            value: function canDrag() {
                return true;
            }
        },
        {
            key: "beginDrag",
            value: function beginDrag() {
                return this.item;
            }
        },
        {
            key: "isDragging",
            value: function isDragging(monitor, handle) {
                return handle === monitor.getSourceId();
            }
        },
        {
            key: "endDrag",
            value: function endDrag() {}
        }
    ]);
    return NativeDragSource;
}();

});


parcelRegister("2IemK", function(module, exports) {

$parcel$export(module.exports, "OptionsReader", function () { return $1f9ad59e7ca3f73f$export$2b3a268803e49e64; });
function $1f9ad59e7ca3f73f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1f9ad59e7ca3f73f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1f9ad59e7ca3f73f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1f9ad59e7ca3f73f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1f9ad59e7ca3f73f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $1f9ad59e7ca3f73f$export$2b3a268803e49e64 = /*#__PURE__*/ function() {
    function OptionsReader(globalContext) {
        $1f9ad59e7ca3f73f$var$_classCallCheck(this, OptionsReader);
        this.globalContext = globalContext;
    }
    $1f9ad59e7ca3f73f$var$_createClass(OptionsReader, [
        {
            key: "window",
            get: function get() {
                if (this.globalContext) return this.globalContext;
                else if (typeof window !== "undefined") return window;
                return undefined;
            }
        },
        {
            key: "document",
            get: function get() {
                if (this.window) return this.window.document;
                return undefined;
            }
        }
    ]);
    return OptionsReader;
}();

});


parcelRegister("czvRk", function(module, exports) {

$parcel$export(module.exports, "getEmptyImage", function () { return $927177789de69133$export$bf32f66787bcad4b; });
var $927177789de69133$var$emptyImage;
function $927177789de69133$export$bf32f66787bcad4b() {
    if (!$927177789de69133$var$emptyImage) {
        $927177789de69133$var$emptyImage = new Image();
        $927177789de69133$var$emptyImage.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
    }
    return $927177789de69133$var$emptyImage;
}

});


parcelRegister("avTyj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7a77e434af97da47$export$2e2bcd8739ae039; });

var $4UHLV = parcelRequire("4UHLV");
var $7a77e434af97da47$var$createBackend = function createBackend(manager, context) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return new (0, $4UHLV.default)(manager, context, options);
};
var $7a77e434af97da47$export$2e2bcd8739ae039 = $7a77e434af97da47$var$createBackend;

});
parcelRegister("4UHLV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $393e589e1befd7c2$export$2e2bcd8739ae039; });

var $jWomj = parcelRequire("jWomj");

var $4YbYz = parcelRequire("4YbYz");

var $dzEZr = parcelRequire("dzEZr");

var $ew8QM = parcelRequire("ew8QM");

var $djEBA = parcelRequire("djEBA");

var $bLTbU = parcelRequire("bLTbU");

var $83UZI = parcelRequire("83UZI");
var $393e589e1befd7c2$var$_eventNames;
function $393e589e1befd7c2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $393e589e1befd7c2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $393e589e1befd7c2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $393e589e1befd7c2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $393e589e1befd7c2$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $393e589e1befd7c2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $393e589e1befd7c2$var$eventNames = ($393e589e1befd7c2$var$_eventNames = {}, $393e589e1befd7c2$var$_defineProperty($393e589e1befd7c2$var$_eventNames, (0, $4YbYz.ListenerType).mouse, {
    start: "mousedown",
    move: "mousemove",
    end: "mouseup",
    contextmenu: "contextmenu"
}), $393e589e1befd7c2$var$_defineProperty($393e589e1befd7c2$var$_eventNames, (0, $4YbYz.ListenerType).touch, {
    start: "touchstart",
    move: "touchmove",
    end: "touchend"
}), $393e589e1befd7c2$var$_defineProperty($393e589e1befd7c2$var$_eventNames, (0, $4YbYz.ListenerType).keyboard, {
    keydown: "keydown"
}), $393e589e1befd7c2$var$_eventNames);
var $393e589e1befd7c2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function TouchBackend(manager, context, options) {
        var _this = this;
        $393e589e1befd7c2$var$_classCallCheck(this, TouchBackend);
        this.getSourceClientOffset = function(sourceId) {
            return (0, $ew8QM.getNodeClientOffset)(_this.sourceNodes[sourceId]);
        };
        this.handleTopMoveStartCapture = function(e) {
            if (!(0, $dzEZr.eventShouldStartDrag)(e)) return;
            _this.moveStartSourceIds = [];
        };
        this.handleMoveStart = function(sourceId) {
            // Just because we received an event doesn't necessarily mean we need to collect drag sources.
            // We only collect start collecting drag sources on touch and left mouse events.
            if (Array.isArray(_this.moveStartSourceIds)) _this.moveStartSourceIds.unshift(sourceId);
        };
        this.handleTopMoveStart = function(e) {
            if (!(0, $dzEZr.eventShouldStartDrag)(e)) return;
             // Don't prematurely preventDefault() here since it might:
            // 1. Mess up scrolling
            // 2. Mess up long tap (which brings up context menu)
            // 3. If there's an anchor link as a child, tap won't be triggered on link
            var clientOffset = (0, $ew8QM.getEventClientOffset)(e);
            if (clientOffset) {
                if ((0, $dzEZr.isTouchEvent)(e)) _this.lastTargetTouchFallback = e.targetTouches[0];
                _this._mouseClientOffset = clientOffset;
            }
            _this.waitingForDelay = false;
        };
        this.handleTopMoveStartDelay = function(e) {
            if (!(0, $dzEZr.eventShouldStartDrag)(e)) return;
            var delay = e.type === $393e589e1befd7c2$var$eventNames.touch.start ? _this.options.delayTouchStart : _this.options.delayMouseStart;
            _this.timeout = setTimeout(_this.handleTopMoveStart.bind(_this, e), delay);
            _this.waitingForDelay = true;
        };
        this.handleTopMoveCapture = function() {
            _this.dragOverTargetIds = [];
        };
        this.handleMove = function(_, targetId) {
            if (_this.dragOverTargetIds) _this.dragOverTargetIds.unshift(targetId);
        };
        this.handleTopMove = function(e) {
            if (_this.timeout) clearTimeout(_this.timeout);
            if (!_this.document || _this.waitingForDelay) return;
            var moveStartSourceIds = _this.moveStartSourceIds, dragOverTargetIds = _this.dragOverTargetIds;
            var enableHoverOutsideTarget = _this.options.enableHoverOutsideTarget;
            var clientOffset = (0, $ew8QM.getEventClientOffset)(e, _this.lastTargetTouchFallback);
            if (!clientOffset) return;
             // If the touch move started as a scroll, or is is between the scroll angles
            if (_this._isScrolling || !_this.monitor.isDragging() && (0, $djEBA.inAngleRanges)(_this._mouseClientOffset.x || 0, _this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y, _this.options.scrollAngleRanges)) {
                _this._isScrolling = true;
                return;
            } // If we're not dragging and we've moved a little, that counts as a drag start
            if (!_this.monitor.isDragging() && // eslint-disable-next-line no-prototype-builtins
            _this._mouseClientOffset.hasOwnProperty("x") && moveStartSourceIds && (0, $djEBA.distance)(_this._mouseClientOffset.x || 0, _this._mouseClientOffset.y || 0, clientOffset.x, clientOffset.y) > (_this.options.touchSlop ? _this.options.touchSlop : 0)) {
                _this.moveStartSourceIds = undefined;
                _this.actions.beginDrag(moveStartSourceIds, {
                    clientOffset: _this._mouseClientOffset,
                    getSourceClientOffset: _this.getSourceClientOffset,
                    publishSource: false
                });
            }
            if (!_this.monitor.isDragging()) return;
            var sourceNode = _this.sourceNodes[_this.monitor.getSourceId()];
            _this.installSourceNodeRemovalObserver(sourceNode);
            _this.actions.publishDragSource();
            e.preventDefault(); // Get the node elements of the hovered DropTargets
            var dragOverTargetNodes = (dragOverTargetIds || []).map(function(key) {
                return _this.targetNodes[key];
            }); // Get the a ordered list of nodes that are touched by
            var elementsAtPoint = _this.options.getDropTargetElementsAtPoint ? _this.options.getDropTargetElementsAtPoint(clientOffset.x, clientOffset.y, dragOverTargetNodes) : _this.document.elementsFromPoint(clientOffset.x, clientOffset.y); // Extend list with parents that are not receiving elementsFromPoint events (size 0 elements and svg groups)
            var elementsAtPointExtended = [];
            for(var nodeId in elementsAtPoint){
                // eslint-disable-next-line no-prototype-builtins
                if (!elementsAtPoint.hasOwnProperty(nodeId)) continue;
                var currentNode = elementsAtPoint[nodeId];
                elementsAtPointExtended.push(currentNode);
                while(currentNode){
                    currentNode = currentNode.parentElement;
                    if (elementsAtPointExtended.indexOf(currentNode) === -1) elementsAtPointExtended.push(currentNode);
                }
            }
            var orderedDragOverTargetIds = elementsAtPointExtended // Filter off nodes that arent a hovered DropTargets nodes
            .filter(function(node) {
                return dragOverTargetNodes.indexOf(node) > -1;
            }) // Map back the nodes elements to targetIds
            .map(function(node) {
                for(var targetId in _this.targetNodes){
                    if (node === _this.targetNodes[targetId]) return targetId;
                }
                return undefined;
            }) // Filter off possible null rows
            .filter(function(node) {
                return !!node;
            }).filter(function(id, index, ids) {
                return ids.indexOf(id) === index;
            }); // Invoke hover for drop targets when source node is still over and pointer is outside
            if (enableHoverOutsideTarget) {
                for(var targetId in _this.targetNodes)if (_this.targetNodes[targetId] && _this.targetNodes[targetId].contains(sourceNode) && orderedDragOverTargetIds.indexOf(targetId) === -1) {
                    orderedDragOverTargetIds.unshift(targetId);
                    break;
                }
            } // Reverse order because dnd-core reverse it before calling the DropTarget drop methods
            orderedDragOverTargetIds.reverse();
            _this.actions.hover(orderedDragOverTargetIds, {
                clientOffset: clientOffset
            });
        };
        this.handleTopMoveEndCapture = function(e) {
            _this._isScrolling = false;
            _this.lastTargetTouchFallback = undefined;
            if (!(0, $dzEZr.eventShouldEndDrag)(e)) return;
            if (!_this.monitor.isDragging() || _this.monitor.didDrop()) {
                _this.moveStartSourceIds = undefined;
                return;
            }
            e.preventDefault();
            _this._mouseClientOffset = {};
            _this.uninstallSourceNodeRemovalObserver();
            _this.actions.drop();
            _this.actions.endDrag();
        };
        this.handleCancelOnEscape = function(e) {
            if (e.key === "Escape" && _this.monitor.isDragging()) {
                _this._mouseClientOffset = {};
                _this.uninstallSourceNodeRemovalObserver();
                _this.actions.endDrag();
            }
        };
        this.options = new (0, $83UZI.OptionsReader)(options, context);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.sourceNodes = {};
        this.sourcePreviewNodes = {};
        this.sourcePreviewNodeOptions = {};
        this.targetNodes = {};
        this.listenerTypes = [];
        this._mouseClientOffset = {};
        this._isScrolling = false;
        if (this.options.enableMouseEvents) this.listenerTypes.push((0, $4YbYz.ListenerType).mouse);
        if (this.options.enableTouchEvents) this.listenerTypes.push((0, $4YbYz.ListenerType).touch);
        if (this.options.enableKeyboardEvents) this.listenerTypes.push((0, $4YbYz.ListenerType).keyboard);
    } // public for test
    $393e589e1befd7c2$var$_createClass(TouchBackend, [
        {
            key: "setup",
            value: function setup() {
                if (!this.window) return;
                (0, $jWomj.invariant)(!TouchBackend.isSetUp, "Cannot have two Touch backends at the same time.");
                TouchBackend.isSetUp = true;
                this.addEventListener(this.window, "start", this.getTopMoveStartHandler());
                this.addEventListener(this.window, "start", this.handleTopMoveStartCapture, true);
                this.addEventListener(this.window, "move", this.handleTopMove);
                this.addEventListener(this.window, "move", this.handleTopMoveCapture, true);
                this.addEventListener(this.window, "end", this.handleTopMoveEndCapture, true);
                if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.addEventListener(this.window, "contextmenu", this.handleTopMoveEndCapture);
                if (this.options.enableKeyboardEvents) this.addEventListener(this.window, "keydown", this.handleCancelOnEscape, true);
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                if (!this.window) return;
                TouchBackend.isSetUp = false;
                this._mouseClientOffset = {};
                this.removeEventListener(this.window, "start", this.handleTopMoveStartCapture, true);
                this.removeEventListener(this.window, "start", this.handleTopMoveStart);
                this.removeEventListener(this.window, "move", this.handleTopMoveCapture, true);
                this.removeEventListener(this.window, "move", this.handleTopMove);
                this.removeEventListener(this.window, "end", this.handleTopMoveEndCapture, true);
                if (this.options.enableMouseEvents && !this.options.ignoreContextMenu) this.removeEventListener(this.window, "contextmenu", this.handleTopMoveEndCapture);
                if (this.options.enableKeyboardEvents) this.removeEventListener(this.window, "keydown", this.handleCancelOnEscape, true);
                this.uninstallSourceNodeRemovalObserver();
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(subject, event, handler, capture) {
                var options = (0, $bLTbU.default) ? {
                    capture: capture,
                    passive: false
                } : capture;
                this.listenerTypes.forEach(function(listenerType) {
                    var evt = $393e589e1befd7c2$var$eventNames[listenerType][event];
                    if (evt) subject.addEventListener(evt, handler, options);
                });
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(subject, event, handler, capture) {
                var options = (0, $bLTbU.default) ? {
                    capture: capture,
                    passive: false
                } : capture;
                this.listenerTypes.forEach(function(listenerType) {
                    var evt = $393e589e1befd7c2$var$eventNames[listenerType][event];
                    if (evt) subject.removeEventListener(evt, handler, options);
                });
            }
        },
        {
            key: "connectDragSource",
            value: function connectDragSource(sourceId, node) {
                var _this2 = this;
                var handleMoveStart = this.handleMoveStart.bind(this, sourceId);
                this.sourceNodes[sourceId] = node;
                this.addEventListener(node, "start", handleMoveStart);
                return function() {
                    delete _this2.sourceNodes[sourceId];
                    _this2.removeEventListener(node, "start", handleMoveStart);
                };
            }
        },
        {
            key: "connectDragPreview",
            value: function connectDragPreview(sourceId, node, options) {
                var _this3 = this;
                this.sourcePreviewNodeOptions[sourceId] = options;
                this.sourcePreviewNodes[sourceId] = node;
                return function() {
                    delete _this3.sourcePreviewNodes[sourceId];
                    delete _this3.sourcePreviewNodeOptions[sourceId];
                };
            }
        },
        {
            key: "connectDropTarget",
            value: function connectDropTarget(targetId, node) {
                var _this4 = this;
                if (!this.document) return function() {
                    return null;
                };
                var handleMove = function handleMove(e) {
                    if (!_this4.document || !_this4.monitor.isDragging()) return;
                    var coords;
                    /**
         * Grab the coordinates for the current mouse/touch position
         */ switch(e.type){
                        case $393e589e1befd7c2$var$eventNames.mouse.move:
                            coords = {
                                x: e.clientX,
                                y: e.clientY
                            };
                            break;
                        case $393e589e1befd7c2$var$eventNames.touch.move:
                            coords = {
                                x: e.touches[0].clientX,
                                y: e.touches[0].clientY
                            };
                            break;
                    }
                    /**
         * Use the coordinates to grab the element the drag ended on.
         * If the element is the same as the target node (or any of it's children) then we have hit a drop target and can handle the move.
         */ var droppedOn = coords != null ? _this4.document.elementFromPoint(coords.x, coords.y) : undefined;
                    var childMatch = droppedOn && node.contains(droppedOn);
                    if (droppedOn === node || childMatch) return _this4.handleMove(e, targetId);
                };
                /**
       * Attaching the event listener to the body so that touchmove will work while dragging over multiple target elements.
       */ this.addEventListener(this.document.body, "move", handleMove);
                this.targetNodes[targetId] = node;
                return function() {
                    if (_this4.document) {
                        delete _this4.targetNodes[targetId];
                        _this4.removeEventListener(_this4.document.body, "move", handleMove);
                    }
                };
            }
        },
        {
            key: "getTopMoveStartHandler",
            value: function getTopMoveStartHandler() {
                if (!this.options.delayTouchStart && !this.options.delayMouseStart) return this.handleTopMoveStart;
                return this.handleTopMoveStartDelay;
            }
        },
        {
            key: "installSourceNodeRemovalObserver",
            value: function installSourceNodeRemovalObserver(node) {
                var _this5 = this;
                this.uninstallSourceNodeRemovalObserver();
                this.draggedSourceNode = node;
                this.draggedSourceNodeRemovalObserver = new MutationObserver(function() {
                    if (node && !node.parentElement) {
                        _this5.resurrectSourceNode();
                        _this5.uninstallSourceNodeRemovalObserver();
                    }
                });
                if (!node || !node.parentElement) return;
                this.draggedSourceNodeRemovalObserver.observe(node.parentElement, {
                    childList: true
                });
            }
        },
        {
            key: "resurrectSourceNode",
            value: function resurrectSourceNode() {
                if (this.document && this.draggedSourceNode) {
                    this.draggedSourceNode.style.display = "none";
                    this.draggedSourceNode.removeAttribute("data-reactid");
                    this.document.body.appendChild(this.draggedSourceNode);
                }
            }
        },
        {
            key: "uninstallSourceNodeRemovalObserver",
            value: function uninstallSourceNodeRemovalObserver() {
                if (this.draggedSourceNodeRemovalObserver) this.draggedSourceNodeRemovalObserver.disconnect();
                this.draggedSourceNodeRemovalObserver = undefined;
                this.draggedSourceNode = undefined;
            }
        },
        {
            key: "window",
            get: function get() {
                return this.options.window;
            } // public for test
        },
        {
            key: "document",
            get: function get() {
                if (this.window) return this.window.document;
                return undefined;
            }
        }
    ]);
    return TouchBackend;
}();

});
parcelRegister("4YbYz", function(module, exports) {

$parcel$export(module.exports, "ListenerType", function () { return $39e60e336a372a6c$export$77315d8e4e38ac8f; });
var $39e60e336a372a6c$export$77315d8e4e38ac8f;
(function(ListenerType) {
    ListenerType["mouse"] = "mouse";
    ListenerType["touch"] = "touch";
    ListenerType["keyboard"] = "keyboard";
})($39e60e336a372a6c$export$77315d8e4e38ac8f || ($39e60e336a372a6c$export$77315d8e4e38ac8f = {}));

});

parcelRegister("dzEZr", function(module, exports) {

$parcel$export(module.exports, "eventShouldStartDrag", function () { return $9e1e570205f45020$export$c64909add7c8d190; });
$parcel$export(module.exports, "eventShouldEndDrag", function () { return $9e1e570205f45020$export$23bc6ab5d304a5; });
$parcel$export(module.exports, "isTouchEvent", function () { return $9e1e570205f45020$export$c4dfce035d43d1e0; });
// Used for MouseEvent.buttons (note the s on the end).
var $9e1e570205f45020$var$MouseButtons = {
    Left: 1,
    Right: 2,
    Center: 4
}; // Used for e.button (note the lack of an s on the end).
var $9e1e570205f45020$var$MouseButton = {
    Left: 0,
    Center: 1,
    Right: 2
};
function $9e1e570205f45020$export$c64909add7c8d190(e) {
    // For touch events, button will be undefined. If e.button is defined,
    // then it should be MouseButton.Left.
    return e.button === undefined || e.button === $9e1e570205f45020$var$MouseButton.Left;
}
function $9e1e570205f45020$export$23bc6ab5d304a5(e) {
    // Touch events will have buttons be undefined, while mouse events will have e.buttons's left button
    // bit field unset if the left mouse button has been released
    return e.buttons === undefined || (e.buttons & $9e1e570205f45020$var$MouseButtons.Left) === 0;
}
function $9e1e570205f45020$export$c4dfce035d43d1e0(e) {
    return !!e.targetTouches;
}

});

parcelRegister("ew8QM", function(module, exports) {

$parcel$export(module.exports, "getNodeClientOffset", function () { return $a91aeb576b241175$export$8419e8612027b1d8; });
$parcel$export(module.exports, "getEventClientOffset", function () { return $a91aeb576b241175$export$710c829989c68339; });

var $dzEZr = parcelRequire("dzEZr");
var $a91aeb576b241175$var$ELEMENT_NODE = 1;
function $a91aeb576b241175$export$8419e8612027b1d8(node) {
    var el = node.nodeType === $a91aeb576b241175$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return undefined;
    var _el$getBoundingClient = el.getBoundingClientRect(), top = _el$getBoundingClient.top, left = _el$getBoundingClient.left;
    return {
        x: left,
        y: top
    };
}
function $a91aeb576b241175$export$149d0d89063ea9ba(e, lastTargetTouchFallback) {
    if (e.targetTouches.length === 1) return $a91aeb576b241175$export$710c829989c68339(e.targetTouches[0]);
    else if (lastTargetTouchFallback && e.touches.length === 1) {
        if (e.touches[0].target === lastTargetTouchFallback.target) return $a91aeb576b241175$export$710c829989c68339(e.touches[0]);
    }
}
function $a91aeb576b241175$export$710c829989c68339(e, lastTargetTouchFallback) {
    if ((0, $dzEZr.isTouchEvent)(e)) return $a91aeb576b241175$export$149d0d89063ea9ba(e, lastTargetTouchFallback);
    else return {
        x: e.clientX,
        y: e.clientY
    };
}

});

parcelRegister("djEBA", function(module, exports) {

$parcel$export(module.exports, "distance", function () { return $9b1c8c0aed6f271a$export$9f17032d917177de; });
$parcel$export(module.exports, "inAngleRanges", function () { return $9b1c8c0aed6f271a$export$7c909de71a662f4d; });
function $9b1c8c0aed6f271a$export$9f17032d917177de(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(Math.abs(x2 - x1), 2) + Math.pow(Math.abs(y2 - y1), 2));
}
function $9b1c8c0aed6f271a$export$7c909de71a662f4d(x1, y1, x2, y2, angleRanges) {
    if (!angleRanges) return false;
    var angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI + 180;
    for(var i = 0; i < angleRanges.length; ++i){
        if ((angleRanges[i].start == null || angle >= angleRanges[i].start) && (angleRanges[i].end == null || angle <= angleRanges[i].end)) return true;
    }
    return false;
}

});

parcelRegister("bLTbU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $891ee5498626c0f1$export$2e2bcd8739ae039; });
var $891ee5498626c0f1$var$supportsPassive = function() {
    // simular to jQuery's test
    var supported = false;
    try {
        addEventListener("test", function() {}, Object.defineProperty({}, "passive", {
            get: function get() {
                supported = true;
                return true;
            }
        }));
    } catch (e) {}
    return supported;
}();
var $891ee5498626c0f1$export$2e2bcd8739ae039 = $891ee5498626c0f1$var$supportsPassive;

});

parcelRegister("83UZI", function(module, exports) {

$parcel$export(module.exports, "OptionsReader", function () { return $5dead06dd8e01613$export$2b3a268803e49e64; });
function $5dead06dd8e01613$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5dead06dd8e01613$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5dead06dd8e01613$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5dead06dd8e01613$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5dead06dd8e01613$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $5dead06dd8e01613$export$2b3a268803e49e64 = /*#__PURE__*/ function() {
    function OptionsReader(incoming, context) {
        var _this = this;
        $5dead06dd8e01613$var$_classCallCheck(this, OptionsReader);
        this.enableTouchEvents = true;
        this.enableMouseEvents = false;
        this.enableKeyboardEvents = false;
        this.ignoreContextMenu = false;
        this.enableHoverOutsideTarget = false;
        this.touchSlop = 0;
        this.scrollAngleRanges = undefined;
        this.context = context;
        this.delayTouchStart = incoming.delayTouchStart || incoming.delay || 0;
        this.delayMouseStart = incoming.delayMouseStart || incoming.delay || 0;
        Object.keys(incoming).forEach(function(key) {
            if (incoming[key] != null) _this[key] = incoming[key];
        });
    }
    $5dead06dd8e01613$var$_createClass(OptionsReader, [
        {
            key: "window",
            get: function get() {
                if (this.context && this.context.window) return this.context.window;
                else if (typeof window !== "undefined") return window;
                return undefined;
            }
        },
        {
            key: "document",
            get: function get() {
                if (this.window) return this.window.document;
                return undefined;
            }
        }
    ]);
    return OptionsReader;
}();

});




parcelRegister("jQ5Ec", function(module, exports) {


module.exports = (parcelRequire("DvgwY"))((parcelRequire("9Y92Q")).resolve("hqy07")).then(()=>parcelRequire("cWUG1"));

});
parcelRegister("DvgwY", function(module, exports) {
"use strict";

var $eUbOu = parcelRequire("eUbOu");
module.exports = $eUbOu(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("eUbOu", function(module, exports) {
"use strict";
var $ad9f7584e34522ee$var$cachedBundles = {};
var $ad9f7584e34522ee$var$cachedPreloads = {};
var $ad9f7584e34522ee$var$cachedPrefetches = {};
function $ad9f7584e34522ee$var$getCache(type) {
    switch(type){
        case "preload":
            return $ad9f7584e34522ee$var$cachedPreloads;
        case "prefetch":
            return $ad9f7584e34522ee$var$cachedPrefetches;
        default:
            return $ad9f7584e34522ee$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $ad9f7584e34522ee$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("6VfQj", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $50a45afab12f1b3a$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $50a45afab12f1b3a$var$isUndefined;

});

parcelRegister("6ey0B", function(module, exports) {

var $lEvq9 = parcelRequire("lEvq9");

var $3FKAp = parcelRequire("3FKAp");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $489e6e51eae5bb6c$var$values(object) {
    return object == null ? [] : $lEvq9(object, $3FKAp(object));
}
module.exports = $489e6e51eae5bb6c$var$values;

});
parcelRegister("lEvq9", function(module, exports) {

var $2CmH3 = parcelRequire("2CmH3");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $fc35b4e4b65c5540$var$baseValues(object, props) {
    return $2CmH3(props, function(key) {
        return object[key];
    });
}
module.exports = $fc35b4e4b65c5540$var$baseValues;

});


parcelRegister("6JHIT", function(module, exports) {

var $6tHAe = parcelRequire("6tHAe");

var $3FKAp = parcelRequire("3FKAp");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $4e78dc8bbbfd2c69$var$baseAssign(object, source) {
    return object && $6tHAe(source, $3FKAp(source), object);
}
module.exports = $4e78dc8bbbfd2c69$var$baseAssign;

});
parcelRegister("6tHAe", function(module, exports) {

var $3IABh = parcelRequire("3IABh");

var $hI9C8 = parcelRequire("hI9C8");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $4b77424482bc5d8d$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $hI9C8(object, key, newValue);
        else $3IABh(object, key, newValue);
    }
    return object;
}
module.exports = $4b77424482bc5d8d$var$copyObject;

});


parcelRegister("34AQF", function(module, exports) {

var $9svsg = parcelRequire("9svsg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $9svsg.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("9jzwr", function(module, exports) {

var $eGM7V = parcelRequire("eGM7V");

var $gdxV3 = parcelRequire("gdxV3");

var $ebRRA = parcelRequire("ebRRA");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6c817165510d2c80$var$getAllKeysIn(object) {
    return $eGM7V(object, $ebRRA, $gdxV3);
}
module.exports = $6c817165510d2c80$var$getAllKeysIn;

});
parcelRegister("gdxV3", function(module, exports) {

var $gHWYa = parcelRequire("gHWYa");

var $aF2fW = parcelRequire("aF2fW");

var $fUrke = parcelRequire("fUrke");

var $cJ0ms = parcelRequire("cJ0ms");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bce82be4e772c694$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $bce82be4e772c694$var$getSymbolsIn = !$bce82be4e772c694$var$nativeGetSymbols ? $cJ0ms : function(object) {
    var result = [];
    while(object){
        $gHWYa(result, $fUrke(object));
        object = $aF2fW(object);
    }
    return result;
};
module.exports = $bce82be4e772c694$var$getSymbolsIn;

});
parcelRegister("aF2fW", function(module, exports) {

var $kres7 = parcelRequire("kres7");
/** Built-in value references. */ var $7c2f7bb8852bd6f6$var$getPrototype = $kres7(Object.getPrototypeOf, Object);
module.exports = $7c2f7bb8852bd6f6$var$getPrototype;

});


parcelRegister("ebRRA", function(module, exports) {

var $N18tZ = parcelRequire("N18tZ");

var $kLtKg = parcelRequire("kLtKg");

var $8kHR7 = parcelRequire("8kHR7");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $a54bdfe10800457e$var$keysIn(object) {
    return $8kHR7(object) ? $N18tZ(object, true) : $kLtKg(object);
}
module.exports = $a54bdfe10800457e$var$keysIn;

});
parcelRegister("kLtKg", function(module, exports) {

var $6Sqac = parcelRequire("6Sqac");

var $3g81o = parcelRequire("3g81o");

var $brJel = parcelRequire("brJel");
/** Used for built-in method references. */ var $f1df453019f0b292$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f1df453019f0b292$var$hasOwnProperty = $f1df453019f0b292$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f1df453019f0b292$var$baseKeysIn(object) {
    if (!$6Sqac(object)) return $brJel(object);
    var isProto = $3g81o(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$f1df453019f0b292$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $f1df453019f0b292$var$baseKeysIn;

});
parcelRegister("brJel", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $85554d218d6d2f69$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $85554d218d6d2f69$var$nativeKeysIn;

});




parcelRegister("c98tJ", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $8d7ce6f5b1c7d3a6$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $8d7ce6f5b1c7d3a6$var$last;

});

parcelRegister("dDG5q", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $9edf9065ffd1010c$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $9edf9065ffd1010c$var$baseSlice;

});

parcelRegister("ctdPd", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});

parcelRegister("4UnI7", function(module, exports) {

var $fC8jd = parcelRequire("fC8jd");
/** Used to compose bitmasks for function metadata. */ var $392ec8d4b4b458b9$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $392ec8d4b4b458b9$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $fC8jd(func, $392ec8d4b4b458b9$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $392ec8d4b4b458b9$var$ary;

});

parcelRegister("euAev", function(module, exports) {

var $isuQz = parcelRequire("isuQz");
/** Used to compose bitmasks for cloning. */ var $a8cff91e8c445061$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $a8cff91e8c445061$var$clone(value) {
    return $isuQz(value, $a8cff91e8c445061$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $a8cff91e8c445061$var$clone;

});
parcelRegister("isuQz", function(module, exports) {

var $l5Ia8 = parcelRequire("l5Ia8");

var $e43Zj = parcelRequire("e43Zj");

var $3IABh = parcelRequire("3IABh");

var $6JHIT = parcelRequire("6JHIT");

var $2lnFT = parcelRequire("2lnFT");

var $34AQF = parcelRequire("34AQF");

var $iIgar = parcelRequire("iIgar");

var $eBHtl = parcelRequire("eBHtl");

var $bFCAB = parcelRequire("bFCAB");

var $UV49P = parcelRequire("UV49P");

var $9jzwr = parcelRequire("9jzwr");

var $eGYov = parcelRequire("eGYov");

var $bskAM = parcelRequire("bskAM");

var $fu2Vv = parcelRequire("fu2Vv");

var $kWfa7 = parcelRequire("kWfa7");

var $eDRhj = parcelRequire("eDRhj");

var $lN48w = parcelRequire("lN48w");

var $9qbXj = parcelRequire("9qbXj");

var $6Sqac = parcelRequire("6Sqac");

var $9IMGA = parcelRequire("9IMGA");

var $3FKAp = parcelRequire("3FKAp");

var $ebRRA = parcelRequire("ebRRA");
/** Used to compose bitmasks for cloning. */ var $d702c51730a3b3e8$var$CLONE_DEEP_FLAG = 1, $d702c51730a3b3e8$var$CLONE_FLAT_FLAG = 2, $d702c51730a3b3e8$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $d702c51730a3b3e8$var$argsTag = "[object Arguments]", $d702c51730a3b3e8$var$arrayTag = "[object Array]", $d702c51730a3b3e8$var$boolTag = "[object Boolean]", $d702c51730a3b3e8$var$dateTag = "[object Date]", $d702c51730a3b3e8$var$errorTag = "[object Error]", $d702c51730a3b3e8$var$funcTag = "[object Function]", $d702c51730a3b3e8$var$genTag = "[object GeneratorFunction]", $d702c51730a3b3e8$var$mapTag = "[object Map]", $d702c51730a3b3e8$var$numberTag = "[object Number]", $d702c51730a3b3e8$var$objectTag = "[object Object]", $d702c51730a3b3e8$var$regexpTag = "[object RegExp]", $d702c51730a3b3e8$var$setTag = "[object Set]", $d702c51730a3b3e8$var$stringTag = "[object String]", $d702c51730a3b3e8$var$symbolTag = "[object Symbol]", $d702c51730a3b3e8$var$weakMapTag = "[object WeakMap]";
var $d702c51730a3b3e8$var$arrayBufferTag = "[object ArrayBuffer]", $d702c51730a3b3e8$var$dataViewTag = "[object DataView]", $d702c51730a3b3e8$var$float32Tag = "[object Float32Array]", $d702c51730a3b3e8$var$float64Tag = "[object Float64Array]", $d702c51730a3b3e8$var$int8Tag = "[object Int8Array]", $d702c51730a3b3e8$var$int16Tag = "[object Int16Array]", $d702c51730a3b3e8$var$int32Tag = "[object Int32Array]", $d702c51730a3b3e8$var$uint8Tag = "[object Uint8Array]", $d702c51730a3b3e8$var$uint8ClampedTag = "[object Uint8ClampedArray]", $d702c51730a3b3e8$var$uint16Tag = "[object Uint16Array]", $d702c51730a3b3e8$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $d702c51730a3b3e8$var$cloneableTags = {};
$d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$argsTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$arrayTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$arrayBufferTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$dataViewTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$boolTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$dateTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$float32Tag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$float64Tag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$int8Tag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$int16Tag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$int32Tag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$mapTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$numberTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$objectTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$regexpTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$setTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$stringTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$symbolTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$uint8Tag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$uint8ClampedTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$uint16Tag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$uint32Tag] = true;
$d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$errorTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$funcTag] = $d702c51730a3b3e8$var$cloneableTags[$d702c51730a3b3e8$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $d702c51730a3b3e8$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $d702c51730a3b3e8$var$CLONE_DEEP_FLAG, isFlat = bitmask & $d702c51730a3b3e8$var$CLONE_FLAT_FLAG, isFull = bitmask & $d702c51730a3b3e8$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$6Sqac(value)) return value;
    var isArr = $eDRhj(value);
    if (isArr) {
        result = $bskAM(value);
        if (!isDeep) return $iIgar(value, result);
    } else {
        var tag = $eGYov(value), isFunc = tag == $d702c51730a3b3e8$var$funcTag || tag == $d702c51730a3b3e8$var$genTag;
        if ($lN48w(value)) return $34AQF(value, isDeep);
        if (tag == $d702c51730a3b3e8$var$objectTag || tag == $d702c51730a3b3e8$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $kWfa7(value);
            if (!isDeep) return isFlat ? $bFCAB(value, $2lnFT(result, value)) : $eBHtl(value, $6JHIT(result, value));
        } else {
            if (!$d702c51730a3b3e8$var$cloneableTags[tag]) return object ? value : {};
            result = $fu2Vv(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $l5Ia8);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($9IMGA(value)) value.forEach(function(subValue) {
        result.add($d702c51730a3b3e8$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($9qbXj(value)) value.forEach(function(subValue, key) {
        result.set(key, $d702c51730a3b3e8$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $9jzwr : $UV49P : isFlat ? $ebRRA : $3FKAp;
    var props = isArr ? undefined : keysFunc(value);
    $e43Zj(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $3IABh(result, key, $d702c51730a3b3e8$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $d702c51730a3b3e8$var$baseClone;

});
parcelRegister("2lnFT", function(module, exports) {

var $6tHAe = parcelRequire("6tHAe");

var $ebRRA = parcelRequire("ebRRA");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $1b4fe8394a04f41a$var$baseAssignIn(object, source) {
    return object && $6tHAe(source, $ebRRA(source), object);
}
module.exports = $1b4fe8394a04f41a$var$baseAssignIn;

});

parcelRegister("eBHtl", function(module, exports) {

var $6tHAe = parcelRequire("6tHAe");

var $fUrke = parcelRequire("fUrke");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $aa263e1a03c2a36d$var$copySymbols(source, object) {
    return $6tHAe(source, $fUrke(source), object);
}
module.exports = $aa263e1a03c2a36d$var$copySymbols;

});

parcelRegister("bFCAB", function(module, exports) {

var $6tHAe = parcelRequire("6tHAe");

var $gdxV3 = parcelRequire("gdxV3");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $87f1751780fd62c9$var$copySymbolsIn(source, object) {
    return $6tHAe(source, $gdxV3(source), object);
}
module.exports = $87f1751780fd62c9$var$copySymbolsIn;

});

parcelRegister("bskAM", function(module, exports) {
/** Used for built-in method references. */ var $857248683a310718$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $857248683a310718$var$hasOwnProperty = $857248683a310718$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $857248683a310718$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $857248683a310718$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $857248683a310718$var$initCloneArray;

});

parcelRegister("fu2Vv", function(module, exports) {

var $fH0tx = parcelRequire("fH0tx");

var $6KOGS = parcelRequire("6KOGS");

var $cyQr4 = parcelRequire("cyQr4");

var $5DYaB = parcelRequire("5DYaB");

var $1lAYg = parcelRequire("1lAYg");
/** `Object#toString` result references. */ var $b45bed7ca506d4af$var$boolTag = "[object Boolean]", $b45bed7ca506d4af$var$dateTag = "[object Date]", $b45bed7ca506d4af$var$mapTag = "[object Map]", $b45bed7ca506d4af$var$numberTag = "[object Number]", $b45bed7ca506d4af$var$regexpTag = "[object RegExp]", $b45bed7ca506d4af$var$setTag = "[object Set]", $b45bed7ca506d4af$var$stringTag = "[object String]", $b45bed7ca506d4af$var$symbolTag = "[object Symbol]";
var $b45bed7ca506d4af$var$arrayBufferTag = "[object ArrayBuffer]", $b45bed7ca506d4af$var$dataViewTag = "[object DataView]", $b45bed7ca506d4af$var$float32Tag = "[object Float32Array]", $b45bed7ca506d4af$var$float64Tag = "[object Float64Array]", $b45bed7ca506d4af$var$int8Tag = "[object Int8Array]", $b45bed7ca506d4af$var$int16Tag = "[object Int16Array]", $b45bed7ca506d4af$var$int32Tag = "[object Int32Array]", $b45bed7ca506d4af$var$uint8Tag = "[object Uint8Array]", $b45bed7ca506d4af$var$uint8ClampedTag = "[object Uint8ClampedArray]", $b45bed7ca506d4af$var$uint16Tag = "[object Uint16Array]", $b45bed7ca506d4af$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $b45bed7ca506d4af$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $b45bed7ca506d4af$var$arrayBufferTag:
            return $fH0tx(object);
        case $b45bed7ca506d4af$var$boolTag:
        case $b45bed7ca506d4af$var$dateTag:
            return new Ctor(+object);
        case $b45bed7ca506d4af$var$dataViewTag:
            return $6KOGS(object, isDeep);
        case $b45bed7ca506d4af$var$float32Tag:
        case $b45bed7ca506d4af$var$float64Tag:
        case $b45bed7ca506d4af$var$int8Tag:
        case $b45bed7ca506d4af$var$int16Tag:
        case $b45bed7ca506d4af$var$int32Tag:
        case $b45bed7ca506d4af$var$uint8Tag:
        case $b45bed7ca506d4af$var$uint8ClampedTag:
        case $b45bed7ca506d4af$var$uint16Tag:
        case $b45bed7ca506d4af$var$uint32Tag:
            return $1lAYg(object, isDeep);
        case $b45bed7ca506d4af$var$mapTag:
            return new Ctor;
        case $b45bed7ca506d4af$var$numberTag:
        case $b45bed7ca506d4af$var$stringTag:
            return new Ctor(object);
        case $b45bed7ca506d4af$var$regexpTag:
            return $cyQr4(object);
        case $b45bed7ca506d4af$var$setTag:
            return new Ctor;
        case $b45bed7ca506d4af$var$symbolTag:
            return $5DYaB(object);
    }
}
module.exports = $b45bed7ca506d4af$var$initCloneByTag;

});
parcelRegister("fH0tx", function(module, exports) {

var $apQoP = parcelRequire("apQoP");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $b6cb3d8ffec7464b$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $apQoP(result).set(new $apQoP(arrayBuffer));
    return result;
}
module.exports = $b6cb3d8ffec7464b$var$cloneArrayBuffer;

});

parcelRegister("6KOGS", function(module, exports) {

var $fH0tx = parcelRequire("fH0tx");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $4eae5c0b61e6c7a8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $fH0tx(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $4eae5c0b61e6c7a8$var$cloneDataView;

});

parcelRegister("cyQr4", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $925155a34cb6ea07$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $925155a34cb6ea07$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $925155a34cb6ea07$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $925155a34cb6ea07$var$cloneRegExp;

});

parcelRegister("5DYaB", function(module, exports) {

var $7MX8u = parcelRequire("7MX8u");
/** Used to convert symbols to primitives and strings. */ var $41bf44c549a2f713$var$symbolProto = $7MX8u ? $7MX8u.prototype : undefined, $41bf44c549a2f713$var$symbolValueOf = $41bf44c549a2f713$var$symbolProto ? $41bf44c549a2f713$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $41bf44c549a2f713$var$cloneSymbol(symbol) {
    return $41bf44c549a2f713$var$symbolValueOf ? Object($41bf44c549a2f713$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $41bf44c549a2f713$var$cloneSymbol;

});

parcelRegister("1lAYg", function(module, exports) {

var $fH0tx = parcelRequire("fH0tx");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $0fb46e4509dc1f14$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $fH0tx(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $0fb46e4509dc1f14$var$cloneTypedArray;

});


parcelRegister("kWfa7", function(module, exports) {

var $2Xhhy = parcelRequire("2Xhhy");

var $aF2fW = parcelRequire("aF2fW");

var $3g81o = parcelRequire("3g81o");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $f3e4fc57af766979$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$3g81o(object) ? $2Xhhy($aF2fW(object)) : {};
}
module.exports = $f3e4fc57af766979$var$initCloneObject;

});

parcelRegister("9qbXj", function(module, exports) {

var $6JSeS = parcelRequire("6JSeS");

var $29wFm = parcelRequire("29wFm");

var $8TADj = parcelRequire("8TADj");
/* Node.js helper references. */ var $6dbfd0e322e88e7f$var$nodeIsMap = $8TADj && $8TADj.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $6dbfd0e322e88e7f$var$isMap = $6dbfd0e322e88e7f$var$nodeIsMap ? $29wFm($6dbfd0e322e88e7f$var$nodeIsMap) : $6JSeS;
module.exports = $6dbfd0e322e88e7f$var$isMap;

});
parcelRegister("6JSeS", function(module, exports) {

var $eGYov = parcelRequire("eGYov");

var $cLyAa = parcelRequire("cLyAa");
/** `Object#toString` result references. */ var $4e8104c16d3c989c$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $4e8104c16d3c989c$var$baseIsMap(value) {
    return $cLyAa(value) && $eGYov(value) == $4e8104c16d3c989c$var$mapTag;
}
module.exports = $4e8104c16d3c989c$var$baseIsMap;

});


parcelRegister("9IMGA", function(module, exports) {

var $dBGci = parcelRequire("dBGci");

var $29wFm = parcelRequire("29wFm");

var $8TADj = parcelRequire("8TADj");
/* Node.js helper references. */ var $713dfd186f3ed144$var$nodeIsSet = $8TADj && $8TADj.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $713dfd186f3ed144$var$isSet = $713dfd186f3ed144$var$nodeIsSet ? $29wFm($713dfd186f3ed144$var$nodeIsSet) : $dBGci;
module.exports = $713dfd186f3ed144$var$isSet;

});
parcelRegister("dBGci", function(module, exports) {

var $eGYov = parcelRequire("eGYov");

var $cLyAa = parcelRequire("cLyAa");
/** `Object#toString` result references. */ var $9e7f76927532e7c2$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $9e7f76927532e7c2$var$baseIsSet(value) {
    return $cLyAa(value) && $eGYov(value) == $9e7f76927532e7c2$var$setTag;
}
module.exports = $9e7f76927532e7c2$var$baseIsSet;

});




parcelRegister("aL6hR", function(module, exports) {

var $hyuxh = parcelRequire("hyuxh");

var $cLyAa = parcelRequire("cLyAa");

var $ckn2g = parcelRequire("ckn2g");
/** `Object#toString` result references. */ var $7d532ba7a3786a14$var$domExcTag = "[object DOMException]", $7d532ba7a3786a14$var$errorTag = "[object Error]";
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $7d532ba7a3786a14$var$isError(value) {
    if (!$cLyAa(value)) return false;
    var tag = $hyuxh(value);
    return tag == $7d532ba7a3786a14$var$errorTag || tag == $7d532ba7a3786a14$var$domExcTag || typeof value.message == "string" && typeof value.name == "string" && !$ckn2g(value);
}
module.exports = $7d532ba7a3786a14$var$isError;

});
parcelRegister("ckn2g", function(module, exports) {

var $hyuxh = parcelRequire("hyuxh");

var $aF2fW = parcelRequire("aF2fW");

var $cLyAa = parcelRequire("cLyAa");
/** `Object#toString` result references. */ var $8f9938ab21fa35b9$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $8f9938ab21fa35b9$var$funcProto = Function.prototype, $8f9938ab21fa35b9$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8f9938ab21fa35b9$var$funcToString = $8f9938ab21fa35b9$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8f9938ab21fa35b9$var$hasOwnProperty = $8f9938ab21fa35b9$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $8f9938ab21fa35b9$var$objectCtorString = $8f9938ab21fa35b9$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $8f9938ab21fa35b9$var$isPlainObject(value) {
    if (!$cLyAa(value) || $hyuxh(value) != $8f9938ab21fa35b9$var$objectTag) return false;
    var proto = $aF2fW(value);
    if (proto === null) return true;
    var Ctor = $8f9938ab21fa35b9$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $8f9938ab21fa35b9$var$funcToString.call(Ctor) == $8f9938ab21fa35b9$var$objectCtorString;
}
module.exports = $8f9938ab21fa35b9$var$isPlainObject;

});


parcelRegister("iOSJj", function(module, exports) {

var $eGYov = parcelRequire("eGYov");

var $cLyAa = parcelRequire("cLyAa");
/** `Object#toString` result references. */ var $db3759bba24e05b6$var$weakMapTag = "[object WeakMap]";
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $db3759bba24e05b6$var$isWeakMap(value) {
    return $cLyAa(value) && $eGYov(value) == $db3759bba24e05b6$var$weakMapTag;
}
module.exports = $db3759bba24e05b6$var$isWeakMap;

});

parcelRegister("3CVRv", function(module, exports) {

var $isuQz = parcelRequire("isuQz");

var $hChE7 = parcelRequire("hChE7");
/** Used to compose bitmasks for cloning. */ var $2a41cde0ab2b1c47$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $2a41cde0ab2b1c47$var$iteratee(func) {
    return $hChE7(typeof func == "function" ? func : $isuQz(func, $2a41cde0ab2b1c47$var$CLONE_DEEP_FLAG));
}
module.exports = $2a41cde0ab2b1c47$var$iteratee;

});

parcelRegister("6vMwC", function(module, exports) {

var $fC8jd = parcelRequire("fC8jd");

var $dAIZI = parcelRequire("dAIZI");
/** Used to compose bitmasks for function metadata. */ var $4bdb47680fb717d2$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $4bdb47680fb717d2$var$rearg = $dAIZI(function(func, indexes) {
    return $fC8jd(func, $4bdb47680fb717d2$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $4bdb47680fb717d2$var$rearg;

});
parcelRegister("dAIZI", function(module, exports) {

var $bT1Wq = parcelRequire("bT1Wq");

var $86CUP = parcelRequire("86CUP");

var $kn1gs = parcelRequire("kn1gs");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $9e518a1d0d62b4b5$var$flatRest(func) {
    return $kn1gs($86CUP(func, undefined, $bT1Wq), func + "");
}
module.exports = $9e518a1d0d62b4b5$var$flatRest;

});


parcelRegister("jUokQ", function(module, exports) {

var $2CmH3 = parcelRequire("2CmH3");

var $iIgar = parcelRequire("iIgar");

var $eDRhj = parcelRequire("eDRhj");

var $ejqIN = parcelRequire("ejqIN");

var $9OS4o = parcelRequire("9OS4o");

var $fMmVj = parcelRequire("fMmVj");

var $3zxVF = parcelRequire("3zxVF");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $e7e61fc08815504e$var$toPath(value) {
    if ($eDRhj(value)) return $2CmH3(value, $fMmVj);
    return $ejqIN(value) ? [
        value
    ] : $iIgar($9OS4o($3zxVF(value)));
}
module.exports = $e7e61fc08815504e$var$toPath;

});

parcelRegister("feGMd", function(module, exports) {

var $g7tjp = parcelRequire("g7tjp");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $b179585d11ba079b$var$set(object, path, value) {
    return object == null ? object : $g7tjp(object, path, value);
}
module.exports = $b179585d11ba079b$var$set;

});

parcelRegister("cK3Q5", function(module, exports) {

var $difjz = parcelRequire("difjz");
var $946cc2426c91ab75$var$_typeof = $difjz.default;
function $946cc2426c91ab75$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $946cc2426c91ab75$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $946cc2426c91ab75$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($946cc2426c91ab75$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $946cc2426c91ab75$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kD81i", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $03e038729e083ff5$export$2e2bcd8739ae039; });
function $03e038729e083ff5$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("7pPJC", function(module, exports) {

$parcel$export(module.exports, "getAuthProfiles", function () { return $5662ffa38fd740d3$export$5036b583cb9e07d4; });
$parcel$export(module.exports, "getAccessTokens", function () { return $5662ffa38fd740d3$export$b73c31f87535ee13; });
$parcel$export(module.exports, "getAuth", function () { return $5662ffa38fd740d3$export$209d0cb5060b8e69; });
$parcel$export(module.exports, "selectCurrentAuthServices", function () { return $5662ffa38fd740d3$export$53c1070cb0205622; });

var $1LbRi = parcelRequire("1LbRi");

var $a4sDT = parcelRequire("a4sDT");

var $bT1Wq = parcelRequire("bT1Wq");

var $izTcV = parcelRequire("izTcV");

var $fr77o = parcelRequire("fr77o");

var $jGts0 = parcelRequire("jGts0");

var $1MgBx = parcelRequire("1MgBx");
function $5662ffa38fd740d3$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $5662ffa38fd740d3$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $5662ffa38fd740d3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5662ffa38fd740d3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5662ffa38fd740d3$var$_arrayLikeToArray(o, minLen);
}
function $5662ffa38fd740d3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5662ffa38fd740d3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5662ffa38fd740d3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5662ffa38fd740d3$var$ownKeys(Object(source), true).forEach(function(key) {
            $5662ffa38fd740d3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5662ffa38fd740d3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5662ffa38fd740d3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5662ffa38fd740d3$export$5036b583cb9e07d4 = (0, $1LbRi.createSelector)([
    (0, $jGts0.getConfig)
], function(_ref) {
    var _ref$auth = _ref.auth;
    _ref$auth = _ref$auth === void 0 ? {} : _ref$auth;
    var _ref$auth$serviceProf = _ref$auth.serviceProfiles, serviceProfiles = _ref$auth$serviceProf === void 0 ? [] : _ref$auth$serviceProf;
    return serviceProfiles;
});
var $5662ffa38fd740d3$export$b73c31f87535ee13 = function getAccessTokens(state) {
    return (0, $fr77o.miradorSlice)(state).accessTokens || {};
};
var $5662ffa38fd740d3$export$209d0cb5060b8e69 = function getAuth(state) {
    return (0, $fr77o.miradorSlice)(state).auth || {};
};
var $5662ffa38fd740d3$export$53c1070cb0205622 = (0, $1LbRi.createSelector)([
    (0, $1MgBx.getVisibleCanvases),
    (0, $1MgBx.selectInfoResponses),
    $5662ffa38fd740d3$export$5036b583cb9e07d4,
    $5662ffa38fd740d3$export$209d0cb5060b8e69,
    function(state, _ref2) {
        var iiifResources = _ref2.iiifResources;
        return iiifResources;
    }
], function(canvases) {
    var infoResponses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var serviceProfiles = arguments.length > 2 ? arguments[2] : undefined;
    var auth = arguments.length > 3 ? arguments[3] : undefined;
    var iiifResources = arguments.length > 4 ? arguments[4] : undefined;
    var currentAuthResources = iiifResources;
    if (!currentAuthResources && canvases) currentAuthResources = (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(canvases.map(function(c) {
        var miradorCanvas = new (0, $izTcV.default)(c);
        var images = miradorCanvas.iiifImageResources;
        return images.map(function(i) {
            var iiifImageService = i.getServices()[0];
            var infoResponse = infoResponses[iiifImageService.id];
            if (infoResponse && infoResponse.json) return $5662ffa38fd740d3$var$_objectSpread($5662ffa38fd740d3$var$_objectSpread({}, infoResponse.json), {}, {
                options: {}
            });
            return iiifImageService;
        });
    }));
    if (!currentAuthResources) return [];
    if (currentAuthResources.length === 0) return [];
    var currentAuthServices = currentAuthResources.map(function(resource) {
        var lastAttemptedService;
        var services = (0, $a4sDT.Utils).getServices(resource);
        var _iterator = $5662ffa38fd740d3$var$_createForOfIteratorHelper(serviceProfiles), _step;
        try {
            var _loop = function _loop() {
                var authProfile = _step.value;
                var profiledAuthServices = services.filter(function(p) {
                    return authProfile.profile === p.getProfile();
                });
                var _iterator2 = $5662ffa38fd740d3$var$_createForOfIteratorHelper(profiledAuthServices), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var service = _step2.value;
                        lastAttemptedService = service;
                        if (!auth[service.id] || auth[service.id].isFetching || auth[service.id].ok) return {
                            v: service
                        };
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            };
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _ret = _loop();
                if (typeof _ret === "object") return _ret.v;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return lastAttemptedService;
    });
    return Object.values(currentAuthServices.reduce(function(h, service) {
        if (service && !h[service.id]) h[service.id] = service; // eslint-disable-line no-param-reassign
        return h;
    }, {}));
});

});

parcelRegister("lBHhj", function(module, exports) {

$parcel$export(module.exports, "getCurrentCanvasWorld", function () { return $fbae9fcee3f58158$export$65f78d7ff6be654e; });

var $1LbRi = parcelRequire("1LbRi");

var $2vCMW = parcelRequire("2vCMW");

var $1MgBx = parcelRequire("1MgBx");

var $konAW = parcelRequire("konAW");

var $51Gx5 = parcelRequire("51Gx5");
var $fbae9fcee3f58158$export$65f78d7ff6be654e = (0, $1LbRi.createSelector)((0, $1MgBx.getVisibleCanvases), (0, $konAW.getLayersForVisibleCanvases), (0, $51Gx5.getSequenceViewingDirection), function(canvases, layers, viewingDirection) {
    return new (0, $2vCMW.default)(canvases, layers, viewingDirection);
});

});

parcelRegister("amdCE", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78a6869bc0459d01$var$_createTheme = $kr74f((parcelRequire("9pVSu")));
var $78a6869bc0459d01$var$defaultTheme = (0, $78a6869bc0459d01$var$_createTheme.default)();
var $78a6869bc0459d01$var$_default = $78a6869bc0459d01$var$defaultTheme;
module.exports.default = $78a6869bc0459d01$var$_default;

});
parcelRegister("9pVSu", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMuiTheme = $6db3582e66ab40ac$var$createMuiTheme;
module.exports.default = void 0;

var $6db3582e66ab40ac$var$_defineProperty2 = $kr74f((parcelRequire("5TZlQ")));

var $6db3582e66ab40ac$var$_objectWithoutProperties2 = $kr74f((parcelRequire("gpjWH")));

var $52Kw7 = parcelRequire("52Kw7");

var $6db3582e66ab40ac$var$_createBreakpoints = $kr74f((parcelRequire("4F6dy")));

var $6db3582e66ab40ac$var$_createMixins = $kr74f((parcelRequire("5C8LF")));

var $6db3582e66ab40ac$var$_createPalette = $kr74f((parcelRequire("hbWnT")));

var $6db3582e66ab40ac$var$_createTypography = $kr74f((parcelRequire("2CfzN")));

var $6db3582e66ab40ac$var$_shadows = $kr74f((parcelRequire("ifzPh")));

var $6db3582e66ab40ac$var$_shape = $kr74f((parcelRequire("5Qt12")));

var $6db3582e66ab40ac$var$_createSpacing = $kr74f((parcelRequire("5bRs5")));

var $6db3582e66ab40ac$var$_transitions = $kr74f((parcelRequire("1aiNk")));

var $6db3582e66ab40ac$var$_zIndex = $kr74f((parcelRequire("iXzQn")));
function $6db3582e66ab40ac$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $6db3582e66ab40ac$var$_objectWithoutProperties2.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $6db3582e66ab40ac$var$_createPalette.default)(paletteInput);
    var breakpoints = (0, $6db3582e66ab40ac$var$_createBreakpoints.default)(breakpointsInput);
    var spacing = (0, $6db3582e66ab40ac$var$_createSpacing.default)(spacingInput);
    var muiTheme = (0, $52Kw7.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        mixins: (0, $6db3582e66ab40ac$var$_createMixins.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: $6db3582e66ab40ac$var$_shadows.default,
        typography: (0, $6db3582e66ab40ac$var$_createTypography.default)(palette, typographyInput),
        spacing: spacing,
        shape: $6db3582e66ab40ac$var$_shape.default,
        transitions: $6db3582e66ab40ac$var$_transitions.default,
        zIndex: $6db3582e66ab40ac$var$_zIndex.default
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $52Kw7.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $6db3582e66ab40ac$var$warnedOnce = false;
function $6db3582e66ab40ac$var$createMuiTheme() {
    return $6db3582e66ab40ac$var$createTheme.apply(void 0, arguments);
}
var $6db3582e66ab40ac$var$_default = $6db3582e66ab40ac$var$createTheme;
module.exports.default = $6db3582e66ab40ac$var$_default;

});
parcelRegister("4F6dy", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $364fd073361fba06$var$createBreakpoints;
module.exports.keys = void 0;

var $364fd073361fba06$var$_extends2 = $kr74f((parcelRequire("1S7Z7")));

var $364fd073361fba06$var$_objectWithoutProperties2 = $kr74f((parcelRequire("gpjWH")));
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var $364fd073361fba06$var$keys = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
]; // Keep in mind that @media is inclusive by the CSS specification.
module.exports.keys = $364fd073361fba06$var$keys;
function $364fd073361fba06$var$createBreakpoints(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? "px" : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $364fd073361fba06$var$_objectWithoutProperties2.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $364fd073361fba06$var$keys.indexOf(key) + 1;
        var upperbound = values[$364fd073361fba06$var$keys[endIndex]];
        if (endIndex === $364fd073361fba06$var$keys.length) // xl down applies to all sizes
        return up("xs");
        var value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $364fd073361fba06$var$keys.indexOf(end);
        if (endIndex === $364fd073361fba06$var$keys.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$364fd073361fba06$var$keys[endIndex + 1]] === "number" ? values[$364fd073361fba06$var$keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $364fd073361fba06$var$_extends2.default)({
        keys: $364fd073361fba06$var$keys,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});
parcelRegister("1S7Z7", function(module, exports) {
function $15d10734a78b6931$var$_extends() {
    module.exports = $15d10734a78b6931$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $15d10734a78b6931$var$_extends.apply(this, arguments);
}
module.exports = $15d10734a78b6931$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5C8LF", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $41674d7bd84c6747$var$createMixins;

var $41674d7bd84c6747$var$_defineProperty2 = $kr74f((parcelRequire("5TZlQ")));

var $41674d7bd84c6747$var$_extends3 = $kr74f((parcelRequire("1S7Z7")));
function $41674d7bd84c6747$var$createMixins(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $41674d7bd84c6747$var$_extends3.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                "Material-UI: theme.mixins.gutters() is deprecated.",
                "You can use the source of the mixin directly:",
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join("\n"));
            return (0, $41674d7bd84c6747$var$_extends3.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $41674d7bd84c6747$var$_defineProperty2.default)({}, breakpoints.up("sm"), (0, $41674d7bd84c6747$var$_extends3.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up("sm")])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $41674d7bd84c6747$var$_defineProperty2.default)(_toolbar, "".concat(breakpoints.up("xs"), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $41674d7bd84c6747$var$_defineProperty2.default)(_toolbar, breakpoints.up("sm"), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("hbWnT", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c840c0a53470fdd1$var$createPalette;
module.exports.dark = module.exports.light = void 0;

var $c840c0a53470fdd1$var$_extends2 = $kr74f((parcelRequire("1S7Z7")));

var $c840c0a53470fdd1$var$_objectWithoutProperties2 = $kr74f((parcelRequire("gpjWH")));

var $52Kw7 = parcelRequire("52Kw7");
var $eQGDD = parcelRequire("eQGDD");

var $c840c0a53470fdd1$var$_common = $kr74f((parcelRequire("GL84D")));

var $c840c0a53470fdd1$var$_grey = $kr74f((parcelRequire("fHq20")));

var $c840c0a53470fdd1$var$_indigo = $kr74f((parcelRequire("hkruX")));

var $c840c0a53470fdd1$var$_pink = $kr74f((parcelRequire("9A1l2")));

var $c840c0a53470fdd1$var$_red = $kr74f((parcelRequire("9TU8e")));

var $c840c0a53470fdd1$var$_orange = $kr74f((parcelRequire("38U5b")));

var $c840c0a53470fdd1$var$_blue = $kr74f((parcelRequire("9TKwO")));

var $c840c0a53470fdd1$var$_green = $kr74f((parcelRequire("kgwK7")));

var $6U1Fo = parcelRequire("6U1Fo");
var $c840c0a53470fdd1$var$light = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.54)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)",
        // Text hints.
        hint: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: $c840c0a53470fdd1$var$_common.default.white,
        default: $c840c0a53470fdd1$var$_grey.default[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
module.exports.light = $c840c0a53470fdd1$var$light;
var $c840c0a53470fdd1$var$dark = {
    text: {
        primary: $c840c0a53470fdd1$var$_common.default.white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        hint: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: $c840c0a53470fdd1$var$_grey.default[800],
        default: "#303030"
    },
    action: {
        active: $c840c0a53470fdd1$var$_common.default.white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
module.exports.dark = $c840c0a53470fdd1$var$dark;
function $c840c0a53470fdd1$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $6U1Fo.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $6U1Fo.darken)(intent.main, tonalOffsetDark);
    }
}
function $c840c0a53470fdd1$var$createPalette(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: $c840c0a53470fdd1$var$_indigo.default[300],
        main: $c840c0a53470fdd1$var$_indigo.default[500],
        dark: $c840c0a53470fdd1$var$_indigo.default[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: $c840c0a53470fdd1$var$_pink.default.A200,
        main: $c840c0a53470fdd1$var$_pink.default.A400,
        dark: $c840c0a53470fdd1$var$_pink.default.A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: $c840c0a53470fdd1$var$_red.default[300],
        main: $c840c0a53470fdd1$var$_red.default[500],
        dark: $c840c0a53470fdd1$var$_red.default[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: $c840c0a53470fdd1$var$_orange.default[300],
        main: $c840c0a53470fdd1$var$_orange.default[500],
        dark: $c840c0a53470fdd1$var$_orange.default[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: $c840c0a53470fdd1$var$_blue.default[300],
        main: $c840c0a53470fdd1$var$_blue.default[500],
        dark: $c840c0a53470fdd1$var$_blue.default[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: $c840c0a53470fdd1$var$_green.default[300],
        main: $c840c0a53470fdd1$var$_green.default[500],
        dark: $c840c0a53470fdd1$var$_green.default[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? "light" : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $c840c0a53470fdd1$var$_objectWithoutProperties2.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $6U1Fo.getContrastRatio)(background, $c840c0a53470fdd1$var$dark.text.primary) >= contrastThreshold ? $c840c0a53470fdd1$var$dark.text.primary : $c840c0a53470fdd1$var$light.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $c840c0a53470fdd1$var$_extends2.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $eQGDD.default)(4, mainShade));
        if (typeof color.main !== "string") throw new Error(_formatMuiErrorMessage(5, JSON.stringify(color.main)));
        $c840c0a53470fdd1$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $c840c0a53470fdd1$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $c840c0a53470fdd1$var$dark,
        light: $c840c0a53470fdd1$var$light
    };
    var paletteOutput = (0, $52Kw7.default)((0, $c840c0a53470fdd1$var$_extends2.default)({
        // A collection of common colors.
        common: $c840c0a53470fdd1$var$_common.default,
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, "A400", "A200", "A700"),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: $c840c0a53470fdd1$var$_grey.default,
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("GL84D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $08087b3d7088e0bf$var$common = {
    black: "#000",
    white: "#fff"
};
var $08087b3d7088e0bf$var$_default = $08087b3d7088e0bf$var$common;
module.exports.default = $08087b3d7088e0bf$var$_default;

});

parcelRegister("fHq20", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $b6df107215d21529$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161"
};
var $b6df107215d21529$var$_default = $b6df107215d21529$var$grey;
module.exports.default = $b6df107215d21529$var$_default;

});

parcelRegister("hkruX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $c9d9a27eceb6b7b2$var$indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
var $c9d9a27eceb6b7b2$var$_default = $c9d9a27eceb6b7b2$var$indigo;
module.exports.default = $c9d9a27eceb6b7b2$var$_default;

});

parcelRegister("9A1l2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $6f98839bfdefd557$var$pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
var $6f98839bfdefd557$var$_default = $6f98839bfdefd557$var$pink;
module.exports.default = $6f98839bfdefd557$var$_default;

});

parcelRegister("9TU8e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $7354cab6900a460d$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $7354cab6900a460d$var$_default = $7354cab6900a460d$var$red;
module.exports.default = $7354cab6900a460d$var$_default;

});

parcelRegister("38U5b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $249d9f451b6f3686$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $249d9f451b6f3686$var$_default = $249d9f451b6f3686$var$orange;
module.exports.default = $249d9f451b6f3686$var$_default;

});

parcelRegister("9TKwO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $734d57aae86acf0f$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $734d57aae86acf0f$var$_default = $734d57aae86acf0f$var$blue;
module.exports.default = $734d57aae86acf0f$var$_default;

});

parcelRegister("kgwK7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $ec0eb35761bf6f36$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $ec0eb35761bf6f36$var$_default = $ec0eb35761bf6f36$var$green;
module.exports.default = $ec0eb35761bf6f36$var$_default;

});


parcelRegister("2CfzN", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1e7b3682aba463c5$var$createTypography;

var $1e7b3682aba463c5$var$_extends2 = $kr74f((parcelRequire("1S7Z7")));

var $1e7b3682aba463c5$var$_objectWithoutProperties2 = $kr74f((parcelRequire("gpjWH")));

var $52Kw7 = parcelRequire("52Kw7");
function $1e7b3682aba463c5$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $1e7b3682aba463c5$var$warnedOnce = false;
function $1e7b3682aba463c5$var$roundWithDeprecationWarning(value) {
    return $1e7b3682aba463c5$var$round(value);
}
var $1e7b3682aba463c5$var$caseAllCaps = {
    textTransform: "uppercase"
};
var $1e7b3682aba463c5$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */ function $1e7b3682aba463c5$var$createTypography(palette, typography) {
    var _ref = typeof typography === "function" ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $1e7b3682aba463c5$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $1e7b3682aba463c5$var$_objectWithoutProperties2.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $1e7b3682aba463c5$var$_extends2.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $1e7b3682aba463c5$var$defaultFontFamily ? {
            letterSpacing: "".concat($1e7b3682aba463c5$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $1e7b3682aba463c5$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $1e7b3682aba463c5$var$caseAllCaps)
    };
    return (0, $52Kw7.default)((0, $1e7b3682aba463c5$var$_extends2.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $1e7b3682aba463c5$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("ifzPh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $d4956b09733361f6$var$shadowKeyUmbraOpacity = 0.2;
var $d4956b09733361f6$var$shadowKeyPenumbraOpacity = 0.14;
var $d4956b09733361f6$var$shadowAmbientShadowOpacity = 0.12;
function $d4956b09733361f6$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($d4956b09733361f6$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($d4956b09733361f6$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($d4956b09733361f6$var$shadowAmbientShadowOpacity, ")")
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $d4956b09733361f6$var$shadows = [
    "none",
    $d4956b09733361f6$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $d4956b09733361f6$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $d4956b09733361f6$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $d4956b09733361f6$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $d4956b09733361f6$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $d4956b09733361f6$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $d4956b09733361f6$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $d4956b09733361f6$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $d4956b09733361f6$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $d4956b09733361f6$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $d4956b09733361f6$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $d4956b09733361f6$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $d4956b09733361f6$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $d4956b09733361f6$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $d4956b09733361f6$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $d4956b09733361f6$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $d4956b09733361f6$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $d4956b09733361f6$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $d4956b09733361f6$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $d4956b09733361f6$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $d4956b09733361f6$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $d4956b09733361f6$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $d4956b09733361f6$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $d4956b09733361f6$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $d4956b09733361f6$var$_default = $d4956b09733361f6$var$shadows;
module.exports.default = $d4956b09733361f6$var$_default;

});

parcelRegister("5Qt12", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $441850fd9931b6a9$var$shape = {
    borderRadius: 4
};
var $441850fd9931b6a9$var$_default = $441850fd9931b6a9$var$shape;
module.exports.default = $441850fd9931b6a9$var$_default;

});

parcelRegister("5bRs5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3c77714f22c1552e$var$createSpacing;

var $1vnm9 = parcelRequire("1vnm9");
var $3c77714f22c1552e$var$warnOnce;
function $3c77714f22c1552e$var$createSpacing() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $1vnm9.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === "string") return argument;
            var output = transform(argument);
            return typeof output === "number" ? "".concat(output, "px") : output;
        }).join(" ");
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, "unit", {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("1aiNk", function(module, exports) {
"use strict";

var $kr74f = parcelRequire("kr74f");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.duration = module.exports.easing = void 0;

var $0d954dd46dbb639a$var$_objectWithoutProperties2 = $kr74f((parcelRequire("gpjWH")));
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var $0d954dd46dbb639a$var$easing = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
module.exports.easing = $0d954dd46dbb639a$var$easing;
var $0d954dd46dbb639a$var$duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
module.exports.duration = $0d954dd46dbb639a$var$duration;
function $0d954dd46dbb639a$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ var $0d954dd46dbb639a$var$_default = {
    easing: $0d954dd46dbb639a$var$easing,
    duration: $0d954dd46dbb639a$var$duration,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            "all"
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $0d954dd46dbb639a$var$duration.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $0d954dd46dbb639a$var$easing.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $0d954dd46dbb639a$var$_objectWithoutProperties2.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : $0d954dd46dbb639a$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === "string" ? delay : $0d954dd46dbb639a$var$formatMs(delay));
        }).join(",");
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};
module.exports.default = $0d954dd46dbb639a$var$_default;

});

parcelRegister("iXzQn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $dcd98a827479aed6$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $dcd98a827479aed6$var$_default = $dcd98a827479aed6$var$zIndex;
module.exports.default = $dcd98a827479aed6$var$_default;

});



parcelRegister("htvgE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb8d66339f64ca33$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");



var $cgNhc = parcelRequire("cgNhc");

var $2XZwC = parcelRequire("2XZwC");

var $j1k3T = parcelRequire("j1k3T");

var $zFv3V = parcelRequire("zFv3V");

var $gIuBF = parcelRequire("gIuBF");
var $cb8d66339f64ca33$export$da34bb2ed94165a0 = function isWidthUp(breakpoint, width) {
    var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (inclusive) return (0, $zFv3V.keys).indexOf(breakpoint) <= (0, $zFv3V.keys).indexOf(width);
    return (0, $zFv3V.keys).indexOf(breakpoint) < (0, $zFv3V.keys).indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.
var $cb8d66339f64ca33$export$43a67ae92cf379e6 = function isWidthDown(breakpoint, width) {
    var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (inclusive) return (0, $zFv3V.keys).indexOf(width) <= (0, $zFv3V.keys).indexOf(breakpoint);
    return (0, $zFv3V.keys).indexOf(width) < (0, $zFv3V.keys).indexOf(breakpoint);
};
var $cb8d66339f64ca33$var$useEnhancedEffect = typeof window === "undefined" ? $arQ7u.useEffect : $arQ7u.useLayoutEffect;
var $cb8d66339f64ca33$var$withWidth = function withWidth() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(Component) {
        var _options$withTheme = options.withTheme, withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme, _options$noSSR = options.noSSR, noSSR = _options$noSSR === void 0 ? false : _options$noSSR, initialWidthOption = options.initialWidth;
        function WithWidth(props) {
            var contextTheme = (0, $j1k3T.default)();
            var theme = props.theme || contextTheme;
            var _getThemeProps = (0, $cgNhc.default)({
                theme: theme,
                name: "MuiWithWidth",
                props: (0, $abElG.default)({}, props)
            }), initialWidth = _getThemeProps.initialWidth, width = _getThemeProps.width, other = (0, $dXEVX.default)(_getThemeProps, [
                "initialWidth",
                "width"
            ]);
            var _React$useState = $arQ7u.useState(false), mountedState = _React$useState[0], setMountedState = _React$useState[1];
            $cb8d66339f64ca33$var$useEnhancedEffect(function() {
                setMountedState(true);
            }, []);
            /**
       * innerWidth |xs      sm      md      lg      xl
       *            |-------|-------|-------|-------|------>
       * width      |  xs   |  sm   |  md   |  lg   |  xl
       */ var keys = theme.breakpoints.keys.slice().reverse();
            var widthComputed = keys.reduce(function(output, key) {
                // eslint-disable-next-line react-hooks/rules-of-hooks
                var matches = (0, $gIuBF.default)(theme.breakpoints.up(key));
                return !output && matches ? key : output;
            }, null);
            var more = (0, $abElG.default)({
                width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
            }, withThemeOption ? {
                theme: theme
            } : {}, other); // When rendering the component on the server,
            // we have no idea about the client browser screen width.
            // In order to prevent blinks and help the reconciliation of the React tree
            // we are not rendering the child component.
            //
            // An alternative is to use the `initialWidth` property.
            if (more.width === undefined) return null;
            return /*#__PURE__*/ $arQ7u.createElement(Component, more);
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($2XZwC)))(WithWidth, Component);
        return WithWidth;
    };
};
var $cb8d66339f64ca33$export$2e2bcd8739ae039 = $cb8d66339f64ca33$var$withWidth;

});
parcelRegister("gIuBF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2b87f39eb7e748d$export$2e2bcd8739ae039; });

var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");

var $cgNhc = parcelRequire("cgNhc");
var $gkz9m = parcelRequire("gkz9m");
function $c2b87f39eb7e748d$export$2e2bcd8739ae039(queryInput) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var theme = (0, $gkz9m.default)();
    var props = (0, $cgNhc.default)({
        theme: theme,
        name: "MuiUseMediaQuery",
        props: {}
    });
    var query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, ""); // Wait for jsdom to support the match media feature.
    // All the browsers Material-UI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    var supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    var _props$options = (0, $abElG.default)({}, props, options), _props$options$defaul = _props$options.defaultMatches, defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul, _props$options$matchM = _props$options.matchMedia, matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM, _props$options$noSsr = _props$options.noSsr, noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr, _props$options$ssrMat = _props$options.ssrMatchMedia, ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
    var _React$useState = $arQ7u.useState(function() {
        if (noSsr && supportMatchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
         // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    }), match = _React$useState[0], setMatch = _React$useState[1];
    $arQ7u.useEffect(function() {
        var active = true;
        if (!supportMatchMedia) return undefined;
        var queryList = matchMedia(query);
        var updateMatch = function updateMatch() {
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addListener(updateMatch);
        return function() {
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia,
        supportMatchMedia
    ]);
    return match;
}

});



var $arQ7u = parcelRequire("arQ7u");

var $9sDDw = parcelRequire("9sDDw");
parcelRequire("9dO3T");
var $iEjUn = parcelRequire("iEjUn");

var $arQ7u = parcelRequire("arQ7u");

var $arQ7u = parcelRequire("arQ7u");

var $lLUHy = parcelRequire("lLUHy");

var $hRjpy = parcelRequire("hRjpy");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $eBGBV = parcelRequire("eBGBV");
function $877f9dd7da0b1ac9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $877f9dd7da0b1ac9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $877f9dd7da0b1ac9$var$ownKeys(Object(source), true).forEach(function(key) {
            $877f9dd7da0b1ac9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $877f9dd7da0b1ac9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $877f9dd7da0b1ac9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $877f9dd7da0b1ac9$var$_toConsumableArray(arr) {
    return $877f9dd7da0b1ac9$var$_arrayWithoutHoles(arr) || $877f9dd7da0b1ac9$var$_iterableToArray(arr) || $877f9dd7da0b1ac9$var$_unsupportedIterableToArray(arr) || $877f9dd7da0b1ac9$var$_nonIterableSpread();
}
function $877f9dd7da0b1ac9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $877f9dd7da0b1ac9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $877f9dd7da0b1ac9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $877f9dd7da0b1ac9$var$_arrayLikeToArray(o, minLen);
}
function $877f9dd7da0b1ac9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $877f9dd7da0b1ac9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $877f9dd7da0b1ac9$var$_arrayLikeToArray(arr);
}
function $877f9dd7da0b1ac9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $877f9dd7da0b1ac9$export$d5ae3cb823789a24(plugins) {
    return plugins.reduce(function(map, plugin) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hRjpy)))(map, [
            plugin.target,
            plugin.mode
        ], function(x) {
            return [].concat($877f9dd7da0b1ac9$var$_toConsumableArray(x || []), [
                plugin
            ]);
        });
    }, {});
}
function $877f9dd7da0b1ac9$export$59eb6ae2602ec702(plugins) {
    return plugins.map(function(plugin) {
        return $877f9dd7da0b1ac9$var$_objectSpread($877f9dd7da0b1ac9$var$_objectSpread({}, plugin), {}, {
            component: $877f9dd7da0b1ac9$var$connectPluginComponent(plugin)
        });
    });
}
function $877f9dd7da0b1ac9$export$4c96acacd9a12aa5(plugins) {
    plugins.filter(function(p) {
        return p.companionWindowKey;
    }).forEach(function(plugin) {
        (0, $eBGBV.default)[plugin.companionWindowKey] = plugin.component;
    });
    return 0, $eBGBV.default;
}
/** Connect plugin component to state */ function $877f9dd7da0b1ac9$var$connectPluginComponent(plugin) {
    if (!plugin.mapStateToProps && !plugin.mapDispatchToProps) return plugin.component;
    return (0, $fbonu.default).apply(void 0, [
        plugin.mapStateToProps,
        plugin.mapDispatchToProps
    ].concat($877f9dd7da0b1ac9$var$_toConsumableArray(plugin.connectOptions || [])))(plugin.component);
}


function $e79aa799f7ed2e4a$var$_slicedToArray(arr, i) {
    return $e79aa799f7ed2e4a$var$_arrayWithHoles(arr) || $e79aa799f7ed2e4a$var$_iterableToArrayLimit(arr, i) || $e79aa799f7ed2e4a$var$_unsupportedIterableToArray(arr, i) || $e79aa799f7ed2e4a$var$_nonIterableRest();
}
function $e79aa799f7ed2e4a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e79aa799f7ed2e4a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e79aa799f7ed2e4a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e79aa799f7ed2e4a$var$_arrayLikeToArray(o, minLen);
}
function $e79aa799f7ed2e4a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e79aa799f7ed2e4a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e79aa799f7ed2e4a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e79aa799f7ed2e4a$export$2e2bcd8739ae039(props) {
    var plugins = props.plugins, children = props.children;
    var _useState = (0, $arQ7u.useState)({}), _useState2 = $e79aa799f7ed2e4a$var$_slicedToArray(_useState, 2), pluginMap = _useState2[0], setPluginMap = _useState2[1];
    (0, $arQ7u.useEffect)(function() {
        var connectedPlugins = (0, $877f9dd7da0b1ac9$export$59eb6ae2602ec702)(plugins);
        (0, $877f9dd7da0b1ac9$export$4c96acacd9a12aa5)(connectedPlugins);
        setPluginMap((0, $877f9dd7da0b1ac9$export$d5ae3cb823789a24)(connectedPlugins));
    }, [
        plugins
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $lLUHy.default).Provider, {
        value: pluginMap
    }, children);
}
$e79aa799f7ed2e4a$export$2e2bcd8739ae039.defaultProps = {
    children: null,
    plugins: []
};



var $k19ic = parcelRequire("k19ic");
parcelRequire("9dO3T");
var $fbonu = parcelRequire("fbonu");

var $7XHRd = parcelRequire("7XHRd");

var $bcVRp = parcelRequire("bcVRp");

var $jGts0 = parcelRequire("jGts0");
var $3DW53 = parcelRequire("3DW53");

var $arQ7u = parcelRequire("arQ7u");
var $99ce74d8590d35ce$exports = {};
"use strict";
Object.defineProperty($99ce74d8590d35ce$exports, "__esModule", {
    value: true
});
var $99ce74d8590d35ce$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $arQ7u = parcelRequire("arQ7u");
var $99ce74d8590d35ce$var$_react2 = $99ce74d8590d35ce$var$_interopRequireDefault($arQ7u);

var $4Jbg8 = parcelRequire("4Jbg8");
var $99ce74d8590d35ce$var$_propTypes2 = $99ce74d8590d35ce$var$_interopRequireDefault($4Jbg8);
var $52a98507112c0ee9$exports = {};

$parcel$defineInteropFlag($52a98507112c0ee9$exports);

$parcel$export($52a98507112c0ee9$exports, "default", function () { return $52a98507112c0ee9$export$2e2bcd8739ae039; });
var $52a98507112c0ee9$var$key = {
    fullscreenEnabled: 0,
    fullscreenElement: 1,
    requestFullscreen: 2,
    exitFullscreen: 3,
    fullscreenchange: 4,
    fullscreenerror: 5,
    fullscreen: 6
};
var $52a98507112c0ee9$var$webkit = [
    "webkitFullscreenEnabled",
    "webkitFullscreenElement",
    "webkitRequestFullscreen",
    "webkitExitFullscreen",
    "webkitfullscreenchange",
    "webkitfullscreenerror",
    "-webkit-full-screen"
];
var $52a98507112c0ee9$var$moz = [
    "mozFullScreenEnabled",
    "mozFullScreenElement",
    "mozRequestFullScreen",
    "mozCancelFullScreen",
    "mozfullscreenchange",
    "mozfullscreenerror",
    "-moz-full-screen"
];
var $52a98507112c0ee9$var$ms = [
    "msFullscreenEnabled",
    "msFullscreenElement",
    "msRequestFullscreen",
    "msExitFullscreen",
    "MSFullscreenChange",
    "MSFullscreenError",
    "-ms-fullscreen"
];
// so it doesn't throw if no window or document
var $52a98507112c0ee9$var$document = typeof window !== "undefined" && typeof window.document !== "undefined" ? window.document : {};
var $52a98507112c0ee9$var$vendor = "fullscreenEnabled" in $52a98507112c0ee9$var$document && Object.keys($52a98507112c0ee9$var$key) || $52a98507112c0ee9$var$webkit[0] in $52a98507112c0ee9$var$document && $52a98507112c0ee9$var$webkit || $52a98507112c0ee9$var$moz[0] in $52a98507112c0ee9$var$document && $52a98507112c0ee9$var$moz || $52a98507112c0ee9$var$ms[0] in $52a98507112c0ee9$var$document && $52a98507112c0ee9$var$ms || [];
var $52a98507112c0ee9$var$fscreen = {
    requestFullscreen: function(element) {
        return element[$52a98507112c0ee9$var$vendor[$52a98507112c0ee9$var$key.requestFullscreen]]();
    },
    requestFullscreenFunction: function(element) {
        return element[$52a98507112c0ee9$var$vendor[$52a98507112c0ee9$var$key.requestFullscreen]];
    },
    get exitFullscreen () {
        return $52a98507112c0ee9$var$document[$52a98507112c0ee9$var$vendor[$52a98507112c0ee9$var$key.exitFullscreen]].bind($52a98507112c0ee9$var$document);
    },
    get fullscreenPseudoClass () {
        return ":" + $52a98507112c0ee9$var$vendor[$52a98507112c0ee9$var$key.fullscreen];
    },
    addEventListener: function(type, handler1, options) {
        return $52a98507112c0ee9$var$document.addEventListener($52a98507112c0ee9$var$vendor[$52a98507112c0ee9$var$key[type]], handler1, options);
    },
    removeEventListener: function(type, handler1, options) {
        return $52a98507112c0ee9$var$document.removeEventListener($52a98507112c0ee9$var$vendor[$52a98507112c0ee9$var$key[type]], handler1, options);
    },
    get fullscreenEnabled () {
        return Boolean($52a98507112c0ee9$var$document[$52a98507112c0ee9$var$vendor[$52a98507112c0ee9$var$key.fullscreenEnabled]]);
    },
    set fullscreenEnabled (val){},
    get fullscreenElement () {
        return $52a98507112c0ee9$var$document[$52a98507112c0ee9$var$vendor[$52a98507112c0ee9$var$key.fullscreenElement]];
    },
    set fullscreenElement (val){},
    get onfullscreenchange () {
        return $52a98507112c0ee9$var$document[("on" + $52a98507112c0ee9$var$vendor[$52a98507112c0ee9$var$key.fullscreenchange]).toLowerCase()];
    },
    set onfullscreenchange (handler){
        return $52a98507112c0ee9$var$document[("on" + $52a98507112c0ee9$var$vendor[$52a98507112c0ee9$var$key.fullscreenchange]).toLowerCase()] = handler;
    },
    get onfullscreenerror () {
        return $52a98507112c0ee9$var$document[("on" + $52a98507112c0ee9$var$vendor[$52a98507112c0ee9$var$key.fullscreenerror]).toLowerCase()];
    },
    set onfullscreenerror (handler){
        return $52a98507112c0ee9$var$document[("on" + $52a98507112c0ee9$var$vendor[$52a98507112c0ee9$var$key.fullscreenerror]).toLowerCase()] = handler;
    }
};
var $52a98507112c0ee9$export$2e2bcd8739ae039 = $52a98507112c0ee9$var$fscreen;


var $99ce74d8590d35ce$var$_fscreen2 = $99ce74d8590d35ce$var$_interopRequireDefault($52a98507112c0ee9$exports);
function $99ce74d8590d35ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $99ce74d8590d35ce$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $99ce74d8590d35ce$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $99ce74d8590d35ce$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $99ce74d8590d35ce$var$FullScreen = function(_Component) {
    $99ce74d8590d35ce$var$_inherits(FullScreen, _Component);
    function FullScreen(props) {
        $99ce74d8590d35ce$var$_classCallCheck(this, FullScreen);
        var _this = $99ce74d8590d35ce$var$_possibleConstructorReturn(this, (FullScreen.__proto__ || Object.getPrototypeOf(FullScreen)).call(this, props));
        _this.fullScreenElement = null;
        _this.detectFullScreen = _this.detectFullScreen.bind(_this);
        return _this;
    }
    $99ce74d8590d35ce$var$_createClass(FullScreen, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                $99ce74d8590d35ce$var$_fscreen2.default.addEventListener("fullscreenchange", this.detectFullScreen);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                $99ce74d8590d35ce$var$_fscreen2.default.removeEventListener("fullscreenchange", this.detectFullScreen);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.handleProps(this.props);
            }
        },
        {
            key: "handleProps",
            value: function handleProps(props) {
                var enabled = $99ce74d8590d35ce$var$_fscreen2.default.fullscreenElement === this.node;
                if (enabled && !props.enabled) this.leaveFullScreen();
                else if (!enabled && props.enabled) this.enterFullScreen();
            }
        },
        {
            key: "detectFullScreen",
            value: function detectFullScreen() {
                if ($99ce74d8590d35ce$var$_fscreen2.default.fullscreenElement === this.node) {
                    this.fullScreenElement = $99ce74d8590d35ce$var$_fscreen2.default.fullscreenElement;
                    this.props.onChange(true);
                } else if (!$99ce74d8590d35ce$var$_fscreen2.default.fullscreenElement && this.fullScreenElement) {
                    this.fullScreenElement = null;
                    this.props.onChange(false);
                }
            }
        },
        {
            key: "enterFullScreen",
            value: function enterFullScreen() {
                if ($99ce74d8590d35ce$var$_fscreen2.default.fullscreenEnabled) $99ce74d8590d35ce$var$_fscreen2.default.requestFullscreen(this.node);
            }
        },
        {
            key: "leaveFullScreen",
            value: function leaveFullScreen() {
                if ($99ce74d8590d35ce$var$_fscreen2.default.fullscreenEnabled) $99ce74d8590d35ce$var$_fscreen2.default.exitFullscreen();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var className = [
                    "fullscreen"
                ];
                if (this.props.enabled) className.push("fullscreen-enabled");
                return $99ce74d8590d35ce$var$_react2.default.createElement("div", {
                    className: className.join(" "),
                    ref: function ref(node) {
                        return _this2.node = node;
                    },
                    style: this.props.enabled ? {
                        height: "100%",
                        width: "100%"
                    } : undefined
                }, this.props.children);
            }
        }
    ]);
    return FullScreen;
}($arQ7u.Component);
$99ce74d8590d35ce$var$FullScreen.propTypes = {
    children: $99ce74d8590d35ce$var$_propTypes2.default.node.isRequired,
    enabled: $99ce74d8590d35ce$var$_propTypes2.default.bool.isRequired,
    onChange: $99ce74d8590d35ce$var$_propTypes2.default.func
};
$99ce74d8590d35ce$var$FullScreen.defaultProps = {
    enabled: false,
    onChange: function onChange() {
        return void 0;
    }
};
$99ce74d8590d35ce$exports.default = $99ce74d8590d35ce$var$FullScreen;



var $arQ7u = parcelRequire("arQ7u");

var $8LHwv = parcelRequire("8LHwv");
function $63291e5e77f7ce3a$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $arQ7u.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $arQ7u.createElement)((0, $8LHwv.I18nContext).Provider, {
        value: value
    }, children);
}


parcelRequire("cox1R");
var $7Abnn = parcelRequire("7Abnn");

var $iPknr = parcelRequire("iPknr");
var $ecQ1P = parcelRequire("ecQ1P");
var $85CAN = parcelRequire("85CAN");
var $6OzM9 = parcelRequire("6OzM9");
var $abElG = parcelRequire("abElG");

var $arQ7u = parcelRequire("arQ7u");



var $1oPzq = parcelRequire("1oPzq");

var $gkz9m = parcelRequire("gkz9m");

var $k7dzb = parcelRequire("k7dzb");
function $b4da39daca98febb$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        var mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $abElG.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $b4da39daca98febb$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $gkz9m.default)();
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $b4da39daca98febb$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $k7dzb.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $1oPzq.default).Provider, {
        value: theme
    }, children);
}
var $b4da39daca98febb$export$2e2bcd8739ae039 = $b4da39daca98febb$var$ThemeProvider;



var $3nbWv = parcelRequire("3nbWv");
var $1lzPe = parcelRequire("1lzPe");
parcelRequire("iCfXF");
var $9I5De = parcelRequire("9I5De");

var $1I9Y5 = parcelRequire("1I9Y5");

var $1s5gz = parcelRequire("1s5gz");
var $12a7defa7c6ab0d1$exports = {};
"use strict";
Object.defineProperty($12a7defa7c6ab0d1$exports, "__esModule", {
    value: true
});
var $7e60d9bee0a9b4d1$exports = {};

$parcel$defineInteropFlag($7e60d9bee0a9b4d1$exports);

$parcel$export($7e60d9bee0a9b4d1$exports, "default", function () { return $7e60d9bee0a9b4d1$export$2e2bcd8739ae039; });
/**
 * Takes an array of [keyValue1, keyValue2] pairs and creates an object of {keyValue1: keyValue2, keyValue2: keyValue1}
 * @param {Array} array the array of pairs
 * @return {Object} the {key, value} pair object
 */ function $a7e7f8a39f99c8f0$export$2d1720544b23b823(array) {
    return array.reduce(function(obj, _ref) {
        var prop1 = _ref[0], prop2 = _ref[1];
        obj[prop1] = prop2;
        obj[prop2] = prop1;
        return obj;
    }, {});
}
function $a7e7f8a39f99c8f0$export$7ccc53e8f1e7dfc5(val) {
    return typeof val === "boolean";
}
function $a7e7f8a39f99c8f0$export$ae1af26003f05816(val) {
    return typeof val === "function";
}
function $a7e7f8a39f99c8f0$export$9e5f44173e64f162(val) {
    return typeof val === "number";
}
function $a7e7f8a39f99c8f0$export$43caf9889c228507(val) {
    return val === null || typeof val === "undefined";
}
function $a7e7f8a39f99c8f0$export$2408f22a0fab9ae5(val) {
    return val && typeof val === "object";
}
function $a7e7f8a39f99c8f0$export$625550452a3fa3ec(val) {
    return typeof val === "string";
}
function $a7e7f8a39f99c8f0$export$953cecd6e717a553(inclusive, inclusee) {
    return inclusive.indexOf(inclusee) !== -1;
}
/**
 * Flip the sign of a CSS value, possibly with a unit.
 *
 * We can't just negate the value with unary minus due to the units.
 *
 * @private
 * @param {String} value - the original value (for example 77%)
 * @return {String} the result (for example -77%)
 */ function $a7e7f8a39f99c8f0$export$342063e11d6c3cad(value) {
    if (parseFloat(value) === 0) // Don't mangle zeroes
    return value;
    if (value[0] === "-") return value.slice(1);
    return "-" + value;
}
function $a7e7f8a39f99c8f0$export$35e795649ee09318(match, prefix, offset, suffix) {
    return prefix + $a7e7f8a39f99c8f0$export$342063e11d6c3cad(offset) + suffix;
}
/**
 * Takes a percentage for background position and inverts it.
 * This was copied and modified from CSSJanus:
 * https://github.com/cssjanus/cssjanus/blob/4245f834365f6cfb0239191a151432fb85abab23/src/cssjanus.js#L152-L175
 * @param {String} value - the original value (for example 77%)
 * @return {String} the result (for example 23%)
 */ function $a7e7f8a39f99c8f0$export$dda1d9f60106f0e9(value) {
    var idx = value.indexOf(".");
    if (idx === -1) value = 100 - parseFloat(value) + "%";
    else {
        // Two off, one for the "%" at the end, one for the dot itself
        var len = value.length - idx - 2;
        value = 100 - parseFloat(value);
        value = value.toFixed(len) + "%";
    }
    return value;
}
/**
 * This takes a list of CSS values and converts it to an array
 * @param {String} value - something like `1px`, `1px 2em`, or `3pt rgb(150, 230, 550) 40px calc(100% - 5px)`
 * @return {Array} the split values (for example: `['3pt', 'rgb(150, 230, 550)', '40px', 'calc(100% - 5px)']`)
 */ function $a7e7f8a39f99c8f0$export$3b14a55fb2447963(value) {
    return value.replace(/ +/g, " ") // remove all extraneous spaces
    .split(" ").map(function(i) {
        return i.trim();
    }) // get rid of extra space before/after each item
    .filter(Boolean) // get rid of empty strings
    // join items which are within parenthese
    // luckily `calc (100% - 5px)` is invalid syntax and it must be `calc(100% - 5px)`, otherwise this would be even more complex
    .reduce(function(_ref2, item) {
        var list = _ref2.list, state = _ref2.state;
        var openParansCount = (item.match(/\(/g) || []).length;
        var closedParansCount = (item.match(/\)/g) || []).length;
        if (state.parensDepth > 0) list[list.length - 1] = list[list.length - 1] + " " + item;
        else list.push(item);
        state.parensDepth += openParansCount - closedParansCount;
        return {
            list: list,
            state: state
        };
    }, {
        list: [],
        state: {
            parensDepth: 0
        }
    }).list;
}
/**
 * This is intended for properties that are `top right bottom left` and will switch them to `top left bottom right`
 * @param {String} value - `1px 2px 3px 4px` for example, but also handles cases where there are too few/too many and
 * simply returns the value in those cases (which is the correct behavior)
 * @return {String} the result - `1px 4px 3px 2px` for example.
 */ function $a7e7f8a39f99c8f0$export$882b5998b3b9117c(value) {
    var splitValues = $a7e7f8a39f99c8f0$export$3b14a55fb2447963(value);
    if (splitValues.length <= 3 || splitValues.length > 4) return value;
    var top = splitValues[0], right = splitValues[1], bottom = splitValues[2], left = splitValues[3];
    return [
        top,
        left,
        bottom,
        right
    ].join(" ");
}
/**
 *
 * @param {String|Number|Object} value css property value to test
 * @returns If the css property value can(should?) have an RTL equivalent
 */ function $a7e7f8a39f99c8f0$export$23f2a1d2818174ef(value) {
    return !$a7e7f8a39f99c8f0$export$7ccc53e8f1e7dfc5(value) && !$a7e7f8a39f99c8f0$export$43caf9889c228507(value);
}
/**
 * Splits a shadow style into its separate shadows using the comma delimiter, but creating an exception
 * for comma separated values in parentheses often used for rgba colours.
 * @param {String} value
 * @returns {Array} array of all box shadow values in the string
 */ function $a7e7f8a39f99c8f0$export$efccba1c4a2ef57b(value) {
    var shadows = [];
    var start = 0;
    var end = 0;
    var rgba = false;
    while(end < value.length){
        if (!rgba && value[end] === ",") {
            shadows.push(value.substring(start, end).trim());
            end++;
            start = end;
        } else if (value[end] === "(") {
            rgba = true;
            end++;
        } else if (value[end] === ")") {
            rgba = false;
            end++;
        } else end++;
    }
    // push the last shadow value if there is one
    // istanbul ignore next
    if (start != end) shadows.push(value.substring(start, end + 1));
    return shadows;
}
// some values require a little fudging, that fudging goes here.
var $a7e7f8a39f99c8f0$export$ffb5f4729a158638 = {
    padding: function padding(_ref) {
        var value = _ref.value;
        if ($a7e7f8a39f99c8f0$export$9e5f44173e64f162(value)) return value;
        return $a7e7f8a39f99c8f0$export$882b5998b3b9117c(value);
    },
    textShadow: function textShadow(_ref2) {
        var value = _ref2.value;
        var flippedShadows = $a7e7f8a39f99c8f0$export$efccba1c4a2ef57b(value).map(function(shadow) {
            // intentionally leaving off the `g` flag here because we only want to change the first number (which is the offset-x)
            return shadow.replace(/(^|\s)(-*)([.|\d]+)/, function(match, whiteSpace, negative, number) {
                if (number === "0") return match;
                var doubleNegative = negative === "" ? "-" : "";
                return "" + whiteSpace + doubleNegative + number;
            });
        });
        return flippedShadows.join(",");
    },
    borderColor: function borderColor(_ref3) {
        var value = _ref3.value;
        return $a7e7f8a39f99c8f0$export$882b5998b3b9117c(value);
    },
    borderRadius: function borderRadius(_ref4) {
        var value = _ref4.value;
        if ($a7e7f8a39f99c8f0$export$9e5f44173e64f162(value)) return value;
        if ($a7e7f8a39f99c8f0$export$953cecd6e717a553(value, "/")) {
            var _value$split = value.split("/"), radius1 = _value$split[0], radius2 = _value$split[1];
            var convertedRadius1 = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.borderRadius({
                value: radius1.trim()
            });
            var convertedRadius2 = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.borderRadius({
                value: radius2.trim()
            });
            return convertedRadius1 + " / " + convertedRadius2;
        }
        var splitValues = $a7e7f8a39f99c8f0$export$3b14a55fb2447963(value);
        switch(splitValues.length){
            case 2:
                return splitValues.reverse().join(" ");
            case 4:
                var topLeft = splitValues[0], topRight = splitValues[1], bottomRight = splitValues[2], bottomLeft = splitValues[3];
                return [
                    topRight,
                    topLeft,
                    bottomLeft,
                    bottomRight
                ].join(" ");
            default:
                return value;
        }
    },
    background: function background(_ref5) {
        var value = _ref5.value, valuesToConvert = _ref5.valuesToConvert, isRtl = _ref5.isRtl, bgImgDirectionRegex = _ref5.bgImgDirectionRegex, bgPosDirectionRegex = _ref5.bgPosDirectionRegex;
        if ($a7e7f8a39f99c8f0$export$9e5f44173e64f162(value)) return value;
        // Yeah, this is in need of a refactor 🙃...
        // but this property is a tough cookie 🍪
        // get the backgroundPosition out of the string by removing everything that couldn't be the backgroundPosition value
        var backgroundPositionValue = value.replace(/(url\(.*?\))|(rgba?\(.*?\))|(hsl\(.*?\))|(#[a-fA-F0-9]+)|((^| )(\D)+( |$))/g, "").trim();
        // replace that backgroundPosition value with the converted version
        value = value.replace(backgroundPositionValue, $a7e7f8a39f99c8f0$export$ffb5f4729a158638.backgroundPosition({
            value: backgroundPositionValue,
            valuesToConvert: valuesToConvert,
            isRtl: isRtl,
            bgPosDirectionRegex: bgPosDirectionRegex
        }));
        // do the backgroundImage value replacing on the whole value (because why not?)
        return $a7e7f8a39f99c8f0$export$ffb5f4729a158638.backgroundImage({
            value: value,
            valuesToConvert: valuesToConvert,
            bgImgDirectionRegex: bgImgDirectionRegex
        });
    },
    backgroundImage: function backgroundImage(_ref6) {
        var value = _ref6.value, valuesToConvert = _ref6.valuesToConvert, bgImgDirectionRegex = _ref6.bgImgDirectionRegex;
        if (!$a7e7f8a39f99c8f0$export$953cecd6e717a553(value, "url(") && !$a7e7f8a39f99c8f0$export$953cecd6e717a553(value, "linear-gradient(")) return value;
        return value.replace(bgImgDirectionRegex, function(match, g1, group2) {
            return match.replace(group2, valuesToConvert[group2]);
        });
    },
    backgroundPosition: function backgroundPosition(_ref7) {
        var value = _ref7.value, valuesToConvert = _ref7.valuesToConvert, isRtl = _ref7.isRtl, bgPosDirectionRegex = _ref7.bgPosDirectionRegex;
        return value// intentionally only grabbing the first instance of this because that represents `left`
        .replace(isRtl ? /^((-|\d|\.)+%)/ : null, function(match, group) {
            return $a7e7f8a39f99c8f0$export$dda1d9f60106f0e9(group);
        }).replace(bgPosDirectionRegex, function(match) {
            return valuesToConvert[match];
        });
    },
    backgroundPositionX: function backgroundPositionX(_ref8) {
        var value = _ref8.value, valuesToConvert = _ref8.valuesToConvert, isRtl = _ref8.isRtl, bgPosDirectionRegex = _ref8.bgPosDirectionRegex;
        if ($a7e7f8a39f99c8f0$export$9e5f44173e64f162(value)) return value;
        return $a7e7f8a39f99c8f0$export$ffb5f4729a158638.backgroundPosition({
            value: value,
            valuesToConvert: valuesToConvert,
            isRtl: isRtl,
            bgPosDirectionRegex: bgPosDirectionRegex
        });
    },
    transition: function transition(_ref9) {
        var value = _ref9.value, propertiesToConvert = _ref9.propertiesToConvert;
        return value.split(/,\s*/g).map(function(transition) {
            var values = transition.split(" ");
            // Property is always defined first
            values[0] = propertiesToConvert[values[0]] || values[0];
            return values.join(" ");
        }).join(", ");
    },
    transitionProperty: function transitionProperty(_ref10) {
        var value = _ref10.value, propertiesToConvert = _ref10.propertiesToConvert;
        return value.split(/,\s*/g).map(function(prop) {
            return propertiesToConvert[prop] || prop;
        }).join(", ");
    },
    transform: function transform(_ref11) {
        var value = _ref11.value;
        // This was copied and modified from CSSJanus:
        // https://github.com/cssjanus/cssjanus/blob/4a40f001b1ba35567112d8b8e1d9d95eda4234c3/src/cssjanus.js#L152-L153
        var nonAsciiPattern = "[^\\u0020-\\u007e]";
        var escapePattern = "(?:(?:(?:\\[0-9a-f]{1,6})(?:\\r\\n|\\s)?)|\\\\[^\\r\\n\\f0-9a-f])";
        var signedQuantPattern = "((?:-?" + ("(?:[0-9]*\\.[0-9]+|[0-9]+)(?:\\s*(?:em|ex|px|cm|mm|in|pt|pc|deg|rad|grad|ms|s|hz|khz|%)|" + ("-?" + ("(?:[_a-z]|" + nonAsciiPattern + "|" + escapePattern + ")") + ("(?:[_a-z0-9-]|" + nonAsciiPattern + "|" + escapePattern + ")") + "*") + ")?") + ")|(?:inherit|auto))";
        var translateXRegExp = new RegExp("(translateX\\s*\\(\\s*)" + signedQuantPattern + "(\\s*\\))", "gi");
        var translateRegExp = new RegExp("(translate\\s*\\(\\s*)" + signedQuantPattern + "((?:\\s*,\\s*" + signedQuantPattern + "){0,1}\\s*\\))", "gi");
        var translate3dRegExp = new RegExp("(translate3d\\s*\\(\\s*)" + signedQuantPattern + "((?:\\s*,\\s*" + signedQuantPattern + "){0,2}\\s*\\))", "gi");
        var rotateRegExp = new RegExp("(rotate[ZY]?\\s*\\(\\s*)" + signedQuantPattern + "(\\s*\\))", "gi");
        return value.replace(translateXRegExp, $a7e7f8a39f99c8f0$export$35e795649ee09318).replace(translateRegExp, $a7e7f8a39f99c8f0$export$35e795649ee09318).replace(translate3dRegExp, $a7e7f8a39f99c8f0$export$35e795649ee09318).replace(rotateRegExp, $a7e7f8a39f99c8f0$export$35e795649ee09318);
    }
};
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.objectPosition = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.backgroundPosition;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.margin = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.padding;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.borderWidth = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.padding;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.boxShadow = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.textShadow;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.webkitBoxShadow = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.boxShadow;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.mozBoxShadow = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.boxShadow;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.WebkitBoxShadow = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.boxShadow;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.MozBoxShadow = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.boxShadow;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.borderStyle = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.borderColor;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.webkitTransform = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transform;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.mozTransform = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transform;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.WebkitTransform = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transform;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.MozTransform = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transform;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.transformOrigin = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.backgroundPosition;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.webkitTransformOrigin = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transformOrigin;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.mozTransformOrigin = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transformOrigin;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.WebkitTransformOrigin = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transformOrigin;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.MozTransformOrigin = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transformOrigin;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.webkitTransition = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transition;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.mozTransition = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transition;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.WebkitTransition = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transition;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.MozTransition = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transition;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.webkitTransitionProperty = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transitionProperty;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.mozTransitionProperty = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transitionProperty;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.WebkitTransitionProperty = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transitionProperty;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638.MozTransitionProperty = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transitionProperty;
// kebab-case versions
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["text-shadow"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.textShadow;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["border-color"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.borderColor;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["border-radius"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.borderRadius;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["background-image"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.backgroundImage;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["background-position"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.backgroundPosition;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["background-position-x"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.backgroundPositionX;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["object-position"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.objectPosition;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["border-width"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.padding;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["box-shadow"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.textShadow;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["-webkit-box-shadow"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.textShadow;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["-moz-box-shadow"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.textShadow;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["border-style"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.borderColor;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["-webkit-transform"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transform;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["-moz-transform"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transform;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["transform-origin"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transformOrigin;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["-webkit-transform-origin"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transformOrigin;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["-moz-transform-origin"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transformOrigin;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["-webkit-transition"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transition;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["-moz-transition"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transition;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["transition-property"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transitionProperty;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["-webkit-transition-property"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transitionProperty;
$a7e7f8a39f99c8f0$export$ffb5f4729a158638["-moz-transition-property"] = $a7e7f8a39f99c8f0$export$ffb5f4729a158638.transitionProperty;
// this will be an object of properties that map to their corresponding rtl property (their doppelganger)
var $a7e7f8a39f99c8f0$export$407448d2b89b1813 = $a7e7f8a39f99c8f0$export$2d1720544b23b823([
    [
        "paddingLeft",
        "paddingRight"
    ],
    [
        "marginLeft",
        "marginRight"
    ],
    [
        "left",
        "right"
    ],
    [
        "borderLeft",
        "borderRight"
    ],
    [
        "borderLeftColor",
        "borderRightColor"
    ],
    [
        "borderLeftStyle",
        "borderRightStyle"
    ],
    [
        "borderLeftWidth",
        "borderRightWidth"
    ],
    [
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ],
    [
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ],
    // kebab-case versions
    [
        "padding-left",
        "padding-right"
    ],
    [
        "margin-left",
        "margin-right"
    ],
    [
        "border-left",
        "border-right"
    ],
    [
        "border-left-color",
        "border-right-color"
    ],
    [
        "border-left-style",
        "border-right-style"
    ],
    [
        "border-left-width",
        "border-right-width"
    ],
    [
        "border-top-left-radius",
        "border-top-right-radius"
    ],
    [
        "border-bottom-left-radius",
        "border-bottom-right-radius"
    ]
]);
var $a7e7f8a39f99c8f0$export$8b22cf2602fb60ce = [
    "content"
];
// this is the same as the propertiesToConvert except for values
var $a7e7f8a39f99c8f0$export$90a7f3efeed30595 = $a7e7f8a39f99c8f0$export$2d1720544b23b823([
    [
        "ltr",
        "rtl"
    ],
    [
        "left",
        "right"
    ],
    [
        "w-resize",
        "e-resize"
    ],
    [
        "sw-resize",
        "se-resize"
    ],
    [
        "nw-resize",
        "ne-resize"
    ]
]);
// Sorry for the regex 😞, but basically thisis used to replace _every_ instance of
// `ltr`, `rtl`, `right`, and `left` in `backgroundimage` with the corresponding opposite.
// A situation we're accepting here:
// url('/left/right/rtl/ltr.png') will be changed to url('/right/left/ltr/rtl.png')
// Definite trade-offs here, but I think it's a good call.
var $a7e7f8a39f99c8f0$var$bgImgDirectionRegex = new RegExp("(^|\\W|_)((ltr)|(rtl)|(left)|(right))(\\W|_|$)", "g");
var $a7e7f8a39f99c8f0$var$bgPosDirectionRegex = new RegExp("(left)|(right)");
/**
 * converts properties and values in the CSS in JS object to their corresponding RTL values
 * @param {Object} object the CSS in JS object
 * @return {Object} the RTL converted object
 */ function $a7e7f8a39f99c8f0$export$db3b6bfb95261072(object) {
    return Object.keys(object).reduce(function(newObj, originalKey) {
        var originalValue = object[originalKey];
        if ($a7e7f8a39f99c8f0$export$625550452a3fa3ec(originalValue)) // you're welcome to later code 😺
        originalValue = originalValue.trim();
        // Some properties should never be transformed
        if ($a7e7f8a39f99c8f0$export$953cecd6e717a553($a7e7f8a39f99c8f0$export$8b22cf2602fb60ce, originalKey)) {
            newObj[originalKey] = originalValue;
            return newObj;
        }
        var _convertProperty = $a7e7f8a39f99c8f0$export$4368d992c4eafac0(originalKey, originalValue), key = _convertProperty.key, value = _convertProperty.value;
        newObj[key] = value;
        return newObj;
    }, Array.isArray(object) ? [] : {});
}
/**
 * Converts a property and its value to the corresponding RTL key and value
 * @param {String} originalKey the original property key
 * @param {Number|String|Object} originalValue the original css property value
 * @return {Object} the new {key, value} pair
 */ function $a7e7f8a39f99c8f0$export$4368d992c4eafac0(originalKey, originalValue) {
    var isNoFlip = /\/\*\s?@noflip\s?\*\//.test(originalValue);
    var key = isNoFlip ? originalKey : $a7e7f8a39f99c8f0$export$39b482c5e57630a8(originalKey);
    var value = isNoFlip ? originalValue : $a7e7f8a39f99c8f0$export$f1e1789686576879(key, originalValue);
    return {
        key: key,
        value: value
    };
}
/**
 * This gets the RTL version of the given property if it has a corresponding RTL property
 * @param {String} property the name of the property
 * @return {String} the name of the RTL property
 */ function $a7e7f8a39f99c8f0$export$39b482c5e57630a8(property) {
    return $a7e7f8a39f99c8f0$export$407448d2b89b1813[property] || property;
}
/**
 * This converts the given value to the RTL version of that value based on the key
 * @param {String} key this is the key (note: this should be the RTL version of the originalKey)
 * @param {String|Number|Object} originalValue the original css property value. If it's an object, then we'll convert that as well
 * @return {String|Number|Object} the converted value
 */ function $a7e7f8a39f99c8f0$export$f1e1789686576879(key, originalValue) {
    if (!$a7e7f8a39f99c8f0$export$23f2a1d2818174ef(originalValue)) return originalValue;
    if ($a7e7f8a39f99c8f0$export$2408f22a0fab9ae5(originalValue)) return $a7e7f8a39f99c8f0$export$db3b6bfb95261072(originalValue); // recursion 🌀
    var isNum = $a7e7f8a39f99c8f0$export$9e5f44173e64f162(originalValue);
    var isFunc = $a7e7f8a39f99c8f0$export$ae1af26003f05816(originalValue);
    var importantlessValue = isNum || isFunc ? originalValue : originalValue.replace(/ !important.*?$/, "");
    var isImportant = !isNum && importantlessValue.length !== originalValue.length;
    var valueConverter = $a7e7f8a39f99c8f0$export$ffb5f4729a158638[key];
    var newValue;
    if (valueConverter) newValue = valueConverter({
        value: importantlessValue,
        valuesToConvert: $a7e7f8a39f99c8f0$export$90a7f3efeed30595,
        propertiesToConvert: $a7e7f8a39f99c8f0$export$407448d2b89b1813,
        isRtl: true,
        bgImgDirectionRegex: $a7e7f8a39f99c8f0$var$bgImgDirectionRegex,
        bgPosDirectionRegex: $a7e7f8a39f99c8f0$var$bgPosDirectionRegex
    });
    else newValue = $a7e7f8a39f99c8f0$export$90a7f3efeed30595[importantlessValue] || importantlessValue;
    if (isImportant) return newValue + " !important";
    return newValue;
}


var $7e60d9bee0a9b4d1$export$2e2bcd8739ae039 = (0, $a7e7f8a39f99c8f0$export$db3b6bfb95261072);


var $12a7defa7c6ab0d1$var$convert = $7e60d9bee0a9b4d1$exports["default"] || $7e60d9bee0a9b4d1$exports;
function $12a7defa7c6ab0d1$var$jssRTL(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.enabled, enabled = _c === void 0 ? true : _c, _d = _b.opt, opt = _d === void 0 ? "out" : _d;
    return {
        onProcessStyle: function(style, rule, sheet) {
            if (rule.type === "font-face") return style;
            if (!enabled) {
                if (typeof style.flip === "boolean") delete style.flip;
                return style;
            }
            var flip = opt === "out"; // If it's set to opt-out, then it should flip by default
            if (typeof sheet.options.flip === "boolean") flip = sheet.options.flip;
            if (typeof style.flip === "boolean") {
                flip = style.flip;
                delete style.flip;
            }
            if (!flip) return style;
            return $12a7defa7c6ab0d1$var$convert(typeof rule.toJSON === "function" ? rule.toJSON() : style);
        }
    };
}
$12a7defa7c6ab0d1$exports.default = $12a7defa7c6ab0d1$var$jssRTL;



var $7Dbhg = parcelRequire("7Dbhg");

var $4g0WD = parcelRequire("4g0WD");
function $42a689e08d909a83$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? Object(arguments[i]) : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $4g0WD.default)(target, key, source[key]);
        });
    }
    return target;
}



var $9mrtf = parcelRequire("9mrtf");

var $b6hTo = parcelRequire("b6hTo");

var $7Dbhg = parcelRequire("7Dbhg");

var $7qIdT = parcelRequire("7qIdT");
function $63875517ca9c2c3f$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $7Dbhg.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $7qIdT.default)(self);
}


function $7abe53ac2191fe8e$export$2e2bcd8739ae039(o) {
    $7abe53ac2191fe8e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7abe53ac2191fe8e$export$2e2bcd8739ae039(o);
}



var $7qIdT = parcelRequire("7qIdT");

var $8LoK5 = parcelRequire("8LoK5");
function $8d5798401138edf0$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $8LoK5.default)(subClass, superClass);
}


var $9bb3d3a0c854c004$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $9bb3d3a0c854c004$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $9mrtf.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $b6hTo.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $9bb3d3a0c854c004$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }, this.options));
            }
        }
    ]);
    return Logger;
}();
var $9bb3d3a0c854c004$var$baseLogger = new $9bb3d3a0c854c004$var$Logger();
var $9bb3d3a0c854c004$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $9mrtf.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $b6hTo.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $9bb3d3a0c854c004$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $9bb3d3a0c854c004$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $9bb3d3a0c854c004$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $9bb3d3a0c854c004$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $9bb3d3a0c854c004$var$setPath(object, path, newValue) {
    var _getLastOfPath = $9bb3d3a0c854c004$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $9bb3d3a0c854c004$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $9bb3d3a0c854c004$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $9bb3d3a0c854c004$var$getPath(object, path) {
    var _getLastOfPath3 = $9bb3d3a0c854c004$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $9bb3d3a0c854c004$var$getPathWithDefaults(data, defaultData, key) {
    var value = $9bb3d3a0c854c004$var$getPath(data, key);
    if (value !== undefined) return value;
    return $9bb3d3a0c854c004$var$getPath(defaultData, key);
}
function $9bb3d3a0c854c004$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $9bb3d3a0c854c004$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $9bb3d3a0c854c004$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $9bb3d3a0c854c004$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $9bb3d3a0c854c004$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $9bb3d3a0c854c004$var$_entityMap[s];
    });
    return data;
}
var $9bb3d3a0c854c004$var$isIE10 = typeof window !== "undefined" && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var $9bb3d3a0c854c004$var$ResourceStore = function(_EventEmitter) {
    (0, $8d5798401138edf0$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $9mrtf.default)(this, ResourceStore);
        _this = (0, $63875517ca9c2c3f$export$2e2bcd8739ae039)(this, (0, $7abe53ac2191fe8e$export$2e2bcd8739ae039)(ResourceStore).call(this));
        if ($9bb3d3a0c854c004$var$isIE10) $9bb3d3a0c854c004$var$EventEmitter.call((0, $7qIdT.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        return _this;
    }
    (0, $b6hTo.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                return $9bb3d3a0c854c004$var$getPath(this.data, path);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $9bb3d3a0c854c004$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $9bb3d3a0c854c004$var$getPath(this.data, path) || {};
                if (deep) $9bb3d3a0c854c004$var$deepExtend(pack, resources, overwrite);
                else pack = (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, pack, resources);
                $9bb3d3a0c854c004$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, {}, this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($9bb3d3a0c854c004$var$EventEmitter);
var $9bb3d3a0c854c004$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
var $9bb3d3a0c854c004$var$checkedLoadedFor = {};
var $9bb3d3a0c854c004$var$Translator = function(_EventEmitter) {
    (0, $8d5798401138edf0$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $9mrtf.default)(this, Translator);
        _this = (0, $63875517ca9c2c3f$export$2e2bcd8739ae039)(this, (0, $7abe53ac2191fe8e$export$2e2bcd8739ae039)(Translator).call(this));
        if ($9bb3d3a0c854c004$var$isIE10) $9bb3d3a0c854c004$var$EventEmitter.call((0, $7qIdT.default)(_this));
        $9bb3d3a0c854c004$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $7qIdT.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $9bb3d3a0c854c004$var$baseLogger.create("translator");
        return _this;
    }
    (0, $b6hTo.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS;
                if (nsSeparator && key.indexOf(nsSeparator) > -1) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $7Dbhg.default)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        return namespace + nsSeparator + key;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, options, {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, options, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, fallbackValue) {
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init((0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, options, {
                        interpolation: (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, this.options.interpolation, options.interpolation)
                    }));
                    var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, this.options.interpolation.defaultVariables, data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $9bb3d3a0c854c004$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0, $42a689e08d909a83$export$2e2bcd8739ae039)({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsContextHandling = options.context !== undefined && typeof options.context === "string" && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$9bb3d3a0c854c004$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $9bb3d3a0c854c004$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKey = key;
                            var finalKeys = [
                                finalKey
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
                                if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
                                if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
                                if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($9bb3d3a0c854c004$var$EventEmitter);
function $9bb3d3a0c854c004$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $9bb3d3a0c854c004$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $9mrtf.default)(this, LanguageUtil);
        this.options = options;
        this.whitelist = this.options.supportedLngs || false;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $9bb3d3a0c854c004$var$baseLogger.create("languageUtils");
    }
    (0, $b6hTo.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $9bb3d3a0c854c004$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $9bb3d3a0c854c004$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $9bb3d3a0c854c004$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isWhitelisted",
            value: function isWhitelisted(code) {
                this.logger.deprecate("languageUtils.isWhitelisted", 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
                return this.isSupportedCode(code);
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $9bb3d3a0c854c004$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "kk",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $9bb3d3a0c854c004$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
function $9bb3d3a0c854c004$var$createRules() {
    var rules = {};
    $9bb3d3a0c854c004$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $9bb3d3a0c854c004$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $9bb3d3a0c854c004$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $9mrtf.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $9bb3d3a0c854c004$var$baseLogger.create("pluralResolver");
        this.rules = $9bb3d3a0c854c004$var$createRules();
    }
    (0, $b6hTo.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var rule = this.getRule(code);
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                return this.getSuffixes(code).map(function(suffix) {
                    return key + suffix;
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var rule = this.getRule(code);
                if (!rule) return [];
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var _this2 = this;
                var rule = this.getRule(code);
                if (rule) {
                    var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                    var suffix = rule.numbers[idx];
                    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                        if (suffix === 2) suffix = "plural";
                        else if (suffix === 1) suffix = "";
                    }
                    var returnSuffix = function returnSuffix() {
                        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                    };
                    if (this.options.compatibilityJSON === "v1") {
                        if (suffix === 1) return "";
                        if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                        return returnSuffix();
                    } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                    else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        }
    ]);
    return PluralResolver;
}();
var $9bb3d3a0c854c004$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $9mrtf.default)(this, Interpolator);
        this.logger = $9bb3d3a0c854c004$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $b6hTo.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $9bb3d3a0c854c004$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $9bb3d3a0c854c004$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $9bb3d3a0c854c004$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $9bb3d3a0c854c004$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $9bb3d3a0c854c004$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $9bb3d3a0c854c004$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $9bb3d3a0c854c004$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $9bb3d3a0c854c004$var$getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($9bb3d3a0c854c004$var$getPathWithDefaults(data, defaultData, k), f, lng, options);
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        value = handleFormat(match[1].trim());
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $9bb3d3a0c854c004$var$makeString(value);
                        str = str.replace(match[0], todo.safeValue(value));
                        todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, inheritedOptions, clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $9bb3d3a0c854c004$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, options);
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $9bb3d3a0c854c004$var$remove(arr, what) {
    var found = arr.indexOf(what);
    while(found !== -1){
        arr.splice(found, 1);
        found = arr.indexOf(what);
    }
}
var $9bb3d3a0c854c004$var$Connector = function(_EventEmitter) {
    (0, $8d5798401138edf0$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $9mrtf.default)(this, Connector);
        _this = (0, $63875517ca9c2c3f$export$2e2bcd8739ae039)(this, (0, $7abe53ac2191fe8e$export$2e2bcd8739ae039)(Connector).call(this));
        if ($9bb3d3a0c854c004$var$isIE10) $9bb3d3a0c854c004$var$EventEmitter.call((0, $7qIdT.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $9bb3d3a0c854c004$var$baseLogger.create("backendConnector");
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $b6hTo.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = [];
                var pending = [];
                var toLoadLanguages = [];
                var toLoadNamespaces = [];
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending.indexOf(name) < 0) pending.push(name);
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending.indexOf(name) < 0) pending.push(name);
                            if (toLoad.indexOf(name) < 0) toLoad.push(name);
                            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages.push(lng);
                });
                if (toLoad.length || pending.length) this.queue.push({
                    pending: pending,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: toLoad,
                    pending: pending,
                    toLoadLanguages: toLoadLanguages,
                    toLoadNamespaces: toLoadNamespaces
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $9bb3d3a0c854c004$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $9bb3d3a0c854c004$var$remove(q.pending, name);
                    if (err) q.errors.push(err);
                    if (q.pending.length === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = [];
                            if (q.loaded[l].length) q.loaded[l].forEach(function(ns) {
                                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                return this.backend[fcName](lng, ns, function(err, data) {
                    if (err && data && tried < 5) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, options, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($9bb3d3a0c854c004$var$EventEmitter);
function $9bb3d3a0c854c004$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        whitelist: false,
        nonExplicitWhitelist: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $7Dbhg.default)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $7Dbhg.default)(args[2]) === "object" || (0, $7Dbhg.default)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: false
        }
    };
}
function $9bb3d3a0c854c004$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.whitelist) {
        if (options.whitelist && options.whitelist.indexOf("cimode") < 0) options.whitelist = options.whitelist.concat([
            "cimode"
        ]);
        options.supportedLngs = options.whitelist;
    }
    if (options.nonExplicitWhitelist) options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $9bb3d3a0c854c004$var$noop() {}
var $9bb3d3a0c854c004$var$I18n = function(_EventEmitter) {
    (0, $8d5798401138edf0$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $9mrtf.default)(this, I18n);
        _this = (0, $63875517ca9c2c3f$export$2e2bcd8739ae039)(this, (0, $7abe53ac2191fe8e$export$2e2bcd8739ae039)(I18n).call(this));
        if ($9bb3d3a0c854c004$var$isIE10) $9bb3d3a0c854c004$var$EventEmitter.call((0, $7qIdT.default)(_this));
        _this.options = $9bb3d3a0c854c004$var$transformOptions(options);
        _this.services = {};
        _this.logger = $9bb3d3a0c854c004$var$baseLogger;
        _this.modules = {
            external: []
        };
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $63875517ca9c2c3f$export$2e2bcd8739ae039)(_this, (0, $7qIdT.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $b6hTo.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (options.whitelist && !options.supportedLngs) this.logger.deprecate("whitelist", 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
                if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) this.logger.deprecate("whitelist", 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
                this.options = (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, $9bb3d3a0c854c004$var$get(), this.options, $9bb3d3a0c854c004$var$transformOptions(options));
                this.format = this.options.interpolation.format;
                if (!callback) callback = $9bb3d3a0c854c004$var$noop;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $9bb3d3a0c854c004$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $9bb3d3a0c854c004$var$baseLogger.init(null, this.options);
                    var lu = new $9bb3d3a0c854c004$var$LanguageUtil(this.options);
                    this.store = new $9bb3d3a0c854c004$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $9bb3d3a0c854c004$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $9bb3d3a0c854c004$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    s.interpolator = new $9bb3d3a0c854c004$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $9bb3d3a0c854c004$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $9bb3d3a0c854c004$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $9bb3d3a0c854c004$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9bb3d3a0c854c004$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $9bb3d3a0c854c004$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $9bb3d3a0c854c004$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $9bb3d3a0c854c004$var$postProcessor.addPostProcessor(module);
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $9bb3d3a0c854c004$var$defer();
                this.emit("languageChanging", lng);
                var done = function done(err, l) {
                    if (l) {
                        _this4.language = l;
                        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) {
                            _this4.language = l;
                            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        }
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $7Dbhg.default)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    return _this5.t(key, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $9bb3d3a0c854c004$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $9bb3d3a0c854c004$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam"
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? "rtl" : "ltr";
            }
        },
        {
            key: "createInstance",
            value: function createInstance() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                return new I18n(options, callback);
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9bb3d3a0c854c004$var$noop;
                var mergedOptions = (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, this.options, options, {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = (0, $42a689e08d909a83$export$2e2bcd8739ae039)({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $9bb3d3a0c854c004$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        }
    ]);
    return I18n;
}($9bb3d3a0c854c004$var$EventEmitter);
var $9bb3d3a0c854c004$var$i18next = new $9bb3d3a0c854c004$var$I18n();
var $9bb3d3a0c854c004$export$2e2bcd8739ae039 = $9bb3d3a0c854c004$var$i18next;



var $8LHwv = parcelRequire("8LHwv");
var $787f97e84b3cf68a$exports = {};
$787f97e84b3cf68a$exports = JSON.parse('{"translation":{"aboutThisItem":"\u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631","addedFromUrl":"(\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u062A\u0647 \u0645\u0646 \u0627\u0644\u0631\u0627\u0628\u0637)","addManifestUrl":"\u0645\u0648\u0642\u0639 \u0627\u0644\u0645\u0635\u062F\u0631","addManifestUrlHelp":"\u0627\u0644\u0631\u0627\u0628\u0637 \u0644\u0645\u0635\u062F\u0631 IIIF ","addResource":"\u0627\u0636\u0641 \u0645\u0635\u062F\u0631","annotationCanvasLabel_1/1":"\u0627\u0644\u0639\u0646\u0635\u0631: [{{\u0627\u0644\u0645\u0644\u0635\u0642}}]","annotationCanvasLabel_1/2":"\u064A\u0633\u0627\u0631: [{{\u0627\u0644\u0645\u0644\u0635\u0642 }}]","annotationCanvasLabel_2/2":"\u064A\u0645\u064A\u0646: [{{\u0627\u0644\u0645\u0644\u0635\u0642}}]","annotations":"\u0645\u0644\u0627\u062D\u0638\u0627\u062A","attribution":"\u0625\u0633\u0646\u0627\u062F","attributionTitle":"\u062D\u0642\u0648\u0642","authenticationFailed":"\u0627\u0644\u062A\u0648\u062B\u064A\u0642 \u0644\u0645 \u064A\u0646\u062C\u062D","authenticationRequired":"\u064A\u062C\u0628 \u062A\u0648\u062B\u064A\u0642 \u0627\u0644\u062D\u0633\u0627\u0628 \u0644\u0645\u0646\u062D \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u0643\u0627\u0645\u0644","backToResults":"\u0627\u0644\u0631\u062C\u0648\u0639 \u0627\u0644\u0649 \u0627\u0644\u0646\u062A\u0627\u0626\u062C","book":"\u0643\u062A\u0627\u0628","bottom":"\u0623\u0633\u0641\u0644","cancel":"\u0627\u0644\u063A\u0627\u0621","canvasIndex":"\u0641\u0647\u0631\u0633","changeTheme":"\u0642\u0645 \u0628\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0645\u0648\u0636\u0648\u0639","clearSearch":"\u0627\u0645\u0633\u062D","closeAddResourceForm":"\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0625\u0633\u062A\u0645\u0627\u0631\u0629","closeAddResourceMenu":"\u0625\u063A\u0644\u0627\u0642 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0635\u0627\u062F\u0631","closeCompanionWindow":"\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0644\u0648\u062D\u0629","closeWindow":"\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629","collapseSection":"\u062A\u0635\u063A\u064A\u0631 \u062C\u0632\u0621 {{section}}","collapseSidePanel":"\u062A\u0635\u063A\u064A\u0631 \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A","itemList":"\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0639\u0646\u0627\u0635\u0631","continue":"\u0627\u0633\u062A\u0645\u0631","copy":"\u0646\u0633\u062E","currentItem":"\u0627\u0644\u0639\u0646\u0635\u0631 \u0627\u0644\u062D\u0627\u0644\u064A","currentItem_1/1":"\u0627\u0644\u0639\u0646\u0635\u0631 \u0627\u0644\u062D\u0627\u0644\u064A","currentItem_1/2":"\u064A\u0633\u0627\u0631","currentItem_2/2":"\u064A\u0645\u064A\u0646","dark":"\u0645\u0648\u0636\u0648\u0639 \u062F\u0627\u0643\u0646","dismiss":"\u062A\u062C\u0627\u0647\u0644","highlightAllAnnotations":"\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0643\u0644","downloadExport":"\u062A\u0635\u062F\u064A\u0631 \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0639\u0645\u0644","downloadExportWorkspace":"\u062A\u0635\u062F\u064A\u0631 \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0639\u0645\u0644","elastic":"\u0645\u0631\u0646","elasticDescription":"\u062D\u0631\u0643 \u0627\u0644\u0646\u0648\u0627\u0641\u0630 \u0648 \u063A\u064A\u0631 \u062D\u062C\u0645\u0647\u0627 \u0628\u062D\u0631\u064A\u0629 \u0641\u064A \u0645\u0633\u0627\u062D\u0629 \u0639\u0645\u0644 \u063A\u064A\u0631 \u0645\u062D\u062F\u0648\u062F\u0629. \u064A\u0645\u0643\u0646 \u0623\u0646 \u062A\u062A\u062F\u0627\u062E\u0644 \u0627\u0644\u0646\u0648\u0627\u0641\u0630 \u0623\u064A\u0636\u0627\u064B .","emptyResourceList":"\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0635\u0627\u062F\u0631 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u0641\u0627\u0631\u063A\u0629.","errorDialogConfirm":"\u062D\u0633\u0646\u0627\u064B","errorDialogTitle":"\u0644\u0642\u062F \u062D\u062F\u062B \u062E\u0637\u0623","exitFullScreen":"\u062E\u0631\u0648\u062C \u0645\u0646 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0643\u0627\u0645\u0644\u0629","expandSection":"\u062A\u0648\u0633\u064A\u0639 \u0627\u0644\u062C\u0632\u0621 {{section}}","expandSidePanel":"\u062A\u0648\u0633\u064A\u0639 \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A","fetchManifest":"\u0623\u0636\u0641","fullScreen":"\u0634\u0627\u0634\u0629 \u0643\u0627\u0645\u0644\u0629","gallery":"\u0627\u0644\u0645\u0639\u0631\u0636","hideZoomControls":"\u0625\u062E\u0641\u0627\u0621 \u0636\u0648\u0627\u0628\u0637 \u0627\u0644\u062A\u0643\u0628\u064A\u0631","iiif_homepage":"\u0639\u0646 \u0647\u0630\u0647 \u0627\u0644\u0645\u0635\u062F\u0631","iiif_manifest":"IIIF \u0642\u0627\u0626\u0645\u0629 ","iiif_renderings":"\u062A\u0646\u0633\u064A\u0642\u0627\u062A \u0628\u062F\u064A\u0644\u0629","iiif_seeAlso":"\u0623\u0646\u0638\u0631 \u0623\u064A\u0636\u0627","import":"\u0627\u0633\u062A\u0648\u0631\u062F ","importWorkspace":"\u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0639\u0645\u0644","importWorkspaceHint":"\u0642\u0645 \u0628\u0644\u0635\u0642 \u062A\u0631\u0643\u064A\u0628\u0629 Mirador 3 \u0644\u064A\u062A\u0645 \u0627\u0633\u062A\u064A\u0631\u0627\u062F\u0647","item":"\u0627\u0644\u0639\u0646\u0635\u0631: {{label}}","language":"\u0627\u0644\u0644\u063A\u0629","layer_hide":"\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0637\u0628\u0642\u0629","layer_move":"\u062A\u062D\u0631\u064A\u0643 \u0627\u0644\u0637\u0628\u0642\u0629","layer_opacity":"\u062A\u0639\u062A\u064A\u0645 \u0627\u0644\u0637\u0628\u0642\u0629","layer_show":"\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0637\u0628\u0642\u0629","layer_moveToTop":"\u062D\u0631\u0643 \u0627\u0644\u0637\u0628\u0642\u0629 \u0625\u0644\u0649 \u0627\u0644\u0623\u0639\u0644\u0649","layers":"\u0637\u0628\u0642\u0627\u062A","light":"\u0645\u0648\u0636\u0648\u0639 \u0641\u0627\u062A\u062D","links":"\u0627\u0644\u0631\u0648\u0627\u0628\u0637","listAllOpenWindows":"\u0627\u0646\u062A\u0642\u0644 \u0628\u0633\u0631\u0639\u0629 \u0644\u0644\u0646\u0627\u0641\u0630\u0629","login":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644","logout":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C","manifestError":"\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0635\u062F\u0631:","maximizeWindow":"\u062A\u0643\u0628\u064A\u0631 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0625\u0644\u0649 \u0627\u0644\u062D\u062F \u0627\u0644\u0627\u0643\u0628\u0631","minimizeWindow":"\u062A\u0635\u063A\u064A\u0631 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0625\u0644\u0649 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u062F\u0646\u0649","mirador":"Mirador","miradorResources":"\u0645\u0635\u0627\u062F\u0631 Mirador ","miradorViewer":"\u0645\u0634\u0627\u0647\u062F Mirador","more":"\u0623\u0643\u062B\u0631...","moreResults":"\u0646\u062A\u0627\u0626\u062C \u0625\u0636\u0627\u0641\u064A\u0629","mosaic":"\u0641\u0633\u064A\u0641\u0633\u0627\u0621","mosaicDescription":"\u062D\u0631\u0643 \u0648\u063A\u064A\u064C\u0631 \u062D\u062C\u0645 \u0627\u0644\u0646\u0648\u0627\u0641\u0630 \u0627\u0644\u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u0628\u0639\u0636\u0647\u0627 \u0627\u0644\u0628\u0639\u0636 \u062F\u0627\u062E\u0644 \u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0631\u0626\u064A.","moveCompanionWindowToBottom":"\u0627\u0646\u062A\u0642\u0644 \u0644\u0644\u0623\u0633\u0641\u0644","moveCompanionWindowToRight":"\u0627\u0646\u062A\u0642\u0644 \u0644\u0644\u064A\u0645\u064A\u0646","nextCanvas":"\u0627\u0644\u0639\u0646\u0635\u0631 \u0627\u0644\u062A\u0627\u0644\u064A","numItems":"{{number}} \u0639\u0646\u0627\u0635\u0631","off":"\u0627\u064A\u0642\u0627\u0641","openCompanionWindow_annotations":"\u0645\u0644\u0627\u062D\u0638\u0627\u062A","openCompanionWindow_attribution":"\u062D\u0642\u0648\u0642","openCompanionWindow_canvas":"\u0641\u0647\u0631\u0633","openCompanionWindow_info":"\u0645\u0639\u0644\u0648\u0645\u0627\u062A","openCompanionWindow_layers":"\u0637\u0628\u0642\u0627\u062A","openCompanionWindow_search":"\u0628\u062D\u062B","openInCompanionWindow":"\u0627\u0641\u062A\u062D \u0641\u064A \u0635\u0641\u062D\u0629 \u062C\u062F\u064A\u062F\u0629","openWindows":"\u0627\u0644\u0646\u0648\u0627\u0641\u0630 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0627\u0644\u0645\u0641\u062A\u0648\u062D\u0629","pagination":"{{current}} \u0645\u0646 {{total}}","position":"\u0645\u0631\u0643\u0632","previewWindowTitle":"\u0639\u0646\u0648\u0627\u0646","previousCanvas":"\u0627\u0644\u0639\u0646\u0635\u0631 \u0627\u0644\u0633\u0627\u0628\u0642","related":"\u0630\u0627\u062A \u0635\u0644\u0629","resource":"\u0645\u0635\u062F\u0631","retry":"\u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 ","right":"\u062D\u0642","rights":"\u062A\u0631\u062E\u064A\u0635","searchInputLabel":"\u0645\u0635\u0637\u0644\u062D\u0627\u062A \u0627\u0644\u0628\u062D\u062B","searchNextResult":"\u0627\u0644\u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629","searchNoResults":"\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0646\u062A\u0627\u0626\u062C","searchPreviousResult":"\u0627\u0644\u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629","searchSubmitAria":"\u0627\u0628\u062D\u062B","searchTitle":"\u0628\u062D\u062B","selectWorkspaceMenu":"\u0627\u062E\u062A\u0631 \u0646\u0648\u0639 \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0639\u0645\u0644","showingNumAnnotations":"\u062A\u0638\u0647\u0631 {{number}} \u0645\u0644\u0627\u062D\u0638\u0627\u062A","showZoomControls":"\u0627\u0638\u0647\u0631 \u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u062A\u062D\u0643\u0645 \u0628\u0627\u0644\u062A\u0643\u0628\u064A\u0631 \u0648 \u0627\u0644\u062A\u0635\u063A\u064A\u0631","sidebarPanelsNavigation":"\u062A\u0635\u0641\u062D \u0644\u0648\u062D \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A","single":"\u0645\u0641\u0631\u062F","startHere":"\u0625\u0628\u062F\u0623 \u0647\u0646\u0627","suggestSearch":"\u0627\u0628\u062D\u062B \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0639\u0646  \\"{{ query }}\\"","tableOfContentsList":"\u062C\u062F\u0648\u0644 \u0627\u0644\u0645\u062D\u062A\u0648\u064A\u0627\u062A","theme":"\u0645\u0648\u0636\u0648\u0639","thumbnailList":"\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0645\u0635\u063A\u0631\u0629","thumbnailNavigation":"\u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0645\u0635\u063A\u0631\u0629","thumbnails":"\u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0645\u0635\u063A\u0631\u0629","toggleWindowSideBar":"\u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A","tryAgain":"\u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649","untitled":"[\u0628\u062F\u0648\u0646 \u0639\u0646\u0648\u0627\u0646]","view":"\u0634\u0627\u0647\u062F","welcome":"\u0645\u0631\u062D\u0628\u0627\u064B \u0628\u0643\u0645 \u0641\u064A Mirador","window":"\u0627\u0644\u0646\u0627\u0641\u0630\u0629:  {{label}}","windowMenu":"\u0639\u0631\u0636 \u0627\u0644\u0646\u0648\u0627\u0641\u0630 \u0648 \u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u0645\u0635\u063A\u0631\u0629","windowNavigation":"\u062A\u0635\u0641\u062D \u0627\u0644\u0646\u0627\u0641\u0630\u0629","windowPluginButtons":"\u062E\u064A\u0627\u0631\u0627\u062A","windowPluginMenu":"\u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0646\u0627\u0641\u0630\u0629","workspace":"\u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0639\u0645\u0644","workspaceFullScreen":"\u0634\u0627\u0634\u0629 \u0643\u0627\u0645\u0644\u0629","workspaceMenu":"\u0627\u0639\u062F\u0627\u062F\u0627\u062A \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0639\u0645\u0644","workspaceOptions":"\u062E\u064A\u0627\u0631\u0627\u062A \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0639\u0645\u0644 ","workspaceSelectionTitle":"\u0627\u062E\u062A\u0631 \u0646\u0648\u0639 \u0645\u0633\u0627\u062D\u0629 \u0627\u0644\u0639\u0645\u0644","zoomIn":"\u062A\u0643\u0628\u064A\u0631 \u0627\u0644\u0635\u0648\u0631\u0629","zoomOut":"\u062A\u0635\u063A\u064A\u0631 \u0627\u0644\u0635\u0648\u0631\u0629","zoomReset":"\u0627\u0644\u0631\u062C\u0648\u0639 \u0644\u062D\u062C\u0645 \u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u0623\u0633\u0627\u0633\u064A"}}');


var $b1042e723da910d1$exports = {};
$b1042e723da910d1$exports = JSON.parse('{"translation":{"aboutMirador":"\xdcber Mirador","aboutThisItem":"\xdcber dieses Element","addedFromUrl":"(Via URL hinzugef\xfcgt)","addManifestUrl":"Ort der Ressource","addManifestUrlHelp":"Die URL einer IIIF-Ressource","addResource":"Ressource hinzuf\xfcgen","annotationCanvasLabel_1/1":"Objekt: [{{label}}]","annotationCanvasLabel_1/2":"Links: [{{label}}]","annotationCanvasLabel_2/2":"Rechts: [{{label}}]","annotations":"Annotationen","attribution":"Zuschreibung","attributionTitle":"Rechte","authenticationFailed":"Authentifizierung fehlgeschlagen","authenticationRequired":"F\xfcr vollen Zugriff ist eine Authentifizierung n\xf6tig.","backToResults":"Zur\xfcck zur Trefferansicht","book":"Buch","bottom":"Unten","cancel":"Abbrechen","canvasIndex":"Index","changeTheme":"Farbschema \xe4ndern","clearSearch":"zur\xfccksetzen","closeAddResourceForm":"Formular schlie\xdfen","closeAddResourceMenu":"Ressourcenliste schlie\xdfen","closeCompanionWindow":"Hilfsfenster schlie\xdfen","closeWindow":"Fenster schlie\xdfen","collapseSection":"Bereich \\"{{section}}\\" zuklappen","collapseSidePanel":"Seitenleiste zuklappen","itemList":"Kompaktliste","continue":"Fortfahren","copy":"Kopieren","currentItem":"Aktuelles Objekt","currentItem_1/1":"Aktuelles Objekt","currentItem_1/2":"Links","currentItem_2/2":"Rechts","dark":"Dunkel","digitizedView":"Digitalisat-Ansicht","dismiss":"Verwerfen","highlightAllAnnotations":"Alle hervorheben","displayNoAnnotations":"Keine hervorheben","downloadExport":"Arbeitsfl\xe4che exportieren","downloadExportWorkspace":"Arbeitsfl\xe4che exportieren","elastic":"Elastisch","elasticDescription":"Fenster k\xf6nnen frei und unbegrenzt innerhalb der Arbeitsfl\xe4che bewegt werden und sich \xfcberlappen","emptyResourceList":"Ihre Ressourcenliste ist leer","error":"Fehler","errorDialogConfirm":"OK","errorDialogTitle":"Es ist ein Fehler aufgetreten","exitFullScreen":"Vollbildmodus verlassen","expandSection":"Bereich \\"{{section}}\\" aufklappen","expandSidePanel":"Seitenleiste aufklappen","exportCopied":"Die Konfiguration der Arbeitsfl\xe4che wurde in die Zwischenablage kopiert.","fetchManifest":"Hinzuf\xfcgen","fullScreen":"Vollbild","gallery":"Galerie","hideZoomControls":"Zoomsteuerung verbergen","iiif_homepage":"\xdcber diese Ressource","iiif_manifest":"IIIF-Manifest","iiif_renderings":"Alternative Formate","iiif_seeAlso":"Siehe auch","import":"Importieren","importWorkspace":"Arbeitsfl\xe4che importieren","importWorkspaceHint":"F\xfcgen Sie eine Mirador-3-Konfiguration ein, die importiert werden soll.","item":"Objekt: {{label}}","jsError":"Technische Details","jsStack":"{{ stack }}","language":"Sprache","layer_hide":"Ebene verbergen","layer_move":"Ebene verschieben","layer_opacity":"Ebenendeckkraft","layer_show":"Ebene anzeigen","layer_moveToTop":"Ebene ganz nach vorn bringen","layers":"Ebenen","light":"Hell","links":"Links","listAllOpenWindows":"Zu Fenster springen","login":"Anmelden","logout":"Abmelden","manifestError":"Die Ressource konnte nicht hinzugef\xfcgt werden:","maximizeWindow":"Fenster maximieren","minimizeWindow":"Fenster minimieren","mirador":"Mirador","miradorResources":"Mirador-Ressourcen","miradorViewer":"Mirador","more":"mehr...","moreResults":"Mehr Treffer","mosaic":"Mosaik","mosaicDescription":"Fenster k\xf6nnen innerhalb der Arbeitsfl\xe4che in Relation zueinander verschoben und ihrer Gr\xf6\xdfe ver\xe4ndert werden.","moveCompanionWindowToBottom":"Unten anordnen","moveCompanionWindowToRight":"Rechts anordnen","nextCanvas":"N\xe4chstes Objekt","numItems":"{{number}} Elemente","off":"Keine","openCompanionWindow_annotations":"Annotationen","openCompanionWindow_attribution":"Rechte","openCompanionWindow_canvas":"Index","openCompanionWindow_info":"Informationen","openCompanionWindow_layers":"Ebenen","openCompanionWindow_search":"Suche","openInCompanionWindow":"In Hilfsfenster \xf6ffnen","openWindows":"Aktuell offene Fenster","pagination":"{{current}} von {{total}}","position":"Position","previewWindowTitle":"{{title}}","previousCanvas":"Vorheriges Objekt","related":"Verwandtes","resource":"Ressource","retry":"Erneut versuchen","right":"Rechts","rights":"Lizenz","scroll":"Kontinuierlich","searchInputLabel":"Suchbegriffe","searchNextResult":"N\xe4chster Treffer","searchNoResults":"Keine Treffer","searchPreviousResult":"Vorheriger Treffer","searchResultsRemaining":"{{numLeft}} weitere","searchSubmitAria":"Suchen","searchTitle":"Suche","selectWorkspaceMenu":"W\xe4hlen Sie einen Arbeitsfl\xe4chentyp","showingNumAnnotations":"{{number}} Annotationen werden angezeigt","showZoomControls":"Zoomsteuerung anzeigen","sidebarPanelsNavigation":"Hilfsfensternavigation","single":"Einzeln","startHere":"Hier starten","suggestSearch":"Dieses Dokument durchsuchen nach \\"{{ query }}\\"","tableOfContentsList":"Inhaltsverzeichnis","theme":"Farbschema","thumbnailList":"Miniaturansicht","thumbnailNavigation":"Miniaturansicht","thumbnails":"Miniaturansicht","toggleWindowSideBar":"Seitenleiste umschalten","tryAgain":"Wiederholen","untitled":"[Unbenannt]","view":"Ansicht","welcome":"Willkommen bei Mirador","window":"Fenster: {{label}}","windowMenu":"Fenstermen\xfc und Miniaturansicht","windowNavigation":"Fensternavigation","windowPluginButtons":"Optionen","windowPluginMenu":"Fensteroptionen","workspace":"Arbeitsfl\xe4che","workspaceNavigation":"Arbeitsfl\xe4chensteuerung","workspaceFullScreen":"Vollbild","workspaceMenu":"Arbeitsfl\xe4chenmen\xfc","workspaceOptions":"Arbeitsfl\xe4chenoptionen","workspaceSelectionTitle":"Bitte w\xe4hlen Sie einen Arbeitsfl\xe4chentyp","zoomIn":"Vergr\xf6\xdfern","zoomOut":"Verkleinern","zoomReset":"Ansicht zur\xfccksetzen"}}');


var $a66fbaabfd5ffdf0$exports = {};
$a66fbaabfd5ffdf0$exports = JSON.parse('{"translation":{"aboutMirador":"About Project Mirador","aboutThisItem":"About this item","addedFromUrl":"(Added from URL)","addManifestUrl":"Resource location","addManifestUrlHelp":"The URL of a IIIF resource","addResource":"Add resource","annotationCanvasLabel_1/1":"Item: [{{label}}]","annotationCanvasLabel_1/2":"Left: [{{label}}]","annotationCanvasLabel_2/2":"Right: [{{label}}]","annotations":"Annotations","attribution":"Attribution","attributionTitle":"Rights","authenticationFailed":"Authentication failed.","authenticationRequired":"Authentication required for full access","backToResults":"Back to results","book":"Book","bottom":"Bottom","cancel":"Cancel","canvasIndex":"Index","changeTheme":"Change theme","clearSearch":"clear","close":"Close","closeAddResourceForm":"Close form","closeAddResourceMenu":"Close resource list","closeCompanionWindow":"Close panel","closeWindow":"Close window","collapseSection":"Collapse \\"{{section}}\\" section","collapseSidePanel":"Collapse sidebar","collection":"Collection","itemList":"Item list","continue":"Continue","copy":"Copy","currentItem":"Current item","currentItem_1/1":"Current item","currentItem_1/2":"Left","currentItem_2/2":"Right","dark":"Dark theme","digitizedView":"Digitized view","dismiss":"Dismiss","highlightAllAnnotations":"Highlight all","displayNoAnnotations":"Highlight none","downloadExport":"Export workspace","downloadExportWorkspace":"Export workspace","elastic":"Elastic","elasticDescription":"Move and size windows freely in an unlimited workspace. Windows can overlap.","emptyResourceList":"Your resource list is empty","error":"Error","errorDialogConfirm":"OK","errorDialogTitle":"An error occurred","exitFullScreen":"Exit full screen","expandSection":"Expand \\"{{section}}\\" section","expandSidePanel":"Expand sidebar","exportCopied":"The workspace configuration was copied to your clipboard","fetchManifest":"Add","fullScreen":"Full Screen","gallery":"Gallery","hideZoomControls":"Hide zoom controls","iiif_homepage":"About this resource","iiif_manifest":"IIIF manifest","iiif_renderings":"Alternate formats","iiif_seeAlso":"See also","import":"Import","importWorkspace":"Import workspace","importWorkspaceHint":"Paste a Mirador 3 configuration to be imported","item":"Item: {{label}}","jsError":"Technical details","jsStack":"{{ stack }}","language":"Language","layer_hide":"Hide layer","layer_move":"Move layer","layer_opacity":"Layer opacity","layer_show":"Show layer","layer_moveToTop":"Move layer to top","layers":"Layers","light":"Light theme","links":"Links","listAllOpenWindows":"Jump to window","login":"Log in","logout":"Log out","manifestError":"The resource cannot be added:","maximizeWindow":"Maximize window","minimizeWindow":"Minimize window","mirador":"Mirador","miradorResources":"Mirador resources","miradorViewer":"Mirador viewer","more":"more...","moreResults":"More results","mosaic":"Mosaic","mosaicDescription":"Move and size windows in relation to each other, within the visible frame.","moveCompanionWindowToBottom":"Move to bottom","moveCompanionWindowToRight":"Move to right","nextCanvas":"Next item","noItemSelected":"No item selected","numItems":"{{number}} item","numItems_plural":"{{number}} items","off":"Off","openCompanionWindow_annotations":"Annotations","openCompanionWindow_attribution":"Rights","openCompanionWindow_canvas":"Index","openCompanionWindow_info":"Information","openCompanionWindow_layers":"Layers","openCompanionWindow_search":"Search","openInCompanionWindow":"Open in separate panel","openWindows":"Current open windows","pagination":"{{current}} of {{total}}","position":"Position","previewWindowTitle":"{{title}}","previousCanvas":"Previous item","related":"Related","resource":"Resource","retry":"Retry","right":"Right","rights":"License","scroll":"Scroll","searchInputLabel":"search terms","searchNextResult":"Next result","searchNoResults":"No results found","searchPreviousResult":"Previous result","searchResultsRemaining":"{{numLeft}} remaining","searchSubmitAria":"Submit search","searchTitle":"Search","selectWorkspaceMenu":"Select workspace type","showingNumAnnotations":"Showing {{number}} annotation","showingNumAnnotations_plural":"Showing {{number}} annotations","showCollection":"Show collection","showZoomControls":"Show zoom controls","sidebarPanelsNavigation":"Sidebar panels navigation","single":"Single","startHere":"Start Here","suggestSearch":"Search this document for \\"{{ query }}\\"","tableOfContentsList":"Table of contents","theme":"Theme","thumbnailList":"Thumbnail list","thumbnailNavigation":"Thumbnails","thumbnails":"Thumbnails","toggleWindowSideBar":"Toggle sidebar","totalCollections":"{{count}} collection","totalCollections_plural":"{{count}} collections","totalManifests":"{{count}} manifest","totalManifests_plural":"{{count}} manifests","tryAgain":"Try again","untitled":"[Untitled]","view":"View","viewWorkspaceConfiguration":"View workspace configuration","welcome":"Welcome to Mirador","window":"Window: {{label}}","windowMenu":"Window views & thumbnail display","windowNavigation":"Window navigation","windowPluginButtons":"Options","windowPluginMenu":"Window options","workspace":"Workspace","workspaceNavigation":"Workspace navigation","workspaceFullScreen":"Full screen","workspaceMenu":"Workspace settings","workspaceOptions":"Workspace options","workspaceSelectionTitle":"Select a workspace type","zoomIn":"Zoom in","zoomOut":"Zoom out","zoomReset":"Reset zoom"}}');


var $4ae0ed079fd9b6a1$exports = {};
$4ae0ed079fd9b6a1$exports = JSON.parse('{"translation":{"aboutThisItem":"\u6709\u5173\u6B64\u7269\u4EF6","addedFromUrl":"(\u4ECEURL\u6DFB\u52A0)","addManifestUrl":"\u6765\u6E90","addManifestUrlHelp":"IIIF\u8D44\u6E90\u7684URL","addResource":"\u6DFB\u52A0\u8D44\u6E90","annotationCanvasLabel_1/1":"\u7269\u4EF6: [{{label}}]","annotationCanvasLabel_1/2":"\u5DE6\u65B9: [{{label}}]","annotationCanvasLabel_2/2":"\u53F3\u65B9: [{{label}}]","annotations":"\u6CE8\u91CA","attribution":"\u7740\u4F5C\u6743","attributionTitle":"\u7740\u4F5C\u6743","book":"\u4E66\u7C4D","bottom":"\u4E0B\u65B9","cancel":"\u53D6\u6D88","canvasIndex":"\u7D22\u5F15","changeTheme":"\u53D8\u66F4\u4F48\u666F\u4E3B\u9898","closeAddResourceForm":"\u5173\u95ED\u8868\u683C","closeAddResourceMenu":"\u5173\u95ED\u8D44\u6E90\u5217\u8868","closeCompanionWindow":"\u5173\u95ED\u9644\u5C5E\u89C6\u7A97","closeWindow":"\u5173\u95ED\u89C6\u7A97","collapseSection":"\u5173\u95ED{{section}}\u5206\u9875","collapseSidePanel":"\u5173\u95ED\u8FB9\u680F","itemList":"\u6807\u9898\u5217\u8868","copy":"\u8907\u88FD","currentItem":"\u76EE\u524D\u7269\u4EF6","currentItem_1/1":"\u76EE\u524D\u7269\u4EF6","currentItem_1/2":"\u5DE6\u65B9","currentItem_2/2":"\u53F3\u65B9","dark":"\u9ED1\u8272\u4E3B\u9898","dismiss":"\u5173\u95ED\u4FE1\u606F","highlightAllAnnotations":"\u663E\u793A\u6240\u6709\u6CE8\u91CA","downloadExport":"\u6ED9\u51FA\u684C\u9762\u6392\u7248","downloadExportWorkspace":"\u6ED9\u51FA\u684C\u9762\u6392\u7248","elastic":"\u5F39\u6027","elasticDescription":"\u5728\u684C\u9762\u4E0A\u81EA\u7531\u6446\u653E\u89C6\u7A97","emptyResourceList":"\u8D44\u6E90\u5217\u8868\u6CA1\u6709\u7269\u4EF6","errorDialogConfirm":"\u786E\u5B9A","errorDialogTitle":"\u53D1\u751F\u9519\u8BEF","exitFullScreen":"\u9000\u51FA\u5168\u8424\u5E55","expandSection":"\u5F00\u542F{{section}}\u5206\u9875","expandSidePanel":"\u5F00\u542F\u8FB9\u680F","fetchManifest":"\u6DFB\u52A0","fullScreen":"\u5168\u8424\u5E55","gallery":"\u77E9\u5217","hideZoomControls":"\u9690\u85CF\u7F29\u653E\u9009\u9879","iiif_homepage":"\u6709\u5173\u6B64\u8D44\u6E90","iiif_manifest":"IIIF","iiif_renderings":"\u5176\u4ED6\u683C\u5F0F","iiif_seeAlso":"\u53E6\u89C1","import":"\u6ED9\u5165","importWorkspace":"\u6ED9\u5165\u684C\u9762\u6392\u7248","importWorkspaceHint":"\u5728\u6B64\u8D34\u4E0AMirador 3\u6392\u7248\u8BBE\u5B9A\u7801","item":"\u7269\u4EF6: {{label}}","language":"\u8BED\u8A00","light":"\u767D\u8272\u4E3B\u9898","links":"\u8FDE\u7ED3","listAllOpenWindows":"\u5207\u6362\u81F3\u89C6\u7A97","login":"\u767B\u5165","manifestError":"\u65E0\u6CD5\u589E\u6DFB\u8D44\u6E90:","maximizeWindow":"\u89C6\u7A97\u6700\u5927\u5316","minimizeWindow":"\u89C6\u7A97\u6700\u5C0F\u5316","mirador":"Mirador","miradorResources":"Mirador\u8D44\u6E90","miradorViewer":"Mirador\u9605\u89C8\u5668","mosaic":"\u9A6C\u8D5B\u514B","mosaicDescription":"\u5728\u684C\u9762\u4E0A\u4EE5\u683C\u72B6\u65B9\u5F0F\u6392\u5217\u89C6\u7A97","moveCompanionWindowToBottom":"\u79FB\u81F3\u4E0B\u65B9","moveCompanionWindowToRight":"\u79FB\u81F3\u53F3\u65B9","nextCanvas":"\u4E0B\u4E00\u9875","numItems":"{{number}} \u9879\u7269\u4EF6","off":"\u5173\u95ED","openCompanionWindow_annotations":"\u6CE8\u91CA","openCompanionWindow_attribution":"\u7740\u4F5C\u6743","openCompanionWindow_canvas":"\u76EE\u5F55","openCompanionWindow_info":"\u8D44\u8BAF","openInCompanionWindow":"\u79FB\u81F3\u65B0\u9644\u5C5E\u89C6\u7A97","openWindows":"\u73B0\u6709\u89C6\u7A97","pagination":"{{current}} / {{total}}","position":"\u4F4D\u7F6E","previewWindowTitle":"{{title}}","previousCanvas":"\u4E0A\u4E00\u9875","related":"\u76F8\u5173\u8D44\u8BAF","resource":"\u8D44\u6E90","right":"\u53F3\u65B9","rights":"\u7248\u6743","selectWorkspaceMenu":"\u9009\u62E9\u684C\u9762\u6392\u7248\u65B9\u5F0F","showingNumAnnotations":"\u663E\u793A {{number}} \u9879\u6CE8\u91CA","showZoomControls":"\u663E\u793A\u7F29\u653E\u9009\u9879","sidebarPanelsNavigation":"\u5207\u6362\u8FB9\u680F","single":"\u5355\u9879","startHere":"\u6309\u6B64\u5F00\u59CB","theme":"\u4F48\u666F\u4E3B\u9898","thumbnailList":"\u7F29\u56FE\u5217\u8868","thumbnailNavigation":"\u7F29\u56FE","thumbnails":"\u663E\u793A\u7F29\u56FE","toggleWindowSideBar":"\u5207\u6362\u8FB9\u680F\u5F00\u5173","tryAgain":"\u8BF7\u91CD\u8BD5","untitled":"[\u65E0\u6807\u9898]","view":"\u7269\u4EF6\u6392\u5217\u65B9\u5F0F","welcome":"\u6B22\u8FCE\u4F7F\u7528Mirador","window":"\u89C6\u7A97: {{label}}","windowMenu":"\u89C6\u7A97\u9009\u9879","windowNavigation":"\u5207\u6362\u89C6\u7A97","windowPluginButtons":"\u9009\u9879","workspace":"\u684C\u9762","workspaceFullScreen":"\u5168\u8424\u5E55","workspaceMenu":"\u684C\u9762\u8BBE\u5B9A","workspaceOptions":"\u684C\u9762\u9009\u9879","workspaceSelectionTitle":"\u9009\u62E9\u684C\u9762\u6392\u7248\u65B9\u5F0F","zoomIn":"\u653E\u5927","zoomOut":"\u653E\u5C0F","zoomReset":"\u91CD\u8BBE\u7F29\u653E"}}');


var $0ccdc17f8cc0188e$exports = {};
$0ccdc17f8cc0188e$exports = JSON.parse('{"translation":{"aboutThisItem":"\u6709\u95DC\u6B64\u7269\u4EF6","addedFromUrl":"(\u5F9EURL\u6DFB\u52A0)","addManifestUrl":"\u4F86\u6E90","addManifestUrlHelp":"IIIF\u8CC7\u6E90\u7684URL","addResource":"\u6DFB\u52A0\u8CC7\u6E90","annotationCanvasLabel_1/1":"\u7269\u4EF6: [{{label}}]","annotationCanvasLabel_1/2":"\u5DE6\u65B9: [{{label}}]","annotationCanvasLabel_2/2":"\u53F3\u65B9: [{{label}}]","annotations":"\u6CE8\u91CB","attribution":"\u8457\u4F5C\u6B0A","attributionTitle":"\u8457\u4F5C\u6B0A","book":"\u66F8\u7C4D","bottom":"\u4E0B\u65B9","cancel":"\u53D6\u6D88","canvasIndex":"\u7D22\u5F15","changeTheme":"\u8B8A\u66F4\u4F48\u666F\u4E3B\u984C","closeAddResourceForm":"\u95DC\u9589\u8868\u683C","closeAddResourceMenu":"\u95DC\u9589\u8CC7\u6E90\u5217\u8868","closeCompanionWindow":"\u95DC\u9589\u9644\u5C6C\u8996\u7A97","closeWindow":"\u95DC\u9589\u8996\u7A97","collapseSection":"\u95DC\u9589{{section}}\u5206\u9801","collapseSidePanel":"\u95DC\u9589\u908A\u6B04","itemList":"\u6A19\u984C\u5217\u8868","copy":"\u8907\u88FD","currentItem":"\u76EE\u524D\u7269\u4EF6","currentItem_1/1":"\u76EE\u524D\u7269\u4EF6","currentItem_1/2":"\u5DE6\u65B9","currentItem_2/2":"\u53F3\u65B9","dark":"\u9ED1\u8272\u4E3B\u984C","dismiss":"\u95DC\u9589\u4FE1\u606F","highlightAllAnnotations":"\u986F\u793A\u6240\u6709\u6CE8\u91CB","downloadExport":"\u6ED9\u51FA\u684C\u9762\u6392\u7248","downloadExportWorkspace":"\u6ED9\u51FA\u684C\u9762\u6392\u7248","elastic":"\u5F48\u6027","elasticDescription":"\u5728\u684C\u9762\u4E0A\u81EA\u7531\u64FA\u653E\u8996\u7A97","emptyResourceList":"\u8CC7\u6E90\u5217\u8868\u6C92\u6709\u7269\u4EF6","errorDialogConfirm":"\u78BA\u5B9A","errorDialogTitle":"\u767C\u751F\u932F\u8AA4","exitFullScreen":"\u9000\u51FA\u5168\u87A2\u5E55","expandSection":"\u958B\u555F{{section}}\u5206\u9801","expandSidePanel":"\u958B\u555F\u908A\u6B04","fetchManifest":"\u6DFB\u52A0","fullScreen":"\u5168\u87A2\u5E55","gallery":"\u77E9\u5217","hideZoomControls":"\u96B1\u85CF\u7E2E\u653E\u9078\u9805","iiif_homepage":"\u6709\u95DC\u6B64\u8CC7\u6E90","iiif_manifest":"IIIF","iiif_renderings":"\u5176\u4ED6\u683C\u5F0F","iiif_seeAlso":"\u53E6\u898B","import":"\u6ED9\u5165","importWorkspace":"\u6ED9\u5165\u684C\u9762\u6392\u7248","importWorkspaceHint":"\u5728\u6B64\u8CBC\u4E0AMirador 3\u6392\u7248\u8A2D\u5B9A\u78BC","item":"\u7269\u4EF6: {{label}}","language":"\u8A9E\u8A00","light":"\u767D\u8272\u4E3B\u984C","links":"\u9023\u7D50","listAllOpenWindows":"\u5207\u63DB\u81F3\u8996\u7A97","login":"\u767B\u5165","manifestError":"\u7121\u6CD5\u589E\u6DFB\u8CC7\u6E90:","maximizeWindow":"\u8996\u7A97\u6700\u5927\u5316","minimizeWindow":"\u8996\u7A97\u6700\u5C0F\u5316","mirador":"Mirador","miradorResources":"Mirador\u8CC7\u6E90","miradorViewer":"Mirador\u95B1\u89BD\u5668","mosaic":"\u99AC\u8CFD\u514B","mosaicDescription":"\u5728\u684C\u9762\u4E0A\u4EE5\u683C\u72C0\u65B9\u5F0F\u6392\u5217\u8996\u7A97","moveCompanionWindowToBottom":"\u79FB\u81F3\u4E0B\u65B9","moveCompanionWindowToRight":"\u79FB\u81F3\u53F3\u65B9","nextCanvas":"\u4E0B\u4E00\u9801","numItems":"{{number}} \u9805\u7269\u4EF6","off":"\u95DC\u9589","openCompanionWindow_annotations":"\u6CE8\u91CB","openCompanionWindow_attribution":"\u8457\u4F5C\u6B0A","openCompanionWindow_canvas":"\u76EE\u9304","openCompanionWindow_info":"\u8CC7\u8A0A","openInCompanionWindow":"\u79FB\u81F3\u65B0\u9644\u5C6C\u8996\u7A97","openWindows":"\u73FE\u6709\u8996\u7A97","pagination":"{{current}} / {{total}}","position":"\u4F4D\u7F6E","previewWindowTitle":"{{title}}","previousCanvas":"\u4E0A\u4E00\u9801","related":"\u76F8\u95DC\u8CC7\u8A0A","resource":"\u8CC7\u6E90","right":"\u53F3\u65B9","rights":"\u7248\u6B0A","selectWorkspaceMenu":"\u9078\u64C7\u684C\u9762\u6392\u7248\u65B9\u5F0F","showingNumAnnotations":"\u986F\u793A {{number}} \u9805\u6CE8\u91CB","showZoomControls":"\u986F\u793A\u7E2E\u653E\u9078\u9805","sidebarPanelsNavigation":"\u5207\u63DB\u908A\u6B04","single":"\u55AE\u9805","startHere":"\u6309\u6B64\u958B\u59CB","theme":"\u4F48\u666F\u4E3B\u984C","thumbnailList":"\u7E2E\u5716\u5217\u8868","thumbnailNavigation":"\u7E2E\u5716","thumbnails":"\u986F\u793A\u7E2E\u5716","toggleWindowSideBar":"\u5207\u63DB\u908A\u6B04\u958B\u95DC","tryAgain":"\u8ACB\u91CD\u8A66","untitled":"[\u7121\u6A19\u984C]","view":"\u7269\u4EF6\u6392\u5217\u65B9\u5F0F","welcome":"\u6B61\u8FCE\u4F7F\u7528Mirador","window":"\u8996\u7A97: {{label}}","windowMenu":"\u8996\u7A97\u9078\u9805","windowNavigation":"\u5207\u63DB\u8996\u7A97","windowPluginButtons":"\u63D2\u4EF6","workspace":"\u684C\u9762","workspaceFullScreen":"\u5168\u87A2\u5E55","workspaceMenu":"\u684C\u9762\u8A2D\u5B9A","workspaceOptions":"\u684C\u9762\u9078\u9805","workspaceSelectionTitle":"\u9078\u64C7\u684C\u9762\u6392\u7248\u65B9\u5F0F","zoomIn":"\u653E\u5927","zoomOut":"\u653E\u5C0F","zoomReset":"\u91CD\u8A2D\u7E2E\u653E"}}');


var $8a0bdbd9d900ff59$exports = {};
$8a0bdbd9d900ff59$exports = JSON.parse('{"translation":{"aboutMirador":"A propos du projet Mirador","aboutThisItem":"Informations","addedFromUrl":"(Ajout\xe9 depuis une URL)","addManifestUrl":"Emplacement de la ressource","addManifestUrlHelp":"Coller ici l\'URL de la ressource IIIF","addResource":"Ajouter une ressource","annotationCanvasLabel_1/1":"Item : [{{label}}]","annotationCanvasLabel_1/2":"Gauche : [{{label}}]","annotationCanvasLabel_2/2":"Droite : [{{label}}]","annotations":"Annotations","attribution":"Attribution","attributionTitle":"Droits","authenticationFailed":"L\'authentification a \xe9chou\xe9.","authenticationRequired":"Authentification requise pour un acc\xe8s complet","backToResults":"Retour aux r\xe9sultats","book":"Livre","bottom":"Bas","cancel":"Annuler","canvasIndex":"Index","changeTheme":"Changer le th\xe8me","clearSearch":"effacer","closeAddResourceForm":"Fermer le panneau","closeAddResourceMenu":"Fermer la liste des ressources","closeCompanionWindow":"Fermer le panneau","closeWindow":"Fermer cette fen\xeatre","collapseSection":"Replier la section \\"{{section}}\\"","collapseSidePanel":"Replier le panneau","itemList":"Liste compacte","continue":"Continuer","copy":"Copier","currentItem":"Image courante","currentItem_1/1":"Image courante","currentItem_1/2":"Gauche","currentItem_2/2":"Droite","dark":"Th\xe8me sombre","digitizedView":"Vue de l\'objet num\xe9rique","dismiss":"Rejeter","highlightAllAnnotations":"Afficher tout","displayNoAnnotations":"Masquer tout","downloadExport":"Exporter l\'espace de travail","downloadExportWorkspace":"Exporter l\'espace de travail","elastic":"Elastique","elasticDescription":"D\xe9placer et redimensionner librement les fen\xeatres dans un espace de travail non limit\xe9 par l\'\xe9cran. Les fen\xeatres peuvent \xeatre superpos\xe9es.","emptyResourceList":"Votre liste de ressource est vide","error":"Erreur","errorDialogConfirm":"OK","errorDialogTitle":"Une erreur est survenue","exitFullScreen":"Quitter le plein \xe9cran","expandSection":"D\xe9plier la section \\"{{section}}\\"","expandSidePanel":"D\xe9plier le panneau","exportCopied":"La configuration de l\'espace de travail a \xe9t\xe9 copi\xe9e dans votre presse-papier","fetchManifest":"Ajouter","fullScreen":"Plein \xe9cran","gallery":"Galerie","hideZoomControls":"D\xe9sactiver les commandes de zoom","iiif_homepage":"A propos de cette ressource","iiif_manifest":"Manifeste IIIF","iiif_renderings":"Formats alternatifs","iiif_seeAlso":"Voir aussi","import":"Importer","importWorkspace":"Importer un espace de travail","importWorkspaceHint":"Ins\xe9rer une configuration Mirador 3 \xe0 importer","item":"Item : {{label}}","jsError":"D\xe9tails techniques","jsStack":"{{ stack }}","language":"Langue","layer_hide":"Masquer le calque","layer_move":"D\xe9placer le calque","layer_opacity":"Opacit\xe9 du calque","layer_show":"Afficher le calque","layer_moveToTop":"D\xe9placer le calque en haut","layers":"Calques","light":"Th\xe8me clair","links":"Liens","listAllOpenWindows":"Lister les fen\xeatres","login":"Se connecter","logout":"Se d\xe9connecter","manifestError":"Cette ressource ne peut pas \xeatre ajout\xe9e :","maximizeWindow":"Agrandir cette fen\xeatre","minimizeWindow":"R\xe9duire cette fen\xeatre","mirador":"Mirador","miradorResources":"Ressources Mirador","miradorViewer":"Visualiseur Mirador","more":"plus...","moreResults":"Plus de r\xe9sultats","mosaic":"Mosa\xefque","mosaicDescription":"D\xe9placer et redimensionner les fen\xeatres les unes par rapport aux autres dans l\'espace disponible sur l\'\xe9cran","moveCompanionWindowToBottom":"D\xe9placer en bas","moveCompanionWindowToRight":"D\xe9placer \xe0 droite","nextCanvas":"Suivant","noItemSelected":"Aucun \xe9l\xe9ment s\xe9lectionn\xe9","numItems":"{{number}} image","numItems_plural":"{{number}} images","off":"aucun","openCompanionWindow_annotations":"Annotations","openCompanionWindow_attribution":"Droits","openCompanionWindow_canvas":"Index","openCompanionWindow_info":"Informations","openCompanionWindow_layers":"Calques","openCompanionWindow_search":"Rechercher","openInCompanionWindow":"Ouvrir dans un panneau s\xe9par\xe9","openWindows":"Fen\xeatres ouvertes","pagination":"{{current}} sur {{total}}","position":"Position","previewWindowTitle":"{{title}}","previousCanvas":"Pr\xe9c\xe9dent","related":"En relation","resource":"Ressource","retry":"R\xe9essayer","right":"Droite","rights":"Licence","scroll":"D\xe9filement horizontal","searchInputLabel":"Chercher un mot","searchNextResult":"R\xe9sultat suivant","searchNoResults":"Aucun r\xe9sultat trouv\xe9","searchPreviousResult":"R\xe9sultat pr\xe9c\xe9dent","searchSubmitAria":"Lancer la recherche","searchTitle":"Rechercher","selectWorkspaceMenu":"Changer de type d\'espace de travail","showingNumAnnotations":"{{number}} annotation affich\xe9e","showingNumAnnotations_plural":"{{number}} annotations affich\xe9es","showCollection":"Voir la collection","showZoomControls":"Activer les commandes de zoom","sidebarPanelsNavigation":"Navigation dans les panneaux lat\xe9raux","single":"Simple","startHere":"Commencer ici","suggestSearch":"Rechercher \\"{{ query }}\\" dans ce document","tableOfContentsList":"Sommaire","theme":"Th\xe8me","thumbnailList":"Liste des vignettes","thumbnailNavigation":"Vignettes","thumbnails":"Afficher les vignettes","toggleWindowSideBar":"Afficher le menu lat\xe9ral","totalCollections":"{{count}} collection","totalCollections_plural":"{{count}} collections","totalManifests":"{{count}} manifeste","totalManifests_plural":"{{count}} manifestes","tryAgain":"Essayer \xe0 nouveau","untitled":"[Sans titre]","view":"Voir les images en mode","welcome":"Bienvenue dans Mirador","window":"Fen\xeatre : {{label}}","windowMenu":"Options de fen\xeatre","windowNavigation":"Navigation dans les fen\xeatres","windowPluginButtons":"Options","windowPluginMenu":"Autres options et outils","workspace":"Espace de travail","workspaceNavigation":"Menu de l\'espace de travail","workspaceFullScreen":"Plein \xe9cran","workspaceMenu":"R\xe9glages de l\'espace de travail","workspaceOptions":"Options de l\'espace de travail","workspaceSelectionTitle":"S\xe9lectionner un type d\'espace de travail","zoomIn":"Zoom avant","zoomOut":"Zoom arri\xe8re","zoomReset":"R\xe9initialiser le zoom"}}');


var $4f14724e586bbc28$exports = {};
$4f14724e586bbc28$exports = JSON.parse('{"translation":{"aboutMirador":"Project Mirador\u306B\u3064\u3044\u3066","aboutThisItem":"\u3053\u306E\u8CC7\u6599\u306B\u3064\u3044\u3066","addedFromUrl":"(URL\u3067\u8FFD\u52A0)","addManifestUrl":"\u8CC7\u6599\u306EURL","addManifestUrlHelp":"IIIF\u8CC7\u6599\u306EURL","addResource":"\u8CC7\u6599\u306E\u8FFD\u52A0","annotationCanvasLabel_1/1":"\u30A2\u30A4\u30C6\u30E0: [{{label}}]","annotationCanvasLabel_1/2":"\u5DE6: [{{label}}]","annotationCanvasLabel_2/2":"\u53F3: [{{label}}]","annotations":"\u30A2\u30CE\u30C6\u30FC\u30B7\u30E7\u30F3","attribution":"\u5E30\u5C5E","attributionTitle":"\u6A29\u5229","authenticationFailed":"\u8A8D\u8A3C\u5931\u6557","authenticationRequired":"\u30D5\u30EB\u30A2\u30AF\u30BB\u30B9\u306B\u306F\u8A8D\u8A3C\u304C\u5FC5\u8981","backToResults":"\u7D50\u679C\u306B\u623B\u308B","book":"\u898B\u958B\u304D","bottom":"\u4E0B\u90E8","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","canvasIndex":"\u30A4\u30F3\u30C7\u30C3\u30AF\u30B9","changeTheme":"\u30C6\u30FC\u30DE\u306E\u5909\u66F4","clearSearch":"\u30AF\u30EA\u30A2","close":"\u9589\u3058\u308B","closeAddResourceForm":"\u30D5\u30A9\u30FC\u30E0\u3092\u9589\u3058\u308B","closeAddResourceMenu":"\u8CC7\u6599\u4E00\u89A7\u3092\u9589\u3058\u308B","closeCompanionWindow":"\u30D1\u30CD\u30EB\u3092\u9589\u3058\u308B","closeWindow":"\u30A6\u30A4\u30F3\u30C9\u30A6\u3092\u9589\u3058\u308B","collapseSection":"{{section}} \u30BB\u30AF\u30B7\u30E7\u30F3\u3092\u7573\u3080","collapseSidePanel":"\u30B5\u30A4\u30C9\u30D0\u30FC\u3092\u7573\u3080","collection":"\u30B3\u30EC\u30AF\u30B7\u30E7\u30F3","itemList":"\u30A2\u30A4\u30C6\u30E0\u4E00\u89A7","continue":"\u7D9A\u3051\u308B","copy":"\u30B3\u30D4\u30FC","currentItem":"\u73FE\u5728\u306E\u30A2\u30A4\u30C6\u30E0","currentItem_1/1":"\u73FE\u5728\u306E\u30A2\u30A4\u30C6\u30E0","currentItem_1/2":"\u5DE6","currentItem_2/2":"\u53F3","dark":"\u30C0\u30FC\u30AF\u306A\u30C6\u30FC\u30DE","digitizedView":"\u30C7\u30B8\u30BF\u30EB\u30D3\u30E5\u30FC","dismiss":"\u7247\u4ED8\u3051","highlightAllAnnotations":"\u3059\u3079\u3066\u3092\u8868\u793A","displayNoAnnotations":"\u30A2\u30CE\u30C6\u30FC\u30B7\u30E7\u30F3\u3092\u975E\u8868\u793A","downloadExport":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u3092\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8","downloadExportWorkspace":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u3092\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8","elastic":"\u4F38\u7E2E","elasticDescription":"\u81EA\u7531\u306A\u30A6\u30A4\u30F3\u30C9\u30A6\u306E\u4F38\u7E2E","emptyResourceList":"\u8CC7\u6599\u306E\u4E00\u89A7\u304C\u7A7A\u3067\u3059","error":"\u30A8\u30E9\u30FC","errorDialogConfirm":"OK","errorDialogTitle":"\u30A8\u30E9\u30FC\u767A\u751F","exitFullScreen":"\u5168\u753B\u9762\u3092\u89E3\u9664","expandSection":"\u30BB\u30AF\u30B7\u30E7\u30F3 {{section}}\u3092\u62E1\u5927","expandSidePanel":"\u30B5\u30A4\u30C9\u30D0\u30FC\u3092\u62E1\u5927","exportCopied":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u306E\u8A2D\u5B9A\u304C\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002","fetchManifest":"\u8FFD\u52A0","fullScreen":"\u5168\u753B\u9762","gallery":"\u30AE\u30E3\u30E9\u30EA\u30FC","hideZoomControls":"zoom\u5236\u5FA1\u3092\u96A0\u3059","iiif_homepage":"IIIF\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8","iiif_manifest":"IIIF \u30DE\u30CB\u30D5\u30A7\u30B9\u30C8","iiif_renderings":"\u5225\u306E\u5F62\u5F0F","iiif_seeAlso":"\u53C2\u7167","import":"\u53D6\u308A\u8FBC\u307F","importWorkspace":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u306E\u53D6\u308A\u8FBC\u307F","importWorkspaceHint":"Mirador3\u306E\u8A2D\u5B9A\u3092\u8CBC\u308A\u4ED8\u3051","item":"\u30A2\u30A4\u30C6\u30E0: {{label}}","jsError":"\u6280\u8853\u7684\u306A\u8A73\u7D30","jsStack":"{{ stack }}","language":"\u8A00\u8A9E","layer_hide":"\u30EC\u30A4\u30E4\u30FC\u3092\u96A0\u3059","layer_move":"\u30EC\u30A4\u30E4\u30FC\u3092\u52D5\u304B\u3059","layer_opacity":"\u30EC\u30A4\u30E4\u30FC\u306E\u900F\u904E\u5EA6","layer_show":"\u30EC\u30A4\u30E4\u30FC\u3092\u8868\u793A","layer_moveToTop":"\u30EC\u30A4\u30E4\u30FC\u3092\u30C8\u30C3\u30D7\u3078","layers":"\u30EC\u30A4\u30E4\u30FC","light":"\u660E\u308B\u3044\u30C6\u30FC\u30DE","links":"\u30EA\u30F3\u30AF","listAllOpenWindows":"\u30A6\u30A4\u30F3\u30C9\u30A6\u306B\u30B8\u30E3\u30F3\u30D7","login":"\u30ED\u30B0\u30A4\u30F3","logout":"\u30ED\u30B0\u30A2\u30A6\u30C8","manifestError":"\u8CC7\u6599\u8FFD\u52A0\u306B\u5931\u6557:","maximizeWindow":"\u30A6\u30A4\u30F3\u30C9\u30A6\u3092\u6700\u5927\u5316","minimizeWindow":"\u30A6\u30A4\u30F3\u30C9\u30A6\u3092\u6700\u5C0F\u5316","mirador":"Mirador","miradorResources":"Mirador\u8CC7\u6599","miradorViewer":"Mirador\u30D3\u30E5\u30FC\u30EF","more":"\u3055\u3089\u306B...","moreResults":"\u3055\u3089\u306B\u7D50\u679C\u3092","mosaic":"\u30E2\u30B6\u30A4\u30AF","mosaicDescription":"\u30E2\u30B6\u30A4\u30AF\u8868\u793A","moveCompanionWindowToBottom":"\u4E0B\u90E8\u306B\u79FB\u52D5","moveCompanionWindowToRight":"\u53F3\u306B\u79FB\u52D5","nextCanvas":"\u6B21\u306E\u30A2\u30A4\u30C6\u30E0","noItemSelected":"\u30A2\u30A4\u30C6\u30E0\u304C\u672A\u9078\u629E","numItems":"{{number}} \u30A2\u30A4\u30C6\u30E0","off":"\u30AA\u30D5","openCompanionWindow_annotations":"\u30A2\u30CE\u30C6\u30FC\u30B7\u30E7\u30F3","openCompanionWindow_attribution":"\u6A29\u5229","openCompanionWindow_canvas":"\u30A4\u30F3\u30C7\u30C3\u30AF\u30B9","openCompanionWindow_info":"\u60C5\u5831","openCompanionWindow_layers":"\u30EC\u30A4\u30E4\u30FC","openCompanionWindow_search":"\u691C\u7D22","openInCompanionWindow":"\u5225\u306E\u30D1\u30CD\u30EB\u3067\u958B\u304F","openWindows":"\u73FE\u5728\u958B\u3044\u3066\u3044\u308B\u30A6\u30A4\u30F3\u30C9\u30A6","pagination":"{{current}} of {{total}}","position":"\u4F4D\u7F6E","previewWindowTitle":"{{title}}","previousCanvas":"\u524D\u306E\u30A2\u30A4\u30C6\u30E0","related":"\u95A2\u9023","resource":"\u8CC7\u6599","retry":"\u30EA\u30C8\u30E9\u30A4","right":"\u53F3\u5074","rights":"\u5229\u7528\u6761\u4EF6","scroll":"\u30B9\u30AF\u30ED\u30FC\u30EB","searchInputLabel":"\u691C\u7D22\u8A9E","searchNextResult":"\u6B21\u306E\u7D50\u679C","searchNoResults":"\u30D2\u30C3\u30C8\u305B\u305A","searchPreviousResult":"\u524D\u306E\u7D50\u679C","searchSubmitAria":"\u691C\u7D22","searchTitle":"\u691C\u7D22","selectWorkspaceMenu":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u30BF\u30A4\u30D7\u306E\u9078\u629E","showingNumAnnotations":"\u30A2\u30CE\u30C6\u30FC\u30B7\u30E7\u30F3 {{number}} \u3092\u8868\u793A","showCollection":"\u30B3\u30EC\u30AF\u30B7\u30E7\u30F3\u3092\u8868\u793A","showZoomControls":"\u30BA\u30FC\u30E0\u64CD\u4F5C\u3092\u8868\u793A","sidebarPanelsNavigation":"\u30B5\u30A4\u30C9\u30D0\u30FC\u30D1\u30CD\u30EB\u306E\u64CD\u4F5C","single":"\u5358\u4E00","startHere":"\u3053\u3053\u304B\u3089\u59CB\u3081\u308B","suggestSearch":"\u3053\u306E\u6587\u66F8\u3092 \\"{{ query }}\\" \u3067\u691C\u7D22","tableOfContentsList":"\u76EE\u6B21","theme":"\u30C6\u30FC\u30DE","thumbnailList":"\u30B5\u30E0\u30CD\u30A4\u30EB\u4E00\u89A7","thumbnailNavigation":"\u30B5\u30E0\u30CD\u30A4\u30EB","thumbnails":"\u30B5\u30E0\u30CD\u30A4\u30EB\u8868\u793A","toggleWindowSideBar":"\u30B5\u30A4\u30C9\u30D0\u30FC\u5207\u308A\u66FF\u3048","totalCollections":"{{count}} \u30B3\u30EC\u30AF\u30B7\u30E7\u30F3","totalManifests":"{{count}} \u30DE\u30CB\u30D5\u30A7\u30B9\u30C8","tryAgain":"\u3082\u3046\u4E00\u5EA6\u8A66\u3059","untitled":"[\u30BF\u30A4\u30C8\u30EB\u7121\u3057]","view":"\u8868\u793A\u306E\u4ED5\u65B9","welcome":"Mirador\u306B\u3088\u3046\u3053\u305D","window":"{{label}} \u30A6\u30A4\u30F3\u30C9\u30A6","windowMenu":"\u30A6\u30A4\u30F3\u30C9\u30A6\u30E1\u30CB\u30E5\u30FC","windowNavigation":"\u30A6\u30A3\u30F3\u30C9\u30A6\u64CD\u4F5C","windowPluginButtons":"\u30AA\u30D7\u30B7\u30E7\u30F3","windowPluginMenu":"\u30A6\u30A4\u30F3\u30C9\u30A6\u30AA\u30D7\u30B7\u30E7\u30F3","workspace":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9","workspaceNavigation":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u30CA\u30D3","workspaceFullScreen":"\u5168\u753B\u9762","workspaceMenu":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u306E\u8A2D\u5B9A","workspaceOptions":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u306E\u30AA\u30D7\u30B7\u30E7\u30F3","workspaceSelectionTitle":"\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9\u306E\u30BF\u30A4\u30D7\u3092\u9078\u629E","zoomIn":"\u30BA\u30FC\u30E0\u30A4\u30F3","zoomOut":"\u30BA\u30FC\u30E0\u30A2\u30A6\u30C8","zoomReset":"\u30BA\u30FC\u30E0\u3092\u623B\u3059"}}');


var $965fa5721f64c95f$exports = {};
$965fa5721f64c95f$exports = JSON.parse('{"translation":{"aboutMirador":"Mirador \uD504\uB85C\uC81D\uD2B8\uC5D0 \uB300\uD558\uC5EC","aboutThisItem":"\uD574\uB2F9 \uC544\uC774\uD15C\uC5D0 \uB300\uD558\uC5EC","addedFromUrl":"(URL\uC5D0\uC11C \uCD94\uAC00\uB428)","addManifestUrl":"\uB9AC\uC18C\uC2A4\uC758 \uC704\uCE58","addManifestUrlHelp":"IIIF \uB9AC\uC18C\uC2A4\uC758 URL","addResource":"\uB9AC\uC18C\uC2A4 \uCD94\uAC00","annotationCanvasLabel_1/1":"\uC544\uC774\uD15C: [{{label}}]","annotationCanvasLabel_1/2":"\uC67C\uCABD: [{{label}}]","annotationCanvasLabel_2/2":"\uC624\uB978\uCABD: [{{label}}]","annotations":"\uC8FC\uC11D","attribution":"\uADC0\uC18D","attributionTitle":"\uAD8C\uB9AC","authenticationFailed":"\uC778\uC99D \uC2E4\uD328.","authenticationRequired":"\uBAA8\uB4E0 \uC815\uBCF4\uC5D0 \uC811\uADFC\uD558\uAE30 \uC704\uD574\uC120 \uC778\uC99D\uC774 \uD544\uC694\uD569\uB2C8\uB2E4.","backToResults":"\uACB0\uACFC\uB85C \uB3CC\uC544\uAC00\uAE30","book":"\uCC45","bottom":"\uC544\uB798","cancel":"\uCDE8\uC18C","canvasIndex":"\uC778\uB371\uC2A4","changeTheme":"\uD14C\uB9C8 \uBCC0\uACBD","clearSearch":"\uC9C0\uC6B0\uAE30","close":"\uB2EB\uAE30","closeAddResourceForm":"\uD3FC \uB2EB\uAE30","closeAddResourceMenu":"\uB9AC\uC18C\uC2A4 \uBAA9\uB85D \uB2EB\uAE30","closeCompanionWindow":"\uD328\uB110 \uB2EB\uAE30","closeWindow":"\uC708\uB3C4\uC6B0 \uB2EB\uAE30","collapseSection":"\\"{{section}}\\" \uC139\uC158 \uC811\uAE30","collapseSidePanel":"\uC0AC\uC774\uB4DC\uBC14 \uC811\uAE30","collection":"\uCEEC\uB809\uC158","itemList":"\uC544\uC774\uD15C \uBAA9\uB85D","continue":"\uACC4\uC18D\uD558\uAE30","copy":"\uBCF5\uC0AC","currentItem":"\uD604\uC7AC \uC544\uC774\uD15C","currentItem_1/1":"\uD604\uC7AC \uC544\uC774\uD15C","currentItem_1/2":"\uC67C\uCABD","currentItem_2/2":"\uC624\uB978\uCABD","dark":"\uB2E4\uD06C \uBAA8\uB4DC","digitizedView":"\uB514\uC9C0\uD138 \uBDF0","dismiss":"\uBB34\uC2DC\uD558\uAE30","highlightAllAnnotations":"\uBAA8\uB450 \uD558\uC774\uB77C\uC774\uD2B8\uD558\uAE30","displayNoAnnotations":"\uD558\uC774\uB77C\uC774\uD2B8 \uD574\uC81C","downloadExport":"\uC791\uC5C5\uACF5\uAC04 \uB0B4\uBCF4\uB0B4\uAE30","downloadExportWorkspace":"\uC791\uC5C5\uACF5\uAC04 \uB0B4\uBCF4\uB0B4\uAE30","elastic":"\uC2E0\uCD95\uC131","elasticDescription":"\uBB34\uD55C\uD55C \uC791\uC5C5\uACF5\uAC04\uC5D0\uC11C \uC708\uB3C4\uC6B0\uB97C \uC790\uC720\uB86D\uAC8C \uC6C0\uC9C1\uC774\uACE0 \uC870\uC808\uD574\uBCF4\uC138\uC694. \uC708\uB3C4\uC6B0\uB294 \uC11C\uB85C \uACB9\uCE60 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","emptyResourceList":"\uB9AC\uC18C\uC2A4 \uBAA9\uB85D\uC774 \uBE44\uC5B4\uC788\uC2B5\uB2C8\uB2E4","error":"\uC624\uB958","errorDialogConfirm":"\uD5C8\uB77D","errorDialogTitle":"\uC624\uB958 \uBC1C\uC0DD","exitFullScreen":"\uC804\uCCB4\uD654\uBA74\uC5D0\uC11C \uB098\uAC00\uAE30","expandSection":"\\"{{section}}\\" \uC139\uC158 \uD655\uC7A5","expandSidePanel":"\uC0AC\uC774\uB4DC\uBC14 \uD655\uC7A5","exportCopied":"\uC791\uC5C5\uACF5\uAC04 \uD658\uACBD\uC124\uC815\uC744 \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uD588\uC2B5\uB2C8\uB2E4","fetchManifest":"\uCD94\uAC00\uD558\uAE30","fullScreen":"\uC804\uCCB4\uD654\uBA74","gallery":"\uAC24\uB7EC\uB9AC","hideZoomControls":"\uD655\uB300/\uCD95\uC18C \uAE30\uB2A5 \uC228\uAE30\uAE30","iiif_homepage":"\uD574\uB2F9 \uB9AC\uC18C\uC2A4\uC5D0 \uB300\uD558\uC5EC","iiif_manifest":"IIIF \uB9E4\uB2C8\uD398\uC2A4\uD2B8","iiif_renderings":"\uB300\uCCB4 \uD3EC\uB9F7","iiif_seeAlso":"\uCC38\uACE0","import":"\uAC00\uC838\uC624\uAE30","importWorkspace":"\uC791\uC5C5\uACF5\uAC04 \uAC00\uC838\uC624\uAE30","importWorkspaceHint":"Mirador 3 \uD658\uACBD\uC124\uC815 \uAC00\uC838\uC640 \uBD99\uC5EC\uB123\uAE30","item":"\uC544\uC774\uD15C: {{label}}","jsError":"\uAE30\uC220\uC801\uC778 \uC138\uBD80\uC0AC\uD56D","jsStack":"{{ stack }}","language":"\uC5B8\uC5B4","layer_hide":"\uB808\uC774\uC5B4 \uC228\uAE30\uAE30","layer_move":"\uB808\uC774\uC5B4 \uC6C0\uC9C1\uC774\uAE30","layer_opacity":"\uB808\uC774\uC5B4 \uBD88\uD22C\uBA85\uB3C4","layer_show":"\uB808\uC774\uC5B4 \uBCF4\uC774\uAE30","layer_moveToTop":"\uB808\uC774\uC5B4\uB97C \uC704\uB85C \uC62E\uAE30\uAE30","layers":"\uB808\uC774\uC5B4","light":"\uB77C\uC774\uD2B8 \uBAA8\uB4DC","links":"\uB9C1\uD06C","listAllOpenWindows":"\uC708\uB3C4\uC6B0\uB85C \uC774\uB3D9\uD558\uAE30","login":"\uB85C\uADF8\uC778","logout":"\uB85C\uADF8\uC544\uC6C3","manifestError":"\uB9AC\uC18C\uC2A4\uB97C \uCD94\uAC00\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4:","maximizeWindow":"\uC708\uB3C4\uC6B0 \uD06C\uAE30 \uCD5C\uB300\uD654","minimizeWindow":"\uC708\uB3C4\uC6B0 \uD06C\uAE30 \uCD5C\uC18C\uD654","mirador":"Mirador","miradorResources":"Mirador \uB9AC\uC18C\uC2A4","miradorViewer":"Mirador \uBDF0\uC5B4","more":"\uB354 \uBCF4\uAE30...","moreResults":"\uACB0\uACFC \uB354 \uBCF4\uAE30","mosaic":"\uBAA8\uC790\uC774\uD06C","mosaicDescription":"\uD504\uB808\uC784 \uB0B4\uC5D0\uC11C \uC708\uB3C4\uC6B0\uB97C \uC774\uB3D9\uD558\uACE0 \uD06C\uAE30\uB97C \uC870\uC815\uD569\uB2C8\uB2E4.","moveCompanionWindowToBottom":"\uC544\uB798\uB85C \uC62E\uAE30\uAE30","moveCompanionWindowToRight":"\uC624\uB978\uCABD\uC73C\uB85C \uC62E\uAE30\uAE30","nextCanvas":"\uB2E4\uC74C \uC544\uC774\uD15C","noItemSelected":"\uC544\uC774\uD15C\uC774 \uC120\uD0DD\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4","numItems":"{{number}}\uAC1C\uC758 \uC544\uC774\uD15C","numItems_plural":"{{number}}\uAC1C\uC758 \uC544\uC774\uD15C","off":"\uB044\uAE30","openCompanionWindow_annotations":"\uC8FC\uC11D","openCompanionWindow_attribution":"\uAD8C\uB9AC","openCompanionWindow_canvas":"\uC778\uB371\uC2A4","openCompanionWindow_info":"\uC815\uBCF4","openCompanionWindow_layers":"\uB808\uC774\uC5B4","openCompanionWindow_search":"\uAC80\uC0C9","openInCompanionWindow":"\uBCC4\uB3C4\uC758 \uD328\uB110\uC5D0\uC11C \uC5F4\uAE30","openWindows":"\uD604\uC7AC \uC5F4\uB824\uC788\uB294 \uC708\uB3C4\uC6B0","pagination":"{{current}} of {{total}}","position":"\uBC30\uCE58","previewWindowTitle":"{{title}}","previousCanvas":"\uC774\uC804 \uC544\uC774\uD15C","related":"\uAD00\uB828","resource":"\uB9AC\uC18C\uC2A4","retry":"\uC7AC\uC2DC\uB3C4","right":"\uC624\uB978\uCABD","rights":"\uB77C\uC774\uC120\uC2A4","scroll":"\uC2A4\uD06C\uB864","searchInputLabel":"\uC6A9\uC5B4 \uCC3E\uAE30","searchNextResult":"\uB2E4\uC74C \uACB0\uACFC","searchNoResults":"\uD574\uB2F9 \uACB0\uACFC \uC5C6\uC74C","searchPreviousResult":"\uC774\uC804 \uACB0\uACFC","searchResultsRemaining":"{{numLeft}}\uAC1C \uB0A8\uC74C","searchSubmitAria":"\uAC80\uC0C9\uD558\uAE30","searchTitle":"\uAC80\uC0C9","selectWorkspaceMenu":"\uC791\uC5C5\uACF5\uAC04 \uC720\uD615 \uC120\uD0DD","showingNumAnnotations":"{{number}}\uAC1C\uC758 \uC8FC\uC11D \uB098\uD0C0\uB0B4\uAE30","showingNumAnnotations_plural":"{{number}}\uAC1C\uC758 \uC8FC\uC11D \uB098\uD0C0\uB0B4\uAE30","showCollection":"\uCEEC\uB809\uC158 \uBCF4\uC774\uAE30","showZoomControls":"\uD655\uB300/\uCD95\uC18C \uAE30\uB2A5 \uBCF4\uC774\uAE30","sidebarPanelsNavigation":"\uC0AC\uC774\uB4DC\uBC14 \uD328\uB110 \uD0D0\uC0C9","single":"\uD55C \uAC1C","startHere":"\uC2DC\uC791\uD558\uAE30","suggestSearch":"\uC774 \uBB38\uC11C\uB97C \\"{{ query }}\\"\uB85C \uAC80\uC0C9\uD558\uAE30","tableOfContentsList":"\uBAA9\uCC28","theme":"\uD14C\uB9C8","thumbnailList":"\uC378\uB124\uC77C \uBAA9\uB85D","thumbnailNavigation":"\uC378\uB124\uC77C","thumbnails":"\uC378\uB124\uC77C","toggleWindowSideBar":"\uC0AC\uC774\uB4DC\uBC14 \uC804\uD658","totalCollections":"{{count}}\uAC1C\uC758 \uCEEC\uB809\uC158","totalCollections_plural":"{{count}}\uAC1C\uC758 \uCEEC\uB809\uC158","totalManifests":"{{count}}\uAC1C\uC758 \uB9E4\uB2C8\uD398\uC2A4\uD2B8","totalManifests_plural":"{{count}}\uAC1C\uC758 \uB9E4\uB2C8\uD398\uC2A4\uD2B8","tryAgain":"\uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694","untitled":"[\uD0C0\uC774\uD2C0 \uC5C6\uC74C]","view":"\uBDF0","viewWorkspaceConfiguration":"\uC791\uC5C5\uACF5\uAC04 \uD658\uACBD\uC124\uC815 \u3142\uAD34","welcome":"Mirador\uC5D0 \uC624\uC2E0 \uAC83\uC744 \uD658\uC601\uD569\uB2C8\uB2E4","window":"\uC708\uB3C4\uC6B0: {{label}}","windowMenu":"\uC708\uB3C4\uC6B0 \uBDF0 & \uC378\uB124\uC77C \uD45C\uC2DC","windowNavigation":"\uC708\uB3C4\uC6B0 \uD0D0\uC0C9","windowPluginButtons":"\uC635\uC158","windowPluginMenu":"\uC708\uB3C4\uC6B0 \uC635\uC158","workspace":"\uC791\uC5C5\uACF5\uAC04","workspaceNavigation":"\uC791\uC5C5\uACF5\uAC04 \uD0D0\uC0C9","workspaceFullScreen":"\uC804\uCCB4\uD654\uBA74","workspaceMenu":"\uC791\uC5C5\uACF5\uAC04 \uC124\uC815","workspaceOptions":"\uC791\uC5C5\uACF5\uAC04 \uC635\uC158","workspaceSelectionTitle":"\uC791\uC5C5\uACF5\uAC04 \uC720\uD615\uC744 \uC120\uD0DD\uD558\uC138\uC694","zoomIn":"\uD655\uB300","zoomOut":"\uCD95\uC18C","zoomReset":"\uC90C \uC7AC\uC124\uC815"}}');


var $93d32d10d4ebae9d$exports = {};
$93d32d10d4ebae9d$exports = JSON.parse('{"translation":{"aboutThisItem":"Over dit item","addedFromUrl":"(Toegevoegd via URL)","addManifestUrl":"Locatie bron","addManifestUrlHelp":"De URL van een IIIF-resource","addResource":"Voeg bron toe","annotationCanvasLabel_1/1":"Item: [{{label}}]","annotationCanvasLabel_1/2":"Links: [{{label}}]","annotationCanvasLabel_2/2":"Rechts: [{{label}}]","annotations":"Annotaties","attribution":"Naamsvermelding","attributionTitle":"Rechten","authenticationFailed":"Authenticatie gefaald.","authenticationRequired":"Authenticatie is vereist voor volledige toegang","backToResults":"Terug naar resultaten","book":"Boek","bottom":"Onderaan","cancel":"Annuleer","canvasIndex":"Index","changeTheme":"Wijzig thema","clearSearch":"clear","closeAddResourceForm":"Sluit formulier","closeAddResourceMenu":"Sluit lijst met bronnen","closeCompanionWindow":"Sluit paneel","closeWindow":"Sluit venster","collapseSection":"Klap \\"{{section}}\\" sectie in","collapseSidePanel":"Klap zijbalk in","itemList":"Compacte lijst","continue":"Ga verder","copy":"Kopieer","currentItem":"Huidig item","currentItem_1/1":"Huidig item","currentItem_1/2":"Links","currentItem_2/2":"Rechts","dark":"Donker thema","dismiss":"Dismiss","highlightAllAnnotations":"Markeer alles","downloadExport":"Exporteer workspace","downloadExportWorkspace":"Exporteer workspace","elastic":"Elastisch","elasticDescription":"Verplaats en rangschik vensters vrij in een onbeperkte workspace. Vensters kunnen elkaar overlappen.","emptyResourceList":"Je lijst met bronnen is leeg","errorDialogConfirm":"OK","errorDialogTitle":"Er is een fout opgetreden","exitFullScreen":"Verlaat volledig scherm","expandSection":"Klap \\"{{section}}\\" sectie uit","expandSidePanel":"Klap zijbalk uit","fetchManifest":"Voeg toe","fullScreen":"Volledig scherm","gallery":"Gallerij","hideZoomControls":"Verberg zoomknoppen","iiif_homepage":"Over deze bron","iiif_manifest":"IIIF-manifest","iiif_renderings":"Alternatieve formaten","iiif_seeAlso":"Zie ook","import":"Importeer","importWorkspace":"Importeer workspace","importWorkspaceHint":"Plak een Mirador 3 configuratie die ge\xefmporteerd moet worden","item":"Item: {{label}}","language":"Taal","light":"Licht thema","links":"Links","listAllOpenWindows":"Ga naar venster","login":"Log in","manifestError":"De bron kan niet worden toegevoegd:","maximizeWindow":"Maximaliseer venster","minimizeWindow":"Minimaliseer venster","mirador":"Mirador","miradorResources":"Mirador resources","miradorViewer":"Mirador viewer","more":"meer...","moreResults":"Meer resultaten","mosaic":"Moza\xefek","mosaicDescription":"Verplaats en rangschik vensters in verhouding tot elkaar binnen het zichtbare kader.","moveCompanionWindowToBottom":"Verplaats naar beneden","moveCompanionWindowToRight":"Verplaats naar rechts","nextCanvas":"Volgend item","numItems":"{{number}} item","numItems_plural":"{{number}} items","off":"Uit","openCompanionWindow_annotations":"Annotaties","openCompanionWindow_attribution":"Rechten","openCompanionWindow_canvas":"Index","openCompanionWindow_info":"Informatie","openCompanionWindow_search":"Zoeken","openInCompanionWindow":"Open in een apart paneel","openWindows":"Geopende vensters","pagination":"{{current}} van {{total}}","position":"Positie","previewWindowTitle":"{{title}}","previousCanvas":"Vorig item","related":"Verwant","resource":"Bron","retry":"Probeer opnieuw","right":"Rechts","rights":"Licentie","searchInputLabel":"zoek termen","searchNextResult":"Volgend resultaat","searchNoResults":"Geen resultaten gevonden","searchPreviousResult":"Vorig resultaat","searchSubmitAria":"Zoeken","searchTitle":"Zoek","selectWorkspaceMenu":"Selecteer workspacetype","showingNumAnnotations":"{{number}} annotatie weergegeven","showingNumAnnotations_plural":"{{number}} annotaties weergegeven","showZoomControls":"Toon zoomknoppen","sidebarPanelsNavigation":"Zijbalk panelen navigatie","single":"Enkel","startHere":"Begin Hier","suggestSearch":"Zoek in dit document naar \\"{{ query }}\\"","theme":"Thema","thumbnailList":"Lijst thumbnails","thumbnailNavigation":"Thumbnails","thumbnails":"Thumbnails","toggleWindowSideBar":"Toon zijbalk","totalCollections":"{{count}} collectie","totalCollections_plural":"{{count}} collecties","totalManifests":"{{count}} manifest","totalManifests_plural":"{{count}} manifests","tryAgain":"Probeer opnieuw","untitled":"[Zonder titel]","view":"Weergave","welcome":"Welkom in Mirador","window":"Venster: {{label}}","windowMenu":"Vensters- en miniatuurweergave","windowNavigation":"Navigatie venster","windowPluginButtons":"Opties","windowPluginMenu":"Vensteropties","workspace":"Workspace","workspaceFullScreen":"Volledig scherm","workspaceMenu":"Workspace instellingen","workspaceOptions":"Workspace opties","workspaceSelectionTitle":"Selecteer een workspace type","zoomIn":"Zoom in","zoomOut":"Zoom out","zoomReset":"Reset zoom"}}');


var $863d8257acf4aadf$exports = {};
$863d8257acf4aadf$exports = JSON.parse('{"translation":{"aboutMirador":"O Projekcie Mirador","aboutThisItem":"O bie\u017C\u0105cej pozycji","addedFromUrl":"(Dodano z URL)","addManifestUrl":"Lokalizacja zasob\xf3w","addManifestUrlHelp":"URL zasob\xf3w IIIF","addResource":"Dodaj zasoby","annotationCanvasLabel_1/1":"Pozycja: [{{label}}]","annotationCanvasLabel_1/2":"Lewo: [{{label}}]","annotationCanvasLabel_2/2":"Prawo: [{{label}}]","annotations":"Adnotacje","attribution":"Atrybucja","attributionTitle":"Prawa","authenticationFailed":"Uwierzytelnianie nie powiod\u0142o si\u0119.","authenticationRequired":"Do pe\u0142nego dost\u0119pu wymagane jest uwierzytelnienie","backToResults":"Powr\xf3t do wynik\xf3w","book":"Ksi\u0105\u017Cka","bottom":"D\xf3\u0142","cancel":"Anuluj","canvasIndex":"Indeks","changeTheme":"Zmie\u0144 motyw","clearSearch":"wyczy\u015B\u0107","close":"Zamknij","closeAddResourceForm":"Zamknij formularz","closeAddResourceMenu":"Zamknij list\u0119 zasob\xf3w","closeCompanionWindow":"Zamknij panel","closeWindow":"Zamknij okno","collapseSection":"Zwi\u0144 sekcj\u0119 \\"{{section}}\\"","collapseSidePanel":"Zwi\u0144 panel boczny","collection":"Zbi\xf3r","itemList":"Lista pozycji","continue":"Kontynuuj","copy":"Kopiuj","currentItem":"Bie\u017C\u0105ca pozycja","currentItem_1/1":"Bie\u017C\u0105ca pozycja","currentItem_1/2":"Lewo","currentItem_2/2":"Prawo","dark":"Ciemny motyw","digitizedView":"Widok zdigitalizowany","dismiss":"Odrzu\u0107","highlightAllAnnotations":"Pod\u015Bwietl wszystko","displayNoAnnotations":"Nie pod\u015Bwietlaj","downloadExport":"Eksportuj obszar roboczy","downloadExportWorkspace":"Eksportuj obszar roboczy","elastic":"Elastyczny","elasticDescription":"Swobodnie przesuwaj i dopasowuj okna w nieograniczonej przestrzeni roboczej. Okna mog\u0105 zachodzi\u0107 na siebie.","emptyResourceList":"Twoja lista zasob\xf3w jest pusta","error":"B\u0142\u0105d","errorDialogConfirm":"OK","errorDialogTitle":"Wyst\u0105pi\u0142 b\u0142\u0105d","exitFullScreen":"Wy\u0142\u0105cz tryb pe\u0142noekranowy","expandSection":"Rozwi\u0144 sekcj\u0119 \\"{{section}}\\"","expandSidePanel":"Rozwi\u0144 panel boczny","exportCopied":"Konfiguracja obszaru roboczego zosta\u0142a skopiowana do schowka","fetchManifest":"Dodaj","fullScreen":"Pe\u0142ny ekran","gallery":"Galeria","hideZoomControls":"Ukryj kontrolki powi\u0119kszenia","iiif_homepage":"O tym zasobie","iiif_manifest":"Manifest IIIF","iiif_renderings":"Alternatywne formaty","iiif_seeAlso":"Zobacz te\u017C","import":"Importuj","importWorkspace":"Importuj obszar roboczy","importWorkspaceHint":"Wklej konfiguracj\u0119 Mirador 3 do zaimportowania","item":"Pozycja: {{label}}","jsError":"Szczeg\xf3\u0142y techniczne","jsStack":"{{ stack }}","language":"J\u0119zyk","layer_hide":"Ukryj warstw\u0119","layer_move":"Przenie\u015B warstw\u0119","layer_opacity":"Krycie warstwy","layer_show":"Poka\u017C warstw\u0119","layer_moveToTop":"Przenie\u015B warstw\u0119 na g\xf3r\u0119","layers":"Warstwy","light":"Jasny motyw","links":"Linki","listAllOpenWindows":"Przejd\u017A do okna","login":"Zaloguj","logout":"Wyloguj","manifestError":"Nast\u0119puj\u0105ce zasoby nie mog\u0105 by\u0107 dodane:","maximizeWindow":"Maksymalizuj okno","minimizeWindow":"Minimalizuj okno","mirador":"Mirador","miradorResources":"Zasoby Mirador","miradorViewer":"Przegl\u0105darka Mirador","more":"wi\u0119cej...","moreResults":"Wi\u0119cej wynik\xf3w","mosaic":"Mozaika","mosaicDescription":"Przesuwaj i zmieniaj rozmiary okien wzgl\u0119dem siebie, w widocznej ramce.","moveCompanionWindowToBottom":"Przesu\u0144 na d\xf3\u0142","moveCompanionWindowToRight":"Przesu\u0144 w prawo","nextCanvas":"Nast\u0119pna pozycja","noItemSelected":"Nie wybrano pozycji","numItems":"{{number}} pozycja","numItems_plural":"{{number}} pozycje","off":"Wy\u0142\u0105cz","openCompanionWindow_annotations":"Adnotacje","openCompanionWindow_attribution":"Prawa","openCompanionWindow_canvas":"Indeks","openCompanionWindow_info":"Informacje","openCompanionWindow_layers":"Warstwy","openCompanionWindow_search":"Szukaj","openInCompanionWindow":"Otw\xf3rz w oddzielnym panelu","openWindows":"Aktualnie otwarte okna","pagination":"{{current}} of {{total}}","position":"Pozycja","previewWindowTitle":"{{title}}","previousCanvas":"Poprzednia pozycja","related":"Powi\u0105zane","resource":"Zasoby","retry":"Spr\xf3buj ponownie","right":"Prawo","rights":"Licencja","scroll":"Przewi\u0144","searchInputLabel":"szukane s\u0142owa","searchNextResult":"Nast\u0119pny wynik","searchNoResults":"Nie znaleziono wynik\xf3w","searchPreviousResult":"Poprzedni wynik","searchResultsRemaining":"Pozosta\u0142o {{numLeft}}","searchSubmitAria":"Wyszukaj","searchTitle":"Wyszukaj","selectWorkspaceMenu":"Wybierz typ obszaru roboczego","showingNumAnnotations":"Wy\u015Bwietlanie {{number}} adnotacji","showingNumAnnotations_plural":"Wy\u015Bwietlanie {{number}} adnotacji","showCollection":"Poka\u017C zbi\xf3r","showZoomControls":"Poka\u017C kontrolki powi\u0119kszenia","sidebarPanelsNavigation":"Nawigacja pask\xf3w panelu bocznego","single":"Pojedynczy","startHere":"Zacznij tutaj","suggestSearch":"Przeszukaj ten dokument pod k\u0105tem \\"{{ query }}\\"","tableOfContentsList":"Spis tre\u015Bci","theme":"Motyw","thumbnailList":"Lista miniatur","thumbnailNavigation":"Miniatury","thumbnails":"Miniatury","toggleWindowSideBar":"Prze\u0142\u0105cz panel boczny","totalCollections":"{{count}} zbi\xf3r","totalCollections_plural":"{{count}} zbior\xf3w","totalManifests":"{{count}} manifest","totalManifests_plural":"{{count}} manifest\xf3w","tryAgain":"Spr\xf3buj ponownie","untitled":"[Bez nazwy]","view":"Widok","viewWorkspaceConfiguration":"Wy\u015Bwietl konfiguracj\u0119 obszaru roboczego","welcome":"Witaj w Miradorze","window":"Okno: {{label}}","windowMenu":"Widoki okien i wy\u015Bwietlanie miniatur","windowNavigation":"Nawigacja okna","windowPluginButtons":"Opcje","windowPluginMenu":"Opcje okna","workspace":"Obszar roboczy","workspaceNavigation":"Nawigacja obszaru roboczego","workspaceFullScreen":"Pe\u0142ny ekran","workspaceMenu":"Ustawienia obszaru roboczego","workspaceOptions":"Opcje obszaru roboczego","workspaceSelectionTitle":"Wybierz typ obszaru roboczego","zoomIn":"Przybli\u017C","zoomOut":"Oddal","zoomReset":"Zresetuj powi\u0119kszenie"}}');


var $4ecdf6402c4e99c0$exports = {};
$4ecdf6402c4e99c0$exports = JSON.parse('{"translation":{"aboutThisItem":"Sobre esse item","addedFromUrl":"(Adicionado por URL)","addManifestUrl":"Localiza\xe7\xe3o do manifesto","addManifestUrlHelp":"URL do manifesto IIIF","addResource":"Adicionar conte\xfado","annotationCanvasLabel_1/1":"Item: [{{label}}]","annotationCanvasLabel_1/2":"Esquerda: [{{label}}]","annotationCanvasLabel_2/2":"Direita: [{{label}}]","annotations":"Anota\xe7\xf5es","attribution":"Atribui\xe7\xf5es","attributionTitle":"Direitos","authenticationFailed":"Falha na autentica\xe7\xe3o.","authenticationRequired":"Autentica\xe7\xe3o necess\xe1ria para acesso completo","backToResults":"Voltar aos resultados","book":"Livro","bottom":"Embaixo","cancel":"Cancelar","canvasIndex":"\xcdndice","changeTheme":"Mudar tema","clearSearch":"limpar","closeAddResourceForm":"Fechar formul\xe1rio","closeAddResourceMenu":"Fechar lista de conte\xfado","closeCompanionWindow":"Fechar painel","closeWindow":"Fechar janela","collapseSection":"Suprimir se\xe7\xe3o \\"{{section}}\\"","collapseSidePanel":"Suprimir barra lateral","itemList":"Lista compacta","continue":"Continuar","copy":"Copiar","currentItem":"Item atual","currentItem_1/1":"Item atual","currentItem_1/2":"Esquerda","currentItem_2/2":"Direita","dark":"Tema escuro","dismiss":"Cancelar","highlightAllAnnotations":"Exibir todas","downloadExport":"Exportar \xe1rea de trabalho","downloadExportWorkspace":"Exportar \xe1rea de trabalho","elastic":"El\xe1stico","elasticDescription":"Mova e redimensione janelas livremente numa \xe1rea de trabalho ilimitada. Janelas podem se sobrepor.","emptyResourceList":"Sua lista de conte\xfados est\xe1 vazia","errorDialogConfirm":"OK","errorDialogTitle":"Um erro ocorreu","exitFullScreen":"Sair do modo tela cheia","expandSection":"Expandir se\xe7\xe3o \\"{{section}}\\"","expandSidePanel":"Expandir barra lateral","fetchManifest":"Adicionar","fullScreen":"Tela cheia","gallery":"Galeria","hideZoomControls":"Ocultar controles de zoom","iiif_homepage":"Sobre esse conte\xfado","iiif_manifest":"Manifesto IIIF","iiif_renderings":"Outros formatos","iiif_seeAlso":"Veja tamb\xe9m","import":"Importar","importWorkspace":"Importar \xe1rea de trabalho","importWorkspaceHint":"Cole uma configura\xe7\xe3o do Mirador 3 para importar","item":"Item: {{label}}","language":"Idioma","light":"Tema claro","links":"Links","listAllOpenWindows":"Pular para janela","login":"Login","manifestError":"O conte\xfado n\xe3o pode ser adicionado:","maximizeWindow":"Maximizar janela","minimizeWindow":"Minimizar janela","mirador":"Mirador","miradorResources":"conte\xfado Mirador","miradorViewer":"visualizador Mirador","more":"mais...","moreResults":"Mais resultados","mosaic":"Mos\xe1ico","mosaicDescription":"Mova e redimensione janelas em rela\xe7\xe3o entre si, dentro de uma \xe1rea vis\xedvel (grid).","moveCompanionWindowToBottom":"Mover para baixo","moveCompanionWindowToRight":"Mover para direita","nextCanvas":"Pr\xf3ximo item","numItems":"{{number}} itens","off":"Desativado","openCompanionWindow_annotations":"Anota\xe7\xf5es","openCompanionWindow_attribution":"Direitos","openCompanionWindow_canvas":"\xcdndice","openCompanionWindow_info":"Informa\xe7\xf5es","openCompanionWindow_search":"Busca","openInCompanionWindow":"Abrir em janela separada","openWindows":"Janelas abertas","pagination":"{{current}} de {{total}}","position":"Posi\xe7\xe3o","previewWindowTitle":"{{title}}","previousCanvas":"Item anterior","related":"Relacionado","resource":"Conte\xfado","retry":"Tentar novamente","right":"Direita","rights":"Licen\xe7as","searchInputLabel":"termos de busca","searchNextResult":"Pr\xf3ximo resultado","searchNoResults":"Nenhum resultado encontrado","searchPreviousResult":"Resultado anterior","searchSubmitAria":"Realizar busca","searchTitle":"Busca","selectWorkspaceMenu":"Selecione um tipo de \xe1rea de trabalho","showingNumAnnotations":"Mostrando {{number}} anota\xe7\xf5es","showZoomControls":"Mostrar controles de zoom","sidebarPanelsNavigation":"Navega\xe7\xe3o por paineis na barra lateral","single":"Individual","startHere":"Comece aqui","suggestSearch":"Procurar neste documento por \\"{{ query }}\\"","theme":"Tema","thumbnailList":"Lista de thumbnails","thumbnailNavigation":"Thumbnails","thumbnails":"Thumbnails","toggleWindowSideBar":"Ver barra lateral","tryAgain":"Tente novamente","untitled":"[Sem t\xedtulo]","view":"Visualiza\xe7\xf5es","welcome":"Bem-vindo ao Mirador","window":"Janela: {{label}}","windowMenu":"Op\xe7\xf5es de visualiza\xe7\xe3o de janelas e thumbnails","windowNavigation":"Navega\xe7\xe3o de janelas","windowPluginButtons":"Op\xe7\xf5es","windowPluginMenu":"Op\xe7\xf5es de janela","workspace":"\xc1rea de trabalho","workspaceFullScreen":"Tela cheia","workspaceMenu":"Configura\xe7\xf5es de \xe1rea de trabalho","workspaceOptions":"Op\xe7\xf5es de \xe1rea de trabalho","workspaceSelectionTitle":"Selecionar tipo de \xe1rea de trabalho","zoomIn":"Mais zoom","zoomOut":"Menos zoom","zoomReset":"Zerar zoom"}}');


var $1f5af9c1db8256d6$exports = {};
$1f5af9c1db8256d6$exports = JSON.parse('{"translation":{"aboutMirador":"Informazioni su Mirador","aboutThisItem":"Informazioni sull\'oggetto","addManifestUrl":"URL della risorsa","addManifestUrlHelp":"L\'URL di una risorsa IIIF","addResource":"Aggiungi una risorsa","addedFromUrl":"(Aggiunto dall\'URL)","annotationCanvasLabel_1/1":"Oggetto: [{{label}}]","annotationCanvasLabel_1/2":"Sinistra: [{{label}}]","annotationCanvasLabel_2/2":"Destra: [{{label}}]","annotations":"Annotazioni","attribution":"Attribuzione","attributionTitle":"Diritti","authenticationFailed":"Autenticazione fallita.","authenticationRequired":"Autenticazione richiesta per l\'accesso completo","backToResults":"Torna ai risultati","book":"Libro","bottom":"Fondo","cancel":"Cancella","canvasIndex":"Indice","changeTheme":"Cambia tema","clearSearch":"pulisci","close":"Chiudi","closeAddResourceForm":"Chiudi il modulo","closeAddResourceMenu":"Chiudi la lista di risorse","closeCompanionWindow":"Chiudi il pannello","closeWindow":"Chiudi finestra","collapseSection":"Collassa la sezione \\"{{section}}\\"","collapseSidePanel":"Collassa la barra laterale","collection":"Collezione","continue":"Continua","copy":"Copia","currentItem":"Oggetto corrente","currentItem_1/1":"Oggetto corrente","currentItem_1/2":"Sinistra","currentItem_2/2":"Destra","dark":"Tema scuro","digitizedView":"Digitized view","dismiss":"Dismiss","displayNoAnnotations":"Nascondi evidenziazione","downloadExport":"Esporta il workspace","downloadExportWorkspace":"Esporta il workspace","elastic":"Elastico","elasticDescription":"Muovi e ridimensiona le finestre liberamente in un workspace illimitato. Le finestre possono sovrapporsi.","emptyResourceList":"La tua lista di risorse \xe8 vuota.","error":"Errore","errorDialogConfirm":"OK","errorDialogTitle":"Si \xe8 verificato un errore.","exitFullScreen":"Esci da schermo intero","expandSection":"Espandi la sezione \\"{{section}}\\"","expandSidePanel":"Espandi la barra laterale","exportCopied":"La configurazione del workspace \xe8 stata copiata nella tua clipboard","fetchManifest":"Aggiungi","fullScreen":"Schermo intero","gallery":"Galleria","hideZoomControls":"Nascondi i controlli di zoom","highlightAllAnnotations":"Evidenzia tutto","iiif_homepage":"Informazioni su questa risorsa","iiif_manifest":"IIIF manifest","iiif_renderings":"Formati alternativi","iiif_seeAlso":"Vedi anche","import":"Importa","importWorkspace":"Importa workspace","importWorkspaceHint":"Incolla una configurazione di Mirador 3 da importare","item":"Oggetto: {{label}}","itemList":"Lista compatta","jsError":"Dettagli tecnici","jsStack":"{{ stack }}","language":"Lingua","layer_hide":"Nascondi livello","layer_move":"Sposta livello","layer_moveToTop":"Sposta il livello in alto","layer_opacity":"Opacit\xe0 del livello","layer_show":"Visualizza livello","layers":"Livelli","light":"Tema chiaro","links":"Link","listAllOpenWindows":"Vai alla finestra","login":"Entra","logout":"Esci","manifestError":"La risorsa non pu\xf2 essere aggiunta:","maximizeWindow":"Massimizza la finestra","minimizeWindow":"Minimizza la finestra","mirador":"Mirador","miradorResources":"Risorse Mirador","miradorViewer":"Visualizzatore Mirador","more":"ancora...","moreResults":"Pi\xf9 risultati","mosaic":"Mosaico","mosaicDescription":"Muovi e ridimensiona le finestre, tenendole all\'interno dell\'area visibile","moveCompanionWindowToBottom":"Sposta in fondo","moveCompanionWindowToRight":"Sposta a destra","nextCanvas":"Prossimo oggetto","noItemSelected":"Nessun oggetto selezionato","numItems":"{{number}} oggetti","numItems_plural":"{{number}} oggetti","off":"Off","openCompanionWindow_annotations":"Annotazioni","openCompanionWindow_attribution":"Diritti","openCompanionWindow_canvas":"Indice","openCompanionWindow_info":"Informazioni","openCompanionWindow_layers":"Livelli","openCompanionWindow_search":"Cerca","openInCompanionWindow":"Apri in un pannello separato","openWindows":"Finestre aperte in questo momento","pagination":"{{current}} di {{total}}","position":"Posizione","previewWindowTitle":"{{title}}","previousCanvas":"Previous item","related":"Contenuti collegati","resource":"Risorsa","retry":"Riprova","right":"Right","rights":"Licenza","scroll":"Scorri","searchInputLabel":"termini di ricerca","searchNextResult":"Prossimo risultato","searchNoResults":"Nessun risultato","searchPreviousResult":"Risultato precedente","searchResultsRemaining":"{{numLeft}} rimanenti","searchSubmitAria":"Cerca","searchTitle":"Cerca","selectWorkspaceMenu":"Selezione il tipo di workspace","showCollection":"Visualizza la collezione","showZoomControls":"Mostra i controlli di zoom","showingNumAnnotations":"Sto mostrando {{number}} annotazioni","showingNumAnnotations_plural":"Visualizzando {{number}} annotazioni","sidebarPanelsNavigation":"Navigazione dei pannelli della barra laterale","single":"Singolo","startHere":"Inizia qui","suggestSearch":"Cerca in questo documento: \\"{{ query }}\\"","tableOfContentsList":"Sommario","theme":"Tema","thumbnailList":"Lista thumbnail","thumbnailNavigation":"Thumbnails","thumbnails":"Thumbnails","toggleWindowSideBar":"Apri/Chiudi la barra","totalCollections":"{{count}} collezione","totalCollections_plural":"{{count}} collezioni","totalManifests":"{{count}} manifest","totalManifests_plural":"{{count}} manifests","tryAgain":"Riprova","untitled":"[senza titolo]","view":"Visualizza","viewWorkspaceConfiguration":"Visualizza la configurazione del workspace","welcome":"Benvenuto in Mirador","window":"Finestra: {{label}}","windowMenu":"Visualizzazioni finestra e display thumbnail","windowNavigation":"Navigazione finestra","windowPluginButtons":"Opzioni","windowPluginMenu":"Opzioni finestra","workspace":"Workspace","workspaceFullScreen":"Schermo intero","workspaceMenu":"Configurazioni Workspace","workspaceNavigation":"Navigazione del workspace","workspaceOptions":"Opzioni Workspace","workspaceSelectionTitle":"Seleziona il tipo di workspace","zoomIn":"Zoom in","zoomOut":"Zoom out","zoomReset":"Reset zoom"}}');


var $2ebf63d896d02c56$exports = {};
$2ebf63d896d02c56$exports = JSON.parse('{"translation":{"aboutMirador":"\u041E \u043F\u0440\u043E\u0458\u0435\u043A\u0442\u0443 Mirador","aboutThisItem":"\u041E\u043F\u0438\u0441","addedFromUrl":"(\u0414\u043E\u0434\u0430\u0442\u043E \u0441\u0430 URL)","addManifestUrl":"\u041B\u043E\u043A\u0430\u0446\u0438\u0458\u0430 \u0440\u0435\u0441\u0443\u0440\u0441\u0430","addManifestUrlHelp":"URL IIIF \u0440\u0435\u0441\u0443\u0440\u0441\u0430","addResource":"\u0414\u043E\u0434\u0430\u0458\u0442\u0435 \u0440\u0435\u0441\u0443\u0440\u0441","annotationCanvasLabel_1/1":"\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430: [{{label}}]","annotationCanvasLabel_1/2":"\u041B\u0435\u0432\u0430: [{{label}}]","annotationCanvasLabel_2/2":"\u0414\u0435\u0441\u043D\u0430: [{{label}}]","annotations":"\u0410\u043D\u043E\u0442\u0430\u0446\u0438\u0458\u0435","attribution":"\u041F\u0440\u0438\u0441\u0442\u0443\u043F","attributionTitle":"\u041F\u0440\u0430\u0432\u0430","authenticationFailed":"\u041D\u0435\u0443\u0441\u043F\u0435\u043B\u0430 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0458\u0430.","authenticationRequired":"\u0417\u0430 \u043F\u043E\u0442\u043F\u0443\u043D\u0438 \u043F\u0440\u0438\u0441\u0442\u0443\u043F \u043D\u0435\u043E\u043F\u0445\u043E\u0434\u043D\u0430 \u0458\u0435 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0458\u0430","backToResults":"\u041F\u043E\u0432\u0440\u0430\u0442\u0430\u043A \u043D\u0430 \u0440\u0435\u0437\u0443\u043B\u0442\u0430\u0442\u0435","book":"\u041A\u045A\u0438\u0433\u0430","bottom":"\u041D\u0430 \u0434\u043D\u0443","cancel":"\u041E\u0434\u0443\u0441\u0442\u0430\u043D\u0438\u0442\u0435","canvasIndex":"\u0418\u043D\u0434\u0435\u043A\u0441","changeTheme":"\u041F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435 \u0442\u0435\u043C\u0443","clearSearch":"\u043E\u0431\u0440\u0438\u0448\u0438\u0442\u0435","close":"\u0417\u0430\u0442\u0432\u043E\u0440\u0438\u0442\u0435","closeAddResourceForm":"\u0417\u0430\u0442\u0432\u043E\u0440\u0438\u0442\u0435","closeAddResourceMenu":"\u0417\u0430\u0442\u0432\u043E\u0440\u0438\u0442\u0435 \u043B\u0438\u0441\u0442\u0443 \u0440\u0435\u0441\u0443\u0440\u0441\u0430","closeCompanionWindow":"\u0417\u0430\u0442\u0432\u043E\u0440\u0438\u0442\u0435 \u043F\u0430\u043D\u0435\u043B","closeWindow":"\u0417\u0430\u0442\u0432\u043E\u0440\u0438\u0442\u0435 \u043F\u0440\u0438\u043A\u0430\u0437","collapseSection":"\u0421\u0430\u043A\u0440\u0438\u0458\u0442\u0435 \\"{{section}}\\" \u0441\u0435\u043A\u0446\u0438\u0458\u0443","collapseSidePanel":"\u0421\u0430\u043A\u0440\u0438\u0458\u0442\u0435","collection":"\u041A\u043E\u043B\u0435\u043A\u0446\u0438\u0458\u0430","itemList":"\u041B\u0438\u0441\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430","continue":"\u041D\u0430\u0441\u0442\u0430\u0432\u0438\u0442\u0435","copy":"\u041A\u043E\u043F\u0438\u0440\u0430\u0458\u0442\u0435","currentItem":"\u0422\u0440\u0435\u043D\u0443\u0442\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430","currentItem_1/1":"\u0422\u0440\u0435\u043D\u0443\u0442\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430","currentItem_1/2":"\u041B\u0435\u0432\u0430","currentItem_2/2":"\u0414\u0435\u0441\u043D\u0430","dark":"\u0422\u0430\u043C\u043D\u0430 \u0442\u0435\u043C\u0430","digitizedView":"\u041F\u0440\u0438\u043A\u0430\u0437 \u0434\u0438\u0433\u0438\u0442\u0430\u043B\u043D\u043E\u0433 \u043E\u0431\u0458\u0435\u043A\u0442\u0430","dismiss":"\u041E\u0442\u043A\u0430\u0436\u0438\u0442\u0435","highlightAllAnnotations":"\u041F\u0440\u0438\u043A\u0430\u0437 \u0441\u0432\u0438\u0445","displayNoAnnotations":"\u0411\u0435\u0437 \u043F\u0440\u0438\u043A\u0430\u0437\u0430","downloadExport":"\u0418\u0437\u0432\u0435\u0437\u0438\u0442\u0435 \u0440\u0430\u0434\u043D\u043E \u043E\u043A\u0440\u0443\u0436\u0435\u045A\u0435","downloadExportWorkspace":"\u0418\u0437\u0432\u0435\u0437\u0438\u0442\u0435 \u0440\u0430\u0434\u043D\u043E \u043E\u043A\u0440\u0443\u0436\u0435\u045A\u0435","elastic":"\u0415\u043B\u0430\u0441\u0442\u0438\u0447\u043D\u0438","elasticDescription":"\u0421\u043B\u043E\u0431\u043E\u0434\u043D\u043E \u043F\u043E\u043C\u0435\u0440\u0430\u0458\u0442\u0435 \u0438 \u043E\u0434\u0440\u0435\u0434\u0438\u0442\u0435 \u0432\u0435\u043B\u0438\u0447\u0438\u043D\u0443 \u043F\u0440\u0438\u043A\u0430\u0437\u0430 \u0443 \u043D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043E\u043C \u0440\u0430\u0434\u043D\u043E\u043C \u043F\u0440\u043E\u0441\u0442\u043E\u0440\u0443. \u041F\u0440\u0438\u043A\u0430\u0437\u0438 \u043C\u043E\u0433\u0443 \u0431\u0438\u0442\u0438 \u0432\u0435\u045B\u0438 \u043E\u0434 \u0440\u0430\u0434\u043D\u043E\u0433 \u043F\u0440\u043E\u0441\u0442\u043E\u0440\u0430.","emptyResourceList":"\u0412\u0430\u0448\u0430 \u043B\u0438\u0441\u0442\u0430 \u0440\u0435\u0441\u0443\u0440\u0441\u0430 \u0458\u0435 \u043F\u0440\u0430\u0437\u043D\u0430","error":"\u0413\u0440\u0435\u0448\u043A\u0430","errorDialogConfirm":"OK","errorDialogTitle":"\u0414\u043E\u0448\u043B\u043E \u0458\u0435 \u0434\u043E \u0433\u0440\u0435\u0448\u043A\u0435","exitFullScreen":"\u0418\u0437\u0430\u0452\u0438\u0442\u0435 \u0438\u0437 \u043F\u0440\u0438\u043A\u0430\u0437\u0430 \u043F\u0440\u0435\u043A\u043E \u0446\u0435\u043B\u043E\u0433 \u0435\u043A\u0440\u0430\u043D\u0430","expandSection":"\u041F\u0440\u043E\u0448\u0438\u0440\u0438\u0442\u0435 \\"{{section}}\\" \u0441\u0435\u043A\u0446\u0438\u0458\u0443","expandSidePanel":"\u041F\u0440\u0438\u043A\u0430\u0436\u0438\u0442\u0435","exportCopied":"\u041A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0458\u0430 \u0440\u0430\u0434\u043D\u043E\u0433 \u043E\u043A\u0440\u0443\u0436\u0435\u045A\u0430 \u0458\u0435 \u043A\u043E\u043F\u0438\u0440\u0430\u043D\u0430 \u0443 \u043F\u0440\u0438\u0432\u0440\u0435\u043C\u0435\u043D\u0443 \u043C\u0435\u043C\u043E\u0440\u0438\u0458\u0443","fetchManifest":"\u0414\u043E\u0434\u0430\u0458\u0442\u0435","fullScreen":"\u041F\u0440\u0438\u043A\u0430\u0437 \u0443 \u043F\u0443\u043D\u043E\u043C \u0435\u043A\u0440\u0430\u043D\u0443","gallery":"\u0413\u0430\u043B\u0435\u0440\u0438\u0458\u0430","hideZoomControls":"\u0421\u0430\u043A\u0440\u0438\u0458\u0442\u0435 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0435 \u0437\u0443\u043C\u0430","iiif_homepage":"\u041E \u0440\u0435\u0441\u0443\u0440\u0441\u0443","iiif_manifest":"IIIF manifest","iiif_renderings":"\u0414\u043E\u0434\u0430\u0442\u043D\u0438 \u0444\u043E\u0440\u043C\u0430\u0442\u0438","iiif_seeAlso":"\u041F\u043E\u0433\u043B\u0435\u0434\u0430\u0458\u0442\u0435 \u0438","import":"\u0423\u0432\u0435\u0437\u0438\u0442\u0435","importWorkspace":"\u0423\u0432\u0435\u0437\u0438\u0442\u0435 \u0440\u0430\u0434\u043D\u043E \u043E\u043A\u0440\u0443\u0436\u0435\u045A\u0435","importWorkspaceHint":"\u0423\u0431\u0430\u0446\u0438\u0442\u0435 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0458\u0443 Mirador 3 \u043A\u0430\u043A\u043E \u0431\u0438 \u043C\u043E\u0433\u043B\u0438 \u0434\u0430 \u0458\u0435 \u0443\u0432\u0435\u0437\u0435\u0442\u0435","item":"\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430: {{label}}","jsError":"\u0422\u0435\u0445\u043D\u0438\u0447\u043A\u0438 \u0434\u0435\u0442\u0430\u0459\u0438","jsStack":"{{ stack }}","language":"\u0408\u0435\u0437\u0438\u043A \u043F\u0440\u0438\u043A\u0430\u0437\u0430","layer_hide":"\u0421\u0430\u043A\u0440\u0438\u0458\u0442\u0435 \u0441\u043B\u043E\u0458","layer_move":"\u041F\u043E\u043C\u0435\u0440\u0438\u0442\u0435 \u0441\u043B\u043E\u0458","layer_opacity":"\u0412\u0438\u0434\u0459\u0438\u0432\u043E\u0441\u0442 \u0441\u043B\u043E\u0458\u0430","layer_show":"\u041F\u0440\u0438\u043A\u0430\u0437 \u0441\u043B\u043E\u0458\u0430","layer_moveToTop":"\u041F\u043E\u043C\u0435\u0440\u0438\u0442\u0435 \u0441\u043B\u043E\u0458 \u043D\u0430 \u0432\u0440\u0445","layers":"\u0421\u043B\u043E\u0458\u0435\u0432\u0438","light":"\u0421\u0432\u0435\u0442\u043B\u0430 \u0442\u0435\u043C\u0430","links":"\u041B\u0438\u043D\u043A\u043E\u0432\u0438","listAllOpenWindows":"\u0418\u0434\u0438\u0442\u0435 \u043D\u0430 \u043F\u0440\u0438\u043A\u0430\u0437","login":"\u0423\u043B\u043E\u0433\u0443\u0458\u0442\u0435 \u0441\u0435","logout":"\u0418\u0437\u043B\u043E\u0433\u0443\u0458\u0442\u0435 \u0441\u0435","manifestError":"\u0420\u0435\u0441\u0443\u0440\u0441 \u0441\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0434\u043E\u0434\u0430\u0442\u0438","maximizeWindow":"\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u0430\u043D \u043F\u0440\u0438\u043A\u0430\u0437","minimizeWindow":"\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u0430\u043D \u043F\u0440\u0438\u043A\u0430\u0437","mirador":"Mirador","miradorResources":"Mirador \u0440\u0435\u0441\u0443\u0440\u0441\u0438","miradorViewer":"Mirador \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0447","more":"\u0458\u043E\u0448...","moreResults":"\u0408\u043E\u0448 \u0440\u0435\u0437\u0443\u043B\u0442\u0430\u0442\u0430","mosaic":"\u041C\u043E\u0437\u0430\u0438\u043A","mosaicDescription":"\u041F\u043E\u043C\u0435\u0440\u0430\u0458\u0442\u0435 \u0438 \u043E\u0434\u0440\u0435\u0434\u0438\u0442\u0435 \u0432\u0435\u043B\u0438\u0447\u0438\u043D\u0443 \u043F\u0440\u0438\u043A\u0430\u0437\u0430 \u043A\u043E\u0458\u0438 \u0441\u0443 \u0443 \u043C\u0435\u0452\u0443\u0441\u043E\u0431\u043D\u043E\u0458 \u0440\u0435\u043B\u0430\u0446\u0438\u0458\u0438, \u0443\u043D\u0443\u0442\u0430\u0440 \u0432\u0438\u0434\u0459\u0438\u0432\u043E\u0433 \u043E\u043A\u0432\u0438\u0440\u0430.","moveCompanionWindowToBottom":"\u041F\u0440\u0435\u0431\u0430\u0446\u0438\u0442\u0435 \u043D\u0430 \u0434\u043D\u043E","moveCompanionWindowToRight":"\u041F\u043E\u043C\u0435\u0440\u0438\u0442\u0435 \u0443 \u0434\u0435\u0441\u043D\u0443 \u0441\u0442\u0440\u0430\u043D\u0443","nextCanvas":"\u0421\u043B\u0435\u0434\u0435\u045B\u0430","noItemSelected":"\u041D\u0435\u043C\u0430 \u0438\u0437\u0430\u0431\u0440\u0430\u043D\u0438\u0445 \u043E\u0431\u0458\u0435\u043A\u0430\u0442\u0430","numItems":"{{number}} \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430/\u0446\u0435","off":"\u0418\u0441\u043A\u0459\u0443\u0447\u0435\u043D\u0435","openCompanionWindow_annotations":"\u0410\u043D\u043E\u0442\u0430\u0446\u0438\u0458\u0435","openCompanionWindow_attribution":"\u041F\u0440\u0430\u0432\u0430","openCompanionWindow_canvas":"\u0418\u043D\u0434\u0435\u043A\u0441","openCompanionWindow_info":"\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0435","openCompanionWindow_layers":"\u0421\u043B\u043E\u0458\u0435\u0432\u0438","openCompanionWindow_search":"\u041F\u0440\u0435\u0442\u0440\u0430\u0433\u0430","openInCompanionWindow":"\u041E\u0442\u0432\u043E\u0440\u0438\u0442\u0435 \u0443 \u0437\u0430\u0441\u0435\u0431\u043D\u043E\u043C \u043F\u0430\u043D\u0435\u043B\u0443","openWindows":"\u0422\u0440\u0435\u043D\u0443\u0442\u043D\u043E \u043E\u0442\u0432\u043E\u0440\u0435\u043D\u0438 \u043F\u0440\u0438\u043A\u0430\u0437\u0438","pagination":"{{current}} \u043E\u0434 {{total}}","position":"\u041F\u043E\u0437\u0438\u0446\u0438\u0458\u0430","previewWindowTitle":"{{title}}","previousCanvas":"\u041F\u0440\u0435\u0442\u0445\u043E\u0434\u043D\u0430","related":"\u0420\u0435\u043B\u0430\u0446\u0438\u0458\u0435","resource":"\u0420\u0435\u0441\u0443\u0440\u0441","retry":"\u041F\u043E\u043A\u0443\u0448\u0430\u0458\u0442\u0435 \u043F\u043E\u043D\u043E\u0432\u043E","right":"\u0414\u0435\u0441\u043D\u043E","rights":"\u041B\u0438\u0446\u0435\u043D\u0446\u0430","scroll":"\u041F\u043E\u043C\u0435\u0440\u0430\u0458\u0442\u0435","searchInputLabel":"\u043F\u0440\u0435\u0442\u0440\u0430\u0436\u0438\u0442\u0435 \u043F\u043E\u0458\u0430\u043C","searchNextResult":"\u0421\u043B\u0435\u0434\u0435\u045B\u0438 \u0440\u0435\u0437\u0443\u043B\u0442\u0430\u0442","searchNoResults":"\u0422\u0440\u0430\u0436\u0435\u043D\u0438 \u043F\u043E\u0458\u0430\u043C \u043D\u0438\u0458\u0435 \u043F\u0440\u043E\u043D\u0430\u0452\u0435\u043D","searchPreviousResult":"\u041F\u0440\u0435\u0442\u0445\u043E\u0434\u043D\u0438 \u0440\u0435\u0437\u0443\u043B\u0442\u0430\u0442","searchSubmitAria":"\u041F\u0440\u0435\u0442\u0440\u0430\u0436\u0438\u0442\u0435","searchTitle":"\u041F\u0440\u0435\u0442\u0440\u0430\u0433\u0430","selectWorkspaceMenu":"\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0440\u0430\u0434\u043D\u043E\u0433 \u043E\u043A\u0440\u0443\u0436\u0435\u045A\u0430","showingNumAnnotations":"\u041F\u0440\u0438\u043A\u0430\u0437 {{number}} \u0430\u043D\u043E\u0442\u0430\u0446\u0438\u0458\u0430/\u0458\u0435","showCollection":"\u041F\u0440\u0438\u043A\u0430\u0436\u0438 \u043A\u043E\u043B\u0435\u043A\u0446\u0438\u0458\u0443","showZoomControls":"\u041F\u0440\u0438\u043A\u0430\u0437 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0430 \u0437\u0443\u043C\u0430","sidebarPanelsNavigation":"\u041D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u0458\u0430 \u0441\u0430\u0458\u0434\u0431\u0430\u0440 \u043F\u0430\u043D\u0435\u043B\u0430","single":"\u041F\u043E\u0458\u0435\u0434\u0438\u043D\u0430\u0447\u043D\u043E","startHere":"\u0417\u0430\u043F\u043E\u0447\u043D\u0438\u0442\u0435","suggestSearch":"\u041F\u0440\u043E\u043D\u0430\u0452\u0438\u0442\u0435 \u043F\u043E\u0458\u0430\u043C \\"{{ query }}\\" \u0443 \u043E\u0432\u043E\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0443","tableOfContentsList":"\u0421\u0430\u0434\u0440\u0436\u0430\u0458","theme":"\u0422\u0435\u043C\u0430","thumbnailList":"\u041B\u0438\u0441\u0442\u0430 \u0441\u043B\u0438\u0447\u0438\u0446\u0430","thumbnailNavigation":"\u0421\u043B\u0438\u0447\u0438\u0446\u0435","thumbnails":"\u0421\u043B\u0438\u0447\u0438\u0446\u0435","toggleWindowSideBar":"\u0421\u0430\u0458\u0434\u0431\u0430\u0440","totalCollections":"{{count}} \u043A\u043E\u043B\u0435\u043A\u0446\u0438\u0458\u0430/\u0435","totalManifests":"{{count}} \u043E\u0431\u0458\u0435\u043A(\u0430)\u0442\u0430","tryAgain":"\u041F\u043E\u043A\u0443\u0448\u0430\u0458\u0442\u0435 \u043F\u043E\u043D\u043E\u0432\u043E","untitled":"[\u0411\u0435\u0437 \u043D\u0430\u0441\u043B\u043E\u0432\u0430]","view":"\u041F\u0440\u0435\u0433\u043B\u0435\u0434","welcome":"\u0414\u043E\u0431\u0440\u043E\u0434\u043E\u0448\u043B\u0438 \u0443 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0447 Mirador","window":"\u041F\u0440\u0438\u043A\u0430\u0437: {{label}}","windowMenu":"\u0418\u0437\u0433\u043B\u0435\u0434 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430 \u0438 \u043F\u043E\u0437\u0438\u0446\u0438\u0458\u0430 \u0441\u043B\u0438\u0447\u0438\u0446\u0430","windowNavigation":"\u041D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u0458\u0430 \u043F\u0440\u0438\u043A\u0430\u0437\u0430","windowPluginButtons":"\u041E\u043F\u0446\u0438\u0458\u0435","windowPluginMenu":"\u041E\u043F\u0446\u0438\u0458\u0435 \u043F\u0440\u0438\u043A\u0430\u0437\u0430","workspace":"\u0420\u0430\u0434\u043D\u0438 \u043F\u0440\u043E\u0441\u0442\u043E\u0440","workspaceFullScreen":"\u041F\u0440\u0438\u043A\u0430\u0437 \u043F\u0440\u0435\u043A\u043E \u0446\u0435\u043B\u043E\u0433 \u0435\u043A\u0440\u0430\u043D\u0430","workspaceMenu":"\u0423\u0440\u0435\u0452\u0438\u0432\u0430\u045A\u0435 \u0440\u0430\u0434\u043D\u043E\u0433 \u043F\u0440\u043E\u0441\u0442\u043E\u0440\u0430","workspaceOptions":"\u041E\u043F\u0446\u0438\u0458\u0435 \u0440\u0430\u0434\u043D\u043E\u0433 \u043E\u043A\u0440\u0443\u0436\u0435\u045A\u0430","workspaceSelectionTitle":"\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0440\u0430\u0434\u043D\u043E\u0433 \u043E\u043A\u0440\u0443\u0436\u0435\u045A\u0430","zoomIn":"\u0423\u0432\u0435\u045B\u0430\u0458\u0442\u0435","zoomOut":"\u0423\u043C\u0430\u045A\u0438\u0442\u0435","zoomReset":"\u0420\u0435\u0441\u0435\u0442 \u0437\u0443\u043C\u0430"}}');


var $43dfd9b2aa27e026$exports = {};
$43dfd9b2aa27e026$exports = JSON.parse('{"translation":{"aboutMirador":"Om Projekt Mirador","aboutThisItem":"Om det h\xe4r objektet","addedFromUrl":"(Tillagd fr\xe5n URL)","addManifestUrl":"Webbadress till samling eller manifest","addManifestUrlHelp":"URL till en IIIF-resurs","addResource":"L\xe4gg till resurs","annotationCanvasLabel_1/1":"Objekt: [{{label}}]","annotationCanvasLabel_1/2":"V\xe4nster: [{{label}}]","annotationCanvasLabel_2/2":"H\xf6ger: [{{label}}]","annotations":"Noteringar","attribution":"Tillskrivning","attributionTitle":"R\xe4ttigheter","authenticationFailed":"Autentisering misslyckades.","authenticationRequired":"Autentisering kr\xe4vs f\xf6r full \xe5tkomst","backToResults":"Tillbaka till resultat","book":"Bok","bottom":"Nederkant","cancel":"Avbryt","canvasIndex":"Index","changeTheme":"\xc4ndra tema","clearSearch":"Ta bort s\xf6kning","close":"St\xe4ng","closeAddResourceForm":"St\xe4ng formul\xe4r","closeAddResourceMenu":"St\xe4ng resurslista","closeCompanionWindow":"St\xe4ng panel","closeWindow":"St\xe4ng f\xf6nster","collapseSection":"St\xe4ng sektionen \\"{{section}}\\"","collapseSidePanel":"St\xe4ng sidof\xe4lt","collection":"Samling","itemList":"Objektlista","continue":"Forts\xe4tt","copy":"Kopiera","currentItem":"Aktuellt objekt","currentItem_1/1":"Aktuellt objekt","currentItem_1/2":"V\xe4nster","currentItem_2/2":"H\xf6ger","dark":"M\xf6rkt tema","digitizedView":"Digitaliserad vy","dismiss":"St\xe4ng","highlightAllAnnotations":"Markera alla","displayNoAnnotations":"Avmarkera alla","downloadExport":"Exportera arbetsyta","downloadExportWorkspace":"Exportera arbetsyta","elastic":"Elastisk","elasticDescription":"Flytta och \xe4ndra storlek p\xe5 f\xf6nster fritt i en obegr\xe4nsad arbetsyta. F\xf6nster kan \xf6verlappa.","emptyResourceList":"Din resurslista \xe4r tom","error":"Error","errorDialogConfirm":"OK","errorDialogTitle":"Ett problem uppstod","exitFullScreen":"L\xe4mna helsk\xe4rmsl\xe4ge","expandSection":"Expandera sektionen \\"{{section}}\\"","expandSidePanel":"Expandera sidof\xe4lt","exportCopied":"Konfiguration av arbetsytan har kopierats till dina urklipp","fetchManifest":"L\xe4gg till","fullScreen":"Helsk\xe4rmsl\xe4ge","gallery":"Galleri","hideZoomControls":"D\xf6lj zoomkontroller","iiif_homepage":"Om den h\xe4r resursen","iiif_manifest":"IIIF manifest","iiif_renderings":"Alternativa format","iiif_seeAlso":"Se \xe4ven","import":"Importera","importWorkspace":"Importera arbetsyta","importWorkspaceHint":"Klistra in en Mirador 3 konfiguration att importera","item":"Objekt: {{label}}","jsError":"Tekniska detaljer","jsStack":"{{ stack }}","language":"Spr\xe5k","layer_hide":"D\xf6lj lager","layer_move":"Flytta lager","layer_opacity":"Lageropacitet","layer_show":"Visa lager","layer_moveToTop":"Flytta lager till toppen","layers":"Lager","light":"Ljust tema","links":"L\xe4nkar","listAllOpenWindows":"G\xe5 till f\xf6nster","login":"Logga in","logout":"Logga ut","manifestError":"Resursen kan inte l\xe4ggas till:","maximizeWindow":"Maximera f\xf6nster","minimizeWindow":"Minimera f\xf6nster","mirador":"Mirador","miradorResources":"Miradorresurser","miradorViewer":"Mirador bildvisare","more":"mer...","moreResults":"Fler resultat","mosaic":"Mosaik","mosaicDescription":"Flytta och \xe4ndra storlek p\xe5 f\xf6nster i relation till varandra, innanf\xf6r den synliga ramen.","moveCompanionWindowToBottom":"Flytta till botten","moveCompanionWindowToRight":"Flytta till h\xf6ger","nextCanvas":"N\xe4sta objekt","noItemSelected":"Inga valda objekt","numItems":"{{number}} objekt","off":"Av","openCompanionWindow_annotations":"Noteringar","openCompanionWindow_attribution":"R\xe4ttigheter","openCompanionWindow_canvas":"Index","openCompanionWindow_info":"Information","openCompanionWindow_layers":"Lager","openCompanionWindow_search":"S\xf6k","openInCompanionWindow":"\xd6ppna i separat panel","openWindows":"\xd6ppna f\xf6nster","pagination":"{{current}} av {{total}}","position":"Position","previewWindowTitle":"{{title}}","previousCanvas":"F\xf6reg\xe5ende objekt","related":"Relaterat","resource":"Resurs","retry":"F\xf6rs\xf6k igen","right":"Till h\xf6ger","rights":"Licens","scroll":"Scrolla","searchInputLabel":"S\xf6kord","searchNextResult":"N\xe4sta resultat","searchNoResults":"Inga resultat hittades","searchPreviousResult":"F\xf6reg\xe5ende resultat","searchResultsRemaining":"{{numLeft}} kvar","searchSubmitAria":"S\xf6k","searchTitle":"S\xf6k","selectWorkspaceMenu":"V\xe4lj typ av arbetsyta","showingNumAnnotations":"Visar {{number}} noteringar","showCollection":"Visa samling","showZoomControls":"Visa zoomkontroller","sidebarPanelsNavigation":"Sidof\xe4ltspaneler navigering","single":"En och en","startHere":"B\xf6rja h\xe4r","suggestSearch":"S\xf6k i detta dokument efter \\"{{ query }}\\"","tableOfContentsList":"Inneh\xe5llsf\xf6rteckning","theme":"Tema","thumbnailList":"Miniatyrlista","thumbnailNavigation":"Miniatyrer","thumbnails":"Miniatyrer","toggleWindowSideBar":"Visa/d\xf6lj sidof\xe4lt","totalCollections":"{{count}} samlingar","totalManifests":"{{count}} manifest","tryAgain":"F\xf6rs\xf6k igen","untitled":"[namnl\xf6s]","view":"Vy","welcome":"V\xe4lkommen till Mirador","window":"F\xf6nster: {{label}}","windowMenu":"F\xf6nstervyer & miniatyrdisplay","windowNavigation":"F\xf6nsternavigation","windowPluginButtons":"Inst\xe4llningar","windowPluginMenu":"F\xf6nsterinst\xe4llningar","workspace":"Arbetsyta","workspaceNavigation":"Navigera i arbetsyta","workspaceFullScreen":"Helsk\xe4rmsl\xe4ge","workspaceMenu":"Inst\xe4llningar f\xf6r arbetsyta","workspaceOptions":"Fler val f\xf6r arbetsyta","workspaceSelectionTitle":"V\xe4lj typ av arbetsyta","zoomIn":"Zooma in","zoomOut":"Zooma ut","zoomReset":"\xc5terst\xe4ll zoom"}}');


var $64a07ebaddf5a499$exports = {};
$64a07ebaddf5a499$exports = JSON.parse('{"translation":{"aboutMirador":"Apie Project Mirador","aboutThisItem":"Apie \u0161\u012F \u012Fra\u0161\u0105","addedFromUrl":"(Prid\u0117ta naudojant URL)","addManifestUrl":"\u0160altinio adresas","addManifestUrlHelp":"Nuoroda \u012F IIIF \u0161altin\u012F","addResource":"Prid\u0117ti \u0161altin\u012F","annotationCanvasLabel_1/1":"\u012Era\u0161as: [{{label}}]","annotationCanvasLabel_1/2":"Kair\u0117: [{{label}}]","annotationCanvasLabel_2/2":"De\u0161in\u0117: [{{label}}]","annotations":"Anotacijos","attribution":"Priskyrimas","attributionTitle":"Teis\u0117s","authenticationFailed":"Autentifikavimo klaida.","authenticationRequired":"Pilnai prieigai b\u016Btina autentifikacija","backToResults":"Gr\u012F\u017Eti \u012F rezultatus","book":"Knyga","bottom":"Apa\u010Dia","cancel":"At\u0161aukti","canvasIndex":"Indeksas","changeTheme":"Keisti tem\u0105","clearSearch":"valyti","closeAddResourceForm":"U\u017Edaryti parai\u0161k\u0105","closeAddResourceMenu":"U\u017Edaryti \u0161altini\u0173 s\u0105ra\u0161\u0105","closeCompanionWindow":"U\u017Edaryti panel\u0119","closeWindow":"U\u017Edaryti lang\u0105","collapseSection":"Suskleisti \\"{{section}}\\" sekcij\u0105","collapseSidePanel":"Suskleisti \u0161onin\u0119 juost\u0105","itemList":"\u012Era\u0161\u0173 s\u0105ra\u0161as","continue":"T\u0119sti","copy":"Kopijuoti","currentItem":"Dabartinis \u012Fra\u0161as","currentItem_1/1":"Dabartinis \u012Fra\u0161as","currentItem_1/2":"Kair\u0117","currentItem_2/2":"De\u0161in\u0117","dark":"Tamsi tema","digitizedView":"Skaitmenintas vaizdas","dismiss":"Atmesti","highlightAllAnnotations":"Pary\u0161kinti visk\u0105","displayNoAnnotations":"Sl\u0117pti visk\u0105","downloadExport":"I\u0161saugoti darbalauk\u012F","downloadExportWorkspace":"I\u0161saugoti darbalauk\u012F","elastic":"Lankstus","elasticDescription":"Lang\u0173 dydis ir vieta gali b\u016Bti laisvai valdomi. Langai gali persidengti.","emptyResourceList":"J\u016Bs\u0173 \u0161altini\u0173 s\u0105ra\u0161as yra tu\u0161\u010Dias","error":"Klaida","errorDialogConfirm":"Gerai","errorDialogTitle":"\u012Evyko klaida","exitFullScreen":"I\u0161jungti pilno ekrano re\u017Eim\u0105","expandSection":"I\u0161pl\u0117sti \\"{{section}}\\" sekcij\u0105","expandSidePanel":"I\u0161pl\u0117sti \u0161onin\u0119 juost\u0105","exportCopied":"Darbalaukio nustatymai nukopijuoti","fetchManifest":"Prid\u0117ti","fullScreen":"Pilnas ekranas","gallery":"Galerija","hideZoomControls":"Sl\u0117pti priartinimo valdym\u0105","iiif_homepage":"Apie \u0161\u012F \u0161altin\u012F","iiif_manifest":"IIIF manifestas","iiif_renderings":"Kiti formatai","iiif_seeAlso":"Susij\u0119","import":"\u012Ekelti","importWorkspace":"\u012Ekelti darbalauk\u012F","importWorkspaceHint":"\u012Eterpkite Mirador 3 nustatymus \u012Fk\u0117limui","item":"\u012Era\u0161as: {{label}}","jsError":"Technin\u0117 informacija","jsStack":"{{ stack }}","language":"Kalba","layer_hide":"Sl\u0117pti sluoksn\u012F","layer_move":"Perkelti sluoksn\u012F","layer_opacity":"Sluoksnio nepermatomumas","layer_show":"Rodyti sluoksn\u012F","layer_moveToTop":"Perkelti sluoksn\u012F \u012F vir\u0161\u0173","layers":"Sluoksniai","light":"\u0160viesi tema","links":"Nuorodos","listAllOpenWindows":"Rodyti aktyvius langus","login":"Prisijungti","logout":"Atsijungti","manifestError":"\u0160altinis negali b\u016Bti prid\u0117tas:","maximizeWindow":"I\u0161didinti lang\u0105","minimizeWindow":"Suma\u017Einti lang\u0105","mirador":"Mirador","miradorResources":"Mirador \u0161altiniai","miradorViewer":"Mirador \u017Ei\u016Brykl\u0117","more":"daugiau...","moreResults":"Daugiau rezultat\u0173","mosaic":"Mosaic","mosaicDescription":"Lang\u0173 dyd\u017Eio ir pozicijos keitimai apribojami ekrano erdv\u0117je.","moveCompanionWindowToBottom":"Perkelti \u012F apa\u010Di\u0105","moveCompanionWindowToRight":"Perkelti \u012F de\u0161in\u0119","nextCanvas":"Kitas \u012Fra\u0161as","numItems":"{{number}} \u012Fra\u0161as (-ai)","off":"I\u0161jungti","openCompanionWindow_annotations":"Anotacijos","openCompanionWindow_attribution":"Teis\u0117s","openCompanionWindow_canvas":"Indeksas","openCompanionWindow_info":"Informacija","openCompanionWindow_layers":"Sluoksniai","openCompanionWindow_search":"Paie\u0161ka","openInCompanionWindow":"Atidaryti kaip nauj\u0105 panel\u0119","openWindows":"Aktyv\u0173s langai","pagination":"{{current}} i\u0161 {{total}}","position":"Pozicija","previewWindowTitle":"{{title}}","previousCanvas":"Buv\u0119s \u012Fra\u0161as","related":"Susij\u0119","resource":"\u0160altinis","retry":"Pabandyti i\u0161 naujo","right":"De\u0161in\u0117","rights":"Teis\u0117s","scroll":"Paslinkti","searchInputLabel":"paie\u0161kos terminas","searchNextResult":"Kitas rezultatas","searchNoResults":"N\u0117ra rezultat\u0173","searchPreviousResult":"Buv\u0119s rezultatas","searchSubmitAria":"Pateikti paie\u0161kos u\u017Eklaus\u0105","searchTitle":"Ie\u0161koti","selectWorkspaceMenu":"Pasirinkti darbalaukio tip\u0105","showingNumAnnotations":"Rodoma {{number}} anotacija (-os)","showCollection":"Rodyti kolekcij\u0105","showZoomControls":"Rodyti priartinimo valdym\u0105","sidebarPanelsNavigation":"\u0160onin\u0117s juostos valdymas","single":"Atskiras","startHere":"Prad\u0117kite \u010Dia","suggestSearch":"Ie\u0161koti \\"{{ query }}\\" visame documente","tableOfContentsList":"Turinys","theme":"Tema","thumbnailList":"Miniati\u016Br\u0173 s\u0105ra\u0161as","thumbnailNavigation":"Miniati\u016Bros","thumbnails":"Miniati\u016Bros","toggleWindowSideBar":"Perjungti \u0161onin\u0119 juost\u0105","totalCollections":"{{count}} kolekcija (-os)","totalManifests":"{{count}} \u0161altinis (-iai)","tryAgain":"Bandykite dar kart\u0105","untitled":"[Be pavadinimo]","view":"\u017Di\u016Br\u0117ti","welcome":"Sveiki atvyk\u0119 \u012F Mirador","window":"Langas: {{label}}","windowMenu":"Lang\u0173 & miniati\u016Br\u0173 atvaizdavimas","windowNavigation":"Lang\u0173 valdymas","windowPluginButtons":"Pasirinkimai","windowPluginMenu":"Lang\u0173 pasirinkimai","workspace":"Darbalaukis","workspaceNavigation":"Darbalaukio valdymas","workspaceFullScreen":"Pilnas ekranas","workspaceMenu":"Darbalaukio nustatymai","workspaceOptions":"Darbalaukio pasirinkimai","workspaceSelectionTitle":"Pasirinkite darbalaukio tip\u0105","zoomIn":"Priartinti","zoomOut":"Atitolinti","zoomReset":"Atstatyti priartinim\u0105"}}');


var $3413bb0b2a956d1d$exports = {};
$3413bb0b2a956d1d$exports = JSON.parse('{"translation":{"aboutMirador":"V\u1EC1 d\u1EF1 \xe1n Mirador","aboutThisItem":"V\u1EC1 kho\u1EA3n m\u1EE5c n\xe0y","addedFromUrl":"(\u0110\u01B0\u1EE3c th\xeam t\u1EEB URL)","addManifestUrl":"V\u1ECB tr\xed t\xe0i nguy\xean","addManifestUrlHelp":"URL c\u1EE7a t\xe0i nguy\xean IIIF","addResource":"B\u1ED5 sung t\xe0i nguy\xean","annotationCanvasLabel_1/1":"Kho\u1EA3n m\u1EE5c: [{{label}}]","annotationCanvasLabel_1/2":"Tr\xe1i: [{{label}}]","annotationCanvasLabel_2/2":"Ph\u1EA3i: [{{label}}]","annotations":"Ch\xfa gi\u1EA3i","attribution":"Quy\u1EC1n h\u1EA1n","attributionTitle":"Quy\u1EC1n","authenticationFailed":"X\xe1c th\u1EF1c th\u1EA5t b\u1EA1i.","authenticationRequired":"X\xe1c th\u1EF1c \u0111\u01B0\u1EE3c y\xeau c\u1EA7u cho truy nh\u1EADp \u0111\u1EA7y \u0111\u1EE7","backToResults":"Tr\u1EDF l\u1EA1i k\u1EBFt qu\u1EA3","book":"S\xe1ch","bottom":"\u0110\xe1y","cancel":"Hu\u1EF7 b\u1ECF","canvasIndex":"Ch\u1EC9 m\u1EE5c","changeTheme":"\u0110\u1ED5i ch\u1EE7 \u0111\u1EC1","clearSearch":"xo\xe1","close":"\u0110\xf3ng","closeAddResourceForm":"\u0110\xf3ng m\u1EABu","closeAddResourceMenu":"\u0110\xf3ng danh s\xe1ch t\xe0i nguy\xean","closeCompanionWindow":"\u0110\xf3ng panel","closeWindow":"\u0110\xf3ng c\u1EEDa s\u1ED5","collapseSection":"Co s\u1EADp {{section}} m\u1EE5c","collapseSidePanel":"Co s\u1EADp thanh b\xean","collection":"Tuy\u1EC3n t\u1EADp","itemList":"Danh s\xe1ch kho\u1EA3n m\u1EE5c","continue":"Ti\u1EBFp t\u1EE5c","copy":"Sao","currentItem":"Kho\u1EA3n m\u1EE5c hi\u1EC7n th\u1EDDi","currentItem_1/1":"Kho\u1EA3n m\u1EE5c hi\u1EC7n th\u1EDDi","currentItem_1/2":"Tr\xe1i","currentItem_2/2":"Ph\u1EA3i","dark":"Ch\u1EE7 \u0111\u1EC1 t\u1ED1i","digitizedView":"C\xe1i nh\xecn s\u1ED1 ho\xe1","dismiss":"B\xe1c b\u1ECF","highlightAllAnnotations":"L\xe0m n\u1ED5i b\u1EADt t\u1EA5t","displayNoAnnotations":"Kh\xf4ng l\xe0m n\u1ED5i b\u1EADt","downloadExport":"V\xf9ng xu\u1EA5t kh\u1EA9u","downloadExportWorkspace":"V\xf9ng xu\u1EA5t kh\u1EA9u","elastic":"Co gi\xe3n","elasticDescription":"Di chuy\u1EC3n v\xe0 \u0111\u1ECBnh c\u1EE1 c\u1EEDa s\u1ED5 t\u1EF1 do trong v\xf9ng v\xf4 gi\u1EDBi h\u1EA1n. C\u1EEDa s\u1ED5 c\xf3 th\u1EC3 ch\xe8n l\u1EA5p.","emptyResourceList":"Danh s\xe1ch t\xe0i nguy\xean c\u1EE7a b\u1EA1n l\xe0 tr\u1ED1ng","error":"L\u1ED7i","errorDialogConfirm":"OK","errorDialogTitle":"L\u1ED7i \u0111\xe3 xu\u1EA5t hi\u1EC7n","exitFullScreen":"Ra kh\u1ECFi to\xe0n m\xe0n h\xecnh","expandSection":"M\u1EDF r\u1ED9ng {{section}} m\u1EE5c","expandSidePanel":"M\u1EDF r\u1ED9ng thanh b\xean","exportCopied":"C\u1EA5u h\xecnh v\xf9ng l\xe0m vi\u1EC7c \u0111\u01B0\u1EE3c sao v\xe0o b\u1EA3ng \u0111\u1EC7m c\u1EE7a b\u1EA1n","fetchManifest":"Th\xeam","fullScreen":"To\xe0n m\xe0n h\xecnh","gallery":"Ph\xf2ng tranh","hideZoomControls":"\u1EA8n \u0111i\u1EC1u khi\u1EC3n thu ph\xf3ng","iiif_homepage":"V\u1EC1 t\xe0i nguy\xean n\xe0y","iiif_manifest":"B\u1EA3n k\xea IIIF","iiif_renderings":"D\u1EA1ng th\u1EE9c lu\xe2n phi\xean","iiif_seeAlso":"C\u0169ng xem","import":"Nh\u1EADp kh\u1EA9u","importWorkspace":"V\xf9ng nh\u1EADp kh\u1EA9u","importWorkspaceHint":"D\xe1n c\u1EA5u h\xecnh Mirador 3 \u0111\u1EC3 \u0111\u01B0\u1EE3c nh\u1EADp kh\u1EA9u","item":"Kho\u1EA3n m\u1EE5c: {{label}}","jsError":"Chi ti\u1EBFt k\u0129 thu\u1EADt","jsStack":"{{ stack }}","language":"Ng\xf4n ng\u1EEF","layer_hide":"Gi\u1EA5u t\u1EA7ng","layer_move":"Chuy\u1EC3n t\u1EA7ng","layer_opacity":"L\xe0m m\u1EDD t\u1EA7ng","layer_show":"Hi\u1EC7n t\u1EA7ng","layer_moveToTop":"Chuy\u1EC3n t\u1EA7ng l\xean \u0111\u1EC9nh","layers":"T\u1EA7ng","light":"Ch\u1EE7 \u0111\u1EC1 s\xe1ng","links":"M\xf3c n\u1ED1i","listAllOpenWindows":"Nh\u1EA3y t\u1EDBi c\u1EEDa s\u1ED5","login":"\u0110\u0103ng nh\u1EADp","logout":"\u0110\u0103ng xu\u1EA5t","manifestError":"T\xe0i nguy\xean kh\xf4ng th\u1EC3 \u0111\u01B0\u1EE3c b\u1ED5 sung:","maximizeWindow":"C\u1EF1c \u0111\u1EA1i c\u1EEDa s\u1ED5","minimizeWindow":"C\u1EF1c ti\u1EC3u c\u1EEDa s\u1ED5","mirador":"Mirador","miradorResources":"T\xe0i nguy\xean Mirador","miradorViewer":"B\u1ED9 xem Mirador","more":"th\xeam...","moreResults":"Th\xeam k\u1EBFt qu\u1EA3","mosaic":"Mosaic","mosaicDescription":"Di chuy\u1EC3n v\xe0 \u0111\u1ECBnh c\u1EE1 c\u1EEDa s\u1ED5 trong quan h\u1EC7 l\u1EABn nhau, b\xean trong khung th\u1EA5y \u0111\u01B0\u1EE3c.","moveCompanionWindowToBottom":"Chuy\u1EC3n t\u1EDBi \u0111\xe1y","moveCompanionWindowToRight":"Chuy\u1EC3n sang ph\u1EA3i","nextCanvas":"Kho\u1EA3n m\u1EE5c ti\u1EBFp","noItemSelected":"Kh\xf4ng kho\u1EA3n m\u1EE5c n\xe0o \u0111\u01B0\u1EE3c ch\u1ECDn","numItems":"{{number}} kho\u1EA3n m\u1EE5c","off":"Off","openCompanionWindow_annotations":"Ch\xfa gi\u1EA3i","openCompanionWindow_attribution":"Quy\u1EC1n","openCompanionWindow_canvas":"Ch\u1EC9 m\u1EE5c","openCompanionWindow_info":"Th\xf4ng tin","openCompanionWindow_layers":"T\u1EA7ng","openCompanionWindow_search":"T\xecm","openInCompanionWindow":"M\u1EDF trong ng\u0103n t\xe1ch r\u1EDDi","openWindows":"C\u1EEDa s\u1ED5 m\u1EDF hi\u1EC7n th\u1EDDi","pagination":"{{current}} trong {{total}}","position":"V\u1ECB tr\xed","previewWindowTitle":"{{title}}","previousCanvas":"Kho\u1EA3n m\u1EE5c tr\u01B0\u1EDBc","related":"C\xf3 li\xean quan","resource":"T\xe0i nguy\xean","retry":"Th\u1EED l\u1EA1i","right":"Quy\u1EC1n","rights":"C\u1EA5p ph\xe9p","scroll":"Cu\u1ED9n","searchInputLabel":"T\u1EEB t\xecm ki\u1EBFm","searchNextResult":"K\u1EBFt qu\u1EA3 ti\u1EBFp","searchNoResults":"Kh\xf4ng t\xecm \u0111\u01B0\u1EE3c k\u1EBFt qu\u1EA3 n\xe0o","searchPreviousResult":"K\u1EBFt qu\u1EA3 tr\u01B0\u1EDBc","searchSubmitAria":"\u0110\u1EC7 tr\xecnh vi\u1EC7c t\xecm","searchTitle":"T\xecm","selectWorkspaceMenu":"Ch\u1ECDn ki\u1EC3u v\xf9ng l\xe0m vi\u1EC7c","showingNumAnnotations":"Hi\u1EC7n {{number}} ch\xfa gi\u1EA3i","showCollection":"Hi\u1EC7n b\u1ED9 s\u01B0u t\u1EADp","showZoomControls":"Hi\u1EC7n ki\u1EC3m so\xe1t thu ph\xf3ng","sidebarPanelsNavigation":"D\u1EABn l\xe1i ng\u0103n thanh b\xean","single":"Ch\u1EC9 m\u1ED9t","startHere":"B\u1EAFt \u0111\u1EA7u \u1EDF \u0111\xe2y","suggestSearch":"T\xecm t\xe0i li\u1EC7u n\xe0y cho \\"{{ query }}\\"","tableOfContentsList":"M\u1EE5c l\u1EE5c","theme":"Ch\u1EE7 \u0111\u1EC1","thumbnailList":"Danh s\xe1ch \u1EA3nh thu nh\u1ECF","thumbnailNavigation":"\u1EA2nh thu nh\u1ECF","thumbnails":"\u1EA2nh thu nh\u1ECF","toggleWindowSideBar":"ch\u1ED1t thanh b\xean","totalCollections":"{{count}} b\u1ED9 s\u01B0u t\u1EADp","totalManifests":"{{count}} b\u1EA3n k\xea","tryAgain":"Th\u1EED l\u1EA1i","untitled":"[Untitled]","view":"Xem","welcome":"Ch\xe0o m\u1EEBng b\u1EA1n t\u1EDBi Mirador","window":"C\u1EEDa s\u1ED5: {{label}}","windowMenu":"Xem c\u1EEDa s\u1ED5 & hi\u1EC3n th\u1ECB \u1EA3nh thu nh\u1ECF","windowNavigation":"D\u1EABn l\xe1i c\u1EEDa s\u1ED5","windowPluginButtons":"Tu\u1EF3 ch\u1ECDn","windowPluginMenu":"Tu\u1EF3 ch\u1ECDn c\u1EEDa s\u1ED5","workspace":"V\xf9ng l\xe0m vi\u1EC7c","workspaceNavigation":"D\u1EABn l\xe1i v\xf9ng l\xe0m vi\u1EC7c","workspaceFullScreen":"To\xe0n m\xe0n h\xecnh","workspaceMenu":"Thi\u1EBFt \u0111\u1EB7t v\xf9ng l\xe0m vi\u1EC7c","workspaceOptions":"Tu\u1EF3 ch\u1ECDn v\xf9ng l\xe0m vi\u1EC7c","workspaceSelectionTitle":"Ch\u1ECDn ki\u1EC3u v\xf9ng l\xe0m vi\u1EC7c","zoomIn":"Thu nh\u1ECF","zoomOut":"Ph\xf3ng to","zoomReset":"\u0110\u1EB7t l\u1EA1i thu ph\xf3ng"}}');


var $3ff265ae4a44026f$exports = {};
$3ff265ae4a44026f$exports = JSON.parse('{"translation":{"aboutMirador":"Om Projekt Mirador","aboutThisItem":"Om dette objektet","addedFromUrl":"(Lagt til fra URL)","addManifestUrl":"Nettadresse til samling eller manifest","addManifestUrlHelp":"URL til en IIIF-ressurs","addResource":"Legg til ressurs","annotationCanvasLabel_1/1":"Objekt: [{{label}}]","annotationCanvasLabel_1/2":"Venstre: [{{label}}]","annotationCanvasLabel_2/2":"H\xf8yre: [{{label}}]","annotations":"Annoteringer","attribution":"Tilskrivelse","attributionTitle":"Rettigheter","authenticationFailed":"Autentiseringen feilet.","authenticationRequired":"Autentisering kreves for full tilgang","backToResults":"Tilbake til resultat","book":"Bok","bottom":"Nederst","cancel":"Avbryt","canvasIndex":"Index","changeTheme":"Skift tema","clearSearch":"Fjern s\xf8ket","close":"Lukk","closeAddResourceForm":"Lukk skjemaet","closeAddResourceMenu":"Lukk ressurslisten","closeCompanionWindow":"Lukk panelet","closeWindow":"Lukk vinduet","collapseSection":"Lukk seksjonen \\"{{section}}\\"","collapseSidePanel":"Lukk sidemenyen","collection":"Samling","itemList":"Objektliste","continue":"Fortsett","copy":"Kopiere","currentItem":"Valgt objekt","currentItem_1/1":"Valgt objekt","currentItem_1/2":"Venstre","currentItem_2/2":"H\xf8yre","dark":"M\xf8rkt tema","digitizedView":"Digitalisert visning","dismiss":"Lukk","highlightAllAnnotations":"Mark\xe9r alle","displayNoAnnotations":"Avmark\xe9r alle","downloadExport":"Eksport\xe9r arbeidsomr\xe5de","downloadExportWorkspace":"Eksport\xe9r arbeidsomr\xe5de","elastic":"Elastisk","elasticDescription":"Flytt og endre st\xf8rrelsen p\xe5 vinduet fritt i et ubegrenset arbeidsomr\xe5de. Vindu kan overlappe.","emptyResourceList":"Din resursliste er tom","error":"Error","errorDialogConfirm":"OK","errorDialogTitle":"Et problem oppstod","exitFullScreen":"Forlat fullskjermsvisning","expandSection":"Ekspand\xe9r seksjonen \\"{{section}}\\"","expandSidePanel":"Ekspand\xe9r sidemenyen","exportCopied":"Konfiguration av arbeidsomr\xe5det ble kopiert til din utklippstavle","fetchManifest":"Legg til","fullScreen":"Fullskjermsvisning","gallery":"Galleri","hideZoomControls":"Skjul zoomkontroll","iiif_homepage":"Om denne ressursen","iiif_manifest":"IIIF manifest","iiif_renderings":"Alternativt format","iiif_seeAlso":"Se ogs\xe5","import":"Import\xe9r","importWorkspace":"Import\xe9r arbeidsomr\xe5de","importWorkspaceHint":"Lim inn en Mirador 3 konfigurasjon for import","item":"Objekt: {{label}}","jsError":"Tekniske detaljer","jsStack":"{{ stack }}","language":"Spr\xe5k","layer_hide":"Skjul lag","layer_move":"Flytt lag","layer_opacity":"Lag-gjennomsiktighet","layer_show":"Vis lag","layer_moveToTop":"Flytt laget \xf8verst","layers":"Lag","light":"Lyst tema","links":"Lenker","listAllOpenWindows":"G\xe5 til vindu","login":"Logg inn","logout":"Logg ut","manifestError":"Ressursen kan ikke legges til:","maximizeWindow":"Maksim\xe9r vinduet","minimizeWindow":"Minim\xe9r vinduet","mirador":"Mirador","miradorResources":"Miradorressurser","miradorViewer":"Mirador bildeviser","more":"mer...","moreResults":"Flere resultat","mosaic":"Mosaik","mosaicDescription":"Flytt og endre st\xf8rrelse p\xe5 vinduet i relasjon til hverandre, innenfor den synlige rammen.","moveCompanionWindowToBottom":"Flytt til bunnen","moveCompanionWindowToRight":"Flytt til h\xf8yre","nextCanvas":"Neste objekt","noItemSelected":"Ingen valgte objekt","numItems":"{{number}} objekt","numItems_plural":"{{number}} objekter","off":"Av","openCompanionWindow_annotations":"Annoteringer","openCompanionWindow_attribution":"Rettigheter","openCompanionWindow_canvas":"Indeks","openCompanionWindow_info":"Informasjon","openCompanionWindow_layers":"Lag","openCompanionWindow_search":"S\xf8k","openInCompanionWindow":"\xc5pne i eget panel","openWindows":"\xc5pne vindu","pagination":"{{current}} av {{total}}","position":"Posisjon","previewWindowTitle":"{{title}}","previousCanvas":"Forrige objekt","related":"Relatert","resource":"Ressurs","retry":"Fors\xf8k igjen","right":"Til h\xf8yre","rights":"Lisens","scroll":"Bla","searchInputLabel":"S\xf8keord","searchNextResult":"Neste resultat","searchNoResults":"Ingen treff","searchPreviousResult":"Forrige resultat","searchResultsRemaining":"{{numLeft}} igjen","searchSubmitAria":"S\xf8k","searchTitle":"S\xf8k","selectWorkspaceMenu":"Velg arbeidsomr\xe5de-type","showingNumAnnotations":"Vis {{number}} annotasjon","showingNumAnnotations_plural":"Vis {{number}} annotasjoner","showCollection":"Vis samling","showZoomControls":"Vis zoomkontroll","sidebarPanelsNavigation":"Sidemeny-panel navigering","single":"En og en","startHere":"Start her","suggestSearch":"S\xf8k etter \\"{{ query }}\\" i dette dokument","tableOfContentsList":"Innholdsfortegnelse","theme":"Tema","thumbnailList":"Miniatyrliste","thumbnailNavigation":"Miniatyrer","thumbnails":"Miniatyrer","toggleWindowSideBar":"Vis/skjul sidemenyen","totalCollections":"{{count}} samling","totalCollections_plural":"{{count}} samlinger","totalManifests":"{{count}} manifest","totalManifests_plural":"{{count}} manifester","tryAgain":"Fors\xf8k igjen","untitled":"[uten tittel]","view":"Visning","viewWorkspaceConfiguration":"Vis konfigurasjon av arbeidsomr\xe5de.","welcome":"Velkommen til Mirador","window":"Vindu: {{label}}","windowMenu":"Vindusvisning & miniatyrvisning","windowNavigation":"Vindusnavigasjon","windowPluginButtons":"Innstillinger","windowPluginMenu":"Vindusinnstillinger","workspace":"Arbeidsomr\xe5de","workspaceNavigation":"Navigasjon i arbeidsomr\xe5det","workspaceFullScreen":"Fullskjermsvisning","workspaceMenu":"Innstillinger for arbeidsomr\xe5det","workspaceOptions":"Flere valg for arbeidsomr\xe5det","workspaceSelectionTitle":"Velg arbeidsomr\xe5de-type","zoomIn":"Zoom inn","zoomOut":"Zoom ut","zoomReset":"Tilbakestill zoom"}}');


/**
 * Load translations for each language
 */ function $c50d4cf6b6df3646$var$createI18nInstance() {
    var resources = {
        ar: (0, (/*@__PURE__*/$parcel$interopDefault($787f97e84b3cf68a$exports))),
        de: (0, (/*@__PURE__*/$parcel$interopDefault($b1042e723da910d1$exports))),
        en: (0, (/*@__PURE__*/$parcel$interopDefault($a66fbaabfd5ffdf0$exports))),
        fr: (0, (/*@__PURE__*/$parcel$interopDefault($8a0bdbd9d900ff59$exports))),
        it: (0, (/*@__PURE__*/$parcel$interopDefault($1f5af9c1db8256d6$exports))),
        ja: (0, (/*@__PURE__*/$parcel$interopDefault($4f14724e586bbc28$exports))),
        kr: (0, (/*@__PURE__*/$parcel$interopDefault($965fa5721f64c95f$exports))),
        lt: (0, (/*@__PURE__*/$parcel$interopDefault($64a07ebaddf5a499$exports))),
        "nb-NO": (0, (/*@__PURE__*/$parcel$interopDefault($3ff265ae4a44026f$exports))),
        nl: (0, (/*@__PURE__*/$parcel$interopDefault($93d32d10d4ebae9d$exports))),
        pl: (0, (/*@__PURE__*/$parcel$interopDefault($863d8257acf4aadf$exports))),
        "pt-BR": (0, (/*@__PURE__*/$parcel$interopDefault($4ecdf6402c4e99c0$exports))),
        sr: (0, (/*@__PURE__*/$parcel$interopDefault($2ebf63d896d02c56$exports))),
        sv: (0, (/*@__PURE__*/$parcel$interopDefault($43dfd9b2aa27e026$exports))),
        vi: (0, (/*@__PURE__*/$parcel$interopDefault($3413bb0b2a956d1d$exports))),
        "zh-CN": (0, (/*@__PURE__*/$parcel$interopDefault($4ae0ed079fd9b6a1$exports))),
        "zh-TW": (0, (/*@__PURE__*/$parcel$interopDefault($0ccdc17f8cc0188e$exports)))
    };
    var instance = (0, $9bb3d3a0c854c004$export$2e2bcd8739ae039).createInstance();
    instance.use((0, $8LHwv.initReactI18next)).init({
        fallbackLng: "en",
        interpolation: {
            escapeValue: false // react is already safe from xss
        },
        lng: "en",
        resources: resources
    });
    return instance;
}
var $c50d4cf6b6df3646$export$2e2bcd8739ae039 = $c50d4cf6b6df3646$var$createI18nInstance;


function $b5f964c8dc1d296c$var$_toConsumableArray(arr) {
    return $b5f964c8dc1d296c$var$_arrayWithoutHoles(arr) || $b5f964c8dc1d296c$var$_iterableToArray(arr) || $b5f964c8dc1d296c$var$_unsupportedIterableToArray(arr) || $b5f964c8dc1d296c$var$_nonIterableSpread();
}
function $b5f964c8dc1d296c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b5f964c8dc1d296c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b5f964c8dc1d296c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b5f964c8dc1d296c$var$_arrayLikeToArray(o, minLen);
}
function $b5f964c8dc1d296c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b5f964c8dc1d296c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b5f964c8dc1d296c$var$_arrayLikeToArray(arr);
}
function $b5f964c8dc1d296c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b5f964c8dc1d296c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b5f964c8dc1d296c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b5f964c8dc1d296c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b5f964c8dc1d296c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b5f964c8dc1d296c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b5f964c8dc1d296c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b5f964c8dc1d296c$var$_setPrototypeOf(subClass, superClass);
}
function $b5f964c8dc1d296c$var$_setPrototypeOf(o, p) {
    $b5f964c8dc1d296c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b5f964c8dc1d296c$var$_setPrototypeOf(o, p);
}
function $b5f964c8dc1d296c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b5f964c8dc1d296c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b5f964c8dc1d296c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b5f964c8dc1d296c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b5f964c8dc1d296c$var$_possibleConstructorReturn(this, result);
    };
}
function $b5f964c8dc1d296c$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b5f964c8dc1d296c$var$_assertThisInitialized(self);
}
function $b5f964c8dc1d296c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b5f964c8dc1d296c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b5f964c8dc1d296c$var$_getPrototypeOf(o) {
    $b5f964c8dc1d296c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b5f964c8dc1d296c$var$_getPrototypeOf(o);
}
/**
 * Allow applications to opt-out of (or provide their own) drag and drop context
 */ var $b5f964c8dc1d296c$var$MaybeDndProvider = function MaybeDndProvider(props) {
    var dndManager = props.dndManager, children = props.children;
    if (dndManager === false) return children;
    if (dndManager === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $1lzPe.DndProvider), {
        backend: (0, $9I5De.default),
        options: (0, (/*@__PURE__*/$parcel$interopDefault($1I9Y5)))
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $3nbWv.DndContext).Provider, {
        value: dndManager
    }, children);
};
var $b5f964c8dc1d296c$export$6c4743022ef2c318 = /*#__PURE__*/ function(_Component) {
    $b5f964c8dc1d296c$var$_inherits(AppProviders, _Component);
    var _super = $b5f964c8dc1d296c$var$_createSuper(AppProviders);
    /** */ function AppProviders(props) {
        var _this;
        $b5f964c8dc1d296c$var$_classCallCheck(this, AppProviders);
        _this = _super.call(this, props);
        _this.i18n = (0, $c50d4cf6b6df3646$export$2e2bcd8739ae039)();
        return _this;
    }
    /**
   * Set i18n language on component mount
   */ $b5f964c8dc1d296c$var$_createClass(AppProviders, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var language = this.props.language;
                this.i18n.changeLanguage(language);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var language = this.props.language;
                if (prevProps.language !== language) this.i18n.changeLanguage(language);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, children = _this$props.children, createGenerateClassNameOptions = _this$props.createGenerateClassNameOptions, isFullscreenEnabled = _this$props.isFullscreenEnabled, setWorkspaceFullscreen = _this$props.setWorkspaceFullscreen, theme = _this$props.theme, translations = _this$props.translations, dndManager = _this$props.dndManager;
                var generateClassName = (0, $iPknr.default)(createGenerateClassNameOptions);
                Object.keys(translations).forEach(function(lng) {
                    _this2.i18n.addResourceBundle(lng, "translation", translations[lng], true, true);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99ce74d8590d35ce$exports))), {
                    enabled: isFullscreenEnabled,
                    onChange: setWorkspaceFullscreen
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $63291e5e77f7ce3a$export$1325e8699caa160f), {
                    i18n: this.i18n
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $7Abnn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $b4da39daca98febb$export$2e2bcd8739ae039), {
                    theme: (0, $ecQ1P.createMuiTheme)(theme)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $6OzM9.default), {
                    jss: (0, $1s5gz.create)({
                        plugins: [].concat($b5f964c8dc1d296c$var$_toConsumableArray((0, $85CAN.default)().plugins), [
                            (0, (/*@__PURE__*/$parcel$interopDefault($12a7defa7c6ab0d1$exports)))()
                        ])
                    }),
                    generateClassName: generateClassName
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($b5f964c8dc1d296c$var$MaybeDndProvider, {
                    dndManager: dndManager
                }, children))))));
            }
        }
    ]);
    return AppProviders;
}((0, $arQ7u.Component));
$b5f964c8dc1d296c$export$6c4743022ef2c318.defaultProps = {
    children: null,
    createGenerateClassNameOptions: {},
    dndManager: undefined,
    isFullscreenEnabled: false
};


/**
 * mapStateToProps - to hook up connect
 * @memberof App
 * @private
 */ var $924e0df07e5aecfc$var$mapStateToProps = function mapStateToProps(state) {
    return {
        createGenerateClassNameOptions: (0, $jGts0.getConfig)(state).createGenerateClassNameOptions,
        isFullscreenEnabled: (0, $3DW53.getFullScreenEnabled)(state),
        language: (0, $jGts0.getConfig)(state).language,
        theme: (0, $jGts0.getTheme)(state),
        translations: (0, $jGts0.getConfig)(state).translations
    };
};
/**
 * mapDispatchToProps - used to hook up connect to action creators
 * @memberof App
 * @private
 */ var $924e0df07e5aecfc$var$mapDispatchToProps = {
    setWorkspaceFullscreen: $bcVRp.setWorkspaceFullscreen
};
var $924e0df07e5aecfc$var$enhance = (0, $k19ic.compose)((0, $fbonu.default)($924e0df07e5aecfc$var$mapStateToProps, $924e0df07e5aecfc$var$mapDispatchToProps), (0, $7XHRd.withPlugins)("AppProviders"));
var $924e0df07e5aecfc$export$2e2bcd8739ae039 = $924e0df07e5aecfc$var$enhance((0, $b5f964c8dc1d296c$export$6c4743022ef2c318));


function $6b9e03c96368022e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6b9e03c96368022e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6b9e03c96368022e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6b9e03c96368022e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6b9e03c96368022e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6b9e03c96368022e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6b9e03c96368022e$var$_setPrototypeOf(subClass, superClass);
}
function $6b9e03c96368022e$var$_setPrototypeOf(o, p) {
    $6b9e03c96368022e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6b9e03c96368022e$var$_setPrototypeOf(o, p);
}
function $6b9e03c96368022e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6b9e03c96368022e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6b9e03c96368022e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6b9e03c96368022e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6b9e03c96368022e$var$_possibleConstructorReturn(this, result);
    };
}
function $6b9e03c96368022e$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6b9e03c96368022e$var$_assertThisInitialized(self);
}
function $6b9e03c96368022e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6b9e03c96368022e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6b9e03c96368022e$var$_getPrototypeOf(o) {
    $6b9e03c96368022e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6b9e03c96368022e$var$_getPrototypeOf(o);
}

var $6b9e03c96368022e$var$WorkspaceArea = /*#__PURE__*/ (0, $arQ7u.lazy)(function() {
    return (parcelRequire("jQ5Ec"));
});
var $6b9e03c96368022e$export$86fbec116b87613f = /*#__PURE__*/ function(_Component) {
    $6b9e03c96368022e$var$_inherits(App, _Component);
    var _super = $6b9e03c96368022e$var$_createSuper(App);
    function App() {
        $6b9e03c96368022e$var$_classCallCheck(this, App);
        return _super.apply(this, arguments);
    }
    $6b9e03c96368022e$var$_createClass(App, [
        {
            key: "render",
            value: /**
     * render
     * @return {String} - HTML markup for the component
     */ function render() {
                var _this$props = this.props, dndManager = _this$props.dndManager, plugins = _this$props.plugins;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $e79aa799f7ed2e4a$export$2e2bcd8739ae039), {
                    plugins: plugins
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $924e0df07e5aecfc$export$2e2bcd8739ae039), {
                    dndManager: dndManager
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $arQ7u.Suspense), {
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", null)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement($6b9e03c96368022e$var$WorkspaceArea, null))));
            }
        }
    ]);
    return App;
}((0, $arQ7u.Component));
$6b9e03c96368022e$export$86fbec116b87613f.defaultProps = {
    dndManager: undefined,
    plugins: []
};
var $6b9e03c96368022e$export$2e2bcd8739ae039 = $6b9e03c96368022e$export$86fbec116b87613f;



var $iyYa0 = parcelRequire("iyYa0");
var $74e5e0c2d276174d$exports = {};

var $hyuxh = parcelRequire("hyuxh");

var $eDRhj = parcelRequire("eDRhj");

var $cLyAa = parcelRequire("cLyAa");
/** `Object#toString` result references. */ var $74e5e0c2d276174d$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $74e5e0c2d276174d$var$isString(value) {
    return typeof value == "string" || !$eDRhj(value) && $cLyAa(value) && $hyuxh(value) == $74e5e0c2d276174d$var$stringTag;
}
$74e5e0c2d276174d$exports = $74e5e0c2d276174d$var$isString;



var $6VfQj = parcelRequire("6VfQj");

var $4n8SM = parcelRequire("4n8SM");

var $6Sqac = parcelRequire("6Sqac");
var $4056e3d707262023$exports = {};
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */ function $4056e3d707262023$var$isNull(value) {
    return value === null;
}
$4056e3d707262023$exports = $4056e3d707262023$var$isNull;



var $6ey0B = parcelRequire("6ey0B");
var $11d200af01bdafd7$export$49497c49246d5b6a = function validatePlugin(plugin) {
    return [
        $11d200af01bdafd7$var$checkPlugin,
        $11d200af01bdafd7$var$checkName,
        $11d200af01bdafd7$var$checkTarget,
        $11d200af01bdafd7$var$checkMode,
        $11d200af01bdafd7$var$checkMapStateToProps,
        $11d200af01bdafd7$var$checkMapDispatchToProps,
        $11d200af01bdafd7$var$checkReducers
    ].every(function(check) {
        return check(plugin);
    });
};
/** */ var $11d200af01bdafd7$var$checkPlugin = function checkPlugin(plugin) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6Sqac)))(plugin);
};
/** */ var $11d200af01bdafd7$var$checkName = function checkName(plugin) {
    var name = plugin.name;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6VfQj)))(name) || (0, (/*@__PURE__*/$parcel$interopDefault($74e5e0c2d276174d$exports)))(name);
};
/** */ var $11d200af01bdafd7$var$checkTarget = function checkTarget(plugin) {
    var mode = plugin.mode, target = plugin.target;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6VfQj)))(mode)) return (0, (/*@__PURE__*/$parcel$interopDefault($6VfQj)))(target);
    return (0, (/*@__PURE__*/$parcel$interopDefault($74e5e0c2d276174d$exports)))(target);
};
/** */ var $11d200af01bdafd7$var$checkMode = function checkMode(plugin) {
    var mode = plugin.mode;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6VfQj)))(mode) || [
        "add",
        "wrap"
    ].some(function(s) {
        return s === mode;
    });
};
/** */ var $11d200af01bdafd7$var$checkMapStateToProps = function checkMapStateToProps(plugin) {
    var mapStateToProps = plugin.mapStateToProps;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6VfQj)))(mapStateToProps) || (0, (/*@__PURE__*/$parcel$interopDefault($4056e3d707262023$exports)))(mapStateToProps) || (0, (/*@__PURE__*/$parcel$interopDefault($4n8SM)))(mapStateToProps);
};
/** */ var $11d200af01bdafd7$var$checkMapDispatchToProps = function checkMapDispatchToProps(plugin) {
    var mapDispatchToProps = plugin.mapDispatchToProps;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6VfQj)))(mapDispatchToProps) || (0, (/*@__PURE__*/$parcel$interopDefault($4056e3d707262023$exports)))(mapDispatchToProps) || (0, (/*@__PURE__*/$parcel$interopDefault($4n8SM)))(mapDispatchToProps) || (0, (/*@__PURE__*/$parcel$interopDefault($6Sqac)))(mapDispatchToProps);
};
/** */ var $11d200af01bdafd7$var$checkReducers = function checkReducers(plugin) {
    var reducers = plugin.reducers;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6VfQj)))(reducers) || (0, (/*@__PURE__*/$parcel$interopDefault($6Sqac)))(reducers) && (0, (/*@__PURE__*/$parcel$interopDefault($6ey0B)))(reducers).every((0, (/*@__PURE__*/$parcel$interopDefault($4n8SM))));
};


function $a964f97edaaf1ca3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a964f97edaaf1ca3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a964f97edaaf1ca3$var$ownKeys(Object(source), true).forEach(function(key) {
            $a964f97edaaf1ca3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a964f97edaaf1ca3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a964f97edaaf1ca3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a964f97edaaf1ca3$var$_toConsumableArray(arr) {
    return $a964f97edaaf1ca3$var$_arrayWithoutHoles(arr) || $a964f97edaaf1ca3$var$_iterableToArray(arr) || $a964f97edaaf1ca3$var$_unsupportedIterableToArray(arr) || $a964f97edaaf1ca3$var$_nonIterableSpread();
}
function $a964f97edaaf1ca3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a964f97edaaf1ca3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a964f97edaaf1ca3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a964f97edaaf1ca3$var$_arrayLikeToArray(o, minLen);
}
function $a964f97edaaf1ca3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a964f97edaaf1ca3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a964f97edaaf1ca3$var$_arrayLikeToArray(arr);
}
function $a964f97edaaf1ca3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a964f97edaaf1ca3$export$6e11632ede5393c1(plugins) {
    var _splitPluginsByValida = $a964f97edaaf1ca3$var$splitPluginsByValidation(plugins), validPlugins = _splitPluginsByValida.validPlugins, invalidPlugins = _splitPluginsByValida.invalidPlugins;
    $a964f97edaaf1ca3$var$logInvalidPlugins(invalidPlugins);
    return validPlugins;
}
/** */ function $a964f97edaaf1ca3$var$splitPluginsByValidation(plugins) {
    var invalidPlugins = [];
    var validPlugins = [];
    plugins.forEach(function(plugin) {
        if (Array.isArray(plugin)) {
            var allValid = plugin.every(function(p) {
                return (0, $11d200af01bdafd7$export$49497c49246d5b6a)(p);
            });
            allValid ? validPlugins.push.apply(validPlugins, $a964f97edaaf1ca3$var$_toConsumableArray(plugin)) : invalidPlugins.push.apply(invalidPlugins, $a964f97edaaf1ca3$var$_toConsumableArray(plugin));
        } else (0, $11d200af01bdafd7$export$49497c49246d5b6a)(plugin) ? validPlugins.push(plugin) : invalidPlugins.push(plugin);
    });
    return {
        invalidPlugins: invalidPlugins,
        validPlugins: validPlugins
    };
}
/** */ function $a964f97edaaf1ca3$var$logInvalidPlugins(plugins) {
    plugins.forEach(function(plugin) {
        return console.log("Mirador: Plugin ".concat(plugin.name, " is not valid and was rejected."));
    });
}
function $a964f97edaaf1ca3$export$233f394bcea1bb1b(plugins) {
    return plugins && plugins.reduce(function(acc, plugin) {
        return $a964f97edaaf1ca3$var$_objectSpread($a964f97edaaf1ca3$var$_objectSpread({}, acc), plugin.reducers);
    }, {});
}
function $a964f97edaaf1ca3$export$5b091520b72492a8(plugins) {
    return plugins && plugins.reduce(function(acc, plugin) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($iyYa0)))(acc, plugin.config || {});
    }, {});
}
function $a964f97edaaf1ca3$export$2ab9ab1ccd196479(plugins) {
    return plugins && plugins.filter(function(plugin) {
        return plugin.saga;
    }).map(function(plugin) {
        return plugin.saga;
    });
}



var $iyYa0 = parcelRequire("iyYa0");
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $c945bc57412f63c2$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $c945bc57412f63c2$var$thunk = $c945bc57412f63c2$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$c945bc57412f63c2$var$thunk.withExtraArgument = $c945bc57412f63c2$var$createThunkMiddleware;
var $c945bc57412f63c2$export$2e2bcd8739ae039 = $c945bc57412f63c2$var$thunk;


var $dc199d1abd145370$var$createSymbol = function createSymbol(name) {
    return "@@redux-saga/" + name;
};
var $dc199d1abd145370$export$2b10f4b30fb65583 = /*#__PURE__*/ $dc199d1abd145370$var$createSymbol("CANCEL_PROMISE");
var $dc199d1abd145370$export$3281fbb3edc9dee3 = /*#__PURE__*/ $dc199d1abd145370$var$createSymbol("CHANNEL_END");
var $dc199d1abd145370$export$8f8422ac5947a789 = /*#__PURE__*/ $dc199d1abd145370$var$createSymbol("IO");
var $dc199d1abd145370$export$5a1a83be8f503735 = /*#__PURE__*/ $dc199d1abd145370$var$createSymbol("MATCH");
var $dc199d1abd145370$export$9074c4e62c4e51bb = /*#__PURE__*/ $dc199d1abd145370$var$createSymbol("MULTICAST");
var $dc199d1abd145370$export$7d963e45ecdffba1 = /*#__PURE__*/ $dc199d1abd145370$var$createSymbol("SAGA_ACTION");
var $dc199d1abd145370$export$3f4d38f8b89bfda7 = /*#__PURE__*/ $dc199d1abd145370$var$createSymbol("SELF_CANCELLATION");
var $dc199d1abd145370$export$9355e489ad16f98e = /*#__PURE__*/ $dc199d1abd145370$var$createSymbol("TASK");
var $dc199d1abd145370$export$a47f788ef0b36709 = /*#__PURE__*/ $dc199d1abd145370$var$createSymbol("TASK_CANCEL");
var $dc199d1abd145370$export$d966e43d90bf4c05 = /*#__PURE__*/ $dc199d1abd145370$var$createSymbol("TERMINATE");
var $dc199d1abd145370$export$bdae2c4f4f03305d = /*#__PURE__*/ $dc199d1abd145370$var$createSymbol("LOCATION");



var $abElG = parcelRequire("abElG");

var $fJZol = parcelRequire("fJZol");

var $5c8ed2ed0ad83760$export$c7b6444af1f098df = function undef(v) {
    return v === null || v === undefined;
};
var $5c8ed2ed0ad83760$export$1352885233577768 = function notUndef(v) {
    return v !== null && v !== undefined;
};
var $5c8ed2ed0ad83760$export$86951950244e2001 = function func(f) {
    return typeof f === "function";
};
var $5c8ed2ed0ad83760$export$98e628dec113755e = function number(n) {
    return typeof n === "number";
};
var $5c8ed2ed0ad83760$export$22b082955e083ec3 = function string(s) {
    return typeof s === "string";
};
var $5c8ed2ed0ad83760$export$2f23118c22fb2630 = Array.isArray;
var $5c8ed2ed0ad83760$export$be5493f9613cbbe = function object(obj) {
    return obj && !$5c8ed2ed0ad83760$export$2f23118c22fb2630(obj) && typeof obj === "object";
};
var $5c8ed2ed0ad83760$export$c957ef27a0ebfd4 = function promise(p) {
    return p && $5c8ed2ed0ad83760$export$86951950244e2001(p.then);
};
var $5c8ed2ed0ad83760$export$6f58e2338da23f4d = function iterator(it) {
    return it && $5c8ed2ed0ad83760$export$86951950244e2001(it.next) && $5c8ed2ed0ad83760$export$86951950244e2001(it.throw);
};
var $5c8ed2ed0ad83760$export$8e2ddbe84aff549 = function iterable(it) {
    return it && $5c8ed2ed0ad83760$export$86951950244e2001(Symbol) ? $5c8ed2ed0ad83760$export$86951950244e2001(it[Symbol.iterator]) : $5c8ed2ed0ad83760$export$2f23118c22fb2630(it);
};
var $5c8ed2ed0ad83760$export$94e939b87ca64fb4 = function task(t) {
    return t && t[0, $dc199d1abd145370$export$9355e489ad16f98e];
};
var $5c8ed2ed0ad83760$export$2ce8c19c8dfba715 = function sagaAction(a) {
    return Boolean(a && a[0, $dc199d1abd145370$export$7d963e45ecdffba1]);
};
var $5c8ed2ed0ad83760$export$5ab46cbf6120b33a = function observable(ob) {
    return ob && $5c8ed2ed0ad83760$export$86951950244e2001(ob.subscribe);
};
var $5c8ed2ed0ad83760$export$ab1029bcae9ddb4a = function buffer(buf) {
    return buf && $5c8ed2ed0ad83760$export$86951950244e2001(buf.isEmpty) && $5c8ed2ed0ad83760$export$86951950244e2001(buf.take) && $5c8ed2ed0ad83760$export$86951950244e2001(buf.put);
};
var $5c8ed2ed0ad83760$export$24f82734ea047e6f = function pattern(pat) {
    return pat && ($5c8ed2ed0ad83760$export$22b082955e083ec3(pat) || $5c8ed2ed0ad83760$export$8f701197936bc2a6(pat) || $5c8ed2ed0ad83760$export$86951950244e2001(pat) || $5c8ed2ed0ad83760$export$2f23118c22fb2630(pat) && pat.every(pattern));
};
var $5c8ed2ed0ad83760$export$1f95fbd68d964d36 = function channel(ch) {
    return ch && $5c8ed2ed0ad83760$export$86951950244e2001(ch.take) && $5c8ed2ed0ad83760$export$86951950244e2001(ch.close);
};
var $5c8ed2ed0ad83760$export$32b5e46230afa379 = function stringableFunc(f) {
    return $5c8ed2ed0ad83760$export$86951950244e2001(f) && f.hasOwnProperty("toString");
};
var $5c8ed2ed0ad83760$export$8f701197936bc2a6 = function symbol(sym) {
    return Boolean(sym) && typeof Symbol === "function" && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var $5c8ed2ed0ad83760$export$1364843af8d5a963 = function multicast(ch) {
    return $5c8ed2ed0ad83760$export$1f95fbd68d964d36(ch) && ch[0, $dc199d1abd145370$export$9074c4e62c4e51bb];
};
var $5c8ed2ed0ad83760$export$dc573d8a6576cdb3 = function effect(eff) {
    return eff && eff[0, $dc199d1abd145370$export$8f8422ac5947a789];
};




var $abElG = parcelRequire("abElG");


var $4037b7a34192b7be$var$MAX_SIGNED_INT = 2147483647;
function $4037b7a34192b7be$var$delayP(ms, val) {
    if (val === void 0) val = true;
    var timeoutId;
    var promise = new Promise(function(resolve) {
        timeoutId = setTimeout(resolve, Math.min($4037b7a34192b7be$var$MAX_SIGNED_INT, ms), val);
    });
    promise[0, $dc199d1abd145370$export$2b10f4b30fb65583] = function() {
        clearTimeout(timeoutId);
    };
    return promise;
}
var $4037b7a34192b7be$export$2e2bcd8739ae039 = $4037b7a34192b7be$var$delayP;


var $95e707af523f0ac0$var$konst = function konst(v) {
    return function() {
        return v;
    };
};
var $95e707af523f0ac0$export$342063e11d6c3cad = /*#__PURE__*/ $95e707af523f0ac0$var$konst(true);
var $95e707af523f0ac0$export$625550452a3fa3ec = function noop() {};
var $95e707af523f0ac0$export$7f8ddf7c7c20b3cd = function identity(v) {
    return v;
};
var $95e707af523f0ac0$var$hasSymbol = typeof Symbol === "function";
var $95e707af523f0ac0$export$d141bba7fdc215a3 = $95e707af523f0ac0$var$hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : "@@asyncIterator";
function $95e707af523f0ac0$export$db3b6bfb95261072(value, predicate, error) {
    if (!predicate(value)) throw new Error(error);
}
var $95e707af523f0ac0$export$ffb5f4729a158638 = function assignWithSymbols(target, source) {
    (0, $abElG.default)(target, source);
    if (Object.getOwnPropertySymbols) Object.getOwnPropertySymbols(source).forEach(function(s) {
        target[s] = source[s];
    });
};
var $95e707af523f0ac0$export$3b14a55fb2447963 = function flatMap(mapper, arr) {
    var _ref;
    return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function $95e707af523f0ac0$export$43caf9889c228507(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}
function $95e707af523f0ac0$export$ae1af26003f05816(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        fn();
    };
}
var $95e707af523f0ac0$var$kThrow = function kThrow(err) {
    throw err;
};
var $95e707af523f0ac0$var$kReturn = function kReturn(value) {
    return {
        value: value,
        done: true
    };
};
function $95e707af523f0ac0$export$9e5f44173e64f162(next, thro, name) {
    if (thro === void 0) thro = $95e707af523f0ac0$var$kThrow;
    if (name === void 0) name = "iterator";
    var iterator = {
        meta: {
            name: name
        },
        next: next,
        throw: thro,
        return: $95e707af523f0ac0$var$kReturn,
        isSagaIterator: true
    };
    if (typeof Symbol !== "undefined") iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $95e707af523f0ac0$export$96f57966bedc81b4(error, _ref2) {
    var sagaStack = _ref2.sagaStack;
    /*eslint-disable no-console*/ console.error(error);
    console.error(sagaStack);
}
var $95e707af523f0ac0$export$23f2a1d2818174ef = function internalErr(err) {
    return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var $95e707af523f0ac0$export$efccba1c4a2ef57b = function createSetContextWarning(ctx, props) {
    return (ctx ? ctx + "." : "") + "setContext(props): argument " + props + " is not a plain object";
};
var $95e707af523f0ac0$var$FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array
var $95e707af523f0ac0$export$953cecd6e717a553 = function createEmptyArray(n) {
    return Array.apply(null, new Array(n));
};
var $95e707af523f0ac0$export$a9c23c6ac3fc3eca = function wrapSagaDispatch(dispatch) {
    return function(action) {
        return dispatch(Object.defineProperty(action, (0, $dc199d1abd145370$export$7d963e45ecdffba1), {
            value: true
        }));
    };
};
var $95e707af523f0ac0$export$df995fae86a55f06 = function shouldTerminate(res) {
    return res === (0, $dc199d1abd145370$export$d966e43d90bf4c05);
};
var $95e707af523f0ac0$export$4a5767248b18ef41 = function shouldCancel(res) {
    return res === (0, $dc199d1abd145370$export$a47f788ef0b36709);
};
var $95e707af523f0ac0$export$2408f22a0fab9ae5 = function shouldComplete(res) {
    return $95e707af523f0ac0$export$df995fae86a55f06(res) || $95e707af523f0ac0$export$4a5767248b18ef41(res);
};
function $95e707af523f0ac0$export$882b5998b3b9117c(shape, parentCallback) {
    var keys = Object.keys(shape);
    var totalCount = keys.length;
    var completedCount = 0;
    var completed;
    var results = (0, $5c8ed2ed0ad83760$export$2f23118c22fb2630)(shape) ? $95e707af523f0ac0$export$953cecd6e717a553(totalCount) : {};
    var childCallbacks = {};
    function checkEnd() {
        if (completedCount === totalCount) {
            completed = true;
            parentCallback(results);
        }
    }
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || $95e707af523f0ac0$export$2408f22a0fab9ae5(res)) {
                parentCallback.cancel();
                parentCallback(res, isErr);
            } else {
                results[key] = res;
                completedCount++;
                checkEnd();
            }
        };
        chCbAtKey.cancel = $95e707af523f0ac0$export$625550452a3fa3ec;
        childCallbacks[key] = chCbAtKey;
    });
    parentCallback.cancel = function() {
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCallbacks[key].cancel();
            });
        }
    };
    return childCallbacks;
}
function $95e707af523f0ac0$export$35e795649ee09318(fn) {
    return {
        name: fn.name || "anonymous",
        location: $95e707af523f0ac0$export$90a7f3efeed30595(fn)
    };
}
function $95e707af523f0ac0$export$90a7f3efeed30595(instrumented) {
    return instrumented[0, $dc199d1abd145370$export$bdae2c4f4f03305d];
}
function $95e707af523f0ac0$export$ef35774e6d314e91() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
var $95e707af523f0ac0$var$BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var $95e707af523f0ac0$var$ON_OVERFLOW_THROW = 1;
var $95e707af523f0ac0$var$ON_OVERFLOW_DROP = 2;
var $95e707af523f0ac0$var$ON_OVERFLOW_SLIDE = 3;
var $95e707af523f0ac0$var$ON_OVERFLOW_EXPAND = 4;
var $95e707af523f0ac0$var$zeroBuffer = {
    isEmpty: $95e707af523f0ac0$export$342063e11d6c3cad,
    put: $95e707af523f0ac0$export$625550452a3fa3ec,
    take: $95e707af523f0ac0$export$625550452a3fa3ec
};
function $95e707af523f0ac0$var$ringBuffer(limit, overflowAction) {
    if (limit === void 0) limit = 10;
    var arr = new Array(limit);
    var length = 0;
    var pushIndex = 0;
    var popIndex = 0;
    var push = function push(it) {
        arr[pushIndex] = it;
        pushIndex = (pushIndex + 1) % limit;
        length++;
    };
    var take = function take() {
        if (length != 0) {
            var it = arr[popIndex];
            arr[popIndex] = null;
            length--;
            popIndex = (popIndex + 1) % limit;
            return it;
        }
    };
    var flush = function flush() {
        var items = [];
        while(length)items.push(take());
        return items;
    };
    return {
        isEmpty: function isEmpty() {
            return length == 0;
        },
        put: function put(it) {
            if (length < limit) push(it);
            else {
                var doubledLimit;
                switch(overflowAction){
                    case $95e707af523f0ac0$var$ON_OVERFLOW_THROW:
                        throw new Error($95e707af523f0ac0$var$BUFFER_OVERFLOW);
                    case $95e707af523f0ac0$var$ON_OVERFLOW_SLIDE:
                        arr[pushIndex] = it;
                        pushIndex = (pushIndex + 1) % limit;
                        popIndex = pushIndex;
                        break;
                    case $95e707af523f0ac0$var$ON_OVERFLOW_EXPAND:
                        doubledLimit = 2 * limit;
                        arr = flush();
                        length = arr.length;
                        pushIndex = arr.length;
                        popIndex = 0;
                        arr.length = doubledLimit;
                        limit = doubledLimit;
                        push(it);
                        break;
                    default:
                }
            }
        },
        take: take,
        flush: flush
    };
}
var $95e707af523f0ac0$export$7ccc53e8f1e7dfc5 = function none() {
    return $95e707af523f0ac0$var$zeroBuffer;
};
var $95e707af523f0ac0$var$fixed = function fixed(limit) {
    return $95e707af523f0ac0$var$ringBuffer(limit, $95e707af523f0ac0$var$ON_OVERFLOW_THROW);
};
var $95e707af523f0ac0$var$dropping = function dropping(limit) {
    return $95e707af523f0ac0$var$ringBuffer(limit, $95e707af523f0ac0$var$ON_OVERFLOW_DROP);
};
var $95e707af523f0ac0$export$e7c866399fa523f5 = function sliding(limit) {
    return $95e707af523f0ac0$var$ringBuffer(limit, $95e707af523f0ac0$var$ON_OVERFLOW_SLIDE);
};
var $95e707af523f0ac0$export$f1e1789686576879 = function expanding(initialSize) {
    return $95e707af523f0ac0$var$ringBuffer(initialSize, $95e707af523f0ac0$var$ON_OVERFLOW_EXPAND);
};
var $95e707af523f0ac0$export$9bb611d729802a56 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    none: $95e707af523f0ac0$export$7ccc53e8f1e7dfc5,
    fixed: $95e707af523f0ac0$var$fixed,
    dropping: $95e707af523f0ac0$var$dropping,
    sliding: $95e707af523f0ac0$export$e7c866399fa523f5,
    expanding: $95e707af523f0ac0$export$f1e1789686576879
});
var $95e707af523f0ac0$export$971d5caa766a69d7 = "TAKE";
var $95e707af523f0ac0$export$56c0d5a1e737357d = "PUT";
var $95e707af523f0ac0$export$ebd11618f299a286 = "ALL";
var $95e707af523f0ac0$export$db202ddc8be9136 = "RACE";
var $95e707af523f0ac0$export$e7094788287c5e9b = "CALL";
var $95e707af523f0ac0$export$407448d2b89b1813 = "CPS";
var $95e707af523f0ac0$export$d66501df72047452 = "FORK";
var $95e707af523f0ac0$export$b4171a6734a65d42 = "JOIN";
var $95e707af523f0ac0$export$8b22cf2602fb60ce = "CANCEL";
var $95e707af523f0ac0$export$25ce5a424b770e84 = "SELECT";
var $95e707af523f0ac0$export$4368d992c4eafac0 = "ACTION_CHANNEL";
var $95e707af523f0ac0$export$2d1720544b23b823 = "CANCELLED";
var $95e707af523f0ac0$export$39b482c5e57630a8 = "FLUSH";
var $95e707af523f0ac0$export$2329c99376c9d0a4 = "GET_CONTEXT";
var $95e707af523f0ac0$export$dda1d9f60106f0e9 = "SET_CONTEXT";
var $95e707af523f0ac0$export$78acf4525d8a74c4 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TAKE: $95e707af523f0ac0$export$971d5caa766a69d7,
    PUT: $95e707af523f0ac0$export$56c0d5a1e737357d,
    ALL: $95e707af523f0ac0$export$ebd11618f299a286,
    RACE: $95e707af523f0ac0$export$db202ddc8be9136,
    CALL: $95e707af523f0ac0$export$e7094788287c5e9b,
    CPS: $95e707af523f0ac0$export$407448d2b89b1813,
    FORK: $95e707af523f0ac0$export$d66501df72047452,
    JOIN: $95e707af523f0ac0$export$b4171a6734a65d42,
    CANCEL: $95e707af523f0ac0$export$8b22cf2602fb60ce,
    SELECT: $95e707af523f0ac0$export$25ce5a424b770e84,
    ACTION_CHANNEL: $95e707af523f0ac0$export$4368d992c4eafac0,
    CANCELLED: $95e707af523f0ac0$export$2d1720544b23b823,
    FLUSH: $95e707af523f0ac0$export$39b482c5e57630a8,
    GET_CONTEXT: $95e707af523f0ac0$export$2329c99376c9d0a4,
    SET_CONTEXT: $95e707af523f0ac0$export$dda1d9f60106f0e9
});
var $95e707af523f0ac0$var$TEST_HINT = "\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)";
var $95e707af523f0ac0$var$makeEffect = function makeEffect(type, payload) {
    var _ref;
    return _ref = {}, _ref[0, $dc199d1abd145370$export$8f8422ac5947a789] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};
var $95e707af523f0ac0$var$isForkEffect = function isForkEffect(eff) {
    return (0, $5c8ed2ed0ad83760$export$dc573d8a6576cdb3)(eff) && eff.type === $95e707af523f0ac0$export$d66501df72047452;
};
var $95e707af523f0ac0$export$3466f893ebf79586 = function detach(eff) {
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$d66501df72047452, (0, $abElG.default)({}, eff.payload, {
        detached: true
    }));
};
function $95e707af523f0ac0$export$61196ced6d74a310(patternOrChannel, multicastPattern) {
    if (patternOrChannel === void 0) patternOrChannel = "*";
    if ((0, $5c8ed2ed0ad83760$export$24f82734ea047e6f)(patternOrChannel)) {
        if ((0, $5c8ed2ed0ad83760$export$1352885233577768)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
        return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$971d5caa766a69d7, {
            pattern: patternOrChannel
        });
    }
    if ((0, $5c8ed2ed0ad83760$export$1364843af8d5a963)(patternOrChannel) && (0, $5c8ed2ed0ad83760$export$1352885233577768)(multicastPattern) && (0, $5c8ed2ed0ad83760$export$24f82734ea047e6f)(multicastPattern)) return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$971d5caa766a69d7, {
        channel: patternOrChannel,
        pattern: multicastPattern
    });
    if ((0, $5c8ed2ed0ad83760$export$1f95fbd68d964d36)(patternOrChannel)) {
        if ((0, $5c8ed2ed0ad83760$export$1352885233577768)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
        return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$971d5caa766a69d7, {
            channel: patternOrChannel
        });
    }
}
var $95e707af523f0ac0$export$8743009a87fcb00f = function takeMaybe() {
    var eff = $95e707af523f0ac0$export$61196ced6d74a310.apply(void 0, arguments);
    eff.payload.maybe = true;
    return eff;
};
function $95e707af523f0ac0$export$dc98b0b04f4c7758(channel$1, action) {
    if ((0, $5c8ed2ed0ad83760$export$c7b6444af1f098df)(action)) {
        action = channel$1; // `undefined` instead of `null` to make default parameter work
        channel$1 = undefined;
    }
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$56c0d5a1e737357d, {
        channel: channel$1,
        action: action
    });
}
var $95e707af523f0ac0$export$71511d61b312f219 = function putResolve() {
    var eff = $95e707af523f0ac0$export$dc98b0b04f4c7758.apply(void 0, arguments);
    eff.payload.resolve = true;
    return eff;
};
function $95e707af523f0ac0$export$3d8c2f653ac9d0b9(effects) {
    var eff = $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$ebd11618f299a286, effects);
    eff.combinator = true;
    return eff;
}
function $95e707af523f0ac0$export$71cec2538cb2c617(effects) {
    var eff = $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$db202ddc8be9136, effects);
    eff.combinator = true;
    return eff;
} // this match getFnCallDescriptor logic
var $95e707af523f0ac0$var$validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
    $95e707af523f0ac0$export$db3b6bfb95261072(fnDescriptor, (0, $5c8ed2ed0ad83760$export$1352885233577768), effectName + ": argument fn is undefined or null");
    if ((0, $5c8ed2ed0ad83760$export$86951950244e2001)(fnDescriptor)) return;
    var context = null;
    var fn;
    if ((0, $5c8ed2ed0ad83760$export$2f23118c22fb2630)(fnDescriptor)) {
        context = fnDescriptor[0];
        fn = fnDescriptor[1];
        $95e707af523f0ac0$export$db3b6bfb95261072(fn, (0, $5c8ed2ed0ad83760$export$1352885233577768), effectName + ": argument of type [context, fn] has undefined or null `fn`");
    } else if ((0, $5c8ed2ed0ad83760$export$be5493f9613cbbe)(fnDescriptor)) {
        context = fnDescriptor.context;
        fn = fnDescriptor.fn;
        $95e707af523f0ac0$export$db3b6bfb95261072(fn, (0, $5c8ed2ed0ad83760$export$1352885233577768), effectName + ": argument of type {context, fn} has undefined or null `fn`");
    } else {
        $95e707af523f0ac0$export$db3b6bfb95261072(fnDescriptor, (0, $5c8ed2ed0ad83760$export$86951950244e2001), effectName + ": argument fn is not function");
        return;
    }
    if (context && (0, $5c8ed2ed0ad83760$export$22b082955e083ec3)(fn)) {
        $95e707af523f0ac0$export$db3b6bfb95261072(context[fn], (0, $5c8ed2ed0ad83760$export$86951950244e2001), effectName + ': context arguments has no such method - "' + fn + '"');
        return;
    }
    $95e707af523f0ac0$export$db3b6bfb95261072(fn, (0, $5c8ed2ed0ad83760$export$86951950244e2001), effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};
function $95e707af523f0ac0$var$getFnCallDescriptor(fnDescriptor, args) {
    var context = null;
    var fn;
    if ((0, $5c8ed2ed0ad83760$export$86951950244e2001)(fnDescriptor)) fn = fnDescriptor;
    else {
        if ((0, $5c8ed2ed0ad83760$export$2f23118c22fb2630)(fnDescriptor)) {
            context = fnDescriptor[0];
            fn = fnDescriptor[1];
        } else {
            context = fnDescriptor.context;
            fn = fnDescriptor.fn;
        }
        if (context && (0, $5c8ed2ed0ad83760$export$22b082955e083ec3)(fn) && (0, $5c8ed2ed0ad83760$export$86951950244e2001)(context[fn])) fn = context[fn];
    }
    return {
        context: context,
        fn: fn,
        args: args
    };
}
var $95e707af523f0ac0$var$isNotDelayEffect = function isNotDelayEffect(fn) {
    return fn !== $95e707af523f0ac0$export$3722cfe417b6ed86;
};
function $95e707af523f0ac0$export$c4ce752e73470fba(fnDescriptor) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var arg0;
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$e7094788287c5e9b, $95e707af523f0ac0$var$getFnCallDescriptor(fnDescriptor, args));
}
function $95e707af523f0ac0$export$34aec0b863436764(context, fn, args) {
    if (args === void 0) args = [];
    var fnDescriptor = [
        context,
        fn
    ];
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$e7094788287c5e9b, $95e707af523f0ac0$var$getFnCallDescriptor([
        context,
        fn
    ], args));
}
function $95e707af523f0ac0$export$3c2fa207a37baaea(fnDescriptor) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$407448d2b89b1813, $95e707af523f0ac0$var$getFnCallDescriptor(fnDescriptor, args));
}
function $95e707af523f0ac0$export$3a1a48c8f6ef640e(fnDescriptor) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$d66501df72047452, $95e707af523f0ac0$var$getFnCallDescriptor(fnDescriptor, args));
}
function $95e707af523f0ac0$export$ce26c07117d59d6a(fnDescriptor) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    return $95e707af523f0ac0$export$3466f893ebf79586($95e707af523f0ac0$export$3a1a48c8f6ef640e.apply(void 0, [
        fnDescriptor
    ].concat(args)));
}
function $95e707af523f0ac0$export$6559d589eb85fbb6(taskOrTasks) {
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$b4171a6734a65d42, taskOrTasks);
}
function $95e707af523f0ac0$export$a07804094c3ecf2d(taskOrTasks) {
    if (taskOrTasks === void 0) taskOrTasks = (0, $dc199d1abd145370$export$3f4d38f8b89bfda7);
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$8b22cf2602fb60ce, taskOrTasks);
}
function $95e707af523f0ac0$export$efca4cbe5dd06740(selector) {
    if (selector === void 0) selector = $95e707af523f0ac0$export$7f8ddf7c7c20b3cd;
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$25ce5a424b770e84, {
        selector: selector,
        args: args
    });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/ function $95e707af523f0ac0$export$3a6d5c9ae78a2c08(pattern$1, buffer$1) {
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$4368d992c4eafac0, {
        pattern: pattern$1,
        buffer: buffer$1
    });
}
function $95e707af523f0ac0$export$a8550f7dbe79f93a() {
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$2d1720544b23b823, {});
}
function $95e707af523f0ac0$export$2e2af4578d910ddf(channel$1) {
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$39b482c5e57630a8, channel$1);
}
function $95e707af523f0ac0$export$a93c5207d687da10(prop) {
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$2329c99376c9d0a4, prop);
}
function $95e707af523f0ac0$export$c3950d9923825c02(props) {
    return $95e707af523f0ac0$var$makeEffect($95e707af523f0ac0$export$dda1d9f60106f0e9, props);
}
var $95e707af523f0ac0$export$3722cfe417b6ed86 = /*#__PURE__*/ $95e707af523f0ac0$export$c4ce752e73470fba.bind(null, (0, $4037b7a34192b7be$export$2e2bcd8739ae039));


function $74d2fdfb17b715c9$var$deferred() {
    var def = {};
    def.promise = new Promise(function(resolve, reject) {
        def.resolve = resolve;
        def.reject = reject;
    });
    return def;
}
function $74d2fdfb17b715c9$export$368f32fb8739d33c(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push($74d2fdfb17b715c9$var$deferred());
    return arr;
}
var $74d2fdfb17b715c9$export$2e2bcd8739ae039 = $74d2fdfb17b715c9$var$deferred;



var $b2e9780ad85835a0$var$queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/ var $b2e9780ad85835a0$var$semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/ function $b2e9780ad85835a0$var$exec(task) {
    try {
        $b2e9780ad85835a0$var$suspend();
        task();
    } finally{
        $b2e9780ad85835a0$var$release();
    }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/ function $b2e9780ad85835a0$var$asap(task) {
    $b2e9780ad85835a0$var$queue.push(task);
    if (!$b2e9780ad85835a0$var$semaphore) {
        $b2e9780ad85835a0$var$suspend();
        $b2e9780ad85835a0$var$flush();
    }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */ function $b2e9780ad85835a0$var$immediately(task) {
    try {
        $b2e9780ad85835a0$var$suspend();
        return task();
    } finally{
        $b2e9780ad85835a0$var$flush();
    }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/ function $b2e9780ad85835a0$var$suspend() {
    $b2e9780ad85835a0$var$semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/ function $b2e9780ad85835a0$var$release() {
    $b2e9780ad85835a0$var$semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/ function $b2e9780ad85835a0$var$flush() {
    $b2e9780ad85835a0$var$release();
    var task;
    while(!$b2e9780ad85835a0$var$semaphore && (task = $b2e9780ad85835a0$var$queue.shift()) !== undefined)$b2e9780ad85835a0$var$exec(task);
}
var $b2e9780ad85835a0$var$array = function array(patterns) {
    return function(input) {
        return patterns.some(function(p) {
            return $b2e9780ad85835a0$var$matcher(p)(input);
        });
    };
};
var $b2e9780ad85835a0$var$predicate = function predicate(_predicate) {
    return function(input) {
        return _predicate(input);
    };
};
var $b2e9780ad85835a0$var$string = function string(pattern) {
    return function(input) {
        return input.type === String(pattern);
    };
};
var $b2e9780ad85835a0$var$symbol = function symbol(pattern) {
    return function(input) {
        return input.type === pattern;
    };
};
var $b2e9780ad85835a0$var$wildcard = function wildcard() {
    return 0, $95e707af523f0ac0$export$342063e11d6c3cad;
};
function $b2e9780ad85835a0$var$matcher(pattern) {
    // prettier-ignore
    var matcherCreator = pattern === "*" ? $b2e9780ad85835a0$var$wildcard : (0, $5c8ed2ed0ad83760$export$22b082955e083ec3)(pattern) ? $b2e9780ad85835a0$var$string : (0, $5c8ed2ed0ad83760$export$2f23118c22fb2630)(pattern) ? $b2e9780ad85835a0$var$array : (0, $5c8ed2ed0ad83760$export$32b5e46230afa379)(pattern) ? $b2e9780ad85835a0$var$string : (0, $5c8ed2ed0ad83760$export$86951950244e2001)(pattern) ? $b2e9780ad85835a0$var$predicate : (0, $5c8ed2ed0ad83760$export$8f701197936bc2a6)(pattern) ? $b2e9780ad85835a0$var$symbol : null;
    if (matcherCreator === null) throw new Error("invalid pattern: " + pattern);
    return matcherCreator(pattern);
}
var $b2e9780ad85835a0$export$32239d68d9c6cb49 = {
    type: (0, $dc199d1abd145370$export$3281fbb3edc9dee3)
};
var $b2e9780ad85835a0$export$42af6f45c6e0d09f = function isEnd(a) {
    return a && a.type === (0, $dc199d1abd145370$export$3281fbb3edc9dee3);
};
var $b2e9780ad85835a0$var$CLOSED_CHANNEL_WITH_TAKERS = "Cannot have a closed channel with pending takers";
var $b2e9780ad85835a0$var$INVALID_BUFFER = "invalid buffer passed to channel factory function";
var $b2e9780ad85835a0$var$UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function $b2e9780ad85835a0$export$1f95fbd68d964d36(buffer$1) {
    if (buffer$1 === void 0) buffer$1 = (0, $95e707af523f0ac0$export$f1e1789686576879)();
    var closed = false;
    var takers = [];
    function checkForbiddenStates() {
        if (closed && takers.length) throw (0, $95e707af523f0ac0$export$23f2a1d2818174ef)($b2e9780ad85835a0$var$CLOSED_CHANNEL_WITH_TAKERS);
        if (takers.length && !buffer$1.isEmpty()) throw (0, $95e707af523f0ac0$export$23f2a1d2818174ef)("Cannot have pending takers with non empty buffer");
    }
    function put(input) {
        if (closed) return;
        if (takers.length === 0) return buffer$1.put(input);
        var cb = takers.shift();
        cb(input);
    }
    function take(cb) {
        if (closed && buffer$1.isEmpty()) cb($b2e9780ad85835a0$export$32239d68d9c6cb49);
        else if (!buffer$1.isEmpty()) cb(buffer$1.take());
        else {
            takers.push(cb);
            cb.cancel = function() {
                (0, $95e707af523f0ac0$export$43caf9889c228507)(takers, cb);
            };
        }
    }
    function flush(cb) {
        if (closed && buffer$1.isEmpty()) {
            cb($b2e9780ad85835a0$export$32239d68d9c6cb49);
            return;
        }
        cb(buffer$1.flush());
    }
    function close() {
        if (closed) return;
        closed = true;
        var arr = takers;
        takers = [];
        for(var i = 0, len = arr.length; i < len; i++){
            var taker = arr[i];
            taker($b2e9780ad85835a0$export$32239d68d9c6cb49);
        }
    }
    return {
        take: take,
        put: put,
        flush: flush,
        close: close
    };
}
function $b2e9780ad85835a0$export$dfc3101b3180c292(subscribe, buffer) {
    if (buffer === void 0) buffer = (0, $95e707af523f0ac0$export$7ccc53e8f1e7dfc5)();
    var closed = false;
    var unsubscribe;
    var chan = $b2e9780ad85835a0$export$1f95fbd68d964d36(buffer);
    var close = function close() {
        if (closed) return;
        closed = true;
        if ((0, $5c8ed2ed0ad83760$export$86951950244e2001)(unsubscribe)) unsubscribe();
        chan.close();
    };
    unsubscribe = subscribe(function(input) {
        if ($b2e9780ad85835a0$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        chan.put(input);
    });
    unsubscribe = (0, $95e707af523f0ac0$export$ae1af26003f05816)(unsubscribe);
    if (closed) unsubscribe();
    return {
        take: chan.take,
        flush: chan.flush,
        close: close
    };
}
function $b2e9780ad85835a0$export$438eddf2fd884f37() {
    var _ref;
    var closed = false;
    var currentTakers = [];
    var nextTakers = currentTakers;
    function checkForbiddenStates() {
        if (closed && nextTakers.length) throw (0, $95e707af523f0ac0$export$23f2a1d2818174ef)($b2e9780ad85835a0$var$CLOSED_CHANNEL_WITH_TAKERS);
    }
    var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
        if (nextTakers !== currentTakers) return;
        nextTakers = currentTakers.slice();
    };
    var close = function close() {
        closed = true;
        var takers = currentTakers = nextTakers;
        nextTakers = [];
        takers.forEach(function(taker) {
            taker($b2e9780ad85835a0$export$32239d68d9c6cb49);
        });
    };
    return _ref = {}, _ref[0, $dc199d1abd145370$export$9074c4e62c4e51bb] = true, _ref.put = function put(input) {
        if (closed) return;
        if ($b2e9780ad85835a0$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        var takers = currentTakers = nextTakers;
        for(var i = 0, len = takers.length; i < len; i++){
            var taker = takers[i];
            if (taker[0, $dc199d1abd145370$export$5a1a83be8f503735](input)) {
                taker.cancel();
                taker(input);
            }
        }
    }, _ref.take = function take(cb, matcher) {
        if (matcher === void 0) matcher = $b2e9780ad85835a0$var$wildcard;
        if (closed) {
            cb($b2e9780ad85835a0$export$32239d68d9c6cb49);
            return;
        }
        cb[0, $dc199d1abd145370$export$5a1a83be8f503735] = matcher;
        ensureCanMutateNextTakers();
        nextTakers.push(cb);
        cb.cancel = (0, $95e707af523f0ac0$export$ae1af26003f05816)(function() {
            ensureCanMutateNextTakers();
            (0, $95e707af523f0ac0$export$43caf9889c228507)(nextTakers, cb);
        });
    }, _ref.close = close, _ref;
}
function $b2e9780ad85835a0$export$e987d166a3a4f3ec() {
    var chan = $b2e9780ad85835a0$export$438eddf2fd884f37();
    var put = chan.put;
    chan.put = function(input) {
        if (input[0, $dc199d1abd145370$export$7d963e45ecdffba1]) {
            put(input);
            return;
        }
        $b2e9780ad85835a0$var$asap(function() {
            put(input);
        });
    };
    return chan;
}
var $b2e9780ad85835a0$var$RUNNING = 0;
var $b2e9780ad85835a0$var$CANCELLED = 1;
var $b2e9780ad85835a0$var$ABORTED = 2;
var $b2e9780ad85835a0$var$DONE = 3;
function $b2e9780ad85835a0$var$resolvePromise(promise, cb) {
    var cancelPromise = promise[0, $dc199d1abd145370$export$2b10f4b30fb65583];
    if ((0, $5c8ed2ed0ad83760$export$86951950244e2001)(cancelPromise)) cb.cancel = cancelPromise;
    promise.then(cb, function(error) {
        cb(error, true);
    });
}
var $b2e9780ad85835a0$var$current = 0;
var $b2e9780ad85835a0$var$nextSagaId = function() {
    return ++$b2e9780ad85835a0$var$current;
};
var $b2e9780ad85835a0$var$_effectRunnerMap;
function $b2e9780ad85835a0$var$getIteratorMetaInfo(iterator, fn) {
    if (iterator.isSagaIterator) return {
        name: iterator.meta.name
    };
    return (0, $95e707af523f0ac0$export$35e795649ee09318)(fn);
}
function $b2e9780ad85835a0$var$createTaskIterator(_ref) {
    var context = _ref.context, fn = _ref.fn, args = _ref.args;
    // catch synchronous failures; see #152 and #441
    try {
        var result = fn.apply(context, args); // i.e. a generator function returns an iterator
        if ((0, $5c8ed2ed0ad83760$export$6f58e2338da23f4d)(result)) return result;
        var resolved = false;
        var next = function next(arg) {
            if (!resolved) {
                resolved = true; // Only promises returned from fork will be interpreted. See #1573
                return {
                    value: result,
                    done: !(0, $5c8ed2ed0ad83760$export$c957ef27a0ebfd4)(result)
                };
            } else return {
                value: arg,
                done: true
            };
        };
        return (0, $95e707af523f0ac0$export$9e5f44173e64f162)(next);
    } catch (err) {
        // do not bubble up synchronous failures for detached forks
        // instead create a failed task. See #152 and #441
        return (0, $95e707af523f0ac0$export$9e5f44173e64f162)(function() {
            throw err;
        });
    }
}
function $b2e9780ad85835a0$var$runPutEffect(env, _ref2, cb) {
    var channel = _ref2.channel, action = _ref2.action, resolve = _ref2.resolve;
    /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/ $b2e9780ad85835a0$var$asap(function() {
        var result;
        try {
            result = (channel ? channel.put : env.dispatch)(action);
        } catch (error) {
            cb(error, true);
            return;
        }
        if (resolve && (0, $5c8ed2ed0ad83760$export$c957ef27a0ebfd4)(result)) $b2e9780ad85835a0$var$resolvePromise(result, cb);
        else cb(result);
    }); // Put effects are non cancellables
}
function $b2e9780ad85835a0$var$runTakeEffect(env, _ref3, cb) {
    var _ref3$channel = _ref3.channel, channel = _ref3$channel === void 0 ? env.channel : _ref3$channel, pattern = _ref3.pattern, maybe = _ref3.maybe;
    var takeCb = function takeCb(input) {
        if (input instanceof Error) {
            cb(input, true);
            return;
        }
        if ($b2e9780ad85835a0$export$42af6f45c6e0d09f(input) && !maybe) {
            cb((0, $dc199d1abd145370$export$d966e43d90bf4c05));
            return;
        }
        cb(input);
    };
    try {
        channel.take(takeCb, (0, $5c8ed2ed0ad83760$export$1352885233577768)(pattern) ? $b2e9780ad85835a0$var$matcher(pattern) : null);
    } catch (err) {
        cb(err, true);
        return;
    }
    cb.cancel = takeCb.cancel;
}
function $b2e9780ad85835a0$var$runCallEffect(env, _ref4, cb, _ref5) {
    var context = _ref4.context, fn = _ref4.fn, args = _ref4.args;
    var task = _ref5.task;
    // catch synchronous failures; see #152
    try {
        var result = fn.apply(context, args);
        if ((0, $5c8ed2ed0ad83760$export$c957ef27a0ebfd4)(result)) {
            $b2e9780ad85835a0$var$resolvePromise(result, cb);
            return;
        }
        if ((0, $5c8ed2ed0ad83760$export$6f58e2338da23f4d)(result)) {
            // resolve iterator
            $b2e9780ad85835a0$var$proc(env, result, task.context, $b2e9780ad85835a0$var$current, (0, $95e707af523f0ac0$export$35e795649ee09318)(fn), /* isRoot */ false, cb);
            return;
        }
        cb(result);
    } catch (error) {
        cb(error, true);
    }
}
function $b2e9780ad85835a0$var$runCPSEffect(env, _ref6, cb) {
    var context = _ref6.context, fn = _ref6.fn, args = _ref6.args;
    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb
    // catch synchronous failures; see #152
    try {
        var cpsCb = function cpsCb(err, res) {
            if ((0, $5c8ed2ed0ad83760$export$c7b6444af1f098df)(err)) cb(res);
            else cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) cb.cancel = cpsCb.cancel;
    } catch (error) {
        cb(error, true);
    }
}
function $b2e9780ad85835a0$var$runForkEffect(env, _ref7, cb, _ref8) {
    var context = _ref7.context, fn = _ref7.fn, args = _ref7.args, detached = _ref7.detached;
    var parent = _ref8.task;
    var taskIterator = $b2e9780ad85835a0$var$createTaskIterator({
        context: context,
        fn: fn,
        args: args
    });
    var meta = $b2e9780ad85835a0$var$getIteratorMetaInfo(taskIterator, fn);
    $b2e9780ad85835a0$var$immediately(function() {
        var child = $b2e9780ad85835a0$var$proc(env, taskIterator, parent.context, $b2e9780ad85835a0$var$current, meta, detached, undefined);
        if (detached) cb(child);
        else {
            if (child.isRunning()) {
                parent.queue.addTask(child);
                cb(child);
            } else if (child.isAborted()) parent.queue.abort(child.error());
            else cb(child);
        }
    }); // Fork effects are non cancellables
}
function $b2e9780ad85835a0$var$runJoinEffect(env, taskOrTasks, cb, _ref9) {
    var task = _ref9.task;
    var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
        if (taskToJoin.isRunning()) {
            var joiner = {
                task: task,
                cb: cb
            };
            cb.cancel = function() {
                if (taskToJoin.isRunning()) (0, $95e707af523f0ac0$export$43caf9889c228507)(taskToJoin.joiners, joiner);
            };
            taskToJoin.joiners.push(joiner);
        } else if (taskToJoin.isAborted()) cb(taskToJoin.error(), true);
        else cb(taskToJoin.result());
    };
    if ((0, $5c8ed2ed0ad83760$export$2f23118c22fb2630)(taskOrTasks)) {
        if (taskOrTasks.length === 0) {
            cb([]);
            return;
        }
        var childCallbacks = (0, $95e707af523f0ac0$export$882b5998b3b9117c)(taskOrTasks, cb);
        taskOrTasks.forEach(function(t, i) {
            joinSingleTask(t, childCallbacks[i]);
        });
    } else joinSingleTask(taskOrTasks, cb);
}
function $b2e9780ad85835a0$var$cancelSingleTask(taskToCancel) {
    if (taskToCancel.isRunning()) taskToCancel.cancel();
}
function $b2e9780ad85835a0$var$runCancelEffect(env, taskOrTasks, cb, _ref10) {
    var task = _ref10.task;
    if (taskOrTasks === (0, $dc199d1abd145370$export$3f4d38f8b89bfda7)) $b2e9780ad85835a0$var$cancelSingleTask(task);
    else if ((0, $5c8ed2ed0ad83760$export$2f23118c22fb2630)(taskOrTasks)) taskOrTasks.forEach($b2e9780ad85835a0$var$cancelSingleTask);
    else $b2e9780ad85835a0$var$cancelSingleTask(taskOrTasks);
    cb(); // cancel effects are non cancellables
}
function $b2e9780ad85835a0$var$runAllEffect(env, effects, cb, _ref11) {
    var digestEffect = _ref11.digestEffect;
    var effectId = $b2e9780ad85835a0$var$current;
    var keys = Object.keys(effects);
    if (keys.length === 0) {
        cb((0, $5c8ed2ed0ad83760$export$2f23118c22fb2630)(effects) ? [] : {});
        return;
    }
    var childCallbacks = (0, $95e707af523f0ac0$export$882b5998b3b9117c)(effects, cb);
    keys.forEach(function(key) {
        digestEffect(effects[key], effectId, childCallbacks[key], key);
    });
}
function $b2e9780ad85835a0$var$runRaceEffect(env, effects, cb, _ref12) {
    var digestEffect = _ref12.digestEffect;
    var effectId = $b2e9780ad85835a0$var$current;
    var keys = Object.keys(effects);
    var response = (0, $5c8ed2ed0ad83760$export$2f23118c22fb2630)(effects) ? (0, $95e707af523f0ac0$export$953cecd6e717a553)(keys.length) : {};
    var childCbs = {};
    var completed = false;
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || (0, $95e707af523f0ac0$export$2408f22a0fab9ae5)(res)) {
                // Race Auto cancellation
                cb.cancel();
                cb(res, isErr);
            } else {
                cb.cancel();
                completed = true;
                response[key] = res;
                cb(response);
            }
        };
        chCbAtKey.cancel = (0, $95e707af523f0ac0$export$625550452a3fa3ec);
        childCbs[key] = chCbAtKey;
    });
    cb.cancel = function() {
        // prevents unnecessary cancellation
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCbs[key].cancel();
            });
        }
    };
    keys.forEach(function(key) {
        if (completed) return;
        digestEffect(effects[key], effectId, childCbs[key], key);
    });
}
function $b2e9780ad85835a0$var$runSelectEffect(env, _ref13, cb) {
    var selector = _ref13.selector, args = _ref13.args;
    try {
        var state = selector.apply(void 0, [
            env.getState()
        ].concat(args));
        cb(state);
    } catch (error) {
        cb(error, true);
    }
}
function $b2e9780ad85835a0$var$runChannelEffect(env, _ref14, cb) {
    var pattern = _ref14.pattern, buffer = _ref14.buffer;
    var chan = $b2e9780ad85835a0$export$1f95fbd68d964d36(buffer);
    var match = $b2e9780ad85835a0$var$matcher(pattern);
    var taker = function taker(action) {
        if (!$b2e9780ad85835a0$export$42af6f45c6e0d09f(action)) env.channel.take(taker, match);
        chan.put(action);
    };
    var close = chan.close;
    chan.close = function() {
        taker.cancel();
        close();
    };
    env.channel.take(taker, match);
    cb(chan);
}
function $b2e9780ad85835a0$var$runCancelledEffect(env, data, cb, _ref15) {
    var task = _ref15.task;
    cb(task.isCancelled());
}
function $b2e9780ad85835a0$var$runFlushEffect(env, channel, cb) {
    channel.flush(cb);
}
function $b2e9780ad85835a0$var$runGetContextEffect(env, prop, cb, _ref16) {
    var task = _ref16.task;
    cb(task.context[prop]);
}
function $b2e9780ad85835a0$var$runSetContextEffect(env, props, cb, _ref17) {
    var task = _ref17.task;
    (0, $95e707af523f0ac0$export$ffb5f4729a158638)(task.context, props);
    cb();
}
var $b2e9780ad85835a0$var$effectRunnerMap = ($b2e9780ad85835a0$var$_effectRunnerMap = {}, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$971d5caa766a69d7] = $b2e9780ad85835a0$var$runTakeEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$56c0d5a1e737357d] = $b2e9780ad85835a0$var$runPutEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$ebd11618f299a286] = $b2e9780ad85835a0$var$runAllEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$db202ddc8be9136] = $b2e9780ad85835a0$var$runRaceEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$e7094788287c5e9b] = $b2e9780ad85835a0$var$runCallEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$407448d2b89b1813] = $b2e9780ad85835a0$var$runCPSEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$d66501df72047452] = $b2e9780ad85835a0$var$runForkEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$b4171a6734a65d42] = $b2e9780ad85835a0$var$runJoinEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$8b22cf2602fb60ce] = $b2e9780ad85835a0$var$runCancelEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$25ce5a424b770e84] = $b2e9780ad85835a0$var$runSelectEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$4368d992c4eafac0] = $b2e9780ad85835a0$var$runChannelEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$2d1720544b23b823] = $b2e9780ad85835a0$var$runCancelledEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$39b482c5e57630a8] = $b2e9780ad85835a0$var$runFlushEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$2329c99376c9d0a4] = $b2e9780ad85835a0$var$runGetContextEffect, $b2e9780ad85835a0$var$_effectRunnerMap[0, $95e707af523f0ac0$export$dda1d9f60106f0e9] = $b2e9780ad85835a0$var$runSetContextEffect, $b2e9780ad85835a0$var$_effectRunnerMap);
/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/ function $b2e9780ad85835a0$var$forkQueue(mainTask, onAbort, cont) {
    var tasks = [];
    var result;
    var completed = false;
    addTask(mainTask);
    var getTasks = function getTasks() {
        return tasks;
    };
    function abort(err) {
        onAbort();
        cancelAll();
        cont(err, true);
    }
    function addTask(task) {
        tasks.push(task);
        task.cont = function(res, isErr) {
            if (completed) return;
            (0, $95e707af523f0ac0$export$43caf9889c228507)(tasks, task);
            task.cont = (0, $95e707af523f0ac0$export$625550452a3fa3ec);
            if (isErr) abort(res);
            else {
                if (task === mainTask) result = res;
                if (!tasks.length) {
                    completed = true;
                    cont(result);
                }
            }
        };
    }
    function cancelAll() {
        if (completed) return;
        completed = true;
        tasks.forEach(function(t) {
            t.cont = (0, $95e707af523f0ac0$export$625550452a3fa3ec);
            t.cancel();
        });
        tasks = [];
    }
    return {
        addTask: addTask,
        cancelAll: cancelAll,
        abort: abort,
        getTasks: getTasks
    };
}
// there can be only a single saga error created at any given moment
function $b2e9780ad85835a0$var$formatLocation(fileName, lineNumber) {
    return fileName + "?" + lineNumber;
}
function $b2e9780ad85835a0$var$effectLocationAsString(effect) {
    var location = (0, $95e707af523f0ac0$export$90a7f3efeed30595)(effect);
    if (location) {
        var code = location.code, fileName = location.fileName, lineNumber = location.lineNumber;
        var source = code + "  " + $b2e9780ad85835a0$var$formatLocation(fileName, lineNumber);
        return source;
    }
    return "";
}
function $b2e9780ad85835a0$var$sagaLocationAsString(sagaMeta) {
    var name = sagaMeta.name, location = sagaMeta.location;
    if (location) return name + "  " + $b2e9780ad85835a0$var$formatLocation(location.fileName, location.lineNumber);
    return name;
}
function $b2e9780ad85835a0$var$cancelledTasksAsString(sagaStack) {
    var cancelledTasks = (0, $95e707af523f0ac0$export$3b14a55fb2447963)(function(i) {
        return i.cancelledTasks;
    }, sagaStack);
    if (!cancelledTasks.length) return "";
    return [
        "Tasks cancelled due to error:"
    ].concat(cancelledTasks).join("\n");
}
var $b2e9780ad85835a0$var$crashedEffect = null;
var $b2e9780ad85835a0$var$sagaStack = [];
var $b2e9780ad85835a0$var$addSagaFrame = function addSagaFrame(frame) {
    frame.crashedEffect = $b2e9780ad85835a0$var$crashedEffect;
    $b2e9780ad85835a0$var$sagaStack.push(frame);
};
var $b2e9780ad85835a0$var$clear = function clear() {
    $b2e9780ad85835a0$var$crashedEffect = null;
    $b2e9780ad85835a0$var$sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now
var $b2e9780ad85835a0$var$setCrashedEffect = function setCrashedEffect(effect) {
    $b2e9780ad85835a0$var$crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/ var $b2e9780ad85835a0$var$toString = function toString() {
    var firstSaga = $b2e9780ad85835a0$var$sagaStack[0], otherSagas = $b2e9780ad85835a0$var$sagaStack.slice(1);
    var crashedEffectLocation = firstSaga.crashedEffect ? $b2e9780ad85835a0$var$effectLocationAsString(firstSaga.crashedEffect) : null;
    var errorMessage = "The above error occurred in task " + $b2e9780ad85835a0$var$sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : "");
    return [
        errorMessage
    ].concat(otherSagas.map(function(s) {
        return "    created by " + $b2e9780ad85835a0$var$sagaLocationAsString(s.meta);
    }), [
        $b2e9780ad85835a0$var$cancelledTasksAsString($b2e9780ad85835a0$var$sagaStack)
    ]).join("\n");
};
function $b2e9780ad85835a0$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
    var _task;
    if (cont === void 0) cont = (0, $95e707af523f0ac0$export$625550452a3fa3ec);
    var status = $b2e9780ad85835a0$var$RUNNING;
    var taskResult;
    var taskError;
    var deferredEnd = null;
    var cancelledDueToErrorTasks = [];
    var context = Object.create(parentContext);
    var queue = $b2e9780ad85835a0$var$forkQueue(mainTask, function onAbort() {
        cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function(t) {
            return t.meta.name;
        }));
    }, end);
    /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/ function cancel() {
        if (status === $b2e9780ad85835a0$var$RUNNING) {
            // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
            // effects in the iterator's finally block will still be executed
            status = $b2e9780ad85835a0$var$CANCELLED;
            queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners
            end((0, $dc199d1abd145370$export$a47f788ef0b36709), false);
        }
    }
    function end(result, isErr) {
        if (!isErr) {
            // The status here may be RUNNING or CANCELLED
            // If the status is CANCELLED, then we do not need to change it here
            if (result === (0, $dc199d1abd145370$export$a47f788ef0b36709)) status = $b2e9780ad85835a0$var$CANCELLED;
            else if (status !== $b2e9780ad85835a0$var$CANCELLED) status = $b2e9780ad85835a0$var$DONE;
            taskResult = result;
            deferredEnd && deferredEnd.resolve(result);
        } else {
            status = $b2e9780ad85835a0$var$ABORTED;
            $b2e9780ad85835a0$var$addSagaFrame({
                meta: meta,
                cancelledTasks: cancelledDueToErrorTasks
            });
            if (task.isRoot) {
                var sagaStack = $b2e9780ad85835a0$var$toString(); // we've dumped the saga stack to string and are passing it to user's code
                // we know that it won't be needed anymore and we need to clear it
                $b2e9780ad85835a0$var$clear();
                env.onError(result, {
                    sagaStack: sagaStack
                });
            }
            taskError = result;
            deferredEnd && deferredEnd.reject(result);
        }
        task.cont(result, isErr);
        task.joiners.forEach(function(joiner) {
            joiner.cb(result, isErr);
        });
        task.joiners = null;
    }
    function setContext(props) {
        (0, $95e707af523f0ac0$export$ffb5f4729a158638)(context, props);
    }
    function toPromise() {
        if (deferredEnd) return deferredEnd.promise;
        deferredEnd = (0, $74d2fdfb17b715c9$export$2e2bcd8739ae039)();
        if (status === $b2e9780ad85835a0$var$ABORTED) deferredEnd.reject(taskError);
        else if (status !== $b2e9780ad85835a0$var$RUNNING) deferredEnd.resolve(taskResult);
        return deferredEnd.promise;
    }
    var task = (_task = {}, _task[0, $dc199d1abd145370$export$9355e489ad16f98e] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
        return status === $b2e9780ad85835a0$var$RUNNING;
    }, _task.isCancelled = function isCancelled() {
        return status === $b2e9780ad85835a0$var$CANCELLED || status === $b2e9780ad85835a0$var$RUNNING && mainTask.status === $b2e9780ad85835a0$var$CANCELLED;
    }, _task.isAborted = function isAborted() {
        return status === $b2e9780ad85835a0$var$ABORTED;
    }, _task.result = function result() {
        return taskResult;
    }, _task.error = function error() {
        return taskError;
    }, _task);
    return task;
}
function $b2e9780ad85835a0$var$proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
    var finalRunEffect = env.finalizeRunEffect(runEffect);
    /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/ next.cancel = (0, $95e707af523f0ac0$export$625550452a3fa3ec);
    /** Creates a main task to track the main flow */ var mainTask = {
        meta: meta,
        cancel: cancelMain,
        status: $b2e9780ad85835a0$var$RUNNING
    };
    /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/ var task = $b2e9780ad85835a0$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
    var executingContext = {
        task: task,
        digestEffect: digestEffect
    };
    /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/ function cancelMain() {
        if (mainTask.status === $b2e9780ad85835a0$var$RUNNING) {
            mainTask.status = $b2e9780ad85835a0$var$CANCELLED;
            next((0, $dc199d1abd145370$export$a47f788ef0b36709));
        }
    }
    /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/ if (cont) cont.cancel = task.cancel;
     // kicks up the generator
    next(); // then return the task descriptor to the caller
    return task;
    /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */ function next(arg, isErr) {
        try {
            var result;
            if (isErr) {
                result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values
                $b2e9780ad85835a0$var$clear();
            } else if ((0, $95e707af523f0ac0$export$4a5767248b18ef41)(arg)) {
                /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/ mainTask.status = $b2e9780ad85835a0$var$CANCELLED;
                /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/ next.cancel();
                /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/ result = (0, $5c8ed2ed0ad83760$export$86951950244e2001)(iterator$1.return) ? iterator$1.return((0, $dc199d1abd145370$export$a47f788ef0b36709)) : {
                    done: true,
                    value: (0, $dc199d1abd145370$export$a47f788ef0b36709)
                };
            } else if ((0, $95e707af523f0ac0$export$df995fae86a55f06)(arg)) // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
            result = (0, $5c8ed2ed0ad83760$export$86951950244e2001)(iterator$1.return) ? iterator$1.return() : {
                done: true
            };
            else result = iterator$1.next(arg);
            if (!result.done) digestEffect(result.value, parentEffectId, next);
            else {
                /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/ if (mainTask.status !== $b2e9780ad85835a0$var$CANCELLED) mainTask.status = $b2e9780ad85835a0$var$DONE;
                mainTask.cont(result.value);
            }
        } catch (error) {
            if (mainTask.status === $b2e9780ad85835a0$var$CANCELLED) throw error;
            mainTask.status = $b2e9780ad85835a0$var$ABORTED;
            mainTask.cont(error, true);
        }
    }
    function runEffect(effect, effectId, currCb) {
        /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/ if ((0, $5c8ed2ed0ad83760$export$c957ef27a0ebfd4)(effect)) $b2e9780ad85835a0$var$resolvePromise(effect, currCb);
        else if ((0, $5c8ed2ed0ad83760$export$6f58e2338da23f4d)(effect)) // resolve iterator
        $b2e9780ad85835a0$var$proc(env, effect, task.context, effectId, meta, /* isRoot */ false, currCb);
        else if (effect && effect[0, $dc199d1abd145370$export$8f8422ac5947a789]) {
            var effectRunner = $b2e9780ad85835a0$var$effectRunnerMap[effect.type];
            effectRunner(env, effect.payload, currCb, executingContext);
        } else // anything else returned as is
        currCb(effect);
    }
    function digestEffect(effect, parentEffectId, cb, label) {
        if (label === void 0) label = "";
        var effectId = $b2e9780ad85835a0$var$nextSagaId();
        env.sagaMonitor && env.sagaMonitor.effectTriggered({
            effectId: effectId,
            parentEffectId: parentEffectId,
            label: label,
            effect: effect
        });
        /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/ var effectSettled; // Completion callback passed to the appropriate effect runner
        function currCb(res, isErr) {
            if (effectSettled) return;
            effectSettled = true;
            cb.cancel = (0, $95e707af523f0ac0$export$625550452a3fa3ec); // defensive measure
            if (env.sagaMonitor) {
                if (isErr) env.sagaMonitor.effectRejected(effectId, res);
                else env.sagaMonitor.effectResolved(effectId, res);
            }
            if (isErr) $b2e9780ad85835a0$var$setCrashedEffect(effect);
            cb(res, isErr);
        } // tracks down the current cancel
        currCb.cancel = (0, $95e707af523f0ac0$export$625550452a3fa3ec); // setup cancellation logic on the parent cb
        cb.cancel = function() {
            // prevents cancelling an already completed effect
            if (effectSettled) return;
            effectSettled = true;
            currCb.cancel(); // propagates cancel downward
            currCb.cancel = (0, $95e707af523f0ac0$export$625550452a3fa3ec); // defensive measure
            env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
        };
        finalRunEffect(effect, effectId, currCb);
    }
}
var $b2e9780ad85835a0$var$RUN_SAGA_SIGNATURE = "runSaga(options, saga, ...args)";
var $b2e9780ad85835a0$var$NON_GENERATOR_ERR = $b2e9780ad85835a0$var$RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function $b2e9780ad85835a0$export$3d8d44bf0c43bb61(_ref, saga) {
    var _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $b2e9780ad85835a0$export$e987d166a3a4f3ec() : _ref$channel, dispatch = _ref.dispatch, getState = _ref.getState, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, sagaMonitor = _ref.sagaMonitor, effectMiddlewares = _ref.effectMiddlewares, _ref$onError = _ref.onError, onError = _ref$onError === void 0 ? (0, $95e707af523f0ac0$export$96f57966bedc81b4) : _ref$onError;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var iterator$1 = saga.apply(void 0, args);
    var effectId = $b2e9780ad85835a0$var$nextSagaId();
    if (sagaMonitor) {
        // monitors are expected to have a certain interface, let's fill-in any missing ones
        sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || (0, $95e707af523f0ac0$export$625550452a3fa3ec);
        sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || (0, $95e707af523f0ac0$export$625550452a3fa3ec);
        sagaMonitor.effectResolved = sagaMonitor.effectResolved || (0, $95e707af523f0ac0$export$625550452a3fa3ec);
        sagaMonitor.effectRejected = sagaMonitor.effectRejected || (0, $95e707af523f0ac0$export$625550452a3fa3ec);
        sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || (0, $95e707af523f0ac0$export$625550452a3fa3ec);
        sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || (0, $95e707af523f0ac0$export$625550452a3fa3ec);
        sagaMonitor.rootSagaStarted({
            effectId: effectId,
            saga: saga,
            args: args
        });
    }
    var MIDDLEWARE_TYPE_ERROR;
    var finalizeRunEffect;
    if (effectMiddlewares) {
        var middleware = (0, $95e707af523f0ac0$export$ef35774e6d314e91).apply(void 0, effectMiddlewares);
        finalizeRunEffect = function finalizeRunEffect(runEffect) {
            return function(effect, effectId, currCb) {
                var plainRunEffect = function plainRunEffect(eff) {
                    return runEffect(eff, effectId, currCb);
                };
                return middleware(plainRunEffect)(effect);
            };
        };
    } else finalizeRunEffect = (0, $95e707af523f0ac0$export$7f8ddf7c7c20b3cd);
    var env = {
        channel: channel,
        dispatch: (0, $95e707af523f0ac0$export$a9c23c6ac3fc3eca)(dispatch),
        getState: getState,
        sagaMonitor: sagaMonitor,
        onError: onError,
        finalizeRunEffect: finalizeRunEffect
    };
    return $b2e9780ad85835a0$var$immediately(function() {
        var task = $b2e9780ad85835a0$var$proc(env, iterator$1, context, effectId, (0, $95e707af523f0ac0$export$35e795649ee09318)(saga), /* isRoot */ true, undefined);
        if (sagaMonitor) sagaMonitor.effectResolved(effectId, task);
        return task;
    });
}
function $b2e9780ad85835a0$var$sagaMiddlewareFactory(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $b2e9780ad85835a0$export$e987d166a3a4f3ec() : _ref$channel, sagaMonitor = _ref.sagaMonitor, options = (0, $fJZol.default)(_ref, [
        "context",
        "channel",
        "sagaMonitor"
    ]);
    var boundRunSaga;
    function sagaMiddleware(_ref2) {
        var getState = _ref2.getState, dispatch = _ref2.dispatch;
        boundRunSaga = $b2e9780ad85835a0$export$3d8d44bf0c43bb61.bind(null, (0, $abElG.default)({}, options, {
            context: context,
            channel: channel,
            dispatch: dispatch,
            getState: getState,
            sagaMonitor: sagaMonitor
        }));
        return function(next) {
            return function(action) {
                if (sagaMonitor && sagaMonitor.actionDispatched) sagaMonitor.actionDispatched(action);
                var result = next(action); // hit reducers
                channel.put(action);
                return result;
            };
        };
    }
    sagaMiddleware.run = function() {
        return boundRunSaga.apply(void 0, arguments);
    };
    sagaMiddleware.setContext = function(props) {
        (0, $95e707af523f0ac0$export$ffb5f4729a158638)(context, props);
    };
    return sagaMiddleware;
}
var $b2e9780ad85835a0$export$2e2bcd8739ae039 = $b2e9780ad85835a0$var$sagaMiddlewareFactory;


var $a35165576857b28e$export$2e2bcd8739ae039 = (0, $b2e9780ad85835a0$export$2e2bcd8739ae039);



var $k19ic = parcelRequire("k19ic");
var $3e31eabb6cb5f37a$export$1e511d4a378977f5;
var $3e31eabb6cb5f37a$export$d32324a03b6bde1b;
var $3e31eabb6cb5f37a$export$321b1ffcca858b2b;
"use strict";

var $k19ic = parcelRequire("k19ic");
var $3e31eabb6cb5f37a$require$compose = $k19ic.compose;
$3e31eabb6cb5f37a$export$1e511d4a378977f5 = true;
$3e31eabb6cb5f37a$export$d32324a03b6bde1b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === "object") return $3e31eabb6cb5f37a$require$compose;
    return $3e31eabb6cb5f37a$require$compose.apply(null, arguments);
};
$3e31eabb6cb5f37a$export$321b1ffcca858b2b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};



var $k19ic = parcelRequire("k19ic");
var $a839522a202c9ac5$exports = {};

$parcel$export($a839522a202c9ac5$exports, "accessTokensReducer", function () { return $a839522a202c9ac5$export$d7b758c77335fd33; });
var $cc106592ee5b750f$exports = {};

var $2CmH3 = parcelRequire("2CmH3");

var $isuQz = parcelRequire("isuQz");
var $8515753799c55e47$exports = {};

var $hMUIl = parcelRequire("hMUIl");

var $c98tJ = parcelRequire("c98tJ");
var $786ecefc9d55a964$exports = {};

var $kVyVU = parcelRequire("kVyVU");

var $dDG5q = parcelRequire("dDG5q");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $786ecefc9d55a964$var$parent(object, path) {
    return path.length < 2 ? object : $kVyVU(object, $dDG5q(path, 0, -1));
}
$786ecefc9d55a964$exports = $786ecefc9d55a964$var$parent;



var $fMmVj = parcelRequire("fMmVj");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $8515753799c55e47$var$baseUnset(object, path) {
    path = $hMUIl(path, object);
    object = $786ecefc9d55a964$exports(object, path);
    return object == null || delete object[$fMmVj($c98tJ(path))];
}
$8515753799c55e47$exports = $8515753799c55e47$var$baseUnset;



var $hMUIl = parcelRequire("hMUIl");

var $6tHAe = parcelRequire("6tHAe");
var $468b2b7065e228c7$exports = {};

var $ckn2g = parcelRequire("ckn2g");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $468b2b7065e228c7$var$customOmitClone(value) {
    return $ckn2g(value) ? undefined : value;
}
$468b2b7065e228c7$exports = $468b2b7065e228c7$var$customOmitClone;



var $dAIZI = parcelRequire("dAIZI");

var $9jzwr = parcelRequire("9jzwr");
/** Used to compose bitmasks for cloning. */ var $cc106592ee5b750f$var$CLONE_DEEP_FLAG = 1, $cc106592ee5b750f$var$CLONE_FLAT_FLAG = 2, $cc106592ee5b750f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $cc106592ee5b750f$var$omit = $dAIZI(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $2CmH3(paths, function(path) {
        path = $hMUIl(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $6tHAe(object, $9jzwr(object), result);
    if (isDeep) result = $isuQz(result, $cc106592ee5b750f$var$CLONE_DEEP_FLAG | $cc106592ee5b750f$var$CLONE_FLAT_FLAG | $cc106592ee5b750f$var$CLONE_SYMBOLS_FLAG, $468b2b7065e228c7$exports);
    var length = paths.length;
    while(length--)$8515753799c55e47$exports(result, paths[length]);
    return result;
});
$cc106592ee5b750f$exports = $cc106592ee5b750f$var$omit;



var $7CtTT = parcelRequire("7CtTT");
function $a839522a202c9ac5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a839522a202c9ac5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a839522a202c9ac5$var$ownKeys(Object(source), true).forEach(function(key) {
            $a839522a202c9ac5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a839522a202c9ac5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a839522a202c9ac5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a839522a202c9ac5$export$d7b758c77335fd33() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case (0, $7CtTT.default).RESOLVE_AUTHENTICATION_REQUEST:
            return $a839522a202c9ac5$var$_objectSpread($a839522a202c9ac5$var$_objectSpread({}, state), {}, $a839522a202c9ac5$var$_defineProperty({}, action.tokenServiceId, {
                authId: action.id,
                id: action.tokenServiceId,
                isFetching: true
            }));
        case (0, $7CtTT.default).REQUEST_ACCESS_TOKEN:
            return $a839522a202c9ac5$var$_objectSpread($a839522a202c9ac5$var$_objectSpread({}, state), {}, $a839522a202c9ac5$var$_defineProperty({}, action.serviceId, {
                authId: action.authId,
                id: action.serviceId,
                isFetching: true
            }));
        case (0, $7CtTT.default).RECEIVE_ACCESS_TOKEN:
            return $a839522a202c9ac5$var$_objectSpread($a839522a202c9ac5$var$_objectSpread({}, state), {}, $a839522a202c9ac5$var$_defineProperty({}, action.serviceId, $a839522a202c9ac5$var$_objectSpread($a839522a202c9ac5$var$_objectSpread({}, state[action.serviceId]), {}, {
                isFetching: false,
                json: action.json
            })));
        case (0, $7CtTT.default).RECEIVE_ACCESS_TOKEN_FAILURE:
            return $a839522a202c9ac5$var$_objectSpread($a839522a202c9ac5$var$_objectSpread({}, state), {}, $a839522a202c9ac5$var$_defineProperty({}, action.serviceId, $a839522a202c9ac5$var$_objectSpread($a839522a202c9ac5$var$_objectSpread({}, state[action.serviceId]), {}, {
                error: action.error,
                isFetching: false
            })));
        case (0, $7CtTT.default).RESET_AUTHENTICATION_STATE:
            return (0, (/*@__PURE__*/$parcel$interopDefault($cc106592ee5b750f$exports)))(state, action.tokenServiceId);
        case (0, $7CtTT.default).RECEIVE_INFO_RESPONSE:
            if (!action.tokenServiceId) return state;
            if (state[action.tokenServiceId].success) return state;
            return $a839522a202c9ac5$var$_objectSpread($a839522a202c9ac5$var$_objectSpread({}, state), {}, $a839522a202c9ac5$var$_defineProperty({}, action.tokenServiceId, $a839522a202c9ac5$var$_objectSpread($a839522a202c9ac5$var$_objectSpread({}, state[action.tokenServiceId]), {}, {
                success: true
            })));
        default:
            return state;
    }
}

var $d61f94fc0f4df01c$exports = {};

$parcel$export($d61f94fc0f4df01c$exports, "annotationsReducer", function () { return $d61f94fc0f4df01c$export$5851330a61c651b8; });

var $7CtTT = parcelRequire("7CtTT");
function $d61f94fc0f4df01c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d61f94fc0f4df01c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d61f94fc0f4df01c$var$ownKeys(Object(source), true).forEach(function(key) {
            $d61f94fc0f4df01c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d61f94fc0f4df01c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d61f94fc0f4df01c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d61f94fc0f4df01c$export$5851330a61c651b8 = function annotationsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case (0, $7CtTT.default).REQUEST_ANNOTATION:
            return $d61f94fc0f4df01c$var$_objectSpread($d61f94fc0f4df01c$var$_objectSpread({}, state), {}, $d61f94fc0f4df01c$var$_defineProperty({}, action.targetId, $d61f94fc0f4df01c$var$_objectSpread($d61f94fc0f4df01c$var$_objectSpread({}, state[action.targetId]), {}, $d61f94fc0f4df01c$var$_defineProperty({}, action.annotationId, {
                id: action.annotationId,
                isFetching: true
            }))));
        case (0, $7CtTT.default).RECEIVE_ANNOTATION:
            return $d61f94fc0f4df01c$var$_objectSpread($d61f94fc0f4df01c$var$_objectSpread({}, state), {}, $d61f94fc0f4df01c$var$_defineProperty({}, action.targetId, $d61f94fc0f4df01c$var$_objectSpread($d61f94fc0f4df01c$var$_objectSpread({}, state[action.targetId]), {}, $d61f94fc0f4df01c$var$_defineProperty({}, action.annotationId, {
                id: action.annotationId,
                isFetching: false,
                json: action.annotationJson
            }))));
        case (0, $7CtTT.default).RECEIVE_ANNOTATION_FAILURE:
            return $d61f94fc0f4df01c$var$_objectSpread($d61f94fc0f4df01c$var$_objectSpread({}, state), {}, $d61f94fc0f4df01c$var$_defineProperty({}, action.targetId, $d61f94fc0f4df01c$var$_objectSpread($d61f94fc0f4df01c$var$_objectSpread({}, state[action.targetId]), {}, $d61f94fc0f4df01c$var$_defineProperty({}, action.annotationId, {
                error: action.error,
                id: action.annotationId,
                isFetching: false
            }))));
        case (0, $7CtTT.default).IMPORT_MIRADOR_STATE:
            return {};
        default:
            return state;
    }
};

var $dd040eb6a01d7fb3$exports = {};

$parcel$export($dd040eb6a01d7fb3$exports, "authReducer", function () { return $dd040eb6a01d7fb3$export$b3aa4dbb59e7857d; });


var $7CtTT = parcelRequire("7CtTT");
function $dd040eb6a01d7fb3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dd040eb6a01d7fb3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dd040eb6a01d7fb3$var$ownKeys(Object(source), true).forEach(function(key) {
            $dd040eb6a01d7fb3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dd040eb6a01d7fb3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dd040eb6a01d7fb3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $dd040eb6a01d7fb3$export$b3aa4dbb59e7857d = function authReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case (0, $7CtTT.default).ADD_AUTHENTICATION_REQUEST:
            return $dd040eb6a01d7fb3$var$_objectSpread($dd040eb6a01d7fb3$var$_objectSpread({}, state), {}, $dd040eb6a01d7fb3$var$_defineProperty({}, action.id, {
                id: action.id,
                isFetching: true,
                profile: action.profile,
                windowId: action.windowId
            }));
        case (0, $7CtTT.default).RESOLVE_AUTHENTICATION_REQUEST:
            return $dd040eb6a01d7fb3$var$_objectSpread($dd040eb6a01d7fb3$var$_objectSpread({}, state), {}, $dd040eb6a01d7fb3$var$_defineProperty({}, action.id, $dd040eb6a01d7fb3$var$_objectSpread($dd040eb6a01d7fb3$var$_objectSpread({}, state[action.id]), {}, {
                isFetching: false,
                ok: action.ok
            })));
        case (0, $7CtTT.default).RECEIVE_ACCESS_TOKEN:
            if (!action.authId) return state;
            return $dd040eb6a01d7fb3$var$_objectSpread($dd040eb6a01d7fb3$var$_objectSpread({}, state), {}, $dd040eb6a01d7fb3$var$_defineProperty({}, action.authId, $dd040eb6a01d7fb3$var$_objectSpread($dd040eb6a01d7fb3$var$_objectSpread({}, state[action.authId]), {}, {
                ok: true
            })));
        case (0, $7CtTT.default).RESET_AUTHENTICATION_STATE:
            return (0, (/*@__PURE__*/$parcel$interopDefault($cc106592ee5b750f$exports)))(state, action.id);
        default:
            return state;
    }
};

var $88808f398f003532$exports = {};

$parcel$export($88808f398f003532$exports, "catalogReducer", function () { return $88808f398f003532$export$2f65e618d6a2bb81; });

var $7CtTT = parcelRequire("7CtTT");
function $88808f398f003532$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $88808f398f003532$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $88808f398f003532$var$ownKeys(Object(source), true).forEach(function(key) {
            $88808f398f003532$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $88808f398f003532$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $88808f398f003532$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $88808f398f003532$var$_toConsumableArray(arr) {
    return $88808f398f003532$var$_arrayWithoutHoles(arr) || $88808f398f003532$var$_iterableToArray(arr) || $88808f398f003532$var$_unsupportedIterableToArray(arr) || $88808f398f003532$var$_nonIterableSpread();
}
function $88808f398f003532$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $88808f398f003532$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $88808f398f003532$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $88808f398f003532$var$_arrayLikeToArray(o, minLen);
}
function $88808f398f003532$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $88808f398f003532$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $88808f398f003532$var$_arrayLikeToArray(arr);
}
function $88808f398f003532$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $88808f398f003532$export$2f65e618d6a2bb81 = function catalogReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case (0, $7CtTT.default).ADD_RESOURCE:
            if (state.some(function(m) {
                return m.manifestId === action.manifestId;
            })) return state;
            return [
                $88808f398f003532$var$_objectSpread({
                    manifestId: action.manifestId
                }, action.payload)
            ].concat($88808f398f003532$var$_toConsumableArray(state));
        case (0, $7CtTT.default).ADD_WINDOW:
            if (state.some(function(m) {
                return m.manifestId === action.window.manifestId;
            })) return state;
            return [
                {
                    manifestId: action.window.manifestId
                }
            ].concat($88808f398f003532$var$_toConsumableArray(state));
        case (0, $7CtTT.default).UPDATE_WINDOW:
            if (!action.payload.manifestId) return state;
            if (state.some(function(m) {
                return m.manifestId === action.payload.manifestId;
            })) return state;
            return [
                {
                    manifestId: action.payload.manifestId
                }
            ].concat($88808f398f003532$var$_toConsumableArray(state));
        case (0, $7CtTT.default).REMOVE_RESOURCE:
            return state.filter(function(r) {
                return r.manifestId !== action.manifestId;
            });
        case (0, $7CtTT.default).IMPORT_CONFIG:
            return action.config.catalog || [];
        case (0, $7CtTT.default).IMPORT_MIRADOR_STATE:
            return action.state.catalog || [];
        default:
            return state;
    }
};

var $e7041dc4135381e1$exports = {};

$parcel$export($e7041dc4135381e1$exports, "companionWindowsReducer", function () { return $e7041dc4135381e1$export$94bf2dca0275e147; });

var $7cb2669cc036695c$exports = {};
var $2cd6752a0bb50bdd$exports = {};
var $1b992060d9e9b728$exports = {};
/** Used to map aliases to their real names. */ var $c5aefb818d9babf4$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $c5aefb818d9babf4$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $c5aefb818d9babf4$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $c5aefb818d9babf4$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $c5aefb818d9babf4$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $c5aefb818d9babf4$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $c5aefb818d9babf4$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $c5aefb818d9babf4$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $c5aefb818d9babf4$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $c5aefb818d9babf4$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $c5aefb818d9babf4$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $c5aefb818d9babf4$export$b4d07413ce528c90;
$c5aefb818d9babf4$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    "each": "forEach",
    "eachRight": "forEachRight",
    "entries": "toPairs",
    "entriesIn": "toPairsIn",
    "extend": "assignIn",
    "extendAll": "assignInAll",
    "extendAllWith": "assignInAllWith",
    "extendWith": "assignInWith",
    "first": "head",
    // Methods that are curried variants of others.
    "conforms": "conformsTo",
    "matches": "isMatch",
    "property": "get",
    // Ramda aliases.
    "__": "placeholder",
    "F": "stubFalse",
    "T": "stubTrue",
    "all": "every",
    "allPass": "overEvery",
    "always": "constant",
    "any": "some",
    "anyPass": "overSome",
    "apply": "spread",
    "assoc": "set",
    "assocPath": "set",
    "complement": "negate",
    "compose": "flowRight",
    "contains": "includes",
    "dissoc": "unset",
    "dissocPath": "unset",
    "dropLast": "dropRight",
    "dropLastWhile": "dropRightWhile",
    "equals": "isEqual",
    "identical": "eq",
    "indexBy": "keyBy",
    "init": "initial",
    "invertObj": "invert",
    "juxt": "over",
    "omitAll": "omit",
    "nAry": "ary",
    "path": "get",
    "pathEq": "matchesProperty",
    "pathOr": "getOr",
    "paths": "at",
    "pickAll": "pick",
    "pipe": "flow",
    "pluck": "map",
    "prop": "get",
    "propEq": "matchesProperty",
    "propOr": "getOr",
    "props": "at",
    "symmetricDifference": "xor",
    "symmetricDifferenceBy": "xorBy",
    "symmetricDifferenceWith": "xorWith",
    "takeLast": "takeRight",
    "takeLastWhile": "takeRightWhile",
    "unapply": "rest",
    "unnest": "flatten",
    "useWith": "overArgs",
    "where": "conformsTo",
    "whereEq": "isMatch",
    "zipObj": "zipObject"
};
$c5aefb818d9babf4$export$85c665b4d7da9cb4 = {
    "1": [
        "assignAll",
        "assignInAll",
        "attempt",
        "castArray",
        "ceil",
        "create",
        "curry",
        "curryRight",
        "defaultsAll",
        "defaultsDeepAll",
        "floor",
        "flow",
        "flowRight",
        "fromPairs",
        "invert",
        "iteratee",
        "memoize",
        "method",
        "mergeAll",
        "methodOf",
        "mixin",
        "nthArg",
        "over",
        "overEvery",
        "overSome",
        "rest",
        "reverse",
        "round",
        "runInContext",
        "spread",
        "template",
        "trim",
        "trimEnd",
        "trimStart",
        "uniqueId",
        "words",
        "zipAll"
    ],
    "2": [
        "add",
        "after",
        "ary",
        "assign",
        "assignAllWith",
        "assignIn",
        "assignInAllWith",
        "at",
        "before",
        "bind",
        "bindAll",
        "bindKey",
        "chunk",
        "cloneDeepWith",
        "cloneWith",
        "concat",
        "conformsTo",
        "countBy",
        "curryN",
        "curryRightN",
        "debounce",
        "defaults",
        "defaultsDeep",
        "defaultTo",
        "delay",
        "difference",
        "divide",
        "drop",
        "dropRight",
        "dropRightWhile",
        "dropWhile",
        "endsWith",
        "eq",
        "every",
        "filter",
        "find",
        "findIndex",
        "findKey",
        "findLast",
        "findLastIndex",
        "findLastKey",
        "flatMap",
        "flatMapDeep",
        "flattenDepth",
        "forEach",
        "forEachRight",
        "forIn",
        "forInRight",
        "forOwn",
        "forOwnRight",
        "get",
        "groupBy",
        "gt",
        "gte",
        "has",
        "hasIn",
        "includes",
        "indexOf",
        "intersection",
        "invertBy",
        "invoke",
        "invokeMap",
        "isEqual",
        "isMatch",
        "join",
        "keyBy",
        "lastIndexOf",
        "lt",
        "lte",
        "map",
        "mapKeys",
        "mapValues",
        "matchesProperty",
        "maxBy",
        "meanBy",
        "merge",
        "mergeAllWith",
        "minBy",
        "multiply",
        "nth",
        "omit",
        "omitBy",
        "overArgs",
        "pad",
        "padEnd",
        "padStart",
        "parseInt",
        "partial",
        "partialRight",
        "partition",
        "pick",
        "pickBy",
        "propertyOf",
        "pull",
        "pullAll",
        "pullAt",
        "random",
        "range",
        "rangeRight",
        "rearg",
        "reject",
        "remove",
        "repeat",
        "restFrom",
        "result",
        "sampleSize",
        "some",
        "sortBy",
        "sortedIndex",
        "sortedIndexOf",
        "sortedLastIndex",
        "sortedLastIndexOf",
        "sortedUniqBy",
        "split",
        "spreadFrom",
        "startsWith",
        "subtract",
        "sumBy",
        "take",
        "takeRight",
        "takeRightWhile",
        "takeWhile",
        "tap",
        "throttle",
        "thru",
        "times",
        "trimChars",
        "trimCharsEnd",
        "trimCharsStart",
        "truncate",
        "union",
        "uniqBy",
        "uniqWith",
        "unset",
        "unzipWith",
        "without",
        "wrap",
        "xor",
        "zip",
        "zipObject",
        "zipObjectDeep"
    ],
    "3": [
        "assignInWith",
        "assignWith",
        "clamp",
        "differenceBy",
        "differenceWith",
        "findFrom",
        "findIndexFrom",
        "findLastFrom",
        "findLastIndexFrom",
        "getOr",
        "includesFrom",
        "indexOfFrom",
        "inRange",
        "intersectionBy",
        "intersectionWith",
        "invokeArgs",
        "invokeArgsMap",
        "isEqualWith",
        "isMatchWith",
        "flatMapDepth",
        "lastIndexOfFrom",
        "mergeWith",
        "orderBy",
        "padChars",
        "padCharsEnd",
        "padCharsStart",
        "pullAllBy",
        "pullAllWith",
        "rangeStep",
        "rangeStepRight",
        "reduce",
        "reduceRight",
        "replace",
        "set",
        "slice",
        "sortedIndexBy",
        "sortedLastIndexBy",
        "transform",
        "unionBy",
        "unionWith",
        "update",
        "xorBy",
        "xorWith",
        "zipWith"
    ],
    "4": [
        "fill",
        "setWith",
        "updateWith"
    ]
};
$c5aefb818d9babf4$export$42564e045b285e32 = {
    "2": [
        1,
        0
    ],
    "3": [
        2,
        0,
        1
    ],
    "4": [
        3,
        2,
        0,
        1
    ]
};
$c5aefb818d9babf4$export$81e17196e6a22b07 = {
    "dropRightWhile": 1,
    "dropWhile": 1,
    "every": 1,
    "filter": 1,
    "find": 1,
    "findFrom": 1,
    "findIndex": 1,
    "findIndexFrom": 1,
    "findKey": 1,
    "findLast": 1,
    "findLastFrom": 1,
    "findLastIndex": 1,
    "findLastIndexFrom": 1,
    "findLastKey": 1,
    "flatMap": 1,
    "flatMapDeep": 1,
    "flatMapDepth": 1,
    "forEach": 1,
    "forEachRight": 1,
    "forIn": 1,
    "forInRight": 1,
    "forOwn": 1,
    "forOwnRight": 1,
    "map": 1,
    "mapKeys": 1,
    "mapValues": 1,
    "partition": 1,
    "reduce": 2,
    "reduceRight": 2,
    "reject": 1,
    "remove": 1,
    "some": 1,
    "takeRightWhile": 1,
    "takeWhile": 1,
    "times": 1,
    "transform": 2
};
$c5aefb818d9babf4$export$30975ceb42167ebd = {
    "mapKeys": [
        1
    ],
    "reduceRight": [
        1,
        0
    ]
};
$c5aefb818d9babf4$export$8ceb0ad7e94d3801 = {
    "assignInAllWith": [
        1,
        0
    ],
    "assignInWith": [
        1,
        2,
        0
    ],
    "assignAllWith": [
        1,
        0
    ],
    "assignWith": [
        1,
        2,
        0
    ],
    "differenceBy": [
        1,
        2,
        0
    ],
    "differenceWith": [
        1,
        2,
        0
    ],
    "getOr": [
        2,
        1,
        0
    ],
    "intersectionBy": [
        1,
        2,
        0
    ],
    "intersectionWith": [
        1,
        2,
        0
    ],
    "isEqualWith": [
        1,
        2,
        0
    ],
    "isMatchWith": [
        2,
        1,
        0
    ],
    "mergeAllWith": [
        1,
        0
    ],
    "mergeWith": [
        1,
        2,
        0
    ],
    "padChars": [
        2,
        1,
        0
    ],
    "padCharsEnd": [
        2,
        1,
        0
    ],
    "padCharsStart": [
        2,
        1,
        0
    ],
    "pullAllBy": [
        2,
        1,
        0
    ],
    "pullAllWith": [
        2,
        1,
        0
    ],
    "rangeStep": [
        1,
        2,
        0
    ],
    "rangeStepRight": [
        1,
        2,
        0
    ],
    "setWith": [
        3,
        1,
        2,
        0
    ],
    "sortedIndexBy": [
        2,
        1,
        0
    ],
    "sortedLastIndexBy": [
        2,
        1,
        0
    ],
    "unionBy": [
        1,
        2,
        0
    ],
    "unionWith": [
        1,
        2,
        0
    ],
    "updateWith": [
        3,
        1,
        2,
        0
    ],
    "xorBy": [
        1,
        2,
        0
    ],
    "xorWith": [
        1,
        2,
        0
    ],
    "zipWith": [
        1,
        2,
        0
    ]
};
$c5aefb818d9babf4$export$fbaeb3f87df3cf26 = {
    "assignAll": {
        "start": 0
    },
    "assignAllWith": {
        "start": 0
    },
    "assignInAll": {
        "start": 0
    },
    "assignInAllWith": {
        "start": 0
    },
    "defaultsAll": {
        "start": 0
    },
    "defaultsDeepAll": {
        "start": 0
    },
    "invokeArgs": {
        "start": 2
    },
    "invokeArgsMap": {
        "start": 2
    },
    "mergeAll": {
        "start": 0
    },
    "mergeAllWith": {
        "start": 0
    },
    "partial": {
        "start": 1
    },
    "partialRight": {
        "start": 1
    },
    "without": {
        "start": 1
    },
    "zipAll": {
        "start": 0
    }
};
$c5aefb818d9babf4$export$57e795267c26e600 = {
    "array": {
        "fill": true,
        "pull": true,
        "pullAll": true,
        "pullAllBy": true,
        "pullAllWith": true,
        "pullAt": true,
        "remove": true,
        "reverse": true
    },
    "object": {
        "assign": true,
        "assignAll": true,
        "assignAllWith": true,
        "assignIn": true,
        "assignInAll": true,
        "assignInAllWith": true,
        "assignInWith": true,
        "assignWith": true,
        "defaults": true,
        "defaultsAll": true,
        "defaultsDeep": true,
        "defaultsDeepAll": true,
        "merge": true,
        "mergeAll": true,
        "mergeAllWith": true,
        "mergeWith": true
    },
    "set": {
        "set": true,
        "setWith": true,
        "unset": true,
        "update": true,
        "updateWith": true
    }
};
$c5aefb818d9babf4$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $c5aefb818d9babf4$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$c5aefb818d9babf4$export$aee1dbae5de2db9d = {
    "assignAll": "assign",
    "assignAllWith": "assignWith",
    "assignInAll": "assignIn",
    "assignInAllWith": "assignInWith",
    "curryN": "curry",
    "curryRightN": "curryRight",
    "defaultsAll": "defaults",
    "defaultsDeepAll": "defaultsDeep",
    "findFrom": "find",
    "findIndexFrom": "findIndex",
    "findLastFrom": "findLast",
    "findLastIndexFrom": "findLastIndex",
    "getOr": "get",
    "includesFrom": "includes",
    "indexOfFrom": "indexOf",
    "invokeArgs": "invoke",
    "invokeArgsMap": "invokeMap",
    "lastIndexOfFrom": "lastIndexOf",
    "mergeAll": "merge",
    "mergeAllWith": "mergeWith",
    "padChars": "pad",
    "padCharsEnd": "padEnd",
    "padCharsStart": "padStart",
    "propertyOf": "get",
    "rangeStep": "range",
    "rangeStepRight": "rangeRight",
    "restFrom": "rest",
    "spreadFrom": "spread",
    "trimChars": "trim",
    "trimCharsEnd": "trimEnd",
    "trimCharsStart": "trimStart",
    "zipAll": "zip"
};
$c5aefb818d9babf4$export$87ffbe4821a5d5e0 = {
    "castArray": true,
    "flow": true,
    "flowRight": true,
    "iteratee": true,
    "mixin": true,
    "rearg": true,
    "runInContext": true
};
$c5aefb818d9babf4$export$b4d07413ce528c90 = {
    "add": true,
    "assign": true,
    "assignIn": true,
    "bind": true,
    "bindKey": true,
    "concat": true,
    "difference": true,
    "divide": true,
    "eq": true,
    "gt": true,
    "gte": true,
    "isEqual": true,
    "lt": true,
    "lte": true,
    "matchesProperty": true,
    "merge": true,
    "multiply": true,
    "overArgs": true,
    "partial": true,
    "partialRight": true,
    "propertyOf": true,
    "random": true,
    "range": true,
    "rangeRight": true,
    "subtract": true,
    "zip": true,
    "zipObject": true,
    "zipObjectDeep": true
};



var $ctdPd = parcelRequire("ctdPd");
/** Built-in value reference. */ var $1b992060d9e9b728$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $1b992060d9e9b728$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $1b992060d9e9b728$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $1b992060d9e9b728$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $1b992060d9e9b728$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $1b992060d9e9b728$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $1b992060d9e9b728$var$push.apply(otherArgs, array);
        if (start != lastIndex) $1b992060d9e9b728$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $1b992060d9e9b728$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $1b992060d9e9b728$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == "function", isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        "cap": "cap" in options ? options.cap : true,
        "curry": "curry" in options ? options.curry : true,
        "fixed": "fixed" in options ? options.fixed : true,
        "immutable": "immutable" in options ? options.immutable : true,
        "rearg": "rearg" in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $ctdPd, forceCurry = "curry" in options && options.curry, forceFixed = "fixed" in options && options.fixed, forceRearg = "rearg" in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        "ary": util.ary,
        "assign": util.assign,
        "clone": util.clone,
        "curry": util.curry,
        "forEach": util.forEach,
        "isArray": util.isArray,
        "isError": util.isError,
        "isFunction": util.isFunction,
        "isWeakMap": util.isWeakMap,
        "iteratee": util.iteratee,
        "keys": util.keys,
        "rearg": util.rearg,
        "toInteger": util.toInteger,
        "toPath": util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($c5aefb818d9babf4$export$85c665b4d7da9cb4);
    var wrappers = {
        "castArray": function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($1b992060d9e9b728$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        "iteratee": function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == "number") {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $1b992060d9e9b728$var$baseAry(result, arity);
                }
                return result;
            };
        },
        "mixin": function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        "nthArg": function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        "rearg": function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        "runInContext": function(runInContext) {
            return function(context) {
                return $1b992060d9e9b728$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $c5aefb818d9babf4$export$30975ceb42167ebd[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $c5aefb818d9babf4$export$81e17196e6a22b07[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$c5aefb818d9babf4$export$87ffbe4821a5d5e0[name])) {
            var data = $c5aefb818d9babf4$export$fbaeb3f87df3cf26[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $1b992060d9e9b728$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$c5aefb818d9babf4$export$b4d07413ce528c90[name]) ? rearg(func, $c5aefb818d9babf4$export$8ceb0ad7e94d3801[name] || $c5aefb818d9babf4$export$42564e045b285e32[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $c5aefb818d9babf4$export$bd0f5e6e44efa6b4[name] || name, methodName = $c5aefb818d9babf4$export$aee1dbae5de2db9d[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $1b992060d9e9b728$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == "function" ? $1b992060d9e9b728$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $1b992060d9e9b728$var$baseArity(rearg($1b992060d9e9b728$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $c5aefb818d9babf4$export$bd0f5e6e44efa6b4[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($c5aefb818d9babf4$export$57e795267c26e600.array[realName]) wrapped = $1b992060d9e9b728$var$wrapImmutable(func, $1b992060d9e9b728$var$cloneArray);
            else if ($c5aefb818d9babf4$export$57e795267c26e600.object[realName]) wrapped = $1b992060d9e9b728$var$wrapImmutable(func, $1b992060d9e9b728$var$createCloner(func));
            else if ($c5aefb818d9babf4$export$57e795267c26e600.set[realName]) wrapped = $1b992060d9e9b728$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($c5aefb818d9babf4$export$85c665b4d7da9cb4[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $c5aefb818d9babf4$export$fbaeb3f87df3cf26[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($c5aefb818d9babf4$export$85c665b4d7da9cb4[aryKey], function(key) {
            var func = _[$c5aefb818d9babf4$export$aee1dbae5de2db9d[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == "function") {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($c5aefb818d9babf4$export$1eb71a7e27943e71[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
$1b992060d9e9b728$exports = $1b992060d9e9b728$var$baseConvert;


var $2110d2352552f4a2$exports = {};














$2110d2352552f4a2$exports = {
    "ary": (parcelRequire("4UnI7")),
    "assign": (parcelRequire("6JHIT")),
    "clone": (parcelRequire("euAev")),
    "curry": (parcelRequire("atexn")),
    "forEach": (parcelRequire("e43Zj")),
    "isArray": (parcelRequire("eDRhj")),
    "isError": (parcelRequire("aL6hR")),
    "isFunction": (parcelRequire("4n8SM")),
    "isWeakMap": (parcelRequire("iOSJj")),
    "iteratee": (parcelRequire("3CVRv")),
    "keys": (parcelRequire("aff5X")),
    "rearg": (parcelRequire("6vMwC")),
    "toInteger": (parcelRequire("ltgXV")),
    "toPath": (parcelRequire("jUokQ"))
};


/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $2cd6752a0bb50bdd$var$convert(name, func, options) {
    return $1b992060d9e9b728$exports($2110d2352552f4a2$exports, name, func, options);
}
$2cd6752a0bb50bdd$exports = $2cd6752a0bb50bdd$var$convert;



var $7cb2669cc036695c$var$func = $2cd6752a0bb50bdd$exports("set", (parcelRequire("feGMd")));

$7cb2669cc036695c$var$func.placeholder = (parcelRequire("ctdPd"));
$7cb2669cc036695c$exports = $7cb2669cc036695c$var$func;


var $c0b2d5e34d2f4471$exports = {};


var $c0b2d5e34d2f4471$var$func = $2cd6752a0bb50bdd$exports("update", (parcelRequire("hRjpy")));

$c0b2d5e34d2f4471$var$func.placeholder = (parcelRequire("ctdPd"));
$c0b2d5e34d2f4471$exports = $c0b2d5e34d2f4471$var$func;



var $7CtTT = parcelRequire("7CtTT");
function $e7041dc4135381e1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e7041dc4135381e1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e7041dc4135381e1$var$ownKeys(Object(source), true).forEach(function(key) {
            $e7041dc4135381e1$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e7041dc4135381e1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e7041dc4135381e1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e7041dc4135381e1$export$94bf2dca0275e147() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case (0, $7CtTT.default).ADD_COMPANION_WINDOW:
            return (0, (/*@__PURE__*/$parcel$interopDefault($7cb2669cc036695c$exports)))([
                action.id
            ], action.payload, state);
        case (0, $7CtTT.default).ADD_WINDOW:
            return $e7041dc4135381e1$var$_objectSpread($e7041dc4135381e1$var$_objectSpread({}, state), (action.companionWindows || []).reduce(function(newState, cw) {
                newState[cw.id] = $e7041dc4135381e1$var$_objectSpread($e7041dc4135381e1$var$_objectSpread($e7041dc4135381e1$var$_objectSpread({}, state[cw.id]), cw), {}, {
                    windowId: action.id
                });
                return newState;
            }, {}));
        case (0, $7CtTT.default).REMOVE_WINDOW:
            return Object.keys(state).reduce(function(object, key) {
                if (state[key].windowId !== action.windowId) object[key] = state[key]; // eslint-disable-line no-param-reassign
                return object;
            }, {});
        case (0, $7CtTT.default).UPDATE_COMPANION_WINDOW:
            return (0, (/*@__PURE__*/$parcel$interopDefault($c0b2d5e34d2f4471$exports)))([
                action.id
            ], function(orig) {
                return $e7041dc4135381e1$var$_objectSpread($e7041dc4135381e1$var$_objectSpread({}, orig || {}), action.payload);
            }, state);
        case (0, $7CtTT.default).REMOVE_COMPANION_WINDOW:
            return (0, (/*@__PURE__*/$parcel$interopDefault($cc106592ee5b750f$exports)))(state, action.id);
        case (0, $7CtTT.default).IMPORT_MIRADOR_STATE:
            return action.state.companionWindows || [];
        case (0, $7CtTT.default).TOGGLE_TOC_NODE:
            return (0, (/*@__PURE__*/$parcel$interopDefault($c0b2d5e34d2f4471$exports)))([
                action.id,
                "tocNodes"
            ], function(orig) {
                return $e7041dc4135381e1$var$_objectSpread($e7041dc4135381e1$var$_objectSpread({}, orig || {}), action.payload);
            }, state);
        default:
            return state;
    }
}

var $5d0d949ec1c52f63$exports = {};

$parcel$export($5d0d949ec1c52f63$exports, "configReducer", function () { return $5d0d949ec1c52f63$export$21f3d8f1fe4f2d8; });

var $iyYa0 = parcelRequire("iyYa0");

var $Kyao2 = parcelRequire("Kyao2");

var $7CtTT = parcelRequire("7CtTT");
function $5d0d949ec1c52f63$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5d0d949ec1c52f63$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5d0d949ec1c52f63$var$ownKeys(Object(source), true).forEach(function(key) {
            $5d0d949ec1c52f63$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5d0d949ec1c52f63$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5d0d949ec1c52f63$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5d0d949ec1c52f63$var$initialState = $5d0d949ec1c52f63$var$_objectSpread({}, (0, $Kyao2.default));
/** Overwrite arrays when deep merging */ var $5d0d949ec1c52f63$var$overwriteMerge = function overwriteMerge(destinationArray, sourceArray, options) {
    return sourceArray;
};
var $5d0d949ec1c52f63$export$21f3d8f1fe4f2d8 = function configReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $5d0d949ec1c52f63$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case (0, $7CtTT.default).UPDATE_CONFIG:
        case (0, $7CtTT.default).IMPORT_CONFIG:
            return (0, (/*@__PURE__*/$parcel$interopDefault($iyYa0)))(state, action.config, {
                arrayMerge: $5d0d949ec1c52f63$var$overwriteMerge
            });
        case (0, $7CtTT.default).SET_CONFIG:
            return action.config;
        case (0, $7CtTT.default).IMPORT_MIRADOR_STATE:
            return action.state.config || {};
        default:
            return state;
    }
};

var $f2ab5acdaf261ede$exports = {};

$parcel$export($f2ab5acdaf261ede$exports, "elasticLayoutReducer", function () { return $f2ab5acdaf261ede$export$3f64673c9071d634; });



var $7CtTT = parcelRequire("7CtTT");
function $f2ab5acdaf261ede$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f2ab5acdaf261ede$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f2ab5acdaf261ede$var$ownKeys(Object(source), true).forEach(function(key) {
            $f2ab5acdaf261ede$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f2ab5acdaf261ede$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f2ab5acdaf261ede$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $f2ab5acdaf261ede$export$3f64673c9071d634 = function elasticLayoutReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case (0, $7CtTT.default).ADD_WINDOW:
            return $f2ab5acdaf261ede$var$_objectSpread($f2ab5acdaf261ede$var$_objectSpread({}, state), {}, $f2ab5acdaf261ede$var$_defineProperty({}, action.window.id, $f2ab5acdaf261ede$var$_objectSpread({
                windowId: action.window.id
            }, action.elasticLayout)));
        case (0, $7CtTT.default).UPDATE_ELASTIC_WINDOW_LAYOUT:
            return (0, (/*@__PURE__*/$parcel$interopDefault($c0b2d5e34d2f4471$exports)))([
                action.windowId
            ], function(orig) {
                return $f2ab5acdaf261ede$var$_objectSpread($f2ab5acdaf261ede$var$_objectSpread({}, orig || {}), action.payload);
            }, state);
        case (0, $7CtTT.default).REMOVE_WINDOW:
            return (0, (/*@__PURE__*/$parcel$interopDefault($cc106592ee5b750f$exports)))(state, action.windowId);
        case (0, $7CtTT.default).IMPORT_MIRADOR_STATE:
            return action.state.elasticLayout || {};
        default:
            return state;
    }
};

var $06e26c5102ef3b7f$exports = {};

$parcel$export($06e26c5102ef3b7f$exports, "errorsReducer", function () { return $06e26c5102ef3b7f$export$ce00ddf575bea579; });

var $8sxbG = parcelRequire("8sxbG");

var $7CtTT = parcelRequire("7CtTT");
function $06e26c5102ef3b7f$var$_toConsumableArray(arr) {
    return $06e26c5102ef3b7f$var$_arrayWithoutHoles(arr) || $06e26c5102ef3b7f$var$_iterableToArray(arr) || $06e26c5102ef3b7f$var$_unsupportedIterableToArray(arr) || $06e26c5102ef3b7f$var$_nonIterableSpread();
}
function $06e26c5102ef3b7f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $06e26c5102ef3b7f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $06e26c5102ef3b7f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $06e26c5102ef3b7f$var$_arrayLikeToArray(o, minLen);
}
function $06e26c5102ef3b7f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $06e26c5102ef3b7f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $06e26c5102ef3b7f$var$_arrayLikeToArray(arr);
}
function $06e26c5102ef3b7f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $06e26c5102ef3b7f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $06e26c5102ef3b7f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $06e26c5102ef3b7f$var$ownKeys(Object(source), true).forEach(function(key) {
            $06e26c5102ef3b7f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $06e26c5102ef3b7f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $06e26c5102ef3b7f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $06e26c5102ef3b7f$var$defaultState = {
    items: []
};
var $06e26c5102ef3b7f$export$ce00ddf575bea579 = function errorsReducer() {
    var _objectSpread2, _objectSpread3, _objectSpread4;
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $06e26c5102ef3b7f$var$defaultState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var ret;
    switch(action.type){
        case (0, $7CtTT.default).ADD_ERROR:
            return $06e26c5102ef3b7f$var$_objectSpread($06e26c5102ef3b7f$var$_objectSpread({}, state), {}, (_objectSpread2 = {}, $06e26c5102ef3b7f$var$_defineProperty(_objectSpread2, action.id, {
                id: action.id,
                message: action.message
            }), $06e26c5102ef3b7f$var$_defineProperty(_objectSpread2, "items", [].concat($06e26c5102ef3b7f$var$_toConsumableArray(state.items), [
                action.id
            ])), _objectSpread2));
        // eslint-disable-line max-len
        case (0, $7CtTT.default).RECEIVE_INFO_RESPONSE_FAILURE:
            return $06e26c5102ef3b7f$var$_objectSpread($06e26c5102ef3b7f$var$_objectSpread({}, state), {}, (_objectSpread3 = {}, $06e26c5102ef3b7f$var$_defineProperty(_objectSpread3, action.infoId, {
                id: action.infoId,
                message: action.error
            }), $06e26c5102ef3b7f$var$_defineProperty(_objectSpread3, "items", [].concat($06e26c5102ef3b7f$var$_toConsumableArray(state.items), [
                action.infoId
            ])), _objectSpread3));
        case (0, $7CtTT.default).RECEIVE_SEARCH_FAILURE:
            return $06e26c5102ef3b7f$var$_objectSpread($06e26c5102ef3b7f$var$_objectSpread({}, state), {}, (_objectSpread4 = {}, $06e26c5102ef3b7f$var$_defineProperty(_objectSpread4, action.searchId, {
                id: action.searchId,
                message: action.error
            }), $06e26c5102ef3b7f$var$_defineProperty(_objectSpread4, "items", [].concat($06e26c5102ef3b7f$var$_toConsumableArray(state.items), [
                action.searchId
            ])), _objectSpread4));
        case (0, $7CtTT.default).REMOVE_ERROR:
            ret = Object.keys(state).reduce(function(object, key) {
                if (key !== action.id) object[key] = state[key]; // eslint-disable-line no-param-reassign
                return object;
            }, {});
            ret.items = (0, (/*@__PURE__*/$parcel$interopDefault($8sxbG)))(ret.items, action.id);
            return ret;
        case (0, $7CtTT.default).IMPORT_MIRADOR_STATE:
            return $06e26c5102ef3b7f$var$defaultState;
        default:
            return state;
    }
};

var $dab6f0e5d10a15b8$exports = {};

$parcel$export($dab6f0e5d10a15b8$exports, "infoResponsesReducer", function () { return $dab6f0e5d10a15b8$export$cd22fbc520bc423c; });

var $7CtTT = parcelRequire("7CtTT");
function $dab6f0e5d10a15b8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dab6f0e5d10a15b8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dab6f0e5d10a15b8$var$ownKeys(Object(source), true).forEach(function(key) {
            $dab6f0e5d10a15b8$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dab6f0e5d10a15b8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dab6f0e5d10a15b8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $dab6f0e5d10a15b8$export$cd22fbc520bc423c = function infoResponsesReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case (0, $7CtTT.default).REQUEST_INFO_RESPONSE:
            return $dab6f0e5d10a15b8$var$_objectSpread($dab6f0e5d10a15b8$var$_objectSpread({}, state), {}, $dab6f0e5d10a15b8$var$_defineProperty({}, action.infoId, {
                id: action.infoId,
                isFetching: true
            }));
        case (0, $7CtTT.default).RECEIVE_INFO_RESPONSE:
            return $dab6f0e5d10a15b8$var$_objectSpread($dab6f0e5d10a15b8$var$_objectSpread({}, state), {}, $dab6f0e5d10a15b8$var$_defineProperty({}, action.infoId, {
                degraded: false,
                id: action.infoId,
                isFetching: false,
                json: action.infoJson,
                tokenServiceId: action.tokenServiceId
            }));
        case (0, $7CtTT.default).RECEIVE_DEGRADED_INFO_RESPONSE:
            return $dab6f0e5d10a15b8$var$_objectSpread($dab6f0e5d10a15b8$var$_objectSpread({}, state), {}, $dab6f0e5d10a15b8$var$_defineProperty({}, action.infoId, {
                degraded: true,
                id: action.infoId,
                isFetching: false,
                json: action.infoJson,
                tokenServiceId: action.tokenServiceId
            }));
        case (0, $7CtTT.default).RECEIVE_INFO_RESPONSE_FAILURE:
            return $dab6f0e5d10a15b8$var$_objectSpread($dab6f0e5d10a15b8$var$_objectSpread({}, state), {}, $dab6f0e5d10a15b8$var$_defineProperty({}, action.infoId, {
                error: action.error,
                id: action.infoId,
                isFetching: false,
                tokenServiceId: action.tokenServiceId
            }));
        case (0, $7CtTT.default).REMOVE_INFO_RESPONSE:
            return Object.keys(state).reduce(function(object, key) {
                if (key !== action.infoId) object[key] = state[key]; // eslint-disable-line no-param-reassign
                return object;
            }, {});
        case (0, $7CtTT.default).IMPORT_MIRADOR_STATE:
            return {};
        default:
            return state;
    }
};

var $feb7911e676721d8$exports = {};

$parcel$export($feb7911e676721d8$exports, "layersReducer", function () { return $feb7911e676721d8$export$eca2f5a0745255fb; });


var $iyYa0 = parcelRequire("iyYa0");

var $7CtTT = parcelRequire("7CtTT");
function $feb7911e676721d8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $feb7911e676721d8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $feb7911e676721d8$var$ownKeys(Object(source), true).forEach(function(key) {
            $feb7911e676721d8$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $feb7911e676721d8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $feb7911e676721d8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $feb7911e676721d8$export$eca2f5a0745255fb = function layersReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case (0, $7CtTT.default).UPDATE_LAYERS:
            return $feb7911e676721d8$var$_objectSpread($feb7911e676721d8$var$_objectSpread({}, state), {}, $feb7911e676721d8$var$_defineProperty({}, action.windowId, $feb7911e676721d8$var$_objectSpread($feb7911e676721d8$var$_objectSpread({}, state[action.windowId]), {}, $feb7911e676721d8$var$_defineProperty({}, action.canvasId, (0, (/*@__PURE__*/$parcel$interopDefault($iyYa0)))((state[action.windowId] || {})[action.canvasId] || {}, action.payload)))));
        case (0, $7CtTT.default).REMOVE_WINDOW:
            return (0, (/*@__PURE__*/$parcel$interopDefault($cc106592ee5b750f$exports)))(state, [
                action.windowId
            ]);
        default:
            return state;
    }
};

var $a71ebeb4ee7e4bd2$exports = {};

$parcel$export($a71ebeb4ee7e4bd2$exports, "manifestsReducer", function () { return $a71ebeb4ee7e4bd2$export$bc3bd53317a29ffe; });


var $7CtTT = parcelRequire("7CtTT");
function $a71ebeb4ee7e4bd2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a71ebeb4ee7e4bd2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a71ebeb4ee7e4bd2$var$ownKeys(Object(source), true).forEach(function(key) {
            $a71ebeb4ee7e4bd2$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a71ebeb4ee7e4bd2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a71ebeb4ee7e4bd2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a71ebeb4ee7e4bd2$export$bc3bd53317a29ffe = function manifestsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case (0, $7CtTT.default).REQUEST_MANIFEST:
            return $a71ebeb4ee7e4bd2$var$_objectSpread($a71ebeb4ee7e4bd2$var$_defineProperty({}, action.manifestId, $a71ebeb4ee7e4bd2$var$_objectSpread($a71ebeb4ee7e4bd2$var$_objectSpread($a71ebeb4ee7e4bd2$var$_objectSpread({}, state[action.manifestId]), action.properties), {}, {
                id: action.manifestId
            })), (0, (/*@__PURE__*/$parcel$interopDefault($cc106592ee5b750f$exports)))(state, action.manifestId));
        case (0, $7CtTT.default).RECEIVE_MANIFEST:
            return $a71ebeb4ee7e4bd2$var$_objectSpread($a71ebeb4ee7e4bd2$var$_objectSpread({}, state), {}, $a71ebeb4ee7e4bd2$var$_defineProperty({}, action.manifestId, $a71ebeb4ee7e4bd2$var$_objectSpread($a71ebeb4ee7e4bd2$var$_objectSpread({}, state[action.manifestId]), {}, {
                error: null,
                // Explicitly set the error to null in case this is a re-fetch
                id: action.manifestId,
                isFetching: false,
                json: action.manifestJson
            })));
        case (0, $7CtTT.default).RECEIVE_MANIFEST_FAILURE:
            return $a71ebeb4ee7e4bd2$var$_objectSpread($a71ebeb4ee7e4bd2$var$_objectSpread({}, state), {}, $a71ebeb4ee7e4bd2$var$_defineProperty({}, action.manifestId, $a71ebeb4ee7e4bd2$var$_objectSpread($a71ebeb4ee7e4bd2$var$_objectSpread({}, state[action.manifestId]), {}, {
                error: action.error,
                id: action.manifestId,
                isFetching: false
            })));
        case (0, $7CtTT.default).REMOVE_MANIFEST:
            return Object.keys(state).reduce(function(object, key) {
                if (key !== action.manifestId) object[key] = state[key]; // eslint-disable-line no-param-reassign
                return object;
            }, {});
        case (0, $7CtTT.default).IMPORT_MIRADOR_STATE:
            return action.state.manifests || {};
        default:
            return state;
    }
};

var $4428321196a285de$exports = {};

$parcel$export($4428321196a285de$exports, "searchesReducer", function () { return $4428321196a285de$export$6609a1d429307c63; });


var $bT1Wq = parcelRequire("bT1Wq");

var $7CtTT = parcelRequire("7CtTT");
function $4428321196a285de$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4428321196a285de$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4428321196a285de$var$ownKeys(Object(source), true).forEach(function(key) {
            $4428321196a285de$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4428321196a285de$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4428321196a285de$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $4428321196a285de$export$6609a1d429307c63 = function searchesReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var searchStruct = (state[action.windowId] || {})[action.companionWindowId] || {};
    switch(action.type){
        case (0, $7CtTT.default).REQUEST_SEARCH:
            if (searchStruct.query !== action.query) // new query
            return $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state), {}, $4428321196a285de$var$_defineProperty({}, action.windowId, $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state[action.windowId]), {}, $4428321196a285de$var$_defineProperty({}, action.companionWindowId, $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, searchStruct), {}, {
                data: $4428321196a285de$var$_defineProperty({}, action.searchId, {
                    isFetching: true
                }),
                query: action.query,
                selectedContentSearchAnnotation: []
            })))));
             // paginating through a query
            return $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state), {}, $4428321196a285de$var$_defineProperty({}, action.windowId, $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state[action.windowId]), {}, $4428321196a285de$var$_defineProperty({}, action.companionWindowId, $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, searchStruct), {}, {
                data: $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, searchStruct.data), {}, $4428321196a285de$var$_defineProperty({}, action.searchId, {
                    isFetching: true
                }))
            })))));
        case (0, $7CtTT.default).RECEIVE_SEARCH:
            return $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state), {}, $4428321196a285de$var$_defineProperty({}, action.windowId, $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state[action.windowId]), {}, $4428321196a285de$var$_defineProperty({}, action.companionWindowId, $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, searchStruct), {}, {
                data: $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, searchStruct.data), {}, $4428321196a285de$var$_defineProperty({}, action.searchId, {
                    isFetching: false,
                    json: action.searchJson
                }))
            })))));
        case (0, $7CtTT.default).RECEIVE_SEARCH_FAILURE:
            return $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state), {}, $4428321196a285de$var$_defineProperty({}, action.windowId, $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state[action.windowId]), {}, $4428321196a285de$var$_defineProperty({}, action.companionWindowId, $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, searchStruct), {}, {
                data: $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, searchStruct.data), {}, $4428321196a285de$var$_defineProperty({}, action.searchId, {
                    error: action.error,
                    isFetching: false
                }))
            })))));
        case (0, $7CtTT.default).REMOVE_SEARCH:
            return $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state), {}, $4428321196a285de$var$_defineProperty({}, action.windowId, Object.keys(state[action.windowId]).reduce(function(object, key) {
                if (key !== action.companionWindowId) object[key] = state[action.windowId][key]; // eslint-disable-line no-param-reassign
                return object;
            }, {})));
        case (0, $7CtTT.default).SET_CONTENT_SEARCH_CURRENT_ANNOTATIONS:
            return $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state), {}, $4428321196a285de$var$_defineProperty({}, action.windowId, $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state[action.windowId]), {}, $4428321196a285de$var$_defineProperty({}, action.companionWindowId, $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, searchStruct), {}, {
                selectedContentSearchAnnotationIds: action.annotationIds
            })))));
        case (0, $7CtTT.default).SELECT_ANNOTATION:
            if (!state[action.windowId]) return state;
            return $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state), {}, $4428321196a285de$var$_defineProperty({}, action.windowId, Object.keys(state[action.windowId]).reduce(function(object, key) {
                var search = state[action.windowId][key];
                var searchHasAnnotation = search.data && Object.values(search.data).filter(function(resp) {
                    return resp.json && resp.json.resources;
                }).some(function(resp) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))([
                        resp.json.resources
                    ]).some(function(r) {
                        return r["@id"] === action.annotationId;
                    });
                });
                if (searchHasAnnotation) object[key] = $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, search), {}, {
                    selectedContentSearchAnnotationIds: [
                        action.annotationId
                    ]
                });
                else object[key] = search; // eslint-disable-line no-param-reassign
                return object;
            }, {})));
        case (0, $7CtTT.default).IMPORT_MIRADOR_STATE:
            return {};
        case (0, $7CtTT.default).REMOVE_WINDOW:
            return (0, (/*@__PURE__*/$parcel$interopDefault($cc106592ee5b750f$exports)))(state, action.windowId);
        case (0, $7CtTT.default).REMOVE_COMPANION_WINDOW:
            if (!state[action.windowId]) return state;
            return $4428321196a285de$var$_objectSpread($4428321196a285de$var$_objectSpread({}, state), {}, $4428321196a285de$var$_defineProperty({}, action.windowId, $4428321196a285de$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($cc106592ee5b750f$exports)))(state[action.windowId], action.id))));
        default:
            return state;
    }
};

var $eefca1db3103cfbf$exports = {};

$parcel$export($eefca1db3103cfbf$exports, "viewersReducer", function () { return $eefca1db3103cfbf$export$127d9a04c8f08903; });



var $7CtTT = parcelRequire("7CtTT");
function $eefca1db3103cfbf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eefca1db3103cfbf$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $eefca1db3103cfbf$var$ownKeys(Object(source), true).forEach(function(key) {
            $eefca1db3103cfbf$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $eefca1db3103cfbf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $eefca1db3103cfbf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $eefca1db3103cfbf$export$127d9a04c8f08903 = function viewersReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case (0, $7CtTT.default).UPDATE_VIEWPORT:
            return $eefca1db3103cfbf$var$_objectSpread($eefca1db3103cfbf$var$_objectSpread({}, state), {}, $eefca1db3103cfbf$var$_defineProperty({}, action.windowId, $eefca1db3103cfbf$var$_objectSpread($eefca1db3103cfbf$var$_objectSpread({}, state[action.windowId]), action.payload)));
        case (0, $7CtTT.default).REMOVE_WINDOW:
            return (0, (/*@__PURE__*/$parcel$interopDefault($cc106592ee5b750f$exports)))(state, action.windowId);
        case (0, $7CtTT.default).SET_WINDOW_VIEW_TYPE:
            return (0, (/*@__PURE__*/$parcel$interopDefault($7cb2669cc036695c$exports)))([
                action.windowId
            ], null, state);
        case (0, $7CtTT.default).SET_CANVAS:
            if (!action.preserveViewport) return (0, (/*@__PURE__*/$parcel$interopDefault($7cb2669cc036695c$exports)))([
                action.windowId
            ], null, state);
            return state;
        case (0, $7CtTT.default).IMPORT_MIRADOR_STATE:
            return action.state.viewers || {};
        default:
            return state;
    }
};

var $85c03845757be162$exports = {};

$parcel$export($85c03845757be162$exports, "windowsReducer", function () { return $85c03845757be162$export$ed49d226c8d5e0d6; });



var $7CtTT = parcelRequire("7CtTT");
function $85c03845757be162$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $85c03845757be162$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $85c03845757be162$var$ownKeys(Object(source), true).forEach(function(key) {
            $85c03845757be162$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $85c03845757be162$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $85c03845757be162$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $85c03845757be162$export$ed49d226c8d5e0d6 = function windowsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case (0, $7CtTT.default).ADD_WINDOW:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.window.id, action.window));
        case (0, $7CtTT.default).MAXIMIZE_WINDOW:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                maximized: true
            })));
        case (0, $7CtTT.default).MINIMIZE_WINDOW:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                maximized: false
            })));
        case (0, $7CtTT.default).UPDATE_WINDOW:
            return (0, (/*@__PURE__*/$parcel$interopDefault($c0b2d5e34d2f4471$exports)))([
                action.id
            ], function(orig) {
                return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, orig || {}), action.payload);
            }, state);
        case (0, $7CtTT.default).REMOVE_WINDOW:
            return (0, (/*@__PURE__*/$parcel$interopDefault($cc106592ee5b750f$exports)))(state, [
                action.windowId
            ]);
        case (0, $7CtTT.default).TOGGLE_WINDOW_SIDE_BAR:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                sideBarOpen: !state[action.windowId].sideBarOpen
            })));
        case (0, $7CtTT.default).SET_WINDOW_VIEW_TYPE:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                view: action.viewType
            })));
        case (0, $7CtTT.default).UPDATE_WINDOW_POSITION:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.payload.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.payload.windowId]), {}, {
                x: action.payload.position.x,
                y: action.payload.position.y
            })));
        case (0, $7CtTT.default).SET_WINDOW_SIZE:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.payload.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.payload.windowId]), {}, {
                height: action.payload.size.height,
                width: action.payload.size.width,
                x: action.payload.size.x,
                y: action.payload.size.y
            })));
        case (0, $7CtTT.default).SET_CANVAS:
            if (!state[action.windowId]) return state;
            return (0, (/*@__PURE__*/$parcel$interopDefault($c0b2d5e34d2f4471$exports)))([
                action.windowId
            ], function(orig) {
                return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, orig || {}), {}, {
                    canvasId: action.canvasId,
                    visibleCanvases: action.visibleCanvases || []
                });
            }, state);
        case (0, $7CtTT.default).ADD_COMPANION_WINDOW:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                companionWindowIds: state[action.windowId].companionWindowIds.concat([
                    action.id
                ])
            }, action.payload.position === "left" ? {
                companionAreaOpen: true,
                sideBarPanel: action.payload.content
            } : {})));
        case (0, $7CtTT.default).UPDATE_COMPANION_WINDOW:
            if (action.payload.position !== "left") return state;
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                companionAreaOpen: true
            })));
        case (0, $7CtTT.default).REMOVE_COMPANION_WINDOW:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                companionWindowIds: state[action.windowId].companionWindowIds.filter(function(id) {
                    return id !== action.id;
                })
            })));
        case (0, $7CtTT.default).SELECT_ANNOTATION:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                selectedAnnotationId: action.annotationId
            })));
        case (0, $7CtTT.default).DESELECT_ANNOTATION:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                selectedAnnotationId: undefined
            })));
        case (0, $7CtTT.default).HOVER_ANNOTATION:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                hoveredAnnotationIds: action.annotationIds
            })));
        case (0, $7CtTT.default).TOGGLE_ANNOTATION_DISPLAY:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                highlightAllAnnotations: !state[action.windowId].highlightAllAnnotations
            })));
        case (0, $7CtTT.default).IMPORT_MIRADOR_STATE:
            return action.state.windows || [];
        case (0, $7CtTT.default).REQUEST_SEARCH:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                suggestedSearches: undefined
            })));
        case (0, $7CtTT.default).SHOW_COLLECTION_DIALOG:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                collectionDialogOn: true,
                collectionManifestId: action.manifestId,
                collectionPath: action.collectionPath
            })));
        case (0, $7CtTT.default).HIDE_COLLECTION_DIALOG:
            return $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state), {}, $85c03845757be162$var$_defineProperty({}, action.windowId, $85c03845757be162$var$_objectSpread($85c03845757be162$var$_objectSpread({}, state[action.windowId]), {}, {
                collectionDialogOn: false
            })));
        default:
            return state;
    }
};

var $e4a743f8da7baec6$exports = {};

$parcel$export($e4a743f8da7baec6$exports, "workspaceReducer", function () { return $e4a743f8da7baec6$export$5b85b33560271979; });

var $Kyao2 = parcelRequire("Kyao2");

var $7CtTT = parcelRequire("7CtTT");
function $e4a743f8da7baec6$var$_toConsumableArray(arr) {
    return $e4a743f8da7baec6$var$_arrayWithoutHoles(arr) || $e4a743f8da7baec6$var$_iterableToArray(arr) || $e4a743f8da7baec6$var$_unsupportedIterableToArray(arr) || $e4a743f8da7baec6$var$_nonIterableSpread();
}
function $e4a743f8da7baec6$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e4a743f8da7baec6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e4a743f8da7baec6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e4a743f8da7baec6$var$_arrayLikeToArray(o, minLen);
}
function $e4a743f8da7baec6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e4a743f8da7baec6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e4a743f8da7baec6$var$_arrayLikeToArray(arr);
}
function $e4a743f8da7baec6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e4a743f8da7baec6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e4a743f8da7baec6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e4a743f8da7baec6$var$ownKeys(Object(source), true).forEach(function(key) {
            $e4a743f8da7baec6$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e4a743f8da7baec6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e4a743f8da7baec6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/** Check if the viewport dimensions are fully specified */ function $e4a743f8da7baec6$var$hasViewportPosition(viewportPosition) {
    return viewportPosition.x !== undefined && viewportPosition.y !== undefined && viewportPosition.width !== undefined && viewportPosition.height !== undefined;
}
/** Check if the containee is fully within the bounds on the container */ function $e4a743f8da7baec6$var$contains(container, containee) {
    return containee.x - containee.width / 2 > container.x - container.width / 2 && containee.y - containee.height / 2 > container.y - container.height / 2 && containee.x + containee.width / 2 < container.x + container.width / 2 && containee.y + containee.height / 2 < container.y + container.height / 2;
}
var $e4a743f8da7baec6$export$5b85b33560271979 = function workspaceReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, (0, $Kyao2.default).workspace), {}, {
        windowIds: []
    });
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var newWorkspaceDimensions;
    var viewportPosition;
    var newWindowIds;
    switch(action.type){
        case (0, $7CtTT.default).UPDATE_WORKSPACE:
            return $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state), action.config);
        case (0, $7CtTT.default).FOCUS_WINDOW:
            return $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state), {}, {
                focusedWindowId: action.windowId,
                viewportPosition: $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state.viewportPosition), action.position)
            });
        case (0, $7CtTT.default).ADD_WINDOW:
            return $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state), {}, {
                focusedWindowId: action.window.id,
                windowIds: [].concat($e4a743f8da7baec6$var$_toConsumableArray(state.windowIds || []), [
                    action.window.id
                ])
            });
        case (0, $7CtTT.default).REMOVE_WINDOW:
            newWindowIds = (state.windowIds || []).filter(function(v) {
                return v !== action.windowId;
            });
            return $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state), {}, {
                focusedWindowId: action.windowId === state.focusedWindowId ? newWindowIds[newWindowIds.length - 1] : state.focusedWindowId,
                windowIds: newWindowIds
            });
        case (0, $7CtTT.default).SET_WORKSPACE_FULLSCREEN:
            return $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state), {}, {
                isFullscreenEnabled: action.isFullscreenEnabled
            });
        case (0, $7CtTT.default).TOGGLE_ZOOM_CONTROLS:
            return $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state), {}, {
                showZoomControls: action.showZoomControls
            });
        case (0, $7CtTT.default).UPDATE_WORKSPACE_MOSAIC_LAYOUT:
            return $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state), {}, {
                layout: action.layout
            });
        case (0, $7CtTT.default).SET_WORKSPACE_ADD_VISIBILITY:
            return $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state), {}, {
                isWorkspaceAddVisible: action.isWorkspaceAddVisible
            });
        case (0, $7CtTT.default).SET_WORKSPACE_VIEWPORT_POSITION:
            newWorkspaceDimensions = {};
            viewportPosition = $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state.viewportPosition), action.payload.position);
            if ($e4a743f8da7baec6$var$hasViewportPosition(viewportPosition) && !$e4a743f8da7baec6$var$contains({
                height: state.height,
                width: state.width,
                x: 0,
                y: 0
            }, viewportPosition)) newWorkspaceDimensions = {
                height: state.height * 2,
                width: state.width * 2
            };
            return $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state), newWorkspaceDimensions), {}, {
                viewportPosition: viewportPosition
            });
        case (0, $7CtTT.default).SET_CONFIG:
        case (0, $7CtTT.default).IMPORT_CONFIG:
        case (0, $7CtTT.default).UPDATE_CONFIG:
            return $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state), action.config.workspace);
        case (0, $7CtTT.default).IMPORT_MIRADOR_STATE:
            return action.state.workspace || {};
        case (0, $7CtTT.default).TOGGLE_DRAGGING:
            return $e4a743f8da7baec6$var$_objectSpread($e4a743f8da7baec6$var$_objectSpread({}, state), {}, {
                draggingEnabled: !state.draggingEnabled
            });
        default:
            return state;
    }
};


function $cf24dcd11ee58809$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cf24dcd11ee58809$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $cf24dcd11ee58809$var$ownKeys(Object(source), true).forEach(function(key) {
            $cf24dcd11ee58809$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $cf24dcd11ee58809$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cf24dcd11ee58809$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cf24dcd11ee58809$export$2e2bcd8739ae039(pluginReducers) {
    return (0, $k19ic.combineReducers)($cf24dcd11ee58809$var$_objectSpread({
        accessTokens: (0, $a839522a202c9ac5$export$d7b758c77335fd33),
        annotations: (0, $d61f94fc0f4df01c$export$5851330a61c651b8),
        auth: (0, $dd040eb6a01d7fb3$export$b3aa4dbb59e7857d),
        catalog: (0, $88808f398f003532$export$2f65e618d6a2bb81),
        companionWindows: (0, $e7041dc4135381e1$export$94bf2dca0275e147),
        config: (0, $5d0d949ec1c52f63$export$21f3d8f1fe4f2d8),
        elasticLayout: (0, $f2ab5acdaf261ede$export$3f64673c9071d634),
        errors: (0, $06e26c5102ef3b7f$export$ce00ddf575bea579),
        infoResponses: (0, $dab6f0e5d10a15b8$export$cd22fbc520bc423c),
        layers: (0, $feb7911e676721d8$export$eca2f5a0745255fb),
        manifests: (0, $a71ebeb4ee7e4bd2$export$bc3bd53317a29ffe),
        searches: (0, $4428321196a285de$export$6609a1d429307c63),
        viewers: (0, $eefca1db3103cfbf$export$127d9a04c8f08903),
        windows: (0, $85c03845757be162$export$ed49d226c8d5e0d6),
        workspace: (0, $e4a743f8da7baec6$export$5b85b33560271979)
    }, pluginReducers));
}


var $367a945b1d23cee9$exports = {};

$parcel$defineInteropFlag($367a945b1d23cee9$exports);

$parcel$export($367a945b1d23cee9$exports, "default", function () { return $367a945b1d23cee9$export$2e2bcd8739ae039; });
var $38f11260a35c9e11$exports = {};
// TODO(Babel 8): Remove this file.

var $38f11260a35c9e11$var$runtime = (parcelRequire("cK3Q5"))();
$38f11260a35c9e11$exports = $38f11260a35c9e11$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $38f11260a35c9e11$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $38f11260a35c9e11$var$runtime;
    else Function("r", "regeneratorRuntime = r")($38f11260a35c9e11$var$runtime);
}



parcelRequire("abElG");



var $792512301ef1185e$var$done = function done(value) {
    return {
        done: true,
        value: value
    };
};
var $792512301ef1185e$var$qEnd = {};
function $792512301ef1185e$var$safeName(patternOrChannel) {
    if ((0, $5c8ed2ed0ad83760$export$1f95fbd68d964d36)(patternOrChannel)) return "channel";
    if ((0, $5c8ed2ed0ad83760$export$32b5e46230afa379)(patternOrChannel)) return String(patternOrChannel);
    if ((0, $5c8ed2ed0ad83760$export$86951950244e2001)(patternOrChannel)) return patternOrChannel.name;
    return String(patternOrChannel);
}
function $792512301ef1185e$var$fsmIterator(fsm, startState, name) {
    var stateUpdater, errorState, effect, nextState = startState;
    function next(arg, error) {
        if (nextState === $792512301ef1185e$var$qEnd) return $792512301ef1185e$var$done(arg);
        if (error && !errorState) {
            nextState = $792512301ef1185e$var$qEnd;
            throw error;
        } else {
            stateUpdater && stateUpdater(arg);
            var currentState = error ? fsm[errorState](error) : fsm[nextState]();
            nextState = currentState.nextState;
            effect = currentState.effect;
            stateUpdater = currentState.stateUpdater;
            errorState = currentState.errorState;
            return nextState === $792512301ef1185e$var$qEnd ? $792512301ef1185e$var$done(arg) : effect;
        }
    }
    return (0, $95e707af523f0ac0$export$9e5f44173e64f162)(next, function(error) {
        return next(null, error);
    }, name);
}
function $792512301ef1185e$var$takeEvery(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $95e707af523f0ac0$export$61196ced6d74a310)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $95e707af523f0ac0$export$3a1a48c8f6ef640e).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action, setAction = function setAction(ac) {
        return action = ac;
    };
    return $792512301ef1185e$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q1",
                effect: yFork(action)
            };
        }
    }, "q1", "takeEvery(" + $792512301ef1185e$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $792512301ef1185e$var$takeLatest(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $95e707af523f0ac0$export$61196ced6d74a310)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $95e707af523f0ac0$export$3a1a48c8f6ef640e).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yCancel = function yCancel(task) {
        return {
            done: false,
            value: (0, $95e707af523f0ac0$export$a07804094c3ecf2d)(task)
        };
    };
    var task, action;
    var setTask = function setTask(t) {
        return task = t;
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $792512301ef1185e$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return task ? {
                nextState: "q3",
                effect: yCancel(task)
            } : {
                nextState: "q1",
                effect: yFork(action),
                stateUpdater: setTask
            };
        },
        q3: function q3() {
            return {
                nextState: "q1",
                effect: yFork(action),
                stateUpdater: setTask
            };
        }
    }, "q1", "takeLatest(" + $792512301ef1185e$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $792512301ef1185e$var$takeLeading(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $95e707af523f0ac0$export$61196ced6d74a310)(patternOrChannel)
    };
    var yCall = function yCall(ac) {
        return {
            done: false,
            value: (0, $95e707af523f0ac0$export$c4ce752e73470fba).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action;
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $792512301ef1185e$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q1",
                effect: yCall(action)
            };
        }
    }, "q1", "takeLeading(" + $792512301ef1185e$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $792512301ef1185e$var$throttle(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, channel$1;
    var yTake = function yTake() {
        return {
            done: false,
            value: (0, $95e707af523f0ac0$export$61196ced6d74a310)(channel$1)
        };
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $95e707af523f0ac0$export$3a1a48c8f6ef640e).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yDelay = {
        done: false,
        value: (0, $95e707af523f0ac0$export$3722cfe417b6ed86)(delayLength)
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setChannel = function setChannel(ch) {
        return channel$1 = ch;
    };
    var needsChannel = !(0, $5c8ed2ed0ad83760$export$1f95fbd68d964d36)(patternOrChannel);
    if (!needsChannel) setChannel(patternOrChannel);
    return $792512301ef1185e$var$fsmIterator({
        q1: function q1() {
            var yActionChannel = {
                done: false,
                value: (0, $95e707af523f0ac0$export$3a6d5c9ae78a2c08)(patternOrChannel, (0, $95e707af523f0ac0$export$e7c866399fa523f5)(1))
            };
            return {
                nextState: "q2",
                effect: yActionChannel,
                stateUpdater: setChannel
            };
        },
        q2: function q2() {
            return {
                nextState: "q3",
                effect: yTake(),
                stateUpdater: setAction
            };
        },
        q3: function q3() {
            return {
                nextState: "q4",
                effect: yFork(action)
            };
        },
        q4: function q4() {
            return {
                nextState: "q2",
                effect: yDelay
            };
        }
    }, needsChannel ? "q1" : "q2", "throttle(" + $792512301ef1185e$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $792512301ef1185e$var$retry(maxTries, delayLength, fn) {
    var counter = maxTries;
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var yCall = {
        done: false,
        value: (0, $95e707af523f0ac0$export$c4ce752e73470fba).apply(void 0, [
            fn
        ].concat(args))
    };
    var yDelay = {
        done: false,
        value: (0, $95e707af523f0ac0$export$3722cfe417b6ed86)(delayLength)
    };
    return $792512301ef1185e$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yCall,
                errorState: "q10"
            };
        },
        q2: function q2() {
            return {
                nextState: $792512301ef1185e$var$qEnd
            };
        },
        q10: function q10(error) {
            counter -= 1;
            if (counter <= 0) throw error;
            return {
                nextState: "q1",
                effect: yDelay
            };
        }
    }, "q1", "retry(" + fn.name + ")");
}
function $792512301ef1185e$var$debounceHelper(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, raceOutput;
    var yTake = {
        done: false,
        value: (0, $95e707af523f0ac0$export$61196ced6d74a310)(patternOrChannel)
    };
    var yRace = {
        done: false,
        value: (0, $95e707af523f0ac0$export$71cec2538cb2c617)({
            action: (0, $95e707af523f0ac0$export$61196ced6d74a310)(patternOrChannel),
            debounce: (0, $95e707af523f0ac0$export$3722cfe417b6ed86)(delayLength)
        })
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $95e707af523f0ac0$export$3a1a48c8f6ef640e).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yNoop = function yNoop(value) {
        return {
            done: false,
            value: value
        };
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setRaceOutput = function setRaceOutput(ro) {
        return raceOutput = ro;
    };
    return $792512301ef1185e$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q3",
                effect: yRace,
                stateUpdater: setRaceOutput
            };
        },
        q3: function q3() {
            return raceOutput.debounce ? {
                nextState: "q1",
                effect: yFork(action)
            } : {
                nextState: "q2",
                effect: yNoop(raceOutput.action),
                stateUpdater: setAction
            };
        }
    }, "q1", "debounce(" + $792512301ef1185e$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
var $792512301ef1185e$var$validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
    (0, $95e707af523f0ac0$export$db3b6bfb95261072)(patternOrChannel, (0, $5c8ed2ed0ad83760$export$1352885233577768), fn.name + " requires a pattern or channel");
    (0, $95e707af523f0ac0$export$db3b6bfb95261072)(worker, (0, $5c8ed2ed0ad83760$export$1352885233577768), fn.name + " requires a saga parameter");
};
function $792512301ef1185e$export$4e24be1e1c9d5c69(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return (0, $95e707af523f0ac0$export$3a1a48c8f6ef640e).apply(void 0, [
        $792512301ef1185e$var$takeEvery,
        patternOrChannel,
        worker
    ].concat(args));
}
function $792512301ef1185e$export$ca010cea618a298a(patternOrChannel, worker) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
    return (0, $95e707af523f0ac0$export$3a1a48c8f6ef640e).apply(void 0, [
        $792512301ef1185e$var$takeLatest,
        patternOrChannel,
        worker
    ].concat(args));
}
function $792512301ef1185e$export$ab18f80dcccecca4(patternOrChannel, worker) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
    return (0, $95e707af523f0ac0$export$3a1a48c8f6ef640e).apply(void 0, [
        $792512301ef1185e$var$takeLeading,
        patternOrChannel,
        worker
    ].concat(args));
}
function $792512301ef1185e$export$de363e709c412c8a(ms, patternOrChannel, worker) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++)args[_key4 - 3] = arguments[_key4];
    return (0, $95e707af523f0ac0$export$3a1a48c8f6ef640e).apply(void 0, [
        $792512301ef1185e$var$throttle,
        ms,
        patternOrChannel,
        worker
    ].concat(args));
}
function $792512301ef1185e$export$9369b12211e1fce4(maxTries, delayLength, worker) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++)args[_key5 - 3] = arguments[_key5];
    return (0, $95e707af523f0ac0$export$c4ce752e73470fba).apply(void 0, [
        $792512301ef1185e$var$retry,
        maxTries,
        delayLength,
        worker
    ].concat(args));
}
function $792512301ef1185e$export$61fc7d43ac8f84b0(delayLength, pattern, worker) {
    for(var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++)args[_key6 - 3] = arguments[_key6];
    return (0, $95e707af523f0ac0$export$3a1a48c8f6ef640e).apply(void 0, [
        $792512301ef1185e$var$debounceHelper,
        delayLength,
        pattern,
        worker
    ].concat(args));
}







var $aowE3 = parcelRequire("aowE3");


var $1df03f06aa946eb2$exports = {};


$1df03f06aa946eb2$exports = self.fetch || (self.fetch = (parcelRequire("kD81i")).default || (parcelRequire("kD81i")));



var $a4sDT = parcelRequire("a4sDT");

var $5lva4 = parcelRequire("5lva4");

var $7CtTT = parcelRequire("7CtTT");

var $61Aec = parcelRequire("61Aec");
var $kPH0F = parcelRequire("kPH0F");
var $6PGpp = parcelRequire("6PGpp");
var $kQy7d = parcelRequire("kQy7d");

var $7pPJC = parcelRequire("7pPJC");
var $dy9HC = parcelRequire("dy9HC");
var $jGts0 = parcelRequire("jGts0");
var $1MgBx = parcelRequire("1MgBx");
function $5c0bb2131eadfd57$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5c0bb2131eadfd57$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5c0bb2131eadfd57$var$ownKeys(Object(source), true).forEach(function(key) {
            $5c0bb2131eadfd57$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5c0bb2131eadfd57$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5c0bb2131eadfd57$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5c0bb2131eadfd57$var$_marked = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($5c0bb2131eadfd57$var$fetchIiifResource), $5c0bb2131eadfd57$var$_marked2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($5c0bb2131eadfd57$var$fetchIiifResourceWithAuth), $5c0bb2131eadfd57$var$_marked3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($5c0bb2131eadfd57$export$314985ea6858ebe9), $5c0bb2131eadfd57$var$_marked4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($5c0bb2131eadfd57$var$getAccessTokenService), $5c0bb2131eadfd57$var$_marked5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($5c0bb2131eadfd57$export$7b9a02b272fcba97), $5c0bb2131eadfd57$var$_marked6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($5c0bb2131eadfd57$export$4519dd6654ea6001), $5c0bb2131eadfd57$var$_marked7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($5c0bb2131eadfd57$export$c79ffb87be4ade0), $5c0bb2131eadfd57$var$_marked8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($5c0bb2131eadfd57$export$91a7b83347d2e9b9), $5c0bb2131eadfd57$var$_marked9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($5c0bb2131eadfd57$export$9c67ebb76c614fe), $5c0bb2131eadfd57$var$_marked10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($5c0bb2131eadfd57$export$2e2bcd8739ae039);
/** */ function $5c0bb2131eadfd57$var$fetchWrapper(url, options, _ref) {
    var success = _ref.success, degraded = _ref.degraded, failure = _ref.failure;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1df03f06aa946eb2$exports)))(url, options).then(function(response) {
        return response.json().then(function(json) {
            if (response.status === 401) return (degraded || success)({
                json: json,
                response: response
            });
            if (response.ok) return success({
                json: json,
                response: response
            });
            return failure({
                error: response.statusText,
                json: json,
                response: response
            });
        })["catch"](function(error) {
            return failure({
                error: error,
                response: response
            });
        });
    })["catch"](function(error) {
        return failure({
            error: error
        });
    });
}
/** */ function $5c0bb2131eadfd57$var$fetchIiifResource(url, options, _ref2) {
    var success, degraded, failure, _yield$select, _yield$select$preproc, preprocessors, _yield$select$postpro, postprocessors, reqOptions, action;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchIiifResource$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                success = _ref2.success, degraded = _ref2.degraded, failure = _ref2.failure;
                _context.next = 3;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $jGts0.getRequestsConfig));
            case 3:
                _yield$select = _context.sent;
                _yield$select$preproc = _yield$select.preprocessors;
                preprocessors = _yield$select$preproc === void 0 ? [] : _yield$select$preproc;
                _yield$select$postpro = _yield$select.postprocessors;
                postprocessors = _yield$select$postpro === void 0 ? [] : _yield$select$postpro;
                _context.prev = 8;
                reqOptions = preprocessors.reduce(function(acc, f) {
                    return f(url, acc) || acc;
                }, options);
                _context.next = 12;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($5c0bb2131eadfd57$var$fetchWrapper, url, reqOptions, {
                    degraded: degraded,
                    failure: failure,
                    success: success
                });
            case 12:
                action = _context.sent;
                action = postprocessors.reduce(function(acc, f) {
                    return f(url, acc) || acc;
                }, action);
                return _context.abrupt("return", action);
            case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](8);
                return _context.abrupt("return", failure({
                    error: _context.t0
                }));
            case 20:
            case "end":
                return _context.stop();
        }
    }, $5c0bb2131eadfd57$var$_marked, null, [
        [
            8,
            17
        ]
    ]);
}
/** */ function $5c0bb2131eadfd57$var$fetchIiifResourceWithAuth(url, iiifResource, options, _ref3) {
    var degraded, failure, success, urlOptions, tokenServiceId, tokenService, _yield$call, error, json, response, id, authoritativeTokenService;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchIiifResourceWithAuth$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                degraded = _ref3.degraded, failure = _ref3.failure, success = _ref3.success;
                urlOptions = $5c0bb2131eadfd57$var$_objectSpread({}, options);
                if (!iiifResource) {
                    _context2.next = 8;
                    break;
                }
                _context2.next = 5;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($5c0bb2131eadfd57$var$getAccessTokenService, iiifResource);
            case 5:
                tokenService = _context2.sent;
                tokenServiceId = tokenService && tokenService.id;
                if (tokenService && tokenService.json) urlOptions.headers = $5c0bb2131eadfd57$var$_objectSpread({
                    Authorization: "Bearer ".concat(tokenService.json.accessToken)
                }, options.headers);
            case 8:
                _context2.next = 10;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($5c0bb2131eadfd57$var$fetchIiifResource, url, urlOptions, {
                    failure: function failure(arg) {
                        return arg;
                    },
                    success: function success(arg) {
                        return arg;
                    }
                });
            case 10:
                _yield$call = _context2.sent;
                error = _yield$call.error;
                json = _yield$call.json;
                response = _yield$call.response;
                if (!error) {
                    _context2.next = 18;
                    break;
                }
                _context2.next = 17;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)(failure({
                    error: error,
                    json: json,
                    response: response,
                    tokenServiceId: tokenServiceId
                }));
            case 17:
                return _context2.abrupt("return");
            case 18:
                id = json["@id"] || json.id;
                if (!response.ok) {
                    _context2.next = 26;
                    break;
                }
                if (!((0, (/*@__PURE__*/$parcel$interopDefault($5lva4)))(id, {
                    stripAuthentication: false
                }) === (0, (/*@__PURE__*/$parcel$interopDefault($5lva4)))(url.replace(/info\.json$/, ""), {
                    stripAuthentication: false
                }))) {
                    _context2.next = 24;
                    break;
                }
                _context2.next = 23;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)(success({
                    json: json,
                    response: response,
                    tokenServiceId: tokenServiceId
                }));
            case 23:
                return _context2.abrupt("return");
            case 24:
                _context2.next = 30;
                break;
            case 26:
                if (!(response.status !== 401)) {
                    _context2.next = 30;
                    break;
                }
                _context2.next = 29;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)(failure({
                    error: error,
                    json: json,
                    response: response,
                    tokenServiceId: tokenServiceId
                }));
            case 29:
                return _context2.abrupt("return");
            case 30:
                _context2.next = 32;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($5c0bb2131eadfd57$var$getAccessTokenService, json);
            case 32:
                authoritativeTokenService = _context2.sent;
                if (!(authoritativeTokenService && authoritativeTokenService.id !== tokenServiceId)) {
                    _context2.next = 37;
                    break;
                }
                _context2.next = 36;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($5c0bb2131eadfd57$var$fetchIiifResourceWithAuth, url, json, options, {
                    degraded: degraded,
                    failure: failure,
                    success: success
                });
            case 36:
                return _context2.abrupt("return");
            case 37:
                _context2.next = 39;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((degraded || success)({
                    json: json,
                    response: response,
                    tokenServiceId: tokenServiceId
                }));
            case 39:
            case "end":
                return _context2.stop();
        }
    }, $5c0bb2131eadfd57$var$_marked2);
}
function $5c0bb2131eadfd57$export$314985ea6858ebe9(_ref4) {
    var manifestId, callbacks, dispatch;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchManifest$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                manifestId = _ref4.manifestId;
                callbacks = {
                    failure: function failure(_ref5) {
                        var error = _ref5.error, json = _ref5.json, response = _ref5.response;
                        return (0, $6PGpp.receiveManifestFailure)(manifestId, typeof error === "object" ? String(error) : error);
                    },
                    success: function success(_ref6) {
                        var json = _ref6.json, response = _ref6.response;
                        return (0, $6PGpp.receiveManifest)(manifestId, json);
                    }
                };
                _context3.next = 4;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($5c0bb2131eadfd57$var$fetchIiifResource, manifestId, {}, callbacks);
            case 4:
                dispatch = _context3.sent;
                _context3.next = 7;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)(dispatch);
            case 7:
            case "end":
                return _context3.stop();
        }
    }, $5c0bb2131eadfd57$var$_marked3);
}
/** @private */ function $5c0bb2131eadfd57$var$getAccessTokenService(resource) {
    var manifestoCompatibleResource, services, accessTokens, i, authService, accessTokenService, token;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function getAccessTokenService$(_context4) {
        while(true)switch(_context4.prev = _context4.next){
            case 0:
                manifestoCompatibleResource = resource && resource.__jsonld ? resource : $5c0bb2131eadfd57$var$_objectSpread($5c0bb2131eadfd57$var$_objectSpread({}, resource), {}, {
                    options: {}
                });
                services = (0, $a4sDT.Utils).getServices(manifestoCompatibleResource).filter(function(s) {
                    return s.getProfile().match(/http:\/\/iiif.io\/api\/auth\//);
                });
                if (!(services.length === 0)) {
                    _context4.next = 4;
                    break;
                }
                return _context4.abrupt("return", undefined);
            case 4:
                _context4.next = 6;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $7pPJC.getAccessTokens));
            case 6:
                accessTokens = _context4.sent;
                if (accessTokens) {
                    _context4.next = 9;
                    break;
                }
                return _context4.abrupt("return", undefined);
            case 9:
                i = 0;
            case 10:
                if (!(i < services.length)) {
                    _context4.next = 19;
                    break;
                }
                authService = services[i];
                accessTokenService = (0, $a4sDT.Utils).getService(authService, "http://iiif.io/api/auth/1/token") || (0, $a4sDT.Utils).getService(authService, "http://iiif.io/api/auth/0/token");
                token = accessTokenService && accessTokens[accessTokenService.id];
                if (!(token && token.json)) {
                    _context4.next = 16;
                    break;
                }
                return _context4.abrupt("return", token);
            case 16:
                i += 1;
                _context4.next = 10;
                break;
            case 19:
                return _context4.abrupt("return", undefined);
            case 20:
            case "end":
                return _context4.stop();
        }
    }, $5c0bb2131eadfd57$var$_marked4);
}
function $5c0bb2131eadfd57$export$7b9a02b272fcba97(_ref7) {
    var imageResource, infoId, windowId, iiifResource, callbacks;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchInfoResponse$(_context5) {
        while(true)switch(_context5.prev = _context5.next){
            case 0:
                imageResource = _ref7.imageResource, infoId = _ref7.infoId, windowId = _ref7.windowId;
                iiifResource = imageResource;
                if (iiifResource) {
                    _context5.next = 6;
                    break;
                }
                _context5.next = 5;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $1MgBx.selectInfoResponse), {
                    infoId: infoId
                });
            case 5:
                iiifResource = _context5.sent;
            case 6:
                callbacks = {
                    degraded: function degraded(_ref8) {
                        var json = _ref8.json, response = _ref8.response, tokenServiceId = _ref8.tokenServiceId;
                        return (0, $kPH0F.receiveDegradedInfoResponse)(infoId, json, response.ok, tokenServiceId, windowId);
                    },
                    failure: function failure(_ref9) {
                        var error = _ref9.error, json = _ref9.json, response = _ref9.response, tokenServiceId = _ref9.tokenServiceId;
                        return (0, $kPH0F.receiveInfoResponseFailure)(infoId, error, tokenServiceId);
                    },
                    success: function success(_ref10) {
                        var json = _ref10.json, response = _ref10.response, tokenServiceId = _ref10.tokenServiceId;
                        return (0, $kPH0F.receiveInfoResponse)(infoId, json, response.ok, tokenServiceId);
                    }
                };
                _context5.next = 9;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($5c0bb2131eadfd57$var$fetchIiifResourceWithAuth, "".concat(infoId.replace(/\/$/, ""), "/info.json"), iiifResource, {}, callbacks);
            case 9:
            case "end":
                return _context5.stop();
        }
    }, $5c0bb2131eadfd57$var$_marked5);
}
function $5c0bb2131eadfd57$export$4519dd6654ea6001(_ref11) {
    var windowId, companionWindowId, query, searchId, callbacks, dispatch;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchSearchResponse$(_context6) {
        while(true)switch(_context6.prev = _context6.next){
            case 0:
                windowId = _ref11.windowId, companionWindowId = _ref11.companionWindowId, query = _ref11.query, searchId = _ref11.searchId;
                callbacks = {
                    failure: function failure(_ref12) {
                        var error = _ref12.error, json = _ref12.json, response = _ref12.response;
                        return (0, $kQy7d.receiveSearchFailure)(windowId, companionWindowId, searchId, error);
                    },
                    success: function success(_ref13) {
                        var json = _ref13.json, response = _ref13.response;
                        return (0, $kQy7d.receiveSearch)(windowId, companionWindowId, searchId, json);
                    }
                };
                _context6.next = 4;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($5c0bb2131eadfd57$var$fetchIiifResource, searchId, {}, callbacks);
            case 4:
                dispatch = _context6.sent;
                _context6.next = 7;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)(dispatch);
            case 7:
            case "end":
                return _context6.stop();
        }
    }, $5c0bb2131eadfd57$var$_marked6);
}
function $5c0bb2131eadfd57$export$c79ffb87be4ade0(_ref14) {
    var targetId, annotationId, callbacks, dispatch;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchAnnotation$(_context7) {
        while(true)switch(_context7.prev = _context7.next){
            case 0:
                targetId = _ref14.targetId, annotationId = _ref14.annotationId;
                callbacks = {
                    failure: function failure(_ref15) {
                        var error = _ref15.error, json = _ref15.json, response = _ref15.response;
                        return (0, $61Aec.receiveAnnotationFailure)(targetId, annotationId, error);
                    },
                    success: function success(_ref16) {
                        var json = _ref16.json, response = _ref16.response;
                        return (0, $61Aec.receiveAnnotation)(targetId, annotationId, json);
                    }
                };
                _context7.next = 4;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($5c0bb2131eadfd57$var$fetchIiifResource, annotationId, {}, callbacks);
            case 4:
                dispatch = _context7.sent;
                _context7.next = 7;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)(dispatch);
            case 7:
            case "end":
                return _context7.stop();
        }
    }, $5c0bb2131eadfd57$var$_marked7);
}
function $5c0bb2131eadfd57$export$91a7b83347d2e9b9(_ref17) {
    var manifestId, manifestJson, manifests;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchResourceManifest$(_context8) {
        while(true)switch(_context8.prev = _context8.next){
            case 0:
                manifestId = _ref17.manifestId, manifestJson = _ref17.manifestJson;
                if (!manifestJson) {
                    _context8.next = 5;
                    break;
                }
                _context8.next = 4;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $6PGpp.receiveManifest)(manifestId, manifestJson));
            case 4:
                return _context8.abrupt("return");
            case 5:
                if (manifestId) {
                    _context8.next = 7;
                    break;
                }
                return _context8.abrupt("return");
            case 7:
                _context8.next = 9;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $dy9HC.getManifests)) || {};
            case 9:
                manifests = _context8.sent;
                if (manifests[manifestId]) {
                    _context8.next = 12;
                    break;
                }
                return _context8.delegateYield($5c0bb2131eadfd57$export$314985ea6858ebe9({
                    manifestId: manifestId
                }), "t0", 12);
            case 12:
            case "end":
                return _context8.stop();
        }
    }, $5c0bb2131eadfd57$var$_marked8);
}
function $5c0bb2131eadfd57$export$9c67ebb76c614fe() {
    var manifests, i, manifestId, _args9 = arguments;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchManifests$(_context9) {
        while(true)switch(_context9.prev = _context9.next){
            case 0:
                _context9.next = 2;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $dy9HC.getManifests));
            case 2:
                manifests = _context9.sent;
                i = 0;
            case 4:
                if (!(i < _args9.length)) {
                    _context9.next = 12;
                    break;
                }
                manifestId = i < 0 || _args9.length <= i ? undefined : _args9[i];
                if (manifests[manifestId]) {
                    _context9.next = 9;
                    break;
                }
                _context9.next = 9;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($5c0bb2131eadfd57$export$314985ea6858ebe9, {
                    manifestId: manifestId
                });
            case 9:
                i += 1;
                _context9.next = 4;
                break;
            case 12:
            case "end":
                return _context9.stop();
        }
    }, $5c0bb2131eadfd57$var$_marked9);
}
function $5c0bb2131eadfd57$export$2e2bcd8739ae039() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function iiifSaga$(_context10) {
        while(true)switch(_context10.prev = _context10.next){
            case 0:
                _context10.next = 2;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)([
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).REQUEST_MANIFEST, $5c0bb2131eadfd57$export$314985ea6858ebe9),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).REQUEST_INFO_RESPONSE, $5c0bb2131eadfd57$export$7b9a02b272fcba97),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).REQUEST_SEARCH, $5c0bb2131eadfd57$export$4519dd6654ea6001),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).REQUEST_ANNOTATION, $5c0bb2131eadfd57$export$c79ffb87be4ade0),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).ADD_RESOURCE, $5c0bb2131eadfd57$export$91a7b83347d2e9b9)
                ]);
            case 2:
            case "end":
                return _context10.stop();
        }
    }, $5c0bb2131eadfd57$var$_marked10);
}





var $7CtTT = parcelRequire("7CtTT");

var $25EET = parcelRequire("25EET");

var $izTcV = parcelRequire("izTcV");

var $kPH0F = parcelRequire("kPH0F");
var $kQy7d = parcelRequire("kQy7d");
var $6PGpp = parcelRequire("6PGpp");
var $61Aec = parcelRequire("61Aec");
var $in9CU = parcelRequire("in9CU");
var $bcVRp = parcelRequire("bcVRp");
var $k4YEs = parcelRequire("k4YEs");

var $1MgBx = parcelRequire("1MgBx");
var $bvh50 = parcelRequire("bvh50");
var $24Kso = parcelRequire("24Kso");
var $3DW53 = parcelRequire("3DW53");
var $7GY88 = parcelRequire("7GY88");
var $dy9HC = parcelRequire("dy9HC");
var $9E7MS = parcelRequire("9E7MS");

var $c412572b8ce8b59d$var$_marked = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$d0674690a952d502), $c412572b8ce8b59d$var$_marked2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$737c7d8a3b4d0740), $c412572b8ce8b59d$var$_marked3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$85580fe40970b353), $c412572b8ce8b59d$var$_marked4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$f7b98f06039c46ef), $c412572b8ce8b59d$var$_marked5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$9d2244806f7d02cd), $c412572b8ce8b59d$var$_marked6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$e33e8e42522da8ed), $c412572b8ce8b59d$var$_marked7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$1cab088a393d1e4d), $c412572b8ce8b59d$var$_marked8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$e528333864804b6d), $c412572b8ce8b59d$var$_marked9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$e07a1ab6c216e43c), $c412572b8ce8b59d$var$_marked10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$b2724feb17175f59), $c412572b8ce8b59d$var$_marked11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$7b1ced5421434aaa), $c412572b8ce8b59d$var$_marked12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$560f55d82871ccdb), $c412572b8ce8b59d$var$_marked13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$9a3b12a015530ada), $c412572b8ce8b59d$var$_marked14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($c412572b8ce8b59d$export$2e2bcd8739ae039);
function $c412572b8ce8b59d$var$_toConsumableArray(arr) {
    return $c412572b8ce8b59d$var$_arrayWithoutHoles(arr) || $c412572b8ce8b59d$var$_iterableToArray(arr) || $c412572b8ce8b59d$var$_unsupportedIterableToArray(arr) || $c412572b8ce8b59d$var$_nonIterableSpread();
}
function $c412572b8ce8b59d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c412572b8ce8b59d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c412572b8ce8b59d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c412572b8ce8b59d$var$_arrayLikeToArray(o, minLen);
}
function $c412572b8ce8b59d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c412572b8ce8b59d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c412572b8ce8b59d$var$_arrayLikeToArray(arr);
}
function $c412572b8ce8b59d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c412572b8ce8b59d$export$d0674690a952d502(action) {
    var _ref, collectionPath, id, manifestId;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchWindowManifest$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _ref = action.payload || action.window, collectionPath = _ref.collectionPath, id = _ref.id, manifestId = _ref.manifestId;
                if (manifestId) {
                    _context.next = 3;
                    break;
                }
                return _context.abrupt("return");
            case 3:
                if (!action.manifest) {
                    _context.next = 8;
                    break;
                }
                _context.next = 6;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $6PGpp.receiveManifest)(manifestId, action.manifest));
            case 6:
                _context.next = 10;
                break;
            case 8:
                _context.next = 10;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba).apply(void 0, [
                    (0, $5c0bb2131eadfd57$export$9c67ebb76c614fe),
                    manifestId
                ].concat($c412572b8ce8b59d$var$_toConsumableArray(collectionPath || [])));
            case 10:
                _context.next = 12;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($c412572b8ce8b59d$export$9d2244806f7d02cd, action);
            case 12:
                _context.next = 14;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($c412572b8ce8b59d$export$e33e8e42522da8ed, action);
            case 14:
                if (collectionPath) {
                    _context.next = 17;
                    break;
                }
                _context.next = 17;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($c412572b8ce8b59d$export$85580fe40970b353, {
                    manifestId: manifestId,
                    windowId: action.id || action.window.id
                });
            case 17:
                _context.next = 19;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($c412572b8ce8b59d$export$9a3b12a015530ada, manifestId, id);
            case 19:
            case "end":
                return _context.stop();
        }
    }, $c412572b8ce8b59d$var$_marked);
}
function $c412572b8ce8b59d$export$737c7d8a3b4d0740(action) {
    var windowId, canvases, thunk;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function setCanvasOnNewSequence$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                windowId = action.id;
                if (!(!action || !action.payload || !action.payload.sequenceId)) {
                    _context2.next = 3;
                    break;
                }
                return _context2.abrupt("return");
            case 3:
                _context2.next = 5;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $1MgBx.getCanvases), {
                    windowId: windowId
                });
            case 5:
                canvases = _context2.sent;
                if (!(!canvases || !canvases[0] || !canvases[0].id)) {
                    _context2.next = 8;
                    break;
                }
                return _context2.abrupt("return");
            case 8:
                _context2.next = 10;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)((0, $in9CU.setCanvas), windowId, canvases[0].id);
            case 10:
                thunk = _context2.sent;
                _context2.next = 13;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)(thunk);
            case 13:
            case "end":
                return _context2.stop();
        }
    }, $c412572b8ce8b59d$var$_marked2);
}
function $c412572b8ce8b59d$export$85580fe40970b353(_ref2) {
    var manifestId, windowId, manifestoInstance, partOfs, partOf;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function setCollectionPath$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                manifestId = _ref2.manifestId, windowId = _ref2.windowId;
                _context3.next = 3;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $7GY88.getManifestoInstance), {
                    manifestId: manifestId
                });
            case 3:
                manifestoInstance = _context3.sent;
                if (!manifestoInstance) {
                    _context3.next = 10;
                    break;
                }
                partOfs = manifestoInstance.getProperty("partOf");
                partOf = Array.isArray(partOfs) ? partOfs[0] : partOfs;
                if (!(partOf && partOf.id)) {
                    _context3.next = 10;
                    break;
                }
                _context3.next = 10;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $k4YEs.updateWindow)(windowId, {
                    collectionPath: [
                        partOf.id
                    ]
                }));
            case 10:
            case "end":
                return _context3.stop();
        }
    }, $c412572b8ce8b59d$var$_marked3);
}
function $c412572b8ce8b59d$export$f7b98f06039c46ef(action) {
    var collectionPath;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchCollectionManifests$(_context4) {
        while(true)switch(_context4.prev = _context4.next){
            case 0:
                collectionPath = action.payload.collectionPath;
                if (collectionPath) {
                    _context4.next = 3;
                    break;
                }
                return _context4.abrupt("return");
            case 3:
                _context4.next = 5;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba).apply(void 0, [
                    (0, $5c0bb2131eadfd57$export$9c67ebb76c614fe)
                ].concat($c412572b8ce8b59d$var$_toConsumableArray(collectionPath)));
            case 5:
            case "end":
                return _context4.stop();
        }
    }, $c412572b8ce8b59d$var$_marked4);
}
function $c412572b8ce8b59d$export$9d2244806f7d02cd(action) {
    var _ref3, canvasId, canvasIndex, manifestId, windowId, thunk, manifestoInstance, miradorManifest, startCanvas, _thunk;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function setWindowStartingCanvas$(_context5) {
        while(true)switch(_context5.prev = _context5.next){
            case 0:
                _ref3 = action.payload || action.window, canvasId = _ref3.canvasId, canvasIndex = _ref3.canvasIndex, manifestId = _ref3.manifestId;
                windowId = action.id || action.window.id;
                if (!canvasId) {
                    _context5.next = 10;
                    break;
                }
                _context5.next = 5;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)((0, $in9CU.setCanvas), windowId, canvasId, null, {
                    preserveViewport: !!action.payload
                });
            case 5:
                thunk = _context5.sent;
                _context5.next = 8;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)(thunk);
            case 8:
                _context5.next = 22;
                break;
            case 10:
                _context5.next = 12;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $7GY88.getManifestoInstance), {
                    manifestId: manifestId
                });
            case 12:
                manifestoInstance = _context5.sent;
                if (!manifestoInstance) {
                    _context5.next = 22;
                    break;
                }
                // set the startCanvas
                miradorManifest = new (0, $25EET.default)(manifestoInstance);
                startCanvas = miradorManifest.startCanvas || miradorManifest.canvasAt(canvasIndex || 0) || miradorManifest.canvasAt(0);
                if (!startCanvas) {
                    _context5.next = 22;
                    break;
                }
                _context5.next = 19;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)((0, $in9CU.setCanvas), windowId, startCanvas.id);
            case 19:
                _thunk = _context5.sent;
                _context5.next = 22;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)(_thunk);
            case 22:
            case "end":
                return _context5.stop();
        }
    }, $c412572b8ce8b59d$var$_marked5);
}
function $c412572b8ce8b59d$export$e33e8e42522da8ed(action) {
    var _action$window, windowId, defaultSearchQuery, searchService, companionWindowIds, companionWindowId, searchId;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function setWindowDefaultSearchQuery$(_context6) {
        while(true)switch(_context6.prev = _context6.next){
            case 0:
                if (!(!action.window || !action.window.defaultSearchQuery)) {
                    _context6.next = 2;
                    break;
                }
                return _context6.abrupt("return");
            case 2:
                _action$window = action.window, windowId = _action$window.id, defaultSearchQuery = _action$window.defaultSearchQuery;
                _context6.next = 5;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $7GY88.getManifestSearchService), {
                    windowId: windowId
                });
            case 5:
                searchService = _context6.sent;
                _context6.next = 8;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $24Kso.getCompanionWindowIdsForPosition), {
                    position: "left",
                    windowId: windowId
                });
            case 8:
                companionWindowIds = _context6.sent;
                companionWindowId = companionWindowIds[0];
                if (!(searchService && companionWindowId)) {
                    _context6.next = 14;
                    break;
                }
                searchId = searchService && "".concat(searchService.id, "?q=").concat(defaultSearchQuery);
                _context6.next = 14;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $kQy7d.fetchSearch)(windowId, companionWindowId, searchId, defaultSearchQuery));
            case 14:
            case "end":
                return _context6.stop();
        }
    }, $c412572b8ce8b59d$var$_marked6);
}
function $c412572b8ce8b59d$export$19bd87971cbf997b(state, _ref4) {
    var canvasIds = _ref4.canvasIds, companionWindowIds = _ref4.companionWindowIds, windowId = _ref4.windowId;
    var annotationBySearch = companionWindowIds.reduce(function(accumulator, companionWindowId) {
        var annotations = (0, $bvh50.getSearchAnnotationsForCompanionWindow)(state, {
            companionWindowId: companionWindowId,
            windowId: windowId
        });
        var resourceAnnotations = annotations.resources;
        var hitAnnotation = resourceAnnotations.find(function(r) {
            return canvasIds.includes(r.targetId);
        });
        if (hitAnnotation) accumulator[companionWindowId] = [
            hitAnnotation.id
        ];
        return accumulator;
    }, {});
    return annotationBySearch;
}
function $c412572b8ce8b59d$export$1cab088a393d1e4d(_ref5) {
    var annotationId, windowId, visibleCanvases, searches, companionWindowIds, annotationBySearch;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function setCurrentAnnotationsOnCurrentCanvas$(_context7) {
        while(true)switch(_context7.prev = _context7.next){
            case 0:
                annotationId = _ref5.annotationId, windowId = _ref5.windowId, visibleCanvases = _ref5.visibleCanvases;
                _context7.next = 3;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $bvh50.getSearchForWindow), {
                    windowId: windowId
                });
            case 3:
                searches = _context7.sent;
                companionWindowIds = Object.keys(searches || {});
                if (!(companionWindowIds.length === 0)) {
                    _context7.next = 7;
                    break;
                }
                return _context7.abrupt("return");
            case 7:
                _context7.next = 9;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)($c412572b8ce8b59d$export$19bd87971cbf997b, {
                    canvasIds: visibleCanvases,
                    companionWindowIds: companionWindowIds,
                    windowId: windowId
                });
            case 9:
                annotationBySearch = _context7.sent;
                _context7.next = 12;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)(Object.keys(annotationBySearch).map(function(companionWindowId) {
                    return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $kQy7d.setContentSearchCurrentAnnotation)(windowId, companionWindowId, annotationBySearch[companionWindowId]));
                }));
            case 12:
                if (!(Object.values(annotationBySearch).length > 0)) {
                    _context7.next = 15;
                    break;
                }
                _context7.next = 15;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $61Aec.selectAnnotation)(windowId, Object.values(annotationBySearch)[0][0]));
            case 15:
            case "end":
                return _context7.stop();
        }
    }, $c412572b8ce8b59d$var$_marked7);
}
function $c412572b8ce8b59d$export$e528333864804b6d(_ref6) {
    var pan, windowId, elasticLayout, _ref7, x, y, width, height, _yield$select, _yield$select$viewpor, viewWidth, viewHeight;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function panToFocusedWindow$(_context8) {
        while(true)switch(_context8.prev = _context8.next){
            case 0:
                pan = _ref6.pan, windowId = _ref6.windowId;
                if (pan) {
                    _context8.next = 3;
                    break;
                }
                return _context8.abrupt("return");
            case 3:
                _context8.next = 5;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $3DW53.getElasticLayout));
            case 5:
                elasticLayout = _context8.sent;
                _ref7 = elasticLayout[windowId] || {}, x = _ref7.x, y = _ref7.y, width = _ref7.width, height = _ref7.height;
                _context8.next = 9;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $dy9HC.getWorkspace));
            case 9:
                _yield$select = _context8.sent;
                _yield$select$viewpor = _yield$select.viewportPosition;
                viewWidth = _yield$select$viewpor.width;
                viewHeight = _yield$select$viewpor.height;
                _context8.next = 15;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $bcVRp.setWorkspaceViewportPosition)({
                    x: x + width / 2 - viewWidth / 2,
                    y: y + height / 2 - viewHeight / 2
                }));
            case 15:
            case "end":
                return _context8.stop();
        }
    }, $c412572b8ce8b59d$var$_marked8);
}
function $c412572b8ce8b59d$export$e07a1ab6c216e43c(_ref8) {
    var windowId, _yield$select2, canvasId, visibleCanvases;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function updateVisibleCanvases$(_context9) {
        while(true)switch(_context9.prev = _context9.next){
            case 0:
                windowId = _ref8.windowId;
                _context9.next = 3;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $dy9HC.getWindow), {
                    windowId: windowId
                });
            case 3:
                _yield$select2 = _context9.sent;
                canvasId = _yield$select2.canvasId;
                _context9.next = 7;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $1MgBx.getCanvasGrouping), {
                    canvasId: canvasId,
                    windowId: windowId
                });
            case 7:
                visibleCanvases = _context9.sent;
                _context9.next = 10;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $k4YEs.updateWindow)(windowId, {
                    visibleCanvases: (visibleCanvases || []).map(function(c) {
                        return c.id;
                    })
                }));
            case 10:
            case "end":
                return _context9.stop();
        }
    }, $c412572b8ce8b59d$var$_marked9);
}
function $c412572b8ce8b59d$export$b2724feb17175f59(_ref9) {
    var companionWindowId, windowId, _yield$select3, switchCanvasOnSearch, selectedIds, annotations;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function setCanvasOfFirstSearchResult$(_context10) {
        while(true)switch(_context10.prev = _context10.next){
            case 0:
                companionWindowId = _ref9.companionWindowId, windowId = _ref9.windowId;
                _context10.next = 3;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $9E7MS.getWindowConfig), {
                    windowId: windowId
                });
            case 3:
                _yield$select3 = _context10.sent;
                switchCanvasOnSearch = _yield$select3.switchCanvasOnSearch;
                if (switchCanvasOnSearch) {
                    _context10.next = 7;
                    break;
                }
                return _context10.abrupt("return");
            case 7:
                _context10.next = 9;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $bvh50.getSelectedContentSearchAnnotationIds), {
                    companionWindowId: companionWindowId,
                    windowId: windowId
                });
            case 9:
                selectedIds = _context10.sent;
                if (!(selectedIds.length !== 0)) {
                    _context10.next = 12;
                    break;
                }
                return _context10.abrupt("return");
            case 12:
                _context10.next = 14;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $bvh50.getSortedSearchAnnotationsForCompanionWindow), {
                    companionWindowId: companionWindowId,
                    windowId: windowId
                });
            case 14:
                annotations = _context10.sent;
                if (!(!annotations || annotations.length === 0)) {
                    _context10.next = 17;
                    break;
                }
                return _context10.abrupt("return");
            case 17:
                _context10.next = 19;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $61Aec.selectAnnotation)(windowId, annotations[0].id));
            case 19:
            case "end":
                return _context10.stop();
        }
    }, $c412572b8ce8b59d$var$_marked10);
}
function $c412572b8ce8b59d$export$7b1ced5421434aaa(_ref10) {
    var annotationId, windowId, canvasIds, canvas, thunk;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function setCanvasforSelectedAnnotation$(_context11) {
        while(true)switch(_context11.prev = _context11.next){
            case 0:
                annotationId = _ref10.annotationId, windowId = _ref10.windowId;
                _context11.next = 3;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $1MgBx.getVisibleCanvasIds), {
                    windowId: windowId
                });
            case 3:
                canvasIds = _context11.sent;
                _context11.next = 6;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $bvh50.getCanvasForAnnotation), {
                    annotationId: annotationId,
                    windowId: windowId
                });
            case 6:
                canvas = _context11.sent;
                if (!(!canvas || canvasIds.includes(canvas.id))) {
                    _context11.next = 9;
                    break;
                }
                return _context11.abrupt("return");
            case 9:
                _context11.next = 11;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)((0, $in9CU.setCanvas), windowId, canvas.id);
            case 11:
                thunk = _context11.sent;
                _context11.next = 14;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)(thunk);
            case 14:
            case "end":
                return _context11.stop();
        }
    }, $c412572b8ce8b59d$var$_marked11);
}
function $c412572b8ce8b59d$export$560f55d82871ccdb(_ref11) {
    var visibleCanvasIds, windowId, canvases, infoResponses, visibleCanvases;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchInfoResponses$(_context12) {
        while(true)switch(_context12.prev = _context12.next){
            case 0:
                visibleCanvasIds = _ref11.visibleCanvases, windowId = _ref11.windowId;
                _context12.next = 3;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $1MgBx.getCanvases), {
                    windowId: windowId
                });
            case 3:
                canvases = _context12.sent;
                _context12.next = 6;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $1MgBx.selectInfoResponses));
            case 6:
                infoResponses = _context12.sent;
                visibleCanvases = (canvases || []).filter(function(c) {
                    return visibleCanvasIds.includes(c.id);
                });
                _context12.next = 10;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)(visibleCanvases.map(function(canvas) {
                    var miradorCanvas = new (0, $izTcV.default)(canvas);
                    return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)(miradorCanvas.iiifImageResources.map(function(imageResource) {
                        return !infoResponses[imageResource.getServices()[0].id] && (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $kPH0F.fetchInfoResponse)({
                            imageResource: imageResource,
                            windowId: windowId
                        }));
                    }).filter(Boolean));
                }));
            case 10:
            case "end":
                return _context12.stop();
        }
    }, $c412572b8ce8b59d$var$_marked12);
}
function $c412572b8ce8b59d$export$9a3b12a015530ada(manifestId, windowId) {
    var manifestoInstance;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function determineAndShowCollectionDialog$(_context13) {
        while(true)switch(_context13.prev = _context13.next){
            case 0:
                _context13.next = 2;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $7GY88.getManifestoInstance), {
                    manifestId: manifestId
                });
            case 2:
                manifestoInstance = _context13.sent;
                if (!(manifestoInstance && manifestoInstance.isCollection())) {
                    _context13.next = 6;
                    break;
                }
                _context13.next = 6;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $k4YEs.showCollectionDialog)(manifestId, [], windowId));
            case 6:
            case "end":
                return _context13.stop();
        }
    }, $c412572b8ce8b59d$var$_marked13);
}
function $c412572b8ce8b59d$export$2e2bcd8739ae039() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function windowsSaga$(_context14) {
        while(true)switch(_context14.prev = _context14.next){
            case 0:
                _context14.next = 2;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)([
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).ADD_WINDOW, $c412572b8ce8b59d$export$d0674690a952d502),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).UPDATE_WINDOW, $c412572b8ce8b59d$export$d0674690a952d502),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).UPDATE_WINDOW, $c412572b8ce8b59d$export$737c7d8a3b4d0740),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).SET_CANVAS, $c412572b8ce8b59d$export$1cab088a393d1e4d),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).SET_CANVAS, $c412572b8ce8b59d$export$560f55d82871ccdb),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).UPDATE_COMPANION_WINDOW, $c412572b8ce8b59d$export$f7b98f06039c46ef),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).SET_WINDOW_VIEW_TYPE, $c412572b8ce8b59d$export$e07a1ab6c216e43c),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).RECEIVE_SEARCH, $c412572b8ce8b59d$export$b2724feb17175f59),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).SELECT_ANNOTATION, $c412572b8ce8b59d$export$7b1ced5421434aaa),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).FOCUS_WINDOW, $c412572b8ce8b59d$export$e528333864804b6d)
                ]);
            case 2:
            case "end":
                return _context14.stop();
        }
    }, $c412572b8ce8b59d$var$_marked14);
}



var $k4YEs = parcelRequire("k4YEs");

var $7CtTT = parcelRequire("7CtTT");
function $979cb186030559e4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $979cb186030559e4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $979cb186030559e4$var$ownKeys(Object(source), true).forEach(function(key) {
            $979cb186030559e4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $979cb186030559e4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $979cb186030559e4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $979cb186030559e4$var$_marked = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($979cb186030559e4$export$6e60cc7ac044108b), $979cb186030559e4$var$_marked2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($979cb186030559e4$export$f8e3c1f829b275d3), $979cb186030559e4$var$_marked3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($979cb186030559e4$export$f7b98f06039c46ef), $979cb186030559e4$var$_marked4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($979cb186030559e4$export$2e2bcd8739ae039);
function $979cb186030559e4$var$_slicedToArray(arr, i) {
    return $979cb186030559e4$var$_arrayWithHoles(arr) || $979cb186030559e4$var$_iterableToArrayLimit(arr, i) || $979cb186030559e4$var$_unsupportedIterableToArray(arr, i) || $979cb186030559e4$var$_nonIterableRest();
}
function $979cb186030559e4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $979cb186030559e4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $979cb186030559e4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $979cb186030559e4$var$_toConsumableArray(arr) {
    return $979cb186030559e4$var$_arrayWithoutHoles(arr) || $979cb186030559e4$var$_iterableToArray(arr) || $979cb186030559e4$var$_unsupportedIterableToArray(arr) || $979cb186030559e4$var$_nonIterableSpread();
}
function $979cb186030559e4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $979cb186030559e4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $979cb186030559e4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $979cb186030559e4$var$_arrayLikeToArray(o, minLen);
}
function $979cb186030559e4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $979cb186030559e4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $979cb186030559e4$var$_arrayLikeToArray(arr);
}
function $979cb186030559e4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $979cb186030559e4$export$6e60cc7ac044108b(action) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function importState$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _context.next = 2;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)([].concat($979cb186030559e4$var$_toConsumableArray(Object.entries(action.state.windows || {}).map(function(_ref) {
                    var _ref2 = $979cb186030559e4$var$_slicedToArray(_ref, 2), _ = _ref2[0], window = _ref2[1];
                    return (0, $95e707af523f0ac0$export$c4ce752e73470fba)((0, $c412572b8ce8b59d$export$d0674690a952d502), {
                        id: window.id,
                        payload: window
                    });
                })), $979cb186030559e4$var$_toConsumableArray(Object.entries(action.state.manifests || {}).filter(function(_ref3) {
                    var _ref4 = $979cb186030559e4$var$_slicedToArray(_ref3, 2), _ = _ref4[0], manifest = _ref4[1];
                    return !manifest.json;
                }).map(function(_ref5) {
                    var _ref6 = $979cb186030559e4$var$_slicedToArray(_ref5, 2), _ = _ref6[0], manifest = _ref6[1];
                    return (0, $95e707af523f0ac0$export$c4ce752e73470fba)((0, $5c0bb2131eadfd57$export$9c67ebb76c614fe), manifest.id);
                }))));
            case 2:
            case "end":
                return _context.stop();
        }
    }, $979cb186030559e4$var$_marked);
}
function $979cb186030559e4$export$f8e3c1f829b275d3(_ref7) {
    var _ref7$config, thumbnailNavigation, windows, thunks;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function importConfig$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _ref7$config = _ref7.config, thumbnailNavigation = _ref7$config.thumbnailNavigation, windows = _ref7$config.windows;
                if (!(!windows || windows.length === 0)) {
                    _context2.next = 3;
                    break;
                }
                return _context2.abrupt("return");
            case 3:
                _context2.next = 5;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)(windows.map(function(miradorWindow) {
                    var windowId = "window-".concat((0, $aowE3.default)());
                    var manifestId = miradorWindow.manifestId || miradorWindow.loadedManifest;
                    return (0, $95e707af523f0ac0$export$c4ce752e73470fba)((0, $k4YEs.addWindow), $979cb186030559e4$var$_objectSpread({
                        // these are default values ...
                        id: windowId,
                        manifestId: manifestId,
                        thumbnailNavigationPosition: thumbnailNavigation && thumbnailNavigation.defaultPosition
                    }, miradorWindow));
                }));
            case 5:
                thunks = _context2.sent;
                _context2.next = 8;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)(thunks.map(function(thunk) {
                    return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)(thunk);
                }));
            case 8:
            case "end":
                return _context2.stop();
        }
    }, $979cb186030559e4$var$_marked2);
}
function $979cb186030559e4$export$f7b98f06039c46ef(action) {
    var collectionPath, manifestId;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchCollectionManifests$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                collectionPath = action.collectionPath, manifestId = action.manifestId;
                _context3.next = 3;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba).apply(void 0, [
                    (0, $5c0bb2131eadfd57$export$9c67ebb76c614fe),
                    manifestId
                ].concat($979cb186030559e4$var$_toConsumableArray(collectionPath)));
            case 3:
            case "end":
                return _context3.stop();
        }
    }, $979cb186030559e4$var$_marked3);
}
function $979cb186030559e4$export$2e2bcd8739ae039() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function appSaga$(_context4) {
        while(true)switch(_context4.prev = _context4.next){
            case 0:
                _context4.next = 2;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)([
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).IMPORT_MIRADOR_STATE, $979cb186030559e4$export$6e60cc7ac044108b),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).IMPORT_CONFIG, $979cb186030559e4$export$f8e3c1f829b275d3),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).SHOW_COLLECTION_DIALOG, $979cb186030559e4$export$f7b98f06039c46ef)
                ]);
            case 2:
            case "end":
                return _context4.stop();
        }
    }, $979cb186030559e4$var$_marked4);
}







var $61Aec = parcelRequire("61Aec");

var $dj0kG = parcelRequire("dj0kG");
var $1MgBx = parcelRequire("1MgBx");

var $7CtTT = parcelRequire("7CtTT");

var $izTcV = parcelRequire("izTcV");
var $ea87ed0b788dc7a8$var$_marked = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($ea87ed0b788dc7a8$export$bd30a22dba1f51c2), $ea87ed0b788dc7a8$var$_marked2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($ea87ed0b788dc7a8$export$20f6b62d67ced347), $ea87ed0b788dc7a8$var$_marked3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($ea87ed0b788dc7a8$export$2e2bcd8739ae039);
function $ea87ed0b788dc7a8$var$_toConsumableArray(arr) {
    return $ea87ed0b788dc7a8$var$_arrayWithoutHoles(arr) || $ea87ed0b788dc7a8$var$_iterableToArray(arr) || $ea87ed0b788dc7a8$var$_unsupportedIterableToArray(arr) || $ea87ed0b788dc7a8$var$_nonIterableSpread();
}
function $ea87ed0b788dc7a8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ea87ed0b788dc7a8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ea87ed0b788dc7a8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ea87ed0b788dc7a8$var$_arrayLikeToArray(o, minLen);
}
function $ea87ed0b788dc7a8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ea87ed0b788dc7a8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ea87ed0b788dc7a8$var$_arrayLikeToArray(arr);
}
function $ea87ed0b788dc7a8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ea87ed0b788dc7a8$export$bd30a22dba1f51c2(_ref) {
    var canvasId, windowId, canvas, annotations, miradorCanvas;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchCanvasAnnotations$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                canvasId = _ref.canvasId, windowId = _ref.windowId;
                _context.next = 3;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $1MgBx.getCanvas), {
                    canvasId: canvasId,
                    windowId: windowId
                });
            case 3:
                canvas = _context.sent;
                _context.next = 6;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $dj0kG.getAnnotations));
            case 6:
                annotations = _context.sent;
                miradorCanvas = new (0, $izTcV.default)(canvas);
                _context.next = 10;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)([].concat($ea87ed0b788dc7a8$var$_toConsumableArray(miradorCanvas.annotationListUris.filter(function(uri) {
                    return !(annotations[canvas.id] && annotations[canvas.id][uri]);
                }).map(function(uri) {
                    return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $61Aec.requestAnnotation)(canvas.id, uri));
                })), $ea87ed0b788dc7a8$var$_toConsumableArray(miradorCanvas.canvasAnnotationPages.filter(function(annotation) {
                    return !(annotations[canvas.id] && annotations[canvas.id][annotation.id]);
                }).map(function(annotation) {
                    // If there are no items, try to retrieve the referenced resource.
                    // otherwise the resource should be embedded and just add to the store.
                    if (!annotation.items) return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $61Aec.requestAnnotation)(canvas.id, annotation.id));
                    return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $61Aec.receiveAnnotation)(canvas.id, annotation.id, annotation));
                }))));
            case 10:
                return _context.abrupt("return", _context.sent);
            case 11:
            case "end":
                return _context.stop();
        }
    }, $ea87ed0b788dc7a8$var$_marked);
}
function $ea87ed0b788dc7a8$export$20f6b62d67ced347(_ref2) {
    var _ref2$visibleCanvases, visibleCanvases, windowId;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function fetchAnnotations$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _ref2$visibleCanvases = _ref2.visibleCanvases, visibleCanvases = _ref2$visibleCanvases === void 0 ? [] : _ref2$visibleCanvases, windowId = _ref2.windowId;
                _context2.next = 3;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)(visibleCanvases.map(function(canvasId) {
                    return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $61Aec.requestCanvasAnnotations)(windowId, canvasId));
                }));
            case 3:
                return _context2.abrupt("return", _context2.sent);
            case 4:
            case "end":
                return _context2.stop();
        }
    }, $ea87ed0b788dc7a8$var$_marked2);
}
function $ea87ed0b788dc7a8$export$2e2bcd8739ae039() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function appSaga$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                _context3.next = 2;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)([
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).REQUEST_CANVAS_ANNOTATIONS, $ea87ed0b788dc7a8$export$bd30a22dba1f51c2),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).SET_CANVAS, $ea87ed0b788dc7a8$export$20f6b62d67ced347)
                ]);
            case 2:
            case "end":
                return _context3.stop();
        }
    }, $ea87ed0b788dc7a8$var$_marked3);
}





var $a4sDT = parcelRequire("a4sDT");

var $bT1Wq = parcelRequire("bT1Wq");

var $7CtTT = parcelRequire("7CtTT");

var $izTcV = parcelRequire("izTcV");

var $aeQGD = parcelRequire("aeQGD");

var $7pPJC = parcelRequire("7pPJC");
var $jGts0 = parcelRequire("jGts0");
var $1MgBx = parcelRequire("1MgBx");
var $dy9HC = parcelRequire("dy9HC");

var $8c80d22a4a81a8e2$var$_marked = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($8c80d22a4a81a8e2$export$1d0d3df00fcf66e1), $8c80d22a4a81a8e2$var$_marked2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($8c80d22a4a81a8e2$export$1ce982a1eb24ded5), $8c80d22a4a81a8e2$var$_marked3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($8c80d22a4a81a8e2$export$b438b1e1c72aa0db), $8c80d22a4a81a8e2$var$_marked4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($8c80d22a4a81a8e2$export$5ecbc7a7d31cb67e), $8c80d22a4a81a8e2$var$_marked5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($8c80d22a4a81a8e2$export$bae2ce58053a7637), $8c80d22a4a81a8e2$var$_marked6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($8c80d22a4a81a8e2$export$2e2bcd8739ae039);
function $8c80d22a4a81a8e2$export$1d0d3df00fcf66e1(_ref) {
    var tokenServiceId;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function refetchInfoResponsesOnLogout$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                tokenServiceId = _ref.tokenServiceId;
                _context.next = 3;
                return (0, $95e707af523f0ac0$export$3722cfe417b6ed86)(2000);
            case 3:
                _context.next = 5;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)($8c80d22a4a81a8e2$export$1ce982a1eb24ded5, {
                    serviceId: tokenServiceId
                });
            case 5:
            case "end":
                return _context.stop();
        }
    }, $8c80d22a4a81a8e2$var$_marked);
}
function $8c80d22a4a81a8e2$export$1ce982a1eb24ded5(_ref2) {
    var serviceId, windows, canvases, visibleImageApiIds, infoResponses, haveThisTokenService, obsoleteInfoResponses;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function refetchInfoResponses$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                serviceId = _ref2.serviceId;
                _context2.next = 3;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $dy9HC.getWindows));
            case 3:
                windows = _context2.sent;
                _context2.next = 6;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)(Object.keys(windows).map(function(windowId) {
                    return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $1MgBx.getVisibleCanvases), {
                        windowId: windowId
                    });
                }));
            case 6:
                canvases = _context2.sent;
                visibleImageApiIds = (0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))((0, (/*@__PURE__*/$parcel$interopDefault($bT1Wq)))(canvases).map(function(canvas) {
                    var miradorCanvas = new (0, $izTcV.default)(canvas);
                    return miradorCanvas.imageServiceIds;
                }));
                _context2.next = 10;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $1MgBx.selectInfoResponses));
            case 10:
                infoResponses = _context2.sent;
                /** */ haveThisTokenService = function haveThisTokenService(infoResponse) {
                    var services = (0, $a4sDT.Utils).getServices(infoResponse);
                    return services.some(function(e) {
                        var infoTokenService = (0, $a4sDT.Utils).getService(e, "http://iiif.io/api/auth/1/token") || (0, $a4sDT.Utils).getService(e, "http://iiif.io/api/auth/0/token");
                        return infoTokenService && infoTokenService.id === serviceId;
                    });
                };
                obsoleteInfoResponses = Object.values(infoResponses).filter(function(i) {
                    return i.json && haveThisTokenService(i.json);
                });
                _context2.next = 15;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)(obsoleteInfoResponses.map(function(_ref3) {
                    var infoId = _ref3.id;
                    if (visibleImageApiIds.includes(infoId)) return (0, $95e707af523f0ac0$export$c4ce752e73470fba)((0, $5c0bb2131eadfd57$export$7b9a02b272fcba97), {
                        infoId: infoId
                    });
                    return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)({
                        infoId: infoId,
                        type: (0, $7CtTT.default).REMOVE_INFO_RESPONSE
                    });
                }));
            case 15:
            case "end":
                return _context2.stop();
        }
    }, $8c80d22a4a81a8e2$var$_marked2);
}
function $8c80d22a4a81a8e2$export$b438b1e1c72aa0db(_ref4) {
    var infoJson, windowId, auths, _yield$select, _yield$select$auth, _yield$select$auth$se, serviceProfiles, nonInteractiveAuthFlowProfiles, authService, profileConfig, tokenService;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function doAuthWorkflow$(_context3) {
        while(true)switch(_context3.prev = _context3.next){
            case 0:
                infoJson = _ref4.infoJson, windowId = _ref4.windowId;
                _context3.next = 3;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $7pPJC.getAuth));
            case 3:
                auths = _context3.sent;
                _context3.next = 6;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $jGts0.getConfig));
            case 6:
                _yield$select = _context3.sent;
                _yield$select$auth = _yield$select.auth;
                _yield$select$auth = _yield$select$auth === void 0 ? {} : _yield$select$auth;
                _yield$select$auth$se = _yield$select$auth.serviceProfiles, serviceProfiles = _yield$select$auth$se === void 0 ? [] : _yield$select$auth$se;
                nonInteractiveAuthFlowProfiles = serviceProfiles.filter(function(p) {
                    return p.external || p.kiosk;
                }); // try to get an untried, non-interactive auth service
                authService = (0, $a4sDT.Utils).getServices(infoJson).filter(function(s) {
                    return !auths[s.id];
                }).find(function(e) {
                    return nonInteractiveAuthFlowProfiles.some(function(p) {
                        return p.profile === e.getProfile();
                    });
                });
                if (authService) {
                    _context3.next = 14;
                    break;
                }
                return _context3.abrupt("return");
            case 14:
                profileConfig = nonInteractiveAuthFlowProfiles.find(function(p) {
                    return p.profile === authService.getProfile();
                });
                if (!profileConfig.kiosk) {
                    _context3.next = 20;
                    break;
                }
                _context3.next = 18;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $aeQGD.addAuthenticationRequest)(windowId, authService.id, authService.getProfile()));
            case 18:
                _context3.next = 28;
                break;
            case 20:
                if (!profileConfig.external) {
                    _context3.next = 28;
                    break;
                }
                tokenService = (0, $a4sDT.Utils).getService(authService, "http://iiif.io/api/auth/1/token") || (0, $a4sDT.Utils).getService(authService, "http://iiif.io/api/auth/0/token");
                if (tokenService) {
                    _context3.next = 24;
                    break;
                }
                return _context3.abrupt("return");
            case 24:
                _context3.next = 26;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $aeQGD.resolveAuthenticationRequest)(authService.id, tokenService.id));
            case 26:
                _context3.next = 28;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $aeQGD.requestAccessToken)(tokenService.id, authService.id));
            case 28:
            case "end":
                return _context3.stop();
        }
    }, $8c80d22a4a81a8e2$var$_marked3);
}
function $8c80d22a4a81a8e2$export$5ecbc7a7d31cb67e(_ref5) {
    var infoJson, windowId, tokenServiceId, authService, accessTokenServices, service;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function rerequestOnAccessTokenFailure$(_context4) {
        while(true)switch(_context4.prev = _context4.next){
            case 0:
                infoJson = _ref5.infoJson, windowId = _ref5.windowId, tokenServiceId = _ref5.tokenServiceId;
                if (tokenServiceId) {
                    _context4.next = 3;
                    break;
                }
                return _context4.abrupt("return");
            case 3:
                // make sure we have an auth service to try
                authService = (0, $a4sDT.Utils).getServices(infoJson).find(function(service) {
                    var tokenService = (0, $a4sDT.Utils).getService(service, "http://iiif.io/api/auth/1/token") || (0, $a4sDT.Utils).getService(service, "http://iiif.io/api/auth/0/token");
                    return tokenService && tokenService.id === tokenServiceId;
                });
                if (authService) {
                    _context4.next = 6;
                    break;
                }
                return _context4.abrupt("return");
            case 6:
                _context4.next = 8;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $7pPJC.getAccessTokens));
            case 8:
                accessTokenServices = _context4.sent;
                service = accessTokenServices[tokenServiceId];
                if (service && service.success) {
                    _context4.next = 12;
                    break;
                }
                return _context4.abrupt("return");
            case 12:
                _context4.next = 14;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $aeQGD.requestAccessToken)(tokenServiceId, authService.id));
            case 14:
            case "end":
                return _context4.stop();
        }
    }, $8c80d22a4a81a8e2$var$_marked4);
}
function $8c80d22a4a81a8e2$export$bae2ce58053a7637(_ref6) {
    var serviceId, accessTokenServices, authServices, accessTokenService, authService;
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function invalidateInvalidAuth$(_context5) {
        while(true)switch(_context5.prev = _context5.next){
            case 0:
                serviceId = _ref6.serviceId;
                _context5.next = 3;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $7pPJC.getAccessTokens));
            case 3:
                accessTokenServices = _context5.sent;
                _context5.next = 6;
                return (0, $95e707af523f0ac0$export$efca4cbe5dd06740)((0, $7pPJC.getAuth));
            case 6:
                authServices = _context5.sent;
                accessTokenService = accessTokenServices[serviceId];
                if (accessTokenService) {
                    _context5.next = 10;
                    break;
                }
                return _context5.abrupt("return");
            case 10:
                authService = authServices[accessTokenService.authId];
                if (authService) {
                    _context5.next = 13;
                    break;
                }
                return _context5.abrupt("return");
            case 13:
                if (!accessTokenService.success) {
                    _context5.next = 18;
                    break;
                }
                _context5.next = 16;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $aeQGD.resetAuthenticationState)({
                    authServiceId: authService.id,
                    tokenServiceId: accessTokenService.id
                }));
            case 16:
                _context5.next = 20;
                break;
            case 18:
                _context5.next = 20;
                return (0, $95e707af523f0ac0$export$dc98b0b04f4c7758)((0, $aeQGD.resolveAuthenticationRequest)(authService.id, accessTokenService.id, {
                    ok: false
                }));
            case 20:
            case "end":
                return _context5.stop();
        }
    }, $8c80d22a4a81a8e2$var$_marked5);
}
function $8c80d22a4a81a8e2$export$2e2bcd8739ae039() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function authSaga$(_context6) {
        while(true)switch(_context6.prev = _context6.next){
            case 0:
                _context6.next = 2;
                return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)([
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).RECEIVE_DEGRADED_INFO_RESPONSE, $8c80d22a4a81a8e2$export$5ecbc7a7d31cb67e),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).RECEIVE_ACCESS_TOKEN_FAILURE, $8c80d22a4a81a8e2$export$bae2ce58053a7637),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).RECEIVE_DEGRADED_INFO_RESPONSE, $8c80d22a4a81a8e2$export$b438b1e1c72aa0db),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).RECEIVE_ACCESS_TOKEN, $8c80d22a4a81a8e2$export$1ce982a1eb24ded5),
                    (0, $792512301ef1185e$export$4e24be1e1c9d5c69)((0, $7CtTT.default).RESET_AUTHENTICATION_STATE, $8c80d22a4a81a8e2$export$1d0d3df00fcf66e1)
                ]);
            case 2:
            case "end":
                return _context6.stop();
        }
    }, $8c80d22a4a81a8e2$var$_marked6);
}


function $367a945b1d23cee9$var$_toConsumableArray(arr) {
    return $367a945b1d23cee9$var$_arrayWithoutHoles(arr) || $367a945b1d23cee9$var$_iterableToArray(arr) || $367a945b1d23cee9$var$_unsupportedIterableToArray(arr) || $367a945b1d23cee9$var$_nonIterableSpread();
}
function $367a945b1d23cee9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $367a945b1d23cee9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $367a945b1d23cee9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $367a945b1d23cee9$var$_arrayLikeToArray(o, minLen);
}
function $367a945b1d23cee9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $367a945b1d23cee9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $367a945b1d23cee9$var$_arrayLikeToArray(arr);
}
function $367a945b1d23cee9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $367a945b1d23cee9$var$_marked = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark($367a945b1d23cee9$var$launchSaga);
/** */ function $367a945b1d23cee9$var$launchSaga(saga) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function launchSaga$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _context.prev = 1;
                _context.next = 4;
                return (0, $95e707af523f0ac0$export$c4ce752e73470fba)(saga);
            case 4:
                return _context.abrupt("break", 12);
            case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                console.log(_context.t0);
            case 10:
                _context.next = 0;
                break;
            case 12:
            case "end":
                return _context.stop();
        }
    }, $367a945b1d23cee9$var$_marked, null, [
        [
            1,
            7
        ]
    ]);
}
/** */ function $367a945b1d23cee9$var$getRootSaga() {
    var pluginSagas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).mark(function rootSaga() {
        var sagas;
        return (0, (/*@__PURE__*/$parcel$interopDefault($38f11260a35c9e11$exports))).wrap(function rootSaga$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    sagas = [
                        (0, $ea87ed0b788dc7a8$export$2e2bcd8739ae039),
                        (0, $979cb186030559e4$export$2e2bcd8739ae039),
                        (0, $5c0bb2131eadfd57$export$2e2bcd8739ae039),
                        (0, $c412572b8ce8b59d$export$2e2bcd8739ae039),
                        (0, $8c80d22a4a81a8e2$export$2e2bcd8739ae039)
                    ].concat($367a945b1d23cee9$var$_toConsumableArray(pluginSagas));
                    _context2.next = 3;
                    return (0, $95e707af523f0ac0$export$3d8c2f653ac9d0b9)(sagas.map(function(saga) {
                        return (0, $95e707af523f0ac0$export$ce26c07117d59d6a)($367a945b1d23cee9$var$launchSaga, saga);
                    }));
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, rootSaga);
    });
}
var $367a945b1d23cee9$export$2e2bcd8739ae039 = $367a945b1d23cee9$var$getRootSaga;



var $Kyao2 = parcelRequire("Kyao2");
function $cf1fef3e78520f29$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Configure Store
 */ function $cf1fef3e78520f29$var$configureStore(pluginReducers) {
    var pluginSagas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var miradorReducer = (0, $cf24dcd11ee58809$export$2e2bcd8739ae039)(pluginReducers);
    var rootReducer = (0, $Kyao2.default).state.slice ? (0, $k19ic.combineReducers)($cf1fef3e78520f29$var$_defineProperty({}, (0, $Kyao2.default).state.slice, miradorReducer)) : miradorReducer; // create the saga middleware
    var sagaMiddleware = (0, $a35165576857b28e$export$2e2bcd8739ae039)();
    var store = (0, $k19ic.createStore)(rootReducer, (0, $3e31eabb6cb5f37a$export$d32324a03b6bde1b)((0, $k19ic.applyMiddleware)((0, $c945bc57412f63c2$export$2e2bcd8739ae039), sagaMiddleware))); // then run the saga
    sagaMiddleware.run((0, $367a945b1d23cee9$export$2e2bcd8739ae039)(pluginSagas));
    return store;
}
var $cf1fef3e78520f29$export$2e2bcd8739ae039 = $cf1fef3e78520f29$var$configureStore;



var $2H2ri = parcelRequire("2H2ri");

/**
 * Configure Store
 */ function $4f2688eaa337893e$var$createPluggableStore(config) {
    var plugins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var filteredPlugins = (0, $a964f97edaaf1ca3$export$6e11632ede5393c1)(plugins);
    var store = (0, $cf1fef3e78520f29$export$2e2bcd8739ae039)((0, $a964f97edaaf1ca3$export$233f394bcea1bb1b)(filteredPlugins), (0, $a964f97edaaf1ca3$export$2ab9ab1ccd196479)(filteredPlugins));
    store.dispatch((0, $2H2ri.importConfig)((0, (/*@__PURE__*/$parcel$interopDefault($iyYa0)))((0, $a964f97edaaf1ca3$export$5b091520b72492a8)(filteredPlugins), config)));
    return store;
}
var $4f2688eaa337893e$export$2e2bcd8739ae039 = $4f2688eaa337893e$var$createPluggableStore;


function $7d859df9ab69ced8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7d859df9ab69ced8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7d859df9ab69ced8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7d859df9ab69ced8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7d859df9ab69ced8$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Default Mirador instantiation
 */ var $7d859df9ab69ced8$var$MiradorViewer = /*#__PURE__*/ function() {
    /**
   */ function MiradorViewer(config) {
        var viewerConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $7d859df9ab69ced8$var$_classCallCheck(this, MiradorViewer);
        this.plugins = (0, $a964f97edaaf1ca3$export$6e11632ede5393c1)(viewerConfig.plugins || []);
        this.config = config;
        this.store = viewerConfig.store || (0, $4f2688eaa337893e$export$2e2bcd8739ae039)(this.config, this.plugins);
        config.id && (0, (/*@__PURE__*/$parcel$interopDefault($9sDDw))).render(this.render(), document.getElementById(config.id));
    }
    /**
   * Render the mirador viewer
   */ $7d859df9ab69ced8$var$_createClass(MiradorViewer, [
        {
            key: "render",
            value: function render() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $iEjUn.default), {
                    store: this.store
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $6b9e03c96368022e$export$2e2bcd8739ae039), Object.assign({
                    plugins: this.plugins
                }, props)));
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                this.config.id && (0, (/*@__PURE__*/$parcel$interopDefault($9sDDw))).unmountComponentAtNode(document.getElementById(this.config.id));
            }
        }
    ]);
    return MiradorViewer;
}();
var $7d859df9ab69ced8$export$2e2bcd8739ae039 = $7d859df9ab69ced8$var$MiradorViewer;


/**
 * Default Mirador instantiation
 */ function $940a8d24282014da$var$viewer(config, pluginsOrStruct) {
    var struct;
    if (Array.isArray(pluginsOrStruct)) struct = {
        plugins: pluginsOrStruct
    };
    else struct = pluginsOrStruct;
    return new (0, $7d859df9ab69ced8$export$2e2bcd8739ae039)(config, struct);
}
var $940a8d24282014da$export$2e2bcd8739ae039 = {
    viewer: $940a8d24282014da$var$viewer
};



var $kUnI3 = parcelRequire("kUnI3");
var $fb188aba4811907c$exports = {};















$parcel$exportWildcard($fb188aba4811907c$exports, $a839522a202c9ac5$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $e7041dc4135381e1$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $06e26c5102ef3b7f$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $e4a743f8da7baec6$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $85c03845757be162$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $a71ebeb4ee7e4bd2$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $dab6f0e5d10a15b8$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $5d0d949ec1c52f63$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $eefca1db3103cfbf$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $d61f94fc0f4df01c$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $dd040eb6a01d7fb3$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $f2ab5acdaf261ede$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $4428321196a285de$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $feb7911e676721d8$exports);
$parcel$exportWildcard($fb188aba4811907c$exports, $88808f398f003532$exports);



var $64ef419aa1ac2243$exports = {};

var $dj0kG = parcelRequire("dj0kG");

var $1MgBx = parcelRequire("1MgBx");

var $24Kso = parcelRequire("24Kso");

var $jGts0 = parcelRequire("jGts0");

var $dy9HC = parcelRequire("dy9HC");

var $7GY88 = parcelRequire("7GY88");

var $9E7MS = parcelRequire("9E7MS");

var $3DW53 = parcelRequire("3DW53");

var $bvh50 = parcelRequire("bvh50");

var $dJvB2 = parcelRequire("dJvB2");

var $konAW = parcelRequire("konAW");

var $51Gx5 = parcelRequire("51Gx5");

var $7pPJC = parcelRequire("7pPJC");

var $fr77o = parcelRequire("fr77o");

var $lBHhj = parcelRequire("lBHhj");
$parcel$exportWildcard($64ef419aa1ac2243$exports, $dj0kG);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $1MgBx);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $24Kso);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $jGts0);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $dy9HC);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $7GY88);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $9E7MS);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $3DW53);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $bvh50);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $dJvB2);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $konAW);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $51Gx5);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $7pPJC);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $fr77o);
$parcel$exportWildcard($64ef419aa1ac2243$exports, $lBHhj);



var $19f04589c5c5feb7$export$2e2bcd8739ae039 = {
    actions: $kUnI3,
    createStore: (0, $cf1fef3e78520f29$export$2e2bcd8739ae039),
    reducers: $fb188aba4811907c$exports,
    sagas: $367a945b1d23cee9$exports,
    selectors: $64ef419aa1ac2243$exports
};


function $927e9442cc0782c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $927e9442cc0782c0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $927e9442cc0782c0$var$ownKeys(Object(source), true).forEach(function(key) {
            $927e9442cc0782c0$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $927e9442cc0782c0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $927e9442cc0782c0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $927e9442cc0782c0$export$2e2bcd8739ae039 = $927e9442cc0782c0$var$_objectSpread($927e9442cc0782c0$var$_objectSpread({}, (0, $940a8d24282014da$export$2e2bcd8739ae039)), (0, $19f04589c5c5feb7$export$2e2bcd8739ae039));


var $cb0c5def5f018efa$exports = {};
"use strict";

var $kr74f = parcelRequire("kr74f");
Object.defineProperty($cb0c5def5f018efa$exports, "__esModule", {
    value: true
});
$cb0c5def5f018efa$exports.default = void 0;

var $abElG = parcelRequire("abElG");

var $dXEVX = parcelRequire("dXEVX");

var $arQ7u = parcelRequire("arQ7u");


var $2XZwC = parcelRequire("2XZwC");


var $gkz9m = parcelRequire("gkz9m");
function $57ea26ac29d96626$export$f19c0a3aeca9fe3a() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaultTheme = options.defaultTheme;
    var withTheme = function withTheme(Component) {
        var WithTheme = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).forwardRef(function WithTheme(props, ref) {
            var innerRef = props.innerRef, other = (0, $dXEVX.default)(props, [
                "innerRef"
            ]);
            var theme = (0, $gkz9m.default)() || defaultTheme;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement(Component, (0, $abElG.default)({
                theme: theme,
                ref: innerRef || ref
            }, other));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2XZwC)))(WithTheme, Component);
        return WithTheme;
    };
    return withTheme;
} // Provide the theme object as a prop to the input component.
// It's an alternative API to useTheme().
// We encourage the usage of useTheme() where possible.
var $57ea26ac29d96626$var$withTheme = $57ea26ac29d96626$export$f19c0a3aeca9fe3a();
var $57ea26ac29d96626$export$2e2bcd8739ae039 = $57ea26ac29d96626$var$withTheme;



var $cb0c5def5f018efa$var$_defaultTheme = $kr74f((parcelRequire("amdCE")));
var $cb0c5def5f018efa$var$withTheme = (0, $57ea26ac29d96626$export$f19c0a3aeca9fe3a)({
    defaultTheme: $cb0c5def5f018efa$var$_defaultTheme.default
});
var $cb0c5def5f018efa$var$_default = $cb0c5def5f018efa$var$withTheme;
$cb0c5def5f018efa$exports.default = $cb0c5def5f018efa$var$_default;



var $in9CU = parcelRequire("in9CU");
var $k4YEs = parcelRequire("k4YEs");

var $jGts0 = parcelRequire("jGts0");
var $dy9HC = parcelRequire("dy9HC");
var $9E7MS = parcelRequire("9E7MS");

var $arQ7u = parcelRequire("arQ7u");

var $6057abd19285f926$exports = {};
var $28b740462aaee008$exports = {};

var $f9dpb = parcelRequire("f9dpb");

var $dAIZI = parcelRequire("dAIZI");

var $5qK0p = parcelRequire("5qK0p");

var $hBuQN = parcelRequire("hBuQN");

var $eDRhj = parcelRequire("eDRhj");

var $deASb = parcelRequire("deASb");
/** Error message constants. */ var $28b740462aaee008$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to compose bitmasks for function metadata. */ var $28b740462aaee008$var$WRAP_CURRY_FLAG = 8, $28b740462aaee008$var$WRAP_PARTIAL_FLAG = 32, $28b740462aaee008$var$WRAP_ARY_FLAG = 128, $28b740462aaee008$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function $28b740462aaee008$var$createFlow(fromRight) {
    return $dAIZI(function(funcs) {
        var length = funcs.length, index = length, prereq = $f9dpb.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != "function") throw new TypeError($28b740462aaee008$var$FUNC_ERROR_TEXT);
            if (prereq && !wrapper && $hBuQN(func) == "wrapper") var wrapper = new $f9dpb([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = $hBuQN(func), data = funcName == "wrapper" ? $5qK0p(func) : undefined;
            if (data && $deASb(data[0]) && data[1] == ($28b740462aaee008$var$WRAP_ARY_FLAG | $28b740462aaee008$var$WRAP_CURRY_FLAG | $28b740462aaee008$var$WRAP_PARTIAL_FLAG | $28b740462aaee008$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$hBuQN(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && $deASb(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && $eDRhj(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
$28b740462aaee008$exports = $28b740462aaee008$var$createFlow;


/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */ var $6057abd19285f926$var$flowRight = $28b740462aaee008$exports(true);
$6057abd19285f926$exports = $6057abd19285f926$var$flowRight;


var $5633618eca30a83d$exports = {};
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty($5633618eca30a83d$exports, "__esModule", {
    value: true
});
$5633618eca30a83d$exports.default = void 0;

var $5633618eca30a83d$var$React = $363GR((parcelRequire("arQ7u")));

var $5633618eca30a83d$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $5633618eca30a83d$var$_default = (0, $5633618eca30a83d$var$_createSvgIcon.default)(/*#__PURE__*/ $5633618eca30a83d$var$React.createElement("path", {
    d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
}), "Brightness5");
$5633618eca30a83d$exports.default = $5633618eca30a83d$var$_default;


var $ec7f73b3a7272850$exports = {};
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty($ec7f73b3a7272850$exports, "__esModule", {
    value: true
});
$ec7f73b3a7272850$exports.default = void 0;

var $ec7f73b3a7272850$var$React = $363GR((parcelRequire("arQ7u")));

var $ec7f73b3a7272850$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $ec7f73b3a7272850$var$_default = (0, $ec7f73b3a7272850$var$_createSvgIcon.default)(/*#__PURE__*/ $ec7f73b3a7272850$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
}), "Tonality");
$ec7f73b3a7272850$exports.default = $ec7f73b3a7272850$var$_default;


var $4a94a86ed3ed01b9$exports = {};
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty($4a94a86ed3ed01b9$exports, "__esModule", {
    value: true
});
$4a94a86ed3ed01b9$exports.default = void 0;

var $4a94a86ed3ed01b9$var$React = $363GR((parcelRequire("arQ7u")));

var $4a94a86ed3ed01b9$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $4a94a86ed3ed01b9$var$_default = (0, $4a94a86ed3ed01b9$var$_createSvgIcon.default)(/*#__PURE__*/ $4a94a86ed3ed01b9$var$React.createElement("path", {
    d: "M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"
}), "Gradient");
$4a94a86ed3ed01b9$exports.default = $4a94a86ed3ed01b9$var$_default;


var $fca37e3a9ae456ca$exports = {};
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty($fca37e3a9ae456ca$exports, "__esModule", {
    value: true
});
$fca37e3a9ae456ca$exports.default = void 0;

var $fca37e3a9ae456ca$var$React = $363GR((parcelRequire("arQ7u")));

var $fca37e3a9ae456ca$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $fca37e3a9ae456ca$var$_default = (0, $fca37e3a9ae456ca$var$_createSvgIcon.default)(/*#__PURE__*/ $fca37e3a9ae456ca$var$React.createElement("path", {
    d: "M21 3H3v18h18V3zM6 7h5v1.5H6V7zm13 12H5L19 5v14zm-4.5-3v2H16v-2h2v-1.5h-2v-2h-1.5v2h-2V16h2z"
}), "ExposureSharp");
$fca37e3a9ae456ca$exports.default = $fca37e3a9ae456ca$var$_default;


var $d9b6e2d91d99651a$exports = {};
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty($d9b6e2d91d99651a$exports, "__esModule", {
    value: true
});
$d9b6e2d91d99651a$exports.default = void 0;

var $d9b6e2d91d99651a$var$React = $363GR((parcelRequire("arQ7u")));

var $d9b6e2d91d99651a$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $d9b6e2d91d99651a$var$_default = (0, $d9b6e2d91d99651a$var$_createSvgIcon.default)(/*#__PURE__*/ $d9b6e2d91d99651a$var$React.createElement("path", {
    d: "M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"
}), "InvertColors");
$d9b6e2d91d99651a$exports.default = $d9b6e2d91d99651a$var$_default;


var $d0f783e0d9be67d9$exports = {};
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty($d0f783e0d9be67d9$exports, "__esModule", {
    value: true
});
$d0f783e0d9be67d9$exports.default = void 0;

var $d0f783e0d9be67d9$var$React = $363GR((parcelRequire("arQ7u")));

var $d0f783e0d9be67d9$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $d0f783e0d9be67d9$var$_default = (0, $d0f783e0d9be67d9$var$_createSvgIcon.default)(/*#__PURE__*/ $d0f783e0d9be67d9$var$React.createElement("path", {
    d: "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
}), "TuneSharp");
$d0f783e0d9be67d9$exports.default = $d0f783e0d9be67d9$var$_default;



var $9cuMj = parcelRequire("9cuMj");
var $c5fd0088fc7889a6$exports = {};
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty($c5fd0088fc7889a6$exports, "__esModule", {
    value: true
});
$c5fd0088fc7889a6$exports.default = void 0;

var $c5fd0088fc7889a6$var$React = $363GR((parcelRequire("arQ7u")));

var $c5fd0088fc7889a6$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $c5fd0088fc7889a6$var$_default = (0, $c5fd0088fc7889a6$var$_createSvgIcon.default)(/*#__PURE__*/ $c5fd0088fc7889a6$var$React.createElement("path", {
    d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
}), "ReplaySharp");
$c5fd0088fc7889a6$exports.default = $c5fd0088fc7889a6$var$_default;



var $6U1Fo = parcelRequire("6U1Fo");
var $b5ba31e48f4e34af$exports = {};
"use strict";

var $kr74f = parcelRequire("kr74f");
Object.defineProperty($b5ba31e48f4e34af$exports, "__esModule", {
    value: true
});
$b5ba31e48f4e34af$exports.default = void 0;

var $b5ba31e48f4e34af$var$_extends2 = $kr74f((parcelRequire("1S7Z7")));

var $hDK8L = parcelRequire("hDK8L");

var $b5ba31e48f4e34af$var$_defaultTheme = $kr74f((parcelRequire("amdCE")));
function $b5ba31e48f4e34af$var$withStyles(stylesOrCreator, options) {
    return (0, $hDK8L.default)(stylesOrCreator, (0, $b5ba31e48f4e34af$var$_extends2.default)({
        defaultTheme: $b5ba31e48f4e34af$var$_defaultTheme.default
    }, options));
}
var $b5ba31e48f4e34af$var$_default = $b5ba31e48f4e34af$var$withStyles;
$b5ba31e48f4e34af$exports.default = $b5ba31e48f4e34af$var$_default;



var $htvgE = parcelRequire("htvgE");

var $bds4h = parcelRequire("bds4h");

var $arQ7u = parcelRequire("arQ7u");



var $bds4h = parcelRequire("bds4h");

var $gzsLn = parcelRequire("gzsLn");


var $htvgE = parcelRequire("htvgE");

var $6U1Fo = parcelRequire("6U1Fo");
function $a02c9a9859ae2b87$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a02c9a9859ae2b87$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a02c9a9859ae2b87$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/** Styles for withStyles HOC */ var $a02c9a9859ae2b87$var$styles = function styles(_ref) {
    var _slider;
    var palette = _ref.palette, breakpoints = _ref.breakpoints;
    return {
        slider: (_slider = {
            backgroundColor: (0, $6U1Fo.fade)(palette.shades.main, 0.8),
            borderRadius: 25,
            top: 48,
            marginTop: 2,
            position: "absolute",
            height: 150,
            zIndex: 100,
            marginLeft: 2,
            padding: [
                [
                    2,
                    7,
                    2,
                    7
                ]
            ]
        }, _slider[breakpoints.down("sm")] = {
            top: "auto",
            right: 48,
            width: 150,
            height: "auto",
            marginTop: -46,
            marginBottom: 2,
            padding: [
                [
                    4,
                    2,
                    4,
                    2
                ]
            ]
        }, _slider)
    };
};
var $a02c9a9859ae2b87$var$ImageTool = function(_Component) {
    $a02c9a9859ae2b87$var$_inherits(ImageTool, _Component);
    function ImageTool(props) {
        $a02c9a9859ae2b87$var$_classCallCheck(this, ImageTool);
        var _this = $a02c9a9859ae2b87$var$_possibleConstructorReturn(this, _Component.call(this, props));
        _this.state = {
            open: props.open
        };
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    ImageTool.prototype.handleClick = function handleClick() {
        var _props = this.props, value = _props.value, variant = _props.variant;
        switch(variant){
            case "toggle":
                this.handleChange({}, value === 0 ? 100 : 0);
                break;
            default:
                this.setState(function(state) {
                    return {
                        open: !state.open
                    };
                });
        }
    };
    ImageTool.prototype.handleChange = function handleChange(e, val) {
        var onChange = this.props.onChange;
        onChange(val);
    };
    ImageTool.prototype.render = function render() {
        var _props2 = this.props, children = _props2.children, containerId = _props2.containerId, label = _props2.label, max = _props2.max, min = _props2.min, value = _props2.value, type = _props2.type, variant = _props2.variant, windowId = _props2.windowId, foregroundColor = _props2.foregroundColor, classes = _props2.classes, width = _props2.width;
        var open = this.state.open;
        var toggled = variant === "toggle" && value > 0;
        var id = windowId + "-" + type;
        var bubbleBg = void 0;
        if (open || toggled) bubbleBg = (0, $6U1Fo.fade)(foregroundColor, open ? 0.1 : 0.25);
        return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
            style: {
                display: "inline-block"
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $bds4h.MiradorMenuButton), {
            id: id + "-label",
            "aria-label": label,
            containerId: containerId,
            onClick: this.handleClick,
            "aria-expanded": open,
            "aria-controls": id,
            style: {
                backgroundColor: bubbleBg
            }
        }, children), open && (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
            id: id,
            "aria-labelledby": id + "-label",
            className: "MuiPaper-elevation4 " + classes.slider
        }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $gzsLn.default), {
            orientation: [
                "xs",
                "sm"
            ].indexOf(width) >= 0 ? "horizontal" : "vertical",
            min: min,
            max: max,
            value: value,
            onChange: this.handleChange
        })));
    };
    return ImageTool;
}((0, $arQ7u.Component));
$a02c9a9859ae2b87$var$ImageTool.propTypes = {};
$a02c9a9859ae2b87$var$ImageTool.defaultProps = {
    foregroundColor: "rgb(0, 0, 0)",
    min: 0,
    max: 100,
    open: false,
    variant: "slider"
};
var $a02c9a9859ae2b87$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($6057abd19285f926$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($b5ba31e48f4e34af$exports)))($a02c9a9859ae2b87$var$styles), (0, $htvgE.default)())($a02c9a9859ae2b87$var$ImageTool);



var $arQ7u = parcelRequire("arQ7u");


var $bds4h = parcelRequire("bds4h");
var $2ecec88d19b46c15$exports = {};
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty($2ecec88d19b46c15$exports, "__esModule", {
    value: true
});
$2ecec88d19b46c15$exports.default = void 0;

var $2ecec88d19b46c15$var$React = $363GR((parcelRequire("arQ7u")));

var $2ecec88d19b46c15$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $2ecec88d19b46c15$var$_default = (0, $2ecec88d19b46c15$var$_createSvgIcon.default)(/*#__PURE__*/ $2ecec88d19b46c15$var$React.createElement("path", {
    d: "M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
}), "RotateRight");
$2ecec88d19b46c15$exports.default = $2ecec88d19b46c15$var$_default;


var $a170ce4e7b6b1a45$exports = {};
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty($a170ce4e7b6b1a45$exports, "__esModule", {
    value: true
});
$a170ce4e7b6b1a45$exports.default = void 0;

var $a170ce4e7b6b1a45$var$React = $363GR((parcelRequire("arQ7u")));

var $a170ce4e7b6b1a45$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $a170ce4e7b6b1a45$var$_default = (0, $a170ce4e7b6b1a45$var$_createSvgIcon.default)(/*#__PURE__*/ $a170ce4e7b6b1a45$var$React.createElement("path", {
    d: "M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"
}), "RotateLeft");
$a170ce4e7b6b1a45$exports.default = $a170ce4e7b6b1a45$var$_default;


var $0cb62226f8009b0c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $0cb62226f8009b0c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $0cb62226f8009b0c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0cb62226f8009b0c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0cb62226f8009b0c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $0cb62226f8009b0c$export$2e2bcd8739ae039 = function(_Component) {
    $0cb62226f8009b0c$var$_inherits(ImageRotation, _Component);
    function ImageRotation() {
        $0cb62226f8009b0c$var$_classCallCheck(this, ImageRotation);
        return $0cb62226f8009b0c$var$_possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    ImageRotation.prototype.render = function render() {
        var _props = this.props, label = _props.label, variant = _props.variant, otherProps = $0cb62226f8009b0c$var$_objectWithoutProperties(_props, [
            "label",
            "variant"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $bds4h.MiradorMenuButton), $0cb62226f8009b0c$var$_extends({
            "aria-label": label
        }, otherProps), variant === "left" ? (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a170ce4e7b6b1a45$exports))), null) : (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2ecec88d19b46c15$exports))), null));
    };
    return ImageRotation;
}((0, $arQ7u.Component));
$0cb62226f8009b0c$export$2e2bcd8739ae039.propTypes = {};



var $arQ7u = parcelRequire("arQ7u");


var $bds4h = parcelRequire("bds4h");
var $5116d117d53810fe$exports = {};
"use strict";

var $kr74f = parcelRequire("kr74f");

var $363GR = parcelRequire("363GR");
Object.defineProperty($5116d117d53810fe$exports, "__esModule", {
    value: true
});
$5116d117d53810fe$exports.default = void 0;

var $5116d117d53810fe$var$React = $363GR((parcelRequire("arQ7u")));

var $5116d117d53810fe$var$_createSvgIcon = $kr74f((parcelRequire("hkOZE")));
var $5116d117d53810fe$var$_default = (0, $5116d117d53810fe$var$_createSvgIcon.default)(/*#__PURE__*/ $5116d117d53810fe$var$React.createElement("path", {
    d: "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
}), "SwapHoriz");
$5116d117d53810fe$exports.default = $5116d117d53810fe$var$_default;



var $6U1Fo = parcelRequire("6U1Fo");
var $93a61ce08dfc2821$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $93a61ce08dfc2821$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $93a61ce08dfc2821$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $93a61ce08dfc2821$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $93a61ce08dfc2821$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $93a61ce08dfc2821$export$2e2bcd8739ae039 = function(_Component) {
    $93a61ce08dfc2821$var$_inherits(ImageFlip, _Component);
    function ImageFlip() {
        $93a61ce08dfc2821$var$_classCallCheck(this, ImageFlip);
        return $93a61ce08dfc2821$var$_possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    ImageFlip.prototype.render = function render() {
        var _props = this.props, flipped = _props.flipped, label = _props.label, backgroundColor = _props.backgroundColor, foregroundColor = _props.foregroundColor, otherProps = $93a61ce08dfc2821$var$_objectWithoutProperties(_props, [
            "flipped",
            "label",
            "backgroundColor",
            "foregroundColor"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $bds4h.MiradorMenuButton), $93a61ce08dfc2821$var$_extends({
            "aria-label": label,
            style: {
                backgroundColor: flipped && (0, $6U1Fo.fade)(foregroundColor, 0.25)
            }
        }, otherProps), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5116d117d53810fe$exports))), {
            style: {
                color: flipped && backgroundColor
            }
        }));
    };
    return ImageFlip;
}((0, $arQ7u.Component));
$93a61ce08dfc2821$export$2e2bcd8739ae039.propTypes = {};
$93a61ce08dfc2821$export$2e2bcd8739ae039.defaultProps = {
    backgroundColor: "rgb(255, 255, 255)",
    foregroundColor: "rgb(0, 0, 0)"
};


function $7a77e19f278b65ae$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7a77e19f278b65ae$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7a77e19f278b65ae$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/** Styles for withStyles HOC */ var $7a77e19f278b65ae$var$styles = function styles(_ref) {
    var _root, _borderContainer;
    var breakpoints = _ref.breakpoints, palette = _ref.palette;
    var backgroundColor = palette.shades.main;
    var foregroundColor = palette.getContrastText(backgroundColor);
    var border = "1px solid " + (0, $6U1Fo.fade)(foregroundColor, 0.2);
    var borderImageRight = "linear-gradient(to bottom, " + ((0, $6U1Fo.fade)(foregroundColor, 0) + " 20%, ") + ((0, $6U1Fo.fade)(foregroundColor, 0.2) + " 20% 80%, ") + ((0, $6U1Fo.fade)(foregroundColor, 0) + " 80% )");
    var borderImageBottom = borderImageRight.replace("to bottom", "to right");
    return {
        root: (_root = {
            backgroundColor: (0, $6U1Fo.fade)(backgroundColor, 0.8),
            borderRadius: 25,
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 999,
            display: "flex",
            flexDirection: "row"
        }, _root[breakpoints.down("sm")] = {
            flexDirection: "column"
        }, _root),
        borderContainer: (_borderContainer = {
            border: 0,
            borderRight: border,
            borderImageSlice: 1,
            borderImageSource: borderImageRight,
            display: "flex",
            flexDirection: "row"
        }, _borderContainer[breakpoints.down("sm")] = {
            flexDirection: "column",
            borderBottom: border,
            borderRight: "none",
            borderImageSource: borderImageBottom
        }, _borderContainer)
    };
};
var $7a77e19f278b65ae$var$MiradorImageTools = function(_Component) {
    $7a77e19f278b65ae$var$_inherits(MiradorImageTools, _Component);
    function MiradorImageTools(props) {
        $7a77e19f278b65ae$var$_classCallCheck(this, MiradorImageTools);
        var _this = $7a77e19f278b65ae$var$_possibleConstructorReturn(this, _Component.call(this, props));
        _this.toggleState = _this.toggleState.bind(_this);
        _this.toggleRotate = _this.toggleRotate.bind(_this);
        _this.toggleFlip = _this.toggleFlip.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleReset = _this.handleReset.bind(_this);
        return _this;
    }
    MiradorImageTools.prototype.componentDidMount = function componentDidMount() {
        var viewer = this.props.viewer;
        if (viewer) this.applyFilters();
    };
    MiradorImageTools.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _props = this.props, viewConfig = _props.viewConfig, viewer = _props.viewer;
        if (viewer && viewConfig !== prevProps.viewConfig) this.applyFilters();
    };
    MiradorImageTools.prototype.handleChange = function handleChange(param) {
        var _props2 = this.props, updateViewport = _props2.updateViewport, windowId = _props2.windowId;
        return function(value) {
            var _updateViewport;
            return updateViewport(windowId, (_updateViewport = {}, _updateViewport[param] = value, _updateViewport));
        };
    };
    MiradorImageTools.prototype.handleReset = function handleReset() {
        var _props3 = this.props, updateViewport = _props3.updateViewport, windowId = _props3.windowId;
        var viewConfig = {
            rotation: 0,
            flip: false,
            brightness: 100,
            contrast: 100,
            saturate: 100,
            grayscale: 0,
            invert: 0
        };
        updateViewport(windowId, viewConfig);
    };
    MiradorImageTools.prototype.applyFilters = function applyFilters() {
        var _props4 = this.props, _props4$viewConfig = _props4.viewConfig, _props4$viewConfig$br = _props4$viewConfig.brightness, brightness = _props4$viewConfig$br === undefined ? 100 : _props4$viewConfig$br, _props4$viewConfig$co = _props4$viewConfig.contrast, contrast = _props4$viewConfig$co === undefined ? 100 : _props4$viewConfig$co, _props4$viewConfig$sa = _props4$viewConfig.saturate, saturate = _props4$viewConfig$sa === undefined ? 100 : _props4$viewConfig$sa, _props4$viewConfig$gr = _props4$viewConfig.grayscale, grayscale = _props4$viewConfig$gr === undefined ? 0 : _props4$viewConfig$gr, _props4$viewConfig$in = _props4$viewConfig.invert, invert = _props4$viewConfig$in === undefined ? 0 : _props4$viewConfig$in, canvas = _props4.viewer.canvas;
        if (!canvas) return;
        var controlledFilters = [
            "brightness",
            "contrast",
            "saturate",
            "grayscale",
            "invert"
        ];
        var currentFilters = canvas.style.filter.split(" ");
        var newFilters = currentFilters.filter(function(filter) {
            return !controlledFilters.some(function(type) {
                return filter.includes(type);
            });
        });
        newFilters.push("brightness(" + brightness + "%)");
        newFilters.push("contrast(" + contrast + "%)");
        newFilters.push("saturate(" + saturate + "%)");
        newFilters.push("grayscale(" + grayscale + "%)");
        newFilters.push("invert(" + invert + "%)");
        canvas.style.filter = newFilters.join(" ");
    };
    MiradorImageTools.prototype.toggleState = function toggleState() {
        var _props5 = this.props, open = _props5.open, updateWindow = _props5.updateWindow, windowId = _props5.windowId;
        updateWindow(windowId, {
            imageToolsOpen: !open
        });
    };
    MiradorImageTools.prototype.toggleRotate = function toggleRotate(value) {
        var _props6 = this.props, updateViewport = _props6.updateViewport, _props6$viewConfig = _props6.viewConfig, _props6$viewConfig$fl = _props6$viewConfig.flip, flip = _props6$viewConfig$fl === undefined ? false : _props6$viewConfig$fl, _props6$viewConfig$ro = _props6$viewConfig.rotation, rotation = _props6$viewConfig$ro === undefined ? 0 : _props6$viewConfig$ro, windowId = _props6.windowId;
        var offset = flip ? -1 * value : value;
        updateViewport(windowId, {
            rotation: (rotation + offset) % 360
        });
    };
    MiradorImageTools.prototype.toggleFlip = function toggleFlip() {
        var _props7 = this.props, updateViewport = _props7.updateViewport, _props7$viewConfig$fl = _props7.viewConfig.flip, flip = _props7$viewConfig$fl === undefined ? false : _props7$viewConfig$fl, windowId = _props7.windowId;
        updateViewport(windowId, {
            flip: !flip
        });
    };
    MiradorImageTools.prototype.render = function render() {
        var _this2 = this;
        var _props8 = this.props, classes = _props8.classes, containerId = _props8.containerId, enabled = _props8.enabled, open = _props8.open, viewer = _props8.viewer, windowId = _props8.windowId, width = _props8.width, palette = _props8.theme.palette, _props8$viewConfig = _props8.viewConfig, _props8$viewConfig$fl = _props8$viewConfig.flip, flip = _props8$viewConfig$fl === undefined ? false : _props8$viewConfig$fl, _props8$viewConfig$br = _props8$viewConfig.brightness, brightness = _props8$viewConfig$br === undefined ? 100 : _props8$viewConfig$br, _props8$viewConfig$co = _props8$viewConfig.contrast, contrast = _props8$viewConfig$co === undefined ? 100 : _props8$viewConfig$co, _props8$viewConfig$sa = _props8$viewConfig.saturate, saturate = _props8$viewConfig$sa === undefined ? 100 : _props8$viewConfig$sa, _props8$viewConfig$gr = _props8$viewConfig.grayscale, grayscale = _props8$viewConfig$gr === undefined ? 0 : _props8$viewConfig$gr, _props8$viewConfig$in = _props8$viewConfig.invert, invert = _props8$viewConfig$in === undefined ? 0 : _props8$viewConfig$in, t = _props8.t;
        if (!viewer || !enabled) return null;
        var backgroundColor = palette.shades.main;
        var foregroundColor = palette.getContrastText(backgroundColor);
        var isSmallDisplay = [
            "xs",
            "sm"
        ].indexOf(width) >= 0;
        /** Button for toggling the menu */ var toggleButton = (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
            className: isSmallDisplay && open ? classes.borderContainer : ""
        }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $bds4h.MiradorMenuButton), {
            "aria-expanded": open,
            "aria-haspopup": true,
            "aria-label": t("collapse", {
                context: open ? "open" : "close"
            }),
            containerId: containerId,
            onClick: this.toggleState
        }, open ? (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9cuMj))), null) : (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d0f783e0d9be67d9$exports))), null)));
        return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
            className: "MuiPaper-elevation4 " + classes.root
        }, isSmallDisplay && toggleButton, open && (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
            className: classes.borderContainer
        }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $0cb62226f8009b0c$export$2e2bcd8739ae039), {
            containerId: containerId,
            label: t("rotateRight"),
            onClick: function onClick() {
                return _this2.toggleRotate(90);
            },
            variant: "right"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $0cb62226f8009b0c$export$2e2bcd8739ae039), {
            containerId: containerId,
            label: t("rotateLeft"),
            onClick: function onClick() {
                return _this2.toggleRotate(-90);
            },
            variant: "left"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $93a61ce08dfc2821$export$2e2bcd8739ae039), {
            label: t("flip"),
            onClick: this.toggleFlip,
            flipped: flip,
            containerId: containerId
        })), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
            className: classes.borderContainer
        }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $a02c9a9859ae2b87$export$2e2bcd8739ae039), {
            type: "brightness",
            label: t("brightness"),
            max: 200,
            windowId: windowId,
            value: brightness,
            foregroundColor: foregroundColor,
            containerId: containerId,
            onChange: this.handleChange("brightness")
        }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5633618eca30a83d$exports))), null)), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $a02c9a9859ae2b87$export$2e2bcd8739ae039), {
            type: "contrast",
            label: t("contrast"),
            max: 200,
            windowId: windowId,
            value: contrast,
            foregroundColor: foregroundColor,
            containerId: containerId,
            onChange: this.handleChange("contrast")
        }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fca37e3a9ae456ca$exports))), {
            style: {
                transform: "rotate(180deg)"
            }
        })), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $a02c9a9859ae2b87$export$2e2bcd8739ae039), {
            type: "saturate",
            label: t("saturation"),
            max: 200,
            windowId: windowId,
            value: saturate,
            foregroundColor: foregroundColor,
            containerId: containerId,
            onChange: this.handleChange("saturate")
        }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4a94a86ed3ed01b9$exports))), null)), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $a02c9a9859ae2b87$export$2e2bcd8739ae039), {
            type: "grayscale",
            variant: "toggle",
            label: t("greyscale"),
            windowId: windowId,
            value: grayscale,
            backgroundColor: backgroundColor,
            foregroundColor: foregroundColor,
            containerId: containerId,
            onChange: this.handleChange("grayscale")
        }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ec7f73b3a7272850$exports))), null)), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $a02c9a9859ae2b87$export$2e2bcd8739ae039), {
            type: "invert",
            variant: "toggle",
            label: t("invert"),
            windowId: windowId,
            value: invert,
            foregroundColor: foregroundColor,
            containerId: containerId,
            onChange: this.handleChange("invert")
        }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d9b6e2d91d99651a$exports))), null))), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement("div", {
            className: isSmallDisplay ? "" : classes.borderContainer
        }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $bds4h.MiradorMenuButton), {
            "aria-label": t("revert"),
            containerId: containerId,
            onClick: this.handleReset
        }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c5fd0088fc7889a6$exports))), null)))), !isSmallDisplay && toggleButton);
    };
    return MiradorImageTools;
}((0, $arQ7u.Component));
$7a77e19f278b65ae$var$MiradorImageTools.propTypes = {};
$7a77e19f278b65ae$var$MiradorImageTools.defaultProps = {
    enabled: true,
    open: true,
    viewer: undefined,
    viewConfig: {}
};
var $7a77e19f278b65ae$export$e187a2051eaef35b = $7a77e19f278b65ae$var$MiradorImageTools;
var $7a77e19f278b65ae$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($6057abd19285f926$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($b5ba31e48f4e34af$exports)))($7a77e19f278b65ae$var$styles), (0, $htvgE.default)())($7a77e19f278b65ae$var$MiradorImageTools);



var $arQ7u = parcelRequire("arQ7u");


var $2NDUy = parcelRequire("2NDUy");

var $kUHj7 = parcelRequire("kUHj7");

var $TXAJ5 = parcelRequire("TXAJ5");

var $74d6114e6fd2d02a$var$MiradorImageToolsMenuItem = function MiradorImageToolsMenuItem(_ref) {
    var enabled = _ref.enabled, handleClose = _ref.handleClose, t = _ref.t, updateWindow = _ref.updateWindow, windowId = _ref.windowId;
    var handleClickOpen = function handleClickOpen() {
        handleClose();
        updateWindow(windowId, {
            imageToolsEnabled: !enabled
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $2NDUy.default), {
        onClick: handleClickOpen
    }, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $kUHj7.default), null, (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d0f783e0d9be67d9$exports))), null)), (0, (/*@__PURE__*/$parcel$interopDefault($arQ7u))).createElement((0, $TXAJ5.default), {
        primaryTypographyProps: {
            variant: "body1"
        }
    }, enabled ? t("hide") : t("show")));
};
$74d6114e6fd2d02a$var$MiradorImageToolsMenuItem.propTypes = {};
$74d6114e6fd2d02a$var$MiradorImageToolsMenuItem.defaultProps = {
    enabled: true
};
var $74d6114e6fd2d02a$export$2e2bcd8739ae039 = $74d6114e6fd2d02a$var$MiradorImageToolsMenuItem;


var $afb04ad3ef0014cf$var$translations = {
    de: {
        brightness: "Helligkeit",
        collapse_open: "Bildbearbeitung ausblenden",
        collapse_close: "Bildbearbeitung einblenden",
        contrast: "Kontrast",
        flip: "Spiegeln",
        greyscale: "Darstellung in Graustufen",
        hide: "Bildbearbeitung verbergen",
        invert: "Umkehrung der Farben",
        revert: "Einstellungen zur\xfccksetzen",
        rotateLeft: "Rotation links",
        rotateRight: "Rotation rechts",
        saturation: "S\xe4ttigung",
        show: "Bildbearbeitung anzeigen"
    },
    en: {
        brightness: "Brightness",
        collapse_open: "Collapse image tools",
        collapse_close: "Expand image tools",
        contrast: "Contrast",
        flip: "Flip",
        greyscale: "Greyscale",
        hide: "Hide image tools",
        invert: "Invert colors",
        revert: "Revert image",
        rotateLeft: "Rotate left",
        rotateRight: "Rotate right",
        saturation: "Saturation",
        show: "Show image tools"
    },
    fr: {
        brightness: "Luminosit\xe9",
        collapse_open: "Fermer les outils de r\xe9glages de l'image",
        collapse_close: "Ouvrir les outils de r\xe9glages de l'image",
        contrast: "Contraste",
        flip: "Miroir",
        greyscale: "Niveaux de gris",
        invert: "Inverser les couleurs",
        revert: "R\xe9initialiser les r\xe9glages",
        rotateLeft: "Rotation vers la gauche",
        rotateRight: "Rotation vers la droite",
        saturation: "Saturation"
    },
    sr: {
        brightness: "\u041E\u0441\u0432\u0435\u0442\u0459\u0435\u045A\u0435",
        collapse_open: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438\u0442\u0435 \u0430\u043B\u0430\u0442",
        collapse_close: "\u041E\u0442\u0432\u043E\u0440\u0438\u0442\u0435 \u0430\u043B\u0430\u0442",
        contrast: "\u041A\u043E\u043D\u0442\u0440\u0430\u0441\u0442",
        flip: "\u041E\u043A\u0440\u0435\u043D\u0438",
        greyscale: "\u0426\u0440\u043D\u043E\u0431\u0435\u043B\u043E",
        hideImageTools: "\u0421\u0430\u043A\u0440\u0438\u0458\u0442\u0435 \u0430\u043B\u0430\u0442",
        invert: "\u0418\u043D\u0432\u0435\u0440\u0437\u0438\u0458\u0430 \u0431\u043E\u0458\u0430",
        revert: "\u041F\u043E\u043D\u0438\u0448\u0442\u0438 \u043F\u043E\u0434\u0435\u0448\u0430\u0432\u0430\u045A\u0430",
        rotateLeft: "\u0420\u043E\u0442\u0438\u0440\u0430\u0458 \u043B\u0435\u0432\u043E",
        rotateRight: "\u0420\u043E\u0442\u0438\u0440\u0430\u0458 \u0434\u0435\u0441\u043D\u043E",
        saturation: "\u0421\u0430\u0442\u0443\u0440\u0430\u0446\u0438\u0458\u0430",
        showImageTools: "\u041F\u0440\u0438\u043A\u0430\u0436\u0438\u0442\u0435 \u0430\u043B\u0430\u0442"
    }
};
var $afb04ad3ef0014cf$export$2e2bcd8739ae039 = $afb04ad3ef0014cf$var$translations;


var $dfcc5e79247dfcd3$export$2e2bcd8739ae039 = [
    {
        target: "OpenSeadragonViewer",
        mapDispatchToProps: {
            updateWindow: $k4YEs.updateWindow,
            updateViewport: $in9CU.updateViewport
        },
        mapStateToProps: function mapStateToProps(state, _ref) {
            var windowId = _ref.windowId;
            return {
                containerId: (0, $jGts0.getContainerId)(state),
                enabled: (0, $9E7MS.getWindowConfig)(state, {
                    windowId: windowId
                }).imageToolsEnabled || false,
                open: (0, $9E7MS.getWindowConfig)(state, {
                    windowId: windowId
                }).imageToolsOpen || false,
                viewConfig: (0, $dy9HC.getViewer)(state, {
                    windowId: windowId
                }) || {}
            };
        },
        mode: "add",
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cb0c5def5f018efa$exports)))((0, $7a77e19f278b65ae$export$2e2bcd8739ae039)),
        config: {
            translations: (0, $afb04ad3ef0014cf$export$2e2bcd8739ae039)
        }
    },
    {
        target: "WindowTopBarPluginMenu",
        component: (0, $74d6114e6fd2d02a$export$2e2bcd8739ae039),
        mode: "add",
        mapDispatchToProps: {
            updateWindow: $k4YEs.updateWindow
        },
        mapStateToProps: function mapStateToProps(state, _ref2) {
            var windowId = _ref2.windowId;
            return {
                enabled: (0, $9E7MS.getWindowConfig)(state, {
                    windowId: windowId
                }).imageToolsEnabled || false
            };
        }
    }
];




window.renderMirador = function(options) {
    return (0, $927e9442cc0782c0$export$2e2bcd8739ae039).viewer({
        ...options
    }, [
        ...(0, $dfcc5e79247dfcd3$export$2e2bcd8739ae039)
    ]);
};

})();
//# sourceMappingURL=index.aaee2d87.js.map
